var exports =
webpackJsonpexports([74],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["setLocaleDebug"] = setLocaleDebug;
/* harmony export (immutable) */ __webpack_exports__["setLocale"] = setLocale;
/* harmony export (immutable) */ __webpack_exports__["parseComponentTemplate"] = parseComponentTemplate;
/* harmony export (immutable) */ __webpack_exports__["renderComponentTemplate"] = renderComponentTemplate;
/* harmony export (immutable) */ __webpack_exports__["format"] = format;
/* harmony export (immutable) */ __webpack_exports__["gettext"] = gettext;
/* harmony export (immutable) */ __webpack_exports__["ngettext"] = ngettext;
/* harmony export (immutable) */ __webpack_exports__["gettextComponentTemplate"] = gettextComponentTemplate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return t; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tn", function() { return tn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tct", function() { return tct; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isObject__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isString__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jed__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sprintf_js__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sprintf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sprintf_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_translations__ = __webpack_require__(851);




function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/*eslint no-cond-assign:0*/






var LOCALE_DEBUG = false;

var sessionStorage = window.sessionStorage;
if (sessionStorage && sessionStorage.getItem('localeDebug') == '1') {
  LOCALE_DEBUG = true;
}

function setLocaleDebug(value) {
  sessionStorage.setItem('localeDebug', value ? '1' : '0');
  /*eslint no-console:0*/
  console.log('Locale debug is: ', value ? 'on' : 'off', '. Reload page to apply changes!');
}

var i18n = null;

function setLocale(locale) {
  var translations = Object(__WEBPACK_IMPORTED_MODULE_6_app_translations__["a" /* getTranslations */])(locale);
  i18n = new __WEBPACK_IMPORTED_MODULE_3_jed___default.a({
    domain: 'sentry',
    missing_key_callback: function missing_key_callback(key) {},
    locale_data: {
      sentry: translations
    }
  });
}

setLocale('en');

function formatForReact(formatString, args) {
  var rv = [];
  var cursor = 0;

  // always re-parse, do not cache, because we change the match
  __WEBPACK_IMPORTED_MODULE_5_sprintf_js__["sprintf"].parse(formatString).forEach(function (match, idx) {
    if (__WEBPACK_IMPORTED_MODULE_2_lodash_isString___default()(match)) {
      rv.push(match);
    } else {
      var arg = null;
      if (match[2]) {
        arg = args[0][match[2][0]];
      } else if (match[1]) {
        arg = args[parseInt(match[1], 10) - 1];
      } else {
        arg = args[cursor++];
      }

      // this points to a react element!
      if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(arg)) {
        rv.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(arg, { key: idx }));
        // not a react element, fuck around with it so that sprintf.format
        // can format it for us.  We make sure match[2] is null so that we
        // do not go down the object path, and we set match[1] to the first
        // index and then pass an array with two items in.
      } else {
        match[2] = null;
        match[1] = 1;
        rv.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'span',
          { key: idx++ },
          __WEBPACK_IMPORTED_MODULE_5_sprintf_js__["sprintf"].format([match], [null, arg])
        ));
      }
    }
  });

  return rv;
}

function argsInvolveReact(args) {
  if (args.some(__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement)) {
    return true;
  }
  if (args.length == 1 && __WEBPACK_IMPORTED_MODULE_1_lodash_isObject___default()(args[0])) {
    return Object.keys(args[0]).some(function (key) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(args[0][key]);
    });
  }
  return false;
}

function parseComponentTemplate(string) {
  var rv = {};

  function process(startPos, group, inGroup) {
    var regex = /\[(.*?)(:|\])|\]/g;
    var match = void 0;
    var buf = [];
    var satisfied = false;

    var pos = regex.lastIndex = startPos;
    while ((match = regex.exec(string)) !== null) {
      var substr = string.substr(pos, match.index - pos);
      if (substr !== '') {
        buf.push(substr);
      }

      if (match[0] == ']') {
        if (inGroup) {
          satisfied = true;
          break;
        } else {
          pos = regex.lastIndex;
          continue;
        }
      }

      if (match[2] == ']') {
        pos = regex.lastIndex;
      } else {
        pos = regex.lastIndex = process(regex.lastIndex, match[1], true);
      }
      buf.push({ group: match[1] });
    }

    var endPos = regex.lastIndex;
    if (!satisfied) {
      var rest = string.substr(pos);
      if (rest) {
        buf.push(rest);
      }
      endPos = string.length;
    }

    rv[group] = buf;
    return endPos;
  }

  process(0, 'root', false);

  return rv;
}

function renderComponentTemplate(template, components) {
  var idx = 0;
  function renderGroup(group) {
    var children = [];

    (template[group] || []).forEach(function (item) {
      if (__WEBPACK_IMPORTED_MODULE_2_lodash_isString___default()(item)) {
        children.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'span',
          { key: idx++ },
          item
        ));
      } else {
        children.push(renderGroup(item.group));
      }
    });

    // in case we cannot find our component, we call back to an empty
    // span so that stuff shows up at least.
    var reference = components[group] || __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { key: idx++ });
    if (!__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(reference)) {
      reference = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'span',
        { key: idx++ },
        reference
      );
    }

    if (children.length > 0) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(reference, { key: idx++ }, children);
    } else {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(reference, { key: idx++ });
    }
  }

  return renderGroup('root');
}

function mark(rv) {
  if (!LOCALE_DEBUG) {
    return rv;
  }

  var proxy = {
    $$typeof: Symbol.for('react.element'),
    type: 'span',
    key: null,
    ref: null,
    props: {
      className: 'translation-wrapper',
      children: __WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default()(rv) ? rv : [rv]
    },
    _owner: null,
    _store: {}
  };

  proxy.toString = function () {
    return '🇦🇹' + rv + '🇦🇹';
  };

  return proxy;
}

function format(formatString, args) {
  if (argsInvolveReact(args)) {
    return formatForReact(formatString, args);
  } else {
    return __WEBPACK_IMPORTED_MODULE_5_sprintf_js__["sprintf"].apply(undefined, [formatString].concat(_toConsumableArray(args)));
  }
}

function gettext(string) {
  var rv = i18n.gettext(string);

  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (args.length > 0) {
    rv = format(rv, args);
  }
  return mark(rv);
}

function ngettext(singular, plural) {
  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return mark(format(i18n.ngettext(singular, plural, args[0] || 0), args));
}

/* special form of gettext where you can render nested react
   components in template strings.  Example:

      gettextComponentTemplate('Welcome. Click [link:here]', {
        root: <p/>,
        link: <a href="#" />
      });

   the root string is always called "root", the rest is prefixed
   with the name in the brackets */
function gettextComponentTemplate(template, components) {
  var tmpl = parseComponentTemplate(i18n.gettext(template));
  return mark(renderComponentTemplate(tmpl, components));
}

var t = gettext;
var tn = ngettext;
var tct = gettextComponentTemplate;

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Metadata; });
/* unused harmony export User */
/* unused harmony export Config */
/* unused harmony export Deploy */
/* unused harmony export Member */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Group; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Event; });
/* unused harmony export Tag */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Actor; });
/* unused harmony export Team */
/* unused harmony export Project */
/* unused harmony export ProjectDetail */
/* unused harmony export NavigationObject */
/* unused harmony export Environment */
/* unused harmony export PageLinks */
/* unused harmony export Plugin */
/* unused harmony export PluginShape */
/* unused harmony export PluginsStore */
/* unused harmony export ProjectDsn */
/* unused harmony export ProjectDsnShape */
/* unused harmony export ProjectKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var Metadata = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  message: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  directive: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  uri: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
});

var Avatar = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  avatarType: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['letter_avatar', 'upload', 'gravatar']),
  avatarUuid: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
});

/**
 * A User is someone that has registered on Sentry
 *
 */
var User = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  avatar: Avatar,
  avatarUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  dateJoined: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  email: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  emails: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    is_verified: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    email: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
  })),
  has2fa: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  hasPasswordAuth: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  identities: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  isManaged: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  lastActive: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  lastLogin: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  username: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
});

var Config = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  dsn: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  features: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.instanceOf(Set),
  gravatarBaseUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  invitesEnabled: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  isAuthenticated: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  isOnPremise: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  mediaUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  messages: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,
  needsUpgrade: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  privacyUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  singleOrganization: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  supportEmail: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  termsUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  urlPrefix: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  user: User,
  version: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    current: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    build: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    latest: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    upgradeAvailable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
  })
});

var Deploy = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  environment: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  dateFinished: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  version: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
});

/**
 * A Member is someone that was invited to Sentry but may
 * not have registered for an account yet
 */
var Member = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  dateCreated: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  email: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  flags: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    'sso:linked': __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    'sso:invalid': __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
  }),
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  pending: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  roleName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  user: User
});

var Group = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  annotations: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,
  assignedTo: User,
  count: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  culprit: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  firstSeen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  hasSeen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  isBookmarked: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  isPublic: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  lastSeen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  level: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  logger: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  metadata: Metadata,
  numComments: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  permalink: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  project: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    slug: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
  }),
  shareId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  shortId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  status: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  statusDetails: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['error', 'csp', 'default']),
  userCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
});

var Event = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  context: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  contexts: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  dateCreated: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  dateReceived: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  entries: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
  })),
  errors: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    message: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
  })),
  eventID: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  fingerprints: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string),
  groupID: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  message: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  metadata: Metadata,
  packages: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  platform: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  sdk: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  tags: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    key: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
  })),
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['error', 'csp', 'default']),
  user: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
});

var Tag = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  uniqueValues: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
});

var Actor = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['user', 'team']),
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
});

var Team = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  slug: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
});

var Project = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  slug: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  isBookmarked: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  teams: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(Team).isRequired,
  status: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
});

var ProjectDetail = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  slug: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  dateCreated: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  isBookmarked: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  isMember: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  hasAccess: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  teams: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(Team).isRequired,
  color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  features: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string),
  firstEvent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool]),
  isPublic: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  platform: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  stats: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number)),
  status: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
});

var NavigationObject = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  items: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    path: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    /**
     * Function that is given an object with
     * `access`, `features`
     *
     * Return true to show nav item, false to hide
     */
    show: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool]),

    /**
     * Function that is given an object with
     * `access`, `features`, `organization`
     *
     * Return number to show in badge
     */
    badge: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
  }))
});

var Environment = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
});

var PageLinks = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string;

var Plugin = {
  assets: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,
  author: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    url: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
  }),
  canDisable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  contexts: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,
  doc: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  enabled: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  hasConfiguration: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  isTestable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  metadata: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  shortName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  slug: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  status: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  version: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};

var PluginShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape(Plugin);

var PluginsStore = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  loading: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  plugins: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(PluginShape),
  error: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  pageLinks: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any
});

var ProjectDsn = {
  secret: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  minidump: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  public: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  csp: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};

var ProjectDsnShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape(ProjectDsn);

var ProjectKey = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  dsn: ProjectDsnShape,
  public: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  secret: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  rateLimit: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    count: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    window: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
  }),
  projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  dateCreated: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  label: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  relay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    url: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
  }),
  cdnSdkUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
});

var SentryTypes = {
  AnyModel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
  }),
  Actor: Actor,
  Config: Config,
  Deploy: Deploy,
  Environment: Environment,
  Event: Event,
  Organization: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
  }),
  Group: Group,
  Tag: Tag,
  PageLinks: PageLinks,
  Project: Project,
  TagKey: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    key: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
  }),
  Team: Team,
  NavigationObject: NavigationObject,
  Member: Member,
  Plugin: Plugin,
  PluginShape: PluginShape,
  PluginsStore: PluginsStore,
  ProjectKey: ProjectKey,
  User: User
};

/* harmony default export */ __webpack_exports__["e"] = (SentryTypes);

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api__ = __webpack_require__(46);


var ApiMixin = {
  componentWillMount: function componentWillMount() {
    this.api = new __WEBPACK_IMPORTED_MODULE_0_app_api__["Client"]();
  },
  componentWillUnmount: function componentWillUnmount() {
    this.api.clear();
  }
};

/* harmony default export */ __webpack_exports__["default"] = (ApiMixin);

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return valueIsEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return objectToArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return intcomma; });
/* harmony export (immutable) */ __webpack_exports__["q"] = sortArray;
/* harmony export (immutable) */ __webpack_exports__["m"] = objectIsEmpty;
/* harmony export (immutable) */ __webpack_exports__["t"] = trim;
/* harmony export (immutable) */ __webpack_exports__["g"] = explodeSlug;
/* harmony export (immutable) */ __webpack_exports__["d"] = defined;
/* unused harmony export nl2br */
/* harmony export (immutable) */ __webpack_exports__["l"] = isUrl;
/* harmony export (immutable) */ __webpack_exports__["f"] = escape;
/* harmony export (immutable) */ __webpack_exports__["p"] = percent;
/* harmony export (immutable) */ __webpack_exports__["s"] = toTitleCase;
/* harmony export (immutable) */ __webpack_exports__["i"] = formatBytes;
/* harmony export (immutable) */ __webpack_exports__["j"] = getShortVersion;
/* harmony export (immutable) */ __webpack_exports__["o"] = parseRepo;
/* harmony export (immutable) */ __webpack_exports__["h"] = extractMultilineFields;
/* harmony export (immutable) */ __webpack_exports__["r"] = sortProjects;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buildUserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildTeamId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isString__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isUndefined__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isObject__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_utils_parseLinkHeader__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_utils_deviceNameMapper__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_utils_collection__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_utils_pendingChangeQueue__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_utils_cursorPoller__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_utils_streamManager__ = __webpack_require__(903);
/* unused harmony reexport parseLinkHeader */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5_app_utils_deviceNameMapper__["a"]; });
/* unused harmony reexport Collection */
/* unused harmony reexport PendingChangeQueue */
/* unused harmony reexport CursorPoller */






// import/export sub-utils







/*eslint no-use-before-define:0*/

var arrayIsEqual = function arrayIsEqual(arr, other, deep) {
  // if the other array is a falsy value, return
  if (!arr && !other) {
    return true;
  }

  if (!arr || !other) {
    return false;
  }

  // compare lengths - can save a lot of time
  if (arr.length != other.length) {
    return false;
  }

  return arr.every(function (val, idx) {
    return valueIsEqual(val, other[idx], deep);
  });
};

var valueIsEqual = function valueIsEqual(value, other, deep) {
  if (value === other) {
    return true;
  } else if (__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(value) || __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(other)) {
    if (arrayIsEqual(value, other, deep)) {
      return true;
    }
  } else if (__WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default()(value) || __WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default()(other)) {
    if (objectMatchesSubset(value, other, deep)) {
      return true;
    }
  }
  return false;
};

var objectMatchesSubset = function objectMatchesSubset(obj, other, deep) {
  var k = void 0;

  if (obj === other) {
    return true;
  }

  if (!obj || !other) {
    return false;
  }

  if (deep !== true) {
    for (k in other) {
      if (obj[k] != other[k]) {
        return false;
      }
    }
    return true;
  }

  for (k in other) {
    if (!valueIsEqual(obj[k], other[k], deep)) {
      return false;
    }
  }
  return true;
};

// XXX(dcramer): the previous mechanism of using _.map here failed
// miserably if a param was named 'length'
var objectToArray = function objectToArray(obj) {
  var result = [];
  for (var key in obj) {
    result.push([key, obj[key]]);
  }
  return result;
};

var intcomma = function intcomma(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

function sortArray(arr, score_fn) {
  arr.sort(function (a, b) {
    var a_score = score_fn(a),
        b_score = score_fn(b);

    for (var i = 0; i < a_score.length; i++) {
      if (a_score[i] > b_score[i]) {
        return 1;
      }
      if (a_score[i] < b_score[i]) {
        return -1;
      }
    }
    return 0;
  });

  return arr;
}

function objectIsEmpty(obj) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      return false;
    }
  }

  return true;
}

function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
}

/**
 * Replaces slug special chars with a space
 */
function explodeSlug(slug) {
  return trim(slug.replace(/[-_]+/g, ' '));
}

function defined(item) {
  return !__WEBPACK_IMPORTED_MODULE_1_lodash_isUndefined___default()(item) && item !== null;
}

function nl2br(str) {
  return str.replace(/(?:\r\n|\r|\n)/g, '<br />');
}

function isUrl(str) {
  return !!str && __WEBPACK_IMPORTED_MODULE_0_lodash_isString___default()(str) && (str.indexOf('http://') === 0 || str.indexOf('https://') === 0);
}

function escape(str) {
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function percent(value, totalValue, precise) {
  return value / totalValue * 100;
}

function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function formatBytes(bytes) {
  var units = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var thresh = 1024;
  if (bytes < thresh) {
    return bytes + ' B';
  }

  var u = -1;
  do {
    bytes /= thresh;
    ++u;
  } while (bytes >= thresh);
  return bytes.toFixed(1) + ' ' + units[u];
}

function getShortVersion(version) {
  var match = version.match(/^(?:[a-zA-Z][a-zA-Z0-9-]+)(?:\.[a-zA-Z][a-zA-Z0-9-]+)+-(.*)$/);
  if (match) {
    version = match[1];
  }
  if (version.match(/^[a-f0-9]{40}$/)) {
    version = version.substr(0, 7);
  }
  return version;
}

function parseRepo(repo) {
  if (!repo) {
    return repo;
  } else {
    var re = /(?:github\.com|bitbucket\.org)\/([^\/]+\/[^\/]+)/i;
    var match = repo.match(re);
    var parsedRepo = match ? match[1] : repo;
    return parsedRepo;
  }
}

/**
 * Converts a multi-line textarea input value into an array,
 * eliminating empty lines
 */
function extractMultilineFields(value) {
  return value.split('\n').map(function (f) {
    return trim(f);
  }).filter(function (f) {
    return f !== '';
  });
}

function projectDisplayCompare(a, b) {
  if (a.isBookmarked !== b.isBookmarked) {
    return a.isBookmarked ? -1 : 1;
  }
  return a.slug.localeCompare(b.slug);
}

// Sort a list of projects by bookmarkedness, then by id
function sortProjects(projects) {
  return projects.sort(projectDisplayCompare);
}

//build actorIds
var buildUserId = function buildUserId(id) {
  return 'user:' + id;
};
var buildTeamId = function buildTeamId(id) {
  return 'team:' + id;
};

// re-export under utils


// backwards compatible default export for use w/ getsentry (exported
// as a single object w/ function refs for consumption by getsentry)
/* harmony default export */ __webpack_exports__["c"] = ({
  sortArray: sortArray,
  objectIsEmpty: objectIsEmpty,
  defined: defined,
  nl2br: nl2br,
  isUrl: isUrl,
  escape: escape,
  percent: percent,
  toTitleCase: toTitleCase,
  intcomma: intcomma,
  valueIsEqual: valueIsEqual,
  parseLinkHeader: __WEBPACK_IMPORTED_MODULE_4_app_utils_parseLinkHeader__["a" /* default */],
  buildUserId: buildUserId,
  buildTeamId: buildTeamId,

  // external imports
  deviceNameMapper: __WEBPACK_IMPORTED_MODULE_5_app_utils_deviceNameMapper__["a" /* default */],
  objectToArray: objectToArray,
  Collection: __WEBPACK_IMPORTED_MODULE_6_app_utils_collection__["a" /* default */],
  PendingChangeQueue: __WEBPACK_IMPORTED_MODULE_7_app_utils_pendingChangeQueue__["a" /* default */],
  StreamManager: __WEBPACK_IMPORTED_MODULE_9_app_utils_streamManager__["a" /* default */],
  CursorPoller: __WEBPACK_IMPORTED_MODULE_8_app_utils_cursorPoller__["a" /* default */]
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);




function LoadingIndicator(props) {
  var hideMessage = props.hideMessage,
      mini = props.mini,
      triangle = props.triangle,
      overlay = props.overlay,
      dark = props.dark,
      children = props.children,
      finished = props.finished,
      className = props.className,
      style = props.style,
      relative = props.relative,
      size = props.size;

  var cx = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
    overlay: overlay,
    dark: dark,
    loading: true,
    mini: mini,
    triangle: triangle
  });

  var loadingCx = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
    relative: relative,
    'loading-indicator': true,
    'load-complete': finished
  });

  var loadingStyle = {};
  if (size) {
    loadingStyle = {
      width: size,
      height: size
    };
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: cx, style: style },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: loadingCx, style: loadingStyle },
      finished ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'checkmark draw' }) : null
    ),
    !hideMessage && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'loading-message' },
      children
    )
  );
}

LoadingIndicator.propTypes = {
  overlay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  dark: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  mini: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  triangle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  finished: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  relative: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  hideMessage: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
};

/* harmony default export */ __webpack_exports__["default"] = (LoadingIndicator);

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes += ' ' + arg;
			} else if (Array.isArray(arg)) {
				classes += ' ' + classNames.apply(null, arg);
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes += ' ' + key;
					}
				}
			}
		}

		return classes.substr(1);
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var LoadingError = (_temp = _class = function (_React$Component) {
  _inherits(LoadingError, _React$Component);

  function LoadingError() {
    _classCallCheck(this, LoadingError);

    return _possibleConstructorReturn(this, (LoadingError.__proto__ || Object.getPrototypeOf(LoadingError)).apply(this, arguments));
  }

  _createClass(LoadingError, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'alert alert-error alert-block' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          this.props.message,
          this.props.onRetry && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            {
              onClick: this.props.onRetry,
              className: 'btn btn-default btn-sm',
              style: { marginLeft: 5 }
            },
            Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Retry')
          )
        )
      );
    }
  }]);

  return LoadingError;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  onRetry: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  message: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, _class.defaultProps = {
  message: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('There was an error loading data.')
}, _temp);


/* harmony default export */ __webpack_exports__["default"] = (LoadingError);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.BrowserSpriteSymbol = factory());
}(this, (function () { 'use strict';

var SpriteSymbol = function SpriteSymbol(ref) {
  var id = ref.id;
  var viewBox = ref.viewBox;
  var content = ref.content;

  this.id = id;
  this.viewBox = viewBox;
  this.content = content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.stringify = function stringify () {
  return this.content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.toString = function toString () {
  return this.stringify();
};

SpriteSymbol.prototype.destroy = function destroy () {
    var this$1 = this;

  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
};

/**
 * @param {string} content
 * @return {Element}
 */
var parse = function (content) {
  var hasImportNode = !!document.importNode;
  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;

  /**
   * Fix for browser which are throwing WrongDocumentError
   * if you insert an element which is not part of the document
   * @see http://stackoverflow.com/a/7986519/4624403
   */
  if (hasImportNode) {
    return document.importNode(doc, true);
  }

  return doc;
};

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var index = createCommonjsModule(function (module, exports) {
(function (root, factory) {
    if (false) {
        undefined(factory);
    } else {
        module.exports = factory();
    }
}(commonjsGlobal, function () {

function isMergeableObject(val) {
    var nonNullObject = val && typeof val === 'object';

    return nonNullObject
        && Object.prototype.toString.call(val) !== '[object RegExp]'
        && Object.prototype.toString.call(val) !== '[object Date]'
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function (key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function (key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination
}

function deepmerge(target, source, optionsArgument) {
    var array = Array.isArray(source);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var arrayMerge = options.arrayMerge || defaultArrayMerge;

    if (array) {
        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
};

return deepmerge

}));
});

var namespaces_1 = createCommonjsModule(function (module, exports) {
var namespaces = {
  svg: {
    name: 'xmlns',
    uri: 'http://www.w3.org/2000/svg'
  },
  xlink: {
    name: 'xmlns:xlink',
    uri: 'http://www.w3.org/1999/xlink'
  }
};

exports.default = namespaces;
module.exports = exports.default;
});

/**
 * @param {Object} attrs
 * @return {string}
 */
var objectToAttrsString = function (attrs) {
  return Object.keys(attrs).map(function (attr) {
    var value = attrs[attr].toString().replace(/"/g, '&quot;');
    return (attr + "=\"" + value + "\"");
  }).join(' ');
};

var svg = namespaces_1.svg;
var xlink = namespaces_1.xlink;

var defaultAttrs = {};
defaultAttrs[svg.name] = svg.uri;
defaultAttrs[xlink.name] = xlink.uri;

/**
 * @param {string} [content]
 * @param {Object} [attributes]
 * @return {string}
 */
var wrapInSvgString = function (content, attributes) {
  if ( content === void 0 ) content = '';

  var attrs = index(defaultAttrs, attributes || {});
  var attrsRendered = objectToAttrsString(attrs);
  return ("<svg " + attrsRendered + ">" + content + "</svg>");
};

var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
  function BrowserSpriteSymbol () {
    SpriteSymbol$$1.apply(this, arguments);
  }

  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;

  var prototypeAccessors = { isMounted: {} };

  prototypeAccessors.isMounted.get = function () {
    return !!this.node;
  };

  /**
   * @param {Element} node
   * @return {BrowserSpriteSymbol}
   */
  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
    return new BrowserSpriteSymbol({
      id: node.getAttribute('id'),
      viewBox: node.getAttribute('viewBox'),
      content: node.outerHTML
    });
  };

  BrowserSpriteSymbol.prototype.destroy = function destroy () {
    if (this.isMounted) {
      this.unmount();
    }
    SpriteSymbol$$1.prototype.destroy.call(this);
  };

  /**
   * @param {Element|string} target
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.mount = function mount (target) {
    if (this.isMounted) {
      return this.node;
    }

    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
    var node = this.render();
    this.node = node;

    mountTarget.appendChild(node);

    return node;
  };

  /**
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.render = function render () {
    var content = this.stringify();
    return parse(wrapInSvgString(content)).childNodes[0];
  };

  BrowserSpriteSymbol.prototype.unmount = function unmount () {
    this.node.parentNode.removeChild(this.node);
  };

  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );

  return BrowserSpriteSymbol;
}(SpriteSymbol));

return BrowserSpriteSymbol;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.BrowserSprite = factory());
}(this, (function () { 'use strict';

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var index = createCommonjsModule(function (module, exports) {
(function (root, factory) {
    if (false) {
        undefined(factory);
    } else {
        module.exports = factory();
    }
}(commonjsGlobal, function () {

function isMergeableObject(val) {
    var nonNullObject = val && typeof val === 'object';

    return nonNullObject
        && Object.prototype.toString.call(val) !== '[object RegExp]'
        && Object.prototype.toString.call(val) !== '[object Date]'
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function (key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function (key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination
}

function deepmerge(target, source, optionsArgument) {
    var array = Array.isArray(source);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var arrayMerge = options.arrayMerge || defaultArrayMerge;

    if (array) {
        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
};

return deepmerge

}));
});

//      
// An event handler can take an optional event argument
// and should not return a value
                                          
// An array of all currently registered event handlers for a type
                                            
// A map of event types and their corresponding event handlers.
                        
                                   
  

/** Mitt: Tiny (~200b) functional event emitter / pubsub.
 *  @name mitt
 *  @returns {Mitt}
 */
function mitt(all                 ) {
	all = all || Object.create(null);

	return {
		/**
		 * Register an event handler for the given type.
		 *
		 * @param  {String} type	Type of event to listen for, or `"*"` for all events
		 * @param  {Function} handler Function to call in response to given event
		 * @memberOf mitt
		 */
		on: function on(type        , handler              ) {
			(all[type] || (all[type] = [])).push(handler);
		},

		/**
		 * Remove an event handler for the given type.
		 *
		 * @param  {String} type	Type of event to unregister `handler` from, or `"*"`
		 * @param  {Function} handler Handler function to remove
		 * @memberOf mitt
		 */
		off: function off(type        , handler              ) {
			if (all[type]) {
				all[type].splice(all[type].indexOf(handler) >>> 0, 1);
			}
		},

		/**
		 * Invoke all handlers for the given type.
		 * If present, `"*"` handlers are invoked after type-matched handlers.
		 *
		 * @param {String} type  The event type to invoke
		 * @param {Any} [evt]  Any value (object is recommended and powerful), passed to each handler
		 * @memberof mitt
		 */
		emit: function emit(type        , evt     ) {
			(all[type] || []).map(function (handler) { handler(evt); });
			(all['*'] || []).map(function (handler) { handler(type, evt); });
		}
	};
}

var namespaces_1 = createCommonjsModule(function (module, exports) {
var namespaces = {
  svg: {
    name: 'xmlns',
    uri: 'http://www.w3.org/2000/svg'
  },
  xlink: {
    name: 'xmlns:xlink',
    uri: 'http://www.w3.org/1999/xlink'
  }
};

exports.default = namespaces;
module.exports = exports.default;
});

/**
 * @param {Object} attrs
 * @return {string}
 */
var objectToAttrsString = function (attrs) {
  return Object.keys(attrs).map(function (attr) {
    var value = attrs[attr].toString().replace(/"/g, '&quot;');
    return (attr + "=\"" + value + "\"");
  }).join(' ');
};

var svg = namespaces_1.svg;
var xlink = namespaces_1.xlink;

var defaultAttrs = {};
defaultAttrs[svg.name] = svg.uri;
defaultAttrs[xlink.name] = xlink.uri;

/**
 * @param {string} [content]
 * @param {Object} [attributes]
 * @return {string}
 */
var wrapInSvgString = function (content, attributes) {
  if ( content === void 0 ) content = '';

  var attrs = index(defaultAttrs, attributes || {});
  var attrsRendered = objectToAttrsString(attrs);
  return ("<svg " + attrsRendered + ">" + content + "</svg>");
};

var svg$1 = namespaces_1.svg;
var xlink$1 = namespaces_1.xlink;

var defaultConfig = {
  attrs: ( obj = {
    style: ['position: absolute', 'width: 0', 'height: 0'].join('; ')
  }, obj[svg$1.name] = svg$1.uri, obj[xlink$1.name] = xlink$1.uri, obj )
};
var obj;

var Sprite = function Sprite(config) {
  this.config = index(defaultConfig, config || {});
  this.symbols = [];
};

/**
 * Add new symbol. If symbol with the same id exists it will be replaced.
 * @param {SpriteSymbol} symbol
 * @return {boolean} `true` - symbol was added, `false` - replaced
 */
Sprite.prototype.add = function add (symbol) {
  var ref = this;
    var symbols = ref.symbols;
  var existing = this.find(symbol.id);

  if (existing) {
    symbols[symbols.indexOf(existing)] = symbol;
    return false;
  }

  symbols.push(symbol);
  return true;
};

/**
 * Remove symbol & destroy it
 * @param {string} id
 * @return {boolean} `true` - symbol was found & successfully destroyed, `false` - otherwise
 */
Sprite.prototype.remove = function remove (id) {
  var ref = this;
    var symbols = ref.symbols;
  var symbol = this.find(id);

  if (symbol) {
    symbols.splice(symbols.indexOf(symbol), 1);
    symbol.destroy();
    return true;
  }

  return false;
};

/**
 * @param {string} id
 * @return {SpriteSymbol|null}
 */
Sprite.prototype.find = function find (id) {
  return this.symbols.filter(function (s) { return s.id === id; })[0] || null;
};

/**
 * @param {string} id
 * @return {boolean}
 */
Sprite.prototype.has = function has (id) {
  return this.find(id) !== null;
};

/**
 * @return {string}
 */
Sprite.prototype.stringify = function stringify () {
  var ref = this.config;
    var attrs = ref.attrs;
  var stringifiedSymbols = this.symbols.map(function (s) { return s.stringify(); }).join('');
  return wrapInSvgString(stringifiedSymbols, attrs);
};

/**
 * @return {string}
 */
Sprite.prototype.toString = function toString () {
  return this.stringify();
};

Sprite.prototype.destroy = function destroy () {
  this.symbols.forEach(function (s) { return s.destroy(); });
};

var SpriteSymbol = function SpriteSymbol(ref) {
  var id = ref.id;
  var viewBox = ref.viewBox;
  var content = ref.content;

  this.id = id;
  this.viewBox = viewBox;
  this.content = content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.stringify = function stringify () {
  return this.content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.toString = function toString () {
  return this.stringify();
};

SpriteSymbol.prototype.destroy = function destroy () {
    var this$1 = this;

  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
};

/**
 * @param {string} content
 * @return {Element}
 */
var parse = function (content) {
  var hasImportNode = !!document.importNode;
  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;

  /**
   * Fix for browser which are throwing WrongDocumentError
   * if you insert an element which is not part of the document
   * @see http://stackoverflow.com/a/7986519/4624403
   */
  if (hasImportNode) {
    return document.importNode(doc, true);
  }

  return doc;
};

var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
  function BrowserSpriteSymbol () {
    SpriteSymbol$$1.apply(this, arguments);
  }

  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;

  var prototypeAccessors = { isMounted: {} };

  prototypeAccessors.isMounted.get = function () {
    return !!this.node;
  };

  /**
   * @param {Element} node
   * @return {BrowserSpriteSymbol}
   */
  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
    return new BrowserSpriteSymbol({
      id: node.getAttribute('id'),
      viewBox: node.getAttribute('viewBox'),
      content: node.outerHTML
    });
  };

  BrowserSpriteSymbol.prototype.destroy = function destroy () {
    if (this.isMounted) {
      this.unmount();
    }
    SpriteSymbol$$1.prototype.destroy.call(this);
  };

  /**
   * @param {Element|string} target
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.mount = function mount (target) {
    if (this.isMounted) {
      return this.node;
    }

    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
    var node = this.render();
    this.node = node;

    mountTarget.appendChild(node);

    return node;
  };

  /**
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.render = function render () {
    var content = this.stringify();
    return parse(wrapInSvgString(content)).childNodes[0];
  };

  BrowserSpriteSymbol.prototype.unmount = function unmount () {
    this.node.parentNode.removeChild(this.node);
  };

  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );

  return BrowserSpriteSymbol;
}(SpriteSymbol));

var defaultConfig$1 = {
  /**
   * Should following options be automatically configured:
   * - `syncUrlsWithBaseTag`
   * - `locationChangeAngularEmitter`
   * - `moveGradientsOutsideSymbol`
   * @type {boolean}
   */
  autoConfigure: true,

  /**
   * Default mounting selector
   * @type {string}
   */
  mountTo: 'body',

  /**
   * Fix disappearing SVG elements when <base href> exists.
   * Executes when sprite mounted.
   * @see http://stackoverflow.com/a/18265336/796152
   * @see https://github.com/everdimension/angular-svg-base-fix
   * @see https://github.com/angular/angular.js/issues/8934#issuecomment-56568466
   * @type {boolean}
   */
  syncUrlsWithBaseTag: false,

  /**
   * Should sprite listen custom location change event
   * @type {boolean}
   */
  listenLocationChangeEvent: true,

  /**
   * Custom window event name which should be emitted to update sprite urls
   * @type {string}
   */
  locationChangeEvent: 'locationChange',

  /**
   * Emit location change event in Angular automatically
   * @type {boolean}
   */
  locationChangeAngularEmitter: false,

  /**
   * Selector to find symbols usages when updating sprite urls
   * @type {string}
   */
  usagesToUpdate: 'use[*|href]',

  /**
   * Fix Firefox bug when gradients and patterns don't work if they are within a symbol.
   * Executes when sprite is rendered, but not mounted.
   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=306674
   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=353575
   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=1235364
   * @type {boolean}
   */
  moveGradientsOutsideSymbol: false
};

/**
 * @param {*} arrayLike
 * @return {Array}
 */
var arrayFrom = function (arrayLike) {
  return Array.prototype.slice.call(arrayLike, 0);
};

var ua = navigator.userAgent;

var browser = {
  isChrome: /chrome/i.test(ua),
  isFirefox: /firefox/i.test(ua),

  // https://msdn.microsoft.com/en-us/library/ms537503(v=vs.85).aspx
  isIE: /msie/i.test(ua) || /trident/i.test(ua),
  isEdge: /edge/i.test(ua)
};

/**
 * @param {string} name
 * @param {*} data
 */
var dispatchEvent = function (name, data) {
  var event = document.createEvent('CustomEvent');
  event.initCustomEvent(name, false, false, data);
  window.dispatchEvent(event);
};

/**
 * IE doesn't evaluate <style> tags in SVGs that are dynamically added to the page.
 * This trick will trigger IE to read and use any existing SVG <style> tags.
 * @see https://github.com/iconic/SVGInjector/issues/23
 * @see https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10898469/
 *
 * @param {Element} node DOM Element to search <style> tags in
 * @return {Array<HTMLStyleElement>}
 */
var evalStylesIEWorkaround = function (node) {
  var updatedNodes = [];

  arrayFrom(node.querySelectorAll('style'))
    .forEach(function (style) {
      style.textContent += '';
      updatedNodes.push(style);
    });

  return updatedNodes;
};

/**
 * @param {string} [url] If not provided - current URL will be used
 * @return {string}
 */
var getUrlWithoutFragment = function (url) {
  return (url || window.location.href).split('#')[0];
};

/* global angular */
/**
 * @param {string} eventName
 */
var locationChangeAngularEmitter = function (eventName) {
  angular.module('ng').run(['$rootScope', function ($rootScope) {
    $rootScope.$on('$locationChangeSuccess', function (e, newUrl, oldUrl) {
      dispatchEvent(eventName, { oldUrl: oldUrl, newUrl: newUrl });
    });
  }]);
};

var defaultSelector = 'linearGradient, radialGradient, pattern';

/**
 * @param {Element} svg
 * @param {string} [selector]
 * @return {Element}
 */
var moveGradientsOutsideSymbol = function (svg, selector) {
  if ( selector === void 0 ) selector = defaultSelector;

  arrayFrom(svg.querySelectorAll('symbol')).forEach(function (symbol) {
    arrayFrom(symbol.querySelectorAll(selector)).forEach(function (node) {
      symbol.parentNode.insertBefore(node, symbol);
    });
  });
  return svg;
};

/**
 * @param {NodeList} nodes
 * @param {Function} [matcher]
 * @return {Attr[]}
 */
function selectAttributes(nodes, matcher) {
  var attrs = arrayFrom(nodes).reduce(function (acc, node) {
    if (!node.attributes) {
      return acc;
    }

    var arrayfied = arrayFrom(node.attributes);
    var matched = matcher ? arrayfied.filter(matcher) : arrayfied;
    return acc.concat(matched);
  }, []);

  return attrs;
}

/**
 * @param {NodeList|Node} nodes
 * @param {boolean} [clone=true]
 * @return {string}
 */

var xLinkNS = namespaces_1.xlink.uri;
var xLinkAttrName = 'xlink:href';

// eslint-disable-next-line no-useless-escape
var specialUrlCharsPattern = /[{}|\\\^\[\]`"<>]/g;

function encoder(url) {
  return url.replace(specialUrlCharsPattern, function (match) {
    return ("%" + (match[0].charCodeAt(0).toString(16).toUpperCase()));
  });
}

/**
 * @param {NodeList} nodes
 * @param {string} startsWith
 * @param {string} replaceWith
 * @return {NodeList}
 */
function updateReferences(nodes, startsWith, replaceWith) {
  arrayFrom(nodes).forEach(function (node) {
    var href = node.getAttribute(xLinkAttrName);
    if (href && href.indexOf(startsWith) === 0) {
      var newUrl = href.replace(startsWith, replaceWith);
      node.setAttributeNS(xLinkNS, xLinkAttrName, newUrl);
    }
  });

  return nodes;
}

/**
 * List of SVG attributes to update url() target in them
 */
var attList = [
  'clipPath',
  'colorProfile',
  'src',
  'cursor',
  'fill',
  'filter',
  'marker',
  'markerStart',
  'markerMid',
  'markerEnd',
  'mask',
  'stroke',
  'style'
];

var attSelector = attList.map(function (attr) { return ("[" + attr + "]"); }).join(',');

/**
 * Update URLs in svg image (like `fill="url(...)"`) and update referencing elements
 * @param {Element} svg
 * @param {NodeList} references
 * @param {string|RegExp} startsWith
 * @param {string} replaceWith
 * @return {void}
 *
 * @example
 * const sprite = document.querySelector('svg.sprite');
 * const usages = document.querySelectorAll('use');
 * updateUrls(sprite, usages, '#', 'prefix#');
 */
var updateUrls = function (svg, references, startsWith, replaceWith) {
  var startsWithEncoded = encoder(startsWith);
  var replaceWithEncoded = encoder(replaceWith);

  var nodes = svg.querySelectorAll(attSelector);
  var attrs = selectAttributes(nodes, function (ref) {
    var localName = ref.localName;
    var value = ref.value;

    return attList.indexOf(localName) !== -1 && value.indexOf(("url(" + startsWithEncoded)) !== -1;
  });

  attrs.forEach(function (attr) { return attr.value = attr.value.replace(startsWithEncoded, replaceWithEncoded); });
  updateReferences(references, startsWithEncoded, replaceWithEncoded);
};

/**
 * Internal emitter events
 * @enum
 * @private
 */
var Events = {
  MOUNT: 'mount',
  SYMBOL_MOUNT: 'symbol_mount'
};

var BrowserSprite = (function (Sprite$$1) {
  function BrowserSprite(cfg) {
    var this$1 = this;
    if ( cfg === void 0 ) cfg = {};

    Sprite$$1.call(this, index(defaultConfig$1, cfg));

    var emitter = mitt();
    this._emitter = emitter;
    this.node = null;

    var ref = this;
    var config = ref.config;

    if (config.autoConfigure) {
      this._autoConfigure(cfg);
    }

    if (config.syncUrlsWithBaseTag) {
      var baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
      emitter.on(Events.MOUNT, function () { return this$1.updateUrls('#', baseUrl); });
    }

    var handleLocationChange = this._handleLocationChange.bind(this);
    this._handleLocationChange = handleLocationChange;

    // Provide way to update sprite urls externally via dispatching custom window event
    if (config.listenLocationChangeEvent) {
      window.addEventListener(config.locationChangeEvent, handleLocationChange);
    }

    // Emit location change event in Angular automatically
    if (config.locationChangeAngularEmitter) {
      locationChangeAngularEmitter(config.locationChangeEvent);
    }

    // After sprite mounted
    emitter.on(Events.MOUNT, function (spriteNode) {
      if (config.moveGradientsOutsideSymbol) {
        moveGradientsOutsideSymbol(spriteNode);
      }
    });

    // After symbol mounted into sprite
    emitter.on(Events.SYMBOL_MOUNT, function (symbolNode) {
      if (config.moveGradientsOutsideSymbol) {
        moveGradientsOutsideSymbol(symbolNode.parentNode);
      }

      if (browser.isIE || browser.isEdge) {
        evalStylesIEWorkaround(symbolNode);
      }
    });
  }

  if ( Sprite$$1 ) BrowserSprite.__proto__ = Sprite$$1;
  BrowserSprite.prototype = Object.create( Sprite$$1 && Sprite$$1.prototype );
  BrowserSprite.prototype.constructor = BrowserSprite;

  var prototypeAccessors = { isMounted: {} };

  /**
   * @return {boolean}
   */
  prototypeAccessors.isMounted.get = function () {
    return !!this.node;
  };

  /**
   * Automatically configure following options
   * - `syncUrlsWithBaseTag`
   * - `locationChangeAngularEmitter`
   * - `moveGradientsOutsideSymbol`
   * @param {Object} cfg
   * @private
   */
  BrowserSprite.prototype._autoConfigure = function _autoConfigure (cfg) {
    var ref = this;
    var config = ref.config;

    if (typeof cfg.syncUrlsWithBaseTag === 'undefined') {
      config.syncUrlsWithBaseTag = typeof document.getElementsByTagName('base')[0] !== 'undefined';
    }

    if (typeof cfg.locationChangeAngularEmitter === 'undefined') {
      config.locationChangeAngularEmitter = 'angular' in window;
    }

    if (typeof cfg.moveGradientsOutsideSymbol === 'undefined') {
      config.moveGradientsOutsideSymbol = browser.isFirefox;
    }
  };

  /**
   * @param {Event} event
   * @param {Object} event.detail
   * @param {string} event.detail.oldUrl
   * @param {string} event.detail.newUrl
   * @private
   */
  BrowserSprite.prototype._handleLocationChange = function _handleLocationChange (event) {
    var ref = event.detail;
    var oldUrl = ref.oldUrl;
    var newUrl = ref.newUrl;
    this.updateUrls(oldUrl, newUrl);
  };

  /**
   * Add new symbol. If symbol with the same id exists it will be replaced.
   * If sprite already mounted - `symbol.mount(sprite.node)` will be called.
   * @fires Events#SYMBOL_MOUNT
   * @param {BrowserSpriteSymbol} symbol
   * @return {boolean} `true` - symbol was added, `false` - replaced
   */
  BrowserSprite.prototype.add = function add (symbol) {
    var sprite = this;
    var isNewSymbol = Sprite$$1.prototype.add.call(this, symbol);

    if (this.isMounted && isNewSymbol) {
      symbol.mount(sprite.node);
      this._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
    }

    return isNewSymbol;
  };

  /**
   * Attach to existing DOM node
   * @param {string|Element} target
   * @return {Element|null} attached DOM Element. null if node to attach not found.
   */
  BrowserSprite.prototype.attach = function attach (target) {
    var this$1 = this;

    var sprite = this;

    if (sprite.isMounted) {
      return sprite.node;
    }

    /** @type Element */
    var node = typeof target === 'string' ? document.querySelector(target) : target;
    sprite.node = node;

    // Already added symbols needs to be mounted
    this.symbols.forEach(function (symbol) {
      symbol.mount(sprite.node);
      this$1._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
    });

    // Create symbols from existing DOM nodes, add and mount them
    arrayFrom(node.querySelectorAll('symbol'))
      .forEach(function (symbolNode) {
        var symbol = BrowserSpriteSymbol.createFromExistingNode(symbolNode);
        symbol.node = symbolNode; // hack to prevent symbol mounting to sprite when adding
        sprite.add(symbol);
      });

    this._emitter.emit(Events.MOUNT, node);

    return node;
  };

  BrowserSprite.prototype.destroy = function destroy () {
    var ref = this;
    var config = ref.config;
    var symbols = ref.symbols;
    var _emitter = ref._emitter;

    symbols.forEach(function (s) { return s.destroy(); });

    _emitter.off('*');
    window.removeEventListener(config.locationChangeEvent, this._handleLocationChange);

    if (this.isMounted) {
      this.unmount();
    }
  };

  /**
   * @fires Events#MOUNT
   * @param {string|Element} [target]
   * @param {boolean} [prepend=false]
   * @return {Element|null} rendered sprite node. null if mount node not found.
   */
  BrowserSprite.prototype.mount = function mount (target, prepend) {
    if ( target === void 0 ) target = this.config.mountTo;
    if ( prepend === void 0 ) prepend = false;

    var sprite = this;

    if (sprite.isMounted) {
      return sprite.node;
    }

    var mountNode = typeof target === 'string' ? document.querySelector(target) : target;
    var node = sprite.render();
    this.node = node;

    if (prepend && mountNode.childNodes[0]) {
      mountNode.insertBefore(node, mountNode.childNodes[0]);
    } else {
      mountNode.appendChild(node);
    }

    this._emitter.emit(Events.MOUNT, node);

    return node;
  };

  /**
   * @return {Element}
   */
  BrowserSprite.prototype.render = function render () {
    return parse(this.stringify());
  };

  /**
   * Detach sprite from the DOM
   */
  BrowserSprite.prototype.unmount = function unmount () {
    this.node.parentNode.removeChild(this.node);
  };

  /**
   * Update URLs in sprite and usage elements
   * @param {string} oldUrl
   * @param {string} newUrl
   * @return {boolean} `true` - URLs was updated, `false` - sprite is not mounted
   */
  BrowserSprite.prototype.updateUrls = function updateUrls$1 (oldUrl, newUrl) {
    if (!this.isMounted) {
      return false;
    }

    var usages = document.querySelectorAll(this.config.usagesToUpdate);

    updateUrls(
      this.node,
      usages,
      ((getUrlWithoutFragment(oldUrl)) + "#"),
      ((getUrlWithoutFragment(newUrl)) + "#")
    );

    return true;
  };

  Object.defineProperties( BrowserSprite.prototype, prototypeAccessors );

  return BrowserSprite;
}(Sprite));

var ready$1 = createCommonjsModule(function (module) {
/*!
  * domready (c) Dustin Diaz 2014 - License MIT
  */
!function (name, definition) {

  { module.exports = definition(); }

}('domready', function () {

  var fns = [], listener
    , doc = document
    , hack = doc.documentElement.doScroll
    , domContentLoaded = 'DOMContentLoaded'
    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState);


  if (!loaded)
  { doc.addEventListener(domContentLoaded, listener = function () {
    doc.removeEventListener(domContentLoaded, listener);
    loaded = 1;
    while (listener = fns.shift()) { listener(); }
  }); }

  return function (fn) {
    loaded ? setTimeout(fn, 0) : fns.push(fn);
  }

});
});

var spriteNodeId = '__SVG_SPRITE_NODE__';
var spriteGlobalVarName = '__SVG_SPRITE__';
var isSpriteExists = !!window[spriteGlobalVarName];

// eslint-disable-next-line import/no-mutable-exports
var sprite;

if (isSpriteExists) {
  sprite = window[spriteGlobalVarName];
} else {
  sprite = new BrowserSprite({ attrs: { id: spriteNodeId } });
  window[spriteGlobalVarName] = sprite;
}

var loadSprite = function () {
  /**
   * Check for page already contains sprite node
   * If found - attach to and reuse it's content
   * If not - render and mount the new sprite
   */
  var existing = document.getElementById(spriteNodeId);

  if (existing) {
    sprite.attach(existing);
  } else {
    sprite.mount(document.body, true);
  }
};

if (document.body) {
  loadSprite();
} else {
  ready$1(loadSprite);
}

var sprite$1 = sprite;

return sprite$1;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_components_panels_panel__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_panels_panelHeader__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_panels_panelBody__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_panels_panelFooter__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_panels_panelItem__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_panels_panelAlert__ = __webpack_require__(312);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_app_components_panels_panel__["default"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1_app_components_panels_panelHeader__["default"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2_app_components_panels_panelBody__["default"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3_app_components_panels_panelFooter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4_app_components_panels_panelItem__["default"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5_app_components_panels_panelAlert__["a"]; });









/***/ }),
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_js_tooltip__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_js_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_js_tooltip__);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// Non-mixin way to get Tooltips
// Right now this just wraps Bootstrap's tooltip
var Tooltip = (_temp2 = _class = function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  function Tooltip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidUpdate = function (prevProps) {
      // Reattach tooltip if options or tooltip message changes
      if (!_this.props.disabled && (!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevProps.tooltipOptions, _this.props.tooltipOptions) || prevProps.title != _this.props.title)) {
        _this.removeTooltips(_this.ref);
        _this.attachTooltips(_this.ref);
      }
    }, _this.handleMount = function (ref) {
      if (ref && !_this.ref) {
        // eslint-disable-next-line react/no-find-dom-node
        _this.attachTooltips(ref);
      } else if (!ref && _this.ref) {
        _this.removeTooltips(ref);
      }

      _this.ref = ref;
    }, _this.attachTooltips = function (ref) {
      _this.$ref = $(__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(ref));

      var _this$props = _this.props,
          title = _this$props.title,
          tooltipOptions = _this$props.tooltipOptions;

      var options = typeof tooltipOptions === 'function' ? tooltipOptions.call(_this) : tooltipOptions || {};

      _this.$ref.tooltip(_extends({
        title: title
      }, options));
    }, _this.removeTooltips = function (ref) {
      _this.$ref = $(__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(ref));

      var tooltipOptions = _this.props.tooltipOptions;


      _this.$ref.tooltip('destroy') // destroy tooltips on parent ...
      .find(tooltipOptions && tooltipOptions.selector).tooltip('destroy'); // ... and descendents

      _this.$ref = null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tooltip, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var disabled = this.props.disabled;

      if (newProps.disabled && !disabled) {
        this.removeTooltips(this.ref);
      } else if (!newProps.disabled && disabled) {
        this.attachTooltips(this.ref);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          title = _props.title,
          children = _props.children,
          disabled = _props.disabled,
          tooltipOptions = _props.tooltipOptions,
          props = _objectWithoutProperties(_props, ['className', 'title', 'children', 'disabled', 'tooltipOptions']);

      // Return children as normal if Tooltip is disabled
      // (this lets us do <Tooltip disabled={isDisabled}><Button>Foo</Button></Tooltip>)


      if (disabled) {
        return children;
      }
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, _extends({}, props, {
        ref: this.handleMount,
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('tip', children.props && children.props.className, className),
        title: title
      }));
    }
  }]);

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tooltipOptions: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  title: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func])
}, _temp2);


/* harmony default export */ __webpack_exports__["default"] = (Tooltip);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var InlineSvg = function InlineSvg(_ref) {
  var src = _ref.src,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      props = _objectWithoutProperties(_ref, ['src', 'size', 'width', 'height']);

  var _require$default = __webpack_require__(853)("./" + src + '.svg').default,
      id = _require$default.id,
      viewBox = _require$default.viewBox;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    StyledSvg,
    _extends({}, props, {
      viewBox: viewBox,
      width: width || size || '1em',
      height: height || size || '1em'
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('use', { href: '#' + id, xlinkHref: '#' + id })
  );
};

InlineSvg.propTypes = {
  src: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  size: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};

var StyledSvg = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('svg', {
  target: 'e2idor0'
})('vertical-align:middle;');

/* harmony default export */ __webpack_exports__["a"] = (InlineSvg);

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);




var ConfigStore = __WEBPACK_IMPORTED_MODULE_1_reflux___default.a.createStore({
  init: function init() {
    this.config = {};
  },
  get: function get(key) {
    return this.config[key];
  },
  set: function set(key, value) {
    this.config[key] = value;
    var out = {};
    out[key] = value;
    this.trigger(out);
  },
  getConfig: function getConfig() {
    return this.config;
  },
  loadInitialData: function loadInitialData(config) {
    config.features = new Set(config.features || []);
    this.config = config;

    // TODO(dcramer): abstract this out of ConfigStore
    if (config.user) {
      config.user.permissions = new Set(config.user.permissions);
      __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default.a.tz.setDefault(config.user.options.timezone);
      Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["setLocale"])(config.user.options.language || 'en');
    }

    this.trigger(config);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (ConfigStore);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_externalLink__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_inlineSvg__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_tooltip__ = __webpack_require__(21);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2, _initialiseProps;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var Button = (_temp2 = _class = function (_React$Component) {
  _inherits(Button, _React$Component);

  function Button() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  // Intercept onClick and propagate


  _createClass(Button, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          size = _props.size,
          to = _props.to,
          href = _props.href,
          title = _props.title,
          icon = _props.icon,
          children = _props.children,
          label = _props.label,
          onClick = _props.onClick,
          buttonProps = _objectWithoutProperties(_props, ['size', 'to', 'href', 'title', 'icon', 'children', 'label', 'onClick']);

      // For `aria-label`


      var screenReaderLabel = label || typeof children === 'string' ? children : undefined;

      // Buttons come in 4 flavors: <Link>, <ExternalLink>, <a>, and <button>.
      // Let's use props to determine which to serve up, so we don't have to think about it.
      // *Note* you must still handle tabindex manually.
      var button = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        StyledButton,
        _extends({
          'aria-label': screenReaderLabel,
          to: this.getUrl(to),
          href: this.getUrl(href),
          size: size
        }, buttonProps, {
          onClick: this.handleClick,
          role: 'button'
        }),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          ButtonLabel,
          { size: size },
          icon && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            Icon,
            { size: size, hasChildren: !!children },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(StyledInlineSvg, { src: icon, size: size === 'small' ? '12px' : '16px' })
          ),
          children
        )
      );

      // Doing this instead of using `Tooltip`'s `disabled` prop so that we can minimize snapshot nesting
      if (title) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_app_components_tooltip__["default"],
          { title: title },
          button
        );
      }

      return button;
    }
  }]);

  return Button;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component), _class.propTypes = {
  priority: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['primary', 'danger', 'link', 'success']),
  size: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['zero', 'small', 'xsmall', 'large']),
  disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  busy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  /**
   * Use this prop if button is a react-router link
   */
  to: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  /**
   * Use this prop if button should use a normal (non-react-router) link
   */
  href: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  /**
   * Path to an icon svg that will be displayed to left of button label
   */
  icon: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  /**
   * Tooltip text
   */
  title: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  /**
   * Is an external link? (Will open in new tab)
   */
  external: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  /**
   * Button with a border
   */
  borderless: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  /**
   * Label for screen-readers (`aria-label`).
   * `children` will be used by default (only if it is a string), but this property takes priority.
   */
  label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

  onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
}, _class.defaultProps = {
  disabled: false
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleClick = function () {
    var _props2 = _this2.props,
        disabled = _props2.disabled,
        busy = _props2.busy,
        onClick = _props2.onClick;

    // Don't allow clicks when disabled or busy

    if (disabled || busy) return;

    if (typeof onClick !== 'function') return;

    onClick.apply(undefined, arguments);
  };

  this.getUrl = function (prop) {
    var disabled = _this2.props.disabled;

    if (disabled) return null;
    return prop;
  };
}, _temp2);


/* harmony default export */ __webpack_exports__["default"] = (Button);

var getFontSize = function getFontSize(_ref2) {
  var size = _ref2.size,
      theme = _ref2.theme;

  switch (size) {
    case 'xsmall':
    case 'small':
      return theme.fontSizeSmall;
    case 'large':
      return theme.fontSizeLarge;
    default:
      return theme.fontSizeMedium;
  }
};

var getFontWeight = function getFontWeight(_ref3) {
  var priority = _ref3.priority;
  return 'font-weight: ' + (priority === 'link' ? 400 : 600) + ';';
};

var getBoxShadow = function getBoxShadow(active) {
  return function (_ref4) {
    var priority = _ref4.priority,
        borderless = _ref4.borderless,
        disabled = _ref4.disabled;

    if (disabled || borderless || priority === 'link') {
      return 'box-shadow: none';
    }

    return 'box-shadow: ' + (active ? 'inset' : '') + ' 0 2px rgba(0, 0, 0, 0.05)';
  };
};

var getColors = function getColors(_ref5) {
  var priority = _ref5.priority,
      disabled = _ref5.disabled,
      borderless = _ref5.borderless,
      theme = _ref5.theme;

  var themeName = disabled ? 'disabled' : priority || 'default';
  var _theme$button$themeNa = theme.button[themeName],
      color = _theme$button$themeNa.color,
      colorActive = _theme$button$themeNa.colorActive,
      background = _theme$button$themeNa.background,
      backgroundActive = _theme$button$themeNa.backgroundActive,
      border = _theme$button$themeNa.border,
      borderActive = _theme$button$themeNa.borderActive;


  return (/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["css"])('color:', color, ';background-color:', background, ';border:1px solid ', !borderless && !!border ? border : 'transparent', ';&:hover{color:', color, ';}&:hover,&:focus,&:active{', colorActive ? 'color: ${colorActive};' : '', ';background:', backgroundActive, ';border:1px solid\n        ', !borderless && (borderActive || border) ? borderActive || border : 'transparent', ';}')
  );
};

var StyledButton = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])(function (_ref6) {
  var busy = _ref6.busy,
      external = _ref6.external,
      borderless = _ref6.borderless,
      props = _objectWithoutProperties(_ref6, ['busy', 'external', 'borderless']);

  // Get component to use based on existance of `to` or `href` properties
  // Can be react-router `Link`, `a`, or `button`
  if (props.to) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Link"], props);
  }

  if (!props.href) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button', props);
  }

  if (external) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_externalLink__["a" /* default */], props);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', props);
}, {
  target: 'e17811v30'
})('display:inline-block;line-height:1;border-radius:', function (p) {
  return p.theme.button.borderRadius;
}, ';padding:0;text-transform:none;', getFontWeight, ';font-size:', getFontSize, ';', getColors, ';', getBoxShadow(false), ';cursor:', function (p) {
  return p.disabled ? 'not-allowed' : 'pointer';
}, ';opacity:', function (p) {
  return (p.busy || p.disabled) && '0.65';
}, ';&:active{', getBoxShadow(true), ';}&:focus{outline:none;}', function (p) {
  return p.borderless && 'border-color: transparent';
}, ';');

/**
 * Get label padding determined by size
 */
var getLabelPadding = function getLabelPadding(_ref7) {
  var size = _ref7.size,
      priority = _ref7.priority;

  if (priority === 'link') {
    return '0';
  }

  switch (size) {
    case 'zero':
      return '0';
    case 'xsmall':
      return '6px 10px';
    case 'small':
      return '8px 12px;';
    case 'large':
      return '14px 20px';

    default:
      return '12px 16px;';
  }
};

var ButtonLabel = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])(function (props) {
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Flex"], _extends({ align: 'center' }, props));
}, {
  target: 'e17811v31'
})('padding:', getLabelPadding, ';.icon{margin-right:2px;}');

var getIconMargin = function getIconMargin(_ref8) {
  var size = _ref8.size,
      hasChildren = _ref8.hasChildren;

  // If button is only an icon, then it shouldn't have margin
  if (!hasChildren) {
    return '0';
  }

  return size === 'small' ? '6px' : '8px';
};

var Icon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])(function (_ref9) {
  var hasChildren = _ref9.hasChildren,
      props = _objectWithoutProperties(_ref9, ['hasChildren']);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Box"], props);
}, {
  target: 'e17811v32'
})('margin-right:', getIconMargin, ';margin-left:-2px;');

var StyledInlineSvg = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_6_app_components_inlineSvg__["a" /* default */], {
  target: 'e17811v33'
})('display:block;');

/***/ }),
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(839);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_actions_indicatorActions__ = __webpack_require__(479);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var IndicatorStore = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({
  init: function init() {
    this.items = [];
    this.lastId = 0;
    this.listenTo(__WEBPACK_IMPORTED_MODULE_2_app_actions_indicatorActions__["a" /* default */].append, this.append);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_2_app_actions_indicatorActions__["a" /* default */].replace, this.add);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_2_app_actions_indicatorActions__["a" /* default */].remove, this.remove);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_2_app_actions_indicatorActions__["a" /* default */].clear, this.clear);
  },
  addSuccess: function addSuccess(message) {
    return this.add(message, 'success', { duration: 2000 });
  },
  addError: function addError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_app_locale__["t"])('An error occurred');

    return this.add(message, 'error', { duration: 2000 });
  },
  addMessage: function addMessage(message, type) {
    var _this = this;

    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var append = _ref.append,
        options = _objectWithoutProperties(_ref, ['append']);

    var indicator = {
      id: this.lastId++,
      message: message,
      type: type,
      options: options,
      clearId: null
    };

    if (options.duration) {
      indicator.clearId = setTimeout(function () {
        _this.remove(indicator);
      }, options.duration);
    }

    var newItems = append ? [].concat(_toConsumableArray(this.items), [indicator]) : [indicator];

    this.items = newItems;
    this.trigger(this.items);
    return indicator;
  },


  /**
   * Appends a message to be displayed in list of indicators
   *
   * @param {String} message Toast message to be displayed
   * @param {String} type One of ['error', 'success', '']
   * @param {Object} options Options object
   * @param {Number} options.duration Duration the toast should be displayed
   */
  append: function append(message, type, options) {
    return this.addMessage(message, type, _extends({}, options, {
      append: true
    }));
  },


  /**
   * When this method is called directly via older parts of the application,
   * we want to maintain the old behavior in that it is replaced (and not queued up)
   *
   * @param {String} message Toast message to be displayed
   * @param {String} type One of ['error', 'success', '']
   * @param {Object} options Options object
   * @param {Number} options.duration Duration the toast should be displayed
   */
  add: function add(message) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'loading';
    var options = arguments[2];

    return this.addMessage(message, type, _extends({}, options, {
      append: false
    }));
  },


  // Clear all indicators
  clear: function clear() {
    this.items = [];
    this.trigger(this.items);
  },


  // Remove a single indicator
  remove: function remove(indicator) {
    if (!indicator) return;

    this.items = this.items.filter(function (item) {
      return item !== indicator;
    });

    if (indicator.clearId) {
      window.clearTimeout(indicator.options.clearId);
      indicator.options.clearId = null;
    }

    this.trigger(this.items);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (IndicatorStore);

/***/ }),
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_avatar_teamAvatar__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_avatar_organizationAvatar__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_avatar_projectAvatar__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_avatar_userAvatar__ = __webpack_require__(950);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Avatar = (_temp = _class = function (_React$Component) {
  _inherits(Avatar, _React$Component);

  function Avatar() {
    _classCallCheck(this, Avatar);

    return _possibleConstructorReturn(this, (Avatar.__proto__ || Object.getPrototypeOf(Avatar)).apply(this, arguments));
  }

  _createClass(Avatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          team = _props.team,
          project = _props.project,
          organization = _props.organization,
          props = _objectWithoutProperties(_props, ['user', 'team', 'project', 'organization']);

      if (user) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_avatar_userAvatar__["a" /* default */], _extends({ user: user }, props));
      }

      if (team) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_avatar_teamAvatar__["a" /* default */], _extends({ team: team }, props));
      }

      if (project) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_avatar_projectAvatar__["a" /* default */], _extends({ project: project }, props));
      }

      // Could support project too
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_avatar_organizationAvatar__["a" /* default */], _extends({ organization: organization }, props));
    }
  }]);

  return Avatar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = _extends({
  team: __WEBPACK_IMPORTED_MODULE_1_app_proptypes__["e" /* default */].Team,
  organization: __WEBPACK_IMPORTED_MODULE_1_app_proptypes__["e" /* default */].Organization,
  project: __WEBPACK_IMPORTED_MODULE_1_app_proptypes__["e" /* default */].Project
}, __WEBPACK_IMPORTED_MODULE_5_app_components_avatar_userAvatar__["a" /* default */].propTypes), _class.defaultProps = {
  hasTooltip: false
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (Avatar);

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_dropdownMenu__ = __webpack_require__(269);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var DropdownLink = (_temp = _class = function (_React$Component) {
  _inherits(DropdownLink, _React$Component);

  function DropdownLink() {
    var _ref;

    _classCallCheck(this, DropdownLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(this, (_ref = DropdownLink.__proto__ || Object.getPrototypeOf(DropdownLink)).call.apply(_ref, [this].concat(args)));
  }

  _createClass(DropdownLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          anchorRight = _props.anchorRight,
          disabled = _props.disabled,
          title = _props.title,
          caret = _props.caret,
          children = _props.children,
          menuClasses = _props.menuClasses,
          className = _props.className,
          alwaysRenderMenu = _props.alwaysRenderMenu,
          topLevelClasses = _props.topLevelClasses,
          otherProps = _objectWithoutProperties(_props, ['anchorRight', 'disabled', 'title', 'caret', 'children', 'menuClasses', 'className', 'alwaysRenderMenu', 'topLevelClasses']);

      // Default anchor = left


      var isRight = anchorRight;

      // .dropdown-actor-title = flexbox to fix vertical alignment on firefox
      // Need the extra container because dropdown-menu alignment is off if `dropdown-actor` is a flexbox
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_app_components_dropdownMenu__["a" /* default */],
        _extends({ alwaysRenderMenu: alwaysRenderMenu }, otherProps),
        function (_ref2) {
          var isOpen = _ref2.isOpen,
              getRootProps = _ref2.getRootProps,
              getActorProps = _ref2.getActorProps,
              getMenuProps = _ref2.getMenuProps;

          var shouldRenderMenu = alwaysRenderMenu || isOpen;
          var cx = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('dropdown-actor', className, {
            'dropdown-menu-right': isRight,
            'dropdown-toggle': true,
            hover: isOpen,
            disabled: disabled
          });
          var topLevelCx = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('dropdown', topLevelClasses, {
            'pull-right': isRight,
            'anchor-right': isRight,
            open: isOpen
          });

          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            getRootProps({
              className: topLevelCx
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              getActorProps({
                className: cx
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'dropdown-actor-title' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  null,
                  title
                ),
                caret && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'icon-arrow-down' })
              )
            ),
            shouldRenderMenu && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'ul',
              getMenuProps({
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(menuClasses, 'dropdown-menu')
              }),
              children
            )
          );
        }
      );
    }
  }]);

  return DropdownLink;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_3_app_components_dropdownMenu__["a" /* default */].propTypes, {

  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  /** display dropdown caret */
  caret: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /** anchors menu to the right */
  anchorRight: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * Always render children of dropdown menu, this is included to support
   * menu items that open a confirm modal. Otherwise when dropdown menu hides,
   * the modal also gets unmounted
   */
  alwaysRenderMenu: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  topLevelClasses: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  menuClasses: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}), _class.defaultProps = {
  alwaysRenderMenu: true,
  disabled: false,
  anchorRight: false,
  caret: true
}, _temp);


/* harmony default export */ __webpack_exports__["default"] = (DropdownLink);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var space = function space(size) {
  switch (size) {
    //Our spacing scale is based on a base unit of 8
    //We use a case switch to prevent odd numbers, decimals, and big numbers.
    case 0:
      return '0';
    case 0.25:
      return '2px';
    case 0.5:
      return '4px';
    case 1:
      return '8px';
    case 2:
      return '16px';
    case 3:
      return '20px';
    case 4:
      return '30px';
    default:
      return '8px';
  }
};

/* harmony default export */ __webpack_exports__["a"] = (space);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getOrganizationState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_proptypes__ = __webpack_require__(6);


var OrganizationStateMixin = {
  contextTypes: {
    organization: __WEBPACK_IMPORTED_MODULE_0_app_proptypes__["e" /* default */].Organization
  },

  getOrganization: function getOrganization() {
    return this.context.organization;
  },
  getAccess: function getAccess() {
    return new Set(this.context.organization.access);
  },
  getFeatures: function getFeatures() {
    return new Set(this.context.organization.features);
  },
  getOnboardingTasks: function getOnboardingTasks() {
    return new Set(this.context.organization.onboardingTasks);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (OrganizationStateMixin);

// Non-mixin version for use with es6 components
var getOrganizationState = function getOrganizationState(org) {
  return {
    getOrganization: function getOrganization() {
      return org;
    },
    getAccess: function getAccess() {
      return new Set(org.access);
    },
    getFeatures: function getFeatures() {
      return new Set(org.features);
    },
    getOnboardingTasks: function getOnboardingTasks() {
      return new Set(org.onboardingTasks);
    }
  };
};

/***/ }),
/* 40 */,
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_mixins_organizationState__ = __webpack_require__(39);



var ProjectState = {
  mixins: [__WEBPACK_IMPORTED_MODULE_1_app_mixins_organizationState__["a" /* default */]],

  contextTypes: {
    project: __WEBPACK_IMPORTED_MODULE_0_app_proptypes__["e" /* default */].Project
  },

  getProjectFeatures: function getProjectFeatures() {
    return new Set(this.context.project.features);
  },
  getProject: function getProject() {
    return this.context.project;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ProjectState);

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_assistant_guideAnchor__ = __webpack_require__(65);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var GroupEventDataSection = (_temp = _class = function (_React$Component) {
  _inherits(GroupEventDataSection, _React$Component);

  function GroupEventDataSection() {
    _classCallCheck(this, GroupEventDataSection);

    return _possibleConstructorReturn(this, (GroupEventDataSection.__proto__ || Object.getPrototypeOf(GroupEventDataSection)).apply(this, arguments));
  }

  _createClass(GroupEventDataSection, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (location.hash) {
        var _location$hash$split = location.hash.split('#'),
            _location$hash$split2 = _slicedToArray(_location$hash$split, 2),
            hash = _location$hash$split2[1];

        try {
          var anchorElement = hash && document.querySelector('div#' + hash);
          if (anchorElement) {
            anchorElement.scrollIntoView();
          }
        } catch (e) {
          // Since we're blindly taking the hash from the url and shoving
          // it into a querySelector, it's possible that this may
          // raise an exception if the input is invalid. So let's just ignore
          // this instead of blowing up.
          // e.g. `document.querySelector('div#=')`
          // > Uncaught DOMException: Failed to execute 'querySelector' on 'Document': 'div#=' is not a valid selector.
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var guideAnchor = this.props.type === 'tags' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_assistant_guideAnchor__["default"], { target: 'tags', type: 'text' }) : null;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: (this.props.className || '') + ' box' },
        this.props.title && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'box-header', id: this.props.type },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            { href: '#' + this.props.type, className: 'permalink' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em', { className: 'icon-anchor' })
          ),
          this.props.wrapTitle ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h3',
            null,
            guideAnchor,
            this.props.title
          ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            guideAnchor,
            this.props.title
          ),
          this.props.type === 'extra' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'btn-group pull-right' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              {
                className: (!this.props.raw ? 'active' : '') + ' btn btn-default btn-sm',
                onClick: function onClick() {
                  return _this2.props.toggleRaw(false);
                }
              },
              Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Formatted')
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              {
                className: (this.props.raw ? 'active' : '') + ' btn btn-default btn-sm',
                onClick: function onClick() {
                  return _this2.props.toggleRaw(true);
                }
              },
              Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Raw')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'box-content with-padding' },
          this.props.children
        )
      );
    }
  }]);

  return GroupEventDataSection;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  wrapTitle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  toggleRaw: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  raw: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _class.defaultProps = {
  wrapTitle: true,
  raw: false
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (GroupEventDataSection);

/***/ }),
/* 43 */,
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var MenuItem = (_temp2 = _class = function (_React$Component) {
  _inherits(MenuItem, _React$Component);

  function MenuItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      if (_this.props.onSelect) {
        e.preventDefault();
        _this.props.onSelect(_this.props.eventKey);
      }
    }, _this.renderAnchor = function () {
      if (_this.props.to) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
          {
            to: { pathname: _this.props.to, query: _this.props.query },
            title: _this.props.title,
            onClick: _this.handleClick,
            className: _this.props.linkClassName,
            tabIndex: '-1'
          },
          _this.props.children
        );
      }
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        {
          title: _this.props.title,
          onClick: _this.handleClick,
          href: _this.props.href,
          className: _this.props.linkClassName,
          tabIndex: '-1'
        },
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuItem, [{
    key: 'render',
    value: function render() {
      var classes = {
        'dropdown-header': this.props.header,
        divider: this.props.divider,
        active: this.props.isActive
      };

      var children = null;
      if (this.props.noAnchor) {
        children = this.props.children;
      } else if (this.props.header) {
        children = this.props.children;
      } else if (!this.props.divider) {
        children = this.renderAnchor();
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'li',
        {
          role: 'presentation',
          title: null,
          href: null,
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(this.props.className, classes),
          onClick: this.props.onClick
        },
        children
      );
    }
  }]);

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  header: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  divider: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  onSelect: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  noAnchor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  // basic link
  href: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  // router link
  to: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  query: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  linkClassName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
}, _temp2);


/* harmony default export */ __webpack_exports__["default"] = (MenuItem);

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNumber__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_stores_configStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var TimeSince = (_temp = _class = function (_React$PureComponent) {
  _inherits(TimeSince, _React$PureComponent);

  _createClass(TimeSince, null, [{
    key: 'getDateObj',
    value: function getDateObj(date) {
      if (__WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(date) || __WEBPACK_IMPORTED_MODULE_0_lodash_isNumber___default()(date)) {
        date = new Date(date);
      }
      return date;
    }
  }]);

  function TimeSince(props) {
    _classCallCheck(this, TimeSince);

    var _this = _possibleConstructorReturn(this, (TimeSince.__proto__ || Object.getPrototypeOf(TimeSince)).call(this, props));

    _this.setRelativeDateTicker = function () {
      var ONE_MINUTE_IN_MS = 60000;

      _this.ticker = setTimeout(function () {
        _this.setState({
          relative: _this.getRelativeDate()
        });
        _this.setRelativeDateTicker();
      }, ONE_MINUTE_IN_MS);
    };

    _this.getRelativeDate = function () {
      var date = TimeSince.getDateObj(_this.props.date);
      if (!_this.props.suffix) {
        return __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(date).fromNow(true);
      } else if (_this.props.suffix === 'ago') {
        return __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(date).fromNow();
      } else if (_this.props.suffix === 'old') {
        return Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('%(time)s old', { time: __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(date).fromNow(true) });
      } else {
        throw new Error('Unsupported time format suffix');
      }
    };

    _this.state = {
      relative: _this.getRelativeDate()
    };
    return _this;
  }

  _createClass(TimeSince, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setRelativeDateTicker();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.ticker) {
        clearTimeout(this.ticker);
        this.ticker = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var date = TimeSince.getDateObj(this.props.date);
      var user = __WEBPACK_IMPORTED_MODULE_5_app_stores_configStore__["default"].get('user');
      var options = user ? user.options : {};
      var format = options.clock24Hours ? 'MMMM D YYYY HH:mm:ss z' : 'LLL z';
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'time',
        {
          dateTime: date.toISOString(),
          title: __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(date, options.timezone).format(format),
          className: this.props.className
        },
        this.state.relative
      );
    }
  }]);

  return TimeSince;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.PureComponent), _class.propTypes = {
  date: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any.isRequired,
  suffix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
}, _class.defaultProps = {
  suffix: 'ago'
}, _temp);


/* harmony default export */ __webpack_exports__["default"] = (TimeSince);

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Request", function() { return Request; });
/* harmony export (immutable) */ __webpack_exports__["paramsToQueryArgs"] = paramsToQueryArgs;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Client", function() { return Client; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idx__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_actionCreators_modal__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_actions_groupActions__ = __webpack_require__(202);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var Request = function () {
  function Request(xhr) {
    _classCallCheck(this, Request);

    this.xhr = xhr;
    this.alive = true;
  }

  _createClass(Request, [{
    key: 'cancel',
    value: function cancel() {
      this.alive = false;
      this.xhr.abort();
    }
  }]);

  return Request;
}();

/**
 * Converts input parameters to API-compatible query arguments
 * @param params
 */
function paramsToQueryArgs(params) {
  return params.itemIds ? { id: params.itemIds // items matching array of itemids
  } : params.query ? { query: params.query // items matching search query
  } : undefined; // all items
}

var Client = function () {
  function Client(options) {
    _classCallCheck(this, Client);

    if (__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(options)) {
      options = {};
    }
    this.baseUrl = options.baseUrl || '/api/0';
    this.activeRequests = {};
  }

  _createClass(Client, [{
    key: 'uniqueId',
    value: function uniqueId() {
      var s4 = function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      };
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }
  }, {
    key: 'wrapCallback',
    value: function wrapCallback(id, func, cleanup) {
      var _this = this;

      /*eslint consistent-return:0*/
      if (__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(func)) {
        return;
      }

      return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var req = _this.activeRequests[id];
        if (cleanup === true) {
          delete _this.activeRequests[id];
        }
        if (req && req.alive) {
          return func.apply(req, args);
        }
      };
    }

    /**
     * Attempt to cancel all active XHR requests
     */

  }, {
    key: 'clear',
    value: function clear() {
      for (var id in this.activeRequests) {
        this.activeRequests[id].cancel();
      }
    }
  }, {
    key: 'handleRequestError',
    value: function handleRequestError(_ref2, response) {
      var _this2 = this;

      var id = _ref2.id,
          path = _ref2.path,
          requestOptions = _ref2.requestOptions;

      var _ref;

      var code = response && ((_ref = response) != null ? (_ref = _ref.responseJSON) != null ? (_ref = _ref.detail) != null ? _ref.code : _ref : _ref : _ref);
      var isSudoRequired = code === 'sudo-required' || code === 'superuser-required';

      if (isSudoRequired) {
        Object(__WEBPACK_IMPORTED_MODULE_3_app_actionCreators_modal__["h" /* openSudo */])({
          superuser: code === 'superuser-required',
          sudo: code === 'sudo-required',
          retryRequest: function retryRequest() {
            return _this2.requestPromise(path, requestOptions).then(function () {
              if (typeof requestOptions.success !== 'function') return;

              requestOptions.success.apply(requestOptions, arguments);
            }).catch(function () {
              if (typeof requestOptions.error !== 'function') return;
              requestOptions.error.apply(requestOptions, arguments);
            });
          },
          onClose: function onClose() {
            if (typeof requestOptions.error !== 'function') return;
            // If modal was closed, then forward the original response
            requestOptions.error(response);
          }
        });
        return;
      }

      // Call normal error callback
      var errorCb = this.wrapCallback(id, requestOptions.error);
      if (typeof errorCb !== 'function') return;

      for (var _len2 = arguments.length, responseArgs = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        responseArgs[_key2 - 2] = arguments[_key2];
      }

      errorCb.apply(undefined, [response].concat(responseArgs));
    }
  }, {
    key: 'request',
    value: function request(path) {
      var _this3 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var query = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.param(options.query || '', true);
      var method = options.method || (options.data ? 'POST' : 'GET');
      var data = options.data;
      var id = this.uniqueId();

      if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(data) && method !== 'GET') {
        data = JSON.stringify(data);
      }

      var fullUrl = void 0;
      if (path.indexOf(this.baseUrl) === -1) {
        fullUrl = this.baseUrl + path;
      } else {
        fullUrl = path;
      }
      if (query) {
        if (fullUrl.indexOf('?') !== -1) {
          fullUrl += '&' + query;
        } else {
          fullUrl += '?' + query;
        }
      }

      this.activeRequests[id] = new Request(__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax({
        url: fullUrl,
        method: method,
        data: data,
        contentType: 'application/json',
        headers: {
          Accept: 'application/json; charset=utf-8'
        },
        success: this.wrapCallback(id, options.success),
        error: function error() {
          for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
          }

          return _this3.handleRequestError.apply(_this3, [{
            id: id,
            path: path,
            requestOptions: options
          }].concat(args));
        },
        complete: this.wrapCallback(id, options.complete, true)
      }));

      return this.activeRequests[id];
    }
  }, {
    key: 'requestPromise',
    value: function requestPromise(path) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return new Promise(function (resolve, reject) {
        _this4.request(path, _extends({}, options, {
          success: function success(data) {
            // This fails if we need jqXhr :(
            resolve(data);
          },
          error: function error(_error) {
            reject(_error);
          }
        }));
      });
    }
  }, {
    key: '_chain',
    value: function _chain() {
      for (var _len4 = arguments.length, funcs = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        funcs[_key4] = arguments[_key4];
      }

      funcs = funcs.filter(function (f) {
        return !__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(f) && f;
      });
      return function () {
        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          args[_key5] = arguments[_key5];
        }

        funcs.forEach(function (func) {
          func.apply(funcs, args);
        });
      };
    }
  }, {
    key: '_wrapRequest',
    value: function _wrapRequest(path, options, extraParams) {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(extraParams)) {
        extraParams = {};
      }

      options.success = this._chain(options.success, extraParams.success);
      options.error = this._chain(options.error, extraParams.error);
      options.complete = this._chain(options.complete, extraParams.complete);

      return this.request(path, options);
    }
  }, {
    key: 'bulkDelete',
    value: function bulkDelete(params, options) {
      var path = '/projects/' + params.orgId + '/' + params.projectId + '/issues/';
      var query = paramsToQueryArgs(params);
      var id = this.uniqueId();

      __WEBPACK_IMPORTED_MODULE_4_app_actions_groupActions__["a" /* default */].delete(id, params.itemIds);

      return this._wrapRequest(path, {
        query: query,
        method: 'DELETE',
        success: function success(response) {
          __WEBPACK_IMPORTED_MODULE_4_app_actions_groupActions__["a" /* default */].deleteSuccess(id, params.itemIds, response);
        },
        error: function error(_error2) {
          __WEBPACK_IMPORTED_MODULE_4_app_actions_groupActions__["a" /* default */].deleteError(id, params.itemIds, _error2);
        }
      }, options);
    }
  }, {
    key: 'bulkUpdate',
    value: function bulkUpdate(params, options) {
      var path = '/projects/' + params.orgId + '/' + params.projectId + '/issues/';
      var query = paramsToQueryArgs(params);
      var id = this.uniqueId();

      __WEBPACK_IMPORTED_MODULE_4_app_actions_groupActions__["a" /* default */].update(id, params.itemIds, params.data);

      return this._wrapRequest(path, {
        query: query,
        method: 'PUT',
        data: params.data,
        success: function success(response) {
          __WEBPACK_IMPORTED_MODULE_4_app_actions_groupActions__["a" /* default */].updateSuccess(id, params.itemIds, response);
        },
        error: function error(_error3) {
          __WEBPACK_IMPORTED_MODULE_4_app_actions_groupActions__["a" /* default */].updateError(id, params.itemIds, _error3, params.failSilently);
        }
      }, options);
    }
  }, {
    key: 'merge',
    value: function merge(params, options) {
      var path = '/projects/' + params.orgId + '/' + params.projectId + '/issues/';
      var query = paramsToQueryArgs(params);
      var id = this.uniqueId();

      __WEBPACK_IMPORTED_MODULE_4_app_actions_groupActions__["a" /* default */].merge(id, params.itemIds);

      return this._wrapRequest(path, {
        query: query,
        method: 'PUT',
        data: { merge: 1 },
        success: function success(response) {
          __WEBPACK_IMPORTED_MODULE_4_app_actions_groupActions__["a" /* default */].mergeSuccess(id, params.itemIds, response);
        },
        error: function error(_error4) {
          __WEBPACK_IMPORTED_MODULE_4_app_actions_groupActions__["a" /* default */].mergeError(id, params.itemIds, _error4);
        }
      }, options);
    }
  }]);

  return Client;
}();

/***/ }),
/* 47 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(185),
    baseClone = __webpack_require__(618),
    baseUnset = __webpack_require__(963),
    castPath = __webpack_require__(171),
    copyObject = __webpack_require__(611),
    customOmitClone = __webpack_require__(968),
    flatRest = __webpack_require__(402),
    getAllKeysIn = __webpack_require__(969);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_styles_space__ = __webpack_require__(38);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var SettingsPageHeading = (_temp = _class = function (_React$Component) {
  _inherits(SettingsPageHeading, _React$Component);

  function SettingsPageHeading() {
    _classCallCheck(this, SettingsPageHeading);

    return _possibleConstructorReturn(this, (SettingsPageHeading.__proto__ || Object.getPrototypeOf(SettingsPageHeading)).apply(this, arguments));
  }

  _createClass(SettingsPageHeading, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        Wrapper,
        { tabs: this.props.tabs },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_grid_emotion__["Flex"],
          { align: 'center' },
          this.props.icon && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_grid_emotion__["Box"],
            { pr: 1 },
            this.props.icon
          ),
          this.props.title && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            Title,
            null,
            this.props.title
          ),
          this.props.action && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            this.props.action
          )
        ),
        this.props.tabs && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          this.props.tabs
        )
      );
    }
  }]);

  return SettingsPageHeading;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  icon: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  action: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  tabs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node
}, _temp);


var Wrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'e1kblvez0'
})('font-size:14px;box-shadow:inset 0 -1px 0 ', function (p) {
  return p.theme.borderLight;
}, ';margin:-', Object(__WEBPACK_IMPORTED_MODULE_4_app_styles_space__["a" /* default */])(3), ' 0 ', Object(__WEBPACK_IMPORTED_MODULE_4_app_styles_space__["a" /* default */])(3), ';');

var Title = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'e1kblvez1'
})('font-size:20px;font-weight:bold;margin:', Object(__WEBPACK_IMPORTED_MODULE_4_app_styles_space__["a" /* default */])(3), ' 0;flex:1;');

/* harmony default export */ __webpack_exports__["default"] = (SettingsPageHeading);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * A context-aware version of Link (from react-router) that falls
 * back to <a> if there is no router present OR if you use `href`.
 */
var Link = (_temp = _class = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    _classCallCheck(this, Link);

    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
  }

  _createClass(Link, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          to = _props.to,
          href = _props.href,
          props = _objectWithoutProperties(_props, ['to', 'href']);

      if (this.context.location && to) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Link"], this.props);
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', _extends({}, props, { href: to || href }));
      }
    }
  }]);

  return Link;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, _class.contextTypes = {
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Pagination; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Pagination = (_temp = _class = function (_React$Component) {
  _inherits(Pagination, _React$Component);

  function Pagination() {
    _classCallCheck(this, Pagination);

    return _possibleConstructorReturn(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).apply(this, arguments));
  }

  _createClass(Pagination, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onCursor = _props.onCursor,
          pageLinks = _props.pageLinks;

      if (!pageLinks) {
        return null;
      }

      var location = this.context.location;
      var path = this.props.to || location.pathname;
      var query = location.query;

      var links = __WEBPACK_IMPORTED_MODULE_3_app_utils__["c" /* default */].parseLinkHeader(pageLinks);

      var previousPageClassName = 'btn btn-default btn-lg prev';
      if (links.previous.results === false) {
        previousPageClassName += ' disabled';
      }

      var nextPageClassName = 'btn btn-default btn-lg next';
      if (links.next.results === false) {
        nextPageClassName += ' disabled';
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'stream-pagination clearfix' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'btn-group pull-right' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            {
              onClick: function onClick() {
                onCursor(links.previous.cursor, path, query);
              },
              className: previousPageClassName,
              disabled: links.previous.results === false
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { title: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Previous'), className: 'icon-arrow-left' })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            {
              onClick: function onClick() {
                onCursor(links.next.cursor, path, query);
              },
              className: nextPageClassName,
              disabled: links.next.results === false
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { title: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Next'), className: 'icon-arrow-right' })
          )
        )
      );
    }
  }]);

  return Pagination;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  pageLinks: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  onCursor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
}, _class.contextTypes = {
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
}, _class.defaultProps = {
  onCursor: function onCursor(cursor, path, query) {
    query.cursor = cursor;
    __WEBPACK_IMPORTED_MODULE_2_react_router__["browserHistory"].push({
      pathname: path,
      query: query
    });
  }
}, _temp);


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apiForm__ = __webpack_require__(418);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ApiForm", function() { return __WEBPACK_IMPORTED_MODULE_0__apiForm__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__booleanField__ = __webpack_require__(324);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BooleanField", function() { return __WEBPACK_IMPORTED_MODULE_1__booleanField__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emailField__ = __webpack_require__(325);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EmailField", function() { return __WEBPACK_IMPORTED_MODULE_2__emailField__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dateTimeField__ = __webpack_require__(499);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DateTimeField", function() { return __WEBPACK_IMPORTED_MODULE_3__dateTimeField__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form__ = __webpack_require__(243);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return __WEBPACK_IMPORTED_MODULE_4__form__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state__ = __webpack_require__(167);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormState", function() { return __WEBPACK_IMPORTED_MODULE_5__state__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__genericField__ = __webpack_require__(959);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GenericField", function() { return __WEBPACK_IMPORTED_MODULE_6__genericField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__multipleCheckboxField__ = __webpack_require__(633);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MultipleCheckboxField", function() { return __WEBPACK_IMPORTED_MODULE_7__multipleCheckboxField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__numberField__ = __webpack_require__(500);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NumberField", function() { return __WEBPACK_IMPORTED_MODULE_8__numberField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__passwordField__ = __webpack_require__(501);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PasswordField", function() { return __WEBPACK_IMPORTED_MODULE_9__passwordField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__radioBooleanField__ = __webpack_require__(504);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RadioBooleanField", function() { return __WEBPACK_IMPORTED_MODULE_10__radioBooleanField__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__rangeField__ = __webpack_require__(326);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RangeField", function() { return __WEBPACK_IMPORTED_MODULE_11__rangeField__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__select2FieldAutocomplete__ = __webpack_require__(502);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Select2FieldAutocomplete", function() { return __WEBPACK_IMPORTED_MODULE_12__select2FieldAutocomplete__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__select2Field__ = __webpack_require__(170);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Select2Field", function() { return __WEBPACK_IMPORTED_MODULE_13__select2Field__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__select2TextField__ = __webpack_require__(503);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Select2TextField", function() { return __WEBPACK_IMPORTED_MODULE_14__select2TextField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__textField__ = __webpack_require__(222);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TextField", function() { return __WEBPACK_IMPORTED_MODULE_15__textField__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__textareaField__ = __webpack_require__(275);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TextareaField", function() { return __WEBPACK_IMPORTED_MODULE_16__textareaField__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__selectField__ = __webpack_require__(397);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SelectField", function() { return __WEBPACK_IMPORTED_MODULE_17__selectField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__multiSelectField__ = __webpack_require__(960);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MultiSelectField", function() { return __WEBPACK_IMPORTED_MODULE_18__multiSelectField__["a"]; });




















/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = analytics;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_stores_hookStore__ = __webpack_require__(72);


/**
 * Note, you will need to add the event `name` to the inclusion list in redash
 * See: https://github.com/getsentry/reload/blob/master/reload_app/app.py#L20
 *
 * @param {String} name The name of the event
 * @param {Object} data Additional event data to record
 */
function analytics(name, data) {
  __WEBPACK_IMPORTED_MODULE_0_app_stores_hookStore__["default"].get('analytics:event').forEach(function (cb) {
    return cb(name, data);
  });
}

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emotion__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var EmptyStateWarning = function (_React$Component) {
  _inherits(EmptyStateWarning, _React$Component);

  function EmptyStateWarning() {
    _classCallCheck(this, EmptyStateWarning);

    return _possibleConstructorReturn(this, (EmptyStateWarning.__proto__ || Object.getPrototypeOf(EmptyStateWarning)).apply(this, arguments));
  }

  _createClass(EmptyStateWarning, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        EmptyStreamWrapper,
        { className: 'ref-empty-state' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, { className: 'icon icon-exclamation' }),
        this.props.children
      );
    }
  }]);

  return EmptyStateWarning;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var EmptyStreamWrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])('div', {
  target: 'ernlsnc0'
})('text-align:center;font-size:22px;padding:48px 0;p{line-height:1.2;margin:0 auto 20px;&:last-child{margin-bottom:0;}}');

var Icon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])('div', {
  target: 'ernlsnc1'
})('display:block;font-size:54px;color:', function (p) {
  return p.theme.gray2;
}, ';margin-bottom:20px;opacity:0.45;');

/* harmony default export */ __webpack_exports__["a"] = (EmptyStateWarning);

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_alert__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_errors_detailedError__ = __webpack_require__(495);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var exclamation = ['Raspberries', 'Snap', 'Frig', 'Welp', 'Uhhhh', 'Hmmm'];

var getExclamation = function getExclamation() {
  return exclamation[Math.floor(Math.random() * exclamation.length)];
};

var ErrorBoundary = (_temp = _class = function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  function ErrorBoundary(props) {
    _classCallCheck(this, ErrorBoundary);

    var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));

    _this.state = { error: null };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // Listen for route changes so we can clear error
      this.unlisten = __WEBPACK_IMPORTED_MODULE_0_react_router__["browserHistory"].listen(function () {
        return _this2.setState({ error: null });
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.unlisten) {
        this.unlisten();
      }
    }
  }, {
    key: 'componentDidCatch',
    value: function componentDidCatch(error, errorInfo) {
      this.setState({ error: error });
      __WEBPACK_IMPORTED_MODULE_2_raven_js___default.a.captureException(error, { extra: errorInfo });
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.error) {
        var _props = this.props,
            mini = _props.mini,
            message = _props.message,
            className = _props.className;


        if (mini) {
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_app_components_alert__["a" /* default */],
            { type: 'error', icon: 'icon-circle-exclamation', className: className },
            message || Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('There was a problem rendering this component')
          );
        }

        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          Wrapper,
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_errors_detailedError__["a" /* default */], {
            heading: getExclamation(),
            message: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Something went horribly wrong rendering this page.\nWe use a decent error reporting service so this will probably be fixed soon. Unless our error reporting service is also broken. That would be awkward.\nAnyway, we apologize for the inconvenience.')
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            StackTrace,
            null,
            this.state.error.toString()
          )
        );
      } else {
        //when there's not an error, render children untouched
        return this.props.children;
      }
    }
  }]);

  return ErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component), _class.propTypes = {
  mini: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
}, _class.defaultProps = {
  mini: false
}, _temp);


var Wrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('div', {
  target: 'e14xq66l0'
})('color:', function (p) {
  return p.theme.gray4;
}, ';padding:', function (p) {
  return p.theme.grid * 3;
}, 'px;max-width:1000px;margin:auto;');

var StackTrace = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('pre', {
  target: 'e14xq66l1'
})('white-space:pre-wrap;margin:32px;margin-left:85px;margin-right:18px;');

/* harmony default export */ __webpack_exports__["default"] = (ErrorBoundary);

/***/ }),
/* 64 */,
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "conditionalGuideAnchor", function() { return conditionalGuideAnchor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_actionCreators_guides__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_stores_guideStore__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_styles_animations__ = __webpack_require__(236);











// A guide anchor provides a ripple-effect on an element to draw attention to it.
// Guide anchors register with the guide store, which uses this information to
// determine which guides can be shown on the page. Multiple guide anchors on
// a page can have the same `target` property, which will make all of them glow
// when a step in the guide matches that target (although only one of them will
// be scrolled to).
var GuideAnchor = __WEBPACK_IMPORTED_MODULE_4_create_react_class___default()({
  displayName: 'GuideAnchor',

  propTypes: {
    target: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    // The `invisible` anchor type can be used for guides not attached to specific elements.
    type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['text', 'button', 'invisible'])
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_8_app_stores_guideStore__["a" /* default */], 'onGuideStateChange')],

  getInitialState: function getInitialState() {
    return {
      active: false
    };
  },
  componentDidMount: function componentDidMount() {
    Object(__WEBPACK_IMPORTED_MODULE_7_app_actionCreators_guides__["f" /* registerAnchor */])(this);
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    if (!prevState.active && this.state.active && this.props.type !== 'invisible') {
      var windowHeight = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(window).height();
      __WEBPACK_IMPORTED_MODULE_6_jquery___default()('html,body').animate({
        scrollTop: __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this.anchorElement).offset().top - windowHeight / 4
      });
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    Object(__WEBPACK_IMPORTED_MODULE_7_app_actionCreators_guides__["g" /* unregisterAnchor */])(this);
  },
  onGuideStateChange: function onGuideStateChange(data) {
    if (data.currentGuide && data.currentStep > 0 && data.currentGuide.steps[data.currentStep - 1].target == this.props.target &&
    // TODO(adhiraj): It would be more correct to let invisible anchors become active,
    // and use CSS to make them invisible.
    this.props.type !== 'invisible') {
      this.setState({ active: true });
    } else {
      this.setState({ active: false });
    }
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        target = _props.target,
        type = _props.type;


    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      GuideAnchorContainer,
      { innerRef: function innerRef(el) {
          return _this.anchorElement = el;
        }, type: type },
      this.props.children,
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        StyledGuideAnchor,
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('guide-anchor-ping', target),
          active: this.state.active
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StyledGuideAnchorRipples, null)
      )
    );
  }
});

var conditionalGuideAnchor = function conditionalGuideAnchor(condition, target, type, children) {
  return condition ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(GuideAnchor, { target: target, type: type }, children) : children;
};

var recedeAnchor = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["keyframes"])('0%{transform:scale(3,3);opacity:1;}100%{transform:scale(1,1);opacity:0.75;}');

var GuideAnchorContainer = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e130o4350'
})(function (p) {
  return p.type == 'text' && '\n      display: inline-block;\n      position: relative;\n    ';
}, ';');

var StyledGuideAnchor = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e130o4351'
})('width:20px;height:20px;cursor:pointer;z-index:999;position:absolute;pointer-events:none;visibility:hidden;', function (p) {
  return p.active ? '\n    visibility: visible;\n    animation: ' + recedeAnchor + ' 5s ease-in forwards;\n  ' : '';
}, ';');

var StyledGuideAnchorRipples = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e130o4352'
})('animation:', __WEBPACK_IMPORTED_MODULE_9_app_styles_animations__["a" /* expandOut */], ' 1.5s ease-out infinite;width:100%;height:100%;top:0;left:0;&,&:before,&:after{position:absolute;display:block;left:calc(50% - 10px);top:calc(50% - 10px);background-color:', function (p) {
  return p.theme.greenTransparent;
}, ';border-radius:50%;}&:before,&:after{content:\'\';}&:before{width:70%;height:70%;left:calc(50% - 7px);top:calc(50% - 7px);background-color:', function (p) {
  return p.theme.greenTransparent;
}, ';}&:after{width:50%;height:50%;left:calc(50% - 5px);top:calc(50% - 5px);color:', function (p) {
  return p.theme.green;
}, ';}');

/* harmony default export */ __webpack_exports__["default"] = (GuideAnchor);

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_stores_environmentStore__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_stores_latestContextStore__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_constants__ = __webpack_require__(102);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };












var withEnvironmentInQueryString = function withEnvironmentInQueryString(WrappedComponent) {
  return __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
    displayName: 'withEnvironmentInQueryString',

    propTypes: {
      location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_3_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_7_app_stores_latestContextStore__["a" /* default */], 'onLatestContextChange')],

    getInitialState: function getInitialState() {
      var latestContext = __WEBPACK_IMPORTED_MODULE_7_app_stores_latestContextStore__["a" /* default */].getInitialState();
      return {
        environment: latestContext.environment,
        organization: latestContext.organization,
        hasEnvironmentsFeature: this.hasEnvironmentsFeature(latestContext.organization)
      };
    },
    componentWillMount: function componentWillMount() {
      var _state = this.state,
          hasEnvironmentsFeature = _state.hasEnvironmentsFeature,
          environment = _state.environment;


      if (hasEnvironmentsFeature) {
        var _props$location = this.props.location,
            query = _props$location.query,
            pathname = _props$location.pathname;


        var isDefaultEnvironment = environment === __WEBPACK_IMPORTED_MODULE_6_app_stores_environmentStore__["a" /* default */].getDefault();

        // Update the query string to match environment if they are not in sync
        if (environment) {
          if (environment.name !== query.environment) {
            if (isDefaultEnvironment) {
              delete query.environment;
            } else {
              query.environment = environment.name;
            }
            __WEBPACK_IMPORTED_MODULE_4_react_router__["browserHistory"].replace(pathname + '?' + __WEBPACK_IMPORTED_MODULE_5_query_string___default.a.stringify(query));
          }
        } else {
          if (environment === null && !isDefaultEnvironment) {
            query.environment = __WEBPACK_IMPORTED_MODULE_8_app_constants__["a" /* ALL_ENVIRONMENTS_KEY */];
            __WEBPACK_IMPORTED_MODULE_4_react_router__["browserHistory"].replace(pathname + '?' + __WEBPACK_IMPORTED_MODULE_5_query_string___default.a.stringify(query));
          }
        }
      }
    },
    onLatestContextChange: function onLatestContextChange(_ref) {
      var environment = _ref.environment,
          organization = _ref.organization;

      // TODO(lyn): Remove this when environments feature is active
      var hasEnvironmentsFeature = this.hasEnvironmentsFeature(organization);

      var environmentHasChanged = environment !== this.state.environment;

      var defaultEnvironment = __WEBPACK_IMPORTED_MODULE_6_app_stores_environmentStore__["a" /* default */].getDefault();

      if (hasEnvironmentsFeature && environmentHasChanged) {
        var _props$location2 = this.props.location,
            query = _props$location2.query,
            pathname = _props$location2.pathname;

        if (environment === defaultEnvironment) {
          // We never show environment in the query string if it's the default one
          delete query.environment;
        } else {
          // We show ?environment=__all_environments__ in the query string if 'All environments'
          // is selected and that is not the default
          var envName = environment ? environment.name : __WEBPACK_IMPORTED_MODULE_8_app_constants__["a" /* ALL_ENVIRONMENTS_KEY */];
          query.environment = envName;
        }
        __WEBPACK_IMPORTED_MODULE_4_react_router__["browserHistory"].push(pathname + '?' + __WEBPACK_IMPORTED_MODULE_5_query_string___default.a.stringify(query));
      }

      this.setState({
        environment: environment,
        organization: organization,
        hasEnvironmentsFeature: hasEnvironmentsFeature
      });
    },
    hasEnvironmentsFeature: function hasEnvironmentsFeature(org) {
      var features = new Set(org ? org.features : []);
      return features.has('environments');
    },
    render: function render() {
      var environment = this.state.hasEnvironmentsFeature ? this.state.environment : null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({ environment: environment }, this.props));
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (withEnvironmentInQueryString);

/***/ }),
/* 70 */,
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ExternalLink;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_less_components_externalLink_less__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_less_components_externalLink_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_app_less_components_externalLink_less__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





/**
 * Use this component when creating external links.
 *
 * By default will open in a new tab with `rel="noreferrer noopener"` to guard against
 * `target="_blank"` vulnerabilities
 */
function ExternalLink(_ref) {
  var href = _ref.href,
      otherProps = _objectWithoutProperties(_ref, ['href']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, otherProps, { href: href }));
}

ExternalLink.propTypes = {
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  rel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

// Should we allow these to be overridden?
ExternalLink.defaultProps = {
  target: '_blank',
  rel: 'noreferrer noopener'
};

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reflux__);




var validHookNames = new Set(['assistant:support-button', 'component:org-members-view', 'footer', 'settings:organization-navigation', 'settings:organization-navigation-config', 'organization:header', 'organization:sidebar', 'routes', 'routes:admin', 'routes:organization', 'project:data-forwarding:disabled', 'project:rate-limits:disabled', 'project:custom-inbound-filters:disabled', 'project:discard-groups:disabled', 'issue:secondary-column', 'analytics:onboarding-complete', 'analytics:event', 'sidebar:organization-dropdown-menu']);

var HookStore = __WEBPACK_IMPORTED_MODULE_1_reflux___default.a.createStore({
  init: function init() {
    this.hooks = {};
  },
  add: function add(hookName, callback) {
    // Gracefully error on invalid hooks, but maintain registration
    if (!validHookNames.has(hookName)) {
      // eslint-disable-next-line no-console
      console.error('Invalid hook name: ' + hookName);
    }
    if (__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(this.hooks[hookName])) {
      this.hooks[hookName] = [];
    }
    this.hooks[hookName].push(callback);
    this.trigger(hookName, this.hooks[hookName]);
  },
  remove: function remove(hookName, callback) {
    if (__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(this.hooks[hookName])) {
      return;
    }
    this.hooks[hookName] = this.hooks[hookName].filter(function (cb) {
      return cb !== callback;
    });
    this.trigger(hookName, this.hooks[hookName]);
  },
  get: function get(hookName) {
    return this.hooks[hookName] || [];
  }
});

/* harmony default export */ __webpack_exports__["default"] = (HookStore);

/***/ }),
/* 73 */,
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_mixins_projectState__ = __webpack_require__(41);



var GroupState = {
  mixins: [__WEBPACK_IMPORTED_MODULE_1_app_mixins_projectState__["a" /* default */]],

  contextTypes: {
    group: __WEBPACK_IMPORTED_MODULE_0_app_proptypes__["e" /* default */].Group.isRequired
  },

  getGroup: function getGroup() {
    return this.context.group;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GroupState);

/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = removeIndicator;
/* unused harmony export clearIndicators */
/* harmony export (immutable) */ __webpack_exports__["c"] = addMessage;
/* harmony export (immutable) */ __webpack_exports__["b"] = addLoadingMessage;
/* harmony export (immutable) */ __webpack_exports__["a"] = addErrorMessage;
/* harmony export (immutable) */ __webpack_exports__["d"] = addSuccessMessage;
/* harmony export (immutable) */ __webpack_exports__["f"] = saveOnBlurUndoMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_constants__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_actions_indicatorActions__ = __webpack_require__(479);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








// RFormValueoves a single indicator
function removeIndicator(indicator) {
  __WEBPACK_IMPORTED_MODULE_4_app_actions_indicatorActions__["a" /* default */].remove(indicator);
}

// Clears all indicators
function clearIndicators() {
  __WEBPACK_IMPORTED_MODULE_4_app_actions_indicatorActions__["a" /* default */].clear();
}

// Note previous IndicatorStore.add behavior was to default to "loading" if no type was supplied
function addMessage(msg, type) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var duration = options.duration;

  // use default only if undefined, as 0 is a valid duration

  duration = typeof duration === 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_app_constants__["g" /* DEFAULT_TOAST_DURATION */] : duration;

  var action = options.append ? 'append' : 'replace';
  // XXX: This differs from `IndicatorStore.add` since it won't return the indicator that is created
  // because we are firing an action. You can just add a new message and it will, by default,
  // replace active indicator
  __WEBPACK_IMPORTED_MODULE_4_app_actions_indicatorActions__["a" /* default */][action](msg, type, _extends({}, options, { duration: duration }));
}

function addMessageWithType(type) {
  return function (msg, duration) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return addMessage(msg, type, _extends({}, options, { duration: duration }));
  };
}

function addLoadingMessage() {
  var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Saving changes...');

  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return addMessageWithType('loading').apply(undefined, [msg].concat(args));
}

function addErrorMessage() {
  return addMessageWithType('error').apply(undefined, arguments);
}

function addSuccessMessage() {
  return addMessageWithType('success').apply(undefined, arguments);
}

// Transform form values into a string
// Otherwise bool values will not get rendered and empty strings look like a bug
var prettyFormString = function prettyFormString(val) {
  if (val === '') {
    return '<empty>';
  }

  return '' + val;
};

/**
 * This will call an action creator to generate a "Toast" message that
 * notifies user the field that changed with its previous and current values.
 *
 * Also allows for undo
 */

function saveOnBlurUndoMessage(change, model, fieldName) {
  if (!model) return;

  var label = model.getDescriptor(fieldName, 'label');

  if (!label) return;

  addSuccessMessage(Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["tct"])('Changed [fieldName] from [oldValue] to [newValue]', {
    fieldName: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'strong',
      null,
      label
    ),
    oldValue: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      FormValue,
      null,
      prettyFormString(change.old)
    ),
    newValue: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      FormValue,
      null,
      prettyFormString(change.new)
    )
  }), __WEBPACK_IMPORTED_MODULE_2_app_constants__["g" /* DEFAULT_TOAST_DURATION */], {
    model: model,
    id: fieldName,
    undo: function undo() {
      if (!model || !fieldName) return;

      var oldValue = model.getValue(fieldName);
      var didUndo = model.undo();
      var newValue = model.getValue(fieldName);

      if (!didUndo) return;
      if (!label) return;

      // `saveField` can return null if it can't save
      var saveResult = model.saveField(fieldName, newValue);

      if (!saveResult) {
        addErrorMessage(Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["tct"])('Unable to restore [fieldName] from [oldValue] to [newValue]', {
          fieldName: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            null,
            label
          ),
          oldValue: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            FormValue,
            null,
            prettyFormString(oldValue)
          ),
          newValue: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            FormValue,
            null,
            prettyFormString(newValue)
          )
        }));
        return;
      }

      saveResult.then(function () {
        addMessage(Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["tct"])('Restored [fieldName] from [oldValue] to [newValue]', {
          fieldName: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            null,
            label
          ),
          oldValue: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            FormValue,
            null,
            prettyFormString(oldValue)
          ),
          newValue: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            FormValue,
            null,
            prettyFormString(newValue)
          )
        }), 'undo', {
          duration: __WEBPACK_IMPORTED_MODULE_2_app_constants__["g" /* DEFAULT_TOAST_DURATION */]
        });
      });
    }
  });
}

var FormValue = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])('span', {
  target: 'ercrvsw0'
})('font-style:italic;');

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_styles_space__ = __webpack_require__(38);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var TextBlock = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])(function (_ref) {
  var noMargin = _ref.noMargin,
      props = _objectWithoutProperties(_ref, ['noMargin']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', props);
}, {
  target: 'ec8ep340'
})('line-height:1.5;', function (p) {
  return p.noMargin ? '' : 'margin-bottom:' + Object(__WEBPACK_IMPORTED_MODULE_2_app_styles_space__["a" /* default */])(3);
}, ';');

/* harmony default export */ __webpack_exports__["default"] = (TextBlock);

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);





/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'count',

  propTypes: {
    value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any.isRequired
  },

  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return this.props.value !== nextProps.value;
  },


  numberFormats: [[1000000000, 'b'], [1000000, 'm'], [1000, 'k']],

  floatFormat: function floatFormat(number, places) {
    var multi = Math.pow(10, places);
    return parseInt(number * multi, 10) / multi;
  },
  formatNumber: function formatNumber(number) {
    var b = void 0,
        x = void 0,
        y = void 0,
        o = void 0,
        p = void 0;

    number = parseInt(number, 10);

    /*eslint no-cond-assign:0*/
    for (var i = 0; b = this.numberFormats[i]; i++) {
      x = b[0];
      y = b[1];
      o = Math.floor(number / x);
      p = number % x;
      if (o > 0) {
        if (o / 10 > 1 || !p) return '' + o + y;
        return '' + this.floatFormat(number / x, 1) + y;
      }
    }
    return '' + number.toLocaleString();
  },
  render: function render() {
    var _props = this.props,
        value = _props.value,
        className = _props.className;


    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      { className: className },
      this.formatNumber(value)
    );
  }
}));

/***/ }),
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_contextData__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_utils__ = __webpack_require__(10);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var KeyValueList = (_temp = _class = function (_React$Component) {
  _inherits(KeyValueList, _React$Component);

  function KeyValueList() {
    _classCallCheck(this, KeyValueList);

    return _possibleConstructorReturn(this, (KeyValueList.__proto__ || Object.getPrototypeOf(KeyValueList)).apply(this, arguments));
  }

  _createClass(KeyValueList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // TODO(dcramer): use non-string keys as reserved words ("unauthorized")
      // break rendering

      var data = this.props.data;
      if (data === undefined || data === null) {
        data = [];
      } else if (!(data instanceof Array)) {
        data = Object.keys(data).map(function (key) {
          return [key, data[key]];
        });
      }

      data = this.props.isSorted ? __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default()(data, [function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
            key = _ref2[0];

        return key;
      }]) : data;
      var raw = this.props.raw;
      var props = this.props.onClick ? { onClick: this.props.onClick } : {};
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'table',
        _extends({ className: 'table key-value' }, props),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'tbody',
          null,
          data.map(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
                key = _ref4[0],
                value = _ref4[1];

            if (_this2.props.isContextData) {
              return [__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'tr',
                { key: key },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'td',
                  { className: 'key' },
                  key
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'td',
                  { className: 'value' },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_contextData__["a" /* default */], { data: !raw ? value : JSON.stringify(value) })
                )
              )];
            } else {
              return [__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'tr',
                { key: key },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'td',
                  { className: 'key' },
                  key
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'td',
                  { className: 'value' },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'pre',
                    null,
                    Object(__WEBPACK_IMPORTED_MODULE_4_app_utils__["e" /* deviceNameMapper */])('' + value || ' ')
                  )
                )
              )];
            }
          })
        )
      );
    }
  }]);

  return KeyValueList;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired,
  isContextData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isSorted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  raw: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class.defaultProps = {
  isContextData: false,
  isSorted: true,
  raw: false
}, _temp);


KeyValueList.displayName = 'KeyValueList';

/* harmony default export */ __webpack_exports__["a"] = (KeyValueList);

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_forms_formField__ = __webpack_require__(239);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var InputField = (_temp = _class = function (_FormField) {
  _inherits(InputField, _FormField);

  function InputField() {
    _classCallCheck(this, InputField);

    return _possibleConstructorReturn(this, (InputField.__proto__ || Object.getPrototypeOf(InputField)).apply(this, arguments));
  }

  _createClass(InputField, [{
    key: 'componentDidMount',


    // XXX(dcramer): this comes from TooltipMixin
    value: function componentDidMount() {
      _get(InputField.prototype.__proto__ || Object.getPrototypeOf(InputField.prototype), 'componentDidMount', this).call(this);
      this.attachTooltips();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeTooltips();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(this)).unbind();
      _get(InputField.prototype.__proto__ || Object.getPrototypeOf(InputField.prototype), 'componentWillUnmount', this).call(this);
    }
  }, {
    key: 'attachTooltips',
    value: function attachTooltips() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tip', __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(this)).tooltip();
    }
  }, {
    key: 'removeTooltips',
    value: function removeTooltips() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tip', __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(this)).tooltip('destroy');
    }
  }, {
    key: 'getAttributes',
    value: function getAttributes() {
      return {};
    }
  }, {
    key: 'getField',
    value: function getField() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', _extends({
        id: this.getId(),
        type: this.getType(),
        className: 'form-control',
        placeholder: this.props.placeholder,
        onChange: this.onChange,
        disabled: this.props.disabled,
        ref: 'input',
        name: this.props.name,
        required: this.props.required,
        value: this.state.value,
        style: this.props.inputStyle
      }, this.getAttributes()));
    }
  }, {
    key: 'getClassName',
    value: function getClassName() {
      return 'control-group';
    }
  }, {
    key: 'getType',
    value: function getType() {
      throw new Error('Must be implemented by child.');
    }
  }]);

  return InputField;
}(__WEBPACK_IMPORTED_MODULE_4_app_components_forms_formField__["a" /* default */]), _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_4_app_components_forms_formField__["a" /* default */].propTypes, {
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}), _temp);


/***/ }),
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AsyncView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_document_title__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_asyncComponent__ = __webpack_require__(182);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var AsyncView = function (_AsyncComponent) {
  _inherits(AsyncView, _AsyncComponent);

  function AsyncView() {
    _classCallCheck(this, AsyncView);

    return _possibleConstructorReturn(this, (AsyncView.__proto__ || Object.getPrototypeOf(AsyncView)).apply(this, arguments));
  }

  _createClass(AsyncView, [{
    key: 'getTitle',
    value: function getTitle() {
      return '';
    }
  }, {
    key: 'render',
    value: function render() {
      var title = this.getTitle();
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react_document_title___default.a,
        { title: (title ? title + ' - ' : '') + 'Sentry' },
        this.renderComponent()
      );
    }
  }]);

  return AsyncView;
}(__WEBPACK_IMPORTED_MODULE_2_app_components_asyncComponent__["default"]);



/***/ }),
/* 93 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 94 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0;

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function createStyleElement() {
	var styleElement = document.createElement("style");
	var head = getHeadElement();
	styleElement.type = "text/css";
	head.appendChild(styleElement);
	return styleElement;
}

function createLinkElement() {
	var linkElement = document.createElement("link");
	var head = getHeadElement();
	linkElement.rel = "stylesheet";
	head.appendChild(linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement());
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement();
		update = updateLink.bind(null, styleElement);
		remove = function() {
			styleElement.parentNode.removeChild(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement();
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			styleElement.parentNode.removeChild(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;
	var sourceMap = obj.sourceMap;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var media = obj.media;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_actions_groupActions__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_stores_indicatorStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_utils_pendingChangeQueue__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function showAlert(msg, type) {
  __WEBPACK_IMPORTED_MODULE_4_app_stores_indicatorStore__["default"].add(msg, type, {
    duration: 4000
  });
}

var GroupStore = __WEBPACK_IMPORTED_MODULE_2_reflux___default.a.createStore({
  listenables: [__WEBPACK_IMPORTED_MODULE_3_app_actions_groupActions__["a" /* default */]],

  init: function init() {
    this.reset();
  },
  reset: function reset() {
    this.items = [];
    this.statuses = {};
    this.pendingChanges = new __WEBPACK_IMPORTED_MODULE_5_app_utils_pendingChangeQueue__["a" /* default */]();
  },


  // TODO(dcramer): this should actually come from an action of some sorts
  loadInitialData: function loadInitialData(items) {
    var _this = this;

    this.reset();

    var itemIds = new Set();
    items.forEach(function (item) {
      itemIds.add(item.id);
      _this.items.push(item);
    });

    this.trigger(itemIds);
  },
  add: function add(items) {
    var _this2 = this;

    if (!__WEBPACK_IMPORTED_MODULE_1_lodash_isArray___default()(items)) {
      items = [items];
    }

    var itemsById = {};
    var itemIds = new Set();
    items.forEach(function (item) {
      itemsById[item.id] = item;
      itemIds.add(item.id);
    });

    // See if any existing items are updated by this new set of items
    this.items.forEach(function (item, idx) {
      if (itemsById[item.id]) {
        _this2.items[idx] = _extends({}, item, itemsById[item.id]);
        delete itemsById[item.id];
      }
    });

    // New items
    for (var itemId in itemsById) {
      this.items.push(itemsById[itemId]);
    }

    this.trigger(itemIds);
  },
  remove: function remove(itemId) {
    var _this3 = this;

    this.items.forEach(function (item, idx) {
      if (item.id === itemId) {
        _this3.items.splice(idx, idx + 1);
      }
    });

    this.trigger(new Set([itemId]));
  },
  addStatus: function addStatus(id, status) {
    if (__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(this.statuses[id])) {
      this.statuses[id] = {};
    }
    this.statuses[id][status] = true;
  },
  clearStatus: function clearStatus(id, status) {
    if (__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(this.statuses[id])) {
      return;
    }
    this.statuses[id][status] = false;
  },
  hasStatus: function hasStatus(id, status) {
    if (__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(this.statuses[id])) {
      return false;
    }
    return this.statuses[id][status] || false;
  },
  indexOfActivity: function indexOfActivity(group_id, id) {
    var group = this.get(group_id);
    if (!group) return -1;

    for (var i = 0; i < group.activity.length; i++) {
      if (group.activity[i].id === id) {
        return i;
      }
    }
    return -1;
  },
  addActivity: function addActivity(id, data) {
    var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;

    var group = this.get(id);
    if (!group) return;

    // insert into beginning by default
    if (index === -1) {
      group.activity.unshift(data);
    } else {
      group.activity.splice(index, 0, data);
    }
    if (data.type === 'note') group.numComments++;

    this.trigger(new Set([id]));
  },
  updateActivity: function updateActivity(group_id, id, data) {
    var group = this.get(group_id);
    if (!group) return;

    var index = this.indexOfActivity(group_id, id);
    if (index === -1) return;

    // Here, we want to merge the new `data` being passed in
    // into the existing `data` object. This effectively
    // allows passing in an object of only changes.
    group.activity[index].data = Object.assign(group.activity[index].data, data);
    this.trigger(new Set([group.id]));
  },
  removeActivity: function removeActivity(group_id, id) {
    var group = this.get(group_id);
    if (!group) return -1;

    var index = this.indexOfActivity(group.id, id);
    if (index === -1) return -1;

    var activity = group.activity.splice(index, 1);

    if (activity[0].type === 'note') group.numComments--;

    this.trigger(new Set([group.id]));
    return index;
  },
  get: function get(id) {
    var pendingForId = [];
    this.pendingChanges.forEach(function (change) {
      if (change.id === id) {
        pendingForId.push(change);
      }
    });

    for (var i = 0; i < this.items.length; i++) {
      if (this.items[i].id === id) {
        var rItem = this.items[i];
        if (pendingForId.length) {
          // copy the object so dirty state doesnt mutate original
          rItem = _extends({}, rItem);

          for (var c = 0; c < pendingForId.length; c++) {
            rItem = _extends({}, rItem, pendingForId[c].params);
          }
        }
        return rItem;
      }
    }
    return undefined;
  },
  getAllItemIds: function getAllItemIds() {
    return this.items.map(function (item) {
      return item.id;
    });
  },
  getAllItems: function getAllItems() {
    // regroup pending changes by their itemID
    var pendingById = {};
    this.pendingChanges.forEach(function (change) {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(pendingById[change.id])) {
        pendingById[change.id] = [];
      }
      pendingById[change.id].push(change);
    });

    return this.items.map(function (item) {
      var rItem = item;
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(pendingById[item.id])) {
        // copy the object so dirty state doesnt mutate original
        rItem = _extends({}, rItem);
        pendingById[item.id].forEach(function (change) {
          rItem = _extends({}, rItem, change.params);
        });
      }
      return rItem;
    });
  },
  onAssignTo: function onAssignTo(changeId, itemId, data) {
    this.addStatus(itemId, 'assignTo');
    this.trigger(new Set([itemId]));
  },


  // TODO(dcramer): This is not really the best place for this
  onAssignToError: function onAssignToError(changeId, itemId, error) {
    this.clearStatus(itemId, 'assignTo');
    showAlert(Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Unable to change assignee. Please try again.'), 'error');
  },
  onAssignToSuccess: function onAssignToSuccess(changeId, itemId, response) {
    var item = this.get(itemId);
    if (!item) {
      return;
    }
    item.assignedTo = response.assignedTo;
    this.clearStatus(itemId, 'assignTo');
    this.trigger(new Set([itemId]));
  },
  onDelete: function onDelete(changeId, itemIds) {
    var _this4 = this;

    itemIds = this._itemIdsOrAll(itemIds);
    itemIds.forEach(function (itemId) {
      _this4.addStatus(itemId, 'delete');
    });
    this.trigger(new Set(itemIds));
  },
  onDeleteError: function onDeleteError(changeId, itemIds, response) {
    var _this5 = this;

    showAlert(Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Unable to delete events. Please try again.'), 'error');

    if (!itemIds) return;

    itemIds.forEach(function (itemId) {
      _this5.clearStatus(itemId, 'delete');
    });
    this.trigger(new Set(itemIds));
  },
  onDeleteSuccess: function onDeleteSuccess(changeId, itemIds, response) {
    var _this6 = this;

    itemIds = this._itemIdsOrAll(itemIds);
    var itemIdSet = new Set(itemIds);
    itemIds.forEach(function (itemId) {
      delete _this6.statuses[itemId];
      _this6.clearStatus(itemId, 'delete');
    });
    this.items = this.items.filter(function (item) {
      return !itemIdSet.has(item.id);
    });
    showAlert(Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('The selected events have been scheduled for deletion.'), 'success');
    this.trigger(new Set(itemIds));
  },
  onDiscard: function onDiscard(changeId, itemId) {
    this.addStatus(itemId, 'discard');
    this.trigger(new Set([itemId]));
  },
  onDiscardError: function onDiscardError(changeId, itemId, response) {
    this.clearStatus(itemId, 'discard');
    showAlert(Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Unable to discard event. Please try again.'), 'error');
    this.trigger(new Set([itemId]));
  },
  onDiscardSuccess: function onDiscardSuccess(changeId, itemId, response) {
    delete this.statuses[itemId];
    this.clearStatus(itemId, 'discard');
    this.items = this.items.filter(function (item) {
      return item.id !== itemId;
    });
    showAlert(Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Similar events will be filtered and discarded.'), 'success');
    this.trigger(new Set([itemId]));
  },
  onMerge: function onMerge(changeId, itemIds) {
    var _this7 = this;

    itemIds = this._itemIdsOrAll(itemIds);

    itemIds.forEach(function (itemId) {
      _this7.addStatus(itemId, 'merge');
    });
    // XXX(billy): Not sure if this is a bug or not but do we need to publish all itemIds?
    // Seems like we only need to publish parent id
    this.trigger(new Set(itemIds));
  },
  onMergeError: function onMergeError(changeId, itemIds, response) {
    var _this8 = this;

    itemIds = this._itemIdsOrAll(itemIds);

    itemIds.forEach(function (itemId) {
      _this8.clearStatus(itemId, 'merge');
    });
    showAlert(Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Unable to merge events. Please try again.'), 'error');
    this.trigger(new Set(itemIds));
  },
  onMergeSuccess: function onMergeSuccess(changeId, mergedIds, response) {
    var _this9 = this;

    mergedIds = this._itemIdsOrAll(mergedIds); // everything on page

    mergedIds.forEach(function (itemId) {
      _this9.clearStatus(itemId, 'merge');
    });

    // Remove all but parent id (items were merged into this one)
    var mergedIdSet = new Set(mergedIds);
    this.items = this.items.filter(function (item) {
      return !mergedIdSet.has(item.id) || item.id === response.merge.parent;
    });

    showAlert(Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('The selected events have been scheduled for merge.'), 'success');
    this.trigger(new Set(mergedIds));
  },


  /**
   * If itemIds is undefined, returns all ids in the store
   */
  _itemIdsOrAll: function _itemIdsOrAll(itemIds) {
    if (__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(itemIds)) {
      itemIds = this.items.map(function (item) {
        return item.id;
      });
    }
    return itemIds;
  },
  onUpdate: function onUpdate(changeId, itemIds, data) {
    var _this10 = this;

    itemIds = this._itemIdsOrAll(itemIds);

    itemIds.forEach(function (itemId) {
      _this10.addStatus(itemId, 'update');
      _this10.pendingChanges.push(changeId, itemId, data);
    });
    this.trigger(new Set(itemIds));
  },
  onUpdateError: function onUpdateError(changeId, itemIds, error, failSilently) {
    var _this11 = this;

    itemIds = this._itemIdsOrAll(itemIds);

    this.pendingChanges.remove(changeId);
    itemIds.forEach(function (itemId) {
      _this11.clearStatus(itemId, 'update');
    });
    if (!failSilently) {
      showAlert(Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Unable to update events. Please try again.'), 'error');
    }
    this.trigger(new Set(itemIds));
  },
  onUpdateSuccess: function onUpdateSuccess(changeId, itemIds, response) {
    var _this12 = this;

    itemIds = this._itemIdsOrAll(itemIds);

    this.items.forEach(function (item, idx) {
      if (itemIds.indexOf(item.id) !== -1) {
        _this12.items[idx] = _extends({}, item, response);
        _this12.clearStatus(item.id, 'update');
      }
    });
    this.pendingChanges.remove(changeId);
    this.trigger(new Set(itemIds));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (GroupStore);

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(235),
    isArray = __webpack_require__(47),
    isObjectLike = __webpack_require__(200);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 97 */,
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(455);

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str) {
	if (typeof str !== 'string') {
		return {};
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return {};
	}

	return str.split('&').reduce(function (ret, param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		key = decodeURIComponent(key);

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		if (!ret.hasOwnProperty(key)) {
			ret[key] = val;
		} else if (Array.isArray(ret[key])) {
			ret[key].push(val);
		} else {
			ret[key] = [ret[key], val];
		}

		return ret;
	}, {});
};

exports.stringify = function (obj) {
	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (Array.isArray(val)) {
			return val.sort().map(function (val2) {
				return strictUriEncode(key) + '=' + strictUriEncode(val2);
			}).join('&');
		}

		return strictUriEncode(key) + '=' + strictUriEncode(val);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(121),
    now = __webpack_require__(942),
    toNumber = __webpack_require__(943);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_SCOPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DEFAULT_API_SCOPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DEFAULT_TOAST_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CSRF_COOKIE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_ENVIRONMENTS_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DEFAULT_FUSE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AVATAR_URL_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MENU_CLOSE_DELAY; });
/**
 * Common constants here
 */

var API_SCOPES = ['project:read', 'project:write', 'project:admin', 'project:releases', 'team:read', 'team:write', 'team:admin', 'event:read', 'event:admin', 'org:read', 'org:write', 'org:admin', 'member:read', 'member:admin'];

// Default API scopes when adding a new API token or org API token
var DEFAULT_API_SCOPES = ['event:read', 'event:admin', 'project:read', 'project:releases', 'org:read', 'team:read', 'member:read'];

var DEFAULT_TOAST_DURATION = 6000;

var CSRF_COOKIE_NAME = window.csrfCookieName || 'sc';

var ALL_ENVIRONMENTS_KEY = '__all_environments__';

// See http://fusejs.io/ for more information
var DEFAULT_FUSE_OPTIONS = {
  includeScore: true,
  includeMatches: true,
  threshold: 0.4,
  location: 0,
  distance: 75,
  maxPatternLength: 24,
  minMatchCharLength: 1
  // tokenize: true,
  // findAllMatches: true,
};

// Maps a `type: string` -> `url-prefix: string`
var AVATAR_URL_MAP = {
  team: 'team-avatar',
  organization: 'organization-avatar',
  project: 'project-avatar',
  user: 'avatar'
};

var MENU_CLOSE_DELAY = 200;

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNumber__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_stores_configStore__ = __webpack_require__(25);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var DateTime = (_temp2 = _class = function (_React$Component) {
  _inherits(DateTime, _React$Component);

  function DateTime() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DateTime);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DateTime.__proto__ || Object.getPrototypeOf(DateTime)).call.apply(_ref, [this].concat(args))), _this), _this.getFormat = function (_ref2) {
      var clock24Hours = _ref2.clock24Hours;
      var _this$props = _this.props,
          dateOnly = _this$props.dateOnly,
          seconds = _this$props.seconds,
          shortDate = _this$props.shortDate;

      // October 26, 2017

      if (dateOnly) {
        return 'LL';
      }

      if (shortDate) {
        return 'MM/DD/YYYY';
      }

      if (clock24Hours) {
        return 'MMMM D YYYY HH:mm:ss z';
      }

      // Oct 26, 2017 11:30:30 AM
      if (seconds) {
        return 'll LTS z';
      }

      // Default is Oct 26, 2017 11:30 AM
      return 'lll';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DateTime, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          date = _props.date,
          seconds = _props.seconds,
          shortDate = _props.shortDate,
          dateOnly = _props.dateOnly,
          carriedProps = _objectWithoutProperties(_props, ['date', 'seconds', 'shortDate', 'dateOnly']);

      var user = __WEBPACK_IMPORTED_MODULE_5_app_stores_configStore__["default"].get('user');
      var options = user ? user.options : {};
      var format = this.getFormat(options);

      if (__WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(date) || __WEBPACK_IMPORTED_MODULE_0_lodash_isNumber___default()(date)) {
        date = new Date(date);
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'time',
        carriedProps,
        __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(date, options.timezone).format(format)
      );
    }
  }]);

  return DateTime;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component), _class.propTypes = {
  date: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any.isRequired,
  dateOnly: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  shortDate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  seconds: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
}, _class.defaultProps = {
  seconds: true
}, _temp2);


/* harmony default export */ __webpack_exports__["default"] = (DateTime);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = openModal;
/* harmony export (immutable) */ __webpack_exports__["a"] = closeModal;
/* harmony export (immutable) */ __webpack_exports__["h"] = openSudo;
/* harmony export (immutable) */ __webpack_exports__["e"] = openDiffModal;
/* harmony export (immutable) */ __webpack_exports__["d"] = openCreateTeamModal;
/* harmony export (immutable) */ __webpack_exports__["c"] = openCreateOwnershipRule;
/* harmony export (immutable) */ __webpack_exports__["b"] = openCommandPalette;
/* harmony export (immutable) */ __webpack_exports__["g"] = openRecoveryOptions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_actions_modalActions__ = __webpack_require__(462);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





/**
 * Show a modal
 */
function openModal(renderer, options) {
  __WEBPACK_IMPORTED_MODULE_1_app_actions_modalActions__["a" /* default */].openModal(renderer, options);
}

/**
 * Close modal
 */
function closeModal() {
  __WEBPACK_IMPORTED_MODULE_1_app_actions_modalActions__["a" /* default */].closeModal();
}

function openSudo() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var onClose = _ref.onClose,
      args = _objectWithoutProperties(_ref, ['onClose']);

  __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 1564)).then(function (mod) {
    return mod.default;
  }).then(function (SudoModal) {
    return openModal(function (deps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SudoModal, _extends({}, deps, args));
    }, {
      modalClassName: 'sudo-modal',
      onClose: onClose
    });
  });
}

function openDiffModal(options) {
  __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1565)).then(function (mod) {
    return mod.default;
  }).then(function (Modal) {
    return openModal(function (deps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Modal, _extends({}, deps, options));
    }, {
      modalClassName: 'diff-modal'
    });
  });
}

/**
 * @param Object options
 * @param Object options.organization The organization to create a team for
 * @param Object options.project (optional) An initial project to add the team to. This may be deprecated soon as
 * we may add a project selection inside of the modal flow
 */
function openCreateTeamModal() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 1566)).then(function (mod) {
    return mod.default;
  }).then(function (Modal) {
    openModal(function (deps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Modal, _extends({}, deps, options));
    }, {
      modalClassName: 'create-team-modal'
    });
  });
}

/**
 * @param Object options.organization The organization to create a rules for
 * @param Object options.project The project to create a rules for
 */
function openCreateOwnershipRule() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1567)).then(function (mod) {
    return mod.default;
  }).then(function (Modal) {
    openModal(function (deps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Modal, _extends({}, deps, options));
    }, {
      modalClassName: 'create-ownership-rule-modal'
    });
  });
}

function openCommandPalette() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1568)).then(function (mod) {
    return mod.default;
  }).then(function (Modal) {
    openModal(function (deps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Modal, _extends({}, deps, options));
    }, {
      modalClassName: 'command-palette'
    });
  });
}

function openRecoveryOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 1569)).then(function (mod) {
    return mod.default;
  }).then(function (Modal) {
    openModal(function (deps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Modal, _extends({}, deps, options));
    }, {
      modalClassName: 'recovery-options'
    });
  });
}

/***/ }),
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['createSuccess', 'update', 'updateError', 'updateSuccess', 'loadStats', 'loadStatsError', 'loadStatsSuccess', 'loadStatsForProjectSuccess', 'removeProject', 'removeProjectError', 'removeProjectSuccess', 'setActive', 'changeSlug', 'addTeam', 'addTeamSuccess', 'addTeamError', 'removeTeam', 'removeTeamSuccess', 'removeTeamError']));

/***/ }),
/* 117 */,
/* 118 */,
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_Modal__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Confirm = (_temp = _class = function (_React$PureComponent) {
  _inherits(Confirm, _React$PureComponent);

  function Confirm() {
    var _ref;

    _classCallCheck(this, Confirm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = Confirm.__proto__ || Object.getPrototypeOf(Confirm)).call.apply(_ref, [this].concat(args)));

    _this.openModal = function () {
      var onConfirming = _this.props.onConfirming;

      if (typeof onConfirming === 'function') {
        onConfirming();
      }

      _this.setState(function (state) {
        return {
          isModalOpen: true,
          disableConfirmButton: false
        };
      });

      // always reset `confirming` when modal visibility changes
      _this.confirming = false;
    };

    _this.closeModal = function () {
      var onCancel = _this.props.onCancel;

      if (typeof onCancel === 'function') {
        onCancel();
      }
      _this.setState(function (state) {
        return {
          isModalOpen: false,
          disableConfirmButton: false
        };
      });

      // always reset `confirming` when modal visibility changes
      _this.confirming = false;
    };

    _this.handleConfirm = function (e) {
      // `confirming` is used to make sure `onConfirm` is only called once
      if (!_this.confirming) {
        _this.props.onConfirm();
      }

      // Close modal
      _this.setState({
        isModalOpen: false,
        disableConfirmButton: true
      });
      _this.confirming = true;
    };

    _this.handleToggle = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          bypass = _this$props.bypass;

      if (disabled) return;

      if (bypass) {
        _this.props.onConfirm();
        return;
      }

      // Current state is closed, means it will toggle open
      if (!_this.state.isModalOpen) {
        _this.openModal();
      } else {
        _this.closeModal();
      }
    };

    _this.state = {
      isModalOpen: false,
      disableConfirmButton: false
    };
    _this.confirming = false;
    return _this;
  }

  _createClass(Confirm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          disabled = _props.disabled,
          message = _props.message,
          renderMessage = _props.renderMessage,
          priority = _props.priority,
          confirmText = _props.confirmText,
          cancelText = _props.cancelText,
          children = _props.children;


      var confirmMessage = void 0;
      if (typeof renderMessage === 'function') {
        confirmMessage = renderMessage({
          confirm: this.handleConfirm,
          close: this.handleToggle
        });
      } else {
        confirmMessage = __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(message) ? message : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            null,
            message
          )
        );
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        typeof children === 'function' ? children({
          close: this.closeModal,
          open: this.openModal
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(children, { disabled: disabled, onClick: this.handleToggle }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_Modal___default.a,
          { show: this.state.isModalOpen, animation: false, onHide: this.handleToggle },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'modal-body' },
            confirmMessage
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'modal-footer' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_app_components_buttons_button__["default"],
              { style: { marginRight: 10 }, onClick: this.handleToggle },
              cancelText
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_app_components_buttons_button__["default"],
              {
                'data-test-id': 'confirm-modal',
                disabled: this.state.disableConfirmButton,
                priority: priority,
                onClick: this.handleConfirm,
                autoFocus: true
              },
              confirmText
            )
          )
        )
      );
    }
  }]);

  return Confirm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent), _class.propTypes = {
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  confirmText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  cancelText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  priority: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['primary', 'danger']).isRequired,
  /**
   * If true, will skip the confirmation modal and call `onConfirm`
   */
  bypass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  /**
   * Renderer that passes:
   * `confirm`: Allows renderer to perform confirm action
   * `close`: Allows renderer to toggle confirm modal
   */
  renderMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onConfirming: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class.defaultProps = {
  priority: 'primary',
  cancelText: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Cancel'),
  confirmText: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Confirm')
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (Confirm);

/***/ }),
/* 120 */,
/* 121 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_omit__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ListLink = (_temp2 = _class = function (_React$Component) {
  _inherits(ListLink, _React$Component);

  function ListLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ListLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ListLink.__proto__ || Object.getPrototypeOf(ListLink)).call.apply(_ref, [this].concat(args))), _this), _this.isActive = function () {
      return (_this.props.isActive || _this.context.router.isActive)({ pathname: _this.props.to, query: _this.props.query }, _this.props.index);
    }, _this.getClassName = function () {
      var _classNames = {};

      if (_this.props.className) _classNames[_this.props.className] = true;

      if (_this.isActive()) _classNames[_this.props.activeClassName] = true;

      return __WEBPACK_IMPORTED_MODULE_4_classnames___default()(_classNames);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ListLink, [{
    key: 'render',
    value: function render() {
      var carriedProps = __WEBPACK_IMPORTED_MODULE_0_lodash_omit___default()(this.props, 'activeClassName', 'isActive', 'index');
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'li',
        { className: this.getClassName() },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router__["Link"],
          _extends({}, carriedProps, { onlyActiveOnIndex: this.props.index }),
          this.props.children
        )
      );
    }
  }]);

  return ListLink;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.displayName = 'ListLink', _class.propTypes = {
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  // If supplied by parent component, decides whether link element
  // is "active" or not ... overriding default behavior of strict
  // route matching
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
}, _class.defaultProps = {
  activeClassName: 'active',
  index: false
}, _temp2);


/* harmony default export */ __webpack_exports__["default"] = (ListLink);

/***/ }),
/* 123 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_emotion__ = __webpack_require__(5);


var TextOverflow = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react_emotion__["default"])('div', {
  target: 'e8qi82q0'
})('text-overflow:ellipsis;overflow:hidden;white-space:nowrap;');

/* harmony default export */ __webpack_exports__["a"] = (TextOverflow);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var NarrowLayout = function (_React$Component) {
  _inherits(NarrowLayout, _React$Component);

  function NarrowLayout() {
    _classCallCheck(this, NarrowLayout);

    return _possibleConstructorReturn(this, (NarrowLayout.__proto__ || Object.getPrototypeOf(NarrowLayout)).apply(this, arguments));
  }

  _createClass(NarrowLayout, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.body).addClass('narrow');
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.body).removeClass('narrow');
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'app' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pattern-bg' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'container' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'box box-modal' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'box-header' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { href: '/' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon-sentry-logo' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'box-content with-padding' },
              this.props.children
            )
          )
        )
      );
    }
  }]);

  return NarrowLayout;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

/* harmony default export */ __webpack_exports__["default"] = (NarrowLayout);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var theme = {
  breakpoints: ['768px', '992px', '1200px'],

  // Colors
  offWhite: '#FAF9FB',
  offWhite2: '#E7E1EC',
  whiteDark: '#fbfbfc',
  white: '#FFFFFF',

  gray1: '#BDB4C7',
  gray2: '#9585A3',
  gray3: '#645574',
  gray4: '#4A3E56',
  gray5: '#302839',

  blue: '#3B6ECC',
  blueLight: '#628BD6',
  blueDark: '#2F58A3',

  green: '#57be8c',
  greenLight: '#71D8A6',
  greenDark: '#3EA573',
  greenTransparent: 'rgba(87, 190, 140, 0.5)',

  yellow: '#ecc844',
  yellowLightest: '#FFFDF7',
  yellowLight: '#FFF15E',
  yellowDark: '#e6bc23',

  yellowOrange: '#f9a66d',
  yellowOrangeLight: '#FFC087',
  yellowOrangeDark: '#E08D54',

  orange: '#ec5e44',
  orangeLight: '#FF785E',
  orangeDark: '#D3452B',

  red: '#e03e2f',
  redLight: '#FA5849',
  redDark: '#C72516',

  pink: '#F868BC',
  pinkLight: '#FF82D6',
  pinkDark: '#DF4FA3',

  purple: '#6C5FC7',
  purple2: '#6f617c', // This is from event-details
  purplelightest: '#9F92FA',
  purpleLight: '#8679E1',
  purpleDark: '#5346AE',
  purpleDarkest: '#392C94',

  borderLighter: '#f9f6fd',
  borderLight: '#E2DBE8',
  borderDark: '#D1CAD8',
  borderRadius: '4px',

  dropShadowLight: '0 2px 0 rgba(37, 11, 54, 0.04)',
  dropShadowHeavy: '0 1px 4px 1px rgba(47,40,55,0.08), 0 4px 16px 0 rgba(47,40,55,0.12)',

  background: '#fff',

  zIndex: {
    sidebar: 1002,
    header: 1000,
    dropdown: 1001,
    modal: 10000,
    toast: 10001
  },

  alert: {
    info: {
      backgroundLight: '#F5FAFE',
      border: '#B5D6ED'
    },
    warning: {
      backgroundLight: '#FFFDF7',
      background: '#f9a66d',
      border: '#E1D697',
      textDark: '#D3BE2B'
    },
    success: {
      backgroundLight: '#F8FCF7',
      background: '#57be8c',
      border: '#BBD6B3'
    },
    error: {
      backgroundLight: '#FDF6F5',
      border: '#E7C0BC',
      textLight: '#92635f',
      textDark: '#5d3e3b'
    }
  },

  grid: 8,
  fontSizeSmall: '12px',
  fontSizeMedium: '14px',
  fontSizeLarge: '16px',
  fontSizeExtraLarge: '18px',

  settings: {
    // Max-width for settings breadcrumbs
    // i.e. organization, project, or team
    maxCrumbWidth: '240px',

    containerWidth: '1140px',
    headerHeight: '115px',
    sidebarWidth: '210px'
  },

  sidebar: {
    background: '#2f2936',
    color: '#9586a5',
    divider: '#493e54',
    badgeSize: '22px',
    smallBadgeSize: '11px',
    collapsedWidth: '70px',
    expandedWidth: '220px',
    mobileHeight: '54px',
    menuSpacing: '15px',
    panel: {
      width: '320px',
      headerHeight: '62px'
    }
  },

  text: {
    family: '"Rubik", "Avenir Next", sans-serif',
    familyMono: 'Monaco, Consolas, "Courier New", monospace',
    lineHeightHeading: '1.15',
    lineHeightBody: '1.4'
  }
};

// Aliases
theme.textColor = theme.gray5;
theme.success = theme.green;
theme.error = theme.red;
theme.disabled = '#ced3d6';

theme.alert.info.iconColor = theme.blue;
theme.alert.info.background = theme.blue;

theme.alert.warning.iconColor = theme.yellowDark;
theme.alert.warning.background = theme.yellow;

theme.alert.success.iconColor = theme.greenDark;
theme.alert.success.background = theme.green;

theme.alert.error.iconColor = theme.redDark;
theme.alert.error.background = theme.red;

//alias warn to warning
theme.alert.warn = theme.alert.warning;

theme.button = {
  borderRadius: '3px',

  default: {
    color: '#2f2936',
    colorActive: '#161319',
    background: theme.white,
    backgroundActive: theme.white,
    border: '#d8d2de',
    borderActive: '#c9c0d1'
  },
  primary: {
    color: theme.white,
    background: theme.purple,
    backgroundActive: '#4e3fb4',
    border: '#3d328e',
    borderActive: '#352b7b'
  },
  success: {
    color: theme.white,
    background: '#3fa372',
    backgroundActive: theme.green,
    border: '#7ccca5',
    borderActive: '#7ccca5'
  },
  danger: {
    color: theme.white,
    background: theme.red,
    backgroundActive: '#bf2a1d',
    border: '#bf2a1d',
    borderActive: '#7d1c13'
  },
  link: {
    color: theme.blue,
    background: 'transparent',
    // border: '#3d328e',
    backgroundActive: 'transparent'
    // borderActive: '#352b7b',
  },
  disabled: {
    color: theme.disabled,
    border: '#e3e5e6',
    borderActive: '#e3e5e6',
    background: theme.white,
    backgroundActive: theme.white
  }
};

/* harmony default export */ __webpack_exports__["default"] = (theme);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





// Flexbox container whose children will have `justify-content: space-between`
//
// Intended for children.length == 2
// "responsive" will change flex-direction to be column on small widths
var SpreadLayout = function SpreadLayout(_ref) {
  var children = _ref.children,
      className = _ref.className,
      responsive = _ref.responsive,
      center = _ref.center,
      props = _objectWithoutProperties(_ref, ['children', 'className', 'responsive', 'center']);

  var cx = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('spread-layout', className, {
    center: center,
    'allow-responsive': responsive
  });

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({}, props, { className: cx }),
    children
  );
};

SpreadLayout.defaultProps = {
  responsive: false,
  center: true
};

SpreadLayout.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  center: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (SpreadLayout);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_views_settings_components_forms_formField__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_views_settings_components_forms_controls_input__ = __webpack_require__(268);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var InputField = (_temp = _class = function (_React$Component) {
  _inherits(InputField, _React$Component);

  function InputField() {
    _classCallCheck(this, InputField);

    return _possibleConstructorReturn(this, (InputField.__proto__ || Object.getPrototypeOf(InputField)).apply(this, arguments));
  }

  _createClass(InputField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          field = _props.field;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_app_views_settings_components_forms_formField__["a" /* default */],
        _extends({ className: className }, this.props),
        function (_ref) {
          var children = _ref.children,
              formFieldProps = _objectWithoutProperties(_ref, ['children']);

          return field(_extends({}, formFieldProps));
        }
      );
    }
  }]);

  return InputField;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_2_app_views_settings_components_forms_formField__["a" /* default */].propTypes, {
  field: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
}), _class.defaultProps = {
  field: function field(_ref2) {
    var _onChange = _ref2.onChange,
        _onBlur = _ref2.onBlur,
        _onKeyDown = _ref2.onKeyDown,
        props = _objectWithoutProperties(_ref2, ['onChange', 'onBlur', 'onKeyDown']);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_views_settings_components_forms_controls_input__["a" /* default */], _extends({}, props, {
      onBlur: function onBlur(e) {
        return _onBlur(e.target.value, e);
      },
      onKeyDown: function onKeyDown(e) {
        return _onKeyDown(e.target.value, e);
      },
      onChange: function onChange(e) {
        return _onChange(e.target.value, e);
      }
    }));
  }
}, _temp);


/***/ }),
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);


var AlertActions = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['addAlert', 'closeAlert']);

/* harmony default export */ __webpack_exports__["default"] = (AlertActions);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = setActiveEnvironment;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearActiveEnvironment;
/* harmony export (immutable) */ __webpack_exports__["c"] = loadEnvironments;
/* harmony export (immutable) */ __webpack_exports__["b"] = loadActiveEnvironments;
/* harmony export (immutable) */ __webpack_exports__["d"] = loadHiddenEnvironments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_actions_environmentActions__ = __webpack_require__(322);


function setActiveEnvironment(environment) {
  __WEBPACK_IMPORTED_MODULE_0_app_actions_environmentActions__["a" /* default */].setActive(environment);
}

function clearActiveEnvironment() {
  __WEBPACK_IMPORTED_MODULE_0_app_actions_environmentActions__["a" /* default */].clearActive();
}

function loadEnvironments(data, envName) {
  __WEBPACK_IMPORTED_MODULE_0_app_actions_environmentActions__["a" /* default */].loadData(data, envName);
}

function loadActiveEnvironments(data) {
  __WEBPACK_IMPORTED_MODULE_0_app_actions_environmentActions__["a" /* default */].loadActiveData(data);
}

function loadHiddenEnvironments(data) {
  __WEBPACK_IMPORTED_MODULE_0_app_actions_environmentActions__["a" /* default */].loadHiddenData(data);
}

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = recreateRoute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_findLastIndex__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_findLastIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_findLastIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_utils_replaceRouterParams__ = __webpack_require__(266);






// Given a route object or a string and a list of routes + params from router, this will attempt to
// recreate a location string while replacing url params.
//
// Can additionally specify the number of routes to move back
//
// See tests for examples
function recreateRoute(to, _ref) {
  var routes = _ref.routes,
      params = _ref.params,
      location = _ref.location,
      stepBack = _ref.stepBack;

  var paths = routes.map(function (_ref2) {
    var path = _ref2.path;
    return path || '';
  });
  var lastRootIndex = __WEBPACK_IMPORTED_MODULE_0_lodash_findLastIndex___default()(paths, function (path) {
    return path[0] === '/';
  });
  var routeIndex = void 0;
  var routeToRoute = typeof to !== 'string';
  if (routeToRoute) {
    routeIndex = routes.indexOf(to) + lastRootIndex;
  }

  var baseRoute = paths.slice(lastRootIndex, routeIndex);

  if (typeof stepBack !== 'undefined') {
    baseRoute = baseRoute.slice(0, stepBack);
  }

  var query = typeof location !== 'undefined' && location.search ? location.search : '';

  var fullRoute = '' + baseRoute.join('') + (routeToRoute ? '' : to) + query;

  return Object(__WEBPACK_IMPORTED_MODULE_1_app_utils_replaceRouterParams__["a" /* default */])(fullRoute, params);
}

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);


var MemberListStore = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({
  // listenables: MemberActions,

  init: function init() {
    this.items = [];
    this.loaded = false;
  },


  // TODO(dcramer): this should actually come from an action of some sorts
  loadInitialData: function loadInitialData(items) {
    this.items = items;
    this.loaded = true;
    this.trigger(this.items, 'initial');
  },
  getById: function getById(id) {
    if (!this.items) return null;

    id = '' + id;
    for (var i = 0; i < this.items.length; i++) {
      if (this.items[i].id === id) {
        return this.items[i];
      }
    }
    return null;
  },
  getByEmail: function getByEmail(email) {
    if (!this.items) return null;

    email = email.toLowerCase();
    for (var i = 0; i < this.items.length; i++) {
      if (this.items[i].email.toLowerCase() === email) {
        return this.items[i];
      }
    }
    return null;
  },
  getAll: function getAll() {
    return this.items;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (MemberListStore);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_actions_teamActions__ = __webpack_require__(238);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var TeamStore = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({
  init: function init() {
    this.initialized = false;
    this.reset();

    this.listenTo(__WEBPACK_IMPORTED_MODULE_1_app_actions_teamActions__["a" /* default */].updateSuccess, this.onUpdateSuccess);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_1_app_actions_teamActions__["a" /* default */].fetchDetailsSuccess, this.onUpdateSuccess);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_1_app_actions_teamActions__["a" /* default */].removeTeamSuccess, this.onRemoveSuccess);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_1_app_actions_teamActions__["a" /* default */].createTeamSuccess, this.onCreateSuccess);
  },
  reset: function reset() {
    this.items = [];
  },
  loadInitialData: function loadInitialData(items) {
    this.initialized = true;
    this.items = items;
    this.trigger(new Set(items.map(function (item) {
      return item.id;
    })));
  },
  onUpdateSuccess: function onUpdateSuccess(itemId, response) {
    if (!response) return;

    var item = this.getBySlug(itemId);

    if (!item) {
      this.items.push(response);
    } else {
      // Slug was changed
      // Note: This is the proper way to handle slug changes but unfortunately not all of our
      // components use stores correctly. To be safe reload browser :((
      if (response.slug !== itemId) {
        // Remove old team
        this.items = this.items.filter(function (_ref) {
          var slug = _ref.slug;
          return slug !== itemId;
        });
        // Add team w/ updated slug
        this.items.push(response);
        this.trigger(new Set([response.slug]));
        return;
      }

      $.extend(true /*deep*/, item, response);
    }

    this.trigger(new Set([itemId]));
  },
  onRemoveSuccess: function onRemoveSuccess(slug) {
    this.loadInitialData(this.items.filter(function (team) {
      return team.slug !== slug;
    }));
  },
  onCreateSuccess: function onCreateSuccess(team) {
    this.loadInitialData([].concat(_toConsumableArray(this.items), [team]));
  },
  getById: function getById(id) {
    return this.items.find(function (item) {
      return item.id.toString() === id.toString();
    }) || null;
  },
  getBySlug: function getBySlug(slug) {
    return this.items.find(function (item) {
      return item.slug === slug;
    }) || null;
  },
  getActive: function getActive() {
    return this.items.filter(function (item) {
      return item.isMember;
    });
  },
  getAll: function getAll() {
    return this.items;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (TeamStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_actions_projectActions__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_actions_environmentActions__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_actionCreators_environments__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_constants__ = __webpack_require__(102);









var DEFAULT_EMPTY_ENV_NAME = '(No Environment)';
var DEFAULT_EMPTY_ROUTING_NAME = 'none';

var EnvironmentStore = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({
  init: function init() {
    this.items = [];
    this.hidden = null;
    this.defaultEnvironment = null;
    this.listenTo(__WEBPACK_IMPORTED_MODULE_3_app_actions_environmentActions__["a" /* default */].loadData, this.loadInitialData);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_3_app_actions_environmentActions__["a" /* default */].loadActiveData, this.loadActiveData);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_3_app_actions_environmentActions__["a" /* default */].loadHiddenData, this.loadHiddenData);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_2_app_actions_projectActions__["a" /* default */].setActive, this.onSetActiveProject);
  },
  loadInitialData: function loadInitialData(items, activeEnvironmentName) {
    this.loadActiveData(items);
    // Update the default environment in the latest context store
    // The active environment will be null (aka All Environments) if the name matches
    // ALL_ENVIRONMENTS_KEY otherwise find the environment matching the name provided
    var activeEnvironment = null;
    if (activeEnvironmentName !== __WEBPACK_IMPORTED_MODULE_5_app_constants__["a" /* ALL_ENVIRONMENTS_KEY */]) {
      activeEnvironment = this.getByName(activeEnvironmentName) || this.getDefault();
    }
    Object(__WEBPACK_IMPORTED_MODULE_4_app_actionCreators_environments__["e" /* setActiveEnvironment */])(activeEnvironment);
  },
  loadHiddenData: function loadHiddenData(items) {
    this.loadData('hidden', items);
  },
  loadActiveData: function loadActiveData(items) {
    this.loadData('items', items);
  },
  loadData: function loadData(key, items) {
    items = items || [];
    this[key] = items.map(function (item) {
      return {
        id: item.id,
        name: item.name,
        get displayName() {
          return Object(__WEBPACK_IMPORTED_MODULE_1_app_utils__["s" /* toTitleCase */])(item.name) || DEFAULT_EMPTY_ENV_NAME;
        },
        get urlRoutingName() {
          return item.name || DEFAULT_EMPTY_ROUTING_NAME;
        }
      };
    });
    this.trigger(this.items);
  },
  getByName: function getByName(name) {
    var envs = this.items;
    return envs.find(function (item) {
      return item.name === name;
    }) || null;
  },
  getActive: function getActive() {
    return this.items;
  },
  getHidden: function getHidden() {
    return this.hidden;
  },
  onSetActiveProject: function onSetActiveProject(project) {
    if (project) {
      this.defaultEnvironment = project.defaultEnvironment || null;
    }
  },


  // Default environment is either the first based on the set of common names
  // or the first in the environment list if none match
  getDefault: function getDefault() {
    var _this = this;

    var allEnvs = this.items;

    var defaultEnv = allEnvs.find(function (e) {
      return e.name === _this.defaultEnvironment;
    });

    return defaultEnv || null;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (EnvironmentStore);

/***/ }),
/* 155 */,
/* 156 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_projectLink__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_utils__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Version = (_temp = _class = function (_React$Component) {
  _inherits(Version, _React$Component);

  function Version() {
    _classCallCheck(this, Version);

    return _possibleConstructorReturn(this, (Version.__proto__ || Object.getPrototypeOf(Version)).apply(this, arguments));
  }

  _createClass(Version, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          orgId = _props.orgId,
          projectId = _props.projectId,
          showShortVersion = _props.showShortVersion,
          version = _props.version;

      var versionTitle = showShortVersion ? Object(__WEBPACK_IMPORTED_MODULE_3_app_utils__["j" /* getShortVersion */])(version) : version;

      if (this.props.anchor) {
        return (
          // NOTE: version is encoded because it can contain slashes "/",
          //       which can interfere with URL construction
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_app_components_projectLink__["a" /* default */],
            {
              to: '/' + orgId + '/' + projectId + '/releases/' + encodeURIComponent(version) + '/'
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { title: version },
              versionTitle
            )
          )
        );
      }
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { title: version },
        versionTitle
      );
    }
  }]);

  return Version;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  anchor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  version: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  orgId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  showShortVersion: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _class.defaultProps = {
  anchor: true,
  showShortVersion: true
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (Version);

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_stores_latestContextStore__ = __webpack_require__(169);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







// Passes the active environment to the wrapped component if the organizations:environments
// feature is active, otherwiss passes null (i.e. the value that means "All environments")

var withEnvironment = function withEnvironment(WrappedComponent) {
  return __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
    displayName: 'withEnvironment',

    mixins: [__WEBPACK_IMPORTED_MODULE_2_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_3_app_stores_latestContextStore__["a" /* default */], 'onLatestContextChange')],

    getInitialState: function getInitialState() {
      var latestContext = __WEBPACK_IMPORTED_MODULE_3_app_stores_latestContextStore__["a" /* default */].getInitialState();

      return {
        environment: latestContext.environment,
        organization: latestContext.organization
      };
    },
    onLatestContextChange: function onLatestContextChange(_ref) {
      var environment = _ref.environment,
          organization = _ref.organization;

      this.setState({ environment: environment, organization: organization });
    },
    render: function render() {
      var features = new Set(this.state.organization ? this.state.organization.features : []);
      var environment = features.has('environments') ? this.state.environment : null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({ environment: environment }, this.props));
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (withEnvironment);

/***/ }),
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  HOVER: 'Hover',
  DISABLED: 'Disabled',
  LOADING: 'Loading',
  READY: 'Ready',
  SAVING: 'Saving',
  ERROR: 'Error'
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_actions_organizationsActions__ = __webpack_require__(242);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var OrganizationsStore = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({
  listenables: [__WEBPACK_IMPORTED_MODULE_1_app_actions_organizationsActions__["a" /* default */]],

  // So we can use Reflux.connect in a component mixin
  getInitialState: function getInitialState() {
    return this.items;
  },
  init: function init() {
    this.items = [];
  },
  onUpdate: function onUpdate(org) {
    this.add(org);
  },
  onChangeSlug: function onChangeSlug(prev, next) {
    if (prev.slug === next.slug) return;

    this.remove(prev.slug);
    this.add(next);
  },
  onRemoveSuccess: function onRemoveSuccess(slug) {
    this.remove(slug);
  },
  get: function get(slug) {
    return this.items.find(function (item) {
      return item.slug === slug;
    });
  },
  getAll: function getAll() {
    return this.items;
  },
  remove: function remove(slug) {
    this.items = this.items.filter(function (item) {
      return slug !== item.slug;
    });
    this.trigger(this.items);
  },
  add: function add(item) {
    var _this = this;

    var match = false;
    this.items.forEach(function (existing, idx) {
      if (existing.id === item.id) {
        item = _extends({}, existing, item);
        _this.items[idx] = item;
        match = true;
      }
    });
    if (!match) {
      this.items.push(item);
    }
    this.trigger(this.items);
  },
  load: function load(items) {
    this.items = items;
    this.trigger(items);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (OrganizationsStore);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_actions_projectActions__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_actions_organizationsActions__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_actions_environmentActions__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_actions_navigationActions__ = __webpack_require__(497);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








// Keeps track of last usable project/org
// this currently won't track when users navigate out of a org/project completely,
// it tracks only if a user switches into a new org/project
//
// Only keep slug so that people don't get the idea to access org/project data here
// Org/project data is currently in organizationsStore/projectsStore
var LatestContextStore = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({
  getInitialState: function getInitialState() {
    return this.state;
  },
  init: function init() {
    this.reset();
    this.listenTo(__WEBPACK_IMPORTED_MODULE_1_app_actions_projectActions__["a" /* default */].setActive, this.onSetActiveProject);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_1_app_actions_projectActions__["a" /* default */].updateSuccess, this.onUpdateProject);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_2_app_actions_organizationsActions__["a" /* default */].setActive, this.onSetActiveOrganization);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_2_app_actions_organizationsActions__["a" /* default */].update, this.onUpdateOrganization);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_3_app_actions_environmentActions__["a" /* default */].setActive, this.onSetActiveEnvironment);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_3_app_actions_environmentActions__["a" /* default */].clearActive, this.onClearActiveEnvironment);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_4_app_actions_navigationActions__["a" /* default */].setLastRoute, this.onSetLastRoute);
  },
  reset: function reset() {
    this.state = {
      project: null,
      lastProject: null,
      organization: null,
      environment: null,
      lastRoute: null
    };
    return this.state;
  },
  onSetLastRoute: function onSetLastRoute(route) {
    this.state = _extends({}, this.state, {
      lastRoute: route
    });

    this.trigger(this.state);
  },
  onUpdateOrganization: function onUpdateOrganization(org) {
    // Don't do anything if base/target orgs are falsey
    if (!this.state.organization) return;
    if (!org) return;
    // Check to make sure current active org is what has been updated
    if (org.slug !== this.state.organization.slug) return;

    this.state = _extends({}, this.state, {
      organization: org
    });
    this.trigger(this.state);
  },
  onSetActiveOrganization: function onSetActiveOrganization(org) {
    if (!org) {
      this.state = _extends({}, this.state, {
        organization: null,
        project: null
      });
    } else if (!this.state.organization || this.state.organization.slug !== org.slug) {
      // Update only if different
      this.state = _extends({}, this.state, {
        organization: org,
        project: null
      });
    }

    this.trigger(this.state);
  },
  onSetActiveProject: function onSetActiveProject(project) {
    if (!project) {
      this.state = _extends({}, this.state, {
        lastProject: this.state.project,
        project: null
      });
    } else if (!this.state.project || this.state.project.slug !== project.slug) {
      // Update only if different
      this.state = _extends({}, this.state, {
        lastProject: this.state.project,
        project: project
      });
    }

    this.trigger(this.state);
  },
  onUpdateProject: function onUpdateProject(project) {
    this.state = _extends({}, this.state, {
      project: project
    });
    this.trigger(this.state);
  },
  onSetActiveEnvironment: function onSetActiveEnvironment(environment) {
    this.state = _extends({}, this.state, {
      environment: environment
    });

    this.trigger(this.state);
  },
  onClearActiveEnvironment: function onClearActiveEnvironment() {
    this.state = _extends({}, this.state, {
      environment: null
    });
    this.trigger(this.state);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (LatestContextStore);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Select2Field; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_forms_inputField__ = __webpack_require__(86);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Select2Field = (_temp2 = _class = function (_InputField) {
  _inherits(Select2Field, _InputField);

  function Select2Field() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Select2Field);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Select2Field.__proto__ || Object.getPrototypeOf(Select2Field)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
      if (_this.props.multiple) {
        var options = e.target.options;
        var value = [];
        for (var i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        _this.setValue(value);
      } else {
        _this.setValue(e.target.value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Select2Field, [{
    key: 'getField',
    value: function getField() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'select',
        {
          id: this.getId(),
          className: 'form-control',
          ref: 'input',
          placeholder: this.props.placeholder,
          onChange: this.onChange.bind(this),
          disabled: this.props.disabled,
          required: this.props.required,
          multiple: this.props.multiple,
          value: this.state.value
        },
        (this.props.choices || []).map(function (choice) {
          return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'option',
            { key: choice[0], value: choice[0] },
            choice[1]
          );
        })
      );
    }
  }, {
    key: 'getSelect2Options',
    value: function getSelect2Options() {
      return {
        allowClear: this.props.allowClear,
        allowEmpty: this.props.allowEmpty,
        width: 'element',
        escapeMarkup: !this.props.escapeMarkup ? function (m) {
          return m;
        } : undefined
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _get(Select2Field.prototype.__proto__ || Object.getPrototypeOf(Select2Field.prototype), 'componentDidMount', this).call(this);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.refs.input).select2(this.getSelect2Options()).on('change', this.onChange);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.refs.select).select2('destroy');
      _get(Select2Field.prototype.__proto__ || Object.getPrototypeOf(Select2Field.prototype), 'componentWillUnmount', this).call(this);
    }
  }]);

  return Select2Field;
}(__WEBPACK_IMPORTED_MODULE_3_app_components_forms_inputField__["a" /* default */]), _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_3_app_components_forms_inputField__["a" /* default */].propTypes, {
  choices: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  allowClear: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  allowEmpty: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  escapeMarkup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}), _class.defaultProps = _extends({}, __WEBPACK_IMPORTED_MODULE_3_app_components_forms_inputField__["a" /* default */].defaultProps, {
  allowClear: false,
  allowEmpty: false,
  placeholder: '--',
  escapeMarkup: true,
  multiple: false
}), _temp2);


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(47);

/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return isArray(value) ? value : [value];
}

module.exports = castArray;


/***/ }),
/* 172 */,
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_errorBoundary__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_events_interfaces_keyValueList__ = __webpack_require__(85);


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ContextBlock = (_temp = _class = function (_React$Component) {
  _inherits(ContextBlock, _React$Component);

  function ContextBlock() {
    _classCallCheck(this, ContextBlock);

    return _possibleConstructorReturn(this, (ContextBlock.__proto__ || Object.getPrototypeOf(ContextBlock)).apply(this, arguments));
  }

  _createClass(ContextBlock, [{
    key: 'render',
    value: function render() {
      var data = [];
      var className = 'context-block context-block-' + this.props.data.type;

      (this.props.knownData || []).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        var allowSkip = false;
        if (key[0] === '?') {
          allowSkip = true;
          key = key.substr(1);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_3_app_utils__["d" /* defined */])(value)) {
          if (allowSkip) {
            return;
          }
          value = 'n/a';
        }
        data.push([key, value]);
      });

      var extraData = [];
      for (var key in this.props.data) {
        if (key !== 'type' && key !== 'title') {
          extraData.push([key, this.props.data[key]]);
        }
      }

      if (extraData.length > 0) {
        data = data.concat(__WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default()(extraData, function (key, value) {
          return key;
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: className },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_app_components_errorBoundary__["default"],
          { mini: true },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_events_interfaces_keyValueList__["a" /* default */], { data: data, isSorted: false })
        )
      );
    }
  }]);

  return ContextBlock;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  knownData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (ContextBlock);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_pick__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_stores_indicatorStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_actions_groupingActions__ = __webpack_require__(209);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }








var api = new __WEBPACK_IMPORTED_MODULE_3_app_api__["Client"]();

// Between 0-100
var MIN_SCORE = 0.6;

// @param score: {[key: string]: number}
var checkBelowThreshold = function checkBelowThreshold(scores) {
  var scoreKeys = scores && Object.keys(scores) || [];
  return !scoreKeys.map(function (key) {
    return scores[key];
  }).find(function (score) {
    return score >= MIN_SCORE;
  });
};

var GroupingStore = __WEBPACK_IMPORTED_MODULE_1_reflux___default.a.createStore({
  listenables: [__WEBPACK_IMPORTED_MODULE_4_app_actions_groupingActions__["a" /* default */]],
  init: function init() {
    var _this = this;

    var state = this.getInitialState();

    Object.entries(state).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      _this[key] = value;
    });
  },
  getInitialState: function getInitialState() {
    return {
      // List of fingerprints that belong to issue
      mergedItems: [],
      // Map of {[fingerprint]: Array<fingerprint, event id>} that is selected to be unmerged
      unmergeList: new Map(),
      // Map of state for each fingerprint (i.e. "collapsed")
      unmergeState: new Map(),
      // Disabled state of "Unmerge" button in "Merged" tab (for Issues)
      unmergeDisabled: true,
      // If "Collapse All" was just used, this will be true
      unmergeLastCollapsed: false,
      // "Compare" button state
      enableFingerprintCompare: false,

      similarItems: [],
      filteredSimilarItems: [],
      similarLinks: '',
      mergeState: new Map(),
      mergeList: new Set(),
      mergedLinks: '',
      mergeDisabled: false,

      loading: true,
      error: false
    };
  },
  setStateForId: function setStateForId(map, idOrIds, newState) {
    var ids = Array.isArray(idOrIds) ? idOrIds : [idOrIds];

    return ids.map(function (id) {
      var state = map.has(id) && map.get(id) || {};
      var mergedState = Object.assign({}, state, newState);
      map.set(id, mergedState);
      return mergedState;
    });
  },
  isAllUnmergedSelected: function isAllUnmergedSelected() {
    var lockedItems = Array.from(this.unmergeState.values()).filter(function (_ref3) {
      var busy = _ref3.busy;
      return busy;
    }) || [];
    return this.unmergeList.size === this.mergedItems.filter(function (_ref4) {
      var latestEvent = _ref4.latestEvent;
      return !!latestEvent;
    }).length - lockedItems.length;
  },


  // Fetches data
  onFetch: function onFetch(toFetchArray) {
    var _this2 = this;

    var requests = toFetchArray || this.toFetchArray;

    // Reset state and trigger update
    this.init();
    this.triggerFetchState();

    var promises = requests.map(function (_ref5) {
      var endpoint = _ref5.endpoint,
          queryParams = _ref5.queryParams,
          dataKey = _ref5.dataKey;

      return new Promise(function (resolve, reject) {
        api.request(endpoint, {
          method: 'GET',
          data: queryParams,
          success: function success(data, _, jqXHR) {
            resolve({
              dataKey: dataKey,
              data: data,
              links: jqXHR.getResponseHeader('Link')
            });
          },
          error: function error(err) {
            var error = err.responseJSON && err.responseJSON.detail || true;
            reject(error);
          }
        });
      });
    });

    var responseProcessors = {
      merged: function merged(item) {
        // Check for locked items
        _this2.setStateForId(_this2.unmergeState, item.id, {
          busy: item.state === 'locked'
        });
        return item;
      },
      similar: function similar(_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
            issue = _ref7[0],
            scoreMap = _ref7[1];

        // Hide items with a low scores
        var isBelowThreshold = checkBelowThreshold(scoreMap);

        // List of scores indexed by interface (i.e., exception and message)
        var scoresByInterface = Object.keys(scoreMap).map(function (scoreKey) {
          return [scoreKey, scoreMap[scoreKey]];
        }).reduce(function (acc, _ref8) {
          var _ref9 = _slicedToArray(_ref8, 2),
              scoreKey = _ref9[0],
              score = _ref9[1];

          // tokenize scorekey, first token is the interface name
          var _scoreKey$split = scoreKey.split(':'),
              _scoreKey$split2 = _slicedToArray(_scoreKey$split, 1),
              interfaceName = _scoreKey$split2[0];

          if (!acc[interfaceName]) {
            acc[interfaceName] = [];
          }
          acc[interfaceName].push([scoreKey, score]);

          return acc;
        }, {});

        // Aggregate score by interface
        var aggregate = Object.keys(scoresByInterface).map(function (interfaceName) {
          return [interfaceName, scoresByInterface[interfaceName]];
        }).reduce(function (acc, _ref10) {
          var _ref11 = _slicedToArray(_ref10, 2),
              interfaceName = _ref11[0],
              allScores = _ref11[1];

          // `null` scores means feature was not present in both issues, do not
          // include in aggregate
          var scores = allScores.filter(function (_ref12) {
            var _ref13 = _slicedToArray(_ref12, 2),
                score = _ref13[1];

            return score !== null;
          });
          var avg = scores.reduce(function (sum, _ref14) {
            var _ref15 = _slicedToArray(_ref14, 2),
                score = _ref15[1];

            return sum + score;
          }, 0) / scores.length;
          acc[interfaceName] = avg;
          return acc;
        }, {});

        return {
          issue: issue,
          score: scoreMap,
          scoresByInterface: scoresByInterface,
          aggregate: aggregate,
          isBelowThreshold: isBelowThreshold
        };
      }
    };

    if (toFetchArray) {
      this.toFetchArray = toFetchArray;
    }

    return Promise.all(promises).then(function (resultsArray) {
      resultsArray.forEach(function (_ref16) {
        var dataKey = _ref16.dataKey,
            data = _ref16.data,
            links = _ref16.links;

        var items = data.map(responseProcessors[dataKey]);
        _this2[dataKey + 'Items'] = items;
        _this2[dataKey + 'Links'] = links;
      });

      _this2.loading = false;
      _this2.error = false;
      _this2.triggerFetchState();
    }, function () {
      _this2.loading = false;
      _this2.error = true;
      _this2.triggerFetchState();
    });
  },


  // Toggle merge checkbox
  onToggleMerge: function onToggleMerge(id) {
    var checked = void 0;

    // Don't do anything if item is busy
    var state = this.mergeState.has(id) && this.mergeState.get(id);
    if (state && state.busy === true) return;

    if (this.mergeList.has(id)) {
      this.mergeList.delete(id);
      checked = false;
    } else {
      this.mergeList.add(id);
      checked = true;
    }

    this.setStateForId(this.mergeState, id, {
      checked: checked
    });

    this.triggerMergeState();
  },


  // Toggle unmerge check box
  onToggleUnmerge: function onToggleUnmerge(_ref17) {
    var _ref18 = _slicedToArray(_ref17, 2),
        fingerprint = _ref18[0],
        eventId = _ref18[1];

    var checked = void 0;

    // Uncheck an item to unmerge
    var state = this.unmergeState.get(fingerprint);

    if (state && state.busy === true) return;

    if (this.unmergeList.has(fingerprint)) {
      this.unmergeList.delete(fingerprint);
      checked = false;
    } else {
      this.unmergeList.set(fingerprint, eventId);
      checked = true;
    }

    // Update "checked" state for row
    this.setStateForId(this.unmergeState, fingerprint, {
      checked: checked
    });

    // Unmerge should be disabled if 0 or all items are selected
    this.unmergeDisabled = this.unmergeList.size === 0 || this.isAllUnmergedSelected();
    this.enableFingerprintCompare = this.unmergeList.size === 2;

    this.triggerUnmergeState();
  },
  onUnmerge: function onUnmerge(_ref19) {
    var _this3 = this;

    var groupId = _ref19.groupId,
        loadingMessage = _ref19.loadingMessage,
        successMessage = _ref19.successMessage,
        errorMessage = _ref19.errorMessage;

    var ids = Array.from(this.unmergeList.keys());

    return new Promise(function (resolve, reject) {
      if (_this3.isAllUnmergedSelected()) {
        reject(new Error('Not allowed to unmerge ALL events'));
        return;
      }

      // Disable unmerge button
      _this3.unmergeDisabled = true;

      // Disable rows
      _this3.setStateForId(_this3.unmergeState, ids, {
        checked: false,
        busy: true
      });
      _this3.triggerUnmergeState();
      var loadingIndicator = __WEBPACK_IMPORTED_MODULE_2_app_stores_indicatorStore__["default"].add(loadingMessage);

      api.request('/issues/' + groupId + '/hashes/', {
        method: 'DELETE',
        query: {
          id: ids
        },
        success: function success(data, _, jqXHR) {
          __WEBPACK_IMPORTED_MODULE_2_app_stores_indicatorStore__["default"].remove(loadingIndicator);
          __WEBPACK_IMPORTED_MODULE_2_app_stores_indicatorStore__["default"].add(successMessage, 'success', {
            duration: 5000
          });
          // Busy rows after successful merge
          _this3.setStateForId(_this3.unmergeState, ids, {
            checked: false,
            busy: true
          });
          _this3.unmergeList.clear();
        },
        error: function error() {
          __WEBPACK_IMPORTED_MODULE_2_app_stores_indicatorStore__["default"].remove(loadingIndicator);
          __WEBPACK_IMPORTED_MODULE_2_app_stores_indicatorStore__["default"].add(errorMessage, 'error');
          _this3.setStateForId(_this3.unmergeState, ids, {
            checked: true,
            busy: false
          });
        },
        complete: function complete() {
          _this3.unmergeDisabled = false;
          resolve(_this3.triggerUnmergeState());
        }
      });
    });
  },
  onMerge: function onMerge(_ref20) {
    var _this4 = this;

    var params = _ref20.params,
        query = _ref20.query;

    var ids = Array.from(this.mergeList.values());

    this.mergeDisabled = true;
    this.setStateForId(this.mergeState, ids, {
      busy: true
    });
    this.triggerMergeState();

    var promise = new Promise(function (resolve, reject) {
      // Disable merge button

      if (params) {
        var orgId = params.orgId,
            groupId = params.groupId,
            projectId = params.projectId;

        api.merge({
          orgId: orgId,
          projectId: projectId,
          itemIds: [].concat(_toConsumableArray(ids), [groupId]),
          query: query
        }, {
          success: function success(data, _, jqXHR) {
            // Hide rows after successful merge
            _this4.setStateForId(_this4.mergeState, ids, {
              checked: false,
              busy: true
            });
            _this4.mergeList.clear();
          },
          error: function error() {
            _this4.setStateForId(_this4.mergeState, ids, {
              checked: true,
              busy: false
            });
          },
          complete: function complete() {
            _this4.mergeDisabled = false;
            resolve(_this4.triggerMergeState());
          }
        });
      } else {
        resolve(null);
      }
    });

    return promise;
  },
  onMergeSuccess: function onMergeSuccess(id, ids, response) {
    if (!response || !response.merge || !response.merge.parent) return;

    this.trigger({
      mergedParent: response.merge.parent
    });
  },


  // Toggle collapsed state of all fingerprints
  onToggleCollapseFingerprints: function onToggleCollapseFingerprints() {
    this.setStateForId(this.unmergeState, this.mergedItems.map(function (_ref21) {
      var id = _ref21.id;
      return id;
    }), {
      collapsed: !this.unmergeLastCollapsed
    });

    this.unmergeLastCollapsed = !this.unmergeLastCollapsed;

    this.trigger({
      unmergeLastCollapsed: this.unmergeLastCollapsed,
      unmergeState: this.unmergeState
    });
  },
  onToggleCollapseFingerprint: function onToggleCollapseFingerprint(fingerprint) {
    var collapsed = this.unmergeState.has(fingerprint) && this.unmergeState.get(fingerprint).collapsed;
    this.setStateForId(this.unmergeState, fingerprint, { collapsed: !collapsed });
    this.trigger({
      unmergeState: this.unmergeState
    });
  },
  triggerFetchState: function triggerFetchState() {
    var state = _extends({
      similarItems: this.similarItems.filter(function (_ref22) {
        var isBelowThreshold = _ref22.isBelowThreshold;
        return !isBelowThreshold;
      }),
      filteredSimilarItems: this.similarItems.filter(function (_ref23) {
        var isBelowThreshold = _ref23.isBelowThreshold;
        return isBelowThreshold;
      })
    }, __WEBPACK_IMPORTED_MODULE_0_lodash_pick___default()(this, ['mergedItems', 'mergedLinks', 'similarLinks', 'mergeState', 'unmergeState', 'loading', 'error']));
    this.trigger(state);
    return state;
  },
  triggerUnmergeState: function triggerUnmergeState() {
    var state = __WEBPACK_IMPORTED_MODULE_0_lodash_pick___default()(this, ['unmergeDisabled', 'unmergeState', 'unmergeList', 'enableFingerprintCompare', 'unmergeLastCollapsed']);
    this.trigger(state);
    return state;
  },
  triggerMergeState: function triggerMergeState() {
    var state = __WEBPACK_IMPORTED_MODULE_0_lodash_pick___default()(this, ['mergeDisabled', 'mergeState', 'mergeList']);
    this.trigger(state);
    return state;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (GroupingStore);

/***/ }),
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_inlineSvg__ = __webpack_require__(24);






var Wrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'eh488yo0'
})('display:flex;align-items:center;flex-direction:column;color:', function (p) {
  return p.theme.gray4;
}, ';padding:', function (p) {
  return p.theme.grid * 3;
}, 'px;font-size:', function (p) {
  return p.theme.large ? p.theme.fontSizeExtraLarge : p.theme.fontSizeLarge;
}, ';font-weight:bold;');

var StyledInlineSvg = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_3_app_components_inlineSvg__["a" /* default */], {
  target: 'eh488yo1'
})('display:block;color:', function (p) {
  return p.theme.gray1;
}, ';width:2em;height:2em;margin-bottom:0.75em;');

var Action = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'eh488yo2'
})('display:block;margin-top:0.75em;');

var EmptyMessage = function EmptyMessage(_ref) {
  var icon = _ref.icon,
      children = _ref.children,
      action = _ref.action,
      size = _ref.size;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Wrapper,
    { size: size },
    icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledInlineSvg, { src: icon }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'ref-message' },
      children
    ),
    action && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Action,
      null,
      action
    )
  );
};

EmptyMessage.propTypes = {
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  action: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['large', 'medium'])
};

/* harmony default export */ __webpack_exports__["a"] = (EmptyMessage);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_each__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_actions_projectActions__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_actions_teamActions__ = __webpack_require__(238);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var ProjectsStore = __WEBPACK_IMPORTED_MODULE_1_reflux___default.a.createStore({
  init: function init() {
    this.reset();
    this.listenTo(__WEBPACK_IMPORTED_MODULE_2_app_actions_projectActions__["a" /* default */].createSuccess, this.onCreateSuccess);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_2_app_actions_projectActions__["a" /* default */].updateSuccess, this.onUpdateSuccess);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_2_app_actions_projectActions__["a" /* default */].loadStatsSuccess, this.onStatsLoadSuccess);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_2_app_actions_projectActions__["a" /* default */].changeSlug, this.onChangeSlug);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_2_app_actions_projectActions__["a" /* default */].addTeamSuccess, this.onAddTeam);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_2_app_actions_projectActions__["a" /* default */].removeTeamSuccess, this.onRemoveTeam);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_3_app_actions_teamActions__["a" /* default */].removeTeamSuccess, this.onDeleteTeam);
  },
  reset: function reset() {
    this.itemsById = {};
  },
  loadInitialData: function loadInitialData(items) {
    this.itemsById = items.reduce(function (map, project) {
      map[project.id] = project;
      return map;
    }, {});
    this.trigger(new Set(Object.keys(this.itemsById)));
  },
  onChangeSlug: function onChangeSlug(prevSlug, newSlug) {
    var prevProject = this.getBySlug(prevSlug);

    // This shouldn't happen
    if (!prevProject) return;

    var newProject = _extends({}, prevProject, {
      slug: newSlug
    });

    this.itemsById = _extends({}, this.itemsById, _defineProperty({}, newProject.id, newProject));

    // Ideally we'd always trigger this.itemsById, but following existing patterns
    // so we don't break things
    this.trigger(new Set([prevProject.id]));
  },
  onCreateSuccess: function onCreateSuccess(project) {
    this.itemsById = _extends({}, this.itemsById, _defineProperty({}, project.id, project));
    this.trigger(new Set([project.id]));
  },
  onUpdateSuccess: function onUpdateSuccess(data) {
    var project = this.getById(data.id);
    var newProject = Object.assign({}, project, data);
    this.itemsById = _extends({}, this.itemsById, _defineProperty({}, project.id, newProject));
    this.trigger(new Set([data.id]));
  },
  onStatsLoadSuccess: function onStatsLoadSuccess(data) {
    var _this = this;

    var touchedIds = [];
    __WEBPACK_IMPORTED_MODULE_0_lodash_each___default()(data || [], function (stats, projectId) {
      if (projectId in _this.itemsById) {
        _this.itemsById[projectId].stats = stats;
        touchedIds.push(projectId);
      }
    });
    this.trigger(new Set(touchedIds));
  },


  /**
   * Listener for when a team is completely removed
   * @param {String} teamSlug Team Slug
   */
  onDeleteTeam: function onDeleteTeam(teamSlug) {
    var _this2 = this;

    // Look for team in all projects
    var projectIds = this.getWithTeam(teamSlug).map(function (projectWithTeam) {
      _this2.removeTeamFromProject(teamSlug, projectWithTeam);
      return projectWithTeam.id;
    });

    this.trigger(new Set([projectIds]));
  },
  onRemoveTeam: function onRemoveTeam(teamSlug, projectSlug) {
    var project = this.getBySlug(projectSlug);
    if (!project) return;

    this.removeTeamFromProject(teamSlug, project);
    this.trigger(new Set([project.id]));
  },
  onAddTeam: function onAddTeam(team, projectSlug) {
    var project = this.getBySlug(projectSlug);

    // Don't do anything if we can't find a project
    if (!project) return;

    this.itemsById = _extends({}, this.itemsById, _defineProperty({}, project.id, _extends({}, project, {
      teams: [].concat(_toConsumableArray(project.teams), [team])
    })));

    this.trigger(new Set([project.id]));
  },


  // Internal method, does not trigger
  removeTeamFromProject: function removeTeamFromProject(teamSlug, project) {
    var newTeams = project.teams.filter(function (_ref) {
      var slug = _ref.slug;
      return slug !== teamSlug;
    });

    this.itemsById = _extends({}, this.itemsById, _defineProperty({}, project.id, _extends({}, project, {
      teams: newTeams
    })));
  },


  /**
   * Returns a list of projects that has the specified team
   *
   * @param {String} teamSlug Slug of team to find in projects
   */
  getWithTeam: function getWithTeam(teamSlug) {
    return this.getAll().filter(function (_ref2) {
      var teams = _ref2.teams;
      return teams.find(function (_ref3) {
        var slug = _ref3.slug;
        return slug === teamSlug;
      });
    });
  },
  getAll: function getAll() {
    return Object.values(this.itemsById).sort(function (a, b) {
      if (a.slug > b.slug) return 1;
      if (a.slug < b.slug) return -1;
      return 0;
    });
  },
  getAllGroupedByOrganization: function getAllGroupedByOrganization() {
    return this.getAll().reduce(function (acc, project) {
      var orgSlug = project.organization.slug;
      if (acc[orgSlug]) {
        acc[orgSlug].projects.push(project);
      } else {
        acc[orgSlug] = {
          organization: project.organization,
          projects: [project]
        };
      }
      return acc;
    }, {});
  },
  getById: function getById(id) {
    return this.getAll().find(function (project) {
      return project.id === id;
    });
  },
  getBySlug: function getBySlug(slug) {
    return this.getAll().find(function (project) {
      return project.slug === slug;
    });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ProjectsStore);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["i"] = update;
/* harmony export (immutable) */ __webpack_exports__["c"] = loadStats;
/* harmony export (immutable) */ __webpack_exports__["d"] = loadStatsForProject;
/* harmony export (immutable) */ __webpack_exports__["g"] = setActiveProject;
/* harmony export (immutable) */ __webpack_exports__["e"] = removeProject;
/* harmony export (immutable) */ __webpack_exports__["h"] = transferProject;
/* harmony export (immutable) */ __webpack_exports__["a"] = addTeamToProject;
/* harmony export (immutable) */ __webpack_exports__["f"] = removeTeamFromProject;
/* harmony export (immutable) */ __webpack_exports__["b"] = changeProjectSlug;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_actionCreators_indicator__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_actions_projectActions__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_stores_projectsStatsStore__ = __webpack_require__(318);









function update(api, params) {
  __WEBPACK_IMPORTED_MODULE_3_app_actions_projectActions__["a" /* default */].update(params.projectId, params.data);

  var endpoint = '/projects/' + params.orgId + '/' + params.projectId + '/';
  return api.requestPromise(endpoint, {
    method: 'PUT',
    data: params.data
  }).then(function (data) {
    __WEBPACK_IMPORTED_MODULE_3_app_actions_projectActions__["a" /* default */].updateSuccess(data);
    return data;
  }, function (err) {
    __WEBPACK_IMPORTED_MODULE_3_app_actions_projectActions__["a" /* default */].updateError(err, params.projectId);
    throw err;
  });
}

function loadStats(api, params) {
  __WEBPACK_IMPORTED_MODULE_3_app_actions_projectActions__["a" /* default */].loadStats(params.orgId, params.data);

  var endpoint = '/organizations/' + params.orgId + '/stats/';
  api.request(endpoint, {
    query: params.query,
    success: function success(data) {
      __WEBPACK_IMPORTED_MODULE_3_app_actions_projectActions__["a" /* default */].loadStatsSuccess(data);
    },
    error: function error(data) {
      __WEBPACK_IMPORTED_MODULE_3_app_actions_projectActions__["a" /* default */].loadStatsError(data);
    }
  });
}

// This is going to queue up a list of project ids we need to fetch stats for
// Will be cleared when debounced function fires
var _projectStatsToFetch = new Set();

var _debouncedLoadStats = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function (api, projectSet, params) {
  var existingProjectStats = Object.values(__WEBPACK_IMPORTED_MODULE_4_app_stores_projectsStatsStore__["a" /* default */].getAll()).map(function (_ref) {
    var id = _ref.id;
    return id;
  });
  var projects = Array.from(projectSet).filter(function (project) {
    return !existingProjectStats.includes(project);
  });

  if (!projects.length) {
    _projectStatsToFetch.clear();
    return;
  }

  var idQueryParams = projects.map(function (project) {
    return 'id:' + project;
  }).join(' ');
  var endpoint = '/organizations/' + params.orgId + '/projects/';

  api.request(endpoint, {
    query: {
      statsPeriod: '24h',
      query: idQueryParams
    },
    success: function success(data) {
      __WEBPACK_IMPORTED_MODULE_3_app_actions_projectActions__["a" /* default */].loadStatsForProjectSuccess(data);
    },
    error: function error(data) {}
  });

  // Reset projects list
  _projectStatsToFetch.clear();
}, 50);

function loadStatsForProject(api, project, params) {
  // Queue up a list of projects that we need stats for
  // and call a debounced function to fetch stats for list of projects
  _projectStatsToFetch.add(project);
  _debouncedLoadStats(api, _projectStatsToFetch, params);
}

function setActiveProject(project) {
  __WEBPACK_IMPORTED_MODULE_3_app_actions_projectActions__["a" /* default */].setActive(project);
}

function removeProject(api, orgId, project) {
  var endpoint = '/projects/' + orgId + '/' + project.slug + '/';

  __WEBPACK_IMPORTED_MODULE_3_app_actions_projectActions__["a" /* default */].removeProject(project);
  return api.requestPromise(endpoint, {
    method: 'DELETE'
  }).then(function () {
    __WEBPACK_IMPORTED_MODULE_3_app_actions_projectActions__["a" /* default */].removeProjectSuccess(project);
    Object(__WEBPACK_IMPORTED_MODULE_1_app_actionCreators_indicator__["d" /* addSuccessMessage */])(Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["tct"])('[project] was successfully removed', { project: project.slug }));
  }, function (err) {
    __WEBPACK_IMPORTED_MODULE_3_app_actions_projectActions__["a" /* default */].removeProjectError(project);
    Object(__WEBPACK_IMPORTED_MODULE_1_app_actionCreators_indicator__["a" /* addErrorMessage */])(Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["tct"])('Error removing [project]', { project: project.slug }));
    throw err;
  });
}

function transferProject(api, orgId, project, email) {
  var endpoint = '/projects/' + orgId + '/' + project.slug + '/transfer/';

  return api.requestPromise(endpoint, {
    method: 'POST',
    data: {
      email: email
    }
  }).then(function () {
    Object(__WEBPACK_IMPORTED_MODULE_1_app_actionCreators_indicator__["d" /* addSuccessMessage */])(Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["tct"])('A request was sent to move [project] to a different organization', {
      project: project.slug
    }));
  }, function (err) {
    Object(__WEBPACK_IMPORTED_MODULE_1_app_actionCreators_indicator__["a" /* addErrorMessage */])(Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["tct"])('Error transferring [project]', { project: project.slug }));
    throw err;
  });
}

/**
 * Associate a team with a project
 */

/**
 *  Adds a team to a project
 *
 * @param {Client} api API Client
 * @param {String} orgSlug Organization Slug
 * @param {String} projectSlug Project Slug
 * @param {String} team Team data object
 */
function addTeamToProject(api, orgSlug, projectSlug, team) {
  var endpoint = '/projects/' + orgSlug + '/' + projectSlug + '/teams/' + team.slug + '/';

  Object(__WEBPACK_IMPORTED_MODULE_1_app_actionCreators_indicator__["b" /* addLoadingMessage */])();
  __WEBPACK_IMPORTED_MODULE_3_app_actions_projectActions__["a" /* default */].addTeam(team);

  return api.requestPromise(endpoint, {
    method: 'POST'
  }).then(function (project) {
    Object(__WEBPACK_IMPORTED_MODULE_1_app_actionCreators_indicator__["d" /* addSuccessMessage */])(Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["tct"])('[team] has been added to the [project] project', {
      team: '#' + team.slug,
      project: projectSlug
    }));
    __WEBPACK_IMPORTED_MODULE_3_app_actions_projectActions__["a" /* default */].addTeamSuccess(team, projectSlug);
    __WEBPACK_IMPORTED_MODULE_3_app_actions_projectActions__["a" /* default */].updateSuccess(project);
  }, function (err) {
    Object(__WEBPACK_IMPORTED_MODULE_1_app_actionCreators_indicator__["a" /* addErrorMessage */])(Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["tct"])('Unable to add [team] to the [project] project', {
      team: '#' + team.slug,
      project: projectSlug
    }));
    __WEBPACK_IMPORTED_MODULE_3_app_actions_projectActions__["a" /* default */].addTeamError();
    throw err;
  });
}

/**
 *  Removes a team from a project
 *
 * @param {Client} api API Client
 * @param {String} orgSlug Organization Slug
 * @param {String} projectSlug Project Slug
 * @param {String} teamSlug Team Slug
 */
function removeTeamFromProject(api, orgSlug, projectSlug, teamSlug) {
  var endpoint = '/projects/' + orgSlug + '/' + projectSlug + '/teams/' + teamSlug + '/';

  Object(__WEBPACK_IMPORTED_MODULE_1_app_actionCreators_indicator__["b" /* addLoadingMessage */])();
  __WEBPACK_IMPORTED_MODULE_3_app_actions_projectActions__["a" /* default */].removeTeam(teamSlug);

  return api.requestPromise(endpoint, {
    method: 'DELETE'
  }).then(function (project) {
    Object(__WEBPACK_IMPORTED_MODULE_1_app_actionCreators_indicator__["d" /* addSuccessMessage */])(Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["tct"])('[team] has been removed from the [project] project', {
      team: '#' + teamSlug,
      project: projectSlug
    }));
    __WEBPACK_IMPORTED_MODULE_3_app_actions_projectActions__["a" /* default */].removeTeamSuccess(teamSlug, projectSlug);
    __WEBPACK_IMPORTED_MODULE_3_app_actions_projectActions__["a" /* default */].updateSuccess(project);
  }, function (err) {
    Object(__WEBPACK_IMPORTED_MODULE_1_app_actionCreators_indicator__["a" /* addErrorMessage */])(Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["tct"])('Unable to remove [team] from the [project] project', {
      team: '#' + teamSlug,
      project: projectSlug
    }));
    __WEBPACK_IMPORTED_MODULE_3_app_actions_projectActions__["a" /* default */].removeTeamError(err);
    throw err;
  });
}

/**
 * Change a project's slug
 * @param {String} prev Previous slug
 * @param {String} next New slug
 */
function changeProjectSlug(prev, next) {
  __WEBPACK_IMPORTED_MODULE_3_app_actions_projectActions__["a" /* default */].changeSlug(prev, next);
}

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n");

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Raven) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_views_permissionDenied__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_views_routeError__ = __webpack_require__(323);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var AsyncComponent = (_temp = _class = function (_React$Component) {
  _inherits(AsyncComponent, _React$Component);

  function AsyncComponent(props, context) {
    _classCallCheck(this, AsyncComponent);

    var _this = _possibleConstructorReturn(this, (AsyncComponent.__proto__ || Object.getPrototypeOf(AsyncComponent)).call(this, props, context));

    _this.remountComponent = function () {
      _this.setState(_this.getDefaultState(), _this.fetchData);
    };

    _this.fetchData = function () {
      var endpoints = _this.getEndpoints();

      if (!endpoints.length) {
        _this.setState({
          loading: false,
          error: false
        });
        return;
      }

      // TODO(dcramer): this should cancel any existing API requests
      _this.setState({
        loading: true,
        error: false,
        remainingRequests: endpoints.length
      });

      endpoints.forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 4),
            stateKey = _ref2[0],
            endpoint = _ref2[1],
            params = _ref2[2],
            options = _ref2[3];

        options = options || {};
        var locationQuery = _this.props.location && _this.props.location.query || {};
        var query = params && params.query || {};
        // If paginate option then pass entire `query` object to API call
        // It should only be expecting `query.cursor` for pagination
        if (options.paginate || locationQuery.cursor) {
          query = _extends({}, locationQuery, query);
        }

        _this.api.request(endpoint, _extends({
          method: 'GET'
        }, params, {
          query: query,
          success: function success(data, _, jqXHR) {
            _this.handleRequestSuccess({ stateKey: stateKey, data: data, jqXHR: jqXHR }, true);
          },
          error: function error(_error) {
            // Allow endpoints to fail
            if (options.allowError && options.allowError(_error)) {
              _error = null;
            }

            _this.handleError(_error, [stateKey, endpoint, params, options]);
          }
        }));
      });
    };

    _this.handleRequestSuccess = function (_ref3, initialRequest) {
      var stateKey = _ref3.stateKey,
          data = _ref3.data,
          jqXHR = _ref3.jqXHR;

      _this.setState(function (prevState) {
        var _state;

        var state = (_state = {}, _defineProperty(_state, stateKey, data), _defineProperty(_state, stateKey + 'PageLinks', jqXHR && jqXHR.getResponseHeader('Link')), _state);

        if (initialRequest) {
          state.remainingRequests = prevState.remainingRequests - 1;
          state.loading = prevState.remainingRequests > 1;
        }

        return state;
      });
    };

    _this.fetchData = AsyncComponent.errorHandler(_this, _this.fetchData.bind(_this));
    _this.render = AsyncComponent.errorHandler(_this, _this.render.bind(_this));

    _this.state = _this.getDefaultState();
    return _this;
  }

  _createClass(AsyncComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.api = new __WEBPACK_IMPORTED_MODULE_3_app_api__["Client"]();
      this.fetchData();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps, nextContext) {
      var isRouterInContext = !!this.context.router;
      var isLocationInProps = nextProps.location !== undefined;

      var currentLocation = isLocationInProps ? this.props.location : isRouterInContext ? this.context.router.location : null;
      var nextLocation = isLocationInProps ? nextProps.location : isRouterInContext ? nextContext.router.location : null;

      // re-fetch data when router params change
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(this.props.params, nextProps.params) || currentLocation.search !== nextLocation.search || currentLocation.state !== nextLocation.state) {
        this.remountComponent();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.api.clear();
    }

    // XXX: cant call this getInitialState as React whines

  }, {
    key: 'getDefaultState',
    value: function getDefaultState() {
      var endpoints = this.getEndpoints();
      var state = {
        // has all data finished requesting?
        loading: true,
        // is there an error loading ANY data?
        error: false,
        errors: {}
      };
      endpoints.forEach(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            stateKey = _ref5[0],
            endpoint = _ref5[1];

        state[stateKey] = null;
      });
      return state;
    }
  }, {
    key: 'handleError',
    value: function handleError(error, _ref6) {
      var _ref7 = _slicedToArray(_ref6, 1),
          stateKey = _ref7[0];

      if (error && error.responseText) {
        Raven.captureBreadcrumb({
          message: error.responseText,
          category: 'xhr',
          level: 'error'
        });
      }
      this.setState(function (prevState) {
        var _ref8;

        return _ref8 = {}, _defineProperty(_ref8, stateKey, null), _defineProperty(_ref8, 'errors', _extends({}, prevState.errors, _defineProperty({}, stateKey, error))), _defineProperty(_ref8, 'remainingRequests', prevState.remainingRequests - 1), _defineProperty(_ref8, 'loading', prevState.remainingRequests > 1), _defineProperty(_ref8, 'error', prevState.error || !!error), _ref8;
      });
    }

    // DEPRECATED: use getEndpoints()

  }, {
    key: 'getEndpointParams',
    value: function getEndpointParams() {
      // eslint-disable-next-line no-console
      console.warn('getEndpointParams is deprecated');
      return {};
    }

    // DEPRECATED: use getEndpoints()

  }, {
    key: 'getEndpoint',
    value: function getEndpoint() {
      // eslint-disable-next-line no-console
      console.warn('getEndpoint is deprecated');
      return null;
    }

    /**
     * Return a list of endpoint queries to make.
     *
     * return [
     *   ['stateKeyName', '/endpoint/', {optional: 'query params'}]
     * ]
     */

  }, {
    key: 'getEndpoints',
    value: function getEndpoints() {
      var endpoint = this.getEndpoint();
      if (!endpoint) return [];
      return [['data', endpoint, this.getEndpointParams()]];
    }
  }, {
    key: 'renderLoading',
    value: function renderLoading() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_loadingIndicator__["default"], null);
    }
  }, {
    key: 'renderError',
    value: function renderError(error) {
      var _this2 = this;

      var unauthorizedErrors = Object.keys(this.state.errors).find(function (endpointName) {
        var result = _this2.state.errors[endpointName];
        // 401s are captured by SudaModal, but may be passed back to AsyncComponent if they close the modal without identifying
        return result && result.status === 401;
      });

      // Look through endpoint results to see if we had any 403s, means their role can not access resource
      var permissionErrors = Object.keys(this.state.errors).find(function (endpointName) {
        var result = _this2.state.errors[endpointName];
        return result && result.status === 403;
      });

      if (unauthorizedErrors) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_loadingError__["default"], { message: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('You are not authorized to access this resource.') });
      }

      if (permissionErrors) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_views_permissionDenied__["a" /* default */], null);
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_views_routeError__["a" /* default */], { error: error, component: this, onRetry: this.remountComponent });
    }
  }, {
    key: 'renderComponent',
    value: function renderComponent() {
      return this.state.loading ? this.renderLoading() : this.state.error ? this.renderError(new Error('Unable to load all required endpoints')) : this.renderBody();
    }
  }, {
    key: 'render',
    value: function render() {
      return this.renderComponent();
    }
  }]);

  return AsyncComponent;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
}, _class.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
}, _temp);


AsyncComponent.errorHandler = function (component, fn) {
  return function () {
    try {
      return fn.apply(undefined, arguments);
    } catch (err) {
      /*eslint no-console:0*/
      console.error(err);
      setTimeout(function () {
        throw err;
      });
      component.setState({
        error: err
      });
      return null;
    }
  };
};

/* harmony default export */ __webpack_exports__["default"] = (AsyncComponent);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(40)))

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_confirm__ = __webpack_require__(119);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * <Confirm> is a more generic version of this component
 */
var LinkWithConfirmation = (_temp = _class = function (_React$PureComponent) {
  _inherits(LinkWithConfirmation, _React$PureComponent);

  function LinkWithConfirmation() {
    var _ref;

    _classCallCheck(this, LinkWithConfirmation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = LinkWithConfirmation.__proto__ || Object.getPrototypeOf(LinkWithConfirmation)).call.apply(_ref, [this].concat(args)));

    _this.state = {
      isModalOpen: false
    };
    return _this;
  }

  _createClass(LinkWithConfirmation, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          disabled = _props.disabled,
          title = _props.title,
          children = _props.children,
          otherProps = _objectWithoutProperties(_props, ['className', 'disabled', 'title', 'children']);

      if (this.props.disabled) {
        className += ' disabled';
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_app_components_confirm__["a" /* default */],
        _extends({}, otherProps, { disabled: disabled }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          {
            className: className,
            disabled: disabled,
            onClick: this.onToggle,
            title: title
          },
          children
        )
      );
    }
  }]);

  return LinkWithConfirmation;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent), _class.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (LinkWithConfirmation);

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

 // eslint-disable-line strict

/**
 * Traverses properties on objects and arrays. If an intermediate property is
 * either null or undefined, it is instead returned. The purpose of this method
 * is to simplify extracting properties from a chain of maybe-typed properties.
 *
 * === EXAMPLE ===
 *
 * Consider the following type:
 *
 *   const props: {
 *     user: ?{
 *       name: string,
 *       friends: ?Array<User>,
 *     }
 *   };
 *
 * Getting to the friends of my first friend would resemble:
 *
 *   props.user &&
 *   props.user.friends &&
 *   props.user.friends[0] &&
 *   props.user.friends[0].friends
 *
 * Instead, `idx` allows us to safely write:
 *
 *   idx(props, _ => _.user.friends[0].friends)
 *
 * The second argument must be a function that returns one or more nested member
 * expressions. Any other expression has undefined behavior.
 *
 * === NOTE ===
 *
 * The code below exists for the purpose of illustrating expected behavior and
 * is not meant to be executed. The `idx` function is used in conjunction with a
 * Babel transform that replaces it with better performing code:
 *
 *   props.user == null ? props.user :
 *   props.user.friends == null ? props.user.friends :
 *   props.user.friends[0] == null ? props.user.friends[0] :
 *   props.user.friends[0].friends
 *
 * All this machinery exists due to the fact that an existential operator does
 * not currently exist in JavaScript.
 */

function idx(input, accessor) {
  try {
    return accessor(input);
  } catch (error) {
    if (error instanceof TypeError) {
      if (isNullPropertyAccessError(error)) {
        return null;
      } else if (isUndefinedPropertyAccessError(error)) {
        return undefined;
      }
    }
    throw error;
  }
}

var nullPattern = void 0;
function isNullPropertyAccessError(_ref) {
  var message = _ref.message;

  if (!nullPattern) {
    nullPattern = getInvalidPropertyAccessErrorPattern(null);
  }
  return nullPattern.test(message);
}

var undefinedPattern = void 0;
function isUndefinedPropertyAccessError(_ref2) {
  var message = _ref2.message;

  if (!undefinedPattern) {
    undefinedPattern = getInvalidPropertyAccessErrorPattern(undefined);
  }
  return undefinedPattern.test(message);
}

/**
 * Use `new Function(...)` to avoid minifying "$object$" and "$property$".
 */
// eslint-disable-next-line no-new-func, flowtype/no-weak-types
var getInvalidPropertyAccessErrorPattern = new Function('$object$', '\n  try {\n    $object$.$property$;\n  } catch (error) {\n    return new RegExp(\n      error.message\n        .replace(/[-\\[\\]\\/\\{\\}\\(\\)\\*\\+\\?\\.\\\\\\^\\$\\|]/g, \'\\\\$&\')\n        .replace(\'\\\\$object\\\\$\', \'.+\')\n        .replace(\'\\\\$property\\\\$\', \'.+\')\n    );\n  }\n  throw new Error(\'Expected property access on \' + $object$ + \' to throw.\');\n');

module.exports = idx;


/***/ }),
/* 185 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ClippedBox = (_temp = _class = function (_React$Component) {
  _inherits(ClippedBox, _React$Component);

  function ClippedBox() {
    var _ref;

    _classCallCheck(this, ClippedBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = ClippedBox.__proto__ || Object.getPrototypeOf(ClippedBox)).call.apply(_ref, [this].concat(args)));

    _this.reveal = function (e) {
      e.stopPropagation();

      _this.setState({
        clipped: false,
        revealed: true
      });
    };

    _this.state = {
      clipped: _this.props.defaultClipped,
      revealed: false // True once user has clicked "Show More" button
    };
    return _this;
  }

  _createClass(ClippedBox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var renderedHeight = __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(this).offsetHeight;

      if (!this.state.clipped && renderedHeight > this.props.clipHeight) {
        /*eslint react/no-did-mount-set-state:0*/
        // okay if this causes re-render; cannot determine until
        // rendered first anyways
        this.setState({
          clipped: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var className = 'box-clippable';
      if (this.state.clipped) {
        className += ' clipped';
      }
      if (this.state.revealed) {
        className += ' revealed';
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          className: className,
          style: { maxHeight: this.state.clipped ? this.props.clipHeight : null }
        },
        this.props.title && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h5',
          null,
          this.props.title
        ),
        this.props.children,
        this.state.clipped && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'clip-fade' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            { onClick: this.reveal, className: this.props.btnClassName },
            this.props.btnText
          )
        )
      );
    }
  }]);

  return ClippedBox;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  defaultClipped: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  clipHeight: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  btnClassName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  btnText: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, _class.defaultProps = {
  defaultClipped: false,
  clipHeight: 200,
  renderedHeight: null,
  btnClassName: 'btn btn-primary btn-xs show-more',
  btnText: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Show More')
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (ClippedBox);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils_selectText__ = __webpack_require__(390);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var AutoSelectText = (_temp2 = _class = function (_React$Component) {
  _inherits(AutoSelectText, _React$Component);

  function AutoSelectText() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AutoSelectText);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AutoSelectText.__proto__ || Object.getPrototypeOf(AutoSelectText)).call.apply(_ref, [this].concat(args))), _this), _this.selectText = function () {
      if (!_this.el) return;

      Object(__WEBPACK_IMPORTED_MODULE_2_app_utils_selectText__["a" /* selectText */])(_this.el);
    }, _this.handleMount = function (el) {
      _this.el = el;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AutoSelectText, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['children']);

      if (typeof children === 'function') {
        return children({
          doMount: this.handleMount,
          doSelect: this.selectText
        });
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({}, props, {
          ref: this.handleMount,
          onClick: this.selectText,
          className: 'auto-select-text'
        }),
        children
      );
    }
  }]);

  return AutoSelectText;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  /**
   * Can be a `node` for a simple auto select div container.
   * When children is a render function, it is passed 2 functions:
   * - `doMount` - should be applied on parent element's `ref`
   *   (or `innerRef` for styled components) whose children is the
   *   text to be copied
   * - `doSelect` - selects text
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (AutoSelectText);

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["logException"] = logException;
/* harmony export (immutable) */ __webpack_exports__["logAjaxError"] = logAjaxError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raven_js__);


function logException(ex, context) {
  __WEBPACK_IMPORTED_MODULE_0_raven_js___default.a.captureException(ex, {
    extra: context
  });
  /*eslint no-console:0*/
  window.console && console.error && console.error(ex);
}

function logAjaxError(error, context) {
  var errorString = error.responseJSON ? error.responseJSON.detail || JSON.stringify(error.responseJSON, null, 2) : error.responseText ? error.responseText.substr(0, 255) : '<unknown response>'; // occassionally responseText is undefined

  var message = 'HTTP ' + error.status + ': ' + errorString;
  __WEBPACK_IMPORTED_MODULE_0_raven_js___default.a.captureMessage(message, {
    extra: context
  });
  /*eslint no-console:0*/
  window.console && console.error && console.error(message);
}

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils_getDynamicText__ = __webpack_require__(603);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* global process */
// eslint-disable-next-line no-unused-vars





// XXX: Most likely you can just use getDynamicText instead
var DynamicWrapper = function DynamicWrapper(_ref) {
  var fixed = _ref.fixed,
      value = _ref.value,
      otherProps = _objectWithoutProperties(_ref, ['fixed', 'value']);

  // Wrap with span b/c react
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'span',
    otherProps,
    Object(__WEBPACK_IMPORTED_MODULE_2_app_utils_getDynamicText__["a" /* default */])({ value: value, fixed: fixed })
  );
};

DynamicWrapper.propTypes = {
  /**
   * Value to display when `process.env.IS_PERCY` is truthy
   */
  fixed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node.isRequired,
  /**
   * Actual value to use when not in a test environment
   */
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node.isRequired
};

/* harmony default export */ __webpack_exports__["default"] = (DynamicWrapper);

/***/ }),
/* 193 */,
/* 194 */,
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.0.4
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
(function (factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		module.exports = factory();
	} else {
		var _OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = _OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				value = encodeURIComponent(String(value));
				value = value.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				return (document.cookie = [
					key, '=', value,
					attributes.expires && '; expires=' + attributes.expires.toUTCString(), // use expires attribute, max-age is not supported by IE
					attributes.path    && '; path=' + attributes.path,
					attributes.domain  && '; domain=' + attributes.domain,
					attributes.secure ? '; secure' : ''
				].join(''));
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var name = parts[0].replace(rdecode, decodeURIComponent);
				var cookie = parts.slice(1).join('=');

				if (cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					cookie = converter && converter(cookie, name) || cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.get = api.set = api;
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init();
}));


/***/ }),
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(185),
    baseIteratee = __webpack_require__(123),
    baseMap = __webpack_require__(486),
    isArray = __webpack_require__(47);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);


// TODO(dcramer): we should probably just make every parameter update
// work on bulk groups
var GroupActions = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['assignTo', 'assignToError', 'assignToSuccess', 'delete', 'deleteError', 'deleteSuccess', 'discard', 'discardError', 'discardSuccess', 'update', 'updateError', 'updateSuccess', 'merge', 'mergeError', 'mergeSuccess']);

/* harmony default export */ __webpack_exports__["a"] = (GroupActions);

/***/ }),
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_less_components_flowLayout_less__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_less_components_flowLayout_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_app_less_components_flowLayout_less__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// Simple horizontal layout with vertical centering
// Takes up remaining space of a flexbox container (i.e. "flex: 1")
var FlowLayout = (_temp = _class = function (_React$Component) {
  _inherits(FlowLayout, _React$Component);

  function FlowLayout() {
    _classCallCheck(this, FlowLayout);

    return _possibleConstructorReturn(this, (FlowLayout.__proto__ || Object.getPrototypeOf(FlowLayout)).apply(this, arguments));
  }

  _createClass(FlowLayout, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          truncate = _props.truncate,
          vertical = _props.vertical,
          center = _props.center,
          otherProps = _objectWithoutProperties(_props, ['className', 'children', 'truncate', 'vertical', 'center']);

      var cx = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('flow-layout', className, {
        'is-vertical': vertical,
        'is-center': center,
        'is-truncated': truncate
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        _extends({ className: cx }, otherProps),
        children
      );
    }
  }]);

  return FlowLayout;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  /** Centers content via `justify-content` */
  center: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  /** Changes flex direction to be column */
  vertical: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  /** Applies "overflow: hidden" to container so that children can be truncated */
  truncate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _class.defaultProps = {
  truncate: true
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (FlowLayout);

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * A modified link used for navigating between project pages that
 * will keep the environment in the querystring when navigating if it's present
 *
 * Falls back to <a> if there is no router present.
 */
var ProjectLink = (_temp = _class = function (_React$Component) {
  _inherits(ProjectLink, _React$Component);

  function ProjectLink() {
    _classCallCheck(this, ProjectLink);

    return _possibleConstructorReturn(this, (ProjectLink.__proto__ || Object.getPrototypeOf(ProjectLink)).apply(this, arguments));
  }

  _createClass(ProjectLink, [{
    key: 'render',
    value: function render() {
      var location = this.context.location;


      if (location) {
        var hasEnvironment = 'environment' in location.query;

        var to = this.props.to;


        if (hasEnvironment) {
          if (typeof to === 'string') {
            to = { pathname: to, query: { environment: location.query.environment } };
          } else {
            to.query = _extends({}, to.query, { environment: location.query.environment });
          }
        }

        var routerProps = to ? _extends({}, this.props, { to: to }) : _extends({}, this.props);

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
          routerProps,
          this.props.children
        );
      } else {
        var _props = this.props,
            _to = _props.to,
            props = _objectWithoutProperties(_props, ['to']);

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          _extends({}, props, { href: _to }),
          this.props.children
        );
      }
    }
  }]);

  return ProjectLink;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object]).isRequired
}, _class.contextTypes = {
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (ProjectLink);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Checkbox = (_temp = _class = function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  function Checkbox() {
    _classCallCheck(this, Checkbox);

    return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
  }

  _createClass(Checkbox, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          otherProps = _objectWithoutProperties(_props, ['className']);

      var cx = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('chk-select', className);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({ type: 'checkbox', className: cx }, otherProps));
    }
  }]);

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.defaultProps = {
  checked: false
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (Checkbox);

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);


// Actions for "Grouping" view - for merging/unmerging events/issues
var GroupingActions = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['fetch', 'showAllSimilarItems', 'toggleUnmerge', 'toggleMerge', 'unmerge', 'merge', 'toggleCollapseFingerprint', 'toggleCollapseFingerprints']);
/* harmony default export */ __webpack_exports__["a"] = (GroupingActions);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_projectLabel__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_dropdownLink__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_menuItem__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_locale__ = __webpack_require__(2);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

















var ProjectSelector = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'ProjectSelector',

  propTypes: {
    // Accepts a project id (slug) and not a project *object* because ProjectSelector
    // is created from Django templates, and only organization is serialized
    projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    organization: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
  },

  contextTypes: {
    location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__["default"]],

  getDefaultProps: function getDefaultProps() {
    return {
      projectId: null
    };
  },
  getInitialState: function getInitialState() {
    return _extends({
      isOpen: false,
      filter: '',
      currentIndex: -1
    }, this.getProjectState({ filter: '' }));
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this.filterBlurTimeout) {
      clearTimeout(this.filterBlurTimeout);
    }
  },
  urlPrefix: function urlPrefix() {
    var org = this.props.organization;
    return '/organizations/' + org.slug;
  },


  /**
   * Returns an object with the target project url. If
   * the router is present, passed as the 'to' property.
   * If not, passed as an absolute URL via the 'href' property.
   */
  getProjectUrlProps: function getProjectUrlProps(project) {
    var org = this.props.organization;
    var path = '/' + org.slug + '/' + project.slug + '/';

    if (this.context.location) {
      return { to: path };
    } else {
      return { href: path };
    }
  },
  getProjectState: function getProjectState(state) {
    var _this = this;

    state = state || this.state;
    var org = this.props.organization;
    var features = new Set(org.features);
    var filter = state.filter.toLowerCase();
    var projectList = [];

    var activeTeam = void 0;
    var activeProject = void 0;

    org.projects.forEach(function (project) {
      // TODO(jess): stop relying on this soon
      var team = project.team;
      if (!project.isMember) {
        return;
      }
      if (project.slug === _this.props.projectId) {
        activeProject = project;
        activeTeam = project.team;
      }

      var fullName = void 0;
      if (features.has('new-teams')) {
        fullName = [project.name, project.slug];
      } else {
        fullName = [team.name, project.name, team.slug, project.slug];
      }
      fullName = fullName.join(' ').toLowerCase();

      if (filter && fullName.indexOf(filter) === -1) {
        return;
      }
      projectList.push([team, project]);
    });
    return {
      projectList: projectList,
      activeTeam: activeTeam,
      activeProject: activeProject
    };
  },
  onFilterBlur: function onFilterBlur() {
    var _this2 = this;

    // HACK: setTimeout because blur might be caused by clicking
    // project link; in which case, will close dropdown before
    // link click is processed. Why 200ms? Decently short time
    // period that seemed to work in all browsers.
    this.filterBlurTimeout = setTimeout(function () {
      _this2.filterBlurTimeout = null;
      _this2.onClose();
    }, 200);
  },
  onFilterChange: function onFilterChange(evt) {
    this.setState(_extends({
      filter: evt.target.value,
      currentIndex: -1
    }, this.getProjectState({ filter: evt.target.value })));
  },
  onFilterClick: function onFilterClick(e) {
    e.stopPropagation();
  },
  onFilterMount: function onFilterMount(ref) {
    if (ref) {
      ref.focus();
    }
  },
  onKeyDown: function onKeyDown(evt) {
    var projects = this.state.projectList;
    if (evt.key === 'Down' || evt.keyCode === 40) {
      if (this.state.currentIndex + 1 < projects.length) {
        this.setState({
          currentIndex: this.state.currentIndex + 1
        });
      }
    } else if (evt.key === 'Up' || evt.keyCode === 38) {
      if (this.state.currentIndex > 0) {
        this.setState({
          currentIndex: this.state.currentIndex - 1
        });
      }
    } else if (evt.key === 'Enter' || evt.keyCode === 13) {
      if (this.state.currentIndex > -1) {
        var url = this.getProjectUrlProps(projects[this.state.currentIndex][1]);
        if (url.to) {
          __WEBPACK_IMPORTED_MODULE_3_react_router__["browserHistory"].push(url.to);
        } else if (url.href) {
          window.location = url.href;
        }

        this.onClose();
      }
    }
  },
  onKeyUp: function onKeyUp(evt) {
    if (evt.key === 'Escape' || evt.keyCode === 27) {
      // blur handler should additionally hide dropdown
      this.onClose();
    }
  },
  onOpen: function onOpen() {
    this.setState({
      isOpen: true
    });
    // Not sure if this is still necessary
    // this.setState(state => ({
    // ...this.getProjectState(state)
    // }));
  },
  onClose: function onClose() {
    this.setState(_extends({
      isOpen: false,
      filter: '',
      currentIndex: -1
    }, this.getProjectState({ filter: '' })));
  },
  getProjectNode: function getProjectNode(team, project, highlightText, hasSingleTeam, isSelected) {
    var projectId = project.slug;
    var label = this.getProjectLabel(team, project, hasSingleTeam, highlightText);

    var menuItemProps = _extends({
      key: projectId, // TODO: what if two projects w/ same name under diff orgs?
      linkClassName: projectId == this.props.projectId ? 'active' : '',
      className: isSelected ? 'project-selected' : ''

    }, this.getProjectUrlProps(project));

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_app_components_menuItem__["default"],
      menuItemProps,
      project.isBookmarked && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon-star-solid bookmark ' }),
      label
    );
  },
  getProjectLabel: function getProjectLabel(team, project, hasSingleTeam, highlightText) {
    var label = void 0,
        text = void 0;
    var features = new Set(this.props.organization.features);

    if (features.has('new-teams')) {
      label = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        null,
        project.slug
      );
      text = project.slug;
    } else if (!hasSingleTeam && project.name.indexOf(team.name) === -1) {
      label = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        null,
        team.name,
        ' /',
        ' ',
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_projectLabel__["a" /* default */], { project: project, organization: this.props.organization })
      );
      text = team.name + ' / ' + project.name;
    } else {
      label = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        null,
        project.name
      );
      text = project.name;
    }

    if (!highlightText) {
      return label;
    }

    // in case we have something to highlight we just render a replacement
    // selector without the callsigns.
    // TODO(mitsuhiko): make this work with the project label.
    highlightText = highlightText.toLowerCase();
    var idx = text.toLowerCase().indexOf(highlightText);
    if (idx === -1) {
      return text;
    }
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      null,
      text.substr(0, idx),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'strong',
        { className: 'highlight' },
        text.substr(idx, highlightText.length)
      ),
      text.substr(idx + highlightText.length)
    );
  },
  getLinkNode: function getLinkNode(team, project) {
    var org = this.props.organization;
    var label = this.getProjectLabel(team, project);

    if (!this.context.location) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        this.getProjectUrlProps(project),
        label
      );
    }

    var orgId = org.slug;
    var projectId = project.slug;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_app_components_link__["a" /* default */],
      { to: '/' + orgId + '/' + projectId + '/' },
      label
    );
  },
  renderProjectList: function renderProjectList(_ref) {
    var org = _ref.organization,
        projects = _ref.projects,
        filter = _ref.filter,
        hasProjectWrite = _ref.hasProjectWrite;

    var hasFilter = !!filter;
    var hasProjects = projects && projects.length;
    // Will always need to show divider
    var showDivider = !hasFilter && hasProjectWrite;

    if (hasProjects) {
      return projects;
    } else {
      // There can be a filter and have no found results or
      // there can simply be no projects to list
      //
      // Give an actionable item when there are no projects
      return [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_app_components_menuItem__["default"],
        { key: 'empty-message', className: 'empty-projects-item', noAnchor: true },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'empty-message' },
          hasFilter && Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('No projects found'),
          !hasFilter && Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('You have no projects.')
        )
      ), showDivider ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_menuItem__["default"], { key: 'divider', divider: true }) : null, !hasFilter && hasProjectWrite ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_app_components_menuItem__["default"],
        { key: 'create-project', className: 'empty-projects-item', noAnchor: true },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          {
            className: 'btn btn-primary btn-block',
            href: this.urlPrefix() + '/projects/new/'
          },
          Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Create project')
        )
      ) : null];
    }
  },
  render: function render() {
    var _this3 = this;

    var org = this.props.organization;
    var features = new Set(org.features);
    var access = new Set(org.access);
    var hasSingleTeam = org.teams.length === 1;

    var projectList = void 0;
    if (features.has('new-teams')) {
      projectList = Object(__WEBPACK_IMPORTED_MODULE_10_app_utils__["q" /* sortArray */])(this.state.projectList, function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            team = _ref3[0],
            project = _ref3[1];

        return [!project.isBookmarked, project.name];
      });
    } else {
      projectList = Object(__WEBPACK_IMPORTED_MODULE_10_app_utils__["q" /* sortArray */])(this.state.projectList, function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            team = _ref5[0],
            project = _ref5[1];

        return [!project.isBookmarked, team.name, project.name];
      });
    }

    var children = projectList.map(function (_ref6, index) {
      var _ref7 = _slicedToArray(_ref6, 2),
          team = _ref7[0],
          project = _ref7[1];

      return _this3.getProjectNode(team, project, _this3.state.filter, hasSingleTeam, _this3.state.currentIndex === index);
    });
    var hasFilter = !!this.state.filter;
    var hasProjects = children && !!children.length;
    var dropdownClassNames = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('project-dropdown', {
      'is-empty': !hasProjects
    });

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'project-select' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'h3',
        null,
        this.state.activeProject ? this.getLinkNode(this.state.activeTeam, this.state.activeProject) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          {
            role: 'button',
            style: { cursor: 'pointer' },
            onClick: function onClick() {
              return _this3.state.isOpen ? _this3.onClose() : _this3.onOpen();
            }
          },
          Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Select a project')
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_app_components_dropdownLink__["default"],
          {
            title: '',
            topLevelClasses: dropdownClassNames,
            isOpen: this.state.isOpen,
            onOpen: this.onOpen,
            onClose: this.onClose,
            alwaysRenderMenu: false
          },
          (hasFilter || hasProjects) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'li',
            { className: 'project-filter', key: '_filter' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
              value: this.state.filter,
              type: 'text',
              placeholder: Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Filter projects'),
              onChange: this.onFilterChange,
              onKeyUp: this.onKeyUp,
              onKeyDown: this.onKeyDown,
              onBlur: this.onFilterBlur,
              onClick: this.onFilterClick,
              ref: this.onFilterMount
            })
          ),
          this.renderProjectList({
            organization: org,
            hasProjectWrite: access.has('project:write'),
            projects: children,
            filter: this.state.filter
          })
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["default"] = (ProjectSelector);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchPlugins;
/* harmony export (immutable) */ __webpack_exports__["b"] = enablePlugin;
/* harmony export (immutable) */ __webpack_exports__["a"] = disablePlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_actions_pluginActions__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_stores_indicatorStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api__ = __webpack_require__(46);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var activeFetch = {};
// PluginsStore always exists, so api client should be independent of component lifecycle
var api = new __WEBPACK_IMPORTED_MODULE_3_app_api__["Client"]();

function doUpdate(_ref) {
  var orgId = _ref.orgId,
      projectId = _ref.projectId,
      pluginId = _ref.pluginId,
      update = _ref.update,
      params = _objectWithoutProperties(_ref, ['orgId', 'projectId', 'pluginId', 'update']);

  __WEBPACK_IMPORTED_MODULE_1_app_actions_pluginActions__["a" /* default */].update(pluginId, update);
  var request = api.requestPromise('/projects/' + orgId + '/' + projectId + '/plugins/' + pluginId + '/', _extends({}, params));

  // This is intentionally not chained because we want the unhandled promise to be returned
  request.then(function () {
    __WEBPACK_IMPORTED_MODULE_1_app_actions_pluginActions__["a" /* default */].updateSuccess(pluginId, update);
  }).catch(function (resp) {
    var err = resp && resp.responseJSON && typeof resp.responseJSON.detail === 'string' ? new Error(resp.responseJSON.detail) : new Error('Unable to update plugin');
    __WEBPACK_IMPORTED_MODULE_1_app_actions_pluginActions__["a" /* default */].updateError(pluginId, update, err);
  });

  return request;
}

/**
 * Fetches list of available plugins for a project
 *
 * @param {object} params
 * @param {string} params.orgId Organization ID
 * @param {string} params.projectId Project ID
 * @param {object} options
 * @param {boolean} options.resetLoading Reset will set loading state = true
 * @return Promise
 */
function fetchPlugins(_ref2, options) {
  var orgId = _ref2.orgId,
      projectId = _ref2.projectId;

  var path = '/projects/' + orgId + '/' + projectId + '/plugins/';

  // Make sure we throttle fetches
  if (activeFetch[path]) return activeFetch[path];

  __WEBPACK_IMPORTED_MODULE_1_app_actions_pluginActions__["a" /* default */].fetchAll(options);
  var request = api.requestPromise(path, {
    method: 'GET'
  });

  activeFetch[path] = request;

  // This is intentionally not chained because we want the unhandled promise to be returned
  request.then(function (data, _, jqXHR) {
    __WEBPACK_IMPORTED_MODULE_1_app_actions_pluginActions__["a" /* default */].fetchAllSuccess(data, {
      pageLinks: jqXHR && jqXHR.getResponseHeader('Link')
    });

    return data;
  }).catch(function (err) {
    __WEBPACK_IMPORTED_MODULE_1_app_actions_pluginActions__["a" /* default */].fetchAllError(err);
    throw new Error('Unable to fetch plugins');
  }).then(function () {
    return activeFetch[path] = null;
  });

  return request;
}

/**
 * Enables a plugin
 *
 * @param {object} params
 * @param {string} params.orgId Organization ID
 * @param {string} params.projectId Project ID
 * @param {string} params.pluginId Plugin ID
 * @return Promise
 */
function enablePlugin(params) {
  __WEBPACK_IMPORTED_MODULE_2_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_0_app_locale__["t"])('Enabling...'));
  return doUpdate(_extends({}, params, { update: { enabled: true }, method: 'POST' })).then(function () {
    return __WEBPACK_IMPORTED_MODULE_2_app_stores_indicatorStore__["default"].addSuccess(Object(__WEBPACK_IMPORTED_MODULE_0_app_locale__["t"])('Plugin was enabled'));
  }).catch(function () {
    return __WEBPACK_IMPORTED_MODULE_2_app_stores_indicatorStore__["default"].addError(Object(__WEBPACK_IMPORTED_MODULE_0_app_locale__["t"])('Unable to enable plugin'));
  });
}

/**
 * Disables a plugin
 *
 * @param {object} params
 * @param {string} params.orgId Organization ID
 * @param {string} params.projectId Project ID
 * @param {string} params.pluginId Plugin ID
 */
function disablePlugin(params) {
  __WEBPACK_IMPORTED_MODULE_2_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_0_app_locale__["t"])('Disabling...'));
  return doUpdate(_extends({}, params, { update: { enabled: false }, method: 'DELETE' })).then(function () {
    return __WEBPACK_IMPORTED_MODULE_2_app_stores_indicatorStore__["default"].addSuccess(Object(__WEBPACK_IMPORTED_MODULE_0_app_locale__["t"])('Plugin was disabled'));
  }).catch(function () {
    return __WEBPACK_IMPORTED_MODULE_2_app_stores_indicatorStore__["default"].addError(Object(__WEBPACK_IMPORTED_MODULE_0_app_locale__["t"])('Unable to disable plugin'));
  });
}

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emotion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_views_settings_components_text_textBlock__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_inlineSvg__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_styles_space__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var StyledInlineSvg = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_5_app_components_inlineSvg__["a" /* default */], {
  target: 'e1xb5l7j0'
})('margin-right:12px;');

var getAlertColorStyles = function getAlertColorStyles(_ref, textColor) {
  var backgroundLight = _ref.backgroundLight,
      border = _ref.border,
      iconColor = _ref.iconColor;
  return '\n  background: ' + backgroundLight + ';\n  border: 1px solid ' + border + ';\n\n  svg {\n    color: ' + iconColor + ';\n  }\n\n  a {\n    color: ' + textColor + ';\n    border-bottom: 1px dotted ' + textColor + ';\n  }\n';
};

var getSystemAlertColorStyles = function getSystemAlertColorStyles(_ref2) {
  var background = _ref2.background;
  return '\n  background: ' + background + ';\n  border: 0;\n  border-radius: 0;\n  color: #fff;\n  font-weight: bold;\n  text-shadow: 0 1px 1px rgba(0,0,0, .15);\n\n  ' + StyledInlineSvg + ' {\n    color: #fff;\n  }\n\n  a {\n    color: #fff;\n    border-bottom: 1px dotted rgba(255,255,255, .8);\n\n    &:hover {\n      border-bottom: 1px dotted rgba(255,255,255, 1);\n    }\n  }\n';
};

var AlertWrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e1xb5l7j1'
})('margin:0 0 ', Object(__WEBPACK_IMPORTED_MODULE_6_app_styles_space__["a" /* default */])(3), ';padding:', function (p) {
  return p.theme.grid * 2;
}, 'px;font-size:15px;box-shadow:', function (p) {
  return p.theme.dropShadowLight;
}, ';display:flex;border-radius:', function (p) {
  return p.theme.borderRadius;
}, ';background:', function (p) {
  return p.theme.whiteDark;
}, ';border:1px solid ', function (p) {
  return p.theme.borderDark;
}, ';', function (p) {
  return p.system ? p.type && getSystemAlertColorStyles(p.theme.alert[p.type]) : p.type && getAlertColorStyles(p.theme.alert[p.type], p.theme.gray5);
}, ';');

var StyledTextBlock = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_4_app_views_settings_components_text_textBlock__["default"], {
  target: 'e1xb5l7j2'
})('line-height:1.4;margin-bottom:0;flex:1;align-self:center;');

var Alert = function Alert(_ref3) {
  var type = _ref3.type,
      icon = _ref3.icon,
      children = _ref3.children,
      className = _ref3.className,
      props = _objectWithoutProperties(_ref3, ['type', 'icon', 'children', 'className']);

  var refClass = void 0;

  if (type) {
    refClass = 'ref-' + type;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    AlertWrapper,
    _extends({ type: type }, props, { className: Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["cx"])(refClass, className) }),
    icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledInlineSvg, { src: icon, size: '24px' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      StyledTextBlock,
      null,
      children
    )
  );
};

Alert.propTypes = {
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Alert);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_count__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_stores_configStore__ = __webpack_require__(25);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }











var StackedBarChart = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'StackedBarChart',

  propTypes: {
    // TODO(dcramer): DEPRECATED, use series instead
    points: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
      x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
      y: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array.isRequired,
      label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
    })),
    series: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
      data: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
        x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
        y: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number
      })),
      label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
    })),
    height: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    markers: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
      x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
      label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
    })),
    tooltip: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    barClasses: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array
  },

  statics: {
    getInterval: function getInterval(series) {
      // TODO(dcramer): not guaranteed correct
      return series.length && series[0].data.length > 1 ? series[0].data[1].x - series[0].data[0].x : null;
    },
    pointsToSeries: function pointsToSeries(points) {
      var series = [];
      points.forEach(function (p, pIdx) {
        p.y.forEach(function (y, yIdx) {
          if (!series[yIdx]) {
            series[yIdx] = { data: [] };
          }
          series[yIdx].data.push({ x: p.x, y: y });
        });
      });
      return series;
    },
    pointIndex: function pointIndex(series) {
      var points = {};
      series.forEach(function (s) {
        s.data.forEach(function (p) {
          if (!points[p.x]) {
            points[p.x] = { y: [], x: p.x };
          }
          points[p.x].y.push(p.y);
        });
      });
      return points;
    }
  },

  getDefaultProps: function getDefaultProps() {
    return {
      className: 'sparkline',
      height: null,
      label: '',
      points: [],
      series: [],
      markers: [],
      width: null,
      barClasses: ['chart-bar']
    };
  },
  getInitialState: function getInitialState() {
    // massage points
    var series = this.props.series;
    if (this.props.points.length) {
      if (series.length) {
        throw new Error('Only one of [points|series] should be specified.');
      }

      series = StackedBarChart.pointsToSeries(this.props.points);
    }

    return {
      series: series,
      pointIndex: StackedBarChart.pointIndex(series),
      interval: StackedBarChart.getInterval(series)
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.points || nextProps.series) {
      var series = nextProps.series;
      if (nextProps.points.length) {
        if (series.length) {
          throw new Error('Only one of [points|series] should be specified.');
        }

        series = StackedBarChart.pointsToSeries(nextProps.points);
      }

      this.setState({
        series: series,
        pointIndex: StackedBarChart.pointIndex(series),
        interval: StackedBarChart.getInterval(series)
      });
    }
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(this.props, nextProps);
  },
  use24Hours: function use24Hours() {
    var user = __WEBPACK_IMPORTED_MODULE_7_app_stores_configStore__["default"].get('user');
    var options = user ? user.options : {};
    return options.clock24Hours;
  },
  floatFormat: function floatFormat(number, places) {
    var multi = Math.pow(10, places);
    return parseInt(number * multi, 10) / multi;
  },
  timeLabelAsHour: function timeLabelAsHour(point) {
    var timeMoment = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(point.x * 1000);
    var nextMoment = timeMoment.clone().add(59, 'minute');
    var format = this.use24Hours() ? 'HH:mm' : 'LT';

    return '<span>' + timeMoment.format('LL') + '<br />' + timeMoment.format(format) + '  &#8594; ' + nextMoment.format(format) + '</span>';
  },
  timeLabelAsDay: function timeLabelAsDay(point) {
    var timeMoment = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(point.x * 1000);

    return '<span>' + timeMoment.format('LL') + '</span>';
  },
  timeLabelAsRange: function timeLabelAsRange(interval, point) {
    var timeMoment = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(point.x * 1000);
    var nextMoment = timeMoment.clone().add(interval - 1, 'second');
    var format = this.use24Hours() ? 'MMM Do, HH:mm' : 'MMM Do, h:mm a';

    return '<span>' +
    // e.g. Aug 23rd, 12:50 pm
    timeMoment.format(format) + ' &#8594 ' + nextMoment.format(format) + '</span>';
  },
  timeLabelAsFull: function timeLabelAsFull(point) {
    var timeMoment = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(point.x * 1000);
    return timeMoment.format('lll');
  },
  getTimeLabel: function getTimeLabel(point) {
    switch (this.state.interval) {
      case 3600:
        return this.timeLabelAsHour(point);
      case 86400:
        return this.timeLabelAsDay(point);
      case null:
        return this.timeLabelAsFull(point);
      default:
        return this.timeLabelAsRange(this.state.interval, point);
    }
  },
  maxPointValue: function maxPointValue() {
    return Math.max(10, this.state.series.map(function (s) {
      return Math.max.apply(Math, _toConsumableArray(s.data.map(function (p) {
        return p.y;
      })));
    }).reduce(function (a, b) {
      return a + b;
    }, 0));
  },
  renderMarker: function renderMarker(marker) {
    var timeLabel = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(marker.x * 1000).format('lll');
    var title = '<div style="width:130px">' + marker.label + '<br/>' + timeLabel + '</div>';
    var className = 'chart-marker ' + (marker.className || '');

    // example key: m-last-seen-22811123, m-first-seen-228191
    var key = ['m', marker.className, marker.x].join('-');

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_app_components_tooltip__["default"],
      { title: title, key: key, tooltipOptions: { html: true, placement: 'bottom' } },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        { className: className, style: { height: '100%' } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          marker.label
        )
      )
    );
  },
  renderTooltip: function renderTooltip(point, pointIdx) {
    var _this = this;

    var timeLabel = this.getTimeLabel(point);
    var totalY = point.y.reduce(function (a, b) {
      return a + b;
    });
    var title = '<div style="width:130px">' + ('<div class="time-label">' + timeLabel + '</div>') + '</div>';
    if (this.props.label) {
      title += '<div class="value-label">' + totalY.toLocaleString() + ' ' + this.props.label + '</div>';
    }
    point.y.forEach(function (y, i) {
      var s = _this.state.series[i];
      if (s.label) {
        title += '<div><span style="color:' + s.color + '">' + s.label + ':</span> ' + (y || 0).toLocaleString() + '</div>';
      }
    });
    return title;
  },
  renderChartColumn: function renderChartColumn(point, maxval, pointWidth) {
    var _this2 = this;

    var totalY = point.y.reduce(function (a, b) {
      return a + b;
    });
    var totalPct = totalY / maxval;
    var prevPct = 0;
    var pts = point.y.map(function (y, i) {
      var pct = totalY && _this2.floatFormat(y / totalY * totalPct * 99, 2);
      var pt = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        {
          key: i,
          className: _this2.props.barClasses[i],
          style: {
            height: pct + '%',
            bottom: prevPct + '%',
            backgroundColor: _this2.state.series[i].color || null
          }
        },
        y
      );
      prevPct += pct;
      return pt;
    });

    var pointIdx = point.x;
    var tooltipFunc = this.props.tooltip || this.renderTooltip;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_app_components_tooltip__["default"],
      {
        title: tooltipFunc(this.state.pointIndex[pointIdx], pointIdx, this),
        key: point.x,
        tooltipOptions: { html: true, placement: 'bottom' }
      },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        { className: 'chart-column', style: { width: pointWidth, height: '100%' } },
        pts
      )
    );
  },
  renderChart: function renderChart() {
    var _this3 = this;

    var _state = this.state,
        pointIndex = _state.pointIndex,
        series = _state.series;

    var totalPoints = Math.max.apply(Math, _toConsumableArray(series.map(function (s) {
      return s.data.length;
    })));
    var pointWidth = this.floatFormat(100.0 / totalPoints, 2) + '%';

    var maxval = this.maxPointValue();
    var markers = this.props.markers.slice();

    // group points, then resort
    var points = Object.keys(pointIndex).map(function (k) {
      var p = pointIndex[k];
      return { x: p.x, y: p.y };
    }).sort(function (a, b) {
      return a.x - b.x;
    });

    markers.sort(function (a, b) {
      return a.x - b.x;
    });

    var children = [];
    points.forEach(function (point) {
      while (markers.length && markers[0].x <= point.x) {
        children.push(_this3.renderMarker(markers.shift()));
      }

      children.push(_this3.renderChartColumn(point, maxval, pointWidth));
    });

    // in bizarre case where markers never got rendered, render them last
    // NOTE: should this ever happen?
    markers.forEach(function (marker) {
      children.push(_this3.renderMarker(marker));
    });

    return children;
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        style = _props.style,
        height = _props.height,
        width = _props.width;

    var figureClass = [className, 'barchart'].join(' ');
    var maxval = this.maxPointValue();

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'figure',
      { className: figureClass, style: _extends({ height: height, width: width }, style) },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { className: 'max-y' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_count__["default"], { value: maxval })
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { className: 'min-y' },
        '0'
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        null,
        this.renderChart()
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["default"] = (StackedBarChart);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Switch = (_temp = _class = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).apply(this, arguments));
  }

  _createClass(Switch, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          size = _props.size,
          isActive = _props.isActive,
          isLoading = _props.isLoading,
          isDisabled = _props.isDisabled,
          toggle = _props.toggle,
          id = _props.id;

      var switchClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('switch', (_classNames = {}, _defineProperty(_classNames, 'switch-' + size, size), _defineProperty(_classNames, 'switch-on', isActive), _defineProperty(_classNames, 'switch-changing', isLoading), _defineProperty(_classNames, 'switch-disabled', isDisabled), _classNames));

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          id: id,
          className: switchClasses,
          onClick: isDisabled ? null : toggle,
          role: 'checkbox',
          'aria-checked': isActive
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'switch-toggle' })
      );
    }
  }]);

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['sm', 'lg']).isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  isLoading: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  isDisabled: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  toggle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
}, _class.defaultProps = {
  size: 'sm'
}, _temp);


/* harmony default export */ __webpack_exports__["default"] = (Switch);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_stackedBarChart__ = __webpack_require__(213);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var BarChart = (_temp = _class = function (_React$Component) {
  _inherits(BarChart, _React$Component);

  function BarChart() {
    _classCallCheck(this, BarChart);

    return _possibleConstructorReturn(this, (BarChart.__proto__ || Object.getPrototypeOf(BarChart)).apply(this, arguments));
  }

  _createClass(BarChart, [{
    key: 'render',
    value: function render() {
      var points = this.props.points.map(function (point) {
        return { x: point.x, y: [point.y] };
      });
      var props = Object.assign({}, this.props, { points: points });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_stackedBarChart__["default"], props);
    }
  }]);

  return BarChart;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  points: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
    y: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
  })),
  interval: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  placement: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  markers: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
  }))
}, _class.defaultProps = {
  points: []
}, _temp);


/* harmony default export */ __webpack_exports__["default"] = (BarChart);

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(219),
    upperFirst = __webpack_require__(536);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ICON_PATHS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_images_integrations_integration_default_png__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_images_integrations_integration_default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_app_images_integrations_integration_default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_images_integrations_integration_sentry_png__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_images_integrations_integration_sentry_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_app_images_integrations_integration_sentry_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_images_integrations_asana_logo_png__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_images_integrations_asana_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_app_images_integrations_asana_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_images_integrations_bitbucket_logo_png__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_images_integrations_bitbucket_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_app_images_integrations_bitbucket_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_images_integrations_campfire_logo_png__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_images_integrations_campfire_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_app_images_integrations_campfire_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_images_integrations_clubhouse_logo_png__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_images_integrations_clubhouse_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_app_images_integrations_clubhouse_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_images_integrations_flowdock_logo_png__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_images_integrations_flowdock_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_app_images_integrations_flowdock_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_images_integrations_github_logo_png__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_images_integrations_github_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_app_images_integrations_github_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_images_integrations_gitlab_logo_png__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_images_integrations_gitlab_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_app_images_integrations_gitlab_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_images_integrations_heroku_logo_png__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_images_integrations_heroku_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_app_images_integrations_heroku_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_images_integrations_hipchat_logo_png__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_images_integrations_hipchat_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_app_images_integrations_hipchat_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_images_integrations_jira_logo_png__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_images_integrations_jira_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_app_images_integrations_jira_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_images_integrations_lighthouse_logo_png__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_images_integrations_lighthouse_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_app_images_integrations_lighthouse_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_images_integrations_opsgenie_logo_png__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_images_integrations_opsgenie_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_app_images_integrations_opsgenie_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_images_integrations_pagerduty_logo_png__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_images_integrations_pagerduty_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_app_images_integrations_pagerduty_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_images_integrations_phabricator_logo_png__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_images_integrations_phabricator_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_app_images_integrations_phabricator_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_images_integrations_pivotaltracker_logo_png__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_images_integrations_pivotaltracker_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_app_images_integrations_pivotaltracker_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_app_images_integrations_pushover_logo_png__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_app_images_integrations_pushover_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_app_images_integrations_pushover_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_app_images_integrations_redmine_logo_png__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_app_images_integrations_redmine_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_app_images_integrations_redmine_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_app_images_integrations_slack_logo_png__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_app_images_integrations_slack_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_app_images_integrations_slack_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_app_images_integrations_taiga_logo_png__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_app_images_integrations_taiga_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_app_images_integrations_taiga_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_app_images_integrations_teamwork_logo_png__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_app_images_integrations_teamwork_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_app_images_integrations_teamwork_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_app_images_integrations_trello_logo_png__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_app_images_integrations_trello_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_app_images_integrations_trello_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_app_images_integrations_twilio_logo_png__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_app_images_integrations_twilio_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_app_images_integrations_twilio_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_app_images_integrations_vsts_logo_svg__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_app_images_integrations_vsts_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_app_images_integrations_vsts_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_app_images_integrations_youtrack_logo_png__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_app_images_integrations_youtrack_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_app_images_integrations_youtrack_logo_png__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
































// Map of plugin id -> logo filename
var DEFAULT_ICON = __WEBPACK_IMPORTED_MODULE_3_app_images_integrations_integration_default_png___default.a;
var ICON_PATHS = {
  _default: DEFAULT_ICON,
  sentry: __WEBPACK_IMPORTED_MODULE_4_app_images_integrations_integration_sentry_png___default.a,
  browsers: __WEBPACK_IMPORTED_MODULE_4_app_images_integrations_integration_sentry_png___default.a,
  device: __WEBPACK_IMPORTED_MODULE_4_app_images_integrations_integration_sentry_png___default.a,
  interface_types: __WEBPACK_IMPORTED_MODULE_4_app_images_integrations_integration_sentry_png___default.a,
  os: __WEBPACK_IMPORTED_MODULE_4_app_images_integrations_integration_sentry_png___default.a,
  urls: __WEBPACK_IMPORTED_MODULE_4_app_images_integrations_integration_sentry_png___default.a,
  webhooks: __WEBPACK_IMPORTED_MODULE_4_app_images_integrations_integration_sentry_png___default.a,

  asana: __WEBPACK_IMPORTED_MODULE_5_app_images_integrations_asana_logo_png___default.a,
  bitbucket: __WEBPACK_IMPORTED_MODULE_6_app_images_integrations_bitbucket_logo_png___default.a,
  campfire: __WEBPACK_IMPORTED_MODULE_7_app_images_integrations_campfire_logo_png___default.a,
  clubhouse: __WEBPACK_IMPORTED_MODULE_8_app_images_integrations_clubhouse_logo_png___default.a,
  flowdock: __WEBPACK_IMPORTED_MODULE_9_app_images_integrations_flowdock_logo_png___default.a,
  github: __WEBPACK_IMPORTED_MODULE_10_app_images_integrations_github_logo_png___default.a,
  gitlab: __WEBPACK_IMPORTED_MODULE_11_app_images_integrations_gitlab_logo_png___default.a,
  heroku: __WEBPACK_IMPORTED_MODULE_12_app_images_integrations_heroku_logo_png___default.a,
  hipchat: __WEBPACK_IMPORTED_MODULE_13_app_images_integrations_hipchat_logo_png___default.a,
  'hipchat-ac': __WEBPACK_IMPORTED_MODULE_13_app_images_integrations_hipchat_logo_png___default.a,
  jira: __WEBPACK_IMPORTED_MODULE_14_app_images_integrations_jira_logo_png___default.a,
  'jira-atlassian-connect': __WEBPACK_IMPORTED_MODULE_14_app_images_integrations_jira_logo_png___default.a,
  'jira-ac': __WEBPACK_IMPORTED_MODULE_14_app_images_integrations_jira_logo_png___default.a,
  lighthouse: __WEBPACK_IMPORTED_MODULE_15_app_images_integrations_lighthouse_logo_png___default.a,
  opsgenie: __WEBPACK_IMPORTED_MODULE_16_app_images_integrations_opsgenie_logo_png___default.a,
  pagerduty: __WEBPACK_IMPORTED_MODULE_17_app_images_integrations_pagerduty_logo_png___default.a,
  phabricator: __WEBPACK_IMPORTED_MODULE_18_app_images_integrations_phabricator_logo_png___default.a,
  pivotal: __WEBPACK_IMPORTED_MODULE_19_app_images_integrations_pivotaltracker_logo_png___default.a,
  pushover: __WEBPACK_IMPORTED_MODULE_20_app_images_integrations_pushover_logo_png___default.a,
  redmine: __WEBPACK_IMPORTED_MODULE_21_app_images_integrations_redmine_logo_png___default.a,
  slack: __WEBPACK_IMPORTED_MODULE_22_app_images_integrations_slack_logo_png___default.a,
  taiga: __WEBPACK_IMPORTED_MODULE_23_app_images_integrations_taiga_logo_png___default.a,
  teamwork: __WEBPACK_IMPORTED_MODULE_24_app_images_integrations_teamwork_logo_png___default.a,
  trello: __WEBPACK_IMPORTED_MODULE_25_app_images_integrations_trello_logo_png___default.a,
  twilio: __WEBPACK_IMPORTED_MODULE_26_app_images_integrations_twilio_logo_png___default.a,
  vsts: __WEBPACK_IMPORTED_MODULE_27_app_images_integrations_vsts_logo_svg___default.a,
  youtrack: __WEBPACK_IMPORTED_MODULE_28_app_images_integrations_youtrack_logo_png___default.a
};

var IntegrationIcon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'e1bhjds90'
})('position:relative;height:', function (p) {
  return p.size;
}, 'px;width:', function (p) {
  return p.size;
}, 'px;border-radius:2px;border:0;/* this is so that there aren\'t gray boxes before load */\n  background-color: #fff;\n  display: inline-block;\n  background-size: contain;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-image: url(', function (p) {
  return p.image;
}, ');');

var PluginIcon = (_temp = _class = function (_React$Component) {
  _inherits(PluginIcon, _React$Component);

  function PluginIcon() {
    _classCallCheck(this, PluginIcon);

    return _possibleConstructorReturn(this, (PluginIcon.__proto__ || Object.getPrototypeOf(PluginIcon)).apply(this, arguments));
  }

  _createClass(PluginIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          pluginId = _props.pluginId,
          size = _props.size,
          props = _objectWithoutProperties(_props, ['pluginId', 'size']);

      var src = ICON_PATHS[pluginId] || DEFAULT_ICON;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(IntegrationIcon, _extends({}, props, { image: src, size: size }));
    }
  }]);

  return PluginIcon;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  pluginId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
}, _class.defaultProps = {
  pluginId: '_default',
  size: 20
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (PluginIcon);

/***/ }),
/* 218 */,
/* 219 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(314),
    createBaseEach = __webpack_require__(926);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(395),
    isLength = __webpack_require__(487);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TextField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_forms_inputField__ = __webpack_require__(86);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var TextField = (_temp = _class = function (_InputField) {
  _inherits(TextField, _InputField);

  function TextField() {
    _classCallCheck(this, TextField);

    return _possibleConstructorReturn(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).apply(this, arguments));
  }

  _createClass(TextField, [{
    key: 'getAttributes',
    value: function getAttributes() {
      return {
        spellCheck: this.props.spellCheck
      };
    }
  }, {
    key: 'getType',
    value: function getType() {
      return 'text';
    }
  }]);

  return TextField;
}(__WEBPACK_IMPORTED_MODULE_1_app_components_forms_inputField__["a" /* default */]), _class.propTypes = {
  spellCheck: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, _temp);


/***/ }),
/* 223 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(966);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_capitalize__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_capitalize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_capitalize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_projectLink__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_eventOrGroupTitle__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_tooltip__ = __webpack_require__(21);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












/**
 * Displays an event or group/issue title (i.e. in Stream)
 */
var EventOrGroupHeader = (_temp = _class = function (_React$Component) {
  _inherits(EventOrGroupHeader, _React$Component);

  function EventOrGroupHeader() {
    _classCallCheck(this, EventOrGroupHeader);

    return _possibleConstructorReturn(this, (EventOrGroupHeader.__proto__ || Object.getPrototypeOf(EventOrGroupHeader)).apply(this, arguments));
  }

  _createClass(EventOrGroupHeader, [{
    key: 'getMessage',
    value: function getMessage() {
      var data = this.props.data;

      var _ref = data || {},
          metadata = _ref.metadata,
          type = _ref.type,
          culprit = _ref.culprit;

      switch (type) {
        case 'error':
          return metadata.value;
        case 'csp':
          return metadata.message;
        case 'expectct':
        case 'expectstaple':
        case 'hpkp':
          return '';
        default:
          return culprit || '';
      }
    }
  }, {
    key: 'getTitle',
    value: function getTitle() {
      var _props = this.props,
          hideIcons = _props.hideIcons,
          hideLevel = _props.hideLevel,
          includeLink = _props.includeLink,
          orgId = _props.orgId,
          projectId = _props.projectId,
          data = _props.data;

      var _ref2 = data || {},
          id = _ref2.id,
          level = _ref2.level,
          groupID = _ref2.groupID;

      var isEvent = !!data.eventID;

      var props = {};
      var Wrapper = void 0;
      if (includeLink) {
        props.to = {
          pathname: '/' + orgId + '/' + projectId + '/issues/' + (isEvent ? groupID : id) + '/' + (isEvent ? 'events/' + data.id + '/' : ''),
          search: '' + (this.props.query ? '?query=' + this.props.query : '')
        };
        Wrapper = __WEBPACK_IMPORTED_MODULE_5_app_components_projectLink__["a" /* default */];
      } else {
        Wrapper = 'span';
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        Wrapper,
        _extends({}, props, {
          style: data.status === 'resolved' ? { textDecoration: 'line-through' } : null
        }),
        !hideLevel && level && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_app_components_tooltip__["default"],
          { title: 'Error level: ' + __WEBPACK_IMPORTED_MODULE_0_lodash_capitalize___default()(level) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(GroupLevel, { level: data.level })
        ),
        !hideIcons && data.status === 'ignored' && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Muted, { className: 'icon-soundoff' }),
        !hideIcons && data.isBookmarked && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Starred, { className: 'icon-star-solid' }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_eventOrGroupTitle__["a" /* default */], _extends({}, this.props, {
          style: { fontWeight: data.hasSeen ? 400 : 600 }
        }))
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var className = this.props.className;

      var cx = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('event-issue-header', className);
      var message = this.getMessage();

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: cx },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          Title,
          null,
          this.getTitle()
        ),
        message && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          Message,
          null,
          message
        )
      );
    }
  }]);

  return EventOrGroupHeader;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  orgId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  projectId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  /** Either an issue or event **/
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    level: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['error', 'csp', 'hpkp', 'expectct', 'expectstaple', 'default']).isRequired,
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    metadata: __WEBPACK_IMPORTED_MODULE_6_app_proptypes__["d" /* Metadata */],
    groupID: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    culprit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  includeLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hideIcons: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hideLevel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  includeLink: true
}, _temp);


var truncateStyles = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["css"])('overflow:hidden;max-width:100%;text-overflow:ellipsis;white-space:nowrap;');

var Title = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'eex8od0'
})(truncateStyles, ';margin:0 0 5px;& em{font-size:14px;font-style:normal;font-weight:300;color:', function (p) {
  return p.theme.gray3;
}, ';}');

var Message = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'eex8od1'
})(truncateStyles, ';font-size:14px;margin:0 0 5px;');

var iconStyles = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["css"])('font-size:14px;margin-right:5px;');

var Muted = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('span', {
  target: 'eex8od2'
})(iconStyles, ';color:', function (p) {
  return p.theme.red;
}, ';');

var Starred = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('span', {
  target: 'eex8od3'
})(iconStyles, ';color:', function (p) {
  return p.theme.yellowOrange;
}, ';');

var GroupLevel = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'eex8od4'
})('position:absolute;left:-1px;width:9px;height:15px;border-radius:0 3px 3px 0;background-color:', function (p) {
  switch (p.level) {
    case 'sample':
      return p.theme.purple;
    case 'info':
      return p.theme.blue;
    case 'warning':
      return p.theme.yellowOrange;
    case 'error':
      return p.theme.orange;
    case 'fatal':
      return p.theme.red;
    default:
      return p.theme.gray2;
  }
}, ';');

/* harmony default export */ __webpack_exports__["a"] = (EventOrGroupHeader);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_actionCreators_plugins__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_stores_pluginsStore__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_mixins_projectState__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_proptypes__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










/**
 * Higher order component that fetches list of plugins and
 * passes PluginsStore to component as `plugins`
 */
var withPlugins = function withPlugins(WrappedComponent) {
  return __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
    displayName: 'withPlugins',
    propTypes: {
      organization: __WEBPACK_IMPORTED_MODULE_6_app_proptypes__["e" /* default */].Organization,
      project: __WEBPACK_IMPORTED_MODULE_6_app_proptypes__["e" /* default */].Project
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_5_app_mixins_projectState__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_reflux___default.a.connect(__WEBPACK_IMPORTED_MODULE_4_app_stores_pluginsStore__["a" /* default */], 'store')],
    componentDidMount: function componentDidMount() {
      var organization = this.props.organization || this.getOrganization();
      var project = this.props.project || this.getProject();

      if (!project || !organization) return;

      Object(__WEBPACK_IMPORTED_MODULE_3_app_actionCreators_plugins__["c" /* fetchPlugins */])({ projectId: project.slug, orgId: organization.slug });
    },
    render: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, { plugins: this.state.store }));
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (withPlugins);

/***/ }),
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(409);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 234 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 235 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return growIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fadeOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pulse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return expandOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return slideInRight; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_emotion__ = __webpack_require__(5);


var growIn = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react_emotion__["keyframes"])('0%{transform:scale(0);}100%{transform:scale(1);}');

var fadeOut = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react_emotion__["keyframes"])('0%{opacity:1;}100%{opacity:0;}');

var pulse = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react_emotion__["keyframes"])('0%{transform:scale(1,1);}50%{transform:scale(1.15,1.15);}100%{transform:scale(1,1);}');

var expandOut = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react_emotion__["keyframes"])('0%{transform:scale(1,1);opacity:1;}100%{transform:scale(5,5);opacity:0;}');

var slideInRight = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react_emotion__["keyframes"])('0%{transform:translateX(20px);opacity:0;}100%{transform:translateX(0);opacity:1;}');

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = trimPackage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_escape__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_escape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_escape__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_clippedBox__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_strictClick__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_truncate__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_events_interfaces_contextLine__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_events_interfaces_frameVariables__ = __webpack_require__(919);


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

















function trimPackage(pkg) {
  var pieces = pkg.split(/^[a-z]:\\/i.test(pkg) ? '\\' : '/');
  var filename = pieces[pieces.length - 1] || pieces[pieces.length - 2] || pkg;
  return filename.replace(/\.(dylib|so|a|dll|exe)$/, '');
}

var Frame = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'Frame',

  propTypes: {
    data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    nextFrame: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    prevFrame: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    platform: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    isExpanded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    emptySourceNotation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    isOnlyFrame: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    timesRepeated: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      isExpanded: false,
      emptySourceNotation: false
    };
  },
  getInitialState: function getInitialState() {
    // isExpanded can be initialized to true via parent component;
    // data synchronization is not important
    // https://facebook.github.io/react/tips/props-in-getInitialState-as-anti-pattern.html
    return {
      isExpanded: this.props.isExpanded
    };
  },
  toggleContext: function toggleContext(evt) {
    evt && evt.preventDefault();

    this.setState({
      isExpanded: !this.state.isExpanded
    });
  },
  hasContextSource: function hasContextSource() {
    return Object(__WEBPACK_IMPORTED_MODULE_10_app_utils__["d" /* defined */])(this.props.data.context) && this.props.data.context.length;
  },
  hasContextVars: function hasContextVars() {
    return !Object(__WEBPACK_IMPORTED_MODULE_10_app_utils__["m" /* objectIsEmpty */])(this.props.data.vars);
  },
  isExpandable: function isExpandable() {
    return !this.props.isOnlyFrame && this.props.emptySourceNotation || this.hasContextSource() || this.hasContextVars();
  },
  renderOriginalSourceInfo: function renderOriginalSourceInfo() {
    var data = this.props.data;

    var sourceMapText = Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Source Map');

    var out = '\n    <div>\n      <strong>' + sourceMapText + '</strong><br/>';

    // mapUrl not always present; e.g. uploaded source maps
    if (data.mapUrl) out += __WEBPACK_IMPORTED_MODULE_0_lodash_escape___default()(data.mapUrl) + '<br/>';else out += __WEBPACK_IMPORTED_MODULE_0_lodash_escape___default()(data.map) + '<br/>';

    out += '</div>';

    return out;
  },
  getPlatform: function getPlatform() {
    // prioritize the frame platform but fall back to the platform
    // of the stacktrace / exception
    return this.props.data.platform || this.props.platform;
  },
  shouldPrioritizeModuleName: function shouldPrioritizeModuleName() {
    switch (this.getPlatform()) {
      case 'java':
      case 'csharp':
        return true;
      default:
        return false;
    }
  },
  preventCollapse: function preventCollapse(evt) {
    evt.stopPropagation();
  },
  renderDefaultTitle: function renderDefaultTitle() {
    var data = this.props.data;
    var title = [];

    // TODO(dcramer): this needs to use a formatted string so it can be
    // localized correctly

    if (Object(__WEBPACK_IMPORTED_MODULE_10_app_utils__["d" /* defined */])(data.filename || data.module)) {
      // prioritize module name for Java as filename is often only basename
      var shouldPrioritizeModuleName = this.shouldPrioritizeModuleName();
      var pathName = shouldPrioritizeModuleName ? data.module || data.filename : data.filename || data.module;

      title.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'code',
        { key: 'filename', className: 'filename' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_truncate__["a" /* default */], { value: pathName, maxLength: 100, leftTrim: true })
      ));

      // in case we prioritized the module name but we also have a filename info
      // we want to show a litle (?) icon that on hover shows the actual filename
      if (shouldPrioritizeModuleName && data.filename) {
        title.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_app_components_tooltip__["default"],
          { title: __WEBPACK_IMPORTED_MODULE_0_lodash_escape___default()(data.filename), tooltipOptions: { html: true } },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'a',
            { className: 'in-at real-filename' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon-question' })
          )
        ));
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_10_app_utils__["l" /* isUrl */])(data.absPath)) {
        title.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', {
          href: data.absPath,
          className: 'icon-open',
          key: 'share',
          target: '_blank',
          onClick: this.preventCollapse
        }));
      }
      if (Object(__WEBPACK_IMPORTED_MODULE_10_app_utils__["d" /* defined */])(data.function)) {
        title.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'span',
          { className: 'in-at', key: 'in' },
          ' ',
          'in',
          ' '
        ));
      }
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_10_app_utils__["d" /* defined */])(data.function)) {
      title.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'code',
        { key: 'function', className: 'function' },
        data.function
      ));
    }

    // we don't want to render out zero line numbers which are used to
    // indicate lack of source information for native setups.  We could
    // TODO(mitsuhiko): only do this for events from native platforms?
    if (Object(__WEBPACK_IMPORTED_MODULE_10_app_utils__["d" /* defined */])(data.lineNo) && data.lineNo != 0) {
      title.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'span',
        { className: 'in-at in-at-line', key: 'no' },
        ' ',
        'at line',
        ' '
      ));
      title.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'code',
        { key: 'line', className: 'lineno' },
        Object(__WEBPACK_IMPORTED_MODULE_10_app_utils__["d" /* defined */])(data.colNo) ? data.lineNo + ':' + data.colNo : data.lineNo
      ));
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_10_app_utils__["d" /* defined */])(data.package)) {
      title.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'span',
        { className: 'within', key: 'within' },
        ' ',
        'within',
        ' '
      ));
      title.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'code',
        { title: data.package, className: 'package', key: 'package' },
        trimPackage(data.package)
      ));
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_10_app_utils__["d" /* defined */])(data.origAbsPath)) {
      title.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_app_components_tooltip__["default"],
        {
          key: 'info-tooltip',
          title: this.renderOriginalSourceInfo(),
          tooltipOptions: { html: true }
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'a',
          { className: 'in-at original-src' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon-question' })
        )
      ));
    }

    title.push(this.renderExpander());

    return title;
  },
  renderContext: function renderContext() {
    var data = this.props.data;
    var context = '';
    var isExpanded = this.state.isExpanded;


    var outerClassName = 'context';
    if (isExpanded) {
      outerClassName += ' expanded';
    }

    var hasContextSource = this.hasContextSource();
    var hasContextVars = this.hasContextVars();
    var expandable = this.isExpandable();

    var contextLines = isExpanded ? data.context : data.context && data.context.filter(function (l) {
      return l[0] === data.lineNo;
    });

    if (hasContextSource || hasContextVars) {
      var startLineNo = hasContextSource ? data.context[0][0] : '';
      context = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'ol',
        { start: startLineNo, className: outerClassName },
        Object(__WEBPACK_IMPORTED_MODULE_10_app_utils__["d" /* defined */])(data.errors) && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'li',
          { className: expandable ? 'expandable error' : 'error', key: 'errors' },
          data.errors.join(', ')
        ),
        data.context && contextLines.map(function (line, index) {
          return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_events_interfaces_contextLine__["a" /* default */], { key: index, line: line, isActive: data.lineNo === line[0] });
        }),
        hasContextVars && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_app_components_clippedBox__["a" /* default */],
          { clipHeight: 100 },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_events_interfaces_frameVariables__["a" /* default */], { data: data.vars, key: 'vars' })
        )
      );
    } else if (this.props.emptySourceNotation) {
      context = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'empty-context' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon icon-exclamation' }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'p',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('No additional details are available for this frame.')
        )
      );
    }
    return context;
  },
  renderExpander: function renderExpander() {
    if (!this.isExpandable()) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'a',
      {
        key: 'expander',
        title: Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Toggle context'),
        onClick: this.toggleContext,
        className: 'btn btn-sm btn-default btn-toggle'
      },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: this.state.isExpanded ? 'icon-minus' : 'icon-plus' })
    );
  },
  leadsToApp: function leadsToApp() {
    return !this.props.data.inApp && this.props.nextFrame && this.props.nextFrame.inApp;
  },
  isInlineFrame: function isInlineFrame() {
    return this.props.prevFrame && this.getPlatform() == (this.props.prevFrame.platform || this.props.platform) && this.props.data.instructionAddr == this.props.prevFrame.instructionAddr;
  },
  getFrameHint: function getFrameHint() {
    if (this.isInlineFrame()) {
      return Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Inlined frame');
    }
    if (this.getPlatform() == 'cocoa') {
      var func = this.props.data.function || '<unknown>';
      if (func.match(/^@objc\s/)) {
        return Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Objective-C -> Swift shim frame');
      }
      if (func === '<redacted>') {
        return Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Unknown system frame. Usually from beta SDKs');
      }
      if (func.match(/^__?hidden#\d+/)) {
        return Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Hidden function from bitcode build');
      }
    }
    return null;
  },
  renderLeadHint: function renderLeadHint() {
    if (this.leadsToApp() && !this.state.isExpanded) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'span',
        { className: 'leads-to-app-hint' },
        'Called from: '
      );
    } else return null;
  },
  renderRepeats: function renderRepeats() {
    var timesRepeated = this.props.timesRepeated;
    if (timesRepeated > 0) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'span',
        {
          className: 'repeated-frames',
          title: 'Frame repeated ' + timesRepeated + ' time' + (timesRepeated === 1 ? '' : 's')
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon-refresh' }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'span',
          null,
          timesRepeated
        )
      );
    } else return null;
  },
  renderDefaultLine: function renderDefaultLine() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_app_components_strictClick__["a" /* default */],
      { onClick: this.isExpandable() ? this.toggleContext : null },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'title' },
        this.renderLeadHint(),
        this.renderDefaultTitle(),
        this.renderRepeats()
      )
    );
  },
  renderNativeLine: function renderNativeLine() {
    var data = this.props.data;
    var hint = this.getFrameHint();
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_app_components_strictClick__["a" /* default */],
      { onClick: this.isExpandable() ? this.toggleContext : null },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'title as-table' },
        this.renderLeadHint(),
        Object(__WEBPACK_IMPORTED_MODULE_10_app_utils__["d" /* defined */])(data.package) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'span',
          { className: 'package', title: data.package },
          trimPackage(data.package)
        ) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'span',
          { className: 'package' },
          '<unknown>'
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'span',
          { className: 'address' },
          data.instructionAddr
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'span',
          { className: 'symbol' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'code',
            null,
            data.function || '<unknown>'
          ),
          ' ',
          data.filename && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'span',
            { className: 'filename' },
            data.filename,
            data.lineNo ? ':' + data.lineNo : ''
          ),
          hint !== null ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'a',
            { key: 'inline', className: 'tip', 'data-title': __WEBPACK_IMPORTED_MODULE_0_lodash_escape___default()(hint) },
            ' ',
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon-question' })
          ) : null,
          this.renderExpander()
        )
      )
    );
  },
  renderLine: function renderLine() {
    switch (this.getPlatform()) {
      case 'objc':
      // fallthrough
      case 'cocoa':
      // fallthrough
      case 'native':
        return this.renderNativeLine();
      default:
        return this.renderDefaultLine();
    }
  },
  render: function render() {
    var data = this.props.data;
    var className = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({
      frame: true,
      'is-expandable': this.isExpandable(),
      expanded: this.state.isExpanded,
      collapsed: !this.state.isExpanded,
      'system-frame': !data.inApp,
      'frame-errors': data.errors,
      'leads-to-app': this.leadsToApp()
    }, this.getPlatform(), true));
    var props = { className: className };

    var context = this.renderContext();

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'li',
      props,
      this.renderLine(),
      context
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Frame);

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);


var TeamActions = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['update', 'updateError', 'updateSuccess', 'fetchAll', 'fetchAllSuccess', 'fetchAllError', 'fetchDetails', 'fetchDetailsSuccess', 'fetchDetailsError', 'createTeam', 'createTeamSuccess', 'createTeamError', 'removeTeam', 'removeTeamSuccess', 'removeTeamError']);

/* harmony default export */ __webpack_exports__["a"] = (TeamActions);

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_idx__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_inlineSvg__ = __webpack_require__(24);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var StyledInlineSvg = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_6_app_components_inlineSvg__["a" /* default */], {
  target: 'e1jdcnj10'
})('display:block;color:', function (p) {
  return p.theme.gray3;
}, ';');

var FormField = (_temp = _class = function (_React$PureComponent) {
  _inherits(FormField, _React$PureComponent);

  function FormField(props, context) {
    _classCallCheck(this, FormField);

    var _this = _possibleConstructorReturn(this, (FormField.__proto__ || Object.getPrototypeOf(FormField)).call(this, props, context));

    _this.onChange = function (e) {
      var value = e.target.value;
      _this.setValue(value);
    };

    _this.setValue = function (value) {
      var form = (_this.context || {}).form;
      _this.setState({
        value: value
      }, function () {
        _this.props.onChange && _this.props.onChange(_this.coerceValue(_this.state.value));
        form && form.onFieldChange(_this.props.name, _this.coerceValue(_this.state.value));
      });
    };

    _this.state = {
      error: null,
      value: _this.getValue(props, context)
    };
    return _this;
  }

  _createClass(FormField, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps, nextContext) {
      var newError = this.getError(nextProps, nextContext);
      if (newError != this.state.error) {
        this.setState({ error: newError });
      }
      if (this.props.value !== nextProps.value || Object(__WEBPACK_IMPORTED_MODULE_5_app_utils__["d" /* defined */])(nextContext.form)) {
        var newValue = this.getValue(nextProps, nextContext);
        if (newValue !== this.state.value) {
          this.setValue(newValue);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'getValue',
    value: function getValue(props, context) {
      var form = (context || this.context || {}).form;
      props = props || this.props;
      if (Object(__WEBPACK_IMPORTED_MODULE_5_app_utils__["d" /* defined */])(props.value)) {
        return props.value;
      }
      if (form && form.data.hasOwnProperty(props.name)) {
        return Object(__WEBPACK_IMPORTED_MODULE_5_app_utils__["d" /* defined */])(form.data[props.name]) ? form.data[props.name] : '';
      }
      return Object(__WEBPACK_IMPORTED_MODULE_5_app_utils__["d" /* defined */])(props.defaultValue) ? props.defaultValue : '';
    }
  }, {
    key: 'getError',
    value: function getError(props, context) {
      var _ref;

      var form = (context || this.context || {}).form;
      props = props || this.props;
      if (Object(__WEBPACK_IMPORTED_MODULE_5_app_utils__["d" /* defined */])(props.error)) {
        return props.error;
      }
      return ((_ref = form) != null ? (_ref = _ref.errors) != null ? _ref[props.name] : _ref : _ref) || null;
    }
  }, {
    key: 'getId',
    value: function getId() {
      return 'id-' + this.props.name;
    }
  }, {
    key: 'coerceValue',
    value: function coerceValue(value) {
      return value;
    }
  }, {
    key: 'getField',
    value: function getField() {
      throw new Error('Must be implemented by child.');
    }
  }, {
    key: 'getFinalClassNames',
    value: function getFinalClassNames() {
      var _props = this.props,
          className = _props.className,
          required = _props.required;
      var error = this.state.error;

      return __WEBPACK_IMPORTED_MODULE_0_classnames___default()(className, this.getClassName(), {
        'has-error': !!error,
        required: required
      });
    }
  }, {
    key: 'renderDisabledReason',
    value: function renderDisabledReason() {
      var _props2 = this.props,
          disabled = _props2.disabled,
          disabledReason = _props2.disabledReason;

      if (!disabled) return null;
      if (!disabledReason) return null;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'span',
        { className: 'disabled-indicator tip', title: disabledReason },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StyledInlineSvg, { src: 'icon-circle-question', size: '18px' })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          label = _props3.label,
          hideErrorMessage = _props3.hideErrorMessage,
          help = _props3.help,
          style = _props3.style;
      var error = this.state.error;

      var cx = this.getFinalClassNames();
      var shouldShowErrorMessage = error && !hideErrorMessage;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { style: style, className: cx },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'controls' },
          label && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'label',
            { htmlFor: this.getId(), className: 'control-label' },
            label
          ),
          this.getField(),
          this.renderDisabledReason(),
          Object(__WEBPACK_IMPORTED_MODULE_5_app_utils__["d" /* defined */])(help) && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'p',
            { className: 'help-block' },
            help
          ),
          shouldShowErrorMessage && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'p',
            { className: 'error' },
            error
          )
        )
      );
    }
  }]);

  return FormField;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.PureComponent), _class.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  /** Inline style */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  // This is actually used but eslint doesn't parse it correctly
  // eslint-disable-next-line react/no-unused-prop-types
  defaultValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,

  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabledReason: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  help: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hideErrorMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  // the following should only be used without form context
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
}, _class.defaultProps = {
  hideErrorMessage: false,
  disabled: false,
  required: false
}, _class.contextTypes = {
  form: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
}, _temp);


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_avatar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_styles_space__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_styles_overflowEllipsis__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_proptypes__ = __webpack_require__(6);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var BaseBadge = (_temp = _class = function (_React$Component) {
  _inherits(BaseBadge, _React$Component);

  function BaseBadge() {
    _classCallCheck(this, BaseBadge);

    return _possibleConstructorReturn(this, (BaseBadge.__proto__ || Object.getPrototypeOf(BaseBadge)).apply(this, arguments));
  }

  _createClass(BaseBadge, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          hideAvatar = _props.hideAvatar,
          hideName = _props.hideName,
          avatarSize = _props.avatarSize,
          avatarClassName = _props.avatarClassName,
          displayName = _props.displayName,
          description = _props.description,
          team = _props.team,
          organization = _props.organization,
          project = _props.project;


      var data = {
        team: team,
        organization: organization,
        project: project
      };

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Flex"],
        { align: 'center', className: className },
        !hideAvatar && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StyledAvatar, _extends({
          className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(avatarClassName),
          size: avatarSize }, data)),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          DisplayNameAndDescription,
          null,
          !hideName && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { 'data-test-id': 'badge-display-name' },
            displayName
          ),
          !!description && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            Description,
            null,
            description
          )
        )
      );
    }
  }]);

  return BaseBadge;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  team: __WEBPACK_IMPORTED_MODULE_8_app_proptypes__["e" /* default */].Team,
  organization: __WEBPACK_IMPORTED_MODULE_8_app_proptypes__["e" /* default */].Organization,
  project: __WEBPACK_IMPORTED_MODULE_8_app_proptypes__["e" /* default */].Project,
  /**
   * Avatar size
   */
  avatarSize: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  /**
   * Hides the avatar
   */
  hideAvatar: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  /**
   * Hides the main display name
   */
  hideName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  displayName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  description: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  avatarClassName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
}, _class.defaultProps = {
  avatarSize: 24,
  hideAvatar: false
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (BaseBadge);

var StyledAvatar = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_5_app_components_avatar__["a" /* default */], {
  target: 'e165dl3i0'
})('margin-right:', Object(__WEBPACK_IMPORTED_MODULE_6_app_styles_space__["a" /* default */])(1), ';flex-shrink:0;');

var DisplayNameAndDescription = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Flex"], {
  target: 'e165dl3i1'
})('flex-direction:column;line-height:1;');

var Description = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('div', {
  target: 'e165dl3i2'
})('font-size:0.875em;margin-top:', Object(__WEBPACK_IMPORTED_MODULE_6_app_styles_space__["a" /* default */])(0.25), ';color:', function (p) {
  return p.theme.gray2;
}, ';line-height:14px;', __WEBPACK_IMPORTED_MODULE_7_app_styles_overflowEllipsis__["a" /* default */], ';');

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_letterAvatar__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gravatar__ = __webpack_require__(946);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var DEFAULT_GRAVATAR_SIZE = 64;
var ALLOWED_SIZES = [20, 32, 36, 48, 52, 64, 80, 96, 120];
var DEFAULT_REMOTE_SIZE = 120;

var BaseAvatar = (_temp = _class = function (_React$Component) {
  _inherits(BaseAvatar, _React$Component);

  function BaseAvatar(props) {
    _classCallCheck(this, BaseAvatar);

    var _this = _possibleConstructorReturn(this, (BaseAvatar.__proto__ || Object.getPrototypeOf(BaseAvatar)).call(this, props));

    _this.getRemoteImageSize = function () {
      var _this$props = _this.props,
          remoteImageSize = _this$props.remoteImageSize,
          size = _this$props.size;
      // Try to make sure remote image size is >= requested size
      // If requested size > allowed size then use the largest allowed size

      var allowed = size && (ALLOWED_SIZES.find(function (allowedSize) {
        return allowedSize >= size;
      }) || ALLOWED_SIZES[ALLOWED_SIZES.length - 1]);

      return remoteImageSize || allowed || DEFAULT_GRAVATAR_SIZE;
    };

    _this.buildUploadUrl = function () {
      var _this$props2 = _this.props,
          uploadPath = _this$props2.uploadPath,
          uploadId = _this$props2.uploadId;


      return '/' + (uploadPath || 'avatar') + '/' + uploadId + '/?' + __WEBPACK_IMPORTED_MODULE_3_query_string___default.a.stringify({
        s: DEFAULT_REMOTE_SIZE
      });
    };

    _this.handleLoad = function () {
      _this.setState({ showBackupAvatar: false });
    };

    _this.handleError = function () {
      _this.setState({ showBackupAvatar: true, loadError: true });
    };

    _this.renderImg = function () {
      if (_this.state.loadError) {
        return null;
      }

      var _this$props3 = _this.props,
          type = _this$props3.type,
          round = _this$props3.round,
          gravatarId = _this$props3.gravatarId;


      var eventProps = {
        onError: _this.handleError,
        onLoad: _this.handleLoad
      };

      if (type === 'gravatar') {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__gravatar__["a" /* default */], _extends({
          placeholder: _this.props.default,
          gravatarId: gravatarId,
          round: round,
          remoteSize: DEFAULT_REMOTE_SIZE
        }, eventProps));
      }

      if (type === 'upload') {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Image, _extends({ round: round, src: _this.buildUploadUrl() }, eventProps));
      }

      return _this.renderLetterAvatar();
    };

    _this.state = {
      showBackupAvatar: false,
      loadError: false
    };
    return _this;
  }

  _createClass(BaseAvatar, [{
    key: 'renderLetterAvatar',
    value: function renderLetterAvatar() {
      var _props = this.props,
          title = _props.title,
          letterId = _props.letterId,
          round = _props.round;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_letterAvatar__["a" /* default */], { round: round, displayName: title, identifier: letterId });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          hasTooltip = _props2.hasTooltip,
          size = _props2.size,
          tooltip = _props2.tooltip,
          tooltipOptions = _props2.tooltipOptions,
          style = _props2.style;

      var sizeStyle = {};

      if (size) {
        sizeStyle = {
          width: size + 'px',
          height: size + 'px'
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_app_components_tooltip__["default"],
        { title: tooltip, tooltipOptions: tooltipOptions, disabled: !hasTooltip },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          StyledBaseAvatar,
          {
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('avatar', className),
            style: _extends({}, sizeStyle, style)
          },
          this.state.showBackupAvatar && this.renderLetterAvatar(),
          this.renderImg()
        )
      );
    }
  }]);

  return BaseAvatar;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  size: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  /**
   * This is the size of the remote image to request.
   */
  remoteImageSize: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(ALLOWED_SIZES),
  /**
   * Default gravatar to display
   */
  default: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  hasTooltip: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  /**
   * Path to uploaded avatar (differs based on model type)
   */
  uploadPath: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['avatar', 'team-avatar', 'organization-avatar', 'project-avatar']),
  uploadId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  gravatarId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  letterId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  tooltip: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  tooltipOptions: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  /**
   * Should avatar be round instead of a square
   */
  round: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _class.defaultProps = {
  // No default size to ease transition from CSS defined sizes
  // size: 64,
  style: {},
  hasTooltip: false,
  type: 'letter_avatar',
  uploadPath: 'avatar'
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (BaseAvatar);

// Note: Avatar will not always be a child of a flex layout, but this seems like a
// sensible default.
var StyledBaseAvatar = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('span', {
  target: 'e1z0ohzl0'
})('flex-shrink:0;');

var Image = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('img', {
  target: 'e1z0ohzl1'
})(__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* imageStyle */], ';');

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);


var OrganizationsActions = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['update', 'setActive', 'changeSlug', 'remove', 'removeSuccess', 'removeError']);

/* harmony default export */ __webpack_exports__["a"] = (OrganizationsActions);

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Form; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_forms_state__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Form = (_temp = _class = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form(props, context) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props, context));

    _this.onSubmit = function (e) {
      e.preventDefault();
      _this.props.onSubmit(_this.state.data, _this.onSubmitSuccess, _this.onSubmitError);
    };

    _this.onSubmitSuccess = function (data) {
      var curData = _this.state.data;
      var newData = {};
      if (data) {
        Object.keys(curData).forEach(function (k) {
          if (data.hasOwnProperty(k)) newData[k] = data[k];else newData[k] = curData[k];
        });
      } else {
        newData = curData;
      }

      _this.setState({
        state: __WEBPACK_IMPORTED_MODULE_3_app_components_forms_state__["a" /* default */].READY,
        errors: {},
        initialData: newData
      });
      _this.props.onSubmitSuccess && _this.props.onSubmitSuccess(data);
    };

    _this.onSubmitError = function (error) {
      _this.setState({
        state: __WEBPACK_IMPORTED_MODULE_3_app_components_forms_state__["a" /* default */].ERROR,
        errors: error.responseJSON
      });

      if (_this.props.resetOnError) {
        _this.setState({
          initialData: {}
        });
      }

      _this.props.onSubmitError && _this.props.onSubmitError(error);
    };

    _this.onFieldChange = function (name, value) {
      _this.setState(function (state) {
        return {
          data: _extends({}, state.data, _defineProperty({}, name, value))
        };
      });
    };

    _this.state = {
      data: _extends({}, _this.props.initialData),
      errors: {},
      initialData: _extends({}, _this.props.initialData),
      state: __WEBPACK_IMPORTED_MODULE_3_app_components_forms_state__["a" /* default */].READY
    };
    return _this;
  }

  _createClass(Form, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _state = this.state,
          data = _state.data,
          errors = _state.errors;

      return {
        form: {
          data: data,
          errors: errors,
          onFieldChange: this.onFieldChange
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var isSaving = this.state.state === __WEBPACK_IMPORTED_MODULE_3_app_components_forms_state__["a" /* default */].SAVING;
      var _state2 = this.state,
          initialData = _state2.initialData,
          data = _state2.data;
      var _props = this.props,
          errorMessage = _props.errorMessage,
          hideErrors = _props.hideErrors,
          requireChanges = _props.requireChanges;

      var hasChanges = requireChanges ? Object.keys(data).length && !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(data, initialData) : true;
      var isError = this.state.state == __WEBPACK_IMPORTED_MODULE_3_app_components_forms_state__["a" /* default */].ERROR;
      var nonFieldErrors = this.state.errors && this.state.errors.non_field_errors;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'form',
        { onSubmit: this.onSubmit, className: this.props.className },
        isError && !hideErrors && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'alert alert-error alert-block' },
          nonFieldErrors ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'p',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Unable to save your changes. Please correct the following errors try again.')
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'ul',
              null,
              nonFieldErrors.map(function (e, i) {
                return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'li',
                  { key: i },
                  e
                );
              })
            )
          ) : errorMessage
        ),
        this.props.children,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: this.props.footerClass, style: { marginTop: 25 } },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'button',
            {
              className: 'btn btn-primary',
              disabled: isSaving || this.props.submitDisabled || !hasChanges,
              type: 'submit'
            },
            this.props.submitLabel
          ),
          this.props.onCancel && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-default',
              disabled: isSaving,
              onClick: this.props.onCancel,
              style: { marginLeft: 5 }
            },
            this.props.cancelLabel
          ),
          this.props.extraButton
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  cancelLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onSubmitSuccess: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSubmitError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  submitDisabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  submitLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  footerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  extraButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  initialData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  requireChanges: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  errorMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  hideErrors: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  resetOnError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class.defaultProps = {
  cancelLabel: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Cancel'),
  submitLabel: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Save Changes'),
  submitDisabled: false,
  footerClass: 'form-actions align-right',
  className: 'form-stacked',
  requireChanges: false,
  hideErrors: false,
  resetOnError: false,
  errorMessage: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Unable to save your changes. Please ensure all fields are valid and try again.')
}, _class.childContextTypes = {
  form: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
}, _temp);


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _resetStore */
/* harmony export (immutable) */ __webpack_exports__["a"] = activate;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteInstance;
/* harmony export (immutable) */ __webpack_exports__["c"] = findBindingForEvent;
/* harmony export (immutable) */ __webpack_exports__["d"] = getBinding;
/* harmony export (immutable) */ __webpack_exports__["e"] = getInstances;
/* harmony export (immutable) */ __webpack_exports__["f"] = isEmpty;
/* harmony export (immutable) */ __webpack_exports__["g"] = setBinding;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_match_keys__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_parse_keys__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_uuid__ = __webpack_require__(978);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * @module store
 *
 */




/**
 * private
 *
 */

// dict for class prototypes => bindings
var _handlers = new Map();

// all mounted instances that have keybindings
var _instances = new Set();

// for testing
function _resetStore() {
  _handlers.clear();
  _instances.clear();
}

/**
 * activate
 *
 * @access public
 * @param {object} instance Instantiated class that extended React.Component, to be focused to receive keydown events
 */
function activate(instances) {
  var instancesArray = [].concat(instances);

  // if no components were found as ancestors of the event target,
  // effectively deactivate keydown handling by capping the set of instances
  // with `null`.
  if (!instancesArray.length) {
    _instances.add(null);
  } else {
    _instances.delete(null);

    // deleting and then adding the instance(s) has the effect of sorting the set
    // according to instance activation (ascending)
    instancesArray.forEach(function (instance) {
      _instances.delete(instance);
      _instances.add(instance);
    });
  }
};

/**
 * deleteInstance
 *
 * @access public
 * @param {object} target Instantiated class that extended React.Component
 * @return {boolean} The value set.has( target ) would have returned prior to deletion
 */
function deleteInstance(target) {
  _instances.delete(target);
};

function findBindingForEvent(event) {
  if (!_instances.has(null)) {
    var keyMatchesEvent = function keyMatchesEvent(keySet) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__lib_match_keys__["a" /* default */])({ keySet: keySet, event: event });
    };

    // loop through instances in reverse activation order so that most
    // recently activated instance gets first dibs on event
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = [].concat(_toConsumableArray(_instances)).reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var instance = _step.value;

        var bindings = getBinding(instance.constructor.prototype);
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = bindings[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _step2$value = _slicedToArray(_step2.value, 2),
                keySets = _step2$value[0],
                fn = _step2$value[1];

            if (keySets.some(keyMatchesEvent)) {
              // return when matching keybinding is found - i.e. only one
              // keybound component can respond to a given key code. to get around this,
              // scope a common ancestor component class with @keydown and use
              // @keydownScoped to bind the duplicate keys in your child components
              // (or just inspect nextProps.keydown.event).
              return { fn: fn, instance: instance };
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  return null;
};

/**
 * getBinding
 *
 * @access public
 * @param {object} target Class used as key in dict of key bindings
 * @return {object} The object containing bindings for the given class
 */
function getBinding(_ref) {
  var __reactKeydownUUID = _ref.__reactKeydownUUID;

  return _handlers.get(__reactKeydownUUID);
};

/**
 * getInstances
 *
 * @access public
 * @return {set} All stored instances (all mounted component instances with keybindings)
 */
function getInstances() {
  return _instances;
};

/**
 * isEmpty
 *
 * @access public
 * @return {number} Size of the set of all stored instances
 */
function isEmpty() {
  return !_instances.size;
};

/**
 * setBinding
 *
 * @access public
 * @param {object} args All arguments necessary to set the binding
 * @param {array} args.keys Key codes that should trigger the fn
 * @param {function} args.fn The callback to be triggered when given keys are pressed
 * @param {object} args.target The decorated class
 */
function setBinding(_ref2) {
  var keys = _ref2.keys,
      fn = _ref2.fn,
      target = _ref2.target;

  var keySets = Object(__WEBPACK_IMPORTED_MODULE_1__lib_parse_keys__["a" /* default */])(keys);

  var __reactKeydownUUID = target.__reactKeydownUUID;

  if (!__reactKeydownUUID) {
    target.__reactKeydownUUID = Object(__WEBPACK_IMPORTED_MODULE_2__lib_uuid__["a" /* default */])();
    _handlers.set(target.__reactKeydownUUID, new Map([[keySets, fn]]));
  } else {
    _handlers.get(__reactKeydownUUID).set(keySets, fn);
  }
};

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return modifiers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_KEYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ALL_PRINTABLE_KEYS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_symbol__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_es6_symbol__);


// TODO: Need better, more complete, and more methodical key definitions

var Keys = {
  backspace: 8,
  del: 46,
  delete: 46,
  tab: 9,
  enter: 13,
  'return': 13,
  esc: 27,
  space: 32,
  pageUp: 33,
  pageDown: 34,
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221
};

// Add uppercase versions of keys above for backwards compatibility
Object.keys(Keys).forEach(function (key) {
  return Keys[key.toUpperCase()] = Keys[key];
});

'0123456789'.split('').forEach(function (num, index) {
  return Keys[num] = index + 48;
});

'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').forEach(function (letter, index) {
  Keys[letter] = index + 65;
  Keys[letter.toLowerCase()] = index + 65;
});

// fn keys
[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].forEach(function (item, index) {
  return Keys['f' + index] = 111 + index;
});

var modifiers = {
  control: 'ctrl',
  ctrl: 'ctrl',
  shift: 'shift',
  meta: 'meta',
  cmd: 'meta',
  command: 'meta',
  option: 'alt',
  alt: 'alt'
};

var ALL_KEYS = Symbol('ALL_KEYS');

var ALL_PRINTABLE_KEYS = Symbol('ALL_PRINTABLE_KEYS');

/* harmony default export */ __webpack_exports__["c"] = (Keys);

/***/ }),
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(991)();
}


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return onboardingSteps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stepDescriptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return flattenedPlatforms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return categoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPlatformName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_integration_docs_platforms__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_integration_docs_platforms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_integration_docs_platforms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_locale__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ref;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// import {platforms} from '../../../../../integration-docs/_platforms.json';
// eslint-disable-next-line import/extensions



var popular = ['javascript', 'javascript-react', 'python-django', 'python', 'python-flask', 'ruby-rails', 'node-express', 'php-laravel', 'php-symfony2', 'java', 'csharp', 'exilir', 'php', 'ruby', 'node', 'cocoa', 'javascript-angular'];

var frontend = ['javascript', 'javascript-react', 'javascript-angular', 'javascript-angularjs', 'javascript-backbone', 'javascript-ember', 'javascript-vue'];

var mobile = ['objc', 'swift', 'java-android', 'cocoa', 'cordova'];

var backend = ['go', 'go-http', 'java-appengine', 'java', 'java-log4j', 'java-log4j2', 'java-logback', 'java-logging', 'node', 'node-express', 'node-koa', 'node-connect', 'csharp', 'php', 'php-laravel', 'php-monolog', 'php-symfony2', 'python', 'python-django', 'python-flask', 'python-celery', 'python-bottle', 'python-pylons', 'python-pyramid', 'python-tornado', 'python-rq', 'ruby', 'ruby-rails', 'ruby-rack', 'rust', 'elixir'];

var desktop = ['cocoa', 'csharp', 'java', 'electron', 'minidump'];

var categoryList = [{ id: 'popular', name: Object(__WEBPACK_IMPORTED_MODULE_1_app_locale__["t"])('Popular'), platforms: popular }, { id: 'browser', name: Object(__WEBPACK_IMPORTED_MODULE_1_app_locale__["t"])('Browser'), platforms: frontend }, { id: 'server', name: Object(__WEBPACK_IMPORTED_MODULE_1_app_locale__["t"])('Server'), platforms: backend }, { id: 'mobile', name: Object(__WEBPACK_IMPORTED_MODULE_1_app_locale__["t"])('Mobile'), platforms: mobile }, { id: 'desktop', name: Object(__WEBPACK_IMPORTED_MODULE_1_app_locale__["t"])('Desktop'), platforms: desktop }];

var additional = __WEBPACK_IMPORTED_MODULE_0_integration_docs_platforms__["platforms"].concat({
  integrations: [{
    link: 'https://docs.getsentry.com/hosted/clients/',
    type: 'language',
    id: 'other',
    name: Object(__WEBPACK_IMPORTED_MODULE_1_app_locale__["t"])('Other')
  }],
  id: 'other',
  name: Object(__WEBPACK_IMPORTED_MODULE_1_app_locale__["t"])('Other')
});

var flattenedPlatforms = (_ref = []).concat.apply(_ref, [[]].concat(_toConsumableArray(additional.map(function (language) {
  return language.integrations.map(function (i) {
    return _extends({}, i, { language: language.id });
  });
}))));

var onboardingSteps = { organization: 0, project: 1, configure: 2 };

var stepDescriptions = {
  organization: Object(__WEBPACK_IMPORTED_MODULE_1_app_locale__["t"])('Create an organization in Sentry'),
  project: Object(__WEBPACK_IMPORTED_MODULE_1_app_locale__["t"])('Tell us about your project'),
  configure: Object(__WEBPACK_IMPORTED_MODULE_1_app_locale__["t"])('Configure your application and send an event')
};

function getPlatformName(platform) {
  var platformData = flattenedPlatforms.find(function (_ref2) {
    var id = _ref2.id;
    return platform == id;
  });
  return platformData && platformData.name;
}



/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export registry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_plugins_registry__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_plugins_basePlugin__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_plugins_baseContext__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_plugins_defaultIssuePlugin__ = __webpack_require__(528);
/* unused harmony reexport BasePlugin */
/* unused harmony reexport DefaultIssuePlugin */





var contexts = {};
var registry = new __WEBPACK_IMPORTED_MODULE_0_app_plugins_registry__["a" /* default */]();



/* harmony default export */ __webpack_exports__["a"] = ({
  BaseContext: __WEBPACK_IMPORTED_MODULE_2_app_plugins_baseContext__["a" /* default */],
  BasePlugin: __WEBPACK_IMPORTED_MODULE_1_app_plugins_basePlugin__["a" /* default */],
  DefaultIssuePlugin: __WEBPACK_IMPORTED_MODULE_3_app_plugins_defaultIssuePlugin__["b" /* default */],

  add: registry.add.bind(registry),
  addContext: function addContext(id, component) {
    contexts[id] = component;
  },
  contexts: contexts,
  get: registry.get.bind(registry),
  isLoaded: registry.isLoaded.bind(registry),
  load: registry.load.bind(registry),
  loadAll: registry.loadAll.bind(registry)
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AvatarList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_avatar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_tooltip__ = __webpack_require__(21);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var AvatarList = (_temp = _class = function (_React$Component) {
  _inherits(AvatarList, _React$Component);

  function AvatarList() {
    _classCallCheck(this, AvatarList);

    return _possibleConstructorReturn(this, (AvatarList.__proto__ || Object.getPrototypeOf(AvatarList)).apply(this, arguments));
  }

  _createClass(AvatarList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          users = _props.users,
          avatarSize = _props.avatarSize,
          maxVisibleAvatars = _props.maxVisibleAvatars,
          tooltipOptions = _props.tooltipOptions,
          renderTooltip = _props.renderTooltip,
          typeMembers = _props.typeMembers;

      var visibleUsers = users.slice(0, maxVisibleAvatars);
      var numCollapsedUsers = users.length - visibleUsers.length;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_grid_emotion__["Flex"],
        { direction: 'row-reverse' },
        !!numCollapsedUsers && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_app_components_tooltip__["default"],
          { title: numCollapsedUsers + ' other ' + typeMembers },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            CollapsedUsers,
            { size: avatarSize },
            numCollapsedUsers < 99 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              Plus,
              null,
              '+'
            ),
            numCollapsedUsers
          )
        ),
        visibleUsers.map(function (user) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledAvatar, {
            key: user.id,
            user: user,
            size: avatarSize,
            renderTooltip: renderTooltip,
            tooltipOptions: tooltipOptions,
            hasTooltip: true
          });
        })
      );
    }
  }]);

  return AvatarList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  users: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].User).isRequired,
  avatarSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  maxVisibleAvatars: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  renderTooltip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  tooltipOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  typeMembers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  avatarSize: 28,
  maxVisibleAvatars: 5,
  typeMembers: 'users'
}, _temp);



var Circle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["css"])('border-radius:50%;border:2px solid white;margin-left:-8px;cursor:default;&:hover{z-index:1;}');

var StyledAvatar = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_5_app_components_avatar__["a" /* default */], {
  target: 'e1axh4r50'
})('overflow:hidden;', Circle, ';');

var CollapsedUsers = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'e1axh4r51'
})('display:flex;align-items:center;justify-content:center;position:relative;text-align:center;font-weight:600;background-color:', function (p) {
  return p.theme.borderLight;
}, ';color:', function (p) {
  return p.theme.gray2;
}, ';font-size:', function (p) {
  return Math.floor(p.size / 2.3);
}, 'px;width:', function (p) {
  return p.size;
}, 'px;height:', function (p) {
  return p.size;
}, 'px;', Circle, ';');

var Plus = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('span', {
  target: 'e1axh4r52'
})('font-size:10px;margin-left:1px;margin-right:-1px;');

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_intersection__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_intersection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_intersection__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Hovercard = (_temp = _class = function (_React$Component) {
  _inherits(Hovercard, _React$Component);

  function Hovercard() {
    var _ref;

    _classCallCheck(this, Hovercard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = Hovercard.__proto__ || Object.getPrototypeOf(Hovercard)).call.apply(_ref, [this].concat(args)));

    _this.handleToggleOn = function () {
      return _this.toggleHovercard(true);
    };

    _this.handleToggleOff = function () {
      return _this.toggleHovercard(false);
    };

    _this.toggleHovercard = function (visible) {
      var _this$props = _this.props,
          header = _this$props.header,
          body = _this$props.body;

      // Don't toggle hovercard if both of these are null

      if (!header && !body) return;

      if (_this.hoverWait !== null) {
        clearTimeout(_this.hoverWait);
      }

      var rendered = visible;
      var timeout = _this.props.displayTimeout;

      // Immediately render the hovercard, but don't mark it as visible until
      // after the delay period. This allows us to compute the size of the
      // hovercard to position it before it is made visible.
      if (visible) {
        _this.setState({ rendered: rendered });
      }

      _this.hoverWait = setTimeout(function () {
        return _this.setState({ visible: visible, rendered: rendered });
      }, timeout);
    };

    _this.state = {
      visible: false,
      rendered: false
    };
    _this.hoverWait = null;
    _this.cardElement = null;
    return _this;
  }

  _createClass(Hovercard, [{
    key: 'positionClasses',
    value: function positionClasses() {
      if (!this.cardElement || !this.state.visible) return {};
      var rect = this.cardElement.getBoundingClientRect();

      var classes = {
        'hovercard-bottom': rect.top < 0,
        'hovercard-left': rect.left < 0,
        'hovercard-right': rect.right > window.innerWidth && !(rect.left < 0)
      };

      // If it's already been given a positon class do not use the recomputed
      // position classes, since they will have been computed from it's new
      // current correct position. Use the previous positions.
      var currentClasses = __WEBPACK_IMPORTED_MODULE_3_lodash_intersection___default()(this.cardElement.classList, Object.keys(classes));

      return currentClasses.length > 0 ? currentClasses : classes;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          containerClassName = _props.containerClassName,
          className = _props.className,
          header = _props.header,
          body = _props.body;
      var _state = this.state,
          rendered = _state.rendered,
          visible = _state.visible;


      var containerCx = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('hovercard-container', containerClassName);
      var cx = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('hovercard', this.positionClasses(), className, {
        'with-header': header,
        visible: visible
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        {
          className: containerCx,
          onMouseEnter: this.handleToggleOn,
          onMouseLeave: this.handleToggleOff
        },
        this.props.children,
        rendered && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          {
            className: cx,
            ref: function ref(e) {
              _this2.cardElement = e;
            }
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'hovercard-hoverlap' }),
          header && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'hovercard-header' },
            header
          ),
          body && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'hovercard-body' },
            body
          )
        )
      );
    }
  }]);

  return Hovercard;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  displayTimeout: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  containerClassName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  header: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  body: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node
}, _class.defaultProps = {
  displayTimeout: 100
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (Hovercard);

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_mixins_organizationState__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_views_organizationDashboard_projectNav__ = __webpack_require__(546);






var HomeContainer = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'HomeContainer',

  mixins: [__WEBPACK_IMPORTED_MODULE_2_app_mixins_organizationState__["a" /* default */]],

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: (this.props.className || '') + ' organization-home' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_views_organizationDashboard_projectNav__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        this.props.children
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["default"] = (HomeContainer);

/***/ }),
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = replaceRouterParams;
function replaceRouterParams(route, params) {
  // parse route params from route
  var matches = route.match(/:\w+/g);

  if (!matches || !matches.length) {
    return route;
  }

  // replace with current params
  matches.forEach(function (param) {
    var paramName = param.slice(1);
    if (typeof params[paramName] === 'undefined') return;

    route = route.replace(param, params[paramName]);
  });

  return route;
}

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IdBadge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_errorBoundary__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_idBadge_baseBadge__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_idBadge_userBadge__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_idBadge_teamBadge__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_idBadge_projectBadge__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_idBadge_organizationBadge__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_proptypes__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var COMPONENT_MAP = new Map([['organization', __WEBPACK_IMPORTED_MODULE_7_app_components_idBadge_organizationBadge__["a" /* default */]], ['project', __WEBPACK_IMPORTED_MODULE_6_app_components_idBadge_projectBadge__["a" /* default */]], ['member', __WEBPACK_IMPORTED_MODULE_4_app_components_idBadge_userBadge__["a" /* default */]], ['user', __WEBPACK_IMPORTED_MODULE_4_app_components_idBadge_userBadge__["a" /* default */]], ['team', __WEBPACK_IMPORTED_MODULE_5_app_components_idBadge_teamBadge__["a" /* default */]]]);

/**
 * Public interface for all "id badges":
 * Organization, project, team, user
 */
var IdBadge = (_temp = _class = function (_React$Component) {
  _inherits(IdBadge, _React$Component);

  function IdBadge() {
    _classCallCheck(this, IdBadge);

    return _possibleConstructorReturn(this, (IdBadge.__proto__ || Object.getPrototypeOf(IdBadge)).apply(this, arguments));
  }

  _createClass(IdBadge, [{
    key: 'render',
    value: function render() {
      // Given the set of sentry types, find the prop name that was passed to this component,
      // of which we have a mapped component for
      var propNameWithData = Object.keys(this.props).find(function (key) {
        return COMPONENT_MAP.has(key);
      });

      if (!propNameWithData) {
        throw new Error('IdBadge: required property missing (organization, project, team, member, user) or misconfigured');
      }

      var Component = COMPONENT_MAP.get(propNameWithData);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        InlineErrorBoundary,
        { mini: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, this.props)
      );
    }
  }]);

  return IdBadge;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_3_app_components_idBadge_baseBadge__["a" /* default */].propTypes, {
  team: __WEBPACK_IMPORTED_MODULE_8_app_proptypes__["e" /* default */].Team,
  project: __WEBPACK_IMPORTED_MODULE_8_app_proptypes__["e" /* default */].Project,
  organization: __WEBPACK_IMPORTED_MODULE_8_app_proptypes__["e" /* default */].Organization,
  member: __WEBPACK_IMPORTED_MODULE_8_app_proptypes__["e" /* default */].Member,
  user: __WEBPACK_IMPORTED_MODULE_8_app_proptypes__["e" /* default */].User
}), _temp);



var InlineErrorBoundary = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_2_app_components_errorBoundary__["default"], {
  target: 'e83vi020'
})('background-color:transparent;border-color:transparent;display:flex;align-items:center;margin-bottom:0;box-shadow:none;padding:0;/* Because badges dont have any padding,so this should make the boundary fit well */');

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_styles_input__ = __webpack_require__(389);




var Input = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react_emotion__["default"])('input', {
  target: 'e1xej46s0'
})(__WEBPACK_IMPORTED_MODULE_1_app_styles_input__["a" /* inputStyles */], ';');

/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Raven) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_constants__ = __webpack_require__(102);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DropdownMenu = (_temp = _class = function (_React$Component) {
  _inherits(DropdownMenu, _React$Component);

  function DropdownMenu() {
    var _ref;

    _classCallCheck(this, DropdownMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = DropdownMenu.__proto__ || Object.getPrototypeOf(DropdownMenu)).call.apply(_ref, [this].concat(args)));

    _initialiseProps.call(_this);

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(DropdownMenu, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.checkClickOutside, true);
    }

    // Gets open state from props or local state when appropriate


    // Checks if click happens inside of dropdown menu (or its button)
    // Closes dropdownmenu if it is "outside"


    // Callback function from <DropdownMenu> to see if we should close menu


    // Opens dropdown menu


    // Decide whether dropdown should be closed when mouse leaves element
    // Only for nested dropdowns


    // Closes dropdown menu


    // When dropdown menu is displayed and mounted to DOM,
    // bind a click handler to `document` to listen for clicks outside of
    // this component and close menu if so


    // Control whether we should hide dropdown menu when it is clicked


    // Actor is the component that will open the dropdown menu


    // Menu is the menu component that <DropdownMenu> will control

  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      // Default anchor = left

      var shouldShowDropdown = this.isOpen();

      return children({
        isOpen: shouldShowDropdown,
        getRootProps: this.getRootProps,
        getActorProps: this.getActorProps,
        getMenuProps: this.getMenuProps
      });
    }
  }]);

  return DropdownMenu;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  onOpen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onClose: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  /**
   * Callback for when we get a click outside of dropdown menus.
   * Useful for when menu is controlled.
   */
  onClickOutside: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,

  /**
   * Callback function to check if we should ignore click outside to
   * hide dropdown menu
   */
  shouldIgnoreClickOutside: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,

  /**
   * If this is set, then this will become a "controlled" component.
   * It will no longer set local state and dropdown visiblity will
   * only follow `isOpen`.
   */
  isOpen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /** Keeps dropdown menu open when menu is clicked */
  keepMenuOpen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  // Compatibility for <DropdownLink>
  // This will change where we attach event handlers
  alwaysRenderMenu: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * If this is set to true, the dropdown behaves as a "nested dropdown" and is
   * triggered on mouse enter and mouse leave
   */
  isNestedDropdown: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _class.defaultProps = {
  keepMenuOpen: false
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.isOpen = function () {
    var isOpen = _this2.props.isOpen;

    var isControlled = typeof isOpen !== 'undefined';
    return isControlled && isOpen || _this2.state.isOpen;
  };

  this.checkClickOutside = function (e) {
    var _props = _this2.props,
        onClickOutside = _props.onClickOutside,
        shouldIgnoreClickOutside = _props.shouldIgnoreClickOutside;


    if (!_this2.dropdownMenu) return;
    // Dropdown menu itself
    if (_this2.dropdownMenu.contains(e.target)) return;

    if (!_this2.dropdownActor) {
      // Log an error, should be lower priority
      Raven.captureException(new Error('DropdownMenu does not have "Actor" attached'), {
        level: 'warning'
      });
    }

    // Button that controls visibility of dropdown menu
    if (_this2.dropdownActor && _this2.dropdownActor.contains(e.target)) return;

    if (typeof shouldIgnoreClickOutside === 'function' && shouldIgnoreClickOutside(e)) return;

    if (typeof onClickOutside === 'function') {
      onClickOutside(e);
    }

    _this2.handleClose(e);
  };

  this.shouldIgnoreClickOutside = function (e) {
    var shouldIgnoreClickOutside = _this2.props.shouldIgnoreClickOutside;

    if (_this2.dropdownActor.contains(e.target)) return true;
    if (typeof shouldIgnoreClickOutside === 'function') {
      return shouldIgnoreClickOutside(e);
    }

    return false;
  };

  this.handleOpen = function (e) {
    var _props2 = _this2.props,
        onOpen = _props2.onOpen,
        isOpen = _props2.isOpen,
        alwaysRenderMenu = _props2.alwaysRenderMenu;

    var isControlled = typeof isOpen !== 'undefined';
    if (!isControlled) {
      _this2.setState({
        isOpen: true
      });
    }

    if (_this2.mouseLeaveId) {
      window.clearTimeout(_this2.mouseLeaveId);
    }

    // If we always render menu (e.g. DropdownLink), then add the check click outside handlers when we open the menu
    // instead of when the menu component mounts. Otherwise we will have many click handlers attached on initial load.
    if (alwaysRenderMenu) {
      document.addEventListener('click', _this2.checkClickOutside, true);
    }

    if (typeof onOpen === 'function') {
      onOpen(e);
    }
  };

  this.handleMouseLeave = function (e) {
    var isNestedDropdown = _this2.props.isNestedDropdown;

    if (!isNestedDropdown) return;

    var toElement = e.toElement || e.relatedTarget;

    try {
      if (_this2.dropdownMenu && !_this2.dropdownMenu.contains(toElement)) {
        _this2.mouseLeaveId = window.setTimeout(function () {
          _this2.handleClose(e);
        }, __WEBPACK_IMPORTED_MODULE_2_app_constants__["h" /* MENU_CLOSE_DELAY */]);
      }
    } catch (err) {
      Raven.captureException(err, {
        event: e,
        toElement: e.toElement,
        relatedTarget: e.relatedTarget
      });
    }
  };

  this.handleClose = function (e) {
    var _props3 = _this2.props,
        onClose = _props3.onClose,
        isOpen = _props3.isOpen,
        alwaysRenderMenu = _props3.alwaysRenderMenu;

    var isControlled = typeof isOpen !== 'undefined';

    if (!isControlled) {
      _this2.setState({ isOpen: false });
    }

    // Clean up click handlers when the menu is closed for menus that are always rendered,
    // otherwise the click handlers get cleaned up when menu is unmounted
    if (alwaysRenderMenu) {
      document.removeEventListener('click', _this2.checkClickOutside, true);
    }

    if (typeof onClose === 'function') {
      onClose(e);
    }
  };

  this.handleMenuMount = function (ref) {
    if (ref && !(ref instanceof HTMLElement)) return;
    var alwaysRenderMenu = _this2.props.alwaysRenderMenu;


    _this2.dropdownMenu = ref;

    // Don't add document event listeners here if we are always rendering menu
    // Instead add when menu is opened
    if (alwaysRenderMenu) return;

    if (_this2.dropdownMenu) {
      // 3rd arg = useCapture = so event capturing vs event bubbling
      document.addEventListener('click', _this2.checkClickOutside, true);
    } else {
      document.removeEventListener('click', _this2.checkClickOutside, true);
    }
  };

  this.handleActorMount = function (ref) {
    if (ref && !(ref instanceof HTMLElement)) return;
    _this2.dropdownActor = ref;
  };

  this.handleToggle = function (e) {
    if (_this2.isOpen()) {
      _this2.handleClose(e);
    } else {
      _this2.handleOpen(e);
    }
  };

  this.handleDropdownMenuClick = function (e) {
    if (_this2.props.keepMenuOpen) return;

    _this2.handleClose(e);
  };

  this.getRootProps = function (props) {
    return props;
  };

  this.getActorProps = function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _onClick = _ref2.onClick,
        _onMouseEnter = _ref2.onMouseEnter,
        _onMouseLeave = _ref2.onMouseLeave,
        isStyled = _ref2.isStyled,
        props = _objectWithoutProperties(_ref2, ['onClick', 'onMouseEnter', 'onMouseLeave', 'isStyled']);

    var isNestedDropdown = _this2.props.isNestedDropdown;

    // Props that the actor needs to have <DropdownMenu> work
    //
    // `isStyled`: with styled-components we need to pass `innerRef` to get DOM el's ref vs `ref` otherwise

    return _extends({}, props, isStyled && { innerRef: _this2.handleActorMount } || {}, {
      ref: !isStyled ? _this2.handleActorMount : undefined,
      onMouseEnter: function onMouseEnter() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        if (typeof _onMouseEnter === 'function') {
          _onMouseEnter.apply(undefined, args);
        }

        // Only handle mouse enter for nested dropdowns
        if (!isNestedDropdown) return;

        if (_this2.mouseLeaveId) window.clearTimeout(_this2.mouseLeaveId);

        _this2.mouseEnterId = window.setTimeout(function () {
          _this2.handleOpen.apply(_this2, args);
        }, __WEBPACK_IMPORTED_MODULE_2_app_constants__["h" /* MENU_CLOSE_DELAY */]);
      },

      onMouseLeave: function onMouseLeave() {
        if (typeof _onMouseLeave === 'function') {
          _onMouseLeave.apply(undefined, arguments);
        }

        if (_this2.mouseEnterId) window.clearTimeout(_this2.mouseEnterId);
        _this2.handleMouseLeave.apply(_this2, arguments);
      },
      onClick: function onClick() {
        // Note: clicking on an actor that has a nested menu will close the dropdown menus
        // This is because we currently do not try to find the deepest non-nested dropdown menu
        _this2.handleToggle.apply(_this2, arguments);

        if (typeof _onClick === 'function') {
          _onClick.apply(undefined, arguments);
        }
      }
    });
  };

  this.getMenuProps = function () {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _onClick2 = _ref3.onClick,
        _onMouseLeave2 = _ref3.onMouseLeave,
        _onMouseEnter2 = _ref3.onMouseEnter,
        isStyled = _ref3.isStyled,
        props = _objectWithoutProperties(_ref3, ['onClick', 'onMouseLeave', 'onMouseEnter', 'isStyled']);

    // Props that the menu needs to have <DropdownMenu> work
    //
    // `isStyled`: with styled-components we need to pass `innerRef` to get DOM el's ref vs `ref` otherwise
    return _extends({}, props, isStyled && { innerRef: _this2.handleMenuMount } || {}, {
      ref: !isStyled ? _this2.handleMenuMount : undefined,
      onMouseEnter: function onMouseEnter() {
        if (typeof _onMouseEnter2 === 'function') {
          _onMouseEnter2.apply(undefined, arguments);
        }

        // There is a delay before closing a menu on mouse leave, cancel this action if mouse enters menu again
        if (_this2.mouseLeaveId) {
          window.clearTimeout(_this2.mouseLeaveId);
        }
      },
      onMouseLeave: function onMouseLeave() {
        if (typeof _onMouseLeave2 === 'function') {
          _onMouseLeave2.apply(undefined, arguments);
        }

        _this2.handleMouseLeave.apply(_this2, arguments);
      },
      onClick: function onClick(e) {
        // Note: clicking on an actor that has a nested menu will close the dropdown menus
        // This is because we currently do not try to find the deepest non-nested dropdown menu
        _this2.handleDropdownMenuClick(e);

        if (typeof _onClick2 === 'function') {
          _onClick2(e);
        }
      }
    });
  };
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (DropdownMenu);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(40)))

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(920),
    isFlattenable = __webpack_require__(921);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_stores_projectsStore__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_proptypes__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








/**
 * Higher order component that uses ProjectsStore and provides a list of projects
 */
var withProjects = function withProjects(WrappedComponent) {
  return __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
    displayName: 'withProjects',
    propTypes: {
      organization: __WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Organization,
      project: __WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Project
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_2_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_3_app_stores_projectsStore__["a" /* default */], 'onProjectUpdate')],
    getInitialState: function getInitialState() {
      return {
        projects: __WEBPACK_IMPORTED_MODULE_3_app_stores_projectsStore__["a" /* default */].getAll()
      };
    },
    onProjectUpdate: function onProjectUpdate() {
      this.setState({
        projects: __WEBPACK_IMPORTED_MODULE_3_app_stores_projectsStore__["a" /* default */].getAll()
      });
    },
    render: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, { projects: this.state.projects }));
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (withProjects);

/***/ }),
/* 272 */,
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Duration = (_temp2 = _class = function (_React$Component) {
  _inherits(Duration, _React$Component);

  function Duration() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Duration);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Duration.__proto__ || Object.getPrototypeOf(Duration)).call.apply(_ref, [this].concat(args))), _this), _this.getDuration = function () {
      var value = Math.abs(_this.props.seconds * 1000);
      var result = '';

      if (value >= 604800000) {
        // one week
        result = Math.round(value / 604800000);
        result = result !== 1 ? result + ' weeks' : result + ' week';
      } else if (value >= 172800000) {
        // two days
        result = Math.round(value / 86400000);
        result = result !== 1 ? result + ' days' : result + ' day';
      } else if (value >= 7200000) {
        result = Math.round(value / 3600000);
        result = result !== 1 ? result + ' hours' : result + ' hour';
      } else if (value >= 120000) {
        result = Math.round(value / 60000);
        result = result !== 1 ? result + ' minutes' : result + ' minute';
      } else if (value >= 1000) {
        result = Math.round(value / 1000);
        result = result !== 1 ? result + ' seconds' : result + ' second';
      } else {
        result = Math.round(value) + ' ms';
      }

      return result;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Duration, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { className: this.props.className },
        this.getDuration()
      );
    }
  }]);

  return Duration;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  seconds: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (Duration);

/***/ }),
/* 274 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TextareaField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_forms_inputField__ = __webpack_require__(86);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var TextareaField = function (_InputField) {
  _inherits(TextareaField, _InputField);

  function TextareaField() {
    _classCallCheck(this, TextareaField);

    return _possibleConstructorReturn(this, (TextareaField.__proto__ || Object.getPrototypeOf(TextareaField)).apply(this, arguments));
  }

  _createClass(TextareaField, [{
    key: 'getField',
    value: function getField() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', _extends({
        id: this.getId(),
        ref: 'input',
        className: 'form-control',
        value: this.state.value,
        disabled: this.props.disabled,
        required: this.props.required,
        placeholder: this.props.placeholder,
        onChange: this.onChange.bind(this)
      }, this.getAttributes));
    }
  }]);

  return TextareaField;
}(__WEBPACK_IMPORTED_MODULE_1_app_components_forms_inputField__["a" /* default */]);



/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forceCheck = exports.lazyload = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(31);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _event = __webpack_require__(1153);

var _scrollParent = __webpack_require__(1154);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

var _debounce = __webpack_require__(1155);

var _debounce2 = _interopRequireDefault(_debounce);

var _throttle = __webpack_require__(1156);

var _throttle2 = _interopRequireDefault(_throttle);

var _decorator = __webpack_require__(1157);

var _decorator2 = _interopRequireDefault(_decorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var defaultBoundingClientRect = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
var LISTEN_FLAG = 'data-lazyload-listened';
var listeners = [];
var pending = [];

// try to handle passive events
var passiveEventSupported = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      passiveEventSupported = true;
    }
  });
  window.addEventListener('test', null, opts);
} catch (e) {}
// if they are supported, setup the optional params
// IMPORTANT: FALSE doubles as the default CAPTURE value!
var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;

/**
 * Check if `component` is visible in overflow container `parent`
 * @param  {node} component React component
 * @param  {node} parent    component's scroll parent
 * @return {bool}
 */
var checkOverflowVisible = function checkOverflowVisible(component, parent) {
  var node = _reactDom2.default.findDOMNode(component);

  var parentTop = void 0;
  var parentHeight = void 0;

  try {
    var _parent$getBoundingCl = parent.getBoundingClientRect();

    parentTop = _parent$getBoundingCl.top;
    parentHeight = _parent$getBoundingCl.height;
  } catch (e) {
    parentTop = defaultBoundingClientRect.top;
    parentHeight = defaultBoundingClientRect.height;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;

  // calculate top and height of the intersection of the element's scrollParent and viewport
  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height

  // check whether the element is visible in the intersection
  var top = void 0;
  var height = void 0;

  try {
    var _node$getBoundingClie = node.getBoundingClientRect();

    top = _node$getBoundingClie.top;
    height = _node$getBoundingClie.height;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    height = defaultBoundingClientRect.height;
  }

  var offsetTop = top - intersectionTop; // element's top relative to intersection

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0;
};

/**
 * Check if `component` is visible in document
 * @param  {node} component React component
 * @return {bool}
 */
var checkNormalVisible = function checkNormalVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);

  // If this element is hidden by css rules somehow, it's definitely invisible
  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;

  var top = void 0;
  var elementHeight = void 0;

  try {
    var _node$getBoundingClie2 = node.getBoundingClientRect();

    top = _node$getBoundingClie2.top;
    elementHeight = _node$getBoundingClie2.height;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    elementHeight = defaultBoundingClientRect.height;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
};

/**
 * Detect if element is visible in viewport, if so, set `visible` state to true.
 * If `once` prop is provided true, remove component as listener after checkVisible
 *
 * @param  {React} component   React component that respond to scroll and resize
 */
var checkVisible = function checkVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);
  if (!node) {
    return;
  }

  var parent = (0, _scrollParent2.default)(node);
  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
  if (visible) {
    // Avoid extra render if previously is visible
    if (!component.visible) {
      if (component.props.once) {
        pending.push(component);
      }

      component.visible = true;
      component.forceUpdate();
    }
  } else if (!(component.props.once && component.visible)) {
    component.visible = false;
    if (component.props.unmountIfInvisible) {
      component.forceUpdate();
    }
  }
};

var purgePending = function purgePending() {
  pending.forEach(function (component) {
    var index = listeners.indexOf(component);
    if (index !== -1) {
      listeners.splice(index, 1);
    }
  });

  pending = [];
};

var lazyLoadHandler = function lazyLoadHandler() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    checkVisible(listener);
  }
  // Remove `once` component in listeners
  purgePending();
};

// Depending on component's props
var delayType = void 0;
var finalLazyLoadHandler = null;

var LazyLoad = function (_Component) {
  _inherits(LazyLoad, _Component);

  function LazyLoad(props) {
    _classCallCheck(this, LazyLoad);

    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));

    _this.visible = false;
    return _this;
  }

  _createClass(LazyLoad, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof process !== 'undefined' && "production" !== 'production') {
        if (_react2.default.Children.count(this.props.children) > 1) {
          console.warn('[react-lazyload] Only one child is allowed to be passed to `LazyLoad`.');
        }

        if (this.props.wheel) {
          // eslint-disable-line
          console.warn('[react-lazyload] Props `wheel` is not supported anymore, try set `overflow` for lazy loading in overflow containers.');
        }

        // Warn the user if placeholder and height is not specified and the rendered height is 0
        if (!this.props.placeholder && this.props.height === undefined && _reactDom2.default.findDOMNode(this).offsetHeight === 0) {
          console.warn('[react-lazyload] Please add `height` props to <LazyLoad> for better performance.');
        }
      }

      // It's unlikely to change delay type on the fly, this is mainly
      // designed for tests
      var needResetFinalLazyLoadHandler = false;
      if (this.props.debounce !== undefined && delayType === 'throttle') {
        console.warn('[react-lazyload] Previous delay function is `throttle`, now switching to `debounce`, try setting them unanimously');
        needResetFinalLazyLoadHandler = true;
      } else if (delayType === 'debounce' && this.props.debounce === undefined) {
        console.warn('[react-lazyload] Previous delay function is `debounce`, now switching to `throttle`, try setting them unanimously');
        needResetFinalLazyLoadHandler = true;
      }

      if (needResetFinalLazyLoadHandler) {
        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        finalLazyLoadHandler = null;
      }

      if (!finalLazyLoadHandler) {
        if (this.props.debounce !== undefined) {
          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
          delayType = 'debounce';
        } else if (this.props.throttle !== undefined) {
          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
          delayType = 'throttle';
        } else {
          finalLazyLoadHandler = lazyLoadHandler;
        }
      }

      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
          if (listenerCount === 1) {
            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
          }
          parent.setAttribute(LISTEN_FLAG, listenerCount);
        }
      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
        var _props = this.props,
            scroll = _props.scroll,
            resize = _props.resize;


        if (scroll) {
          (0, _event.on)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
        }

        if (resize) {
          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        }
      }

      listeners.push(this);
      checkVisible(this);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.visible;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
          if (listenerCount === 0) {
            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
            parent.removeAttribute(LISTEN_FLAG);
          } else {
            parent.setAttribute(LISTEN_FLAG, listenerCount);
          }
        }
      }

      var index = listeners.indexOf(this);
      if (index !== -1) {
        listeners.splice(index, 1);
      }

      if (listeners.length === 0) {
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : _react2.default.createElement('div', { style: { height: this.props.height }, className: 'lazyload-placeholder' });
    }
  }]);

  return LazyLoad;
}(_react.Component);

LazyLoad.propTypes = {
  once: _propTypes2.default.bool,
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
  overflow: _propTypes2.default.bool,
  resize: _propTypes2.default.bool,
  scroll: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  placeholder: _propTypes2.default.node,
  unmountIfInvisible: _propTypes2.default.bool
};

LazyLoad.defaultProps = {
  once: false,
  offset: 0,
  overflow: false,
  resize: false,
  scroll: true,
  unmountIfInvisible: false
};

var lazyload = exports.lazyload = _decorator2.default;
exports.default = LazyLoad;
exports.forceCheck = lazyLoadHandler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1152)))

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProjectContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_actionCreators_environments__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_actionCreators_projects__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_stores_memberListStore__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_missingProjectMembership__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_mixins_organizationState__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_stores_projectsStore__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_utils_recreateRoute__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_utils_withProjects__ = __webpack_require__(271);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






















var ERROR_TYPES = {
  MISSING_MEMBERSHIP: 'MISSING_MEMBERSHIP',
  PROJECT_NOT_FOUND: 'PROJECT_NOT_FOUND',
  UNKNOWN: 'UNKNOWN'
};

/**
 * Higher-order component that sets `project` as a child context
 * value to be accessed by child elements.
 *
 * Additionally delays rendering of children until project XHR has finished
 * and context is populated.
 */
var ProjectContext = __WEBPACK_IMPORTED_MODULE_5_create_react_class___default()({
  displayName: 'ProjectContext',

  propTypes: {
    /**
     * If true, this will not change `state.loading` during `fetchData` phase
     */
    skipReload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    projects: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_17_app_proptypes__["e" /* default */].Project),
    projectId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    orgId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    location: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  },

  childContextTypes: {
    project: __WEBPACK_IMPORTED_MODULE_17_app_proptypes__["e" /* default */].Project
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_9_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_4_reflux___default.a.connect(__WEBPACK_IMPORTED_MODULE_12_app_stores_memberListStore__["a" /* default */], 'memberList'), __WEBPACK_IMPORTED_MODULE_4_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_15_app_stores_projectsStore__["a" /* default */], 'onProjectChange'), __WEBPACK_IMPORTED_MODULE_14_app_mixins_organizationState__["a" /* default */]],

  getInitialState: function getInitialState() {
    return {
      loading: true,
      error: false,
      errorType: null,
      memberList: [],
      project: null,
      projectNavSection: null
    };
  },
  getChildContext: function getChildContext() {
    return {
      project: this.state.project
    };
  },
  componentWillMount: function componentWillMount() {
    this.fetchData();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.projectId === this.props.projectId) return;

    if (!nextProps.skipReload) {
      this.remountComponent();
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    if (prevProps.projectId !== this.props.projectId) {
      this.fetchData();
    }

    // Call forceUpdate() on <DocumentTitle/> if either project or organization
    // state has changed. This is because <DocumentTitle/>'s shouldComponentUpdate()
    // returns false unless props differ; meaning context changes for project/org
    // do NOT trigger renders for <DocumentTitle/> OR any subchildren. The end result
    // being that child elements that listen for context changes on project/org will
    // NOT update (without this hack).
    // See: https://github.com/gaearon/react-document-title/issues/35

    // intentionally shallow comparing references
    if (prevState.project !== this.state.project || prevState.organization !== this.state.organization) {
      if (!this.docTitle) return;
      var docTitle = this.docTitleRef.docTitle;
      if (docTitle) docTitle.forceUpdate();
    }
  },
  remountComponent: function remountComponent() {
    this.setState(this.getInitialState());
  },
  getTitle: function getTitle() {
    if (this.state.project) return this.state.project.slug;
    return 'Sentry';
  },
  onProjectChange: function onProjectChange(projectIds) {
    if (!this.state.project) return;
    if (!projectIds.has(this.state.project.id)) return;

    this.setState({
      project: _extends({}, __WEBPACK_IMPORTED_MODULE_15_app_stores_projectsStore__["a" /* default */].getById(this.state.project.id))
    });
  },
  identifyProject: function identifyProject() {
    var _props = this.props,
        projects = _props.projects,
        projectId = _props.projectId;

    var projectSlug = projectId;
    return projects.find(function (_ref) {
      var slug = _ref.slug;
      return slug === projectSlug;
    }) || null;
  },
  fetchData: function fetchData() {
    var _this = this;

    var _props2 = this.props,
        orgId = _props2.orgId,
        projectId = _props2.projectId,
        location = _props2.location,
        skipReload = _props2.skipReload;
    // we fetch core access/information from the global organization data

    var activeProject = this.identifyProject();
    var hasAccess = activeProject && activeProject.hasAccess;

    this.setState(function (state) {
      return {
        // if `skipReload` is true, then don't change loading state
        loading: skipReload ? state.loading : true,
        // we bind project initially, but it'll rebind
        project: activeProject
      };
    });

    if (activeProject && hasAccess) {
      Object(__WEBPACK_IMPORTED_MODULE_7_app_actionCreators_projects__["g" /* setActiveProject */])(null);
      var projectRequest = this.api.requestPromise('/projects/' + orgId + '/' + projectId + '/');

      var environmentRequest = this.api.requestPromise(this.getEnvironmentListEndpoint());

      Promise.all([projectRequest, environmentRequest]).then(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            project = _ref3[0],
            envs = _ref3[1];

        _this.setState({
          loading: false,
          project: project,
          error: false,
          errorType: null
        });

        // assuming here that this means the project is considered the active project
        Object(__WEBPACK_IMPORTED_MODULE_7_app_actionCreators_projects__["g" /* setActiveProject */])(project);

        // If an environment is specified in the query string, load it instead of default
        var queryEnv = location.query.environment;
        // The default environment cannot be "" (No Environment)
        var defaultEnvironment = project.defaultEnvironment;

        var envName = typeof queryEnv === 'undefined' ? defaultEnvironment : queryEnv;
        Object(__WEBPACK_IMPORTED_MODULE_6_app_actionCreators_environments__["c" /* loadEnvironments */])(envs, envName);
      }, function () {
        _this.setState({
          loading: false,
          error: false,
          errorType: ERROR_TYPES.UNKNOWN
        });
      });

      // TODO(dcramer): move member list to organization level
      this.api.request(this.getMemberListEndpoint(), {
        success: function success(data) {
          __WEBPACK_IMPORTED_MODULE_12_app_stores_memberListStore__["a" /* default */].loadInitialData(data.filter(function (m) {
            return m.user;
          }).map(function (m) {
            return m.user;
          }));
        }
      });
    } else if (activeProject && !activeProject.isMember) {
      this.setState({
        loading: false,
        error: true,
        errorType: ERROR_TYPES.MISSING_MEMBERSHIP
      });
    } else {
      // The project may have been renamed, attempt to lookup the project, if
      // we 302 we will receive the moved project slug and can update update
      // our route accordingly.
      var lookupHandler = function lookupHandler(resp) {
        var status = resp.status,
            responseJSON = resp.responseJSON;


        if (status !== 302 || !responseJSON || !responseJSON.detail) {
          _this.setState({
            loading: false,
            error: true,
            errorType: ERROR_TYPES.PROJECT_NOT_FOUND
          });
          return;
        }

        _this.props.router.replace(Object(__WEBPACK_IMPORTED_MODULE_16_app_utils_recreateRoute__["a" /* default */])('', _extends({}, _this.props, {
          params: _extends({}, _this.props.params, { projectId: responseJSON.detail.slug })
        })));
      };

      // The request ill 404 or 302
      this.api.request('/projects/' + orgId + '/' + projectId + '/', { error: lookupHandler });
    }
  },
  getEnvironmentListEndpoint: function getEnvironmentListEndpoint() {
    var _props3 = this.props,
        orgId = _props3.orgId,
        projectId = _props3.projectId;

    return '/projects/' + orgId + '/' + projectId + '/environments/';
  },
  getMemberListEndpoint: function getMemberListEndpoint() {
    var _props4 = this.props,
        orgId = _props4.orgId,
        projectId = _props4.projectId;

    return '/projects/' + orgId + '/' + projectId + '/members/';
  },
  setProjectNavSection: function setProjectNavSection(section) {
    this.setState({
      projectNavSection: section
    });
  },
  renderBody: function renderBody() {
    if (this.state.loading) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: 'loading-full-layout' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_loadingIndicator__["default"], null)
      );
    } else if (this.state.error) {
      switch (this.state.errorType) {
        case ERROR_TYPES.PROJECT_NOT_FOUND:
          // TODO(chrissy): use scale for margin values
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'div',
            { className: 'container' },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'div',
              { className: 'alert alert-block', style: { margin: '30px 0 10px' } },
              Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('The project you were looking for was not found.')
            )
          );
        case ERROR_TYPES.MISSING_MEMBERSHIP:
          // TODO(dcramer): add various controls to improve this flow and break it
          // out into a reusable missing access error component
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_app_components_missingProjectMembership__["a" /* default */], {
            organization: this.getOrganization(),
            projectId: this.state.project.slug
          });
        default:
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_loadingError__["default"], { onRetry: this.remountComponent });
      }
    }

    return this.props.children;
  },
  render: function render() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,
      { ref: function ref(_ref4) {
          return _this2.docTitleRef = _ref4;
        }, title: this.getTitle() },
      this.renderBody()
    );
  }
});



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_18_app_utils_withProjects__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["withRouter"])(ProjectContext)));

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sidebar", function() { return Sidebar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_emotion_theming__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_actionCreators_preferences__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_actionCreators_incidents__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_stores_configStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_inlineSvg__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_stores_preferencesStore__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_utils_theme__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_styles_space__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_utils_withLatestContext__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__broadcasts__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__incidents__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__sidebarDropdown__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__sidebarItem__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__onboardingStatus__ = __webpack_require__(1232);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



























var Sidebar = (_temp = _class = function (_React$Component) {
  _inherits(Sidebar, _React$Component);

  function Sidebar(props) {
    _classCallCheck(this, Sidebar);

    var _this = _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call(this, props));

    _this.toggleSidebar = function () {
      var collapsed = _this.props.collapsed;


      if (!collapsed) {
        Object(__WEBPACK_IMPORTED_MODULE_8_app_actionCreators_preferences__["a" /* hideSidebar */])();
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_8_app_actionCreators_preferences__["c" /* showSidebar */])();
      }
    };

    _this.hashChangeHandler = function () {
      if (window.location.hash == '#welcome') {
        _this.setState({ showTodos: true });
      }
    };

    _this.handleMediaQueryChange = function (changed) {
      _this.setState({
        horizontal: changed.matches
      });
    };

    _this.hidePanel = function () {
      if (!_this.state.sidePanel && _this.state.currentPanel === '') return;

      _this.setState({
        showPanel: false,
        currentPanel: ''
      });
    };

    _this.showPanel = function (panel) {
      _this.setState({
        showPanel: true,
        currentPanel: panel
      });
    };

    _this.togglePanel = function (panel, e) {
      if (_this.state.currentPanel === panel) _this.hidePanel();else _this.showPanel(panel);
    };

    _this.documentClickHandler = function (evt) {
      // If click occurs outside of sidebar, close any active panel
      if (_this.sidebar && !_this.sidebar.contains(evt.target)) {
        _this.hidePanel();
      }
    };

    _this.state = {
      horizontal: false
    };

    if (!window.matchMedia) return _possibleConstructorReturn(_this);
    // TODO(billy): We should consider moving this into a component
    _this.mq = window.matchMedia('(max-width: ' + __WEBPACK_IMPORTED_MODULE_15_app_utils_theme__["default"].breakpoints[0] + ')');
    _this.mq.addListener(_this.handleMediaQueryChange);
    _this.state.horizontal = _this.mq.matches;
    return _this;
  }

  _createClass(Sidebar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var router = this.props.router;

      jQuery(document.body).addClass('body-sidebar');
      jQuery(document).on('click', this.documentClickHandler);

      Object(__WEBPACK_IMPORTED_MODULE_9_app_actionCreators_incidents__["a" /* load */])();

      // router can potentially not exist in server side (django) views
      // Otherwise when we change routes using collapsed sidebar, the tooltips will remain after
      // route changes.
      this.routerListener = router && router.listen(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.tooltip').tooltip('hide');
      });
      this.doCollapse(this.props.collapsed);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          collapsed = _props.collapsed,
          location = _props.location;

      var nextLocation = nextProps.location;

      // Close active panel if we navigated anywhere
      if (nextLocation && location && location.pathname !== nextLocation.pathname) {
        this.hidePanel();
      }

      if (collapsed === nextProps.collapsed) return;

      this.doCollapse(nextProps.collapsed);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      jQuery(document).off('click', this.documentClickHandler);
      jQuery(document.body).removeClass('body-sidebar');

      if (this.mq) {
        this.mq.removeListener(this.handleMediaQueryChange);
        this.mq = null;
      }

      // Unlisten to router changes
      if (this.routerListener) {
        this.routerListener();
      }
    }
  }, {
    key: 'doCollapse',
    value: function doCollapse(collapsed) {
      if (collapsed) {
        jQuery(document.body).addClass('collapsed');
      } else {
        jQuery(document.body).removeClass('collapsed');
      }
    }

    // Hide slideout panel


    // Show slideout panel

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          organization = _props2.organization,
          collapsed = _props2.collapsed;
      var _state = this.state,
          currentPanel = _state.currentPanel,
          showPanel = _state.showPanel,
          horizontal = _state.horizontal;

      var config = __WEBPACK_IMPORTED_MODULE_11_app_stores_configStore__["default"].getConfig();
      var user = __WEBPACK_IMPORTED_MODULE_11_app_stores_configStore__["default"].get('user');
      var hasPanel = !!currentPanel;
      var orientation = horizontal ? 'top' : 'left';
      var sidebarItemProps = {
        orientation: orientation,
        collapsed: collapsed,
        hasPanel: hasPanel
      };
      var hasOrganization = !!organization;

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        StyledSidebar,
        {
          innerRef: function innerRef(ref) {
            return _this2.sidebar = ref;
          },
          collapsed: hasOrganization ? collapsed : true
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          SidebarSectionGroup,
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            SidebarSection,
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__sidebarDropdown__["a" /* default */], {
              onClick: this.hidePanel,
              orientation: orientation,
              collapsed: collapsed,
              org: organization,
              user: user,
              config: config
            })
          ),
          hasOrganization && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              SidebarSection,
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__sidebarItem__["a" /* default */], _extends({}, sidebarItemProps, {
                index: true,
                onClick: this.hidePanel,
                icon: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_inlineSvg__["a" /* default */], { src: 'icon-projects' }),
                label: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Projects'),
                to: '/' + organization.slug + '/'
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              SidebarSection,
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__sidebarItem__["a" /* default */], _extends({}, sidebarItemProps, {
                onClick: this.hidePanel,
                icon: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_inlineSvg__["a" /* default */], { src: 'icon-user' }),
                label: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Assigned to me'),
                to: '/organizations/' + organization.slug + '/issues/assigned/'
              })),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__sidebarItem__["a" /* default */], _extends({}, sidebarItemProps, {
                onClick: this.hidePanel,
                icon: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_inlineSvg__["a" /* default */], { src: 'icon-star' }),
                label: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Bookmarked issues'),
                to: '/organizations/' + organization.slug + '/issues/bookmarks/'
              })),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__sidebarItem__["a" /* default */], _extends({}, sidebarItemProps, {
                onClick: this.hidePanel,
                icon: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_inlineSvg__["a" /* default */], { src: 'icon-history' }),
                label: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Recently viewed'),
                to: '/organizations/' + organization.slug + '/issues/history/'
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              SidebarSection,
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__sidebarItem__["a" /* default */], _extends({}, sidebarItemProps, {
                onClick: this.hidePanel,
                icon: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_inlineSvg__["a" /* default */], { src: 'icon-activity' }),
                label: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Activity'),
                to: '/organizations/' + organization.slug + '/activity/'
              })),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__sidebarItem__["a" /* default */], _extends({}, sidebarItemProps, {
                onClick: this.hidePanel,
                icon: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_inlineSvg__["a" /* default */], { src: 'icon-stats' }),
                label: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Stats'),
                to: '/organizations/' + organization.slug + '/stats/'
              }))
            )
          )
        ),
        hasOrganization && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          SidebarSectionGroup,
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            SidebarSection,
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__broadcasts__["a" /* default */], {
              orientation: orientation,
              collapsed: collapsed,
              showPanel: showPanel,
              currentPanel: currentPanel,
              onShowPanel: function onShowPanel() {
                return _this2.togglePanel('broadcasts');
              },
              hidePanel: this.hidePanel
            }),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__incidents__["a" /* default */], {
              orientation: orientation,
              collapsed: collapsed,
              showPanel: showPanel,
              currentPanel: currentPanel,
              onShowPanel: function onShowPanel() {
                return _this2.togglePanel('statusupdate');
              },
              hidePanel: this.hidePanel
            })
          ),
          !horizontal && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            SidebarSection,
            { noMargin: true },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__onboardingStatus__["a" /* default */], {
              org: organization,
              currentPanel: currentPanel,
              onShowPanel: function onShowPanel() {
                return _this2.togglePanel('todos');
              },
              showPanel: showPanel,
              hidePanel: this.hidePanel,
              collapsed: collapsed
            })
          ),
          !horizontal && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            SidebarSection,
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(SidebarCollapseItem, _extends({
              'data-test-id': 'sidebar-collapse'
            }, sidebarItemProps, {
              icon: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(StyledInlineSvg, { src: 'icon-collapse', collapsed: collapsed }),
              label: collapsed ? Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Expand') : Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Collapse'),
              onClick: this.toggleSidebar
            }))
          )
        )
      );
    }
  }]);

  return Sidebar;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component), _class.propTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  organization: __WEBPACK_IMPORTED_MODULE_13_app_proptypes__["e" /* default */].Organization,
  collapsed: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
}, _temp);


var SidebarContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["withRouter"])(__WEBPACK_IMPORTED_MODULE_6_create_react_class___default()({
  displayName: 'SidebarContainer',
  mixins: [__WEBPACK_IMPORTED_MODULE_5_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_14_app_stores_preferencesStore__["a" /* default */], 'onPreferenceChange')],
  getInitialState: function getInitialState() {
    return {
      collapsed: __WEBPACK_IMPORTED_MODULE_14_app_stores_preferencesStore__["a" /* default */].getInitialState().collapsed
    };
  },
  onPreferenceChange: function onPreferenceChange(store) {
    if (store.collapsed === this.state.collapsed) return;

    this.setState({
      collapsed: store.collapsed
    });
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_emotion_theming__["ThemeProvider"],
      { theme: __WEBPACK_IMPORTED_MODULE_15_app_utils_theme__["default"] },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Sidebar, _extends({}, this.props, { collapsed: this.state.collapsed }))
    );
  }
}));


/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_17_app_utils_withLatestContext__["a" /* default */])(SidebarContainer));

var responsiveFlex = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_7_react_emotion__["css"])('display:flex;flex-direction:column;@media (max-width:', __WEBPACK_IMPORTED_MODULE_15_app_utils_theme__["default"].breakpoints[0], '){flex-direction:row;}');

var StyledSidebar = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_7_react_emotion__["default"])('div', {
  target: 'e1sgxx350'
})('background:', function (p) {
  return p.theme.sidebar.background;
}, ';background:linear-gradient(', function (p) {
  return p.theme.gray4;
}, ',', function (p) {
  return p.theme.gray5;
}, ');color:', function (p) {
  return p.theme.sidebar.color;
}, ';line-height:1;padding:12px 19px 2px;/* Allows for 32px avatars  */\n  width:', function (p) {
  return p.theme.sidebar.expandedWidth;
}, ';position:fixed;top:0;left:0;bottom:0;justify-content:space-between;z-index:', function (p) {
  return p.theme.zIndex.sidebar;
}, ';', responsiveFlex, ';', function (p) {
  return p.collapsed && 'width: ' + p.theme.sidebar.collapsedWidth + ';';
}, ';@media (max-width:', function (p) {
  return p.theme.breakpoints[0];
}, '){top:0;left:0;right:0;height:', function (p) {
  return p.theme.sidebar.mobileHeight;
}, ';bottom:auto;width:auto;padding:0;align-items:center;}');

var SidebarSectionGroup = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_7_react_emotion__["default"])('div', {
  target: 'e1sgxx351'
})(responsiveFlex, ';flex-shrink:0;');

var SidebarSection = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_7_react_emotion__["default"])(SidebarSectionGroup, {
  target: 'e1sgxx352'
})(function (p) {
  return !p.noMargin && 'margin: ' + Object(__WEBPACK_IMPORTED_MODULE_16_app_styles_space__["a" /* default */])(1) + ' 0';
}, ';@media (max-width:', function (p) {
  return p.theme.breakpoints[0];
}, '){margin:0 ', Object(__WEBPACK_IMPORTED_MODULE_16_app_styles_space__["a" /* default */])(1), ';}');

var ExpandedIcon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_7_react_emotion__["css"])('transition:0.3s transform ease;transform:rotate(0deg);');
var CollapsedIcon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_7_react_emotion__["css"])('transform:rotate(180deg);');
var StyledInlineSvg = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_7_react_emotion__["default"])(function (_ref) {
  var className = _ref.className,
      collapsed = _ref.collapsed,
      props = _objectWithoutProperties(_ref, ['className', 'collapsed']);

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_inlineSvg__["a" /* default */], _extends({
    className: Object(__WEBPACK_IMPORTED_MODULE_7_react_emotion__["cx"])(className, ExpandedIcon, collapsed && CollapsedIcon)
  }, props));
}, {
  target: 'e1sgxx353'
})();

var SidebarCollapseItem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_7_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_21__sidebarItem__["a" /* default */], {
  target: 'e1sgxx354'
})('@media (max-width:', function (p) {
  return p.theme.breakpoints[0];
}, '){display:none;}');
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(47);

/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return isArray(value) ? value : [value];
}

module.exports = castArray;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(460);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 310 */,
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (header) {
  if (header === null) {
    return {};
  }

  var header_vals = header.split(','),
      links = {};

  header_vals.forEach(function (val) {
    var match = /<([^>]+)>; rel="([^"]+)"(?:; results="([^"]+)")?(?:; cursor="([^"]+)")?/g.exec(val);
    var hasResults = match[3] === 'true' ? true : match[3] === 'false' ? false : null;

    links[match[2]] = {
      href: match[1],
      results: hasResults,
      cursor: match[4]
    };
  });

  return links;
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_alert__ = __webpack_require__(212);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// Margin bottom should probably be a different prop
var StyledPanelAlert = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_3_app_components_alert__["a" /* default */], {
  target: 'e1wrupv90'
})(function (p) {
  return typeof p.m !== 'undefined' ? 'margin: -' + (p.m * p.theme.grid + 1) + 'px -' + (p.m * p.theme.grid + 1) + 'px;' : '';
}, ';', function (p) {
  return typeof p.mb !== 'undefined' ? 'margin-bottom: ' + p.mb * p.theme.grid + ';' : '';
}, ';border-radius:0;');

var DEFAULT_ICONS = {
  info: 'icon-circle-info',
  error: 'icon-circle-close',
  warning: 'icon-circle-exclamation',
  success: 'icon-circle-success'
};

var PanelAlert = (_temp = _class = function (_React$Component) {
  _inherits(PanelAlert, _React$Component);

  function PanelAlert() {
    _classCallCheck(this, PanelAlert);

    return _possibleConstructorReturn(this, (PanelAlert.__proto__ || Object.getPrototypeOf(PanelAlert)).apply(this, arguments));
  }

  _createClass(PanelAlert, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          type = _props.type,
          icon = _props.icon,
          props = _objectWithoutProperties(_props, ['type', 'icon']);

      var iconOrDefault = icon || DEFAULT_ICONS[type];

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledPanelAlert, _extends({}, props, { icon: iconOrDefault, type: type }));
    }
  }]);

  return PanelAlert;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  /**
   * Number of grid units to use for component's negative margin.
   */
  m: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  /**
   * margin-bottom
   */
  mb: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['info', 'warning', 'success', 'error']),
  icon: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, _class.defaultProps = {
  m: 0,
  mb: 0
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (PanelAlert);

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var escapeHtmlChar = __webpack_require__(915),
    toString = __webpack_require__(219);

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"']/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/**
 * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
 * corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape(string) {
  string = toString(string);
  return (string && reHasUnescapedHtml.test(string))
    ? string.replace(reUnescapedHtml, escapeHtmlChar)
    : string;
}

module.exports = escape;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(629),
    keys = __webpack_require__(605);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNumber__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isString__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_utils__ = __webpack_require__(10);




var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








function looksLikeObjectRepr(value) {
  var a = value[0];
  var z = value[value.length - 1];
  if (a == '<' && z == '>') {
    return true;
  } else if (a == '[' && z == ']') {
    return true;
  } else if (a == '(' && z == ')') {
    return true;
  } else if (z == ')' && value.match(/^[\w\d._-]+\(/)) {
    return true;
  }
  return false;
}

function looksLikeMultiLineString(value) {
  return !!value.match(/[\r\n]/);
}

function padNumbersInString(string) {
  return string.replace(/(\d+)/g, function (num) {
    var isNegative = false;
    num = parseInt(num, 10);
    if (num < 0) {
      num *= -1;
      isNegative = true;
    }
    var s = '0000000000000' + num;
    s = s.substr(s.length - (isNegative ? 11 : 12));
    if (isNegative) {
      s = '-' + s;
    }
    return s;
  });
}

function naturalCaseInsensitiveSort(a, b) {
  a = padNumbersInString(a).toLowerCase();
  b = padNumbersInString(b).toLowerCase();
  return a === b ? 0 : a < b ? -1 : 1;
}

function analyzeStringForRepr(value) {
  var rv = {
    repr: value,
    isString: true,
    isMultiLine: false,
    isStripped: false
  };

  // stripped for security reasons
  if (value.match(/^['"]?\*{8,}['"]?$/)) {
    rv.isStripped = true;
    return rv;
  }

  if (looksLikeObjectRepr(value)) {
    rv.isString = false;
  } else {
    rv.isMultiLine = looksLikeMultiLineString(value);
  }

  return rv;
}

var ContextData = (_temp2 = _class = function (_React$Component) {
  _inherits(ContextData, _React$Component);

  function ContextData() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ContextData);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContextData.__proto__ || Object.getPrototypeOf(ContextData)).call.apply(_ref, [this].concat(args))), _this), _this.renderValue = function (value) {
      function toggle(evt) {
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()(evt.target).parent().toggleClass('val-toggle-open');
        evt.preventDefault();
      }

      function makeToggle(highUp, childCount, children) {
        if (childCount === 0) {
          return null;
        }
        if (highUp) {
          return children;
        }
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'span',
          { className: 'val-toggle' },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: '#', className: 'val-toggle-link', onClick: toggle }),
          children
        );
      }

      /*eslint no-shadow:0*/
      function walk(value, depth) {
        var i = 0,
            children = [];
        if (value === null) {
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'span',
            { className: 'val-null' },
            'None'
          );
        } else if (value === true || value === false) {
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'span',
            { className: 'val-bool' },
            value ? 'True' : 'False'
          );
        } else if (__WEBPACK_IMPORTED_MODULE_2_lodash_isString___default()(value)) {
          var valueInfo = analyzeStringForRepr(value);

          var out = [__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'span',
            {
              key: 'value',
              className: (valueInfo.isString ? 'val-string' : 'val-repr') + (valueInfo.isStripped ? ' val-stripped' : '') + (valueInfo.isMultiLine ? ' val-string-multiline' : '')
            },
            valueInfo.repr
          )];

          if (valueInfo.isString && Object(__WEBPACK_IMPORTED_MODULE_6_app_utils__["l" /* isUrl */])(value)) {
            out.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              'a',
              { key: 'external', href: value, className: 'external-icon' },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('em', { className: 'icon-open' })
            ));
          }

          return out;
        } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isNumber___default()(value)) {
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'span',
            { className: 'val-number' },
            value
          );
        } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default()(value)) {
          for (i = 0; i < value.length; i++) {
            children.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              'span',
              { className: 'val-array-item', key: i },
              walk(value[i], depth + 1),
              i < value.length - 1 ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'span',
                { className: 'val-array-sep' },
                ', '
              ) : null
            ));
          }
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'span',
            { className: 'val-array' },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              'span',
              { className: 'val-array-marker' },
              '['
            ),
            makeToggle(depth <= 2, children.length, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              'span',
              { className: 'val-array-items' },
              children
            )),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              'span',
              { className: 'val-array-marker' },
              ']'
            )
          );
        } else {
          var keys = Object.keys(value);
          keys.sort(naturalCaseInsensitiveSort);
          for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            children.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              'span',
              { className: 'val-dict-pair', key: key },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'span',
                { className: 'val-dict-key' },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  'span',
                  { className: 'val-string' },
                  key
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'span',
                { className: 'val-dict-col' },
                ': '
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'span',
                { className: 'val-dict-value' },
                walk(value[key], depth + 1),
                i < keys.length - 1 ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  'span',
                  { className: 'val-dict-sep' },
                  ', '
                ) : null
              )
            ));
          }
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'span',
            { className: 'val-dict' },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              'span',
              { className: 'val-dict-marker' },
              '{'
            ),
            makeToggle(depth <= 1, children.length, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              'span',
              { className: 'val-dict-items' },
              children
            )),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              'span',
              { className: 'val-dict-marker' },
              '}'
            )
          );
        }
      }
      return walk(value, 0);
    }, _this.renderKeyPosValue = function (value) {
      if (__WEBPACK_IMPORTED_MODULE_2_lodash_isString___default()(value)) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'span',
          { className: 'val-string' },
          value
        );
      }
      return _this.renderValue(value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ContextData, [{
    key: 'render',
    value: function render() {
      // XXX(dcramer): babel does not support this yet
      // let {data, className, ...other} = this.props;
      var data = this.props.data;
      var className = this.props.className;
      var other = {};
      for (var key in this.props) {
        if (key !== 'data' && key !== 'className') {
          other[key] = this.props[key];
        }
      }
      other.className = 'val ' + (className || '');

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'pre',
        other,
        this.renderValue(data)
      );
    }
  }]);

  return ContextData;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component), _class.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
}, _class.defaultProps = {
  data: null
}, _temp2);


ContextData.displayName = 'ContextData';

/* harmony default export */ __webpack_exports__["a"] = (ContextData);

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(235),
    isObjectLike = __webpack_require__(200);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectControl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2, _class2, _temp3;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var SelectControl = (_temp2 = _class = function (_React$Component) {
  _inherits(SelectControl, _React$Component);

  function SelectControl() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SelectControl);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectControl.__proto__ || Object.getPrototypeOf(SelectControl)).call.apply(_ref, [this].concat(args))), _this), _this.renderArrow = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'icon-arrow-down' });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SelectControl, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          async = _props.async,
          props = _objectWithoutProperties(_props, ['async']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledSelect, _extends({ arrowRenderer: this.renderArrow, async: async }, props));
    }
  }]);

  return SelectControl;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  async: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _temp2);

// We're making this class because we pass `innerRef` from `FormField`
// And react yells at us if this picker is a stateless function component
// (since you can't attach refs to them)


var SelectPicker = (_temp3 = _class2 = function (_React$Component2) {
  _inherits(SelectPicker, _React$Component2);

  function SelectPicker() {
    _classCallCheck(this, SelectPicker);

    return _possibleConstructorReturn(this, (SelectPicker.__proto__ || Object.getPrototypeOf(SelectPicker)).apply(this, arguments));
  }

  _createClass(SelectPicker, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          async = _props2.async,
          props = _objectWithoutProperties(_props2, ['async']);

      if (async) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* Async */], props);
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["b" /* default */], props);
    }
  }]);

  return SelectPicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class2.propTypes = {
  async: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _temp3);


var StyledSelect = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(SelectPicker, {
  target: 'eho28m20'
})('font-size:15px;.Select-control,&.Select.is-focused:not(.is-open) > .Select-control{overflow:visible;border:1px solid ', function (p) {
  return p.theme.borderDark;
}, ';box-shadow:inset ', function (p) {
  return p.theme.dropShadowLight;
}, ';}.Select-input{height:36px;input{padding:10px 0;}}.Select-placeholder,.Select--single > .Select-control .Select-value{height:36px;&:focus{border:1px solid ', function (p) {
  return p.theme.gray;
}, ';}}.Select-option.is-focused{color:white;background-color:', function (p) {
  return p.theme.purple;
}, ';}.Select-multi-value-wrapper{> a{margin-left:4px;}}.Select.is-focused:not(.is-open) > .Select-control{border-color:', function (p) {
  return p.theme.gray;
}, ';}');

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_actions_projectActions__ = __webpack_require__(116);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





/**
 * This is a store specifically used by the dashboard, so that we can
 * clear the store when the Dashboard unmounts
 * (as to not disrupt ProjectsStore which a lot more components use)
 */
var ProjectsStatsStore = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({
  init: function init() {
    this.reset();
    this.listenTo(__WEBPACK_IMPORTED_MODULE_1_app_actions_projectActions__["a" /* default */].loadStatsForProjectSuccess, this.onStatsLoadSuccess);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_1_app_actions_projectActions__["a" /* default */].update, this.onUpdate);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_1_app_actions_projectActions__["a" /* default */].updateError, this.onUpdateError);
  },
  getInitialState: function getInitialState() {
    return this.itemsBySlug;
  },
  reset: function reset() {
    this.itemsBySlug = {};
    this.updatingItems = new Map();
  },
  onStatsLoadSuccess: function onStatsLoadSuccess(projects) {
    var _this = this;

    projects.forEach(function (project) {
      _this.itemsBySlug[project.slug] = project;
    });
    this.trigger(this.itemsBySlug);
  },


  /**
   * Optimistic updates
   * @param {String} projectSlug  Project slug
   * @param {Object} data Project data
   */
  onUpdate: function onUpdate(projectSlug, data) {
    var project = this.getBySlug(projectSlug);
    this.updatingItems.set(projectSlug, project);
    if (!project) return;

    var newProject = _extends({}, project, data);

    this.itemsBySlug = _extends({}, this.itemsBySlug, _defineProperty({}, project.slug, newProject));
    this.trigger(this.itemsBySlug);
  },
  onUpdateSuccess: function onUpdateSuccess(data) {
    // Remove project from updating map
    this.updatingItems.delete(data.slug);
  },


  /**
   * Revert project data when there was an error updating project details
   * @param {Object} err Error object
   * @param {Object} data Previous project data
   */
  onUpdateError: function onUpdateError(err, projectSlug) {
    var project = this.updatingItems.get(projectSlug);
    if (!project) return;

    this.updatingItems.delete(projectSlug);
    // Restore old project
    this.itemsBySlug = _extends({}, this.itemsBySlug, _defineProperty({}, project.slug, _extends({}, project)));
    this.trigger(this.itemsBySlug);
  },
  getAll: function getAll() {
    return this.itemsBySlug;
  },
  getBySlug: function getBySlug(slug) {
    return this.itemsBySlug[slug];
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ProjectsStatsStore);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return imageStyle; });
var imageStyle = function imageStyle(props) {
  return '\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  border-radius: ' + (props.round ? '50%' : '3px') + ';\n';
};

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = userDisplayName;
function userDisplayName(user) {
  var displayName = user.name;
  if (user.email && user.email !== user.name) {
    displayName += ' (' + user.email + ')';
  }
  return displayName;
}

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_styles_overflowEllipsis__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_styles_space__ = __webpack_require__(38);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var BadgeDisplayName = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])(function (_ref) {
  var hideOverflow = _ref.hideOverflow,
      props = _objectWithoutProperties(_ref, ['hideOverflow']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', props);
}, {
  target: 'eeoia0v0'
})(function (p) {
  return p.hideOverflow && __WEBPACK_IMPORTED_MODULE_2_app_styles_overflowEllipsis__["a" /* default */];
}, ';', function (p) {
  return p.hideOverflow && 'max-width: ' + (typeof p.hideOverflow === 'string' ? p.hideOverflow : p.theme.settings.maxCrumbWidth);
}, ';padding:', Object(__WEBPACK_IMPORTED_MODULE_3_app_styles_space__["a" /* default */])(0.25), ' 0;');

/* harmony default export */ __webpack_exports__["a"] = (BadgeDisplayName);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);


var EnvironmentActions = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['setActive', 'clearActive', 'loadData', 'loadActiveData', 'loadHiddenData']);

/* harmony default export */ __webpack_exports__["a"] = (EnvironmentActions);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raven_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_utils_getRouteStringFromRoutes__ = __webpack_require__(498);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var RouteError = (_temp = _class = function (_React$Component) {
  _inherits(RouteError, _React$Component);

  function RouteError() {
    _classCallCheck(this, RouteError);

    return _possibleConstructorReturn(this, (RouteError.__proto__ || Object.getPrototypeOf(RouteError)).apply(this, arguments));
  }

  _createClass(RouteError, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var routes = this.props.routes;
      var _context = this.context,
          organization = _context.organization,
          project = _context.project;
      // TODO(dcramer): show something in addition to embed (that contains it?)
      // throw this in a timeout so if it errors we dont fall over

      this._timeout = window.setTimeout(function () {
        var route = Object(__WEBPACK_IMPORTED_MODULE_5_app_utils_getRouteStringFromRoutes__["a" /* default */])(routes);

        __WEBPACK_IMPORTED_MODULE_3_raven_js___default.a.captureException(this.props.error, {
          fingerprint: [this.props.error, route],
          extra: {
            route: route,
            orgFeatures: organization && organization.features || [],
            orgAccess: organization && organization.access || [],
            projectFeatures: project && project.features || []
          }
        });
        // TODO(dcramer): we do not have errorId until send() is called which
        // has latency in production so this will literally never fire
        __WEBPACK_IMPORTED_MODULE_3_raven_js___default.a.showReportDialog();
      }.bind(this));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._timeout) {
        window.clearTimeout(this._timeout);
      }
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.sentry-error-embed-wrapper').remove();
    }
  }, {
    key: 'render',
    value: function render() {
      // TODO(dcramer): show additional resource links
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'div',
        { className: 'alert alert-block alert-error' },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'div',
          { style: { fontSize: 24, marginBottom: 10 } },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'icon-exclamation', style: { fontSize: 20, marginRight: 10 } }),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'span',
            null,
            'Oops! Something went wrong'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'p',
          null,
          'It looks like you\'ve hit an issue in our client application. Don\'t worry though! We use Sentry to monitor Sentry and it\'s likely we\'re already looking into this!'
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'p',
          null,
          'If you\'re daring, you may want to try the following:'
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'ul',
          null,
          window && window.adblockSuspected && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'li',
            null,
            'We detected something AdBlock-like. Try disabling it, as it\'s known to cause issues.'
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'li',
            null,
            'Give it a few seconds and',
            ' ',
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              'a',
              {
                onClick: function onClick() {
                  window.location.href = window.location.href;
                }
              },
              'reload the page'
            ),
            '.'
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'li',
            null,
            'If all else fails,',
            ' ',
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              'a',
              { href: 'http://github.com/getsentry/sentry/issues' },
              'create an issue'
            ),
            ' with more details.'
          )
        )
      );
    }
  }]);

  return RouteError;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component), _class.propTypes = {
  error: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  routes: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array
}, _class.contextTypes = {
  organization: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  project: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["withRouter"])(RouteError));

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return BooleanField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_forms_inputField__ = __webpack_require__(86);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var BooleanField = function (_InputField) {
  _inherits(BooleanField, _InputField);

  function BooleanField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BooleanField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BooleanField.__proto__ || Object.getPrototypeOf(BooleanField)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
      var value = e.target.checked;
      _this.setValue(value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BooleanField, [{
    key: 'coerceValue',
    value: function coerceValue(props) {
      var value = _get(BooleanField.prototype.__proto__ || Object.getPrototypeOf(BooleanField.prototype), 'coerceValue', this).call(this, props);
      return value ? true : false;
    }
  }, {
    key: 'getField',
    value: function getField() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
        id: this.getId(),
        type: this.getType(),
        checked: this.state.value,
        onChange: this.onChange.bind(this),
        disabled: this.props.disabled
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var error = this.state.error;

      var className = this.getClassName();
      if (error) {
        className += ' has-error';
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: className },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'controls' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            { className: 'control-label' },
            this.getField(),
            this.props.label,
            this.props.disabled && this.props.disabledReason && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              {
                className: 'disabled-indicator tip',
                title: this.props.disabledReason
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'icon-question' })
            )
          ),
          Object(__WEBPACK_IMPORTED_MODULE_1_app_utils__["d" /* defined */])(this.props.help) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'help-block' },
            this.props.help
          ),
          error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'error' },
            error
          )
        )
      );
    }
  }, {
    key: 'getClassName',
    value: function getClassName() {
      return 'control-group checkbox';
    }
  }, {
    key: 'getType',
    value: function getType() {
      return 'checkbox';
    }
  }]);

  return BooleanField;
}(__WEBPACK_IMPORTED_MODULE_2_app_components_forms_inputField__["a" /* default */]);



/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EmailField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_components_forms_inputField__ = __webpack_require__(86);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var EmailField = function (_InputField) {
  _inherits(EmailField, _InputField);

  function EmailField() {
    _classCallCheck(this, EmailField);

    return _possibleConstructorReturn(this, (EmailField.__proto__ || Object.getPrototypeOf(EmailField)).apply(this, arguments));
  }

  _createClass(EmailField, [{
    key: 'getType',
    value: function getType() {
      return 'email';
    }
  }]);

  return EmailField;
}(__WEBPACK_IMPORTED_MODULE_0_app_components_forms_inputField__["a" /* default */]);



/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RangeField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_forms_inputField__ = __webpack_require__(86);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var RangeField = (_temp = _class = function (_InputField) {
  _inherits(RangeField, _InputField);

  function RangeField() {
    _classCallCheck(this, RangeField);

    return _possibleConstructorReturn(this, (RangeField.__proto__ || Object.getPrototypeOf(RangeField)).apply(this, arguments));
  }

  _createClass(RangeField, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _get(RangeField.prototype.__proto__ || Object.getPrototypeOf(RangeField.prototype), 'componentDidMount', this).call(this);
      this.attachSlider();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeSlider();
      _get(RangeField.prototype.__proto__ || Object.getPrototypeOf(RangeField.prototype), 'componentWillUnmount', this).call(this);
    }
  }, {
    key: 'attachSlider',
    value: function attachSlider() {
      var _this2 = this;

      var $value = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<span class="value" />');
      var suffixClassNames = '';
      if (this.props.disabled) {
        suffixClassNames += ' disabled';
      }
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(this.refs.input)).on('slider:ready', function (e, data) {
        var value = parseInt(data.value, 10);
        $value.appendTo(data.el);
        $value.html(_this2.props.formatLabel(value));
      }).on('slider:changed', function (e, data) {
        var value = parseInt(data.value, 10);
        $value.html(_this2.props.formatLabel(value));
        _this2.setValue(value);
      }).simpleSlider({
        value: this.props.defaultValue || this.props.value,
        range: [this.props.min, this.props.max],
        step: this.props.step,
        snap: this.props.snap,
        allowedValues: this.props.allowedValues,
        classSuffix: suffixClassNames
      });
    }
  }, {
    key: 'removeSlider',
    value: function removeSlider() {
      // TODO(dcramer): it seems we cant actually implement this with the current slider
      // implementation
    }
  }, {
    key: 'getAttributes',
    value: function getAttributes() {
      return {
        min: this.props.min,
        max: this.props.max,
        step: this.props.step
      };
    }
  }, {
    key: 'getType',
    value: function getType() {
      return 'range';
    }
  }]);

  return RangeField;
}(__WEBPACK_IMPORTED_MODULE_3_app_components_forms_inputField__["a" /* default */]), _class.formatMinutes = function (value) {
  value = value / 60;
  return value + ' minute' + (value != 1 ? 's' : '');
}, _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_3_app_components_forms_inputField__["a" /* default */].propTypes, {
  min: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  step: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  snap: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  allowedValues: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number)
}), _class.defaultProps = _extends({}, __WEBPACK_IMPORTED_MODULE_3_app_components_forms_inputField__["a" /* default */].defaultProps, {
  formatLabel: function formatLabel(value) {
    return value;
  },
  min: 0,
  max: 100,
  step: 1,
  snap: true,
  allowedValues: null
}), _temp);


/***/ }),
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchGuides;
/* harmony export (immutable) */ __webpack_exports__["f"] = registerAnchor;
/* harmony export (immutable) */ __webpack_exports__["g"] = unregisterAnchor;
/* harmony export (immutable) */ __webpack_exports__["c"] = nextStep;
/* harmony export (immutable) */ __webpack_exports__["a"] = closeGuideOrSupport;
/* harmony export (immutable) */ __webpack_exports__["e"] = recordFinish;
/* harmony export (immutable) */ __webpack_exports__["d"] = recordDismiss;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_actions_guideActions__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils_analytics__ = __webpack_require__(56);




var api = new __WEBPACK_IMPORTED_MODULE_0_app_api__["Client"]();

function fetchGuides() {
  api.request('/assistant/', {
    method: 'GET',
    success: function success(data) {
      __WEBPACK_IMPORTED_MODULE_1_app_actions_guideActions__["a" /* default */].fetchSucceeded(data);
    }
  });
}

function registerAnchor(anchor) {
  __WEBPACK_IMPORTED_MODULE_1_app_actions_guideActions__["a" /* default */].registerAnchor(anchor);
}

function unregisterAnchor(anchor) {
  __WEBPACK_IMPORTED_MODULE_1_app_actions_guideActions__["a" /* default */].unregisterAnchor(anchor);
}

function nextStep() {
  __WEBPACK_IMPORTED_MODULE_1_app_actions_guideActions__["a" /* default */].nextStep();
}

function closeGuideOrSupport() {
  __WEBPACK_IMPORTED_MODULE_1_app_actions_guideActions__["a" /* default */].closeGuideOrSupport();
}

function recordFinish(guideId, useful) {
  api.request('/assistant/', {
    method: 'PUT',
    data: {
      guide_id: guideId,
      status: 'viewed',
      useful: useful
    }
  });
  Object(__WEBPACK_IMPORTED_MODULE_2_app_utils_analytics__["a" /* default */])('assistant.guide_finished', {
    guide: guideId,
    useful: useful
  });
}

function recordDismiss(guideId, step) {
  api.request('/assistant/', {
    method: 'PUT',
    data: {
      guide_id: guideId,
      status: 'dismissed'
    }
  });
  Object(__WEBPACK_IMPORTED_MODULE_2_app_utils_analytics__["a" /* default */])('assistant.guide_dismissed', {
    guide: guideId,
    step: step
  });
}

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_inlineSvg__ = __webpack_require__(24);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var QuestionMarkIcon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])(function (_ref) {
  var hasGuide = _ref.hasGuide,
      props = _objectWithoutProperties(_ref, ['hasGuide']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_inlineSvg__["a" /* default */], _extends({
    src: hasGuide ? 'icon-circle-exclamation' : 'icon-circle-question'
  }, props));
}, {
  target: 'ej1r13u0'
})('width:2.75em;height:2.75em;color:', function (p) {
  return p.hasGuide ? p.theme.greenLight : p.theme.purple;
}, ';');

/* harmony default export */ __webpack_exports__["a"] = (QuestionMarkIcon);

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_inlineSvg__ = __webpack_require__(24);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CloseIcon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])(function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_inlineSvg__["a" /* default */], _extends({ src: 'icon-close-lg' }, props));
}, {
  target: 'ex6ysov0'
})('stroke-width:3px;width:0.75em;height:0.75em;margin:0 0.875em 0 0.66em;cursor:pointer;');

/* harmony default export */ __webpack_exports__["a"] = (CloseIcon);

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_emotion__ = __webpack_require__(5);


var AssistantContainer = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react_emotion__["default"])('div', {
  target: 'e5qu1sf0'
})('position:fixed;z-index:', function (p) {
  return p.theme.zIndex.modal;
}, ';width:25vw;max-width:450px;min-width:300px;bottom:1vw;right:1vw;background:', function (p) {
  return p.theme.offWhite;
}, ';border:1px solid ', function (p) {
  return p.theme.borderLight;
}, ';border-radius:1.45em;color:', function (p) {
  return p.theme.purple;
}, ';font-weight:bold;box-shadow:', function (p) {
  return p.theme.dropShadowHeavy;
}, ';');

/* harmony default export */ __webpack_exports__["a"] = (AssistantContainer);

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_styles_space__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_styles_text__ = __webpack_require__(1008);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var PanelBody = function PanelBody(_ref) {
  var disablePadding = _ref.disablePadding,
      flex = _ref.flex,
      direction = _ref.direction,
      props = _objectWithoutProperties(_ref, ['disablePadding', 'flex', 'direction']);

  var padding = !disablePadding ? /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["css"])('padding:', Object(__WEBPACK_IMPORTED_MODULE_4_app_styles_space__["a" /* default */])(2), ';') : '';
  var flexDirection = flex ? direction : undefined;
  var Comp = flex ? __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Flex"] : 'div';

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Comp, _extends({ className: Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["cx"])(padding, __WEBPACK_IMPORTED_MODULE_5_app_styles_text__["a" /* default */]) }, props, { direction: flexDirection }));
};

PanelBody.propTypes = {
  flex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  direction: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  disablePadding: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

PanelBody.defaultProps = {
  flex: false,
  direction: 'column',
  disablePadding: true
};

/* harmony default export */ __webpack_exports__["default"] = (PanelBody);

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_styles_space__ = __webpack_require__(38);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var getPadding = function getPadding(_ref) {
  var disablePadding = _ref.disablePadding,
      hasButtons = _ref.hasButtons;
  return (/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["css"])('padding:', hasButtons ? Object(__WEBPACK_IMPORTED_MODULE_4_app_styles_space__["a" /* default */])(1) : Object(__WEBPACK_IMPORTED_MODULE_4_app_styles_space__["a" /* default */])(2), ' ', disablePadding ? 0 : Object(__WEBPACK_IMPORTED_MODULE_4_app_styles_space__["a" /* default */])(2), ';')
  );
};

var StyledPanelHeader = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(function (_ref2) {
  var disablePadding = _ref2.disablePadding,
      hasButtons = _ref2.hasButtons,
      props = _objectWithoutProperties(_ref2, ['disablePadding', 'hasButtons']);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Flex"], _extends({ align: 'center', justify: 'space-between' }, props));
}, {
  target: 'e1p8v8nv0'
})('color:', function (p) {
  return p.lightText ? p.theme.gray2 : p.theme.gray3;
}, ';font-size:13px;font-weight:600;text-transform:uppercase;border-bottom:1px solid ', function (p) {
  return p.theme.borderDark;
}, ';border-radius:', function (p) {
  return p.theme.borderRadius;
}, ' ', function (p) {
  return p.theme.borderRadius;
}, ' 0 0;background:', function (p) {
  return p.theme.offWhite;
}, ';line-height:1;', getPadding, ';');

var PanelHeader = (_temp = _class = function (_React$Component) {
  _inherits(PanelHeader, _React$Component);

  function PanelHeader() {
    _classCallCheck(this, PanelHeader);

    return _possibleConstructorReturn(this, (PanelHeader.__proto__ || Object.getPrototypeOf(PanelHeader)).apply(this, arguments));
  }

  _createClass(PanelHeader, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StyledPanelHeader, this.props);
    }
  }]);

  return PanelHeader;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = _extends({
  disablePadding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hasButtons: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  lightText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Flex"].propTypes), _temp);


/* harmony default export */ __webpack_exports__["default"] = (PanelHeader);

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_plugins_components_settings__ = __webpack_require__(1025);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var BasePlugin = function () {
  function BasePlugin(data) {
    _classCallCheck(this, BasePlugin);

    Object.assign(this, data);
  }

  _createClass(BasePlugin, [{
    key: 'renderSettings',
    value: function renderSettings(props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_app_plugins_components_settings__["a" /* default */], _extends({ plugin: this }, props));
    }
  }]);

  return BasePlugin;
}();

BasePlugin.DefaultSettings = __WEBPACK_IMPORTED_MODULE_1_app_plugins_components_settings__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (BasePlugin);

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_confirm__ = __webpack_require__(119);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ActionLink = (_temp = _class = function (_React$Component) {
  _inherits(ActionLink, _React$Component);

  function ActionLink() {
    _classCallCheck(this, ActionLink);

    return _possibleConstructorReturn(this, (ActionLink.__proto__ || Object.getPrototypeOf(ActionLink)).apply(this, arguments));
  }

  _createClass(ActionLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          shouldConfirm = _props.shouldConfirm,
          message = _props.message,
          className = _props.className,
          title = _props.title,
          onAction = _props.onAction,
          confirmLabel = _props.confirmLabel,
          disabled = _props.disabled,
          children = _props.children;


      if (shouldConfirm && !disabled) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_app_components_confirm__["a" /* default */],
          { message: message, confirmText: confirmLabel, onConfirm: onAction },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: className, title: title },
            ' ',
            children
          )
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          {
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, { disabled: disabled }),
            onClick: disabled ? undefined : onAction,
            disabled: disabled
          },
          children
        );
      }
    }
  }]);

  return ActionLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  shouldConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  onAction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  confirmLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class.defaultProps = {
  shouldConfirm: false,
  disabled: false
}, _temp);


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_proptypes__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var EventOrGroupTitle = (_temp = _class = function (_React$Component) {
  _inherits(EventOrGroupTitle, _React$Component);

  function EventOrGroupTitle() {
    _classCallCheck(this, EventOrGroupTitle);

    return _possibleConstructorReturn(this, (EventOrGroupTitle.__proto__ || Object.getPrototypeOf(EventOrGroupTitle)).apply(this, arguments));
  }

  _createClass(EventOrGroupTitle, [{
    key: 'render',
    value: function render() {
      var data = this.props.data;
      var metadata = data.metadata,
          title = data.title,
          type = data.type,
          culprit = data.culprit;

      var subtitle = null;

      if (type == 'error') {
        title = metadata.type;
        subtitle = culprit;
      } else if (type == 'csp') {
        title = metadata.directive;
        subtitle = metadata.uri;
      } else if (type === 'expectct' || type === 'expectstaple' || type === 'hpkp') {
        title = metadata.message;
        subtitle = metadata.origin;
      } else if (type == 'default') {
        title = metadata.title;
      }

      if (subtitle) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { style: this.props.style },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { style: { marginRight: 10 } },
            title
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'em',
            null,
            subtitle
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null)
        );
      }
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { style: this.props.style },
        title
      );
    }
  }]);

  return EventOrGroupTitle;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['error', 'csp', 'hpkp', 'expectct', 'expectstaple', 'default']).isRequired,
    title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    metadata: __WEBPACK_IMPORTED_MODULE_2_app_proptypes__["d" /* Metadata */].isRequired,
    culprit: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
  })
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (EventOrGroupTitle);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var SearchBar = (_temp = _class = function (_React$PureComponent) {
  _inherits(SearchBar, _React$PureComponent);

  function SearchBar() {
    var _ref;

    _classCallCheck(this, SearchBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call.apply(_ref, [this].concat(args)));

    _this.blur = function () {
      _this.searchInput.blur();
    };

    _this.onSubmit = function (evt) {
      evt.preventDefault();
      _this.blur();
      _this.props.onSearch(_this.state.query);
    };

    _this.clearSearch = function () {
      _this.setState({ query: _this.props.defaultQuery }, function () {
        return _this.props.onSearch(_this.state.query);
      });
    };

    _this.onQueryFocus = function () {
      _this.setState({
        dropdownVisible: true
      });
    };

    _this.onQueryBlur = function () {
      _this.setState({ dropdownVisible: false });
    };

    _this.onQueryChange = function (evt) {
      _this.setState({ query: evt.target.value });
    };

    _this.state = {
      query: _this.props.query || _this.props.defaultQuery
    };
    return _this;
  }

  _createClass(SearchBar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.query !== this.props.query) {
        this.setState({
          query: nextProps.query
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'search' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'form',
          { className: 'form-horizontal', onSubmit: this.onSubmit },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
              type: 'text',
              className: 'search-input form-control',
              placeholder: this.props.placeholder,
              name: 'query',
              ref: function ref(el) {
                return _this2.searchInput = el;
              },
              autoComplete: 'off',
              value: this.state.query,
              onBlur: this.onQueryBlur,
              onChange: this.onQueryChange
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon-search' }),
            this.state.query !== this.props.defaultQuery && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { className: 'search-clear-form', onClick: this.clearSearch },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon-circle-cross' })
              )
            )
          )
        )
      );
    }
  }]);

  return SearchBar;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent), _class.propTypes = {
  query: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  defaultQuery: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  onSearch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  placeholder: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, _class.defaultProps = {
  defaultQuery: '',
  query: '',
  onSearch: function onSearch() {}
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (SearchBar);

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Pills = function (_React$Component) {
  _inherits(Pills, _React$Component);

  function Pills() {
    _classCallCheck(this, Pills);

    return _possibleConstructorReturn(this, (Pills.__proto__ || Object.getPrototypeOf(Pills)).apply(this, arguments));
  }

  _createClass(Pills, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          otherProps = _objectWithoutProperties(_props, ['className', 'children']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('pills', className) }, otherProps),
        children
      );
    }
  }]);

  return Pills;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Pills);

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Pill = (_temp2 = _class = function (_React$Component) {
  _inherits(Pill, _React$Component);

  function Pill() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Pill);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pill.__proto__ || Object.getPrototypeOf(Pill)).call.apply(_ref, [this].concat(args))), _this), _this.renderValue = function () {
      var value = _this.props.value;

      if (value === undefined) {
        return [null, null];
      }
      var extraClass = null;
      var renderedValue = void 0;
      if (value === true || value === false) {
        extraClass = value ? 'true' : 'false';
        renderedValue = value ? 'yes' : 'no';
      } else if (value === null) {
        extraClass = 'false';
        renderedValue = 'n/a';
      } else {
        renderedValue = value.toString();
      }
      return [extraClass, renderedValue];
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Pill, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          children = _props.children,
          className = _props.className,
          props = _objectWithoutProperties(_props, ['name', 'children', 'className']);

      var _renderValue = this.renderValue(),
          _renderValue2 = _slicedToArray(_renderValue, 2),
          extraClass = _renderValue2[0],
          renderedValue = _renderValue2[1];

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'li',
        _extends({ className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, extraClass) }, props),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'key' },
          name
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'value' },
          renderedValue,
          children
        )
      );
    }
  }]);

  return Pill;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (Pill);

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_after__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_after___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_after__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_avatar_avatarList__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_lastCommit__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_timeSince__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_hovercard__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_mixins_apiMixin__ = __webpack_require__(8);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



















var VersionHoverCard = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'VersionHoverCard',

  propTypes: {
    version: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    orgId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    projectId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_12_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    return {
      loading: true,
      error: false,
      data: {},
      visible: false,
      hasRepos: false,
      deploys: []
    };
  },
  componentDidMount: function componentDidMount() {
    this.fetchData();
  },
  fetchData: function fetchData() {
    var _this = this;

    var _props = this.props,
        orgId = _props.orgId,
        projectId = _props.projectId,
        version = _props.version;

    var done = __WEBPACK_IMPORTED_MODULE_0_lodash_after___default()(3, function () {
      _this.setState({ loading: false });
    });

    // releases
    var releasePath = '/projects/' + orgId + '/' + projectId + '/releases/' + encodeURIComponent(version) + '/';
    this.api.request(releasePath, {
      method: 'GET',
      success: function success(data) {
        _this.setState({
          release: data
        });
      },
      error: function error() {
        _this.setState({
          error: true
        });
      },
      complete: done
    });

    // repos
    var repoPath = '/organizations/' + orgId + '/repos/';
    this.api.request(repoPath, {
      method: 'GET',
      success: function success(data) {
        _this.setState({
          hasRepos: data.length > 0
        });
      },
      error: function error() {
        _this.setState({
          error: true
        });
      },
      complete: done
    });

    //deploys
    var deployPath = '/organizations/' + orgId + '/releases/' + encodeURIComponent(version) + '/deploys/';
    this.api.request(deployPath, {
      method: 'GET',
      success: function success(data) {
        _this.setState({
          deploys: data
        });
      },
      error: function error() {
        _this.setState({
          error: true
        });
      },
      complete: done
    });
  },
  toggleHovercard: function toggleHovercard() {
    this.setState({
      visible: true
      // visible: !this.state.visible,
    });
  },
  getRepoLink: function getRepoLink() {
    var orgId = this.props.orgId;

    return {
      body: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'version-hovercard blankslate m-a-0 p-x-1 p-y-1 align-center' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'h5',
          null,
          'Releases are better with commit data!'
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'p',
          null,
          'Connect a repository to see commit info, files changed, and authors involved in future releases.'
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'a',
          { className: 'btn btn-primary', href: '/organizations/' + orgId + '/repos/' },
          'Connect a repository'
        )
      )
    };
  },
  getBody: function getBody() {
    var _state = this.state,
        release = _state.release,
        deploys = _state.deploys;
    var version = this.props.version;

    var lastCommit = release.lastCommit;
    var shortVersion = Object(__WEBPACK_IMPORTED_MODULE_10_app_utils__["j" /* getShortVersion */])(version);

    var recentDeploysByEnviroment = deploys.reduce(function (dbe, deploy) {
      var dateFinished = deploy.dateFinished,
          environment = deploy.environment;

      if (!dbe.hasOwnProperty(environment)) {
        dbe[environment] = dateFinished;
      }

      return dbe;
    }, {});
    var mostRecentDeploySlice = Object.keys(recentDeploysByEnviroment);
    if (Object.keys(recentDeploysByEnviroment).length > 3) {
      mostRecentDeploySlice = Object.keys(recentDeploysByEnviroment).slice(0, 3);
    }
    return {
      header: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'span',
        { className: 'truncate' },
        Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["tct"])('Release [version]', { version: shortVersion })
      ),
      body: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'row row-flex' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'col-xs-4' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'h6',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('New Issues')
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'count-since' },
              release.newGroups
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'col-xs-8' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'h6',
              { style: { textAlign: 'right' } },
              release.commitCount,
              ' ',
              release.commitCount !== 1 ? Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('commits ') : Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('commit '),
              ' ',
              Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('by '),
              ' ',
              release.authors.length,
              ' ',
              release.authors.length !== 1 ? Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('authors') : Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('author'),
              ' '
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_avatar_avatarList__["a" /* default */], {
              users: release.authors,
              avatarSize: 25,
              tooltipOptions: { container: 'body' },
              typeMembers: 'authors'
            })
          )
        ),
        lastCommit && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_lastCommit__["a" /* default */], { commit: lastCommit, headerClass: 'commit-heading' }),
        deploys.length > 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'divider' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'h6',
              { className: 'deploy-heading' },
              Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Deploys')
            )
          ),
          mostRecentDeploySlice.map(function (env, idx) {
            var dateFinished = recentDeploysByEnviroment[env];
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'deploy', key: idx },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: 'deploy-meta', style: { position: 'relative' } },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'strong',
                  {
                    className: 'repo-label truncate',
                    style: {
                      padding: 3,
                      display: 'inline-block',
                      width: 86,
                      maxWidth: 86,
                      textAlign: 'center',
                      fontSize: 12
                    }
                  },
                  env
                ),
                dateFinished && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'span',
                  {
                    className: 'text-light',
                    style: {
                      position: 'absolute',
                      left: 98,
                      width: '50%',
                      padding: '3px 0'
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_timeSince__["default"], { date: dateFinished })
                )
              )
            );
          })
        )
      )
    };
  },
  render: function render() {
    var _state2 = this.state,
        loading = _state2.loading,
        error = _state2.error,
        hasRepos = _state2.hasRepos;

    var header = null;
    var body = loading ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_loadingIndicator__["default"], { mini: true }) : error ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_loadingError__["default"], null) : null;

    if (!loading && !error) {
      var renderObj = hasRepos ? this.getBody() : this.getRepoLink();
      header = renderObj.header;
      body = renderObj.body;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_app_components_hovercard__["a" /* default */],
      _extends({}, this.props, { header: header, body: body }),
      this.props.children
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (VersionHoverCard);

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_avatar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_timeSince__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_link__ = __webpack_require__(53);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var EventUserReport = (_temp = _class = function (_React$Component) {
  _inherits(EventUserReport, _React$Component);

  function EventUserReport() {
    _classCallCheck(this, EventUserReport);

    return _possibleConstructorReturn(this, (EventUserReport.__proto__ || Object.getPrototypeOf(EventUserReport)).apply(this, arguments));
  }

  _createClass(EventUserReport, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          report = _props.report,
          orgId = _props.orgId,
          projectId = _props.projectId,
          issueId = _props.issueId;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'user-report' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'activity-container' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'ul',
            { className: 'activity' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'li',
              { className: 'activity-note' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_avatar__["a" /* default */], { user: report, size: 38, className: 'avatar' }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'activity-bubble' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_timeSince__["default"], { date: report.dateCreated }),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'activity-author' },
                    report.name,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'small',
                      null,
                      report.email
                    ),
                    report.event.id && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'small',
                      null,
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_app_components_link__["a" /* default */],
                        {
                          to: '/' + orgId + '/' + projectId + '/issues/' + issueId + '/events/' + report.event.id
                        },
                        'View event'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p', {
                    dangerouslySetInnerHTML: {
                      __html: __WEBPACK_IMPORTED_MODULE_4_app_utils__["c" /* default */].nl2br(__WEBPACK_IMPORTED_MODULE_4_app_utils__["c" /* default */].escape(report.comments))
                    }
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return EventUserReport;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  report: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  orgId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  issueId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (EventUserReport);

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isStacktraceNewestFirst;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_stores_configStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_events_eventDataSection__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_events_interfaces_crashHeader__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_events_interfaces_crashContent__ = __webpack_require__(348);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










function isStacktraceNewestFirst() {
  var user = __WEBPACK_IMPORTED_MODULE_2_app_stores_configStore__["default"].get('user');
  // user may not be authenticated
  var options = user ? user.options : {};
  switch (options.stacktraceOrder) {
    case 2:
      return true;
    case 1:
      return false;
    case -1:
    default:
      return true;
  }
}

var StacktraceInterface = (_temp = _class = function (_React$Component) {
  _inherits(StacktraceInterface, _React$Component);

  function StacktraceInterface() {
    var _ref;

    _classCallCheck(this, StacktraceInterface);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = StacktraceInterface.__proto__ || Object.getPrototypeOf(StacktraceInterface)).call.apply(_ref, [this].concat(args)));

    _this.toggleStack = function (value) {
      _this.setState({
        stackView: value
      });
    };

    _this.state = {
      stackView: _this.props.data.hasSystemFrames ? 'app' : 'full',
      newestFirst: isStacktraceNewestFirst()
    };
    return _this;
  }

  _createClass(StacktraceInterface, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var group = this.props.group;
      var evt = this.props.event;
      var data = this.props.data;
      var stackView = this.state.stackView;
      var newestFirst = this.state.newestFirst;

      var title = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_events_interfaces_crashHeader__["a" /* default */], {
        title: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Stacktrace'),
        group: group,
        platform: evt.platform,
        stacktrace: data,
        stackView: stackView,
        newestFirst: newestFirst,
        onChange: function onChange(newState) {
          _this2.setState(newState);
        }
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_app_components_events_eventDataSection__["a" /* default */],
        {
          group: group,
          event: evt,
          type: this.props.type,
          title: title,
          wrapTitle: false
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_events_interfaces_crashContent__["a" /* default */], {
          group: group,
          event: evt,
          stackView: stackView,
          newestFirst: newestFirst,
          stacktrace: data
        })
      );
    }
  }]);

  return StacktraceInterface;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  group: __WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Group.isRequired,
  event: __WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Event.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (StacktraceInterface);

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_assistant_guideAnchor__ = __webpack_require__(65);







var CrashHeader = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'CrashHeader',

  propTypes: {
    title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    beforeTitle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
    platform: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    thread: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    exception: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    stacktrace: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    stackView: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    newestFirst: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
    stackType: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, // 'original', 'minified', or falsy (none)
    onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
  },

  hasSystemFrames: function hasSystemFrames() {
    var _props = this.props,
        stacktrace = _props.stacktrace,
        thread = _props.thread,
        exception = _props.exception;

    return stacktrace && stacktrace.hasSystemFrames || thread && thread.stacktrace && thread.stacktrace.hasSystemFrames || exception && exception.values.find(function (x) {
      return !!(x.stacktrace && x.stacktrace.hasSystemFrames);
    });
  },
  hasMinified: function hasMinified() {
    if (!this.props.stackType) {
      return false;
    }
    var _props2 = this.props,
        exception = _props2.exception,
        thread = _props2.thread;

    return exception && !!exception.values.find(function (x) {
      return x.rawStacktrace;
    }) || thread && !!thread.rawStacktrace;
  },
  getOriginalButtonLabel: function getOriginalButtonLabel() {
    if (this.props.platform === 'javascript' || this.props.platform === 'node') {
      return Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Original');
    } else {
      return Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Symbolicated');
    }
  },
  getMinifiedButtonLabel: function getMinifiedButtonLabel() {
    if (this.props.platform === 'javascript' || this.props.platform === 'node') {
      return Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Minified');
    } else {
      return Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Unsymbolicated');
    }
  },
  toggleOrder: function toggleOrder() {
    this.notify({
      newestFirst: !this.props.newestFirst
    });
  },
  setStackType: function setStackType(type) {
    this.notify({
      stackType: type
    });
  },
  setStackView: function setStackView(view) {
    this.notify({
      stackView: view
    });
  },
  notify: function notify(obj) {
    if (this.props.onChange) {
      this.props.onChange(obj);
    }
  },
  render: function render() {
    var _this = this;

    var _props3 = this.props,
        stackView = _props3.stackView,
        stackType = _props3.stackType,
        newestFirst = _props3.newestFirst;


    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'crash-title' },
      this.props.beforeTitle,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_assistant_guideAnchor__["default"], { target: 'exception', type: 'text' }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'h3',
        { className: 'pull-left' },
        this.props.title,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'small',
          { style: { marginLeft: 5 } },
          '(',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_app_components_tooltip__["default"],
            { title: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Toggle stacktrace order') },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { onClick: this.toggleOrder, style: { borderBottom: '1px dotted #aaa' } },
              newestFirst ? Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('most recent call first') : Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('most recent call last')
            )
          ),
          ')'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'btn-group', style: { marginLeft: 10 } },
        this.hasSystemFrames() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          {
            className: (stackView === 'app' ? 'active' : '') + ' btn btn-default btn-sm',
            onClick: this.setStackView.bind(this, 'app')
          },
          Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('App Only')
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          {
            className: (stackView === 'full' ? 'active' : '') + ' btn btn-default btn-sm',
            onClick: this.setStackView.bind(this, 'full')
          },
          Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Full')
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          {
            className: (stackView === 'raw' ? 'active' : '') + ' btn btn-default btn-sm',
            onClick: this.setStackView.bind(this, 'raw')
          },
          Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Raw')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        this.hasMinified() && [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          {
            key: 'original',
            className: (stackType === 'original' ? 'active' : '') + ' btn btn-default btn-sm',
            onClick: function onClick() {
              return _this.setStackType('original');
            }
          },
          this.getOriginalButtonLabel()
        ), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          {
            key: 'minified',
            className: (stackType === 'minified' ? 'active' : '') + ' btn btn-default btn-sm',
            onClick: function onClick() {
              return _this.setStackType('minified');
            }
          },
          this.getMinifiedButtonLabel()
        )]
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (CrashHeader);

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_errorBoundary__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_events_interfaces_exceptionContent__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_events_interfaces_rawExceptionContent__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_events_interfaces_stacktraceContent__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_events_interfaces_rawStacktraceContent__ = __webpack_require__(412);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var CrashContent = (_temp2 = _class = function (_React$Component) {
  _inherits(CrashContent, _React$Component);

  function CrashContent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CrashContent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CrashContent.__proto__ || Object.getPrototypeOf(CrashContent)).call.apply(_ref, [this].concat(args))), _this), _this.renderException = function () {
      var _this$props = _this.props,
          event = _this$props.event,
          stackView = _this$props.stackView,
          stackType = _this$props.stackType,
          newestFirst = _this$props.newestFirst,
          exception = _this$props.exception;

      return stackView === 'raw' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_events_interfaces_rawExceptionContent__["a" /* default */], {
        eventId: event.id,
        type: stackType,
        values: exception.values,
        platform: event.platform
      }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_events_interfaces_exceptionContent__["a" /* default */], {
        type: stackType,
        view: stackView,
        values: exception.values,
        platform: event.platform,
        newestFirst: newestFirst
      });
    }, _this.renderStacktrace = function () {
      var _this$props2 = _this.props,
          event = _this$props2.event,
          stackView = _this$props2.stackView,
          newestFirst = _this$props2.newestFirst,
          stacktrace = _this$props2.stacktrace;

      return stackView === 'raw' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'pre',
        { className: 'traceback plain' },
        Object(__WEBPACK_IMPORTED_MODULE_7_app_components_events_interfaces_rawStacktraceContent__["a" /* default */])(stacktrace, event.platform)
      ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_events_interfaces_stacktraceContent__["a" /* default */], {
        data: stacktrace,
        className: 'no-exception',
        includeSystemFrames: stackView === 'full',
        platform: event.platform,
        newestFirst: newestFirst
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CrashContent, [{
    key: 'render',
    value: function render() {
      if (this.props.exception) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_app_components_errorBoundary__["default"],
          { mini: true },
          this.renderException()
        );
      }
      if (this.props.stacktrace) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_app_components_errorBoundary__["default"],
          { mini: true },
          this.renderStacktrace()
        );
      }
      return null;
    }
  }]);

  return CrashContent;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  event: __WEBPACK_IMPORTED_MODULE_5_app_proptypes__["e" /* default */].Event.isRequired,
  stackView: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  stackType: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  newestFirst: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  exception: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  stacktrace: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (CrashContent);

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_events_interfaces_breadcrumbs_category__ = __webpack_require__(1098);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var CrumbTable = (_temp2 = _class = function (_React$Component) {
  _inherits(CrumbTable, _React$Component);

  function CrumbTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CrumbTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CrumbTable.__proto__ || Object.getPrototypeOf(CrumbTable)).call.apply(_ref, [this].concat(args))), _this), _this.renderData = function () {
      if (!_this.props.kvData) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(_this.props.kvData, function (val, key) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'tr',
          { key: key },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'td',
            { className: 'key' },
            key
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'td',
            { className: 'value' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'pre',
              null,
              val + ''
            )
          )
        );
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CrumbTable, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'table',
        { className: 'table key-value' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'thead',
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'tr',
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'td',
              { className: 'key' },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_events_interfaces_breadcrumbs_category__["a" /* default */], { value: this.props.crumb.category })
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'td',
              { className: 'value' },
              this.props.summary
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'tbody',
          null,
          this.props.children,
          this.renderData()
        )
      );
    }
  }]);

  return CrumbTable;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  crumb: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  kvData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  summary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (CrumbTable);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



function isOverflowing(el) {
  // XXX(mitsuhiko): subtract one because of reasons. Not sure which ones.
  return el.offsetHeight < el.scrollHeight - 1;
}

var SummaryLine = function (_React$Component) {
  _inherits(SummaryLine, _React$Component);

  function SummaryLine() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SummaryLine);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SummaryLine.__proto__ || Object.getPrototypeOf(SummaryLine)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      expanded: false,
      hasOverflow: false
    }, _this.makeSummariesGreatAgain = function (ref) {
      _this.domElement = ref;
      _this.respondToLayoutChanges();
    }, _this.respondToLayoutChanges = function () {
      if (!_this.domElement) {
        return;
      }
      var hasOverflow = isOverflowing(_this.domElement);
      if (hasOverflow !== _this.state.hasOverflow) {
        _this.setState({
          hasOverflow: hasOverflow
        });
      }
    }, _this.onToggle = function () {
      _this.setState({
        expanded: !_this.state.expanded
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SummaryLine, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.domElement = null;
      window.addEventListener('resize', this.respondToLayoutChanges);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.domElement = null;
      window.addEventListener('resize', this.respondToLayoutChanges);
    }
  }, {
    key: 'render',
    value: function render() {
      var className = 'summary';
      if (this.state.hasOverflow) {
        className += ' can-expand';
      }
      if (this.state.expanded) {
        className += ' expanded';
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: className,
          onClick: this.onToggle,
          ref: this.makeSummariesGreatAgain
        },
        this.props.children
      );
    }
  }]);

  return SummaryLine;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (SummaryLine);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var FileSize = (_temp = _class = function (_React$Component) {
  _inherits(FileSize, _React$Component);

  function FileSize() {
    _classCallCheck(this, FileSize);

    return _possibleConstructorReturn(this, (FileSize.__proto__ || Object.getPrototypeOf(FileSize)).apply(this, arguments));
  }

  _createClass(FileSize, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_2_app_utils__["i" /* formatBytes */])(this.props.bytes)
      );
    }
  }]);

  return FileSize;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  bytes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (FileSize);

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(1119),
    flatRest = __webpack_require__(402);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);




/**
 * Displays a number count. If `max` is specified, then give representation
 * of count, i.e. "1000+"
 *
 * Render nothing by default if `count` is falsy.
 */
function QueryCount(_ref) {
  var className = _ref.className,
      count = _ref.count,
      max = _ref.max,
      hideIfEmpty = _ref.hideIfEmpty,
      inline = _ref.inline;

  var countOrMax = typeof max !== 'undefined' && count >= max ? max + '+' : count;
  var cx = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('query-count', className, {
    inline: inline
  });

  if (hideIfEmpty && !count) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: cx },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      null,
      '('
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      { className: 'query-count-value' },
      countOrMax
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      null,
      ')'
    )
  );
}
QueryCount.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  count: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  hideIfEmpty: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};
QueryCount.defaultProps = {
  hideIfEmpty: true,
  inline: true
};

/* harmony default export */ __webpack_exports__["a"] = (QueryCount);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_mixins_projectState__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_timeSince__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_shortId__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_locale__ = __webpack_require__(2);












var EventOrGroupExtraDetails = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'EventOrGroupExtraDetails',

  propTypes: {
    orgId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    groupId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    lastSeen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    firstSeen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    subscriptionDetails: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
      reason: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
    }),
    numComments: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    logger: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    annotations: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string),
    assignedTo: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
      name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
    }),
    showAssignee: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    shortId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6_app_mixins_projectState__["a" /* default */]],

  render: function render() {
    var _props = this.props,
        orgId = _props.orgId,
        projectId = _props.projectId,
        groupId = _props.groupId,
        lastSeen = _props.lastSeen,
        firstSeen = _props.firstSeen,
        subscriptionDetails = _props.subscriptionDetails,
        numComments = _props.numComments,
        logger = _props.logger,
        assignedTo = _props.assignedTo,
        annotations = _props.annotations,
        showAssignee = _props.showAssignee,
        shortId = _props.shortId;

    var styles = {};
    if (subscriptionDetails && subscriptionDetails.reason === 'mentioned') {
      styles = { color: '#57be8c' };
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      GroupExtra,
      { align: 'center' },
      shortId && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_grid_emotion__["Box"],
        { mr: 2 },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(GroupShortId, { shortId: shortId })
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_grid_emotion__["Flex"],
        { align: 'center', mr: 2 },
        lastSeen && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(GroupExtraIcon, { className: 'icon icon-clock' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_timeSince__["default"], { date: lastSeen, suffix: Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('ago') })
        ),
        firstSeen && lastSeen && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'hidden-xs hidden-sm' },
          '\xA0\u2014\xA0'
        ),
        firstSeen && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_timeSince__["default"], {
          date: firstSeen,
          suffix: Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('old'),
          className: 'hidden-xs hidden-sm'
        })
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        GroupExtraCommentsAndLogger,
        null,
        numComments > 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_grid_emotion__["Box"],
          { mr: 2 },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_router__["Link"],
            {
              to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/activity/',
              className: 'comments'
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(GroupExtraIcon, { className: 'icon icon-comments', style: styles }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              GroupExtraIcon,
              { className: 'tag-count' },
              numComments
            )
          )
        ),
        logger && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_grid_emotion__["Box"],
          { className: 'event-annotation', mr: 2 },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_router__["Link"],
            {
              to: {
                pathname: '/' + orgId + '/' + projectId + '/',
                query: {
                  query: 'logger:' + logger
                }
              }
            },
            logger
          )
        )
      ),
      annotations && annotations.map(function (annotation, key) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grid_emotion__["Box"], {
          className: 'event-annotation',
          dangerouslySetInnerHTML: {
            __html: annotation
          },
          key: key
        });
      }),
      showAssignee && assignedTo && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_grid_emotion__["Box"],
        null,
        Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["tct"])('Assigned to [name]', { name: assignedTo.name })
      )
    );
  }
});

var GroupExtra = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_5_grid_emotion__["Flex"], {
  target: 'eec9orn0'
})('color:', function (p) {
  return p.theme.gray3;
}, ';font-size:12px;a{color:inherit;}');

var GroupExtraCommentsAndLogger = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_5_grid_emotion__["Flex"], {
  target: 'eec9orn1'
})('color:', function (p) {
  return p.theme.gray4;
}, ';');

var GroupShortId = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_8_app_components_shortId__["a" /* default */], {
  target: 'eec9orn2'
})('font-size:12px;color:', function (p) {
  return p.theme.gray3;
}, ';');

var GroupExtraIcon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('span', {
  target: 'eec9orn3'
})('font-size:11px;margin-right:4px;');

/* harmony default export */ __webpack_exports__["a"] = (EventOrGroupExtraDetails);

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_utils_retryableImport__ = __webpack_require__(1149);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var LazyLoad = (_temp = _class = function (_React$Component) {
  _inherits(LazyLoad, _React$Component);

  function LazyLoad() {
    var _ref;

    _classCallCheck(this, LazyLoad);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call.apply(_ref, [this].concat(args)));

    _this.getComponentGetter = function () {
      return _this.props.component || _this.props.route.componentPromise;
    };

    _this.handleFetchError = function (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      __WEBPACK_IMPORTED_MODULE_1_raven_js___default.a.captureException(error, { fingerprint: ['webpack', 'error loading chunk'] });
      _this.setState({
        error: error
      });
    };

    _this.fetchComponent = function () {
      var getComponent = _this.getComponentGetter();

      Object(__WEBPACK_IMPORTED_MODULE_6_app_utils_retryableImport__["a" /* default */])(getComponent).then(function (Component) {
        // Always load default export if available
        _this.setState({
          Component: Component.default || Component
        });
      }, _this.handleFetchError).catch(_this.handleFetchError);
    };

    _this.fetchRetry = function () {
      _this.setState({
        error: null
      }, function () {
        return _this.fetchComponent();
      });
    };

    _this.state = {
      Component: null,
      error: null
    };
    return _this;
  }

  _createClass(LazyLoad, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchComponent();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps, nextState) {
      // This is to handle the following case:
      // <Route path="a/">
      //   <Route path="b/" component={LazyLoad} componentPromise={...} />
      //   <Route path="c/" component={LazyLoad} componentPromise={...} />
      // </Route>
      //
      // `LazyLoad` will get not fully remount when we switch between `b` and `c`,
      // instead will just re-render.  Refetch if route paths are different
      if (nextProps.route && nextProps.route === this.props.route) return;

      // If `this.fetchComponent` is not in callback,
      // then there's no guarantee that new Component will be rendered
      this.setState({
        Component: null
      }, this.fetchComponent);
    }
  }, {
    key: 'componentDidCatch',
    value: function componentDidCatch(error, info) {
      this.handleFetchError(error);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          Component = _state.Component,
          error = _state.error;
      // eslint-disable-next-line no-unused-vars

      var _props = this.props,
          hideBusy = _props.hideBusy,
          hideError = _props.hideError,
          component = _props.component,
          otherProps = _objectWithoutProperties(_props, ['hideBusy', 'hideError', 'component']);

      if (error && !hideError) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_loadingError__["default"], {
          onRetry: this.fetchRetry,
          message: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('There was an error loading a component.')
        });
      }

      if (!Component && !hideBusy) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_loadingIndicator__["default"], null);

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, otherProps);
    }
  }]);

  return LazyLoad;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  hideBusy: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  hideError: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  /**
   * Function that returns a promise of a React.Component
   */
  component: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,

  /**
   * Also accepts a route object from react-router that has a `componentPromise` property
   */
  route: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    path: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    componentPromise: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
  })
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (LazyLoad);

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_stores_groupStore__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_issueList__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_organizations_homeContainer__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var OrganizationIssueList = (_temp = _class = function (_React$Component) {
  _inherits(OrganizationIssueList, _React$Component);

  function OrganizationIssueList(props) {
    _classCallCheck(this, OrganizationIssueList);

    var _this = _possibleConstructorReturn(this, (OrganizationIssueList.__proto__ || Object.getPrototypeOf(OrganizationIssueList)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = _this.getQueryStringState(props);
    return _this;
  }

  _createClass(OrganizationIssueList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.location.search !== this.props.location.search) {
        this.setState(this.getQueryStringState(nextProps), this.fetchData);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_3_app_stores_groupStore__["a" /* default */].reset();
    }
  }, {
    key: 'render',
    value: function render() {
      var path = this.props.location.pathname;
      var status = this.state.status;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_app_components_organizations_homeContainer__["default"],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'pull-right' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'btn-group' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
              {
                to: path,
                className: 'btn btn-sm btn-default' + (status === 'unresolved' ? ' active' : '')
              },
              Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Unresolved')
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
              {
                to: { pathname: path, query: { status: '' } },
                className: 'btn btn-sm btn-default' + (status === '' ? ' active' : '')
              },
              Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('All Issues')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h4',
          null,
          this.props.title
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_issueList__["a" /* default */], _extends({
          endpoint: this.props.endpoint,
          emptyText: this.props.emptyText,
          query: {
            status: this.state.status,
            statsPeriod: '24h',
            per_page: this.props.pageSize || 25
          },
          statsPeriod: '24h'
        }, this.props))
      );
    }
  }]);

  return OrganizationIssueList;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  endpoint: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  emptyText: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  pageSize: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
}, _initialiseProps = function _initialiseProps() {
  this.getQueryStringState = function (props) {
    var query = props.location.query;
    var status = 'status' in query ? query.status : 'unresolved';
    return {
      status: status
    };
  };
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (OrganizationIssueList);

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_mixins_projectState__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_loadingIndicator__ = __webpack_require__(11);










var ProjectDocsContext = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'ProjectDocsContext',
  mixins: [__WEBPACK_IMPORTED_MODULE_2_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_3_app_mixins_projectState__["a" /* default */]],

  getInitialState: function getInitialState() {
    return {
      loading: true,
      platformList: null,
      project: null,
      team: null
    };
  },
  componentDidMount: function componentDidMount() {
    this.fetchData();
  },
  fetchData: function fetchData() {
    var _this = this;

    var org = this.context.organization;
    if (!org) {
      return;
    }

    var orgId = org.slug;
    var projectId = this.context.project.slug;

    this.api.request('/projects/' + orgId + '/' + projectId + '/docs/', {
      success: function success(data) {
        _this.setState({
          loading: false,
          data: data
        });
      }
    });
  },
  render: function render() {
    if (this.state.loading) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_loadingIndicator__["default"], null);else if (this.state.error) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_loadingError__["default"], { onRetry: this.fetchData });

    var data = this.state.data;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.children, {
      platformData: data
    });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ProjectDocsContext);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__textOverflow__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tooltip__ = __webpack_require__(21);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SidebarItem = (_temp2 = _class = function (_React$Component) {
  _inherits(SidebarItem, _React$Component);

  function SidebarItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SidebarItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SidebarItem.__proto__ || Object.getPrototypeOf(SidebarItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      var _this$props = _this.props,
          id = _this$props.id,
          onClick = _this$props.onClick;


      if (typeof onClick !== 'function') return;

      onClick(id, e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SidebarItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          router = _props.router,
          href = _props.href,
          index = _props.index,
          to = _props.to,
          icon = _props.icon,
          label = _props.label,
          badge = _props.badge,
          active = _props.active,
          hasPanel = _props.hasPanel,
          collapsed = _props.collapsed,
          className = _props.className,
          orientation = _props.orientation;

      // If there is no active panel open and if path is active according to react-router

      var isActiveRouter = !hasPanel && router && to && router.isActive({
        pathname: to
      }, index);
      var isTop = orientation === 'top';
      var placement = isTop ? 'bottom' : 'right';

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__tooltip__["default"],
        {
          disabled: !collapsed,
          title: label,
          tooltipOptions: { placement: placement, html: true }
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          StyledSidebarItem,
          {
            'data-test-id': this.props['data-test-id'],
            active: active || isActiveRouter,
            href: href,
            to: to,
            className: className,
            onClick: this.handleClick
          },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            SidebarItemWrapper,
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              SidebarItemIcon,
              null,
              icon
            ),
            !collapsed && !isTop && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              SidebarItemLabel,
              null,
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__textOverflow__["a" /* default */],
                null,
                label
              )
            ),
            badge > 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              SidebarItemBadge,
              { collapsed: collapsed },
              badge
            )
          )
        )
      );
    }
  }]);

  return SidebarItem;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_4__link__["a" /* default */].propTypes, {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  // Is sidebar item active
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  // Is sidebar in a collapsed state
  collapsed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  // Sidebar has a panel open
  hasPanel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  // Icon to display
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  // Label to display (only when expanded)
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  // Additional badge to display after label
  badge: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  // Sidebar is at "top" or "left" of screen
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['top', 'left'])
}), _temp2);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["withRouter"])(SidebarItem));

var getActiveStyle = function getActiveStyle(_ref2) {
  var active = _ref2.active,
      theme = _ref2.theme;

  if (!active) return '';
  return (/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["css"])('color:', theme.white, ';&:active,&:focus,&:hover{color:', theme.white, ';}&:before{background-color:', theme.purple, ';}')
  );
};

var StyledSidebarItem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(function (_ref3) {
  var active = _ref3.active,
      props = _objectWithoutProperties(_ref3, ['active']);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__link__["a" /* default */], props);
}, {
  target: 'e1qdnaq70'
})('display:flex;color:inherit;position:relative;cursor:pointer;font-size:15px;line-height:32px;height:34px;flex-shrink:0;transition:0.15s color linear;&:before{display:block;content:\'\';position:absolute;top:5px;left:-20px;bottom:5px;width:5px;border-radius:0 3px 3px 0;background-color:transparent;transition:0.15s background-color linear;}@media (max-width:', function (p) {
  return p.theme.breakpoints[0];
}, '){margin:0 4px;&:before{top:auto;left:5px;bottom:-10px;height:5px;width:auto;right:5px;border-radius:3px 3px 0 0;}}&:hover,&:focus{color:', function (p) {
  return p.theme.gray1;
}, ';}', getActiveStyle, ';');

var SidebarItemWrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e1qdnaq71'
})('display:flex;align-items:center;width:100%;');

var SidebarItemIcon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('span', {
  target: 'e1qdnaq72'
})('content:\'\';display:inline-block;width:32px;height:22px;font-size:20px;svg{display:block;margin:0 auto;}');

var SidebarItemLabel = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('span', {
  target: 'e1qdnaq73'
})('margin-left:12px;white-space:nowrap;opacity:1;flex:1;');

var getCollapsedBadgeStyle = function getCollapsedBadgeStyle(_ref4) {
  var collapsed = _ref4.collapsed,
      theme = _ref4.theme;

  if (!collapsed) return '';

  return (/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["css"])('text-indent:-99999em;position:absolute;right:0;top:1px;background:', theme.red, ';width:', theme.sidebar.smallBadgeSize, ';height:', theme.sidebar.smallBadgeSize, ';border-radius:', theme.sidebar.smallBadgeSize, ';line-height:', theme.sidebar.smallBadgeSize, ';box-shadow:0 3px 3px ', theme.sidebar.background, ';')
  );
};

var SidebarItemBadge = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(function (_ref5) {
  var collapsed = _ref5.collapsed,
      props = _objectWithoutProperties(_ref5, ['collapsed']);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', props);
}, {
  target: 'e1qdnaq74'
})('display:block;text-align:center;color:', function (p) {
  return p.theme.white;
}, ';font-size:12px;background:', function (p) {
  return p.theme.red;
}, ';width:', function (p) {
  return p.theme.sidebar.badgeSize;
}, ';height:', function (p) {
  return p.theme.sidebar.badgeSize;
}, ';border-radius:', function (p) {
  return p.theme.sidebar.badgeSize;
}, ';line-height:', function (p) {
  return p.theme.sidebar.badgeSize;
}, ';', getCollapsedBadgeStyle, ';');

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var SidebarPanel = (_temp = _class = function (_React$Component) {
  _inherits(SidebarPanel, _React$Component);

  function SidebarPanel() {
    _classCallCheck(this, SidebarPanel);

    return _possibleConstructorReturn(this, (SidebarPanel.__proto__ || Object.getPrototypeOf(SidebarPanel)).apply(this, arguments));
  }

  _createClass(SidebarPanel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          orientation = _props.orientation,
          collapsed = _props.collapsed,
          hidePanel = _props.hidePanel,
          title = _props.title,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['orientation', 'collapsed', 'hidePanel', 'title', 'children']);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        StyledSidebarPanel,
        _extends({ collapsed: collapsed, orientation: orientation }, props),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          SidebarPanelHeader,
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            PanelClose,
            { onClick: hidePanel },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon-close' })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            Title,
            null,
            title
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          SidebarPanelBody,
          null,
          children
        )
      );
    }
  }]);

  return SidebarPanel;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  collapsed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  orientation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['top', 'left']),
  hidePanel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (SidebarPanel);

var getPositionForOrientation = function getPositionForOrientation(p) {
  if (p.orientation === 'top') {
    return (/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["css"])('top:', p.theme.sidebar.mobileHeight, ';left:0;right:0;')
    );
  }

  return (/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["css"])('width:', p.theme.sidebar.panel.width, ';top:0;left:', p.collapsed ? p.theme.sidebar.collapsedWidth : p.theme.sidebar.expandedWidth, ';')
  );
};
var StyledSidebarPanel = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(function (_ref) {
  var collapsed = _ref.collapsed,
      orientation = _ref.orientation,
      props = _objectWithoutProperties(_ref, ['collapsed', 'orientation']);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', props);
}, {
  target: 'e1cvaskl0'
})('position:fixed;bottom:0;background:', function (p) {
  return p.theme.whiteDark;
}, ';z-index:', function (p) {
  return p.theme.zIndex.sidebar;
}, ';color:#2f2936;border-right:1px solid ', function (p) {
  return p.theme.borderLight;
}, ';box-shadow:1px 0 2px rgba(0,0,0,0.06);text-align:left;line-height:24px;', getPositionForOrientation, ';');

var SidebarPanelHeader = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'e1cvaskl1'
})('border-bottom:1px solid ', function (p) {
  return p.theme.borderLight;
}, ';padding:20px;background:', function (p) {
  return p.theme.background;
}, ';box-shadow:0 1px 2px rgba(0,0,0,0.06);height:', function (p) {
  return p.theme.sidebar.panel.headerHeight;
}, ';');
var SidebarPanelBody = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'e1cvaskl2'
})('position:absolute;left:0;right:0;bottom:0;top:', function (p) {
  return p.theme.sidebar.panel.headerHeight;
}, ';overflow:auto;');

var PanelClose = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('a', {
  target: 'e1cvaskl3'
})('float:right;font-size:22px;position:relative;top:0;right:-3px;color:', function (p) {
  return p.theme.gray3;
}, ';&:hover{color:', function (p) {
  return p.theme.gray5;
}, ';}');

var Title = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'e1cvaskl4'
})('font-size:18px;margin:0;');

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrgSummary; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_avatar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_styles_overflowEllipsis__ = __webpack_require__(181);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SidebarOrgSummary = (_temp = _class = function (_React$Component) {
  _inherits(SidebarOrgSummary, _React$Component);

  function SidebarOrgSummary() {
    _classCallCheck(this, SidebarOrgSummary);

    return _possibleConstructorReturn(this, (SidebarOrgSummary.__proto__ || Object.getPrototypeOf(SidebarOrgSummary)).apply(this, arguments));
  }

  _createClass(SidebarOrgSummary, [{
    key: 'render',
    value: function render() {
      var organization = this.props.organization;

      var projects = organization.projects && organization.projects.length;
      var extra = [];

      if (projects) {
        extra.push(projects + ' projects');
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        OrgSummary,
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_avatar__["a" /* default */], {
          className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])({ flexShrink: 0 }),
          organization: organization, size: 36 }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Details,
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            SummaryOrgName,
            null,
            organization.name
          ),
          !!extra.length && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            SummaryOrgDetails,
            null,
            extra.join(', ')
          )
        )
      );
    }
  }]);

  return SidebarOrgSummary;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  organization: __WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Organization
}, _temp);


/* harmony default export */ __webpack_exports__["b"] = (SidebarOrgSummary);

var OrgSummary = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'e1n88pby0'
})('display:flex;padding:10px 15px;overflow:hidden;');
var SummaryOrgName = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'e1n88pby1'
})('color:', function (p) {
  return p.theme.gray5;
}, ';font-size:16px;line-height:1.1;font-weight:bold;margin-bottom:4px;', __WEBPACK_IMPORTED_MODULE_5_app_styles_overflowEllipsis__["a" /* default */], ';');
var SummaryOrgDetails = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'e1n88pby2'
})('color:', function (p) {
  return p.theme.gray3;
}, ';font-size:14px;line-height:1;', __WEBPACK_IMPORTED_MODULE_5_app_styles_overflowEllipsis__["a" /* default */], ';');
var Details = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'e1n88pby3'
})('display:flex;flex-direction:column;justify-content:center;padding-left:10px;overflow:hidden;');

// Needed for styling in SidebarMenuItem


/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_mixins_organizationState__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_onboardingWizard_toDoItem__ = __webpack_require__(1233);








var TodoList = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'TodoList',
  mixins: [__WEBPACK_IMPORTED_MODULE_3_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_4_app_mixins_organizationState__["a" /* default */]],

  statics: {
    TASKS: [{
      task: 1,
      title: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Create a project'),
      description: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Create your first Sentry project'),
      detailedDescription: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Follow our quick and easy steps to set up a project and start sending errors'),
      skippable: false,
      prereq: [],
      featureLocation: 'organization',
      location: 'projects/new/',
      display: true
    }, {
      task: 2,
      title: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Send your first event'),
      description: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])("Install Sentry's client"),
      detailedDescription: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Choose your platform and send an event'),
      skippable: false,
      prereq: [1],
      featureLocation: 'project',
      location: 'settings/install/',
      display: true
    }, {
      task: 3,
      title: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Invite team member'),
      description: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Bring your team aboard'),
      detailedDescription: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Let Sentry help your team triage and assign issues. Improve your workflow\n          by unlocking suggested owners, mentions, and assignment'),
      skippable: true,
      prereq: [],
      featureLocation: 'organization',
      location: 'members/',
      display: true
    }, {
      task: 4,
      title: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Add a second platform'),
      description: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Add Sentry to a second platform'),
      detailedDescription: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Cross platform functionality to support both your frontend and backend.'),
      skippable: true,
      prereq: [1, 2],
      featureLocation: 'organization',
      location: 'projects/new/',
      display: true
    }, {
      task: 5,
      title: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Add user context'),
      description: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Know who is being affected by crashes'),
      detailedDescription: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Unlock features that let you\n          drill down into the number of users affected by an issue as well as get a broader sense about the quality of the application.'),
      skippable: true,
      prereq: [1, 2],
      featureLocation: 'absolute',
      location: 'https://docs.sentry.io/hosted/learn/context/#capturing-the-user',
      display: true
    }, {
      task: 6,
      title: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Set up release tracking'),
      description: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('See what releases are generating errors'),
      detailedDescription: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Set up commits for additional context when determining the cause of an issue\n          e.g. suggested owners and resolve issues via commit messages'),
      skippable: true,
      prereq: [1, 2],
      featureLocation: 'project',
      location: 'settings/release-tracking/',
      display: true
    }, {
      task: 7,
      title: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Upload sourcemaps'),
      description: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Deminify javascript stacktraces'),
      detailedDescription: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('View source code context obtained from stack traces in their\n          original untransformed form, which is particularly useful for debugging minified code'),
      skippable: true,
      prereq: [1, 2], // Is one of the platforms javascript?
      featureLocation: 'absolute',
      location: 'https://docs.sentry.io/hosted/clients/javascript/sourcemaps/',
      display: true
    }, {
      task: 8,
      title: 'User crash reports',
      description: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Collect user feedback when your application crashes'),
      skippable: true,
      prereq: [1, 2, 5],
      featureLocation: 'project',
      location: 'settings/user-reports/',
      display: false
    }, {
      task: 9,
      title: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Set up issue tracking'),
      description: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Link to Sentry issues within your issue tracker'),
      skippable: true,
      prereq: [1, 2],
      featureLocation: 'project',
      location: 'settings/issue-tracking/',
      display: false
    }, {
      task: 10,
      title: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Set up an alerts service'),
      description: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Receive Sentry alerts in Slack or HipChat'),
      skippable: true,
      prereq: [1, 2],
      featureLocation: 'project',
      location: 'settings/alerts/',
      display: false
    }]
  },

  getInitialState: function getInitialState() {
    return {
      tasks: [],
      seeAll: false // Show all tasks, included those completed
    };
  },
  componentWillMount: function componentWillMount() {
    // Map server task state (who finished what) to TodoList.TASK objects
    var org = this.getOrganization();
    var tasks = TodoList.TASKS.map(function (task) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = org.onboardingTasks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var server_task = _step.value;

          if (server_task.task == task.task) {
            Object.assign(task, server_task);
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return task;
    });
    this.setState({ tasks: tasks });
  },
  skipTask: function skipTask(skipped_task) {
    var _this = this;

    var org = this.getOrganization();
    this.api.request('/organizations/' + org.slug + '/onboarding-tasks/', {
      method: 'POST',
      data: { task: skipped_task, status: 'skipped' },
      success: function success() {
        var new_state = _this.state.tasks.map(function (task) {
          if (task.task == skipped_task) {
            task.status = 'skipped';
          }
          return task;
        });
        _this.setState({ tasks: new_state });
      }
    });
    this.getOnboardingTasks();
  },
  render: function render() {
    var _this2 = this;

    var nextTasks = this.state.tasks.filter(function (task) {
      return task.display;
    });

    var todoListTasks = nextTasks.map(function (task) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_onboardingWizard_toDoItem__["a" /* default */], { key: task.task, task: task, onSkip: _this2.skipTask });
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'onboarding-wrapper' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: 'list-unstyled' },
          todoListTasks
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["default"] = (TodoList);

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_stores_indicatorStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_plugins_components_pluginIcon__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_plugins__ = __webpack_require__(252);
















var PluginConfig = __WEBPACK_IMPORTED_MODULE_4_create_react_class___default()({
  displayName: 'PluginConfig',

  propTypes: {
    organization: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    project: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    data: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    onDisablePlugin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    enabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6_app_mixins_apiMixin__["default"]],

  getDefaultProps: function getDefaultProps() {
    return {
      onDisablePlugin: function onDisablePlugin() {}
    };
  },
  getInitialState: function getInitialState() {
    return {
      loading: !__WEBPACK_IMPORTED_MODULE_12_app_plugins__["a" /* default */].isLoaded(this.props.data),
      testResults: ''
    };
  },
  componentWillMount: function componentWillMount() {
    this.loadPlugin(this.props.data);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    this.loadPlugin(nextProps.data);
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(nextState, this.state) || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(nextProps.data, this.props.data);
  },
  loadPlugin: function loadPlugin(data) {
    var _this = this;

    this.setState({
      loading: true
    }, function () {
      __WEBPACK_IMPORTED_MODULE_12_app_plugins__["a" /* default */].load(data, function () {
        _this.setState({ loading: false });
      });
    });
  },
  getPluginEndpoint: function getPluginEndpoint() {
    var _props = this.props,
        organization = _props.organization,
        project = _props.project,
        data = _props.data;

    return '/projects/' + organization.slug + '/' + project.slug + '/plugins/' + data.id + '/';
  },
  disablePlugin: function disablePlugin() {
    this.props.onDisablePlugin(this.props.data);
  },
  testPlugin: function testPlugin() {
    var _this2 = this;

    var loadingIndicator = __WEBPACK_IMPORTED_MODULE_8_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Sending test..'));
    this.api.request(this.getPluginEndpoint(), {
      method: 'POST',
      data: {
        test: true
      },
      success: function success(data) {
        _this2.setState({ testResults: JSON.stringify(data.detail) });
        __WEBPACK_IMPORTED_MODULE_8_app_stores_indicatorStore__["default"].remove(loadingIndicator);
        __WEBPACK_IMPORTED_MODULE_8_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Test Complete!'), 'success');
      },
      error: function error(_error) {
        __WEBPACK_IMPORTED_MODULE_8_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('An unexpected error occurred while testing your plugin. Please try again.'), 'error');
      }
    });
  },
  createMarkup: function createMarkup() {
    return { __html: this.props.data.doc };
  },
  render: function render() {
    var data = this.props.data;
    // If passed via props, use that value instead of from `data`

    var enabled = typeof this.props.enabled !== 'undefined' ? this.props.enabled : data.enabled;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_app_components_panels__["a" /* Panel */],
      { className: 'plugin-config ref-plugin-config-' + data.id },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_app_components_panels__["e" /* PanelHeader */],
        { hasButtons: true },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Flex"],
          { align: 'center', flex: '1' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Flex"],
            { align: 'center', mr: 1 },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_plugins_components_pluginIcon__["a" /* default */], { pluginId: data.id })
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'span',
            null,
            data.name
          )
        ),
        data.canDisable && enabled && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Flex"],
          { align: 'center' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Box"],
            { mr: 1 },
            data.isTestable && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_app_components_buttons_button__["default"],
              { onClick: this.testPlugin, size: 'small' },
              Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Test Plugin')
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Box"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_app_components_buttons_button__["default"],
              { size: 'small', onClick: this.disablePlugin },
              Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Disable')
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_app_components_panels__["c" /* PanelBody */],
        { px: 2, pt: 2, flex: true, wrap: 'wrap' },
        data.status === 'beta' ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: 'alert alert-block alert-warning' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'strong',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Note: This plugin is considered beta and may change in the future.')
          )
        ) : null,
        this.state.testResults != '' ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: 'alert alert-block alert-warning' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'strong',
            null,
            'Test Results: '
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'p',
            null,
            this.state.testResults
          )
        ) : null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { dangerouslySetInnerHTML: this.createMarkup() }),
        this.state.loading ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_loadingIndicator__["default"], null) : __WEBPACK_IMPORTED_MODULE_12_app_plugins__["a" /* default */].get(data).renderSettings({
          organization: this.props.organization,
          project: this.props.project
        })
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["default"] = (PluginConfig);

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_stores_groupStore__ = __webpack_require__(95);



var SelectedGroupStore = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({
  init: function init() {
    this.records = {};

    this.listenTo(__WEBPACK_IMPORTED_MODULE_1_app_stores_groupStore__["a" /* default */], this.onGroupChange, this.onGroupChange);
  },
  onGroupChange: function onGroupChange(itemIds) {
    this.prune();
    this.add(itemIds);
    this.trigger();
  },
  add: function add(ids) {
    var _this = this;

    var allSelected = this.allSelected();
    ids.forEach(function (id) {
      if (!_this.records.hasOwnProperty(id)) {
        _this.records[id] = allSelected;
      }
    });
  },
  prune: function prune() {
    var existingIds = new Set(__WEBPACK_IMPORTED_MODULE_1_app_stores_groupStore__["a" /* default */].getAllItemIds());

    // Remove ids that no longer exist
    for (var itemId in this.records) {
      if (!existingIds.has(itemId)) {
        delete this.records[itemId];
      }
    }
  },
  allSelected: function allSelected() {
    var itemIds = this.getSelectedIds();
    var numRecords = this.numSelected();
    return itemIds.size > 0 && itemIds.size === numRecords;
  },
  numSelected: function numSelected() {
    return Object.keys(this.records).length;
  },
  anySelected: function anySelected() {
    var itemIds = this.getSelectedIds();
    return itemIds.size > 0;
  },
  multiSelected: function multiSelected() {
    var itemIds = this.getSelectedIds();
    return itemIds.size > 1;
  },
  getSelectedIds: function getSelectedIds() {
    var selected = new Set();
    for (var itemId in this.records) {
      if (this.records[itemId]) {
        selected.add(itemId);
      }
    }
    return selected;
  },
  isSelected: function isSelected(itemId) {
    return this.records[itemId] === true;
  },
  deselectAll: function deselectAll() {
    for (var itemId in this.records) {
      this.records[itemId] = false;
    }
    this.trigger();
  },
  toggleSelect: function toggleSelect(itemId) {
    if (!this.records.hasOwnProperty(itemId)) return;
    this.records[itemId] = !this.records[itemId];
    this.trigger();
  },
  toggleSelectAll: function toggleSelectAll() {
    var allSelected = !this.allSelected();

    for (var itemId in this.records) {
      this.records[itemId] = allSelected;
    }

    this.trigger();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (SelectedGroupStore);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_reduce__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_actions_tagActions__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_stores_memberListStore__ = __webpack_require__(149);







var getUsername = function getUsername(_ref) {
  var isManaged = _ref.isManaged,
      username = _ref.username,
      email = _ref.email;

  return !isManaged && username ? username : email;
};

var getMemberListStoreUsernames = function getMemberListStoreUsernames() {
  return __WEBPACK_IMPORTED_MODULE_3_app_stores_memberListStore__["a" /* default */].getAll().map(getUsername);
};

var TagStore = __WEBPACK_IMPORTED_MODULE_1_reflux___default.a.createStore({
  listenables: __WEBPACK_IMPORTED_MODULE_2_app_actions_tagActions__["a" /* default */],

  init: function init() {
    this.listenTo(__WEBPACK_IMPORTED_MODULE_3_app_stores_memberListStore__["a" /* default */], this.onMemberListStoreChange);
    this.reset();
  },
  reset: function reset() {
    // TODO(mitsuhiko): what do we do with translations here?
    this.tags = {
      is: {
        key: 'is',
        name: 'Status',
        values: ['resolved', 'unresolved', 'ignored',
        // TODO(dcramer): remove muted once data is migrated and 9.0+
        'muted', 'assigned', 'unassigned'],
        predefined: true
      },
      has: {
        key: 'has',
        name: 'Has Tag',
        values: [],
        predefined: true
      },
      assigned: {
        key: 'assigned',
        name: 'Assigned To',
        values: getMemberListStoreUsernames(),
        predefined: true
      },
      bookmarks: {
        key: 'bookmarks',
        name: 'Bookmarked By',
        values: getMemberListStoreUsernames(),
        predefined: true
      },
      lastSeen: {
        key: 'lastSeen',
        name: 'Last Seen',
        values: ['-1h', '+1d', '-1w'],
        predefined: true
      },
      firstSeen: {
        key: 'firstSeen',
        name: 'First Seen',
        values: ['-1h', '+1d', '-1w'],
        predefined: true
      },
      'event.timestamp': {
        key: 'event.timestamp',
        name: 'Event Timestamp',
        values: ['2017-01-02', '>=2017-01-02T01:00:00', '<2017-01-02T02:00:00'],
        predefined: true
      },
      timesSeen: {
        key: 'timesSeen',
        name: 'Times Seen',
        values: [],
        predefined: true
      }
    };
    this.trigger(this.tags);
  },
  getTag: function getTag(tagName) {
    return this.tags[tagName];
  },
  getAllTags: function getAllTags() {
    return this.tags;
  },
  getTagKeys: function getTagKeys() {
    return Object.keys(this.tags);
  },
  getTagValues: function getTagValues(tagKey, query) {
    return this.tags[tagKey].values || [];
  },
  onLoadTagsSuccess: function onLoadTagsSuccess(data) {
    var _this = this;

    Object.assign(this.tags, __WEBPACK_IMPORTED_MODULE_0_lodash_reduce___default()(data, function (obj, tag) {
      tag = Object.assign({
        values: []
      }, tag);

      var old = _this.tags[tag.key];

      // Don't override predefined filters (e.g. "is")
      if (!old || !old.predefined) obj[tag.key] = tag;

      return obj;
    }, {}));
    this.tags.has.values = data.map(function (tag) {
      return tag.key;
    });
    this.trigger(this.tags);
  },
  onMemberListStoreChange: function onMemberListStoreChange(members) {
    var assignedTag = this.tags.assigned;
    assignedTag.values = getMemberListStoreUsernames();
    assignedTag.values.unshift('me');
    this.tags.bookmarks.values = assignedTag.values;
    this.trigger(this.tags);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (TagStore);

/***/ }),
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_stores_latestContextStore__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_utils_withOrganizations__ = __webpack_require__(417);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










// HoC that returns most usable organization + project
// This means your org if you only have 1 org, or
// last accessed organization/project
var withLatestContext = function withLatestContext(WrappedComponent) {
  return Object(__WEBPACK_IMPORTED_MODULE_6_app_utils_withOrganizations__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
    displayName: 'withLatestContext',
    propTypes: {
      organizations: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Organization)
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_2_reflux___default.a.connect(__WEBPACK_IMPORTED_MODULE_5_app_stores_latestContextStore__["a" /* default */], 'latestContext')],

    render: function render() {
      var organizations = this.props.organizations;
      var latestContext = this.state.latestContext;

      var _ref = latestContext || {},
          organization = _ref.organization,
          project = _ref.project,
          lastRoute = _ref.lastRoute;

      // Even though org details exists in LatestContextStore,
      // fetch organization from OrganizationsStore so that we can
      // expect consistent data structure because OrganizationsStore has a list
      // of orgs but not full org details


      var latestOrganization = organization || (organizations && organizations.length ? organizations[0] : null);

      // TODO(billy): Below is going to be wrong if component is passed project, it will override
      // project from `latestContext`
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({
        organizations: organizations,
        organization: latestOrganization,
        project: project,
        lastRoute: lastRoute
      }, this.props));
    }
  }));
};

/* harmony default export */ __webpack_exports__["a"] = (withLatestContext);

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(270),
    map = __webpack_require__(201);

/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return baseFlatten(map(collection, iteratee), 1);
}

module.exports = flatMap;


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return inputStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_emotion__ = __webpack_require__(5);


var readOnlyStyle = function readOnlyStyle(props) {
  return props.readOnly ? /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react_emotion__["css"])('cursor:default;') : '';
};

var inputStyles = function inputStyles(props) {
  return (/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react_emotion__["css"])('color:', props.theme.gray5, ';display:block;width:100%;background:#fff;border:1px solid ', props.theme.borderDark, ';border-radius:', props.theme.borderRadius, ';box-shadow:inset ', props.theme.dropShadowLight, ';padding:0.5em;transition:border 0.1s linear;resize:vertical;', readOnlyStyle(props), ';&:focus{outline:none;}&:hover,&:focus,&:active{border:1px solid ', props.theme.gray1, ';}&::placeholder{color:', props.theme.gray2, ';}')
  );
};



/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = selectText;
function selectText(node) {
  if (document.selection) {
    var range = document.body.createTextRange();
    range.moveToElementText(node);
    range.select();
  } else if (window.getSelection) {
    var _range = document.createRange();
    _range.selectNode(node);
    var selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(_range);
  }
}

/***/ }),
/* 391 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(923);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_stores_configStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_stores_hookStore__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_dynamicWrapper__ = __webpack_require__(192);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Footer = function (_React$Component) {
  _inherits(Footer, _React$Component);

  function Footer(props) {
    _classCallCheck(this, Footer);

    // Allow injection via getsentry et all
    var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));

    var hooks = [];
    __WEBPACK_IMPORTED_MODULE_2_app_stores_hookStore__["default"].get('footer').forEach(function (cb) {
      hooks.push(cb());
    });

    _this.state = {
      hooks: hooks
    };
    return _this;
  }

  _createClass(Footer, [{
    key: 'render',
    value: function render() {
      var config = __WEBPACK_IMPORTED_MODULE_1_app_stores_configStore__["default"].getConfig();
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'footer',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'pull-right' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'hidden-xs', href: '/api/' },
              Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('API')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: '/docs/' },
              Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Docs')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                className: 'hidden-xs',
                href: 'https://github.com/getsentry/sentry',
                rel: 'noreferrer'
              },
              Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Contribute')
            ),
            config.isOnPremise && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'hidden-xs', href: '/out/' },
              Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Migrate to SaaS')
            )
          ),
          config.isOnPremise && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'version pull-left' },
            'Sentry ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_dynamicWrapper__["default"], { fixed: 'Acceptance Test', value: config.version.current })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/', className: 'icon-sentry-logo' }),
          this.state.hooks
        )
      );
    }
  }]);

  return Footer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = navigateTo;
/* harmony export (immutable) */ __webpack_exports__["b"] = setLastRoute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_actionCreators_modal__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_contextPickerModal__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_actions_navigationActions__ = __webpack_require__(497);






function navigateTo(to, router) {
  // Check for placeholder params
  var needOrg = to.indexOf(':orgId') > -1;
  var needProject = to.indexOf(':projectId') > -1;

  if (needOrg || needProject) {
    Object(__WEBPACK_IMPORTED_MODULE_1_app_actionCreators_modal__["f" /* openModal */])(function (_ref) {
      var closeModal = _ref.closeModal,
          Header = _ref.Header,
          Body = _ref.Body;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_contextPickerModal__["a" /* default */], {
        Header: Header,
        Body: Body,
        nextPath: to,
        needOrg: needOrg,
        needProject: needProject,
        onFinish: function onFinish(path) {
          closeModal();
          router.push(path);
        }
      });
    }, {
      modalClassName: 'context-picker-modal'
    });
  } else {
    router.push(to);
  }
}

function setLastRoute(route) {
  __WEBPACK_IMPORTED_MODULE_3_app_actions_navigationActions__["a" /* default */].setLastRoute(route);
}

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(235),
    isObject = __webpack_require__(121);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 396 */,
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_forms_formField__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_forms_selectControl__ = __webpack_require__(317);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var SelectField = (_temp2 = _class = function (_FormField) {
  _inherits(SelectField, _FormField);

  function SelectField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SelectField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectField.__proto__ || Object.getPrototypeOf(SelectField)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (opt) {
      var value = opt ? opt.value : null;
      _this.setValue(value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SelectField, [{
    key: 'getClassName',
    value: function getClassName() {
      return '';
    }
  }, {
    key: 'getField',
    value: function getField() {
      var _props = this.props,
          options = _props.options,
          placeholder = _props.placeholder,
          disabled = _props.disabled,
          required = _props.required;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_forms_selectControl__["a" /* default */], {
        id: this.getId(),
        options: options,
        placeholder: placeholder,
        disabled: disabled,
        required: required,
        value: this.state.value,
        onChange: this.onChange.bind(this),
        clearable: this.props.clearable
      });
    }
  }]);

  return SelectField;
}(__WEBPACK_IMPORTED_MODULE_2_app_components_forms_formField__["a" /* default */]), _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_2_app_components_forms_formField__["a" /* default */].propTypes, {
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  clearable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}), _class.defaultProps = _extends({}, __WEBPACK_IMPORTED_MODULE_2_app_components_forms_formField__["a" /* default */].defaultProps, {
  clearable: true
}), _temp2);


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Badge = (_temp = _class = function (_React$Component) {
  _inherits(Badge, _React$Component);

  function Badge() {
    _classCallCheck(this, Badge);

    return _possibleConstructorReturn(this, (Badge.__proto__ || Object.getPrototypeOf(Badge)).apply(this, arguments));
  }

  _createClass(Badge, [{
    key: 'render',
    value: function render() {
      var className = 'badge';
      if (this.props.isNew) {
        className += ' new';
      }
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { className: Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["cx"])(className, this.props.className) },
        this.props.text
      );
    }
  }]);

  return Badge;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  text: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  isNew: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _temp);


/* harmony default export */ __webpack_exports__["default"] = (Badge);

/***/ }),
/* 399 */,
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Raven) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_avatar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_stores_memberListStore__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_stores_teamStore__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_proptypes__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ActorAvatar = (_temp = _class = function (_React$Component) {
  _inherits(ActorAvatar, _React$Component);

  function ActorAvatar() {
    _classCallCheck(this, ActorAvatar);

    return _possibleConstructorReturn(this, (ActorAvatar.__proto__ || Object.getPrototypeOf(ActorAvatar)).apply(this, arguments));
  }

  _createClass(ActorAvatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actor = _props.actor,
          props = _objectWithoutProperties(_props, ['actor']);

      if (actor.type == 'user') {
        var user = __WEBPACK_IMPORTED_MODULE_3_app_stores_memberListStore__["a" /* default */].getById(actor.id);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_avatar__["a" /* default */], _extends({ user: user, hasTooltip: true }, props));
      }
      if (actor.type == 'team') {
        var team = __WEBPACK_IMPORTED_MODULE_4_app_stores_teamStore__["a" /* default */].getById(actor.id);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_avatar__["a" /* default */], _extends({ team: team, hasTooltip: true }, props));
      }

      Raven.captureException('Unknown avatar type', {
        extra: { actor: actor }
      });
      return null;
    }
  }]);

  return ActorAvatar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  actor: __WEBPACK_IMPORTED_MODULE_5_app_proptypes__["a" /* Actor */].isRequired,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  default: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gravatar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (ActorAvatar);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(40)))

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export redirectToRemainingOrganization */
/* unused harmony export remove */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeAndRedirectToRemainingOrganization;
/* harmony export (immutable) */ __webpack_exports__["d"] = setActiveOrganization;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeOrganizationSlug;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateOrganization;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchOrganizationDetails;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_stores_indicatorStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_actions_organizationsActions__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_stores_organizationsStore__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_stores_projectsStore__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_stores_teamStore__ = __webpack_require__(150);









function redirectToRemainingOrganization(_ref) {
  var orgId = _ref.orgId;

  // Remove queued, should redirect
  var allOrgs = __WEBPACK_IMPORTED_MODULE_4_app_stores_organizationsStore__["a" /* default */].getAll().filter(function (org) {
    return org.status.id === 'active' && org.slug !== orgId;
  });
  if (!allOrgs.length) {
    __WEBPACK_IMPORTED_MODULE_0_react_router__["browserHistory"].push('/organizations/new/');
    return;
  }

  // Let's be smart and select the best org to redirect to
  var firstRemainingOrg = allOrgs[0];
  __WEBPACK_IMPORTED_MODULE_0_react_router__["browserHistory"].push('/' + firstRemainingOrg.slug + '/');
}

function remove(api) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      successMessage = _ref2.successMessage,
      errorMessage = _ref2.errorMessage,
      orgId = _ref2.orgId;

  var endpoint = '/organizations/' + orgId + '/';
  return api.requestPromise(endpoint, {
    method: 'DELETE'
  }).then(function (data) {
    __WEBPACK_IMPORTED_MODULE_3_app_actions_organizationsActions__["a" /* default */].removeSuccess(orgId);

    if (successMessage) {
      __WEBPACK_IMPORTED_MODULE_2_app_stores_indicatorStore__["default"].add(successMessage, 'success', { duration: 3000 });
    }
  }).catch(function (err) {
    __WEBPACK_IMPORTED_MODULE_3_app_actions_organizationsActions__["a" /* default */].removeError();

    if (errorMessage) {
      __WEBPACK_IMPORTED_MODULE_2_app_stores_indicatorStore__["default"].add(errorMessage, 'error', { duration: 3000 });
    }
  });
}

function removeAndRedirectToRemainingOrganization(api, params) {
  remove(api, params).then(function () {
    return redirectToRemainingOrganization(params);
  });
}

function setActiveOrganization(org) {
  __WEBPACK_IMPORTED_MODULE_3_app_actions_organizationsActions__["a" /* default */].setActive(org);
}

function changeOrganizationSlug(prev, next) {
  __WEBPACK_IMPORTED_MODULE_3_app_actions_organizationsActions__["a" /* default */].changeSlug(prev, next);
}

function updateOrganization(org) {
  __WEBPACK_IMPORTED_MODULE_3_app_actions_organizationsActions__["a" /* default */].update(org);
}

function fetchOrganizationDetails(orgId, _ref3) {
  var setActive = _ref3.setActive,
      loadProjects = _ref3.loadProjects,
      loadTeam = _ref3.loadTeam;

  var api = new __WEBPACK_IMPORTED_MODULE_1_app_api__["Client"]();
  var request = api.requestPromise('/organizations/' + orgId + '/');

  request.then(function (data) {
    if (setActive) {
      setActiveOrganization(data);
    }

    if (loadTeam) {
      __WEBPACK_IMPORTED_MODULE_6_app_stores_teamStore__["a" /* default */].loadInitialData(data.teams);
    }

    if (loadProjects) {
      __WEBPACK_IMPORTED_MODULE_5_app_stores_projectsStore__["a" /* default */].loadInitialData(data.projects || []);
    }
  });

  return request;
}

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(599),
    overRest = __webpack_require__(489),
    setToString = __webpack_require__(490);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProjectLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ProjectLabel = (_temp = _class = function (_React$PureComponent) {
  _inherits(ProjectLabel, _React$PureComponent);

  function ProjectLabel() {
    _classCallCheck(this, ProjectLabel);

    return _possibleConstructorReturn(this, (ProjectLabel.__proto__ || Object.getPrototypeOf(ProjectLabel)).apply(this, arguments));
  }

  _createClass(ProjectLabel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          project = _props.project,
          organization = _props.organization;

      var features = organization && new Set(organization.features);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        _extends({ className: 'project-label' }, this.props),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'project-name' },
          !features || features.has('new-teams') ? project.slug : project.name
        )
      );
    }
  }]);

  return ProjectLabel;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent), _class.propTypes = {
  project: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  organization: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
}, _temp);


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var NotFound = function (_React$Component) {
  _inherits(NotFound, _React$Component);

  function NotFound() {
    _classCallCheck(this, NotFound);

    return _possibleConstructorReturn(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).apply(this, arguments));
  }

  _createClass(NotFound, [{
    key: 'render',
    value: function render() {
      // TODO(chrissy): use scale for margin values
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert alert-block alert-error', style: { margin: '30px 0 10px' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { fontSize: 24, marginBottom: 10 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'icon-exclamation', style: { fontSize: 20, marginRight: 10 } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_1_app_locale__["t"])('Page Not Found')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'The page you are looking for was not found.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'You may wish to try the following:'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            null,
            'If you entered the address manually, double check the path. Did you forget a trailing slash?'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            null,
            'If you followed a link here, try hitting back and reloading the page. It\'s possible the resource was moved out from under you.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            null,
            'If all else fails,',
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: 'http://github.com/getsentry/sentry/issues' },
              'create an issue'
            ),
            ' with more details.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Not sure what to do? ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: '/' },
            'Return to the dashboard'
          )
        )
      );
    }
  }]);

  return NotFound;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (NotFound);

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PluginList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_actionCreators_plugins__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_inactivePlugins__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_pluginConfig__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var PluginList = (_temp2 = _class = function (_React$Component) {
  _inherits(PluginList, _React$Component);

  function PluginList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PluginList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PluginList.__proto__ || Object.getPrototypeOf(PluginList)).call.apply(_ref, [this].concat(args))), _this), _this.handleEnablePlugin = function (plugin) {
      var _this$props = _this.props,
          organization = _this$props.organization,
          project = _this$props.project;

      Object(__WEBPACK_IMPORTED_MODULE_2_app_actionCreators_plugins__["b" /* enablePlugin */])({
        projectId: project.slug,
        orgId: organization.slug,
        pluginId: plugin.slug
      });

      _this.props.onEnablePlugin(plugin);
    }, _this.handleDisablePlugin = function (plugin) {
      var _this$props2 = _this.props,
          organization = _this$props2.organization,
          project = _this$props2.project;

      Object(__WEBPACK_IMPORTED_MODULE_2_app_actionCreators_plugins__["a" /* disablePlugin */])({
        projectId: project.slug,
        orgId: organization.slug,
        pluginId: plugin.slug
      });

      _this.props.onDisablePlugin(plugin);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PluginList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          organization = _props.organization,
          pluginList = _props.pluginList,
          project = _props.project;


      if (!pluginList.length) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'panel panel-default' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'panel-body p-b-0' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])("Oops! Looks like there aren't any available integrations installed.")
            )
          )
        );
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        pluginList.filter(function (p) {
          return p.enabled;
        }).map(function (data) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_pluginConfig__["default"], {
            data: data,
            organization: organization,
            project: project,
            key: data.id,
            onDisablePlugin: _this2.handleDisablePlugin
          });
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_inactivePlugins__["a" /* default */], {
          plugins: pluginList.filter(function (p) {
            return !p.enabled;
          }),
          onEnablePlugin: this.handleEnablePlugin
        })
      );
    }
  }]);

  return PluginList;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  organization: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  project: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  pluginList: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,
  onDisablePlugin: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  onEnablePlugin: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
}, _class.defaultProps = {
  onDisablePlugin: function onDisablePlugin() {},
  onEnablePlugin: function onEnablePlugin() {}
}, _temp2);


/***/ }),
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 410 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 411 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPHPFrame */
/* unused harmony export getPythonFrame */
/* unused harmony export getJavaFrame */
/* unused harmony export getNativeFrame */
/* unused harmony export getJavaPreamble */
/* harmony export (immutable) */ __webpack_exports__["a"] = render;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_events_interfaces_frame__ = __webpack_require__(237);



function getJavaScriptFrame(frame) {
  var result = '';
  if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.function)) {
    result += '  at ' + frame.function + '(';
  } else {
    result += '  at ? (';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.filename)) {
    result += frame.filename;
  } else if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.module)) {
    result += frame.module;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.lineNo) && frame.lineNo >= 0) {
    result += ':' + frame.lineNo;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.colNo) && frame.colNo >= 0) {
    result += ':' + frame.colNo;
  }
  result += ')';
  return result;
}

function getRubyFrame(frame) {
  var result = '  from ';
  if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.filename)) {
    result += frame.filename;
  } else if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.module)) {
    result += '(' + frame.module + ')';
  } else {
    result += '?';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.lineNo) && frame.lineNo >= 0) {
    result += ':' + frame.lineNo;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.colNo) && frame.colNo >= 0) {
    result += ':' + frame.colNo;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.function)) {
    result += ':in `' + frame.function + "'";
  }
  return result;
}

function getPHPFrame(frame, idx) {
  var funcName = frame.function === 'null' ? '{main}' : frame.function;
  return '#' + idx + ' ' + (frame.filename || frame.module) + '(' + frame.lineNo + '): ' + funcName;
}

function getPythonFrame(frame) {
  var result = '';
  if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.filename)) {
    result += '  File "' + frame.filename + '"';
  } else if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.module)) {
    result += '  Module "' + frame.module + '"';
  } else {
    result += '  ?';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.lineNo) && frame.lineNo >= 0) {
    result += ', line ' + frame.lineNo;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.colNo) && frame.colNo >= 0) {
    result += ', col ' + frame.colNo;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.function)) {
    result += ', in ' + frame.function;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.context)) {
    frame.context.forEach(function (item) {
      if (item[0] === frame.lineNo) {
        result += '\n    ' + Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["t" /* trim */])(item[1]);
      }
    });
  }
  return result;
}

function getJavaFrame(frame) {
  var result = '    at';
  if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.module)) {
    result += ' ' + frame.module + '.';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.function)) {
    result += frame.function;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.filename)) {
    result += '(' + frame.filename;
    if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.lineNo) && frame.lineNo >= 0) {
      result += ':' + frame.lineNo;
    }
    result += ')';
  }
  return result;
}

function ljust(str, len) {
  return str + Array(Math.max(0, len - str.length) + 1).join(' ');
}

function getNativeFrame(frame) {
  var result = '  ';
  if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.package)) {
    result += ljust(Object(__WEBPACK_IMPORTED_MODULE_1_app_components_events_interfaces_frame__["b" /* trimPackage */])(frame.package), 20);
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.instructionAddr)) {
    result += ljust(frame.instructionAddr, 12);
  }
  result += ' ' + (frame.function || frame.symbolAddr);
  if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.filename)) {
    result += ' (' + frame.filename;
    if (Object(__WEBPACK_IMPORTED_MODULE_0_app_utils__["d" /* defined */])(frame.lineNo) && frame.lineNo >= 0) {
      result += ':' + frame.lineNo;
    }
    result += ')';
  }
  return result;
}

function getJavaPreamble(exception) {
  var result = exception.type + ': ' + exception.value;
  if (exception.module) {
    result = exception.module + '.' + result;
  }
  return result;
}

function getPreamble(exception, platform) {
  switch (platform) {
    case 'java':
      return getJavaPreamble(exception);
    default:
      return exception.type + ': ' + exception.value;
  }
}

function getFrame(frame, frameIdx, platform) {
  if (frame.platform) {
    platform = frame.platform;
  }
  switch (platform) {
    case 'javascript':
      return getJavaScriptFrame(frame, frameIdx);
    case 'ruby':
      return getRubyFrame(frame, frameIdx);
    case 'php':
      return getPHPFrame(frame, frameIdx);
    case 'python':
      return getPythonFrame(frame, frameIdx);
    case 'java':
      return getJavaFrame(frame, frameIdx);
    case 'objc':
    // fallthrough
    case 'cocoa':
    // fallthrough
    case 'native':
      return getNativeFrame(frame, frameIdx);
    default:
      return getPythonFrame(frame, frameIdx);
  }
}

function render(data, platform, exception) {
  var firstFrameOmitted = void 0,
      lastFrameOmitted = void 0;
  var frames = [];

  if (data.framesOmitted) {
    firstFrameOmitted = data.framesOmitted[0];
    lastFrameOmitted = data.framesOmitted[1];
  } else {
    firstFrameOmitted = null;
    lastFrameOmitted = null;
  }

  data.frames.forEach(function (frame, frameIdx) {
    frames.push(getFrame(frame, frameIdx, platform));
    if (frameIdx === firstFrameOmitted) {
      frames.push('.. frames ' + firstFrameOmitted + ' until ' + lastFrameOmitted + ' were omitted and not available ..');
    }
  });

  if (platform !== 'python') {
    frames.reverse();
  }

  if (exception) {
    frames.unshift(getPreamble(exception, platform));
  }

  return frames.join('\n');
}

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Truncate = (_temp = _class = function (_React$Component) {
  _inherits(Truncate, _React$Component);

  function Truncate() {
    var _ref;

    _classCallCheck(this, Truncate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = Truncate.__proto__ || Object.getPrototypeOf(Truncate)).call.apply(_ref, [this].concat(args)));

    _this.onFocus = function (e) {
      var _this$props = _this.props,
          value = _this$props.value,
          maxLength = _this$props.maxLength;

      if (value.length <= maxLength) return;
      _this.setState({ isExpanded: true });
    };

    _this.onBlur = function (e) {
      if (_this.state.isExpanded) _this.setState({ isExpanded: false });
    };

    _this.state = {
      isExpanded: false
    };
    return _this;
  }

  _createClass(Truncate, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          leftTrim = _props.leftTrim,
          maxLength = _props.maxLength,
          value = _props.value;

      var isTruncated = value.length > maxLength;
      var shortValue = '';

      if (isTruncated) {
        if (leftTrim) {
          shortValue = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            '\u2026 ',
            value.slice(value.length - (maxLength - 4), value.length)
          );
        } else {
          shortValue = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            value.slice(0, maxLength - 4),
            ' \u2026'
          );
        }
      } else {
        shortValue = value;
      }

      var className = this.props.className || '';
      className += ' truncated';
      if (this.state.isExpanded) className += ' expanded';

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        {
          className: className,
          onMouseOver: this.onFocus,
          onMouseOut: this.onBlur,
          onFocus: this.onFocus,
          onBlur: this.onBlur
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'short-value' },
          shortValue
        ),
        isTruncated && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'full-value' },
          value
        )
      );
    }
  }]);

  return Truncate;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  leftTrim: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  maxLength: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
}, _class.defaultProps = {
  leftTrim: false,
  maxLength: 50
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (Truncate);

/***/ }),
/* 414 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(414),
    overRest = __webpack_require__(489),
    setToString = __webpack_require__(490);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(308),
    arrayIncludes = __webpack_require__(491),
    arrayIncludesWith = __webpack_require__(492),
    cacheHas = __webpack_require__(309),
    createSet = __webpack_require__(930),
    setToArray = __webpack_require__(931);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_stores_organizationsStore__ = __webpack_require__(168);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var withOrganizations = function withOrganizations(WrappedComponent) {
  return __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
    displayName: 'withOrganizations',
    mixins: [__WEBPACK_IMPORTED_MODULE_2_reflux___default.a.connect(__WEBPACK_IMPORTED_MODULE_3_app_stores_organizationsStore__["a" /* default */], 'organizations')],

    render: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({ organizations: this.state.organizations }, this.props));
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (withOrganizations);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ApiForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_stores_indicatorStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_forms_form__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_forms_state__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ApiForm = (_temp = _class = function (_Form) {
  _inherits(ApiForm, _Form);

  function ApiForm(props, context) {
    _classCallCheck(this, ApiForm);

    var _this = _possibleConstructorReturn(this, (ApiForm.__proto__ || Object.getPrototypeOf(ApiForm)).call(this, props, context));

    _this.onSubmit = function (e) {
      e.preventDefault();

      if (_this.state.state == __WEBPACK_IMPORTED_MODULE_4_app_components_forms_state__["a" /* default */].SAVING) {
        return;
      }

      var data = _this.state.data;


      _this.props.onSubmit && _this.props.onSubmit(data);
      _this.setState({
        state: __WEBPACK_IMPORTED_MODULE_4_app_components_forms_state__["a" /* default */].SAVING
      }, function () {
        var loadingIndicator = __WEBPACK_IMPORTED_MODULE_2_app_stores_indicatorStore__["default"].add(_this.props.submitLoadingMessage);
        _this.api.request(_this.props.apiEndpoint, {
          method: _this.props.apiMethod,
          data: data,
          success: function success(result) {
            __WEBPACK_IMPORTED_MODULE_2_app_stores_indicatorStore__["default"].remove(loadingIndicator);
            _this.onSubmitSuccess(result);
          },
          error: function error(_error) {
            __WEBPACK_IMPORTED_MODULE_2_app_stores_indicatorStore__["default"].remove(loadingIndicator);
            __WEBPACK_IMPORTED_MODULE_2_app_stores_indicatorStore__["default"].add(_this.props.submitErrorMessage, 'error');
            _this.onSubmitError(_error);
          }
        });
      });
    };

    _this.api = new __WEBPACK_IMPORTED_MODULE_1_app_api__["Client"]();
    return _this;
  }

  _createClass(ApiForm, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.api.clear();
    }
  }]);

  return ApiForm;
}(__WEBPACK_IMPORTED_MODULE_3_app_components_forms_form__["default"]), _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_3_app_components_forms_form__["default"].propTypes, {
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  apiMethod: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  apiEndpoint: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  submitLoadingMessage: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  submitErrorMessage: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}), _class.defaultProps = _extends({}, __WEBPACK_IMPORTED_MODULE_3_app_components_forms_form__["default"].defaultProps, {
  submitErrorMessage: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('There was an error saving your changes.'),
  submitLoadingMessage: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Saving changes..')
}), _temp);


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(224),
    eq = __webpack_require__(409);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_api__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_forms__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_stores_indicatorStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var callbackWithArgs = function callbackWithArgs(callback) {
  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(callback)) {
    var _callback;

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    callback = (_callback = callback).bind.apply(_callback, [this].concat(args));
  } else {
    callback = null;
  }
  return callback;
};

var PluginComponentBase = function (_React$Component) {
  _inherits(PluginComponentBase, _React$Component);

  function PluginComponentBase(props, context) {
    _classCallCheck(this, PluginComponentBase);

    var _this = _possibleConstructorReturn(this, (PluginComponentBase.__proto__ || Object.getPrototypeOf(PluginComponentBase)).call(this, props, context));

    ['onLoadSuccess', 'onLoadError', 'onSave', 'onSaveSuccess', 'onSaveError', 'onSaveComplete', 'renderField'].map(function (method) {
      return _this[method] = _this[method].bind(_this);
    });

    if (_this.fetchData) {
      _this.fetchData = _this.onLoad.bind(_this, _this.fetchData.bind(_this));
    }
    if (_this.onSubmit) {
      _this.onSubmit = _this.onSave.bind(_this, _this.onSubmit.bind(_this));
    }

    _this.state = {
      state: __WEBPACK_IMPORTED_MODULE_3_app_components_forms__["FormState"].READY
    };
    return _this;
  }

  _createClass(PluginComponentBase, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.api = new __WEBPACK_IMPORTED_MODULE_2_app_api__["Client"]();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.api.clear();
    }
  }, {
    key: 'onLoad',
    value: function onLoad(callback) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      this.setState({
        state: __WEBPACK_IMPORTED_MODULE_3_app_components_forms__["FormState"].LOADING
      }, callbackWithArgs.apply(undefined, [callback].concat(args)));
    }
  }, {
    key: 'onLoadSuccess',
    value: function onLoadSuccess(callback) {
      for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      this.setState({
        state: __WEBPACK_IMPORTED_MODULE_3_app_components_forms__["FormState"].READY
      }, callbackWithArgs.apply(undefined, [callback].concat(args)));
    }
  }, {
    key: 'onLoadError',
    value: function onLoadError(callback) {
      for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      this.setState({
        state: __WEBPACK_IMPORTED_MODULE_3_app_components_forms__["FormState"].ERROR
      }, callbackWithArgs.apply(undefined, [callback].concat(args)));
      __WEBPACK_IMPORTED_MODULE_4_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('An error occurred.'), 'error', {
        duration: 3000
      });
    }
  }, {
    key: 'onSave',
    value: function onSave(callback) {
      var _this2 = this;

      if (this.state.state == __WEBPACK_IMPORTED_MODULE_3_app_components_forms__["FormState"].SAVING) {
        return;
      }

      for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      callback = callbackWithArgs.apply(undefined, [callback].concat(args));
      this.setState({
        state: __WEBPACK_IMPORTED_MODULE_3_app_components_forms__["FormState"].SAVING
      }, function () {
        _this2._loadingIndicator = __WEBPACK_IMPORTED_MODULE_4_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Saving changes..'));
        callback && callback();
      });
    }
  }, {
    key: 'onSaveSuccess',
    value: function onSaveSuccess(callback) {
      for (var _len6 = arguments.length, args = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }

      this.setState({
        state: __WEBPACK_IMPORTED_MODULE_3_app_components_forms__["FormState"].READY
      }, callbackWithArgs.apply(undefined, [callback].concat(args)));
      __WEBPACK_IMPORTED_MODULE_4_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Success!'), 'success', {
        duration: 3000
      });
    }
  }, {
    key: 'onSaveError',
    value: function onSaveError(callback) {
      for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        args[_key7 - 1] = arguments[_key7];
      }

      callback = callbackWithArgs.apply(undefined, [callback].concat(args));
      this.setState({
        state: __WEBPACK_IMPORTED_MODULE_3_app_components_forms__["FormState"].ERROR
      }, function () {
        __WEBPACK_IMPORTED_MODULE_4_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Unable to save changes. Please try again.'), 'error', {
          duration: 3000
        });
        callback && callback();
      });
    }
  }, {
    key: 'onSaveComplete',
    value: function onSaveComplete(callback) {
      __WEBPACK_IMPORTED_MODULE_4_app_stores_indicatorStore__["default"].remove(this._loadingIndicator);

      for (var _len8 = arguments.length, args = Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
        args[_key8 - 1] = arguments[_key8];
      }

      callback = callbackWithArgs.apply(undefined, [callback].concat(args));
      callback && callback();
    }
  }, {
    key: 'renderField',
    value: function renderField(props) {
      props = _extends({}, props);
      props.formState = this.state.state;
      props.config = props.config || {};
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_forms__["GenericField"], _extends({ key: props.config.name }, props));
    }
  }]);

  return PluginComponentBase;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (PluginComponentBase);

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(123),
    baseUniq = __webpack_require__(416);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_inlineSvg__ = __webpack_require__(24);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isBitbucket = function isBitbucket(providerId) {
  return ['bitbucket', 'integrations:bitbucket'].includes(providerId);
};
var isGithub = function isGithub(providerId) {
  return ['github', 'integrations:github', 'integrations:github_enterprise'].includes(providerId);
};

var CommitLink = (_temp2 = _class = function (_React$Component) {
  _inherits(CommitLink, _React$Component);

  function CommitLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CommitLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CommitLink.__proto__ || Object.getPrototypeOf(CommitLink)).call.apply(_ref, [this].concat(args))), _this), _this.getCommitUrl = function () {
      // TODO(jess): move this to plugins
      if (isGithub(_this.props.repository.provider.id)) {
        return _this.props.repository.url + '/commit/' + _this.props.commitId;
      }
      if (isBitbucket(_this.props.repository.provider.id)) {
        return _this.props.repository.url + '/commits/' + _this.props.commitId;
      }
      return undefined;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CommitLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          inline = _props.inline,
          commitId = _props.commitId,
          repository = _props.repository;


      if (!commitId || !repository) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Unknown Commit')
        );
      }

      var commitUrl = this.getCommitUrl();
      var shortId = commitId.slice(0, 7);

      return commitUrl ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        {
          className: inline ? 'inline-commit' : 'btn btn-default btn-sm',
          href: commitUrl,
          target: '_blank'
        },
        isGithub(repository.provider.id) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_inlineSvg__["a" /* default */], { src: 'icon-github', style: { verticalAlign: 'text-top' }, size: '14px' }),
        isBitbucket(repository.provider.id) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_inlineSvg__["a" /* default */], {
          src: 'icon-bitbucket',
          style: { verticalAlign: 'text-top' },
          size: '14px'
        }),
        '\xA0',
        inline ? '' : ' ',
        shortId
      ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        null,
        shortId
      );
    }
  }]);

  return CommitLink;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  commitId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  repository: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  inline: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (CommitLink);

/***/ }),
/* 423 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 461 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['openModal', 'closeModal']));

/***/ }),
/* 463 */,
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

(function(window) {
    var re = {
        not_string: /[^s]/,
        number: /[diefg]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^\)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijosuxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[\+\-]/
    }

    function sprintf() {
        var key = arguments[0], cache = sprintf.cache
        if (!(cache[key] && cache.hasOwnProperty(key))) {
            cache[key] = sprintf.parse(key)
        }
        return sprintf.format.call(null, cache[key], arguments)
    }

    sprintf.format = function(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, node_type = "", arg, output = [], i, k, match, pad, pad_character, pad_length, is_positive = true, sign = ""
        for (i = 0; i < tree_length; i++) {
            node_type = get_type(parse_tree[i])
            if (node_type === "string") {
                output[output.length] = parse_tree[i]
            }
            else if (node_type === "array") {
                match = parse_tree[i] // convenience purposes only
                if (match[2]) { // keyword argument
                    arg = argv[cursor]
                    for (k = 0; k < match[2].length; k++) {
                        if (!arg.hasOwnProperty(match[2][k])) {
                            throw new Error(sprintf("[sprintf] property '%s' does not exist", match[2][k]))
                        }
                        arg = arg[match[2][k]]
                    }
                }
                else if (match[1]) { // positional argument (explicit)
                    arg = argv[match[1]]
                }
                else { // positional argument (implicit)
                    arg = argv[cursor++]
                }

                if (get_type(arg) == "function") {
                    arg = arg()
                }

                if (re.not_string.test(match[8]) && re.not_json.test(match[8]) && (get_type(arg) != "number" && isNaN(arg))) {
                    throw new TypeError(sprintf("[sprintf] expecting number but found %s", get_type(arg)))
                }

                if (re.number.test(match[8])) {
                    is_positive = arg >= 0
                }

                switch (match[8]) {
                    case "b":
                        arg = arg.toString(2)
                    break
                    case "c":
                        arg = String.fromCharCode(arg)
                    break
                    case "d":
                    case "i":
                        arg = parseInt(arg, 10)
                    break
                    case "j":
                        arg = JSON.stringify(arg, null, match[6] ? parseInt(match[6]) : 0)
                    break
                    case "e":
                        arg = match[7] ? arg.toExponential(match[7]) : arg.toExponential()
                    break
                    case "f":
                        arg = match[7] ? parseFloat(arg).toFixed(match[7]) : parseFloat(arg)
                    break
                    case "g":
                        arg = match[7] ? parseFloat(arg).toPrecision(match[7]) : parseFloat(arg)
                    break
                    case "o":
                        arg = arg.toString(8)
                    break
                    case "s":
                        arg = ((arg = String(arg)) && match[7] ? arg.substring(0, match[7]) : arg)
                    break
                    case "u":
                        arg = arg >>> 0
                    break
                    case "x":
                        arg = arg.toString(16)
                    break
                    case "X":
                        arg = arg.toString(16).toUpperCase()
                    break
                }
                if (re.json.test(match[8])) {
                    output[output.length] = arg
                }
                else {
                    if (re.number.test(match[8]) && (!is_positive || match[3])) {
                        sign = is_positive ? "+" : "-"
                        arg = arg.toString().replace(re.sign, "")
                    }
                    else {
                        sign = ""
                    }
                    pad_character = match[4] ? match[4] === "0" ? "0" : match[4].charAt(1) : " "
                    pad_length = match[6] - (sign + arg).length
                    pad = match[6] ? (pad_length > 0 ? str_repeat(pad_character, pad_length) : "") : ""
                    output[output.length] = match[5] ? sign + arg + pad : (pad_character === "0" ? sign + pad + arg : pad + sign + arg)
                }
            }
        }
        return output.join("")
    }

    sprintf.cache = {}

    sprintf.parse = function(fmt) {
        var _fmt = fmt, match = [], parse_tree = [], arg_names = 0
        while (_fmt) {
            if ((match = re.text.exec(_fmt)) !== null) {
                parse_tree[parse_tree.length] = match[0]
            }
            else if ((match = re.modulo.exec(_fmt)) !== null) {
                parse_tree[parse_tree.length] = "%"
            }
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1
                    var field_list = [], replacement_field = match[2], field_match = []
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list[field_list.length] = field_match[1]
                        while ((replacement_field = replacement_field.substring(field_match[0].length)) !== "") {
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) {
                                field_list[field_list.length] = field_match[1]
                            }
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
                                field_list[field_list.length] = field_match[1]
                            }
                            else {
                                throw new SyntaxError("[sprintf] failed to parse named argument key")
                            }
                        }
                    }
                    else {
                        throw new SyntaxError("[sprintf] failed to parse named argument key")
                    }
                    match[2] = field_list
                }
                else {
                    arg_names |= 2
                }
                if (arg_names === 3) {
                    throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported")
                }
                parse_tree[parse_tree.length] = match
            }
            else {
                throw new SyntaxError("[sprintf] unexpected placeholder")
            }
            _fmt = _fmt.substring(match[0].length)
        }
        return parse_tree
    }

    var vsprintf = function(fmt, argv, _argv) {
        _argv = (argv || []).slice(0)
        _argv.splice(0, 0, fmt)
        return sprintf.apply(null, _argv)
    }

    /**
     * helpers
     */
    function get_type(variable) {
        return Object.prototype.toString.call(variable).slice(8, -1).toLowerCase()
    }

    function str_repeat(input, multiplier) {
        return Array(multiplier + 1).join(input)
    }

    /**
     * export to either browser or node.js
     */
    if (true) {
        exports.sprintf = sprintf
        exports.vsprintf = vsprintf
    }
    else {
        window.sprintf = sprintf
        window.vsprintf = vsprintf

        if (typeof define === "function" && define.amd) {
            define(function() {
                return {
                    sprintf: sprintf,
                    vsprintf: vsprintf
                }
            })
        }
    }
})(typeof window === "undefined" ? this : window);


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./bg/LC_MESSAGES/django.po": 466,
	"./cs/LC_MESSAGES/django.po": 467,
	"./de/LC_MESSAGES/django.po": 468,
	"./en/LC_MESSAGES/django.po": 852,
	"./es/LC_MESSAGES/django.po": 469,
	"./fi/LC_MESSAGES/django.po": 470,
	"./fr/LC_MESSAGES/django.po": 471,
	"./it/LC_MESSAGES/django.po": 472,
	"./ja/LC_MESSAGES/django.po": 473,
	"./ru/LC_MESSAGES/django.po": 474,
	"./zh_CN/LC_MESSAGES/django.po": 475,
	"./zh_TW/LC_MESSAGES/django.po": 476
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 465;

/***/ }),
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export propTypes */
/* unused harmony export PropTypes */
/* unused harmony export onError */
/* unused harmony export observer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Observer; });
/* unused harmony export renderReporter */
/* unused harmony export componentByNodeRegistery */
/* unused harmony export trackComponents */
/* unused harmony export useStaticRendering */
/* unused harmony export Provider */
/* unused harmony export inject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);




// These functions can be stubbed out in specific environments
var unstable_batchedUpdates$1 = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var EventEmitter = function () {
    function EventEmitter() {
        classCallCheck(this, EventEmitter);
        this.listeners = [];
    }

    createClass(EventEmitter, [{
        key: "on",
        value: function on(cb) {
            var _this = this;

            this.listeners.push(cb);
            return function () {
                var index = _this.listeners.indexOf(cb);
                if (index !== -1) _this.listeners.splice(index, 1);
            };
        }
    }, {
        key: "emit",
        value: function emit(data) {
            this.listeners.forEach(function (fn) {
                return fn(data);
            });
        }
    }]);
    return EventEmitter;
}();

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

var hoistNonReactStatics = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty$1(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};

// Copied from React.PropTypes
function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
            rest[_key - 6] = arguments[_key];
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["k" /* untracked */])(function () {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else {
                return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
            }
        });
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}

// Copied from React.PropTypes
function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") {
        return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") {
        return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
    }

    return false;
}

// Copied from React.PropTypes
function getPropType(propValue) {
    var propType = typeof propValue === "undefined" ? "undefined" : _typeof(propValue);
    if (Array.isArray(propValue)) {
        return "array";
    }
    if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return "object";
    }
    if (isSymbol(propType, propValue)) {
        return "symbol";
    }
    return propType;
}

// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function getPreciseType(propValue) {
    var propType = getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) {
            return "date";
        } else if (propValue instanceof RegExp) {
            return "regexp";
        }
    }
    return propType;
}

function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["k" /* untracked */])(function () {
            if (allowNativeType) {
                if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker = void 0;
            switch (mobxType) {
                case "Array":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* isObservableArray */];
                    break;
                case "Object":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["h" /* isObservableObject */];
                    break;
                case "Map":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["g" /* isObservableMap */];
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}

function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        for (var _len2 = arguments.length, rest = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
            rest[_key2 - 5] = arguments[_key2];
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["k" /* untracked */])(function () {
            if (typeof typeChecker !== "function") {
                return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            }
            var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
            if (error instanceof Error) return error;
            var propValue = props[propName];
            for (var i = 0; i < propValue.length; i++) {
                error = typeChecker.apply(undefined, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
                if (error instanceof Error) return error;
            }
            return null;
        });
    });
}

var observableArray = createObservableTypeCheckerCreator(false, "Array");
var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
var observableMap = createObservableTypeCheckerCreator(false, "Map");
var observableObject = createObservableTypeCheckerCreator(false, "Object");
var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");



var propTypes = Object.freeze({
	observableArray: observableArray,
	observableArrayOf: observableArrayOf,
	observableMap: observableMap,
	observableObject: observableObject,
	arrayOrObservableArray: arrayOrObservableArray,
	arrayOrObservableArrayOf: arrayOrObservableArrayOf,
	objectOrObservableObject: objectOrObservableObject
});

function isStateless(component) {
    // `function() {}` has prototype, but `() => {}` doesn't
    // `() => {}` via Babel has prototype too.
    return !(component.prototype && component.prototype.render);
}

var injectorContextTypes = {
    mobxStores: objectOrObservableObject
};
Object.seal(injectorContextTypes);

var proxiedInjectorProps = {
    contextTypes: {
        get: function get$$1() {
            return injectorContextTypes;
        },
        set: function set$$1(_) {
            console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
        },
        configurable: true,
        enumerable: false
    },
    isMobxInjector: {
        value: true,
        writable: true,
        configurable: true,
        enumerable: true
    }

    /**
     * Store Injection
     */
};function createStoreInjector(grabStoresFn, component, injectNames) {
    var _class, _temp2;

    var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
    if (injectNames) displayName += "-with-" + injectNames;

    var Injector = (_temp2 = _class = function (_Component) {
        inherits(Injector, _Component);

        function Injector() {
            var _ref;

            var _temp, _this, _ret;

            classCallCheck(this, Injector);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Injector.__proto__ || Object.getPrototypeOf(Injector)).call.apply(_ref, [this].concat(args))), _this), _this.storeRef = function (instance) {
                _this.wrappedInstance = instance;
            }, _temp), possibleConstructorReturn(_this, _ret);
        }

        createClass(Injector, [{
            key: "render",
            value: function render() {
                // Optimization: it might be more efficient to apply the mapper function *outside* the render method
                // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
                // See this test: 'using a custom injector is not too reactive' in inject.js
                var newProps = {};
                for (var key in this.props) {
                    if (this.props.hasOwnProperty(key)) {
                        newProps[key] = this.props[key];
                    }
                }var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
                for (var _key2 in additionalProps) {
                    newProps[_key2] = additionalProps[_key2];
                }

                if (!isStateless(component)) {
                    newProps.ref = this.storeRef;
                }

                return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, newProps);
            }
        }]);
        return Injector;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = displayName, _temp2);

    // Static fields from component should be visible on the generated Injector

    hoistNonReactStatics(Injector, component);

    Injector.wrappedComponent = component;
    Object.defineProperties(Injector, proxiedInjectorProps);

    return Injector;
}

function grabStoresByName(storeNames) {
    return function (baseStores, nextProps) {
        storeNames.forEach(function (storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}

/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */
function inject() /* fn(stores, nextProps) or ...storeNames */{
    var grabStoresFn = void 0;
    if (typeof arguments[0] === "function") {
        grabStoresFn = arguments[0];
        return function (componentClass) {
            var injected = createStoreInjector(grabStoresFn, componentClass);
            injected.isMobxInjector = false; // supress warning
            // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
            // see #111
            injected = observer(injected);
            injected.isMobxInjector = true; // restore warning
            return injected;
        };
    } else {
        var storeNames = [];
        for (var i = 0; i < arguments.length; i++) {
            storeNames[i] = arguments[i];
        }grabStoresFn = grabStoresByName(storeNames);
        return function (componentClass) {
            return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
        };
    }
}

/**
 * dev tool support
 */
var isDevtoolsEnabled = false;

var isUsingStaticRendering = false;

var warnedAboutObserverInjectDeprecation = false;

// WeakMap<Node, Object>;
var componentByNodeRegistery = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
var renderReporter = new EventEmitter();

function findDOMNode$2(component) {
    if (__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"]) {
        try {
            return Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(component);
        } catch (e) {
            // findDOMNode will throw in react-test-renderer, see:
            // See https://github.com/mobxjs/mobx-react/issues/216
            // Is there a better heuristic?
            return null;
        }
    }
    return null;
}

function reportRendering(component) {
    var node = findDOMNode$2(component);
    if (node && componentByNodeRegistery) componentByNodeRegistery.set(node, component);

    renderReporter.emit({
        event: "render",
        renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
        totalTime: Date.now() - component.__$mobRenderStart,
        component: component,
        node: node
    });
}

function trackComponents() {
    if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
    if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
}

function useStaticRendering(useStaticRendering) {
    isUsingStaticRendering = useStaticRendering;
}

/**
 * Errors reporter
 */

var errorsReporter = new EventEmitter();

/**
 * Utilities
 */

function patch(target, funcName) {
    var runMixinFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var base = target[funcName];
    var mixinFunc = reactiveMixin[funcName];
    var f = !base ? mixinFunc : runMixinFirst === true ? function () {
        mixinFunc.apply(this, arguments);
        base.apply(this, arguments);
    } : function () {
        base.apply(this, arguments);
        mixinFunc.apply(this, arguments);
    };

    // MWE: ideally we freeze here to protect against accidental overwrites in component instances, see #195
    // ...but that breaks react-hot-loader, see #231...
    target[funcName] = f;
}

function isObjectShallowModified(prev, next) {
    if (null == prev || null == next || (typeof prev === "undefined" ? "undefined" : _typeof(prev)) !== "object" || (typeof next === "undefined" ? "undefined" : _typeof(next)) !== "object") {
        return prev !== next;
    }
    var keys = Object.keys(prev);
    if (keys.length !== Object.keys(next).length) {
        return true;
    }
    var key = void 0;
    for (var i = keys.length - 1; i >= 0, key = keys[i]; i--) {
        if (next[key] !== prev[key]) {
            return true;
        }
    }
    return false;
}

/**
 * ReactiveMixin
 */
var reactiveMixin = {
    componentWillMount: function componentWillMount() {
        var _this = this;

        if (isUsingStaticRendering === true) return;
        // Generate friendly name for debugging
        var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
        var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID;

        /**
         * If props are shallowly modified, react will render anyway,
         * so atom.reportChanged() should not result in yet another re-render
         */
        var skipRender = false;
        /**
         * forceUpdate will re-assign this.props. We don't want that to cause a loop,
         * so detect these changes
         */
        var isForcingUpdate = false;

        function makePropertyObservableReference(propName) {
            var valueHolder = this[propName];
            var atom = new __WEBPACK_IMPORTED_MODULE_0_mobx__["a" /* Atom */]("reactive " + propName);
            Object.defineProperty(this, propName, {
                configurable: true,
                enumerable: true,
                get: function get$$1() {
                    atom.reportObserved();
                    return valueHolder;
                },
                set: function set$$1(v) {
                    if (!isForcingUpdate && isObjectShallowModified(valueHolder, v)) {
                        valueHolder = v;
                        skipRender = true;
                        atom.reportChanged();
                        skipRender = false;
                    } else {
                        valueHolder = v;
                    }
                }
            });
        }

        // make this.props an observable reference, see #124
        makePropertyObservableReference.call(this, "props");
        // make state an observable reference
        makePropertyObservableReference.call(this, "state");

        // wire up reactive render
        var baseRender = this.render.bind(this);
        var reaction = null;
        var isRenderingPending = false;

        var initialRender = function initialRender() {
            reaction = new __WEBPACK_IMPORTED_MODULE_0_mobx__["b" /* Reaction */](initialName + "#" + rootNodeID + ".render()", function () {
                if (!isRenderingPending) {
                    // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
                    // This unidiomatic React usage but React will correctly warn about this so we continue as usual
                    // See #85 / Pull #44
                    isRenderingPending = true;
                    if (typeof _this.componentWillReact === "function") _this.componentWillReact(); // TODO: wrap in action?
                    if (_this.__$mobxIsUnmounted !== true) {
                        // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
                        // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
                        // However, people also claim this migth happen during unit tests..
                        var hasError = true;
                        try {
                            isForcingUpdate = true;
                            if (!skipRender) __WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.forceUpdate.call(_this);
                            hasError = false;
                        } finally {
                            isForcingUpdate = false;
                            if (hasError) reaction.dispose();
                        }
                    }
                }
            });
            reaction.reactComponent = _this;
            reactiveRender.$mobx = reaction;
            _this.render = reactiveRender;
            return reactiveRender();
        };

        var reactiveRender = function reactiveRender() {
            isRenderingPending = false;
            var exception = undefined;
            var rendering = undefined;
            reaction.track(function () {
                if (isDevtoolsEnabled) {
                    _this.__$mobRenderStart = Date.now();
                }
                try {
                    rendering = __WEBPACK_IMPORTED_MODULE_0_mobx__["e" /* extras */].allowStateChanges(false, baseRender);
                } catch (e) {
                    exception = e;
                }
                if (isDevtoolsEnabled) {
                    _this.__$mobRenderEnd = Date.now();
                }
            });
            if (exception) {
                errorsReporter.emit(exception);
                throw exception;
            }
            return rendering;
        };

        this.render = initialRender;
    },

    componentWillUnmount: function componentWillUnmount() {
        if (isUsingStaticRendering === true) return;
        this.render.$mobx && this.render.$mobx.dispose();
        this.__$mobxIsUnmounted = true;
        if (isDevtoolsEnabled) {
            var node = findDOMNode$2(this);
            if (node && componentByNodeRegistery) {
                componentByNodeRegistery.delete(node);
            }
            renderReporter.emit({
                event: "destroy",
                component: this,
                node: node
            });
        }
    },

    componentDidMount: function componentDidMount() {
        if (isDevtoolsEnabled) {
            reportRendering(this);
        }
    },

    componentDidUpdate: function componentDidUpdate() {
        if (isDevtoolsEnabled) {
            reportRendering(this);
        }
    },

    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        if (isUsingStaticRendering) {
            console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
        }
        // update on any state changes (as is the default)
        if (this.state !== nextState) {
            return true;
        }
        // update if props are shallowly not equal, inspired by PureRenderMixin
        // we could return just 'false' here, and avoid the `skipRender` checks etc
        // however, it is nicer if lifecycle events are triggered like usually,
        // so we return true here if props are shallowly modified.
        return isObjectShallowModified(this.props, nextProps);
    }

    /**
     * Observer function / decorator
     */
};function observer(arg1, arg2) {
    if (typeof arg1 === "string") {
        throw new Error("Store names should be provided as array");
    }
    if (Array.isArray(arg1)) {
        // component needs stores
        if (!warnedAboutObserverInjectDeprecation) {
            warnedAboutObserverInjectDeprecation = true;
            console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
        }
        if (!arg2) {
            // invoked as decorator
            return function (componentClass) {
                return observer(arg1, componentClass);
            };
        } else {
            return inject.apply(null, arg1)(observer(arg2));
        }
    }
    var componentClass = arg1;

    if (componentClass.isMobxInjector === true) {
        console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
    }

    // Stateless function component:
    // If it is function but doesn't seem to be a react class constructor,
    // wrap it to a react class automatically
    if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !__WEBPACK_IMPORTED_MODULE_1_react__["Component"].isPrototypeOf(componentClass)) {
        var _class, _temp;

        return observer((_temp = _class = function (_Component) {
            inherits(_class, _Component);

            function _class() {
                classCallCheck(this, _class);
                return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
            }

            createClass(_class, [{
                key: "render",
                value: function render() {
                    return componentClass.call(this, this.props, this.context);
                }
            }]);
            return _class;
        }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
    }

    if (!componentClass) {
        throw new Error("Please pass a valid component to 'observer'");
    }

    var target = componentClass.prototype || componentClass;
    mixinLifecycleEvents(target);
    componentClass.isMobXReactObserver = true;
    return componentClass;
}

function mixinLifecycleEvents(target) {
    patch(target, "componentWillMount", true);["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
        patch(target, funcName);
    });
    if (!target.shouldComponentUpdate) {
        target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
    }
}

// TODO: support injection somehow as well?
var Observer = observer(function (_ref) {
    var children = _ref.children;
    return children();
});

Observer.displayName = "Observer";

Observer.propTypes = {
    children: function children(propValue, key, componentName, location, propFullName) {
        if (typeof propValue[key] !== "function") return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(propValue[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
    }
};

var _class;
var _temp;

var specialReactKeys = { children: true, key: true, ref: true };

var Provider = (_temp = _class = function (_Component) {
    inherits(Provider, _Component);

    function Provider() {
        classCallCheck(this, Provider);
        return possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
    }

    createClass(Provider, [{
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
        }
    }, {
        key: "getChildContext",
        value: function getChildContext() {
            var stores = {};
            // inherit stores
            var baseStores = this.context.mobxStores;
            if (baseStores) for (var key in baseStores) {
                stores[key] = baseStores[key];
            }
            // add own stores
            for (var _key in this.props) {
                if (!specialReactKeys[_key] && _key !== "suppressChangedStoreWarning") stores[_key] = this.props[_key];
            }return {
                mobxStores: stores
            };
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            // Maybe this warning is too aggressive?
            if (Object.keys(nextProps).length !== Object.keys(this.props).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
            if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
                if (!specialReactKeys[key] && this.props[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
            }
        }
    }]);
    return Provider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.contextTypes = {
    mobxStores: objectOrObservableObject
}, _class.childContextTypes = {
    mobxStores: objectOrObservableObject.isRequired
}, _temp);

if (!__WEBPACK_IMPORTED_MODULE_1_react__["Component"]) throw new Error("mobx-react requires React to be available");
if (!__WEBPACK_IMPORTED_MODULE_0_mobx__["e" /* extras */]) throw new Error("mobx-react requires mobx to be available");

if (typeof __WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"] === "function") __WEBPACK_IMPORTED_MODULE_0_mobx__["e" /* extras */].setReactionScheduler(__WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"]);else if (typeof unstable_batchedUpdates$1 === "function") __WEBPACK_IMPORTED_MODULE_0_mobx__["e" /* extras */].setReactionScheduler(unstable_batchedUpdates$1);

var onError = function onError(fn) {
    return errorsReporter.on(fn);
};

/* DevTool support */
// See: https://github.com/andykog/mobx-devtools/blob/d8976c24b8cb727ed59f9a0bc905a009df79e221/src/backend/installGlobalHook.js

if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
    var mobx$1 = { spy: __WEBPACK_IMPORTED_MODULE_0_mobx__["j" /* spy */], extras: __WEBPACK_IMPORTED_MODULE_0_mobx__["e" /* extras */] };
    var mobxReact = { renderReporter: renderReporter, componentByNodeRegistery: componentByNodeRegistery, trackComponents: trackComponents };
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx$1);
}




/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return extras; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Reaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return untracked; });
/* unused harmony export IDerivationState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Atom; });
/* unused harmony export BaseAtom */
/* unused harmony export useStrict */
/* unused harmony export isStrictModeEnabled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return spy; });
/* unused harmony export comparer */
/* unused harmony export asReference */
/* unused harmony export asFlat */
/* unused harmony export asStructure */
/* unused harmony export asMap */
/* unused harmony export isModifierDescriptor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isObservableObject; });
/* unused harmony export isBoxedObservable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isObservableArray; });
/* unused harmony export ObservableMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isObservableMap; });
/* unused harmony export map */
/* unused harmony export transaction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return observable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return computed; });
/* unused harmony export isObservable */
/* unused harmony export isComputed */
/* unused harmony export extendObservable */
/* unused harmony export extendShallowObservable */
/* unused harmony export observe */
/* unused harmony export intercept */
/* unused harmony export autorun */
/* unused harmony export autorunAsync */
/* unused harmony export when */
/* unused harmony export reaction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return action; });
/* unused harmony export isAction */
/* unused harmony export runInAction */
/* unused harmony export expr */
/* unused harmony export toJS */
/* unused harmony export createTransformer */
/* unused harmony export whyRun */
/* unused harmony export isArrayLike */
/** MobX - (c) Michel Weststrate 2015, 2016 - MIT Licensed */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

/**
 * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
 *
 * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
 * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
 */
var BaseAtom = (function () {
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function BaseAtom(name) {
        if (name === void 0) { name = "Atom@" + getNextId(); }
        this.name = name;
        this.isPendingUnobservation = true; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.NOT_TRACKING;
    }
    BaseAtom.prototype.onBecomeUnobserved = function () {
        // noop
    };
    /**
     * Invoke this method to notify mobx that your atom has been used somehow.
     */
    BaseAtom.prototype.reportObserved = function () {
        reportObserved(this);
    };
    /**
     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
     */
    BaseAtom.prototype.reportChanged = function () {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    BaseAtom.prototype.toString = function () {
        return this.name;
    };
    return BaseAtom;
}());
var Atom = (function (_super) {
    __extends(Atom, _super);
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function Atom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
        if (name === void 0) { name = "Atom@" + getNextId(); }
        if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop; }
        if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop; }
        var _this = _super.call(this, name) || this;
        _this.name = name;
        _this.onBecomeObservedHandler = onBecomeObservedHandler;
        _this.onBecomeUnobservedHandler = onBecomeUnobservedHandler;
        _this.isPendingUnobservation = false; // for effective unobserving.
        _this.isBeingTracked = false;
        return _this;
    }
    Atom.prototype.reportObserved = function () {
        startBatch();
        _super.prototype.reportObserved.call(this);
        if (!this.isBeingTracked) {
            this.isBeingTracked = true;
            this.onBecomeObservedHandler();
        }
        endBatch();
        return !!globalState.trackingDerivation;
        // return doesn't really give useful info, because it can be as well calling computed which calls atom (no reactions)
        // also it could not trigger when calculating reaction dependent on Atom because Atom's value was cached by computed called by given reaction.
    };
    Atom.prototype.onBecomeUnobserved = function () {
        this.isBeingTracked = false;
        this.onBecomeUnobservedHandler();
    };
    return Atom;
}(BaseAtom));
var isAtom = createInstanceofPredicate("Atom", BaseAtom);

function hasInterceptors(interceptable) {
    return interceptable.interceptors && interceptable.interceptors.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
    interceptors.push(handler);
    return once(function () {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1)
            interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        var interceptors = interceptable.interceptors;
        if (interceptors)
            for (var i = 0, l = interceptors.length; i < l; i++) {
                change = interceptors[i](change);
                invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
                if (!change)
                    break;
            }
        return change;
    }
    finally {
        untrackedEnd(prevU);
    }
}

function hasListeners(listenable) {
    return listenable.changeListeners && listenable.changeListeners.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
    listeners.push(handler);
    return once(function () {
        var idx = listeners.indexOf(handler);
        if (idx !== -1)
            listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners;
    if (!listeners)
        return;
    listeners = listeners.slice();
    for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i](change);
    }
    untrackedEnd(prevU);
}

function isSpyEnabled() {
    return !!globalState.spyListeners.length;
}
function spyReport(event) {
    if (!globalState.spyListeners.length)
        return;
    var listeners = globalState.spyListeners;
    for (var i = 0, l = listeners.length; i < l; i++)
        listeners[i](event);
}
function spyReportStart(event) {
    var change = objectAssign({}, event, { spyReportStart: true });
    spyReport(change);
}
var END_EVENT = { spyReportEnd: true };
function spyReportEnd(change) {
    if (change)
        spyReport(objectAssign({}, change, END_EVENT));
    else
        spyReport(END_EVENT);
}
function spy(listener) {
    globalState.spyListeners.push(listener);
    return once(function () {
        var idx = globalState.spyListeners.indexOf(listener);
        if (idx !== -1)
            globalState.spyListeners.splice(idx, 1);
    });
}

function iteratorSymbol() {
    return (typeof Symbol === "function" && Symbol.iterator) || "@@iterator";
}
var IS_ITERATING_MARKER = "__$$iterating";
function arrayAsIterator(array) {
    // returning an array for entries(), values() etc for maps was a mis-interpretation of the specs..,
    // yet it is quite convenient to be able to use the response both as array directly and as iterator
    // it is suboptimal, but alas...
    invariant(array[IS_ITERATING_MARKER] !== true, "Illegal state: cannot recycle array as iterator");
    addHiddenFinalProp(array, IS_ITERATING_MARKER, true);
    var idx = -1;
    addHiddenFinalProp(array, "next", function next() {
        idx++;
        return {
            done: idx >= this.length,
            value: idx < this.length ? this[idx] : undefined
        };
    });
    return array;
}
function declareIterator(prototType, iteratorFactory) {
    addHiddenFinalProp(prototType, iteratorSymbol(), iteratorFactory);
}

var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
// Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364
var safariPrototypeSetterInheritanceBug = (function () {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function () {
            v = true;
        }
    });
    Object.create(p)["0"] = 1;
    return v === false;
})();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */
var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = (function () {
    function StubArray() {
    }
    return StubArray;
}());
function inherit(ctor, proto) {
    if (typeof Object["setPrototypeOf"] !== "undefined") {
        Object["setPrototypeOf"](ctor.prototype, proto);
    }
    else if (typeof ctor.prototype.__proto__ !== "undefined") {
        ctor.prototype.__proto__ = proto;
    }
    else {
        ctor["prototype"] = proto;
    }
}
inherit(StubArray, Array.prototype);
// Weex freeze Array.prototype
// Make them writeable and configurable in prototype chain
// https://github.com/alibaba/weex/pull/1529
if (Object.isFrozen(Array)) {
    
    [
        "constructor",
        "push",
        "shift",
        "concat",
        "pop",
        "unshift",
        "replace",
        "find",
        "findIndex",
        "splice",
        "reverse",
        "sort"
    ].forEach(function (key) {
        Object.defineProperty(StubArray.prototype, key, {
            configurable: true,
            writable: true,
            value: Array.prototype[key]
        });
    });
}
var ObservableArrayAdministration = (function () {
    function ObservableArrayAdministration(name, enhancer, array, owned) {
        this.array = array;
        this.owned = owned;
        this.values = [];
        this.lastKnownLength = 0;
        this.interceptors = null;
        this.changeListeners = null;
        this.atom = new BaseAtom(name || "ObservableArray@" + getNextId());
        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
    }
    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
        if (this.dehancer !== undefined)
            return values.map(this.dehancer);
        return values;
    };
    ObservableArrayAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        if (fireImmediately) {
            listener({
                object: this.array,
                type: "splice",
                index: 0,
                added: this.values.slice(),
                addedCount: this.values.length,
                removed: [],
                removedCount: 0
            });
        }
        return registerListener(this, listener);
    };
    ObservableArrayAdministration.prototype.getArrayLength = function () {
        this.atom.reportObserved();
        return this.values.length;
    };
    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
        if (typeof newLength !== "number" || newLength < 0)
            throw new Error("[mobx.array] Out of range: " + newLength);
        var currentLength = this.values.length;
        if (newLength === currentLength)
            return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for (var i = 0; i < newLength - currentLength; i++)
                newItems[i] = undefined; // No Array.fill everywhere...
            this.spliceWithArray(currentLength, 0, newItems);
        }
        else
            this.spliceWithArray(newLength, currentLength - newLength);
    };
    // adds / removes the necessary numeric properties to this object
    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
        if (oldLength !== this.lastKnownLength)
            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
        this.lastKnownLength += delta;
        if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE)
            reserveArrayBuffer(oldLength + delta + 1);
    };
    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom);
        var length = this.values.length;
        if (index === undefined)
            index = 0;
        else if (index > length)
            index = length;
        else if (index < 0)
            index = Math.max(0, length + index);
        if (arguments.length === 1)
            deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null)
            deleteCount = 0;
        else
            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined)
            newItems = [];
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.array,
                type: "splice",
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change)
                return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.map(function (v) { return _this.enhancer(v, undefined); });
        var lengthDelta = newItems.length - deleteCount;
        this.updateArrayLength(length, lengthDelta); // create or remove new entries
        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0)
            this.notifyArraySplice(index, newItems, res);
        return this.dehanceValues(res);
    };
    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            return (_a = this.values).splice.apply(_a, [index, deleteCount].concat(newItems));
        }
        else {
            var res = this.values.slice(index, index + deleteCount);
            this.values = this.values
                .slice(0, index)
                .concat(newItems, this.values.slice(index + deleteCount));
            return res;
        }
        var _a;
    };
    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "update",
                index: index,
                newValue: newValue,
                oldValue: oldValue
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        this.atom.reportChanged();
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "splice",
                index: index,
                removed: removed,
                added: added,
                removedCount: removed.length,
                addedCount: added.length
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        this.atom.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    return ObservableArrayAdministration;
}());
var ObservableArray = (function (_super) {
    __extends(ObservableArray, _super);
    function ObservableArray(initialValues, enhancer, name, owned) {
        if (name === void 0) { name = "ObservableArray@" + getNextId(); }
        if (owned === void 0) { owned = false; }
        var _this = _super.call(this) || this;
        var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
        addHiddenFinalProp(_this, "$mobx", adm);
        if (initialValues && initialValues.length) {
            _this.spliceWithArray(0, 0, initialValues);
        }
        if (safariPrototypeSetterInheritanceBug) {
            // Seems that Safari won't use numeric prototype setter untill any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(adm.array, "0", ENTRY_0);
        }
        return _this;
    }
    ObservableArray.prototype.intercept = function (handler) {
        return this.$mobx.intercept(handler);
    };
    ObservableArray.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        return this.$mobx.observe(listener, fireImmediately);
    };
    ObservableArray.prototype.clear = function () {
        return this.splice(0);
    };
    ObservableArray.prototype.concat = function () {
        var arrays = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arrays[_i] = arguments[_i];
        }
        this.$mobx.atom.reportObserved();
        return Array.prototype.concat.apply(this.peek(), arrays.map(function (a) { return (isObservableArray(a) ? a.peek() : a); }));
    };
    ObservableArray.prototype.replace = function (newItems) {
        return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
    };
    /**
     * Converts this array back to a (shallow) javascript structure.
     * For a deep clone use mobx.toJS
     */
    ObservableArray.prototype.toJS = function () {
        return this.slice();
    };
    ObservableArray.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toJS();
    };
    ObservableArray.prototype.peek = function () {
        this.$mobx.atom.reportObserved();
        return this.$mobx.dehanceValues(this.$mobx.values);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
    ObservableArray.prototype.find = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        var idx = this.findIndex.apply(this, arguments);
        return idx === -1 ? undefined : this.get(idx);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
    ObservableArray.prototype.findIndex = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        var items = this.peek(), l = items.length;
        for (var i = fromIndex; i < l; i++)
            if (predicate.call(thisArg, items[i], i, this))
                return i;
        return -1;
    };
    /*
     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
     * since these functions alter the inner structure of the array, the have side effects.
     * Because the have side effects, they should not be used in computed function,
     * and for that reason the do not call dependencyState.notifyObserved
     */
    ObservableArray.prototype.splice = function (index, deleteCount) {
        var newItems = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            newItems[_i - 2] = arguments[_i];
        }
        switch (arguments.length) {
            case 0:
                return [];
            case 1:
                return this.$mobx.spliceWithArray(index);
            case 2:
                return this.$mobx.spliceWithArray(index, deleteCount);
        }
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.push = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(adm.values.length, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.pop = function () {
        return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
    };
    ObservableArray.prototype.shift = function () {
        return this.splice(0, 1)[0];
    };
    ObservableArray.prototype.unshift = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(0, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.reverse = function () {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        // so we deviate from the default and just make it an dervitation
        var clone = this.slice();
        return clone.reverse.apply(clone, arguments);
    };
    ObservableArray.prototype.sort = function (compareFn) {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        var clone = this.slice();
        return clone.sort.apply(clone, arguments);
    };
    ObservableArray.prototype.remove = function (value) {
        var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    };
    ObservableArray.prototype.move = function (fromIndex, toIndex) {
        function checkIndex(index) {
            if (index < 0) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
            }
            var length = this.$mobx.values.length;
            if (index >= length) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
            }
        }
        checkIndex.call(this, fromIndex);
        checkIndex.call(this, toIndex);
        if (fromIndex === toIndex) {
            return;
        }
        var oldItems = this.$mobx.values;
        var newItems;
        if (fromIndex < toIndex) {
            newItems = oldItems.slice(0, fromIndex).concat(oldItems.slice(fromIndex + 1, toIndex + 1), [
                oldItems[fromIndex]
            ], oldItems.slice(toIndex + 1));
        }
        else {
            // toIndex < fromIndex
            newItems = oldItems.slice(0, toIndex).concat([
                oldItems[fromIndex]
            ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
        }
        this.replace(newItems);
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.get = function (index) {
        var impl = this.$mobx;
        if (impl) {
            if (index < impl.values.length) {
                impl.atom.reportObserved();
                return impl.dehanceValue(impl.values[index]);
            }
            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl
                .values
                .length + "). Please check length first. Out of bound indices will not be tracked by MobX");
        }
        return undefined;
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.set = function (index, newValue) {
        var adm = this.$mobx;
        var values = adm.values;
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(adm.atom);
            var oldValue = values[index];
            if (hasInterceptors(adm)) {
                var change = interceptChange(adm, {
                    type: "update",
                    object: this,
                    index: index,
                    newValue: newValue
                });
                if (!change)
                    return;
                newValue = change.newValue;
            }
            newValue = adm.enhancer(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                adm.notifyArrayChildUpdate(index, newValue, oldValue);
            }
        }
        else if (index === values.length) {
            // add a new item
            adm.spliceWithArray(index, 0, [newValue]);
        }
        else {
            // out of bounds
            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
        }
    };
    return ObservableArray;
}(StubArray));
declareIterator(ObservableArray.prototype, function () {
    return arrayAsIterator(this.slice());
});
Object.defineProperty(ObservableArray.prototype, "length", {
    enumerable: false,
    configurable: true,
    get: function () {
        return this.$mobx.getArrayLength();
    },
    set: function (newLength) {
        this.$mobx.setArrayLength(newLength);
    }
});
[
    "every",
    "filter",
    "forEach",
    "indexOf",
    "join",
    "lastIndexOf",
    "map",
    "reduce",
    "reduceRight",
    "slice",
    "some",
    "toString",
    "toLocaleString"
].forEach(function (funcName) {
    var baseFunc = Array.prototype[funcName];
    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
    addHiddenProp(ObservableArray.prototype, funcName, function () {
        return baseFunc.apply(this.peek(), arguments);
    });
});
/**
 * We don't want those to show up in `for (const key in ar)` ...
 */
makeNonEnumerable(ObservableArray.prototype, [
    "constructor",
    "intercept",
    "observe",
    "clear",
    "concat",
    "get",
    "replace",
    "toJS",
    "toJSON",
    "peek",
    "find",
    "findIndex",
    "splice",
    "spliceWithArray",
    "push",
    "pop",
    "set",
    "shift",
    "unshift",
    "reverse",
    "sort",
    "remove",
    "move",
    "toString",
    "toLocaleString"
]);
// See #364
var ENTRY_0 = createArrayEntryDescriptor(0);
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: false,
        get: function () {
            // TODO: Check `this`?, see #752?
            return this.get(index);
        },
        set: function (value) {
            this.set(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    Object.defineProperty(ObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++)
        createArrayBufferItem(index);
    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
}
reserveArrayBuffer(1000);
var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing.$mobx);
}

var UNCHANGED = {};
var ObservableValue = (function (_super) {
    __extends(ObservableValue, _super);
    function ObservableValue(value, enhancer, name, notifySpy) {
        if (name === void 0) { name = "ObservableValue@" + getNextId(); }
        if (notifySpy === void 0) { notifySpy = true; }
        var _this = _super.call(this, name) || this;
        _this.enhancer = enhancer;
        _this.hasUnreportedChange = false;
        _this.dehancer = undefined;
        _this.value = enhancer(value, undefined, name);
        if (notifySpy && isSpyEnabled()) {
            // only notify spy if this is a stand-alone observable
            spyReport({ type: "create", object: _this, newValue: _this.value });
        }
        return _this;
    }
    ObservableValue.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableValue.prototype.set = function (newValue) {
        var oldValue = this.value;
        newValue = this.prepareNewValue(newValue);
        if (newValue !== UNCHANGED) {
            var notifySpy = isSpyEnabled();
            if (notifySpy) {
                spyReportStart({
                    type: "update",
                    object: this,
                    newValue: newValue,
                    oldValue: oldValue
                });
            }
            this.setNewValue(newValue);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableValue.prototype.prepareNewValue = function (newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: "update",
                newValue: newValue
            });
            if (!change)
                return UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value, this.name);
        return this.value !== newValue ? newValue : UNCHANGED;
    };
    ObservableValue.prototype.setNewValue = function (newValue) {
        var oldValue = this.value;
        this.value = newValue;
        this.reportChanged();
        if (hasListeners(this)) {
            notifyListeners(this, {
                type: "update",
                object: this,
                newValue: newValue,
                oldValue: oldValue
            });
        }
    };
    ObservableValue.prototype.get = function () {
        this.reportObserved();
        return this.dehanceValue(this.value);
    };
    ObservableValue.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableValue.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately)
            listener({
                object: this,
                type: "update",
                newValue: this.value,
                oldValue: undefined
            });
        return registerListener(this, listener);
    };
    ObservableValue.prototype.toJSON = function () {
        return this.get();
    };
    ObservableValue.prototype.toString = function () {
        return this.name + "[" + this.value + "]";
    };
    ObservableValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    return ObservableValue;
}(BaseAtom));
ObservableValue.prototype[primitiveSymbol()] = ObservableValue.prototype.valueOf;
var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);

var messages = {
    m001: "It is not allowed to assign new values to @action fields",
    m002: "`runInAction` expects a function",
    m003: "`runInAction` expects a function without arguments",
    m004: "autorun expects a function",
    m005: "Warning: attempted to pass an action to autorun. Actions are untracked and will not trigger on state changes. Use `reaction` or wrap only your state modification code in an action.",
    m006: "Warning: attempted to pass an action to autorunAsync. Actions are untracked and will not trigger on state changes. Use `reaction` or wrap only your state modification code in an action.",
    m007: "reaction only accepts 2 or 3 arguments. If migrating from MobX 2, please provide an options object",
    m008: "wrapping reaction expression in `asReference` is no longer supported, use options object instead",
    m009: "@computed can only be used on getter functions, like: '@computed get myProps() { return ...; }'. It looks like it was used on a property.",
    m010: "@computed can only be used on getter functions, like: '@computed get myProps() { return ...; }'",
    m011: "First argument to `computed` should be an expression. If using computed as decorator, don't pass it arguments",
    m012: "computed takes one or two arguments if used as function",
    m013: "[mobx.expr] 'expr' should only be used inside other reactive functions.",
    m014: "extendObservable expected 2 or more arguments",
    m015: "extendObservable expects an object as first argument",
    m016: "extendObservable should not be used on maps, use map.merge instead",
    m017: "all arguments of extendObservable should be objects",
    m018: "extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540",
    m019: "[mobx.isObservable] isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.",
    m020: "modifiers can only be used for individual object properties",
    m021: "observable expects zero or one arguments",
    m022: "@observable can not be used on getters, use @computed instead",
    m024: "whyRun() can only be used if a derivation is active, or by passing an computed value / reaction explicitly. If you invoked whyRun from inside a computation; the computation is currently suspended but re-evaluating because somebody requested its value.",
    m025: "whyRun can only be used on reactions and computed values",
    m026: "`action` can only be invoked on functions",
    m028: "It is not allowed to set `useStrict` when a derivation is running",
    m029: "INTERNAL ERROR only onBecomeUnobserved shouldn't be called twice in a row",
    m030a: "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: ",
    m030b: "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ",
    m031: "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: ",
    m032: "* This computation is suspended (not in use by any reaction) and won't run automatically.\n	Didn't expect this computation to be suspended at this point?\n	  1. Make sure this computation is used by a reaction (reaction, autorun, observer).\n	  2. Check whether you are using this computation synchronously (in the same stack as they reaction that needs it).",
    m033: "`observe` doesn't support the fire immediately property for observable maps.",
    m034: "`mobx.map` is deprecated, use `new ObservableMap` or `mobx.observable.map` instead",
    m035: "Cannot make the designated object observable; it is not extensible",
    m036: "It is not possible to get index atoms from arrays",
    m037: "Hi there! I'm sorry you have just run into an exception.\nIf your debugger ends up here, know that some reaction (like the render() of an observer component, autorun or reaction)\nthrew an exception and that mobx caught it, to avoid that it brings the rest of your application down.\nThe original cause of the exception (the code that caused this reaction to run (again)), is still in the stack.\n\nHowever, more interesting is the actual stack trace of the error itself.\nHopefully the error is an instanceof Error, because in that case you can inspect the original stack of the error from where it was thrown.\nSee `error.stack` property, or press the very subtle \"(...)\" link you see near the console.error message that probably brought you here.\nThat stack is more interesting than the stack of this console.error itself.\n\nIf the exception you see is an exception you created yourself, make sure to use `throw new Error(\"Oops\")` instead of `throw \"Oops\"`,\nbecause the javascript environment will only preserve the original stack trace in the first form.\n\nYou can also make sure the debugger pauses the next time this very same exception is thrown by enabling \"Pause on caught exception\".\n(Note that it might pause on many other, unrelated exception as well).\n\nIf that all doesn't help you out, feel free to open an issue https://github.com/mobxjs/mobx/issues!\n",
    m038: "Missing items in this list?\n    1. Check whether all used values are properly marked as observable (use isObservable to verify)\n    2. Make sure you didn't dereference values too early. MobX observes props, not primitives. E.g: use 'person.name' instead of 'name' in your computation.\n"
};
function getMessage(id) {
    return messages[id];
}

function createAction(actionName, fn) {
    invariant(typeof fn === "function", getMessage("m026"));
    invariant(typeof actionName === "string" && actionName.length > 0, "actions should have valid names, got: '" + actionName + "'");
    var res = function () {
        return executeAction(actionName, fn, this, arguments);
    };
    res.originalFn = fn;
    res.isMobxAction = true;
    return res;
}
function executeAction(actionName, fn, scope, args) {
    var runInfo = startAction(actionName, fn, scope, args);
    try {
        return fn.apply(scope, args);
    }
    finally {
        endAction(runInfo);
    }
}
function startAction(actionName, fn, scope, args) {
    var notifySpy = isSpyEnabled() && !!actionName;
    var startTime = 0;
    if (notifySpy) {
        startTime = Date.now();
        var l = (args && args.length) || 0;
        var flattendArgs = new Array(l);
        if (l > 0)
            for (var i = 0; i < l; i++)
                flattendArgs[i] = args[i];
        spyReportStart({
            type: "action",
            name: actionName,
            fn: fn,
            object: scope,
            arguments: flattendArgs
        });
    }
    var prevDerivation = untrackedStart();
    startBatch();
    var prevAllowStateChanges = allowStateChangesStart(true);
    return {
        prevDerivation: prevDerivation,
        prevAllowStateChanges: prevAllowStateChanges,
        notifySpy: notifySpy,
        startTime: startTime
    };
}
function endAction(runInfo) {
    allowStateChangesEnd(runInfo.prevAllowStateChanges);
    endBatch();
    untrackedEnd(runInfo.prevDerivation);
    if (runInfo.notifySpy)
        spyReportEnd({ time: Date.now() - runInfo.startTime });
}
function useStrict(strict) {
    invariant(globalState.trackingDerivation === null, getMessage("m028"));
    globalState.strictMode = strict;
    globalState.allowStateChanges = !strict;
}
function isStrictModeEnabled() {
    return globalState.strictMode;
}
function allowStateChanges(allowStateChanges, func) {
    // TODO: deprecate / refactor this function in next major
    // Currently only used by `@observer`
    // Proposed change: remove first param, rename to `forbidStateChanges`,
    // require error callback instead of the hardcoded error message now used
    // Use `inAction` instead of allowStateChanges in derivation.ts to check strictMode
    var prev = allowStateChangesStart(allowStateChanges);
    var res;
    try {
        res = func();
    }
    finally {
        allowStateChangesEnd(prev);
    }
    return res;
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}

/**
 * Constructs a decorator, that normalizes the differences between
 * TypeScript and Babel. Mainly caused by the fact that legacy-decorator cannot assign
 * values during instance creation to properties that have a getter setter.
 *
 * - Sigh -
 *
 * Also takes care of the difference between @decorator field and @decorator(args) field, and different forms of values.
 * For performance (cpu and mem) reasons the properties are always defined on the prototype (at least initially).
 * This means that these properties despite being enumerable might not show up in Object.keys() (but they will show up in for...in loops).
 */
function createClassPropertyDecorator(
    /**
     * This function is invoked once, when the property is added to a new instance.
     * When this happens is not strictly determined due to differences in TS and Babel:
     * Typescript: Usually when constructing the new instance
     * Babel, sometimes Typescript: during the first get / set
     * Both: when calling `runLazyInitializers(instance)`
     */
    onInitialize, get, set, enumerable, 
    /**
     * Can this decorator invoked with arguments? e.g. @decorator(args)
     */
    allowCustomArguments) {
    function classPropertyDecorator(target, key, descriptor, customArgs, argLen) {
        if (argLen === void 0) { argLen = 0; }
        invariant(allowCustomArguments || quacksLikeADecorator(arguments), "This function is a decorator, but it wasn't invoked like a decorator");
        if (!descriptor) {
            // typescript (except for getter / setters)
            var newDescriptor = {
                enumerable: enumerable,
                configurable: true,
                get: function () {
                    if (!this.__mobxInitializedProps || this.__mobxInitializedProps[key] !== true)
                        typescriptInitializeProperty(this, key, undefined, onInitialize, customArgs, descriptor);
                    return get.call(this, key);
                },
                set: function (v) {
                    if (!this.__mobxInitializedProps || this.__mobxInitializedProps[key] !== true) {
                        typescriptInitializeProperty(this, key, v, onInitialize, customArgs, descriptor);
                    }
                    else {
                        set.call(this, key, v);
                    }
                }
            };
            if (arguments.length < 3 || (arguments.length === 5 && argLen < 3)) {
                // Typescript target is ES3, so it won't define property for us
                // or using Reflect.decorate polyfill, which will return no descriptor
                // (see https://github.com/mobxjs/mobx/issues/333)
                Object.defineProperty(target, key, newDescriptor);
            }
            return newDescriptor;
        }
        else {
            // babel and typescript getter / setter props
            if (!hasOwnProperty(target, "__mobxLazyInitializers")) {
                addHiddenProp(target, "__mobxLazyInitializers", (target.__mobxLazyInitializers && target.__mobxLazyInitializers.slice()) || [] // support inheritance
                );
            }
            var value_1 = descriptor.value, initializer_1 = descriptor.initializer;
            target.__mobxLazyInitializers.push(function (instance) {
                onInitialize(instance, key, initializer_1 ? initializer_1.call(instance) : value_1, customArgs, descriptor);
            });
            return {
                enumerable: enumerable,
                configurable: true,
                get: function () {
                    if (this.__mobxDidRunLazyInitializers !== true)
                        runLazyInitializers(this);
                    return get.call(this, key);
                },
                set: function (v) {
                    if (this.__mobxDidRunLazyInitializers !== true)
                        runLazyInitializers(this);
                    set.call(this, key, v);
                }
            };
        }
    }
    if (allowCustomArguments) {
        /** If custom arguments are allowed, we should return a function that returns a decorator */
        return function () {
            /** Direct invocation: @decorator bla */
            if (quacksLikeADecorator(arguments))
                return classPropertyDecorator.apply(null, arguments);
            /** Indirect invocation: @decorator(args) bla */
            var outerArgs = arguments;
            var argLen = arguments.length;
            return function (target, key, descriptor) {
                return classPropertyDecorator(target, key, descriptor, outerArgs, argLen);
            };
        };
    }
    return classPropertyDecorator;
}
function typescriptInitializeProperty(instance, key, v, onInitialize, customArgs, baseDescriptor) {
    if (!hasOwnProperty(instance, "__mobxInitializedProps"))
        addHiddenProp(instance, "__mobxInitializedProps", {});
    instance.__mobxInitializedProps[key] = true;
    onInitialize(instance, key, v, customArgs, baseDescriptor);
}
function runLazyInitializers(instance) {
    if (instance.__mobxDidRunLazyInitializers === true)
        return;
    if (instance.__mobxLazyInitializers) {
        addHiddenProp(instance, "__mobxDidRunLazyInitializers", true);
        instance.__mobxDidRunLazyInitializers &&
            instance.__mobxLazyInitializers.forEach(function (initializer) { return initializer(instance); });
    }
}
function quacksLikeADecorator(args) {
    return (args.length === 2 || args.length === 3) && typeof args[1] === "string";
}

var actionFieldDecorator = createClassPropertyDecorator(function (target, key, value, args, originalDescriptor) {
    var actionName = args && args.length === 1 ? args[0] : value.name || key || "<unnamed action>";
    var wrappedAction = action(actionName, value);
    addHiddenProp(target, key, wrappedAction);
}, function (key) {
    return this[key];
}, function () {
    invariant(false, getMessage("m001"));
}, false, true);
var boundActionDecorator = createClassPropertyDecorator(function (target, key, value) {
    defineBoundAction(target, key, value);
}, function (key) {
    return this[key];
}, function () {
    invariant(false, getMessage("m001"));
}, false, false);
var action = function action(arg1, arg2, arg3, arg4) {
    if (arguments.length === 1 && typeof arg1 === "function")
        return createAction(arg1.name || "<unnamed action>", arg1);
    if (arguments.length === 2 && typeof arg2 === "function")
        return createAction(arg1, arg2);
    if (arguments.length === 1 && typeof arg1 === "string")
        return namedActionDecorator(arg1);
    return namedActionDecorator(arg2).apply(null, arguments);
};
action.bound = function boundAction(arg1, arg2, arg3) {
    if (typeof arg1 === "function") {
        var action_1 = createAction("<not yet bound action>", arg1);
        action_1.autoBind = true;
        return action_1;
    }
    return boundActionDecorator.apply(null, arguments);
};
function namedActionDecorator(name) {
    return function (target, prop, descriptor) {
        if (descriptor && typeof descriptor.value === "function") {
            // TypeScript @action method() { }. Defined on proto before being decorated
            // Don't use the field decorator if we are just decorating a method
            descriptor.value = createAction(name, descriptor.value);
            descriptor.enumerable = false;
            descriptor.configurable = true;
            return descriptor;
        }
        if (descriptor !== undefined && descriptor.get !== undefined) {
            throw new Error("[mobx] action is not expected to be used with getters");
        }
        // bound instance methods
        return actionFieldDecorator(name).apply(this, arguments);
    };
}
function runInAction(arg1, arg2, arg3) {
    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
    var fn = typeof arg1 === "function" ? arg1 : arg2;
    var scope = typeof arg1 === "function" ? arg2 : arg3;
    invariant(typeof fn === "function", getMessage("m002"));
    invariant(fn.length === 0, getMessage("m003"));
    invariant(typeof actionName === "string" && actionName.length > 0, "actions should have valid names, got: '" + actionName + "'");
    return executeAction(actionName, fn, scope, undefined);
}
function isAction(thing) {
    return typeof thing === "function" && thing.isMobxAction === true;
}
function defineBoundAction(target, propertyName, fn) {
    var res = function () {
        return executeAction(propertyName, fn, target, arguments);
    };
    res.isMobxAction = true;
    addHiddenProp(target, propertyName, res);
}

function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function defaultComparer(a, b) {
    return areBothNaN(a, b) || identityComparer(a, b);
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    default: defaultComparer
};

function autorun(arg1, arg2, arg3) {
    var name, view, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        view = arg2;
        scope = arg3;
    }
    else {
        name = arg1.name || "Autorun@" + getNextId();
        view = arg1;
        scope = arg2;
    }
    invariant(typeof view === "function", getMessage("m004"));
    invariant(isAction(view) === false, getMessage("m005"));
    if (scope)
        view = view.bind(scope);
    var reaction = new Reaction(name, function () {
        this.track(reactionRunner);
    });
    function reactionRunner() {
        view(reaction);
    }
    reaction.schedule();
    return reaction.getDisposer();
}
function when(arg1, arg2, arg3, arg4) {
    var name, predicate, effect, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        predicate = arg2;
        effect = arg3;
        scope = arg4;
    }
    else {
        name = "When@" + getNextId();
        predicate = arg1;
        effect = arg2;
        scope = arg3;
    }
    var disposer = autorun(name, function (r) {
        if (predicate.call(scope)) {
            r.dispose();
            var prevUntracked = untrackedStart();
            effect.call(scope);
            untrackedEnd(prevUntracked);
        }
    });
    return disposer;
}
function autorunAsync(arg1, arg2, arg3, arg4) {
    var name, func, delay, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        func = arg2;
        delay = arg3;
        scope = arg4;
    }
    else {
        name = arg1.name || "AutorunAsync@" + getNextId();
        func = arg1;
        delay = arg2;
        scope = arg3;
    }
    invariant(isAction(func) === false, getMessage("m006"));
    if (delay === void 0)
        delay = 1;
    if (scope)
        func = func.bind(scope);
    var isScheduled = false;
    var r = new Reaction(name, function () {
        if (!isScheduled) {
            isScheduled = true;
            setTimeout(function () {
                isScheduled = false;
                if (!r.isDisposed)
                    r.track(reactionRunner);
            }, delay);
        }
    });
    function reactionRunner() {
        func(r);
    }
    r.schedule();
    return r.getDisposer();
}
function reaction(expression, effect, arg3) {
    if (arguments.length > 3) {
        fail(getMessage("m007"));
    }
    if (isModifierDescriptor(expression)) {
        fail(getMessage("m008"));
    }
    var opts;
    if (typeof arg3 === "object") {
        opts = arg3;
    }
    else {
        opts = {};
    }
    opts.name =
        opts.name || expression.name || effect.name || "Reaction@" + getNextId();
    opts.fireImmediately = arg3 === true || opts.fireImmediately === true;
    opts.delay = opts.delay || 0;
    opts.compareStructural = opts.compareStructural || opts.struct || false;
    // TODO: creates ugly spy events, use `effect = (r) => runInAction(opts.name, () => effect(r))` instead
    effect = action(opts.name, opts.context ? effect.bind(opts.context) : effect);
    if (opts.context) {
        expression = expression.bind(opts.context);
    }
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.equals
        ? opts.equals
        : opts.compareStructural || opts.struct ? comparer.structural : comparer.default;
    var r = new Reaction(opts.name, function () {
        if (firstTime || opts.delay < 1) {
            reactionRunner();
        }
        else if (!isScheduled) {
            isScheduled = true;
            setTimeout(function () {
                isScheduled = false;
                reactionRunner();
            }, opts.delay);
        }
    });
    function reactionRunner() {
        if (r.isDisposed)
            return;
        var changed = false;
        r.track(function () {
            var nextValue = expression(r);
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately)
            effect(value, r);
        if (!firstTime && changed === true)
            effect(value, r);
        if (firstTime)
            firstTime = false;
    }
    r.schedule();
    return r.getDisposer();
}

/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */
var ComputedValue = (function () {
    /**
     * Create a new computed value based on a function expression.
     *
     * The `name` property is for debug purposes only.
     *
     * The `equals` property specifies the comparer function to use to determine if a newly produced
     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
     * Structural comparison can be convenient if you always produce an new aggregated object and
     * don't want to notify observers if it is structurally the same.
     * This is useful for working with vectors, mouse coordinates etc.
     */
    function ComputedValue(derivation, scope, equals, name, setter) {
        this.derivation = derivation;
        this.scope = scope;
        this.equals = equals;
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = null; // during tracking it's an array with new observed observers
        this.isPendingUnobservation = false;
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.runId = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.UP_TO_DATE;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.value = new CaughtException(null);
        this.isComputing = false; // to check for cycles
        this.isRunningSetter = false;
        this.name = name || "ComputedValue@" + getNextId();
        if (setter)
            this.setter = createAction(name + "-setter", setter);
    }
    ComputedValue.prototype.onBecomeStale = function () {
        propagateMaybeChanged(this);
    };
    ComputedValue.prototype.onBecomeUnobserved = function () {
        clearObserving(this);
        this.value = undefined;
    };
    /**
     * Returns the current value of this computed value.
     * Will evaluate its computation first if needed.
     */
    ComputedValue.prototype.get = function () {
        invariant(!this.isComputing, "Cycle detected in computation " + this.name, this.derivation);
        if (globalState.inBatch === 0) {
            // This is an minor optimization which could be omitted to simplify the code
            // The computedValue is accessed outside of any mobx stuff. Batch observing should be enough and don't need
            // tracking as it will never be called again inside this batch.
            startBatch();
            if (shouldCompute(this))
                this.value = this.computeValue(false);
            endBatch();
        }
        else {
            reportObserved(this);
            if (shouldCompute(this))
                if (this.trackAndCompute())
                    propagateChangeConfirmed(this);
        }
        var result = this.value;
        if (isCaughtException(result))
            throw result.cause;
        return result;
    };
    ComputedValue.prototype.peek = function () {
        var res = this.computeValue(false);
        if (isCaughtException(res))
            throw res.cause;
        return res;
    };
    ComputedValue.prototype.set = function (value) {
        if (this.setter) {
            invariant(!this.isRunningSetter, "The setter of computed value '" + this
                .name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
            this.isRunningSetter = true;
            try {
                this.setter.call(this.scope, value);
            }
            finally {
                this.isRunningSetter = false;
            }
        }
        else
            invariant(false, "[ComputedValue '" + this
                .name + "'] It is not possible to assign a new value to a computed value.");
    };
    ComputedValue.prototype.trackAndCompute = function () {
        if (isSpyEnabled()) {
            spyReport({
                object: this.scope,
                type: "compute",
                fn: this.derivation
            });
        }
        var oldValue = this.value;
        var wasSuspended = this.dependenciesState === IDerivationState.NOT_TRACKING;
        var newValue = (this.value = this.computeValue(true));
        return (wasSuspended ||
            isCaughtException(oldValue) ||
            isCaughtException(newValue) ||
            !this.equals(oldValue, newValue));
    };
    ComputedValue.prototype.computeValue = function (track) {
        this.isComputing = true;
        globalState.computationDepth++;
        var res;
        if (track) {
            res = trackDerivedFunction(this, this.derivation, this.scope);
        }
        else {
            try {
                res = this.derivation.call(this.scope);
            }
            catch (e) {
                res = new CaughtException(e);
            }
        }
        globalState.computationDepth--;
        this.isComputing = false;
        return res;
    };
    ComputedValue.prototype.observe = function (listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function () {
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    type: "update",
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    ComputedValue.prototype.toJSON = function () {
        return this.get();
    };
    ComputedValue.prototype.toString = function () {
        return this.name + "[" + this.derivation.toString() + "]";
    };
    ComputedValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    ComputedValue.prototype.whyRun = function () {
        var isTracking = Boolean(globalState.trackingDerivation);
        var observing = unique(this.isComputing ? this.newObserving : this.observing).map(function (dep) { return dep.name; });
        var observers = unique(getObservers(this).map(function (dep) { return dep.name; }));
        return ("\nWhyRun? computation '" + this.name + "':\n * Running because: " + (isTracking
            ? "[active] the value of this computation is needed by a reaction"
            : this.isComputing
                ? "[get] The value of this computed was requested outside a reaction"
                : "[idle] not running at the moment") + "\n" +
            (this.dependenciesState === IDerivationState.NOT_TRACKING
                ? getMessage("m032")
                : " * This computation will re-run if any of the following observables changes:\n    " + joinStrings(observing) + "\n    " + (this.isComputing && isTracking
                    ? " (... or any observable accessed during the remainder of the current run)"
                    : "") + "\n    " + getMessage("m038") + "\n\n  * If the outcome of this computation changes, the following observers will be re-run:\n    " + joinStrings(observers) + "\n"));
    };
    return ComputedValue;
}());
ComputedValue.prototype[primitiveSymbol()] = ComputedValue.prototype.valueOf;
var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);

var ObservableObjectAdministration = (function () {
    function ObservableObjectAdministration(target, name) {
        this.target = target;
        this.name = name;
        this.values = {};
        this.changeListeners = null;
        this.interceptors = null;
    }
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
        invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
        return registerListener(this, callback);
    };
    ObservableObjectAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableObjectAdministration;
}());
function asObservableObject(target, name) {
    if (isObservableObject(target) && target.hasOwnProperty("$mobx"))
        return target.$mobx;
    invariant(Object.isExtensible(target), getMessage("m035"));
    if (!isPlainObject(target))
        name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
    if (!name)
        name = "ObservableObject@" + getNextId();
    var adm = new ObservableObjectAdministration(target, name);
    addHiddenFinalProp(target, "$mobx", adm);
    return adm;
}
function defineObservablePropertyFromDescriptor(adm, propName, descriptor, defaultEnhancer) {
    if (adm.values[propName] && !isComputedValue(adm.values[propName])) {
        // already observable property
        invariant("value" in descriptor, "The property " + propName + " in " + adm.name + " is already observable, cannot redefine it as computed property");
        adm.target[propName] = descriptor.value; // the property setter will make 'value' reactive if needed.
        return;
    }
    // not yet observable property
    if ("value" in descriptor) {
        // not a computed value
        if (isModifierDescriptor(descriptor.value)) {
            // x : ref(someValue)
            var modifierDescriptor = descriptor.value;
            defineObservableProperty(adm, propName, modifierDescriptor.initialValue, modifierDescriptor.enhancer);
        }
        else if (isAction(descriptor.value) && descriptor.value.autoBind === true) {
            defineBoundAction(adm.target, propName, descriptor.value.originalFn);
        }
        else if (isComputedValue(descriptor.value)) {
            // x: computed(someExpr)
            defineComputedPropertyFromComputedValue(adm, propName, descriptor.value);
        }
        else {
            // x: someValue
            defineObservableProperty(adm, propName, descriptor.value, defaultEnhancer);
        }
    }
    else {
        // get x() { return 3 } set x(v) { }
        defineComputedProperty(adm, propName, descriptor.get, descriptor.set, comparer.default, true);
    }
}
function defineObservableProperty(adm, propName, newValue, enhancer) {
    assertPropertyConfigurable(adm.target, propName);
    if (hasInterceptors(adm)) {
        var change = interceptChange(adm, {
            object: adm.target,
            name: propName,
            type: "add",
            newValue: newValue
        });
        if (!change)
            return;
        newValue = change.newValue;
    }
    var observable = (adm.values[propName] = new ObservableValue(newValue, enhancer, adm.name + "." + propName, false));
    newValue = observable.value; // observableValue might have changed it
    Object.defineProperty(adm.target, propName, generateObservablePropConfig(propName));
    notifyPropertyAddition(adm, adm.target, propName, newValue);
}
function defineComputedProperty(adm, propName, getter, setter, equals, asInstanceProperty) {
    if (asInstanceProperty)
        assertPropertyConfigurable(adm.target, propName);
    adm.values[propName] = new ComputedValue(getter, adm.target, equals, adm.name + "." + propName, setter);
    if (asInstanceProperty) {
        Object.defineProperty(adm.target, propName, generateComputedPropConfig(propName));
    }
}
function defineComputedPropertyFromComputedValue(adm, propName, computedValue) {
    var name = adm.name + "." + propName;
    computedValue.name = name;
    if (!computedValue.scope)
        computedValue.scope = adm.target;
    adm.values[propName] = computedValue;
    Object.defineProperty(adm.target, propName, generateComputedPropConfig(propName));
}
var observablePropertyConfigs = {};
var computedPropertyConfigs = {};
function generateObservablePropConfig(propName) {
    return (observablePropertyConfigs[propName] ||
        (observablePropertyConfigs[propName] = {
            configurable: true,
            enumerable: true,
            get: function () {
                return this.$mobx.values[propName].get();
            },
            set: function (v) {
                setPropertyValue(this, propName, v);
            }
        }));
}
function generateComputedPropConfig(propName) {
    return (computedPropertyConfigs[propName] ||
        (computedPropertyConfigs[propName] = {
            configurable: true,
            enumerable: false,
            get: function () {
                return this.$mobx.values[propName].get();
            },
            set: function (v) {
                return this.$mobx.values[propName].set(v);
            }
        }));
}
function setPropertyValue(instance, name, newValue) {
    var adm = instance.$mobx;
    var observable = adm.values[name];
    // intercept
    if (hasInterceptors(adm)) {
        var change = interceptChange(adm, {
            type: "update",
            object: instance,
            name: name,
            newValue: newValue
        });
        if (!change)
            return;
        newValue = change.newValue;
    }
    newValue = observable.prepareNewValue(newValue);
    // notify spy & observers
    if (newValue !== UNCHANGED) {
        var notify = hasListeners(adm);
        var notifySpy = isSpyEnabled();
        var change = notify || notifySpy
            ? {
                type: "update",
                object: instance,
                oldValue: observable.value,
                name: name,
                newValue: newValue
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        observable.setNewValue(newValue);
        if (notify)
            notifyListeners(adm, change);
        if (notifySpy)
            spyReportEnd();
    }
}
function notifyPropertyAddition(adm, object, name, newValue) {
    var notify = hasListeners(adm);
    var notifySpy = isSpyEnabled();
    var change = notify || notifySpy
        ? {
            type: "add",
            object: object,
            name: name,
            newValue: newValue
        }
        : null;
    if (notifySpy)
        spyReportStart(change);
    if (notify)
        notifyListeners(adm, change);
    if (notifySpy)
        spyReportEnd();
}
var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function isObservableObject(thing) {
    if (isObject(thing)) {
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        runLazyInitializers(thing);
        return isObservableObjectAdministration(thing.$mobx);
    }
    return false;
}

/**
 * Returns true if the provided value is reactive.
 * @param value object, function or array
 * @param property if property is specified, checks whether value.property is reactive.
 */
function isObservable(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableArray(value) || isObservableMap(value))
            throw new Error(getMessage("m019"));
        else if (isObservableObject(value)) {
            var o = value.$mobx;
            return o.values && !!o.values[property];
        }
        return false;
    }
    // For first check, see #701
    return (isObservableObject(value) ||
        !!value.$mobx ||
        isAtom(value) ||
        isReaction(value) ||
        isComputedValue(value));
}

function createDecoratorForEnhancer(enhancer) {
    invariant(!!enhancer, ":(");
    return createClassPropertyDecorator(function (target, name, baseValue, _, baseDescriptor) {
        assertPropertyConfigurable(target, name);
        invariant(!baseDescriptor || !baseDescriptor.get, getMessage("m022"));
        var adm = asObservableObject(target, undefined);
        defineObservableProperty(adm, name, baseValue, enhancer);
    }, function (name) {
        var observable = this.$mobx.values[name];
        if (observable === undefined // See #505
        )
            return undefined;
        return observable.get();
    }, function (name, value) {
        setPropertyValue(this, name, value);
    }, true, false);
}

function extendObservable(target) {
    var properties = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        properties[_i - 1] = arguments[_i];
    }
    return extendObservableHelper(target, deepEnhancer, properties);
}
function extendShallowObservable(target) {
    var properties = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        properties[_i - 1] = arguments[_i];
    }
    return extendObservableHelper(target, referenceEnhancer, properties);
}
function extendObservableHelper(target, defaultEnhancer, properties) {
    invariant(arguments.length >= 2, getMessage("m014"));
    invariant(typeof target === "object", getMessage("m015"));
    invariant(!isObservableMap(target), getMessage("m016"));
    properties.forEach(function (propSet) {
        invariant(typeof propSet === "object", getMessage("m017"));
        invariant(!isObservable(propSet), getMessage("m018"));
    });
    var adm = asObservableObject(target);
    var definedProps = {};
    // Note could be optimised if properties.length === 1
    for (var i = properties.length - 1; i >= 0; i--) {
        var propSet = properties[i];
        for (var key in propSet)
            if (definedProps[key] !== true && hasOwnProperty(propSet, key)) {
                definedProps[key] = true;
                if (target === propSet && !isPropertyConfigurable(target, key))
                    continue; // see #111, skip non-configurable or non-writable props for `observable(object)`.
                var descriptor = Object.getOwnPropertyDescriptor(propSet, key);
                defineObservablePropertyFromDescriptor(adm, key, descriptor, defaultEnhancer);
            }
    }
    return target;
}

var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
var deepStructDecorator = createDecoratorForEnhancer(deepStructEnhancer);
var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */
function createObservable(v) {
    if (v === void 0) { v = undefined; }
    // @observable someProp;
    if (typeof arguments[1] === "string")
        return deepDecorator.apply(null, arguments);
    invariant(arguments.length <= 1, getMessage("m021"));
    invariant(!isModifierDescriptor(v), getMessage("m020"));
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    var res = deepEnhancer(v, undefined, undefined);
    // this value could be converted to a new observable data structure, return it
    if (res !== v)
        return res;
    // otherwise, just box it
    return observable.box(v);
}
var observableFactories = {
    box: function (value, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("box");
        return new ObservableValue(value, deepEnhancer, name);
    },
    shallowBox: function (value, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowBox");
        return new ObservableValue(value, referenceEnhancer, name);
    },
    array: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("array");
        return new ObservableArray(initialValues, deepEnhancer, name);
    },
    shallowArray: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowArray");
        return new ObservableArray(initialValues, referenceEnhancer, name);
    },
    map: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("map");
        return new ObservableMap(initialValues, deepEnhancer, name);
    },
    shallowMap: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowMap");
        return new ObservableMap(initialValues, referenceEnhancer, name);
    },
    object: function (props, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("object");
        var res = {};
        // convert to observable object
        asObservableObject(res, name);
        // add properties
        extendObservable(res, props);
        return res;
    },
    shallowObject: function (props, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowObject");
        var res = {};
        asObservableObject(res, name);
        extendShallowObservable(res, props);
        return res;
    },
    ref: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(referenceEnhancer, arguments[0]);
        }
        else {
            return refDecorator.apply(null, arguments);
        }
    },
    shallow: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(shallowEnhancer, arguments[0]);
        }
        else {
            return shallowDecorator.apply(null, arguments);
        }
    },
    deep: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(deepEnhancer, arguments[0]);
        }
        else {
            return deepDecorator.apply(null, arguments);
        }
    },
    struct: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(deepStructEnhancer, arguments[0]);
        }
        else {
            return deepStructDecorator.apply(null, arguments);
        }
    }
};
var observable = createObservable;
// weird trick to keep our typings nicely with our funcs, and still extend the observable function
Object.keys(observableFactories).forEach(function (name) { return (observable[name] = observableFactories[name]); });
observable.deep.struct = observable.struct;
observable.ref.struct = function () {
    if (arguments.length < 2) {
        return createModifierDescriptor(refStructEnhancer, arguments[0]);
    }
    else {
        return refStructDecorator.apply(null, arguments);
    }
};
function incorrectlyUsedAsDecorator(methodName) {
    fail("Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
}

function isModifierDescriptor(thing) {
    return typeof thing === "object" && thing !== null && thing.isMobxModifierDescriptor === true;
}
function createModifierDescriptor(enhancer, initialValue) {
    invariant(!isModifierDescriptor(initialValue), "Modifiers cannot be nested");
    return {
        isMobxModifierDescriptor: true,
        initialValue: initialValue,
        enhancer: enhancer
    };
}
function deepEnhancer(v, _, name) {
    if (isModifierDescriptor(v))
        fail("You tried to assign a modifier wrapped value to a collection, please define modifiers when creating the collection, not when modifying it");
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return observable.array(v, name);
    if (isPlainObject(v))
        return observable.object(v, name);
    if (isES6Map(v))
        return observable.map(v, name);
    return v;
}
function shallowEnhancer(v, _, name) {
    if (isModifierDescriptor(v))
        fail("You tried to assign a modifier wrapped value to a collection, please define modifiers when creating the collection, not when modifying it");
    if (v === undefined || v === null)
        return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v))
        return v;
    if (Array.isArray(v))
        return observable.shallowArray(v, name);
    if (isPlainObject(v))
        return observable.shallowObject(v, name);
    if (isES6Map(v))
        return observable.shallowMap(v, name);
    return fail("The shallow modifier / decorator can only used in combination with arrays, objects and maps");
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function deepStructEnhancer(v, oldValue, name) {
    // don't confuse structurally compare enhancer with ref enhancer! The latter is probably
    // more suited for immutable objects
    if (deepEqual(v, oldValue))
        return oldValue;
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return new ObservableArray(v, deepStructEnhancer, name);
    if (isES6Map(v))
        return new ObservableMap(v, deepStructEnhancer, name);
    if (isPlainObject(v)) {
        var res = {};
        asObservableObject(res, name);
        extendObservableHelper(res, deepStructEnhancer, [v]);
        return res;
    }
    return v;
}
function refStructEnhancer(v, oldValue, name) {
    if (deepEqual(v, oldValue))
        return oldValue;
    return v;
}

/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */
function transaction(action, thisArg) {
    if (thisArg === void 0) { thisArg = undefined; }
    startBatch();
    try {
        return action.apply(thisArg);
    }
    finally {
        endBatch();
    }
}

var ObservableMapMarker = {};
var ObservableMap = (function () {
    function ObservableMap(initialData, enhancer, name) {
        if (enhancer === void 0) { enhancer = deepEnhancer; }
        if (name === void 0) { name = "ObservableMap@" + getNextId(); }
        this.enhancer = enhancer;
        this.name = name;
        this.$mobx = ObservableMapMarker;
        this._data = Object.create(null);
        this._hasMap = Object.create(null); // hasMap, not hashMap >-).
        this._keys = new ObservableArray(undefined, referenceEnhancer, this.name + ".keys()", true);
        this.interceptors = null;
        this.changeListeners = null;
        this.dehancer = undefined;
        this.merge(initialData);
    }
    ObservableMap.prototype._has = function (key) {
        return typeof this._data[key] !== "undefined";
    };
    ObservableMap.prototype.has = function (key) {
        if (!this.isValidKey(key))
            return false;
        key = "" + key;
        if (this._hasMap[key])
            return this._hasMap[key].get();
        return this._updateHasMapEntry(key, false).get();
    };
    ObservableMap.prototype.set = function (key, value) {
        this.assertValidKey(key);
        key = "" + key;
        var hasKey = this._has(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? "update" : "add",
                object: this,
                newValue: value,
                name: key
            });
            if (!change)
                return this;
            value = change.newValue;
        }
        if (hasKey) {
            this._updateValue(key, value);
        }
        else {
            this._addValue(key, value);
        }
        return this;
    };
    ObservableMap.prototype.delete = function (key) {
        var _this = this;
        this.assertValidKey(key);
        key = "" + key;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                name: key
            });
            if (!change)
                return false;
        }
        if (this._has(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "delete",
                    object: this,
                    oldValue: this._data[key].value,
                    name: key
                }
                : null;
            if (notifySpy)
                spyReportStart(change);
            transaction(function () {
                _this._keys.remove(key);
                _this._updateHasMapEntry(key, false);
                var observable$$1 = _this._data[key];
                observable$$1.setNewValue(undefined);
                _this._data[key] = undefined;
            });
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
        // optimization; don't fill the hasMap if we are not observing, or remove entry if there are no observers anymore
        var entry = this._hasMap[key];
        if (entry) {
            entry.setNewValue(value);
        }
        else {
            entry = this._hasMap[key] = new ObservableValue(value, referenceEnhancer, this.name + "." + key + "?", false);
        }
        return entry;
    };
    ObservableMap.prototype._updateValue = function (name, newValue) {
        var observable$$1 = this._data[name];
        newValue = observable$$1.prepareNewValue(newValue);
        if (newValue !== UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: this,
                    oldValue: observable$$1.value,
                    name: name,
                    newValue: newValue
                }
                : null;
            if (notifySpy)
                spyReportStart(change);
            observable$$1.setNewValue(newValue);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableMap.prototype._addValue = function (name, newValue) {
        var _this = this;
        transaction(function () {
            var observable$$1 = (_this._data[name] = new ObservableValue(newValue, _this.enhancer, _this.name + "." + name, false));
            newValue = observable$$1.value; // value might have been changed
            _this._updateHasMapEntry(name, true);
            _this._keys.push(name);
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                type: "add",
                object: this,
                name: name,
                newValue: newValue
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableMap.prototype.get = function (key) {
        key = "" + key;
        if (this.has(key))
            return this.dehanceValue(this._data[key].get());
        return this.dehanceValue(undefined);
    };
    ObservableMap.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableMap.prototype.keys = function () {
        return arrayAsIterator(this._keys.slice());
    };
    ObservableMap.prototype.values = function () {
        return arrayAsIterator(this._keys.map(this.get, this));
    };
    ObservableMap.prototype.entries = function () {
        var _this = this;
        return arrayAsIterator(this._keys.map(function (key) { return [key, _this.get(key)]; }));
    };
    ObservableMap.prototype.forEach = function (callback, thisArg) {
        var _this = this;
        this.keys().forEach(function (key) { return callback.call(thisArg, _this.get(key), key, _this); });
    };
    /** Merge another object into this object, returns this. */
    ObservableMap.prototype.merge = function (other) {
        var _this = this;
        if (isObservableMap(other)) {
            other = other.toJS();
        }
        transaction(function () {
            if (isPlainObject(other))
                Object.keys(other).forEach(function (key) { return _this.set(key, other[key]); });
            else if (Array.isArray(other))
                other.forEach(function (_a) {
                    var key = _a[0], value = _a[1];
                    return _this.set(key, value);
                });
            else if (isES6Map(other))
                other.forEach(function (value, key) { return _this.set(key, value); });
            else if (other !== null && other !== undefined)
                fail("Cannot initialize map from " + other);
        });
        return this;
    };
    ObservableMap.prototype.clear = function () {
        var _this = this;
        transaction(function () {
            untracked(function () {
                _this.keys().forEach(_this.delete, _this);
            });
        });
    };
    ObservableMap.prototype.replace = function (values) {
        var _this = this;
        transaction(function () {
            // grab all the keys that are present in the new map but not present in the current map
            // and delete them from the map, then merge the new map
            // this will cause reactions only on changed values
            var newKeys = getMapLikeKeys(values);
            var oldKeys = _this.keys();
            var missingKeys = oldKeys.filter(function (k) { return newKeys.indexOf(k) === -1; });
            missingKeys.forEach(function (k) { return _this.delete(k); });
            _this.merge(values);
        });
        return this;
    };
    Object.defineProperty(ObservableMap.prototype, "size", {
        get: function () {
            return this._keys.length;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a shallow non observable object clone of this map.
     * Note that the values might still be observable. For a deep clone use mobx.toJS.
     */
    ObservableMap.prototype.toJS = function () {
        var _this = this;
        var res = {};
        this.keys().forEach(function (key) { return (res[key] = _this.get(key)); });
        return res;
    };
    ObservableMap.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toJS();
    };
    ObservableMap.prototype.isValidKey = function (key) {
        if (key === null || key === undefined)
            return false;
        if (typeof key === "string" || typeof key === "number" || typeof key === "boolean")
            return true;
        return false;
    };
    ObservableMap.prototype.assertValidKey = function (key) {
        if (!this.isValidKey(key))
            throw new Error("[mobx.map] Invalid key: '" + key + "', only strings, numbers and booleans are accepted as key in observable maps.");
    };
    ObservableMap.prototype.toString = function () {
        var _this = this;
        return (this.name +
            "[{ " +
            this.keys().map(function (key) { return key + ": " + ("" + _this.get(key)); }).join(", ") +
            " }]");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableMap.prototype.observe = function (listener, fireImmediately) {
        invariant(fireImmediately !== true, getMessage("m033"));
        return registerListener(this, listener);
    };
    ObservableMap.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableMap;
}());
declareIterator(ObservableMap.prototype, function () {
    return this.entries();
});
function map(initialValues) {
    deprecated("`mobx.map` is deprecated, use `new ObservableMap` or `mobx.observable.map` instead");
    return observable.map(initialValues);
}
/* 'var' fixes small-build issue */
var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);

var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
function getGlobal() {
    return typeof window !== "undefined" ? window : global;
}
function getNextId() {
    return ++globalState.mobxGuid;
}
function fail(message, thing) {
    invariant(false, message, thing);
    throw "X"; // unreachable
}
function invariant(check, message, thing) {
    if (!check)
        throw new Error("[mobx] Invariant failed: " + message + (thing ? " in '" + thing + "'" : ""));
}
/**
 * Prints a deprecation message, but only one time.
 * Returns false if the deprecated message was already printed before
 */
var deprecatedMessages = [];
function deprecated(msg) {
    if (deprecatedMessages.indexOf(msg) !== -1)
        return false;
    deprecatedMessages.push(msg);
    console.error("[mobx] Deprecated: " + msg);
    return true;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */
function once(func) {
    var invoked = false;
    return function () {
        if (invoked)
            return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function () { };
function unique(list) {
    var res = [];
    list.forEach(function (item) {
        if (res.indexOf(item) === -1)
            res.push(item);
    });
    return res;
}
function joinStrings(things, limit, separator) {
    if (limit === void 0) { limit = 100; }
    if (separator === void 0) { separator = " - "; }
    if (!things)
        return "";
    var sliced = things.slice(0, limit);
    return "" + sliced.join(separator) + (things.length > limit
        ? " (... and " + (things.length - limit) + "more)"
        : "");
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (value === null || typeof value !== "object")
        return false;
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}
function objectAssign() {
    var res = arguments[0];
    for (var i = 1, l = arguments.length; i < l; i++) {
        var source = arguments[i];
        for (var key in source)
            if (hasOwnProperty(source, key)) {
                res[key] = source[key];
            }
    }
    return res;
}
var prototypeHasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwnProperty(object, propName) {
    return prototypeHasOwnProperty.call(object, propName);
}
function makeNonEnumerable(object, propNames) {
    for (var i = 0; i < propNames.length; i++) {
        addHiddenProp(object, propNames[i], object[propNames[i]]);
    }
}
function addHiddenProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function isPropertyConfigurable(object, prop) {
    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
}
function assertPropertyConfigurable(object, prop) {
    invariant(isPropertyConfigurable(object, prop), "Cannot make property '" + prop + "' observable, it is not configurable and writable in the target object");
}
function getEnumerableKeys(obj) {
    var res = [];
    for (var key in obj)
        res.push(key);
    return res;
}
/**
 * Naive deepEqual. Doesn't check for prototype, non-enumerable or out-of-range properties on arrays.
 * If you have such a case, you probably should use this function but something fancier :).
 */
function deepEqual(a, b) {
    if (a === null && b === null)
        return true;
    if (a === undefined && b === undefined)
        return true;
    if (areBothNaN(a, b))
        return true;
    if (typeof a !== "object")
        return a === b;
    var aIsArray = isArrayLike(a);
    var aIsMap = isMapLike(a);
    if (aIsArray !== isArrayLike(b)) {
        return false;
    }
    else if (aIsMap !== isMapLike(b)) {
        return false;
    }
    else if (aIsArray) {
        if (a.length !== b.length)
            return false;
        for (var i = a.length - 1; i >= 0; i--)
            if (!deepEqual(a[i], b[i]))
                return false;
        return true;
    }
    else if (aIsMap) {
        if (a.size !== b.size)
            return false;
        var equals_1 = true;
        a.forEach(function (value, key) {
            equals_1 = equals_1 && deepEqual(b.get(key), value);
        });
        return equals_1;
    }
    else if (typeof a === "object" && typeof b === "object") {
        if (a === null || b === null)
            return false;
        if (isMapLike(a) && isMapLike(b)) {
            if (a.size !== b.size)
                return false;
            // Freaking inefficient.... Create PR if you run into this :) Much appreciated!
            return deepEqual(observable.shallowMap(a).entries(), observable.shallowMap(b).entries());
        }
        if (getEnumerableKeys(a).length !== getEnumerableKeys(b).length)
            return false;
        for (var prop in a) {
            if (!(prop in b))
                return false;
            if (!deepEqual(a[prop], b[prop]))
                return false;
        }
        return true;
    }
    return false;
}
function createInstanceofPredicate(name, clazz) {
    var propName = "isMobX" + name;
    clazz.prototype[propName] = true;
    return function (x) {
        return isObject(x) && x[propName] === true;
    };
}
function areBothNaN(a, b) {
    return (typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b));
}
/**
 * Returns whether the argument is an array, disregarding observability.
 */
function isArrayLike(x) {
    return Array.isArray(x) || isObservableArray(x);
}
function isMapLike(x) {
    return isES6Map(x) || isObservableMap(x);
}
function isES6Map(thing) {
    if (getGlobal().Map !== undefined && thing instanceof getGlobal().Map)
        return true;
    return false;
}
function getMapLikeKeys(map$$1) {
    var keys;
    if (isPlainObject(map$$1))
        keys = Object.keys(map$$1);
    else if (Array.isArray(map$$1))
        keys = map$$1.map(function (_a) {
            var key = _a[0];
            return key;
        });
    else if (isMapLike(map$$1))
        keys = Array.from(map$$1.keys());
    else
        fail("Cannot get keys from " + map$$1);
    return keys;
}
function primitiveSymbol() {
    return (typeof Symbol === "function" && Symbol.toPrimitive) || "@@toPrimitive";
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}

/**
 * These values will persist if global state is reset
 */
var persistentKeys = ["mobxGuid", "resetId", "spyListeners", "strictMode", "runId"];
var MobXGlobals = (function () {
    function MobXGlobals() {
        /**
         * MobXGlobals version.
         * MobX compatiblity with other versions loaded in memory as long as this version matches.
         * It indicates that the global state still stores similar information
         */
        this.version = 5;
        /**
         * Currently running derivation
         */
        this.trackingDerivation = null;
        /**
         * Are we running a computation currently? (not a reaction)
         */
        this.computationDepth = 0;
        /**
         * Each time a derivation is tracked, it is assigned a unique run-id
         */
        this.runId = 0;
        /**
         * 'guid' for general purpose. Will be persisted amongst resets.
         */
        this.mobxGuid = 0;
        /**
         * Are we in a batch block? (and how many of them)
         */
        this.inBatch = 0;
        /**
         * Observables that don't have observers anymore, and are about to be
         * suspended, unless somebody else accesses it in the same batch
         *
         * @type {IObservable[]}
         */
        this.pendingUnobservations = [];
        /**
         * List of scheduled, not yet executed, reactions.
         */
        this.pendingReactions = [];
        /**
         * Are we currently processing reactions?
         */
        this.isRunningReactions = false;
        /**
         * Is it allowed to change observables at this point?
         * In general, MobX doesn't allow that when running computations and React.render.
         * To ensure that those functions stay pure.
         */
        this.allowStateChanges = true;
        /**
         * If strict mode is enabled, state changes are by default not allowed
         */
        this.strictMode = false;
        /**
         * Used by createTransformer to detect that the global state has been reset.
         */
        this.resetId = 0;
        /**
         * Spy callbacks
         */
        this.spyListeners = [];
        /**
         * Globally attached error handlers that react specifically to errors in reactions
         */
        this.globalReactionErrorHandlers = [];
    }
    return MobXGlobals;
}());
var globalState = new MobXGlobals();
var shareGlobalStateCalled = false;
var runInIsolationCalled = false;
var warnedAboutMultipleInstances = false;
{
    var global_1 = getGlobal();
    if (!global_1.__mobxInstanceCount) {
        global_1.__mobxInstanceCount = 1;
    }
    else {
        global_1.__mobxInstanceCount++;
        setTimeout(function () {
            if (!shareGlobalStateCalled && !runInIsolationCalled && !warnedAboutMultipleInstances) {
                warnedAboutMultipleInstances = true;
                console.warn("[mobx] Warning: there are multiple mobx instances active. This might lead to unexpected results. See https://github.com/mobxjs/mobx/issues/1082 for details.");
            }
        });
    }
}
function isolateGlobalState() {
    runInIsolationCalled = true;
    getGlobal().__mobxInstanceCount--;
}
function shareGlobalState() {
    // TODO: remove in 4.0; just use peer dependencies instead.
    deprecated("Using `shareGlobalState` is not recommended, use peer dependencies instead. See https://github.com/mobxjs/mobx/issues/1082 for details.");
    shareGlobalStateCalled = true;
    var global = getGlobal();
    var ownState = globalState;
    /**
     * Backward compatibility check
     */
    if (global.__mobservableTrackingStack || global.__mobservableViewStack)
        throw new Error("[mobx] An incompatible version of mobservable is already loaded.");
    if (global.__mobxGlobal && global.__mobxGlobal.version !== ownState.version)
        throw new Error("[mobx] An incompatible version of mobx is already loaded.");
    if (global.__mobxGlobal)
        globalState = global.__mobxGlobal;
    else
        global.__mobxGlobal = ownState;
}
function getGlobalState() {
    return globalState;
}

/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */
function resetGlobalState() {
    globalState.resetId++;
    var defaultGlobals = new MobXGlobals();
    for (var key in defaultGlobals)
        if (persistentKeys.indexOf(key) === -1)
            globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.strictMode;
}

function hasObservers(observable) {
    return observable.observers && observable.observers.length > 0;
}
function getObservers(observable) {
    return observable.observers;
}
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    var l = observable.observers.length;
    if (l) {
        // because object assignment is relatively expensive, let's not store data about index 0.
        observable.observersIndexes[node.__mapid] = l;
    }
    observable.observers[l] = node;
    if (observable.lowestObserverState > node.dependenciesState)
        observable.lowestObserverState = node.dependenciesState;
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    if (observable.observers.length === 1) {
        // deleting last observer
        observable.observers.length = 0;
        queueForUnobservation(observable);
    }
    else {
        // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
        var list = observable.observers;
        var map = observable.observersIndexes;
        var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesn't have holes
        if (filler !== node) {
            // otherwise node was the last element, which already got removed from array
            var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.
            if (index) {
                // map store all indexes but 0, see comment in `addObserver`
                map[filler.__mapid] = index;
            }
            else {
                delete map[filler.__mapid];
            }
            list[index] = filler;
        }
        delete map[node.__mapid];
    }
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (!observable.isPendingUnobservation) {
        // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */
function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for (var i = 0; i < list.length; i++) {
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers.length === 0) {
                observable.onBecomeUnobserved();
                // NOTE: onBecomeUnobserved might push to `pendingUnobservations`
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
         * Simple optimization, give each derivation run an unique id (runId)
         * Check if last time this observable was accessed the same runId is used
         * if this is the case, the relation is already known
         */
        if (derivation.runId !== observable.lastAccessedBy) {
            observable.lastAccessedBy = derivation.runId;
            derivation.newObserving[derivation.unboundDepsCount++] = observable;
        }
    }
    else if (observable.observers.length === 0) {
        queueForUnobservation(observable);
    }
}
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */
// Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE)
            d.onBecomeStale();
        d.dependenciesState = IDerivationState.STALE;
    }
    // invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.POSSIBLY_STALE)
            d.dependenciesState = IDerivationState.STALE;
        else if (d.dependenciesState === IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
        )
            observable.lowestObserverState = IDerivationState.UP_TO_DATE;
    }
    // invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState !== IDerivationState.UP_TO_DATE)
        return;
    observable.lowestObserverState = IDerivationState.POSSIBLY_STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            d.dependenciesState = IDerivationState.POSSIBLY_STALE;
            d.onBecomeStale();
        }
    }
    // invariantLOS(observable, "maybe end");
}

var IDerivationState;
(function (IDerivationState) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
})(IDerivationState || (IDerivationState = {}));
var CaughtException = (function () {
    function CaughtException(cause) {
        this.cause = cause;
        // Empty
    }
    return CaughtException;
}());
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */
function shouldCompute(derivation) {
    switch (derivation.dependenciesState) {
        case IDerivationState.UP_TO_DATE:
            return false;
        case IDerivationState.NOT_TRACKING:
        case IDerivationState.STALE:
            return true;
        case IDerivationState.POSSIBLY_STALE: {
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing, l = obs.length;
            for (var i = 0; i < l; i++) {
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    try {
                        obj.get();
                    }
                    catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    if (derivation.dependenciesState === IDerivationState.STALE) {
                        untrackedEnd(prevUntracked);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            return false;
        }
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers$$1 = atom.observers.length > 0;
    // Should never be possible to change an observed observable from inside computed, see #798
    if (globalState.computationDepth > 0 && hasObservers$$1)
        fail(getMessage("m031") + atom.name);
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!globalState.allowStateChanges && hasObservers$$1)
        fail(getMessage(globalState.strictMode ? "m030a" : "m030b") + atom.name);
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */
function trackDerivedFunction(derivation, f, context) {
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving = new Array(derivation.observing.length + 100);
    derivation.unboundDepsCount = 0;
    derivation.runId = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    var result;
    try {
        result = f.call(context);
    }
    catch (e) {
        result = new CaughtException(e);
    }
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    return result;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */
function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing;
    var observing = (derivation.observing = derivation.newObserving);
    var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount;
    for (var i = 0; i < l; i++) {
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i)
                observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState > lowestNewObservingDerivationState) {
            lowestNewObservingDerivationState = dep.dependenciesState;
        }
    }
    observing.length = i0;
    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while (l--) {
        var dep = prevObserving[l];
        if (dep.diffValue === 0) {
            removeObserver(dep, derivation);
        }
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while (i0--) {
        var dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            addObserver(dep, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
        derivation.dependenciesState = lowestNewObservingDerivationState;
        derivation.onBecomeStale();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing;
    derivation.observing = [];
    var i = obs.length;
    while (i--)
        removeObserver(obs[i], derivation);
    derivation.dependenciesState = IDerivationState.NOT_TRACKING;
}
function untracked(action) {
    var prev = untrackedStart();
    var res = action();
    untrackedEnd(prev);
    return res;
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */
function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState === IDerivationState.UP_TO_DATE)
        return;
    derivation.dependenciesState = IDerivationState.UP_TO_DATE;
    var obs = derivation.observing;
    var i = obs.length;
    while (i--)
        obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
}

var Reaction = (function () {
    function Reaction(name, onInvalidate) {
        if (name === void 0) { name = "Reaction@" + getNextId(); }
        this.name = name;
        this.onInvalidate = onInvalidate;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = [];
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.diffValue = 0;
        this.runId = 0;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.isDisposed = false;
        this._isScheduled = false;
        this._isTrackPending = false;
        this._isRunning = false;
    }
    Reaction.prototype.onBecomeStale = function () {
        this.schedule();
    };
    Reaction.prototype.schedule = function () {
        if (!this._isScheduled) {
            this._isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    Reaction.prototype.isScheduled = function () {
        return this._isScheduled;
    };
    /**
     * internal, use schedule() if you intend to kick off a reaction
     */
    Reaction.prototype.runReaction = function () {
        if (!this.isDisposed) {
            startBatch();
            this._isScheduled = false;
            if (shouldCompute(this)) {
                this._isTrackPending = true;
                this.onInvalidate();
                if (this._isTrackPending && isSpyEnabled()) {
                    // onInvalidate didn't trigger track right away..
                    spyReport({
                        object: this,
                        type: "scheduled-reaction"
                    });
                }
            }
            endBatch();
        }
    };
    Reaction.prototype.track = function (fn) {
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        if (notify) {
            startTime = Date.now();
            spyReportStart({
                object: this,
                type: "reaction",
                fn: fn
            });
        }
        this._isRunning = true;
        var result = trackDerivedFunction(this, fn, undefined);
        this._isRunning = false;
        this._isTrackPending = false;
        if (this.isDisposed) {
            // disposed during last run. Clean up everything that was bound after the dispose call.
            clearObserving(this);
        }
        if (isCaughtException(result))
            this.reportExceptionInDerivation(result.cause);
        if (notify) {
            spyReportEnd({
                time: Date.now() - startTime
            });
        }
        endBatch();
    };
    Reaction.prototype.reportExceptionInDerivation = function (error) {
        var _this = this;
        if (this.errorHandler) {
            this.errorHandler(error, this);
            return;
        }
        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this;
        var messageToUser = getMessage("m037");
        console.error(message || messageToUser /* latter will not be true, make sure uglify doesn't remove */, error);
        /** If debugging brought you here, please, read the above message :-). Tnx! */
        if (isSpyEnabled()) {
            spyReport({
                type: "error",
                message: message,
                error: error,
                object: this
            });
        }
        globalState.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
    };
    Reaction.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this._isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    Reaction.prototype.getDisposer = function () {
        var r = this.dispose.bind(this);
        r.$mobx = this;
        r.onError = registerErrorHandler;
        return r;
    };
    Reaction.prototype.toString = function () {
        return "Reaction[" + this.name + "]";
    };
    Reaction.prototype.whyRun = function () {
        var observing = unique(this._isRunning ? this.newObserving : this.observing).map(function (dep) { return dep.name; });
        return "\nWhyRun? reaction '" + this.name + "':\n * Status: [" + (this.isDisposed
            ? "stopped"
            : this._isRunning ? "running" : this.isScheduled() ? "scheduled" : "idle") + "]\n * This reaction will re-run if any of the following observables changes:\n    " + joinStrings(observing) + "\n    " + (this._isRunning
            ? " (... or any observable accessed during the remainder of the current run)"
            : "") + "\n\t" + getMessage("m038") + "\n";
    };
    return Reaction;
}());
function registerErrorHandler(handler) {
    invariant(this && this.$mobx && isReaction(this.$mobx), "Invalid `this`");
    invariant(!this.$mobx.errorHandler, "Only one onErrorHandler can be registered");
    this.$mobx.errorHandler = handler;
}
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function () {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0)
            globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function (f) { return f(); };
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions)
        return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while (allReactions.length > 0) {
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for (var i = 0, l = remainingReactions.length; i < l; i++)
            remainingReactions[i].runReaction();
    }
    globalState.isRunningReactions = false;
}
var isReaction = createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
}

function asReference(value) {
    deprecated("asReference is deprecated, use observable.ref instead");
    return observable.ref(value);
}
function asStructure(value) {
    deprecated("asStructure is deprecated. Use observable.struct, computed.struct or reaction options instead.");
    return observable.struct(value);
}
function asFlat(value) {
    deprecated("asFlat is deprecated, use observable.shallow instead");
    return observable.shallow(value);
}
function asMap(data) {
    deprecated("asMap is deprecated, use observable.map or observable.shallowMap instead");
    return observable.map(data || {});
}

function createComputedDecorator(equals) {
    return createClassPropertyDecorator(function (target, name, _, __, originalDescriptor) {
        invariant(typeof originalDescriptor !== "undefined", getMessage("m009"));
        invariant(typeof originalDescriptor.get === "function", getMessage("m010"));
        var adm = asObservableObject(target, "");
        defineComputedProperty(adm, name, originalDescriptor.get, originalDescriptor.set, equals, false);
    }, function (name) {
        var observable = this.$mobx.values[name];
        if (observable === undefined // See #505
        )
            return undefined;
        return observable.get();
    }, function (name, value) {
        this.$mobx.values[name].set(value);
    }, false, false);
}
var computedDecorator = createComputedDecorator(comparer.default);
var computedStructDecorator = createComputedDecorator(comparer.structural);
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */
var computed = function computed(arg1, arg2, arg3) {
    if (typeof arg2 === "string") {
        return computedDecorator.apply(null, arguments);
    }
    invariant(typeof arg1 === "function", getMessage("m011"));
    invariant(arguments.length < 3, getMessage("m012"));
    var opts = typeof arg2 === "object" ? arg2 : {};
    opts.setter = typeof arg2 === "function" ? arg2 : opts.setter;
    var equals = opts.equals
        ? opts.equals
        : opts.compareStructural || opts.struct ? comparer.structural : comparer.default;
    return new ComputedValue(arg1, opts.context, equals, opts.name || arg1.name || "", opts.setter);
};
computed.struct = computedStructDecorator;
computed.equals = createComputedDecorator;

function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            invariant(property === undefined, getMessage("m036"));
            return thing.$mobx.atom;
        }
        if (isObservableMap(thing)) {
            var anyThing = thing;
            if (property === undefined)
                return getAtom(anyThing._keys);
            var observable = anyThing._data[property] || anyThing._hasMap[property];
            invariant(!!observable, "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
            return observable;
        }
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        runLazyInitializers(thing);
        if (property && !thing.$mobx)
            thing[property]; // See #1072 // TODO: remove in 4.0
        if (isObservableObject(thing)) {
            if (!property)
                return fail("please specify a property");
            var observable = thing.$mobx.values[property];
            invariant(!!observable, "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
            return observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
            return thing;
        }
    }
    else if (typeof thing === "function") {
        if (isReaction(thing.$mobx)) {
            // disposer function
            return thing.$mobx;
        }
    }
    return fail("Cannot obtain atom from " + thing);
}
function getAdministration(thing, property) {
    invariant(thing, "Expecting some object");
    if (property !== undefined)
        return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
        return thing;
    if (isObservableMap(thing))
        return thing;
    // Initializers run lazily when transpiling to babel, so make sure they are run...
    runLazyInitializers(thing);
    if (thing.$mobx)
        return thing.$mobx;
    invariant(false, "Cannot obtain administration from " + thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined)
        named = getAtom(thing, property);
    else if (isObservableObject(thing) || isObservableMap(thing))
        named = getAdministration(thing);
    else
        named = getAtom(thing); // valid for arrays as well
    return named.name;
}

function isComputed(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableObject(value) === false)
            return false;
        if (!value.$mobx.values[property])
            return false;
        var atom = getAtom(value, property);
        return isComputedValue(atom);
    }
    return isComputedValue(value);
}

function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (typeof cbOrFire === "function")
        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else
        return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe(listener, fireImmediately);
}

function intercept(thing, propOrHandler, handler) {
    if (typeof handler === "function")
        return interceptProperty(thing, propOrHandler, handler);
    else
        return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept(handler);
}

/**
 * expr can be used to create temporarily views inside views.
 * This can be improved to improve performance if a value changes often, but usually doesn't affect the outcome of an expression.
 *
 * In the following example the expression prevents that a component is rerender _each time_ the selection changes;
 * instead it will only rerenders when the current todo is (de)selected.
 *
 * reactiveComponent((props) => {
 *     const todo = props.todo;
 *     const isSelected = mobx.expr(() => props.viewState.selection === todo);
 *     return <div className={isSelected ? "todo todo-selected" : "todo"}>{todo.title}</div>
 * });
 *
 */
function expr(expr, scope) {
    if (!isComputingDerivation())
        console.warn(getMessage("m013"));
    // optimization: would be more efficient if the expr itself wouldn't be evaluated first on the next change, but just a 'changed' signal would be fired
    return computed(expr, { context: scope }).get();
}

function toJS(source, detectCycles, __alreadySeen) {
    if (detectCycles === void 0) { detectCycles = true; }
    if (__alreadySeen === void 0) { __alreadySeen = []; }
    // optimization: using ES6 map would be more efficient!
    // optimization: lift this function outside toJS, this makes recursion expensive
    function cache(value) {
        if (detectCycles)
            __alreadySeen.push([source, value]);
        return value;
    }
    if (isObservable(source)) {
        if (detectCycles && __alreadySeen === null)
            __alreadySeen = [];
        if (detectCycles && source !== null && typeof source === "object") {
            for (var i = 0, l = __alreadySeen.length; i < l; i++)
                if (__alreadySeen[i][0] === source)
                    return __alreadySeen[i][1];
        }
        if (isObservableArray(source)) {
            var res = cache([]);
            var toAdd = source.map(function (value) { return toJS(value, detectCycles, __alreadySeen); });
            res.length = toAdd.length;
            for (var i = 0, l = toAdd.length; i < l; i++)
                res[i] = toAdd[i];
            return res;
        }
        if (isObservableObject(source)) {
            var res = cache({});
            for (var key in source)
                res[key] = toJS(source[key], detectCycles, __alreadySeen);
            return res;
        }
        if (isObservableMap(source)) {
            var res_1 = cache({});
            source.forEach(function (value, key) { return (res_1[key] = toJS(value, detectCycles, __alreadySeen)); });
            return res_1;
        }
        if (isObservableValue(source))
            return toJS(source.get(), detectCycles, __alreadySeen);
    }
    return source;
}

function createTransformer(transformer, onCleanup) {
    invariant(typeof transformer === "function" && transformer.length < 2, "createTransformer expects a function that accepts one argument");
    // Memoizes: object id -> reactive view that applies transformer to the object
    var objectCache = {};
    // If the resetId changes, we will clear the object cache, see #163
    // This construction is used to avoid leaking refs to the objectCache directly
    var resetId = globalState.resetId;
    // Local transformer class specifically for this transformer
    var Transformer = (function (_super) {
        __extends(Transformer, _super);
        function Transformer(sourceIdentifier, sourceObject) {
            var _this = _super.call(this, function () { return transformer(sourceObject); }, undefined, comparer.default, "Transformer-" + transformer.name + "-" + sourceIdentifier, undefined) || this;
            _this.sourceIdentifier = sourceIdentifier;
            _this.sourceObject = sourceObject;
            return _this;
        }
        Transformer.prototype.onBecomeUnobserved = function () {
            var lastValue = this.value;
            _super.prototype.onBecomeUnobserved.call(this);
            delete objectCache[this.sourceIdentifier];
            if (onCleanup)
                onCleanup(lastValue, this.sourceObject);
        };
        return Transformer;
    }(ComputedValue));
    return function (object) {
        if (resetId !== globalState.resetId) {
            objectCache = {};
            resetId = globalState.resetId;
        }
        var identifier = getMemoizationId(object);
        var reactiveTransformer = objectCache[identifier];
        if (reactiveTransformer)
            return reactiveTransformer.get();
        // Not in cache; create a reactive view
        reactiveTransformer = objectCache[identifier] = new Transformer(identifier, object);
        return reactiveTransformer.get();
    };
}
function getMemoizationId(object) {
    if (typeof object === "string" || typeof object === "number")
        return object;
    if (object === null || typeof object !== "object")
        throw new Error("[mobx] transform expected some kind of object or primitive value, got: " + object);
    var tid = object.$transformId;
    if (tid === undefined) {
        tid = getNextId();
        addHiddenProp(object, "$transformId", tid);
    }
    return tid;
}

function log(msg) {
    console.log(msg);
    return msg;
}
function whyRun(thing, prop) {
    switch (arguments.length) {
        case 0:
            thing = globalState.trackingDerivation;
            if (!thing)
                return log(getMessage("m024"));
            break;
        case 2:
            thing = getAtom(thing, prop);
            break;
    }
    thing = getAtom(thing);
    if (isComputedValue(thing))
        return log(thing.whyRun());
    else if (isReaction(thing))
        return log(thing.whyRun());
    return fail(getMessage("m025"));
}

function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name
    };
    if (node.observing && node.observing.length > 0)
        result.dependencies = unique(node.observing).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name
    };
    if (hasObservers(node))
        result.observers = getObservers(node).map(nodeToObserverTree);
    return result;
}

function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
        target = getAdministration(thing);
    }
    else if (isObservableObject(thing)) {
        if (typeof propOrHandler !== "string")
            return fail("InterceptReads can only be used with a specific property, not with an object in general");
        target = getAdministration(thing, propOrHandler);
    }
    else {
        return fail("Expected observable map, object or array as first array");
    }
    if (target.dehancer !== undefined)
        return fail("An intercept reader was already established");
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function () {
        target.dehancer = undefined;
    };
}

/**
 * (c) Michel Weststrate 2015 - 2016
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */
var extras = {
    allowStateChanges: allowStateChanges,
    deepEqual: deepEqual,
    getAtom: getAtom,
    getDebugName: getDebugName,
    getDependencyTree: getDependencyTree,
    getAdministration: getAdministration,
    getGlobalState: getGlobalState,
    getObserverTree: getObserverTree,
    interceptReads: interceptReads,
    isComputingDerivation: isComputingDerivation,
    isSpyEnabled: isSpyEnabled,
    onReactionError: onReactionError,
    reserveArrayBuffer: reserveArrayBuffer,
    resetGlobalState: resetGlobalState,
    isolateGlobalState: isolateGlobalState,
    shareGlobalState: shareGlobalState,
    spyReport: spyReport,
    spyReportEnd: spyReportEnd,
    spyReportStart: spyReportStart,
    setReactionScheduler: setReactionScheduler
};
var everything = {
    Reaction: Reaction,
    untracked: untracked,
    Atom: Atom,
    BaseAtom: BaseAtom,
    useStrict: useStrict,
    isStrictModeEnabled: isStrictModeEnabled,
    spy: spy,
    comparer: comparer,
    asReference: asReference,
    asFlat: asFlat,
    asStructure: asStructure,
    asMap: asMap,
    isModifierDescriptor: isModifierDescriptor,
    isObservableObject: isObservableObject,
    isBoxedObservable: isObservableValue,
    isObservableArray: isObservableArray,
    ObservableMap: ObservableMap,
    isObservableMap: isObservableMap,
    map: map,
    transaction: transaction,
    observable: observable,
    computed: computed,
    isObservable: isObservable,
    isComputed: isComputed,
    extendObservable: extendObservable,
    extendShallowObservable: extendShallowObservable,
    observe: observe,
    intercept: intercept,
    autorun: autorun,
    autorunAsync: autorunAsync,
    when: when,
    reaction: reaction,
    action: action,
    isAction: isAction,
    runInAction: runInAction,
    expr: expr,
    toJS: toJS,
    createTransformer: createTransformer,
    whyRun: whyRun,
    isArrayLike: isArrayLike,
    extras: extras
};
var warnedAboutDefaultExport = false;
var _loop_1 = function (p) {
    var val = everything[p];
    Object.defineProperty(everything, p, {
        get: function () {
            if (!warnedAboutDefaultExport) {
                warnedAboutDefaultExport = true;
                console.warn("Using default export (`import mobx from 'mobx'`) is deprecated " +
                    "and won’t work in mobx@4.0.0\n" +
                    "Use `import * as mobx from 'mobx'` instead");
            }
            return val;
        }
    });
};
for (var p in everything) {
    _loop_1(p);
}
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({ spy: spy, extras: extras });
}

/* unused harmony default export */ var _unused_webpack_default_export = (everything);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(66)))

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);


var IndicatorActions = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['replace', 'append', 'remove', 'clear', 'undo']);

/* harmony default export */ __webpack_exports__["a"] = (IndicatorActions);

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isString__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ios_device_list__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ios_device_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ios_device_list__);





/* harmony default export */ __webpack_exports__["a"] = (function (model) {
  if (!model || !__WEBPACK_IMPORTED_MODULE_0_lodash_isString___default()(model)) {
    return null;
  }
  var modelIdentifier = model.split(' ')[0];
  var modelId = model.split(' ').splice(1).join(' ');
  var modelName = __WEBPACK_IMPORTED_MODULE_1_ios_device_list___default.a.generationByIdentifier(modelIdentifier);
  return modelName === undefined ? model : modelName + ' ' + modelId;
});

/***/ }),
/* 481 */,
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PendingChangeQueue = function () {
  function PendingChangeQueue() {
    _classCallCheck(this, PendingChangeQueue);

    this.changes = [];
  }

  _createClass(PendingChangeQueue, [{
    key: "getForItem",
    value: function getForItem(itemId) {
      return this.changes.filter(function (change) {
        return change[1] === itemId;
      });
    }
  }, {
    key: "push",
    value: function push(changeId, itemId, data) {
      this.changes.push([changeId, itemId, data]);
    }
  }, {
    key: "remove",
    value: function remove(changeId, itemId) {
      this.changes = this.changes.filter(function (change) {
        return change[0] != changeId || change[1] != itemId;
      });
    }
  }, {
    key: "forEach",
    value: function forEach() {
      this.changes.forEach.apply(this.changes, arguments);
    }
  }]);

  return PendingChangeQueue;
}();

/* harmony default export */ __webpack_exports__["a"] = (PendingChangeQueue);

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_views_settings_components_forms_field_fieldControlState__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_inlineSvg__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_tooltip__ = __webpack_require__(21);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }










// This wraps Control + ControlError message
// * can NOT be a flex box here because of `position: absolute` on "control error message"
// * can NOT have overflow hidden because "control error message" overflows
var FieldControlErrorWrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(function (_ref) {
  var inline = _ref.inline,
      props = _objectWithoutProperties(_ref, ['inline']);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Box"], props);
}, {
  target: 'e78b1iv0'
})(function (p) {
  return p.inline ? 'width: 50%; padding-left: 10px;' : '';
}, ';');

var FieldControlStyled = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(function (_ref2) {
  var alignRight = _ref2.alignRight,
      props = _objectWithoutProperties(_ref2, ['alignRight']);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Box"], props);
}, {
  target: 'e78b1iv1'
})('color:', function (p) {
  return p.theme.gray3;
}, ';display:flex;flex:1;flex-direction:column;position:relative;', function (p) {
  return p.alignRight ? 'align-items: flex-end;' : '';
}, ';');

var FieldControlWrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(function (_ref3) {
  var hasControlState = _ref3.hasControlState,
      props = _objectWithoutProperties(_ref3, ['hasControlState']);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Flex"], props);
}, {
  target: 'e78b1iv2'
})('flex-shrink:0;');

var StyledInlineSvg = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_5_app_components_inlineSvg__["a" /* default */], {
  target: 'e78b1iv3'
})('display:block;color:', function (p) {
  return p.theme.gray1;
}, ';margin:0 auto;cursor:pointer;transition:0.15s color;&:hover{color:', function (p) {
  return p.theme.gray3;
}, ';}');

var FieldControl = (_temp = _class = function (_React$Component) {
  _inherits(FieldControl, _React$Component);

  function FieldControl() {
    _classCallCheck(this, FieldControl);

    return _possibleConstructorReturn(this, (FieldControl.__proto__ || Object.getPrototypeOf(FieldControl)).apply(this, arguments));
  }

  _createClass(FieldControl, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          inline = _props.inline,
          alignRight = _props.alignRight,
          disabled = _props.disabled,
          disabledReason = _props.disabledReason,
          flexibleControlStateSize = _props.flexibleControlStateSize,
          errorState = _props.errorState,
          controlState = _props.controlState,
          children = _props.children;


      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        FieldControlErrorWrapper,
        { inline: inline },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          FieldControlWrapper,
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            FieldControlStyled,
            { alignRight: alignRight },
            children
          ),
          disabled && disabledReason && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_app_components_tooltip__["default"],
            { title: disabledReason },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'span',
              { className: 'disabled-indicator m-a-0' },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StyledInlineSvg, { src: 'icon-circle-question', size: '18px' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_app_views_settings_components_forms_field_fieldControlState__["a" /* default */],
            { flexibleControlStateSize: flexibleControlStateSize },
            controlState
          )
        ),
        errorState
      );
    }
  }]);

  return FieldControl;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  alignRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabledReason: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  flexibleControlStateSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  controlState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  errorState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
}, _class.defaultProps = {
  flexibleControlStateSize: false
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (FieldControl);

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_u2f_api__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_u2f_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_u2f_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raven_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_stores_configStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var U2fInterface = (_temp2 = _class = function (_React$Component) {
  _inherits(U2fInterface, _React$Component);

  function U2fInterface() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, U2fInterface);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = U2fInterface.__proto__ || Object.getPrototypeOf(U2fInterface)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isSupported: null,
      formElement: null,
      challengeElement: null,
      hasBeenTapped: false,
      deviceFailure: null,
      responseElement: null
    }, _this.onTryAgain = function () {
      _this.setState({
        hasBeenTapped: false,
        deviceFailure: null
      }, function () {
        _this.invokeU2fFlow();
      });
    }, _this.invokeU2fFlow = function () {
      var promise = void 0;
      if (_this.props.flowMode === 'sign') {
        promise = __WEBPACK_IMPORTED_MODULE_2_u2f_api___default.a.sign(_this.props.challengeData.authenticateRequests);
      } else if (_this.props.flowMode === 'enroll') {
        var _this$props$challenge = _this.props.challengeData,
            registerRequests = _this$props$challenge.registerRequests,
            authenticateRequests = _this$props$challenge.authenticateRequests;

        promise = __WEBPACK_IMPORTED_MODULE_2_u2f_api___default.a.register(registerRequests, authenticateRequests);
      } else {
        throw new Error('Unsupported flow mode \'' + _this.props.flowMode + '\'');
      }
      promise.then(function (data) {
        _this.setState({
          hasBeenTapped: true
        }, function () {
          var u2fResponse = JSON.stringify(data);
          var challenge = JSON.stringify(_this.props.challengeData);

          // eslint-disable-next-line react/no-direct-mutation-state
          _this.state.responseElement.value = u2fResponse;

          if (!_this.props.onTap) {
            _this.state.formElement && _this.state.formElement.submit();
          } else {
            _this.props.onTap({
              response: u2fResponse,
              challenge: challenge
            }).catch(function (err) {
              // This is kind of gross but I want to limit the amount of changes to this component
              _this.setState({
                deviceFailure: 'UNKNOWN_ERROR',
                hasBeenTapped: false
              });
            });
          }
        });
      }).catch(function (err) {
        var failure = 'DEVICE_ERROR';
        // in some rare cases there is no metadata on the error which
        // causes this to blow up badly.
        if (err.metaData) {
          if (err.metaData.type === 'DEVICE_INELIGIBLE') {
            if (_this.props.flowMode === 'enroll') {
              failure = 'DUPLICATE_DEVICE';
            } else {
              failure = 'UNKNOWN_DEVICE';
            }
          } else if (err.metaData.type === 'BAD_REQUEST') {
            failure = 'BAD_APPID';
          }
        }
        // we want to know what is happening here.  There are some indicators
        // that users are getting errors that should not happen through the
        // regular u2f flow.
        __WEBPACK_IMPORTED_MODULE_3_raven_js___default.a.captureException(err);
        _this.setState({
          deviceFailure: failure,
          hasBeenTapped: false
        });
      });
    }, _this.bindChallengeElement = function (ref) {
      _this.setState({
        challengeElement: ref,
        formElement: ref && ref.form
      });

      if (ref) {
        ref.value = JSON.stringify(_this.props.challengeData);
      }
    }, _this.bindResponseElement = function (ref) {
      _this.setState({
        responseElement: ref
      });
    }, _this.renderUnsupported = function () {
      if (_this.props.silentIfUnsupported) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'u2f-box' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'inner' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            { className: 'error' },
            Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('\n             Unfortunately your browser does not support U2F. You need to use\n             a different two-factor method or switch to a browser that supports\n             it (Google Chrome or Microsoft Edge).\n            ')
          )
        )
      );
    }, _this.canTryAgain = function () {
      return _this.state.deviceFailure !== 'BAD_APPID';
    }, _this.renderFailure = function () {
      var deviceFailure = _this.state.deviceFailure;

      var supportMail = __WEBPACK_IMPORTED_MODULE_4_app_stores_configStore__["default"].get('supportEmail');
      var support = supportMail ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        { href: 'mailto:' + supportMail },
        supportMail
      ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Support')
      );
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'failure-message' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'strong',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Error: ')
          ),
          ' ',
          {
            UNKNOWN_ERROR: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('There was an unknown problem, please try again'),
            DEVICE_ERROR: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Your U2F device reported an error.'),
            DUPLICATE_DEVICE: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('This device is already in use.'),
            UNKNOWN_DEVICE: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('The device you used for sign-in is unknown.'),
            BAD_APPID: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["tct"])('[p1:The Sentry server administrator modified the ' + 'device registrations.]' + '[p2:You need to remove and re-add the device to continue ' + 'using your U2F device. Use a different sign-in method or ' + 'contact [support] for assistance.]', {
              p1: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p', null),
              p2: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p', null),
              support: support
            })
          }[deviceFailure]
        ),
        _this.canTryAgain() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { marginTop: 18 } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            { onClick: _this.onTryAgain, className: 'btn btn-primary' },
            Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Try Again')
          )
        )
      );
    }, _this.renderBody = function () {
      if (_this.state.deviceFailure) {
        return _this.renderFailure();
      } else {
        return _this.props.children;
      }
    }, _this.renderPrompt = function () {
      var style = _this.props.style;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          style: style,
          className: 'u2f-box' + (_this.state.hasBeenTapped ? ' tapped' : '') + (_this.state.deviceFailure ? ' device-failure' : '')
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'device-animation-frame' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'device-failed' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'device-animation' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'loading-dots' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'dot' }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'dot' }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'dot' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { type: 'hidden', name: 'challenge', ref: _this.bindChallengeElement }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { type: 'hidden', name: 'response', ref: _this.bindResponseElement }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'inner' },
          _this.renderBody()
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(U2fInterface, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_u2f_api___default.a.isSupported().then(function (supported) {
        _this2.setState({
          isSupported: supported
        });
        if (!supported) {
          return;
        }
        _this2.invokeU2fFlow();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var isSupported = this.state.isSupported;
      // if we are still waiting for the browser to tell us if we can do u2f
      // this will be null.

      if (isSupported === null) {
        return null;
      } else if (!isSupported) {
        return this.renderUnsupported();
      } else {
        return this.renderPrompt();
      }
    }
  }]);

  return U2fInterface;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  challengeData: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  flowMode: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  onTap: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  silentIfUnsupported: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _class.defaultProps = {
  silentIfUnsupported: false
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (U2fInterface);

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(270),
    baseOrderBy = __webpack_require__(924),
    baseRest = __webpack_require__(415),
    isIterateeCall = __webpack_require__(631);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(220),
    isArrayLike = __webpack_require__(221);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 487 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 488 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(616);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 490 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(460);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 492 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(932);


/***/ }),
/* 494 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_inlineSvg__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_buttons_button__ = __webpack_require__(26);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var DetailedError = (_temp = _class = function (_React$Component) {
  _inherits(DetailedError, _React$Component);

  function DetailedError() {
    _classCallCheck(this, DetailedError);

    return _possibleConstructorReturn(this, (DetailedError.__proto__ || Object.getPrototypeOf(DetailedError)).apply(this, arguments));
  }

  _createClass(DetailedError, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // window.Raven.lastEventId() may not be immediatly true, so double-check after raven has time to send an error
      setTimeout(function () {
        _this2.forceUpdate();
      }, 100);
    }
  }, {
    key: 'openFeedback',
    value: function openFeedback(e) {
      e.preventDefault();
      if (window.Raven) {
        window.Raven.lastEventId() && window.Raven.showReportDialog();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          heading = _props.heading,
          message = _props.message,
          onRetry = _props.onRetry,
          hideSupportLinks = _props.hideSupportLinks;

      var cx = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('detailed-error', className);

      var showFooter = !!onRetry || !hideSupportLinks;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: cx },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'detailed-error-icon' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_inlineSvg__["a" /* default */], { src: 'icon-circle-exclamation' })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'detailed-error-content' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h4',
            null,
            heading
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            { className: 'detailed-error-content-body' },
            message
          ),
          showFooter && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'detailed-error-content-footer' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              onRetry && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { onClick: onRetry, className: 'btn btn-default' },
                Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Retry')
              )
            ),
            !hideSupportLinks && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'detailed-error-support-links' },
              window.Raven && window.Raven.lastEventId() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_app_components_buttons_button__["default"],
                { priority: 'link', onClick: this.openFeedback },
                Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Fill out a report')
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { href: 'https://status.sentry.io/' },
                Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Service status')
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { href: 'https://sentry.io/support/' },
                Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Contact support')
              )
            )
          )
        )
      );
    }
  }]);

  return DetailedError;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  /* Retry callback */
  onRetry: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  /* Error heading */
  heading: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  /* Detailed error explanation */
  message: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  /* Hide support links in footer of error message */
  hideSupportLinks: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _class.defaultProps = {
  hideSupportLinks: false
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (DetailedError);

/***/ }),
/* 496 */,
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['setLastRoute']));

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getRouteStringFromRoutes;
/**
 * Creates a route string from an array of `routes` from react-router
 * Note this is currently only used for error context logging. It does
 * not attempt to do anything smart (e.g. absolute vs relative paths in the list)
 *
 * @param {Array<{}>} routes An array of route objects from react-router
 * @return String Returns a route path
 */
function getRouteStringFromRoutes(routes) {
  if (!Array.isArray(routes)) return '';

  // Strip the first route (path: '/') since the subsequent children routes
  // are all absolute paths
  return routes.splice(1).filter(function (_ref) {
    var path = _ref.path;
    return path;
  }).map(function (_ref2) {
    var path = _ref2.path;
    return path;
  }).join('') || '';
}

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DateTimeField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_components_forms_inputField__ = __webpack_require__(86);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var DateTimeField = function (_InputField) {
  _inherits(DateTimeField, _InputField);

  function DateTimeField() {
    _classCallCheck(this, DateTimeField);

    return _possibleConstructorReturn(this, (DateTimeField.__proto__ || Object.getPrototypeOf(DateTimeField)).apply(this, arguments));
  }

  _createClass(DateTimeField, [{
    key: 'getType',
    value: function getType() {
      return 'datetime-local';
    }
  }]);

  return DateTimeField;
}(__WEBPACK_IMPORTED_MODULE_0_app_components_forms_inputField__["a" /* default */]);



/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NumberField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_forms_inputField__ = __webpack_require__(86);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var NumberField = (_temp = _class = function (_InputField) {
  _inherits(NumberField, _InputField);

  function NumberField() {
    _classCallCheck(this, NumberField);

    return _possibleConstructorReturn(this, (NumberField.__proto__ || Object.getPrototypeOf(NumberField)).apply(this, arguments));
  }

  _createClass(NumberField, [{
    key: 'coerceValue',
    value: function coerceValue(value, prevValue) {
      var intValue = parseInt(value, 10);

      // return previous value if new value is NaN, otherwise, will get recursive error
      var isNewCoercedNaN = isNaN(intValue);

      if (!isNewCoercedNaN) {
        return intValue;
      }

      return '';
    }
  }, {
    key: 'getType',
    value: function getType() {
      return 'number';
    }
  }, {
    key: 'getAttributes',
    value: function getAttributes() {
      return {
        min: this.props.min || undefined,
        max: this.props.max || undefined
      };
    }
  }]);

  return NumberField;
}(__WEBPACK_IMPORTED_MODULE_1_app_components_forms_inputField__["a" /* default */]), _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_1_app_components_forms_inputField__["a" /* default */].propTypes, {
  min: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
}), _temp);


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PasswordField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_forms_inputField__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_forms_state__ = __webpack_require__(167);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// TODO(dcramer): im not entirely sure this is working correctly with
// value propagation in all scenarios
var PasswordField = (_temp = _class = function (_InputField) {
  _inherits(PasswordField, _InputField);

  function PasswordField(props, context) {
    _classCallCheck(this, PasswordField);

    var _this = _possibleConstructorReturn(this, (PasswordField.__proto__ || Object.getPrototypeOf(PasswordField)).call(this, props, context));

    _this.cancelEdit = function (e) {
      e.preventDefault();
      _this.setState({
        editing: false
      }, function () {
        _this.setValue('');
      });
    };

    _this.startEdit = function (e) {
      e.preventDefault();
      _this.setState({
        editing: true
      });
    };

    _this.state.editing = false;
    return _this;
  }

  _createClass(PasswordField, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // close edit mode after successful save
      // TODO(dcramer): this needs to work with this.context.form
      if (this.props.formState && this.props.formState === __WEBPACK_IMPORTED_MODULE_3_app_components_forms_state__["a" /* default */].SAVING && nextProps.formState === __WEBPACK_IMPORTED_MODULE_3_app_components_forms_state__["a" /* default */].READY) {
        this.setState({
          editing: false
        });
      }
    }
  }, {
    key: 'getType',
    value: function getType() {
      return 'password';
    }
  }, {
    key: 'getField',
    value: function getField() {
      if (!this.props.hasSavedValue) {
        return _get(PasswordField.prototype.__proto__ || Object.getPrototypeOf(PasswordField.prototype), 'getField', this).call(this);
      }

      if (this.state.editing) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'form-password editing' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            _get(PasswordField.prototype.__proto__ || Object.getPrototypeOf(PasswordField.prototype), 'getField', this).call(this)
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { onClick: this.cancelEdit },
              'Cancel'
            )
          )
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'form-password saved' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            this.props.prefix + new Array(21 - this.props.prefix.length).join('*')
          ),
          !this.props.disabled && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            { onClick: this.startEdit },
            'Edit'
          )
        );
      }
    }
  }]);

  return PasswordField;
}(__WEBPACK_IMPORTED_MODULE_2_app_components_forms_inputField__["a" /* default */]), _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_2_app_components_forms_inputField__["a" /* default */].propTypes, {
  hasSavedValue: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  prefix: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}), _class.defaultProps = _extends({}, __WEBPACK_IMPORTED_MODULE_2_app_components_forms_inputField__["a" /* default */].defaultProps, {
  hasSavedValue: false,
  prefix: ''
}), _temp);


/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_forms_select2Field__ = __webpack_require__(170);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Select2FieldAutocomplete = function (_Select2Field) {
  _inherits(Select2FieldAutocomplete, _Select2Field);

  function Select2FieldAutocomplete() {
    _classCallCheck(this, Select2FieldAutocomplete);

    return _possibleConstructorReturn(this, (Select2FieldAutocomplete.__proto__ || Object.getPrototypeOf(Select2FieldAutocomplete)).apply(this, arguments));
  }

  _createClass(Select2FieldAutocomplete, [{
    key: 'getField',
    value: function getField() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
        id: this.getId(),
        className: 'form-control',
        ref: 'input',
        type: 'text',
        placeholder: this.props.placeholder,
        onChange: this.onChange.bind(this),
        disabled: this.props.disabled,
        required: this.props.required,
        value: this.state.value
      });
    }
  }, {
    key: 'getSelect2Options',
    value: function getSelect2Options() {
      return Object.assign(_get(Select2FieldAutocomplete.prototype.__proto__ || Object.getPrototypeOf(Select2FieldAutocomplete.prototype), 'getSelect2Options', this).call(this), {
        placeholder: this.props.placeholder || 'Start typing to search for an issue',
        minimumInputLength: this.props.minimumInputLength,
        ajax: {
          url: this.props.url,
          dataType: 'json',
          data: this.props.onQuery.bind(this),
          cache: true,
          results: this.props.onResults.bind(this),
          delay: this.props.ajaxDelay
        },
        id: this.props.id,
        formatResult: this.props.formatResult ? this.props.formatResult.bind(this) : undefined,
        formatSelection: this.props.formatSelection ? this.props.formatSelection.bind(this) : undefined,
        formatAjaxError: function formatAjaxError(error) {
          var resp = error.responseJSON;
          if (resp && resp.error_type === 'validation') {
            var message = resp.errors[0] && resp.errors[0].__all__;
            if (message) {
              return message;
            }
          }
          return 'Loading failed';
        }
      });
    }
  }]);

  return Select2FieldAutocomplete;
}(__WEBPACK_IMPORTED_MODULE_2_app_components_forms_select2Field__["default"]);

Select2FieldAutocomplete.defaultProps = Object.assign({
  onResults: function onResults(data, page) {
    return { results: data[this.props.name] };
  },
  onQuery: function onQuery(query, page) {
    return { autocomplete_query: query, autocomplete_field: this.props.name };
  },
  minimumInputLength: null,
  ajaxDelay: 250
}, __WEBPACK_IMPORTED_MODULE_2_app_components_forms_select2Field__["default"].defaultProps);

Select2FieldAutocomplete.propTypes = Object.assign({}, __WEBPACK_IMPORTED_MODULE_2_app_components_forms_select2Field__["default"].propTypes, {
  ajaxDelay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  minimumInputLength: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  formatResult: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  formatSelection: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onResults: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onQuery: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  url: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any
});

delete Select2FieldAutocomplete.propTypes.choices;

/* harmony default export */ __webpack_exports__["a"] = (Select2FieldAutocomplete);

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Select2TextField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_forms_select2Field__ = __webpack_require__(170);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Select2TextField = function (_Select2Field) {
  _inherits(Select2TextField, _Select2Field);

  function Select2TextField() {
    _classCallCheck(this, Select2TextField);

    return _possibleConstructorReturn(this, (Select2TextField.__proto__ || Object.getPrototypeOf(Select2TextField)).apply(this, arguments));
  }

  _createClass(Select2TextField, [{
    key: 'getField',
    value: function getField() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
        id: this.getId(),
        className: 'form-control',
        ref: 'input',
        placeholder: this.props.placeholder,
        onChange: this.onChange.bind(this),
        disabled: this.props.disabled,
        required: this.props.required,
        value: this.state.value
      });
    }
  }, {
    key: 'getSelect2Options',
    value: function getSelect2Options() {
      return _extends({}, _get(Select2TextField.prototype.__proto__ || Object.getPrototypeOf(Select2TextField.prototype), 'getSelect2Options', this).call(this), {
        data: (this.props.choices || []).map(function (choice) {
          if (Array.isArray(choice)) {
            return { id: choice[0], text: choice[1] };
          }
          return { id: choice, text: choice };
        }),
        createSearchChoice: function createSearchChoice(term, data) {
          if (!data.find(function (i) {
            return i.id !== term;
          })) {
            return { id: term, text: term };
          }
          return undefined;
        }
      });
    }
  }]);

  return Select2TextField;
}(__WEBPACK_IMPORTED_MODULE_1_app_components_forms_select2Field__["default"]);



/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RadioBooleanField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_forms_inputField__ = __webpack_require__(86);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var RadioBooleanField = (_temp2 = _class = function (_InputField) {
  _inherits(RadioBooleanField, _InputField);

  function RadioBooleanField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RadioBooleanField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadioBooleanField.__proto__ || Object.getPrototypeOf(RadioBooleanField)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
      var value = e.target.value === 'true';
      _this.setValue(value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RadioBooleanField, [{
    key: 'coerceValue',
    value: function coerceValue(props) {
      var value = _get(RadioBooleanField.prototype.__proto__ || Object.getPrototypeOf(RadioBooleanField.prototype), 'coerceValue', this).call(this, props);
      return value ? true : false;
    }
  }, {
    key: 'getType',
    value: function getType() {
      return 'radio';
    }
  }, {
    key: 'getField',
    value: function getField() {
      var yesOption = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'radio', key: 'yes' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'label',
          { style: { fontWeight: 'normal' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
            type: 'radio',
            value: 'true',
            name: this.props.name,
            checked: this.state.value === true,
            onChange: this.onChange.bind(this),
            disabled: this.props.disabled
          }),
          ' ',
          this.props.yesLabel
        )
      );
      var noOption = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'radio', key: 'no' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'label',
          { style: { fontWeight: 'normal' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
            type: 'radio',
            name: this.props.name,
            value: 'false',
            checked: this.state.value === false,
            onChange: this.onChange.bind(this),
            disabled: this.props.disabled
          }),
          ' ',
          this.props.noLabel
        )
      );
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'control-group radio-boolean' },
        this.props.yesFirst ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
          null,
          yesOption,
          noOption
        ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
          null,
          noOption,
          yesOption
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          hideErrorMessage = _props.hideErrorMessage,
          help = _props.help,
          style = _props.style;
      var error = this.state.error;

      var cx = this.getFinalClassNames();
      var shouldShowErrorMessage = error && !hideErrorMessage;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: style, className: cx },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'controls' },
          label && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'label',
            { htmlFor: this.getId(), className: 'control-label' },
            label
          ),
          Object(__WEBPACK_IMPORTED_MODULE_2_app_utils__["d" /* defined */])(help) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            { className: 'help-block' },
            help
          ),
          this.getField(),
          this.renderDisabledReason(),
          shouldShowErrorMessage && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            { className: 'error' },
            error
          )
        )
      );
    }
  }]);

  return RadioBooleanField;
}(__WEBPACK_IMPORTED_MODULE_3_app_components_forms_inputField__["a" /* default */]), _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_3_app_components_forms_inputField__["a" /* default */].propTypes, {
  yesLabel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  noLabel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  yesFirst: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}), _class.defaultProps = _extends({}, __WEBPACK_IMPORTED_MODULE_3_app_components_forms_inputField__["a" /* default */].defaultProps, {
  yesLabel: 'Yes',
  noLabel: 'No',
  yesFirst: true
}), _temp2);


/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keys__ = __webpack_require__(245);


var PRINTABLE_CHARACTERS = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ~!@#$%^&*()-_+=[]\\{}|;\':",./<>?£';

var modKeys = Object.keys(__WEBPACK_IMPORTED_MODULE_0__keys__["d" /* modifiers */]);

function matchKeys(_ref) {
  var keySet = _ref.keySet,
      event = _ref.event;
  var key = keySet.key,
      _keySet$modifiers = keySet.modifiers,
      modifiers = _keySet$modifiers === undefined ? [] : _keySet$modifiers;

  var keysMatch = void 0;

  keysMatch = key === __WEBPACK_IMPORTED_MODULE_0__keys__["a" /* ALL_KEYS */];

  if (key === __WEBPACK_IMPORTED_MODULE_0__keys__["b" /* ALL_PRINTABLE_KEYS */]) {
    if (event.key) {
      // Modern browsers implement `key`, so if `key` is length 1, we have a match. e.g. 'a' for the
      // a key, or '2' for the 2 key. All other non-printable characters have names, e.g. 'Enter' or 'Backspace'.
      keysMatch = event.key.length === 1;
    } else {
      // For browsers that do no support `event.key`, we test against a list of characters
      var pressedChar = String.fromCharCode(event.charCode);
      keysMatch = PRINTABLE_CHARACTERS.indexOf(pressedChar) >= 0;
    }
  }

  if (key === event.which) {
    var evtModKeys = modKeys.filter(function (modKey) {
      return event[modKey + 'Key'];
    }).sort();
    keysMatch = modifiers.length === evtModKeys.length && modifiers.every(function (modKey, index) {
      return evtModKeys[index] === modKey;
    });
  }

  return keysMatch;
}

/* harmony default export */ __webpack_exports__["a"] = (matchKeys);

/***/ }),
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keys__ = __webpack_require__(245);


function parseKeys(keysArray) {
  return keysArray.map(function (key) {
    var keySet = { key: key };
    if (typeof key === 'string') {
      var keyString = key.toLowerCase().trim();
      var matches = keyString.split(/\s?\+\s?/);
      keySet = matches.length === 1 ? { key: __WEBPACK_IMPORTED_MODULE_0__keys__["c" /* default */][keyString] } : {
        key: __WEBPACK_IMPORTED_MODULE_0__keys__["c" /* default */][matches.pop()],
        modifiers: matches.map(function (modKey) {
          return __WEBPACK_IMPORTED_MODULE_0__keys__["d" /* modifiers */][modKey];
        }).sort()
      };
    }
    return keySet;
  });
}

/* harmony default export */ __webpack_exports__["a"] = (parseKeys);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _onClick */
/* harmony export (immutable) */ __webpack_exports__["a"] = _onKeyDown;
/* unused harmony export _shouldConsider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return onMount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return onUnmount; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_dom_helpers__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_listeners__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(244);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* eslint-disable no-use-before-define */
/**
 * @module eventHandlers
 *
 */




/**
 * private
 *
 */

/**
 * _onClick
 *
 * @access private
 * @param {object} event The click event object
 * @param {object} event.target The DOM node from the click event
 */
function _onClick(_ref) {
  var target = _ref.target;

  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* activate */]([].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__store__["e" /* getInstances */]())).reduce(__WEBPACK_IMPORTED_MODULE_0__lib_dom_helpers__["a" /* default */].findContainerNodes(target), []).sort(__WEBPACK_IMPORTED_MODULE_0__lib_dom_helpers__["a" /* default */].sortByDOMPosition).map(function (item) {
    return item.instance;
  }));
}

/**
 * _onKeyDown: The keydown event callback
 *
 * @access private
 * @param {object} event The keydown event object
 * @param {number} event.which The key code (which) received from the keydown event
 */
function _onKeyDown(event) {
  var forceConsider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (forceConsider || _shouldConsider(event)) {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_2__store__["c" /* findBindingForEvent */](event) || {},
        fn = _ref2.fn,
        instance = _ref2.instance;

    if (fn) {
      fn.call(instance, event);
      return true;
    }
  }
  return false;
}

/**
 * _shouldConsider: Conditions for proceeding with key event handling
 *
 * @access private
 * @param {object} event The keydown event object
 * @param {object} event.target The node origin of the event
 * @return {boolean} Whether to continue procesing the keydown event
 */
function _shouldConsider(_ref3) {
  var ctrlKey = _ref3.ctrlKey,
      target = _ref3.target;

  return ctrlKey || !~['INPUT', 'SELECT', 'TEXTAREA'].indexOf(target.tagName) && (!target.getAttribute || target.getAttribute('role') !== 'textbox');
}

/**
 * public
 *
 */

/**
 * onMount
 *
 * @access public
 */
function onMount(instance) {
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* activate */](instance);
  __WEBPACK_IMPORTED_MODULE_1__lib_listeners__["a" /* default */].bindKeys(_onKeyDown);
  __WEBPACK_IMPORTED_MODULE_1__lib_listeners__["a" /* default */].bindClicks(_onClick);
  __WEBPACK_IMPORTED_MODULE_0__lib_dom_helpers__["a" /* default */].bindFocusables(instance, __WEBPACK_IMPORTED_MODULE_2__store__["a" /* activate */]);
}

/**
 * onUnmount
 *
 * @access public
 */
function onUnmount(instance) {
  __WEBPACK_IMPORTED_MODULE_2__store__["b" /* deleteInstance */](instance);
  if (__WEBPACK_IMPORTED_MODULE_2__store__["f" /* isEmpty */]()) {
    __WEBPACK_IMPORTED_MODULE_1__lib_listeners__["a" /* default */].unbindClicks(_onClick);
    __WEBPACK_IMPORTED_MODULE_1__lib_listeners__["a" /* default */].unbindKeys(_onKeyDown);
  }
}



/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_emotion_theming__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_stores_alertStore__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_alertMessage__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_utils_theme__ = __webpack_require__(126);










var Alerts = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Alerts',
  mixins: [__WEBPACK_IMPORTED_MODULE_2_reflux___default.a.connect(__WEBPACK_IMPORTED_MODULE_4_app_stores_alertStore__["a" /* default */], 'alerts')],

  getInitialState: function getInitialState() {
    return {
      alerts: []
    };
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_emotion_theming__["ThemeProvider"],
      { theme: __WEBPACK_IMPORTED_MODULE_6_app_utils_theme__["default"] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        this.props,
        this.state.alerts.map(function (alert) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_alertMessage__["a" /* default */], { alert: alert, key: alert.key, system: true });
        })
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["default"] = (Alerts);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);


var GuideActions = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['closeGuideOrSupport', 'fetchSucceeded', 'nextStep', 'registerAnchor', 'unregisterAnchor']);

/* harmony default export */ __webpack_exports__["a"] = (GuideActions);

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_actions_guideActions__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_actions_organizationsActions__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_utils_analytics__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_actions_projectActions__ = __webpack_require__(116);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }








var GuideStore = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({
  init: function init() {
    this.state = {
      // All guides returned to us from the server.
      guides: {},
      // All anchors that have been registered on this current view.
      anchors: new Set(),
      // The "on deck" guide.
      currentGuide: null,
      // The current step of the current guide (1-indexed). 0 if there's no guide
      // or the guide is just cued but not opened.
      currentStep: 0,

      currentOrg: null,

      currentProject: null,

      forceShow: false,
      prevGuide: null
    };
    this.listenTo(__WEBPACK_IMPORTED_MODULE_2_app_actions_guideActions__["a" /* default */].fetchSucceeded, this.onFetchSucceeded);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_2_app_actions_guideActions__["a" /* default */].closeGuideOrSupport, this.onCloseGuideOrSupport);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_2_app_actions_guideActions__["a" /* default */].nextStep, this.onNextStep);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_2_app_actions_guideActions__["a" /* default */].registerAnchor, this.onRegisterAnchor);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_2_app_actions_guideActions__["a" /* default */].unregisterAnchor, this.onUnregisterAnchor);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_3_app_actions_organizationsActions__["a" /* default */].setActive, this.onSetActiveOrganization);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_5_app_actions_projectActions__["a" /* default */].setActive, this.onSetActiveProject);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_3_app_actions_organizationsActions__["a" /* default */].changeSlug, this.onChangeSlug);

    window.addEventListener('hashchange', this.onHashChange, false);
  },
  onHashChange: function onHashChange() {
    this.state.forceShow = window.location.hash === '#assistant';
    this.updateCurrentGuide();
  },
  onSetActiveOrganization: function onSetActiveOrganization(data) {
    this.state.currentOrg = data;
    this.trigger(this.state);
  },
  onSetActiveProject: function onSetActiveProject(data) {
    this.state.currentProject = data;
    this.trigger(this.state);
  },
  onChangeSlug: function onChangeSlug(prev, next) {
    this.state.currentOrg = next;
  },
  onFetchSucceeded: function onFetchSucceeded(data) {
    this.state.guides = data;
    this.updateCurrentGuide();
  },


  // This handles both closing a guide and the support drawer.
  onCloseGuideOrSupport: function onCloseGuideOrSupport() {
    var _this = this;

    var currentGuide = this.state.currentGuide;

    if (currentGuide) {
      this.state.guides[Object.keys(this.state.guides).find(function (key) {
        return _this.state.guides[key].id == currentGuide.id;
      })].seen = true;
    }
    this.updateCurrentGuide();
  },
  onNextStep: function onNextStep() {
    this.state.currentStep += 1;
    this.trigger(this.state);
    if (this.state.currentGuide && this.state.currentStep == 1) {
      Object(__WEBPACK_IMPORTED_MODULE_4_app_utils_analytics__["a" /* default */])('assistant.guide_opened', {
        guide: this.state.currentGuide.id
      });
    }
  },
  onRegisterAnchor: function onRegisterAnchor(anchor) {
    this.state.anchors.add(anchor);
    this.updateCurrentGuide();
  },
  onUnregisterAnchor: function onUnregisterAnchor(anchor) {
    this.state.anchors.delete(anchor);
    this.updateCurrentGuide();
  },
  recordCue: function recordCue(id, cue) {
    Object(__WEBPACK_IMPORTED_MODULE_4_app_utils_analytics__["a" /* default */])('assistant.guide_cued', {
      guide: id,
      cue: cue
    });
  },
  updatePrevGuide: function updatePrevGuide(bestGuide) {
    if (!bestGuide) return;

    if (!this.state.prevGuide || this.state.prevGuide.id !== bestGuide.id) {
      this.recordCue(bestGuide.id, bestGuide.cue);
      this.state.prevGuide = bestGuide;
    }
  },
  updateCurrentGuide: function updateCurrentGuide() {
    var _this2 = this;

    var availableTargets = [].concat(_toConsumableArray(this.state.anchors)).map(function (a) {
      return a.props.target;
    });

    // Select the first guide that hasn't been seen in this session and has all
    // required anchors on the page.
    // If url hash is #assistant, show the first guide regardless of seen and has
    // all required anchors.
    var bestGuideKey = Object.keys(this.state.guides).find(function (key) {
      var guide = _this2.state.guides[key];
      var allTargetsPresent = guide.required_targets.every(function (t) {
        return availableTargets.indexOf(t) >= 0;
      });
      return (_this2.state.forceShow || !guide.seen) && allTargetsPresent;
    });

    var bestGuide = null;
    if (bestGuideKey) {
      bestGuide = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.extend(true, {}, this.state.guides[bestGuideKey]);
      // Remove steps that don't have an anchor on the page.
      bestGuide.steps = bestGuide.steps.filter(function (step) {
        return step.target === null || step.target && availableTargets.indexOf(step.target) >= 0;
      });
    }
    this.updatePrevGuide(bestGuide);
    this.state.currentGuide = bestGuide;

    this.state.currentStep = this.state.forceShow ? 1 : 0;

    this.trigger(this.state);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (GuideStore);

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_Modal__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_actionCreators_modal__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_confirm__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_stores_modalStore__ = __webpack_require__(988);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var GlobalModal = (_temp2 = _class = function (_React$Component) {
  _inherits(GlobalModal, _React$Component);

  function GlobalModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GlobalModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GlobalModal.__proto__ || Object.getPrototypeOf(GlobalModal)).call.apply(_ref, [this].concat(args))), _this), _this.handleCloseModal = function () {
      var options = _this.props.options;


      if (typeof options.onClose === 'function') {
        options.onClose();
      }

      // Action creator
      Object(__WEBPACK_IMPORTED_MODULE_6_app_actionCreators_modal__["a" /* closeModal */])();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GlobalModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          visible = _props.visible,
          children = _props.children,
          options = _props.options;

      var Component = __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_Modal___default.a;

      if (options && options.type === 'confirm') {
        Component = __WEBPACK_IMPORTED_MODULE_7_app_components_confirm__["a" /* default */];
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        Component,
        {
          className: options && options.modalClassName,
          show: visible,
          animation: false,
          onHide: this.handleCloseModal
        },
        children ? children({
          closeModal: __WEBPACK_IMPORTED_MODULE_6_app_actionCreators_modal__["a" /* closeModal */],
          Header: __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_Modal___default.a.Header,
          Body: __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_Modal___default.a.Body,
          Footer: __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_Modal___default.a.Footer
        }) : null
      );
    }
  }]);

  return GlobalModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component), _class.propTypes = {
  /**
   * Needs to be a function that returns a React Element
   * Function is injected with:
   * Modal `Header`, `Body`, and `Footer,
   * `closeModal`
   *
   */
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    modalClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  }),
  visible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
}, _class.defaultProps = {
  visible: false,
  options: {}
}, _temp2);


var GlobalModalContainer = __WEBPACK_IMPORTED_MODULE_5_create_react_class___default()({
  displayName: 'GlobalModalContainer',
  mixins: [__WEBPACK_IMPORTED_MODULE_4_reflux___default.a.connect(__WEBPACK_IMPORTED_MODULE_8_app_stores_modalStore__["a" /* default */], 'modalStore')],

  getInitialState: function getInitialState() {
    return {
      modalStore: {},
      error: false,
      busy: false
    };
  },
  componentDidMount: function componentDidMount() {
    // Listen for route changes so we can dismiss modal
    this.unlisten = __WEBPACK_IMPORTED_MODULE_1_react_router__["browserHistory"].listen(function () {
      return Object(__WEBPACK_IMPORTED_MODULE_6_app_actionCreators_modal__["a" /* closeModal */])();
    });
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
    }
  },
  render: function render() {
    var modalStore = this.state.modalStore;

    var visible = !!modalStore && typeof modalStore.renderer === 'function';

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      GlobalModal,
      _extends({}, this.props, modalStore, { visible: visible }),
      visible ? modalStore.renderer : null
    );
  }
});
/* harmony default export */ __webpack_exports__["default"] = (GlobalModalContainer);

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Indicators", function() { return Indicators; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_emotion_theming__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_emotion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_alerts_toastIndicator__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_stores_indicatorStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_utils_theme__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_actionCreators_indicator__ = __webpack_require__(80);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var Toasts = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])('div', {
  target: 'e1iqtmub0'
})('position:fixed;right:30px;bottom:30px;z-index:', function (p) {
  return p.theme.zIndex.toast;
}, ';');

var Indicators = (_temp2 = _class = function (_React$Component) {
  _inherits(Indicators, _React$Component);

  function Indicators() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Indicators);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Indicators.__proto__ || Object.getPrototypeOf(Indicators)).call.apply(_ref, [this].concat(args))), _this), _this.handleDismiss = function (indicator) {
      Object(__WEBPACK_IMPORTED_MODULE_11_app_actionCreators_indicator__["e" /* removeIndicator */])(indicator);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Indicators, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          className = _props.className,
          props = _objectWithoutProperties(_props, ['items', 'className']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Toasts,
        _extends({}, props, { className: Object(__WEBPACK_IMPORTED_MODULE_7_emotion__["cx"])(className, 'ref-toasts') }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default.a,
          {
            transitionName: 'toast',
            transitionEnterTimeout: 400,
            transitionLeaveTimeout: 400
          },
          items.map(function (indicator, i) {
            // We purposefully use `i` as key here because of transitions
            // Toasts can now queue up, so when we change from [firstToast] -> [secondToast],
            // we don't want to  animate `firstToast` out and `secondToast` in, rather we want
            // to replace `firstToast` with `secondToast`
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_alerts_toastIndicator__["a" /* default */], {
              onDismiss: _this2.handleDismiss,
              indicator: indicator,
              key: i
            });
          })
        )
      );
    }
  }]);

  return Indicators;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['error', 'success', 'loading', 'undo', '']),
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
    message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
    options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }))
}, _class.defaultProps = {
  items: []
}, _temp2);


var IndicatorsContainer = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'IndicatorsContainer',
  mixins: [__WEBPACK_IMPORTED_MODULE_3_reflux___default.a.connect(__WEBPACK_IMPORTED_MODULE_9_app_stores_indicatorStore__["default"], 'items')],

  getInitialState: function getInitialState() {
    return {
      items: []
    };
  },
  render: function render() {
    // #NEW-SETTINGS - remove ThemeProvider here once new settings is merged
    // `alerts.html` django view includes this container and doesn't have a theme provider
    // not even sure it is used in django views but this is just an easier temp solution
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_emotion_theming__["ThemeProvider"],
      { theme: __WEBPACK_IMPORTED_MODULE_10_app_utils_theme__["default"] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Indicators, _extends({}, this.props, { items: this.state.items }))
    );
  }
});

/* harmony default export */ __webpack_exports__["default"] = (IndicatorsContainer);


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(250);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_views_onboarding_utils__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_actionCreators_modal__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_views_onboarding_project__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_mixins_organizationState__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_panels_panelAlert__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_actions_projectActions__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_actions_teamActions__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_styles_space__ = __webpack_require__(38);




















var CreateProject = __WEBPACK_IMPORTED_MODULE_4_create_react_class___default()({
  displayName: 'CreateProject',

  propTypes: {
    getDocsUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
  },

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_10_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_13_app_mixins_organizationState__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_16_app_actions_teamActions__["a" /* default */].createTeamSuccess, 'onTeamCreated')],

  getDefaultProps: function getDefaultProps() {
    return {
      getDocsUrl: function getDocsUrl(_ref) {
        var slug = _ref.slug,
            projectSlug = _ref.projectSlug,
            platform = _ref.platform;
        return '/onboarding/' + slug + '/' + projectSlug + '/configure/' + platform;
      }
    };
  },
  getInitialState: function getInitialState() {
    var _getOrganization = this.getOrganization(),
        teams = _getOrganization.teams;

    var accessTeams = teams.filter(function (team) {
      return team.hasAccess;
    });
    var query = this.context.location.query;


    var team = query.team || accessTeams.length && accessTeams[0].slug;
    var platform = Object(__WEBPACK_IMPORTED_MODULE_7_app_views_onboarding_utils__["c" /* getPlatformName */])(query.platform) ? query.platform : '';

    return {
      loading: true,
      error: false,
      projectName: Object(__WEBPACK_IMPORTED_MODULE_7_app_views_onboarding_utils__["c" /* getPlatformName */])(platform) || '',
      team: team,
      platform: platform,
      inFlight: false
    };
  },
  onTeamCreated: function onTeamCreated() {
    var router = this.context.router;

    // After team gets created we need to force OrganizationContext to basically remount

    router.replace({
      pathname: router.location.pathname,
      state: 'refresh'
    });
  },
  createProject: function createProject() {
    var _this = this;

    var router = this.context.router;

    var _getOrganization2 = this.getOrganization(),
        slug = _getOrganization2.slug;

    var _state = this.state,
        projectName = _state.projectName,
        platform = _state.platform,
        team = _state.team,
        inFlight = _state.inFlight;

    //prevent double-trigger

    if (inFlight) return;
    this.setState({ inFlight: true });

    if (!projectName) {
      __WEBPACK_IMPORTED_MODULE_1_raven_js___default.a.captureMessage('Onboarding no project name ', {
        extra: { props: this.props, state: this.state }
      });
    }

    this.api.request('/teams/' + slug + '/' + team + '/projects/', {
      method: 'POST',
      data: {
        name: projectName,
        platform: platform
      },
      success: function success(data) {
        __WEBPACK_IMPORTED_MODULE_15_app_actions_projectActions__["a" /* default */].createSuccess(data);

        // navigate to new url _now_
        var url = _this.props.getDocsUrl({ slug: slug, projectSlug: data.slug, platform: platform });
        _this.setState({ inFlight: false });
        router.push(url);
      },
      error: function error(err) {
        _this.setState({
          inFlight: false,
          error: err.responseJSON.detail
        });

        // Only log this if the error is something other than:
        // * The user not having access to create a project, or,
        // * A project with that slug already exists
        if (err.status !== 403 && err.status !== 409) {
          __WEBPACK_IMPORTED_MODULE_1_raven_js___default.a.captureMessage('Onboarding project creation failed', {
            extra: {
              err: err,
              props: _this.props,
              state: _this.state
            }
          });
        }
      }
    });
  },
  render: function render() {
    var _this2 = this;

    var _state2 = this.state,
        projectName = _state2.projectName,
        platform = _state2.platform,
        error = _state2.error;

    var organization = this.getOrganization();
    var teams = organization.teams;

    var accessTeams = teams.filter(function (team) {
      return team.hasAccess;
    });

    var stepProps = {
      next: this.createProject,
      platform: platform,
      setPlatform: function setPlatform(p) {
        if (!projectName || platform && Object(__WEBPACK_IMPORTED_MODULE_7_app_views_onboarding_utils__["c" /* getPlatformName */])(platform) === projectName) {
          _this2.setState({ projectName: Object(__WEBPACK_IMPORTED_MODULE_7_app_views_onboarding_utils__["c" /* getPlatformName */])(p) });
        }
        _this2.setState({ platform: p });
      },
      name: projectName,
      setName: function setName(n) {
        return _this2.setState({ projectName: n });
      },
      team: this.state.team,
      teams: accessTeams,
      setTeam: function setTeam(teamSlug) {
        return _this2.setState({ team: teamSlug });
      }
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      null,
      error && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'h2',
        { className: 'alert alert-error' },
        error
      ),
      accessTeams.length ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_views_onboarding_project__["a" /* default */], stepProps) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_panels__["a" /* Panel */], {
        title: Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Cannot Create Project'),
        body: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_app_components_panels_panelAlert__["a" /* default */],
            { type: 'error' },
            Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('You cannot create a new project because there are no teams to assign it to.')
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            CreateTeamBody,
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_app_components_buttons_button__["default"],
              {
                className: 'ref-create-team',
                priority: 'primary',
                onClick: function onClick() {
                  return Object(__WEBPACK_IMPORTED_MODULE_8_app_actionCreators_modal__["d" /* openCreateTeamModal */])({
                    organization: organization
                  });
                }
              },
              Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Create a Team')
            )
          )
        )
      })
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (CreateProject);

var CreateTeamBody = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])('div', {
  target: 'eovdm170'
})('display:flex;justify-content:center;padding:', Object(__WEBPACK_IMPORTED_MODULE_17_app_styles_space__["a" /* default */])(2), ';');

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_panels_panelBody__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_panels_panelHeader__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_styles_space__ = __webpack_require__(38);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var StyledPanel = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'e1laxa7d0'
})('background:#fff;border-radius:', function (p) {
  return p.theme.borderRadius;
}, ';border:1px solid ', function (p) {
  return p.theme.borderDark;
}, ';box-shadow:', function (p) {
  return p.theme.dropShadowLight;
}, ';margin-bottom:', Object(__WEBPACK_IMPORTED_MODULE_5_app_styles_space__["a" /* default */])(3), ';position:relative;');

var Panel = (_temp = _class = function (_React$Component) {
  _inherits(Panel, _React$Component);

  function Panel() {
    _classCallCheck(this, Panel);

    return _possibleConstructorReturn(this, (Panel.__proto__ || Object.getPrototypeOf(Panel)).apply(this, arguments));
  }

  _createClass(Panel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          body = _props.body;

      var hasHeaderAndBody = !!title && !!body;

      if (hasHeaderAndBody) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          StyledPanel,
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_app_components_panels_panelHeader__["default"],
            null,
            title
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_app_components_panels_panelBody__["default"],
            null,
            body
          )
        );
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledPanel, this.props);
    }
  }]);

  return Panel;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  /**
   * When `title` and `body` are defined, use as children to `<PanelHeader>` and `<PanelBody>` respectively
   */
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  body: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node
}, _temp);


/* harmony default export */ __webpack_exports__["default"] = (Panel);

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var StyledPanelItem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Flex"], {
  target: 'eo8n7lk0'
})('border-bottom:1px solid ', function (p) {
  return p.theme.borderLight;
}, ';&:last-child{border:0;}');

var PanelItem = (_temp = _class = function (_React$Component) {
  _inherits(PanelItem, _React$Component);

  function PanelItem() {
    _classCallCheck(this, PanelItem);

    return _possibleConstructorReturn(this, (PanelItem.__proto__ || Object.getPrototypeOf(PanelItem)).apply(this, arguments));
  }

  _createClass(PanelItem, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StyledPanelItem, this.props);
    }
  }]);

  return PanelItem;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  p: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}, _class.defaultProps = {
  p: 2
}, _temp);


/* harmony default export */ __webpack_exports__["default"] = (PanelItem);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_utils_analytics__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_listLink__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_views_onboarding_utils__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_views_onboarding_project_platformCard__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_locale__ = __webpack_require__(2);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var allCategories = __WEBPACK_IMPORTED_MODULE_6_app_views_onboarding_utils__["a" /* categoryList */].concat({ id: 'all', name: Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('All') });

var PlatformPicker = (_temp = _class = function (_React$Component) {
  _inherits(PlatformPicker, _React$Component);

  function PlatformPicker() {
    var _ref;

    _classCallCheck(this, PlatformPicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = PlatformPicker.__proto__ || Object.getPrototypeOf(PlatformPicker)).call.apply(_ref, [this].concat(args)));

    _this.logSearch = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function () {
      if (_this.state.filter) {
        Object(__WEBPACK_IMPORTED_MODULE_4_app_utils_analytics__["a" /* default */])('platformpicker.search', {
          query: _this.state.filter.toLowerCase(),
          num_results: _this.getPlatformList().length
        });
      }
    }, 300);

    _this.getPlatformList = function () {
      var subsetMatch = function subsetMatch(_ref2) {
        var id = _ref2.id;
        return id.includes(_this.state.filter.toLowerCase());
      };
      var filtered = void 0;

      if (_this.state.filter) {
        filtered = __WEBPACK_IMPORTED_MODULE_6_app_views_onboarding_utils__["b" /* flattenedPlatforms */].filter(subsetMatch);
      } else {
        var tab = _this.state.tab;

        var currentCategory = __WEBPACK_IMPORTED_MODULE_6_app_views_onboarding_utils__["a" /* categoryList */].find(function (_ref3) {
          var id = _ref3.id;
          return id === tab;
        });
        var tabSubset = __WEBPACK_IMPORTED_MODULE_6_app_views_onboarding_utils__["b" /* flattenedPlatforms */].filter(function (platform) {
          return tab === 'all' || currentCategory.platforms.includes(platform.id);
        });
        filtered = tabSubset.filter(subsetMatch);
      }

      if (!_this.props.showOther) {
        filtered = filtered.filter(function (_ref4) {
          var id = _ref4.id;
          return id !== 'other';
        });
      }

      return filtered;
    };

    _this.state = {
      tab: allCategories[0].id,
      filter: (_this.props.platform || '').split('-')[0]
    };
    return _this;
  }

  _createClass(PlatformPicker, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var filter = this.state.filter;

      var filtered = this.getPlatformList();
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'platform-picker' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'ul',
          { className: 'nav nav-tabs' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'li',
            { style: { float: 'right', marginRight: 0 } },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'platform-filter-container' },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon icon-search' }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', {
                type: 'text',
                value: this.state.filter,
                className: 'platform-filter',
                label: Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('Filter'),
                placeholder: 'Filter',
                onChange: function onChange(e) {
                  return _this2.setState({ filter: e.target.value }, _this2.logSearch);
                }
              })
            )
          ),
          allCategories.map(function (_ref5) {
            var id = _ref5.id,
                name = _ref5.name;

            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_app_components_listLink__["default"],
              {
                key: id,
                onClick: function onClick(e) {
                  Object(__WEBPACK_IMPORTED_MODULE_4_app_utils_analytics__["a" /* default */])('platformpicker.select_tab', { tab: id });
                  _this2.setState({ tab: id, filter: '' });
                  e.preventDefault();
                },
                to: '',
                isActive: function isActive() {
                  return id === (filter ? 'all' : _this2.state.tab);
                }
              },
              name
            );
          })
        ),
        filtered.length ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'ul',
          { className: 'client-platform-list platform-tiles' },
          filtered.map(function (platform, idx) {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_views_onboarding_project_platformCard__["a" /* default */], {
              platform: platform.id,
              className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({
                selected: _this2.props.platform === platform.id
              }),
              key: platform.id,
              onClick: function onClick(e) {
                Object(__WEBPACK_IMPORTED_MODULE_4_app_utils_analytics__["a" /* default */])('platformpicker.select_platform', { platform: platform.id });
                _this2.props.setPlatform(platform.id);
                e.preventDefault();
              }
            });
          })
        ) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'p',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])("Not finding your platform? There's a rich ecosystem of community supported SDKs as well (including Perl, CFML, Clojure, and ActionScript).\n Try searching for Sentry clients or contacting support.")
        )
      );
    }
  }]);

  return PlatformPicker;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  setPlatform: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  platform: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  showOther: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class.defaultProps = { showOther: true }, _temp);


/* harmony default export */ __webpack_exports__["a"] = (PlatformPicker);

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var PlatformiconTile = (_temp = _class = function (_React$Component) {
  _inherits(PlatformiconTile, _React$Component);

  function PlatformiconTile() {
    _classCallCheck(this, PlatformiconTile);

    return _possibleConstructorReturn(this, (PlatformiconTile.__proto__ || Object.getPrototypeOf(PlatformiconTile)).apply(this, arguments));
  }

  _createClass(PlatformiconTile, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          platform = _props.platform,
          className = _props.className;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'li',
        {
          className: 'platform-tile list-unstyled ' + platform + ' ' + platform.split('-')[0] + ' ' + className
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'platformicon platformicon-' + platform })
      );
    }
  }]);

  return PlatformiconTile;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  platform: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (PlatformiconTile);

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_actionCreators_group__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_actorAvatar__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_avatar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_stores_configStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_dropdownLink__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_flowLayout__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_stores_groupStore__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_components_inlineSvg__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_stores_memberListStore__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_components_menuItem__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_stores_projectsStore__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_app_components_textOverflow__ = __webpack_require__(124);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

























var AssigneeSelector = __WEBPACK_IMPORTED_MODULE_4_create_react_class___default()({
  displayName: 'AssigneeSelector',

  propTypes: {
    id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    size: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
  },

  contextTypes: {
    organization: __WEBPACK_IMPORTED_MODULE_20_app_proptypes__["e" /* default */].Organization
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_14_app_stores_groupStore__["a" /* default */], 'onGroupChange'), __WEBPACK_IMPORTED_MODULE_2_reflux___default.a.connect(__WEBPACK_IMPORTED_MODULE_17_app_stores_memberListStore__["a" /* default */], 'memberList')],

  statics: {
    filterAssignees: function filterAssignees(itemList, filter) {
      if (!itemList) return [];
      if (!filter) return itemList;

      filter = filter.toLowerCase();

      return itemList.filter(function (item) {
        var fullName = [item.name, item.email, item.slug].join(' ').toLowerCase();

        return fullName.indexOf(filter) !== -1;
      });
    },
    putSessionUserFirst: function putSessionUserFirst(members) {
      // If session user is in the filtered list of members, put them at the top
      var sessionUser = __WEBPACK_IMPORTED_MODULE_11_app_stores_configStore__["default"].get('user');
      var sessionUserIndex = members.findIndex(function (member) {
        return sessionUser && member.id === sessionUser.id;
      });

      if (sessionUserIndex === -1) return members;

      return [members[sessionUserIndex]].concat(members.slice(0, sessionUserIndex)).concat(members.slice(sessionUserIndex + 1));
    }
  },

  getDefaultProps: function getDefaultProps() {
    return {
      size: 20
    };
  },
  getInitialState: function getInitialState() {
    var group = __WEBPACK_IMPORTED_MODULE_14_app_stores_groupStore__["a" /* default */].get(this.props.id);
    return {
      assignedTo: group && group.assignedTo,
      memberList: __WEBPACK_IMPORTED_MODULE_17_app_stores_memberListStore__["a" /* default */].loaded ? __WEBPACK_IMPORTED_MODULE_17_app_stores_memberListStore__["a" /* default */].getAll() : null,
      filter: '',
      isOpen: false,
      loading: false
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var loading = __WEBPACK_IMPORTED_MODULE_14_app_stores_groupStore__["a" /* default */].hasStatus(nextProps.id, 'assignTo');
    if (nextProps.id != this.props.id || loading != this.state.loading) {
      var group = __WEBPACK_IMPORTED_MODULE_14_app_stores_groupStore__["a" /* default */].get(this.props.id);
      this.setState({
        loading: loading,
        assignedTo: group && group.assignedTo
      });
    }
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    if (nextState.isOpen !== this.state.isOpen || nextState.filter !== this.state.filter || nextState.loading !== this.state.loading) {
      return true;
    }

    // XXX(billyvg): this means that once `memberList` is not-null, this component will never update due to `memberList` changes
    // Note: this allows us to show a "loading" state for memberList, but only before `MemberListStore.loadInitialData`
    // is called
    if (this.state.memberList === null && nextState.memberList !== this.state.memberList) {
      return true;
    }
    return !Object(__WEBPACK_IMPORTED_MODULE_8_app_utils__["u" /* valueIsEqual */])(nextState.assignedTo, this.state.assignedTo, true);
  },
  assignableTeams: function assignableTeams() {
    var group = __WEBPACK_IMPORTED_MODULE_14_app_stores_groupStore__["a" /* default */].get(this.props.id);

    return AssigneeSelector.filterAssignees((__WEBPACK_IMPORTED_MODULE_19_app_stores_projectsStore__["a" /* default */].getBySlug(group.project.slug) || {
      teams: []
    }).teams.sort(function (a, b) {
      return a.slug.localeCompare(b.slug);
    }), this.state.filter).map(function (team) {
      return {
        id: Object(__WEBPACK_IMPORTED_MODULE_8_app_utils__["a" /* buildTeamId */])(team.id),
        display: '#' + team.slug,
        email: team.id,
        team: team
      };
    });
  },
  onGroupChange: function onGroupChange(itemIds) {
    if (!itemIds.has(this.props.id)) {
      return;
    }
    var group = __WEBPACK_IMPORTED_MODULE_14_app_stores_groupStore__["a" /* default */].get(this.props.id);
    this.setState({
      assignedTo: group && group.assignedTo,
      loading: __WEBPACK_IMPORTED_MODULE_14_app_stores_groupStore__["a" /* default */].hasStatus(this.props.id, 'assignTo')
    });
  },
  assignToUser: function assignToUser(user) {
    Object(__WEBPACK_IMPORTED_MODULE_6_app_actionCreators_group__["b" /* assignToUser */])({ id: this.props.id, user: user });
    this.setState({ filter: '', loading: true });
  },
  assignToTeam: function assignToTeam(team) {
    Object(__WEBPACK_IMPORTED_MODULE_6_app_actionCreators_group__["a" /* assignToActor */])({ actor: { id: team.id, type: 'team' }, id: this.props.id });
    this.setState({ filter: '', loading: true });
  },
  clearAssignTo: function clearAssignTo() {
    //clears assignment
    Object(__WEBPACK_IMPORTED_MODULE_6_app_actionCreators_group__["c" /* clearAssignment */])(this.props.id);
    this.setState({ filter: '', loading: true });
  },
  onFilterKeyUp: function onFilterKeyUp(evt) {
    if (evt.key === 'Escape') {
      this.onDropdownClose();
    } else {
      this.setState({
        filter: evt.target.value
      });
    }
  },
  onFilterKeyDown: function onFilterKeyDown(evt) {
    if (evt.key === 'Enter' && this.state.filter) {
      var members = AssigneeSelector.filterAssignees(this.state.memberList, this.state.filter);
      if (members.length > 0) {
        this.assignToUser(members[0]);
      }
    }
  },
  onFilterMount: function onFilterMount(ref) {
    if (ref) {
      // focus filter input
      ref.focus();
    }
  },
  onFilterClick: function onFilterClick(e) {
    // Prevent dropdown menu from closing when filter input is clicked
    e.stopPropagation();
  },
  onDropdownOpen: function onDropdownOpen() {
    this.setState({ isOpen: true });
  },
  onDropdownClose: function onDropdownClose() {
    this.setState({
      isOpen: false,
      filter: ''
    });
  },
  highlight: function highlight(text, highlightText) {
    if (!highlightText) {
      return text;
    }
    highlightText = highlightText.toLowerCase();
    var idx = text.toLowerCase().indexOf(highlightText);
    if (idx === -1) {
      return text;
    }
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
      null,
      text.substr(0, idx),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'strong',
        { className: 'highlight' },
        text.substr(idx, highlightText.length)
      ),
      text.substr(idx + highlightText.length)
    );
  },
  renderMemberNodes: function renderMemberNodes() {
    var _this = this;

    var _state = this.state,
        filter = _state.filter,
        memberList = _state.memberList;
    var size = this.props.size;

    var members = AssigneeSelector.filterAssignees(memberList, filter);
    members = AssigneeSelector.putSessionUserFirst(members);

    return members.map(function (item) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_18_app_components_menuItem__["default"],
        {
          key: Object(__WEBPACK_IMPORTED_MODULE_8_app_utils__["b" /* buildUserId */])(item.id),
          onSelect: _this.assignToUser.bind(_this, item)
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          MenuItemWrapper,
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            IconContainer,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_avatar__["a" /* default */], { user: item, size: size })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            Label,
            null,
            _this.highlight(item.name || item.email, filter)
          )
        )
      );
    });
  },
  renderTeamNodes: function renderTeamNodes() {
    var _this2 = this;

    var filter = this.state.filter;
    var size = this.props.size;

    var teamNodes = [];
    var org = this.context.organization;
    var features = new Set(org.features);

    if (features.has('new-teams')) {
      teamNodes = this.assignableTeams().map(function (_ref) {
        var id = _ref.id,
            display = _ref.display,
            team = _ref.team;

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_18_app_components_menuItem__["default"],
          { key: id, onSelect: _this2.assignToTeam.bind(_this2, team) },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            MenuItemWrapper,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              IconContainer,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_avatar__["a" /* default */], { team: team, size: size })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              Label,
              null,
              _this2.highlight(display, filter)
            )
          )
        );
      });
    }
    return teamNodes;
  },
  renderDropdownItems: function renderDropdownItems() {
    var _this3 = this;

    var _state2 = this.state,
        loading = _state2.loading,
        assignedTo = _state2.assignedTo;

    var org = this.context.organization;
    var features = new Set(org.features);
    var teams = this.renderTeamNodes();
    var members = this.renderMemberNodes();
    var hasTeamsAndMembers = teams.length && members.length;
    var hasTeamsOrMembers = teams.length || members.length;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_18_app_components_menuItem__["default"],
        { noAnchor: true },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
          type: 'text',
          className: 'form-control input-sm',
          placeholder: features.has('new-teams') ? Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('Filter teams and people') : Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('Filter members'),
          ref: function ref(_ref2) {
            return _this3.onFilterMount(_ref2);
          },
          onClick: this.onFilterClick,
          onKeyDown: this.onFilterKeyDown,
          onKeyUp: this.onFilterKeyUp
        })
      ),
      assignedTo && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_18_app_components_menuItem__["default"],
        {
          className: 'clear-assignee',
          disabled: !loading,
          onSelect: this.clearAssignTo
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          MenuItemWrapper,
          { py: 0 },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            IconContainer,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ClearAssigneeIcon, null)
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            Label,
            null,
            Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('Clear Assignee')
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'li',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'ul',
          null,
          teams,
          hasTeamsAndMembers ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Divider, { key: 'divider' }) : null,
          members,
          !hasTeamsOrMembers && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'li',
            { className: 'not-found' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('No matches found.')
            )
          )
        )
      )
    );
  },
  render: function render() {
    var _state3 = this.state,
        loading = _state3.loading,
        assignedTo = _state3.assignedTo;

    var group = __WEBPACK_IMPORTED_MODULE_14_app_stores_groupStore__["a" /* default */].get(this.props.id);

    var org = this.context.organization;
    var access = new Set(org.access);

    var assigneeListLoading = this.state.memberList === null || !group;

    if (loading) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'assignee-selector anchor-right' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_app_components_loadingIndicator__["default"], { mini: true, style: { marginRight: '10px' } })
        )
      );
    }

    var className = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('assignee-selector anchor-right', {
      unassigned: !assignedTo
    });

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: className },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_app_components_dropdownLink__["default"],
        {
          className: 'assignee-selector-toggle',
          onOpen: this.onDropdownOpen,
          onClose: this.onDropdownClose,
          isOpen: this.state.isOpen,
          alwaysRenderMenu: false,
          title: assignedTo ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_actorAvatar__["a" /* default */], { actor: assignedTo, className: 'avatar', size: 24 }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon-user' })
        },
        assigneeListLoading ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'li',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13_app_components_flowLayout__["a" /* default */],
            { center: true, className: 'list-loading-container' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_app_components_loadingIndicator__["default"], { mini: true })
          )
        ) : this.renderDropdownItems(),
        __WEBPACK_IMPORTED_MODULE_11_app_stores_configStore__["default"].get('invitesEnabled') && access.has('org:write') && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Divider, null),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_18_app_components_menuItem__["default"],
            {
              className: 'invite-member',
              disabled: !loading,
              to: '/settings/' + this.context.organization.slug + '/members/new/',
              query: { referrer: 'assignee_selector' }
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              MenuItemWrapper,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                IconContainer,
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InviteMemberIcon, null)
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                Label,
                null,
                Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('Invite Member')
              )
            )
          )
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (AssigneeSelector);

var getSvgStyle = function getSvgStyle() {
  return '\n  font-size: 16px;\n  opacity: 0.3;\n';
};

var Divider = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])('hr', {
  target: 'e1gsze4x0'
})('margin:0;');

var IconContainer = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])('div', {
  target: 'e1gsze4x1'
})('display:flex;align-items:center;justify-content:center;width:24px;height:24px;flex-shrink:0;');

var MenuItemWrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])(function (_ref3) {
  var py = _ref3.py,
      props = _objectWithoutProperties(_ref3, ['py']);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', props);
}, {
  target: 'e1gsze4x2'
})('display:flex;align-items:center;padding:5px 8px;', function (p) {
  return typeof p.py !== 'undefined' && '\n      padding-top: ' + p.py + ';\n      padding-bottom: ' + p.py + ';\n    ';
}, ';');

var Label = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_21_app_components_textOverflow__["a" /* default */], {
  target: 'e1gsze4x3'
})('margin-left:6px;');

var ClearAssigneeIcon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])(function (props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_app_components_inlineSvg__["a" /* default */], _extends({}, props, { src: 'icon-circle-close' }));
}, {
  target: 'e1gsze4x4'
})(getSvgStyle, ';');

var InviteMemberIcon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])(function (props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_app_components_inlineSvg__["a" /* default */], _extends({}, props, { src: 'icon-circle-add' }));
}, {
  target: 'e1gsze4x5'
})(getSvgStyle, ';');

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Raven) {/* harmony export (immutable) */ __webpack_exports__["b"] = assignToUser;
/* harmony export (immutable) */ __webpack_exports__["c"] = clearAssignment;
/* harmony export (immutable) */ __webpack_exports__["a"] = assignToActor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_actions_groupActions__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils__ = __webpack_require__(10);




function assignToUser(params) {
  var api = new __WEBPACK_IMPORTED_MODULE_0_app_api__["Client"]();

  var endpoint = '/issues/' + params.id + '/';

  var id = api.uniqueId();

  __WEBPACK_IMPORTED_MODULE_1_app_actions_groupActions__["a" /* default */].assignTo(id, params.id, {
    email: params.member && params.member.email || ''
  });

  var request = api.requestPromise(endpoint, {
    method: 'PUT',
    // Sending an empty value to assignedTo is the same as "clear",
    // so if no member exists, that implies that we want to clear the
    // current assignee.
    data: {
      assignedTo: params.user ? Object(__WEBPACK_IMPORTED_MODULE_2_app_utils__["b" /* buildUserId */])(params.user.id) : ''
    }
  });

  request.then(function (data) {
    __WEBPACK_IMPORTED_MODULE_1_app_actions_groupActions__["a" /* default */].assignToSuccess(id, params.id, data);
  }).catch(function (data) {
    __WEBPACK_IMPORTED_MODULE_1_app_actions_groupActions__["a" /* default */].assignToError(id, params.id, data);
  });

  return request;
}

function clearAssignment(groupId) {
  var api = new __WEBPACK_IMPORTED_MODULE_0_app_api__["Client"]();

  var endpoint = '/issues/' + groupId + '/';

  var id = api.uniqueId();

  __WEBPACK_IMPORTED_MODULE_1_app_actions_groupActions__["a" /* default */].assignTo(id, groupId, {
    email: ''
  });

  var request = api.requestPromise(endpoint, {
    method: 'PUT',
    // Sending an empty value to assignedTo is the same as "clear"
    data: {
      assignedTo: ''
    }
  });

  request.then(function (data) {
    __WEBPACK_IMPORTED_MODULE_1_app_actions_groupActions__["a" /* default */].assignToSuccess(id, groupId, data);
  }).catch(function (data) {
    __WEBPACK_IMPORTED_MODULE_1_app_actions_groupActions__["a" /* default */].assignToError(id, groupId, data);
  });

  return request;
}

function assignToActor(_ref) {
  var id = _ref.id,
      actor = _ref.actor;

  var api = new __WEBPACK_IMPORTED_MODULE_0_app_api__["Client"]();

  var endpoint = '/issues/' + id + '/';

  var uniqueId = api.uniqueId();
  var actorId = void 0;
  switch (actor.type) {
    case 'user':
      actorId = Object(__WEBPACK_IMPORTED_MODULE_2_app_utils__["b" /* buildUserId */])(actor.id);
      break;

    case 'team':
      actorId = Object(__WEBPACK_IMPORTED_MODULE_2_app_utils__["a" /* buildTeamId */])(actor.id);
      break;

    default:
      Raven.captureException('Unknown assignee type', {
        extra: { actor: actor }
      });
  }

  return api.requestPromise(endpoint, {
    method: 'PUT',
    data: { assignedTo: actorId }
  }).then(function (data) {
    __WEBPACK_IMPORTED_MODULE_1_app_actions_groupActions__["a" /* default */].assignToSuccess(uniqueId, id, data);
  }).catch(function (data) {
    __WEBPACK_IMPORTED_MODULE_1_app_actions_groupActions__["a" /* default */].assignToError(uniqueId, id, data);
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(40)))

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultIssuePlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_plugins_basePlugin__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_plugins_components_issueActions__ = __webpack_require__(1026);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DefaultIssuePlugin = function (_BasePlugin) {
  _inherits(DefaultIssuePlugin, _BasePlugin);

  function DefaultIssuePlugin() {
    _classCallCheck(this, DefaultIssuePlugin);

    return _possibleConstructorReturn(this, (DefaultIssuePlugin.__proto__ || Object.getPrototypeOf(DefaultIssuePlugin)).apply(this, arguments));
  }

  _createClass(DefaultIssuePlugin, [{
    key: 'renderGroupActions',
    value: function renderGroupActions(props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_plugins_components_issueActions__["a" /* default */], _extends({ plugin: this }, props));
    }
  }]);

  return DefaultIssuePlugin;
}(__WEBPACK_IMPORTED_MODULE_1_app_plugins_basePlugin__["a" /* default */]);

DefaultIssuePlugin.DefaultIssueActions = __WEBPACK_IMPORTED_MODULE_2_app_plugins_components_issueActions__["a" /* default */];

/* harmony default export */ __webpack_exports__["b"] = (DefaultIssuePlugin);

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResolveActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_customResolutionModal__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_menuItem__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_dropdownLink__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_actions_actionLink__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_assistant_guideAnchor__ = __webpack_require__(65);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var ResolveActions = (_temp = _class = function (_React$Component) {
  _inherits(ResolveActions, _React$Component);

  function ResolveActions(props) {
    _classCallCheck(this, ResolveActions);

    var _this = _possibleConstructorReturn(this, (ResolveActions.__proto__ || Object.getPrototypeOf(ResolveActions)).call(this, props));

    _this.state = { modal: false };
    return _this;
  }

  _createClass(ResolveActions, [{
    key: 'onCustomResolution',
    value: function onCustomResolution(statusDetails) {
      this.setState({
        modal: false
      });
      this.props.onUpdate({
        status: 'resolved',
        statusDetails: statusDetails
      });
    }
  }, {
    key: 'getButtonClass',
    value: function getButtonClass(otherClasses) {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()('btn btn-default btn-sm', otherClasses);
    }
  }, {
    key: 'renderResolved',
    value: function renderResolved() {
      var _props = this.props,
          isAutoResolved = _props.isAutoResolved,
          onUpdate = _props.onUpdate;


      if (isAutoResolved) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_app_components_tooltip__["default"],
            {
              title: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('This event is resolved due to the Auto Resolve configuration for this project')
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: this.getButtonClass('active') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'icon-checkmark' })
            )
          )
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_app_components_tooltip__["default"],
            { title: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Unresolve') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                className: this.getButtonClass('active'),
                onClick: function onClick() {
                  return onUpdate({ status: 'unresolved' });
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'icon-checkmark' })
            )
          )
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          isResolved = _props2.isResolved,
          hasRelease = _props2.hasRelease,
          latestRelease = _props2.latestRelease,
          onUpdate = _props2.onUpdate,
          orgId = _props2.orgId,
          projectId = _props2.projectId,
          confirmMessage = _props2.confirmMessage,
          shouldConfirm = _props2.shouldConfirm,
          disabled = _props2.disabled,
          confirmLabel = _props2.confirmLabel;


      var buttonClass = this.getButtonClass();

      if (isResolved) {
        return this.renderResolved();
      }

      var actionTitle = !hasRelease ? Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Set up release tracking in order to use this feature.') : '';

      var actionLinkProps = {
        shouldConfirm: shouldConfirm,
        message: confirmMessage,
        confirmLabel: confirmLabel,
        disabled: disabled
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { display: 'inline-block' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_customResolutionModal__["a" /* default */], {
          show: this.state.modal,
          onSelected: function onSelected(statusDetails) {
            return _this2.onCustomResolution(statusDetails);
          },
          onCanceled: function onCanceled() {
            return _this2.setState({ modal: false });
          },
          orgId: orgId,
          projectId: projectId
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_app_components_actions_actionLink__["a" /* default */],
            _extends({}, actionLinkProps, {
              title: 'Resolve',
              className: buttonClass,
              onAction: function onAction() {
                return onUpdate({ status: 'resolved' });
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'icon-checkmark hidden-xs', style: { marginRight: 5 } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_assistant_guideAnchor__["default"], { target: 'resolve', type: 'text' }),
            Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Resolve')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_app_components_dropdownLink__["default"],
            {
              key: 'resolve-dropdown',
              caret: true,
              className: buttonClass,
              title: '',
              alwaysRenderMenu: true,
              disabled: disabled
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_app_components_menuItem__["default"],
              { header: true },
              Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Resolved In')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_app_components_menuItem__["default"],
              { noAnchor: true },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_app_components_tooltip__["default"],
                { title: actionTitle },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_app_components_actions_actionLink__["a" /* default */],
                  _extends({}, actionLinkProps, {
                    onAction: function onAction() {
                      return hasRelease && onUpdate({
                        status: 'resolved',
                        statusDetails: {
                          inNextRelease: true
                        }
                      });
                    }
                  }),
                  Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('The next release')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_app_components_tooltip__["default"],
                { title: actionTitle },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_app_components_actions_actionLink__["a" /* default */],
                  _extends({}, actionLinkProps, {
                    onAction: function onAction() {
                      return hasRelease && onUpdate({
                        status: 'resolved',
                        statusDetails: {
                          inRelease: latestRelease ? latestRelease.version : 'latest'
                        }
                      });
                    }
                  }),
                  latestRelease ? Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('The current release (%s)', Object(__WEBPACK_IMPORTED_MODULE_3_app_utils__["j" /* getShortVersion */])(latestRelease.version)) : Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('The current release')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_app_components_tooltip__["default"],
                { title: actionTitle },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_app_components_actions_actionLink__["a" /* default */],
                  _extends({}, actionLinkProps, {
                    onAction: function onAction() {
                      return hasRelease && _this2.setState({ modal: true });
                    },
                    shouldConfirm: false
                  }),
                  Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Another version\u2026')
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ResolveActions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  hasRelease: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  latestRelease: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  orgId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  projectId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  shouldConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  confirmMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isResolved: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isAutoResolved: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  confirmLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  isResolved: false,
  isAutoResolved: false,
  confirmLabel: 'Resolve'
}, _temp);


/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IgnoreActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_menuItem__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_dropdownLink__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_duration__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_customIgnoreCountModal__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_customIgnoreDurationModal__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_actions_actionLink__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_assistant_guideAnchor__ = __webpack_require__(65);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var IgnoreActions = (_temp = _class = function (_React$Component) {
  _inherits(IgnoreActions, _React$Component);

  function IgnoreActions(props) {
    _classCallCheck(this, IgnoreActions);

    var _this = _possibleConstructorReturn(this, (IgnoreActions.__proto__ || Object.getPrototypeOf(IgnoreActions)).call(this, props));

    _this.state = { modal: false };
    return _this;
  }

  _createClass(IgnoreActions, [{
    key: 'getIgnoreDurations',
    value: function getIgnoreDurations() {
      return [30, 120, 360, 60 * 24, 60 * 24 * 7];
    }
  }, {
    key: 'getIgnoreCounts',
    value: function getIgnoreCounts() {
      return [10, 100, 1000, 10000, 100000];
    }
  }, {
    key: 'getIgnoreWindows',
    value: function getIgnoreWindows() {
      return [[60, 'per hour'], [24 * 60, 'per day'], [24 * 7 * 60, 'per week']];
    }
  }, {
    key: 'onCustomIgnore',
    value: function onCustomIgnore(statusDetails) {
      this.setState({
        modal: false
      });
      this.onIgnore(statusDetails);
    }
  }, {
    key: 'onIgnore',
    value: function onIgnore(statusDetails) {
      return this.props.onUpdate({
        status: 'ignored',
        statusDetails: statusDetails || {}
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isIgnored = _props.isIgnored,
          onUpdate = _props.onUpdate,
          disabled = _props.disabled,
          shouldConfirm = _props.shouldConfirm,
          confirmMessage = _props.confirmMessage,
          confirmLabel = _props.confirmLabel;


      var linkClassName = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('btn btn-default btn-sm', {
        active: isIgnored
      });

      var actionLinkProps = {
        shouldConfirm: shouldConfirm,
        title: 'Ignore',
        message: confirmMessage,
        confirmLabel: confirmLabel,
        disabled: disabled
      };

      if (isIgnored) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_app_components_tooltip__["default"],
            { title: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Change status to unresolved') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: linkClassName, onClick: function onClick() {
                  return onUpdate({ status: 'unresolved' });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'icon-ban' })
            )
          )
        );
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { display: 'inline-block' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_customIgnoreDurationModal__["a" /* default */], {
          show: this.state.modal === 'duration',
          onSelected: function onSelected(details) {
            return _this2.onCustomIgnore(details);
          },
          onCanceled: function onCanceled() {
            return _this2.setState({ modal: null });
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_customIgnoreCountModal__["a" /* default */], {
          show: this.state.modal === 'count',
          onSelected: function onSelected(details) {
            return _this2.onCustomIgnore(details);
          },
          onCanceled: function onCanceled() {
            return _this2.setState({ modal: null });
          },
          label: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Ignore this issue until it occurs again\u2026'),
          countLabel: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Number of times'),
          countName: 'ignoreCount',
          windowName: 'ignoreWindow',
          windowChoices: this.getIgnoreWindows()
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_customIgnoreCountModal__["a" /* default */], {
          show: this.state.modal === 'users',
          onSelected: function onSelected(details) {
            return _this2.onCustomIgnore(details);
          },
          onCanceled: function onCanceled() {
            return _this2.setState({ modal: null });
          },
          label: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Ignore this issue until it affects an additional\u2026'),
          countLabel: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Numbers of users'),
          countName: 'ignoreUserCount',
          windowName: 'ignoreUserWindow',
          windowChoices: this.getIgnoreWindows()
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_app_components_actions_actionLink__["a" /* default */],
            _extends({}, actionLinkProps, {
              className: linkClassName,
              onAction: function onAction() {
                return onUpdate({ status: 'ignored' });
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'icon-ban hidden-xs', style: { marginRight: 5 } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_assistant_guideAnchor__["default"], { target: 'ignore_delete_discard', type: 'text' }),
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Ignore')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_app_components_dropdownLink__["default"],
            {
              caret: true,
              className: linkClassName,
              title: '',
              alwaysRenderMenu: true,
              disabled: disabled
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_app_components_menuItem__["default"],
              { header: true },
              'Ignore'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              { className: 'dropdown-submenu' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_app_components_dropdownLink__["default"],
                {
                  title: 'For\u2026',
                  caret: false,
                  isNestedDropdown: true,
                  alwaysRenderMenu: true
                },
                this.getIgnoreDurations().map(function (duration) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_app_components_menuItem__["default"],
                    { noAnchor: true, key: duration },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_9_app_components_actions_actionLink__["a" /* default */],
                      _extends({}, actionLinkProps, {
                        onAction: function onAction() {
                          return _this2.onIgnore({ ignoreDuration: duration });
                        }
                      }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_duration__["a" /* default */], { seconds: duration * 60 })
                    )
                  );
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_menuItem__["default"], { divider: true }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_app_components_menuItem__["default"],
                  { noAnchor: true },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { onClick: function onClick() {
                        return _this2.setState({ modal: 'duration' });
                      } },
                    Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Custom')
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              { className: 'dropdown-submenu' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_app_components_dropdownLink__["default"],
                {
                  title: 'Until this occurs again\u2026',
                  caret: false,
                  isNestedDropdown: true,
                  alwaysRenderMenu: true
                },
                this.getIgnoreCounts().map(function (count) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'li',
                    { className: 'dropdown-submenu', key: count },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_5_app_components_dropdownLink__["default"],
                      {
                        title: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('%s times', count.toLocaleString()),
                        caret: false,
                        isNestedDropdown: true,
                        alwaysRenderMenu: true
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_app_components_menuItem__["default"],
                        { noAnchor: true },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_9_app_components_actions_actionLink__["a" /* default */],
                          _extends({}, actionLinkProps, {
                            onAction: function onAction() {
                              return _this2.onIgnore({ ignoreCount: count });
                            }
                          }),
                          Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('from now')
                        )
                      ),
                      _this2.getIgnoreWindows().map(function (_ref) {
                        var _ref2 = _slicedToArray(_ref, 2),
                            hours = _ref2[0],
                            label = _ref2[1];

                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_4_app_components_menuItem__["default"],
                          { noAnchor: true, key: hours },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_9_app_components_actions_actionLink__["a" /* default */],
                            _extends({}, actionLinkProps, {
                              onAction: function onAction() {
                                return _this2.onIgnore({
                                  ignoreCount: count,
                                  ignoreWindow: hours
                                });
                              }
                            }),
                            label
                          )
                        );
                      })
                    )
                  );
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_menuItem__["default"], { divider: true }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_app_components_menuItem__["default"],
                  { noAnchor: true },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { onClick: function onClick() {
                        return _this2.setState({ modal: 'count' });
                      } },
                    Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Custom')
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              { className: 'dropdown-submenu' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_app_components_dropdownLink__["default"],
                {
                  title: 'Until this affects an additional\u2026',
                  caret: false,
                  isNestedDropdown: true,
                  alwaysRenderMenu: true
                },
                this.getIgnoreCounts().map(function (count) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'li',
                    { className: 'dropdown-submenu', key: count },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_5_app_components_dropdownLink__["default"],
                      {
                        title: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('%s users', count.toLocaleString()),
                        caret: false,
                        isNestedDropdown: true,
                        alwaysRenderMenu: true
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_app_components_menuItem__["default"],
                        { noAnchor: true },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_9_app_components_actions_actionLink__["a" /* default */],
                          _extends({}, actionLinkProps, {
                            onAction: function onAction() {
                              return _this2.onIgnore({ ignoreUserCount: count });
                            }
                          }),
                          Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('from now')
                        )
                      ),
                      _this2.getIgnoreWindows().map(function (_ref3) {
                        var _ref4 = _slicedToArray(_ref3, 2),
                            hours = _ref4[0],
                            label = _ref4[1];

                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_4_app_components_menuItem__["default"],
                          { noAnchor: true, key: hours },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_9_app_components_actions_actionLink__["a" /* default */],
                            _extends({}, actionLinkProps, {
                              onAction: function onAction() {
                                return _this2.onIgnore({
                                  ignoreUserCount: count,
                                  ignoreUserWindow: hours
                                });
                              }
                            }),
                            label
                          )
                        );
                      })
                    )
                  );
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_menuItem__["default"], { divider: true }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_app_components_menuItem__["default"],
                  { noAnchor: true },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { onClick: function onClick() {
                        return _this2.setState({ modal: 'users' });
                      } },
                    Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Custom')
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return IgnoreActions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  isIgnored: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  shouldConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  confirmMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  confirmLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  isIgnored: false,
  confirmLabel: 'Ignore'
}, _temp);


/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_mixins_projectState__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_autoSelectText__ = __webpack_require__(190);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var ShortId = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'ShortId',

  propTypes: {
    shortId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_app_mixins_projectState__["a" /* default */]],

  preventPropagation: function preventPropagation(e) {
    // this is a hack for the stream so the click handler doesn't
    // affect this element
    e.stopPropagation();
  },
  render: function render() {
    var shortId = this.props.shortId;
    if (!shortId) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      StyledShortId,
      _extends({ onClick: this.preventPropagation }, this.props),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_app_components_autoSelectText__["a" /* default */],
        null,
        shortId
      )
    );
  }
});

var StyledShortId = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'ebuncw00'
})('font-family:', function (p) {
  return p.theme.text.familyMono;
}, ';');

/* harmony default export */ __webpack_exports__["a"] = (ShortId);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export formatQueryString */
/* harmony export (immutable) */ __webpack_exports__["b"] = getQueryEnvironment;
/* harmony export (immutable) */ __webpack_exports__["c"] = getQueryStringWithEnvironment;
/* unused harmony export getQueryStringWithoutEnvironment */
// remove leading and trailing whitespace and remove double spaces
function formatQueryString(qs) {
  return qs.trim().replace(/\s+/g, ' ');
}

// returns environment name from query or null if not specified
// Any character can be valid in an environment name but we need to
// check for matching environments with the quotation marks first
// to match the way tag searches are being done
function getQueryEnvironment(qs) {
  // A match with quotes will lazily match any characters within quotation marks
  var matchWithQuotes = qs.match(/(?:^|\s)environment:"(.*?)"/);
  // A match without quotes will match any non space character
  var matchWithoutQuotes = qs.match(/(?:^|\s)environment:([^\s]*)/);

  if (matchWithQuotes) {
    return matchWithQuotes[1];
  } else if (matchWithoutQuotes) {
    return matchWithoutQuotes[1];
  } else {
    return null;
  }
}

function getQueryStringWithEnvironment(qs, env) {
  var qsWithoutEnv = qs.replace(/(?:^|\s)environment:[^\s]*/g, '');
  return formatQueryString(env === null ? qsWithoutEnv : qsWithoutEnv + ' environment:' + env);
}

function getQueryStringWithoutEnvironment(qs) {
  return formatQueryString(qs.replace(/(?:^|\s)environment:[^\s]*/g, ''));
}

/* harmony default export */ __webpack_exports__["a"] = ({
  formatQueryString: formatQueryString,
  getQueryEnvironment: getQueryEnvironment,
  getQueryStringWithEnvironment: getQueryStringWithEnvironment,
  getQueryStringWithoutEnvironment: getQueryStringWithoutEnvironment
});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommitRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_idx__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_avatar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_timeSince__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_commitLink__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_textOverflow__ = __webpack_require__(124);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var CommitRow = (_temp2 = _class = function (_React$Component) {
  _inherits(CommitRow, _React$Component);

  function CommitRow() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, CommitRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = CommitRow.__proto__ || Object.getPrototypeOf(CommitRow)).call.apply(_ref2, [this].concat(args))), _this), _this.renderMessage = function (message) {
      if (!message) {
        return Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('No message provided');
      }

      var firstLine = message.split(/\n/)[0];

      return firstLine;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CommitRow, [{
    key: 'render',
    value: function render() {
      var _ref;

      var _props$commit = this.props.commit,
          id = _props$commit.id,
          dateCreated = _props$commit.dateCreated,
          message = _props$commit.message,
          author = _props$commit.author,
          repository = _props$commit.repository;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_app_components_panels__["f" /* PanelItem */],
        { key: id, align: 'center' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          AvatarWrapper,
          { mr: 2 },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_avatar__["a" /* default */], { size: 36, user: author })
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_grid_emotion__["Box"],
          { flex: '1', direction: 'column', style: { minWidth: 0 }, mr: 2 },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            Message,
            null,
            this.renderMessage(message)
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            Meta,
            null,
            Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["tct"])('[author] committed [timeago]', {
              author: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'strong',
                null,
                ((_ref = author) != null ? _ref.name : _ref) || Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('Unknown author')
              ),
              timeago: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_timeSince__["default"], { date: dateCreated })
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_grid_emotion__["Box"],
          { className: 'hidden-xs' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_commitLink__["a" /* default */], { commitId: id, repository: repository })
        )
      );
    }
  }]);

  return CommitRow;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  commit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
}, _temp2);



var AvatarWrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_4_grid_emotion__["Box"], {
  target: 'ez7y0rd0'
})('align-self:flex-start;');

var Message = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_10_app_components_textOverflow__["a" /* default */], {
  target: 'ez7y0rd1'
})('font-size:15px;line-height:1.1;font-weight:bold;');

var Meta = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('p', {
  target: 'ez7y0rd2'
})('font-size:13px;line-height:1.5;margin:0;color:', function (p) {
  return p.theme.gray3;
}, ';');

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(640),
    getTag = __webpack_require__(461),
    isArguments = __webpack_require__(274),
    isArray = __webpack_require__(47),
    isArrayLike = __webpack_require__(221),
    isBuffer = __webpack_require__(410),
    isPrototype = __webpack_require__(622),
    isTypedArray = __webpack_require__(411);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 535 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(1066);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 537 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_avatar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_timeSince__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var LastCommit = (_temp2 = _class = function (_React$Component) {
  _inherits(LastCommit, _React$Component);

  function LastCommit() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LastCommit);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LastCommit.__proto__ || Object.getPrototypeOf(LastCommit)).call.apply(_ref, [this].concat(args))), _this), _this.renderMessage = function (message) {
      if (!message) {
        return Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('No message provided');
      }

      var firstLine = message.split(/\n/)[0];
      if (firstLine.length > 100) {
        var truncated = firstLine.substr(0, 90);
        var words = truncated.split(/ /);
        // try to not have elipsis mid-word
        if (words.length > 1) {
          words.pop();
          truncated = words.join(' ');
        }
        return truncated + '...';
      }
      return firstLine;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LastCommit, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          commit = _props.commit,
          headerClass = _props.headerClass;

      var commitAuthor = commit && commit.author;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h6',
          { className: headerClass },
          'Last commit'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'commit' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'commit-avatar' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_avatar__["a" /* default */], { user: commitAuthor || { username: '?' } })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'commit-message truncate' },
            this.renderMessage(commit.message)
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'commit-meta' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'strong',
              null,
              commitAuthor && commitAuthor.name || Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Unknown Author')
            ),
            '\xA0',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_timeSince__["default"], { date: commit.dateCreated })
          )
        )
      );
    }
  }]);

  return LastCommit;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  commit: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  headerClass: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (LastCommit);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_events_interfaces_frame__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_mixins_organizationState__ = __webpack_require__(39);



//import GroupEventDataSection from "../eventDataSection";




var StacktraceContent = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'StacktraceContent',

  propTypes: {
    data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
    includeSystemFrames: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    expandFirstFrame: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    platform: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    newestFirst: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5_app_mixins_organizationState__["a" /* default */]],

  getDefaultProps: function getDefaultProps() {
    return {
      includeSystemFrames: true,
      expandFirstFrame: true
    };
  },
  renderOmittedFrames: function renderOmittedFrames(firstFrameOmitted, lastFrameOmitted) {
    var props = {
      className: 'frame frames-omitted',
      key: 'omitted'
    };
    var text = Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Frames %d until %d were omitted and not available.', firstFrameOmitted, lastFrameOmitted);
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'li',
      props,
      text
    );
  },
  frameIsVisible: function frameIsVisible(frame, nextFrame) {
    return this.props.includeSystemFrames || frame.inApp || nextFrame && nextFrame.inApp;
  },
  render: function render() {
    var _this = this;

    var data = this.props.data;
    var firstFrameOmitted = void 0,
        lastFrameOmitted = void 0;

    if (data.framesOmitted) {
      firstFrameOmitted = data.framesOmitted[0];
      lastFrameOmitted = data.framesOmitted[1];
    } else {
      firstFrameOmitted = null;
      lastFrameOmitted = null;
    }

    var lastFrameIdx = null;
    data.frames.forEach(function (frame, frameIdx) {
      if (frame.inApp) lastFrameIdx = frameIdx;
    });
    if (lastFrameIdx === null) {
      lastFrameIdx = data.frames.length - 1;
    }

    var expandFirstFrame = this.props.expandFirstFrame;
    var frames = [];
    var nRepeats = 0;
    data.frames.forEach(function (frame, frameIdx) {
      var prevFrame = data.frames[frameIdx - 1];
      var nextFrame = data.frames[frameIdx + 1];
      var repeatedFrame = nextFrame && frame.lineNo === nextFrame.lineNo && frame.instructionAddr === nextFrame.instructionAddr && frame.package === nextFrame.package && frame.module === nextFrame.module && frame.function === nextFrame.function;

      if (repeatedFrame) {
        nRepeats++;
      }

      if (_this.frameIsVisible(frame, nextFrame) && !repeatedFrame) {
        frames.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_events_interfaces_frame__["a" /* default */], {
          key: frameIdx,
          data: frame,
          isExpanded: expandFirstFrame && lastFrameIdx === frameIdx,
          emptySourceNotation: lastFrameIdx === frameIdx && frameIdx === 0,
          isOnlyFrame: _this.props.data.frames.length === 1,
          nextFrame: nextFrame,
          prevFrame: prevFrame,
          platform: _this.props.platform,
          timesRepeated: nRepeats
        }));
      }

      if (!repeatedFrame) {
        nRepeats = 0;
      }

      if (frameIdx === firstFrameOmitted) {
        frames.push(_this.renderOmittedFrames(firstFrameOmitted, lastFrameOmitted));
      }
    });
    if (this.props.newestFirst) {
      frames.reverse();
    }
    var className = this.props.className || '';
    className += ' traceback';

    if (this.props.includeSystemFrames) {
      className += ' full-traceback';
    } else {
      className += ' in-app-traceback';
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: className },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'ul',
        null,
        frames
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (StacktraceContent);

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery, Raven) {/* unused harmony export escapeQuotes */
/* harmony export (immutable) */ __webpack_exports__["a"] = getCurlCommand;
/* harmony export (immutable) */ __webpack_exports__["b"] = objectToSortedTupleArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isString__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_utils__ = __webpack_require__(10);



var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();



function escapeQuotes(v) {
  return v.replace(/"/g, '\\"');
}

// TODO(dcramer): support cookies
function getCurlCommand(data) {
  var result = 'curl';

  if (Object(__WEBPACK_IMPORTED_MODULE_1_app_utils__["d" /* defined */])(data.method) && data.method !== 'GET') {
    result += ' \\\n -X ' + data.method;
  }

  // TODO(benvinegar): just gzip? what about deflate?
  var compressed = data.headers.find(function (h) {
    return h[0] === 'Accept-Encoding' && h[1].indexOf('gzip') !== -1;
  });
  if (compressed) {
    result += ' \\\n --compressed';
  }

  // sort headers
  var headers = data.headers.sort(function (a, b) {
    return a[0] === b[0] ? 0 : a[0] < b[0] ? -1 : 1;
  });

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = headers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var header = _step.value;

      result += ' \\\n -H "' + header[0] + ': ' + escapeQuotes(header[1] + '') + '"';
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_1_app_utils__["d" /* defined */])(data.data)) {
    switch (data.inferredContentType) {
      case 'application/json':
        result += ' \\\n --data "' + escapeQuotes(JSON.stringify(data.data)) + '"';
        break;
      case 'application/x-www-form-urlencoded':
        result += ' \\\n --data "' + escapeQuotes(jQuery.param(data.data)) + '"';
        break;
      default:
        if (__WEBPACK_IMPORTED_MODULE_0_lodash_isString___default()(data.data)) {
          result += ' \\\n --data "' + escapeQuotes(data.data) + '"';
        } else {
          Raven.captureMessage('Unknown event data', {
            extra: data
          });
        }
    }
  }

  result += ' \\\n "' + data.url;

  if (Object(__WEBPACK_IMPORTED_MODULE_1_app_utils__["d" /* defined */])(data.query) && data.query) {
    result += '?' + data.query;
  }

  result += '"';
  return result;
}

/**
 * Converts an object of body/querystring key/value pairs
 * into a tuple of [key, value] pairs, and sorts them.
 *
 * This handles the case for query strings that were decoded like so:
 *
 *   ?foo=bar&foo=baz => { foo: ['bar', 'baz'] }
 *
 * By converting them to [['foo', 'bar'], ['foo', 'baz']]
 */
function objectToSortedTupleArray(obj) {
  return Object.keys(obj).reduce(function (out, k) {
    var val = obj[k];
    return out.concat({}.toString.call(val) === '[object Array]' ? val.map(function (v) {
      return [k, v];
    }) // key has multiple values (array)
    : [[k, val]] // key has single value
    );
  }, []).sort(function (_ref, _ref2) {
    var _ref4 = _slicedToArray(_ref, 2),
        keyA = _ref4[0],
        valA = _ref4[1];

    var _ref3 = _slicedToArray(_ref2, 2),
        keyB = _ref3[0],
        valB = _ref3[1];

    // if keys are identical, sort on value
    if (keyA === keyB) {
      return valA < valB ? -1 : 1;
    }

    return keyA < keyB ? -1 : 1;
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13), __webpack_require__(40)))

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_less_components_toolbar_less__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_less_components_toolbar_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_app_less_components_toolbar_less__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var Toolbar = function Toolbar(_ref) {
  var className = _ref.className,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ['className', 'children']);

  var cx = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('toolbar', className);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    _extends({ className: cx }, otherProps),
    children
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Toolbar);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_less_components_toolbarHeader_less__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_less_components_toolbarHeader_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_app_less_components_toolbarHeader_less__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var ToolbarHeader = function ToolbarHeader(_ref) {
  var className = _ref.className,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ['className', 'children']);

  var cx = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('toolbar-header', className);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    _extends({ className: cx }, otherProps),
    children
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ToolbarHeader);

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_compactIssue__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_views_settings_components_emptyMessage__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_pagination__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_locale__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















var IssueList = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'IssueList',

  propTypes: {
    endpoint: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    emptyText: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    query: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    pagination: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    renderEmpty: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    statsPeriod: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    showActions: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    noBorder: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__["default"]],

  getDefaultProps: function getDefaultProps() {
    return {
      pagination: true,
      query: {},
      noBorder: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      issueIds: [],
      loading: true,
      error: false,
      pageLinks: null
    };
  },
  componentWillMount: function componentWillMount() {
    this.fetchData();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var location = this.props.location;
    var nextLocation = nextProps.location;
    if (!location) return;

    if (location.pathname != nextLocation.pathname || location.search != nextLocation.search) {
      this.remountComponent();
    }
  },
  remountComponent: function remountComponent() {
    this.setState(this.getInitialState(), this.fetchData);
  },
  fetchData: function fetchData() {
    var _this = this;

    var location = this.props.location;
    this.api.clear();
    this.api.request(this.props.endpoint, {
      method: 'GET',
      query: _extends({
        cursor: location && location.query && location.query.cursor || ''
      }, this.props.query),
      success: function success(data, _, jqXHR) {
        _this.setState({
          data: data,
          loading: false,
          error: false,
          issueIds: data.map(function (item) {
            return item.id;
          }),
          pageLinks: jqXHR.getResponseHeader('Link')
        });
      },
      error: function error() {
        _this.setState({
          loading: false,
          error: true
        });
      }
    });
  },
  renderResults: function renderResults() {
    var _this2 = this;

    var body = void 0;
    var _props = this.props,
        params = _props.params,
        noBorder = _props.noBorder;


    if (this.state.loading) body = this.renderLoading();else if (this.state.error) body = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_loadingError__["default"], { onRetry: this.fetchData });else if (this.state.issueIds.length > 0) {
      var panelStyle = noBorder ? { border: 0, borderRadius: 0 } : {};

      body = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_app_components_panels__["a" /* Panel */],
        { style: panelStyle },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_app_components_panels__["c" /* PanelBody */],
          { className: 'issue-list' },
          this.state.data.map(function (issue) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_compactIssue__["a" /* default */], {
              key: issue.id,
              id: issue.id,
              data: issue,
              orgId: params.orgId,
              statsPeriod: _this2.props.statsPeriod,
              showActions: _this2.props.showActions
            });
          })
        )
      );
    } else body = (this.props.renderEmpty || this.renderEmpty)();

    return body;
  },
  renderLoading: function renderLoading() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'box' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_loadingIndicator__["default"], null)
    );
  },
  renderEmpty: function renderEmpty() {
    var emptyText = this.props.emptyText;


    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_app_components_panels__["a" /* Panel */],
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_app_views_settings_components_emptyMessage__["a" /* default */],
        { icon: 'icon-circle-exclamation' },
        emptyText ? emptyText : Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Nothing to show here, move along.')
      )
    );
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
      null,
      this.renderResults(),
      this.props.pagination && this.state.pageLinks && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_pagination__["default"], _extends({ pageLinks: this.state.pageLinks }, this.props))
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IssueList);

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_stores_indicatorStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_dropdownLink__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_issues_snoozeAction__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_stream_groupChart__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_stores_groupStore__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_projectLink__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_panels__ = __webpack_require__(18);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var CompactIssueHeader = (_temp2 = _class = function (_React$Component) {
  _inherits(CompactIssueHeader, _React$Component);

  function CompactIssueHeader() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CompactIssueHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CompactIssueHeader.__proto__ || Object.getPrototypeOf(CompactIssueHeader)).call.apply(_ref, [this].concat(args))), _this), _this.getTitle = function () {
      var data = _this.props.data;
      var metadata = data.metadata;
      switch (data.type) {
        case 'error':
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: { marginRight: 10 } },
              metadata.type
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'em',
              null,
              data.culprit
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null)
          );
        case 'csp':
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: { marginRight: 10 } },
              metadata.directive
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'em',
              null,
              metadata.uri
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null)
          );
        case 'default':
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            metadata.title
          );
        default:
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            data.title
          );
      }
    }, _this.getMessage = function () {
      var data = _this.props.data;
      var metadata = data.metadata;
      switch (data.type) {
        case 'error':
          return metadata.value;
        case 'csp':
          return metadata.message;
        default:
          return '';
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CompactIssueHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          orgId = _props.orgId,
          projectId = _props.projectId,
          data = _props.data;


      var styles = {};
      if (data.subscriptionDetails && data.subscriptionDetails.reason === 'mentioned') {
        styles = { color: '#57be8c' };
      }
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_grid_emotion__["Flex"],
          { align: 'center' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_grid_emotion__["Box"],
            { mr: 1 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'error-level truncate', title: data.level })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h3',
            { className: 'truncate' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12_app_components_projectLink__["a" /* default */],
              { to: '/' + orgId + '/' + projectId + '/issues/' + data.id + '/' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon icon-soundoff' }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon icon-star-solid' }),
              this.getTitle()
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'event-extra' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'project-name' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12_app_components_projectLink__["a" /* default */],
              { to: '/' + orgId + '/' + projectId + '/' },
              data.project.slug
            )
          ),
          data.numComments !== 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_app_components_link__["a" /* default */],
              {
                to: '/' + orgId + '/' + projectId + '/issues/' + data.id + '/activity/',
                className: 'comments'
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon icon-comments', style: styles }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'tag-count' },
                data.numComments
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'culprit' },
            this.getMessage()
          )
        )
      );
    }
  }]);

  return CompactIssueHeader;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  orgId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
}, _temp2);


var CompactIssue = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'CompactIssue',

  propTypes: {
    data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    orgId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    statsPeriod: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    showActions: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_3_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_10_app_stores_groupStore__["a" /* default */], 'onGroupChange')],

  getInitialState: function getInitialState() {
    return {
      issue: this.props.data || __WEBPACK_IMPORTED_MODULE_10_app_stores_groupStore__["a" /* default */].get(this.props.id)
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.id != this.props.id) {
      this.setState({
        issue: __WEBPACK_IMPORTED_MODULE_10_app_stores_groupStore__["a" /* default */].get(this.props.id)
      });
    }
  },
  onGroupChange: function onGroupChange(itemIds) {
    if (!itemIds.has(this.props.id)) {
      return;
    }
    var id = this.props.id;
    var issue = __WEBPACK_IMPORTED_MODULE_10_app_stores_groupStore__["a" /* default */].get(id);
    this.setState({
      issue: issue
    });
  },
  onSnooze: function onSnooze(duration) {
    var data = {
      status: 'ignored'
    };

    if (duration) data.ignoreDuration = duration;

    this.onUpdate(data);
  },
  onUpdate: function onUpdate(data) {
    var issue = this.state.issue;
    var loadingIndicator = __WEBPACK_IMPORTED_MODULE_6_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Saving changes..'));

    this.api.bulkUpdate({
      orgId: this.props.orgId,
      projectId: issue.project.slug,
      itemIds: [issue.id],
      data: data
    }, {
      complete: function complete() {
        __WEBPACK_IMPORTED_MODULE_6_app_stores_indicatorStore__["default"].remove(loadingIndicator);
      }
    });
  },
  render: function render() {
    var issue = this.state.issue;

    var className = 'issue';
    if (issue.isBookmarked) {
      className += ' isBookmarked';
    }
    if (issue.hasSeen) {
      className += ' hasSeen';
    }
    if (issue.status === 'resolved') {
      className += ' isResolved';
    }
    if (issue.status === 'ignored') {
      className += ' isIgnored';
    }

    className += ' level-' + issue.level;

    if (this.props.statsPeriod) {
      className += ' with-graph';
    }

    var _props2 = this.props,
        id = _props2.id,
        orgId = _props2.orgId;

    var projectId = issue.project.slug;
    var title = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon-more' });

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_14_app_components_panels__["f" /* PanelItem */],
      {
        className: className,
        onClick: this.toggleSelect,
        direction: 'column',
        style: { paddingTop: '12px', paddingBottom: '6px' }
      },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CompactIssueHeader, { data: issue, orgId: orgId, projectId: projectId }),
      this.props.statsPeriod && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'event-graph' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_stream_groupChart__["a" /* default */], {
          id: id,
          statsPeriod: this.props.statsPeriod,
          data: this.props.data
        })
      ),
      this.props.showActions && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'more-menu-container align-right' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_app_components_dropdownLink__["default"],
          {
            topLevelClasses: 'more-menu',
            className: 'more-menu-toggle',
            caret: false,
            title: title
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'li',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              {
                onClick: this.onUpdate.bind(this, {
                  status: issue.status !== 'resolved' ? 'resolved' : 'unresolved'
                })
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon-checkmark' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'li',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              {
                onClick: this.onUpdate.bind(this, { isBookmarked: !issue.isBookmarked })
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon-star-solid' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'li',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_issues_snoozeAction__["a" /* default */], {
              orgId: orgId,
              projectId: projectId,
              groupId: id,
              onSnooze: this.onSnooze
            })
          ),
          false && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'li',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { href: '#' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon-user' })
            )
          )
        )
      ),
      this.props.children
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (CompactIssue);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_lazyload__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_barChart__ = __webpack_require__(215);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var StyledBarChart = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_4_app_components_barChart__["default"], {
  target: 'etl5vum0'
})('height:24px;');

var GroupChart = (_temp = _class = function (_React$Component) {
  _inherits(GroupChart, _React$Component);

  function GroupChart() {
    _classCallCheck(this, GroupChart);

    return _possibleConstructorReturn(this, (GroupChart.__proto__ || Object.getPrototypeOf(GroupChart)).apply(this, arguments));
  }

  _createClass(GroupChart, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      // Sometimes statsPeriod updates before graph data has been
      // pulled from server / propagated down to components ...
      // don't update until data is available
      var data = nextProps.data,
          statsPeriod = nextProps.statsPeriod;

      return data.hasOwnProperty(statsPeriod);
    }
  }, {
    key: 'render',
    value: function render() {
      var stats = this.props.statsPeriod ? this.props.data.stats[this.props.statsPeriod] : null;
      if (!stats || !stats.length) return null;

      var chartData = stats.map(function (point) {
        return { x: point[0], y: point[1] };
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react_lazyload___default.a,
        { debounce: 50, height: 24 },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StyledBarChart, { points: chartData, label: 'events' })
      );
    }
  }]);

  return GroupChart;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  statsPeriod: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (GroupChart);

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_styles_space__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_mixins_organizationState__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_dropdownLink__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_menuItem__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_projectHeader_projectSelector__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_tooltip__ = __webpack_require__(21);
















var ProjectNav = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'ProjectNav',

  mixins: [__WEBPACK_IMPORTED_MODULE_5_app_mixins_organizationState__["a" /* default */]],

  render: function render() {
    var org = this.getOrganization();
    var access = this.getAccess();
    var hasProjectWrite = access.has('project:write');
    var hasTeamWrite = access.has('team:write');

    var menuItems = [{
      title: Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('Project'),
      to: '/organizations/' + org.slug + '/projects/new/',
      disabled: !hasProjectWrite,
      tooltip: Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('You do not have permission to create new projects')
    }, {
      title: Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('Team'),
      to: '/organizations/' + org.slug + '/teams/new/',
      disabled: !hasTeamWrite,
      tooltip: Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('You do not have permission to create new teams')
    }, {
      title: Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('Member'),
      to: 'settings/' + org.slug + '/members/new/',
      disabled: !hasTeamWrite,
      tooltip: Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('You do not have permission to manage teams')
    }];

    var menuContent = menuItems.reduce(function (acc, item, idx) {
      if (idx > 0) {
        acc.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_menuItem__["default"], { key: idx, divider: true }));
      }
      if (item.disabled) {
        acc.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { role: 'presentation', key: item.title, disabled: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_app_components_tooltip__["default"],
            { title: item.tooltip },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              item.title
            )
          )
        ));
      } else {
        acc.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_app_components_menuItem__["default"],
          {
            title: item.title,
            to: item.to,
            key: item.title,
            disabled: item.disabled
          },
          item.title
        ));
      }

      return acc;
    }, []);

    var title = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_app_components_buttons_button__["default"],
      { size: 'small' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('Add new...')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'icon-arrow-down' })
    );

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      StyledNav,
      { justify: 'space-between', align: 'center' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Box"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_projectHeader_projectSelector__["default"], { organization: org })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledDropdown,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_app_components_dropdownLink__["default"],
          { title: title, anchorRight: true, caret: false },
          menuContent
        )
      )
    );
  }
});

var StyledNav = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Flex"], {
  target: 'e1li62g80'
})('font-size:20px;border-bottom:1px solid ', function (p) {
  return p.theme.borderLight;
}, ';box-shadow:', function (p) {
  return p.theme.dropShadowLight;
}, ';background-color:white;padding:', Object(__WEBPACK_IMPORTED_MODULE_4_app_styles_space__["a" /* default */])(2), ' ', Object(__WEBPACK_IMPORTED_MODULE_4_app_styles_space__["a" /* default */])(4), ';');

var StyledDropdown = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e1li62g81'
})('.dropdown-menu:after,.dropdown-menu:before{display:none;}.icon-arrow-down{top:1px;font-size:12px !important;color:', function (p) {
  return p.theme.gray1;
}, ';margin-left:', Object(__WEBPACK_IMPORTED_MODULE_4_app_styles_space__["a" /* default */])(0.5), ';}li[role=\'presentation\'] a:hover{color:white;background-color:', function (p) {
  return p.theme.purpleDark;
}, ';}li[disabled]{color:', function (p) {
  return p.theme.gray1;
}, ';padding:3px 10px;}');

/* harmony default export */ __webpack_exports__["a"] = (ProjectNav);

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(1164),
    baseIteratee = __webpack_require__(123),
    toInteger = __webpack_require__(391);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */
function findLastIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length - 1;
  if (fromIndex !== undefined) {
    index = toInteger(fromIndex);
    index = fromIndex < 0
      ? nativeMax(length + index, 0)
      : nativeMin(index, length - 1);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index, true);
}

module.exports = findLastIndex;


/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_utils_analytics__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_stores_configStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_views_planout_installReact__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_views_projectInstall_languageNav__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_components_errors_notFound__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_views_settings_components_text_textBlock__ = __webpack_require__(81);



















var ProjectInstallPlatform = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'ProjectInstallPlatform',

  propTypes: {
    platformData: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
    linkPath: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_7_app_mixins_apiMixin__["default"]],

  getDefaultProps: function getDefaultProps() {
    return {
      linkPath: function linkPath(orgId, projectId, platform) {
        return '/' + orgId + '/' + projectId + '/settings/install/' + platform + '/';
      }
    };
  },
  getInitialState: function getInitialState(props) {
    props = props || this.props;
    var params = props.params;
    var key = params.platform;
    var integration = void 0;
    var platform = void 0;

    props.platformData.platforms.forEach(function (p_item) {
      if (integration) {
        return;
      }
      integration = p_item.integrations.filter(function (i_item) {
        return i_item.id == key;
      })[0];
      if (integration) {
        platform = p_item;
      }
    });

    return {
      loading: true,
      error: false,
      integration: integration,
      platform: platform,
      html: null,
      experimentPlatforms: new Set(['javascript-react'])
    };
  },
  componentDidMount: function componentDidMount() {
    this.fetchData();
    $(window).scrollTop(0);
    this.recordAnalytics();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.params.platform !== this.props.params.platform) {
      this.setState(this.getInitialState(nextProps), this.fetchData);
      $(window).scrollTop(0);
    }
  },
  isGettingStarted: function isGettingStarted() {
    return location.href.indexOf('getting-started') > 0;
  },
  fetchData: function fetchData() {
    var _this = this;

    var _props$params = this.props.params,
        orgId = _props$params.orgId,
        projectId = _props$params.projectId,
        platform = _props$params.platform;

    this.api.request('/projects/' + orgId + '/' + projectId + '/docs/' + platform + '/', {
      success: function success(data) {
        _this.setState({
          loading: false,
          error: false,
          html: data.html
        });
      },
      error: function error() {
        _this.setState({
          loading: false,
          error: true
        });
      }
    });
  },
  getPlatformLink: function getPlatformLink(platform, display) {
    var _props$params2 = this.props.params,
        orgId = _props$params2.orgId,
        projectId = _props$params2.projectId;

    var path = this.props.linkPath(orgId, projectId, platform);
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_12_app_components_link__["a" /* default */],
      { key: platform, to: path, className: 'list-group-item' },
      display || platform
    );
  },
  inInstallExperiment: function inInstallExperiment() {
    var _state = this.state,
        experimentPlatforms = _state.experimentPlatforms,
        integration = _state.integration;

    if (!integration.id) return;

    var currentPlatform = integration.id;
    var installExperiment = __WEBPACK_IMPORTED_MODULE_9_app_stores_configStore__["default"].get('features').has('install-experiment') && experimentPlatforms.has(currentPlatform);
    return installExperiment;
  },
  recordAnalytics: function recordAnalytics() {
    var _state2 = this.state,
        experimentPlatforms = _state2.experimentPlatforms,
        integration = _state2.integration;


    if (!integration || !experimentPlatforms.has(integration.id)) return;

    Object(__WEBPACK_IMPORTED_MODULE_6_app_utils_analytics__["a" /* default */])('experiment.installation_instructions', {
      integration: integration.id,
      experiment: this.inInstallExperiment()
    });
  },
  renderSidebar: function renderSidebar() {
    var _this2 = this;

    var platform = this.state.platform;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'install-sidebar col-md-2' },
      this.props.platformData.platforms.map(function (p_item) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_app_views_projectInstall_languageNav__["a" /* default */],
          {
            key: p_item.id,
            name: p_item.name,
            active: platform && platform.id === p_item.id
          },
          p_item.integrations.map(function (i_item) {
            return _this2.getPlatformLink(i_item.id, i_item.id === p_item.id ? Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Generic') : i_item.name);
          })
        );
      })
    );
  },
  renderBody: function renderBody() {
    var _state3 = this.state,
        integration = _state3.integration,
        platform = _state3.platform;
    var _props$params3 = this.props.params,
        orgId = _props$params3.orgId,
        projectId = _props$params3.projectId;


    if (!integration || !platform) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_app_components_errors_notFound__["a" /* default */], null);
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_app_components_panels__["a" /* Panel */],
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_app_components_panels__["e" /* PanelHeader */],
        { hasButtons: true },
        Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Configure %(integration)s', { integration: integration.name }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_app_components_buttons_button__["default"],
          { size: 'small', href: integration.link, external: true },
          Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Full Documentation')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_app_components_panels__["c" /* PanelBody */],
        { disablePadding: false },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_16_app_views_settings_components_text_textBlock__["default"],
          null,
          Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["tct"])('\n             This is a quick getting started guide. For in-depth instructions\n             on integrating Sentry with [integration], view\n             [docLink:our complete documentation].\n            ', {
            integration: integration.name,
            docLink: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { href: integration.link })
          })
        ),
        this.state.loading ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_app_components_loadingIndicator__["default"], null) : this.state.error ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_app_components_loadingError__["default"], { onRetry: this.fetchData }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DocumentationWrapper, { dangerouslySetInnerHTML: { __html: this.state.html } }),
        this.isGettingStarted() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_app_components_buttons_button__["default"],
          {
            priority: 'primary',
            size: 'large',
            to: '/' + orgId + '/' + projectId + '/#welcome',
            style: { marginTop: 20 }
          },
          Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Got it! Take me to the Issue Stream.')
        )
      )
    );
  },
  renderTestBody: function renderTestBody() {
    var _state4 = this.state,
        integration = _state4.integration,
        platform = _state4.platform;
    var dsnPublic = this.props.platformData.dsnPublic;
    var _props$params4 = this.props.params,
        orgId = _props$params4.orgId,
        projectId = _props$params4.projectId;


    if (!integration || !platform) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_app_components_errors_notFound__["a" /* default */], null);
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_app_components_panels__["a" /* Panel */],
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_app_components_panels__["e" /* PanelHeader */],
        { hasButtons: true },
        Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Configure %(integration)s', { integration: integration.name }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_app_components_buttons_button__["default"],
          { size: 'small', href: integration.link, external: true },
          Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Full Documentation')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_app_components_panels__["c" /* PanelBody */],
        { disablePadding: false },
        this.state.loading ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_app_components_loadingIndicator__["default"], null) : this.state.error ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_app_components_loadingError__["default"], { onRetry: this.fetchData }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_views_planout_installReact__["a" /* default */], { dsn: dsnPublic }),
        this.isGettingStarted() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_app_components_buttons_button__["default"],
          {
            priority: 'primary',
            size: 'large',
            to: '/' + orgId + '/' + projectId + '/#welcome',
            style: { marginTop: 20 }
          },
          Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Got it! Take me to the Issue Stream.')
        )
      )
    );
  },
  render: function render() {
    var installExperiment = void 0;
    if (!this.state.loading) {
      installExperiment = this.inInstallExperiment();
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'install row' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'install-content col-md-10' },
        installExperiment ? this.renderTestBody() : this.renderBody()
      ),
      this.renderSidebar()
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ProjectInstallPlatform);

var DocumentationWrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e1w9lqpk0'
})('p{line-height:1.5;}pre{word-break:break-all;white-space:pre-wrap;}');
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_document_title__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_actionCreators_organizations__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_broadcastModal__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_stores_configStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_stores_hookStore__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_actions_projectActions__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_stores_projectsStore__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_stores_teamStore__ = __webpack_require__(150);



















var ERROR_TYPES = {
  ORG_NOT_FOUND: 'ORG_NOT_FOUND'
};

var OrganizationContext = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'OrganizationContext',

  childContextTypes: {
    organization: __WEBPACK_IMPORTED_MODULE_15_app_proptypes__["e" /* default */].Organization
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_7_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_2_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_13_app_actions_projectActions__["a" /* default */].createSuccess, 'onProjectCreation')],

  getInitialState: function getInitialState() {
    return {
      loading: true,
      error: false,
      errorType: null,
      organization: null,
      showBroadcast: false
    };
  },
  getChildContext: function getChildContext() {
    return {
      organization: this.state.organization
    };
  },
  componentWillMount: function componentWillMount() {
    this.fetchData();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.params.orgId !== this.props.params.orgId || nextProps.location.state === 'refresh') {
      this.remountComponent();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_16_app_stores_teamStore__["a" /* default */].reset();
  },
  remountComponent: function remountComponent() {
    this.setState(this.getInitialState(), this.fetchData);
  },
  onProjectCreation: function onProjectCreation(project) {
    // If a new project was created, we need to re-fetch the
    // org details endpoint, which will propagate re-rendering
    // for the entire component tree
    this.remountComponent();
  },
  fetchData: function fetchData() {
    var _this = this;

    this.api.request(this.getOrganizationDetailsEndpoint(), {
      success: function success(data) {
        // Allow injection via getsentry et all
        var hooks = [];
        __WEBPACK_IMPORTED_MODULE_10_app_stores_hookStore__["default"].get('organization:header').forEach(function (cb) {
          hooks.push(cb(data));
        });

        Object(__WEBPACK_IMPORTED_MODULE_5_app_actionCreators_organizations__["d" /* setActiveOrganization */])(data);

        __WEBPACK_IMPORTED_MODULE_16_app_stores_teamStore__["a" /* default */].loadInitialData(data.teams);
        __WEBPACK_IMPORTED_MODULE_14_app_stores_projectsStore__["a" /* default */].loadInitialData(data.projects);

        _this.setState({
          organization: data,
          loading: false,
          error: false,
          errorType: null,
          hooks: hooks,
          showBroadcast: _this.shouldShowBroadcast(data)
        });
      },

      error: function error(_, textStatus, errorThrown) {
        var errorType = null;
        switch (errorThrown) {
          case 'NOT FOUND':
            errorType = ERROR_TYPES.ORG_NOT_FOUND;
            break;
          default:
        }
        _this.setState({
          loading: false,
          error: true,
          errorType: errorType
        });
      }
    });
  },
  getOrganizationDetailsEndpoint: function getOrganizationDetailsEndpoint() {
    return '/organizations/' + this.props.params.orgId + '/';
  },
  getTitle: function getTitle() {
    if (this.state.organization) return this.state.organization.name;
    return 'Sentry';
  },
  shouldShowBroadcast: function shouldShowBroadcast(data) {
    var user = __WEBPACK_IMPORTED_MODULE_9_app_stores_configStore__["default"].get('user');
    var options = user ? user.options : {};
    var seen = options.seenReleaseBroadcast;
    var tasks = data.onboardingTasks;
    // don't show broadcast they've seen it
    if (seen) {
      return false;
    }

    // also if they havn't sent their first event
    var sentFirstEvent = tasks.find(function (_ref) {
      var task = _ref.task,
          status = _ref.status;
      return task == 2 && status == 'complete';
    });

    if (!sentFirstEvent) {
      return false;
    }

    // show it if they sent their first event more than 2 days ago
    return __WEBPACK_IMPORTED_MODULE_4_moment___default()().diff(sentFirstEvent.dateCompleted, 'days') > 2;
  },
  closeBroadcast: function closeBroadcast() {
    this.setState({ showBroadcast: false });
  },
  render: function render() {
    if (this.state.loading) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_app_components_loadingIndicator__["default"],
        { triangle: true },
        Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Loading data for your organization.')
      );
    } else if (this.state.error) {
      switch (this.state.errorType) {
        case ERROR_TYPES.ORG_NOT_FOUND:
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'container' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'alert alert-block' },
              Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('The organization you were looking for was not found.')
            )
          );
        default:
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_loadingError__["default"], { onRetry: this.remountComponent });
      }
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_document_title___default.a,
      { title: this.getTitle() },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'app' },
        this.state.hooks,
        this.state.showBroadcast && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_broadcastModal__["a" /* default */], { closeBroadcast: this.closeBroadcast }),
        this.props.children
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (OrganizationContext);

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);









var ErrorRobot = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'ErrorRobot',

  propTypes: {
    org: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    project: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    // sampleIssueId can have 3 values:
    // - empty string to indicate it doesn't exist (render "create sample event")
    // - non-empty string to indicate it exists (render "see sample event")
    // - null/undefined to indicate the project API should be consulted to find out
    sampleIssueId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    gradient: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    return {
      error: false,
      loading: this.props.sampleIssueId === null || this.props.sampleIssueId === undefined,
      sampleIssueId: this.props.sampleIssueId
    };
  },
  componentWillMount: function componentWillMount() {
    this.fetchData();
  },
  fetchData: function fetchData() {
    var _this = this;

    var _props = this.props,
        org = _props.org,
        project = _props.project;
    var sampleIssueId = this.state.sampleIssueId;


    if (sampleIssueId === null || sampleIssueId === undefined) {
      var url = '/projects/' + org.slug + '/' + project.slug + '/issues/';
      var requestParams = { limit: 1 };
      this.api.request(url, {
        method: 'GET',
        data: requestParams,
        success: function success(data, ignore, jqXHR) {
          _this.setState({
            loading: false,
            sampleIssueId: data.length > 0 && data[0].id || ''
          });
        },
        error: function error(err) {
          var error = err.responseJSON || true;
          error = error.detail || true;
          _this.setState({
            error: error,
            loading: false
          });
        }
      });
    }
  },
  createSampleEvent: function createSampleEvent() {
    var _props2 = this.props,
        org = _props2.org,
        project = _props2.project;

    var url = '/projects/' + org.slug + '/' + project.slug + '/create-sample/';
    this.api.request(url, {
      method: 'POST',
      success: function success(data) {
        __WEBPACK_IMPORTED_MODULE_2_react_router__["browserHistory"].push('/' + org.slug + '/' + project.slug + '/issues/' + data.groupID + '/');
      }
    });
  },
  render: function render() {
    var _state = this.state,
        loading = _state.loading,
        error = _state.error,
        sampleIssueId = _state.sampleIssueId;
    var _props3 = this.props,
        org = _props3.org,
        project = _props3.project,
        gradient = _props3.gradient;

    var sampleLink = void 0;

    if (!loading && !error) {
      sampleLink = sampleIssueId === '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { onClick: this.createSampleEvent },
          Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Create a sample event')
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
          { to: '/' + org.slug + '/' + project.slug + '/issues/' + sampleIssueId + '/?sample' },
          Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Or see your sample event')
        )
      );
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ErrorRobotWrapper,
      {
        'data-test-id': 'awaiting-events',
        className: 'awaiting-events',
        gradient: gradient
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'wrap' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'robot' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'eye' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          'Waiting for events\u2026'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              'Our error robot is waiting to '
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'strikethrough' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'devour'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              ' receive your first event.'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
            {
              to: '/' + org.slug + '/' + project.slug + '/getting-started/' + (project.platform || ''),
              className: 'btn btn-primary btn-lg'
            },
            Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Installation Instructions')
          )
        ),
        sampleLink
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ErrorRobot);

var ErrorRobotWrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('div', {
  target: 'e7uylsl0'
})('box-shadow:inset 0 1px 3px rgba(0,0,0,0.08);border-radius:0 0 3px 3px;', function (p) {
  return p.gradient ? '\n          background-image: linear-gradient(to bottom, #F8F9FA, #ffffff);\n         ' : '';
}, ';');

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hideSidebar;
/* harmony export (immutable) */ __webpack_exports__["c"] = showSidebar;
/* harmony export (immutable) */ __webpack_exports__["b"] = loadPreferencesState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_preferencesActions__ = __webpack_require__(552);




var SIDEBAR_COOKIE_KEY = 'sidebar_collapsed';
var COOKIE_ENABLED = '1';
var COOKIE_DISABLED = '0';

function hideSidebar() {
  __WEBPACK_IMPORTED_MODULE_1__actions_preferencesActions__["a" /* default */].hideSidebar();
  __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(SIDEBAR_COOKIE_KEY, COOKIE_ENABLED);
}

function showSidebar() {
  __WEBPACK_IMPORTED_MODULE_1__actions_preferencesActions__["a" /* default */].showSidebar();
  __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(SIDEBAR_COOKIE_KEY, COOKIE_DISABLED);
}

function loadPreferencesState() {
  // Set initial "collapsed" state to true or false
  __WEBPACK_IMPORTED_MODULE_1__actions_preferencesActions__["a" /* default */].loadInitialState({
    collapsed: __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(SIDEBAR_COOKIE_KEY) === COOKIE_ENABLED
  });
}

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);


var PreferencesActions = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['loadInitialState', 'hideSidebar', 'showSidebar']);

/* harmony default export */ __webpack_exports__["a"] = (PreferencesActions);

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['update', 'updateError', 'updateSuccess']));

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_emotion__ = __webpack_require__(5);


var SidebarPanelEmpty = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react_emotion__["default"])('div', {
  target: 'e1i6ba8c0'
})('color:#9586a5;text-align:center;width:100%;position:absolute;top:50%;padding:0 60px;margin-top:-23px;/* offset for sidebar-panel-header + font-size */');

/* harmony default export */ __webpack_exports__["a"] = (SidebarPanelEmpty);

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sidebarOrgSummary__ = __webpack_require__(360);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var SidebarMenuItem = (_temp = _class = function (_React$Component) {
  _inherits(SidebarMenuItem, _React$Component);

  function SidebarMenuItem() {
    _classCallCheck(this, SidebarMenuItem);

    return _possibleConstructorReturn(this, (SidebarMenuItem.__proto__ || Object.getPrototypeOf(SidebarMenuItem)).apply(this, arguments));
  }

  _createClass(SidebarMenuItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          to = _props.to,
          href = _props.href,
          props = _objectWithoutProperties(_props, ['children', 'to', 'href']);

      var hasMenu = !to && !href;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        MenuItemLink,
        _extends({ to: to, href: href }, props),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          MenuItemLabel,
          { hasMenu: hasMenu },
          children
        )
      );
    }
  }]);

  return SidebarMenuItem;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (SidebarMenuItem);

var MenuItemLabel = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('span', {
  target: 'ebifsjx0'
})('flex:1;', function (p) {
  return p.hasMenu ? /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["css"])('margin:0 -15px;padding:0 15px;') : /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["css"])('overflow:hidden;');
}, ';');

var MenuItemLink = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(function (_ref) {
  var to = _ref.to,
      href = _ref.href,
      props = _objectWithoutProperties(_ref, ['to', 'href']);

  if (to || href) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_link__["a" /* default */], _extends({ to: to, href: href }, props));
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', props);
}, {
  target: 'ebifsjx1'
})('color:', function (p) {
  return p.theme.gray5;
}, ';cursor:pointer;display:flex;font-size:14px;line-height:32px;padding:0 ', function (p) {
  return p.theme.sidebar.menuSpacing;
}, ';position:relative;transition:0.1s all linear;', function (p) {
  return (!!p.to || !!p.href) && 'overflow: hidden';
}, ';&:hover,&:active{background:', function (p) {
  return p.theme.offWhite;
}, ';color:', function (p) {
  return p.theme.gray5;
}, ';}/* stylelint-disable-next-line no-duplicate-selectors */\n  ', __WEBPACK_IMPORTED_MODULE_4__sidebarOrgSummary__["a" /* OrgSummary */], '{padding-left:0;padding-right:0;}');

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_emotion__ = __webpack_require__(5);


var Divider = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react_emotion__["default"])('div', {
  target: 'ek5mfa70'
})('height:0;border-bottom:1px solid ', function (p) {
  return p.theme.borderLight;
}, ';margin:5px 0;');
/* harmony default export */ __webpack_exports__["a"] = (Divider);

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_emotion__ = __webpack_require__(5);


var SidebarDropdownMenu = function SidebarDropdownMenu(p) {
  return (/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react_emotion__["css"])('position:absolute;background:', p.theme.white, ';color:', p.theme.gray5, ';border-radius:4px;box-shadow:0 0 0 1px rgba(0,0,0,0.08),0 4px 20px 0 rgba(0,0,0,0.3);padding:5px 0;width:250px;z-index:1000;')
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SidebarDropdownMenu);

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idx__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_actionCreators_indicator__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_views_asyncView__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_views_settings_components_emptyMessage__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_stores_configStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_assistant_guideAnchor__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_views_settings_components_forms_controls_input__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_pagination__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_views_settings_components_settingsPageHeader__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_utils_recreateRoute__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__organizationAccessRequests__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__organizationMemberRow__ = __webpack_require__(1236);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var OrganizationMembersView = (_temp2 = _class = function (_AsyncView) {
  _inherits(OrganizationMembersView, _AsyncView);

  function OrganizationMembersView() {
    var _ref5;

    var _temp, _this, _ret;

    _classCallCheck(this, OrganizationMembersView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref5 = OrganizationMembersView.__proto__ || Object.getPrototypeOf(OrganizationMembersView)).call.apply(_ref5, [this].concat(args))), _this), _this.handleSearch = function (e) {
      var router = _this.context.router;
      var location = _this.props.location;

      e.preventDefault();
      router.push({
        pathname: location.pathname,
        query: {
          query: _this.state.searchQuery
        }
      });
    }, _this.removeMember = function (id) {
      var params = _this.props.params;

      var _ref6 = params || {},
          orgId = _ref6.orgId;

      return new Promise(function (resolve, reject) {
        _this.api.request('/organizations/' + orgId + '/members/' + id + '/', {
          method: 'DELETE',
          data: {},
          success: function success(data) {
            _this.setState(function (state) {
              return {
                members: state.members.filter(function (_ref7) {
                  var existingId = _ref7.id;
                  return existingId !== id;
                })
              };
            });
            resolve(data);
          },
          error: function error(err) {
            return reject(err);
          }
        });
      });
    }, _this.approveOrDeny = function (isApproved, id) {
      var params = _this.props.params;

      var _ref8 = params || {},
          orgId = _ref8.orgId;

      _this.setState(function (state) {
        return {
          accessRequestBusy: state.accessRequestBusy.set(id, true)
        };
      });

      return new Promise(function (resolve, reject) {
        _this.api.request('/organizations/' + orgId + '/access-requests/' + id + '/', {
          method: 'PUT',
          data: { isApproved: isApproved },
          success: function success(data) {
            _this.setState(function (state) {
              return {
                requestList: state.requestList.filter(function (_ref9) {
                  var existingId = _ref9.id;
                  return existingId !== id;
                })
              };
            });
            resolve(data);
          },
          error: function error(err) {
            return reject(err);
          },
          complete: function complete() {
            return _this.setState(function (state) {
              return {
                accessRequestBusy: state.accessRequestBusy.set(id, false)
              };
            });
          }
        });
      });
    }, _this.handleApprove = function (id) {
      return _this.approveOrDeny(true, id);
    }, _this.handleDeny = function (id) {
      return _this.approveOrDeny(false, id);
    }, _this.handleRemove = function (_ref10, e) {
      var id = _ref10.id,
          name = _ref10.name;
      var organization = _this.context.organization;
      var orgName = organization.slug;


      _this.removeMember(id).then(function () {
        return Object(__WEBPACK_IMPORTED_MODULE_5_app_actionCreators_indicator__["d" /* addSuccessMessage */])(Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["tct"])('Removed [name] from [orgName]', {
          name: name,
          orgName: orgName
        }));
      }, function () {
        return Object(__WEBPACK_IMPORTED_MODULE_5_app_actionCreators_indicator__["a" /* addErrorMessage */])(Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["tct"])('Error removing [name] from [orgName]', {
          name: name,
          orgName: orgName
        }));
      });
    }, _this.handleLeave = function (_ref11, e) {
      var id = _ref11.id;
      var organization = _this.context.organization;
      var orgName = organization.slug;


      _this.removeMember(id).then(function () {
        return Object(__WEBPACK_IMPORTED_MODULE_5_app_actionCreators_indicator__["d" /* addSuccessMessage */])(Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["tct"])('You left [orgName]', {
          orgName: orgName
        }));
      }, function () {
        return Object(__WEBPACK_IMPORTED_MODULE_5_app_actionCreators_indicator__["a" /* addErrorMessage */])(Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["tct"])('Error leaving [orgName]', {
          orgName: orgName
        }));
      });
    }, _this.handleSendInvite = function (_ref12) {
      var id = _ref12.id;

      _this.setState(function (state) {
        return {
          invited: state.invited.set(id, 'loading')
        };
      });

      _this.api.request('/organizations/' + _this.props.params.orgId + '/members/' + id + '/', {
        method: 'PUT',
        data: { reinvite: 1 },
        success: function success(data) {
          return _this.setState(function (state) {
            return {
              invited: state.invited.set(id, 'success')
            };
          });
        },
        error: function error() {
          _this.setState(function (state) {
            return {
              invited: state.invited.set(id, null)
            };
          });
          Object(__WEBPACK_IMPORTED_MODULE_5_app_actionCreators_indicator__["a" /* addErrorMessage */])(Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Error sending invite'));
        }
      });
    }, _this.handleChange = function (evt) {
      var searchQuery = evt.target.value;
      _this.getMembers(searchQuery);
      _this.setState({ searchQuery: searchQuery });
    }, _this.getMembers = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function (searchQuery) {
      var params = _this.props.params;

      var _ref13 = params || {},
          orgId = _ref13.orgId;

      _this.api.request('/organizations/' + orgId + '/members/?query=' + searchQuery, {
        method: 'GET',
        success: function success(data, _, jqXHR) {
          _this.handleRequestSuccess({ stateKey: 'members', data: data, jqXHR: jqXHR });
        }
      });
    }, 200), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OrganizationMembersView, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps, nextContext) {
      var _ref, _ref2;

      _get(OrganizationMembersView.prototype.__proto__ || Object.getPrototypeOf(OrganizationMembersView.prototype), 'componentWillReceiveProps', this).call(this, nextProps, nextContext);
      var searchQuery = (_ref = nextProps) != null ? (_ref = _ref.location) != null ? (_ref = _ref.query) != null ? _ref.query : _ref : _ref : _ref;
      if (searchQuery !== ((_ref2 = this.props) != null ? (_ref2 = _ref2.location) != null ? (_ref2 = _ref2.query) != null ? _ref2.query : _ref2 : _ref2 : _ref2)) {
        this.setState({ searchQuery: searchQuery });
      }
    }

    // XXX(billy): setState causes re-render of the entire view...
    // we should not do this

  }, {
    key: 'getDefaultState',
    value: function getDefaultState() {
      var _ref3;

      var state = _get(OrganizationMembersView.prototype.__proto__ || Object.getPrototypeOf(OrganizationMembersView.prototype), 'getDefaultState', this).call(this);
      return _extends({}, state, {
        members: [],
        invited: new Map(),
        accessRequestBusy: new Map(),
        searchQuery: ((_ref3 = this.props) != null ? (_ref3 = _ref3.location) != null ? (_ref3 = _ref3.query) != null ? _ref3.query : _ref3 : _ref3 : _ref3) || ''
      });
    }
  }, {
    key: 'getEndpoints',
    value: function getEndpoints() {
      var _ref4;

      return [['members', '/organizations/' + this.props.params.orgId + '/members/', {
        query: {
          query: (_ref4 = this.props) != null ? (_ref4 = _ref4.location) != null ? (_ref4 = _ref4.query) != null ? _ref4.query : _ref4 : _ref4 : _ref4
        }
      }, { paginate: true }], ['authProvider', '/organizations/' + this.props.params.orgId + '/auth-provider/', {}, {
        allowError: function allowError(error) {
          // Allow for 403s
          return error.status === 403;
        }
      }], ['requestList', '/organizations/' + this.props.params.orgId + '/access-requests/']];
    }
  }, {
    key: 'getTitle',
    value: function getTitle() {
      var org = this.context.organization;
      return org.name + ' Members';
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _this2 = this;

      var _props = this.props,
          params = _props.params,
          routes = _props.routes;
      var _state = this.state,
          membersPageLinks = _state.membersPageLinks,
          members = _state.members,
          requestList = _state.requestList;
      var organization = this.context.organization;

      var _ref14 = params || {},
          orgId = _ref14.orgId;

      var orgName = organization.name,
          access = organization.access;

      var canAddMembers = access.indexOf('org:write') > -1;
      var canRemove = access.indexOf('member:admin') > -1;
      var currentUser = __WEBPACK_IMPORTED_MODULE_10_app_stores_configStore__["default"].get('user');
      // Find out if current user is the only owner
      var isOnlyOwner = !members.find(function (_ref15) {
        var role = _ref15.role,
            email = _ref15.email;
        return role === 'owner' && email !== currentUser.email;
      });
      // Only admins/owners can remove members
      var requireLink = !!this.state.authProvider && this.state.authProvider.require_link;

      var action = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_app_components_buttons_button__["default"],
        {
          priority: 'primary',
          size: 'small',
          disabled: !canAddMembers,
          title: !canAddMembers ? Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('You do not have enough permission to add new members') : undefined,
          to: Object(__WEBPACK_IMPORTED_MODULE_16_app_utils_recreateRoute__["a" /* default */])('new/', { routes: routes, params: params }),
          icon: 'icon-circle-add'
        },
        Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Invite Member')
      );

      if (canAddMembers) action = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_app_components_assistant_guideAnchor__["default"],
        { target: 'member_add', type: 'invisible' },
        action
      );

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_app_views_settings_components_settingsPageHeader__["default"], { title: 'Members', action: action }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__organizationAccessRequests__["a" /* default */], {
          onApprove: this.handleApprove,
          onDeny: this.handleDeny,
          accessRequestBusy: this.state.accessRequestBusy,
          requestList: requestList
        }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_app_components_panels__["a" /* Panel */],
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_app_components_panels__["e" /* PanelHeader */],
            { hasButtons: true },
            Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Member'),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'form',
              { onSubmit: this.handleSearch },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_views_settings_components_forms_controls_input__["a" /* default */], {
                value: this.state.searchQuery,
                onChange: this.handleChange,
                className: 'search',
                placeholder: Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Search Members')
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_app_components_panels__["c" /* PanelBody */],
            null,
            members.map(function (member) {
              return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__organizationMemberRow__["a" /* default */], {
                routes: routes,
                params: params,
                key: member.id,
                member: member,
                status: _this2.state.invited.get(member.id),
                orgId: orgId,
                orgName: orgName,
                memberCanLeave: !isOnlyOwner,
                currentUser: currentUser,
                canRemoveMembers: canRemove,
                canAddMembers: canAddMembers,
                requireLink: requireLink,
                onSendInvite: _this2.handleSendInvite,
                onRemove: _this2.handleRemove,
                onLeave: _this2.handleLeave,
                firstRow: members.indexOf(member) === 0
              });
            }),
            members.length === 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_app_views_settings_components_emptyMessage__["a" /* default */],
              null,
              Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('No members found.')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_app_components_pagination__["default"], { pageLinks: membersPageLinks })
      );
    }
  }]);

  return OrganizationMembersView;
}(__WEBPACK_IMPORTED_MODULE_7_app_views_asyncView__["default"]), _class.propTypes = {
  routes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
}, _class.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  organization: __WEBPACK_IMPORTED_MODULE_14_app_proptypes__["e" /* default */].Organization
}, _temp2);


/* harmony default export */ __webpack_exports__["default"] = (OrganizationMembersView);

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);


var PluginActions = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['update', 'updateError', 'updateSuccess', 'fetchAll', 'fetchAllSuccess', 'fetchAllError']);

/* harmony default export */ __webpack_exports__["a"] = (PluginActions);

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_actionCreators_plugins__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_pluginList__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_views_settings_components_settingsPageHeader__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_views_settings_components_text_textBlock__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_utils_withPlugins__ = __webpack_require__(226);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var ProjectIssueTracking = (_temp = _class = function (_React$Component) {
  _inherits(ProjectIssueTracking, _React$Component);

  function ProjectIssueTracking() {
    _classCallCheck(this, ProjectIssueTracking);

    return _possibleConstructorReturn(this, (ProjectIssueTracking.__proto__ || Object.getPrototypeOf(ProjectIssueTracking)).apply(this, arguments));
  }

  _createClass(ProjectIssueTracking, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _ref = this.props.params || {},
          projectId = _ref.projectId,
          orgId = _ref.orgId;

      Object(__WEBPACK_IMPORTED_MODULE_1_app_actionCreators_plugins__["c" /* fetchPlugins */])({ projectId: projectId, orgId: orgId });
    }
  }, {
    key: 'render',
    value: function render() {
      var _context = this.context,
          organization = _context.organization,
          project = _context.project;

      var _ref2 = this.props.plugins || {},
          loading = _ref2.loading,
          plugins = _ref2.plugins;

      if (loading || !project || !plugins) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_loadingIndicator__["default"], null);
      }

      var issueTrackingPlugins = plugins.filter(function (plugin) {
        return plugin.type === 'issue-tracking' && plugin.hasConfiguration;
      });

      if (issueTrackingPlugins.length) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ref-issue-tracking-settings' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_views_settings_components_settingsPageHeader__["default"], { title: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Issue Tracking') }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_app_views_settings_components_text_textBlock__["default"],
            null,
            Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Enabling Issue Tracking will let you quickly create tasks within your existing\n            tools. You\'ll find the new action on an issue\'s details page. Once you create\n            an issue, you\'ll find a helpful annotation and link to the task in your\n            project management tool.')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_pluginList__["a" /* default */], {
            organization: organization,
            project: project,
            pluginList: issueTrackingPlugins
          })
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'alert alert-info alert-block' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('There are no issue tracker integrations available. Ask your Sentry team about\n            integrating with your favorite project management tools.')
          )
        );
      }
    }
  }]);

  return ProjectIssueTracking;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.contextTypes = {
  organization: __WEBPACK_IMPORTED_MODULE_5_app_proptypes__["e" /* default */].Organization,
  project: __WEBPACK_IMPORTED_MODULE_5_app_proptypes__["e" /* default */].Project
}, _class.propTypes = {
  plugins: __WEBPACK_IMPORTED_MODULE_5_app_proptypes__["e" /* default */].PluginsStore
}, _temp);


/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_8_app_utils_withPlugins__["a" /* default */])(ProjectIssueTracking));

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_avatar_avatarList__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);








var ReleaseStats = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'ReleaseStats',

  propTypes: {
    release: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
  },

  render: function render() {
    var release = this.props.release;
    var commitCount = release.commitCount || 0;
    var authorCount = release.authors && release.authors.length || 0;
    if (commitCount === 0) {
      return null;
    }

    var releaseSummary = commitCount + Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])(commitCount !== 1 ? ' commits ' : ' commit ') + Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('by ') + authorCount + Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])(authorCount !== 1 ? ' authors' : ' author');

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'release-stats' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        ReleaseSummaryHeading,
        null,
        releaseSummary
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { style: { display: 'inline-block' } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_avatar_avatarList__["a" /* default */], { users: release.authors, avatarSize: 25, typeMembers: 'authors' })
      )
    );
  }
});

var ReleaseSummaryHeading = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'eyl9sdc0'
})('color:', function (p) {
  return p.theme.gray2;
}, ';font-size:12px;line-height:1.2;font-weight:600;text-transform:uppercase;margin-bottom:4px;');

/* harmony default export */ __webpack_exports__["a"] = (ReleaseStats);

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_groupListHeader__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_stores_groupStore__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_mixins_projectState__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_stream_group__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_components_emptyStateWarning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_components_panels__ = __webpack_require__(18);



















var GroupList = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'GroupList',

  propTypes: {
    query: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    canSelectGroups: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    orgId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    environment: __WEBPACK_IMPORTED_MODULE_5_app_proptypes__["e" /* default */].Environment
  },

  contextTypes: {
    location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_11_app_mixins_projectState__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_8_app_stores_groupStore__["a" /* default */], 'onGroupChange'), __WEBPACK_IMPORTED_MODULE_6_app_mixins_apiMixin__["default"]],

  getDefaultProps: function getDefaultProps() {
    return {
      canSelectGroups: true
    };
  },
  getInitialState: function getInitialState() {
    return {
      loading: true,
      error: false,
      groupIds: []
    };
  },
  componentWillMount: function componentWillMount() {
    this._streamManager = new __WEBPACK_IMPORTED_MODULE_13_app_utils__["c" /* default */].StreamManager(__WEBPACK_IMPORTED_MODULE_8_app_stores_groupStore__["a" /* default */]);

    this.fetchData();
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return !__WEBPACK_IMPORTED_MODULE_13_app_utils__["c" /* default */].valueIsEqual(this.state, nextState, true);
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    if (prevProps.orgId !== this.props.orgId || prevProps.projectId !== this.props.projectId) {
      this.fetchData();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_8_app_stores_groupStore__["a" /* default */].loadInitialData([]);
  },
  fetchData: function fetchData() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_8_app_stores_groupStore__["a" /* default */].loadInitialData([]);

    this.setState({
      loading: true,
      error: false
    });

    this.api.request(this.getGroupListEndpoint(), {
      success: function success(data, _, jqXHR) {
        _this._streamManager.push(data);

        _this.setState({
          error: false,
          loading: false,
          pageLinks: jqXHR.getResponseHeader('Link')
        });
      },
      error: function error() {
        _this.setState({
          error: true,
          loading: false
        });
      }
    });
  },
  getGroupListEndpoint: function getGroupListEndpoint() {
    var queryParams = this.context.location.query;
    queryParams.limit = 50;
    queryParams.sort = 'new';
    queryParams.query = this.props.query;

    if (this.props.environment) {
      queryParams.environment = this.props.environment.name;
    } else {
      delete queryParams.environment;
    }

    var querystring = __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.param(queryParams);

    var props = this.props;
    return '/projects/' + props.orgId + '/' + props.projectId + '/issues/?' + querystring;
  },
  onGroupChange: function onGroupChange() {
    var groupIds = this._streamManager.getAllItems().map(function (item) {
      return item.id;
    });
    if (!__WEBPACK_IMPORTED_MODULE_13_app_utils__["c" /* default */].valueIsEqual(groupIds, this.state.groupIds)) {
      this.setState({
        groupIds: groupIds
      });
    }
  },
  render: function render() {
    var _this2 = this;

    if (this.state.loading) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_loadingIndicator__["default"], null);else if (this.state.error) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_loadingError__["default"], { onRetry: this.fetchData });else if (this.state.groupIds.length === 0) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_16_app_components_panels__["a" /* Panel */],
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_16_app_components_panels__["c" /* PanelBody */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_15_app_components_emptyStateWarning__["a" /* default */],
          null,
          Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["t"])("There doesn't seem to be any events fitting the query.")
        )
      )
    );

    var _props = this.props,
        orgId = _props.orgId,
        projectId = _props.projectId;


    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_16_app_components_panels__["a" /* Panel */],
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_groupListHeader__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_16_app_components_panels__["c" /* PanelBody */],
        null,
        this.state.groupIds.map(function (id) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_stream_group__["a" /* default */], {
            key: id,
            id: id,
            orgId: orgId,
            projectId: projectId,
            canSelect: _this2.props.canSelectGroups
          });
        })
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (GroupList);

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_assigneeSelector__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_count__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_stream_groupChart__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_stream_groupCheckBox__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_mixins_projectState__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_stores_groupStore__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_assistant_guideAnchor__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_stores_selectedGroupStore__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_components_eventOrGroupHeader__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_components_eventOrGroupExtraDetails__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_utils__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };























var StreamGroup = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'StreamGroup',

  propTypes: {
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    orgId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    projectId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    statsPeriod: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    canSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    hasGuideAnchor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_12_app_stores_groupStore__["a" /* default */], 'onGroupChange'), __WEBPACK_IMPORTED_MODULE_11_app_mixins_projectState__["a" /* default */]],

  getDefaultProps: function getDefaultProps() {
    return {
      canSelect: true,
      id: '',
      statsPeriod: '24h'
    };
  },
  getInitialState: function getInitialState() {
    return {
      data: __WEBPACK_IMPORTED_MODULE_12_app_stores_groupStore__["a" /* default */].get(this.props.id)
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.id != this.props.id) {
      this.setState({
        data: __WEBPACK_IMPORTED_MODULE_12_app_stores_groupStore__["a" /* default */].get(this.props.id)
      });
    }
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.statsPeriod !== this.props.statsPeriod) {
      return true;
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_18_app_utils__["u" /* valueIsEqual */])(this.state.data, nextState.data)) {
      return true;
    }
    return false;
  },
  onGroupChange: function onGroupChange(itemIds) {
    if (!itemIds.has(this.props.id)) {
      return;
    }
    var id = this.props.id;
    var data = __WEBPACK_IMPORTED_MODULE_12_app_stores_groupStore__["a" /* default */].get(id);
    this.setState({
      data: data
    });
  },
  toggleSelect: function toggleSelect(evt) {
    if (evt.target.tagName === 'A') return;
    if (evt.target.tagName === 'INPUT') return;
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(evt.target).parents('a').length !== 0) return;

    __WEBPACK_IMPORTED_MODULE_14_app_stores_selectedGroupStore__["a" /* default */].toggleSelect(this.state.data.id);
  },
  render: function render() {
    var data = this.state.data;
    var _props = this.props,
        id = _props.id,
        orgId = _props.orgId,
        projectId = _props.projectId,
        query = _props.query,
        hasGuideAnchor = _props.hasGuideAnchor,
        canSelect = _props.canSelect;


    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      Group,
      { onClick: this.toggleSelect, py: 1, px: 0, align: 'center' },
      canSelect && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        GroupCheckbox,
        { ml: 2 },
        hasGuideAnchor && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_app_components_assistant_guideAnchor__["default"], { target: 'issues', type: 'text' }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_stream_groupCheckBox__["a" /* default */], { id: data.id })
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        GroupSummary,
        { w: [8 / 12, 8 / 12, 6 / 12], ml: canSelect ? 1 : 2, mr: 1, flex: '1' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_app_components_eventOrGroupHeader__["a" /* default */], {
          data: data,
          orgId: orgId,
          projectId: projectId,
          query: query
        }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_app_components_eventOrGroupExtraDetails__["a" /* default */], _extends({
          group: true
        }, data, {
          groupId: id,
          orgId: orgId,
          projectId: projectId
        }))
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_grid_emotion__["Box"],
        { w: 160, mx: 2, className: 'hidden-xs hidden-sm' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_stream_groupChart__["a" /* default */], { id: data.id, statsPeriod: this.props.statsPeriod, data: data })
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_grid_emotion__["Flex"],
        { w: [40, 60, 80, 80], mx: 2, justify: 'flex-end' },
        hasGuideAnchor && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_app_components_assistant_guideAnchor__["default"], { target: 'events', type: 'text' }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StyledCount, { value: data.count })
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_grid_emotion__["Flex"],
        { w: [40, 60, 80, 80], mx: 2, justify: 'flex-end' },
        hasGuideAnchor && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_app_components_assistant_guideAnchor__["default"], { target: 'users', type: 'text' }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StyledCount, { value: data.userCount })
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_grid_emotion__["Box"],
        { w: 80, mx: 2, className: 'hidden-xs hidden-sm' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_assigneeSelector__["a" /* default */], { id: data.id })
      )
    );
  }
});

var Group = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_17_app_components_panels__["f" /* PanelItem */], {
  target: 'e1x6ya7d0'
})('line-height:1.1;');

var GroupSummary = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_6_grid_emotion__["Box"], {
  target: 'e1x6ya7d1'
})('overflow:hidden;');

var GroupCheckbox = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_6_grid_emotion__["Box"], {
  target: 'e1x6ya7d2'
})('align-self:flex-start;& input[type=\'checkbox\']{margin:0;display:block;}');

var StyledCount = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_8_app_components_count__["default"], {
  target: 'e1x6ya7d3'
})('font-size:18px;color:', function (p) {
  return p.theme.gray3;
}, ';');

/* harmony default export */ __webpack_exports__["a"] = (StreamGroup);

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconBase = function IconBase(_ref, _ref2) {
  var children = _ref.children;
  var color = _ref.color;
  var size = _ref.size;
  var style = _ref.style;
  var width = _ref.width;
  var height = _ref.height;

  var props = _objectWithoutProperties(_ref, ['children', 'color', 'size', 'style', 'width', 'height']);

  var _ref2$reactIconBase = _ref2.reactIconBase;
  var reactIconBase = _ref2$reactIconBase === undefined ? {} : _ref2$reactIconBase;

  var computedSize = size || reactIconBase.size || '1em';
  return _react2.default.createElement('svg', _extends({
    children: children,
    fill: 'currentColor',
    preserveAspectRatio: 'xMidYMid meet',
    height: height || computedSize,
    width: width || computedSize
  }, reactIconBase, props, {
    style: _extends({
      verticalAlign: 'middle',
      color: color || reactIconBase.color
    }, reactIconBase.style || {}, style)
  }));
};

IconBase.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  style: _propTypes2.default.object
};

IconBase.contextTypes = {
  reactIconBase: _propTypes2.default.shape(IconBase.propTypes)
};

exports.default = IconBase;
module.exports = exports['default'];

/***/ }),
/* 565 */,
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(535),
    baseEach = __webpack_require__(220),
    baseIteratee = __webpack_require__(123),
    baseReduce = __webpack_require__(1315),
    isArray = __webpack_require__(47);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['loadTags', 'loadTagsError', 'loadTagsSuccess']));

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = errorHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_views_routeError__ = __webpack_require__(323);



function errorHandler(Component) {
  var originalRender = Component.prototype.render;
  Component.prototype.render = function () {
    try {
      return originalRender.apply(this, arguments);
    } catch (err) {
      /*eslint no-console:0*/
      setTimeout(function () {
        throw err;
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_app_views_routeError__["a" /* default */], { error: err, component: this });
    }
  };
  return Component;
}

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Raven) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InviteMember", function() { return InviteMember; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_actionCreators_indicator__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_stores_configStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_mixins_organizationState__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_views_settings_components_settingsPageHeader__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_views_settings_components_text_textBlock__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_forms_textField__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_utils_replaceRouterParams__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__roleSelect__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__teamSelect__ = __webpack_require__(648);





















// These don't have allowed and are only used for superusers. superceded by server result of allowed roles
var STATIC_ROLE_LIST = [{
  id: 'member',
  name: 'Member',
  desc: 'Members can view and act on events, as well as view most other data within the organization.'
}, {
  id: 'admin',
  name: 'Admin',
  desc: "Admin privileges on any teams of which they're a member. They can create new teams and projects, as well as remove teams and projects which they already hold membership on."
}, {
  id: 'manager',
  name: 'Manager',
  desc: 'Gains admin access on all teams as well as the ability to add and remove members.'
}, {
  id: 'owner',
  name: 'Owner',
  desc: 'Gains full permission across the organization. Can manage members as well as perform catastrophic operations such as removing the organization.'
}];

var InviteMember = __WEBPACK_IMPORTED_MODULE_4_create_react_class___default()({
  displayName: 'InviteMember',
  propTypes: {
    router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_7_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_11_app_mixins_organizationState__["a" /* default */]],

  getInitialState: function getInitialState() {
    var _getOrganization = this.getOrganization(),
        teams = _getOrganization.teams;

    //select team if there's only one


    var initialTeamSelection = teams.length === 1 ? [teams[0].slug] : [];

    return {
      selectedTeams: new Set(initialTeamSelection),
      roleList: [],
      selectedRole: 'member',
      email: '',
      loading: true,
      busy: false,
      error: undefined
    };
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    var _getOrganization2 = this.getOrganization(),
        slug = _getOrganization2.slug;

    var _ConfigStore$get = __WEBPACK_IMPORTED_MODULE_9_app_stores_configStore__["default"].get('user'),
        isSuperuser = _ConfigStore$get.isSuperuser;

    this.api.request('/organizations/' + slug + '/members/me/', {
      method: 'GET',
      success: function success(resp) {
        var _ref = resp || {},
            roles = _ref.roles;

        if (!resp || !roles) {
          _this.setState({
            loading: false,
            error: {
              role: 'Error loading roles, will default to "member"'
            }
          });

          Raven.captureMessage('[members]: data fetch invalid response', {
            extra: { resp: resp, state: _this.state }
          });
        } else {
          _this.setState({ roleList: roles, loading: false });

          if (roles.filter(function (_ref2) {
            var allowed = _ref2.allowed;
            return allowed;
          }).length === 0) {
            // not allowed to invite, redirect
            _this.redirectToMemberPage();
          }
        }
      },
      error: function error(_error) {
        if (_error.status == 404 && isSuperuser) {
          // use the static list
          _this.setState({ roleList: STATIC_ROLE_LIST, loading: false });
        } else {
          Raven.captureMessage('[members]: data fetch error ', {
            extra: { error: _error, state: _this.state }
          });
        }
      }
    });
  },
  redirectToMemberPage: function redirectToMemberPage() {
    // Get path to parent route (`/organizations/${slug}/members/`)
    // `recreateRoute` fucks up because of getsentry hooks
    var _props = this.props,
        params = _props.params,
        router = _props.router;

    var isNewSettings = /^\/settings\//.test(router.location.pathname);
    var pathToParentRoute = isNewSettings ? '/settings/:orgId/members/' : '/organizations/:orgId/members/';
    router.push(Object(__WEBPACK_IMPORTED_MODULE_15_app_utils_replaceRouterParams__["a" /* default */])(pathToParentRoute, params));
  },
  splitEmails: function splitEmails(text) {
    return text.split(',').map(function (e) {
      return e.trim();
    }).filter(function (e) {
      return e;
    });
  },
  inviteUser: function inviteUser(email) {
    var _this2 = this;

    var _getOrganization3 = this.getOrganization(),
        slug = _getOrganization3.slug;

    var _state = this.state,
        selectedTeams = _state.selectedTeams,
        selectedRole = _state.selectedRole;


    return new Promise(function (resolve, reject) {
      _this2.api.request('/organizations/' + slug + '/members/', {
        method: 'POST',
        data: {
          email: email,
          user: email,
          teams: Array.from(selectedTeams.keys()),
          role: selectedRole,
          referrer: _this2.props.location.query.referrer
        },
        success: function success() {
          Object(__WEBPACK_IMPORTED_MODULE_5_app_actionCreators_indicator__["d" /* addSuccessMessage */])(Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["tct"])('Added [email] to [organization]', {
            email: email,
            organization: slug
          }));
          resolve();
        },
        error: function error(err) {
          if (err.status === 403) {
            Object(__WEBPACK_IMPORTED_MODULE_5_app_actionCreators_indicator__["a" /* addErrorMessage */])(Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])("You aren't allowed to invite members."));
            resolve();
          } else if (err.status === 409) {
            Object(__WEBPACK_IMPORTED_MODULE_5_app_actionCreators_indicator__["a" /* addErrorMessage */])('User already exists: ' + email);
            resolve();
          } else {
            reject(err.responseJSON);
          }
        }
      });
    });
  },
  submit: function submit() {
    var _this3 = this;

    var email = this.state.email;

    var emails = this.splitEmails(email);
    if (!emails.length) return;
    this.setState({ busy: true });
    Promise.all(emails.map(this.inviteUser)).then(function () {
      return _this3.redirectToMemberPage();
    }).catch(function (error) {
      if (error && !error.email && !error.role) {
        Raven.captureMessage('Unknown invite member api response', {
          extra: { error: error, state: _this3.state }
        });
      }
      _this3.setState({ error: error, busy: false });
    });
  },
  toggleTeam: function toggleTeam(slug) {
    this.setState(function (state) {
      var selectedTeams = state.selectedTeams;

      if (selectedTeams.has(slug)) {
        selectedTeams.delete(slug);
      } else {
        selectedTeams.add(slug);
      }
      return {
        selectedTeams: selectedTeams
      };
    });
  },
  render: function render() {
    var _this4 = this;

    var _state2 = this.state,
        error = _state2.error,
        loading = _state2.loading,
        roleList = _state2.roleList,
        selectedRole = _state2.selectedRole,
        selectedTeams = _state2.selectedTeams;

    var _getOrganization4 = this.getOrganization(),
        teams = _getOrganization4.teams;

    var _ConfigStore$getConfi = __WEBPACK_IMPORTED_MODULE_9_app_stores_configStore__["default"].getConfig(),
        invitesEnabled = _ConfigStore$getConfi.invitesEnabled;

    var _ConfigStore$get2 = __WEBPACK_IMPORTED_MODULE_9_app_stores_configStore__["default"].get('user'),
        isSuperuser = _ConfigStore$get2.isSuperuser;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_views_settings_components_settingsPageHeader__["default"], { title: Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Add Member to Organization') }),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13_app_views_settings_components_text_textBlock__["default"],
        null,
        invitesEnabled ? Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Invite a member to join this organization via their email address. If they do not already have an account, they will first be asked to create one. Multiple emails delimited by commas.') : Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('You may add a user by their username if they already have an account. Multiple inputs delimited by commas.')
      ),
      loading && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_loadingIndicator__["default"], null),
      !loading && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({ 'has-error': error && error.email }) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_app_components_forms_textField__["default"], {
            name: 'email',
            label: invitesEnabled ? Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Email') + '(s)' : Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Username') + '(s)',
            placeholder: 'e.g. teammate@example.com',
            spellCheck: 'false',
            onChange: function onChange(v) {
              return _this4.setState({ email: v });
            }
          }),
          error && error.email && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'p',
            { className: 'error' },
            error.email
          )
        ),
        error && error.role && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'p',
          { className: 'error alert-error' },
          error.role
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__roleSelect__["a" /* default */], {
          enforceAllowed: !isSuperuser,
          roleList: roleList,
          selectedRole: selectedRole,
          setRole: function setRole(slug) {
            return _this4.setState({ selectedRole: slug });
          }
        }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__teamSelect__["a" /* default */], {
          teams: teams,
          selectedTeams: selectedTeams,
          toggleTeam: this.toggleTeam
        }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_app_components_buttons_button__["default"],
          {
            priority: 'primary',
            busy: this.state.busy,
            className: 'invite-member-submit',
            onClick: this.submit
          },
          Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Add Member')
        )
      )
    );
  }
});


/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["withRouter"])(InviteMember));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(40)))

/***/ }),
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(270);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Form; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_views_settings_components_forms_model__ = __webpack_require__(628);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Form = (_temp = _class = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form(props, context) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props, context));

    _this.onSubmit = function (e) {
      e.preventDefault();
      if (_this.model.isSaving) {
        return;
      }

      if (_this.props.onSubmit) {
        _this.props.onSubmit(_this.model.getData(), _this.onSubmitSuccess, _this.onSubmitError, e);
      } else {
        _this.model.saveForm();
      }
    };

    _this.onSubmitSuccess = function (data) {
      _this.model.submitSuccess(data);
      _this.props.onSubmitSuccess(data, _this.model);
    };

    _this.onSubmitError = function (error) {
      _this.model.submitError(error);
      _this.props.onSubmitError(error, _this.model);
    };

    var saveOnBlur = props.saveOnBlur,
        apiEndpoint = props.apiEndpoint,
        apiMethod = props.apiMethod,
        resetOnError = props.resetOnError,
        onSubmitSuccess = props.onSubmitSuccess,
        onSubmitError = props.onSubmitError,
        onFieldChange = props.onFieldChange,
        initialData = props.initialData,
        model = props.model,
        allowUndo = props.allowUndo;


    _this.model = model || new __WEBPACK_IMPORTED_MODULE_5_app_views_settings_components_forms_model__["a" /* default */]();
    _this.model.setInitialData(initialData);
    _this.model.setFormOptions({
      resetOnError: resetOnError,
      allowUndo: allowUndo,
      onFieldChange: onFieldChange,
      onSubmitSuccess: onSubmitSuccess,
      onSubmitError: onSubmitError,
      saveOnBlur: saveOnBlur,
      apiEndpoint: apiEndpoint,
      apiMethod: apiMethod
    });
    return _this;
  }

  _createClass(Form, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        saveOnBlur: this.props.saveOnBlur,
        form: this.model
      };
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.model.reset();
      this.model = null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var isSaving = this.model.isSaving;
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          footerClass = _props.footerClass,
          footerStyle = _props.footerStyle,
          submitDisabled = _props.submitDisabled,
          submitLabel = _props.submitLabel,
          submitPriority = _props.submitPriority,
          cancelLabel = _props.cancelLabel,
          onCancel = _props.onCancel,
          extraButton = _props.extraButton,
          requireChanges = _props.requireChanges,
          saveOnBlur = _props.saveOnBlur,
          hideFooter = _props.hideFooter;

      var shouldShowFooter = typeof hideFooter !== 'undefined' ? !hideFooter : !saveOnBlur;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'form',
        {
          onSubmit: this.onSubmit,
          className: className,
          'data-test-id': this.props['data-test-id']
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          null,
          children
        ),
        shouldShowFooter && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: footerClass, style: _extends({ marginTop: 25 }, footerStyle) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_mobx_react__["a" /* Observer */],
            null,
            function () {
              return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_app_components_buttons_button__["default"],
                {
                  'data-test-id': 'form-submit',
                  priority: submitPriority,
                  disabled: _this2.model.isError || isSaving || submitDisabled || (requireChanges ? !_this2.model.formChanged : false),
                  type: 'submit'
                },
                submitLabel
              );
            }
          ),
          onCancel && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_app_components_buttons_button__["default"],
            { disabled: isSaving, onClick: onCancel, style: { marginLeft: 5 } },
            cancelLabel
          ),
          extraButton
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  cancelLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSubmitSuccess: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSubmitError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onFieldChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  submitDisabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  submitLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  submitPriority: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  footerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  footerStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  extraButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  initialData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  // Require changes before able to submit form
  requireChanges: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // Reset form when there are errors, after submit
  resetOnError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // Hide Footer
  hideFooter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // Allow undo
  allowUndo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // Save field on control blur
  saveOnBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  model: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  apiMethod: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  apiEndpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  'data-test-id': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  cancelLabel: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Cancel'),
  submitLabel: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Save Changes'),
  submitDisabled: false,
  submitPriority: 'primary',
  footerClass: 'form-actions align-right',
  className: 'form-stacked',
  requireChanges: false,
  allowUndo: false,
  saveOnBlur: false,
  onSubmitSuccess: function onSubmitSuccess() {},
  onSubmitError: function onSubmitError() {}
}, _class.childContextTypes = {
  saveOnBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  form: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
}, _temp);


/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FieldFromConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_views_settings_components_forms_booleanField__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_views_settings_components_forms_rangeField__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_views_settings_components_forms_selectField__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_views_settings_components_forms_textField__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_views_settings_components_forms_textareaField__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_views_settings_components_forms_radioField__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_views_settings_components_forms_inputField__ = __webpack_require__(128);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// import Select2FieldAutocomplete from './select2FieldAutocomplete';

// import Select2TextField from './select2TextField';





var FieldFromConfig = (_temp = _class = function (_React$Component) {
  _inherits(FieldFromConfig, _React$Component);

  function FieldFromConfig() {
    _classCallCheck(this, FieldFromConfig);

    return _possibleConstructorReturn(this, (FieldFromConfig.__proto__ || Object.getPrototypeOf(FieldFromConfig)).apply(this, arguments));
  }

  _createClass(FieldFromConfig, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          field = _props.field,
          otherProps = _objectWithoutProperties(_props, ['field']);

      // TODO(billy) Not sure of structure yet


      var props = _extends({}, otherProps, field);

      switch (field.type) {
        case 'secret':
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_views_settings_components_forms_inputField__["a" /* default */], _extends({}, props, { type: 'password' }));
        case 'range':
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_views_settings_components_forms_rangeField__["a" /* default */], props);
        case 'bool':
        case 'boolean':
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_views_settings_components_forms_booleanField__["a" /* default */], props);
        case 'email':
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_views_settings_components_forms_inputField__["a" /* default */], _extends({}, props, { type: 'email' }));
        case 'string':
        case 'text':
        case 'url':
          if (props.multiline) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_views_settings_components_forms_textareaField__["a" /* default */], props);
          }
          // if (props.choices) return <Select2TextField {...props} />;
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_views_settings_components_forms_textField__["a" /* default */], props);
        case 'number':
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_views_settings_components_forms_inputField__["a" /* default */], _extends({}, props, { type: 'number' }));
        case 'textarea':
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_views_settings_components_forms_textareaField__["a" /* default */], props);
        case 'choice':
        case 'select':
        case 'array':
          // the chrome required tip winds up in weird places
          // so just make it look like it's required in field (with *),
          // and rely on server validation
          delete props.required;
          // if (props.has_autocomplete) {
          // return <Select2FieldAutocomplete {...props} />;
          // }
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_views_settings_components_forms_selectField__["a" /* default */], props);
        case 'radio':
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_views_settings_components_forms_radioField__["a" /* default */], props);
        default:
          return null;
      }
    }
  }]);

  return FieldFromConfig;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  field: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['secret', 'string', 'array', 'boolean', 'radio', 'choice', 'select', 'multichoice', 'range']),
    required: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    multiline: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    label: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),
    placeholder: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),
    help: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),
    visible: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),
    disabled: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),
    /**
     * Should show a "return key" icon in input?
     */
    showReturnButton: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    /**
     * Iff false, disable saveOnBlur for field, instead show a save/cancel button
     */
    saveOnBlur: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    getValue: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    setValue: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
  }).isRequired
}, _temp);


/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_views_settings_components_forms_field_fieldControl__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_views_settings_components_forms_field_fieldDescription__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_views_settings_components_forms_field_fieldHelp__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_views_settings_components_forms_field_fieldLabel__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_views_settings_components_forms_field_fieldRequiredBadge__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_views_settings_components_forms_field_fieldWrapper__ = __webpack_require__(909);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A component to render a Field (i.e. label + help + form "control"),
 * generally inside of a Panel.
 *
 * This is unconnected to any Form state
 */











var Field = (_temp = _class = function (_React$Component) {
  _inherits(Field, _React$Component);

  function Field() {
    _classCallCheck(this, Field);

    return _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).apply(this, arguments));
  }

  _createClass(Field, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          otherProps = _objectWithoutProperties(_props, ['className']);

      var controlClassName = otherProps.controlClassName,
          alignRight = otherProps.alignRight,
          inline = otherProps.inline,
          highlighted = otherProps.highlighted,
          required = otherProps.required,
          visible = otherProps.visible,
          disabled = otherProps.disabled,
          disabledReason = otherProps.disabledReason,
          flexibleControlStateSize = otherProps.flexibleControlStateSize,
          label = otherProps.label,
          help = otherProps.help,
          id = otherProps.id,
          p = otherProps.p,
          children = otherProps.children,
          style = otherProps.style;

      var isDisabled = typeof disabled === 'function' ? disabled(this.props) : disabled;
      var isVisible = typeof visible === 'function' ? visible(this.props) : visible;
      var Control = void 0;

      if (!isVisible) {
        return null;
      }

      var controlProps = {
        className: controlClassName,
        inline: inline,
        alignRight: alignRight,
        disabled: isDisabled,
        disabledReason: disabledReason,
        flexibleControlStateSize: flexibleControlStateSize
      };

      // See comments in prop types
      if (typeof children === 'function') {
        Control = children(_extends({}, otherProps, controlProps));
      } else {
        Control = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_app_views_settings_components_forms_field_fieldControl__["a" /* default */],
          controlProps,
          children
        );
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_app_views_settings_components_forms_field_fieldWrapper__["a" /* default */],
        {
          p: p,
          className: className,
          inline: inline,
          highlighted: highlighted,
          hasControlState: !flexibleControlStateSize,
          style: style
        },
        (label || help) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_app_views_settings_components_forms_field_fieldDescription__["a" /* default */],
          { inline: inline, htmlFor: id },
          label && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_app_views_settings_components_forms_field_fieldLabel__["a" /* default */],
            null,
            label,
            ' ',
            required && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_views_settings_components_forms_field_fieldRequiredBadge__["a" /* default */], null)
          ),
          help && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_app_views_settings_components_forms_field_fieldHelp__["a" /* default */],
            null,
            help
          )
        ),
        Control
      );
    }
  }]);

  return Field;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  /**
   * Aligns Control to the right
   */
  alignRight: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * Is "highlighted", i.e. after a search
   */
  highlighted: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * Padding
   */
  p: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,

  /**
   * Show "required" indicator
   */
  required: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * Should field be visible
   */
  visible: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),

  /**
   * Should field be disabled?
   */
  disabled: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),

  /**
   * Reason why field is disabled (displays in tooltip)
   */
  disabledReason: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  /**
   * Hide ControlState component
   */
  flexibleControlStateSize: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * User-facing field name
   */
  label: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,

  /**
   * Help or description of the field
   */
  help: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element]),

  /**
   * Should Control be inline with Label
   */
  inline: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * The control's `id` property
   */
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  /**
   * The Control component
   */
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),

  /**
   * Class name for inner control
   */
  controlClassName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  /** Inline style */
  style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
}, _class.defaultProps = {
  alignRight: false,
  inline: true,
  disabled: false,
  required: false,
  visible: true
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (Field);

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDynamicText;
/* global process */

// Return a specified "fixed" string when we are in a testing environment
// (more specifically in a PERCY env (e.g. CI))
function getDynamicText(_ref) {
  var value = _ref.value,
      fixed = _ref.fixed;

  return undefined ? fixed : value;
}

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clipboard__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_stores_indicatorStore__ = __webpack_require__(30);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Clipboard = (_temp2 = _class = function (_React$Component) {
  _inherits(Clipboard, _React$Component);

  function Clipboard() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Clipboard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call.apply(_ref, [this].concat(args))), _this), _this.handleMount = function (ref) {
      if (!ref) return;

      var _this$props = _this.props,
          hideMessages = _this$props.hideMessages,
          successMessage = _this$props.successMessage,
          errorMessage = _this$props.errorMessage,
          onSuccess = _this$props.onSuccess,
          onError = _this$props.onError;

      var hasSuccessCb = typeof onSuccess === 'function';
      var hasErrorCb = typeof onError === 'function';
      var bindEventHandlers = !hideMessages || hasSuccessCb || hasErrorCb;

      _this.clipboard = new __WEBPACK_IMPORTED_MODULE_0_clipboard___default.a(__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(ref), {
        text: function text() {
          return _this.props.value;
        }
      });

      if (!bindEventHandlers) return;

      _this.clipboard.on('success', function () {
        if (!hideMessages) {
          __WEBPACK_IMPORTED_MODULE_4_app_stores_indicatorStore__["default"].add(successMessage, 'success', { duration: 2000 });
        }
        if (hasSuccessCb) {
          onSuccess();
        }
      }).on('error', function () {
        if (!hideMessages) {
          __WEBPACK_IMPORTED_MODULE_4_app_stores_indicatorStore__["default"].add(errorMessage, 'error', { duration: 2000 });
        }
        if (hasErrorCb) {
          onError();
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Clipboard, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.clipboard) {
        this.clipboard.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          hideUnsupported = _props.hideUnsupported;

      // Browser doesn't support `execCommand`

      if (hideUnsupported && !__WEBPACK_IMPORTED_MODULE_0_clipboard___default.a.isSupported()) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(children, {
        ref: this.handleMount
      });
    }
  }]);

  return Clipboard;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  successMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  errorMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hideMessages: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Hide component if browser does not support "execCommand"
   */
  hideUnsupported: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onSuccess: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class.defaultProps = {
  hideMessages: false,
  successMessage: 'Copied to clipboard',
  errorMessage: 'Error copying to clipboard'
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (Clipboard);

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(234);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_styles_animations__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_views_settings_components_forms_field__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_views_settings_components_forms_field_fieldControl__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_forms_state__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_inlineSvg__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_panels_panelAlert__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_views_settings_components_forms_spinner__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_views_settings_components_forms_returnButton__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_styles_space__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _class2, _temp3, _initialiseProps;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var FormFieldErrorReason = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e1d9f4g20'
})('color:', function (p) {
  return p.theme.redDark;
}, ';position:absolute;background:#fff;padding:6px 8px;font-weight:600;font-size:12px;border-radius:3px;box-shadow:0 0 0 1px rgba(64,11,54,0.15),0 4px 20px 0 rgba(64,11,54,0.36);z-index:10000;');

var FormFieldError = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e1d9f4g21'
})('color:', function (p) {
  return p.theme.redDark;
}, ';animation:', __WEBPACK_IMPORTED_MODULE_5_app_styles_animations__["d" /* pulse */], ' 1s ease infinite;');

var FormFieldIsSaved = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e1d9f4g22'
})('color:', function (p) {
  return p.theme.green;
}, ';animation:', __WEBPACK_IMPORTED_MODULE_5_app_styles_animations__["b" /* fadeOut */], ' 0.3s ease 2s 1 forwards;position:absolute;top:0;bottom:0;left:0;right:0;display:flex;align-items:center;justify-content:center;');

var FormSpinner = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_13_app_views_settings_components_forms_spinner__["a" /* default */], {
  target: 'e1d9f4g23'
})('margin-left:0;');

var ReturnButtonStyled = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_14_app_views_settings_components_forms_returnButton__["a" /* default */], {
  target: 'e1d9f4g24'
})('position:absolute;right:0;top:0;');

/**
 * Some fields don't need to implement their own onChange handlers, in
 * which case we will receive an Event, but if they do we should handle
 * the case where they return a value as the first argument.
 */
var getValueFromEvent = function getValueFromEvent(valueOrEvent, e) {
  var event = e || valueOrEvent;
  var value = Object(__WEBPACK_IMPORTED_MODULE_4_app_utils__["d" /* defined */])(e) ? valueOrEvent : event && event.target && event.target.value;

  return {
    value: value,
    event: event
  };
};

var ControlStateWrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e1d9f4g25'
})('padding:0 8px;');

/**
 * ControlState (i.e. loading/error icons) for connected form components
 */
var ControlState = (_temp = _class = function (_React$Component) {
  _inherits(ControlState, _React$Component);

  function ControlState() {
    _classCallCheck(this, ControlState);

    return _possibleConstructorReturn(this, (ControlState.__proto__ || Object.getPrototypeOf(ControlState)).apply(this, arguments));
  }

  _createClass(ControlState, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          model = _props.model,
          name = _props.name;


      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_mobx_react__["a" /* Observer */],
          null,
          function () {
            var isSaving = model.getFieldState(name, __WEBPACK_IMPORTED_MODULE_10_app_components_forms_state__["a" /* default */].SAVING);
            var isSaved = model.getFieldState(name, __WEBPACK_IMPORTED_MODULE_10_app_components_forms_state__["a" /* default */].READY);

            if (isSaving) {
              return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                ControlStateWrapper,
                null,
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(FormSpinner, null)
              );
            } else if (isSaved) {
              return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                ControlStateWrapper,
                null,
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  FormFieldIsSaved,
                  null,
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_inlineSvg__["a" /* default */], { src: 'icon-checkmark-sm', size: '18px' })
                )
              );
            }

            return null;
          }
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_mobx_react__["a" /* Observer */],
          null,
          function () {
            var error = model.getError(name);

            if (!error) return null;

            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              ControlStateWrapper,
              null,
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                FormFieldError,
                null,
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_inlineSvg__["a" /* default */], { src: 'icon-warning-sm', size: '18px' })
              )
            );
          }
        )
      );
    }
  }]);

  return ControlState;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  model: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _temp);

// MockedModel that returns values from props
// Disables a lot of functionality but allows you to use fields
// without wrapping them in a Form

var MockModel = function () {
  function MockModel(props) {
    _classCallCheck(this, MockModel);

    this.props = props;

    this.initialData = _defineProperty({}, props.name, props.value);
  }

  _createClass(MockModel, [{
    key: 'setValue',
    value: function setValue() {}
  }, {
    key: 'setFieldDescriptor',
    value: function setFieldDescriptor() {}
  }, {
    key: 'handleBlurField',
    value: function handleBlurField() {}
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.props.value;
    }
  }, {
    key: 'getError',
    value: function getError() {
      return this.props.error;
    }
  }, {
    key: 'getFieldState',
    value: function getFieldState() {
      return false;
    }
  }]);

  return MockModel;
}();

var FormField = (_temp3 = _class2 = function (_React$Component2) {
  _inherits(FormField, _React$Component2);

  function FormField() {
    var _ref;

    var _temp2, _this2, _ret;

    _classCallCheck(this, FormField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref = FormField.__proto__ || Object.getPrototypeOf(FormField)).call.apply(_ref, [this].concat(args))), _this2), _initialiseProps.call(_this2), _temp2), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(FormField, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Tell model about this field's props
      this.getModel().setFieldDescriptor(this.props.name, this.props);
    }
  }, {
    key: 'getError',
    value: function getError(props, context) {
      return this.getModel().getError(this.props.name);
    }
  }, {
    key: 'getId',
    value: function getId() {
      return this.props.name;
    }
  }, {
    key: 'getModel',
    value: function getModel() {
      if (this.context.form === undefined) {
        return new MockModel(this.props);
      }
      return this.context.form;
    }

    // Only works for styled inputs
    // Attempts to autofocus input field if field's name is in url hash


    /**
     * Update field value in form model
     */


    /**
     * Notify model of a field being blurred
     */


    /**
     * Handle keydown to trigger a save on Enter
     */


    /**
     * Handle saving an individual field via UI button
     */

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          className = _props2.className,
          name = _props2.name,
          hideErrorMessage = _props2.hideErrorMessage,
          flexibleControlStateSize = _props2.flexibleControlStateSize,
          saveOnBlur = _props2.saveOnBlur,
          saveMessage = _props2.saveMessage,
          saveMessageAlertType = _props2.saveMessageAlertType,
          defaultValue = _props2.defaultValue,
          props = _objectWithoutProperties(_props2, ['className', 'name', 'hideErrorMessage', 'flexibleControlStateSize', 'saveOnBlur', 'saveMessage', 'saveMessageAlertType', 'defaultValue']);

      var id = this.getId();
      var model = this.getModel();
      var saveOnBlurFieldOverride = typeof saveOnBlur !== 'undefined' && !saveOnBlur;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_app_views_settings_components_forms_field__["a" /* default */],
          _extends({ id: id, name: name, className: className }, props),
          function (_ref2) {
            var alignRight = _ref2.alignRight,
                inline = _ref2.inline,
                disabled = _ref2.disabled,
                disabledReason = _ref2.disabledReason;
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_app_views_settings_components_forms_field_fieldControl__["a" /* default */],
              {
                disabled: disabled,
                disabledReason: disabledReason,
                inline: inline,
                alignRight: alignRight,
                flexibleControlStateSize: flexibleControlStateSize,
                controlState: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ControlState, { model: model, name: name }),
                errorState: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_0_mobx_react__["a" /* Observer */],
                  null,
                  function () {
                    var error = _this3.getError();
                    var shouldShowErrorMessage = error && !hideErrorMessage;
                    if (!shouldShowErrorMessage) return null;
                    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      FormFieldErrorReason,
                      null,
                      error
                    );
                  }
                )
              },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_mobx_react__["a" /* Observer */],
                null,
                function () {
                  var error = _this3.getError();
                  var value = model.getValue(name);
                  var showReturnButton = model.getFieldState(name, 'showReturnButton');

                  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,
                    null,
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(_this3.props.children, _extends({
                      innerRef: _this3.handleInputMount
                    }, _extends({}, props, {
                      name: name,
                      id: id,
                      onKeyDown: _this3.handleKeyDown,
                      onChange: _this3.handleChange,
                      onBlur: _this3.handleBlur,
                      // Fixes react warnings about input switching from controlled to uncontrolled
                      // So force to empty string for null values
                      value: value === null ? '' : value,
                      error: error,
                      disabled: disabled
                    }), {
                      initialData: model.initialData
                    })),
                    showReturnButton && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ReturnButtonStyled, null)
                  );
                }
              )
            );
          }
        ),
        saveOnBlurFieldOverride && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_mobx_react__["a" /* Observer */],
          null,
          function () {
            var showFieldSave = model.getFieldState(name, 'showSave');

            if (!showFieldSave) return null;

            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12_app_components_panels_panelAlert__["a" /* default */],
              { type: saveMessageAlertType },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                MessageAndActions,
                null,
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  null,
                  saveMessage
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  Actions,
                  null,
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    CancelButton,
                    { onClick: _this3.handleCancelField },
                    Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Cancel')
                  ),
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    SaveButton,
                    {
                      priority: 'primary',
                      type: 'button',
                      onClick: _this3.handleSaveField
                    },
                    Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Save')
                  )
                )
              )
            );
          }
        )
      );
    }
  }]);

  return FormField;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class2.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,

  /** Inline style */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Iff false, disable saveOnBlur for field, instead show a save/cancel button
   */
  saveOnBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If saveOnBlur is false, then an optional saveMessage can be used to let
   * the user know what's going to happen when they save a field.
   */
  saveMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * The "alert type" to use for the save message.
   * Probably only "info"/"warning" should be used.
   */
  saveMessageAlertType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['', 'info', 'warning', 'success', 'error']),

  /**
   * Should hide error message?
   */
  hideErrorMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  /**
   * Hides control state component
   */
  flexibleControlStateSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  // Default value to use for form field if value is not specified in `<Form>` parent
  defaultValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  // the following should only be used without form context
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseOut: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class2.defaultProps = {
  hideErrorMessage: false,
  flexibleControlStateSize: false
}, _class2.contextTypes = {
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  form: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
}, _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleInputMount = function (ref) {
    if (ref && !_this4.input) {
      var hash = _this4.context.location && _this4.context.location.hash;

      if (!hash) return;

      if (hash !== '#' + _this4.props.name) return;

      // Not all form fields have this (e.g. Select fields)
      if (typeof ref.focus === 'function') {
        ref.focus();
      }
    }

    _this4.input = ref;
  };

  this.handleChange = function () {
    var _props3 = _this4.props,
        name = _props3.name,
        onChange = _props3.onChange;

    var _getValueFromEvent = getValueFromEvent.apply(undefined, arguments),
        value = _getValueFromEvent.value,
        event = _getValueFromEvent.event;

    var model = _this4.getModel();

    if (onChange) {
      onChange(value, event);
    }

    model.setValue(name, value);
  };

  this.handleBlur = function () {
    var _props4 = _this4.props,
        name = _props4.name,
        onBlur = _props4.onBlur;

    var _getValueFromEvent2 = getValueFromEvent.apply(undefined, arguments),
        value = _getValueFromEvent2.value,
        event = _getValueFromEvent2.event;

    var model = _this4.getModel();

    if (onBlur) {
      onBlur(value, event);
    }

    // Always call this, so model can decide what to do
    model.handleBlurField(name, value);
  };

  this.handleKeyDown = function () {
    var _props5 = _this4.props,
        onKeyDown = _props5.onKeyDown,
        name = _props5.name;

    var _getValueFromEvent3 = getValueFromEvent.apply(undefined, arguments),
        value = _getValueFromEvent3.value,
        event = _getValueFromEvent3.event;

    var model = _this4.getModel();

    if (event.key === 'Enter') {
      model.handleBlurField(name, value);
    }

    if (onKeyDown) {
      onKeyDown(value, event);
    }
  };

  this.handleSaveField = function () {
    var name = _this4.props.name;

    var model = _this4.getModel();

    model.handleSaveField(name, model.getValue(name));
  };

  this.handleCancelField = function () {
    var name = _this4.props.name;

    var model = _this4.getModel();

    model.handleCancelSaveField(name);
  };
}, _temp3);


/* harmony default export */ __webpack_exports__["a"] = (FormField);

var MessageAndActions = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e1d9f4g26'
})('display:flex;justify-content:space-between;align-items:center;');

var Actions = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e1d9f4g27'
})('height:0;display:flex;align-items:center;justify-content:flex-end;');

var CancelButton = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_7_app_components_buttons_button__["default"], {
  target: 'e1d9f4g28'
})('margin-left:', Object(__WEBPACK_IMPORTED_MODULE_15_app_styles_space__["a" /* default */])(2), ';');
var SaveButton = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_7_app_components_buttons_button__["default"], {
  target: 'e1d9f4g29'
})('margin-left:', Object(__WEBPACK_IMPORTED_MODULE_15_app_styles_space__["a" /* default */])(1), ';');

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchTeams */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchTeamDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateTeam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return joinTeam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return leaveTeam; });
/* harmony export (immutable) */ __webpack_exports__["g"] = updateTeamSuccess;
/* harmony export (immutable) */ __webpack_exports__["a"] = createTeam;
/* harmony export (immutable) */ __webpack_exports__["e"] = removeTeam;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_actions_teamActions__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_actionCreators_indicator__ = __webpack_require__(80);









var doCallback = function doCallback() {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var name = arguments[1];

  if (typeof params[name] === 'function') {
    params[name].apply(params, args);
  }
};

// Fetch teams for org
function fetchTeams(api, params, options) {
  __WEBPACK_IMPORTED_MODULE_0_app_actions_teamActions__["a" /* default */].fetchAll(params.orgId);
  return api.request('/teams/' + params.orgId + '/', {
    success: function success(data) {
      __WEBPACK_IMPORTED_MODULE_0_app_actions_teamActions__["a" /* default */].fetchAllSuccess(params.orgId, data);
      doCallback(options, 'success', data);
    },
    error: function error(_error) {
      __WEBPACK_IMPORTED_MODULE_0_app_actions_teamActions__["a" /* default */].fetchAllError(params.orgId, _error);
      doCallback(options, 'error', _error);
    }
  });
}

function fetchTeamDetails(api, params, options) {
  __WEBPACK_IMPORTED_MODULE_0_app_actions_teamActions__["a" /* default */].fetchDetails(params.teamId);
  return api.request('/teams/' + params.orgId + '/' + params.teamId + '/', {
    success: function success(data) {
      __WEBPACK_IMPORTED_MODULE_0_app_actions_teamActions__["a" /* default */].fetchDetailsSuccess(params.teamId, data);
      doCallback(options, 'success', data);
    },
    error: function error(_error2) {
      __WEBPACK_IMPORTED_MODULE_0_app_actions_teamActions__["a" /* default */].fetchDetailsError(params.teamId, _error2);
      doCallback(options, 'error', _error2);
    }
  });
}

function updateTeamSuccess(teamId, data) {
  __WEBPACK_IMPORTED_MODULE_0_app_actions_teamActions__["a" /* default */].updateSuccess(teamId, data);
}

function updateTeam(api, params, options) {
  var endpoint = '/teams/' + params.orgId + '/' + params.teamId + '/';
  __WEBPACK_IMPORTED_MODULE_0_app_actions_teamActions__["a" /* default */].update(params.teamId, params.data);

  return api.request(endpoint, {
    method: 'PUT',
    data: params.data,
    success: function success(data) {
      updateTeamSuccess(params.teamId, data);
      doCallback(options, 'success', data);
    },
    error: function error(_error3) {
      __WEBPACK_IMPORTED_MODULE_0_app_actions_teamActions__["a" /* default */].updateError(params.teamId, _error3);
      doCallback(options, 'error', _error3);
    }
  });
}

function joinTeam(api, params, options) {
  var endpoint = '/organizations/' + params.orgId + '/members/' + (params.memberId || 'me') + '/teams/' + params.teamId + '/';
  var id = api.uniqueId();

  __WEBPACK_IMPORTED_MODULE_0_app_actions_teamActions__["a" /* default */].update(id, params.teamId);

  return api.request(endpoint, {
    method: 'POST',
    data: params.data,
    success: function success(data) {
      __WEBPACK_IMPORTED_MODULE_0_app_actions_teamActions__["a" /* default */].updateSuccess(params.teamId, data);
      doCallback(options, 'success', data);
    },
    error: function error(_error4) {
      __WEBPACK_IMPORTED_MODULE_0_app_actions_teamActions__["a" /* default */].updateError(id, params.teamId, _error4);
      doCallback(options, 'error', _error4);
    }
  });
}

function leaveTeam(api, params, options) {
  var endpoint = '/organizations/' + params.orgId + '/members/' + (params.memberId || 'me') + '/teams/' + params.teamId + '/';
  var id = api.uniqueId();

  __WEBPACK_IMPORTED_MODULE_0_app_actions_teamActions__["a" /* default */].update(id, params.teamId);

  return api.request(endpoint, {
    method: 'DELETE',
    success: function success(data) {
      __WEBPACK_IMPORTED_MODULE_0_app_actions_teamActions__["a" /* default */].updateSuccess(params.teamId, data);
      doCallback(options, 'success', data);
    },
    error: function error(_error5) {
      __WEBPACK_IMPORTED_MODULE_0_app_actions_teamActions__["a" /* default */].updateError(id, params.teamId, _error5);
      doCallback(options, 'error', _error5);
    }
  });
}

function createTeam(api, team, params, options) {
  __WEBPACK_IMPORTED_MODULE_0_app_actions_teamActions__["a" /* default */].createTeam(team);

  return api.requestPromise('/organizations/' + params.orgId + '/teams/', {
    method: 'POST',
    data: team
  }).then(function (data) {
    __WEBPACK_IMPORTED_MODULE_0_app_actions_teamActions__["a" /* default */].createTeamSuccess(data);
    Object(__WEBPACK_IMPORTED_MODULE_2_app_actionCreators_indicator__["d" /* addSuccessMessage */])(Object(__WEBPACK_IMPORTED_MODULE_1_app_locale__["tct"])('[team] has been added to the [organization] organization', {
      team: '#' + data.slug,
      organization: params.orgId
    }));
    return data;
  }, function (err) {
    __WEBPACK_IMPORTED_MODULE_0_app_actions_teamActions__["a" /* default */].createTeamError(team.slug || team.name, err);
    Object(__WEBPACK_IMPORTED_MODULE_2_app_actionCreators_indicator__["a" /* addErrorMessage */])(Object(__WEBPACK_IMPORTED_MODULE_1_app_locale__["tct"])('Unable to create [team] in the [organization] organization', {
      team: '#' + (team.slug || team.name),
      organization: params.orgId
    }));
    throw err;
  });
}

function removeTeam(api, params, options) {
  __WEBPACK_IMPORTED_MODULE_0_app_actions_teamActions__["a" /* default */].removeTeam(params.teamId);

  return api.requestPromise('/teams/' + params.orgId + '/' + params.teamId + '/', {
    method: 'DELETE'
  }).then(function (data) {
    __WEBPACK_IMPORTED_MODULE_0_app_actions_teamActions__["a" /* default */].removeTeamSuccess(params.teamId, data);
    Object(__WEBPACK_IMPORTED_MODULE_2_app_actionCreators_indicator__["d" /* addSuccessMessage */])(Object(__WEBPACK_IMPORTED_MODULE_1_app_locale__["tct"])('[team] has been removed from the [organization] organization', {
      team: '#' + params.teamId,
      organization: params.orgId
    }));
    return data;
  }, function (err) {
    __WEBPACK_IMPORTED_MODULE_0_app_actions_teamActions__["a" /* default */].removeTeamError(params.teamId, err);
    Object(__WEBPACK_IMPORTED_MODULE_2_app_actionCreators_indicator__["a" /* addErrorMessage */])(Object(__WEBPACK_IMPORTED_MODULE_1_app_locale__["tct"])('Unable to remove [team] from the [organization] organization', {
      team: '#' + params.teamId,
      organization: params.orgId
    }));
    throw err;
  });
}

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_views_settings_components_forms_inputField__ = __webpack_require__(128);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var TextField = (_temp = _class = function (_React$Component) {
  _inherits(TextField, _React$Component);

  function TextField() {
    _classCallCheck(this, TextField);

    return _possibleConstructorReturn(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).apply(this, arguments));
  }

  _createClass(TextField, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_app_views_settings_components_forms_inputField__["a" /* default */], _extends({}, this.props, { type: 'text' }));
    }
  }]);

  return TextField;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_1_app_views_settings_components_forms_inputField__["a" /* default */].propTypes), _temp);


/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_array_from__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lib_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__decorators__ = __webpack_require__(974);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__decorators__["a"]; });
/* unused harmony reexport keydownScoped */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(244);
/* unused harmony reexport setBinding */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_keys__ = __webpack_require__(245);
/* unused harmony reexport Keys */
/* unused harmony reexport ALL_KEYS */
/* unused harmony reexport ALL_PRINTABLE_KEYS */
// polyfill array.from (mainly for IE)


// @keydown and @keydownScoped


// setBinding - only useful if you're not going to use decorators


// Keys - use this to find key codes for strings. for example: Keys.j, Keys.enter


/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_stores_teamStore__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_proptypes__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








/**
 * Higher order component that uses TeamStore and provides a list of teams
 */
var withTeams = function withTeams(WrappedComponent) {
  return __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
    displayName: 'withTeams',
    propTypes: {
      organization: __WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Organization
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_2_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_3_app_stores_teamStore__["a" /* default */], 'onTeamUpdate')],
    getInitialState: function getInitialState() {
      return {
        teams: __WEBPACK_IMPORTED_MODULE_3_app_stores_teamStore__["a" /* default */].getAll()
      };
    },
    onTeamUpdate: function onTeamUpdate() {
      this.setState({
        teams: __WEBPACK_IMPORTED_MODULE_3_app_stores_teamStore__["a" /* default */].getAll()
      });
    },
    render: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, { teams: this.state.teams }));
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (withTeams);

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(419),
    baseAssignValue = __webpack_require__(224);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BooleanField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_views_settings_components_forms_inputField__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_switch__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_confirm__ = __webpack_require__(119);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var BooleanField = (_temp2 = _class = function (_InputField) {
  _inherits(BooleanField, _InputField);

  function BooleanField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BooleanField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BooleanField.__proto__ || Object.getPrototypeOf(BooleanField)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (value, onChange, onBlur, e) {
      // We need to toggle current value because Switch is not an input
      var newValue = _this.coerceValue(!value);
      onChange(newValue, e);
      onBlur(newValue, e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BooleanField, [{
    key: 'coerceValue',
    value: function coerceValue(value) {
      return value ? true : false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          confirm = _props.confirm,
          fieldProps = _objectWithoutProperties(_props, ['confirm']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_views_settings_components_forms_inputField__["a" /* default */], _extends({}, fieldProps, {
        resetOnError: true,
        field: function field(_ref2) {
          var onChange = _ref2.onChange,
              onBlur = _ref2.onBlur,
              value = _ref2.value,
              disabled = _ref2.disabled,
              props = _objectWithoutProperties(_ref2, ['onChange', 'onBlur', 'value', 'disabled']);

          // Create a function with required args bound
          var handleChange = _this2.handleChange.bind(_this2, value, onChange, onBlur);

          var switchProps = _extends({
            size: 'lg'
          }, props, {
            isActive: !!value,
            isDisabled: disabled,
            toggle: handleChange
          });

          if (confirm) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_app_components_confirm__["a" /* default */],
              {
                renderMessage: function renderMessage() {
                  return confirm[!value];
                },
                onConfirm: function onConfirm() {
                  return handleChange({});
                }
              },
              function (_ref3) {
                var open = _ref3.open;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_switch__["default"], _extends({}, switchProps, {
                  toggle: function toggle(e) {
                    // If we have a `confirm` prop and enabling switch
                    // Then show confirm dialog, otherwise propagate change as normal
                    if (confirm[!value]) {
                      // Open confirm modal
                      open();
                      return;
                    }

                    handleChange(e);
                  }
                }));
              }
            );
          }

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_switch__["default"], switchProps);
        }
      }));
    }
  }]);

  return BooleanField;
}(__WEBPACK_IMPORTED_MODULE_2_app_views_settings_components_forms_inputField__["a" /* default */]), _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_2_app_views_settings_components_forms_inputField__["a" /* default */].propTypes, {
  confirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    true: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
    false: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
  })
}), _temp2);


/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_styles_animations__ = __webpack_require__(236);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var RadioGroup = function RadioGroup(_ref) {
  var value = _ref.value,
      choices = _ref.choices,
      label = _ref.label,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ['value', 'choices', 'label', 'onChange']);

  var isSelected = function isSelected(id) {
    return value ? value === id : id === 0;
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    _extends({}, props, { role: 'radiogroup', 'aria-labelledby': label }),
    (choices || []).map(function (_ref2, index) {
      var _ref3 = _slicedToArray(_ref2, 2),
          id = _ref3[0],
          name = _ref3[1];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        RadioLineItem,
        {
          key: index,
          onClick: function onClick(e) {
            return onChange(id, e);
          },
          role: 'radio',
          index: index,
          tabIndex: isSelected(id) ? 0 : -1,
          'aria-checked': isSelected(id)
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          RadioLineButton,
          null,
          isSelected(id) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RadioLineButtonFill, { animate: value !== '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          RadioLineText,
          null,
          name
        )
      );
    })
  );
};

RadioGroup.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  choices: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array),
  label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var RadioLineButton = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])('div', {
  target: 'eeb3g7x0'
})('width:1.5em;height:1.5em;position:relative;border-radius:50%;display:flex;align-items:center;justify-content:center;border:1px solid ', function (p) {
  return p.theme.borderLight;
}, ';box-shadow:inset 0 1px 1px rgba(0,0,0,0.04);');

var RadioLineItem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])('div', {
  target: 'eeb3g7x1'
})('display:flex;align-items:center;cursor:pointer;margin-top:', function (p) {
  return p.index ? '0.5em' : '0';
}, ';outline:none;:focus ', RadioLineButton, '{border:1px solid ', function (p) {
  return p.theme.borderDark;
}, ';}');

var RadioLineButtonFill = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])('div', {
  target: 'eeb3g7x2'
})('width:1rem;height:1rem;border-radius:50%;background-color:', function (p) {
  return p.theme.green;
}, ';animation:', function (p) {
  return p.animate ? '0.2s ' + __WEBPACK_IMPORTED_MODULE_3_app_styles_animations__["c" /* growIn */] + ' ease' : 'none';
}, ';');

var RadioLineText = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])('div', {
  target: 'eeb3g7x3'
})('margin-left:0.5em;font-size:0.875em;font-weight:bold;');

/* harmony default export */ __webpack_exports__["a"] = (RadioGroup);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_actionCreators_indicator__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_constants__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var AvatarCropper = (_temp = _class = function (_React$Component) {
  _inherits(AvatarCropper, _React$Component);

  function AvatarCropper() {
    var _ref;

    _classCallCheck(this, AvatarCropper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = AvatarCropper.__proto__ || Object.getPrototypeOf(AvatarCropper)).call.apply(_ref, [this].concat(args)));

    _this.MIN_DIMENSION = 256;
    _this.MAX_DIMENSION = 1024;

    _this.onChange = function (ev) {
      /*eslint consistent-return:0*/
      var file = ev.target.files[0];

      if (!file) return; // No file selected (e.g. user clicked "cancel")

      if (!/^image\//.test(file.type)) return void _this.handleError('That is not a supported file type.');

      _this.revokeObjectUrl();
      _this.setState({
        file: file,
        objectURL: window.URL.createObjectURL(file)
      }, function () {
        _this.props.updateDataUrlState({ savedDataUrl: null });
      });
    };

    _this.revokeObjectUrl = function () {
      _this.state.objectURL && window.URL.revokeObjectURL(_this.state.objectURL);
    };

    _this.updateDimensions = function (ev) {
      if (!_this.cropContainer) return;

      var $container = $(_this.cropContainer);
      var resizeDimensions = _this.state.resizeDimensions;
      var pageY = ev.pageY;
      var pageX = ev.pageX;
      var top = resizeDimensions.top + (pageY - _this.state.mousePosition.pageY);
      var left = resizeDimensions.left + (pageX - _this.state.mousePosition.pageX);
      if (top < 0) {
        top = 0;
        pageY = _this.state.mousePosition.pageY;
      } else if (top + resizeDimensions.size > $container.height()) {
        top = $container.height() - resizeDimensions.size;
        pageY = _this.state.mousePosition.pageY;
      }
      if (left < 0) {
        left = 0;
        pageX = _this.state.mousePosition.pageX;
      } else if (left + resizeDimensions.size > $container.width()) {
        left = $container.width() - resizeDimensions.size;
        pageX = _this.state.mousePosition.pageX;
      }
      _this.setState({
        resizeDimensions: Object.assign({}, resizeDimensions, { top: top, left: left }),
        mousePosition: { pageX: pageX, pageY: pageY }
      });
    };

    _this.startMove = function () {
      $(document).on('mousemove', _this.updateDimensions);
      $(document).on('mouseup', _this.onMouseUp);
    };

    _this.stopMove = function () {
      $(document).off('mousemove', _this.updateDimensions);
      $(document).off('mouseup', _this.onMouseUp);
      _this.drawToCanvas();
    };

    _this.onMouseDown = function (ev) {
      ev.preventDefault();
      _this.setState({
        mousePosition: {
          pageY: ev.pageY,
          pageX: ev.pageX
        }
      });
      _this.startMove();
    };

    _this.onMouseUp = function (ev) {
      ev.preventDefault();
      _this.stopMove();
    };

    _this.startResize = function (direction, ev) {
      ev.stopPropagation();
      ev.preventDefault();
      $(document).on('mousemove', _this.updateSize);
      $(document).on('mouseup', _this.stopResize);
      _this.setState({
        resizeDirection: direction,
        mousePosition: {
          pageY: ev.pageY,
          pageX: ev.pageX
        }
      });
    };

    _this.stopResize = function (ev) {
      ev.stopPropagation();
      ev.preventDefault();
      $(document).off('mousemove', _this.updateSize);
      $(document).off('mouseup', _this.stopResize);
      _this.drawToCanvas();
    };

    _this.updateSize = function (ev) {
      if (!_this.cropContainer) return;

      var yDiff = ev.pageY - _this.state.mousePosition.pageY;
      var xDiff = ev.pageX - _this.state.mousePosition.pageX;
      var $container = $(_this.cropContainer);

      _this.setState({
        resizeDimensions: _this.getNewDimensions($container, yDiff, xDiff),
        mousePosition: { pageX: ev.pageX, pageY: ev.pageY }
      });
    };

    _this.getDiffNW = function (yDiff, xDiff) {
      return (yDiff - yDiff * 2 + (xDiff - xDiff * 2)) / 2;
    };

    _this.getDiffNE = function (yDiff, xDiff) {
      return (yDiff - yDiff * 2 + xDiff) / 2;
    };

    _this.getDiffSW = function (yDiff, xDiff) {
      return (yDiff + (xDiff - xDiff * 2)) / 2;
    };

    _this.getDiffSE = function (yDiff, xDiff) {
      return (yDiff + xDiff) / 2;
    };

    _this.getNewDimensions = function ($container, yDiff, xDiff) {
      var oldDimensions = _this.state.resizeDimensions;
      var resizeDirection = _this.state.resizeDirection;
      var diff = _this['getDiff' + resizeDirection.toUpperCase()](yDiff, xDiff);

      var height = $container.height() - oldDimensions.top;
      var width = $container.width() - oldDimensions.left;

      // Depending on the direction, we update different dimensions:
      // nw: size, top, left
      // ne: size, top
      // sw: size, left
      // se: size
      var editingTop = resizeDirection === 'nw' || resizeDirection === 'ne';
      var editingLeft = resizeDirection === 'nw' || resizeDirection === 'sw';
      var newDimensions = { size: oldDimensions.size + diff };
      if (editingTop) {
        newDimensions.top = oldDimensions.top - diff;
        height = $container.height() - newDimensions.top;
      }

      if (editingLeft) {
        newDimensions.left = oldDimensions.left - diff;
        width = $container.width() - newDimensions.left;
      }

      if (newDimensions.top < 0) {
        newDimensions.size = newDimensions.size + newDimensions.top;
        if (editingLeft) {
          newDimensions.left = newDimensions.left - newDimensions.top;
        }
        newDimensions.top = 0;
      }

      if (newDimensions.left < 0) {
        newDimensions.size = newDimensions.size + newDimensions.left;
        if (editingTop) {
          newDimensions.top = newDimensions.top - newDimensions.left;
        }
        newDimensions.left = 0;
      }

      var maxSize = Math.min(width, height);
      if (newDimensions.size > maxSize) {
        if (editingTop) {
          newDimensions.top = newDimensions.top + newDimensions.size - maxSize;
        }
        if (editingLeft) {
          newDimensions.left = newDimensions.left + newDimensions.size - maxSize;
        }
        newDimensions.size = maxSize;
      } else if (newDimensions.size < _this.MIN_DIMENSION) {
        if (editingTop) {
          newDimensions.top = newDimensions.top + newDimensions.size - _this.MIN_DIMENSION;
        }
        if (editingLeft) {
          newDimensions.left = newDimensions.left + newDimensions.size - _this.MIN_DIMENSION;
        }
        newDimensions.size = _this.MIN_DIMENSION;
      }
      return Object.assign({}, oldDimensions, newDimensions);
    };

    _this.handleError = function (msg) {
      Object(__WEBPACK_IMPORTED_MODULE_2_app_actionCreators_indicator__["a" /* addErrorMessage */])(Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])(msg));
    };

    _this.validateImage = function () {
      var img = _this.image;
      if (!img) return;
      if (img.naturalWidth < _this.MIN_DIMENSION || img.naturalHeight < _this.MIN_DIMENSION) {
        return 'Please upload an image larger than ' + (_this.MIN_DIMENSION - 1) + 'px by ' + (_this.MIN_DIMENSION - 1) + 'px.';
      }
      if (img.naturalWidth > _this.MAX_DIMENSION || img.naturalHeight > _this.MAX_DIMENSION) {
        return 'Please upload an image smaller than ' + _this.MAX_DIMENSION + 'px by ' + _this.MAX_DIMENSION + 'px.';
      }
    };

    _this.onLoad = function (ev) {
      var error = _this.validateImage();
      if (error) {
        window.URL.revokeObjectURL(_this.state.objectURL);
        _this.setState({ objectURL: null });
        _this.handleError(error);
        return;
      }
      if (!_this.image) return;

      var $img = $(_this.image);
      var dimension = Math.min($img.height(), $img.width());
      _this.setState({
        resizeDimensions: Object.assign({ size: dimension, top: 0, left: 0 })
      }, _this.drawToCanvas);
    };

    _this.drawToCanvas = function () {
      var canvas = _this.canvas;
      if (!canvas) return;
      if (!_this.image) return;
      var resizeDimensions = _this.state.resizeDimensions;
      var img = _this.image;
      // Calculate difference between natural dimensions and rendered dimensions
      var imgRatio = (img.naturalHeight / $(img).height() + img.naturalWidth / $(img).width()) / 2;
      canvas.width = resizeDimensions.size * imgRatio;
      canvas.height = resizeDimensions.size * imgRatio;
      canvas.getContext('2d').drawImage(img, resizeDimensions.left * imgRatio, resizeDimensions.top * imgRatio, resizeDimensions.size * imgRatio, resizeDimensions.size * imgRatio, 0, 0, resizeDimensions.size * imgRatio, resizeDimensions.size * imgRatio);
      _this.finishCrop();
    };

    _this.finishCrop = function () {
      var canvas = _this.canvas;
      if (!canvas) return;
      _this.props.updateDataUrlState({ dataUrl: canvas.toDataURL() });
    };

    _this.getImgSrc = function () {
      var _this$props = _this.props,
          savedDataUrl = _this$props.savedDataUrl,
          model = _this$props.model,
          type = _this$props.type;

      var uuid = model && model.avatar.avatarUuid;
      var photoUrl = uuid && '/' + (__WEBPACK_IMPORTED_MODULE_3_app_constants__["c" /* AVATAR_URL_MAP */][type] || 'avatar') + '/' + uuid + '/';
      return savedDataUrl || _this.state.objectURL || photoUrl;
    };

    _this.onImgDrag = function (ev) {
      ev.preventDefault();
    };

    _this.renderImageCrop = function () {
      var src = _this.getImgSrc();
      if (!src) {
        return null;
      }
      var resizeDimensions = _this.state.resizeDimensions;
      var style = {
        top: resizeDimensions.top,
        left: resizeDimensions.left,
        width: resizeDimensions.size,
        height: resizeDimensions.size
      };
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'image-cropper' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'crop-container', ref: function ref(_ref3) {
              return _this.cropContainer = _ref3;
            } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'image-container' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', {
              className: 'preview',
              ref: function ref(_ref2) {
                return _this.image = _ref2;
              },
              src: src,
              onLoad: _this.onLoad,
              onDragStart: _this.onImgDrag
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'cropper', style: style, onMouseDown: _this.onMouseDown },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { onMouseDown: _this.startResize.bind(_this, 'nw'), className: 'resizer nw' }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { onMouseDown: _this.startResize.bind(_this, 'ne'), className: 'resizer ne' }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { onMouseDown: _this.startResize.bind(_this, 'se'), className: 'resizer se' }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { onMouseDown: _this.startResize.bind(_this, 'sw'), className: 'resizer sw' })
          )
        )
      );
    };

    _this.uploadClick = function (ev) {
      ev.preventDefault();
      if (!_this.file) return;
      _this.file.click();
    };

    _this.renderCanvas = function () {
      if (!_this.getImgSrc()) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'canvas-container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('canvas', { ref: function ref(_ref4) {
            return _this.canvas = _ref4;
          } })
      );
    };

    _this.state = {
      mousePosition: {
        pageX: null,
        pageY: null
      },
      resizeDimensions: {
        top: 0,
        left: 0,
        size: 0
      }
    };
    return _this;
  }

  _createClass(AvatarCropper, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.revokeObjectUrl();
    }

    // Normalize diff accross dimensions so that negative diffs
    // are always making the cropper smaller and positive ones
    // are making the cropper larger

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var src = this.getImgSrc();
      var style = {
        position: 'absolute',
        opacity: 0
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        !src && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'image-well well blankslate' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { onClick: this.uploadClick },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'strong',
                null,
                'Upload a photo'
              )
            ),
            ' ',
            'to get started.'
          )
        ),
        this.renderImageCrop(),
        this.renderCanvas(),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          src && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            { onClick: this.uploadClick },
            Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Change Photo')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
            ref: function ref(_ref5) {
              return _this2.file = _ref5;
            },
            type: 'file',
            accept: 'image/gif,image/jpeg,image/png',
            onChange: this.onChange,
            style: style
          })
        )
      );
    }
  }]);

  return AvatarCropper;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  model: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  updateDataUrlState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['user', 'team', 'organization', 'project']),
  savedDataUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (AvatarCropper);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_u2finterface__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MESSAGES = {
  signin: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Insert your U2F device or tap the button on it to confirm the sign-in request.'),
  sudo: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Alternatively you can use your U2F device to confirm the action.'),
  enroll: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('To enroll your U2F device insert it now or tap the button on it to activate it.')
};

var U2fSign = (_temp = _class = function (_React$Component) {
  _inherits(U2fSign, _React$Component);

  function U2fSign() {
    _classCallCheck(this, U2fSign);

    return _possibleConstructorReturn(this, (U2fSign.__proto__ || Object.getPrototypeOf(U2fSign)).apply(this, arguments));
  }

  _createClass(U2fSign, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          displayMode = _props.displayMode,
          props = _objectWithoutProperties(_props, ['displayMode']);

      var flowMode = displayMode === 'enroll' ? 'enroll' : 'sign';
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_app_components_u2finterface__["a" /* default */],
        _extends({}, props, {
          silentIfUnsupported: displayMode === 'sudo',
          flowMode: flowMode
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          MESSAGES[displayMode] || null
        )
      );
    }
  }]);

  return U2fSign;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  challengeData: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  displayMode: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, _class.defaultProps = {
  displayMode: 'signin'
}, _temp);


/* harmony default export */ __webpack_exports__["default"] = (U2fSign);

/***/ }),
/* 616 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MultiSelectControl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_forms_selectControl__ = __webpack_require__(317);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var MultiSelectControl = function (_React$Component) {
  _inherits(MultiSelectControl, _React$Component);

  function MultiSelectControl() {
    _classCallCheck(this, MultiSelectControl);

    return _possibleConstructorReturn(this, (MultiSelectControl.__proto__ || Object.getPrototypeOf(MultiSelectControl)).apply(this, arguments));
  }

  _createClass(MultiSelectControl, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_app_components_forms_selectControl__["a" /* default */], _extends({}, this.props, { multi: true }));
    }
  }]);

  return MultiSelectControl;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);



/***/ }),
/* 618 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(235),
    getPrototype = __webpack_require__(634),
    isObjectLike = __webpack_require__(200);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(224),
    createAggregator = __webpack_require__(1004);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;


/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_views_settings_components_forms_inputField__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_forms_selectControl__ = __webpack_require__(317);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var SelectField = (_temp2 = _class = function (_React$Component) {
  _inherits(SelectField, _React$Component);

  function SelectField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SelectField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectField.__proto__ || Object.getPrototypeOf(SelectField)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (onBlur, onChange, optionObj) {
      var value = void 0;

      // If optionObj is empty, then it probably means that the field was "cleared"
      if (!optionObj) {
        value = optionObj;
      } else if (_this.props.multiple) {
        // List of optionObjs
        value = optionObj.map(function (_ref2) {
          var val = _ref2.value;
          return val;
        });
      } else {
        value = optionObj.value;
      }

      onChange(value, {});
      onBlur(value, {});
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SelectField, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          multiple = _props.multiple,
          allowClear = _props.allowClear,
          otherProps = _objectWithoutProperties(_props, ['multiple', 'allowClear']);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_views_settings_components_forms_inputField__["a" /* default */], _extends({}, otherProps, {
        alignRight: this.props.small,
        field: function field(_ref3) {
          var onChange = _ref3.onChange,
              onBlur = _ref3.onBlur,
              disabled = _ref3.disabled,
              props = _objectWithoutProperties(_ref3, ['onChange', 'onBlur', 'disabled']);

          var choices = props.choices || [];

          if (typeof props.choices === 'function') {
            choices = props.choices(props);
          }

          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_forms_selectControl__["a" /* default */], _extends({}, props, {
            clearable: allowClear,
            multi: multiple,
            disabled: disabled,
            onChange: _this2.handleChange.bind(_this2, onBlur, onChange),
            value: props.value,
            options: choices.map(function (_ref4) {
              var _ref5 = _slicedToArray(_ref4, 2),
                  value = _ref5[0],
                  label = _ref5[1];

              return {
                value: value,
                label: label
              };
            })
          }));
        }
      }));
    }
  }]);

  return SelectField;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_2_app_views_settings_components_forms_inputField__["a" /* default */].propTypes, {
  choices: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]).isRequired,
  allowClear: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  allowEmpty: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  multiple: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  escapeMarkup: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  small: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}), _class.defaultProps = _extends({}, __WEBPACK_IMPORTED_MODULE_2_app_views_settings_components_forms_inputField__["a" /* default */].defaultProps, {
  allowClear: false,
  allowEmpty: false,
  placeholder: '--',
  escapeMarkup: true,
  multiple: false,
  small: false
}), _temp2);


/***/ }),
/* 622 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(841),
    listCacheDelete = __webpack_require__(842),
    listCacheGet = __webpack_require__(843),
    listCacheHas = __webpack_require__(844),
    listCacheSet = __webpack_require__(845);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_api__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_actionCreators_indicator__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_forms_state__ = __webpack_require__(167);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}










var FormModel = (_class = function () {

  /**
   * Holds a list of `fields` states
   */


  /**
   * State of the form as a whole
   */


  /**
   * Errors for individual fields
   * Note we don't keep error in `this.fieldState` so that we can easily
   * See if the form is in an "error" state with the `isError` getter
   */
  function FormModel() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var initialData = _ref.initialData,
        options = _objectWithoutProperties(_ref, ['initialData']);

    _classCallCheck(this, FormModel);

    _initDefineProp(this, 'fields', _descriptor, this);

    _initDefineProp(this, 'errors', _descriptor2, this);

    _initDefineProp(this, 'fieldState', _descriptor3, this);

    _initDefineProp(this, 'formState', _descriptor4, this);

    this.fieldDescriptor = new Map();
    this.snapshots = [];
    this.initialData = {};

    this.setFormOptions(options);

    if (initialData) {
      this.setInitialData(initialData);
    }

    this.api = new __WEBPACK_IMPORTED_MODULE_2_app_api__["Client"]();
  }

  /**
   * Reset state of model
   */


  /**
   * POJO of field name -> value
   * It holds field values "since last save"
   */


  /**
   * Holds field properties as declared in <Form>
   * Does not need to be observable since these props should never change
   */


  /**
   * State of individual fields
   *
   * Map of field name -> object
   */

  _createClass(FormModel, [{
    key: 'reset',
    value: function reset() {
      this.api.clear();
      this.api = null;
      this.fieldDescriptor.clear();
      this.resetForm();
    }
  }, {
    key: 'resetForm',
    value: function resetForm() {
      this.fields.clear();
      this.errors.clear();
      this.fieldState.clear();
      this.snapshots = [];
      this.initialData = {};
    }

    /**
     * Deep equality comparison between last saved state and current fields state
     */

  }, {
    key: 'setInitialData',


    /**
     * Sets initial form data
     *
     * Also resets snapshots
     */
    value: function setInitialData(initialData) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          noResetSnapshots = _ref2.noResetSnapshots;

      this.fields.replace(initialData || {});
      this.initialData = this.fields.toJSON() || {};

      if (noResetSnapshots) return;

      this.snapshots = [new Map(this.fields)];
    }

    /**
     * Set form options
     */

  }, {
    key: 'setFormOptions',
    value: function setFormOptions(options) {
      this.options = options || {};
    }

    /**
     * Set field properties
     */

  }, {
    key: 'setFieldDescriptor',
    value: function setFieldDescriptor(id, props) {
      this.fieldDescriptor.set(id, props);

      // Set default value iff initialData for field is undefined
      // This must take place before checking for `props.setValue` so that it can
      // be applied to `defaultValue`
      if (typeof props.defaultValue !== 'undefined' && typeof this.initialData[id] === 'undefined') {
        this.initialData[id] = props.defaultValue;
        this.fields.set(id, this.initialData[id]);
      }

      if (typeof props.setValue === 'function') {
        this.initialData[id] = props.setValue(this.initialData[id], props);
        this.fields.set(id, this.initialData[id]);
      }
    }

    /**
     * Creates a cloned Map of `this.fields` and returns a closure that when called
     * will save Map to `snapshots
     */

  }, {
    key: 'createSnapshot',
    value: function createSnapshot() {
      var _this = this;

      var snapshot = new Map(this.fields);
      return function () {
        return _this.snapshots.unshift(snapshot);
      };
    }
  }, {
    key: 'getDescriptor',
    value: function getDescriptor(id, key) {
      // Needs to call `has` or else component will not be reactive if `id` doesn't exist in observable map
      var descriptor = this.fieldDescriptor.has(id) && this.fieldDescriptor.get(id);
      if (!descriptor) {
        return null;
      }

      return descriptor[key];
    }
  }, {
    key: 'getFieldState',
    value: function getFieldState(id, key) {
      // Needs to call `has` or else component will not be reactive if `id` doesn't exist in observable map
      var fieldState = this.fieldState.has(id) && this.fieldState.get(id);
      if (!fieldState) {
        return null;
      }

      return fieldState[key];
    }
  }, {
    key: 'getValue',
    value: function getValue(id) {
      if (!this.fields.has(id)) {
        return '';
      }

      return this.fields.get(id);
    }
  }, {
    key: 'getTransformedValue',
    value: function getTransformedValue(id) {
      var fieldDescriptor = this.fieldDescriptor.get(id);
      var transformer = fieldDescriptor && typeof fieldDescriptor.getValue === 'function' ? fieldDescriptor.getValue : null;
      var value = this.getValue(id);

      return transformer ? transformer(value) : value;
    }

    /**
     * Data represented in UI
     */

  }, {
    key: 'getData',
    value: function getData() {
      return this.fields.toJSON();
    }

    /**
     * Form data that will be sent to API endpoint (i.e. after transforms)
     */

  }, {
    key: 'getTransformedData',
    value: function getTransformedData() {
      var _this2 = this;

      var form = this.getData();

      return Object.keys(form).map(function (id) {
        return [id, _this2.getTransformedValue(id)];
      }).reduce(function (acc, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            id = _ref4[0],
            value = _ref4[1];

        acc[id] = value;
        return acc;
      }, {});
    }
  }, {
    key: 'getError',
    value: function getError(id) {
      return this.errors.has(id) && this.errors.get(id);
    }

    // Returns true if not required or is required and is not empty

  }, {
    key: 'isValidRequiredField',
    value: function isValidRequiredField(id) {
      // Check field descriptor to see if field is required
      var isRequired = this.getDescriptor(id, 'required');
      return !isRequired || this.getValue(id) !== '';
    }
  }, {
    key: 'isValidField',
    value: function isValidField(id) {
      var _this3 = this;

      var validate = this.getDescriptor(id, 'validate');
      var errors = [];

      if (typeof validate === 'function') {
        // Returns "tuples" of [id, error string]
        errors = validate({ model: this, id: id, form: this.getData() }) || [];
      }

      errors.filter(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            errorMessage = _ref6[1];

        return !!errorMessage;
      }).forEach(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
            field = _ref8[0],
            errorMessage = _ref8[1];

        _this3.setError(field, errorMessage);
      });

      return !errors.length && this.isValidRequiredField(id);
    }
  }, {
    key: 'doApiRequest',
    value: function doApiRequest(_ref9) {
      var _this4 = this;

      var apiEndpoint = _ref9.apiEndpoint,
          apiMethod = _ref9.apiMethod,
          data = _ref9.data;

      var endpoint = apiEndpoint || this.options.apiEndpoint;
      var method = apiMethod || this.options.apiMethod;

      return new Promise(function (resolve, reject) {
        _this4.api.request(endpoint, {
          method: method,
          data: data,
          success: function success(response) {
            return resolve(response);
          },
          error: function error(_error) {
            return reject(_error);
          }
        });
      });
    }
  }, {
    key: 'setValue',
    value: function setValue(id, value) {
      this.fields.set(id, value);

      if (this.options.onFieldChange) {
        this.options.onFieldChange(id, value);
      }

      this.updateErrorState(id);
      this.updateShowSaveState(id, value);
      this.updateShowReturnButtonState(id, value);
    }
  }, {
    key: 'updateErrorState',
    value: function updateErrorState(id) {
      var fieldIsRequiredMessage = Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Field is required');
      var isValid = this.isValidRequiredField(id);
      // specifically check for empty string, 0 should be allowed
      if (isValid && !this.errors.get(id)) return;
      if (!isValid && this.errors.get(id) === fieldIsRequiredMessage) return;

      this.setError(id, isValid ? false : fieldIsRequiredMessage);
    }
  }, {
    key: 'updateShowSaveState',
    value: function updateShowSaveState(id, value) {
      var isValueChanged = value !== this.initialData[id];
      // Update field state to "show save" if save on blur is disabled for this field
      // (only if contents of field differs from initial value)
      var saveOnBlurFieldOverride = this.getDescriptor(id, 'saveOnBlur');
      if (typeof saveOnBlurFieldOverride === 'undefined' || saveOnBlurFieldOverride) return;
      if (this.getFieldState(id, 'showSave') === isValueChanged) return;

      this.setFieldState(id, 'showSave', isValueChanged);
    }
  }, {
    key: 'updateShowReturnButtonState',
    value: function updateShowReturnButtonState(id, value) {
      var isValueChanged = value !== this.initialData[id];
      var shouldShowReturnButton = this.getDescriptor(id, 'showReturnButton');

      if (!shouldShowReturnButton) return;
      // Only update state if state has changed
      if (this.getFieldState(id, 'showReturnButton') === isValueChanged) return;

      this.setFieldState(id, 'showReturnButton', isValueChanged);
    }

    /**
     * Changes form values to previous saved state
     */

  }, {
    key: 'undo',
    value: function undo() {
      // Always have initial data snapshot
      if (this.snapshots.length < 2) return null;

      this.snapshots.shift();
      this.fields.replace(this.snapshots[0]);

      return true;
    }

    /**
     * Attempts to save entire form to server and saves a snapshot for undos
     */

  }, {
    key: 'saveForm',
    value: function saveForm() {
      var _this5 = this;

      // Represents state of current form
      var form = this.getData();

      var errors = [].concat(_toConsumableArray(Object.keys(form).filter(function (id) {
        return !_this5.isValidField(id);
      }) || []), _toConsumableArray(Array.from(this.fieldDescriptor.keys()).filter(function (id) {
        return !_this5.isValidField(id);
      }) || []));

      if (errors.length > 0) return null;

      var saveSnapshot = this.createSnapshot();

      var request = this.doApiRequest({
        data: this.getTransformedData()
      });

      request.then(function (resp) {
        // save snapshot
        if (saveSnapshot) {
          saveSnapshot();
          saveSnapshot = null;
        }

        if (_this5.options.onSubmitSuccess) {
          _this5.options.onSubmitSuccess(resp, _this5);
        }
      }).catch(function (resp) {
        // should we revert field value to last known state?
        saveSnapshot = null;
        if (_this5.options.resetOnError) {
          _this5.setInitialData({});
        }
        _this5.submitError(resp);
        if (_this5.options.onSubmitError) {
          _this5.options.onSubmitError(resp, _this5);
        }
      });

      return request;
    }

    /**
     * Attempts to save field and show undo message if necessary.
     * Calls submit handlers.
     */

  }, {
    key: 'saveField',
    value: function saveField(id, currentValue) {
      var _this6 = this;

      var oldValue = this.initialData[id];
      var savePromise = this.saveFieldRequest(id, currentValue);

      if (!savePromise) return null;

      return savePromise.then(function (resp) {
        var newValue = _this6.getValue(id);
        var change = { old: oldValue, new: newValue };

        // Only use `allowUndo` option if explicity defined
        if (typeof _this6.options.allowUndo === 'undefined' || _this6.options.allowUndo) {
          Object(__WEBPACK_IMPORTED_MODULE_3_app_actionCreators_indicator__["f" /* saveOnBlurUndoMessage */])(change, _this6, id);
        }

        if (_this6.options.onSubmitSuccess) {
          _this6.options.onSubmitSuccess(resp, _this6, id, change);
        }

        return resp;
      }).catch(function (error) {
        if (_this6.options.onSubmitError) {
          _this6.options.onSubmitError(error, _this6, id);
        }
        return {};
      });
    }

    /**
     * Saves a field with new value
     *
     * If field has changes, field does not have errors, then it will:
     * Save a snapshot, apply any data transforms, perform api request.
     *
     * If successful then: 1) reset save state, 2) update `initialData`, 3) save snapshot
     * If failed then: 1) reset save state, 2) add error state
     */

  }, {
    key: 'saveFieldRequest',
    value: function saveFieldRequest(id, currentValue) {
      var _this7 = this;

      var initialValue = this.initialData[id];

      // Don't save if field hasn't changed
      // Don't need to check for error state since initialData wouldn't have updated since last error
      if (currentValue === initialValue || currentValue === '' && !Object(__WEBPACK_IMPORTED_MODULE_4_app_utils__["d" /* defined */])(initialValue)) return null;

      // Check for error first
      if (!this.isValidField(id)) return null;

      // shallow clone fields
      var saveSnapshot = this.createSnapshot();

      // Save field + value
      this.setSaving(id, true);

      var fieldDescriptor = this.fieldDescriptor.get(id);

      // Check if field needs to handle transforming request object
      var getData = typeof fieldDescriptor.getData === 'function' ? fieldDescriptor.getData : function (a) {
        return a;
      };

      var request = this.doApiRequest({
        data: getData(_defineProperty({}, id, this.getTransformedValue(id)), { model: this, id: id, form: this.getData() })
      });

      request.then(function (data) {
        _this7.setSaving(id, false);

        // save snapshot
        if (saveSnapshot) {
          saveSnapshot();
          saveSnapshot = null;
        }

        // Update initialData after successfully saving a field as it will now be the baseline value
        _this7.initialData[id] = _this7.getValue(id);

        return data;
      }).catch(function (resp) {
        // should we revert field value to last known state?
        saveSnapshot = null;

        // Field can be configured to reset on error
        // e.g. BooleanFields
        var shouldReset = _this7.getDescriptor(id, 'resetOnError');
        if (shouldReset) {
          _this7.setValue(id, initialValue);
        }

        // API can return a JSON object with either:
        // 1) map of {[fieldName] => Array<ErrorMessages>}
        // 2) {'non_field_errors' => Array<ErrorMessages>}
        if (resp && resp.responseJSON) {
          // Show resp msg from API endpoint if possible
          if (Array.isArray(resp.responseJSON[id]) && resp.responseJSON[id].length) {
            // Just take first resp for now
            _this7.setError(id, resp.responseJSON[id][0]);
          } else if (Array.isArray(resp.responseJSON.non_field_errors) && resp.responseJSON.non_field_errors.length) {
            Object(__WEBPACK_IMPORTED_MODULE_3_app_actionCreators_indicator__["a" /* addErrorMessage */])(resp.responseJSON.non_field_errors[0], 10000);
            // Reset saving state
            _this7.setError(id, '');
          } else {
            _this7.setError(id, 'Failed to save');
          }
        } else {
          // Default error behavior
          _this7.setError(id, 'Failed to save');
        }

        // eslint-disable-next-line no-console
        console.error('Error saving form field', resp && resp.responseJSON);
      });

      return request;
    }

    /**
     * This is called when a field is blurred
     *
     * If `saveOnBlur` is set then call `saveField` and handle form callbacks accordingly
     */

  }, {
    key: 'handleBlurField',
    value: function handleBlurField(id, currentValue) {
      // Nothing to do if `saveOnBlur` is not on
      if (!this.options.saveOnBlur) return null;

      // Fields can individually set `saveOnBlur` to `false` (note this is ignored when `undefined`)
      var saveOnBlurFieldOverride = this.getDescriptor(id, 'saveOnBlur');
      if (typeof saveOnBlurFieldOverride !== 'undefined' && !saveOnBlurFieldOverride) {
        return null;
      }

      return this.saveField(id, currentValue);
    }

    /**
     * This is called when a field does not saveOnBlur and has an individual "Save" button
     */

  }, {
    key: 'handleSaveField',
    value: function handleSaveField(id, currentValue) {
      var _this8 = this;

      return this.saveField(id, currentValue).then(function () {
        _this8.setFieldState(id, 'showSave', false);
      });
    }

    /**
     * Cancel "Save Field" state and revert form value back to initial value
     */

  }, {
    key: 'handleCancelSaveField',
    value: function handleCancelSaveField(id) {
      this.setValue(id, this.initialData[id]);
      this.setFieldState(id, 'showSave', false);
    }
  }, {
    key: 'setFieldState',
    value: function setFieldState(id, key, value) {
      var state = _extends({}, this.fieldState.get(id) || {}, _defineProperty({}, key, value));
      this.fieldState.set(id, state);
    }

    /**
     * Set "saving" state for field
     */

  }, {
    key: 'setSaving',
    value: function setSaving(id, value) {
      // When saving, reset error state
      this.setError(id, false);
      this.setFieldState(id, __WEBPACK_IMPORTED_MODULE_6_app_components_forms_state__["a" /* default */].SAVING, value);
      this.setFieldState(id, __WEBPACK_IMPORTED_MODULE_6_app_components_forms_state__["a" /* default */].READY, !value);
    }

    /**
     * Set "error" state for field
     */

  }, {
    key: 'setError',
    value: function setError(id, error) {
      // Note we don't keep error in `this.fieldState` so that we can easily
      // See if the form is in an "error" state with the `isError` getter
      if (!!error) {
        this.formState = __WEBPACK_IMPORTED_MODULE_6_app_components_forms_state__["a" /* default */].ERROR;
        this.errors.set(id, error);
      } else {
        this.formState = __WEBPACK_IMPORTED_MODULE_6_app_components_forms_state__["a" /* default */].READY;
        this.errors.delete(id);
      }

      // Field should no longer to "saving", but is not necessarily "ready"
      this.setFieldState(id, __WEBPACK_IMPORTED_MODULE_6_app_components_forms_state__["a" /* default */].SAVING, false);
    }

    // TODO: More validations

  }, {
    key: 'validate',
    value: function validate() {}
  }, {
    key: 'handleErrorResponse',
    value: function handleErrorResponse() {
      var _this9 = this;

      var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          resp = _ref10.responseJSON;

      if (!resp) return;

      // Show resp msg from API endpoint if possible
      Object.keys(resp).forEach(function (id) {
        if (id === 'non_field_errors' && Array.isArray(resp.non_field_errors) && resp.non_field_errors.length) {
          Object(__WEBPACK_IMPORTED_MODULE_3_app_actionCreators_indicator__["a" /* addErrorMessage */])(resp.non_field_errors[0], 10000);
        } else if (Array.isArray(resp[id]) && resp[id].length) {
          // Just take first resp for now
          _this9.setError(id, resp[id][0]);
        }
      });
    }
  }, {
    key: 'submitSuccess',
    value: function submitSuccess(data) {
      // update initial data
      this.formState = __WEBPACK_IMPORTED_MODULE_6_app_components_forms_state__["a" /* default */].READY;
      this.initialData = data;
    }
  }, {
    key: 'submitError',
    value: function submitError(err) {
      this.formState = __WEBPACK_IMPORTED_MODULE_6_app_components_forms_state__["a" /* default */].ERROR;
      this.formErrors = err.responseJSON;
      this.handleErrorResponse(err);
    }
  }, {
    key: 'formChanged',
    get: function get() {
      return !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(this.initialData, this.fields.toJSON());
    }
  }, {
    key: 'formData',
    get: function get() {
      return this.fields;
    }

    /** Is form saving */

  }, {
    key: 'isSaving',
    get: function get() {
      return this.formState === __WEBPACK_IMPORTED_MODULE_6_app_components_forms_state__["a" /* default */].SAVING;
    }

    /** Does form have any errors */

  }, {
    key: 'isError',
    get: function get() {
      return !!this.errors.size;
    }
  }]);

  return FormModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'fields', [__WEBPACK_IMPORTED_MODULE_1_mobx__["i" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return new Map();
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'errors', [__WEBPACK_IMPORTED_MODULE_1_mobx__["i" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return new Map();
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'fieldState', [__WEBPACK_IMPORTED_MODULE_1_mobx__["i" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return new Map();
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'formState', [__WEBPACK_IMPORTED_MODULE_1_mobx__["i" /* observable */]], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, 'formChanged', [__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* computed */]], Object.getOwnPropertyDescriptor(_class.prototype, 'formChanged'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'formData', [__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* computed */]], Object.getOwnPropertyDescriptor(_class.prototype, 'formData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isSaving', [__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* computed */]], Object.getOwnPropertyDescriptor(_class.prototype, 'isSaving'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isError', [__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* computed */]], Object.getOwnPropertyDescriptor(_class.prototype, 'isError'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setValue', [__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, 'setValue'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateErrorState', [__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, 'updateErrorState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateShowSaveState', [__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, 'updateShowSaveState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateShowReturnButtonState', [__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, 'updateShowReturnButtonState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'undo', [__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, 'undo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'saveForm', [__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, 'saveForm'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'saveField', [__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, 'saveField'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'saveFieldRequest', [__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, 'saveFieldRequest'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleBlurField', [__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, 'handleBlurField'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleSaveField', [__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, 'handleSaveField'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleCancelSaveField', [__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, 'handleCancelSaveField'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setFieldState', [__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, 'setFieldState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setSaving', [__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, 'setSaving'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setError', [__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, 'setError'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'validate', [__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, 'validate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleErrorResponse', [__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, 'handleErrorResponse'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'submitSuccess', [__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, 'submitSuccess'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'submitError', [__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, 'submitError'), _class.prototype)), _class);


/* harmony default export */ __webpack_exports__["a"] = (FormModel);

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(925);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 630 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 631 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 632 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MultipleCheckboxField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_forms_formField__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_utils__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var MultipleCheckboxField = (_temp2 = _class = function (_FormField) {
  _inherits(MultipleCheckboxField, _FormField);

  function MultipleCheckboxField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MultipleCheckboxField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MultipleCheckboxField.__proto__ || Object.getPrototypeOf(MultipleCheckboxField)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (value, e) {
      var allValues = _this.state.value;
      if (e.target.checked) {
        if (allValues) {
          allValues = [].concat(_toConsumableArray(allValues), [value]);
        } else {
          allValues = [value];
        }
      } else {
        allValues = allValues.filter(function (v) {
          return v !== value;
        });
      }
      _this.setValue(allValues);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MultipleCheckboxField, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          required = _props.required,
          className = _props.className,
          disabled = _props.disabled,
          disabledReason = _props.disabledReason,
          label = _props.label,
          help = _props.help,
          choices = _props.choices,
          hideLabelDivider = _props.hideLabelDivider,
          style = _props.style;
      var error = this.state.error;

      var cx = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'control-group', {
        'has-error': error
      });
      // Hacky, but this isn't really a form label vs the checkbox labels, but
      // we want to treat it as one (i.e. for "required" indicator)
      var labelCx = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
        required: required
      });
      var shouldShowDisabledReason = disabled && disabledReason;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: style, className: cx },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: labelCx },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'controls' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'label',
              {
                className: 'control-label',
                style: {
                  display: 'block',
                  marginBottom: !hideLabelDivider ? 10 : undefined,
                  borderBottom: !hideLabelDivider ? '1px solid #f1eff3' : undefined
                }
              },
              label,
              shouldShowDisabledReason && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_app_components_tooltip__["default"],
                { title: disabledReason },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  { className: 'disabled-indicator' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon-question' })
                )
              )
            ),
            help && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { className: 'help-block' },
              help
            ),
            error && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { className: 'error' },
              error
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'control-list' },
          choices.map(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2),
                value = _ref3[0],
                choiceLabel = _ref3[1];

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'label',
              { className: 'checkbox', key: value },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
                type: 'checkbox',
                value: value,
                onChange: _this2.onChange.bind(_this2, value),
                disabled: disabled,
                checked: Object(__WEBPACK_IMPORTED_MODULE_5_app_utils__["d" /* defined */])(_this2.state.value) && _this2.state.value.indexOf(value) !== -1
              }),
              choiceLabel
            );
          })
        )
      );
    }
  }]);

  return MultipleCheckboxField;
}(__WEBPACK_IMPORTED_MODULE_3_app_components_forms_formField__["a" /* default */]), _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_3_app_components_forms_formField__["a" /* default */].propTypes, {
  hideLabelDivider: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  choices: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired
}), _temp2);


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(234);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var functions = {};

var localStorage = window.localStorage;

try {
  var mod = 'sentry';
  localStorage.setItem(mod, mod);
  localStorage.removeItem(mod);

  functions = {
    setItem: localStorage.setItem.bind(localStorage),
    getItem: localStorage.getItem.bind(localStorage)
  };
} catch (e) {
  functions = {
    setItem: function setItem() {
      return;
    },

    // Returns null if key doesn't exist:
    // https://developer.mozilla.org/en-US/docs/Web/API/Storage/getItem
    getItem: function getItem() {
      return null;
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (functions);

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getOption;
/* harmony export (immutable) */ __webpack_exports__["c"] = getOptionField;
/* harmony export (immutable) */ __webpack_exports__["a"] = getForm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_keyBy__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_stores_configStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_forms__ = __webpack_require__(55);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







// This are ordered based on their display order visually
var sections = [{
  key: 'system'
}, {
  key: 'mail',
  heading: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Outbound email')
}, {
  key: 'auth',
  heading: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Authentication')
}, {
  key: 'beacon',
  heading: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Beacon')
}];

// This are ordered based on their display order visually
var definitions = [{
  key: 'system.url-prefix',
  label: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Root URL'),
  placeholder: 'https://sentry.example.com',
  help: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('The root web address which is used to communicate with the Sentry backend.'),
  defaultValue: function defaultValue() {
    return document.location.protocol + '//' + document.location.host;
  }
}, {
  key: 'system.admin-email',
  label: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Admin Email'),
  placeholder: 'admin@example.com',
  help: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('The technical contact for this Sentry installation.'),
  // TODO(dcramer): this should not be hardcoded to a component
  component: __WEBPACK_IMPORTED_MODULE_4_app_components_forms__["EmailField"],
  defaultValue: function defaultValue() {
    return __WEBPACK_IMPORTED_MODULE_2_app_stores_configStore__["default"].get('user').email;
  }
}, {
  key: 'system.support-email',
  label: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Support Email'),
  placeholder: 'support@example.com',
  help: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('The support contact for this Sentry installation.'),
  // TODO(dcramer): this should not be hardcoded to a component
  component: __WEBPACK_IMPORTED_MODULE_4_app_components_forms__["EmailField"],
  defaultValue: function defaultValue() {
    return __WEBPACK_IMPORTED_MODULE_2_app_stores_configStore__["default"].get('user').email;
  }
}, {
  key: 'system.security-email',
  label: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Security Email'),
  placeholder: 'security@example.com',
  help: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('The security contact for this Sentry installation.'),
  // TODO(dcramer): this should not be hardcoded to a component
  component: __WEBPACK_IMPORTED_MODULE_4_app_components_forms__["EmailField"],
  defaultValue: function defaultValue() {
    return __WEBPACK_IMPORTED_MODULE_2_app_stores_configStore__["default"].get('user').email;
  }
}, {
  key: 'system.rate-limit',
  label: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Rate Limit'),
  placeholder: 'e.g. 500',
  help: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('The maximum number of events the system should accept per minute. A value of 0 will disable the default rate limit.')
}, {
  key: 'auth.allow-registration',
  label: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Allow Registration'),
  help: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Allow anyone to create an account and access this Sentry installation.'),
  component: __WEBPACK_IMPORTED_MODULE_4_app_components_forms__["BooleanField"],
  defaultValue: function defaultValue() {
    return false;
  }
}, {
  key: 'auth.ip-rate-limit',
  label: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('IP Rate Limit'),
  placeholder: 'e.g. 10',
  help: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('The maximum number of times an authentication attempt may be made by a single IP address in a 60 second window.')
}, {
  key: 'auth.user-rate-limit',
  label: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('User Rate Limit'),
  placeholder: 'e.g. 10',
  help: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('The maximum number of times an authentication attempt may be made against a single account in a 60 second window.')
}, {
  key: 'api.rate-limit.org-create',
  label: 'Organization Creation Rate Limit',
  placeholder: 'e.g. 5',
  help: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('The maximum number of organizations which may be created by a single account in a one hour window.')
}, {
  key: 'beacon.anonymous',
  label: 'Usage Statistics',
  component: __WEBPACK_IMPORTED_MODULE_4_app_components_forms__["RadioBooleanField"],
  // yes and no are inverted here due to the nature of this configuration
  noLabel: 'Send my contact information along with usage statistics',
  yesLabel: 'Please keep my usage information anonymous',
  yesFirst: false,
  help: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["tct"])('If enabled, any stats reported to sentry.io will exclude identifying information (such as your administrative email address). By anonymizing your installation the Sentry team will be unable to contact you about security updates. For more information on what data is sent to Sentry, see the [link:documentation].', {
    link: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { href: 'https://docs.sentry.io/server/beacon/' })
  })
}, {
  key: 'mail.from',
  label: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Email From'),
  component: __WEBPACK_IMPORTED_MODULE_4_app_components_forms__["EmailField"],
  defaultValue: function defaultValue() {
    return 'sentry@' + document.location.hostname;
  },
  help: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Email address to be used in From for all outbound email.')
}, {
  key: 'mail.host',
  label: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('SMTP Host'),
  placeholder: 'localhost',
  defaultValue: function defaultValue() {
    return 'localhost';
  }
}, {
  key: 'mail.port',
  label: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('SMTP Port'),
  placeholder: '25',
  defaultValue: function defaultValue() {
    return '25';
  }
}, {
  key: 'mail.username',
  label: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('SMTP Username'),
  defaultValue: function defaultValue() {
    return '';
  }
}, {
  key: 'mail.password',
  label: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('SMTP Password'),
  // TODO(mattrobenolt): We don't want to use a real password field unless
  // there's a way to reveal it. Without being able to see the password, it's
  // impossible to confirm if it's right.
  // component: PasswordField,
  defaultValue: function defaultValue() {
    return '';
  }
}, {
  key: 'mail.use-tls',
  label: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Use TLS?'),
  component: __WEBPACK_IMPORTED_MODULE_4_app_components_forms__["BooleanField"],
  defaultValue: function defaultValue() {
    return false;
  }
}];

var definitionsMap = __WEBPACK_IMPORTED_MODULE_0_lodash_keyBy___default()(definitions, function (def) {
  return def.key;
});

var disabledReasons = {
  diskPriority: 'This setting is defined in config.yml and may not be changed via the web UI.',
  smtpDisabled: 'SMTP mail has been disabled, so this option is unavailable'
};

function getOption(option) {
  return definitionsMap[option];
}

function optionsForSection(section) {
  return definitions.filter(function (option) {
    return option.key.split('.')[0] === section.key;
  });
}

function getOptionField(option, field) {
  var meta = _extends({}, getOption(option), field);
  var Field = meta.component || __WEBPACK_IMPORTED_MODULE_4_app_components_forms__["TextField"];
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Field, _extends({}, meta, {
    name: option,
    key: option,
    defaultValue: meta.defaultValue ? meta.defaultValue() : undefined,
    required: meta.required && !meta.allowEmpty,
    disabledReason: meta.disabledReason && disabledReasons[meta.disabledReason]
  }));
}

function getSectionFieldSet(section, fields) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'fieldset',
    { key: section.key },
    section.heading && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'legend',
      null,
      section.heading
    ),
    fields
  );
}

function getForm(fields) {
  // fields is a object mapping key name to Fields, so the goal is to split
  // them up into multiple sections, and spit out fieldsets with a grouping of
  // all fields, in the right order, under their section.
  var sets = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = sections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var section = _step.value;

      var set = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = optionsForSection(section)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var option = _step2.value;

          if (fields[option.key]) {
            set.push(fields[option.key]);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (set.length) {
        sets.push(getSectionFieldSet(section, set));
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return sets;
}

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RangeField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_views_settings_components_forms_inputField__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_views_settings_components_forms_controls_rangeSlider__ = __webpack_require__(638);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var RangeField = function (_React$Component) {
  _inherits(RangeField, _React$Component);

  function RangeField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RangeField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RangeField.__proto__ || Object.getPrototypeOf(RangeField)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (onChange, onBlur, value, e) {
      // We need to toggle current value because Switch is not an input
      onChange(value, e);
      // onBlur(value, e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RangeField, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_app_views_settings_components_forms_inputField__["a" /* default */], _extends({}, this.props, {
        field: function field(_ref2) {
          var onChange = _ref2.onChange,
              onBlur = _ref2.onBlur,
              value = _ref2.value,
              disabled = _ref2.disabled,
              props = _objectWithoutProperties(_ref2, ['onChange', 'onBlur', 'value', 'disabled']);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_views_settings_components_forms_controls_rangeSlider__["a" /* default */], _extends({}, props, {
            isDisabled: disabled,
            value: value,
            onBlur: onBlur,
            onChange: _this2.onChange.bind(_this2, onChange, onBlur)
          }));
        }
      }));
    }
  }]);

  return RangeField;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);



/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var RangeSlider = (_temp = _class = function (_React$Component) {
  _inherits(RangeSlider, _React$Component);

  function RangeSlider(props) {
    _classCallCheck(this, RangeSlider);

    var _this = _possibleConstructorReturn(this, (RangeSlider.__proto__ || Object.getPrototypeOf(RangeSlider)).call(this, props));

    _this.getActualValue = function (sliderValue) {
      var allowedValues = _this.props.allowedValues;

      var value = void 0;

      if (allowedValues) {
        // If `allowedValues` is defined, then `sliderValue` represents index to `allowedValues`
        value = allowedValues[sliderValue];
      } else {
        value = sliderValue;
      }

      return value;
    };

    _this.handleInput = function (e) {
      var sliderValue = parseInt(e.target.value, 10);

      _this.setState({
        sliderValue: sliderValue
      });

      if (_this.props.onChange) {
        var value = _this.getActualValue(sliderValue);
        _this.props.onChange(value, e);
      }
    };

    _this.handleBlur = function (e) {
      var onBlur = _this.props.onBlur;

      if (typeof onBlur !== 'function') return;

      onBlur(e);
    };

    var state = { sliderValue: props.value };
    if (props.allowedValues) {
      // With `allowedValues` sliderValue will be the index to value in `allowedValues`
      // This is so we can snap the rangeSlider using `step`
      // This means that the range slider will have a uniform `step` in the UI
      // and scale won't match `allowedValues
      // e.g. with allowedValues = [0, 100, 1000, 10000] - in UI we'll have values = [0, 3] w/ step of 1
      // so it always snaps at 25% width
      state.sliderValue = props.allowedValues.indexOf(props.value);
    }

    _this.state = state;
    return _this;
  }

  _createClass(RangeSlider, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Update local state when re-rendered with next `props.value` (e.g if this is controlled)
      if (typeof nextProps.value !== 'undefined') {
        var allowedValues = this.props.allowedValues;

        var sliderValue = nextProps.value;

        // If `allowedValues` is defined, then `sliderValue` represents index to `allowedValues`
        if (allowedValues && allowedValues.indexOf(sliderValue) > -1) {
          sliderValue = allowedValues.indexOf(sliderValue);
        }
        this.setState({ sliderValue: sliderValue });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          min = _props.min,
          max = _props.max,
          step = _props.step,
          allowedValues = _props.allowedValues,
          formatLabel = _props.formatLabel;
      var sliderValue = this.state.sliderValue;

      var actualValue = sliderValue;
      var displayValue = actualValue;

      if (allowedValues) {
        step = 1;
        min = 0;
        max = allowedValues.length - 1;
        actualValue = allowedValues[sliderValue];
        displayValue = typeof actualValue !== 'undefined' ? actualValue : Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Invalid value');
      }

      displayValue = typeof formatLabel === 'function' ? formatLabel(actualValue) : displayValue;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Label,
          { 'for': name },
          displayValue
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Slider, {
          type: 'range',
          name: name,
          min: min,
          max: max,
          step: step,
          onInput: this.handleInput,
          onChange: function onChange() {},
          onMouseUp: this.handleBlur,
          onKeyUp: this.handleBlur,
          value: sliderValue
        })
      );
    }
  }]);

  return RangeSlider;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  /**
   * min allowed value, not needed if using `allowedValues`
   */
  min: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  /**
   * max allowed value, not needed if using `allowedValues`
   */
  max: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  /**
   * String is a valid type here only for empty string
   * Otherwise react complains:
   * "`value` prop on `input` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components."
   *
   * And we want this to be a controlled input when value is empty
   */
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
  step: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,

  /**
   * Render prop for slider's label
   * Is passed the value as an argument
   */
  formatLabel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,

  /**
   * Array of allowed values. Make sure `value` is in this list.
   * THIS NEEDS TO BE SORTED
   */
  allowedValues: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number),

  /**
   * This is called when *any* MouseUp or KeyUp event happens.
   * Used for "smart" Fields to trigger a "blur" event. `onChange` can
   * be triggered quite frequently
   */
  onBlur: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (RangeSlider);

var Slider = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('input', {
  target: 'e1txnpuj0'
})('/* stylelint-disable-next-line property-no-vendor-prefix */\n  -webkit-appearance:none;width:100%;margin:', function (p) {
  return p.theme.grid;
}, 'px 0 ', function (p) {
  return p.theme.grid * 2;
}, 'px;&::-webkit-slider-runnable-track{width:100%;height:3px;cursor:pointer;background:', function (p) {
  return p.theme.borderLight;
}, ';border-radius:3px;border:0;}&::-moz-range-track{width:100%;height:3px;cursor:pointer;background:', function (p) {
  return p.theme.borderLight;
}, ';border-radius:3px;border:0;}&::-ms-track{width:100%;height:3px;cursor:pointer;background:', function (p) {
  return p.theme.borderLight;
}, ';border-radius:3px;border:0;}&::-webkit-slider-thumb{box-shadow:0 0 0 3px #fff;height:17px;width:17px;border-radius:50%;background:', function (p) {
  return p.theme.purple;
}, ';cursor:pointer;/* stylelint-disable-next-line property-no-vendor-prefix */\n    -webkit-appearance:none;margin-top:-7px;border:0;}&::-moz-range-thumb{box-shadow:0 0 0 3px #fff;height:17px;width:17px;border-radius:50%;background:', function (p) {
  return p.theme.purple;
}, ';cursor:pointer;/* stylelint-disable-next-line property-no-vendor-prefix */\n    -webkit-appearance:none;margin-top:-7px;border:0;}&::-ms-thumb{box-shadow:0 0 0 3px #fff;height:17px;width:17px;border-radius:50%;background:', function (p) {
  return p.theme.purple;
}, ';cursor:pointer;/* stylelint-disable-next-line property-no-vendor-prefix */\n    -webkit-appearance:none;margin-top:-7px;border:0;}&::-ms-fill-lower{background:', function (p) {
  return p.theme.borderLight;
}, ';border:0;border-radius:50%;}&::-ms-fill-upper{background:', function (p) {
  return p.theme.borderLight;
}, ');border:0;border-radius:50%;}&:focus{outline:none;&::-webkit-slider-runnable-track{background:', function (p) {
  return p.theme.borderDark;
}, ';}&::-ms-fill-upper{background:', function (p) {
  return p.theme.borderDark;
}, ';}&::-ms-fill-lower{background:', function (p) {
  return p.theme.borderDark;
}, ';}}');

var Label = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('label', {
  target: 'e1txnpuj1'
})('font-size:14px;margin-bottom:', function (p) {
  return p.theme.grid;
}, 'px;color:', function (p) {
  return p.theme.gray3;
}, ';');

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export INTERFACES */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_utils_analytics__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_utils_logging__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_events_eventCause__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_events_contexts__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_events_contextSummary__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_events_eventDataSection__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_events_errors__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_events_extraData__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_events_packageData__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_events_eventTags__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_events_sdk__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_events_device__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_components_events_userReport__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_mixins_groupState__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_app_components_events_interfaces_exception__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_app_components_events_interfaces_message__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_app_components_events_interfaces_request__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_app_components_events_interfaces_stacktrace__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_app_components_events_interfaces_template__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_app_components_events_interfaces_csp__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_app_components_events_interfaces_breadcrumbs__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_app_components_events_interfaces_generic__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_app_components_events_interfaces_threads__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_app_components_events_interfaces_debugmeta__ = __webpack_require__(1103);


































var INTERFACES = {
  exception: __WEBPACK_IMPORTED_MODULE_20_app_components_events_interfaces_exception__["a" /* default */],
  message: __WEBPACK_IMPORTED_MODULE_21_app_components_events_interfaces_message__["a" /* default */],
  request: __WEBPACK_IMPORTED_MODULE_22_app_components_events_interfaces_request__["a" /* default */],
  stacktrace: __WEBPACK_IMPORTED_MODULE_23_app_components_events_interfaces_stacktrace__["a" /* default */],
  template: __WEBPACK_IMPORTED_MODULE_24_app_components_events_interfaces_template__["a" /* default */],
  csp: __WEBPACK_IMPORTED_MODULE_25_app_components_events_interfaces_csp__["a" /* default */],
  expectct: __WEBPACK_IMPORTED_MODULE_27_app_components_events_interfaces_generic__["a" /* default */],
  expectstaple: __WEBPACK_IMPORTED_MODULE_27_app_components_events_interfaces_generic__["a" /* default */],
  hpkp: __WEBPACK_IMPORTED_MODULE_27_app_components_events_interfaces_generic__["a" /* default */],
  breadcrumbs: __WEBPACK_IMPORTED_MODULE_26_app_components_events_interfaces_breadcrumbs__["a" /* default */],
  threads: __WEBPACK_IMPORTED_MODULE_28_app_components_events_interfaces_threads__["a" /* default */],
  debugmeta: __WEBPACK_IMPORTED_MODULE_29_app_components_events_interfaces_debugmeta__["a" /* default */]
};

var EventEntries = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'EventEntries',

  propTypes: {
    group: __WEBPACK_IMPORTED_MODULE_16_app_proptypes__["e" /* default */].Group.isRequired,
    event: __WEBPACK_IMPORTED_MODULE_16_app_proptypes__["e" /* default */].Event.isRequired,
    orgId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    project: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
    // TODO(dcramer): ideally isShare would be replaced with simple permission
    // checks
    isShare: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_17_app_mixins_groupState__["a" /* default */]],

  getDefaultProps: function getDefaultProps() {
    return {
      isShare: false
    };
  },
  recordSourcemapError: function recordSourcemapError(errorTypes) {
    var _props = this.props,
        project = _props.project,
        event = _props.event;


    Object(__WEBPACK_IMPORTED_MODULE_3_app_utils_analytics__["a" /* default */])('sourcemap.sourcemap_error', {
      'org_id': project.organization.id,
      'group': event.groupID,
      'error_type': errorTypes
    });
  },
  componentDidMount: function componentDidMount() {
    var event = this.props.event;


    if (!event.errors || !event.errors.length > 0) return;
    var errors = event.errors;
    var errorTypes = errors.map(function (errorEntries) {
      return errorEntries.type;
    });

    this.recordSourcemapError(errorTypes);
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return this.props.event.id !== nextProps.event.id;
  },


  interfaces: INTERFACES,

  render: function render() {
    var _this = this;

    var _props2 = this.props,
        group = _props2.group,
        isShare = _props2.isShare,
        project = _props2.project,
        event = _props2.event,
        orgId = _props2.orgId;

    var organization = this.getOrganization();
    var features = organization ? new Set(organization.features) : new Set();
    var entries = event.entries.map(function (entry, entryIdx) {
      try {
        var Component = _this.interfaces[entry.type];
        if (!Component) {
          /*eslint no-console:0*/
          window.console && console.error && console.error('Unregistered interface: ' + entry.type);
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, {
          key: 'entry-' + entryIdx,
          group: group,
          event: event,
          type: entry.type,
          data: entry.data,
          isShare: isShare
        });
      } catch (ex) {
        Object(__WEBPACK_IMPORTED_MODULE_4_app_utils_logging__["logException"])(ex);
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_app_components_events_eventDataSection__["a" /* default */],
          {
            group: group,
            event: event,
            type: entry.type,
            title: entry.type
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_19_app_locale__["t"])('There was an error rendering this data.')
          )
        );
      }
    });

    var hasContext = !__WEBPACK_IMPORTED_MODULE_18_app_utils__["c" /* default */].objectIsEmpty(event.user) || !__WEBPACK_IMPORTED_MODULE_18_app_utils__["c" /* default */].objectIsEmpty(event.contexts);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'entries' },
      !__WEBPACK_IMPORTED_MODULE_18_app_utils__["c" /* default */].objectIsEmpty(event.errors) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_events_errors__["a" /* default */], { group: group, event: event }),
      ' ',
      !isShare && features.has('suggested-commits') && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_events_eventCause__["a" /* default */], { event: event, orgId: orgId, projectId: project.slug }),
      event.userReport && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_app_components_events_userReport__["a" /* default */], {
        report: event.userReport,
        orgId: orgId,
        projectId: project.slug,
        issueId: group.id
      }),
      hasContext && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_events_contextSummary__["a" /* default */], { group: group, event: event }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_events_eventTags__["a" /* default */], { group: group, event: event, orgId: orgId, projectId: project.slug }),
      entries,
      hasContext && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_events_contexts__["a" /* default */], { group: group, event: event }),
      !__WEBPACK_IMPORTED_MODULE_18_app_utils__["c" /* default */].objectIsEmpty(event.context) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_events_extraData__["a" /* default */], { group: group, event: event }),
      !__WEBPACK_IMPORTED_MODULE_18_app_utils__["c" /* default */].objectIsEmpty(event.packages) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_events_packageData__["a" /* default */], { group: group, event: event }),
      !__WEBPACK_IMPORTED_MODULE_18_app_utils__["c" /* default */].objectIsEmpty(event.device) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_app_components_events_device__["a" /* default */], { group: group, event: event }),
      !__WEBPACK_IMPORTED_MODULE_18_app_utils__["c" /* default */].objectIsEmpty(event.sdk) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_app_components_events_sdk__["a" /* default */], { group: group, event: event }),
      !__WEBPACK_IMPORTED_MODULE_18_app_utils__["c" /* default */].objectIsEmpty(event.sdk) && event.sdk.upstream.isNewer && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'alert-block alert-info box' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon-exclamation' }),
        Object(__WEBPACK_IMPORTED_MODULE_19_app_locale__["t"])('This event was reported with an old version of the %s SDK.', event.platform),
        event.sdk.upstream.url && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          { href: event.sdk.upstream.url, className: 'btn btn-sm btn-default' },
          Object(__WEBPACK_IMPORTED_MODULE_19_app_locale__["t"])('Learn More')
        )
      ),
      ' '
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (EventEntries);

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(234);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(221),
    isObjectLike = __webpack_require__(200);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_inlineSvg__ = __webpack_require__(24);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var PullRequestLink = (_temp2 = _class = function (_React$Component) {
  _inherits(PullRequestLink, _React$Component);

  function PullRequestLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PullRequestLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PullRequestLink.__proto__ || Object.getPrototypeOf(PullRequestLink)).call.apply(_ref, [this].concat(args))), _this), _this.getUrl = function () {
      if (_this.props.repository.provider.id === 'github') {
        return _this.props.repository.url + '/pull/' + _this.props.pullRequest.id;
      }
      return undefined;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PullRequestLink, [{
    key: 'render',
    value: function render() {
      var url = this.getUrl();
      var displayId = this.props.repository.name + ' #' + this.props.pullRequest.id + ': ' + this.props.pullRequest.title;

      return url ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        {
          className: this.props.inline ? 'inline-commit' : 'btn btn-default btn-sm',
          href: url,
          target: '_blank'
        },
        this.props.repository.provider.id == 'github' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_inlineSvg__["a" /* default */], { src: 'icon-github', style: { verticalAlign: 'text-top' }, size: '14px' }),
        this.props.repository.provider.id == 'bitbucket' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_inlineSvg__["a" /* default */], {
          src: 'icon-bitbucket',
          style: { verticalAlign: 'text-top' },
          size: '14px'
        }),
        '\xA0',
        this.props.inline ? '' : ' ',
        displayId
      ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        null,
        displayId
      );
    }
  }]);

  return PullRequestLink;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  pullRequest: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  repository: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  inline: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (PullRequestLink);

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var TagTextStyled = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])('span', {
  target: 'e6q9yfr0'
})('display:inline;padding:0.4em 0.6em;font-size:75%;font-weight:bold;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:0.25em;margin-left:0.5em;text-transform:lowercase;background-color:', function (p) {
  return p.priority ? p.theme.alert[p.priority].background : p.theme.gray1;
}, ';');

var Tag = function Tag(_ref) {
  var children = _ref.children,
      priority = _ref.priority,
      props = _objectWithoutProperties(_ref, ['children', 'priority']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    TagTextStyled,
    { priority: priority },
    children
  );
};

Tag.propTypes = {
  priority: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Tag);

/***/ }),
/* 644 */,
/* 645 */,
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony export (immutable) */ __webpack_exports__["a"] = getCookie;
function getCookie(name) {
  var cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = jQuery.trim(cookies[i]);
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) == name + '=') {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_radio__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_views_settings_components_text_textBlock__ = __webpack_require__(81);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Label = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('label', {
  target: 'e1y9x5r70'
})(function (p) {
  return p.disabled ? 'cursor: default' : '';
}, ';display:flex;flex:1;align-items:center;margin-bottom:0;');

var RoleSelect = (_temp = _class = function (_React$Component) {
  _inherits(RoleSelect, _React$Component);

  function RoleSelect() {
    _classCallCheck(this, RoleSelect);

    return _possibleConstructorReturn(this, (RoleSelect.__proto__ || Object.getPrototypeOf(RoleSelect)).apply(this, arguments));
  }

  _createClass(RoleSelect, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          disabled = _props.disabled,
          enforceAllowed = _props.enforceAllowed,
          roleList = _props.roleList,
          selectedRole = _props.selectedRole;


      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_app_components_panels__["a" /* Panel */],
        { className: 'new-invite-team' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_app_components_panels__["e" /* PanelHeader */],
          null,
          Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Role')
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_app_components_panels__["c" /* PanelBody */],
          null,
          roleList.map(function (role, i) {
            var desc = role.desc,
                name = role.name,
                id = role.id,
                allowed = role.allowed;

            var isDisabled = disabled || enforceAllowed && !allowed;
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_app_components_panels__["f" /* PanelItem */],
              {
                key: id,
                onClick: function onClick() {
                  return !isDisabled && _this2.props.setRole(id);
                },
                className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(!isDisabled ? {} : { color: 'grey', cursor: 'default' })
              },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                Label,
                null,
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_radio__["a" /* default */], {
                  id: id,
                  value: name,
                  checked: id === selectedRole,
                  readOnly: true,
                  style: { margin: 0 }
                }),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  { style: { flex: 1, padding: '0 16px' } },
                  name,
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_app_views_settings_components_text_textBlock__["default"],
                    {
                      className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])({ marginBottom: 0 })
                    },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      'div',
                      { className: 'help-block' },
                      desc
                    )
                  )
                )
              )
            );
          })
        )
      );
    }
  }]);

  return RoleSelect;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  /**
   * Whether to disable or not using `allowed` prop from API request
   */
  enforceAllowed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectedRole: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  roleList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  setRole: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (RoleSelect);

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_checkbox__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_idBadge__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_panels__ = __webpack_require__(18);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var TeamItem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e1tbg1m40'
})('width:25%;padding:6px;');

var TeamSelect = (_temp = _class = function (_React$Component) {
  _inherits(TeamSelect, _React$Component);

  function TeamSelect() {
    _classCallCheck(this, TeamSelect);

    return _possibleConstructorReturn(this, (TeamSelect.__proto__ || Object.getPrototypeOf(TeamSelect)).apply(this, arguments));
  }

  _createClass(TeamSelect, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          disabled = _props.disabled,
          teams = _props.teams,
          selectedTeams = _props.selectedTeams,
          toggleTeam = _props.toggleTeam;
      //no need to select a team when there's only one option

      if (teams.length < 2) return null;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_app_components_panels__["a" /* Panel */],
        { className: 'new-invite-team' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_app_components_panels__["e" /* PanelHeader */],
          null,
          Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Team')
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_app_components_panels__["c" /* PanelBody */],
          { className: 'grouping-controls team-choices' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_app_components_panels__["f" /* PanelItem */],
            {
              className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])({ flexWrap: 'wrap' })
            },
            teams.map(function (team) {
              return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                TeamItem,
                { key: team.slug },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'label',
                  { className: 'checkbox' },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_checkbox__["a" /* default */], {
                    id: team.slug,
                    disabled: disabled,
                    checked: selectedTeams.has(team.slug),
                    onChange: function onChange(e) {
                      toggleTeam(team.slug);
                    },
                    style: { marginTop: '1px' }
                  }),
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_idBadge__["a" /* default */], { team: team, hideAvatar: true })
                )
              );
            })
          )
        )
      );
    }
  }]);

  return TeamSelect;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectedTeams: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Set),
  teams: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  toggleTeam: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (TeamSelect);

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(650);


/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_hot_loader__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom_server__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom_server___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom_server__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emotion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_emotion_theming__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_raven_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_lib_Modal__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_bootstrap_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_utils_emotion_setup__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_utils_emotion_setup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_app_utils_emotion_setup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_constants__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_main__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_app_api__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_app_utils_getCookie__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_app_plugins__ = __webpack_require__(252);
/* global module */



























function csrfSafeMethod(method) {
  // these HTTP methods do not require CSRF protection
  return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method)
  );
}

// setup jquery for CSRF tokens
__WEBPACK_IMPORTED_MODULE_15_jquery___default.a.ajaxSetup({
  beforeSend: function beforeSend(xhr, settings) {
    if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
      xhr.setRequestHeader('X-CSRFToken', Object(__WEBPACK_IMPORTED_MODULE_21_app_utils_getCookie__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_18_app_constants__["d" /* CSRF_COOKIE_NAME */]));
    }
  }
});

// these get exported to a global variable, which is important as its the only
// way we can call into scoped objects

var render = function render(Component) {
  var rootEl = document.getElementById('blk_router');
  __WEBPACK_IMPORTED_MODULE_10_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react_hot_loader__["AppContainer"],
    null,
    __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Component, null)
  ), rootEl);
};

if (false) {
  // webpack 2 has built in support for es2015 modules, so don't have to re-require
  module.hot.accept('./main', function () {
    render(Main);
  });
}

/* harmony default export */ __webpack_exports__["default"] = ({
  jQuery: __WEBPACK_IMPORTED_MODULE_15_jquery___default.a,
  moment: __WEBPACK_IMPORTED_MODULE_16_moment___default.a,
  Raven: __WEBPACK_IMPORTED_MODULE_7_raven_js___default.a,
  React: __WEBPACK_IMPORTED_MODULE_8_react___default.a,
  ReactDOM: {
    findDOMNode: __WEBPACK_IMPORTED_MODULE_10_react_dom___default.a.findDOMNode,
    render: __WEBPACK_IMPORTED_MODULE_10_react_dom___default.a.render
  },
  PropTypes: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a,
  ReactDOMServer: {
    renderToStaticMarkup: __WEBPACK_IMPORTED_MODULE_1_react_dom_server__["renderToStaticMarkup"]
  },
  createReactClass: __WEBPACK_IMPORTED_MODULE_14_create_react_class___default.a,
  ReactBootstrap: {
    Modal: __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_lib_Modal___default.a
  },
  Reflux: __WEBPACK_IMPORTED_MODULE_12_reflux___default.a,
  Router: __WEBPACK_IMPORTED_MODULE_13_react_router__,
  JsCookie: __WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a,
  Emotion: __WEBPACK_IMPORTED_MODULE_2_emotion__,
  EmotionTheming: __WEBPACK_IMPORTED_MODULE_3_emotion_theming__,
  ReactEmotion: __WEBPACK_IMPORTED_MODULE_11_react_emotion__,
  GridEmotion: __WEBPACK_IMPORTED_MODULE_4_grid_emotion__,

  SentryRenderApp: function SentryRenderApp() {
    return render(__WEBPACK_IMPORTED_MODULE_19_app_main__["a" /* default */]);
  },

  Sentry: {
    api: __WEBPACK_IMPORTED_MODULE_20_app_api__,
    forms: {
      // we dont yet export all form field classes as they're not
      // all needed by sentry.io
      ApiForm: __webpack_require__(418).default,
      BooleanField: __webpack_require__(324).default,
      DateTimeField: __webpack_require__(499).default,
      EmailField: __webpack_require__(325).default,
      Form: __webpack_require__(243).default,
      RadioBooleanField: __webpack_require__(504).default,
      RangeField: __webpack_require__(326).default,
      Select2Field: __webpack_require__(170).default,
      TextField: __webpack_require__(222).default,
      TextareaField: __webpack_require__(275).default
    },
    plugins: {
      add: __WEBPACK_IMPORTED_MODULE_23_app_plugins__["a" /* default */].add,
      addContext: __WEBPACK_IMPORTED_MODULE_23_app_plugins__["a" /* default */].addContext,
      BasePlugin: __WEBPACK_IMPORTED_MODULE_23_app_plugins__["a" /* default */].BasePlugin,
      DefaultIssuePlugin: __WEBPACK_IMPORTED_MODULE_23_app_plugins__["a" /* default */].DefaultIssuePlugin
    },

    Alerts: __webpack_require__(515).default,
    AlertActions: __webpack_require__(142).default,
    AsyncComponent: __webpack_require__(182).default,
    AsyncView: __webpack_require__(92).default,
    // TODO(billy): remove when old personal settings are deprecated #new-settings
    AvatarSettings: __webpack_require__(1328).default,
    Button: __webpack_require__(26).default,
    mixins: {
      ApiMixin: __webpack_require__(8).default,
      TooltipMixin: __webpack_require__(1330).default
    },
    BarChart: __webpack_require__(215).default,
    i18n: __WEBPACK_IMPORTED_MODULE_22_app_locale__,
    ConfigStore: __webpack_require__(25).default,
    Count: __webpack_require__(82).default,
    DateTime: __webpack_require__(103).default,
    DropdownLink: __webpack_require__(37).default,
    DynamicWrapper: __webpack_require__(192).default,
    ErrorBoundary: __webpack_require__(63).default,
    Form: __webpack_require__(243).default,
    FormState: __webpack_require__(55).FormState,
    GuideAnchor: __webpack_require__(65).default,
    HookStore: __webpack_require__(72).default,
    Indicators: __webpack_require__(519).default,
    IndicatorStore: __webpack_require__(30).default,
    InviteMember: __webpack_require__(569).default,
    LoadingError: __webpack_require__(15).default,
    LoadingIndicator: __webpack_require__(11).default,
    ListLink: __webpack_require__(122).default,
    MenuItem: __webpack_require__(44).default,
    NarrowLayout: __webpack_require__(125).default,
    OrganizationHomeContainer: __webpack_require__(255).default,
    OrganizationsLoader: __webpack_require__(1331).default,
    OrganizationMembersView: __webpack_require__(558).default,
    Panel: __webpack_require__(522).default,
    PanelHeader: __webpack_require__(337).default,
    PanelBody: __webpack_require__(336).default,
    PanelItem: __webpack_require__(523).default,
    Pagination: __webpack_require__(54).default,
    PluginConfig: __webpack_require__(362).default,
    ProjectIssueTracking: __webpack_require__(560).default,
    ProjectSelector: __webpack_require__(210).default,
    SettingsPageHeader: __webpack_require__(52).default,

    Sidebar: __webpack_require__(278).default,
    StackedBarChart: __webpack_require__(213).default,
    TextBlock: __webpack_require__(81).default,
    TimeSince: __webpack_require__(45).default,
    TodoList: __webpack_require__(361).default,
    Tooltip: __webpack_require__(21).default,
    U2fEnrollment: __webpack_require__(1332).default,
    U2fSign: __webpack_require__(615).default,
    Badge: __webpack_require__(398).default,
    Switch: __webpack_require__(214).default,
    GlobalModal: __webpack_require__(518).default,
    SetupWizard: __webpack_require__(1333).default,
    theme: __webpack_require__(126).default,
    utils: {
      errorHandler: __webpack_require__(568).default,
      logging: __webpack_require__(191)
    }
  }
});

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(652)


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(653);
} else {
  module.exports = require('./index.dev');
}

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.AppContainer = __webpack_require__(654);

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(655);
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */

var React = __webpack_require__(0);

var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

/* global process */

// NEEDS to be true for production because of performance
// But travis builds with NODE_ENV = production, so turn off speed when
// IS_PERCY is true (i.e. we are in TRAVIS and PERCY_TOKEN is set)
if (undefined) {
  var sheet = __webpack_require__(27).sheet;
  sheet.speedy(false);
}

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Main; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_routes__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_actionCreators_preferences__ = __webpack_require__(551);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Main = function (_React$Component) {
  _inherits(Main, _React$Component);

  function Main() {
    _classCallCheck(this, Main);

    return _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).apply(this, arguments));
  }

  _createClass(Main, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      Object(__WEBPACK_IMPORTED_MODULE_3_app_actionCreators_preferences__["b" /* loadPreferencesState */])();
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_router__["Router"],
        { history: __WEBPACK_IMPORTED_MODULE_1_react_router__["browserHistory"] },
        Object(__WEBPACK_IMPORTED_MODULE_2_app_routes__["a" /* default */])()
      );
    }
  }]);

  return Main;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);



/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_views_accountAuthorizations__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_views_accountLayout__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_views_apiApplicationDetails__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_views_apiApplications__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_views_apiLayout__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_views_apiNewToken__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_views_apiTokens__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_views_app__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_views_onboarding_createProject__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_views_groupDetails__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_views_groupEvents__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_views_groupEventDetails__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_views_groupMerged_groupMergedView__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_views_groupSimilar_groupSimilarView__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_views_groupTagValues__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_views_groupTags__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_views_groupUserReports__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_stores_hookStore__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_app_views_myIssues_assignedToMe__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_app_views_myIssues_bookmarked__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_app_views_myIssues_viewed__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_app_views_projectInstall_newProject__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_app_views_onboarding_configure_index__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_app_views_onboarding_index__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_app_views_organizationActivity__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_app_views_organizationContext__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_app_views_organizationCreate__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_app_views_organizationDashboard__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_app_views_organizationDetails__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_app_components_organizations_homeContainer__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_app_views_settings_organizationMembers__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_app_views_organizationRoot__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_app_views_organizationStats__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_app_views_projectEnvironments__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_app_views_projectTags__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_app_views_projectChooser__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_app_views_projectDashboard__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_app_views_projectDataForwarding__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_app_views_projectDebugSymbols__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_app_views_projectDetails__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_app_views_projectInstall_docsContext__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_app_views_projectEvents__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_app_views_projectInstall_gettingStarted__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_app_views_projectInstall_overview__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_app_views_projectInstall_platform__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_app_views_projectIssueTracking__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_app_views_projectReleases__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_app_views_projectSavedSearches__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_app_views_projectSettings__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_app_views_projectUserReports__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_app_views_projectPlugins__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_app_views_projectPluginDetails__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_app_views_releaseAllEvents__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_app_views_releaseArtifacts__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_app_views_releases_releaseCommits__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_app_views_releaseDetails__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_app_views_releaseNewEvents__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_app_views_releases_releaseOverview__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_app_views_routeNotFound__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_app_views_settings_components_settingsProjectProvider__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_app_views_settings_components_settingsWrapper__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_app_views_stream__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__ = __webpack_require__(568);




































































function appendTrailingSlash(nextState, replace) {
  var lastChar = nextState.location.pathname.slice(-1);
  if (lastChar !== '/') {
    replace(nextState.location.pathname + '/');
  }
}

/**
 * Use react-router to lazy load a route. Use this for codesplitting containers (e.g. SettingsLayout)
 *
 * The method for lazy loading a route leaf node is using the <LazyLoad> component + `componentPromise`.
 * The reason for this is because react-router handles the route tree better and if we use <LazyLoad> it will end
 * up having to re-render more components than necesssary.
 */
var lazyLoad = function lazyLoad(cb) {
  return function (m) {
    return cb(null, m.default);
  };
};

var accountSettingsRoutes = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
  null,
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRedirect"], { to: 'details/' }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
    path: 'details/',
    name: 'Details',
    componentPromise: function componentPromise() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1571));
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
  }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
    { path: 'notifications/', name: 'Notifications' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], {
      componentPromise: function componentPromise() {
        return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1572));
      },
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
      path: ':fineTuneType/',
      name: 'Fine Tune Alerts',
      componentPromise: function componentPromise() {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1573));
      },
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
    })
  ),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
    path: 'emails/',
    name: 'Emails',
    componentPromise: function componentPromise() {
      return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1574));
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
  }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
    path: 'authorizations/',
    componentPromise: function componentPromise() {
      return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 1575));
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
  }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
    { name: 'Security', path: 'security/' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], {
      componentPromise: function componentPromise() {
        return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1576));
      },
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
      path: ':authId/enroll/',
      name: 'Enroll',
      componentPromise: function componentPromise() {
        return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1577));
      },
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
      path: ':authId/',
      name: 'Details',
      componentPromise: function componentPromise() {
        return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1578));
      },
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
    })
  ),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
    path: 'subscriptions/',
    name: 'Subscriptions',
    componentPromise: function componentPromise() {
      return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 1579));
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
  }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
    path: 'identities/',
    name: 'Identities',
    componentPromise: function componentPromise() {
      return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 1580));
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
  }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
    { path: 'api/', name: 'API' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRedirect"], { to: 'auth-tokens/' }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
      { path: 'auth-tokens/', name: 'Auth Tokens' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], {
        componentPromise: function componentPromise() {
          return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1581));
        },
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
        path: 'new-token/',
        name: 'Create New Token',
        componentPromise: function componentPromise() {
          return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 1582));
        },
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
      })
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
      { path: 'applications/', name: 'Applications' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], {
        componentPromise: function componentPromise() {
          return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 1583));
        },
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
        path: ':appId/',
        name: 'Details',
        componentPromise: function componentPromise() {
          return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1584));
        },
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
      })
    )
  ),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
    path: 'close-account/',
    name: 'Close Account',
    componentPromise: function componentPromise() {
      return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 1585));
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
  })
);

var projectSettingsRoutes = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
  null,
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], {
    name: 'General',
    componentPromise: function componentPromise() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1586));
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
  }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
    path: 'teams/',
    name: 'Teams',
    componentPromise: function componentPromise() {
      return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1587));
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
  }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
    { name: 'Alerts', path: 'alerts/' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], {
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */]),
      componentPromise: function componentPromise() {
        return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1588));
      }
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
      { path: 'rules/', name: 'Rules', component: null },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], {
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */]),
        componentPromise: function componentPromise() {
          return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 1589));
        }
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
        path: 'new/',
        name: 'New',
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */]),
        componentPromise: function componentPromise() {
          return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 644));
        }
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
        path: ':ruleId/',
        name: 'Edit',
        componentPromise: function componentPromise() {
          return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 644));
        },
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
      })
    )
  ),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
    name: 'Environments',
    path: 'environments/',
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_36_app_views_projectEnvironments__["a" /* default */])
  }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
    name: 'Hidden Environments',
    path: 'environments/hidden/',
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_36_app_views_projectEnvironments__["a" /* default */])
  }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { name: 'Tags', path: 'tags/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_37_app_views_projectTags__["a" /* default */]) }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
    path: 'issue-tracking/',
    name: 'Issue Tracking',
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_48_app_views_projectIssueTracking__["default"])
  }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
    path: 'release-tracking/',
    name: 'Release Tracking',
    componentPromise: function componentPromise() {
      return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 1590));
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
  }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
    path: 'ownership/',
    name: 'Issue Owners',
    componentPromise: function componentPromise() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1591));
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
  }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
    path: 'data-forwarding/',
    name: 'Data Forwarding',
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_40_app_views_projectDataForwarding__["a" /* default */])
  }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
    path: 'saved-searches/',
    name: 'Saved Searches',
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_50_app_views_projectSavedSearches__["a" /* default */])
  }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
    path: 'debug-symbols/',
    name: 'Debug Information Files',
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_41_app_views_projectDebugSymbols__["a" /* default */])
  }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
    key: 'processing-issues/',
    path: 'processing-issues/',
    name: 'Processing Issues',
    componentPromise: function componentPromise() {
      return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1592));
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
  }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
    {
      path: 'filters/',
      name: 'Inbound Filters',
      componentPromise: function componentPromise() {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1593));
      },
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
    },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRedirect"], { to: 'data-filters/' }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: ':filterType/' })
  ),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
    key: 'hooks/',
    path: 'hooks/',
    name: 'Service Hooks',
    componentPromise: function componentPromise() {
      return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 1594));
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
  }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
    key: 'hooks/new/',
    path: 'hooks/new/',
    name: 'Create Service Hook',
    componentPromise: function componentPromise() {
      return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1595));
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
  }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
    key: 'hooks/:hookId/',
    path: 'hooks/:hookId/',
    name: 'Service Hook Details',
    componentPromise: function componentPromise() {
      return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1596));
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
  }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
    { path: 'keys/', name: 'Client Keys' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], {
      componentPromise: function componentPromise() {
        return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1597));
      },
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
      path: ':keyId/',
      name: 'Details',
      componentPromise: function componentPromise() {
        return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1598));
      },
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
    })
  ),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
    path: 'user-feedback/',
    name: 'User Feedback',
    componentPromise: function componentPromise() {
      return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1599));
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
  }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { from: 'csp/', to: 'security-headers/' }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
    { key: 'security-headers/', path: 'security-headers/', name: 'Security Headers' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], {
      componentPromise: function componentPromise() {
        return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1600));
      },
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
      path: 'csp/',
      key: 'csp/',
      name: 'Content Security Policy',
      componentPromise: function componentPromise() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1601));
      },
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
      path: 'expect-ct/',
      key: 'expect-ct/',
      name: 'Certificate Transparency',
      componentPromise: function componentPromise() {
        return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1602));
      },
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
      path: 'hpkp/',
      key: 'hpkp/',
      name: 'HPKP',
      componentPromise: function componentPromise() {
        return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1603));
      },
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
    })
  ),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: 'plugins/', name: 'Integrations', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_53_app_views_projectPlugins__["a" /* default */]) }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
    path: 'plugins/:pluginId/',
    name: 'Integration Details',
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_54_app_views_projectPluginDetails__["a" /* default */])
  }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
    path: 'integrations/:providerKey/',
    name: 'Integration Configuration',
    componentPromise: function componentPromise() {
      return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1604));
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
  }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
    {
      path: 'install/',
      name: 'Configuration',
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_43_app_views_projectInstall_docsContext__["a" /* default */])
    },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], { component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_46_app_views_projectInstall_overview__["a" /* default */]) }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
      path: ':platform/',
      name: 'Docs',
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_47_app_views_projectInstall_platform__["a" /* default */])
    })
  )
);

function routes() {
  var hooksRoutes = [];
  __WEBPACK_IMPORTED_MODULE_19_app_stores_hookStore__["default"].get('routes').forEach(function (cb) {
    hooksRoutes.push(cb());
  });

  var hooksAdminRoutes = [];
  __WEBPACK_IMPORTED_MODULE_19_app_stores_hookStore__["default"].get('routes:admin').forEach(function (cb) {
    hooksAdminRoutes.push(cb());
  });

  var hooksOrgRoutes = [];
  __WEBPACK_IMPORTED_MODULE_19_app_stores_hookStore__["default"].get('routes:organization').forEach(function (cb) {
    hooksOrgRoutes.push(cb());
  });

  // This is declared in the routes() function because some routes need the
  // hook store which is not available at import time.
  var orgSettingsRoutes = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], {
      name: 'General',
      componentPromise: function componentPromise() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 645));
      },
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
      path: 'projects/',
      name: 'Projects',
      componentPromise: function componentPromise() {
        return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1605));
      },
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
      { path: 'api-keys/', name: 'API Key' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], {
        componentPromise: function componentPromise() {
          return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 1606));
        },
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
        path: ':apiKey/',
        name: 'Details',
        componentPromise: function componentPromise() {
          return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 1607));
        },
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
      })
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
      path: 'audit-log/',
      name: 'Audit Log',
      componentPromise: function componentPromise() {
        return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 1608));
      },
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
      path: 'auth/',
      name: 'Auth Providers',
      componentPromise: function componentPromise() {
        return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1609));
      },
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
      { path: 'members/', name: 'Members' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], {
        component: __WEBPACK_IMPORTED_MODULE_19_app_stores_hookStore__["default"].get('component:org-members-view').length ? __WEBPACK_IMPORTED_MODULE_19_app_stores_hookStore__["default"].get('component:org-members-view')[0]() : __WEBPACK_IMPORTED_MODULE_33_app_views_settings_organizationMembers__["default"]
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
        path: 'new/',
        name: 'Invite',
        componentPromise: function componentPromise() {
          return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 569));
        },
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
        path: ':memberId/',
        name: 'Details',
        componentPromise: function componentPromise() {
          return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 1610));
        },
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
      })
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
      path: 'rate-limits/',
      name: 'Rate Limits',
      componentPromise: function componentPromise() {
        return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 1611));
      },
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
      path: 'repos/',
      name: 'Repositories',
      componentPromise: function componentPromise() {
        return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1612));
      },
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
      path: 'settings/',
      componentPromise: function componentPromise() {
        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 645));
      },
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
      { name: 'Teams', path: 'teams/' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], {
        componentPromise: function componentPromise() {
          return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1613));
        },
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
        {
          name: 'Team',
          path: ':teamId/',
          componentPromise: function componentPromise() {
            return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 1614));
          },
          component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRedirect"], { to: 'members/' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
          path: 'members/',
          name: 'Members',
          componentPromise: function componentPromise() {
            return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1615));
          },
          component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
          path: 'projects/',
          name: 'Projects',
          componentPromise: function componentPromise() {
            return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1616));
          },
          component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
          path: 'settings/',
          name: 'settings',
          componentPromise: function componentPromise() {
            return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1617));
          },
          component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
        })
      )
    )
  );

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
    { path: '/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_9_app_views_app__["a" /* default */]) },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
      path: '/accept-transfer/',
      componentPromise: function componentPromise() {
        return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 1618));
      },
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
      { path: '/account/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_3_app_views_accountLayout__["a" /* default */]) },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: 'authorizations/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_2_app_views_accountAuthorizations__["a" /* default */]) })
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
      { path: '/api/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_6_app_views_apiLayout__["a" /* default */]) },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], { component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_8_app_views_apiTokens__["a" /* default */]) }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: 'applications/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_5_app_views_apiApplications__["a" /* default */]) }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
        path: 'applications/:appId/',
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_4_app_views_apiApplicationDetails__["a" /* default */])
      })
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
      { newnew: true, path: '/settings/', name: 'Settings', component: __WEBPACK_IMPORTED_MODULE_63_app_views_settings_components_settingsWrapper__["a" /* default */] },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], {
        getComponent: function getComponent(loc, cb) {
          return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1619)).then(lazyLoad(cb));
        }
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
        {
          path: 'account/',
          name: 'Account',
          getComponent: function getComponent(loc, cb) {
            return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1620)).then(lazyLoad(cb));
          }
        },
        accountSettingsRoutes
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
        {
          name: 'Organization',
          path: ':orgId/',
          component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_28_app_views_organizationContext__["a" /* default */])
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
          {
            getComponent: function getComponent(loc, cb) {
              return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1621)).then(lazyLoad(cb));
            }
          },
          hooksOrgRoutes,
          orgSettingsRoutes
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
          {
            name: 'Project',
            path: ':projectId/',
            getComponent: function getComponent(loc, cb) {
              return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1622)).then(lazyLoad(cb));
            }
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
            { component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_62_app_views_settings_components_settingsProjectProvider__["a" /* default */]) },
            projectSettingsRoutes
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: '/api/new-token/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_7_app_views_apiNewToken__["a" /* default */]) }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
      {
        path: '/manage/',
        componentPromise: function componentPromise() {
          return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 1623));
        },
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
      },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], {
        componentPromise: function componentPromise() {
          return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 1624));
        },
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
        path: 'buffer/',
        componentPromise: function componentPromise() {
          return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 1625));
        },
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
        path: 'relays/',
        componentPromise: function componentPromise() {
          return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 1626));
        },
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
        path: 'organizations/',
        componentPromise: function componentPromise() {
          return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 1627));
        },
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
        path: 'projects/',
        componentPromise: function componentPromise() {
          return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 1628));
        },
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
        path: 'queue/',
        componentPromise: function componentPromise() {
          return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 1629));
        },
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
        path: 'quotas/',
        componentPromise: function componentPromise() {
          return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 1630));
        },
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
        path: 'settings/',
        componentPromise: function componentPromise() {
          return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 1631));
        },
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
        path: 'users/',
        componentPromise: function componentPromise() {
          return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 1632));
        },
        component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
      }),
      hooksAdminRoutes
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { from: '/share/group/:shareId/', to: '/share/issue/:shareId/' }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
      path: '/share/issue/:shareId/',
      componentPromise: function componentPromise() {
        return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1633));
      },
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: '/organizations/new/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_29_app_views_organizationCreate__["a" /* default */]) }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
      { path: '/onboarding/:orgId/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_28_app_views_organizationContext__["a" /* default */]) },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
        { path: '', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_26_app_views_onboarding_index__["a" /* default */]) },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], { component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_10_app_views_onboarding_createProject__["a" /* default */]) }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
          path: ':projectId/configure/(:platform)',
          component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_25_app_views_onboarding_configure_index__["a" /* default */])
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
      { path: '/:orgId/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_31_app_views_organizationDetails__["a" /* default */]) },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
        { component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_34_app_views_organizationRoot__["a" /* default */]) },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], { component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_30_app_views_organizationDashboard__["a" /* default */]) }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
          path: '/organizations/:orgId/activity/',
          component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_27_app_views_organizationActivity__["a" /* default */])
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
          path: '/organizations/:orgId/teams/new/',
          componentPromise: function componentPromise() {
            return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 1634));
          },
          component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
          { path: '/organizations/:orgId/', component: __WEBPACK_IMPORTED_MODULE_32_app_components_organizations_homeContainer__["default"] },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { from: 'projects/', to: '/:orgId/' }),
          hooksOrgRoutes,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { path: 'teams/', to: '/settings/:orgId/teams/' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { path: 'teams/your-teams/', to: '/settings/:orgId/teams/' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { path: 'teams/all-teams/', to: '/settings/:orgId/teams/' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { path: 'teams/:teamId/', to: '/settings/:orgId/teams/:teamId/' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            path: 'teams/:teamId/members/',
            to: '/settings/:orgId/teams/:teamId/members/'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            path: 'teams/:teamId/projects/',
            to: '/settings/:orgId/teams/:teamId/projects/'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            path: 'teams/:teamId/settings/',
            to: '/settings/:orgId/teams/:teamId/settings/'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { path: 'settings/', to: '/settings/:orgId/' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { path: 'api-keys/', to: '/settings/:orgId/api-keys/' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { path: 'api-keys/:apiKey/', to: '/settings/:orgId/api-keys/:apiKey/' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { path: 'members/', to: '/settings/:orgId/members/' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { path: 'members/new/', to: '/settings/:orgId/members/new/' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            path: 'members/:memberId/',
            to: '/settings/:orgId/members/:memberId/'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { path: 'rate-limits/', to: '/settings/:orgId/rate-limits/' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { path: 'repos/', to: '/settings/:orgId/repos/' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: 'stats/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_35_app_views_organizationStats__["a" /* default */]) })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
          path: '/organizations/:orgId/issues/assigned/',
          component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_21_app_views_myIssues_assignedToMe__["a" /* default */])
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
          path: '/organizations/:orgId/issues/bookmarks/',
          component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_22_app_views_myIssues_bookmarked__["a" /* default */])
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
          path: '/organizations/:orgId/issues/history/',
          component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_23_app_views_myIssues_viewed__["a" /* default */])
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
          path: '/organizations/:orgId/projects/new/',
          component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_24_app_views_projectInstall_newProject__["a" /* default */])
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
          path: '/organizations/:orgId/projects/choose/',
          component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_38_app_views_projectChooser__["a" /* default */])
        })
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
        {
          path: ':projectId/getting-started/',
          component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_45_app_views_projectInstall_gettingStarted__["a" /* default */])
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], { component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_46_app_views_projectInstall_overview__["a" /* default */]) }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: ':platform/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_47_app_views_projectInstall_platform__["a" /* default */]) })
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
        { path: ':projectId/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_42_app_views_projectDetails__["a" /* default */]) },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], { component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_64_app_views_stream__["a" /* default */]) }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: 'issues/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_64_app_views_stream__["a" /* default */]) }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: 'searches/:searchId/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_64_app_views_stream__["a" /* default */]) }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: 'dashboard/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_39_app_views_projectDashboard__["a" /* default */]) }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: 'events/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_44_app_views_projectEvents__["a" /* default */]) }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: 'releases/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_49_app_views_projectReleases__["a" /* default */]) }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
          {
            name: 'releaseDetails',
            path: 'releases/:version/',
            component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_58_app_views_releaseDetails__["a" /* default */])
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], { component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_60_app_views_releases_releaseOverview__["a" /* default */]) }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: 'new-events/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_59_app_views_releaseNewEvents__["a" /* default */]) }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: 'all-events/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_55_app_views_releaseAllEvents__["a" /* default */]) }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: 'artifacts/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_56_app_views_releaseArtifacts__["a" /* default */]) }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: 'commits/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_57_app_views_releases_releaseCommits__["a" /* default */]) })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: 'user-feedback/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_52_app_views_projectUserReports__["a" /* default */]) }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
          { path: 'settings/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_51_app_views_projectSettings__["a" /* default */]) },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { from: 'teams/', to: '/settings/:orgId/:projectId/teams/' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { from: 'alerts/', to: '/settings/:orgId/:projectId/alerts/' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            from: 'alerts/rules/',
            to: '/settings/:orgId/:projectId/alerts/rules/'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            from: 'alerts/rules/new/',
            to: '/settings/:orgId/:projectId/alerts/rules/new/'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            from: 'alerts/rules/:ruleId/',
            to: '/settings/:orgId/:projectId/alerts/rules/:ruleId/'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            from: 'environments/',
            to: '/settings/:orgId/:projectId/environments/'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            from: 'environments/hidden/',
            to: '/settings/:orgId/:projectId/environments/hidden/'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { from: 'tags/', to: '/settings/:orgId/:projectId/tags/' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            from: 'issue-tracking/',
            to: '/settings/:orgId/:projectId/issue-tracking/'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            from: 'release-tracking/',
            to: '/settings/:orgId/:projectId/release-tracking/'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { from: 'ownership/', to: '/settings/:orgId/:projectId/ownership/' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            from: 'data-forwarding/',
            to: '/settings/:orgId/:projectId/data-forwarding/'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            from: 'saved-searches/',
            to: '/settings/:orgId/:projectId/saved-searches/'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            from: 'debug-symbols/',
            to: '/settings/:orgId/:projectId/debug-symbols/'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            from: 'processing-issues/',
            to: '/settings/:orgId/:projectId/processing-issues/'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { from: 'filters/', to: '/settings/:orgId/:projectId/filters/' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { from: 'hooks/', to: '/settings/:orgId/:projectId/hooks/' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { from: 'keys/', to: '/settings/:orgId/:projectId/keys/' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { from: 'keys/:keyId/', to: '/settings/:orgId/:projectId/keys/:keyId/' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            from: 'user-feedback/',
            to: '/settings/:orgId/:projectId/user-feedback/'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            from: 'security-headers/',
            to: '/settings/:orgId/:projectId/security-headers/'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            from: 'security-headers/csp/',
            to: '/settings/:orgId/:projectId/security-headers/csp/'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            from: 'security-headers/expect-ct/',
            to: '/settings/:orgId/:projectId/security-headers/expect-ct/'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            from: 'security-headers/hpkp/',
            to: '/settings/:orgId/:projectId/security-headers/hpkp/'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { from: 'plugins/', to: '/settings/:orgId/:projectId/plugins/' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            from: 'plugins/:pluginId/',
            to: '/settings/:orgId/:projectId/plugins/:pluginId/'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            from: 'integrations/:providerKey/',
            to: '/settings/:orgId/:projectId/integrations/:providerKey/'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { from: 'install/', to: '/settings/:orgId/:projectId/install/' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], {
            from: 'install/:platform\'',
            to: '/settings/:orgId/:projectId/install/:platform/'
          }),
          projectSettingsRoutes
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"], { from: 'group/:groupId/', to: 'issues/:groupId/' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"],
          {
            path: 'issues/:groupId/',
            component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_11_app_views_groupDetails__["a" /* default */]),
            ignoreScrollBehavior: true
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["IndexRoute"], { component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_13_app_views_groupEventDetails__["a" /* default */]) }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
            path: 'activity/',
            componentPromise: function componentPromise() {
              return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1635));
            },
            component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_20_app_components_lazyLoad__["a" /* default */])
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: 'events/:eventId/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_13_app_views_groupEventDetails__["a" /* default */]) }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: 'events/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_12_app_views_groupEvents__["a" /* default */]) }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: 'tags/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_17_app_views_groupTags__["a" /* default */]) }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: 'tags/:tagKey/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_16_app_views_groupTagValues__["a" /* default */]) }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: 'feedback/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_18_app_views_groupUserReports__["a" /* default */]) }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: 'similar/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_15_app_views_groupSimilar_groupSimilarView__["a" /* default */]) }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], { path: 'merged/', component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_14_app_views_groupMerged_groupMergedView__["a" /* default */]) })
        )
      )
    ),
    hooksRoutes,
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Route"], {
      path: '*',
      component: Object(__WEBPACK_IMPORTED_MODULE_65_app_utils_errorHandler__["default"])(__WEBPACK_IMPORTED_MODULE_61_app_views_routeNotFound__["a" /* default */]),
      onEnter: appendTrailingSlash
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_views_asyncView__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_stores_indicatorStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var AuthorizationRow = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'AuthorizationRow',

  propTypes: {
    authorization: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
    onRevoke: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    return {
      loading: false
    };
  },
  onRevoke: function onRevoke() {
    var _this = this;

    if (this.state.loading) return;

    var authorization = this.props.authorization;


    this.setState({
      loading: true
    }, function () {
      var loadingIndicator = __WEBPACK_IMPORTED_MODULE_5_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Saving changes..'));
      _this.api.request('/api-authorizations/', {
        method: 'DELETE',
        data: { authorization: authorization.id },
        success: function success(data) {
          __WEBPACK_IMPORTED_MODULE_5_app_stores_indicatorStore__["default"].remove(loadingIndicator);
          _this.props.onRevoke();
        },
        error: function error() {
          __WEBPACK_IMPORTED_MODULE_5_app_stores_indicatorStore__["default"].remove(loadingIndicator);
          __WEBPACK_IMPORTED_MODULE_5_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Unable to save changes. Please try again.'), 'error');
        }
      });
    });
  },
  render: function render() {
    var authorization = this.props.authorization;

    var btnClassName = 'btn btn-default';
    if (this.state.loading) btnClassName += ' disabled';

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'tr',
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'td',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h5',
          { style: { marginBottom: 5 } },
          authorization.application.name
        ),
        authorization.homepageUrl && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { marginBottom: 5 } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { href: authorization.homepageUrl },
              authorization.homepageUrl
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'small',
            { style: { color: '#999' } },
            authorization.scopes.join(', ')
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'td',
        { style: { width: 32 } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          {
            onClick: this.onRevoke.bind(this, authorization),
            className: btnClassName,
            disabled: this.state.loading
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon icon-trash' })
        )
      )
    );
  }
});

var AccountAuthorizations = function (_AsyncView) {
  _inherits(AccountAuthorizations, _AsyncView);

  function AccountAuthorizations() {
    _classCallCheck(this, AccountAuthorizations);

    return _possibleConstructorReturn(this, (AccountAuthorizations.__proto__ || Object.getPrototypeOf(AccountAuthorizations)).apply(this, arguments));
  }

  _createClass(AccountAuthorizations, [{
    key: 'getEndpoint',
    value: function getEndpoint() {
      return '/api-authorizations/';
    }
  }, {
    key: 'getTitle',
    value: function getTitle() {
      return 'Approved Applications';
    }
  }, {
    key: 'onRevoke',
    value: function onRevoke(authorization) {
      this.setState({
        data: this.state.data.filter(function (a) {
          return a.id !== authorization.id;
        })
      });
    }
  }, {
    key: 'renderResults',
    value: function renderResults() {
      var _this3 = this;

      var data = this.state.data;

      if (data.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'table',
          { className: 'table' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'tbody',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'tr',
              { colSpan: '2' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'td',
                { className: 'blankslate well' },
                Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])("You haven't approved any third party applications.")
              )
            )
          )
        );
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h4',
          null,
          'Approved Applications'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'table',
          { className: 'table' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'tbody',
            null,
            data.map(function (authorization) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AuthorizationRow, {
                key: authorization.id,
                authorization: authorization,
                onRevoke: _this3.onRevoke.bind(_this3, authorization)
              });
            })
          )
        )
      );
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        this.renderResults(),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'small',
            null,
            'You can manage your own applications via the ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { href: '/api/' },
              'API dashboard'
            ),
            '.'
          )
        )
      );
    }
  }]);

  return AccountAuthorizations;
}(__WEBPACK_IMPORTED_MODULE_3_app_views_asyncView__["default"]);

/* harmony default export */ __webpack_exports__["a"] = (AccountAuthorizations);

/***/ }),
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(840),
    isObjectLike = __webpack_require__(200);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(627),
    equalArrays = __webpack_require__(846),
    equalByTag = __webpack_require__(848),
    equalObjects = __webpack_require__(849),
    getTag = __webpack_require__(461),
    isArray = __webpack_require__(47),
    isBuffer = __webpack_require__(410),
    isTypedArray = __webpack_require__(411);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 841 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(233);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(233);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(233);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(233);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(308),
    arraySome = __webpack_require__(847),
    cacheHas = __webpack_require__(309);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 847 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 848 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(850);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(234);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTranslations;
/* unused harmony export translationsExist */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// zh-cn => zh_CN
function convertToDjangoLocaleFormat(language) {
  var _language$split = language.split('-'),
      _language$split2 = _slicedToArray(_language$split, 2),
      left = _language$split2[0],
      right = _language$split2[1];

  return left + (right ? '_' + right.toUpperCase() : '');
}

function getTranslations(language) {
  language = convertToDjangoLocaleFormat(language);
  return __webpack_require__(465)("./" + language + '/LC_MESSAGES/django.po');
}

function translationsExist(language) {
  language = convertToDjangoLocaleFormat(language);
  try {
    __webpack_require__(465)("./" + language + '/LC_MESSAGES/django.po');
  } catch (e) {
    return false;
  }
  return true;
}

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports = {"":{"domain":"sentry","plural_forms":"nplurals=2; plural=(n != 1)","lang":"en"}};

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./icon-activity.svg": 854,
	"./icon-bitbucket.svg": 855,
	"./icon-broadcast.svg": 856,
	"./icon-checkmark-sm.svg": 857,
	"./icon-chevron-down.svg": 858,
	"./icon-chevron-left.svg": 859,
	"./icon-chevron-right.svg": 860,
	"./icon-circle-add.svg": 861,
	"./icon-circle-check.svg": 862,
	"./icon-circle-close.svg": 863,
	"./icon-circle-exclamation.svg": 864,
	"./icon-circle-info.svg": 865,
	"./icon-circle-question.svg": 866,
	"./icon-circle-subtract.svg": 867,
	"./icon-clipboard.svg": 868,
	"./icon-close-lg.svg": 869,
	"./icon-collapse.svg": 870,
	"./icon-copy.svg": 871,
	"./icon-docs.svg": 872,
	"./icon-download.svg": 873,
	"./icon-github.svg": 874,
	"./icon-history.svg": 875,
	"./icon-input.svg": 876,
	"./icon-laptop.svg": 877,
	"./icon-link.svg": 878,
	"./icon-location.svg": 879,
	"./icon-lock.svg": 880,
	"./icon-mail.svg": 881,
	"./icon-print.svg": 882,
	"./icon-projects.svg": 883,
	"./icon-refresh.svg": 884,
	"./icon-return-key.svg": 885,
	"./icon-search.svg": 886,
	"./icon-sentry.svg": 887,
	"./icon-settings.svg": 888,
	"./icon-stack.svg": 889,
	"./icon-star.svg": 890,
	"./icon-stats.svg": 891,
	"./icon-support.svg": 892,
	"./icon-trash.svg": 893,
	"./icon-user.svg": 894,
	"./icon-warning-sm.svg": 895
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 853;

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-activity",
  "use": "icon-activity-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" id=\"icon-activity\"><path d=\"M1.1 10h19.8c.608 0 1.1.448 1.1 1s-.492 1-1.1 1H1.1C.492 12 0 11.552 0 11s.492-1 1.1-1zm0-7h19.8c.608 0 1.1.448 1.1 1s-.492 1-1.1 1H1.1C.492 5 0 4.552 0 4s.492-1 1.1-1zm0 14h19.8c.608 0 1.1.448 1.1 1s-.492 1-1.1 1H1.1C.492 19 0 18.552 0 18s.492-1 1.1-1z\" fill=\"currentColor\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-bitbucket",
  "use": "icon-bitbucket-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-bitbucket\"><path d=\"M29.367 3.546a3.484 3.484 0 0 0-.729-.744c-.61-.478-1.297-.82-2.01-1.11-1.516-.616-3.097-.979-4.7-1.239C19.968.138 17.994.013 15.92 0c-1.854.016-3.797.134-5.725.437-1.369.217-2.72.51-4.035.959-.869.299-1.71.654-2.477 1.173a4.176 4.176 0 0 0-.976.875c-.344.442-.49.933-.402 1.49.173 1.101.333 2.202.513 3.298.264 1.623.537 3.246.811 4.865.306 1.8.62 3.6.918 5.4.07.42.246.776.526 1.08.18.194.37.379.574.546.73.595 1.562 1.018 2.432 1.365 2.082.836 4.26 1.214 6.485 1.338 1.616.09 3.23.033 4.838-.189 1.37-.186 2.71-.482 4.011-.955.965-.352 1.891-.78 2.725-1.392.355-.262.683-.552.945-.908.181-.24.305-.508.354-.812.397-2.359.81-4.714 1.196-7.074.362-2.19.701-4.38 1.058-6.568a1.804 1.804 0 0 0-.325-1.382zM15.97 20c-2.753-.01-4.98-2.26-4.97-5.026A4.981 4.981 0 0 1 16.01 10 4.99 4.99 0 0 1 21 15.03c-.013 2.75-2.27 4.98-5.03 4.97zM24.68 4.428c-.124.14-.274.264-.436.36-.45.27-.95.412-1.454.545-.952.244-1.923.386-2.896.488a37.22 37.22 0 0 1-3.79.19c-1.49-.008-2.915-.069-4.333-.24-1.064-.13-2.124-.293-3.146-.638a6.866 6.866 0 0 1-.883-.384 1.386 1.386 0 0 1-.386-.306c-.197-.217-.196-.454.005-.668.117-.126.26-.234.407-.319.424-.248.89-.392 1.36-.516.982-.258 1.984-.405 2.993-.513a37.333 37.333 0 0 1 4.967-.173c1.524.046 3.045.16 4.55.434.706.128 1.407.277 2.075.55.236.096.463.218.683.348.11.065.208.166.288.268.142.184.148.4-.004.574zm1.664 18.508a.97.97 0 0 1-.02.273c-.306 1.616-.615 3.23-.912 4.848a2.626 2.626 0 0 1-.724 1.387c-.422.436-.918.758-1.448 1.031-.979.502-2.018.817-3.085 1.039-1.377.288-2.77.417-3.563.41-2.41-.006-4.184-.2-5.917-.703-.802-.232-1.577-.533-2.3-.96a5.082 5.082 0 0 1-1.042-.796 2.63 2.63 0 0 1-.74-1.406c-.297-1.617-.61-3.232-.916-4.847a1.137 1.137 0 0 1-.019-.247c.02-.397.37-.602.724-.426.036.02.072.041.105.063 1.174.86 2.484 1.434 3.858 1.87a17.94 17.94 0 0 0 3.873.764c1.52.14 3.031.105 4.54-.11 2-.283 3.91-.858 5.687-1.842.354-.195.686-.433 1.025-.65.056-.036.108-.077.167-.105.34-.153.674.038.707.407zM15.982 18A3 3 0 0 1 13 14.985 2.989 2.989 0 0 1 16.007 12c1.668.006 3 1.35 2.993 3.018A3.006 3.006 0 0 1 15.982 18z\" fill=\"currentColor\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-broadcast",
  "use": "icon-broadcast-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-radio\" viewBox=\"0 0 24 24\" id=\"icon-broadcast\"><circle cx=\"12\" cy=\"12\" r=\"2\" /><path d=\"M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-checkmark-sm",
  "use": "icon-checkmark-sm-usage",
  "viewBox": "0 0 9 9",
  "content": "<symbol viewBox=\"0 0 9 9\" id=\"icon-checkmark-sm\"><path d=\"M.5 5l2 2 6-5\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-chevron-down",
  "use": "icon-chevron-down-usage",
  "viewBox": "0 0 10 5",
  "content": "<symbol viewBox=\"0 0 10 5\" id=\"icon-chevron-down\"><path d=\"M9 1L4.997 4.431 1 1.004\" stroke=\"currentColor\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-chevron-left",
  "use": "icon-chevron-left-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" id=\"icon-chevron-left\"><path stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.505 14.495l-6-7L10.5.505\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-chevron-right",
  "use": "icon-chevron-right-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" id=\"icon-chevron-right\"><path stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.5.5l6 7-6 7\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-circle-add",
  "use": "icon-circle-add-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-circle-add\"><path d=\"M11 13H7a1 1 0 0 1 0-2h4V7a1 1 0 0 1 2 0v4h4a1 1 0 0 1 0 2h-4v4a1 1 0 0 1-2 0v-4zm1 11C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z\" fill=\"currentColor\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-circle-check",
  "use": "icon-circle-check-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-circle-check\"><path d=\"M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-1.75-7.33l6.293-6.294a1 1 0 0 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-3.417-3.416A1 1 0 0 1 7.54 11.96l2.71 2.71z\" fill=\"currentColor\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-circle-close",
  "use": "icon-circle-close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-circle-close\"><path d=\"M10.586 12L7.757 9.172a1 1 0 0 1 1.415-1.415L12 10.586l2.828-2.829a1 1 0 0 1 1.415 1.415L13.414 12l2.829 2.828a1 1 0 0 1-1.415 1.415L12 13.414l-2.828 2.829a1 1 0 1 1-1.415-1.415L10.586 12zm-7.071 8.485c-4.687-4.686-4.687-12.284 0-16.97 4.686-4.687 12.284-4.687 16.97 0 4.687 4.686 4.687 12.284 0 16.97-4.686 4.687-12.284 4.687-16.97 0zm1.414-1.414c3.905 3.905 10.237 3.905 14.142 0 3.905-3.905 3.905-10.237 0-14.142-3.905-3.905-10.237-3.905-14.142 0-3.905 3.905-3.905 10.237 0 14.142z\" fill=\"currentColor\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-circle-exclamation",
  "use": "icon-circle-exclamation-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-circle-exclamation\"><path d=\"M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-1-9V7a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0zm0 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0z\" fill=\"currentColor\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-circle-info",
  "use": "icon-circle-info-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-circle-info\"><path d=\"M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm1 9.75v4.5c0 .414-.448.75-1 .75s-1-.336-1-.75v-4.5c0-.414.448-.75 1-.75s1 .336 1 .75zM13 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0z\" fill=\"currentColor\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-circle-question",
  "use": "icon-circle-question-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-circle-question\"><path d=\"M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-1-5a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm2-3a1 1 0 0 1-2 0v-1.004a1 1 0 0 1 .767-.973c1.6-.383 2.233-1.196 2.233-1.96C14 8.81 13.123 8 12 8s-2 .81-2 2.063a1 1 0 0 1-2 0C8 7.668 9.807 6 12 6s4 1.669 4 4.063c0 1.652-1.078 2.802-3 3.442V14z\" fill=\"currentColor\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-circle-subtract",
  "use": "icon-circle-subtract-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-circle-subtract\"><path d=\"M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM7 11h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2z\" fill=\"currentColor\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-clipboard",
  "use": "icon-clipboard-usage",
  "viewBox": "0 0 20 26",
  "content": "<symbol viewBox=\"0 0 20 26\" id=\"icon-clipboard\"><g transform=\"translate(-4)\" fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M6 4v20h16V4H6zm3-2v2h11V2h2a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h3z\" fill-rule=\"nonzero\" /><path d=\"M10 2v2h8V2h-8zm0-2h8a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z\" fill-rule=\"nonzero\" /><rect x=\"8\" y=\"8\" width=\"12\" height=\"2\" rx=\"1\" /><rect x=\"8\" y=\"12\" width=\"12\" height=\"2\" rx=\"1\" /><rect x=\"8\" y=\"16\" width=\"12\" height=\"2\" rx=\"1\" /></g></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-close-lg",
  "use": "icon-close-lg-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-close-lg\"><g stroke=\"currentColor\" fill=\"none\"><path d=\"M.5.5l19 19M.5 19.5l19-19\" /></g></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-collapse",
  "use": "icon-collapse-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" id=\"icon-collapse\"><path d=\"M11 22C4.925 22 0 17.075 0 11S4.925 0 11 0s11 4.925 11 11-4.925 11-11 11zm0-1.833a9.167 9.167 0 1 0 0-18.334 9.167 9.167 0 0 0 0 18.334zm2.019-6.153a.917.917 0 1 1-1.288 1.305l-3.667-3.618a.917.917 0 0 1-.008-1.296l3.667-3.716a.917.917 0 0 1 1.304 1.288l-3.022 3.063 3.014 2.974z\" fill=\"currentColor\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-copy",
  "use": "icon-copy-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" id=\"icon-copy\"><g stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.5 2.5v6.926c0 .593-.453 1.074-.997 1.074H1.497C.947 10.5.5 10.018.5 9.43V1.57C.5.98.951.5 1.505.5h4.997l1.998 2zM2.5 3.5h2M2.5 5.5h4M2.5 7.5h4\" /><path d=\"M8.5 4.5h4.002l1.998 2v6.926c0 .593-.453 1.074-.997 1.074H7.497c-.55 0-.997-.482-.997-1.07V10.5\" /><path fill=\"currentColor\" d=\"M6.5.5v2h2zM12.5 4.5v2h2z\" /><path d=\"M8.5 7.5h2M8.5 9.5h4M8.5 11.5h4\" /><path d=\"M9.5 4.5v5c0 .997-1.039 2-2.037 2H6.5\" opacity=\".4\" /></g></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-docs",
  "use": "icon-docs-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-docs\"><g fill=\"currentColor\"><path d=\"M12 20l-1-1h2l-1 1zm0-17l1-1v19l-1-1-1 1V2l1 1zm-1-1h2v19h-2V2zM4.5 6h4a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm0 4h4a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm11-4h4a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm0 4h4a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z\" /><path d=\"M13.032 19.005c1.744.025 4.718.279 8.968.762V4H2v15.766c4.259-.484 7.239-.738 8.987-.762.375-.005.721.084 1.022.243.302-.16.649-.248 1.023-.243zM2 2h20a2 2 0 0 1 2 2.001v15.765a2 2 0 0 1-2.226 1.99c-4.187-.477-7.11-.726-8.77-.75-.335-.004.106.994-1.004.994s-.657-.998-.985-.994c-1.664.023-4.593.273-8.79.75A2 2 0 0 1 0 19.765V4.002A2 2 0 0 1 2 2z\" /></g></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 384.97 384.97",
  "content": "<symbol viewBox=\"0 0 384.97 384.97\" id=\"icon-download\"><path stroke=\"#000\" stroke-width=\"20\" d=\"M372.939 264.667c-6.641 0-12.03 5.39-12.03 12.03v84.212H24.061v-84.212c0-6.641-5.39-12.03-12.03-12.03S0 270.056 0 276.697v96.242c0 6.641 5.39 12.03 12.03 12.03h360.909c6.641 0 12.03-5.39 12.03-12.03v-96.242c.001-6.641-5.389-12.03-12.03-12.03z\" /><path stroke=\"#000\" stroke-width=\"10\" d=\"M183.703 285.202c4.68 4.632 12.512 4.68 17.191 0l84.2-83.009a11.942 11.942 0 0 0 0-17.011c-4.74-4.704-12.439-4.704-17.179 0l-63.46 62.558V12.03c0-6.641-5.438-12.03-12.151-12.03s-12.151 5.39-12.151 12.03v235.71l-63.46-62.558c-4.752-4.704-12.439-4.704-17.179 0a11.931 11.931 0 0 0 0 17.011l84.189 83.009z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-github",
  "use": "icon-github-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-github\"><path d=\"M15.999 0c-8.835 0-16 7.115-16 15.894 0 7.02 4.585 12.976 10.943 15.079.8.145 1.092-.346 1.092-.767 0-.377-.013-1.377-.021-2.702-4.45.96-5.39-2.131-5.39-2.131-.727-1.836-1.776-2.324-1.776-2.324-1.453-.986.11-.967.11-.967 1.606.113 2.45 1.638 2.45 1.638 1.427 2.428 3.744 1.727 4.657 1.321.145-1.027.558-1.728 1.016-2.125-3.553-.4-7.288-1.765-7.288-7.854 0-1.735.623-3.154 1.647-4.265-.165-.402-.714-2.017.156-4.206 0 0 1.344-.427 4.4 1.63a15.422 15.422 0 0 1 4.006-.536c1.358.007 2.727.182 4.005.536 3.055-2.057 4.395-1.63 4.395-1.63.874 2.189.324 3.804.16 4.206 1.025 1.111 1.645 2.53 1.645 4.265 0 6.105-3.742 7.448-7.306 7.842.575.49 1.086 1.46 1.086 2.943 0 2.124-.02 3.838-.02 4.359 0 .425.288.92 1.1.765C27.42 28.865 32 22.912 32 15.894 32 7.115 24.835 0 15.999 0\" fill=\"currentColor\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-history",
  "use": "icon-history-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" id=\"icon-history\"><path d=\"M12.588 11.917a1.833 1.833 0 0 1-3.244-1.704L7.187 6.477a.957.957 0 0 1 1.656-.957l2.106 3.647H11c.679 0 1.271.368 1.588.916h4.829a.917.917 0 0 1 0 1.834h-4.829zM11 22C4.925 22 0 17.075 0 11S4.925 0 11 0s11 4.925 11 11-4.925 11-11 11zm0-1.833a9.167 9.167 0 1 0 0-18.334 9.167 9.167 0 0 0 0 18.334z\" fill=\"currentColor\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-input",
  "use": "icon-input-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-input\"><path d=\"M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4zm0-2h16a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4zm3 6a1 1 0 1 1 1 1v6a1 1 0 1 1-1 1 1 1 0 1 1-1-1V9a1 1 0 1 1 1-1z\" fill=\"currentColor\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-laptop",
  "use": "icon-laptop-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-laptop\"><g fill=\"currentColor\"><path d=\"M5.143 5.143c-.947 0-1.714.767-1.714 1.714v8.572c0 .946.767 1.714 1.714 1.714h13.714c.947 0 1.714-.768 1.714-1.714V6.857c0-.947-.767-1.714-1.714-1.714H5.143zm0-1.714h13.714a3.429 3.429 0 0 1 3.429 3.428v8.572a3.429 3.429 0 0 1-3.429 3.428H5.143a3.429 3.429 0 0 1-3.429-3.428V6.857A3.429 3.429 0 0 1 5.143 3.43z\" /><circle cx=\"12\" cy=\"11.143\" r=\"1\" /><circle cx=\"15.429\" cy=\"11.143\" r=\"1\" /><circle cx=\"8.571\" cy=\"11.143\" r=\"1\" /><path d=\"M0 17.143h24v.714a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-.714z\" /></g></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-link",
  "use": "icon-link-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-link\"><path d=\"M10.879 6.05L15 1.93A5.001 5.001 0 0 1 22.071 9l-4.121 4.121a1 1 0 0 1-1.414-1.414l4.12-4.121a3 3 0 1 0-4.242-4.243l-4.121 4.121a1 1 0 1 1-1.414-1.414zm2.242 11.9L9 22.07A5 5 0 1 1 1.929 15l4.121-4.121a1 1 0 0 1 1.414 1.414l-4.12 4.121a3 3 0 1 0 4.242 4.243l4.121-4.121a1 1 0 1 1 1.414 1.414zm-8.364-.122l13.071-13.07a1 1 0 0 1 1.415 1.414L6.172 19.242a1 1 0 1 1-1.415-1.414z\" fill=\"currentColor\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-location",
  "use": "icon-location-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-location\"><path d=\"M13.2 23.597a2 2 0 0 1-2.4 0C5.013 19.26 2 14.742 2 10 2 4.477 6.477 0 12 0c5.526 0 10.01 4.48 10 10.003-.008 4.74-3.02 9.255-8.8 13.594zm-1.2-1.6C17.326 18 19.993 14 20 10c.008-4.418-3.582-8-8-8a8 8 0 0 0-8 8c0 4 2.667 8 8 11.997zM12 14a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z\" fill=\"currentColor\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-lock",
  "use": "icon-lock-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-lock\"><g fill=\"currentColor\"><path d=\"M4.286 9.786a.857.857 0 0 0-.857.857v8.571c0 .474.383.857.857.857h15.428a.857.857 0 0 0 .857-.857v-8.571a.857.857 0 0 0-.857-.857H4.286zm0-1.715h15.428a2.571 2.571 0 0 1 2.572 2.572v8.571a2.571 2.571 0 0 1-2.572 2.572H4.286a2.571 2.571 0 0 1-2.572-2.572v-8.571A2.571 2.571 0 0 1 4.286 8.07z\" /><path d=\"M17.143 8.071h-1.714V6.464c0-1.952-1.535-3.535-3.429-3.535S8.571 4.512 8.571 6.464v1.607H6.857v-1.5c0-2.958 2.303-5.357 5.143-5.357s5.143 2.399 5.143 5.357v1.5z\" /></g></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-mail",
  "use": "icon-mail-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol viewBox=\"0 0 16 12\" id=\"icon-mail\"><g transform=\"translate(1 1)\" stroke=\"currentColor\" fill=\"none\"><rect width=\"14\" height=\"10\" rx=\"1.5\" /><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.52.5L7 5 13.512.5\" /></g></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-print",
  "use": "icon-print-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"icon-print\"><path d=\"M482 182.58V135c0-24.813-20.187-45-45-45h-23.787L327.617 4.404c-.018-.018-.039-.035-.057-.054A15.038 15.038 0 0 0 317.232.011c-.078-.001-.153-.011-.231-.011H105c-8.284 0-15 6.716-15 15v75H75c-24.813 0-45 20.187-45 45v47.58C12.541 188.772 0 205.445 0 225v182c0 24.813 20.187 45 45 45h45v45c0 8.284 6.716 15 15 15h302c8.284 0 15-6.716 15-15v-45h45c24.813 0 45-20.187 45-45V225c0-19.555-12.541-36.228-30-42.42zM422 120h15c8.271 0 15 6.729 15 15v45h-30v-60zm-90-68.787L370.787 90H332V51.213zM120 30h182v75c0 8.284 6.716 15 15 15h75v60H120V30zM60 135c0-8.271 6.729-15 15-15h15v60H60v-45zm332 347H120V332h272v150zm90-75c0 8.271-6.729 15-15 15h-45v-90h15c8.284 0 15-6.716 15-15s-6.716-15-15-15H75c-8.284 0-15 6.716-15 15s6.716 15 15 15h15v90H45c-8.271 0-15-6.729-15-15V225c0-8.271 6.729-15 15-15h422c8.271 0 15 6.729 15 15v182z\" /><path d=\"M347 362H165c-8.284 0-15 6.716-15 15s6.716 15 15 15h182c8.284 0 15-6.716 15-15s-6.716-15-15-15zM347 422H165c-8.284 0-15 6.716-15 15s6.716 15 15 15h182c8.284 0 15-6.716 15-15s-6.716-15-15-15zM105 240H75c-8.284 0-15 6.716-15 15s6.716 15 15 15h30c8.284 0 15-6.716 15-15s-6.716-15-15-15z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-projects",
  "use": "icon-projects-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" id=\"icon-projects\"><path d=\"M4 0h14a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm0 2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm2 3h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm0 8h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm8-8h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm0 8h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1z\" fill=\"currentColor\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-refresh",
  "use": "icon-refresh-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" id=\"icon-refresh\"><g stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.15 7c.467-3.11 3.278-5.5 6.675-5.5 3.203 0 5.987 2.15 6.675 5\" /><path d=\"M5.5 7.5h-4v-4M14.815 10c-.47 3.11-3.302 5.5-6.724 5.5-3.235 0-5.941-2.135-6.626-4.995\" /><path d=\"M11.5 9.5h4v4\" /></g></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-return-key",
  "use": "icon-return-key-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol viewBox=\"0 0 16 12\" id=\"icon-return-key\"><path d=\"M15 8.24H3.529l2.13 1.937a1.07 1.07 0 0 1 .094 1.468.973.973 0 0 1-1.412.098l-4-3.64a1.068 1.068 0 0 1 0-1.566l4-3.64a.973.973 0 0 1 1.412.098 1.07 1.07 0 0 1-.094 1.468l-1.947 1.77H14v-5.23C14 .449 14.448 0 15 0s1 .449 1 1.003v6.233c0 .554-.448 1.003-1 1.003z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" id=\"icon-search\"><path d=\"M8.31 6.896l3.397 3.397a1 1 0 0 1-1.414 1.414L6.896 8.31A4.5 4.5 0 1 1 8.31 6.896zM4.5 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z\" fill=\"currentColor\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-sentry",
  "use": "icon-sentry-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-sentry\"><path d=\"M23.7 21.859c.4-.715.4-1.567 0-2.282L13.92 2.141a2.184 2.184 0 0 0-3.84 0L6.92 7.774l.803.476a15.701 15.701 0 0 1 5.662 5.833 16.28 16.28 0 0 1 2.048 7.012H13.22a13.967 13.967 0 0 0-1.747-5.876 13.467 13.467 0 0 0-4.856-5l-.801-.476-2.955 5.27.802.475C5.626 16.652 7 18.793 7.285 21.095H2.22a.353.353 0 0 1-.317-.188.375.375 0 0 1 0-.377l1.412-2.518a5.101 5.101 0 0 0-1.605-.948L.3 19.577c-.4.715-.4 1.567 0 2.282A2.184 2.184 0 0 0 2.22 23h6.972v-.952a9.696 9.696 0 0 0-1.233-4.74 9.401 9.401 0 0 0-2.593-2.952l1.11-1.978a11.643 11.643 0 0 1 3.394 3.794 12.018 12.018 0 0 1 1.532 5.875V23h5.908l.001-.952c.003-3.119-.8-6.202-2.323-8.918a17.646 17.646 0 0 0-5.551-6.032l2.246-4.005A.351.351 0 0 1 12 2.905c.079 0 .225.024.317.188l9.78 17.437a.373.373 0 0 1 0 .376.353.353 0 0 1-.317.189h-2.298c.029.636.032 1.272.002 1.905h2.296c.8 0 1.518-.427 1.92-1.141\" fill=\"currentColor\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-settings",
  "use": "icon-settings-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-settings\" viewBox=\"0 0 24 24\" id=\"icon-settings\"><circle cx=\"12\" cy=\"12\" r=\"3\" /><path d=\"M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-stack",
  "use": "icon-stack-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-stack\"><g fill=\"currentColor\"><path d=\"M11.995 4L3.51 8.485l8.485 4.486 8.486-4.486L11.995 4zm.935-1.768l8.485 4.485c1.42.751 1.42 2.786 0 3.536L12.93 14.74a2 2 0 0 1-1.87 0l-8.485-4.486c-1.42-.75-1.42-2.785 0-3.536l8.486-4.485a2 2 0 0 1 1.869 0z\" /><path d=\"M2.966 12.115a1 1 0 1 0-.932 1.77l9.5 5a1 1 0 0 0 .932 0l9.5-5a1 1 0 1 0-.932-1.77L12 16.87l-9.034-4.755z\" /><path d=\"M2.966 16.115a1 1 0 1 0-.932 1.77l9.5 5a1 1 0 0 0 .932 0l9.5-5a1 1 0 1 0-.932-1.77L12 20.87l-9.034-4.755z\" /></g></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-star",
  "use": "icon-star-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" id=\"icon-star\"><path d=\"M19.9 6.2c1.3.1 2.2 1.3 2.1 2.6-.1.6-.3 1.1-.8 1.5l-3.5 3.2 1 4.6c.3 1.3-.6 2.5-1.8 2.8-.6.1-1.1 0-1.6-.3L11 18.3l-4.2 2.3c-1.1.6-2.6.2-3.2-.9-.3-.5-.4-1.1-.3-1.6l1-4.6-3.5-3.2c-1-.9-1-2.4-.2-3.3.4-.4.9-.7 1.5-.8l4.8-.5 2-4.3C9.4.2 10.9-.3 12 .2c.5.2.9.7 1.2 1.2l2 4.3 4.7.5zm-8.3-3.9c0-.2-.2-.3-.3-.3-.3-.2-.7 0-.9.3L8.2 7c-.1.2-.3.4-.5.4L2.5 8c-.1 0-.3.1-.4.2-.3.3-.2.7 0 1L6 12.6c.2.2.3.4.2.6l-1 5c0 .2 0 .3.1.5.2.3.6.4.9.3l4.5-2.5c.2-.1.5-.1.7 0l4.5 2.5c.1.1.3.1.5.1.4-.1.6-.4.5-.8l-1-5c0-.2 0-.5.2-.6l3.8-3.5c.1-.2.2-.3.2-.5 0-.4-.2-.7-.6-.7l-5.2-.6c-.2 0-.4-.2-.5-.4l-2.2-4.7z\" fill=\"currentColor\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-stats",
  "use": "icon-stats-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" id=\"icon-stats\"><path d=\"M16.051 19V7.093c0-.565.452-1.023 1.01-1.023s1.01.458 1.01 1.023V19h.919c.558 0 1.01-.458 1.01-1.023V4.023C20 3.458 19.548 3 18.99 3H3.01C2.452 3 2 3.458 2 4.023v13.954C2 18.542 2.452 19 3.01 19h.919v-5.767c0-.566.452-1.024 1.01-1.024s1.01.458 1.01 1.024V19h2.02v-5.767c0-.566.453-1.024 1.01-1.024.559 0 1.01.458 1.01 1.024V19h2.021v-7.814c0-.565.452-1.023 1.01-1.023s1.01.458 1.01 1.023V19h2.021zM3.025 1h15.95C20.645 1 22 2.368 22 4.056v13.888C22 19.632 20.646 21 18.975 21H3.025C1.355 21 0 19.632 0 17.944V4.056C0 2.368 1.354 1 3.025 1z\" fill=\"currentColor\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-support",
  "use": "icon-support-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-support\"><path d=\"M8 17.962V17.5A1.5 1.5 0 0 1 9.5 16h5a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 8 20.5v-.514A4.516 4.516 0 0 1 4 15.5v-1h2v1c0 1.212.858 2.225 2 2.462zM10 20h4v-2h-4v2zM20 9h1a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-3V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v11H3a3 3 0 0 1-3-3v-2a3 3 0 0 1 3-3h1V6.5A4.5 4.5 0 0 1 8.5 2h7A4.5 4.5 0 0 1 20 6.5V9zm0 6h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-1v4zM4 11H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h1v-4z\" fill=\"currentColor\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-trash",
  "use": "icon-trash-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-trash\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M6.444 0h11.112H6.444zM22 6v13.2c0 2.651-1.99 4.8-4.444 4.8H6.444C3.99 24 2 21.851 2 19.2V6h2v13.5C4 20.88 5.03 22 6.3 22h11.505c1.27 0 2.3-1.12 2.3-2.5V6H22z\" fill-rule=\"nonzero\" /><rect y=\"4\" width=\"24\" height=\"2\" rx=\"1\" /><path d=\"M15.299 2H8.7l-.777 2h8.152L15.3 2zM8.7 0H15.3a2 2 0 0 1 1.864 1.275L19 6H5l1.837-4.725A2 2 0 0 1 8.701 0z\" fill-rule=\"nonzero\" /><rect x=\"6\" y=\"8\" width=\"2\" height=\"12\" rx=\"1\" /><rect x=\"11\" y=\"8\" width=\"2\" height=\"12\" rx=\"1\" /><rect x=\"16\" y=\"8\" width=\"2\" height=\"12\" rx=\"1\" /></g></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" id=\"icon-user\"><path d=\"M7.421 13.343l-3.225.46a2.75 2.75 0 0 0-2.363 2.722v2.267c0 .76.616 1.375 1.375 1.375h15.584c.76 0 1.375-.616 1.375-1.375v-2.267a2.75 2.75 0 0 0-2.363-2.722l-3.225-.46A5.478 5.478 0 0 1 11 14.667a5.478 5.478 0 0 1-3.579-1.324zm1.194-1.391c.66.566 1.496.881 2.385.881.89 0 1.725-.315 2.385-.881l.63-.541 4.048.577A4.583 4.583 0 0 1 22 16.525v2.267A3.208 3.208 0 0 1 18.792 22H3.208A3.208 3.208 0 0 1 0 18.792v-2.267a4.583 4.583 0 0 1 3.937-4.537l4.048-.577.63.54zM11 1.833A3.667 3.667 0 0 0 7.333 5.5v3.667a3.667 3.667 0 0 0 7.334 0V5.5A3.667 3.667 0 0 0 11 1.833zM11 0a5.5 5.5 0 0 1 5.5 5.5v3.667a5.5 5.5 0 0 1-11 0V5.5A5.5 5.5 0 0 1 11 0z\" fill=\"currentColor\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-warning-sm",
  "use": "icon-warning-sm-usage",
  "viewBox": "0 0 9 9",
  "content": "<symbol viewBox=\"0 0 9 9\" id=\"icon-warning-sm\"><g stroke=\"currentColor\" fill=\"none\" stroke-linejoin=\"round\"><path d=\"M5.152 1.302l3.244 5.702a.75.75 0 0 1-.652 1.121H1.256a.75.75 0 0 1-.652-1.12l3.244-5.703a.75.75 0 0 1 1.304 0z\" /><path d=\"M4.5 3.5v1\" stroke-linecap=\"round\" /><circle cx=\"4.5\" cy=\"6\" r=\".5\" fill=\"currentColor\" stroke=\"none\" /></g></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(897);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(94)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--4-1!../../../../../../node_modules/less-loader/dist/cjs.js!./externalLink.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--4-1!../../../../../../node_modules/less-loader/dist/cjs.js!./externalLink.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(93)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isUndefined__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isUndefined__);




var defaults = {
  limit: null,
  key: function key(item) {
    return item.id;
  }
};

function Collection(collection, options) {
  var i = void 0;

  Array.call(this);

  if (__WEBPACK_IMPORTED_MODULE_1_lodash_isUndefined___default()(options)) {
    options = {};
  }

  for (i in defaults) {
    if (__WEBPACK_IMPORTED_MODULE_1_lodash_isUndefined___default()(options[i])) {
      options[i] = defaults[i];
    }
  }

  this.options = options;

  if (!__WEBPACK_IMPORTED_MODULE_1_lodash_isUndefined___default()(collection)) {
    this.push(collection);
  }

  return this;
}

Collection.prototype = [];

Collection.prototype.constructor = Collection;

Collection.prototype._refresh = function _refresh() {
  if (this.options.limit && this.length > this.options.limit) {
    this.splice(this.options.limit, this.length - this.options.limit);
  }
};

Collection.prototype.push = function push(items) {
  if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default()(items)) {
    items = [items];
  }

  items.forEach(function (item) {
    var existing = this.pop(item);
    if (existing) {
      $.extend(true, existing, item);
      item = existing;
    }
    Array.prototype.push.apply(this, [item]);
  }.bind(this));
  this._refresh();
  return this;
};

Collection.prototype.unshift = function unshift(items) {
  if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default()(items)) {
    items = [items];
  }
  items.reverse().forEach(function (item) {
    var existing = this.pop(item);
    if (existing) {
      $.extend(true, existing, item);
      item = existing;
    }
    Array.prototype.unshift.apply(this, [item]);
  }.bind(this));
  this._refresh();
  return this;
};

Collection.prototype.get = function get(key) {
  var idx = this.indexOf(key);
  if (idx === -1) {
    return null;
  }
  return this[idx];
};

Collection.prototype.pop = function pop(item) {
  var idx = this.indexOf(this.options.key(item));
  if (idx === -1) {
    return null;
  }
  var result = this[idx];
  this.splice(idx, idx + 1);
  return result;
};

Collection.prototype.empty = function empty() {
  this.splice(0, 0);
};

Collection.prototype.indexOf = function indexOf(key) {
  var keyFunc = this.options.key;
  for (var i = 0; i < this.length; i++) {
    if (keyFunc(this[i]) === key) {
      return i;
    }
  }
  return -1;
};

Collection.prototype.update = function update(item) {
  // returns true if the item already existed and was updated (as configured)
  var existing = this.indexOf(this.options.key(item));
  if (existing !== -1) {
    $.extend(true, this[existing], item);
    return true;
  }
  return false;
};

/* harmony default export */ __webpack_exports__["a"] = (Collection);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_utils_parseLinkHeader__ = __webpack_require__(311);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var CursorPoller = function () {
  function CursorPoller(options) {
    _classCallCheck(this, CursorPoller);

    this.api = new __WEBPACK_IMPORTED_MODULE_0_app_api__["Client"]();
    this.options = options;
    this._timeoutId = null;
    this._active = true;
    this._baseDelay = 3000;
    this._maxDelay = 60000;
    this._reqsWithoutData = 0;
    this._pollingEndpoint = options.endpoint;
  }

  _createClass(CursorPoller, [{
    key: 'getDelay',
    value: function getDelay() {
      var delay = this._baseDelay * (this._reqsWithoutData + 1);
      return Math.min(delay, this._maxDelay);
    }
  }, {
    key: 'setEndpoint',
    value: function setEndpoint(url) {
      this._pollingEndpoint = url;
    }
  }, {
    key: 'enable',
    value: function enable() {
      this._active = true;
      if (!this._timeoutId) {
        this._timeoutId = window.setTimeout(this.poll.bind(this), this.getDelay());
      }
    }
  }, {
    key: 'disable',
    value: function disable() {
      this._active = false;
      if (this._timeoutId) {
        window.clearTimeout(this._timeoutId);
        this._timeoutId = null;
      }

      if (this._lastRequest) {
        this._lastRequest.cancel();
      }
    }
  }, {
    key: 'poll',
    value: function poll() {
      var _this = this;

      this._lastRequest = this.api.request(this._pollingEndpoint, {
        success: function success(data, _, jqXHR) {
          // cancel in progress operation if disabled
          if (!_this._active) {
            return;
          }

          // if theres no data, nothing changes
          if (!data.length) {
            _this._reqsWithoutData += 1;
            return;
          }

          if (_this._reqsWithoutData > 0) {
            _this._reqsWithoutData -= 1;
          }

          var links = Object(__WEBPACK_IMPORTED_MODULE_1_app_utils_parseLinkHeader__["a" /* default */])(jqXHR.getResponseHeader('Link'));
          _this._pollingEndpoint = links.previous.href;

          _this.options.success(data, jqXHR.getResponseHeader('Link'));
        },
        complete: function complete() {
          _this._lastRequest = null;

          if (_this._active) {
            _this._timeoutId = window.setTimeout(_this.poll.bind(_this), _this.getDelay());
          }
        }
      });
    }
  }]);

  return CursorPoller;
}();

/* harmony default export */ __webpack_exports__["a"] = (CursorPoller);

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var removeFromList = function removeFromList(item, list) {
  var idx = list.indexOf(item);

  if (idx !== -1) {
    list.splice(idx, 1);
  }
};

var StreamManager = function () {
  // TODO(dcramer): this should listen to changes on GroupStore and remove
  // items that are removed there
  function StreamManager(store) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, StreamManager);

    this.idList = [];
    this.store = store;
    this.limit = options.limit || 1000;
  }

  _createClass(StreamManager, [{
    key: 'trim',
    value: function trim() {
      var excess = this.idList.splice(this.limit, this.idList.length - this.limit);
      excess.forEach(this.store.remove);
    }
  }, {
    key: 'push',
    value: function push() {
      var _this = this;

      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      items = [].concat(items);
      if (items.length === 0) return this;

      items = items.filter(function (item) {
        return item.hasOwnProperty('id');
      });

      items.forEach(function (item) {
        return removeFromList(item.id, _this.idList);
      });
      var ids = items.map(function (item) {
        return item.id;
      });
      this.idList = [].concat(this.idList, ids);

      this.trim();
      this.store.add(items);
      return this;
    }
  }, {
    key: 'getAllItems',
    value: function getAllItems() {
      var _this2 = this;

      return this.store.getAllItems().slice().sort(function (a, b) {
        return _this2.idList.indexOf(a.id) - _this2.idList.indexOf(b.id);
      });
    }
  }, {
    key: 'unshift',
    value: function unshift() {
      var _this3 = this;

      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      items = [].concat(items);
      if (items.length === 0) return this;

      items.forEach(function (item) {
        return removeFromList(item.id, _this3.idList);
      });
      var ids = items.map(function (item) {
        return item.id;
      });
      this.idList = [].concat(ids, this.idList);

      this.trim();
      this.store.add(items);
      return this;
    }
  }]);

  return StreamManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (StreamManager);

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grid_emotion__ = __webpack_require__(14);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var width = '36px';
var FieldControlState = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])(function (_ref) {
  var flexibleControlStateSize = _ref.flexibleControlStateSize,
      props = _objectWithoutProperties(_ref, ['flexibleControlStateSize']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Flex"], props);
}, {
  target: 'e1rziqw00'
})('position:relative;', function (p) {
  return !p.flexibleControlStateSize && 'width: ' + width;
}, ';flex-shrink:0;justify-content:center;align-items:center;');

/* harmony default export */ __webpack_exports__["a"] = (FieldControlState);

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emotion__ = __webpack_require__(5);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var inlineStyle = function inlineStyle(p) {
  return p.inline ? /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["css"])('width:50%;padding-right:10px;flex-shrink:0;') : /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["css"])('margin-bottom:10px;');
};

var FieldDescription = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])(function (_ref) {
  var inline = _ref.inline,
      props = _objectWithoutProperties(_ref, ['inline']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', props);
}, {
  target: 'e12jefmo0'
})('font-weight:normal;margin-bottom:0;', inlineStyle, ';');

/* harmony default export */ __webpack_exports__["a"] = (FieldDescription);

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_emotion__ = __webpack_require__(5);


var FieldHelp = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react_emotion__["default"])('div', {
  target: 'e19g0xdp0'
})('color:', function (p) {
  return p.theme.gray2;
}, ';font-size:14px;margin-top:8px;line-height:1.4;');

/* harmony default export */ __webpack_exports__["a"] = (FieldHelp);

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_emotion__ = __webpack_require__(5);


var FieldLabel = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react_emotion__["default"])('div', {
  target: 'ejkuyjq0'
})('color:', function (p) {
  return p.theme.gray5;
}, ';');

/* harmony default export */ __webpack_exports__["a"] = (FieldLabel);

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_emotion__ = __webpack_require__(5);


var FieldRequiredBadge = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react_emotion__["default"])('div', {
  target: 'e1u93u900'
})('display:inline-block;background:', function (p) {
  return p.theme.redLight;
}, ';opacity:0.6;width:5px;height:5px;border-radius:5px;text-indent:-9999em;vertical-align:super;');

/* harmony default export */ __webpack_exports__["a"] = (FieldRequiredBadge);

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_styles_space__ = __webpack_require__(38);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var inlineStyle = function inlineStyle(p) {
  return p.inline ? /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["css"])('align-items:center;') : /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["css"])('flex-direction:column;align-items:stretch;');
};

var highlightedStyle = function highlightedStyle(p) {
  return p.highlighted ? /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["css"])('outline:1px solid ', p.theme.purple, ';') : '';
};

var getPadding = function getPadding(props) {
  if (typeof props.p !== 'undefined') {
    return 'padding: ' + props.p + ';';
  }
  return 'padding: ' + Object(__WEBPACK_IMPORTED_MODULE_3_app_styles_space__["a" /* default */])(2) + ' ' + (props.hasControlState ? 0 : Object(__WEBPACK_IMPORTED_MODULE_3_app_styles_space__["a" /* default */])(2)) + ' ' + Object(__WEBPACK_IMPORTED_MODULE_3_app_styles_space__["a" /* default */])(2) + ' ' + Object(__WEBPACK_IMPORTED_MODULE_3_app_styles_space__["a" /* default */])(2);
};

/**
 * `hasControlState` - adds padding to right if this is false
 */
var FieldWrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])(function (_ref) {
  var highlighted = _ref.highlighted,
      inline = _ref.inline,
      hasControlState = _ref.hasControlState,
      p = _ref.p,
      props = _objectWithoutProperties(_ref, ['highlighted', 'inline', 'hasControlState', 'p']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Flex"], props);
}, {
  target: 'etqqcs20'
})(getPadding, ';border-bottom:1px solid ', function (p) {
  return p.theme.borderLight;
}, ';transition:background 0.15s;', inlineStyle, ' ', highlightedStyle, ' &:last-child{border-bottom:none;}');

/* harmony default export */ __webpack_exports__["a"] = (FieldWrapper);

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emotion__ = __webpack_require__(5);



var spin = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["keyframes"])('0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}');

var Spinner = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])('div', {
  target: 'enx1duq0'
})('animation:', spin, ' 0.4s linear infinite;width:18px;height:18px;border-radius:18px;border-top:2px solid ', function (p) {
  return p.theme.borderLight;
}, ';border-right:2px solid ', function (p) {
  return p.theme.borderLight;
}, ';border-bottom:2px solid ', function (p) {
  return p.theme.borderLight;
}, ';border-left:2px solid ', function (p) {
  return p.theme.purple;
}, ';margin-left:auto;');

/* harmony default export */ __webpack_exports__["a"] = (Spinner);

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_inlineSvg__ = __webpack_require__(24);





var SubmitButton = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])('div', {
  target: 'e4a59gt0'
})('background:transparent;box-shadow:none;border:1px solid transparent;border-radius:', function (p) {
  return p.theme.borderRadius;
}, ';transition:0.2s all;display:flex;align-items:center;justify-content:center;height:1.4em;width:1.4em;');

var ClickTargetStyled = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])('div', {
  target: 'e4a59gt1'
})('height:100%;width:25%;max-width:2.5em;display:flex;align-items:center;justify-content:center;cursor:pointer;&:hover ', SubmitButton, '{background:#fff;box-shadow:', function (p) {
  return p.theme.dropShadowLight;
}, ';border:1px solid ', function (p) {
  return p.theme.borderLight;
}, ';}');

var returnButton = function returnButton(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    ClickTargetStyled,
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_app_components_tooltip__["default"],
      { title: 'Save' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        SubmitButton,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_inlineSvg__["a" /* default */], { size: '0.75em', src: 'icon-return-key' })
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (returnButton);

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__( 913 );

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

module.exports = API;

var chromeApi = __webpack_require__( 914 );

// Feature detection (yes really)
var isSafari = navigator.userAgent.match( /Safari\// )
	&& !navigator.userAgent.match( /Chrome\// );
var isEDGE = navigator.userAgent.match( /Edge\/12/ );

var _backend = null;
function getBackend( Promise )
{
	if ( !_backend )
		_backend = new Promise( function( resolve, reject )
		{
			function notSupported( )
			{
				// Note; {native: true} means *not* using Google's hack
				resolve( { u2f: null, native: true } );
			}

			if ( isSafari )
				// Safari doesn't support U2F, and the Safari-FIDO-U2F
				// extension lacks full support (Multi-factet apps), so we
				// block it until proper support.
				return notSupported( );

			var hasNativeSupport =
				( typeof window.u2f !== 'undefined' ) &&
				( typeof window.u2f.sign === 'function' );

			if ( hasNativeSupport )
				resolve( { u2f: window.u2f, native: true } );

			if ( isEDGE )
				// We don't want to check for Google's extension hack on EDGE
				// as it'll cause trouble (popups, etc)
				return notSupported( );

			if ( location.protocol === 'http:' )
				// U2F isn't supported over http, only https
				return notSupported( );

			// Test for google extension support
			chromeApi.isSupported( function( ok )
			{
				if ( ok )
					resolve( { u2f: chromeApi, native: false } );
				else
					notSupported( );
			} );
		} );

	return _backend;
}

function API( Promise )
{
	return {
		isSupported   : isSupported.bind( Promise ),
		ensureSupport : ensureSupport.bind( Promise ),
		register      : register.bind( Promise ),
		sign          : sign.bind( Promise ),
		ErrorCodes    : API.ErrorCodes,
		ErrorNames    : API.ErrorNames
	};
}

API.ErrorCodes = {
	CANCELLED: -1,
	OK: 0,
	OTHER_ERROR: 1,
	BAD_REQUEST: 2,
	CONFIGURATION_UNSUPPORTED: 3,
	DEVICE_INELIGIBLE: 4,
	TIMEOUT: 5
};
API.ErrorNames = {
	"-1": "CANCELLED",
	"0": "OK",
	"1": "OTHER_ERROR",
	"2": "BAD_REQUEST",
	"3": "CONFIGURATION_UNSUPPORTED",
	"4": "DEVICE_INELIGIBLE",
	"5": "TIMEOUT"
};

function makeError( msg, err )
{
	var code = err != null ? err.errorCode : 1; // Default to OTHER_ERROR
	var type = API.ErrorNames[ '' + code ];
	var error = new Error( msg );
	error.metaData = {
		type: type,
		code: code
	}
	return error;
}

function deferPromise( Promise, promise )
{
	var ret = { };
	ret.promise = new Promise( function( resolve, reject ) {
		ret.resolve = resolve;
		ret.reject = reject;
		promise.then( resolve, reject );
	} );
	/**
	 * Reject request promise and disconnect port if 'disconnect' flag is true
	 * @param {string} msg
	 * @param {boolean} disconnect
	 */
	ret.promise.cancel = function( msg, disconnect )
	{
		getBackend( Promise )
		.then( function( backend )
		{
			if ( disconnect && !backend.native )
				backend.u2f.disconnect( );

			ret.reject( makeError( msg, { errorCode: -1 } ) );
		} );
	};
	return ret;
}

function defer( Promise, fun )
{
	return deferPromise( Promise, new Promise( function( resolve, reject )
	{
		try
		{
			fun && fun( resolve, reject );
		}
		catch ( err )
		{
			reject( err );
		}
	} ) );
}

function isSupported( )
{
	var Promise = this;

	return getBackend( Promise )
	.then( function( backend )
	{
		return !!backend.u2f;
	} );
}

function _ensureSupport( backend )
{
	if ( !backend.u2f )
	{
		if ( location.protocol === 'http:' )
			throw new Error( "U2F isn't supported over http, only https" );
		throw new Error( "U2F not supported" );
	}
}

function ensureSupport( )
{
	var Promise = this;

	return getBackend( Promise )
	.then( _ensureSupport );
}

function register( registerRequests, signRequests /* = null */, timeout )
{
	var Promise = this;

	if ( !Array.isArray( registerRequests ) )
		registerRequests = [ registerRequests ];

	if ( typeof signRequests === 'number' && typeof timeout === 'undefined' )
	{
		timeout = signRequests;
		signRequests = null;
	}

	if ( !signRequests )
		signRequests = [ ];

	return deferPromise( Promise, getBackend( Promise )
	.then( function( backend )
	{
		_ensureSupport( backend );

		var native = backend.native;
		var u2f = backend.u2f;

		return new Promise( function( resolve, reject )
		{
			function cbNative( response )
			{
				if ( response.errorCode )
					reject( makeError( "Registration failed", response ) );
				else
				{
					delete response.errorCode;
					resolve( response );
				}
			}

			function cbChrome( err, response )
			{
				if ( err )
					reject( err );
				else if ( response.errorCode )
					reject( makeError( "Registration failed", response ) );
				else
					resolve( response );
			}

			if ( native )
			{
				var appId = registerRequests[ 0 ].appId;

				u2f.register(
					appId, registerRequests, signRequests, cbNative, timeout );
			}
			else
			{
				u2f.register(
					registerRequests, signRequests, cbChrome, timeout );
			}
		} );
	} ) ).promise;
}

function sign( signRequests, timeout )
{
	var Promise = this;

	if ( !Array.isArray( signRequests ) )
		signRequests = [ signRequests ];

	return deferPromise( Promise, getBackend( Promise )
	.then( function( backend )
	{
		_ensureSupport( backend );

		var native = backend.native;
		var u2f = backend.u2f;

		return new Promise( function( resolve, reject )
		{
			function cbNative( response )
			{
				if ( response.errorCode )
					reject( makeError( "Sign failed", response ) );
				else
				{
					delete response.errorCode;
					resolve( response );
				}
			}

			function cbChrome( err, response )
			{
				if ( err )
					reject( err );
				else if ( response.errorCode )
					reject( makeError( "Sign failed", response ) );
				else
					resolve( response );
			}

			if ( native )
			{
				var appId = signRequests[ 0 ].appId;
				var challenge = signRequests[ 0 ].challenge;

				u2f.sign( appId, challenge, signRequests, cbNative, timeout );
			}
			else
			{
				u2f.sign( signRequests, cbChrome, timeout );
			}
		} );
	} ) ).promise;
}

function makeDefault( func )
{
	API[ func ] = function( )
	{
		if ( !global.Promise )
			// This is very unlikely to ever happen, since browsers
			// supporting U2F will most likely support Promises.
			throw new Error( "The platform doesn't natively support promises" );

		var args = [ ].slice.call( arguments );
		return API( global.Promise )[ func ].apply( null, args );
	};
}

// Provide default functions using the built-in Promise if available.
makeDefault( 'isSupported' );
makeDefault( 'ensureSupport' );
makeDefault( 'register' );
makeDefault( 'sign' );

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright 2014 Google Inc. All rights reserved
//
// Use of this source code is governed by a BSD-style
// license that can be found in the LICENSE file or at
// https://developers.google.com/open-source/licenses/bsd

/**
 * @fileoverview The U2F api.
 */



/** Namespace for the U2F api.
 * @type {Object}
 */
var u2f = u2f || {};

module.exports = u2f; // Adaptation for u2f-api package

/**
 * The U2F extension id
 * @type {string}
 * @const
 */
u2f.EXTENSION_ID = 'kmendfapggjehodndflmmgagdbamhnfd';

/**
 * Message types for messsages to/from the extension
 * @const
 * @enum {string}
 */
u2f.MessageTypes = {
  'U2F_REGISTER_REQUEST': 'u2f_register_request',
  'U2F_SIGN_REQUEST': 'u2f_sign_request',
  'U2F_REGISTER_RESPONSE': 'u2f_register_response',
  'U2F_SIGN_RESPONSE': 'u2f_sign_response'
};

/**
 * Response status codes
 * @const
 * @enum {number}
 */
u2f.ErrorCodes = {
  'OK': 0,
  'OTHER_ERROR': 1,
  'BAD_REQUEST': 2,
  'CONFIGURATION_UNSUPPORTED': 3,
  'DEVICE_INELIGIBLE': 4,
  'TIMEOUT': 5
};

/**
 * A message type for registration requests
 * @typedef {{
 *   type: u2f.MessageTypes,
 *   signRequests: Array.<u2f.SignRequest>,
 *   registerRequests: ?Array.<u2f.RegisterRequest>,
 *   timeoutSeconds: ?number,
 *   requestId: ?number
 * }}
 */
u2f.Request;

/**
 * A message for registration responses
 * @typedef {{
 *   type: u2f.MessageTypes,
 *   responseData: (u2f.Error | u2f.RegisterResponse | u2f.SignResponse),
 *   requestId: ?number
 * }}
 */
u2f.Response;

/**
 * An error object for responses
 * @typedef {{
 *   errorCode: u2f.ErrorCodes,
 *   errorMessage: ?string
 * }}
 */
u2f.Error;

/**
 * Data object for a single sign request.
 * @typedef {{
 *   version: string,
 *   challenge: string,
 *   keyHandle: string,
 *   appId: string
 * }}
 */
u2f.SignRequest;

/**
 * Data object for a sign response.
 * @typedef {{
 *   keyHandle: string,
 *   signatureData: string,
 *   clientData: string
 * }}
 */
u2f.SignResponse;

/**
 * Data object for a registration request.
 * @typedef {{
 *   version: string,
 *   challenge: string,
 *   appId: string
 * }}
 */
u2f.RegisterRequest;

/**
 * Data object for a registration response.
 * @typedef {{
 *   registrationData: string,
 *   clientData: string
 * }}
 */
u2f.RegisterResponse;


// Low level MessagePort API support

/**
 * Call MessagePort disconnect
 */
u2f.disconnect = function() {
  if (u2f.port_ && u2f.port_.port_) {
    u2f.port_.port_.disconnect();
    u2f.port_ = null;
  }
};

/**
 * Sets up a MessagePort to the U2F extension using the
 * available mechanisms.
 * @param {function((MessagePort|u2f.WrappedChromeRuntimePort_))} callback
 */
u2f.getMessagePort = function(callback) {
  if (typeof chrome != 'undefined' && chrome.runtime) {
    // The actual message here does not matter, but we need to get a reply
    // for the callback to run. Thus, send an empty signature request
    // in order to get a failure response.
    var msg = {
      type: u2f.MessageTypes.U2F_SIGN_REQUEST,
      signRequests: []
    };
    chrome.runtime.sendMessage(u2f.EXTENSION_ID, msg, function() {
      if (!chrome.runtime.lastError) {
        // We are on a whitelisted origin and can talk directly
        // with the extension.
        u2f.getChromeRuntimePort_(callback);
      } else {
        // chrome.runtime was available, but we couldn't message
        // the extension directly, use iframe
        u2f.getIframePort_(callback);
      }
    });
  } else {
    // chrome.runtime was not available at all, which is normal
    // when this origin doesn't have access to any extensions.
    u2f.getIframePort_(callback);
  }
};

/**
 * Connects directly to the extension via chrome.runtime.connect
 * @param {function(u2f.WrappedChromeRuntimePort_)} callback
 * @private
 */
u2f.getChromeRuntimePort_ = function(callback) {
  var port = chrome.runtime.connect(u2f.EXTENSION_ID,
    {'includeTlsChannelId': true});
  setTimeout(function() {
    callback(null, new u2f.WrappedChromeRuntimePort_(port));
  }, 0);
};

/**
 * A wrapper for chrome.runtime.Port that is compatible with MessagePort.
 * @param {Port} port
 * @constructor
 * @private
 */
u2f.WrappedChromeRuntimePort_ = function(port) {
  this.port_ = port;
};

/**
 * Posts a message on the underlying channel.
 * @param {Object} message
 */
u2f.WrappedChromeRuntimePort_.prototype.postMessage = function(message) {
  this.port_.postMessage(message);
};

/**
 * Emulates the HTML 5 addEventListener interface. Works only for the
 * onmessage event, which is hooked up to the chrome.runtime.Port.onMessage.
 * @param {string} eventName
 * @param {function({data: Object})} handler
 */
u2f.WrappedChromeRuntimePort_.prototype.addEventListener =
    function(eventName, handler) {
  var name = eventName.toLowerCase();
  if (name == 'message' || name == 'onmessage') {
    this.port_.onMessage.addListener(function(message) {
      // Emulate a minimal MessageEvent object
      handler({'data': message});
    });
  } else {
    console.error('WrappedChromeRuntimePort only supports onMessage');
  }
};

/**
 * Sets up an embedded trampoline iframe, sourced from the extension.
 * @param {function(MessagePort)} callback
 * @private
 */
u2f.getIframePort_ = function(callback) {
  // Create the iframe
  var iframeOrigin = 'chrome-extension://' + u2f.EXTENSION_ID;
  var iframe = document.createElement('iframe');
  iframe.src = iframeOrigin + '/u2f-comms.html';
  iframe.setAttribute('style', 'display:none');
  document.body.appendChild(iframe);

  var hasCalledBack = false;

  var channel = new MessageChannel();
  var ready = function(message) {
    if (message.data == 'ready') {
      channel.port1.removeEventListener('message', ready);
      if (!hasCalledBack)
      {
        hasCalledBack = true;
        callback(null, channel.port1);
      }
    } else {
      console.error('First event on iframe port was not "ready"');
    }
  };
  channel.port1.addEventListener('message', ready);
  channel.port1.start();

  iframe.addEventListener('load', function() {
    // Deliver the port to the iframe and initialize
    iframe.contentWindow.postMessage('init', iframeOrigin, [channel.port2]);
  });

  // Give this 200ms to initialize, after that, we treat this method as failed
  setTimeout(function() {
    if (!hasCalledBack)
    {
      hasCalledBack = true;
      callback(new Error("IFrame extension not supported"));
    }
  }, 200);
};


// High-level JS API

/**
 * Default extension response timeout in seconds.
 * @const
 */
u2f.EXTENSION_TIMEOUT_SEC = 30;

/**
 * A singleton instance for a MessagePort to the extension.
 * @type {MessagePort|u2f.WrappedChromeRuntimePort_}
 * @private
 */
u2f.port_ = null;

/**
 * Callbacks waiting for a port
 * @type {Array.<function((MessagePort|u2f.WrappedChromeRuntimePort_))>}
 * @private
 */
u2f.waitingForPort_ = [];

/**
 * A counter for requestIds.
 * @type {number}
 * @private
 */
u2f.reqCounter_ = 0;

/**
 * A map from requestIds to client callbacks
 * @type {Object.<number,(function((u2f.Error|u2f.RegisterResponse))
 *                       |function((u2f.Error|u2f.SignResponse)))>}
 * @private
 */
u2f.callbackMap_ = {};

/**
 * Creates or retrieves the MessagePort singleton to use.
 * @param {function((MessagePort|u2f.WrappedChromeRuntimePort_))} callback
 * @private
 */
u2f.getPortSingleton_ = function(callback) {
  if (u2f.port_) {
    callback(null, u2f.port_);
  } else {
    if (u2f.waitingForPort_.length == 0) {
      u2f.getMessagePort(function(err, port) {
        if (!err) {
          u2f.port_ = port;
          u2f.port_.addEventListener('message',
            /** @type {function(Event)} */ (u2f.responseHandler_));
        }

        // Careful, here be async callbacks. Maybe.
        while (u2f.waitingForPort_.length)
          u2f.waitingForPort_.shift()(err, port);
      });
    }
    u2f.waitingForPort_.push(callback);
  }
};

/**
 * Handles response messages from the extension.
 * @param {MessageEvent.<u2f.Response>} message
 * @private
 */
u2f.responseHandler_ = function(message) {
  var response = message.data;
  var reqId = response['requestId'];
  if (!reqId || !u2f.callbackMap_[reqId]) {
    console.error('Unknown or missing requestId in response.');
    return;
  }
  var cb = u2f.callbackMap_[reqId];
  delete u2f.callbackMap_[reqId];
  cb(null, response['responseData']);
};

/**
 * Calls the callback with true or false as first and only argument
 * @param {Function} callback
 */
u2f.isSupported = function(callback) {
  u2f.getPortSingleton_(function(err, port) {
    callback(!err);
  });
}

/**
 * Dispatches an array of sign requests to available U2F tokens.
 * @param {Array.<u2f.SignRequest>} signRequests
 * @param {function((u2f.Error|u2f.SignResponse))} callback
 * @param {number=} opt_timeoutSeconds
 */
u2f.sign = function(signRequests, callback, opt_timeoutSeconds) {
  u2f.getPortSingleton_(function(err, port) {
    if (err)
      return callback(err);

    var reqId = ++u2f.reqCounter_;
    u2f.callbackMap_[reqId] = callback;
    var req = {
      type: u2f.MessageTypes.U2F_SIGN_REQUEST,
      signRequests: signRequests,
      timeoutSeconds: (typeof opt_timeoutSeconds !== 'undefined' ?
        opt_timeoutSeconds : u2f.EXTENSION_TIMEOUT_SEC),
      requestId: reqId
    };
    port.postMessage(req);
  });
};

/**
 * Dispatches register requests to available U2F tokens. An array of sign
 * requests identifies already registered tokens.
 * @param {Array.<u2f.RegisterRequest>} registerRequests
 * @param {Array.<u2f.SignRequest>} signRequests
 * @param {function((u2f.Error|u2f.RegisterResponse))} callback
 * @param {number=} opt_timeoutSeconds
 */
u2f.register = function(registerRequests, signRequests,
    callback, opt_timeoutSeconds) {
  u2f.getPortSingleton_(function(err, port) {
    if (err)
      return callback(err);

    var reqId = ++u2f.reqCounter_;
    u2f.callbackMap_[reqId] = callback;
    var req = {
      type: u2f.MessageTypes.U2F_REGISTER_REQUEST,
      signRequests: signRequests,
      registerRequests: registerRequests,
      timeoutSeconds: (typeof opt_timeoutSeconds !== 'undefined' ?
        opt_timeoutSeconds : u2f.EXTENSION_TIMEOUT_SEC),
      requestId: reqId
    };
    port.postMessage(req);
  });
};


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(916);

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

module.exports = escapeHtmlChar;


/***/ }),
/* 916 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * Usage:
 *   <StrictClick onClick={this.onClickHandler}>
 *     <button>Some button</button>
 *   </StrictClick>
 */
var StrictClick = (_temp = _class = function (_React$PureComponent) {
  _inherits(StrictClick, _React$PureComponent);

  function StrictClick() {
    var _ref;

    _classCallCheck(this, StrictClick);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = StrictClick.__proto__ || Object.getPrototypeOf(StrictClick)).call.apply(_ref, [this].concat(args)));

    _this.handleMouseDown = function (evt) {
      _this.setState({
        startCoords: {
          x: evt.screenX,
          y: evt.screenY
        }
      });
    };

    _this.handleMouseClick = function (evt) {
      // Click happens if mouse down/up in same element - click will
      // not fire if either initial mouse down OR final ouse up occurs in
      // different element
      var startCoords = _this.state.startCoords;

      var deltaX = Math.abs(evt.screenX - startCoords.x);
      var deltaY = Math.abs(evt.screenY - startCoords.y);

      // If mouse hasn't moved more than 10 pixels in either Y
      // or X direction, fire onClick
      if (deltaX < StrictClick.MAX_DELTA_X && deltaY < StrictClick.MAX_DELTA_Y) {
        _this.props.onClick(evt);
      }
      _this.setState({
        startCoords: null
      });
    };

    _this.state = {
      startCoords: null
    };
    return _this;
  }

  _createClass(StrictClick, [{
    key: 'render',
    value: function render() {
      // Bail out early if there is no onClick handler
      if (!this.props.onClick) return this.props.children;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(this.props.children, {
        onMouseDown: this.handleMouseDown,
        onClick: this.handleMouseClick
      });
    }
  }]);

  return StrictClick;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent), _class.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
}, _class.MAX_DELTA_X = 10, _class.MAX_DELTA_Y = 10, _temp);


/* harmony default export */ __webpack_exports__["a"] = (StrictClick);

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils__ = __webpack_require__(10);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();





var ContextLine = function ContextLine(props) {
  var line = props.line,
      isActive = props.isActive;

  var liClassName = 'expandable';
  if (isActive) {
    liClassName += ' active';
  }

  var lineWs = '';
  var lineCode = '';
  if (Object(__WEBPACK_IMPORTED_MODULE_2_app_utils__["d" /* defined */])(line[1]) && line[1].match) {
    var _line$1$match = line[1].match(/^(\s*)(.*?)$/m);

    var _line$1$match2 = _slicedToArray(_line$1$match, 3);

    lineWs = _line$1$match2[1];
    lineCode = _line$1$match2[2];
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'li',
    { className: liClassName, key: line[0] },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      { className: 'ws' },
      lineWs
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      { className: 'contextline' },
      lineCode
    )
  );
};

ContextLine.propTypes = {
  line: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (ContextLine);

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_events_interfaces_keyValueList__ = __webpack_require__(85);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var FrameVariables = (_temp2 = _class = function (_React$Component) {
  _inherits(FrameVariables, _React$Component);

  function FrameVariables() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FrameVariables);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FrameVariables.__proto__ || Object.getPrototypeOf(FrameVariables)).call.apply(_ref, [this].concat(args))), _this), _this.preventToggling = function (evt) {
      evt.stopPropagation();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // make sure that clicking on the variables does not actually do
  // anything on the containing element.


  _createClass(FrameVariables, [{
    key: 'render',
    value: function render() {
      var data = Object(__WEBPACK_IMPORTED_MODULE_2_app_utils__["n" /* objectToArray */])(this.props.data);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_events_interfaces_keyValueList__["a" /* default */], { data: data, isContextData: true, onClick: this.preventToggling });
    }
  }]);

  return FrameVariables;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (FrameVariables);

/***/ }),
/* 920 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(922),
    isArguments = __webpack_require__(274),
    isArray = __webpack_require__(47);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(392);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(185),
    baseIteratee = __webpack_require__(123),
    baseMap = __webpack_require__(486),
    baseSortBy = __webpack_require__(927),
    baseUnary = __webpack_require__(488),
    compareMultiple = __webpack_require__(928),
    identity = __webpack_require__(414);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 925 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(221);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 927 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(929);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(630);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 930 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 931 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(632),
    baseEach = __webpack_require__(220),
    castFunction = __webpack_require__(494),
    isArray = __webpack_require__(47);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Async; });
/* unused harmony export AsyncCreatable */
/* unused harmony export Creatable */
/* unused harmony export Value */
/* unused harmony export Option */
/* unused harmony export defaultMenuRenderer */
/* unused harmony export defaultArrowRenderer */
/* unused harmony export defaultClearRenderer */
/* unused harmony export defaultFilterOptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);






var arrowRenderer = function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var clearRenderer = function clearRenderer() {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

var trim = function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var isValid = function isValid(value) {
	return typeof value !== 'undefined' && value !== null && value !== '';
};

var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
	if (props.ignoreAccents) {
		filterValue = stripDiacritics(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (props.trimFilter) {
		filterValue = trim(filterValue);
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
		if (!filterValue) return true;

		var value = option[props.valueKey];
		var label = option[props.labelKey];
		var hasValue = isValid(value);
		var hasLabel = isValid(label);

		if (!hasValue && !hasLabel) {
			return false;
		}

		var valueTest = hasValue ? String(value) : null;
		var labelTest = hasLabel ? String(label) : null;

		if (props.ignoreAccents) {
			if (valueTest && props.matchProp !== 'label') valueTest = stripDiacritics(valueTest);
			if (labelTest && props.matchProp !== 'value') labelTest = stripDiacritics(labelTest);
		}

		if (props.ignoreCase) {
			if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}

		return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
};

var menuRenderer = function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    focusOption = _ref.focusOption,
	    inputValue = _ref.inputValue,
	    instancePrefix = _ref.instancePrefix,
	    onFocus = _ref.onFocus,
	    onOptionRef = _ref.onOptionRef,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    removeValue = _ref.removeValue,
	    selectValue = _ref.selectValue,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.some(function (x) {
			return x[valueKey] === option[valueKey];
		});
		var isFocused = option === focusedOption;
		var optionClass = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
			Option,
			{
				className: optionClass,
				focusOption: focusOption,
				inputValue: inputValue,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				},
				removeValue: removeValue,
				selectValue: selectValue
			},
			optionRenderer(option, i, inputValue)
		);
	});
};

menuRenderer.propTypes = {
	focusOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	focusedOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
	inputValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onOptionRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	removeValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	selectValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	valueArray: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

var blockEvent = (function (event) {
	event.preventDefault();
	event.stopPropagation();
	if (event.target.tagName !== 'A' || !('href' in event.target)) {
		return;
	}
	if (event.target.target) {
		window.open(event.target.href, event.target.target);
	} else {
		window.location.href = event.target.href;
	}
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Option = function (_React$Component) {
	inherits(Option, _React$Component);

	function Option(props) {
		classCallCheck(this, Option);

		var _this = possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	createClass(Option, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(this.props.className, option.className);

			return option.disabled ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					onMouseDown: blockEvent,
					onClick: blockEvent },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					'aria-label': option.label,
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);
	return Option;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Option.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className (based on mouse position)
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is disabled
	isFocused: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is focused
	isSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is selected
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseEnter on option element
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on option element
	onUnfocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseLeave on option element
	option: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, // object that is base for that option
	optionIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number // index of the option, used to generate unique ids for aria
};

var Value = function (_React$Component) {
	inherits(Value, _React$Component);

	function Value(props) {
		classCallCheck(this, Value);

		var _this = possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-value', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);
	return Value;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Value.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // disabled prop passed to ReactSelect
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // Unique id for the value - used for aria
	onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on value label
	onRemove: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle removal of the value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired // the option object for this value
};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/
var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]);
var stringOrNumber = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]);

var instanceId = 1;

var shouldShowValue = function shouldShowValue(state, props) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	if (!inputValue) return true;

	if (!onSelectResetsInput) {
		return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
	}

	return false;
};

var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
};

/**
 * Retrieve a value from the given options and valueKey
 * @param {String|Number|Array} value	- the selected value(s)
 * @param {Object}		 props	- the Select component's props (or nextProps)
 */
var expandValue = function expandValue(value, props) {
	var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
	var options = props.options,
	    valueKey = props.valueKey;

	if (!options) return;
	for (var i = 0; i < options.length; i++) {
		if (String(options[i][valueKey]) === String(value)) return options[i];
	}
};

var handleRequired = function handleRequired(value, multi) {
	if (!value) return true;
	return multi ? value.length === 0 : Object.keys(value).length === 0;
};

var Select$1 = function (_React$Component) {
	inherits(Select, _React$Component);

	function Select(props) {
		classCallCheck(this, Select);

		var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
				console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
			}
			if (this.props.autoFocus || this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}

			if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
				this.setState({ inputValue: this.handleInputValueChange('') });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuNode = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);

				var scrollTop = menuNode.scrollTop;
				var scrollBottom = scrollTop + menuNode.offsetHeight;
				var optionTop = focusedOptionNode.offsetTop;
				var optionBottom = optionTop + focusedOptionNode.offsetHeight;

				if (scrollTop > optionTop || scrollBottom < optionBottom) {
					menuNode.scrollTop = focusedOptionNode.offsetTop;
				}

				// We still set hasScrolledToOption to true even if we didn't
				// actually need to scroll, as we've still confirmed that the
				// option is in view.
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuDOM = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
			if (prevState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(this.state.isOpen);
				var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.toggleTouchOutsideEvent(false);
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			if (enabled) {
				if (!document.addEventListener && document.attachEvent) {
					document.attachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.addEventListener('touchstart', this.handleTouchOutside);
				}
			} else {
				if (!document.removeEventListener && document.detachEvent) {
					document.detachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.removeEventListener('touchstart', this.handleTouchOutside);
				}
			}
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				if (!this.state.isFocused) {
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				} else if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						isPseudoFocused: false
					});
				}

				return;
			}

			// prevent default event handlers
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				var toOpen = true;

				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				if (this._focusAfterClear) {
					toOpen = false;
					this._focusAfterClear = false;
				}

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: toOpen,
					isPseudoFocused: false,
					focusedOption: null
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
				this.setState({ focusedOption: null });
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (this.state.isOpen) {
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			} else {
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				this.setState({
					isOpen: true
				});
			}
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;

			var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.

			if (this.props.onFocus) {
				this.props.onFocus(event);
			}

			this.setState({
				isFocused: true,
				isOpen: !!toOpen
			});

			this._focusAfterClear = false;
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				inputValue: newInputValue,
				isOpen: true,
				isPseudoFocused: false
			});
		}
	}, {
		key: 'setInputValue',
		value: function setInputValue(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			this.setState({
				inputValue: newValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						break;
					}
					event.preventDefault();
					this.selectFocusedOption();
					break;
				case 13:
					// enter
					event.preventDefault();
					event.stopPropagation();
					if (this.state.isOpen) {
						this.selectFocusedOption();
					} else {
						this.focusNextOption();
					}
					break;
				case 27:
					// escape
					event.preventDefault();
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 32:
					// space
					if (this.props.searchable) {
						break;
					}
					event.preventDefault();
					if (!this.state.isOpen) {
						this.focusNextOption();
						break;
					}
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 38:
					// up
					event.preventDefault();
					this.focusPreviousOption();
					break;
				case 40:
					// down
					event.preventDefault();
					this.focusNextOption();
					break;
				case 33:
					// page up
					event.preventDefault();
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					event.preventDefault();
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusStartOption();
					break;
				case 46:
					// delete
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
			}
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param {String|Number|Array} value		- the value of the select input
   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value) {
			var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') {
					value = value.split(props.delimiter);
				}
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this2 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			if (this.props.onChange) {
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this3 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
			if (this.props.multi) {
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					var valueArray = _this3.getValueArray(_this3.props.value);
					if (valueArray.some(function (i) {
						return i[_this3.props.valueKey] === value[_this3.props.valueKey];
					})) {
						_this3.removeValue(value);
					} else {
						_this3.addValue(value);
					}
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var _this4 = this;

			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.preventDefault();

			this.setValue(this.getResetValue());
			this.setState({
				inputValue: this.handleInputValueChange(''),
				isOpen: false
			}, this.focus);

			this._focusAfterClear = true;
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				var newState = {
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
					isOpen: true
				};
				if (this.props.onSelectResetsInput) {
					newState.inputValue = '';
				}
				this.setState(newState);
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var _potentialIndex = focusedIndex + this.props.pageSize;
				if (_potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = _potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
				return showPlaceholder ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						ValueComponent,
						{
							disabled: _this5.props.disabled || value.clearableValue === false,
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							placeholder: _this5.props.placeholder,
							value: value
						},
						renderLabel(value, i),
						__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (shouldShowValue(this.state, this.props)) {
				if (isOpen) onClick = null;
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					ValueComponent,
					{
						disabled: this.props.disabled,
						id: this._instancePrefix + '-value-item',
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						placeholder: this.props.placeholder,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-input', this.props.inputProps.className);
			var isOpen = this.state.isOpen;

			var ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames = {}, defineProperty(_classNames, this._instancePrefix + '-list', isOpen), defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var value = this.state.inputValue;
			if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
				// it hides input value when it is not focused and was not reset on select
				value = '';
			}

			var inputProps = _extends({}, this.props.inputProps, {
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-expanded': '' + isOpen,
				'aria-haspopup': '' + isOpen,
				'aria-label': this.props['aria-label'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-owns': ariaOwns,
				className: className,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				role: 'combobox',
				required: this.state.required,
				tabIndex: this.props.tabIndex,
				value: value
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var divProps = objectWithoutProperties(this.props.inputProps, []);


				var _ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(defineProperty({}, this._instancePrefix + '-list', isOpen));
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', _extends({}, divProps, {
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-disabled': '' + this.props.disabled,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					className: className,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					role: 'combobox',
					style: { border: 0, width: 1, display: 'inline-block' },
					tabIndex: this.props.tabIndex || 0
				}));
			}

			if (this.props.autosize) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default.a, _extends({ id: this.props.id }, inputProps, { minWidth: '5' }));
			}
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', _extends({ id: this.props.id }, inputProps))
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			var valueArray = this.getValueArray(this.props.value);
			if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
			var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
			var clear = this.props.clearRenderer();

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					'aria-label': ariaLabel,
					className: 'Select-clear-zone',
					onMouseDown: this.clearValue,
					onTouchEnd: this.handleTouchEndClearValue,
					onTouchMove: this.handleTouchMove,
					onTouchStart: this.handleTouchStart,
					title: ariaLabel
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			if (!this.props.arrowRenderer) return;

			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			if (!arrow) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions$$1 = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : filterOptions;

				return filterOptions$$1(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					trimFilter: this.props.trimFilter,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					inputValue: this.state.inputValue,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onOptionRef: this.onOptionRef,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					removeValue: this.removeValue,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey
				});
			} else if (this.props.noResultsText) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: this.props.disabled,
					name: this.props.name,
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					type: 'hidden',
					value: value
				});
			}
			return valueArray.map(function (item, index) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: _this7.props.disabled,
					key: 'hidden.' + index,
					name: _this7.props.name,
					ref: 'value' + index,
					type: 'hidden',
					value: stringifyValue(item[_this7.props.valueKey])
				});
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{
						className: 'Select-menu',
						id: this._instancePrefix + '-list',
						onMouseDown: this.handleMouseDownOnMenu,
						onScroll: this.handleMenuScroll,
						ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						},
						role: 'listbox',
						style: this.props.menuStyle,
						tabIndex: -1
					},
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select', this.props.className, {
				'has-value': valueArray.length,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'Select--multi': this.props.multi,
				'Select--rtl': this.props.rtl,
				'Select--single': !this.props.multi
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						style: this.props.style
					},
					__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						'span',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
			);
		}
	}]);
	return Select;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Select$1.propTypes = {
	'aria-describedby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // aria label (for assistive tech)
	'aria-labelledby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id of an element that should be used as the label (for assistive tech)
	arrowRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create the drop-down caret element
	autoBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // automatically blur the component when an option is selected
	autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // autofocus the component on mount
	autofocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // deprecated; use autoFocus instead
	autosize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable autosizing or not
	backspaceRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // should it be possible to reset value
	closeOnSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to close the menu when a value is selected
	deleteRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether delete removes an item if there is no text input
	delimiter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // delimiter to use to join multiple values for the hidden field value
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is disabled or not
	escapeClearsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether escape clears the value when the menu is closed
	filterOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to filter a single option (option, filterString)
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id to set on the input element for accessibility or tests
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to strip diacritics when filtering
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to perform case-insensitive filtering
	inputProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // custom attributes for the Input
	inputRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // returns a custom input component
	instanceId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // set the components instanceId
	isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	matchPos: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|start) match the start or entire string when filtering
	matchProp: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|label|value) which option property to filter on
	menuBuffer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu container
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // renders a custom menu with options
	menuStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onBlur handler: function (event) {}
	onBlurResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on blur
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is closed
	onCloseResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onFocus handler: function (event) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is opened
	onSelectResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // always open options menu on focus
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // option component to render in dropdown
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optionRenderer: function (option) {}
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, // array of options
	pageSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	removeSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the selected option is removed from the dropdown on multi selects
	required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // applies HTML5 required attribute when needed
	resetValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // value to use when you clear the control
	rtl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // set to true in order to use react-select in right-to-left direction
	scrollMenuIntoView: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable searching feature or not
	simpleValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the control
	tabIndex: stringOrNumber, // optional tab index of the control
	tabSelectsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to treat tabbing out while focused to be value selection
	trimFilter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to trim whitespace around filter value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // initial field value
	valueComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // value component to render
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	valueRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // valueRenderer: function (option) {}
	wrapperStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object // optional style to apply to the component wrapper
};

Select$1.defaultProps = {
	arrowRenderer: arrowRenderer,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: clearRenderer,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: filterOptions,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: menuRenderer,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onCloseResetsInput: true,
	onSelectResetsInput: true,
	openOnClick: true,
	optionComponent: Option,
	pageSize: 5,
	placeholder: 'Select...',
	removeSelected: true,
	required: false,
	rtl: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	trimFilter: true,
	valueComponent: Value,
	valueKey: 'value'
};

var propTypes = {
	autoload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // object to use to cache results; set to null/false to disable caching
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// replaces the placeholder while options are loading
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	noResultsText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field noResultsText, displayed when no options come back from the server
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optional for keeping track of what is being typed
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired, // array of options
	placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	searchPromptText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// label to prompt for search input
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any // initial field value
};

var defaultCache = {};

var defaultChildren = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	inherits(Async, _Component);

	function Async(props, context) {
		classCallCheck(this, Async);

		var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this._callback = null;

				this.setState({
					isLoading: false,
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				var options = data && data.options || [];

				if (cache) {
					cache[inputValue] = options;
				}

				if (callback === _this2._callback) {
					_this2._callback = null;

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var newInputValue = inputValue;

			if (onInputChange) {
				var value = onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
					newInputValue = '' + value;
				}
			}

			var transformedInputValue = newInputValue;

			if (ignoreAccents) {
				transformedInputValue = stripDiacritics(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			this.setState({ inputValue: newInputValue });
			this.loadOptions(transformedInputValue);

			// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
			return newInputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    placeholder = _props3.placeholder;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);
	return Async;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

var CreatableSelect = function (_React$Component) {
	inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		classCallCheck(this, CreatableSelect);

		var _this = possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option, options: options });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1() {
			var _props2 = this.props,
			    filterOptions$$1 = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    promptTextCreator = _props2.promptTextCreator;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions$$1.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					filteredOptions.unshift(this._createPlaceholderOption);
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.props.options;

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer$$1(params) {
			var menuRenderer$$1 = this.props.menuRenderer;


			return menuRenderer$$1(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;

			// This value may be needed in between Select mounts (when this.select is null)

			this.inputValue = input;

			if (onInputChange) {
				this.inputValue = onInputChange(input);
			}

			return this.inputValue;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    refProp = _props4.ref,
			    restProps = objectWithoutProperties(_props4, ['ref']);
			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren$2;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
					if (refProp) {
						refProp(_ref2);
					}
				}
			});

			return children(props);
		}
	}]);
	return CreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$2 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var isOptionUnique = function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	if (!options || !options.length) {
		return true;
	}

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

var isValidNewOption = function isValidNewOption(_ref4) {
	var label = _ref4.label;
	return !!label;
};

var newOptionCreator = function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';

	return option;
};

var promptTextCreator = function promptTextCreator(label) {
	return 'Create option "' + label + '"';
};

var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
		default:
			return false;
	}
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: filterOptions,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: menuRenderer,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.filterOptions
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input change handler: function (inputValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// new option click handler: function (option) {}
	onNewOptionClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.options
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	ref: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var AsyncCreatableSelect = function (_React$Component) {
	inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		classCallCheck(this, AsyncCreatableSelect);
		return possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				Async,
				this.props,
				function (_ref) {
					var ref = _ref.ref,
					    asyncProps = objectWithoutProperties(_ref, ['ref']);

					var asyncRef = ref;
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						CreatableSelect,
						asyncProps,
						function (_ref2) {
							var ref = _ref2.ref,
							    creatableProps = objectWithoutProperties(_ref2, ['ref']);

							var creatableRef = ref;
							return _this2.props.children(_extends({}, creatableProps, {
								ref: function ref(select) {
									creatableRef(select);
									asyncRef(select);
									_this2.select = select;
								}
							}));
						}
					);
				}
			);
		}
	}]);
	return AsyncCreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$1 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

AsyncCreatableSelect.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
};

AsyncCreatableSelect.defaultProps = {
	children: defaultChildren$1
};

Select$1.Async = Async;
Select$1.AsyncCreatable = AsyncCreatableSelect;
Select$1.Creatable = CreatableSelect;
Select$1.Value = Value;
Select$1.Option = Option;


/* harmony default export */ __webpack_exports__["b"] = (Select$1);


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(935);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(936)();
}


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(73);
var invariant = __webpack_require__(62);
var ReactPropTypesSecret = __webpack_require__(937);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(940)();
}


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(73);
var invariant = __webpack_require__(62);
var ReactPropTypesSecret = __webpack_require__(941);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(392);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 943 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_avatar_baseAvatar__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_proptypes__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var TeamAvatar = (_temp = _class = function (_React$Component) {
  _inherits(TeamAvatar, _React$Component);

  function TeamAvatar() {
    _classCallCheck(this, TeamAvatar);

    return _possibleConstructorReturn(this, (TeamAvatar.__proto__ || Object.getPrototypeOf(TeamAvatar)).apply(this, arguments));
  }

  _createClass(TeamAvatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          team = _props.team,
          props = _objectWithoutProperties(_props, ['team']);

      if (!team) return null;
      var slug = team && team.slug || '';
      var title = Object(__WEBPACK_IMPORTED_MODULE_1_app_utils__["g" /* explodeSlug */])(slug);
      var tooltip = '#' + title;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_avatar_baseAvatar__["a" /* default */], _extends({}, props, {
        type: team.avatar && team.avatar.avatarType || 'letter_avatar',
        uploadPath: 'team-avatar',
        uploadId: team.avatar && team.avatar.avatarUuid,
        letterId: slug,
        tooltip: tooltip,
        title: title
      }));
    }
  }]);

  return TeamAvatar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = _extends({
  team: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Team.isRequired
}, __WEBPACK_IMPORTED_MODULE_2_app_components_avatar_baseAvatar__["a" /* default */].propTypes), _temp);

/* harmony default export */ __webpack_exports__["a"] = (TeamAvatar);

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_avatar_styles__ = __webpack_require__(319);







/**
 * Also see avatar.py. Anything changed in this file (how colors
 * are selected, the svg, etc) will also need to be changed there.
 */

var LetterAvatar = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'LetterAvatar',

  propTypes: {
    identifier: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    displayName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    round: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
  },

  COLORS: ['#4674ca', // blue
  '#315cac', // blue_dark
  '#57be8c', // green
  '#3fa372', // green_dark
  '#f9a66d', // yellow_orange
  '#ec5e44', // red
  '#e63717', // red_dark
  '#f868bc', // pink
  '#6c5fc7', // purple
  '#4e3fb4', // purple_dark
  '#57b1be', // teal
  '#847a8c'],

  getColor: function getColor() {
    var id = this.hashIdentifier(this.props.identifier);
    return this.COLORS[id % this.COLORS.length];
  },
  hashIdentifier: function hashIdentifier(identifier) {
    identifier += '';
    var hash = 0;
    for (var i = 0; i < identifier.length; i++) {
      hash += identifier.charCodeAt(i);
    }
    return hash;
  },
  getInitials: function getInitials() {
    var names = (this.props.displayName.trim() || '?').split(' ');
    var initials = names[0][0] + (names.length > 1 ? names[names.length - 1][0] : '');
    return initials.toUpperCase();
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      Svg,
      {
        viewBox: '0 0 120 120',
        round: this.props.round,
        className: this.props.className
      },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect', {
        x: '0',
        y: '0',
        width: '120',
        height: '120',
        rx: '15',
        ry: '15',
        fill: this.getColor()
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'text',
        {
          x: '50%',
          y: '50%',
          fontSize: '65',
          style: { dominantBaseline: 'central' },
          textAnchor: 'middle',
          fill: '#FFFFFF'
        },
        this.getInitials()
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (LetterAvatar);

var Svg = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('svg', {
  target: 'e1knxa8x0'
})(__WEBPACK_IMPORTED_MODULE_4_app_components_avatar_styles__["a" /* imageStyle */], ';');

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_stores_configStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(319);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Gravatar = (_temp = _class = function (_React$Component) {
  _inherits(Gravatar, _React$Component);

  function Gravatar(props) {
    _classCallCheck(this, Gravatar);

    var _this = _possibleConstructorReturn(this, (Gravatar.__proto__ || Object.getPrototypeOf(Gravatar)).call(this, props));

    _this.buildGravatarUrl = function () {
      var _this$props = _this.props,
          gravatarId = _this$props.gravatarId,
          remoteSize = _this$props.remoteSize,
          placeholder = _this$props.placeholder;

      var url = __WEBPACK_IMPORTED_MODULE_4_app_stores_configStore__["default"].getConfig().gravatarBaseUrl + '/avatar/';

      url += _this.state.MD5(gravatarId);

      var query = {
        s: remoteSize || undefined,
        d: placeholder
      };

      url += '?' + __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.stringify(query);

      return url;
    };

    _this.state = {
      MD5: null
    };
    return _this;
  }

  _createClass(Gravatar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this._isMounted = true;

      new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 496)).then(function (MD5) {
        if (!_this2._isMounted) return;
        _this2.setState({ MD5: MD5 });
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Need to track mounted state because `React.isMounted()` is deprecated and because of
      // dynamic imports
      this._isMounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.state.MD5) {
        return null;
      }

      var _props = this.props,
          round = _props.round,
          props = _objectWithoutProperties(_props, ['round']);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Image, _extends({ round: round, src: this.buildGravatarUrl() }, props));
    }
  }]);

  return Gravatar;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  remoteSize: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  gravatarId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  placeholder: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  /**
   * Should avatar be round instead of a square
   */
  round: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _class.defaultProps = {}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (Gravatar);

var Image = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('img', {
  target: 'e15dk3vq0'
})(__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* imageStyle */], ';');

/***/ }),
/* 947 */,
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_avatar_baseAvatar__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_proptypes__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var OrganizationAvatar = (_temp = _class = function (_React$Component) {
  _inherits(OrganizationAvatar, _React$Component);

  function OrganizationAvatar() {
    _classCallCheck(this, OrganizationAvatar);

    return _possibleConstructorReturn(this, (OrganizationAvatar.__proto__ || Object.getPrototypeOf(OrganizationAvatar)).apply(this, arguments));
  }

  _createClass(OrganizationAvatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          organization = _props.organization,
          props = _objectWithoutProperties(_props, ['organization']);

      if (!organization) return null;
      var slug = organization && organization.slug || '';
      var title = Object(__WEBPACK_IMPORTED_MODULE_1_app_utils__["g" /* explodeSlug */])(slug);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_avatar_baseAvatar__["a" /* default */], _extends({}, props, {
        type: organization.avatar && organization.avatar.avatarType || 'letter_avatar',
        uploadPath: 'organization-avatar',
        uploadId: organization.avatar && organization.avatar.avatarUuid,
        letterId: slug,
        tooltip: slug,
        title: title
      }));
    }
  }]);

  return OrganizationAvatar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = _extends({
  organization: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Organization.isRequired
}, __WEBPACK_IMPORTED_MODULE_2_app_components_avatar_baseAvatar__["a" /* default */].propTypes), _temp);

/* harmony default export */ __webpack_exports__["a"] = (OrganizationAvatar);

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_avatar_baseAvatar__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_proptypes__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ProjectAvatar = (_temp = _class = function (_React$Component) {
  _inherits(ProjectAvatar, _React$Component);

  function ProjectAvatar() {
    _classCallCheck(this, ProjectAvatar);

    return _possibleConstructorReturn(this, (ProjectAvatar.__proto__ || Object.getPrototypeOf(ProjectAvatar)).apply(this, arguments));
  }

  _createClass(ProjectAvatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          project = _props.project,
          props = _objectWithoutProperties(_props, ['project']);

      if (!project) return null;
      var slug = project && project.slug || '';
      var title = Object(__WEBPACK_IMPORTED_MODULE_1_app_utils__["g" /* explodeSlug */])(slug);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_avatar_baseAvatar__["a" /* default */], _extends({}, props, {
        type: project.avatar && project.avatar.avatarType || 'letter_avatar',
        uploadPath: 'project-avatar',
        uploadId: project.avatar && project.avatar.avatarUuid,
        letterId: slug,
        tooltip: slug,
        title: title
      }));
    }
  }]);

  return ProjectAvatar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = _extends({
  project: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Project.isRequired
}, __WEBPACK_IMPORTED_MODULE_2_app_components_avatar_baseAvatar__["a" /* default */].propTypes), _temp);

/* harmony default export */ __webpack_exports__["a"] = (ProjectAvatar);

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils_formatters__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_avatar_baseAvatar__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_proptypes__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var UserAvatar = (_temp2 = _class = function (_React$Component) {
  _inherits(UserAvatar, _React$Component);

  function UserAvatar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UserAvatar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserAvatar.__proto__ || Object.getPrototypeOf(UserAvatar)).call.apply(_ref, [this].concat(args))), _this), _this.getType = function (user, gravatar) {
      if (user.avatar) {
        return user.avatar.avatarType;
      }
      if (user.options && user.options.avatarType) {
        return user.options.avatarType;
      }

      return user.email && gravatar ? 'gravatar' : 'letter_avatar';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UserAvatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          gravatar = _props.gravatar,
          renderTooltip = _props.renderTooltip,
          props = _objectWithoutProperties(_props, ['user', 'gravatar', 'renderTooltip']);

      if (!user) return null;

      var type = this.getType(user, gravatar);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_avatar_baseAvatar__["a" /* default */], _extends({}, props, {
        type: type,
        uploadPath: 'avatar',
        uploadId: user.avatar && user.avatar.avatarUuid,
        gravatarId: user && user.email && user.email.toLowerCase(),
        letterId: user.email || user.username || user.id || user.ip_address,
        tooltip: typeof renderTooltip === 'function' ? renderTooltip(user) : Object(__WEBPACK_IMPORTED_MODULE_2_app_utils_formatters__["a" /* userDisplayName */])(user),
        title: user.name || user.email || user.username || '',
        round: true
      }));
    }
  }]);

  return UserAvatar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = _extends({
  user: __WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].User,
  gravatar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  renderTooltip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, __WEBPACK_IMPORTED_MODULE_3_app_components_avatar_baseAvatar__["a" /* default */].propTypes), _class.defaultProps = {
  // Default gravatar to false in order to support transparent avatars
  // Avatar falls through to letter avatars if a remote image fails to load,
  // however gravatar sends back a transparent image when it does not find a gravatar,
  // so there's little we have to control whether we need to fallback to letter avatar
  gravatar: false
}, _temp2);

/* harmony default export */ __webpack_exports__["a"] = (UserAvatar);

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_avatar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_styles_overflowEllipsis__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_styles_space__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_proptypes__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }










var UserBadge = function UserBadge(_ref) {
  var displayName = _ref.displayName,
      displayEmail = _ref.displayEmail,
      user = _ref.user,
      member = _ref.member,
      orgId = _ref.orgId,
      avatarSize = _ref.avatarSize,
      useLink = _ref.useLink,
      hideEmail = _ref.hideEmail,
      props = _objectWithoutProperties(_ref, ['displayName', 'displayEmail', 'user', 'member', 'orgId', 'avatarSize', 'useLink', 'hideEmail']);

  var userFromPropsOrMember = user || member && member.user || member;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    StyledUserBadge,
    props,
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledAvatar, { user: userFromPropsOrMember, size: avatarSize }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      StyledNameAndEmail,
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        StyledName,
        {
          useLink: useLink && orgId && member,
          hideEmail: hideEmail,
          to: member && orgId && '/settings/' + orgId + '/members/' + member.id + '/'
        },
        displayName || userFromPropsOrMember.name || userFromPropsOrMember.email
      ),
      !hideEmail && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        StyledEmail,
        null,
        displayEmail || userFromPropsOrMember.email
      )
    )
  );
};

UserBadge.propTypes = {
  displayName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  displayEmail: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  avatarSize: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  /**
   * Sometimes we may not have the member object (i.e. the current user, `ConfigStore.get('user')`,
   * is an user, not a member)
   */
  user: __WEBPACK_IMPORTED_MODULE_7_app_proptypes__["e" /* default */].User,
  /**
   * This is a Sentry member (not the user object that is a child of the member object)
   */
  member: __WEBPACK_IMPORTED_MODULE_7_app_proptypes__["e" /* default */].Member,
  orgId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  useLink: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  hideEmail: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};

UserBadge.defaultProps = {
  useLink: true,
  hideEmail: false
};

var StyledUserBadge = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'ev46mzr0'
})('display:flex;align-items:center;');

var StyledNameAndEmail = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'ev46mzr1'
})('flex-shrink:1;min-width:0;line-height:1;');

var StyledEmail = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'ev46mzr2'
})('font-size:0.875em;margin-top:', Object(__WEBPACK_IMPORTED_MODULE_6_app_styles_space__["a" /* default */])(0.25), ';color:', function (p) {
  return p.theme.gray2;
}, ';', __WEBPACK_IMPORTED_MODULE_5_app_styles_overflowEllipsis__["a" /* default */], ';');

var StyledName = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(function (_ref2) {
  var useLink = _ref2.useLink,
      hideEmail = _ref2.hideEmail,
      to = _ref2.to,
      props = _objectWithoutProperties(_ref2, ['useLink', 'hideEmail', 'to']);

  return useLink ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_link__["a" /* default */], _extends({ to: to }, props)) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', props);
}, {
  target: 'ev46mzr3'
})('font-weight:bold;line-height:1.15em;', __WEBPACK_IMPORTED_MODULE_5_app_styles_overflowEllipsis__["a" /* default */], ';');

var StyledAvatar = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(function (props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_avatar__["a" /* default */], props);
}, {
  target: 'ev46mzr4'
})('min-width:', Object(__WEBPACK_IMPORTED_MODULE_6_app_styles_space__["a" /* default */])(3), ';min-height:', Object(__WEBPACK_IMPORTED_MODULE_6_app_styles_space__["a" /* default */])(3), ';margin-right:', Object(__WEBPACK_IMPORTED_MODULE_6_app_styles_space__["a" /* default */])(1), ';');

/* harmony default export */ __webpack_exports__["a"] = (UserBadge);

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_idBadge_baseBadge__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_idBadge_badgeDisplayName__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_stores_teamStore__ = __webpack_require__(150);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var TeamBadge = (_temp = _class = function (_React$Component) {
  _inherits(TeamBadge, _React$Component);

  function TeamBadge() {
    _classCallCheck(this, TeamBadge);

    return _possibleConstructorReturn(this, (TeamBadge.__proto__ || Object.getPrototypeOf(TeamBadge)).apply(this, arguments));
  }

  _createClass(TeamBadge, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          hideOverflow = _props.hideOverflow,
          team = _props.team,
          props = _objectWithoutProperties(_props, ['hideOverflow', 'team']);

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_idBadge_baseBadge__["a" /* default */], _extends({
        displayName: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_app_components_idBadge_badgeDisplayName__["a" /* default */],
          { hideOverflow: hideOverflow },
          '#',
          team.slug
        ),
        team: team
      }, props));
    }
  }]);

  return TeamBadge;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_5_app_components_idBadge_baseBadge__["a" /* default */].propTypes, {
  team: __WEBPACK_IMPORTED_MODULE_7_app_proptypes__["e" /* default */].Team.isRequired,
  avatarSize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  /**
   * If true, will use default max-width, or specify one as a string
   */
  hideOverflow: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]),
  hideAvatar: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
}), _class.defaultProps = {
  avatarSize: 24,
  hideOverflow: true,
  hideAvatar: false
}, _temp);


var TeamBadgeContainer = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'TeamBadgeContainer',
  propTypes: {
    team: __WEBPACK_IMPORTED_MODULE_7_app_proptypes__["e" /* default */].Team.isRequired
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_8_app_stores_teamStore__["a" /* default */], 'onTeamStoreUpdate')],
  getInitialState: function getInitialState() {
    return {
      team: this.props.team
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this.state.team === nextProps.team) return;
    if (__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(this.state.team, nextProps.team)) return;

    this.setState({
      team: nextProps.team
    });
  },
  onTeamStoreUpdate: function onTeamStoreUpdate(updatedTeam) {
    if (!updatedTeam.has(this.state.team.id)) return;

    var team = __WEBPACK_IMPORTED_MODULE_8_app_stores_teamStore__["a" /* default */].getById(this.state.team.id);
    if (__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(team.avatar, this.state.team.avatar)) return;

    this.setState({
      team: __WEBPACK_IMPORTED_MODULE_8_app_stores_teamStore__["a" /* default */].getById(this.state.team.id)
    });
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TeamBadge, _extends({}, this.props, { team: this.state.team }));
  }
});
/* harmony default export */ __webpack_exports__["a"] = (TeamBadgeContainer);

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProjectBadge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_idBadge_baseBadge__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_idBadge_badgeDisplayName__ = __webpack_require__(321);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ProjectBadge = (_temp = _class = function (_React$Component) {
  _inherits(ProjectBadge, _React$Component);

  function ProjectBadge() {
    _classCallCheck(this, ProjectBadge);

    return _possibleConstructorReturn(this, (ProjectBadge.__proto__ || Object.getPrototypeOf(ProjectBadge)).apply(this, arguments));
  }

  _createClass(ProjectBadge, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          hideOverflow = _props.hideOverflow,
          project = _props.project,
          props = _objectWithoutProperties(_props, ['hideOverflow', 'project']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_idBadge_baseBadge__["a" /* default */], _extends({
        displayName: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_app_components_idBadge_badgeDisplayName__["a" /* default */],
          { hideOverflow: hideOverflow },
          project.slug
        ),
        project: project
      }, props));
    }
  }]);

  return ProjectBadge;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_2_app_components_idBadge_baseBadge__["a" /* default */].propTypes, {
  project: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Project.isRequired,
  avatarSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  /**
   * If true, will use default max-width, or specify one as a string
   */
  hideOverflow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  hideAvatar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}), _class.defaultProps = {
  hideAvatar: true,
  hideOverflow: true
}, _temp);


/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_idBadge_baseBadge__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_idBadge_badgeDisplayName__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_stores_organizationsStore__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_proptypes__ = __webpack_require__(6);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var OrganizationBadge = (_temp = _class = function (_React$Component) {
  _inherits(OrganizationBadge, _React$Component);

  function OrganizationBadge() {
    _classCallCheck(this, OrganizationBadge);

    return _possibleConstructorReturn(this, (OrganizationBadge.__proto__ || Object.getPrototypeOf(OrganizationBadge)).apply(this, arguments));
  }

  _createClass(OrganizationBadge, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          hideOverflow = _props.hideOverflow,
          organization = _props.organization,
          props = _objectWithoutProperties(_props, ['hideOverflow', 'organization']);

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_idBadge_baseBadge__["a" /* default */], _extends({
        displayName: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_app_components_idBadge_badgeDisplayName__["a" /* default */],
          { hideOverflow: hideOverflow },
          organization.slug
        ),
        organization: organization
      }, props));
    }
  }]);

  return OrganizationBadge;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component), _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_5_app_components_idBadge_baseBadge__["a" /* default */].propTypes, {
  organization: __WEBPACK_IMPORTED_MODULE_8_app_proptypes__["e" /* default */].Organization.isRequired,
  avatarSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  /**
   * If true, will use default max-width, or specify one as a string
   */
  hideOverflow: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  hideAvatar: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
}), _class.defaultProps = {
  avatarSize: 24,
  hideAvatar: false,
  hideOverflow: true
}, _temp);


var OrganizationBadgeContainer = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'OrganizationBadgeContainer',
  propTypes: {
    organization: __WEBPACK_IMPORTED_MODULE_8_app_proptypes__["e" /* default */].Organization.isRequired
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_7_app_stores_organizationsStore__["a" /* default */], 'onOrganizationStoreUpdate')],
  getInitialState: function getInitialState() {
    return {
      organization: this.props.organization
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this.state.organization === nextProps.organization) return;
    if (__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(this.state.organization, nextProps.organization)) return;

    this.setState({
      organization: nextProps.organization
    });
  },
  onOrganizationStoreUpdate: function onOrganizationStoreUpdate() {
    var org = __WEBPACK_IMPORTED_MODULE_7_app_stores_organizationsStore__["a" /* default */].get(this.state.organization.slug);
    if (__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(org.avatar, this.state.organization.avatar)) return;

    this.setState({
      organization: __WEBPACK_IMPORTED_MODULE_7_app_stores_organizationsStore__["a" /* default */].get(this.state.organization.slug)
    });
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(OrganizationBadge, _extends({}, this.props, { organization: this.state.organization }));
  }
});
/* harmony default export */ __webpack_exports__["a"] = (OrganizationBadgeContainer);

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ContextPickerModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_actionCreators_organizations__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_stores_latestContextStore__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_stores_organizationsStore__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_forms_select2Field__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_utils_replaceRouterParams__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_utils_withProjects__ = __webpack_require__(271);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var ContextPickerModal = (_temp = _class = function (_React$Component) {
  _inherits(ContextPickerModal, _React$Component);

  function ContextPickerModal(props) {
    _classCallCheck(this, ContextPickerModal);

    var _this = _possibleConstructorReturn(this, (ContextPickerModal.__proto__ || Object.getPrototypeOf(ContextPickerModal)).call(this, props));

    _this.navigateIfFinish = function (organizations, projects) {
      var latestOrg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.props.latestContext && _this.props.latestContext.organization;
      var _this$props = _this.props,
          needProject = _this$props.needProject,
          onFinish = _this$props.onFinish,
          nextPath = _this$props.nextPath;

      // If no project is needed and theres only 1 org OR
      // if we need a project and there's only 1 project
      // then return because we can't navigate anywhere yet

      if (!needProject && organizations.length !== 1 || needProject && projects.length !== 1) {
        _this.setState({ loading: false });
        return;
      }

      // If there is only one org and we dont need a project slug, then call finish callback
      if (!needProject) {
        onFinish(Object(__WEBPACK_IMPORTED_MODULE_12_app_utils_replaceRouterParams__["a" /* default */])(nextPath, {
          orgId: organizations[0].slug
        }));
        return;
      }

      // Use latest org or if only 1 org, use that
      var org = latestOrg;
      if (!org && organizations.length === 1) {
        org = organizations[0];
      }

      onFinish(Object(__WEBPACK_IMPORTED_MODULE_12_app_utils_replaceRouterParams__["a" /* default */])(nextPath, {
        orgId: org.slug,
        projectId: projects[0].slug
      }));
    };

    _this.handleSelectOrganization = function (value) {
      // If we do not need to select a project, we can early return after selecting an org
      // No need to fetch org details
      if (!_this.props.needProject) {
        _this.navigateIfFinish([{ slug: value }], []);
        return;
      }

      _this.setState({
        loading: true
      }, function () {
        return Object(__WEBPACK_IMPORTED_MODULE_5_app_actionCreators_organizations__["b" /* fetchOrganizationDetails */])(value, { setActive: true, loadProjects: true });
      });
    };

    _this.handleSelectProject = function (projectId) {
      var latestContext = _this.props.latestContext;


      if (!projectId || !latestContext.organization) return;

      _this.navigateIfFinish([latestContext.organization], [{ slug: projectId }]);
    };

    _this.state = {
      // Initialize loading to true if there is only 1 organization because component will immediately
      // attempt to fetch org details for that org. Otherwise we'd have to change state in `DidMount`
      loading: props.organizations.length === 1
    };
    return _this;
  }

  _createClass(ContextPickerModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          latestContext = _props.latestContext,
          organizations = _props.organizations;

      // Don't make any assumptions if there are multiple organizations

      if (organizations.length !== 1) {
        return;
      }

      // If there is an org in context (and there's only 1 org available),
      // attempt to see if we need more info from user and redirect otherwise
      if (latestContext.organization) {
        // This will handle if we can intelligently move the user forward
        this.navigateIfFinish([latestContext.organization], latestContext.organization.projects);
        return;
      }

      // Since user belongs to only 1 org, we can set it as active and componentWillReceiveProps handle the rest
      Object(__WEBPACK_IMPORTED_MODULE_5_app_actionCreators_organizations__["b" /* fetchOrganizationDetails */])(organizations[0].slug, {
        setActive: true,
        loadProjects: true
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Should only check the case where there is no latestContext.organization and we're waiting
      // for it to be set (after fetch in DidMount)
      var latestContext = this.props.latestContext;

      if (!latestContext.organization && latestContext.organization !== nextProps.latestContext.organization || latestContext.organization && nextProps.latestContext.organization && latestContext.organization.slug !== nextProps.latestContext.organization.slug) {
        // Check if we can push the user forward w/o needing them to select anything
        this.navigateIfFinish(this.props.organizations, nextProps.latestContext.organization.projects, nextProps.latestContext.organization);
      }
    }

    // Performs checks to see if we need to prompt user
    // i.e. When there is only 1 org and no project is needed or
    // there is only 1 org and only 1 project (which should be rare)

  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          latestContext = _props2.latestContext,
          needOrg = _props2.needOrg,
          needProject = _props2.needProject,
          organizations = _props2.organizations,
          Header = _props2.Header,
          Body = _props2.Body;
      var loading = this.state.loading;


      var shouldShowPicker = needOrg || needProject;

      var projects = latestContext.organization && latestContext.organization.projects;

      if (!shouldShowPicker) return null;

      // Org select should be empty except if we need a project and there's an org in context
      // (otherwise they need to select an org before we can fetch projects)
      var shouldHaveEmptyOrgSelector = !needProject || !latestContext.organization;

      // We're inserting a blank el for `select2` so that we can have the placeholder :(
      var orgChoices = organizations.filter(function (_ref) {
        var status = _ref.status;
        return status.id !== 'pending_deletion';
      }).map(function (_ref2) {
        var slug = _ref2.slug;
        return [slug, slug];
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        null,
        loading && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_loadingIndicator__["default"], null),
        !loading && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            Header,
            { closeButton: true },
            Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Select...')
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            Body,
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              {
                className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])({ marginBottom: 12 })
              },
              Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Select an organization/project to continue')
            ),
            needOrg && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_forms_select2Field__["default"], {
              placeholder: 'Select an Organization',
              name: 'organization',
              choices: [['', '']].concat(_toConsumableArray(orgChoices)),
              value: shouldHaveEmptyOrgSelector ? '' : latestContext.organization.slug,
              onChange: this.handleSelectOrganization
            }),
            latestContext.organization && needProject && projects && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_forms_select2Field__["default"], {
              placeholder: 'Select a Project',
              name: 'project',
              allowEmpty: true,
              value: '',
              choices: [['', '']].concat(_toConsumableArray(projects.map(function (_ref3) {
                var slug = _ref3.slug;
                return [slug, slug];
              }))),
              onChange: this.handleSelectProject
            })
          )
        )
      );
    }
  }]);

  return ContextPickerModal;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  /**
   * The destination route
   */
  nextPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,

  /**
   * Finish callback
   */
  onFinish: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * Container for modal header
   */
  Header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Container for modal body
   */
  Body: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * List of available organizations
   */
  organizations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_11_app_proptypes__["e" /* default */].Organization),

  /**
   * LatestContext store
   */
  latestContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    organization: __WEBPACK_IMPORTED_MODULE_11_app_proptypes__["e" /* default */].Organization
  }),

  /**
   * Does modal need to prompt for organization.
   * TODO(billy): This can be derived from `nextPath`
   */
  needOrg: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Does modal need to prompt for project
   */
  needProject: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _temp);


var ContextPickerModalContainer = Object(__WEBPACK_IMPORTED_MODULE_13_app_utils_withProjects__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4_create_react_class___default()({
  displayName: 'ContextPickerModalContainer',
  mixins: [__WEBPACK_IMPORTED_MODULE_3_reflux___default.a.connect(__WEBPACK_IMPORTED_MODULE_7_app_stores_latestContextStore__["a" /* default */], 'latestContext'), __WEBPACK_IMPORTED_MODULE_3_reflux___default.a.connect(__WEBPACK_IMPORTED_MODULE_9_app_stores_organizationsStore__["a" /* default */], 'organizations')],
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ContextPickerModal, _extends({}, this.props, {
      latestContext: this.state.latestContext,
      organizations: this.state.organizations
    }));
  }
}));

/* harmony default export */ __webpack_exports__["a"] = (ContextPickerModalContainer);


/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raven_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_externalLink__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_utils_getRouteStringFromRoutes__ = __webpack_require__(498);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var ERROR_NAME = 'Permission Denied';

var PermissionDenied = (_temp = _class = function (_React$Component) {
  _inherits(PermissionDenied, _React$Component);

  function PermissionDenied() {
    _classCallCheck(this, PermissionDenied);

    return _possibleConstructorReturn(this, (PermissionDenied.__proto__ || Object.getPrototypeOf(PermissionDenied)).apply(this, arguments));
  }

  _createClass(PermissionDenied, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var routes = this.props.routes;
      var _context = this.context,
          organization = _context.organization,
          project = _context.project;


      var route = Object(__WEBPACK_IMPORTED_MODULE_8_app_utils_getRouteStringFromRoutes__["a" /* default */])(routes);
      __WEBPACK_IMPORTED_MODULE_3_raven_js___default.a.captureException(new Error(ERROR_NAME), {
        fingerprint: [ERROR_NAME, route],
        extra: {
          route: route,
          orgFeatures: organization && organization.features || [],
          orgAccess: organization && organization.access || [],
          projectFeatures: project && project.features || []
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,
        { title: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Permission Denied') },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_loadingError__["default"], {
          message: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["tct"])('Your role does not have the necessary permissions to access this resource, please read more about [link:organizational roles]', {
            link: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_externalLink__["a" /* default */], { href: 'https://docs.sentry.io/learn/membership/' })
          })
        })
      );
    }
  }]);

  return PermissionDenied;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component), _class.propTypes = {
  routes: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array
}, _class.contextTypes = {
  organization: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  project: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["withRouter"])(PermissionDenied));

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_dropdownLink__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_menuItem__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_narrowLayout__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var AccountLayout = function (_React$Component) {
  _inherits(AccountLayout, _React$Component);

  function AccountLayout() {
    _classCallCheck(this, AccountLayout);

    return _possibleConstructorReturn(this, (AccountLayout.__proto__ || Object.getPrototypeOf(AccountLayout)).apply(this, arguments));
  }

  _createClass(AccountLayout, [{
    key: 'render',
    value: function render() {
      var header = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'pull-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: '/account/logout/' },
            Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Sign out')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { href: '/' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'icon-sentry-logo' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'back-to' },
            Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Back to organization')
          )
        )
      );

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_app_components_narrowLayout__["default"],
        { header: header },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('My Settings')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_app_components_dropdownLink__["default"],
          { anchorRight: true, title: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('More') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_app_components_menuItem__["default"],
            { to: '/account/authorizations/' },
            Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Authorized Applications')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_app_components_menuItem__["default"],
            { href: '/account/settings/identities/' },
            Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Identities')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_app_components_menuItem__["default"],
            { href: '/account/remove/' },
            Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Close Account')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: 'nav nav-tabs border-bottom' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: '/account/settings/' },
              Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Account')
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: '/account/settings/avatar/' },
              Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Avatar')
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: '/account/settings/appearance/' },
              Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Appearance')
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: '/account/settings/notifications/' },
              Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Notifications')
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: '/account/settings/emails/' },
              Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Emails')
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: '/account/settings/security/' },
              Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Security')
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: '/account/settings/subscriptions/' },
              Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Subscriptions')
            )
          )
        ),
        this.props.children
      );
    }
  }]);

  return AccountLayout;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (AccountLayout);

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_document_title__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_autoSelectText__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_stores_configStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_forms__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_stores_indicatorStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_locale__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















var ApiApplicationDetails = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'ApiApplicationDetails',

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    return {
      loading: true,
      error: false,
      app: null,
      formData: null,
      errors: {}
    };
  },
  componentWillMount: function componentWillMount() {
    this.fetchData();
  },
  remountComponent: function remountComponent() {
    this.setState(this.getInitialState(), this.fetchData);
  },
  getFormData: function getFormData(app) {
    return {
      name: app.name,
      homepageUrl: app.homepageUrl,
      privacyUrl: app.privacyUrl,
      termsUrl: app.termsUrl,
      allowedOrigins: app.allowedOrigins.join('\n'),
      redirectUris: app.redirectUris.join('\n')
    };
  },
  fetchData: function fetchData() {
    var _this = this;

    this.setState({
      loading: true
    });

    this.api.request('/api-applications/' + this.props.params.appId + '/', {
      success: function success(data, _, jqXHR) {
        _this.setState({
          loading: false,
          error: false,
          app: data,
          formData: _extends({}, _this.getFormData(data)),
          errors: {}
        });
      },
      error: function error() {
        _this.setState({
          loading: false,
          error: true
        });
      }
    });
  },
  onFieldChange: function onFieldChange(name, value) {
    var formData = this.state.formData;
    formData[name] = value;
    this.setState({
      formData: formData
    });
  },
  onSubmit: function onSubmit(e) {
    var _this2 = this;

    e.preventDefault();

    if (this.state.state == __WEBPACK_IMPORTED_MODULE_7_app_components_forms__["FormState"].SAVING) {
      return;
    }
    this.setState({
      state: __WEBPACK_IMPORTED_MODULE_7_app_components_forms__["FormState"].SAVING
    }, function () {
      var loadingIndicator = __WEBPACK_IMPORTED_MODULE_8_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Saving changes..'));
      var formData = _this2.state.formData;
      _this2.api.request('/api-applications/' + _this2.props.params.appId + '/', {
        method: 'PUT',
        data: _extends({}, formData, {
          allowedOrigins: formData.allowedOrigins.split('\n').filter(function (v) {
            return v;
          }),
          redirectUris: formData.redirectUris.split('\n').filter(function (v) {
            return v;
          })
        }),
        success: function success(data) {
          __WEBPACK_IMPORTED_MODULE_8_app_stores_indicatorStore__["default"].remove(loadingIndicator);
          _this2.setState({
            state: __WEBPACK_IMPORTED_MODULE_7_app_components_forms__["FormState"].READY,
            formData: _extends({}, _this2.getFormData(data)),
            errors: {}
          });
          _this2.context.router.push('/api/applications/');
        },
        error: function error(_error) {
          __WEBPACK_IMPORTED_MODULE_8_app_stores_indicatorStore__["default"].remove(loadingIndicator);
          _this2.setState({
            state: __WEBPACK_IMPORTED_MODULE_7_app_components_forms__["FormState"].ERROR,
            errors: _error.responseJSON
          });
        }
      });
    });
  },
  onRemoveApplication: function onRemoveApplication(app) {},
  getTitle: function getTitle() {
    return 'Application Details';
  },
  render: function render() {
    if (this.state.loading) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_loadingIndicator__["default"], null);else if (this.state.error) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_loadingError__["default"], { onRetry: this.fetchData });

    var app = this.state.app;
    var isSaving = this.state.state === __WEBPACK_IMPORTED_MODULE_7_app_components_forms__["FormState"].SAVING;
    var errors = this.state.errors;

    var urlPrefix = __WEBPACK_IMPORTED_MODULE_6_app_stores_configStore__["default"].get('urlPrefix');

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_document_title___default.a,
      { title: this.getTitle() },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'form',
          { onSubmit: this.onSubmit, className: 'form-stacked' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h4',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Application Details')
          ),
          this.state.state === __WEBPACK_IMPORTED_MODULE_7_app_components_forms__["FormState"].ERROR && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'alert alert-error alert-block' },
            Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Unable to save your changes. Please ensure all fields are valid and try again.')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'fieldset',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_forms__["TextField"], {
              key: 'name',
              name: 'name',
              label: Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Name'),
              placeholder: Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('e.g. My Application'),
              value: this.state.formData.name,
              required: true,
              error: errors.name,
              onChange: this.onFieldChange.bind(this, 'name')
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_forms__["TextField"], {
              key: 'homepageUrl',
              name: 'homepageUrl',
              label: Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Homepage'),
              placeholder: Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('e.g. http://example.com'),
              value: this.state.formData.homepageUrl,
              help: Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])("An optional link to your website's homepage"),
              required: false,
              error: errors.homepageUrl,
              onChange: this.onFieldChange.bind(this, 'homepageUrl')
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_forms__["TextField"], {
              key: 'privacyUrl',
              name: 'privacyUrl',
              label: Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Privacy Policy'),
              placeholder: Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('e.g. http://example.com/privacy'),
              value: this.state.formData.privacyUrl,
              help: Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('An optional link to your Privacy Policy'),
              required: false,
              error: errors.privacyUrl,
              onChange: this.onFieldChange.bind(this, 'privacyUrl')
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_forms__["TextField"], {
              key: 'termsUrl',
              name: 'termsUrl',
              label: Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Terms of Service'),
              placeholder: Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('e.g. http://example.com/terms'),
              value: this.state.formData.termsUrl,
              help: Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('An optional link to your Terms of Service'),
              required: false,
              error: errors.termsUrl,
              onChange: this.onFieldChange.bind(this, 'termsUrl')
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'fieldset',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'legend',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Credentials')
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'control-group' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'label',
                { htmlFor: 'api-key' },
                'Client ID'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'form-control disabled' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_app_components_autoSelectText__["a" /* default */],
                  null,
                  app.clientID
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'control-group' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'label',
                { htmlFor: 'api-key' },
                'Client Secret'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'form-control disabled' },
                app.clientSecret ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_app_components_autoSelectText__["a" /* default */],
                  null,
                  app.clientSecret
                ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'em',
                  null,
                  'hidden'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { className: 'help-block' },
                Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Your secret is only available briefly after application creation. Make\n                  sure to save this value!')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'control-group' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'label',
                { htmlFor: 'api-key' },
                Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Authorization URL')
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'form-control disabled' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_app_components_autoSelectText__["a" /* default */],
                  null,
                  urlPrefix + '/oauth/authorize/'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'control-group' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'label',
                { htmlFor: 'api-key' },
                Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Token URL')
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'form-control disabled' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_app_components_autoSelectText__["a" /* default */],
                  null,
                  urlPrefix + '/oauth/token/'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'fieldset',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'legend',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Security')
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_forms__["TextareaField"], {
              key: 'redirectUris',
              name: 'redirectUris',
              label: Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Authorized Redirect URIs'),
              value: this.state.formData.redirectUris,
              required: false,
              help: Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Separate multiple entries with a newline.'),
              placeholder: Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('e.g. https://example.com/oauth/complete'),
              error: errors.redirectUris,
              onChange: this.onFieldChange.bind(this, 'redirectUris')
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_forms__["TextareaField"], {
              key: 'allowedOrigins',
              name: 'allowedOrigins',
              label: Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Authorized JavaScript Origins'),
              value: this.state.formData.allowedOrigins,
              required: false,
              help: Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Separate multiple entries with a newline.'),
              placeholder: Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('e.g. example.com'),
              error: errors.allowedOrigins,
              onChange: this.onFieldChange.bind(this, 'allowedOrigins')
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'fieldset',
            { className: 'form-actions' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'button',
              { type: 'submit', className: 'btn btn-primary', disabled: isSaving },
              Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Save Changes')
            )
          )
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ApiApplicationDetails);

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GenericField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_forms_booleanField__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_forms_emailField__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_forms_numberField__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_forms_passwordField__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_forms_rangeField__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_forms_select2FieldAutocomplete__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_forms_select2Field__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_forms_select2TextField__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_forms_textField__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_forms_textareaField__ = __webpack_require__(275);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var GenericField = (_temp = _class = function (_React$Component) {
  _inherits(GenericField, _React$Component);

  function GenericField() {
    _classCallCheck(this, GenericField);

    return _possibleConstructorReturn(this, (GenericField.__proto__ || Object.getPrototypeOf(GenericField)).apply(this, arguments));
  }

  _createClass(GenericField, [{
    key: 'render',
    value: function render() {
      var config = this.props.config;
      var required = Object(__WEBPACK_IMPORTED_MODULE_2_app_utils__["d" /* defined */])(config.required) ? config.required : true;
      var props = _extends({}, config, {
        value: this.props.formData[config.name],
        onChange: this.props.onChange,
        label: config.label + (required ? '*' : ''),
        placeholder: config.placeholder,
        required: required,
        name: config.name,
        error: (this.props.formErrors || {})[config.name],
        disabled: config.readonly,
        key: config.name,
        formState: this.props.formState,
        help: Object(__WEBPACK_IMPORTED_MODULE_2_app_utils__["d" /* defined */])(config.help) && config.help !== '' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: config.help } }) : null
      });

      switch (config.type) {
        case 'secret':
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_forms_passwordField__["a" /* default */], props);
        case 'range':
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_forms_rangeField__["default"], props);
        case 'bool':
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_forms_booleanField__["default"], props);
        case 'email':
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_forms_emailField__["default"], props);
        case 'string':
        case 'text':
        case 'url':
          if (props.choices) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_forms_select2TextField__["a" /* default */], props);
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_forms_textField__["default"], props);
        case 'number':
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_forms_numberField__["a" /* default */], props);
        case 'textarea':
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_forms_textareaField__["default"], props);
        case 'choice':
        case 'select':
          // the chrome required tip winds up in weird places
          // for select2 elements, so just make it look like
          // it's required (with *) and rely on server validation
          delete props.required;
          if (props.has_autocomplete) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_forms_select2FieldAutocomplete__["a" /* default */], props);
          }
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_forms_select2Field__["default"], props);
        default:
          return null;
      }
    }
  }]);

  return GenericField;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  config: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  formData: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  formErrors: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  formState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
}, _class.defaultProps = {
  formData: {},
  formErrors: {}
}, _temp);


/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MultiSelectField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_forms_formField__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_forms_multiSelectControl__ = __webpack_require__(617);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var MultiSelectField = (_temp2 = _class = function (_FormField) {
  _inherits(MultiSelectField, _FormField);

  function MultiSelectField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MultiSelectField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MultiSelectField.__proto__ || Object.getPrototypeOf(MultiSelectField)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function () {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var value = opts.map(function (opt) {
        return opt.value;
      });
      _this.setValue(value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MultiSelectField, [{
    key: 'getValue',


    // Overriding this for now so that we can set default value to `[]`
    value: function getValue(props, context) {
      var form = (context || this.context || {}).form;
      props = props || this.props;
      if (Object(__WEBPACK_IMPORTED_MODULE_2_app_utils__["d" /* defined */])(props.value)) {
        return props.value;
      }
      if (form && form.data.hasOwnProperty(props.name)) {
        return Object(__WEBPACK_IMPORTED_MODULE_2_app_utils__["d" /* defined */])(form.data[props.name]) ? form.data[props.name] : [];
      }
      return Object(__WEBPACK_IMPORTED_MODULE_2_app_utils__["d" /* defined */])(props.defaultValue) ? props.defaultValue : [];
    }
  }, {
    key: 'getClassName',
    value: function getClassName() {
      return '';
    }
  }, {
    key: 'getField',
    value: function getField() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_forms_multiSelectControl__["a" /* default */], _extends({
        id: this.getId(),
        value: this.state.value
      }, this.props, {
        onChange: this.onChange
      }));
    }
  }]);

  return MultiSelectField;
}(__WEBPACK_IMPORTED_MODULE_3_app_components_forms_formField__["a" /* default */]), _class.propTypes = {
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
}, _temp2);


/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_document_title__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_stores_indicatorStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_locale__ = __webpack_require__(2);












var ApiApplicationRow = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'ApiApplicationRow',

  propTypes: {
    app: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
    onRemove: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    return {
      loading: false
    };
  },
  onRemove: function onRemove() {
    var _this = this;

    if (this.state.loading) return;

    var app = this.props.app;

    this.setState({
      loading: true
    }, function () {
      var loadingIndicator = __WEBPACK_IMPORTED_MODULE_6_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Saving changes..'));
      _this.api.request('/api-applications/' + app.id + '/', {
        method: 'DELETE',
        success: function success(data) {
          __WEBPACK_IMPORTED_MODULE_6_app_stores_indicatorStore__["default"].remove(loadingIndicator);
          _this.props.onRemove();
        },
        error: function error() {
          __WEBPACK_IMPORTED_MODULE_6_app_stores_indicatorStore__["default"].remove(loadingIndicator);
          __WEBPACK_IMPORTED_MODULE_6_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Unable to remove application. Please try again.'), 'error', {
            duration: 3000
          });
        }
      });
    });
  },
  render: function render() {
    var app = this.props.app;

    var btnClassName = 'btn btn-default';
    if (this.state.loading) btnClassName += ' disabled';

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'tr',
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'td',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h4',
          { style: { marginBottom: 5 } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_router__["Link"],
            { to: '/api/applications/' + app.id + '/' },
            app.name
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'small',
          { style: { color: '#999' } },
          app.clientID
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'td',
        { style: { width: 32 } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          {
            onClick: this.onRemove.bind(this, app),
            className: btnClassName,
            disabled: this.state.loading
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon icon-trash' })
        )
      )
    );
  }
});

var ApiApplications = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'ApiApplications',

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    return {
      loading: true,
      error: false,
      appList: []
    };
  },
  componentWillMount: function componentWillMount() {
    this.fetchData();
  },
  remountComponent: function remountComponent() {
    this.setState(this.getInitialState(), this.fetchData);
  },
  fetchData: function fetchData() {
    var _this2 = this;

    this.setState({
      loading: true
    });

    this.api.request('/api-applications/', {
      success: function success(data, _, jqXHR) {
        _this2.setState({
          loading: false,
          error: false,
          appList: data
        });
      },
      error: function error() {
        _this2.setState({
          loading: false,
          error: true
        });
      }
    });
  },
  createApplication: function createApplication() {
    var _this3 = this;

    var loadingIndicator = __WEBPACK_IMPORTED_MODULE_6_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Saving changes..'));
    this.api.request('/api-applications/', {
      method: 'POST',
      success: function success(app) {
        __WEBPACK_IMPORTED_MODULE_6_app_stores_indicatorStore__["default"].remove(loadingIndicator);
        _this3.context.router.push('/api/applications/' + app.id + '/');
      },
      error: function error(_error) {
        __WEBPACK_IMPORTED_MODULE_6_app_stores_indicatorStore__["default"].remove(loadingIndicator);
        __WEBPACK_IMPORTED_MODULE_6_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Unable to remove application. Please try again.'), 'error');
      }
    });
  },
  onRemoveApplication: function onRemoveApplication(app) {
    this.setState({
      appList: this.state.appList.filter(function (a) {
        return a.id !== app.id;
      })
    });
  },
  renderResults: function renderResults() {
    var _this4 = this;

    if (this.state.appList.length === 0) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'tr',
        { colSpan: '2' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'td',
          { className: 'blankslate well' },
          Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])("You haven't created any applications yet.")
        )
      );
    }

    return this.state.appList.map(function (app) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ApiApplicationRow, {
        key: app.id,
        app: app,
        onRemove: _this4.onRemoveApplication.bind(_this4, app)
      });
    });
  },
  getTitle: function getTitle() {
    return 'API Applications';
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_document_title___default.a,
      { title: this.getTitle() },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'table',
          { className: 'table' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'tbody',
            null,
            this.state.loading ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'tr',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'td',
                { colSpan: '2' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_loadingIndicator__["default"], null)
              )
            ) : this.state.error ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'tr',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'td',
                { colSpan: '2' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_loadingError__["default"], { onRetry: this.fetchData })
              )
            ) : this.renderResults()
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'form-actions', style: { textAlign: 'right' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            {
              className: 'btn btn-primary ref-create-application',
              onClick: this.createApplication
            },
            Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Create New Application')
          )
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ApiApplications);

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_listLink__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_narrowLayout__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ApiDashboard = function (_React$Component) {
  _inherits(ApiDashboard, _React$Component);

  function ApiDashboard() {
    _classCallCheck(this, ApiDashboard);

    return _possibleConstructorReturn(this, (ApiDashboard.__proto__ || Object.getPrototypeOf(ApiDashboard)).apply(this, arguments));
  }

  _createClass(ApiDashboard, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_app_components_narrowLayout__["default"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Sentry Web API')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: 'nav nav-tabs border-bottom' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_app_components_listLink__["default"],
            { to: '/api/', index: true },
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Auth Tokens')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_app_components_listLink__["default"],
            { to: '/api/applications/' },
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Applications')
          )
        ),
        this.props.children
      );
    }
  }]);

  return ApiDashboard;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ApiDashboard);

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(171),
    last = __webpack_require__(964),
    parent = __webpack_require__(965),
    toKey = __webpack_require__(223);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 964 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 965 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(967);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 967 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(619);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 969 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApiNewToken; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_views_asyncView__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_constants__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_narrowLayout__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_forms__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SORTED_DEFAULT_API_SCOPES = __WEBPACK_IMPORTED_MODULE_3_app_constants__["e" /* DEFAULT_API_SCOPES */].sort();
var API_CHOICES = __WEBPACK_IMPORTED_MODULE_3_app_constants__["b" /* API_SCOPES */].map(function (s) {
  return [s, s];
});

var ApiNewToken = function (_AsyncView) {
  _inherits(ApiNewToken, _AsyncView);

  function ApiNewToken() {
    _classCallCheck(this, ApiNewToken);

    return _possibleConstructorReturn(this, (ApiNewToken.__proto__ || Object.getPrototypeOf(ApiNewToken)).apply(this, arguments));
  }

  _createClass(ApiNewToken, [{
    key: 'getEndpoints',
    value: function getEndpoints() {
      return [];
    }
  }, {
    key: 'getTitle',
    value: function getTitle() {
      return 'Create API Token';
    }
  }, {
    key: 'onCancel',
    value: function onCancel() {
      __WEBPACK_IMPORTED_MODULE_1_react_router__["browserHistory"].push('/api/');
    }
  }, {
    key: 'onSubmitSuccess',
    value: function onSubmitSuccess() {
      __WEBPACK_IMPORTED_MODULE_1_react_router__["browserHistory"].push('/api/');
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_app_components_narrowLayout__["default"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Create New Token')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])("Authentication tokens allow you to perform actions against the Sentry API on behalf of your account. They're the easiest way to get started using the API.")
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["tct"])('For more information on how to use the web API, see our [link:documentation].', {
            link: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'https://docs.sentry.io/hosted/api/' })
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_app_components_forms__["ApiForm"],
          {
            apiMethod: 'POST',
            apiEndpoint: '/api-tokens/',
            className: 'form-stacked api-new-token',
            initialData: { scopes: SORTED_DEFAULT_API_SCOPES },
            onSubmitSuccess: this.onSubmitSuccess,
            onCancel: this.onCancel
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_forms__["MultipleCheckboxField"], {
            name: 'scopes',
            choices: API_CHOICES,
            label: Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Scopes'),
            required: true
          })
        )
      );
    }
  }]);

  return ApiNewToken;
}(__WEBPACK_IMPORTED_MODULE_2_app_views_asyncView__["default"]);



/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_document_title__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_autoSelectText__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_dateTime__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_stores_indicatorStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_locale__ = __webpack_require__(2);














var ApiTokenRow = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'ApiTokenRow',

  propTypes: {
    token: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
    onRemove: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    return {
      loading: false
    };
  },
  onRemove: function onRemove() {
    var _this = this;

    if (this.state.loading) return;

    var token = this.props.token;

    this.setState({
      loading: true
    }, function () {
      var loadingIndicator = __WEBPACK_IMPORTED_MODULE_8_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Saving changes..'));
      _this.api.request('/api-tokens/', {
        method: 'DELETE',
        data: { token: token.token },
        success: function success(data) {
          __WEBPACK_IMPORTED_MODULE_8_app_stores_indicatorStore__["default"].remove(loadingIndicator);
          _this.props.onRemove();
        },
        error: function error() {
          __WEBPACK_IMPORTED_MODULE_8_app_stores_indicatorStore__["default"].remove(loadingIndicator);
          __WEBPACK_IMPORTED_MODULE_8_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Unable to remove token. Please try again.'), 'error');
        }
      });
    });
  },
  render: function render() {
    var token = this.props.token;

    var btnClassName = 'btn btn-default';
    if (this.state.loading) btnClassName += ' disabled';

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'tr',
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'td',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { marginBottom: 5 } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_app_components_autoSelectText__["a" /* default */],
              null,
              token.token
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { marginBottom: 5 } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'small',
            null,
            'Created ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_dateTime__["default"], { date: token.dateCreated })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'small',
            { style: { color: '#999' } },
            token.scopes.join(', ')
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'td',
        { style: { width: 32 } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          {
            onClick: this.onRemove.bind(this, token),
            className: btnClassName,
            disabled: this.state.loading
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon icon-trash' })
        )
      )
    );
  }
});

var ApiTokens = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'ApiTokens',
  mixins: [__WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    return {
      loading: true,
      error: false,
      tokenList: []
    };
  },
  componentWillMount: function componentWillMount() {
    this.fetchData();
  },
  remountComponent: function remountComponent() {
    this.setState(this.getInitialState(), this.fetchData);
  },
  fetchData: function fetchData() {
    var _this2 = this;

    this.setState({
      loading: true
    });

    this.api.request('/api-tokens/', {
      success: function success(data, _, jqXHR) {
        _this2.setState({
          loading: false,
          error: false,
          tokenList: data
        });
      },
      error: function error() {
        _this2.setState({
          loading: false,
          error: true
        });
      }
    });
  },
  onRemoveToken: function onRemoveToken(token) {
    this.setState({
      tokenList: this.state.tokenList.filter(function (tk) {
        return tk.token !== token.token;
      })
    });
  },
  renderResults: function renderResults() {
    var _this3 = this;

    var tokenList = this.state.tokenList;


    if (tokenList.length === 0) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'table',
        { className: 'table' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'tbody',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'tr',
            { colSpan: '2' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'td',
              { className: 'blankslate well' },
              Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])("You haven't created any authentication tokens yet.")
            )
          )
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'table',
        { className: 'table' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'tbody',
          null,
          tokenList.map(function (token) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ApiTokenRow, {
              key: token.token,
              token: token,
              onRemove: _this3.onRemoveToken.bind(_this3, token)
            });
          })
        )
      )
    );
  },
  getTitle: function getTitle() {
    return 'API Tokens';
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_document_title___default.a,
      { title: this.getTitle() },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])("Authentication tokens allow you to perform actions against the Sentry API on behalf of your account. They're the easiest way to get started using the API.")
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["tct"])('For more information on how to use the web API, see our [link:documentation].', {
            link: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { href: 'https://docs.sentry.io/hosted/api/' })
          })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'small',
            null,
            'psst. Looking for the ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'strong',
              null,
              'DSN'
            ),
            ' for an SDK? You\'ll find that under ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'strong',
              null,
              '[Project] \xBB Settings \xBB Client Keys'
            ),
            '.'
          )
        ),
        this.state.loading ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_loadingIndicator__["default"], null) : this.state.error ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_loadingError__["default"], { onRetry: this.fetchData }) : this.renderResults(),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'form-actions', style: { textAlign: 'right' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_router__["Link"],
            { to: '/api/new-token/', className: 'btn btn-primary ref-create-token' },
            Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Create New Token')
          )
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ApiTokens);

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_emotion_theming__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_keydown__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_idx__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_actionCreators_modal__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_actions_alertActions__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_alerts__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_assistant_helper__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_stores_configStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_components_errorBoundary__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_components_globalModal__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_components_indicators__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_views_installWizard__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_app_views_newsletterConsent__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_app_stores_organizationsStore__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_app_utils_theme__ = __webpack_require__(126);
var _dec, _desc, _value, _obj;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/*global __webpack_public_path__ */
/*eslint no-native-reassign:0 */


























if (window.globalStaticUrl) __webpack_require__.p = window.globalStaticUrl; // defined in layout.html

function getAlertTypeForProblem(problem) {
  switch (problem.severity) {
    case 'critical':
      return 'error';
    default:
      return 'warning';
  }
}

var App = __WEBPACK_IMPORTED_MODULE_6_create_react_class___default()((_dec = Object(__WEBPACK_IMPORTED_MODULE_7_react_keydown__["a" /* default */])('meta+shift+p', 'meta+k'), (_obj = {
  displayName: 'App',

  childContextTypes: {
    location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_13_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_5_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_15_app_stores_configStore__["default"], 'onConfigStoreChange')],

  getInitialState: function getInitialState() {
    var user = __WEBPACK_IMPORTED_MODULE_15_app_stores_configStore__["default"].get('user');
    return {
      loading: false,
      error: false,
      needsUpgrade: user && user.isSuperuser && __WEBPACK_IMPORTED_MODULE_15_app_stores_configStore__["default"].get('needsUpgrade'),
      newsletterConsentPrompt: user && user.flags.newsletter_consent_prompt
    };
  },
  getChildContext: function getChildContext() {
    return {
      location: this.props.location
    };
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.api.request('/organizations/', {
      query: {
        member: '1'
      },
      success: function success(data) {
        __WEBPACK_IMPORTED_MODULE_22_app_stores_organizationsStore__["a" /* default */].load(data);
        _this.setState({
          loading: false
        });
      },
      error: function error() {
        _this.setState({
          loading: false,
          error: true
        });
      }
    });

    this.api.request('/internal/health/', {
      success: function success(data) {
        if (data && data.problems) {
          data.problems.forEach(function (problem) {
            __WEBPACK_IMPORTED_MODULE_11_app_actions_alertActions__["default"].addAlert({
              id: problem.id,
              message: problem.message,
              type: getAlertTypeForProblem(problem),
              url: problem.url
            });
          });
        }
      },
      error: function error() {} // TODO: do something?
    });

    __WEBPACK_IMPORTED_MODULE_15_app_stores_configStore__["default"].get('messages').forEach(function (msg) {
      __WEBPACK_IMPORTED_MODULE_11_app_actions_alertActions__["default"].addAlert({
        message: msg.message,
        type: msg.level
      });
    });

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ajaxError(function (evt, jqXHR) {
      var _ref, _ref2;

      // TODO: Need better way of identifying anonymous pages
      //       that don't trigger redirect
      var pageAllowsAnon = /^\/share\//.test(window.location.pathname);

      // Ignore error unless it is a 401
      if (!jqXHR || jqXHR.status !== 401 || pageAllowsAnon) return;

      var code = (_ref = jqXHR) != null ? (_ref = _ref.responseJSON) != null ? (_ref = _ref.detail) != null ? _ref.code : _ref : _ref : _ref;
      var extra = (_ref2 = jqXHR) != null ? (_ref2 = _ref2.responseJSON) != null ? (_ref2 = _ref2.detail) != null ? _ref2.extra : _ref2 : _ref2 : _ref2;

      // 401s can also mean sudo is required or it's a request that is allowed to fail
      // Ignore if these are the cases
      if (code === 'sudo-required' || code === 'ignore') return;

      // If user must login via SSO, redirect to org login page
      if (code === 'sso-required') {
        window.location.assign(extra.loginUrl);
        return;
      }

      // Otherwise, user has become unauthenticated; reload URL, and let Django
      // redirect to login page
      __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.set('session_expired', 1);
      window.location.reload();
    });
  },
  componentWillUnmount: function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_22_app_stores_organizationsStore__["a" /* default */].load([]);
  },
  onConfigStoreChange: function onConfigStoreChange(config) {
    var newState = {};
    if (config.needsUpgrade !== undefined) newState.needsUpgrade = config.needsUpgrade;
    if (config.user !== undefined) newState.user = config.user;
    if (Object.keys(newState).length > 0) this.setState(newState);
  },
  openCommandPalette: function openCommandPalette(e) {
    Object(__WEBPACK_IMPORTED_MODULE_9_app_actionCreators_modal__["b" /* openCommandPalette */])();
    e.preventDefault();
    e.stopPropagation();
  },
  onConfigured: function onConfigured() {
    this.setState({ needsUpgrade: false });
  },
  onNewsletterConsent: function onNewsletterConsent() {
    // this is somewhat hackish
    this.setState({
      newsletterConsentPrompt: false
    });
  },
  renderBody: function renderBody() {
    var _state = this.state,
        needsUpgrade = _state.needsUpgrade,
        newsletterConsentPrompt = _state.newsletterConsentPrompt;

    if (needsUpgrade) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_app_views_installWizard__["a" /* default */], { onConfigured: this.onConfigured });
    }

    if (newsletterConsentPrompt) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_app_views_newsletterConsent__["a" /* default */], { onSubmitSuccess: this.onNewsletterConsent });
    }

    return this.props.children;
  },
  render: function render() {
    if (this.state.loading) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_20_app_components_loadingIndicator__["default"],
        { triangle: true },
        Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Getting a list of all of your organizations.')
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_emotion_theming__["ThemeProvider"],
      { theme: __WEBPACK_IMPORTED_MODULE_23_app_utils_theme__["default"] },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'div',
        { className: 'main-container', tabIndex: '-1' },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_app_components_globalModal__["default"], null),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_alerts__["default"], { className: 'messages-container' }),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_app_components_indicators__["default"], { className: 'indicators-container' }),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_16_app_components_errorBoundary__["default"],
          null,
          this.renderBody()
        ),
        __WEBPACK_IMPORTED_MODULE_15_app_stores_configStore__["default"].get('features').has('assistant') && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_app_components_assistant_helper__["a" /* default */], null)
      )
    );
  }
}, (_applyDecoratedDescriptor(_obj, 'openCommandPalette', [_dec], Object.getOwnPropertyDescriptor(_obj, 'openCommandPalette'), _obj)), _obj)));

/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 973 */
/***/ (function(module, exports) {

// Production steps of ECMA-262, Edition 6, 22.1.2.1
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from
if (!Array.from) {
  Array.from = function () {
    var toStr = Object.prototype.toString;
    var isCallable = function isCallable(fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };
    var toInteger = function toInteger(value) {
      var number = Number(value);
      if (isNaN(number)) {
        return 0;
      }
      if (number === 0 || !isFinite(number)) {
        return number;
      }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function toLength(value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    // The length property of the from method is 1.
    return function from(arrayLike /*, mapFn, thisArg */) {
      // 1. Let C be the this value.
      var C = this;

      // 2. Let items be ToObject(arrayLike).
      var items = Object(arrayLike);

      // 3. ReturnIfAbrupt(items).
      if (arrayLike == null) {
        throw new TypeError("Array.from requires an array-like object - not null or undefined");
      }

      // 4. If mapfn is undefined, then let mapping be false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== 'undefined') {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }

        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      var len = toLength(items.length);

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method 
      // of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 16. Let k be 0.
      var k = 0;
      // 17. Repeat, while k < len… (also steps a - h)
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      // 18. Let putStatus be Put(A, "length", len, true).
      A.length = len;
      // 20. Return A.
      return A;
    };
  }();
}

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export keydownScoped */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__class_decorator__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__method_decorator__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__method_decorator_scoped__ = __webpack_require__(982);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module decorators
 *
 */




/**
 * noopDecorator
 *
 * @access private
 * @return {undefined} Returns `undefined` so that the original undecorated instance/method is used
 */
function noopDecorator() {
  return undefined;
}

/**
 * _decorator
 *
 * @access private
 * @param {Function} methodFn The method wrapper to delegate to, based on whether user has specified a scoped decorator or not
 * @param {Array} ...args Remainder of arguments passed in
 * @return {Function} The decorated class or method
 */
function _decorator(methodFn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  // check the first argument to see if it's a user-supplied keycode or array
  // of keycodes, or if it's the wrapped class or method
  var testArg = args[0];
  var isArray = Array.isArray(testArg);

  // if the test argument is not an object or function, it is user-supplied
  // keycodes. else there are no arguments and it's just the wrapped class
  if (isArray || ~['string', 'number', 'symbol'].indexOf(typeof testArg === 'undefined' ? 'undefined' : _typeof(testArg))) {
    var keys = isArray ? testArg : args;

    // return the decorator function, which on the next call will look for
    // the presence of a method name to determine if this is a wrapped method
    // or component
    return function (target, methodName, descriptor) {
      return methodName ? methodFn({ target: target, descriptor: descriptor, keys: keys }) : Object(__WEBPACK_IMPORTED_MODULE_0__class_decorator__["a" /* default */])(target, keys);
    };
  } else {
    var WrappedComponent = args[0];
    var methodName = args[1];

    // method decorators without keycode (which) arguments are not allowed.
    if (WrappedComponent && !methodName) {
      return __WEBPACK_IMPORTED_MODULE_0__class_decorator__["a" /* default */].apply(undefined, args);
    } else {
      console.warn(methodName + ': Method decorators must have keycode arguments, so the decorator for this method will not do anything');
      return noopDecorator;
    }
  }
}

/**
 * keydownScoped
 *
 * Method decorator that will look for changes to its targeted component's
 * `keydown` props to decide when to trigger, rather than responding directly
 * to keydown events. This lets you specify a @keydown decorated class higher
 * up in the view hierarchy for larger scoping of keydown events, or for
 * programmatically sending keydown events as props into the components in order
 * to trigger decorated methods with matching keys.
 *
 * @access public
 * @param {Array} ...args  All (or no) arguments passed in from decoration
 * @return {Function} The decorated class or method
 */
function keydownScoped() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return _decorator.apply(undefined, [__WEBPACK_IMPORTED_MODULE_2__method_decorator_scoped__["a" /* default */]].concat(args));
}

/**
 * keydown
 *
 * The main decorator and default export, handles both classes and methods.
 *
 * @access public
 * @param {Array} ...args  All (or no) arguments passed in from decoration
 * @return {Function} The decorated class or method
 */
function keydown() {
  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return _decorator.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__method_decorator__["a" /* default */]].concat(args));
}

/* harmony default export */ __webpack_exports__["a"] = (keydown);



/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_handlers__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_keys__ = __webpack_require__(245);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @module componentWrapper
 *
 */






/**
 * componentWrapper
 *
 * @access public
 * @param {object} WrappedComponent React component class to be wrapped
 * @param {array} [keys] The key(s) bound to the class
 * @return {object} The higher-order function that wraps the decorated class
 */
function componentWrapper(WrappedComponent) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_3__lib_keys__["a" /* ALL_KEYS */];

  var KeyBoardHelper = function (_React$Component) {
    _inherits(KeyBoardHelper, _React$Component);

    function KeyBoardHelper(props) {
      _classCallCheck(this, KeyBoardHelper);

      var _this = _possibleConstructorReturn(this, (KeyBoardHelper.__proto__ || Object.getPrototypeOf(KeyBoardHelper)).call(this, props));

      _this.state = {
        event: null
      };
      return _this;
    }

    _createClass(KeyBoardHelper, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        Object(__WEBPACK_IMPORTED_MODULE_2__event_handlers__["b" /* onMount */])(this);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        Object(__WEBPACK_IMPORTED_MODULE_2__event_handlers__["c" /* onUnmount */])(this);
      }
    }, {
      key: 'handleKeyDown',
      value: function handleKeyDown(event) {
        var _this2 = this;

        // to simulate a keypress, set the event and then clear it in the callback
        this.setState({ event: event }, function () {
          return _this2.setState({ event: null });
        });
      }
    }, {
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, { keydown: this.state }));
      }
    }]);

    return KeyBoardHelper;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

  __WEBPACK_IMPORTED_MODULE_1__store__["g" /* setBinding */]({ keys: [].concat(keys), fn: KeyBoardHelper.prototype.handleKeyDown, target: KeyBoardHelper.prototype });

  return KeyBoardHelper;
}

/* harmony default export */ __webpack_exports__["a"] = (componentWrapper);

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(506);
__webpack_require__(512);
module.exports = __webpack_require__(76).Symbol;


/***/ }),
/* 977 */,
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uuid;
// Counter being incremented. JS is single-threaded, so it'll Just Work™.
var __counter = 1;

/**
 * Returns a process-wide unique identifier.
 */
function uuid() {
  return "uid-" + __counter++;
}

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/**
 * @module domHelpers
 *
 */


var focusableSelector = 'a[href], button, input, object, select, textarea, [tabindex]';

/**
 * bindFocusables: Find any focusable child elements of the component instance and
 * add an onFocus handler to focus our keydown handlers on the parent component
 * when user keys applies focus to the element.
 *
 * NOTE: One limitation of this right now is that if you tab out of the
 * component, _focusedInstance will still be set until next click or mount or
 * controlled focus.
 *
 * @access public
 * @param {object} instance The key-bound component instance
 * @param {callback} activateOnFocus The fn to fire when element is focused
 */
function bindFocusables(instance, activateOnFocus) {
  if (document.querySelectorAll) {
    try {
      var node = __WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.findDOMNode(instance);
      if (node) {
        var focusables = node.querySelectorAll(focusableSelector);
        if (focusables.length) {
          var onFocus = function onFocus(element) {
            var onFocusPrev = element.onfocus;
            return function (event) {
              activateOnFocus(instance);
              if (onFocusPrev) onFocusPrev.call(element, event);
            };
          };
          Array.prototype.slice.call(focusables).forEach(function (element) {
            return element.onfocus = onFocus(element);
          });
        }
      }
    } catch (error) {
      // noop, mostly suppressing error here https://github.com/glortho/react-keydown/issues/76
    }
  }
}

/**
 * findContainerNodes: Called by our click handler to find instances with nodes
 * that are equal to or that contain the click target. Any that pass this test
 * will be recipients of the next keydown event.
 *
 * @access public
 * @param {object} target The click event.target DOM element
 * @return {function} Reducer function
 */
function findContainerNodes(target) {
  return function (memo, instance) {
    try {
      var node = __WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.findDOMNode(instance);
      if (node && (node === target || node.contains(target))) {
        memo.push({ instance: instance, node: node });
      }
    } finally {
      return memo;
    }
  };
}

/**
 * sortByDOMPosition: Called by our click handler to sort a list of instances
 * according to least -> most nested. This is so that if multiple keybound
 * instances have nodes that are ancestors of the click target, they will be
 * sorted to let the instance closest to the click target get first dibs on the
 * next key down event.
 */
function sortByDOMPosition(a, b) {
  return a.node.compareDocumentPosition(b.node) === 10 ? 1 : -1;
}

/* harmony default export */ __webpack_exports__["a"] = ({ bindFocusables: bindFocusables, findContainerNodes: findContainerNodes, sortByDOMPosition: sortByDOMPosition });

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @module Listeners
 *
 */

// flag for whether click listener has been bound to document
var _clicksBound = false;

// flag for whether keydown listener has been bound to document
var _keysBound = false;

var Listeners = {
  /**
   * _bindKeys
   *
   * @access public
   */
  bindKeys: function bindKeys(callback) {
    if (!_keysBound) {
      document.addEventListener('keydown', callback);
      _keysBound = true;
    }
  },


  /**
   * unbindKeys
   *
   * @access public
   */
  unbindKeys: function unbindKeys(callback) {
    if (_keysBound) {
      document.removeEventListener('keydown', callback);
      _keysBound = false;
    }
  },


  /**
   * bindClicks
   *
   * @access public
   */
  bindClicks: function bindClicks(callback) {
    if (!_clicksBound) {
      document.addEventListener('click', callback, true);
      _clicksBound = true;
    }
  },


  /**
   * unbindClicks
   *
   * @access public
   */
  unbindClicks: function unbindClicks(callback) {
    if (_clicksBound) {
      document.removeEventListener('click', callback, true);
      _clicksBound = false;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Listeners);

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_handlers__ = __webpack_require__(514);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module methodWrapper
 *
 */



/**
 * _isReactKeyDown
 *
 * @access private
 * @param {object} event The possibly synthetic event passed as an argument with
 * the method invocation.
 * @return {boolean}
 */
function _isReactKeyDown(event) {
  return event && (typeof event === 'undefined' ? 'undefined' : _typeof(event)) === 'object' && event.nativeEvent instanceof window.KeyboardEvent && event.type === 'keydown';
}

/**
 * methodWrapper
 *
 * @access public
 * @param {object} args All arguments necessary for wrapping method
 * @param {object} args.target The decorated class
 * @param {object} args.descriptor Method descriptor
 * @param {array} args.keys The array of keys bound to the given method
 * @return {object} The method descriptor
 */
function methodWrapper(_ref) {
  var target = _ref.target,
      descriptor = _ref.descriptor,
      keys = _ref.keys;


  var fn = descriptor.value;

  // if we haven't already created a binding for this class (via another
  // decorated method), wrap these lifecycle methods.
  if (!__WEBPACK_IMPORTED_MODULE_0__store__["d" /* getBinding */](target)) {
    var componentDidMount = target.componentDidMount,
        componentWillUnmount = target.componentWillUnmount;


    target.componentDidMount = function () {
      Object(__WEBPACK_IMPORTED_MODULE_1__event_handlers__["b" /* onMount */])(this);
      if (componentDidMount) return componentDidMount.call(this);
    };

    target.componentWillUnmount = function () {
      Object(__WEBPACK_IMPORTED_MODULE_1__event_handlers__["c" /* onUnmount */])(this);
      if (componentWillUnmount) return componentWillUnmount.call(this);
    };
  }

  // add this binding of keys and method to the target's bindings
  __WEBPACK_IMPORTED_MODULE_0__store__["g" /* setBinding */]({ keys: keys, target: target, fn: fn });

  descriptor.value = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var maybeEvent = args[0];

    if (_isReactKeyDown(maybeEvent)) {
      // proxy method in order to use @keydown as filter for keydown events coming
      // from an actual onKeyDown binding (as identified by react's addition of
      // 'nativeEvent' + type === 'keydown')
      if (!maybeEvent.ctrlKey) {
        // we already whitelist shortcuts with ctrl modifiers so if we were to
        // fire it again here the method would trigger twice. see https://github.com/glortho/react-keydown/issues/38
        return Object(__WEBPACK_IMPORTED_MODULE_1__event_handlers__["a" /* _onKeyDown */])(maybeEvent, true);
      }
    } else if (!maybeEvent || !(maybeEvent instanceof window.KeyboardEvent) || maybeEvent.type !== 'keydown') {
      // if our first argument is a keydown event it is being handled by our
      // binding system. if it's anything else, just pass through.
      return fn.call.apply(fn, [this].concat(args));
    }
  };

  return descriptor;
}

/* harmony default export */ __webpack_exports__["a"] = (methodWrapper);

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_match_keys__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_parse_keys__ = __webpack_require__(513);
/**
 * @module methodWrapperScoped
 *
 */



/**
 * methodWrapperScoped
 *
 * @access public
 * @param {object} args All args necessary for decorating the method
 * @param {object} args.target The decorated method's class object
 * @param {object} args.descriptor The method's descriptor object
 * @param {array} args.keys The key codes bound to the decorated method
 * @return {object} The method's descriptor object
 */
function methodWrapperScoped(_ref) {
  var target = _ref.target,
      descriptor = _ref.descriptor,
      keys = _ref.keys;
  var componentWillReceiveProps = target.componentWillReceiveProps;

  var fn = descriptor.value;
  if (!keys) {
    console.warn(fn + ': keydownScoped requires one or more keys');
  } else {

    /**
     * _shouldTrigger
     *
     * @access private
     * @param {object} thisProps Exsting props from the wrapped component
     * @param {object} thisProps.keydown The namespaced state from the higher-order
     * component (class_decorator)
     * @param {object} nextProps The incoming props from the wrapped component
     * @param {object} nextProps.keydown The namescaped state from the higher-order
     * component (class_decorator)
     * @param {array} keys The keys bound to the decorated method
     * @return {boolean} Whether all tests have passed
     */
    var _shouldTrigger = function _shouldTrigger(keydownThis, keydownNext) {
      if (!(keydownNext && keydownNext.event && !keydownThis.event)) return false;

      return keySets.some(function (keySet) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__lib_match_keys__["a" /* default */])({ keySet: keySet, event: keydownNext.event });
      });
    };

    // wrap the component's lifecycle method to intercept key codes coming down
    // from the wrapped/scoped component up the view hierarchy. if new keydown
    // event has arrived and the key codes match what was specified in the
    // decorator, call the wrapped method.


    var keySets = Object(__WEBPACK_IMPORTED_MODULE_1__lib_parse_keys__["a" /* default */])(keys);target.componentWillReceiveProps = function (nextProps) {
      var keydownNext = nextProps.keydown;
      var keydownThis = this.props.keydown;


      if (_shouldTrigger(keydownThis, keydownNext)) {
        return fn.call(this, keydownNext.event);
      }

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (componentWillReceiveProps) return componentWillReceiveProps.call.apply(componentWillReceiveProps, [this, nextProps].concat(args));
    };
  }

  return descriptor;
}

/* harmony default export */ __webpack_exports__["a"] = (methodWrapperScoped);

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_actions_alertActions__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils_localStorage__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_utils__ = __webpack_require__(10);





var AlertStore = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({
  listenables: __WEBPACK_IMPORTED_MODULE_1_app_actions_alertActions__["default"],

  init: function init() {
    this.alerts = [];
    this.count = 0;
  },
  onAddAlert: function onAddAlert(alert) {
    var _this = this;

    if (Object(__WEBPACK_IMPORTED_MODULE_3_app_utils__["d" /* defined */])(alert.id)) {
      var expirations = __WEBPACK_IMPORTED_MODULE_2_app_utils_localStorage__["a" /* default */].getItem('alerts:muted');
      if (Object(__WEBPACK_IMPORTED_MODULE_3_app_utils__["d" /* defined */])(expirations)) {
        expirations = JSON.parse(expirations);

        // Remove any objects that have passed their mute duration.
        var now = Math.floor(new Date() / 1000);
        for (var key in expirations) {
          if (expirations.hasOwnProperty(key) && expirations[key] < now) {
            delete expirations[key];
          }
        }
        __WEBPACK_IMPORTED_MODULE_2_app_utils_localStorage__["a" /* default */].setItem('alerts:muted', JSON.stringify(expirations));

        if (expirations.hasOwnProperty(alert.id)) {
          return;
        }
      }
    } else {
      if (!Object(__WEBPACK_IMPORTED_MODULE_3_app_utils__["d" /* defined */])(alert.expireAfter)) {
        alert.expireAfter = 5000;
      }
    }

    if (alert.expireAfter) {
      window.setTimeout(function () {
        _this.onCloseAlert(alert);
      }, alert.expireAfter);
    }

    alert.key = this.count++;

    // intentionally recreate array via concat because of Reflux
    // "bug" where React components are given same reference to tracked
    // data objects, and don't *see* that values have changed
    this.alerts = this.alerts.concat([alert]);
    this.trigger(this.alerts);
  },
  onCloseAlert: function onCloseAlert(alert) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60 * 60 * 7 * 24;

    if (Object(__WEBPACK_IMPORTED_MODULE_3_app_utils__["d" /* defined */])(alert.id) && Object(__WEBPACK_IMPORTED_MODULE_3_app_utils__["d" /* defined */])(duration)) {
      var expiry = Math.floor(new Date() / 1000) + duration;
      var expirations = __WEBPACK_IMPORTED_MODULE_2_app_utils_localStorage__["a" /* default */].getItem('alerts:muted');
      if (Object(__WEBPACK_IMPORTED_MODULE_3_app_utils__["d" /* defined */])(expirations)) {
        expirations = JSON.parse(expirations);
      } else {
        expirations = {};
      }
      expirations[alert.id] = expiry;
      __WEBPACK_IMPORTED_MODULE_2_app_utils_localStorage__["a" /* default */].setItem('alerts:muted', JSON.stringify(expirations));
    }

    // TODO(dcramer): we need some animations here for closing alerts
    this.alerts = this.alerts.filter(function (item) {
      return alert !== item;
    });
    this.trigger(this.alerts);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (AlertStore);

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_alert__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_actions_alertActions__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_inlineSvg__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);
var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var StyledAlert = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_3_app_components_alert__["a" /* default */], {
  target: 'e11xovfv0'
})('padding:', function (p) {
  return p.theme.grid;
}, 'px ', function (p) {
  return p.theme.grid * 2;
}, 'px;position:relative;margin:0;padding-right:', function (p) {
  return p.theme.grid * 4;
}, 'px;');

var StyledInlineSvg = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_5_app_components_inlineSvg__["a" /* default */], {
  target: 'e11xovfv1'
})('/* Exists soley to enable its use as a selector in StyledCloseButton */');

var StyledCloseButton = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('button', {
  target: 'e11xovfv2'
})('background:none;border:0;opacity:0.4;transition:opacity 0.2s linear;position:absolute;right:', function (p) {
  return p.theme.grid;
}, 'px;top:7px;/* stylelint-disable-next-line no-duplicate-selectors */\n  ', StyledInlineSvg, '{color:', function (p) {
  return p.theme.gray4;
}, ';}&:hover{opacity:0.8;}');

var AlertMessage = (_temp2 = _class = function (_React$PureComponent) {
  _inherits(AlertMessage, _React$PureComponent);

  function AlertMessage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AlertMessage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AlertMessage.__proto__ || Object.getPrototypeOf(AlertMessage)).call.apply(_ref, [this].concat(args))), _this), _this.closeAlert = function () {
      __WEBPACK_IMPORTED_MODULE_4_app_actions_alertActions__["default"].closeAlert(_this.props.alert);
    }, _this.render = function () {
      var _this$props = _this.props,
          alert = _this$props.alert,
          system = _this$props.system;

      var icon = void 0;

      if (alert.type == 'success') {
        icon = 'icon-circle-check';
      } else {
        icon = 'icon-circle-exclamation';
      }
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        StyledAlert,
        { type: _this.props.alert.type, icon: icon, system: system },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          StyledCloseButton,
          {
            type: 'button',
            'aria-label': Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Close'),
            onClick: _this.closeAlert
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledInlineSvg, { 'aria-hidden': 'true', src: 'icon-circle-close' })
        ),
        _this.props.alert.url ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          { href: _this.props.alert.url },
          _this.props.alert.message
        ) : _this.props.alert.message
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return AlertMessage;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent), _class.propTypes = {
  alert: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    message: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['success', 'error', 'warning', 'info']),
    url: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
  }),
  system: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _temp2);


/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_actionCreators_guides__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_assistant_supportDrawer__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_assistant_guideDrawer__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_stores_guideStore__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_assistant_cueIcon__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_assistant_assistantContainer__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_assistant_closeIcon__ = __webpack_require__(334);













// AssistantHelper is responsible for rendering the cue message, guide drawer and support drawer.
var AssistantHelper = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'AssistantHelper',

  mixins: [__WEBPACK_IMPORTED_MODULE_1_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_8_app_stores_guideStore__["a" /* default */], 'onGuideStateChange')],

  getInitialState: function getInitialState() {
    return {
      currentGuide: null,
      // currentStep is applicable to the Need-Help button too. When currentGuide
      // is null, if currentStep is 0 the Need-Help button is cued, and if it's > 0
      // the support widget is open.
      currentStep: 0,
      currentOrgSlug: null,
      currentProjectSlug: null
    };
  },
  componentDidMount: function componentDidMount() {
    Object(__WEBPACK_IMPORTED_MODULE_5_app_actionCreators_guides__["b" /* fetchGuides */])();
  },
  onGuideStateChange: function onGuideStateChange(data) {
    this.setState({
      currentGuide: data.currentGuide,
      currentStep: data.currentStep,
      currentOrgSlug: data.currentOrg ? data.currentOrg.slug : null,
      currentProjectSlug: data.currentProject ? data.currentProject.slug : null
    });
  },


  // Terminology:
  // - A guide can be FINISHED by answering whether or not is was useful in the last step.
  // - A guide can be DISMISSED by x-ing out of it at any time (including when it's cued).
  // In both cases we consider it CLOSED.
  handleGuideDismiss: function handleGuideDismiss(e) {
    e.stopPropagation();
    Object(__WEBPACK_IMPORTED_MODULE_5_app_actionCreators_guides__["d" /* recordDismiss */])(this.state.currentGuide.id, this.state.currentStep);
    Object(__WEBPACK_IMPORTED_MODULE_5_app_actionCreators_guides__["a" /* closeGuideOrSupport */])();
  },
  render: function render() {
    var _state = this.state,
        currentGuide = _state.currentGuide,
        currentStep = _state.currentStep;

    var cueText = currentGuide && currentGuide.cue || Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Need Help?');

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      StyledHelper,
      null,
      currentGuide !== null && currentStep > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_assistant_guideDrawer__["a" /* default */], {
        guide: currentGuide,
        step: currentStep,
        onFinish: __WEBPACK_IMPORTED_MODULE_5_app_actionCreators_guides__["a" /* closeGuideOrSupport */],
        onDismiss: this.handleGuideDismiss,
        orgSlug: this.state.currentOrgSlug,
        projectSlug: this.state.currentProjectSlug
      }),
      currentGuide === null && currentStep > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_assistant_supportDrawer__["a" /* default */], { onClose: __WEBPACK_IMPORTED_MODULE_5_app_actionCreators_guides__["a" /* closeGuideOrSupport */] }),
      !currentStep && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledAssistantContainer,
        {
          onClick: __WEBPACK_IMPORTED_MODULE_5_app_actionCreators_guides__["c" /* nextStep */],
          className: 'assistant-cue',
          hasGuide: currentGuide
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_assistant_cueIcon__["a" /* default */], { hasGuide: currentGuide }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          StyledCueText,
          { hasGuide: currentGuide },
          cueText
        ),
        currentGuide && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { display: 'flex' }, onClick: this.handleGuideDismiss },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_assistant_closeIcon__["a" /* default */], null)
        )
      )
    );
  }
});

//this globally controls the size of the component
var StyledHelper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e1ap9p4z0'
})('font-size:1.4rem;@media (max-width:600px){display:none;}');

var StyledCueText = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('span', {
  target: 'e1ap9p4z1'
})('width:0px;overflow:hidden;opacity:0;transition:0.2s all;white-space:nowrap;color:', function (p) {
  return p.purpleDark;
}, ';', function (p) {
  return p.hasGuide && '\n    width: auto;\n    opacity: 1;\n    margin-left: 8px;\n  ';
}, ';');

var StyledAssistantContainer = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_10_app_components_assistant_assistantContainer__["a" /* default */], {
  target: 'e1ap9p4z2'
})('display:flex;align-items:center;cursor:pointer;max-width:300px;min-width:0;width:auto;&:hover ', StyledCueText, '{', function (p) {
  return !p.hasGuide && '\n      width: 6em;\n      // this is roughly long enough for the copy \'need help?\'\n      // at any base font size. if you change the copy, change this value\n      opacity: 1;\n      margin: 0 0.5em;\n    ';
}, ';}', function (p) {
  return p.hasGuide && '\n    background-color: ' + p.theme.greenDark + ';\n    border-color: ' + p.theme.greenLight + ';\n    color: ' + p.theme.offWhite + ';\n    ';
}, ';');

/* harmony default export */ __webpack_exports__["a"] = (AssistantHelper);

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_utils_analytics__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_externalLink__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_stores_hookStore__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_assistant_cueIcon__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_assistant_closeIcon__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_assistant_assistantContainer__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_views_settings_components_forms_controls_input__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_inlineSvg__ = __webpack_require__(24);

















// SupportDrawer slides up when the user clicks on a "Need Help?" cue.
var SupportDrawer = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'SupportDrawer',

  propTypes: {
    onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  },

  getInitialState: function getInitialState() {
    return {
      inputVal: '',
      docResults: [],
      helpcenterResults: []
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(props) {
    this.setState({ inputVal: '' });
  },


  search: __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function () {
    var _this = this;

    if (this.state.inputVal.length <= 2) {
      this.setState({
        docResults: [],
        helpcenterResults: []
      });
      return;
    }
    __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.ajax({
      method: 'GET',
      url: 'https://rigidsearch.getsentry.net/api/search',
      data: {
        q: this.state.inputVal,
        page: 1,
        section: 'hosted'
      },
      success: function success(data) {
        _this.setState({ docResults: data.items });
      }
    });
    __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.ajax({
      method: 'GET',
      url: 'https://sentry.zendesk.com/api/v2/help_center/articles/search.json',
      data: {
        query: this.state.inputVal
      },
      success: function success(data) {
        _this.setState({ helpcenterResults: data.results });
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_7_app_utils_analytics__["a" /* default */])('assistant.search', { query: this.state.inputVal });
  }, 300),

  handleChange: function handleChange(evt) {
    this.setState({ inputVal: evt.currentTarget.value }, this.search);
  },
  renderDocsResults: function renderDocsResults() {
    return this.state.docResults.map(function (result, i) {
      var title = result.title;

      var link = 'https://docs.sentry.io/' + result.path + '/';

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        StyledExternalLink,
        { key: i + 'doc', href: link },
        title
      );
    });
  },
  renderHelpCenterResults: function renderHelpCenterResults() {
    return this.state.helpcenterResults.map(function (result, i) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        StyledExternalLink,
        { key: i, href: result.html_url },
        result.title
      );
    });
  },
  render: function render() {
    var _this2 = this;

    var docsResults = this.renderDocsResults();
    var helpcenterResults = this.renderHelpCenterResults();
    var results = helpcenterResults.concat(docsResults);
    var hasResults = results && results.length > 0;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyledAssistantContainer,
      { hasResults: hasResults },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        StyledAssistantInputRow,
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_assistant_cueIcon__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          StyledSearchContainer,
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StyledSearchIcon, { src: 'icon-search' }),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StyledInput, {
            type: 'text',
            placeholder: Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Search FAQs and docs...'),
            onChange: this.handleChange,
            value: this.state.inputVal,
            autoFocus: true
          }),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            {
              className: 'close-button',
              onClick: this.props.onClose,
              style: { display: 'flex' }
            },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_assistant_closeIcon__["a" /* default */], null)
          )
        )
      ),
      hasResults && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        StyledResults,
        null,
        results
      ),
      __WEBPACK_IMPORTED_MODULE_9_app_stores_hookStore__["default"].get('assistant:support-button').map(function (cb) {
        return cb(_this2.state.inputVal);
      })
    );
  }
});

var StyledAssistantContainer = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_12_app_components_assistant_assistantContainer__["a" /* default */], {
  target: 'e14rldf90'
})('display:flex;flex-direction:column;transition:0.1s height;', function (p) {
  return p.hasResults ? 'height: 300px' : '';
}, ';');

var StyledAssistantInputRow = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])('div', {
  target: 'e14rldf91'
})('display:flex;align-items:center;');

var StyledInput = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_13_app_views_settings_components_forms_controls_input__["a" /* default */], {
  target: 'e14rldf92'
})('padding:0.25em 0.25em 0.25em 1em;height:2em;flex-grow:1;text-indent:1em;border-top-left-radius:1.45rem;border-bottom-left-radius:1.45rem;&:focus{border-color:', function (p) {
  return p.theme.borderLight;
}, ';}');

var StyledSearchIcon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_14_app_components_inlineSvg__["a" /* default */], {
  target: 'e14rldf93'
})('left:0.75em;position:absolute;top:53%;/* this is an optics thing */\n  transform:translateY(-50%);color:', function (p) {
  return p.theme.gray1;
}, ';');

var StyledSearchContainer = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])('div', {
  target: 'e14rldf94'
})('position:relative;margin-left:0.5em;display:flex;align-items:center;flex-grow:1;');

var StyledResults = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])('div', {
  target: 'e14rldf95'
})('flex-grow:1;flex-basis:0;overflow:scroll;border-bottom-left-radius:1.45em;border-bottom-right-radius:1.45em;');

var StyledExternalLink = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_8_app_components_externalLink__["a" /* default */], {
  target: 'e14rldf96'
})('color:', function (p) {
  return p.theme.gray4;
}, ';display:block;font-size:0.875;padding:0.5em 1em;&:not(:last-of-type){border-bottom:1px solid ', function (p) {
  return p.theme.borderLight;
}, ';}');

/* harmony default export */ __webpack_exports__["a"] = (SupportDrawer);

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GuideDrawer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_actionCreators_guides__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_assistant_cueIcon__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_assistant_closeIcon__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_assistant_assistantContainer__ = __webpack_require__(335);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











// GuideDrawer is what slides up when the user clicks on a guide cue.
var GuideDrawer = (_temp2 = _class = function (_React$Component) {
  _inherits(GuideDrawer, _React$Component);

  function GuideDrawer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GuideDrawer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GuideDrawer.__proto__ || Object.getPrototypeOf(GuideDrawer)).call.apply(_ref, [this].concat(args))), _this), _this.handleFinish = function (useful) {
      Object(__WEBPACK_IMPORTED_MODULE_5_app_actionCreators_guides__["e" /* recordFinish */])(_this.props.guide.id, useful);
      _this.props.onFinish();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GuideDrawer, [{
    key: 'interpolate',
    value: function interpolate(template, variables) {
      var regex = /\${([^{]+)}/g;
      return template.replace(regex, function (match, g1) {
        return variables[g1.trim()];
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var messageVariables = {
        orgSlug: this.props.orgSlug,
        projectSlug: this.props.projectSlug
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        StyledAssistantContainer,
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          StyledAssistantInputRow,
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_assistant_cueIcon__["a" /* default */], { hasGuide: true }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            StyledTitle,
            null,
            this.props.guide.steps[this.props.step - 1].title
          ),
          this.props.step < this.props.guide.steps.length && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            {
              className: 'close-button',
              style: { display: 'flex' },
              onClick: this.props.onDismiss
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_assistant_closeIcon__["a" /* default */], null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          StyledContent,
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', {
            dangerouslySetInnerHTML: {
              __html: this.interpolate(this.props.guide.steps[this.props.step - 1].message, messageVariables)
            }
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { marginTop: '1em' } },
            this.props.step < this.props.guide.steps.length ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_app_components_buttons_button__["default"],
                { priority: 'success', size: 'small', onClick: __WEBPACK_IMPORTED_MODULE_5_app_actionCreators_guides__["c" /* nextStep */] },
                Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Next'),
                ' \u2192'
              )
            ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { textAlign: 'center' } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Did you find this guide useful?')
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_app_components_buttons_button__["default"],
                {
                  priority: 'success',
                  size: 'small',
                  onClick: function onClick() {
                    return _this2.handleFinish(true);
                  }
                },
                Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Yes'),
                ' \xA0 \u2714'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_app_components_buttons_button__["default"],
                {
                  priority: 'success',
                  size: 'small',
                  style: { marginLeft: '0.25em' },
                  onClick: function onClick() {
                    return _this2.handleFinish(false);
                  }
                },
                Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('No'),
                ' \xA0 \u2716'
              )
            )
          )
        )
      );
    }
  }]);

  return GuideDrawer;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  // `guide` must be a valid guide.
  guide: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  // `step` must be > 0.
  step: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  onFinish: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  onDismiss: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  orgSlug: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  projectSlug: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, _temp2);



var StyledAssistantContainer = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_8_app_components_assistant_assistantContainer__["a" /* default */], {
  target: 'eez09pr0'
})('background-color:', function (p) {
  return p.theme.greenDark;
}, ';border-color:', function (p) {
  return p.theme.greenLight;
}, ';color:', function (p) {
  return p.theme.offWhite;
}, ';height:auto;');

var StyledAssistantInputRow = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'eez09pr1'
})('display:flex;align-items:center;');

var StyledTitle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'eez09pr2'
})('font-size:1.5em;margin-left:0.5em;flex-grow:1;');

var StyledContent = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'eez09pr3'
})('margin:1.5rem;line-height:1.5;a{color:', function (p) {
  return p.theme.greenLight;
}, ';}');

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_actions_modalActions__ = __webpack_require__(462);




var ModalStore = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({
  init: function init() {
    this.reset();
    this.listenTo(__WEBPACK_IMPORTED_MODULE_1_app_actions_modalActions__["a" /* default */].closeModal, this.onCloseModal);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_1_app_actions_modalActions__["a" /* default */].openModal, this.onOpenModal);
  },
  reset: function reset() {
    this.state = {
      renderer: null,
      options: {}
    };
  },
  onCloseModal: function onCloseModal() {
    this.reset();
    this.trigger(this.state);
  },
  onOpenModal: function onOpenModal(renderer, options) {
    this.state = { renderer: renderer, options: options };
    this.trigger(this.state);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ModalStore);

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



module.exports = __webpack_require__(990);


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(250);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(993);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(996);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(520);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(73);
var invariant = __webpack_require__(62);
var ReactPropTypesSecret = __webpack_require__(992);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(994);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(250);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(75);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(995);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 994 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__(997);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(999);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(1000);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(1001);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(250);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(31);

var _PropTypes = __webpack_require__(520);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(998);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
}
module.exports = exports['default'];

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
};

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(112);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf = void 0;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM2.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}

/* https://github.com/component/raf */
var prev = new Date().getTime();
function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);

  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};
compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};
exports.default = compatRaf;
module.exports = exports['default'];

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__(112);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;


  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};


function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_inlineSvg__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_loadingIndicator__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var Toast = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'e1hynkvs0'
})('display:flex;align-items:center;height:40px;padding:0 15px 0 10px;margin-top:15px;background:', function (p) {
  return p.theme.gray5;
}, ';color:#fff;border-radius:44px 7px 7px 44px;box-shadow:0 4px 12px 0 rgba(47,40,55,0.16);transition:transform 0.4s cubic-bezier(0.68,-0.55,0.265,1.55),opacity 0.4s linear;position:relative;transform:translate3d(0,0,0);&.toast-enter{opacity:0;transform:translate3d(0,70px,0);}&.toast-enter-active{opacity:1;transform:translate3d(0,0,0);}&.toast-leave{opacity:1;transform:translate3d(0,0,0);}&.toast-leave-active{opacity:0;transform:translate3d(0,70px,0);}');

var Icon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'e1hynkvs1'
})('margin-right:6px;svg{display:block;}color:', function (p) {
  return p.type == 'success' ? p.theme.green : p.theme.red;
}, ';');

var Message = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'e1hynkvs2'
})('flex:1;');

var Undo = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'e1hynkvs3'
})('display:inline-block;color:', function (p) {
  return p.theme.gray2;
}, ';padding-left:16px;margin-left:16px;border-left:1px solid ', function (p) {
  return p.theme.gray3;
}, ';cursor:pointer;&:hover{color:', function (p) {
  return p.theme.gray1;
}, ';}');

var StyledLoadingIndicator = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_5_app_components_loadingIndicator__["default"], {
  target: 'e1hynkvs4'
})('.loading-indicator{border-color:', function (p) {
  return p.theme.gray4;
}, ';border-left-color:', function (p) {
  return p.theme.purple;
}, ';}');

function ToastIndicator(_ref) {
  var indicator = _ref.indicator,
      onDismiss = _ref.onDismiss,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ['indicator', 'onDismiss', 'className']);

  var icon = void 0;
  var options = indicator.options,
      message = indicator.message,
      type = indicator.type;

  var _ref2 = options || {},
      undo = _ref2.undo,
      disableDismiss = _ref2.disableDismiss;

  var showUndo = typeof undo === 'function';
  var handleClick = function handleClick(e) {
    if (disableDismiss) return;
    if (typeof onDismiss === 'function') {
      onDismiss(indicator, e);
    }
  };

  if (type == 'success') {
    icon = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_inlineSvg__["a" /* default */], { src: 'icon-circle-check', size: '24px' });
  } else if (type == 'error') {
    icon = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_inlineSvg__["a" /* default */], { src: 'icon-circle-close', size: '24px' });
  }
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    Toast,
    _extends({
      onClick: handleClick,
      className: Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["cx"])(className, 'ref-toast', 'ref-' + type)
    }, props),
    type == 'loading' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledLoadingIndicator, { mini: true }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      Icon,
      { type: type },
      icon
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      Message,
      null,
      message
    ),
    showUndo && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      Undo,
      { onClick: undo },
      Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Undo')
    )
  );
}

ToastIndicator.propTypes = {
  indicator: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['error', 'success', 'loading', 'undo', '']),
    id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number]),
    message: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
    options: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
  }),
  onDismiss: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (ToastIndicator);

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InstallWizard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_document_title__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_views_asyncView__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_stores_configStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_forms__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_options__ = __webpack_require__(636);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var InstallWizard = (_temp = _class = function (_AsyncView) {
  _inherits(InstallWizard, _AsyncView);

  function InstallWizard() {
    _classCallCheck(this, InstallWizard);

    return _possibleConstructorReturn(this, (InstallWizard.__proto__ || Object.getPrototypeOf(InstallWizard)).apply(this, arguments));
  }

  _createClass(InstallWizard, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      _get(InstallWizard.prototype.__proto__ || Object.getPrototypeOf(InstallWizard.prototype), 'componentWillMount', this).call(this);
      jQuery(document.body).addClass('install-wizard');
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _get(InstallWizard.prototype.__proto__ || Object.getPrototypeOf(InstallWizard.prototype), 'componentWillUnmount', this).call(this);
      jQuery(document.body).removeClass('install-wizard');
    }
  }, {
    key: 'getEndpoint',
    value: function getEndpoint() {
      return '/internal/options/?query=is:required';
    }
  }, {
    key: 'renderFormFields',
    value: function renderFormFields() {
      var options = this.state.data;
      var missingOptions = new Set(Object.keys(options).filter(function (option) {
        return !options[option].field.isSet;
      }));
      // This is to handle the initial installation case.
      // Even if all options are filled out, we want to prompt to confirm
      // them. This is a bit of a hack because we're assuming that
      // the backend only spit back all filled out options for
      // this case.
      if (missingOptions.size === 0) {
        missingOptions = new Set(Object.keys(options));
      }

      // A mapping of option name to Field object
      var fields = {};

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = missingOptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          var option = options[key];
          if (option.field.disabled) {
            continue;
          }
          fields[key] = Object(__WEBPACK_IMPORTED_MODULE_7_app_options__["c" /* getOptionField */])(key, option.field);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return Object(__WEBPACK_IMPORTED_MODULE_7_app_options__["a" /* getForm */])(fields);
    }
  }, {
    key: 'getInitialData',
    value: function getInitialData() {
      var options = this.state.data;
      var data = {};
      Object.keys(options).forEach(function (optionName) {
        var option = options[optionName];
        if (!option.field.isSet) {
          data[optionName] = option.value;
        }
      });
      return data;
    }
  }, {
    key: 'getTitle',
    value: function getTitle() {
      return Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Setup Sentry');
    }
  }, {
    key: 'render',
    value: function render() {
      var version = __WEBPACK_IMPORTED_MODULE_5_app_stores_configStore__["default"].get('version');
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_document_title___default.a,
        { title: this.getTitle() },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'app' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pattern' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'setup-wizard' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h1',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Welcome to Sentry')
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'small',
                null,
                version.current
              )
            ),
            this.state.loading ? this.renderLoading() : this.state.error ? this.renderError(new Error('Unable to load all required endpoints')) : this.renderBody()
          )
        )
      );
    }
  }, {
    key: 'renderError',
    value: function renderError() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'loading-error' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon-exclamation' }),
        Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('We were unable to load the required configuration from the Sentry server. Please take a look at the service logs.')
      );
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_app_components_forms__["ApiForm"],
        {
          apiMethod: 'PUT',
          apiEndpoint: this.getEndpoint(),
          submitLabel: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Continue'),
          initialData: this.getInitialData(),
          onSubmitSuccess: this.props.onConfigured
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Complete setup by filling out the required configuration.')
        ),
        this.renderFormFields()
      );
    }
  }]);

  return InstallWizard;
}(__WEBPACK_IMPORTED_MODULE_3_app_views_asyncView__["default"]), _class.propTypes = {
  onConfigured: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
}, _temp);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(1005),
    baseAggregator = __webpack_require__(1006),
    baseIteratee = __webpack_require__(123),
    isArray = __webpack_require__(47);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 1005 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(220);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_forms__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_narrowLayout__ = __webpack_require__(125);








/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'NewsletterConsent',

  propTypes: {
    onSubmitSuccess: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  },

  componentWillMount: function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()(document.body).addClass('auth');
  },
  componentWillUnmount: function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()(document.body).removeClass('auth');
  },
  onSubmitSuccess: function onSubmitSuccess() {
    this.props.onSubmitSuccess && this.props.onSubmitSuccess();
  },


  // NOTE: the text here is duplicated within ``RegisterForm`` on the backend
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_app_components_narrowLayout__["default"],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'Pardon the interruption, we just need to get a quick answer from you.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_app_components_forms__["ApiForm"],
        {
          apiMethod: 'POST',
          apiEndpoint: '/users/me/subscriptions/',
          onSubmitSuccess: this.onSubmitSuccess,
          onSubmitError: this.onSubmitError,
          submitLabel: 'Continue'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_forms__["RadioBooleanField"], {
          key: 'subscribed',
          name: 'subscribed',
          label: 'Email Updates',
          help: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'We\'d love to keep you updated via email with product and feature announcements, promotions, educational materials, and events. Our updates focus on relevant information, and we\'ll never sell your data to third parties. See our ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: 'https://sentry.io/privacy/' },
              'Privacy Policy'
            ),
            ' ',
            'for more details.'
          ),
          yesLabel: 'Yes, I would like to receive updates via email',
          noLabel: 'No, I\'d prefer not to receive these updates',
          required: true
        })
      )
    );
  }
}));

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_emotion__ = __webpack_require__(5);


var textStyles = function textStyles(props) {
  return (/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react_emotion__["css"])('/* stylelint-disable no-descending-specificity */\n    h1,h2,h3,h4,h5,h6,p,ul,ol,table,dl,blockquote,form,pre,.auto-select-text,.section,[class^=\'highlight-\']{margin-bottom:20px;&:last-child{margin-bottom:0;}}h1,h2,h3,h4,h5,h6{line-height:1.2;}p,ul,ol,blockquote{line-height:1.5;}h1{font-size:2em;}h2{font-size:1.75em;}h3{font-size:1.5em;}h4{font-size:1.25em;}h5{font-size:1em;}pre{word-break:break-all;white-space:pre-wrap;}/* stylelint-enable */')
  );
};

/* harmony default export */ __webpack_exports__["a"] = (textStyles);

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_emotion__ = __webpack_require__(5);


var PanelFooter = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react_emotion__["default"])('div', {
  target: 'e6hf7n0'
})('border-top:1px solid ', function (p) {
  return p.theme.borderDark;
}, ';color:', function (p) {
  return p.theme.gray3;
}, ';font-size:14px;');

/* harmony default export */ __webpack_exports__["a"] = (PanelFooter);

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports = {
	"platforms": [
		{
			"integrations": [
				{
					"link": "https://docs.getsentry.com/hosted/clients/csharp/",
					"type": "language",
					"id": "csharp",
					"name": "C#"
				}
			],
			"id": "csharp",
			"name": "C#"
		},
		{
			"integrations": [
				{
					"link": "https://docs.getsentry.com/hosted/clients/cordova/",
					"type": "language",
					"id": "cordova",
					"name": "Cordova"
				}
			],
			"id": "cordova",
			"name": "Cordova"
		},
		{
			"integrations": [
				{
					"link": "https://docs.getsentry.com/hosted/clients/electron/",
					"type": "language",
					"id": "electron",
					"name": "Electron"
				}
			],
			"id": "electron",
			"name": "Electron"
		},
		{
			"integrations": [
				{
					"link": "https://docs.getsentry.com/hosted/clients/elixir/",
					"type": "language",
					"id": "elixir",
					"name": "Elixir"
				}
			],
			"id": "elixir",
			"name": "Elixir"
		},
		{
			"integrations": [
				{
					"link": "https://docs.getsentry.com/hosted/clients/go/",
					"type": "language",
					"id": "go",
					"name": "Go"
				},
				{
					"link": null,
					"type": "framework",
					"id": "go-http",
					"name": "net/http"
				}
			],
			"id": "go",
			"name": "Go"
		},
		{
			"integrations": [
				{
					"link": "https://docs.getsentry.com/hosted/clients/java/modules/android/",
					"type": "framework",
					"id": "java-android",
					"name": "Android"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/java/modules/appengine/",
					"type": "framework",
					"id": "java-appengine",
					"name": "Google App Engine"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/java/",
					"type": "language",
					"id": "java",
					"name": "Java"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/java/modules/log4j/",
					"type": "framework",
					"id": "java-log4j",
					"name": "Log4j 1.x"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/java/modules/log4j2/",
					"type": "framework",
					"id": "java-log4j2",
					"name": "Log4j 2.x"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/java/modules/logback/",
					"type": "framework",
					"id": "java-logback",
					"name": "Logback"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/java/modules/jul/",
					"type": "framework",
					"id": "java-logging",
					"name": "java.util.logging"
				}
			],
			"id": "java",
			"name": "Java"
		},
		{
			"integrations": [
				{
					"link": "https://docs.getsentry.com/hosted/clients/javascript/integrations/angular/",
					"type": "framework",
					"id": "javascript-angular",
					"name": "Angular"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/javascript/integrations/angularjs/",
					"type": "framework",
					"id": "javascript-angularjs",
					"name": "AngularJS"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/javascript/integrations/backbone/",
					"type": "framework",
					"id": "javascript-backbone",
					"name": "Backbone"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/javascript/integrations/ember/",
					"type": "framework",
					"id": "javascript-ember",
					"name": "Ember"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/javascript/install/",
					"type": "language",
					"id": "javascript",
					"name": "JavaScript"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/javascript/integrations/react/",
					"type": "framework",
					"id": "javascript-react",
					"name": "React"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/javascript/integrations/vue/",
					"type": "framework",
					"id": "javascript-vue",
					"name": "Vue"
				}
			],
			"id": "javascript",
			"name": "JavaScript"
		},
		{
			"integrations": [
				{
					"link": "https://docs.getsentry.com/hosted/clients/minidump/",
					"type": "language",
					"id": "minidump",
					"name": "Minidump"
				}
			],
			"id": "minidump",
			"name": "Minidump"
		},
		{
			"integrations": [
				{
					"link": "https://docs.getsentry.com/hosted/clients/node/integrations/connect/",
					"type": "framework",
					"id": "node-connect",
					"name": "Connect"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/node/integrations/express/",
					"type": "framework",
					"id": "node-express",
					"name": "Express"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/node/integrations/koa/",
					"type": "framework",
					"id": "node-koa",
					"name": "Koa"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/node/",
					"type": "language",
					"id": "node",
					"name": "Node.js"
				}
			],
			"id": "node",
			"name": "Node.js"
		},
		{
			"integrations": [
				{
					"link": "https://docs.getsentry.com/hosted/clients/cocoa/",
					"type": "language",
					"id": "objc",
					"name": "Objective-C"
				}
			],
			"id": "objc",
			"name": "Objective-C"
		},
		{
			"integrations": [
				{
					"link": "https://docs.getsentry.com/hosted/clients/php/integrations/laravel/",
					"type": "framework",
					"id": "php-laravel",
					"name": "Laravel"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/php/integrations/monolog/",
					"type": "framework",
					"id": "php-monolog",
					"name": "Monolog"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/php/",
					"type": "language",
					"id": "php",
					"name": "PHP"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/php/integrations/symfony2/",
					"type": "framework",
					"id": "php-symfony2",
					"name": "Symfony2"
				}
			],
			"id": "php",
			"name": "PHP"
		},
		{
			"integrations": [
				{
					"link": "https://docs.getsentry.com/hosted/clients/python/integrations/bottle/",
					"type": "framework",
					"id": "python-bottle",
					"name": "Bottle"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/python/integrations/celery/",
					"type": "library",
					"id": "python-celery",
					"name": "Celery"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/python/integrations/django/",
					"type": "framework",
					"id": "python-django",
					"name": "Django"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/python/integrations/flask/",
					"type": "framework",
					"id": "python-flask",
					"name": "Flask"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/python/integrations/pylons/",
					"type": "framework",
					"id": "python-pylons",
					"name": "Pylons"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/python/integrations/pyramid/",
					"type": "framework",
					"id": "python-pyramid",
					"name": "Pyramid"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/python/",
					"type": "language",
					"id": "python",
					"name": "Python"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/python/integrations/rq/",
					"type": "framework",
					"id": "python-rq",
					"name": "RQ"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/python/integrations/tornado/",
					"type": "framework",
					"id": "python-tornado",
					"name": "Tornado"
				}
			],
			"id": "python",
			"name": "Python"
		},
		{
			"integrations": [
				{
					"link": "https://docs.getsentry.com/hosted/clients/react-native/",
					"type": "language",
					"id": "cocoa",
					"name": "React-Native"
				}
			],
			"id": "cocoa",
			"name": "React-Native"
		},
		{
			"integrations": [
				{
					"link": "https://docs.getsentry.com/hosted/clients/ruby/integrations/rack/",
					"type": "framework",
					"id": "ruby-rack",
					"name": "Rack"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/ruby/integrations/rails/",
					"type": "framework",
					"id": "ruby-rails",
					"name": "Rails"
				},
				{
					"link": "https://docs.getsentry.com/hosted/clients/ruby/",
					"type": "language",
					"id": "ruby",
					"name": "Ruby"
				}
			],
			"id": "ruby",
			"name": "Ruby"
		},
		{
			"integrations": [
				{
					"link": "https://docs.getsentry.com/hosted/clients/rust/",
					"type": "language",
					"id": "rust",
					"name": "Rust"
				}
			],
			"id": "rust",
			"name": "Rust"
		},
		{
			"integrations": [
				{
					"link": "https://docs.getsentry.com/hosted/clients/cocoa/",
					"type": "language",
					"id": "swift",
					"name": "Swift"
				}
			],
			"id": "swift",
			"name": "Swift"
		}
	]
};

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_utils_analytics__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_views_onboarding_project_platformpicker__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_views_onboarding_project_platformiconTile__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_forms_selectField__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_locale__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var OnboardingProject = (_temp = _class = function (_React$Component) {
  _inherits(OnboardingProject, _React$Component);

  function OnboardingProject() {
    var _ref;

    _classCallCheck(this, OnboardingProject);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = OnboardingProject.__proto__ || Object.getPrototypeOf(OnboardingProject)).call.apply(_ref, [this].concat(args)));

    _this.setWarning = function (value) {
      _this.setState({ projectRequired: !value });
    };

    _this.submit = function () {
      _this.setWarning(_this.props.name);
      if (_this.props.name) {
        Object(__WEBPACK_IMPORTED_MODULE_3_app_utils_analytics__["a" /* default */])('platformpicker.create_project');
        _this.props.next();
      }
    };

    _this.renderTeamPicker = function () {
      var _this$props = _this.props,
          team = _this$props.team,
          teams = _this$props.teams,
          setTeam = _this$props.setTeam;

      if (teams.length < 2) return null;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'new-project-team' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h4',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('Team') + ':'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_forms_selectField__["a" /* default */], {
            name: 'select-team',
            clearable: false,
            value: team,
            style: { width: 180 },
            onChange: function onChange(val) {
              return setTeam(val);
            },
            options: teams.map(function (_ref2) {
              var slug = _ref2.slug;
              return {
                label: '#' + slug,
                value: slug
              };
            })
          })
        )
      );
    };

    _this.state = { projectRequired: false };
    return _this;
  }

  _createClass(OnboardingProject, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      this.setWarning(newProps.name);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'onboarding-info' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h4',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('Choose a language or framework') + ':'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_views_onboarding_project_platformpicker__["a" /* default */], _extends({}, this.props, { showOther: true })),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'create-project-form' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'new-project-name client-platform' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h4',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('Give your project a name') + ':'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('project-name-wrapper', {
                  required: this.state.projectRequired
                })
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_views_onboarding_project_platformiconTile__["a" /* default */], { platform: this.props.platform }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
                type: 'text',
                name: 'name',
                label: Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('Project Name'),
                placeholder: Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('Project name'),
                autoComplete: 'off',
                value: this.props.name,
                onChange: function onChange(e) {
                  return _this2.props.setName(e.target.value);
                }
              })
            )
          ),
          this.renderTeamPicker(),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'button',
              { className: 'btn btn-primary new-project-submit', onClick: this.submit },
              Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('Create Project')
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('Projects allow you to scope events to a specific application in your organization. For example, you might have separate projects for your API server and frontend client.')
          )
        )
      );
    }
  }]);

  return OnboardingProject;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  next: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  setPlatform: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  platform: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  setName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  team: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  setTeam: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  teams: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array
}, _class.defaultProps = {
  team: '',
  setTeam: function setTeam() {},
  teams: []
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (OnboardingProject);

/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_views_onboarding_utils__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_views_onboarding_project_platformiconTile__ = __webpack_require__(525);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var PlatformCard = (_temp = _class = function (_React$Component) {
  _inherits(PlatformCard, _React$Component);

  function PlatformCard() {
    _classCallCheck(this, PlatformCard);

    return _possibleConstructorReturn(this, (PlatformCard.__proto__ || Object.getPrototypeOf(PlatformCard)).apply(this, arguments));
  }

  _createClass(PlatformCard, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var platform = __WEBPACK_IMPORTED_MODULE_3_app_views_onboarding_utils__["b" /* flattenedPlatforms */].find(function (p) {
        return p.id === _this2.props.platform;
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('platform-card', this.props.className),
          onClick: this.props.onClick
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_views_onboarding_project_platformiconTile__["a" /* default */], this.props),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h5',
          null,
          ' ',
          platform.name,
          ' '
        )
      );
    }
  }]);

  return PlatformCard;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  platform: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (PlatformCard);

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_document_title__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_views_groupDetails_header__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_stores_groupStore__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_utils_withEnvironment__ = __webpack_require__(158);
















var ERROR_TYPES = {
  GROUP_NOT_FOUND: 'GROUP_NOT_FOUND'
};

var GroupDetails = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'GroupDetails',

  propTypes: {
    setProjectNavSection: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    memberList: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,
    environment: __WEBPACK_IMPORTED_MODULE_11_app_proptypes__["e" /* default */].Environment
  },

  childContextTypes: {
    group: __WEBPACK_IMPORTED_MODULE_11_app_proptypes__["e" /* default */].Group,
    location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_3_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_8_app_stores_groupStore__["a" /* default */], 'onGroupChange')],

  getDefaultProps: function getDefaultProps() {
    return {
      memberList: []
    };
  },
  getInitialState: function getInitialState() {
    return {
      group: null,
      loading: true,
      error: false,
      errorType: null
    };
  },
  getChildContext: function getChildContext() {
    return {
      group: this.state.group,
      location: this.props.location
    };
  },
  componentWillMount: function componentWillMount() {
    this.props.setProjectNavSection('stream');
    this.fetchData();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.params.groupId !== this.props.params.groupId) {
      this.remountComponent();
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    if (prevProps.params.groupId !== this.props.params.groupId || prevProps.environment !== this.props.environment) {
      this.fetchData();
    }
  },
  remountComponent: function remountComponent() {
    this.setState(this.getInitialState());
  },
  fetchData: function fetchData() {
    var _this = this;

    var query = {};

    if (this.props.environment) {
      query.environment = this.props.environment.name;
    }

    this.api.request(this.getGroupDetailsEndpoint(), {
      query: query,
      success: function success(data) {
        // TODO: Ideally, this would rebuild the route before parameter
        // interpolation, replace the `groupId` field of `this.routeParams`,
        // and use `formatPattern` from `react-router` to rebuild the URL,
        // rather than blindly pattern matching like we do here. Unfortunately,
        // `formatPattern` isn't actually exported until `react-router` 2.0.1:
        // https://github.com/reactjs/react-router/blob/v2.0.1/modules/index.js#L25
        if (_this.props.params.groupId != data.id) {
          var location = _this.props.location;
          return void __WEBPACK_IMPORTED_MODULE_4_react_router__["browserHistory"].push(location.pathname.replace('/issues/' + _this.props.params.groupId + '/', '/issues/' + data.id + '/') + location.search + location.hash);
        }

        _this.setState({
          loading: false,
          error: false,
          errorType: null
        });

        return void __WEBPACK_IMPORTED_MODULE_8_app_stores_groupStore__["a" /* default */].loadInitialData([data]);
      },
      error: function error(_, textStatus, errorThrown) {
        var errorType = null;
        switch (errorThrown) {
          case 'NOT FOUND':
            errorType = ERROR_TYPES.GROUP_NOT_FOUND;
            break;
          default:
        }
        _this.setState({
          loading: false,
          error: true,
          errorType: errorType
        });
      }
    });
  },
  onGroupChange: function onGroupChange(itemIds) {
    var id = this.props.params.groupId;
    if (itemIds.has(id)) {
      var group = __WEBPACK_IMPORTED_MODULE_8_app_stores_groupStore__["a" /* default */].get(id);
      if (group) {
        if (group.stale) {
          this.fetchData();
          return;
        }
        this.setState({
          group: group
        });
      }
    }
  },
  getGroupDetailsEndpoint: function getGroupDetailsEndpoint() {
    var id = this.props.params.groupId;

    return '/issues/' + id + '/';
  },
  getTitle: function getTitle() {
    var group = this.state.group;

    if (!group) return 'Sentry';

    switch (group.type) {
      case 'error':
        if (group.metadata.type && group.metadata.value) return group.metadata.type + ': ' + group.metadata.value;
        return group.metadata.type || group.metadata.value;
      case 'csp':
        return group.metadata.message;
      case 'expectct':
      case 'expectstaple':
      case 'hpkp':
        return group.metadata.message;
      case 'default':
        return group.metadata.title;
      default:
        return group.message.split('\n')[0];
    }
  },
  render: function render() {
    var group = this.state.group;
    var params = this.props.params;

    if (this.state.error) {
      switch (this.state.errorType) {
        case ERROR_TYPES.GROUP_NOT_FOUND:
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'alert alert-block' },
            Object(__WEBPACK_IMPORTED_MODULE_12_app_locale__["t"])('The issue you were looking for was not found.')
          );
        default:
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_loadingError__["default"], { onRetry: this.remountComponent });
      }
    } else if (this.state.loading || !group) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_loadingIndicator__["default"], null);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_document_title___default.a,
      { title: this.getTitle() },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: this.props.className },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_views_groupDetails_header__["a" /* default */], {
          orgId: params.orgId,
          projectId: params.projectId,
          group: group,
          memberList: this.props.memberList
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(this.props.children, {
          memberList: this.props.memberList,
          group: group
        })
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_app_utils_withEnvironment__["a" /* default */])(GroupDetails));

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_assigneeSelector__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_count__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_views_groupDetails_actions__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_views_groupDetails_seenBy__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_stores_indicatorStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_listLink__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_shortId__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_eventOrGroupTitle__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_assistant_guideAnchor__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_mixins_projectState__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_locale__ = __webpack_require__(2);


















var GroupHeader = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'GroupHeader',

  propTypes: {
    group: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
  },

  contextTypes: {
    location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_14_app_mixins_projectState__["a" /* default */]],

  onToggleMute: function onToggleMute() {
    var group = this.props.group;
    var project = this.getProject();
    var org = this.getOrganization();
    var loadingIndicator = __WEBPACK_IMPORTED_MODULE_9_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_16_app_locale__["t"])('Saving changes..'));

    this.api.bulkUpdate({
      orgId: org.slug,
      projectId: project.slug,
      itemIds: [group.id],
      data: {
        status: group.status === 'ignored' ? 'unresolved' : 'ignored'
      }
    }, {
      complete: function complete() {
        __WEBPACK_IMPORTED_MODULE_9_app_stores_indicatorStore__["default"].remove(loadingIndicator);
      }
    });
  },
  getMessage: function getMessage() {
    var data = this.props.group;
    var metadata = data.metadata;
    switch (data.type) {
      case 'error':
        return metadata.value;
      case 'csp':
        return metadata.message;
      default:
        return this.props.group.culprit || '';
    }
  },
  render: function render() {
    var _this = this;

    var group = this.props.group,
        orgFeatures = new Set(this.getOrganization().features),
        projectFeatures = this.getProjectFeatures(),
        userCount = group.userCount;

    var className = 'group-detail';

    className += ' type-' + group.type;
    className += ' level-' + group.level;

    if (group.isBookmarked) {
      className += ' isBookmarked';
    }
    if (group.hasSeen) {
      className += ' hasSeen';
    }
    if (group.status === 'resolved') {
      className += ' isResolved';
    }

    var groupId = group.id,
        projectId = this.getProject().slug,
        orgId = this.getOrganization().slug;
    var message = this.getMessage();

    var hasSimilarView = projectFeatures.has('similarity-view');
    var hasMergeView = orgFeatures.has('group-unmerge');

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: className },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'col-sm-7' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h3',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_eventOrGroupTitle__["a" /* default */], { data: group })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'event-message' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: 'error-level' },
              group.level
            ),
            message && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: 'message' },
              message
            ),
            group.logger && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: 'event-annotation' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router__["Link"],
                {
                  to: {
                    pathname: '/' + orgId + '/' + projectId + '/',
                    query: { query: 'logger:' + group.logger }
                  }
                },
                group.logger
              )
            ),
            group.annotations.map(function (annotation, i) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', {
                className: 'event-annotation',
                key: i,
                dangerouslySetInnerHTML: { __html: annotation }
              });
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'col-sm-5 stats' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'flex flex-justify-right' },
            group.shortId && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'short-id-box count align-right' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h6',
                { className: 'nav-header' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_app_components_assistant_guideAnchor__["default"], { target: 'issue_number', type: 'text' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_15_app_components_tooltip__["default"],
                  {
                    title: Object(__WEBPACK_IMPORTED_MODULE_16_app_locale__["t"])('This identifier is unique across your organization, and can be used to reference an issue in various places, like commit messages.')
                  },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'a',
                    {
                      className: 'help-link',
                      href: 'https://docs.sentry.io/learn/releases/#resolving-issues-via-commits'
                    },
                    Object(__WEBPACK_IMPORTED_MODULE_16_app_locale__["t"])('Issue #')
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_shortId__["a" /* default */], { shortId: group.shortId })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'count align-right' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h6',
                { className: 'nav-header' },
                Object(__WEBPACK_IMPORTED_MODULE_16_app_locale__["t"])('Events')
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router__["Link"],
                { to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/events/' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_count__["default"], { className: 'count', value: group.count })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'count align-right' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h6',
                { className: 'nav-header' },
                Object(__WEBPACK_IMPORTED_MODULE_16_app_locale__["t"])('Users')
              ),
              userCount !== 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router__["Link"],
                { to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/tags/user/' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_count__["default"], { className: 'count', value: userCount })
              ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                null,
                '0'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'assigned-to' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h6',
                { className: 'nav-header' },
                Object(__WEBPACK_IMPORTED_MODULE_16_app_locale__["t"])('Assignee')
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_assigneeSelector__["a" /* default */], { id: group.id })
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_views_groupDetails_seenBy__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_views_groupDetails_actions__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'ul',
        { className: 'nav nav-tabs' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_app_components_listLink__["default"],
          {
            to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/',
            isActive: function isActive() {
              var rootGroupPath = '/' + orgId + '/' + projectId + '/issues/' + groupId + '/';
              var pathname = _this.context.location.pathname;

              // Because react-router 1.0 removes router.isActive(route)
              return pathname === rootGroupPath || /events\/\w+\/$/.test(pathname);
            }
          },
          Object(__WEBPACK_IMPORTED_MODULE_16_app_locale__["t"])('Details')
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_app_components_listLink__["default"],
          { to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/activity/' },
          Object(__WEBPACK_IMPORTED_MODULE_16_app_locale__["t"])('Comments'),
          ' ',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'badge animated' },
            group.numComments
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_app_components_listLink__["default"],
          { to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/feedback/' },
          Object(__WEBPACK_IMPORTED_MODULE_16_app_locale__["t"])('User Feedback'),
          ' ',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'badge animated' },
            group.userReportCount
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_app_components_listLink__["default"],
          { to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/tags/' },
          Object(__WEBPACK_IMPORTED_MODULE_16_app_locale__["t"])('Tags')
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_app_components_listLink__["default"],
          { to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/events/' },
          Object(__WEBPACK_IMPORTED_MODULE_16_app_locale__["t"])('Events')
        ),
        hasMergeView && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_app_components_listLink__["default"],
          { to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/merged/' },
          Object(__WEBPACK_IMPORTED_MODULE_16_app_locale__["t"])('Merged')
        ),
        hasSimilarView && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_app_components_listLink__["default"],
          { to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/similar/' },
          Object(__WEBPACK_IMPORTED_MODULE_16_app_locale__["t"])('Similar Issues')
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (GroupHeader);

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1016);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(94)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--4-1!../../../../../../node_modules/less-loader/dist/cjs.js!./flowLayout.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--4-1!../../../../../../node_modules/less-loader/dist/cjs.js!./flowLayout.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(93)(undefined);
// imports


// module
exports.push([module.i, ".flow-layout{display:flex;flex:1;align-items:center}.flow-layout.is-vertical{flex-direction:column}.flow-layout.is-truncated{overflow:hidden}.flow-layout.is-center{justify-content:center}", ""]);

// exports


/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_dropdownLink__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_actions_groupActions__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_mixins_groupState__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_errorBoundary__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_group_externalIssues__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_stores_hookStore__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_stores_indicatorStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_group_issuePluginActions__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_assistant_guideAnchor__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_components_linkWithConfirmation__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_components_menuItem__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_components_shareIssue__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_components_actions_resolve__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_components_actions_ignore__ = __webpack_require__(530);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























var DeleteActions = (_temp = _class = function (_React$Component) {
  _inherits(DeleteActions, _React$Component);

  function DeleteActions() {
    var _ref;

    _classCallCheck(this, DeleteActions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = DeleteActions.__proto__ || Object.getPrototypeOf(DeleteActions)).call.apply(_ref, [this].concat(args)));

    _this.renderDisabledDiscard = function () {
      var _this$props = _this.props,
          project = _this$props.project,
          organization = _this$props.organization;

      return _this.state.hooksDisabled.map(function (hook) {
        return hook(organization, project);
      });
    };

    _this.renderDiscard = function () {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_app_components_dropdownLink__["default"],
        { caret: true, className: 'group-delete btn btn-default btn-sm' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'li',
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_15_app_components_linkWithConfirmation__["a" /* default */],
            {
              title: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Discard'),
              message: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Discarding this event will result in the deletion ' + 'of most data associated with this issue and future ' + 'events being discarded before reaching your stream. ' + 'Are you sure you wish to continue?'),
              onConfirm: _this.props.onDiscard
            },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_app_components_assistant_guideAnchor__["default"], { type: 'text', target: 'delete_discard' }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'span',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Delete and discard future events')
            )
          )
        )
      );
    };

    _this.state = {
      hooksDisabled: __WEBPACK_IMPORTED_MODULE_11_app_stores_hookStore__["default"].get('project:discard-groups:disabled')
    };
    return _this;
  }

  _createClass(DeleteActions, [{
    key: 'render',
    value: function render() {
      var features = new Set(this.props.project.features);
      var hasDiscard = features.has('discard-groups');

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_15_app_components_linkWithConfirmation__["a" /* default */],
          {
            className: 'group-remove btn btn-default btn-sm',
            title: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Delete'),
            message: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Deleting this issue is permanent. Are you sure you wish to continue?'),
            onConfirm: this.props.onDelete
          },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon-trash' }),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_app_components_assistant_guideAnchor__["default"], { type: 'text', target: 'ignore_delete_discard' })
        ),
        hasDiscard ? this.renderDiscard() : this.renderDisabledDiscard()
      );
    }
  }]);

  return DeleteActions;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  organization: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  project: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onDelete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onDiscard: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, _temp);


var GroupDetailsActions = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'GroupDetailsActions',

  mixins: [__WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_8_app_mixins_groupState__["a" /* default */]],

  getInitialState: function getInitialState() {
    return { ignoreModal: null, shareBusy: false };
  },
  getShareUrl: function getShareUrl(shareId, absolute) {
    if (!shareId) return '';

    var path = '/share/issue/' + shareId + '/';
    if (!absolute) {
      return path;
    }
    var _window$location = window.location,
        host = _window$location.host,
        protocol = _window$location.protocol;

    return protocol + '//' + host + path;
  },
  onDelete: function onDelete() {
    var group = this.getGroup();
    var project = this.getProject();
    var org = this.getOrganization();
    var loadingIndicator = __WEBPACK_IMPORTED_MODULE_12_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Delete event..'));

    this.api.bulkDelete({
      orgId: org.slug,
      projectId: project.slug,
      itemIds: [group.id]
    }, {
      complete: function complete() {
        __WEBPACK_IMPORTED_MODULE_12_app_stores_indicatorStore__["default"].remove(loadingIndicator);

        __WEBPACK_IMPORTED_MODULE_0_react_router__["browserHistory"].push('/' + org.slug + '/' + project.slug + '/');
      }
    });
  },
  onUpdate: function onUpdate(data) {
    var group = this.getGroup();
    var project = this.getProject();
    var org = this.getOrganization();
    var loadingIndicator = __WEBPACK_IMPORTED_MODULE_12_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Saving changes..'));

    this.api.bulkUpdate({
      orgId: org.slug,
      projectId: project.slug,
      itemIds: [group.id],
      data: data
    }, {
      complete: function complete() {
        __WEBPACK_IMPORTED_MODULE_12_app_stores_indicatorStore__["default"].remove(loadingIndicator);
      }
    });
  },
  onShare: function onShare(shared) {
    var _this2 = this;

    var group = this.getGroup();
    var project = this.getProject();
    var org = this.getOrganization();
    this.setState({ shareBusy: true });

    // not sure why this is a bulkUpdate
    this.api.bulkUpdate({
      orgId: org.slug,
      projectId: project.slug,
      itemIds: [group.id],
      data: {
        isPublic: shared
      }
    }, {
      error: function error() {
        __WEBPACK_IMPORTED_MODULE_12_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Error sharing'), 'error');
      },
      complete: function complete() {
        _this2.setState({ shareBusy: false });
      }
    });
  },
  onToggleShare: function onToggleShare() {
    var group = this.getGroup();
    this.onShare(!group.isPublic);
  },
  onToggleBookmark: function onToggleBookmark() {
    this.onUpdate({ isBookmarked: !this.getGroup().isBookmarked });
  },
  onDiscard: function onDiscard() {
    var group = this.getGroup();
    var project = this.getProject();
    var org = this.getOrganization();
    var id = this.api.uniqueId();
    var loadingIndicator = __WEBPACK_IMPORTED_MODULE_12_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Discarding event..'));

    __WEBPACK_IMPORTED_MODULE_7_app_actions_groupActions__["a" /* default */].discard(id, group.id);

    this.api.request('/issues/' + group.id + '/', {
      method: 'PUT',
      data: { discard: true },
      success: function success(response) {
        __WEBPACK_IMPORTED_MODULE_7_app_actions_groupActions__["a" /* default */].discardSuccess(id, group.id, response);
        __WEBPACK_IMPORTED_MODULE_0_react_router__["browserHistory"].push('/' + org.slug + '/' + project.slug + '/');
      },
      error: function error(_error) {
        __WEBPACK_IMPORTED_MODULE_7_app_actions_groupActions__["a" /* default */].discardError(id, group.id, _error);
      },
      complete: function complete() {
        __WEBPACK_IMPORTED_MODULE_12_app_stores_indicatorStore__["default"].remove(loadingIndicator);
      }
    });
  },
  render: function render() {
    var _this3 = this;

    var group = this.getGroup();
    var project = this.getProject();
    var org = this.getOrganization();
    var orgFeatures = new Set(this.getOrganization().features);

    var bookmarkClassName = 'group-bookmark btn btn-default btn-sm';
    if (group.isBookmarked) {
      bookmarkClassName += ' active';
    }

    var hasRelease = this.getProjectFeatures().has('releases');

    // account for both old and new style plugins
    var hasIssueTracking = group.pluginActions.length || group.pluginIssues.length;

    var isResolved = group.status === 'resolved';
    var isIgnored = group.status === 'ignored';

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: 'group-actions' },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_app_components_actions_resolve__["a" /* default */], {
        hasRelease: hasRelease,
        latestRelease: project.latestRelease,
        onUpdate: this.onUpdate,
        orgId: org.slug,
        projectId: project.slug,
        isResolved: isResolved,
        isAutoResolved: isResolved && group.statusDetails.autoResolved
      }),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_app_components_actions_ignore__["a" /* default */], { isIgnored: isIgnored, onUpdate: this.onUpdate }),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'a',
          {
            className: bookmarkClassName,
            title: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Bookmark'),
            onClick: this.onToggleBookmark
          },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon-star-solid' })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(DeleteActions, {
        project: project,
        organization: org,
        onDelete: this.onDelete,
        onDiscard: this.onDiscard
      }),
      orgFeatures.has('shared-issues') && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_app_components_shareIssue__["a" /* default */], {
          shareUrl: this.getShareUrl(group.shareId, true),
          isSharing: group.isPublic,
          group: group,
          onToggle: this.onToggleShare,
          onShare: function onShare() {
            return _this3.onShare(true);
          },
          busy: this.state.shareBusy
        })
      ),
      group.pluginActions.length > 1 ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'btn-group more' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_app_components_dropdownLink__["default"],
          { className: 'btn btn-default btn-sm', title: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('More') },
          group.pluginActions.map(function (action, actionIdx) {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_16_app_components_menuItem__["default"],
              { key: actionIdx, href: action[1] },
              action[0]
            );
          })
        )
      ) : group.pluginActions.length !== 0 && group.pluginActions.map(function (action, actionIdx) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'btn-group', key: actionIdx },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'a',
            { className: 'btn btn-default btn-sm', href: action[1] },
            action[0]
          )
        );
      }),
      group.pluginIssues && group.pluginIssues.map(function (plugin) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_app_components_group_issuePluginActions__["a" /* default */], { key: plugin.slug, plugin: plugin });
      }),
      !hasIssueTracking && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_14_app_components_assistant_guideAnchor__["default"],
        { type: 'text', target: 'issue_tracking' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'a',
          {
            href: '/' + this.getOrganization().slug + '/' + this.getProject().slug + '/settings/issue-tracking/',
            className: 'btn btn-default btn-sm btn-config-issue-tracking',
            style: { marginRight: '5px' }
          },
          Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Link Issue Tracker')
        )
      ),
      orgFeatures.has('internal-catchall') && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_app_components_errorBoundary__["default"],
        { mini: true },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_group_externalIssues__["a" /* default */], { group: group })
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (GroupDetailsActions);

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Modal__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_actionCreators_indicator__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_asyncComponent__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_dropdownLink__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_views_settings_components_forms_fieldFromConfig__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_views_settings_components_forms_form__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_menuItem__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_locale__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2, _class2, _temp3, _class3, _temp4;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var MESSAGES_BY_ACTION = {
  link: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Successfully linked issue.'),
  create: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Successfully created issue.')
};

var ExternalIssueForm = (_temp2 = _class = function (_AsyncComponent) {
  _inherits(ExternalIssueForm, _AsyncComponent);

  function ExternalIssueForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ExternalIssueForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ExternalIssueForm.__proto__ || Object.getPrototypeOf(ExternalIssueForm)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmitSuccess = function () {
      Object(__WEBPACK_IMPORTED_MODULE_4_app_actionCreators_indicator__["d" /* addSuccessMessage */])(MESSAGES_BY_ACTION[_this.props.action]);
      _this.props.onSubmitSuccess();
    }, _this.getOptions = function (field, input) {
      if (!input) {
        return Promise.resolve([]);
      }
      return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
        url: field.url + '?field=' + field.name + '&query=' + input,
        method: 'GET'
      }).then(function (data) {
        return { options: data };
      });
    }, _this.refetchConfig = function () {
      var dynamicFieldValues = _this.state.dynamicFieldValues;
      var _this$props = _this.props,
          action = _this$props.action,
          group = _this$props.group,
          integration = _this$props.integration;

      var endpoint = '/groups/' + group.id + '/integrations/' + integration.id + '/';
      var query = {
        action: action
      };
      Object.entries(dynamicFieldValues).map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            val = _ref3[1];

        query[key] = encodeURIComponent(val);
      });
      _this.api.request(endpoint, {
        method: 'GET',
        query: query,
        success: function success(data, _, jqXHR) {
          _this.handleRequestSuccess({ stateKey: 'integrationDetails', data: data, jqXHR: jqXHR }, true);
        },
        error: function error(_error) {
          _this.handleError(_error, ['integrationDetails', endpoint, null, null]);
        }
      });
    }, _this.onFieldChange = function (label, value) {
      var integrationDetails = _this.state.integrationDetails;
      var action = _this.props.action;

      var config = integrationDetails[action + 'IssueConfig'];
      var dynamicFields = new Set(config.filter(function (field) {
        return field.updatesForm;
      }).map(function (field) {
        return field.name;
      }));
      if (dynamicFields.has(label)) {
        var dynamicFieldValues = _this.state.dynamicFieldValues || {};
        dynamicFieldValues[label] = value;

        _this.setState({
          dynamicFieldValues: dynamicFieldValues,
          loading: true,
          error: false,
          remainingRequests: 1
        }, _this.refetchConfig);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ExternalIssueForm, [{
    key: 'getEndpoints',
    value: function getEndpoints() {
      var _props = this.props,
          action = _props.action,
          group = _props.group,
          integration = _props.integration;

      return [['integrationDetails', '/groups/' + group.id + '/integrations/' + integration.id + '/?action=' + action]];
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _this2 = this;

      var integrationDetails = this.state.integrationDetails;
      var _props2 = this.props,
          action = _props2.action,
          group = _props2.group,
          integration = _props2.integration;

      var config = integrationDetails[action + 'IssueConfig'];
      var initialData = {};
      config.forEach(function (field) {
        // passing an empty array breaks multi select
        // TODO(jess): figure out why this is breaking and fix
        initialData[field.name] = field.multiple ? '' : field.default;
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_app_views_settings_components_forms_form__["a" /* default */],
        {
          apiEndpoint: '/groups/' + group.id + '/integrations/' + integration.id + '/',
          apiMethod: action === 'create' ? 'POST' : 'PUT',
          onSubmitSuccess: this.onSubmitSuccess,
          initialData: initialData,
          onFieldChange: this.onFieldChange
        },
        config.map(function (field) {
          var props = {};
          if (field.url) {
            props = {
              loadOptions: function loadOptions(input) {
                return _this2.getOptions(field, input);
              },
              async: true,
              cache: false,
              onSelectResetsInput: false,
              onCloseResetsInput: false,
              onBlurResetsInput: false,
              autoload: false
            };
          }
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_views_settings_components_forms_fieldFromConfig__["a" /* default */], _extends({ key: field.name, field: field }, props));
        })
      );
    }
  }]);

  return ExternalIssueForm;
}(__WEBPACK_IMPORTED_MODULE_5_app_components_asyncComponent__["default"]), _class.propTypes = {
  group: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  integration: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  action: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['link', 'create']),
  onSubmitSuccess: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
}, _temp2);
var ExternalIssueActionList = (_temp3 = _class2 = function (_AsyncComponent2) {
  _inherits(ExternalIssueActionList, _AsyncComponent2);

  function ExternalIssueActionList(props, context) {
    _classCallCheck(this, ExternalIssueActionList);

    var _this3 = _possibleConstructorReturn(this, (ExternalIssueActionList.__proto__ || Object.getPrototypeOf(ExternalIssueActionList)).call(this, props, context));

    _this3.openModal = function (integration, action) {
      _this3.setState({
        showModal: true,
        selectedIntegration: integration,
        action: action
      });
    };

    _this3.closeModal = function () {
      _this3.setState({
        showModal: false,
        selectedIntegration: null,
        action: null
      });
    };

    _this3.state.showModal = false;
    _this3.state.selectedIntegration = null;
    _this3.state.action = null;
    return _this3;
  }

  _createClass(ExternalIssueActionList, [{
    key: 'getEndpoints',
    value: function getEndpoints() {
      var group = this.props.group;

      return [['integrations', '/groups/' + group.id + '/integrations/']];
    }
  }, {
    key: 'renderEmpty',
    value: function renderEmpty() {
      // TODO(jess): This should link to org integrations page
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_app_components_menuItem__["default"],
        null,
        Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('No integrations configured')
      );
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _this4 = this;

      var _state = this.state,
          action = _state.action,
          selectedIntegration = _state.selectedIntegration,
          integrations = _state.integrations;

      if (!integrations || !integrations.length) {
        return this.renderEmpty();
      }
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
        null,
        integrations.map(function (integration) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
            { key: integration.id },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_app_components_menuItem__["default"],
              { noAnchor: true },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { onClick: _this4.openModal.bind(_this4, integration, 'link') },
                Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["tct"])('Link [provider] issue', { provider: integration.provider.name })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_app_components_menuItem__["default"],
              { noAnchor: true },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { onClick: _this4.openModal.bind(_this4, integration, 'create') },
                Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["tct"])('Create [provider] issue', { provider: integration.provider.name })
              )
            )
          );
        }),
        selectedIntegration && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Modal___default.a,
          {
            show: this.state.showModal,
            onHide: this.closeModal,
            animation: false,
            backdrop: 'static',
            enforceFocus: false
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Modal___default.a.Header,
            { closeButton: true },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Modal___default.a.Title,
              null,
              selectedIntegration.provider.name + ' Issue'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Modal___default.a.Body,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ExternalIssueForm, {
              group: this.props.group,
              integration: selectedIntegration,
              action: action,
              onSubmitSuccess: this.closeModal
            })
          )
        )
      );
    }
  }]);

  return ExternalIssueActionList;
}(__WEBPACK_IMPORTED_MODULE_5_app_components_asyncComponent__["default"]), _class2.propTypes = {
  group: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
}, _temp3);
var ExternalIssueActions = (_temp4 = _class3 = function (_React$Component) {
  _inherits(ExternalIssueActions, _React$Component);

  function ExternalIssueActions() {
    _classCallCheck(this, ExternalIssueActions);

    return _possibleConstructorReturn(this, (ExternalIssueActions.__proto__ || Object.getPrototypeOf(ExternalIssueActions)).apply(this, arguments));
  }

  _createClass(ExternalIssueActions, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_app_components_dropdownLink__["default"],
        {
          title: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('External Issues'),
          caret: true,
          className: 'btn btn-default btn-sm'
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ExternalIssueActionList, { group: this.props.group })
      );
    }
  }]);

  return ExternalIssueActions;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class3.propTypes = {
  group: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
}, _temp4);


/* harmony default export */ __webpack_exports__["a"] = (ExternalIssueActions);

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextareaField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_views_settings_components_forms_inputField__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_views_settings_components_forms_controls_textarea__ = __webpack_require__(1020);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var TextareaField = function (_InputField) {
  _inherits(TextareaField, _InputField);

  function TextareaField() {
    _classCallCheck(this, TextareaField);

    return _possibleConstructorReturn(this, (TextareaField.__proto__ || Object.getPrototypeOf(TextareaField)).apply(this, arguments));
  }

  _createClass(TextareaField, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_app_views_settings_components_forms_inputField__["a" /* default */], _extends({}, this.props, {
        field: function field(_ref) {
          var children = _ref.children,
              onKeyDown = _ref.onKeyDown,
              fieldProps = _objectWithoutProperties(_ref, ['children', 'onKeyDown']);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_views_settings_components_forms_controls_textarea__["a" /* default */], fieldProps);
        }
      }));
    }
  }]);

  return TextareaField;
}(__WEBPACK_IMPORTED_MODULE_1_app_views_settings_components_forms_inputField__["a" /* default */]);



/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_styles_input__ = __webpack_require__(389);




var TextArea = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react_emotion__["default"])('textarea', {
  target: 'e1oph3pe0'
})(__WEBPACK_IMPORTED_MODULE_1_app_styles_input__["a" /* inputStyles */], ';');
/* harmony default export */ __webpack_exports__["a"] = (TextArea);

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_views_settings_components_forms_controls_radioGroup__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_views_settings_components_forms_inputField__ = __webpack_require__(128);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var RadioField = (_temp2 = _class = function (_React$Component) {
  _inherits(RadioField, _React$Component);

  function RadioField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RadioField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadioField.__proto__ || Object.getPrototypeOf(RadioField)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (id, onChange, onBlur, e) {
      onChange(id, e);
      onBlur(id, e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RadioField, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_views_settings_components_forms_inputField__["a" /* default */], _extends({}, this.props, {
        field: function field(_ref2) {
          var _onChange = _ref2.onChange,
              onBlur = _ref2.onBlur,
              value = _ref2.value,
              disabled = _ref2.disabled,
              props = _objectWithoutProperties(_ref2, ['onChange', 'onBlur', 'value', 'disabled']);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_views_settings_components_forms_controls_radioGroup__["a" /* default */], {
            choices: props.choices,
            value: value == '' ? null : value,
            label: props.label,
            onChange: function onChange(id, e) {
              return _this2.onChange(id, _onChange, onBlur, e);
            }
          });
        }
      }));
    }
  }]);

  return RadioField;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  choices: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array)
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (RadioField);

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Modal__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_dropdownLink__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_mixins_groupState__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_menuItem__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_plugins__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_utils__ = __webpack_require__(10);












var IssuePluginActions = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'IssuePluginActions',

  propTypes: {
    plugin: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_6_app_mixins_groupState__["a" /* default */]],

  getInitialState: function getInitialState() {
    return {
      showModal: false,
      actionType: null,
      pluginLoading: false
    };
  },
  componentWillMount: function componentWillMount() {
    this.loadPlugin(this.props.plugin);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this.props.plugin.id !== nextProps.plugin.id) {
      this.loadPlugin(nextProps.plugin);
    }
  },


  ACTION_LABELS: {
    create: Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Create New Issue'),
    link: Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Link with Existing Issue'),
    unlink: Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Unlink Issue')
  },

  loadPlugin: function loadPlugin(data) {
    var _this = this;

    this.setState({
      pluginLoading: true
    }, function () {
      __WEBPACK_IMPORTED_MODULE_8_app_plugins__["a" /* default */].load(data, function () {
        _this.setState({ pluginLoading: false });
      });
    });
  },
  openModal: function openModal(action) {
    this.setState({
      showModal: true,
      actionType: action
    });
  },
  closeModal: function closeModal() {
    this.setState({
      showModal: false,
      actionType: null
    });
  },
  render: function render() {
    var _this2 = this;

    var plugin = this.props.plugin;

    if (!plugin.allowed_actions || !plugin.allowed_actions.length) {
      return null;
    }

    var allowedActions = plugin.allowed_actions.filter(plugin.issue ? function (action) {
      return action === 'unlink';
    } : function (action) {
      return action !== 'unlink';
    });

    var button = void 0;
    if (allowedActions.length === 1) {
      // # TODO(dcramer): remove plugin.title check in Sentry 8.22+
      button = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'button',
        {
          className: 'btn btn-default btn-sm btn-plugin-' + plugin.slug,
          onClick: this.openModal.bind(this, allowedActions[0])
        },
        Object(__WEBPACK_IMPORTED_MODULE_10_app_utils__["s" /* toTitleCase */])(allowedActions[0]) + ' ' + (plugin.shortName || plugin.name || plugin.title) + ' Issue'
      );
    } else {
      // # TODO(dcramer): remove plugin.title check in Sentry 8.22+
      button = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'btn-plugin-' + plugin.slug },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_app_components_dropdownLink__["default"],
          {
            caret: false,
            className: 'btn btn-default btn-sm',
            title: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: { display: 'flex' } },
              plugin.shortName || plugin.name || plugin.title,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', {
                className: 'icon-arrow-down',
                style: { marginLeft: 3, marginRight: -3 }
              })
            )
          },
          allowedActions.map(function (action) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_app_components_menuItem__["default"],
              { key: action, noAnchor: true },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { onClick: _this2.openModal.bind(_this2, action) },
                _this2.ACTION_LABELS[action]
              )
            );
          })
        )
      );
    }

    // # TODO(dcramer): remove plugin.title check in Sentry 8.22+
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'btn-group' },
      button,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Modal___default.a,
        {
          show: this.state.showModal,
          onHide: this.closeModal,
          animation: false,
          backdrop: 'static',
          enforceFocus: false
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Modal___default.a.Header,
          { closeButton: true },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Modal___default.a.Title,
            null,
            (plugin.name || plugin.title) + ' Issue'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Modal___default.a.Body,
          null,
          !this.state.pluginLoading && this.state.actionType && __WEBPACK_IMPORTED_MODULE_8_app_plugins__["a" /* default */].get(this.props.plugin).renderGroupActions({
            plugin: this.props.plugin,
            group: this.getGroup(),
            project: this.getProject(),
            organization: this.getOrganization(),
            actionType: this.state.actionType,
            onSuccess: this.closeModal
          })
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IssuePluginActions);

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Registry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_plugins_defaultPlugin__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_plugins_defaultIssuePlugin__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*eslint no-console:0*/




var Registry = function () {
  function Registry() {
    _classCallCheck(this, Registry);

    this.plugins = {};
    this.assetCache = {};
  }

  _createClass(Registry, [{
    key: 'isLoaded',
    value: function isLoaded(data) {
      return Object(__WEBPACK_IMPORTED_MODULE_2_app_utils__["d" /* defined */])(this.plugins[data.id]);
    }
  }, {
    key: 'loadAll',
    value: function loadAll(dataList, callback) {
      var _this = this;

      var remaining = dataList.length;
      var pluginList = [];
      dataList.map(function (data) {
        _this.load(data, function (plugin) {
          remaining--;
          pluginList.push(plugin);
          if (remaining === 0) {
            callback(pluginList);
          }
        });
      });
    }
  }, {
    key: 'load',
    value: function load(data, callback) {
      var _this2 = this;

      // TODO(dcramer): we should probably register all valid plugins
      var remainingAssets = data.assets.length;
      var finishLoad = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_2_app_utils__["d" /* defined */])(this.plugins[data.id])) {
          if (data.type === 'issue-tracking') {
            this.plugins[data.id] = __WEBPACK_IMPORTED_MODULE_1_app_plugins_defaultIssuePlugin__["a" /* DefaultIssuePlugin */];
          } else {
            this.plugins[data.id] = __WEBPACK_IMPORTED_MODULE_0_app_plugins_defaultPlugin__["a" /* DefaultPlugin */];
          }
        }
        console.info('[plugins] Loaded ' + data.id + ' as {' + this.plugins[data.id].name + '}');
        callback(this.get(data));
      }.bind(this);

      if (remainingAssets === 0) {
        finishLoad();
        return;
      }

      var onAssetLoaded = function onAssetLoaded(asset) {
        remainingAssets--;
        if (remainingAssets === 0) {
          finishLoad();
        }
      };

      var onAssetFailed = function onAssetFailed(asset) {
        remainingAssets--;
        console.error('[plugins] Failed to load asset ' + asset.url);
        if (remainingAssets === 0) {
          finishLoad();
        }
      };

      // TODO(dcramer): what do we do on failed asset loading?
      data.assets.forEach(function (asset) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_2_app_utils__["d" /* defined */])(_this2.assetCache[asset.url])) {
          console.info('[plugins] Loading asset for ' + data.id + ': ' + asset.url);
          var s = document.createElement('script');
          s.src = asset.url;
          s.onload = onAssetLoaded.bind(_this2, asset);
          s.onerror = onAssetFailed.bind(_this2, asset);
          s.async = true;
          document.body.appendChild(s);
          _this2.assetCache[asset.url] = s;
        } else {
          onAssetLoaded(asset);
        }
      });
    }
  }, {
    key: 'get',
    value: function get(data) {
      var cls = this.plugins[data.id];
      if (!Object(__WEBPACK_IMPORTED_MODULE_2_app_utils__["d" /* defined */])(cls)) {
        throw new Error('Attempted to ``get`` an unloaded plugin: ' + data.id);
      }
      return new cls(data);
    }
  }, {
    key: 'add',
    value: function add(id, cls) {
      this.plugins[id] = cls;
    }
  }]);

  return Registry;
}();



/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_plugins_basePlugin__ = __webpack_require__(338);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var DefaultPlugin = function (_BasePlugin) {
  _inherits(DefaultPlugin, _BasePlugin);

  function DefaultPlugin() {
    _classCallCheck(this, DefaultPlugin);

    return _possibleConstructorReturn(this, (DefaultPlugin.__proto__ || Object.getPrototypeOf(DefaultPlugin)).apply(this, arguments));
  }

  return DefaultPlugin;
}(__WEBPACK_IMPORTED_MODULE_0_app_plugins_basePlugin__["a" /* default */]);

DefaultPlugin.displayName = 'DefaultPlugin';



/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_forms__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_bases_pluginComponentBase__ = __webpack_require__(420);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var PluginSettings = function (_PluginComponentBase) {
  _inherits(PluginSettings, _PluginComponentBase);

  function PluginSettings(props, context) {
    _classCallCheck(this, PluginSettings);

    var _this = _possibleConstructorReturn(this, (PluginSettings.__proto__ || Object.getPrototypeOf(PluginSettings)).call(this, props, context));

    Object.assign(_this.state, {
      fieldList: null,
      initialData: null,
      formData: null,
      errors: {},
      rawData: {},
      // override default FormState.READY if api requests are
      // necessary to even load the form
      state: __WEBPACK_IMPORTED_MODULE_5_app_components_forms__["FormState"].LOADING
    });
    return _this;
  }

  _createClass(PluginSettings, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchData();
    }
  }, {
    key: 'getPluginEndpoint',
    value: function getPluginEndpoint() {
      var org = this.props.organization;
      var project = this.props.project;
      return '/projects/' + org.slug + '/' + project.slug + '/plugins/' + this.props.plugin.id + '/';
    }
  }, {
    key: 'changeField',
    value: function changeField(name, value) {
      var formData = this.state.formData;
      formData[name] = value;
      // upon changing a field, remove errors
      var errors = this.state.errors;
      delete errors[name];
      this.setState({ formData: formData, errors: errors });
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      var _this2 = this;

      var repo = this.state.formData.repo;
      repo = repo && Object(__WEBPACK_IMPORTED_MODULE_6_app_utils__["o" /* parseRepo */])(repo);
      var parsedFormData = _extends({}, this.state.formData, { repo: repo });
      this.api.request(this.getPluginEndpoint(), {
        data: parsedFormData,
        method: 'PUT',
        success: this.onSaveSuccess.bind(this, function (data) {
          var formData = {};
          var initialData = {};
          data.config.forEach(function (field) {
            formData[field.name] = field.value || field.defaultValue;
            initialData[field.name] = field.value;
          });
          _this2.setState({
            fieldList: data.config,
            formData: formData,
            initialData: initialData,
            errors: {}
          });
        }),
        error: this.onSaveError.bind(this, function (error) {
          _this2.setState({
            errors: (error.responseJSON || {}).errors || {}
          });
        }),
        complete: this.onSaveComplete
      });
    }
  }, {
    key: 'fetchData',
    value: function fetchData() {
      var _this3 = this;

      this.api.request(this.getPluginEndpoint(), {
        success: function success(data) {
          if (!data.config) {
            _this3.setState({
              rawData: data
            }, _this3.onLoadSuccess);
            return;
          }
          var formData = {};
          var initialData = {};
          data.config.forEach(function (field) {
            formData[field.name] = field.value || field.defaultValue;
            initialData[field.name] = field.value;
          });
          _this3.setState({
            fieldList: data.config,
            formData: formData,
            initialData: initialData
            // call this here to prevent FormState.READY from being
            // set before fieldList is
          }, _this3.onLoadSuccess);
        },
        error: this.onLoadError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      if (this.state.state === __WEBPACK_IMPORTED_MODULE_5_app_components_forms__["FormState"].LOADING) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_loadingIndicator__["default"], null);
      }
      var isSaving = this.state.state === __WEBPACK_IMPORTED_MODULE_5_app_components_forms__["FormState"].SAVING;
      var hasChanges = !__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default()(this.state.initialData, this.state.formData);

      var data = this.state.rawData;
      if (data.config_error) {
        var authUrl = data.auth_url;
        if (authUrl.indexOf('?') === -1) {
          authUrl += '?next=' + encodeURIComponent(document.location.pathname);
        } else {
          authUrl += '&next=' + encodeURIComponent(document.location.pathname);
        }
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'div',
          { className: 'm-b-1' },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'div',
            { className: 'alert alert-warning m-b-1' },
            data.config_error
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'a',
            { className: 'btn btn-primary', href: authUrl },
            Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('Associate Identity')
          )
        );
      }

      if (this.state.state === __WEBPACK_IMPORTED_MODULE_5_app_components_forms__["FormState"].ERROR && !this.state.fieldList) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'div',
          { className: 'alert alert-error m-b-1' },
          Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["tct"])('An unknown error occurred. Need help with this? [link:Contact support]', {
            link: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: 'https://sentry.io/support/' })
          })
        );
      }

      if (!(this.state.fieldList || []).length) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_app_components_forms__["Form"],
        {
          className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])({ width: '100%' }),

          onSubmit: this.onSubmit,
          submitDisabled: isSaving || !hasChanges
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Flex"],
          { direction: 'column' },
          this.state.errors.__all__ && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'div',
            { className: 'alert alert-block alert-error' },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              'ul',
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'li',
                null,
                this.state.errors.__all__
              )
            )
          ),
          this.state.fieldList.map(function (f) {
            return _this4.renderField({
              key: f.name,
              config: f,
              formData: _this4.state.formData,
              formErrors: _this4.state.errors,
              onChange: _this4.changeField.bind(_this4, f.name)
            });
          })
        )
      );
    }
  }]);

  return PluginSettings;
}(__WEBPACK_IMPORTED_MODULE_9_app_components_bases_pluginComponentBase__["a" /* default */]);

PluginSettings.propTypes = {
  organization: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  project: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  plugin: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (PluginSettings);

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_forms__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_actions_groupActions__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_bases_pluginComponentBase__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var IssueActions = function (_PluginComponentBase) {
  _inherits(IssueActions, _PluginComponentBase);

  function IssueActions(props) {
    _classCallCheck(this, IssueActions);

    var _this = _possibleConstructorReturn(this, (IssueActions.__proto__ || Object.getPrototypeOf(IssueActions)).call(this, props));

    _this.createIssue = _this.onSave.bind(_this, _this.createIssue.bind(_this));
    _this.linkIssue = _this.onSave.bind(_this, _this.linkIssue.bind(_this));
    _this.unlinkIssue = _this.onSave.bind(_this, _this.unlinkIssue.bind(_this));
    _this.onSuccess = _this.onSaveSuccess.bind(_this, _this.onSuccess.bind(_this));
    _this.errorHandler = _this.onLoadError.bind(_this, _this.errorHandler.bind(_this));

    Object.assign(_this.state, {
      createFieldList: null,
      linkFieldList: null,
      loading: ['link', 'create'].includes(_this.props.actionType),
      state: ['link', 'create'].includes(_this.props.actionType) ? __WEBPACK_IMPORTED_MODULE_2_app_components_forms__["FormState"].LOADING : __WEBPACK_IMPORTED_MODULE_2_app_components_forms__["FormState"].READY,
      error: null,
      createFormData: {},
      linkFormData: {}
    });
    return _this;
  }

  _createClass(IssueActions, [{
    key: 'getGroup',
    value: function getGroup() {
      return this.props.group;
    }
  }, {
    key: 'getProject',
    value: function getProject() {
      return this.props.project;
    }
  }, {
    key: 'getOrganization',
    value: function getOrganization() {
      return this.props.organization;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var plugin = this.props.plugin;
      if (!plugin.issue && this.props.actionType !== 'unlink') {
        this.fetchData();
      }
    }
  }, {
    key: 'getPluginCreateEndpoint',
    value: function getPluginCreateEndpoint() {
      return '/issues/' + this.getGroup().id + '/plugins/' + this.props.plugin.slug + '/create/';
    }
  }, {
    key: 'getPluginLinkEndpoint',
    value: function getPluginLinkEndpoint() {
      return '/issues/' + this.getGroup().id + '/plugins/' + this.props.plugin.slug + '/link/';
    }
  }, {
    key: 'getPluginUnlinkEndpoint',
    value: function getPluginUnlinkEndpoint() {
      return '/issues/' + this.getGroup().id + '/plugins/' + this.props.plugin.slug + '/unlink/';
    }
  }, {
    key: 'setError',
    value: function setError(error, defaultMessage) {
      var errorBody = void 0;
      if (error.status === 400 && error.responseJSON) {
        errorBody = error.responseJSON;
      } else {
        errorBody = { message: defaultMessage };
      }
      this.setState({ error: errorBody });
    }
  }, {
    key: 'errorHandler',
    value: function errorHandler(error) {
      var state = {
        loading: false
      };
      if (error.status === 400 && error.responseJSON) {
        state.error = error.responseJSON;
      } else {
        state.error = { message: Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('An unknown error occurred.') };
      }
      this.setState(state);
    }
  }, {
    key: 'fetchData',
    value: function fetchData() {
      var _this2 = this;

      if (this.props.actionType === 'create') {
        this.api.request(this.getPluginCreateEndpoint(), {
          success: function success(data) {
            var createFormData = {};
            data.forEach(function (field) {
              createFormData[field.name] = field.default;
            });
            _this2.setState({
              createFieldList: data,
              error: null,
              loading: false,
              createFormData: createFormData
            }, _this2.onLoadSuccess);
          },
          error: this.errorHandler
        });
      } else if (this.props.actionType === 'link') {
        this.api.request(this.getPluginLinkEndpoint(), {
          success: function success(data) {
            var linkFormData = {};
            data.forEach(function (field) {
              linkFormData[field.name] = field.default;
            });
            _this2.setState({
              linkFieldList: data,
              error: null,
              loading: false,
              linkFormData: linkFormData
            }, _this2.onLoadSuccess);
          },
          error: this.errorHandler
        });
      }
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess() {
      __WEBPACK_IMPORTED_MODULE_3_app_actions_groupActions__["a" /* default */].updateSuccess(null, [this.getGroup().id], { stale: true });
      this.props.onSuccess && this.props.onSuccess();
    }
  }, {
    key: 'createIssue',
    value: function createIssue() {
      var _this3 = this;

      this.api.request(this.getPluginCreateEndpoint(), {
        data: this.state.createFormData,
        success: this.onSuccess,
        error: this.onSaveError.bind(this, function (error) {
          _this3.setError(error, Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('There was an error creating the issue.'));
        }),
        complete: this.onSaveComplete
      });
    }
  }, {
    key: 'linkIssue',
    value: function linkIssue() {
      var _this4 = this;

      this.api.request(this.getPluginLinkEndpoint(), {
        data: this.state.linkFormData,
        success: this.onSuccess,
        error: this.onSaveError.bind(this, function (error) {
          _this4.setError(error, Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('There was an error linking the issue.'));
        }),
        complete: this.onSaveComplete
      });
    }
  }, {
    key: 'unlinkIssue',
    value: function unlinkIssue() {
      var _this5 = this;

      this.api.request(this.getPluginUnlinkEndpoint(), {
        success: this.onSuccess,
        error: this.onSaveError.bind(this, function (error) {
          _this5.setError(error, Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('There was an error unlinking the issue.'));
        }),
        complete: this.onSaveComplete
      });
    }
  }, {
    key: 'changeField',
    value: function changeField(action, name, value) {
      var key = action + 'FormData';
      var formData = this.state[key];
      formData[name] = value;
      var state = {};
      state[key] = formData;
      this.setState(state);
    }
  }, {
    key: 'renderForm',
    value: function renderForm() {
      var _this6 = this;

      var form = void 0;
      switch (this.props.actionType) {
        case 'create':
          if (this.state.createFieldList) {
            form = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_app_components_forms__["Form"],
              {
                onSubmit: this.createIssue,
                submitLabel: Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('Create Issue'),
                footerClass: ''
              },
              this.state.createFieldList.map(function (field) {
                if (field.has_autocomplete) {
                  field = Object.assign({
                    url: '/api/0/issues/' + _this6.getGroup().id + '/plugins/' + _this6.props.plugin.slug + '/autocomplete'
                  }, field);
                }
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { key: field.name },
                  _this6.renderField({
                    config: field,
                    formData: _this6.state.createFormData,
                    onChange: _this6.changeField.bind(_this6, 'create', field.name)
                  })
                );
              })
            );
          }
          break;
        case 'link':
          if (this.state.linkFieldList) {
            form = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_app_components_forms__["Form"],
              { onSubmit: this.linkIssue, submitLabel: Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('Link Issue'), footerClass: '' },
              this.state.linkFieldList.map(function (field) {
                if (field.has_autocomplete) {
                  field = Object.assign({
                    url: '/api/0/issues/' + _this6.getGroup().id + '/plugins/' + _this6.props.plugin.slug + '/autocomplete'
                  }, field);
                }
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { key: field.name },
                  _this6.renderField({
                    config: field,
                    formData: _this6.state.linkFormData,
                    onChange: _this6.changeField.bind(_this6, 'link', field.name)
                  })
                );
              })
            );
          }
          break;
        case 'unlink':
          form = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('Are you sure you want to unlink this issue?')
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'button',
              { onClick: this.unlinkIssue, className: 'btn btn-danger' },
              Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('Unlink Issue')
            )
          );
          break;
        default:
          form = null;
      }
      return form;
    }
  }, {
    key: 'getPluginConfigureUrl',
    value: function getPluginConfigureUrl() {
      var org = this.getOrganization();
      var project = this.getProject();
      var plugin = this.props.plugin;
      return '/' + org.slug + '/' + project.slug + '/settings/plugins/' + plugin.slug;
    }
  }, {
    key: 'renderError',
    value: function renderError() {
      var error = this.state.error;
      if (!error) {
        return null;
      }
      if (error.error_type === 'auth') {
        var authUrl = error.auth_url;
        if (authUrl.indexOf('?') === -1) {
          authUrl += '?next=' + encodeURIComponent(document.location.pathname);
        } else {
          authUrl += '&next=' + encodeURIComponent(document.location.pathname);
        }
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'alert alert-warning m-b-1' },
            'You need to associate an identity with ' + this.props.plugin.name + ' before you can create issues with this service.'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            { className: 'btn btn-primary', href: authUrl },
            'Associate Identity'
          )
        );
      } else if (error.error_type === 'config') {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'alert alert-block' },
          !error.has_auth_configured ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              'Your server administrator will need to configure authentication with ',
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'strong',
                null,
                this.props.plugin.name
              ),
              ' before you can use this integration.'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              'The following settings must be configured:'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'ul',
              null,
              error.required_auth_settings.map(function (setting, i) {
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'li',
                  { key: i },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'code',
                    null,
                    setting
                  )
                );
              })
            )
          ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            'You still need to',
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { href: this.getPluginConfigureUrl() },
              'configure this plugin'
            ),
            ' before you can use it.'
          )
        );
      } else if (error.error_type === 'validation') {
        var errors = [];
        for (var name in error.errors) {
          errors.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            { key: name },
            error.errors[name]
          ));
        }
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'alert alert-error alert-block' },
          errors
        );
      } else if (error.message) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'alert alert-error alert-block' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            error.message
          )
        );
      }
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_loadingError__["default"], null);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.state === __WEBPACK_IMPORTED_MODULE_2_app_components_forms__["FormState"].LOADING) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_loadingIndicator__["default"], null);
      }
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        this.renderError(),
        this.renderForm()
      );
    }
  }]);

  return IssueActions;
}(__WEBPACK_IMPORTED_MODULE_6_app_components_bases_pluginComponentBase__["a" /* default */]);

IssueActions.propTypes = {
  plugin: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  actionType: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['unlink', 'link', 'create']).isRequired,
  onSuccess: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (IssueActions);

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_events_contexts_contextBlock__ = __webpack_require__(173);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var BaseContext = function (_React$Component) {
  _inherits(BaseContext, _React$Component);

  function BaseContext() {
    _classCallCheck(this, BaseContext);

    return _possibleConstructorReturn(this, (BaseContext.__proto__ || Object.getPrototypeOf(BaseContext)).apply(this, arguments));
  }

  _createClass(BaseContext, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_events_contexts_contextBlock__["a" /* default */], { data: this.props.data, alias: this.props.alias });
    }
  }]);

  return BaseContext;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BaseContext.displayName = 'BaseContext';

BaseContext.propTypes = {
  alias: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};

BaseContext.getTitle = function (value) {
  return value;
};

/* harmony default export */ __webpack_exports__["a"] = (BaseContext);

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_utils_selectText__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_autoSelectText__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_clipboard__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_confirm__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_dropdownLink__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_flowLayout__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_spreadLayout__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_switch__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_components_inlineSvg__ = __webpack_require__(24);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2, _class2, _temp3;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var BORDER_COLOR = '#dad5df';

var ShareUrlContainer = (_temp2 = _class = function (_React$Component) {
  _inherits(ShareUrlContainer, _React$Component);

  function ShareUrlContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ShareUrlContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ShareUrlContainer.__proto__ || Object.getPrototypeOf(ShareUrlContainer)).call.apply(_ref, [this].concat(args))), _this), _this.handleCopyClick = function () {
      if (!_this.urlRef) return;
      Object(__WEBPACK_IMPORTED_MODULE_4_app_utils_selectText__["a" /* selectText */])(__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(_this.urlRef));
    }, _this.handleUrlMount = function (ref) {
      _this.urlRef = ref;

      if (_this.urlRef) {
        // Always select url if it's available
        Object(__WEBPACK_IMPORTED_MODULE_4_app_utils_selectText__["a" /* selectText */])(__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(_this.urlRef));
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // Select URL when its container is clicked


  _createClass(ShareUrlContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isSharing = _props.isSharing,
          busy = _props.busy,
          shareUrl = _props.shareUrl,
          onConfirming = _props.onConfirming,
          onCancel = _props.onCancel,
          onShare = _props.onShare;

      var url = !busy && isSharing ? shareUrl : 'Not shared';

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_app_components_flowLayout__["a" /* default */],
        {
          style: {
            flex: 'none',
            alignItems: 'stretch',
            border: '1px solid ' + BORDER_COLOR,
            borderRadius: 4
          }
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          {
            style: {
              position: 'relative',
              display: 'flex',
              flex: 1,
              backgroundColor: !isSharing ? '#f9f7f9' : 'transparent',
              borderRight: '1px solid ' + BORDER_COLOR,
              maxWidth: 288
            }
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_app_components_autoSelectText__["a" /* default */],
            {
              ref: this.handleUrlMount,
              style: {
                flex: 1,
                border: 'none',
                padding: '4px 6px 4px 10px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden'
              }
            },
            url
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_app_components_flowLayout__["a" /* default */],
          { style: { alignItems: 'stretch' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_app_components_clipboard__["a" /* default */],
            { hideUnsupported: true, value: url },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_app_components_buttons_button__["default"],
              {
                borderless: true,
                size: 'xsmall',
                onClick: this.handleCopyClick,
                style: { borderRadius: 0, borderRight: '1px solid ' + BORDER_COLOR }
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_app_components_inlineSvg__["a" /* default */], { src: 'icon-copy' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_app_components_confirm__["a" /* default */],
            {
              message: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('You are about to regenerate a new shared URL. Your previously shared URL will no longer work. Do you want to continue?'),
              onCancel: onCancel,
              onConfirming: onConfirming,
              onConfirm: onShare
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_app_components_buttons_button__["default"],
              { borderless: true, size: 'xsmall' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_app_components_inlineSvg__["a" /* default */], { src: 'icon-refresh' })
            )
          )
        )
      );
    }
  }]);

  return ShareUrlContainer;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  isSharing: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  shareUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  onShare: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onConfirming: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onCancel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  busy: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _temp2);


var SmallHeading = function SmallHeading(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ['children']);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'h6',
    _extends({}, props, {
      style: {
        margin: 0,
        paddingRight: 30,
        whiteSpace: 'nowrap'
      }
    }),
    children
  );
};

var IndicatorDot = function IndicatorDot(_ref3) {
  var active = _ref3.active;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', {
    style: {
      display: 'inline-block',
      marginRight: 4,
      borderRadius: '50%',
      width: 10,
      height: 10,
      background: active ? '#57be8c' : '#dfdbe4'
    }
  });
};
IndicatorDot.propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};

var ShareIssue = (_temp3 = _class2 = function (_React$Component2) {
  _inherits(ShareIssue, _React$Component2);

  function ShareIssue(props) {
    _classCallCheck(this, ShareIssue);

    var _this2 = _possibleConstructorReturn(this, (ShareIssue.__proto__ || Object.getPrototypeOf(ShareIssue)).call(this, props));

    _this2.handleToggleShare = function (e) {
      e.preventDefault();
      _this2.setState({ busy: true }, function () {
        return _this2.props.onToggle();
      });
    };

    _this2.handleShare = function () {
      var onShare = _this2.props.onShare;

      _this2.setState({ busy: true }, function () {
        return onShare();
      });
      _this2.hasConfirmModal = false;
    };

    _this2.handleOpen = function () {
      if (!_this2.props.isSharing) {
        _this2.handleShare();
      }
    };

    _this2.handleConfirmCancel = function (e) {
      return _this2.hasConfirmModal = false;
    };

    _this2.handleConfirmReshare = function () {
      return _this2.hasConfirmModal = true;
    };

    _this2.hasConfirmModal = false;
    _this2.state = { busy: false };
    return _this2;
  }

  _createClass(ShareIssue, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.busy && (this.props.shareUrl !== nextProps.shareUrl || this.props.isSharing !== nextProps.isSharing)) {
        this.setState({ busy: false });
      }
    }

    // Should share URL if


    // State of confirm modal so we can keep dropdown menu opn

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          className = _props2.className,
          isSharing = _props2.isSharing;
      var busy = this.state.busy;

      var cx = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('share-issue btn-sm btn btn-default', className);

      var shareTitle = 'Share';

      // Needs to wrap in an inline block for DropdownLink,
      // or else dropdown icon gets wrapped?
      var title = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: { marginRight: 4 } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_app_components_flowLayout__["a" /* default */],
          { center: true },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(IndicatorDot, { active: isSharing }),
          shareTitle
        )
      );

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_app_components_dropdownLink__["default"],
        {
          className: cx,
          shouldIgnoreClickOutside: function shouldIgnoreClickOutside() {
            return _this3.hasConfirmModal;
          },
          title: title,
          onOpen: this.handleOpen,
          keepMenuOpen: true
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'li',
          {
            style: {
              padding: '12px 18px'
            },
            ref: function ref(_ref4) {
              return _this3.container = _ref4;
            }
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13_app_components_spreadLayout__["a" /* default */],
            { style: { marginBottom: busy || isSharing ? 12 : undefined } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              SmallHeading,
              null,
              Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Enable public share link')
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_app_components_switch__["default"], { isActive: isSharing, size: 'sm', toggle: this.handleToggleShare })
          ),
          busy && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_app_components_flowLayout__["a" /* default */],
            { center: true },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_loadingIndicator__["default"], { mini: true })
          ),
          !busy && isSharing && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ShareUrlContainer, _extends({}, this.props, {
            onCancel: this.handleConfirmCancel,
            onConfirming: this.handleConfirmReshare,
            onShare: this.handleShare
          }))
        )
      );
    }
  }]);

  return ShareIssue;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class2.propTypes = {
  isSharing: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  shareUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  busy: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  onToggle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  onShare: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
}, _temp3);


/* harmony default export */ __webpack_exports__["a"] = (ShareIssue);

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(1030), __webpack_require__(1032), __webpack_require__(1033)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
        global.clipboard = mod.exports;
    }
})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
    'use strict';

    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

    var _goodListener2 = _interopRequireDefault(_goodListener);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var Clipboard = function (_Emitter) {
        _inherits(Clipboard, _Emitter);

        /**
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         * @param {Object} options
         */
        function Clipboard(trigger, options) {
            _classCallCheck(this, Clipboard);

            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

            _this.resolveOptions(options);
            _this.listenClick(trigger);
            return _this;
        }

        /**
         * Defines if attributes would be resolved using internal setter functions
         * or custom functions that were passed in the constructor.
         * @param {Object} options
         */


        _createClass(Clipboard, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
                this.container = _typeof(options.container) === 'object' ? options.container : document.body;
            }
        }, {
            key: 'listenClick',
            value: function listenClick(trigger) {
                var _this2 = this;

                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                    return _this2.onClick(e);
                });
            }
        }, {
            key: 'onClick',
            value: function onClick(e) {
                var trigger = e.delegateTarget || e.currentTarget;

                if (this.clipboardAction) {
                    this.clipboardAction = null;
                }

                this.clipboardAction = new _clipboardAction2.default({
                    action: this.action(trigger),
                    target: this.target(trigger),
                    text: this.text(trigger),
                    container: this.container,
                    trigger: trigger,
                    emitter: this
                });
            }
        }, {
            key: 'defaultAction',
            value: function defaultAction(trigger) {
                return getAttributeValue('action', trigger);
            }
        }, {
            key: 'defaultTarget',
            value: function defaultTarget(trigger) {
                var selector = getAttributeValue('target', trigger);

                if (selector) {
                    return document.querySelector(selector);
                }
            }
        }, {
            key: 'defaultText',
            value: function defaultText(trigger) {
                return getAttributeValue('text', trigger);
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.listener.destroy();

                if (this.clipboardAction) {
                    this.clipboardAction.destroy();
                    this.clipboardAction = null;
                }
            }
        }], [{
            key: 'isSupported',
            value: function isSupported() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

                var actions = typeof action === 'string' ? [action] : action;
                var support = !!document.queryCommandSupported;

                actions.forEach(function (action) {
                    support = support && !!document.queryCommandSupported(action);
                });

                return support;
            }
        }]);

        return Clipboard;
    }(_tinyEmitter2.default);

    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */
    function getAttributeValue(suffix, element) {
        var attribute = 'data-clipboard-' + suffix;

        if (!element.hasAttribute(attribute)) {
            return;
        }

        return element.getAttribute(attribute);
    }

    module.exports = Clipboard;
});

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(1031)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('select'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.select);
        global.clipboardAction = mod.exports;
    }
})(this, function (module, _select) {
    'use strict';

    var _select2 = _interopRequireDefault(_select);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var ClipboardAction = function () {
        /**
         * @param {Object} options
         */
        function ClipboardAction(options) {
            _classCallCheck(this, ClipboardAction);

            this.resolveOptions(options);
            this.initSelection();
        }

        /**
         * Defines base properties passed from constructor.
         * @param {Object} options
         */


        _createClass(ClipboardAction, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = options.action;
                this.container = options.container;
                this.emitter = options.emitter;
                this.target = options.target;
                this.text = options.text;
                this.trigger = options.trigger;

                this.selectedText = '';
            }
        }, {
            key: 'initSelection',
            value: function initSelection() {
                if (this.text) {
                    this.selectFake();
                } else if (this.target) {
                    this.selectTarget();
                }
            }
        }, {
            key: 'selectFake',
            value: function selectFake() {
                var _this = this;

                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

                this.removeFake();

                this.fakeHandlerCallback = function () {
                    return _this.removeFake();
                };
                this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

                this.fakeElem = document.createElement('textarea');
                // Prevent zooming on iOS
                this.fakeElem.style.fontSize = '12pt';
                // Reset box model
                this.fakeElem.style.border = '0';
                this.fakeElem.style.padding = '0';
                this.fakeElem.style.margin = '0';
                // Move element out of screen horizontally
                this.fakeElem.style.position = 'absolute';
                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
                // Move element to the same position vertically
                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                this.fakeElem.style.top = yPosition + 'px';

                this.fakeElem.setAttribute('readonly', '');
                this.fakeElem.value = this.text;

                this.container.appendChild(this.fakeElem);

                this.selectedText = (0, _select2.default)(this.fakeElem);
                this.copyText();
            }
        }, {
            key: 'removeFake',
            value: function removeFake() {
                if (this.fakeHandler) {
                    this.container.removeEventListener('click', this.fakeHandlerCallback);
                    this.fakeHandler = null;
                    this.fakeHandlerCallback = null;
                }

                if (this.fakeElem) {
                    this.container.removeChild(this.fakeElem);
                    this.fakeElem = null;
                }
            }
        }, {
            key: 'selectTarget',
            value: function selectTarget() {
                this.selectedText = (0, _select2.default)(this.target);
                this.copyText();
            }
        }, {
            key: 'copyText',
            value: function copyText() {
                var succeeded = void 0;

                try {
                    succeeded = document.execCommand(this.action);
                } catch (err) {
                    succeeded = false;
                }

                this.handleResult(succeeded);
            }
        }, {
            key: 'handleResult',
            value: function handleResult(succeeded) {
                this.emitter.emit(succeeded ? 'success' : 'error', {
                    action: this.action,
                    text: this.selectedText,
                    trigger: this.trigger,
                    clearSelection: this.clearSelection.bind(this)
                });
            }
        }, {
            key: 'clearSelection',
            value: function clearSelection() {
                if (this.trigger) {
                    this.trigger.focus();
                }

                window.getSelection().removeAllRanges();
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.removeFake();
            }
        }, {
            key: 'action',
            set: function set() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

                this._action = action;

                if (this._action !== 'copy' && this._action !== 'cut') {
                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
                }
            },
            get: function get() {
                return this._action;
            }
        }, {
            key: 'target',
            set: function set(target) {
                if (target !== undefined) {
                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                        }

                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        }

                        this._target = target;
                    } else {
                        throw new Error('Invalid "target" value, use a valid Element');
                    }
                }
            },
            get: function get() {
                return this._target;
            }
        }]);

        return ClipboardAction;
    }();

    module.exports = ClipboardAction;
});

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),
/* 1032 */
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__(1034);
var delegate = __webpack_require__(1035);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),
/* 1034 */
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__(1036);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),
/* 1036 */
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomResolutionModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_escape__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_escape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_escape__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom_server__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom_server___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom_server__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_lib_Modal__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_timeSince__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_version__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_forms__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_locale__ = __webpack_require__(2);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var CustomResolutionModal = (_temp = _class = function (_React$Component) {
  _inherits(CustomResolutionModal, _React$Component);

  function CustomResolutionModal() {
    var _ref;

    _classCallCheck(this, CustomResolutionModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = CustomResolutionModal.__proto__ || Object.getPrototypeOf(CustomResolutionModal)).call.apply(_ref, [this].concat(args)));

    _this.onSubmit = function () {
      _this.props.onSelected({
        inRelease: _this.state.version
      });
    };

    _this.onChange = function (value) {
      _this.setState({ version: value });
    };

    _this.state = { version: '' };
    return _this;
  }

  _createClass(CustomResolutionModal, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevProps.show && this.props.show) {
        // XXX(cramer): this is incorrect but idgaf
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.modal').attr('tabindex', null);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          orgId = _props.orgId,
          projectId = _props.projectId;
      var version = this.state.version;


      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_lib_Modal___default.a,
        { show: this.props.show, animation: false, onHide: this.props.onCanceled },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'modal-header' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h4',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Resolved In')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'modal-body' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'form',
            { className: 'm-b-1' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'control-group m-b-1' },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'h6',
                { className: 'nav-header' },
                Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Version')
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_forms__["Select2FieldAutocomplete"], {
                name: 'version',
                onChange: function onChange(v) {
                  return _this2.onChange(v);
                },
                placeholder: Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('e.g. 1.0.4'),
                url: '/api/0/projects/' + orgId + '/' + projectId + '/releases/',
                value: version,
                id: 'version',
                onResults: function onResults(results) {
                  return { results: results };
                },
                onQuery: function onQuery(query) {
                  return { query: query };
                },
                formatResult: function formatResult(release) {
                  return __WEBPACK_IMPORTED_MODULE_3_react_dom_server___default.a.renderToStaticMarkup(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      'strong',
                      null,
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_version__["a" /* default */], { version: release.version, anchor: false })
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      'small',
                      null,
                      'Created ',
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_timeSince__["default"], { date: release.dateCreated })
                    )
                  ));
                },
                formatSelection: function formatSelection(item) {
                  return __WEBPACK_IMPORTED_MODULE_0_lodash_escape___default()(item.version);
                },
                escapeMarkup: false
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'modal-footer m-t-1' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-default',
              onClick: this.props.onCanceled
            },
            Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Cancel')
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-primary', onClick: this.onSubmit },
            Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Save Changes')
          )
        )
      );
    }
  }]);

  return CustomResolutionModal;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  onSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onCanceled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  orgId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  projectId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _temp);


/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomIgnoreCountModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_Modal__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_forms__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var CustomIgnoreCountModal = (_temp = _class = function (_React$Component) {
  _inherits(CustomIgnoreCountModal, _React$Component);

  function CustomIgnoreCountModal() {
    var _ref;

    _classCallCheck(this, CustomIgnoreCountModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = CustomIgnoreCountModal.__proto__ || Object.getPrototypeOf(CustomIgnoreCountModal)).call.apply(_ref, [this].concat(args)));

    _this.onSubmit = function () {
      var _this$props$onSelecte;

      _this.props.onSelected((_this$props$onSelecte = {}, _defineProperty(_this$props$onSelecte, _this.props.countName, _this.state.count), _defineProperty(_this$props$onSelecte, _this.props.windowName, _this.state.window), _this$props$onSelecte));
    };

    _this.onChange = function (name, value) {
      _this.setState(_defineProperty({}, name, value));
    };

    _this.state = {
      count: 100,
      window: ''
    };
    return _this;
  }

  _createClass(CustomIgnoreCountModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          count = _state.count,
          window = _state.window;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_Modal___default.a,
        { show: this.props.show, animation: false, onHide: this.props.onCanceled },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'modal-header' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h4',
            null,
            this.props.label
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'modal-body' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'form',
            { className: 'm-b-1' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'control-group' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h6',
                { className: 'nav-header' },
                this.props.countLabel
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
                className: 'form-control',
                type: 'number',
                value: count,
                onChange: function onChange(e) {
                  return _this2.onChange('count', e.target.value);
                },
                style: { padding: '3px 10px' },
                required: true,
                placeholder: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('e.g. 100')
              })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'control-group m-b-1' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h6',
                { className: 'nav-header' },
                Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Time window')
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_forms__["Select2Field"], {
                value: window,
                name: 'window',
                onChange: function onChange(v) {
                  return _this2.onChange('window', v);
                },
                choices: [['', ' ']].concat(_toConsumableArray(this.props.windowChoices)),
                placeholder: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('e.g. per hour'),
                allowClear: true,
                help: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('(Optional) If supplied, this rule will apply as a rate of change.')
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'modal-footer m-t-1' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-default',
              onClick: this.props.onCanceled
            },
            Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Cancel')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-primary', onClick: this.onSubmit },
            Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Ignore')
          )
        )
      );
    }
  }]);

  return CustomIgnoreCountModal;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  onSelected: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onCanceled: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  show: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  label: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  countLabel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  countName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  windowName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  windowChoices: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired
}, _temp);


/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomIgnoreDurationModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_Modal__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sprintf_js__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sprintf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sprintf_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var CustomIgnoreDurationModal = (_temp = _class = function (_React$Component) {
  _inherits(CustomIgnoreDurationModal, _React$Component);

  function CustomIgnoreDurationModal() {
    var _ref;

    _classCallCheck(this, CustomIgnoreDurationModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = CustomIgnoreDurationModal.__proto__ || Object.getPrototypeOf(CustomIgnoreDurationModal)).call.apply(_ref, [this].concat(args)));

    _this.selectedIgnoreMinutes = function () {
      var dateStr = _this.refs.snoozeDateInput.value; // YYYY-MM-DD
      var timeStr = _this.refs.snoozeTimeInput.value; // HH:MM
      if (dateStr && timeStr) {
        var selectedDate = new Date(dateStr + 'T' + timeStr); // poor man's ISO datetime
        if (!isNaN(selectedDate)) {
          var now = new Date();
          var millis = selectedDate.getTime() - now.getTime();
          var minutes = parseInt(Math.ceil(millis / 1000.0 / 60.0), 10);
          return minutes;
        }
      }
      return 0;
    };

    _this.snoozeClicked = function () {
      var minutes = _this.selectedIgnoreMinutes();

      _this.setState({
        dateWarning: minutes <= 0
      });

      if (minutes > 0) {
        _this.props.onSelected({ ignoreDuration: minutes });
      }
    };

    _this.state = {
      dateWarning: false
    };
    return _this;
  }

  _createClass(CustomIgnoreDurationModal, [{
    key: 'render',
    value: function render() {
      // Give the user a sane starting point to select a date
      // (prettier than the empty date/time inputs):
      var defaultDate = new Date();
      defaultDate.setDate(defaultDate.getDate() + 14);
      defaultDate.setSeconds(0);
      defaultDate.setMilliseconds(0);

      var defaultDateVal = Object(__WEBPACK_IMPORTED_MODULE_3_sprintf_js__["sprintf"])('%d-%02d-%02d', defaultDate.getUTCFullYear(), defaultDate.getUTCMonth() + 1, defaultDate.getUTCDate());

      var defaultTimeVal = Object(__WEBPACK_IMPORTED_MODULE_3_sprintf_js__["sprintf"])('%02d:00', defaultDate.getUTCHours());

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_Modal___default.a,
        { show: this.props.show, animation: false, onHide: this.props.onCanceled },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'modal-header' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h4',
            null,
            this.props.label
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'modal-body' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'form',
            { className: 'form-horizontal' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'control-group' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h6',
                { className: 'nav-header' },
                Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Date')
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
                className: 'form-control',
                type: 'date',
                id: 'snooze-until-date',
                defaultValue: defaultDateVal,
                ref: 'snoozeDateInput',
                required: true,
                style: { padding: '0 10px' }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'control-group m-b-1' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h6',
                { className: 'nav-header' },
                Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Time (UTC)')
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
                className: 'form-control',
                type: 'time',
                id: 'snooze-until-time',
                defaultValue: defaultTimeVal,
                ref: 'snoozeTimeInput',
                style: { padding: '0 10px' },
                required: true
              })
            )
          )
        ),
        this.state.dateWarning && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'alert alert-error', style: { 'margin-top': '5px' } },
          Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Please enter a valid date in the future')
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'modal-footer' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-default',
              onClick: this.props.onCanceled
            },
            Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Cancel')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-primary', onClick: this.snoozeClicked },
            Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Ignore')
          )
        )
      );
    }
  }]);

  return CustomIgnoreDurationModal;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  onSelected: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onCanceled: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  show: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  label: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, _class.defaultProps = {
  label: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Ignore this issue until it occurs after ..')
}, _temp);


/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_escape__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_escape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_escape__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_stores_configStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_avatar_avatarList__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_mixins_groupState__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_utils_formatters__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_locale__ = __webpack_require__(2);














var GroupSeenBy = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'GroupSeenBy',

  mixins: [__WEBPACK_IMPORTED_MODULE_7_app_mixins_groupState__["a" /* default */]],

  render: function render() {
    var activeUser = __WEBPACK_IMPORTED_MODULE_5_app_stores_configStore__["default"].get('user');
    var group = this.getGroup();

    // NOTE: Sometimes group.seenBy is undefined, even though the /groups/{id} API
    //       endpoint guarantees an array. We haven't figured out HOW GroupSeenBy
    //       is getting incomplete group records, but in the interim, we are just
    //       gracefully handing this case.
    //
    // See: https://github.com/getsentry/sentry/issues/2387

    var seenBy = group.seenBy || [];
    if (seenBy.length === 0) {
      return null;
    }

    // Note className="seen-by" is required for responsive design
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      SeenByWrapper,
      { className: 'seen-by' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_avatar_avatarList__["a" /* default */], {
        users: seenBy.filter(function (user) {
          return activeUser.id !== user.id;
        }),
        avatarSize: 28,
        maxVisibleAvatars: 10,
        tooltipOptions: { html: true },
        renderTooltip: function renderTooltip(user) {
          return __WEBPACK_IMPORTED_MODULE_0_lodash_escape___default()(Object(__WEBPACK_IMPORTED_MODULE_8_app_utils_formatters__["a" /* userDisplayName */])(user)) + ' <br/>\n            ' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(user.lastSeen).format('LL');
        }
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        IconWrapper,
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_app_components_tooltip__["default"],
          { title: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])("People who've viewed this issue") },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(EyeIcon, { className: 'icon-eye' })
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (GroupSeenBy);

var SeenByWrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('div', {
  target: 'eks43bz0'
})('display:flex;flex-direction:row-reverse;margin-top:15px;float:right;');

var IconWrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('div', {
  target: 'eks43bz1'
})('background-color:transparent;color:#493e54;height:28px;width:28px;line-height:26px;text-align:center;margin-right:10px;');

var EyeIcon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('span', {
  target: 'eks43bz2'
})('opacity:0.4;position:relative;top:2px;');

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GroupEvents */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_mixins_groupState__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_pagination__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_searchBar__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_eventsTable_eventsTable__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_utils_withEnvironment__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_utils_queryString__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_stores_environmentStore__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_actionCreators_environments__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_components_emptyStateWarning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_components_panels__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





















var GroupEvents = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'GroupEvents',

  propTypes: {
    environment: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Environment
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_5_app_mixins_groupState__["a" /* default */]],

  getInitialState: function getInitialState() {
    var queryParams = this.props.location.query;

    var initialState = {
      eventList: [],
      loading: true,
      error: false,
      pageLinks: '',
      query: queryParams.query || ''
    };

    // If an environment is specified in the query, update the global environment
    // Otherwise if a global environment is present update the query
    var queryEnvironment = __WEBPACK_IMPORTED_MODULE_14_app_stores_environmentStore__["a" /* default */].getByName(Object(__WEBPACK_IMPORTED_MODULE_13_app_utils_queryString__["b" /* getQueryEnvironment */])(queryParams.query || ''));

    if (queryEnvironment) {
      Object(__WEBPACK_IMPORTED_MODULE_15_app_actionCreators_environments__["e" /* setActiveEnvironment */])(queryEnvironment);
    } else if (this.props.environment) {
      var newQuery = Object(__WEBPACK_IMPORTED_MODULE_13_app_utils_queryString__["c" /* getQueryStringWithEnvironment */])(initialState.query, this.props.environment.name);
      this.handleSearch(newQuery);
    }

    return initialState;
  },
  componentWillMount: function componentWillMount() {
    this.fetchData();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    // If query has changed, update the environment with the query environment
    if (nextProps.location.search !== this.props.location.search) {
      var queryParams = nextProps.location.query;

      var queryEnvironment = __WEBPACK_IMPORTED_MODULE_14_app_stores_environmentStore__["a" /* default */].getByName(Object(__WEBPACK_IMPORTED_MODULE_13_app_utils_queryString__["b" /* getQueryEnvironment */])(queryParams.query || ''));

      if (queryEnvironment) {
        Object(__WEBPACK_IMPORTED_MODULE_15_app_actionCreators_environments__["e" /* setActiveEnvironment */])(queryEnvironment);
      }

      this.setState({
        query: queryParams.query
      }, this.fetchData);
    }

    // If environment has changed, update query with new environment
    if (nextProps.environment !== this.props.environment) {
      var newQueryString = Object(__WEBPACK_IMPORTED_MODULE_13_app_utils_queryString__["c" /* getQueryStringWithEnvironment */])(nextProps.location.query.query || '', nextProps.environment ? nextProps.environment.name : null);
      this.handleSearch(newQueryString);
    }
  },
  handleSearch: function handleSearch(query) {
    var targetQueryParams = {};
    if (query !== '') targetQueryParams.query = query;

    var _props$params = this.props.params,
        groupId = _props$params.groupId,
        orgId = _props$params.orgId,
        projectId = _props$params.projectId;

    __WEBPACK_IMPORTED_MODULE_2_react_router__["browserHistory"].push({
      pathname: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/events/',
      query: targetQueryParams
    });
  },
  fetchData: function fetchData() {
    var _this = this;

    this.setState({
      loading: true,
      error: false
    });
    var query = _extends({}, this.props.location.query, { limit: 50, query: this.state.query });

    this.api.request('/issues/' + this.props.params.groupId + '/events/', {
      query: query,
      method: 'GET',
      success: function success(data, _, jqXHR) {
        _this.setState({
          eventList: data,
          error: false,
          loading: false,
          pageLinks: jqXHR.getResponseHeader('Link')
        });
      },
      error: function error(err) {
        var error = err.responseJSON || true;
        error = error.detail || true;
        _this.setState({
          error: error,
          loading: false
        });
      }
    });
  },
  renderNoQueryResults: function renderNoQueryResults() {
    var environment = this.props.environment;

    var message = environment ? Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["tct"])('Sorry, no events match your search query in the [env] environment.', {
      env: environment.displayName
    }) : Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Sorry, no events match your search query.');

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_16_app_components_emptyStateWarning__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        message
      )
    );
  },
  renderEmpty: function renderEmpty() {
    var environment = this.props.environment;

    var message = environment ? Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["tct"])("There don't seem to be any events in the [env] environment yet.", {
      env: environment.displayName
    }) : Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])("There don't seem to be any events yet.");
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_16_app_components_emptyStateWarning__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])(message)
      )
    );
  },
  renderResults: function renderResults() {
    var group = this.getGroup();
    var tagList = group.tags.filter(function (tag) {
      return tag.key !== 'user';
    }) || [];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_eventsTable_eventsTable__["a" /* default */], {
      tagList: tagList,
      events: this.state.eventList,
      params: this.props.params
    });
  },
  renderBody: function renderBody() {
    var body = void 0;

    if (this.state.loading) body = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_loadingIndicator__["default"], null);else if (this.state.error) body = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_loadingError__["default"], { message: this.state.error, onRetry: this.fetchData });else if (this.state.eventList.length > 0) body = this.renderResults();else if (this.state.query && this.state.query !== '') body = this.renderNoQueryResults();else body = this.renderEmpty();

    return body;
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { marginBottom: 20 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_searchBar__["a" /* default */], {
          defaultQuery: '',
          placeholder: Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('search event id, message, or tags'),
          query: this.state.query,
          onSearch: this.handleSearch
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_17_app_components_panels__["a" /* Panel */],
        { className: 'event-list' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_17_app_components_panels__["c" /* PanelBody */],
          null,
          this.renderBody()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_pagination__["default"], { pageLinks: this.state.pageLinks })
    );
  }
});

 // For tests
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_app_utils_withEnvironment__["a" /* default */])(GroupEvents));

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_eventsTable_eventsTableRow__ = __webpack_require__(1043);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var EventsTable = (_temp = _class = function (_React$Component) {
  _inherits(EventsTable, _React$Component);

  function EventsTable() {
    _classCallCheck(this, EventsTable);

    return _possibleConstructorReturn(this, (EventsTable.__proto__ || Object.getPrototypeOf(EventsTable)).apply(this, arguments));
  }

  _createClass(EventsTable, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          events = _props.events,
          fixedDimensions = _props.fixedDimensions,
          tagList = _props.tagList;


      var cx = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('table events-table', className);
      var hasUser = !!events.find(function (event) {
        return event.user;
      });
      var _props$params = this.props.params,
          orgId = _props$params.orgId,
          projectId = _props$params.projectId,
          groupId = _props$params.groupId;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'table',
        { className: cx },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'thead',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'tr',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'th',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('ID')
            ),
            hasUser && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'th',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('User')
            ),
            tagList.map(function (tag) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'th',
                { key: tag.key },
                tag.name
              );
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'tbody',
          null,
          events.map(function (event) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_eventsTable_eventsTableRow__["a" /* default */], {
              truncate: fixedDimensions,
              key: event.id,
              event: event,
              orgId: orgId,
              projectId: projectId,
              groupId: groupId,
              tagList: tagList,
              hasUser: hasUser
            });
          })
        )
      );
    }
  }]);

  return EventsTable;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  fixedDimensions: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  events: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Event),
  tagList: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Tag)
}, _class.defaultProps = {
  fixedDimensions: false
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (EventsTable);

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_avatar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_dateTime__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_utils_deviceNameMapper__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_less_components_eventsTableRow_less__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_less_components_eventsTableRow_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_app_less_components_eventsTableRow_less__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var EventsTableRow = (_temp2 = _class = function (_React$Component) {
  _inherits(EventsTableRow, _React$Component);

  function EventsTableRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EventsTableRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EventsTableRow.__proto__ || Object.getPrototypeOf(EventsTableRow)).call.apply(_ref, [this].concat(args))), _this), _this.getEventTitle = function (event) {
      switch (event.type) {
        case 'error':
          if (event.metadata.type && event.metadata.value) return event.metadata.type + ': ' + event.metadata.value;
          return event.metadata.type || event.metadata.value || event.metadata.title;
        case 'csp':
          return event.metadata.message;
        case 'default':
          return event.metadata.title;
        default:
          return event.message.split('\n')[0];
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EventsTableRow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          event = _props.event,
          orgId = _props.orgId,
          projectId = _props.projectId,
          groupId = _props.groupId,
          tagList = _props.tagList,
          truncate = _props.truncate,
          hasUser = _props.hasUser;

      var cx = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('events-table-row', className);
      var tagMap = {};
      event.tags.forEach(function (tag) {
        tagMap[tag.key] = tag.value;
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'tr',
        { key: event.id, className: cx },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h5',
            { className: truncate ? 'truncate' : '' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
              { to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/events/' + event.id + '/' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_dateTime__["default"], { date: event.dateCreated })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'small',
              null,
              (this.getEventTitle(event) || '').substr(0, 100)
            )
          )
        ),
        hasUser && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'td',
          { className: 'event-user table-user-info' },
          event.user ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_avatar__["a" /* default */], { user: event.user, size: 24, className: 'avatar', gravatar: false }),
            event.user.email
          ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            '\u2014'
          )
        ),
        tagList.map(function (tag) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'td',
            { key: tag.key },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: truncate ? 'truncate' : '' },
              tag.key === 'device' ? Object(__WEBPACK_IMPORTED_MODULE_7_app_utils_deviceNameMapper__["a" /* default */])(tagMap[tag.key]) : tagMap[tag.key]
            )
          );
        })
      );
    }
  }]);

  return EventsTableRow;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  hasUser: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  truncate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  orgId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  groupId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  event: __WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Event.isRequired,
  tagList: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Tag)
}, _class.defaultProps = { truncate: false }, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (EventsTableRow);

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1045);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(94)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--4-1!../../../../../../node_modules/less-loader/dist/cjs.js!./eventsTableRow.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--4-1!../../../../../../node_modules/less-loader/dist/cjs.js!./eventsTableRow.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(93)(undefined);
// imports


// module
exports.push([module.i, ".events-table-row .truncate{padding:2px 0}", ""]);

// exports


/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_events_eventEntries__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_views_groupDetails_eventToolbar__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_group_sidebar__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_mixins_groupState__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_mutedBox__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_errors_groupEventDetailsLoadingError__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_resolutionBox__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_utils_withEnvironmentInQueryString__ = __webpack_require__(69);













var GroupEventDetails = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'GroupEventDetails',

  mixins: [__WEBPACK_IMPORTED_MODULE_2_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_6_app_mixins_groupState__["a" /* default */]],

  getInitialState: function getInitialState() {
    return {
      loading: true,
      error: false,
      event: null,
      eventNavLinks: ''
    };
  },
  componentWillMount: function componentWillMount() {
    this.fetchData();
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    if (prevProps.params.eventId !== this.props.params.eventId) {
      this.fetchData();
    }
  },
  fetchData: function fetchData() {
    var _this = this;

    var eventId = this.props.params.eventId || 'latest';

    var url = eventId === 'latest' || eventId === 'oldest' ? '/issues/' + this.getGroup().id + '/events/' + eventId + '/' : '/events/' + eventId + '/';

    this.setState({
      loading: true,
      error: false
    });

    this.api.request(url, {
      success: function success(data, _, jqXHR) {
        _this.setState({
          event: data,
          error: false,
          loading: false
        });

        _this.api.bulkUpdate({
          orgId: _this.getOrganization().slug,
          projectId: _this.getProject().slug,
          itemIds: [_this.getGroup().id],
          failSilently: true,
          data: { hasSeen: true }
        });
      },
      error: function error() {
        _this.setState({
          error: true,
          loading: false
        });
      }
    });
  },
  render: function render() {
    var group = this.getGroup();
    var evt = this.state.event;
    var params = this.props.params;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'event-details-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'primary' },
          evt && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_views_groupDetails_eventToolbar__["a" /* default */], {
            group: group,
            event: evt,
            orgId: params.orgId,
            projectId: params.projectId
          }),
          group.status != 'unresolved' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'issue-status' },
            group.status === 'ignored' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_mutedBox__["a" /* default */], { statusDetails: group.statusDetails }),
            group.status === 'resolved' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_resolutionBox__["a" /* default */], { statusDetails: group.statusDetails, params: params })
          ),
          this.state.loading ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_loadingIndicator__["default"], null) : this.state.error ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_errors_groupEventDetailsLoadingError__["a" /* default */], { onRetry: this.fetchData }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_events_eventEntries__["a" /* default */], {
            group: group,
            event: evt,
            orgId: params.orgId,
            project: this.getProject()
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'secondary' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_group_sidebar__["a" /* default */], { group: group, event: evt })
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_app_utils_withEnvironmentInQueryString__["a" /* default */])(GroupEventDetails));

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flatMap__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flatMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_flatMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_mixins_groupState__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_commitRow__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_inlineSvg__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_panels__ = __webpack_require__(18);





var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
















var ExpandButton = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])('span', {
  target: 'ev9yt5i0'
})('cursor:pointer;position:absolute;right:0;top:7px;');

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_create_react_class___default()({
  displayName: 'EventCause',

  propTypes: {
    event: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    orgId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    projectId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_7_app_mixins_groupState__["a" /* default */]],

  getInitialState: function getInitialState() {
    return { committers: undefined, expanded: false };
  },
  componentDidMount: function componentDidMount() {
    this.fetchData(this.props.event);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this.props.event && nextProps.event) {
      if (this.props.event.id !== nextProps.event.id) {
        //two events, with different IDs
        this.fetchData(nextProps.event);
      }
    } else if (nextProps.event) {
      //going from having no event to having an event
      this.fetchData(nextProps.event);
    }
  },
  fetchData: function fetchData(event) {
    var _this = this;

    // TODO(dcramer): this API request happens twice, and we need a store for it
    if (!event) return;
    this.api.request('/projects/' + this.props.orgId + '/' + this.props.projectId + '/events/' + event.id + '/committers/', {
      success: function success(data, _, jqXHR) {
        _this.setState(data);
      },
      error: function error(_error) {
        _this.setState({
          committers: undefined
        });
      }
    });
  },
  getUniqueCommitsWithAuthors: function getUniqueCommitsWithAuthors() {
    var committers = this.state.committers;
    //get a list of commits with author information attached

    var commitsWithAuthors = __WEBPACK_IMPORTED_MODULE_0_lodash_flatMap___default()(committers, function (_ref) {
      var commits = _ref.commits,
          author = _ref.author;
      return commits.map(function (commit) {
        return _extends({}, commit, {
          author: author
        });
      });
    });

    //remove duplicate commits
    var uniqueCommitsWithAuthors = __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy___default()(commitsWithAuthors, function (commit) {
      return commit.id;
    });
    return uniqueCommitsWithAuthors;
  },
  render: function render() {
    var _this2 = this;

    var _state = this.state,
        committers = _state.committers,
        expanded = _state.expanded;

    if (!(committers && committers.length)) {
      return null;
    }

    var commits = this.getUniqueCommitsWithAuthors();

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: 'box' },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: 'box-header' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'h3',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Suspect Commits'),
          ' (',
          commits.length,
          ')',
          commits.length > 1 && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            ExpandButton,
            { onClick: function onClick() {
                return _this2.setState({ expanded: !expanded });
              } },
            expanded ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment,
              null,
              Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Show less'),
              ' ',
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_inlineSvg__["a" /* default */], { src: 'icon-circle-subtract', size: '16px' })
            ) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment,
              null,
              Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Show more'),
              ' ',
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_inlineSvg__["a" /* default */], { src: 'icon-circle-add', size: '16px' })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_app_components_panels__["a" /* Panel */],
          null,
          commits.slice(0, expanded ? 100 : 1).map(function (commit) {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_commitRow__["a" /* default */], { key: commit.id, commit: commit });
          })
        )
      )
    );
  }
}));

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_events_eventDataSection__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_plugins__ = __webpack_require__(252);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _class2, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var CONTEXT_TYPES = {
  default: __webpack_require__(1049).default,
  app: __webpack_require__(1050).default,
  device: __webpack_require__(1051).default,
  os: __webpack_require__(1052).default,
  runtime: __webpack_require__(1053).default,
  user: __webpack_require__(1054).default
};

function getContextComponent(type) {
  return CONTEXT_TYPES[type] || __WEBPACK_IMPORTED_MODULE_4_app_plugins__["a" /* default */].contexts[type] || CONTEXT_TYPES.default;
}

function getSourcePlugin(pluginContexts, contextType) {
  if (CONTEXT_TYPES[contextType]) {
    return null;
  }
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = pluginContexts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var plugin = _step.value;

      if (plugin.contexts.indexOf(contextType) >= 0) {
        return plugin;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return null;
}

var ContextChunk = (_temp = _class = function (_React$Component) {
  _inherits(ContextChunk, _React$Component);

  function ContextChunk() {
    var _ref;

    _classCallCheck(this, ContextChunk);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = ContextChunk.__proto__ || Object.getPrototypeOf(ContextChunk)).call.apply(_ref, [this].concat(args)));

    _this.syncPlugin = function () {
      var sourcePlugin = getSourcePlugin(_this.props.group.pluginContexts, _this.props.type);
      if (!sourcePlugin) {
        _this.setState({
          pluginLoading: false
        });
      } else {
        _this.setState({
          pluginLoading: true
        }, function () {
          __WEBPACK_IMPORTED_MODULE_4_app_plugins__["a" /* default */].load(sourcePlugin, function () {
            _this.setState({ pluginLoading: false });
          });
        });
      }
    };

    _this.renderTitle = function (component) {
      var _this$props = _this.props,
          value = _this$props.value,
          alias = _this$props.alias,
          type = _this$props.type;

      var title = null;
      if (Object(__WEBPACK_IMPORTED_MODULE_2_app_utils__["d" /* defined */])(value.title)) {
        title = value.title;
      } else {
        if (component.getTitle) {
          title = component.getTitle(value);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_2_app_utils__["d" /* defined */])(title)) {
          title = Object(__WEBPACK_IMPORTED_MODULE_2_app_utils__["s" /* toTitleCase */])(alias);
        }
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        null,
        title + ' ',
        alias !== type ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'small',
          null,
          '(',
          alias,
          ')'
        ) : null
      );
    };

    _this.state = {
      isLoading: false
    };
    return _this;
  }

  _createClass(ContextChunk, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.syncPlugin();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.group.id != this.props.group.id || prevProps.type != this.props.type) {
        this.syncPlugin();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      // if we are currently loading the plugin, just render nothing for now.
      if (this.state.pluginLoading) {
        return null;
      }

      var group = this.props.group;
      var evt = this.props.event;
      var _props = this.props,
          type = _props.type,
          alias = _props.alias,
          value = _props.value;

      var Component = getContextComponent(type);

      // this can happen if the component does not exist
      if (!Component) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_app_components_events_eventDataSection__["a" /* default */],
        {
          group: group,
          event: evt,
          key: 'context-' + alias,
          type: 'context-' + alias,
          title: this.renderTitle(Component)
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, { alias: alias, data: value })
      );
    }
  }]);

  return ContextChunk;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  event: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  group: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  alias: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp);
var ContextsInterface = (_temp2 = _class2 = function (_React$Component2) {
  _inherits(ContextsInterface, _React$Component2);

  function ContextsInterface() {
    _classCallCheck(this, ContextsInterface);

    return _possibleConstructorReturn(this, (ContextsInterface.__proto__ || Object.getPrototypeOf(ContextsInterface)).apply(this, arguments));
  }

  _createClass(ContextsInterface, [{
    key: 'render',
    value: function render() {
      var group = this.props.group;
      var evt = this.props.event;
      var children = [];
      if (!Object(__WEBPACK_IMPORTED_MODULE_2_app_utils__["m" /* objectIsEmpty */])(evt.user)) {
        children.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ContextChunk, {
          group: group,
          event: evt,
          type: 'user',
          alias: 'user',
          value: evt.user,
          key: 'user'
        }));
      }

      var value = null;
      for (var key in evt.contexts) {
        value = evt.contexts[key];
        children.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ContextChunk, {
          group: group,
          event: evt,
          type: value.type,
          alias: key,
          value: value,
          key: key
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        children
      );
    }
  }]);

  return ContextsInterface;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class2.propTypes = {
  event: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  group: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (ContextsInterface);

/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_events_contexts_contextBlock__ = __webpack_require__(173);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DefaultContextType = (_temp = _class = function (_React$Component) {
  _inherits(DefaultContextType, _React$Component);

  function DefaultContextType() {
    _classCallCheck(this, DefaultContextType);

    return _possibleConstructorReturn(this, (DefaultContextType.__proto__ || Object.getPrototypeOf(DefaultContextType)).apply(this, arguments));
  }

  _createClass(DefaultContextType, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_events_contexts_contextBlock__["a" /* default */], { data: this.props.data, alias: this.props.alias });
    }
  }]);

  return DefaultContextType;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  alias: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp);


/* harmony default export */ __webpack_exports__["default"] = (DefaultContextType);

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_events_contexts_contextBlock__ = __webpack_require__(173);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var AppContextType = (_temp = _class = function (_React$Component) {
  _inherits(AppContextType, _React$Component);

  function AppContextType() {
    _classCallCheck(this, AppContextType);

    return _possibleConstructorReturn(this, (AppContextType.__proto__ || Object.getPrototypeOf(AppContextType)).apply(this, arguments));
  }

  _createClass(AppContextType, [{
    key: 'render',
    value: function render() {
      var _props$data = this.props.data,
          app_id = _props$data.app_id,
          app_start_time = _props$data.app_start_time,
          device_app_hash = _props$data.device_app_hash,
          build_type = _props$data.build_type,
          app_identifier = _props$data.app_identifier,
          app_name = _props$data.app_name,
          app_version = _props$data.app_version,
          app_build = _props$data.app_build,
          data = _objectWithoutProperties(_props$data, ['app_id', 'app_start_time', 'device_app_hash', 'build_type', 'app_identifier', 'app_name', 'app_version', 'app_build']);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_events_contexts_contextBlock__["a" /* default */], {
        data: data,
        knownData: [['?ID', app_id], ['?Start Time', app_start_time], ['?Device', device_app_hash], ['?Build Type', build_type], ['?Bundle ID', app_identifier], ['?Bundle Name', app_name], ['?Version', app_version], ['?Build', app_build]],
        alias: this.props.alias
      });
    }
  }]);

  return AppContextType;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  alias: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp);


AppContextType.getTitle = function (value) {
  return 'App';
};

/* harmony default export */ __webpack_exports__["default"] = (AppContextType);

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_events_contexts_contextBlock__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_utils__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var DeviceContextType = (_temp2 = _class = function (_React$Component) {
  _inherits(DeviceContextType, _React$Component);

  function DeviceContextType() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DeviceContextType);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DeviceContextType.__proto__ || Object.getPrototypeOf(DeviceContextType)).call.apply(_ref, [this].concat(args))), _this), _this.formatMemory = function (memory_size, free_memory, usable_memory) {
      if (!Number.isInteger(memory_size) || memory_size <= 0 || !Number.isInteger(free_memory) || free_memory <= 0) {
        return null;
      }

      var memory = 'Total: ' + Object(__WEBPACK_IMPORTED_MODULE_3_app_utils__["i" /* formatBytes */])(memory_size) + ' / Free: ' + Object(__WEBPACK_IMPORTED_MODULE_3_app_utils__["i" /* formatBytes */])(free_memory);
      if (Number.isInteger(usable_memory) && usable_memory > 0) memory += ' / Usable: ' + Object(__WEBPACK_IMPORTED_MODULE_3_app_utils__["i" /* formatBytes */])(usable_memory);

      return memory;
    }, _this.formatStorage = function (storage_size, free_storage, external_storage_size, external_free_storage) {
      if (!Number.isInteger(storage_size) || storage_size <= 0) return null;

      var storage = 'Total: ' + Object(__WEBPACK_IMPORTED_MODULE_3_app_utils__["i" /* formatBytes */])(storage_size);
      if (Number.isInteger(free_storage) && free_storage > 0) storage += ' / Free: ' + Object(__WEBPACK_IMPORTED_MODULE_3_app_utils__["i" /* formatBytes */])(free_storage);

      if (Number.isInteger(external_storage_size) && external_storage_size > 0 && Number.isInteger(external_free_storage) && external_free_storage > 0) storage += ' (External Total: ' + Object(__WEBPACK_IMPORTED_MODULE_3_app_utils__["i" /* formatBytes */])(external_storage_size) + ' / Free: ' + Object(__WEBPACK_IMPORTED_MODULE_3_app_utils__["i" /* formatBytes */])(external_free_storage) + ')';

      return storage;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DeviceContextType, [{
    key: 'render',
    value: function render() {
      var _props$data = this.props.data,
          name = _props$data.name,
          family = _props$data.family,
          model = _props$data.model,
          model_id = _props$data.model_id,
          arch = _props$data.arch,
          battery_level = _props$data.battery_level,
          orientation = _props$data.orientation,
          simulator = _props$data.simulator,
          memory_size = _props$data.memory_size,
          free_memory = _props$data.free_memory,
          usable_memory = _props$data.usable_memory,
          storage_size = _props$data.storage_size,
          free_storage = _props$data.free_storage,
          external_storage_size = _props$data.external_storage_size,
          external_free_storage = _props$data.external_free_storage,
          boot_time = _props$data.boot_time,
          timezone = _props$data.timezone,
          data = _objectWithoutProperties(_props$data, ['name', 'family', 'model', 'model_id', 'arch', 'battery_level', 'orientation', 'simulator', 'memory_size', 'free_memory', 'usable_memory', 'storage_size', 'free_storage', 'external_storage_size', 'external_free_storage', 'boot_time', 'timezone']);

      var memory = this.formatMemory(memory_size, free_memory, usable_memory);
      var storage = this.formatStorage(storage_size, free_storage, external_storage_size, external_free_storage);
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_events_contexts_contextBlock__["a" /* default */], {
        data: data,
        knownData: [['?Name', name], ['?Family', family], ['?Model', model + (model_id ? ' (' + model_id + ')' : '')], ['?Architecture', arch], ['?Battery Level', Object(__WEBPACK_IMPORTED_MODULE_3_app_utils__["d" /* defined */])(battery_level) ? battery_level + '%' : null], ['?Orientation', orientation], ['?Memory', memory], ['?Capacity', storage], ['?Simulator', simulator], ['?Boot Time', boot_time], ['?Timezone', timezone]],
        alias: this.props.alias
      });
    }
  }]);

  return DeviceContextType;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  alias: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp2);


DeviceContextType.getTitle = function (value) {
  return 'Device';
};

/* harmony default export */ __webpack_exports__["default"] = (DeviceContextType);

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_events_contexts_contextBlock__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_utils__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var OsContextType = (_temp = _class = function (_React$Component) {
  _inherits(OsContextType, _React$Component);

  function OsContextType() {
    _classCallCheck(this, OsContextType);

    return _possibleConstructorReturn(this, (OsContextType.__proto__ || Object.getPrototypeOf(OsContextType)).apply(this, arguments));
  }

  _createClass(OsContextType, [{
    key: 'render',
    value: function render() {
      var _props$data = this.props.data,
          name = _props$data.name,
          version = _props$data.version,
          build = _props$data.build,
          kernel_version = _props$data.kernel_version,
          rooted = _props$data.rooted,
          data = _objectWithoutProperties(_props$data, ['name', 'version', 'build', 'kernel_version', 'rooted']);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_events_contexts_contextBlock__["a" /* default */], {
        data: data,
        knownData: [['?Name', name], ['?Version', version + (build ? ' (' + build + ')' : '')], ['?Kernel Version', kernel_version], ['?Rooted', Object(__WEBPACK_IMPORTED_MODULE_3_app_utils__["d" /* defined */])(rooted) ? rooted ? 'yes' : 'no' : null]],
        alias: this.props.alias
      });
    }
  }]);

  return OsContextType;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  alias: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp);


OsContextType.getTitle = function (value) {
  return 'Operating System';
};

/* harmony default export */ __webpack_exports__["default"] = (OsContextType);

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_events_contexts_contextBlock__ = __webpack_require__(173);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var RuntimeContextType = (_temp = _class = function (_React$Component) {
  _inherits(RuntimeContextType, _React$Component);

  function RuntimeContextType() {
    _classCallCheck(this, RuntimeContextType);

    return _possibleConstructorReturn(this, (RuntimeContextType.__proto__ || Object.getPrototypeOf(RuntimeContextType)).apply(this, arguments));
  }

  _createClass(RuntimeContextType, [{
    key: 'render',
    value: function render() {
      var _props$data = this.props.data,
          name = _props$data.name,
          version = _props$data.version,
          build = _props$data.build,
          data = _objectWithoutProperties(_props$data, ['name', 'version', 'build']);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_events_contexts_contextBlock__["a" /* default */], {
        data: data,
        knownData: [['Name', name], ['Version', version + (build ? ' (' + build + ')' : '')]],
        alias: this.props.alias
      });
    }
  }]);

  return RuntimeContextType;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  alias: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp);


RuntimeContextType.getTitle = function (value) {
  return 'Runtime';
};

/* harmony default export */ __webpack_exports__["default"] = (RuntimeContextType);

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_each__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_avatar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_errorBoundary__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_events_interfaces_keyValueList__ = __webpack_require__(85);


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*eslint react/jsx-key:0*/








var UserContextType = (_temp = _class = function (_React$Component) {
  _inherits(UserContextType, _React$Component);

  function UserContextType() {
    _classCallCheck(this, UserContextType);

    return _possibleConstructorReturn(this, (UserContextType.__proto__ || Object.getPrototypeOf(UserContextType)).apply(this, arguments));
  }

  _createClass(UserContextType, [{
    key: 'render',
    value: function render() {
      var user = this.props.data;
      var builtins = [];
      var children = [];

      // Handle our native attributes special
      user.id && builtins.push(['ID', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'pre',
        null,
        user.id
      )]);
      user.email && builtins.push(['Email', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'pre',
        null,
        user.email,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'a',
          { href: 'mailto:' + user.email, target: '_blank', className: 'external-icon' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('em', { className: 'icon-envelope' })
        )
      )]);
      user.username && builtins.push(['Username', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'pre',
        null,
        user.username
      )]);
      user.ip_address && builtins.push(['IP Address', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'pre',
        null,
        user.ip_address
      )]);
      user.name && builtins.push(['Name', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'pre',
        null,
        user.name
      )]);

      // We also attach user supplied data as 'user.data'
      __WEBPACK_IMPORTED_MODULE_0_lodash_each___default()(user.data, function (value, key) {
        children.push([key, value]);
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'user-widget' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'pull-left' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_avatar__["a" /* default */], { user: user, size: 48, gravatar: false })
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'table',
          { className: 'key-value table' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'tbody',
            null,
            builtins.map(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                  key = _ref2[0],
                  value = _ref2[1];

              return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'tr',
                { key: key },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'td',
                  { className: 'key', key: '0' },
                  key
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'td',
                  { className: 'value', key: '1' },
                  value
                )
              );
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_app_components_errorBoundary__["default"],
          { mini: true },
          children && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_events_interfaces_keyValueList__["a" /* default */], { data: children, isContextData: true })
        )
      );
    }
  }]);

  return UserContextType;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
}, _temp);


UserContextType.getTitle = function (value) {
  return 'User';
};

/* harmony default export */ __webpack_exports__["default"] = (UserContextType);

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OsSummary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_avatar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_utils__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _class2, _temp2, _class3, _temp3, _class4, _temp4, _class5, _temp5, _class6, _temp6;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var generateClassName = function generateClassName(name) {
  return name.split(/\d/)[0].toLowerCase().replace(/[^a-z0-9\-]+/g, '-').replace(/\-+$/, '').replace(/^\-+/, '');
};

var NoSummary = (_temp = _class = function (_React$Component) {
  _inherits(NoSummary, _React$Component);

  function NoSummary() {
    _classCallCheck(this, NoSummary);

    return _possibleConstructorReturn(this, (NoSummary.__proto__ || Object.getPrototypeOf(NoSummary)).apply(this, arguments));
  }

  _createClass(NoSummary, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'context-item' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'context-item-icon' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          null,
          this.props.title
        )
      );
    }
  }]);

  return NoSummary;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
}, _temp);
var GenericSummary = (_temp2 = _class2 = function (_React$Component2) {
  _inherits(GenericSummary, _React$Component2);

  function GenericSummary() {
    _classCallCheck(this, GenericSummary);

    return _possibleConstructorReturn(this, (GenericSummary.__proto__ || Object.getPrototypeOf(GenericSummary)).apply(this, arguments));
  }

  _createClass(GenericSummary, [{
    key: 'render',
    value: function render() {
      var data = this.props.data;

      if (Object(__WEBPACK_IMPORTED_MODULE_5_app_utils__["m" /* objectIsEmpty */])(data) || !data.name) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(NoSummary, { title: this.props.unknownTitle });
      }

      var className = generateClassName(data.name);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'context-item ' + className },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'context-item-icon' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          null,
          data.name
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'strong',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Version:')
          ),
          ' ',
          data.version || Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Unknown')
        )
      );
    }
  }]);

  return GenericSummary;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class2.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  unknownTitle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
}, _temp2);


var OsSummary = (_temp3 = _class3 = function (_React$Component3) {
  _inherits(OsSummary, _React$Component3);

  function OsSummary() {
    _classCallCheck(this, OsSummary);

    return _possibleConstructorReturn(this, (OsSummary.__proto__ || Object.getPrototypeOf(OsSummary)).apply(this, arguments));
  }

  _createClass(OsSummary, [{
    key: 'render',
    value: function render() {
      var data = this.props.data;

      if (Object(__WEBPACK_IMPORTED_MODULE_5_app_utils__["m" /* objectIsEmpty */])(data) || !data.name) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(NoSummary, { title: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Unknown OS') });
      }

      var className = generateClassName(data.name);
      var versionElement = null;

      if (data.version) {
        versionElement = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'strong',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Version:')
          ),
          ' ',
          data.version
        );
      } else if (data.kernel_version) {
        versionElement = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'strong',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Kernel:')
          ),
          ' ',
          data.kernel_version
        );
      } else {
        versionElement = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'strong',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Version:')
          ),
          ' ',
          Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Unknown')
        );
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'context-item ' + className },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'context-item-icon' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          null,
          data.name
        ),
        versionElement
      );
    }
  }]);

  return OsSummary;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class3.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp3);

var UserSummary = (_temp4 = _class4 = function (_React$Component4) {
  _inherits(UserSummary, _React$Component4);

  function UserSummary() {
    _classCallCheck(this, UserSummary);

    return _possibleConstructorReturn(this, (UserSummary.__proto__ || Object.getPrototypeOf(UserSummary)).apply(this, arguments));
  }

  _createClass(UserSummary, [{
    key: 'render',
    value: function render() {
      var user = this.props.data;

      if (Object(__WEBPACK_IMPORTED_MODULE_5_app_utils__["m" /* objectIsEmpty */])(user)) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(NoSummary, { title: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Unknown User') });
      }

      var userTitle = user.email ? user.email : user.ip_address || user.id || user.username;

      if (!userTitle) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(NoSummary, { title: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Unknown User') });
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'context-item user' },
        userTitle ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_avatar__["a" /* default */], { user: user, size: 48, className: 'context-item-icon', gravatar: false }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'context-item-icon' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          null,
          userTitle
        ),
        user.id && user.id !== userTitle ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'strong',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('ID:')
          ),
          ' ',
          user.id
        ) : user.username && user.username !== userTitle && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'strong',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Username:')
          ),
          ' ',
          user.username
        )
      );
    }
  }]);

  return UserSummary;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class4.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp4);
var DeviceSummary = (_temp5 = _class5 = function (_React$Component5) {
  _inherits(DeviceSummary, _React$Component5);

  function DeviceSummary() {
    _classCallCheck(this, DeviceSummary);

    return _possibleConstructorReturn(this, (DeviceSummary.__proto__ || Object.getPrototypeOf(DeviceSummary)).apply(this, arguments));
  }

  _createClass(DeviceSummary, [{
    key: 'render',
    value: function render() {
      var data = this.props.data;

      if (Object(__WEBPACK_IMPORTED_MODULE_5_app_utils__["m" /* objectIsEmpty */])(data)) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(NoSummary, { title: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Unknown Device') });
      }

      // TODO(dcramer): we need a better way to parse it
      var className = data.model && generateClassName(data.model);

      var subTitle = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p', null);

      if (data.arch) {
        subTitle = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'strong',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Arch:')
          ),
          ' ',
          data.arch
        );
      } else if (data.model_id) {
        subTitle = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'strong',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Model:')
          ),
          ' ',
          data.model_id
        );
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'context-item ' + className },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'context-item-icon' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          null,
          data.model ? Object(__WEBPACK_IMPORTED_MODULE_5_app_utils__["e" /* deviceNameMapper */])(data.model) : Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Unknown Device')
        ),
        subTitle
      );
    }
  }]);

  return DeviceSummary;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class5.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp5);


var MIN_CONTEXTS = 3;
var MAX_CONTEXTS = 4;
var KNOWN_CONTEXTS = [{ key: 'user', Component: UserSummary }, { key: 'browser', Component: GenericSummary, unknownTitle: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Unknown Browser') }, { key: 'runtime', Component: GenericSummary, unknownTitle: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Unknown Runtime') }, { key: 'os', Component: OsSummary }, { key: 'device', Component: DeviceSummary }];

var EventContextSummary = (_temp6 = _class6 = function (_React$Component6) {
  _inherits(EventContextSummary, _React$Component6);

  function EventContextSummary() {
    _classCallCheck(this, EventContextSummary);

    return _possibleConstructorReturn(this, (EventContextSummary.__proto__ || Object.getPrototypeOf(EventContextSummary)).apply(this, arguments));
  }

  _createClass(EventContextSummary, [{
    key: 'render',
    value: function render() {
      var evt = this.props.event;
      var contextCount = 0;

      // Add defined contexts in the declared order, until we reach the limit
      // defined by MAX_CONTEXTS.
      var contexts = KNOWN_CONTEXTS.map(function (_ref) {
        var key = _ref.key,
            Component = _ref.Component,
            props = _objectWithoutProperties(_ref, ['key', 'Component']);

        if (contextCount >= MAX_CONTEXTS) return null;
        var data = evt.contexts[key] || evt[key];
        if (Object(__WEBPACK_IMPORTED_MODULE_5_app_utils__["m" /* objectIsEmpty */])(data)) return null;
        contextCount += 1;
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, _extends({ key: key, data: data }, props));
      });

      // Bail out if all contexts are empty or only the user context is set
      if (contextCount === 0 || contextCount === 1 && contexts[0]) {
        return null;
      }

      if (contextCount < MIN_CONTEXTS) {
        // Add contents in the declared order until we have at least MIN_CONTEXTS
        // contexts in our list.
        contexts = KNOWN_CONTEXTS.map(function (_ref2, index) {
          var key = _ref2.key,
              Component = _ref2.Component,
              props = _objectWithoutProperties(_ref2, ['key', 'Component']);

          if (contexts[index]) return contexts[index];
          if (contextCount >= MIN_CONTEXTS) return null;
          contextCount += 1;
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, _extends({ key: key, data: {} }, props));
        });
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'context-summary' },
        contexts
      );
    }
  }]);

  return EventContextSummary;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class6.propTypes = {
  event: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Event.isRequired
}, _temp6);


/* harmony default export */ __webpack_exports__["a"] = (EventContextSummary);

/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqWith__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniqWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_events_eventDataSection__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_events_errorItem__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var EventErrors = (_temp = _class = function (_React$Component) {
  _inherits(EventErrors, _React$Component);

  function EventErrors() {
    var _ref;

    _classCallCheck(this, EventErrors);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = EventErrors.__proto__ || Object.getPrototypeOf(EventErrors)).call.apply(_ref, [this].concat(args)));

    _this.toggle = function () {
      _this.setState({ isOpen: !_this.state.isOpen });
    };

    _this.uniqueErrors = function (errors) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_uniqWith___default()(errors, __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default.a);
    };

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(EventErrors, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.state.isOpen != nextState.isOpen) {
        return true;
      }
      return this.props.event.id !== nextProps.event.id;
    }
  }, {
    key: 'render',
    value: function render() {
      var errors = this.uniqueErrors(this.props.event.errors);
      var numErrors = errors.length;
      var isOpen = this.state.isOpen;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_app_components_events_eventDataSection__["a" /* default */],
        {
          group: this.props.group,
          event: this.props.event,
          type: 'errors',
          className: 'errors'
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon icon-alert' }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'a',
            { className: 'pull-right', onClick: this.toggle },
            isOpen ? Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Hide') : Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Show')
          ),
          Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["tn"])('There was %d error encountered while processing this event', 'There were %d errors encountered while processing this event', numErrors)
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'ul',
          { style: { display: isOpen ? 'block' : 'none' } },
          errors.map(function (error, errorIdx) {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_events_errorItem__["a" /* default */], { key: errorIdx, error: error });
          })
        )
      );
    }
  }]);

  return EventErrors;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  group: __WEBPACK_IMPORTED_MODULE_5_app_proptypes__["e" /* default */].Group.isRequired,
  event: __WEBPACK_IMPORTED_MODULE_5_app_proptypes__["e" /* default */].Event.isRequired
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (EventErrors);

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(416);

/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */
function uniqWith(array, comparator) {
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
}

module.exports = uniqWith;


/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_startCase__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_startCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_startCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_events_interfaces_keyValueList__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);




var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var keyMapping = {
  image_uuid: 'Debug ID',
  image_name: 'File Name',
  image_path: 'File Path'
};

var EventErrorItem = (_temp = _class = function (_React$Component) {
  _inherits(EventErrorItem, _React$Component);

  function EventErrorItem() {
    var _ref;

    _classCallCheck(this, EventErrorItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = EventErrorItem.__proto__ || Object.getPrototypeOf(EventErrorItem)).call.apply(_ref, [this].concat(args)));

    _this.toggle = function () {
      _this.setState({ isOpen: !_this.state.isOpen });
    };

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(EventErrorItem, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.state.isOpen !== nextState.isOpen;
    }
  }, {
    key: 'cleanedData',
    value: function cleanedData() {
      var data = _extends({}, this.props.error.data);

      if (data.message === 'None') {
        // Python ensures a message string, but "None" doesn't make sense here
        delete data.message;
      }

      if (typeof data.image_path === 'string') {
        // Separate the image name for readability
        var separator = /^[a-z]:\\/i.test(data.image_path) ? '\\' : '/';
        var path = data.image_path.split(separator);
        data.image_name = path.splice(-1, 1)[0];
        data.image_path = path.length ? path.join(separator) + separator : '';
      }

      return __WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys___default()(data, function (value, key) {
        return Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])(keyMapping[key] || __WEBPACK_IMPORTED_MODULE_1_lodash_startCase___default()(key));
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var error = this.props.error;
      var isOpen = this.state.isOpen;
      var data = this.cleanedData();
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'li',
        null,
        error.message,
        !__WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default()(data) && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'small',
          null,
          ' ',
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'a',
            { style: { marginLeft: 10 }, onClick: this.toggle },
            isOpen ? Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Collapse') : Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Expand')
          )
        ),
        isOpen && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_events_interfaces_keyValueList__["a" /* default */], { data: data, isContextData: true })
      );
    }
  }]);

  return EventErrorItem;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component), _class.propTypes = {
  error: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (EventErrorItem);

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(1060),
    upperFirst = __webpack_require__(536);

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

module.exports = startCase;


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(535),
    deburr = __webpack_require__(1061),
    words = __webpack_require__(1062);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),
/* 1061 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

var asciiWords = __webpack_require__(1063),
    hasUnicodeWord = __webpack_require__(1064),
    toString = __webpack_require__(219),
    unicodeWords = __webpack_require__(1065);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),
/* 1063 */
/***/ (function(module, exports) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),
/* 1064 */
/***/ (function(module, exports) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),
/* 1065 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
    rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(1067),
    hasUnicode = __webpack_require__(537),
    stringToArray = __webpack_require__(1069),
    toString = __webpack_require__(219);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(1068);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 1068 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(1070),
    hasUnicode = __webpack_require__(537),
    unicodeToArray = __webpack_require__(1071);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 1070 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 1071 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(224),
    baseForOwn = __webpack_require__(314),
    baseIteratee = __webpack_require__(123);

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;


/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_errorBoundary__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_events_eventDataSection__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_events_interfaces_keyValueList__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_proptypes__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var EventExtraData = (_temp = _class = function (_React$Component) {
  _inherits(EventExtraData, _React$Component);

  function EventExtraData() {
    var _ref;

    _classCallCheck(this, EventExtraData);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = EventExtraData.__proto__ || Object.getPrototypeOf(EventExtraData)).call.apply(_ref, [this].concat(args)));

    _this.toggleRaw = function (shouldBeRaw) {
      _this.setState({
        raw: shouldBeRaw
      });
    };

    _this.state = {
      raw: false
    };
    return _this;
  }

  _createClass(EventExtraData, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.props.event.id !== nextProps.event.id || this.state.raw !== nextState.raw;
    }
  }, {
    key: 'render',
    value: function render() {
      var extraDataArray = Object(__WEBPACK_IMPORTED_MODULE_1_app_utils__["n" /* objectToArray */])(this.props.event.context);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'extra-data' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_app_components_events_eventDataSection__["a" /* default */],
          {
            group: this.props.group,
            event: this.props.event,
            type: 'extra',
            title: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Additional Data'),
            toggleRaw: this.toggleRaw,
            raw: this.state.raw
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_app_components_errorBoundary__["default"],
            { mini: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_events_interfaces_keyValueList__["a" /* default */], {
              data: extraDataArray,
              isContextData: true,
              raw: this.state.raw
            })
          )
        )
      );
    }
  }]);

  return EventExtraData;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  group: __WEBPACK_IMPORTED_MODULE_6_app_proptypes__["e" /* default */].Group.isRequired,
  event: __WEBPACK_IMPORTED_MODULE_6_app_proptypes__["e" /* default */].Event.isRequired
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (EventExtraData);

/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_clippedBox__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_errorBoundary__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_events_eventDataSection__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_events_interfaces_keyValueList__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_proptypes__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var EventPackageData = (_temp = _class = function (_React$Component) {
  _inherits(EventPackageData, _React$Component);

  function EventPackageData() {
    _classCallCheck(this, EventPackageData);

    return _possibleConstructorReturn(this, (EventPackageData.__proto__ || Object.getPrototypeOf(EventPackageData)).apply(this, arguments));
  }

  _createClass(EventPackageData, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.props.event.id !== nextProps.event.id;
    }
  }, {
    key: 'render',
    value: function render() {
      var packages = Object(__WEBPACK_IMPORTED_MODULE_1_app_utils__["n" /* objectToArray */])(this.props.event.packages);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_app_components_events_eventDataSection__["a" /* default */],
        {
          group: this.props.group,
          event: this.props.event,
          type: 'packages',
          title: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Packages')
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_app_components_clippedBox__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_app_components_errorBoundary__["default"],
            { mini: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_events_interfaces_keyValueList__["a" /* default */], { data: packages })
          )
        )
      );
    }
  }]);

  return EventPackageData;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  group: __WEBPACK_IMPORTED_MODULE_7_app_proptypes__["e" /* default */].Group.isRequired,
  event: __WEBPACK_IMPORTED_MODULE_7_app_proptypes__["e" /* default */].Event.isRequired
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (EventPackageData);

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_events_eventDataSection__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_pills__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_pill__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_versionHoverCard__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_inlineSvg__ = __webpack_require__(24);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var EventTags = (_temp = _class = function (_React$Component) {
  _inherits(EventTags, _React$Component);

  function EventTags() {
    _classCallCheck(this, EventTags);

    return _possibleConstructorReturn(this, (EventTags.__proto__ || Object.getPrototypeOf(EventTags)).apply(this, arguments));
  }

  _createClass(EventTags, [{
    key: 'render',
    value: function render() {
      var tags = this.props.event.tags;
      if (__WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default()(tags)) return null;

      var _props = this.props,
          orgId = _props.orgId,
          projectId = _props.projectId;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_app_components_events_eventDataSection__["a" /* default */],
        {
          group: this.props.group,
          event: this.props.event,
          title: Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('Tags'),
          type: 'tags',
          className: 'p-b-1'
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_app_components_pills__["a" /* default */],
          { className: 'no-margin' },
          tags.map(function (tag) {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_app_components_pill__["a" /* default */],
              { key: tag.key, name: tag.key },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router__["Link"],
                {
                  to: {
                    pathname: '/' + orgId + '/' + projectId + '/',
                    query: { query: tag.key + ':"' + tag.value + '"' }
                  }
                },
                Object(__WEBPACK_IMPORTED_MODULE_6_app_utils__["e" /* deviceNameMapper */])(tag.value)
              ),
              Object(__WEBPACK_IMPORTED_MODULE_6_app_utils__["l" /* isUrl */])(tag.value) && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'a',
                { href: tag.value, className: 'external-icon' },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('em', { className: 'icon-open' })
              ),
              tag.key == 'release' && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_app_components_versionHoverCard__["a" /* default */],
                {
                  containerClassName: 'pill-icon',
                  version: tag.value,
                  orgId: orgId,
                  projectId: projectId
                },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_react_router__["Link"],
                  { to: '/' + orgId + '/' + projectId + '/releases/' + tag.value + '/' },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_inlineSvg__["a" /* default */], { src: 'icon-circle-info', size: '14px' })
                )
              )
            );
          })
        )
      );
    }
  }]);

  return EventTags;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  group: __WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Group.isRequired,
  event: __WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Event.isRequired,
  orgId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  projectId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (EventTags);

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(391);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The opposite of `_.before`; this method creates a function that invokes
 * `func` once it's called `n` or more times.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {number} n The number of calls before `func` is invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var saves = ['profile', 'settings'];
 *
 * var done = _.after(saves.length, function() {
 *   console.log('done saving!');
 * });
 *
 * _.forEach(saves, function(type) {
 *   asyncSave({ 'type': type, 'complete': done });
 * });
 * // => Logs 'done saving!' after the two async saves have completed.
 */
function after(n, func) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n = toInteger(n);
  return function() {
    if (--n < 1) {
      return func.apply(this, arguments);
    }
  };
}

module.exports = after;


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(185),
    baseIntersection = __webpack_require__(1078),
    baseRest = __webpack_require__(415),
    castArrayLikeObject = __webpack_require__(1079);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(308),
    arrayIncludes = __webpack_require__(491),
    arrayIncludesWith = __webpack_require__(492),
    arrayMap = __webpack_require__(185),
    baseUnary = __webpack_require__(488),
    cacheHas = __webpack_require__(309);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(641);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_events_eventDataSection__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var EventSdk = (_temp = _class = function (_React$Component) {
  _inherits(EventSdk, _React$Component);

  function EventSdk() {
    _classCallCheck(this, EventSdk);

    return _possibleConstructorReturn(this, (EventSdk.__proto__ || Object.getPrototypeOf(EventSdk)).apply(this, arguments));
  }

  _createClass(EventSdk, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          group = _props.group,
          event = _props.event;

      var data = event.sdk;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_app_components_events_eventDataSection__["a" /* default */],
        {
          group: group,
          event: event,
          type: 'sdk',
          title: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('SDK'),
          wrapTitle: true
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'table',
          { className: 'table key-value' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'tbody',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              { key: 'name' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                { className: 'key' },
                Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Name')
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                { className: 'value' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'pre',
                  null,
                  data.name
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              { key: 'version' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                { className: 'key' },
                Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Version')
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                { className: 'value' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'pre',
                  null,
                  data.version
                )
              )
            )
          )
        )
      );
    }
  }]);

  return EventSdk;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  group: __WEBPACK_IMPORTED_MODULE_1_app_proptypes__["e" /* default */].Group.isRequired,
  event: __WEBPACK_IMPORTED_MODULE_1_app_proptypes__["e" /* default */].Event.isRequired
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (EventSdk);

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_events_eventDataSection__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_contextData__ = __webpack_require__(315);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// TODO(hazat): Is this interface used somewhere? If not delete it?
var DeviceInterface = (_temp = _class = function (_React$Component) {
  _inherits(DeviceInterface, _React$Component);

  function DeviceInterface() {
    _classCallCheck(this, DeviceInterface);

    return _possibleConstructorReturn(this, (DeviceInterface.__proto__ || Object.getPrototypeOf(DeviceInterface)).apply(this, arguments));
  }

  _createClass(DeviceInterface, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          group = _props.group,
          event = _props.event;

      var data = event.device;
      var extras = Object.keys(data.data || {}).map(function (key) {
        var value = data.data[key];
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'tr',
          { key: key },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'td',
            { className: 'key' },
            key
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'td',
            { className: 'value' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_contextData__["a" /* default */], { data: value })
          )
        );
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_app_components_events_eventDataSection__["a" /* default */],
        {
          group: group,
          event: event,
          type: 'device',
          title: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Device'),
          wrapTitle: true
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'table',
          { className: 'table key-value' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'tbody',
            null,
            data.name && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                { className: 'key' },
                'Name'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                { className: 'value' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'pre',
                  null,
                  data.name
                )
              )
            ),
            data.version && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                { className: 'key' },
                'Version'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                { className: 'value' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'pre',
                  null,
                  data.version
                )
              )
            ),
            data.build && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                { className: 'key' },
                'Build'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                { className: 'value' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'pre',
                  null,
                  data.build
                )
              )
            ),
            extras
          )
        )
      );
    }
  }]);

  return DeviceInterface;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  group: __WEBPACK_IMPORTED_MODULE_2_app_proptypes__["e" /* default */].Group.isRequired,
  event: __WEBPACK_IMPORTED_MODULE_2_app_proptypes__["e" /* default */].Event.isRequired
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (DeviceInterface);

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_events_eventDataSection__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_events_interfaces_stacktrace__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_events_interfaces_crashHeader__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_events_interfaces_crashContent__ = __webpack_require__(348);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ExceptionInterface = (_temp = _class = function (_React$Component) {
  _inherits(ExceptionInterface, _React$Component);

  function ExceptionInterface() {
    var _ref;

    _classCallCheck(this, ExceptionInterface);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = ExceptionInterface.__proto__ || Object.getPrototypeOf(ExceptionInterface)).call.apply(_ref, [this].concat(args)));

    _this.eventHasThreads = function () {
      return !!_this.props.event.entries.find(function (x) {
        return x.type === 'threads';
      });
    };

    _this.state = {
      stackView: _this.props.data.hasSystemFrames ? 'app' : 'full',
      newestFirst: Object(__WEBPACK_IMPORTED_MODULE_5_app_components_events_interfaces_stacktrace__["b" /* isStacktraceNewestFirst */])(),
      stackType: 'original'
    };
    return _this;
  }

  _createClass(ExceptionInterface, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var group = this.props.group;
      var event = this.props.event;
      var data = this.props.data;
      var stackView = this.state.stackView;
      var stackType = this.state.stackType;
      var newestFirst = this.state.newestFirst;

      // in case there are threads in the event data, we don't render the
      // exception block.  Instead the exception is contained within the
      // thread interface.
      if (this.eventHasThreads()) {
        return null;
      }

      var title = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_events_interfaces_crashHeader__["a" /* default */], {
        group: group,
        title: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Exception'),
        platform: event.platform,
        exception: data,
        stackView: stackView,
        newestFirst: newestFirst,
        stackType: stackType,
        onChange: function onChange(newState) {
          _this2.setState(newState);
        }
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_app_components_events_eventDataSection__["a" /* default */],
        {
          group: group,
          event: event,
          type: this.props.type,
          title: title,
          wrapTitle: false
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_events_interfaces_crashContent__["a" /* default */], {
          group: group,
          event: event,
          stackType: stackType,
          stackView: stackView,
          newestFirst: newestFirst,
          exception: data
        })
      );
    }
  }]);

  return ExceptionInterface;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  group: __WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Group.isRequired,
  event: __WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Event.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (ExceptionInterface);

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_events_interfaces_stacktraceContent__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_events_interfaces_exceptionMechanism__ = __webpack_require__(1084);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ExceptionContent = (_temp = _class = function (_React$Component) {
  _inherits(ExceptionContent, _React$Component);

  function ExceptionContent() {
    _classCallCheck(this, ExceptionContent);

    return _possibleConstructorReturn(this, (ExceptionContent.__proto__ || Object.getPrototypeOf(ExceptionContent)).apply(this, arguments));
  }

  _createClass(ExceptionContent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var stackView = this.props.view;
      var newestFirst = this.props.newestFirst;
      var children = this.props.values.map(function (exc, excIdx) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { key: excIdx, className: 'exception' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h5',
            { className: 'break-word', style: { marginBottom: 5 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              null,
              exc.type
            )
          ),
          exc.value && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'pre',
            { className: 'exc-message', style: { marginTop: 0 } },
            exc.value
          ),
          exc.mechanism && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_events_interfaces_exceptionMechanism__["a" /* default */], { data: exc.mechanism, platform: _this2.props.platform }),
          Object(__WEBPACK_IMPORTED_MODULE_2_app_utils__["d" /* defined */])(exc.stacktrace) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_events_interfaces_stacktraceContent__["a" /* default */], {
            data: _this2.props.type === 'original' ? exc.stacktrace : exc.rawStacktrace || exc.stacktrace,
            expandFirstFrame: excIdx === 0,
            includeSystemFrames: stackView === 'full',
            platform: _this2.props.platform,
            newestFirst: newestFirst
          })
        );
      });
      if (newestFirst) {
        children.reverse();
      }

      // TODO(dcramer): implement exceptions omitted
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        children
      );
    }
  }]);

  return ExceptionContent;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['original', 'minified']),
  values: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,
  view: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  platform: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  newestFirst: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (ExceptionContent);

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isObject__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forOwn__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forOwn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_forOwn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_pills__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_pill__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_hovercard__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_inlineSvg__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_locale__ = __webpack_require__(2);




var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ExceptionMechanism = (_temp = _class = function (_React$Component) {
  _inherits(ExceptionMechanism, _React$Component);

  function ExceptionMechanism() {
    _classCallCheck(this, ExceptionMechanism);

    return _possibleConstructorReturn(this, (ExceptionMechanism.__proto__ || Object.getPrototypeOf(ExceptionMechanism)).apply(this, arguments));
  }

  _createClass(ExceptionMechanism, [{
    key: 'render',
    value: function render() {
      var mechanism = this.props.data;
      var type = mechanism.type,
          description = mechanism.description,
          help_link = mechanism.help_link,
          handled = mechanism.handled,
          _mechanism$meta = mechanism.meta,
          meta = _mechanism$meta === undefined ? {} : _mechanism$meta,
          _mechanism$data = mechanism.data,
          data = _mechanism$data === undefined ? {} : _mechanism$data;
      var errno = meta.errno,
          signal = meta.signal,
          mach_exception = meta.mach_exception;


      var linkElement = help_link && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'a',
        { href: help_link, className: 'external-icon' },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('em', { className: 'icon-open' })
      );

      var descriptionElement = description && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_app_components_hovercard__["a" /* default */],
        {
          header: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'span',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Details'),
            ' ',
            linkElement
          ),
          body: description,
          containerClassName: 'pill-icon'
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_inlineSvg__["a" /* default */], { src: 'icon-circle-info', size: '14px' })
      );

      var pills = [__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_app_components_pill__["a" /* default */],
        { key: 'mechanism', name: 'mechanism', value: type },
        descriptionElement || linkElement
      )];

      if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(handled)) {
        pills.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_pill__["a" /* default */], { key: 'handled', name: 'handled', value: handled }));
      }

      if (errno) {
        var value = errno.name || errno.number;
        pills.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_pill__["a" /* default */], { key: 'errno', name: 'errno', value: value }));
      }

      if (mach_exception) {
        var _value = mach_exception.name || mach_exception.exception;
        pills.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_pill__["a" /* default */], { key: 'mach', name: 'mach exception', value: _value }));
      }

      if (signal) {
        var code = signal.code_name || Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('code') + ' ' + signal.code;
        var name = signal.name || signal.number;
        var _value2 = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(signal.code) ? name : name + ' (' + code + ')';
        pills.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_pill__["a" /* default */], { key: 'signal', name: 'signal', value: _value2 }));
      }

      __WEBPACK_IMPORTED_MODULE_1_lodash_forOwn___default()(data, function (value, key) {
        if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default()(value)) {
          pills.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_pill__["a" /* default */], { key: 'data:' + key, name: key, value: value }));
        }
      });

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'div',
        { className: 'exception-mechanism' },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_app_components_pills__["a" /* default */],
          null,
          pills
        )
      );
    }
  }]);

  return ExceptionMechanism;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component), _class.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
    description: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    help_link: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    handled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    meta: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
      errno: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
        number: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
        name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
      }),
      mach_exception: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
        exception: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
        code: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
        subcode: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
        name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
      }),
      signal: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
        number: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
        code: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.nubmer,
        name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
        code_name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
      })
    }),
    data: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  }).isRequired
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (ExceptionMechanism);

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(314),
    castFunction = __webpack_require__(494);

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && baseForOwn(object, castFunction(iteratee));
}

module.exports = forOwn;


/***/ }),
/* 1086 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_events_interfaces_rawStacktraceContent__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_clippedBox__ = __webpack_require__(189);









var RawExceptionContent = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'RawExceptionContent',

  propTypes: {
    type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['original', 'minified']),
    platform: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    eventId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    values: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    return {
      loading: false,
      error: false,
      crashReport: ''
    };
  },
  componentDidMount: function componentDidMount() {
    if (this.isNative()) {
      this.fetchAppleCrashReport();
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    if (this.isNative() && this.props.type !== prevProps.type) {
      this.fetchAppleCrashReport();
    }
  },
  isNative: function isNative() {
    var platform = this.props.platform;

    return platform === 'cocoa' || platform === 'native';
  },
  getAppleCrashReportEndpoint: function getAppleCrashReportEndpoint() {
    var minified = this.props.type == 'minified';
    return '/events/' + this.props.eventId + '/apple-crash-report?minified=' + minified;
  },
  fetchAppleCrashReport: function fetchAppleCrashReport() {
    var _this = this;

    this.setState({
      loading: true,
      error: false,
      crashReport: ''
    });
    this.api.request(this.getAppleCrashReportEndpoint(), {
      method: 'GET',
      success: function success(data) {
        _this.setState({
          error: false,
          loading: false,
          crashReport: data
        });
      },
      error: function error() {
        _this.setState({
          error: true,
          loading: false
        });
      }
    });
  },
  render: function render() {
    var _this2 = this;

    var type = this.props.type;

    var downloadButton = void 0;
    var children = this.props.values.map(function (exc, excIdx) {
      var content = exc.stacktrace && Object(__WEBPACK_IMPORTED_MODULE_3_app_components_events_interfaces_rawStacktraceContent__["a" /* default */])(type === 'original' ? exc.stacktrace : exc.rawStacktrace, _this2.props.platform, exc);
      if (_this2.isNative()) {
        if (_this2.state.loading) content = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_loadingIndicator__["default"], null);else if (_this2.state.error) content = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_loadingError__["default"], { onRetry: _this2.fetchData });else if (!_this2.state.loading && _this2.state.crashReport != '') {
          content = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_app_components_clippedBox__["a" /* default */],
            { clipHeight: 250 },
            _this2.state.crashReport
          );
          downloadButton = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            {
              href: _this2.api.baseUrl + _this2.getAppleCrashReportEndpoint() + '&download=1',
              className: 'btn btn-default btn-sm pull-right'
            },
            'Download'
          );
        }
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { key: excIdx },
        downloadButton,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'pre',
          { className: 'traceback plain' },
          content
        )
      );
    });

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      null,
      children
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RawExceptionContent);

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_events_eventDataSection__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var MessageInterface = (_temp = _class = function (_React$Component) {
  _inherits(MessageInterface, _React$Component);

  function MessageInterface() {
    _classCallCheck(this, MessageInterface);

    return _possibleConstructorReturn(this, (MessageInterface.__proto__ || Object.getPrototypeOf(MessageInterface)).apply(this, arguments));
  }

  _createClass(MessageInterface, [{
    key: 'render',
    value: function render() {
      var data = this.props.data;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_app_components_events_eventDataSection__["a" /* default */],
        {
          group: this.props.group,
          event: this.props.event,
          type: 'message',
          title: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Message')
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('pre', {
          className: 'plain',
          dangerouslySetInnerHTML: {
            __html: __WEBPACK_IMPORTED_MODULE_4_app_utils__["c" /* default */].nl2br(__WEBPACK_IMPORTED_MODULE_4_app_utils__["c" /* default */].escape(data.formatted || data.message))
          }
        }),
        data.params && !data.formatted && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h5',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Params')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'pre',
            { className: 'plain' },
            JSON.stringify(data.params, null, 2)
          )
        )
      );
    }
  }]);

  return MessageInterface;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  group: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Group.isRequired,
  event: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Event.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (MessageInterface);

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_events_eventDataSection__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_events_interfaces_richHttpContent__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_events_interfaces_utils__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_truncate__ = __webpack_require__(413);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var RequestInterface = (_temp = _class = function (_React$Component) {
  _inherits(RequestInterface, _React$Component);

  function RequestInterface() {
    var _ref;

    _classCallCheck(this, RequestInterface);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = RequestInterface.__proto__ || Object.getPrototypeOf(RequestInterface)).call.apply(_ref, [this].concat(args)));

    _this.isPartial = function () {
      // We assume we only have a partial interface is we're missing
      // an HTTP method. This means we don't have enough information
      // to reliably construct a full HTTP request.
      return !_this.props.data.method;
    };

    _this.toggleView = function (value) {
      _this.setState({
        view: value
      });
    };

    _this.state = {
      view: 'formatted'
    };
    return _this;
  }

  _createClass(RequestInterface, [{
    key: 'render',
    value: function render() {
      var group = this.props.group;
      var evt = this.props.event;
      var data = this.props.data;
      var view = this.state.view;

      var fullUrl = data.url;
      if (data.query) {
        fullUrl = fullUrl + '?' + data.query;
      }
      if (data.fragment) {
        fullUrl = fullUrl + '#' + data.fragment;
      }

      // lol
      var parsedUrl = document.createElement('a');
      parsedUrl.href = fullUrl;

      var children = [];

      // Check if the url passed in is a safe url to avoid XSS
      var isValidUrl = Object(__WEBPACK_IMPORTED_MODULE_6_app_utils__["l" /* isUrl */])(fullUrl);

      if (!this.isPartial() && isValidUrl) {
        children.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { key: 'view-buttons', className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            {
              className: (view === 'formatted' ? 'active' : '') + ' btn btn-default btn-sm',
              onClick: this.toggleView.bind(this, 'formatted')
            },
            /* Translators: this means "formatted" rendering (fancy tables) */
            Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('Formatted')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            {
              className: (view === 'curl' ? 'active' : '') + ' btn btn-default btn-sm',
              onClick: this.toggleView.bind(this, 'curl')
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'code',
              null,
              'curl'
            )
          )
        ));
      }

      children.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'h3',
        { key: 'title' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          { href: isValidUrl ? fullUrl : null, title: fullUrl },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'path' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'strong',
              null,
              data.method || 'GET'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_truncate__["a" /* default */], { value: parsedUrl.pathname, maxLength: 36, leftTrim: true })
          ),
          isValidUrl && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'external-icon' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em', { className: 'icon-open' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'small',
          { style: { marginLeft: 10 }, className: 'host' },
          parsedUrl.hostname
        )
      ));

      var title = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        children
      );

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_app_components_events_eventDataSection__["a" /* default */],
        {
          group: group,
          event: evt,
          type: this.props.type,
          title: title,
          wrapTitle: false,
          className: 'request'
        },
        view === 'curl' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'pre',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_5_app_components_events_interfaces_utils__["a" /* getCurlCommand */])(data)
        ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_events_interfaces_richHttpContent__["a" /* default */], { data: data })
      );
    }
  }]);

  return RequestInterface;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  group: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Group.isRequired,
  event: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Event.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  isShare: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _class.contextTypes = {
  organization: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Organization,
  project: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Project
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (RequestInterface);

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_events_interfaces_utils__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_clippedBox__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_contextData__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_errorBoundary__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_events_interfaces_keyValueList__ = __webpack_require__(85);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var RichHttpContent = (_temp2 = _class = function (_React$Component) {
  _inherits(RichHttpContent, _React$Component);

  function RichHttpContent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RichHttpContent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RichHttpContent.__proto__ || Object.getPrototypeOf(RichHttpContent)).call.apply(_ref, [this].concat(args))), _this), _this.getBodySection = function (data) {
      // The http interface provides an inferred content type for the data body.
      switch (data.inferredContentType) {
        case 'application/json':
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_contextData__["a" /* default */], { data: data.data });
        case 'application/x-www-form-urlencoded':
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_events_interfaces_keyValueList__["a" /* default */], { data: Object(__WEBPACK_IMPORTED_MODULE_4_app_components_events_interfaces_utils__["b" /* objectToSortedTupleArray */])(data.data), isContextData: true });
        default:
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'pre',
            null,
            JSON.stringify(data.data, null, 2)
          );
      }
    }, _this.getQueryStringOrRaw = function (data) {
      try {
        // Sentry API abbreviates long query string values, sometimes resulting in
        // an un-parsable querystring ... stay safe kids
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_events_interfaces_keyValueList__["a" /* default */], {
          data: Object(__WEBPACK_IMPORTED_MODULE_4_app_components_events_interfaces_utils__["b" /* objectToSortedTupleArray */])(__WEBPACK_IMPORTED_MODULE_2_query_string___default.a.parse(data)),
          isContextData: true
        });
      } catch (e) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'pre',
          null,
          data
        );
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RichHttpContent, [{
    key: 'render',
    value: function render() {
      var data = this.props.data;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        data.query && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_app_components_clippedBox__["a" /* default */],
          { title: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Query String') },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_app_components_errorBoundary__["default"],
            { mini: true },
            this.getQueryStringOrRaw(data.query)
          )
        ),
        data.fragment && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_app_components_clippedBox__["a" /* default */],
          { title: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Fragment') },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_app_components_errorBoundary__["default"],
            { mini: true },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'pre',
              null,
              data.fragment
            )
          )
        ),
        data.data && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_app_components_clippedBox__["a" /* default */],
          { title: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Body') },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_app_components_errorBoundary__["default"],
            { mini: true },
            this.getBodySection(data)
          )
        ),
        data.cookies && !Object(__WEBPACK_IMPORTED_MODULE_3_app_utils__["m" /* objectIsEmpty */])(data.cookies) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_app_components_clippedBox__["a" /* default */],
          { title: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Cookies'), defaultCollapsed: true },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_app_components_errorBoundary__["default"],
            { mini: true },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_events_interfaces_keyValueList__["a" /* default */], { data: data.cookies })
          )
        ),
        !Object(__WEBPACK_IMPORTED_MODULE_3_app_utils__["m" /* objectIsEmpty */])(data.headers) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_app_components_clippedBox__["a" /* default */],
          { title: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Headers') },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_app_components_errorBoundary__["default"],
            { mini: true },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_events_interfaces_keyValueList__["a" /* default */], { data: data.headers })
          )
        ),
        !Object(__WEBPACK_IMPORTED_MODULE_3_app_utils__["m" /* objectIsEmpty */])(data.env) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_app_components_clippedBox__["a" /* default */],
          { title: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Environment'), defaultCollapsed: true },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_app_components_errorBoundary__["default"],
            { mini: true },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_events_interfaces_keyValueList__["a" /* default */], { data: Object(__WEBPACK_IMPORTED_MODULE_4_app_components_events_interfaces_utils__["b" /* objectToSortedTupleArray */])(data.env) })
          )
        )
      );
    }
  }]);

  return RichHttpContent;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (RichHttpContent);

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_events_eventDataSection__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_events_interfaces_frame__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var TemplateInterface = (_temp = _class = function (_React$Component) {
  _inherits(TemplateInterface, _React$Component);

  function TemplateInterface() {
    _classCallCheck(this, TemplateInterface);

    return _possibleConstructorReturn(this, (TemplateInterface.__proto__ || Object.getPrototypeOf(TemplateInterface)).apply(this, arguments));
  }

  _createClass(TemplateInterface, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_app_components_events_eventDataSection__["a" /* default */],
        {
          group: this.props.group,
          event: this.props.event,
          type: this.props.type,
          title: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Template')
          )
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'traceback no-exception' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'ul',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_events_interfaces_frame__["a" /* default */], { data: this.props.data, isExpanded: true })
          )
        )
      );
    }
  }]);

  return TemplateInterface;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  group: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Group.isRequired,
  event: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Event.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (TemplateInterface);

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CspInterface; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_events_eventDataSection__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_events_interfaces_cspContent__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_events_interfaces_cspHelp__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










function getView(view, data) {
  switch (view) {
    case 'report':
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_events_interfaces_cspContent__["a" /* default */], { data: data });
    case 'raw':
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'pre',
        null,
        JSON.stringify({ 'csp-report': data }, null, 2)
      );
    case 'help':
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_events_interfaces_cspHelp__["a" /* default */], { data: data });
    default:
      throw new TypeError('Invalid view: ' + view);
  }
}

var CspInterface = (_temp = _class = function (_React$Component) {
  _inherits(CspInterface, _React$Component);

  function CspInterface(props) {
    _classCallCheck(this, CspInterface);

    var _this = _possibleConstructorReturn(this, (CspInterface.__proto__ || Object.getPrototypeOf(CspInterface)).call(this, props));

    _this.toggleView = function (value) {
      _this.setState({
        view: value
      });
    };

    var data = props.data;
    // hide the report-uri since this is redundant and silly

    data.original_policy = data.original_policy.replace(/(;\s+)?report-uri [^;]+/, '');

    _this.state = {
      view: 'report',
      data: data
    };
    return _this;
  }

  _createClass(CspInterface, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          view = _state.view,
          data = _state.data;
      var _props = this.props,
          group = _props.group,
          event = _props.event;


      var title = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            {
              className: (view === 'report' ? 'active' : '') + ' btn btn-default btn-sm',
              onClick: this.toggleView.bind(this, 'report')
            },
            Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Report')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            {
              className: (view === 'raw' ? 'active' : '') + ' btn btn-default btn-sm',
              onClick: this.toggleView.bind(this, 'raw')
            },
            Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Raw')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            {
              className: (view === 'help' ? 'active' : '') + ' btn btn-default btn-sm',
              onClick: this.toggleView.bind(this, 'help')
            },
            Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Help')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('CSP Report')
        )
      );

      var children = getView(view, data);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_app_components_events_eventDataSection__["a" /* default */],
        {
          group: group,
          event: event,
          type: 'csp',
          title: title,
          wrapTitle: false
        },
        children
      );
    }
  }]);

  return CspInterface;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  group: __WEBPACK_IMPORTED_MODULE_2_app_proptypes__["e" /* default */].Group.isRequired,
  event: __WEBPACK_IMPORTED_MODULE_2_app_proptypes__["e" /* default */].Event.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp);


/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_events_interfaces_keyValueList__ = __webpack_require__(85);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var CSPContent = (_temp = _class = function (_React$Component) {
  _inherits(CSPContent, _React$Component);

  function CSPContent() {
    _classCallCheck(this, CSPContent);

    return _possibleConstructorReturn(this, (CSPContent.__proto__ || Object.getPrototypeOf(CSPContent)).apply(this, arguments));
  }

  _createClass(CSPContent, [{
    key: 'render',
    value: function render() {
      var data = this.props.data;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h4',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            data.effective_directive
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_events_interfaces_keyValueList__["a" /* default */], { data: Object(__WEBPACK_IMPORTED_MODULE_2_app_utils__["n" /* objectToArray */])(data), isContextData: true })
      );
    }
  }]);

  return CSPContent;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (CSPContent);

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/*eslint getsentry/jsx-needs-il8n:0*/
// TODO: Not sure what we're going to do here re: translations. - Ben

var help = {
  'base-uri': Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('\nThe <code>base-uri</code> directive defines the URIs that a user agent\nmay use as the document base URL. If this value is absent, then any URI\nis allowed. If this directive is absent, the user agent will use the\nvalue in the <code>&lt;base&gt;</code> element.'),
  'child-src': Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('\nThe <code>child-src</code> directive defines the valid sources for\nweb workers and nested browsing contexts loaded using elements such as\n<code>&lt;frame&gt;</code> and <code>&lt;iframe&gt;</code>.'),
  'connect-src': Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('\nThe <code>connect-src</code> directive defines valid sources for fetch,\n<code>XMLHttpRequest</code>, <code>WebSocket</code>, and\n<code>EventSource</code> connections.'),
  'font-src': Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('\nThe <code>font-src</code> directive specifies valid sources for fonts\nloaded using <code>@font-face</code>.'),
  'form-action': Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('\nThe <code>form-action</code> directive specifies valid endpoints for\n<code>&lt;form&gt;</code> submissions.'),
  'frame-ancestors': Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('\nThe <code>frame-ancestors</code> directive specifies valid parents that\nmay embed a page using the <code>&lt;frame&gt;</code> and\n<code>&lt;iframe&gt;</code> elements.'),
  'img-src': Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('\nThe <code>img-src</code> directive specifies valid sources of images and\nfavicons.'),
  'manifest-src': Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('\nThe <code>manifest-src</code> directive specifies which manifest can be\napplied to the resource.'),
  'media-src': Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('\nThe <code>media-src</code> directive specifies valid sources for loading\nmedia using the <code>&lt;audio&gt;</code> and <code>&lt;video&gt;</code>\nelements.'),
  'object-src': Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('\nThe <code>object-src</code> directive specifies valid sources for the\n<code>&lt;object&gt;</code>, <code>&lt;embed&gt;</code>, and\n<code>&lt;applet&gt;</code> elements.'),
  'plugin-types': Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('\nThe <code>plugin-types</code> directive specifies the valid plugins that\nthe user agent may invoke.'),
  referrer: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('\nThe <code>referrer</code> directive specifies information in the\n<code>Referer</code> header for links away from a page.'),
  'script-src': Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('\nThe <code>script-src</code> directive specifies valid sources\nfor JavaScript. When either the <code>script-src</code> or the\n<code>default-src</code> directive is included, inline script and\n<code>eval()</code> are disabled unless you specify \'unsafe-inline\'\nand \'unsafe-eval\', respectively.'),
  'style-src': Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('\nThe <code>style-src</code> directive specifies valid sources for\nstylesheets. This includes both externally-loaded stylesheets and inline\nuse of the <code>&lt;style&gt;</code> element and HTML style attributes.\nStylesheets from sources that aren\'t included in the source list are not\nrequested or loaded. When either the <code>style-src</code> or the\n<code>default-src</code> directive is included, inline use of the\n<code>&lt;style&gt;</code> element and HTML style attributes are disabled\nunless you specify \'unsafe-inline\'.'),
  'frame-src': Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('\nThe <code>frame-src</code> directive specifies valid sources for nested\nbrowsing contexts loading using elements such as\n<code>&lt;frame&gt;</code> and <code>&lt;iframe&gt;</code>.'),
  'worker-src': Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('\nThe <code>worker-src</code> directive specifies valid sources for\n<code>Worker<code>, <code>SharedWorker</code>, or\n<code>ServiceWorker</code> scripts.')
};

var linkOverrides = {
  'script-src': 'script-src_2'
};

function getHelp(key) {
  return {
    __html: help[key]
  };
}

function getLinkHref(key) {
  var link = key;
  if (key in linkOverrides) {
    link = linkOverrides[key];
  }
  return 'https://developer.mozilla.org/en-US/docs/Web/Security/CSP/CSP_policy_directives#' + link;
}

function getLink(key) {
  var href = getLinkHref(key);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'span',
    null,
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'a',
      { href: href },
      'developer.mozilla.org'
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'a',
      { href: href, className: 'external-icon' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em', { className: 'icon-open' })
    )
  );
}

var CSPHelp = (_temp = _class = function (_React$Component) {
  _inherits(CSPHelp, _React$Component);

  function CSPHelp() {
    _classCallCheck(this, CSPHelp);

    return _possibleConstructorReturn(this, (CSPHelp.__proto__ || Object.getPrototypeOf(CSPHelp)).apply(this, arguments));
  }

  _createClass(CSPHelp, [{
    key: 'render',
    value: function render() {
      var data = this.props.data;

      var key = data.effective_directive;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h4',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'code',
            null,
            key
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('blockquote', { dangerouslySetInnerHTML: getHelp(key) }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { style: { textAlign: 'right' } },
          '\u2014 MDN (',
          getLink(key),
          ')'
        )
      );
    }
  }]);

  return CSPHelp;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (CSPHelp);

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_events_eventDataSection__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_assistant_guideAnchor__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_events_interfaces_breadcrumbs_breadcrumb__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









function Collapsed(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'li',
    { className: 'crumbs-collapsed' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      { className: 'icon-container' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon icon-ellipsis' })
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'a',
      { onClick: props.onClick },
      Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["tct"])('Show [count] collapsed crumbs', { count: props.count })
    )
  );
}

function moduleToCategory(module) {
  if (!module) {
    return null;
  }
  var match = module.match(/^.*\/(.*?)(:\d+)/);
  if (match) {
    return match[1];
  }
  return module.split(/./)[0];
}

Collapsed.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  count: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
};

var BreadcrumbsInterface = (_temp = _class = function (_React$Component) {
  _inherits(BreadcrumbsInterface, _React$Component);

  function BreadcrumbsInterface() {
    var _ref;

    _classCallCheck(this, BreadcrumbsInterface);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = BreadcrumbsInterface.__proto__ || Object.getPrototypeOf(BreadcrumbsInterface)).call.apply(_ref, [this].concat(args)));

    _this.onCollapseToggle = function () {
      _this.setState({
        collapsed: !_this.state.collapsed
      });
    };

    _this.renderBreadcrumbs = function (crumbs) {
      // reverse array to get consistent idx between collapsed/expanded state
      // (indexes begin and increment from last breadcrumb)
      return crumbs.reverse().map(function (item, idx) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_events_interfaces_breadcrumbs_breadcrumb__["a" /* default */], { key: idx, crumb: item });
      }).reverse(); // un-reverse rendered result
    };

    _this.renderNoMatch = function () {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'li',
        { className: 'crumb-empty' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon icon-exclamation' }),
          ' ',
          Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Sorry, no breadcrumbs match your search query.')
        )
      );
    };

    _this.getVirtualCrumb = function () {
      var evt = _this.props.event;
      var crumb = void 0;

      var exception = evt.entries.find(function (entry) {
        return entry.type === 'exception';
      });
      if (exception) {
        var _exception$data$value = exception.data.values[0],
            type = _exception$data$value.type,
            value = _exception$data$value.value,
            module = _exception$data$value.module;

        crumb = {
          type: 'error',
          level: 'error',
          category: moduleToCategory(module || null) || 'exception',
          data: {
            type: type,
            value: value
          }
        };
      } else if (evt.message) {
        var levelTag = (evt.tags || []).find(function (tag) {
          return tag.key === 'level';
        });
        var level = levelTag && levelTag.value;
        crumb = {
          type: 'message',
          level: level,
          category: 'message',
          message: evt.message
        };
      }

      if (crumb) {
        Object.assign(crumb, {
          timestamp: evt.dateCreated,
          last: true
        });
      }

      return crumb;
    };

    _this.setQuery = function (evt) {
      _this.setState({
        queryValue: evt.target.value
      });
    };

    _this.filterCrumbs = function (crumbs, queryValue) {
      return crumbs.filter(function (item) {
        // return true if any of category, message, or level contain queryValue
        return !!['category', 'message', 'level'].find(function (prop) {
          var propValue = (item[prop] || '').toLowerCase();
          return propValue.includes(queryValue);
        });
      });
    };

    _this.clearSearch = function () {
      _this.setState({
        queryValue: '',
        collapsed: true
      });
    };

    _this.getSearchField = function () {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'breadcrumb-filter' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
          type: 'text',
          className: 'search-input form-control',
          placeholder: Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Search breadcrumbs...'),
          autoComplete: 'off',
          value: _this.state.queryValue,
          onChange: _this.setQuery
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon-search' }),
        _this.state.queryValue && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            { className: 'search-clear-form', onClick: _this.clearSearch },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon-circle-cross' })
          )
        )
      );
    };

    _this.state = {
      collapsed: true,
      queryValue: ''
    };
    return _this;
  }

  _createClass(BreadcrumbsInterface, [{
    key: 'render',
    value: function render() {
      var group = this.props.group;
      var evt = this.props.event;
      var data = this.props.data;

      var title = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_assistant_guideAnchor__["default"], { target: 'breadcrumbs', type: 'text' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'strong',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Breadcrumbs')
          )
        ),
        this.getSearchField()
      );

      var all = data.values;

      // Add the error event as the final (virtual) breadcrumb
      var virtualCrumb = this.getVirtualCrumb();
      if (virtualCrumb) {
        // make copy of values array / don't mutate props
        all = all.slice(0).concat([virtualCrumb]);
      }

      // filter breadcrumbs on text input
      var queryValue = this.state.queryValue;

      var filtered = queryValue ? this.filterCrumbs(all, queryValue.toLowerCase()) : all;

      // cap max number of breadcrumbs to show
      var MAX = BreadcrumbsInterface.MAX_CRUMBS_WHEN_COLLAPSED;
      var crumbs = filtered;
      if (this.state.collapsed && filtered.length > MAX) {
        crumbs = filtered.slice(-MAX);
      }

      var numCollapsed = filtered.length - crumbs.length;

      var crumbContent = void 0;
      if (crumbs.length) {
        crumbContent = this.renderBreadcrumbs(crumbs);
      } else if (all.length) {
        crumbContent = this.renderNoMatch();
      }
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_app_components_events_eventDataSection__["a" /* default */],
        {
          className: 'breadcrumb-box',
          group: group,
          event: evt,
          type: this.props.type,
          title: title,
          wrapTitle: false
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'ul',
          { className: 'crumbs' },
          numCollapsed > 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Collapsed, { onClick: this.onCollapseToggle, count: numCollapsed }),
          crumbContent
        )
      );
    }
  }]);

  return BreadcrumbsInterface;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  group: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Group.isRequired,
  event: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Event.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _class.contextTypes = {
  organization: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Organization,
  project: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Project
}, _class.MAX_CRUMBS_WHEN_COLLAPSED = 10, _temp);


/* harmony default export */ __webpack_exports__["a"] = (BreadcrumbsInterface);

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_events_interfaces_breadcrumbs_httpRenderer__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_events_interfaces_breadcrumbs_errorRenderer__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_events_interfaces_breadcrumbs_defaultRenderer__ = __webpack_require__(1100);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var CUSTOM_RENDERERS = {
  http: __WEBPACK_IMPORTED_MODULE_3_app_components_events_interfaces_breadcrumbs_httpRenderer__["a" /* default */],
  error: __WEBPACK_IMPORTED_MODULE_4_app_components_events_interfaces_breadcrumbs_errorRenderer__["a" /* default */]
};

var Breadcrumb = (_temp2 = _class = function (_React$Component) {
  _inherits(Breadcrumb, _React$Component);

  function Breadcrumb() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Breadcrumb);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Breadcrumb.__proto__ || Object.getPrototypeOf(Breadcrumb)).call.apply(_ref, [this].concat(args))), _this), _this.getClassName = function () {
      var crumb = _this.props.crumb;

      // use Set to avoid duplicate crumb classes (was previously adding
      // values like "crumb-default" as many as three times)

      var classes = new Set(['crumb', 'crumb-default', 'crumb-' + crumb.level]);

      if (crumb.type !== 'default') {
        classes.add('crumb-' + crumb.type.replace(/[\s_]+/g, '-').toLowerCase());
      }

      // special case for 'ui.' category breadcrumbs
      // TODO: find a better way to customize UI around non-schema data
      if (crumb.category && crumb.category.slice(0, 3) === 'ui.') {
        classes.add('crumb-user');
      }

      if (crumb.last) {
        classes.add('crumb-last');
      }
      return [].concat(_toConsumableArray(classes)).join(' ');
    }, _this.renderType = function () {
      var crumb = _this.props.crumb;

      var Renderer = CUSTOM_RENDERERS[crumb.type] || __WEBPACK_IMPORTED_MODULE_5_app_components_events_interfaces_breadcrumbs_defaultRenderer__["a" /* default */];
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Renderer, { crumb: crumb });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Breadcrumb, [{
    key: 'render',
    value: function render() {
      var crumb = this.props.crumb;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'li',
        { className: this.getClassName() },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'icon-container' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon' })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'dt', title: __WEBPACK_IMPORTED_MODULE_2_moment___default()(crumb.timestamp).format() },
          __WEBPACK_IMPORTED_MODULE_2_moment___default()(crumb.timestamp).format('HH:mm:ss')
        ),
        this.renderType()
      );
    }
  }]);

  return Breadcrumb;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  crumb: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (Breadcrumb);

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_events_interfaces_breadcrumbs_crumbTable__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_events_interfaces_breadcrumbs_summaryLine__ = __webpack_require__(350);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var HttpRenderer = (_temp2 = _class = function (_React$Component) {
  _inherits(HttpRenderer, _React$Component);

  function HttpRenderer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HttpRenderer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HttpRenderer.__proto__ || Object.getPrototypeOf(HttpRenderer)).call.apply(_ref, [this].concat(args))), _this), _this.renderUrl = function (url) {
      return url.match(/^https?:\/\//) ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        { href: url },
        url
      ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'em',
        null,
        url
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HttpRenderer, [{
    key: 'render',
    value: function render() {
      var crumb = this.props.crumb;

      var _ref2 = crumb.data || {},
          method = _ref2.method,
          status_code = _ref2.status_code,
          url = _ref2.url,
          extra = _objectWithoutProperties(_ref2, ['method', 'status_code', 'url']);

      var summary = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_app_components_events_interfaces_breadcrumbs_summaryLine__["a" /* default */],
        { crumb: crumb },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'pre',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'code',
            null,
            method && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'strong',
              null,
              method,
              ' '
            ),
            url && this.renderUrl(url),
            status_code !== undefined ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              null,
              ' [' + status_code + ']'
            ) : ''
          )
        )
      );

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_events_interfaces_breadcrumbs_crumbTable__["a" /* default */], _extends({ title: 'HTTP Request', summary: summary, kvData: extra }, this.props));
    }
  }]);

  return HttpRenderer;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  crumb: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (HttpRenderer);

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Category = (_temp = _class = function (_React$Component) {
  _inherits(Category, _React$Component);

  function Category() {
    _classCallCheck(this, Category);

    return _possibleConstructorReturn(this, (Category.__proto__ || Object.getPrototypeOf(Category)).apply(this, arguments));
  }

  _createClass(Category, [{
    key: 'render',
    value: function render() {
      var value = this.props.value;
      if (!value) {
        value = 'generic';
        if (this.props.hideIfEmpty) {
          return null;
        }
      }
      var title = this.props.title;
      if (title) {
        title = title.replace('%s', value);
      } else {
        title = value;
      }
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { className: 'crumb-category', title: title },
        title
      );
    }
  }]);

  return Category;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  hideIfEmpty: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (Category);

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_events_interfaces_breadcrumbs_crumbTable__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_events_interfaces_breadcrumbs_summaryLine__ = __webpack_require__(350);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ErrorRenderer = (_temp2 = _class = function (_React$Component) {
  _inherits(ErrorRenderer, _React$Component);

  function ErrorRenderer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ErrorRenderer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ErrorRenderer.__proto__ || Object.getPrototypeOf(ErrorRenderer)).call.apply(_ref, [this].concat(args))), _this), _this.renderUrl = function (url) {
      return url.match(/^https?:\/\//) ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        { href: url },
        url
      ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'em',
        null,
        url
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ErrorRenderer, [{
    key: 'render',
    value: function render() {
      var crumb = this.props.crumb;

      var _ref2 = crumb.data || {},
          type = _ref2.type,
          value = _ref2.value,
          extra = _objectWithoutProperties(_ref2, ['type', 'value']);

      var messages = [];

      if (value) {
        messages.push(value);
      }
      if (crumb.message) {
        messages.push(crumb.message);
      }

      var summary = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_app_components_events_interfaces_breadcrumbs_summaryLine__["a" /* default */],
        { crumb: crumb },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'pre',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'code',
            null,
            type && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'strong',
              null,
              type,
              ': '
            ),
            messages.join('. ')
          )
        )
      );

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_events_interfaces_breadcrumbs_crumbTable__["a" /* default */], _extends({ title: 'Error', summary: summary, kvData: extra }, this.props));
    }
  }]);

  return ErrorRenderer;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  crumb: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (ErrorRenderer);

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_events_interfaces_breadcrumbs_crumbTable__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_events_interfaces_breadcrumbs_summaryLine__ = __webpack_require__(350);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var DefaultRenderer = (_temp2 = _class = function (_React$Component) {
  _inherits(DefaultRenderer, _React$Component);

  function DefaultRenderer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DefaultRenderer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DefaultRenderer.__proto__ || Object.getPrototypeOf(DefaultRenderer)).call.apply(_ref, [this].concat(args))), _this), _this.getTitle = function () {
      var crumb = _this.props.crumb;
      if (crumb.type === 'default') {
        return null;
      }
      return crumb.type.split(/[_-\s]+/g).map(function (word) {
        return word.substr(0, 1).toUpperCase() + word.substr(1);
      }).join(' ');
    }, _this.renderSummary = function () {
      var crumb = _this.props.crumb;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_app_components_events_interfaces_breadcrumbs_summaryLine__["a" /* default */],
        { crumb: crumb },
        crumb.message && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'pre',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'code',
            null,
            crumb.message
          )
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DefaultRenderer, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_events_interfaces_breadcrumbs_crumbTable__["a" /* default */], _extends({
        title: this.getTitle(),
        summary: this.renderSummary(),
        kvData: this.props.crumb.data || {}
      }, this.props));
    }
  }]);

  return DefaultRenderer;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  crumb: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  kvData: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (DefaultRenderer);

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GenericInterface; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_events_eventDataSection__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_events_interfaces_keyValueList__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_utils__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










function getView(view, data) {
  switch (view) {
    case 'report':
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_events_interfaces_keyValueList__["a" /* default */], { data: Object(__WEBPACK_IMPORTED_MODULE_6_app_utils__["n" /* objectToArray */])(data), isContextData: true });
    case 'raw':
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'pre',
        null,
        JSON.stringify({ 'csp-report': data }, null, 2)
      );
    default:
      throw new TypeError('Invalid view: ' + view);
  }
}
var GenericInterface = (_temp = _class = function (_Component) {
  _inherits(GenericInterface, _Component);

  function GenericInterface(props) {
    _classCallCheck(this, GenericInterface);

    var _this = _possibleConstructorReturn(this, (GenericInterface.__proto__ || Object.getPrototypeOf(GenericInterface)).call(this, props));

    _this.toggleView = function (value) {
      _this.setState({
        view: value
      });
    };

    var data = props.data;

    _this.state = {
      view: 'report',
      data: data
    };
    return _this;
  }

  _createClass(GenericInterface, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          view = _state.view,
          data = _state.data;
      var _props = this.props,
          group = _props.group,
          event = _props.event,
          type = _props.type;


      var title = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            {
              className: (view === 'report' ? 'active' : '') + ' btn btn-default btn-sm',
              onClick: this.toggleView.bind(this, 'report')
            },
            Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Report')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            {
              className: (view === 'raw' ? 'active' : '') + ' btn btn-default btn-sm',
              onClick: this.toggleView.bind(this, 'raw')
            },
            Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Raw')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Report')
        )
      );

      var children = getView(view, data);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_app_components_events_eventDataSection__["a" /* default */],
        {
          group: group,
          event: event,
          type: type,
          title: title,
          wrapTitle: false
        },
        children
      );
    }
  }]);

  return GenericInterface;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.propTypes = {
  group: __WEBPACK_IMPORTED_MODULE_2_app_proptypes__["e" /* default */].Group.isRequired,
  event: __WEBPACK_IMPORTED_MODULE_2_app_proptypes__["e" /* default */].Event.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp);


/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_events_eventDataSection__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_events_interfaces_stacktrace__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_dropdownLink__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_menuItem__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_events_interfaces_frame__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_events_interfaces_crashHeader__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_events_interfaces_crashContent__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_pills__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_pill__ = __webpack_require__(343);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2, _class2, _temp3, _initialiseProps;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















function trimFilename(fn) {
  var pieces = fn.split(/\//g);
  return pieces[pieces.length - 1];
}

function findRelevantFrame(stacktrace) {
  if (!stacktrace.hasSystemFrames) {
    return stacktrace.frames[stacktrace.frames.length - 1];
  }
  for (var i = stacktrace.frames.length - 1; i >= 0; i--) {
    var frame = stacktrace.frames[i];
    if (frame.inApp) {
      return frame;
    }
  }
  // this should not happen
  return stacktrace.frames[stacktrace.frames.length - 1];
}

function findThreadException(thread, event) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = event.entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var entry = _step.value;

      if (entry.type !== 'exception') {
        continue;
      }
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = entry.data.values[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var exc = _step2.value;

          if (exc.threadId === thread.id) {
            return entry.data;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return null;
}

function findThreadStacktrace(thread, event, raw) {
  if (raw && thread.rawStacktrace) {
    return thread.rawStacktrace;
  } else if (thread.stacktrace) {
    return thread.stacktrace;
  }
  var exc = findThreadException(thread, event);
  if (exc) {
    var rv = null;
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = exc.values[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var singleExc = _step3.value;

        if (singleExc.threadId === thread.id) {
          rv = raw && singleExc.rawStacktrace || singleExc.stacktrace;
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return rv;
  }
  return null;
}

function getThreadTitle(thread, event, simplified) {
  var stacktrace = findThreadStacktrace(thread, event, false);
  var bits = ['Thread'];
  if (Object(__WEBPACK_IMPORTED_MODULE_5_app_utils__["d" /* defined */])(thread.name)) {
    bits.push(' "' + thread.name + '"');
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_5_app_utils__["d" /* defined */])(thread.id)) {
    bits.push(' #' + thread.id);
  }

  if (!simplified) {
    if (stacktrace) {
      var frame = findRelevantFrame(stacktrace);
      bits.push(' — ');
      bits.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'em',
        { key: 'location' },
        frame.filename ? trimFilename(frame.filename) : frame.package ? Object(__WEBPACK_IMPORTED_MODULE_8_app_components_events_interfaces_frame__["b" /* trimPackage */])(frame.package) : frame.module ? frame.module : '<unknown>'
      ));
    }

    if (thread.crashed) {
      var exc = findThreadException(thread, event);
      bits.push(' — ');
      bits.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'small',
        { key: 'crashed' },
        exc ? '(crashed with ' + exc.values[0].type + ')' : '(crashed)'
      ));
    }
  }

  return bits;
}

function getIntendedStackView(thread, event) {
  var stacktrace = findThreadStacktrace(thread, event, false);
  return stacktrace && stacktrace.hasSystemFrames ? 'app' : 'full';
}

function findBestThread(threads) {
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = threads[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var thread = _step4.value;

      if (thread.crashed) {
        return thread;
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = threads[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var _thread = _step5.value;

      if (_thread.stacktrace) {
        return _thread;
      }
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  return threads[0];
}

var Thread = (_temp2 = _class = function (_React$Component) {
  _inherits(Thread, _React$Component);

  function Thread() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Thread);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Thread.__proto__ || Object.getPrototypeOf(Thread)).call.apply(_ref, [this].concat(args))), _this), _this.renderMissingStacktrace = function () {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'traceback missing-traceback' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'ul',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'li',
            { className: 'frame missing-frame' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'title' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'informal' },
                _this.props.data.crashed ? 'Thread Crashed' : 'No or unknown stacktrace'
              )
            )
          )
        )
      );
    }, _this.hasMissingStacktrace = function () {
      var _this$props = _this.props,
          exception = _this$props.exception,
          stacktrace = _this$props.stacktrace;

      return !(exception || stacktrace);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Thread, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          group = _props.group,
          event = _props.event,
          stackView = _props.stackView,
          stackType = _props.stackType,
          newestFirst = _props.newestFirst,
          exception = _props.exception,
          stacktrace = _props.stacktrace;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'thread' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_app_components_pills__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_pill__["a" /* default */], { name: 'id', value: data.id }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_pill__["a" /* default */], { name: 'name', value: data.name }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_pill__["a" /* default */], { name: 'was active', value: data.current }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_app_components_pill__["a" /* default */],
            { name: 'crashed', className: data.crashed ? 'false' : 'true' },
            data.crashed ? 'yes' : 'no'
          )
        ),
        this.hasMissingStacktrace() ? this.renderMissingStacktrace() : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_events_interfaces_crashContent__["a" /* default */], {
          group: group,
          event: event,
          stackType: stackType,
          stackView: stackView,
          newestFirst: newestFirst,
          exception: exception,
          stacktrace: stacktrace
        })
      );
    }
  }]);

  return Thread;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  group: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Group.isRequired,
  event: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Event.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  stackView: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  stackType: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  newestFirst: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  exception: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  stacktrace: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
}, _temp2);
var ThreadsInterface = (_temp3 = _class2 = function (_React$Component2) {
  _inherits(ThreadsInterface, _React$Component2);

  function ThreadsInterface(props) {
    _classCallCheck(this, ThreadsInterface);

    var _this2 = _possibleConstructorReturn(this, (ThreadsInterface.__proto__ || Object.getPrototypeOf(ThreadsInterface)).call(this, props));

    _initialiseProps.call(_this2);

    var thread = findBestThread(props.data.values);

    _this2.state = {
      activeThread: thread,
      stackView: getIntendedStackView(thread, props.event),
      stackType: 'original',
      newestFirst: Object(__WEBPACK_IMPORTED_MODULE_4_app_components_events_interfaces_stacktrace__["b" /* isStacktraceNewestFirst */])()
    };
    return _this2;
  }

  _createClass(ThreadsInterface, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var group = this.props.group;
      var evt = this.props.event;
      var _state = this.state,
          stackView = _state.stackView,
          stackType = _state.stackType,
          newestFirst = _state.newestFirst,
          activeThread = _state.activeThread;

      var exception = this.getException();
      var stacktrace = this.getStacktrace();

      var threadSelector = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'pull-left btn-group' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_app_components_dropdownLink__["default"],
          {
            btnGroup: true,
            caret: true,
            className: 'btn btn-default btn-sm',
            title: getThreadTitle(activeThread, this.props.event, true)
          },
          this.props.data.values.map(function (thread, idx) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_app_components_menuItem__["default"],
              { key: idx, noAnchor: true },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { onClick: _this3.onSelectNewThread.bind(_this3, thread) },
                getThreadTitle(thread, _this3.props.event, false)
              )
            );
          })
        )
      );

      var title = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_events_interfaces_crashHeader__["a" /* default */], {
        title: null,
        beforeTitle: threadSelector,
        group: group,
        platform: evt.platform,
        thread: activeThread,
        stacktrace: stacktrace,
        exception: exception,
        stackView: stackView,
        newestFirst: newestFirst,
        stackType: stackType,
        onChange: function onChange(newState) {
          _this3.setState(newState);
        }
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_app_components_events_eventDataSection__["a" /* default */],
        {
          group: group,
          event: evt,
          type: this.props.type,
          title: title,
          wrapTitle: false
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Thread, {
          group: group,
          data: activeThread,
          exception: exception,
          stackView: stackView,
          stackType: stackType,
          stacktrace: stacktrace,
          event: evt,
          newestFirst: newestFirst
        })
      );
    }
  }]);

  return ThreadsInterface;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class2.propTypes = {
  group: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Group.isRequired,
  event: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Event.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.toggleStack = function (value) {
    _this4.setState({
      stackView: value
    });
  };

  this.getStacktrace = function () {
    return findThreadStacktrace(_this4.state.activeThread, _this4.props.event, _this4.state.stackType !== 'original');
  };

  this.getException = function () {
    return findThreadException(_this4.state.activeThread, _this4.props.event);
  };

  this.onSelectNewThread = function (thread) {
    var newStackView = _this4.state.stackView;
    if (_this4.state.stackView !== 'raw') {
      newStackView = getIntendedStackView(thread, _this4.props.event);
    }
    _this4.setState({
      activeThread: thread,
      stackView: newStackView,
      stackType: 'original'
    });
  };
}, _temp3);


/* harmony default export */ __webpack_exports__["a"] = (ThreadsInterface);

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_events_eventDataSection__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_clippedBox__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_events_interfaces_keyValueList__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var DebugMetaInterface = (_temp = _class = function (_React$Component) {
  _inherits(DebugMetaInterface, _React$Component);

  function DebugMetaInterface() {
    _classCallCheck(this, DebugMetaInterface);

    return _possibleConstructorReturn(this, (DebugMetaInterface.__proto__ || Object.getPrototypeOf(DebugMetaInterface)).apply(this, arguments));
  }

  _createClass(DebugMetaInterface, [{
    key: 'getImageDetail',
    value: function getImageDetail(img, evt) {
      // in particular proguard images do not have a name, skip them
      if (img.name === null || img.type === 'proguard') {
        return null;
      }

      var name = img.name.split(/^[a-z]:\\/i.test(img.name) ? '\\' : '/').pop();
      if (name == 'dyld_sim') return null; // this is only for simulator builds

      var version = null;
      if (Number.isInteger(img.major_version) && Number.isInteger(img.minor_version) && Number.isInteger(img.revision_version)) {
        if (img.major_version == 0 && img.minor_version == 0 && img.revision_version == 0) {
          // we show the version
          version = evt.release && evt.release.shortVersion || 'unknown';
        } else version = img.major_version + '.' + img.minor_version + '.' + img.revision_version;
      } else version = img.id || img.uuid || '<none>';

      if (version) return [name, version];

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = this.props.data;
      var images = data.images.map(function (img) {
        return _this2.getImageDetail(img, _this2.props.event);
      }).filter(function (img) {
        return img;
      }); // removes null values

      var result = null;

      if (images.length > 0) {
        result = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_app_components_events_eventDataSection__["a" /* default */],
            {
              group: this.props.group,
              event: this.props.event,
              type: 'packages',
              title: Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Images Loaded')
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_app_components_clippedBox__["a" /* default */],
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_events_interfaces_keyValueList__["a" /* default */], { data: images, isSorted: false })
            )
          )
        );
      }

      return result;
    }
  }]);

  return DebugMetaInterface;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  group: __WEBPACK_IMPORTED_MODULE_2_app_proptypes__["e" /* default */].Group.isRequired,
  event: __WEBPACK_IMPORTED_MODULE_2_app_proptypes__["e" /* default */].Event.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (DebugMetaInterface);

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_stores_configStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_dateTime__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_fileSize__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_locale__ = __webpack_require__(2);














var formatDateDelta = function formatDateDelta(reference, observed) {
  var duration = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default.a.duration(Math.abs(+observed - +reference));
  var hours = Math.floor(+duration / (60 * 60 * 1000));
  var minutes = duration.minutes();
  var results = [];

  if (hours) {
    results.push(hours + ' hour' + (hours != 1 ? 's' : ''));
  }

  if (minutes) {
    results.push(minutes + ' minute' + (minutes != 1 ? 's' : ''));
  }

  if (results.length == 0) {
    results.push('a few seconds');
  }

  return results.join(', ');
};

var GroupEventToolbar = __WEBPACK_IMPORTED_MODULE_4_create_react_class___default()({
  displayName: 'GroupEventToolbar',

  propTypes: {
    orgId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    projectId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    group: __WEBPACK_IMPORTED_MODULE_6_app_proptypes__["e" /* default */].Group.isRequired,
    event: __WEBPACK_IMPORTED_MODULE_6_app_proptypes__["e" /* default */].Event.isRequired
  },

  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return this.props.event.id !== nextProps.event.id;
  },
  getDateTooltip: function getDateTooltip() {
    var evt = this.props.event;
    var user = __WEBPACK_IMPORTED_MODULE_5_app_stores_configStore__["default"].get('user');
    var options = user ? user.options : {};
    var format = options.clock24Hours ? 'HH:mm:ss z' : 'LTS z';
    var dateCreated = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(evt.dateCreated);
    var resp = '<dl class="flat" style="text-align:left;margin:0;min-width:200px">' + '<dt>Occurred</dt>' + '<dd>' + dateCreated.format('ll') + '<br />' + dateCreated.format(format) + '</dd>';
    if (evt.dateReceived) {
      var dateReceived = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(evt.dateReceived);
      resp += '<dt>Received</dt>' + '<dd>' + dateReceived.format('ll') + '<br />' + dateReceived.format(format) + '</dd>' + '<dt>Latency</dt>' + '<dd>' + formatDateDelta(dateCreated, dateReceived) + '</dd>';
    }
    return resp + '</dl>';
  },
  render: function render() {
    var evt = this.props.event;

    var _props = this.props,
        orgId = _props.orgId,
        projectId = _props.projectId;

    var groupId = this.props.group.id;

    var eventNavNodes = [evt.previousEventID ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_router__["Link"],
      {
        key: 'oldest',
        to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/events/oldest/',
        className: 'btn btn-default',
        title: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Oldest')
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'icon-skip-back' })
    ) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'a',
      { key: 'oldest', className: 'btn btn-default disabled' },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'icon-skip-back' })
    ), evt.previousEventID ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_router__["Link"],
      {
        key: 'prev',
        to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/events/' + evt.previousEventID + '/',
        className: 'btn btn-default'
      },
      Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Older')
    ) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'a',
      { key: 'prev', className: 'btn btn-default disabled' },
      Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Older')
    ), evt.nextEventID ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_router__["Link"],
      {
        key: 'next',
        to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/events/' + evt.nextEventID + '/',
        className: 'btn btn-default'
      },
      Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Newer')
    ) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'a',
      { key: 'next', className: 'btn btn-default disabled' },
      Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Newer')
    ), evt.nextEventID ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_router__["Link"],
      {
        key: 'latest',
        to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/events/latest/',
        className: 'btn btn-default',
        title: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Newest')
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'icon-skip-forward' })
    ) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'a',
      { key: 'latest', className: 'btn btn-default disabled' },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'icon-skip-forward' })
    )];

    // TODO: possible to define this as a route in react-router, but without a corresponding
    //       React component?
    var jsonUrl = '/' + orgId + '/' + projectId + '/issues/' + groupId + '/events/' + evt.id + '/json/';
    var style = {
      borderBottom: '1px dotted #dfe3ea'
    };

    var latencyThreshold = 30 * 60 * 1000; // 30 minutes
    var isOverLatencyThreshold = evt.dateReceived && Math.abs(+__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(evt.dateReceived) - +__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(evt.dateCreated)) > latencyThreshold;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: 'event-toolbar' },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: 'pull-right' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          eventNavNodes
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'h4',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Event'),
        ' ',
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react_router__["Link"],
          {
            to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/events/' + evt.id + '/',
            className: 'event-id'
          },
          evt.eventID
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'span',
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_app_components_tooltip__["default"],
          { title: this.getDateTooltip(), tooltipOptions: { html: true } },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_dateTime__["default"], { date: evt.dateCreated, style: style }),
            isOverLatencyThreshold && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'icon-alert' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'a',
          { href: jsonUrl, target: '_blank', className: 'json-link' },
          'JSON',
          ' (',
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_fileSize__["a" /* default */], { bytes: evt.size }),
          ')'
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (GroupEventToolbar);

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GroupSidebar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isObject__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_group_suggestedOwners__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_group_participants__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_group_releaseStats__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_mixins_projectState__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_stores_hookStore__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_stores_indicatorStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_group_tagDistributionMeter__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_utils_withEnvironment__ = __webpack_require__(158);




















var GroupSidebar = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'GroupSidebar',

  propTypes: {
    group: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    event: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    environment: __WEBPACK_IMPORTED_MODULE_5_app_proptypes__["e" /* default */].Environment
  },

  contextTypes: {
    location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_10_app_mixins_projectState__["a" /* default */]],

  getInitialState: function getInitialState() {
    var _this = this;

    // Allow injection via getsentry et all
    var hooks = __WEBPACK_IMPORTED_MODULE_11_app_stores_hookStore__["default"].get('issue:secondary-column').map(function (cb) {
      return cb({
        params: _this.props.params
      });
    });

    return {
      participants: [],
      hooks: hooks
    };
  },
  componentWillMount: function componentWillMount() {
    var _this2 = this;

    var group = this.props.group;

    this.api.request('/issues/' + group.id + '/participants/', {
      success: function success(data) {
        _this2.setState({
          participants: data,
          error: false
        });
      },
      error: function error() {
        _this2.setState({
          error: true
        });
      }
    });
    // Fetch group data for all environments since the one passed in props is filtered for the selected environment
    // The charts rely on having all environment data as well as the data for the selected env
    this.api.request('/issues/' + group.id + '/', {
      success: function success(data) {
        _this2.setState({
          allEnvironmentsGroupData: data
        });
      },
      error: function error() {
        _this2.setState({
          error: true
        });
      }
    });
  },


  subscriptionReasons: {
    commented: Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])("You're receiving updates because you have commented on this issue."),
    assigned: Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])("You're receiving updates because you were assigned to this issue."),
    bookmarked: Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])("You're receiving updates because you have bookmarked this issue."),
    changed_status: Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])("You're receiving updates because you have changed the status of this issue."),
    mentioned: Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])("You're receiving updates because you have been mentioned in this issue.")
  },

  toggleSubscription: function toggleSubscription() {
    var _this3 = this;

    var group = this.props.group;
    var project = this.getProject();
    var org = this.getOrganization();
    var loadingIndicator = __WEBPACK_IMPORTED_MODULE_12_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])('Saving changes..'));

    this.api.bulkUpdate({
      orgId: org.slug,
      projectId: project.slug,
      itemIds: [group.id],
      data: {
        isSubscribed: !group.isSubscribed
      }
    }, {
      complete: function complete() {
        _this3.api.request('/issues/' + group.id + '/participants/', {
          success: function success(data) {
            _this3.setState({
              participants: data,
              error: false
            });
            __WEBPACK_IMPORTED_MODULE_12_app_stores_indicatorStore__["default"].remove(loadingIndicator);
          },
          error: function error() {
            _this3.setState({
              error: true
            });
            __WEBPACK_IMPORTED_MODULE_12_app_stores_indicatorStore__["default"].remove(loadingIndicator);
          }
        });
      }
    });
  },
  renderPluginIssue: function renderPluginIssue() {
    var issues = [];
    (this.props.group.pluginIssues || []).forEach(function (plugin) {
      var issue = plugin.issue;
      // # TODO(dcramer): remove plugin.title check in Sentry 8.22+
      if (issue) {
        issues.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'dl',
          { key: plugin.slug },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'dt',
            null,
            (plugin.shortName || plugin.name || plugin.title) + ': '
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'dd',
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'a',
              { href: issue.url },
              __WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default()(issue.label) ? issue.label.id : issue.label
            )
          )
        ));
      }
    });
    if (issues.length) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'h6',
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'span',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])('External Issues')
          )
        ),
        issues
      );
    }
    return null;
  },
  canChangeSubscriptionState: function canChangeSubscriptionState() {
    return !(this.props.group.subscriptionDetails || { disabled: false }).disabled;
  },
  getNotificationText: function getNotificationText() {
    var group = this.props.group;


    if (group.isSubscribed) {
      var result = Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])("You're receiving updates because you are subscribed to this issue.");
      if (group.subscriptionDetails) {
        var reason = group.subscriptionDetails.reason;
        if (this.subscriptionReasons.hasOwnProperty(reason)) {
          result = this.subscriptionReasons[reason];
        }
      } else {
        result = Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["tct"])("You're receiving updates because you are [link:subscribed to workflow notifications] for this project.", {
          link: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { href: '/account/settings/notifications/' })
        });
      }
      return result;
    } else {
      if (group.subscriptionDetails && group.subscriptionDetails.disabled) {
        return Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["tct"])('You have [link:disabled workflow notifications] for this project.', {
          link: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { href: '/account/settings/notifications/' })
        });
      } else {
        return Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])("You're not subscribed to this issue.");
      }
    }
  },
  renderParticipantData: function renderParticipantData() {
    var error = this.state.error;
    var participants = (this.state || {}).participants || [];

    if (!error) {
      return participants.length !== 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_group_participants__["a" /* default */], { participants: participants });
    } else {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_app_components_loadingError__["default"], {
        message: Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])('There was an error while trying to load participants.')
      });
    }
  },
  render: function render() {
    var group = this.props.group;

    var project = this.getProject();
    var projectId = project.slug;
    var orgId = this.getOrganization().slug;

    var subscribeBtnClass = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('btn btn-default btn-subscribe', {
      subscribed: group.isSubscribed
    });

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: 'group-stats' },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_group_suggestedOwners__["a" /* default */], { event: this.props.event }),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_group_releaseStats__["a" /* default */], {
        group: this.props.group,
        allEnvironments: this.state.allEnvironmentsGroupData
      }),
      this.renderPluginIssue(),
      this.state.hooks,
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'h6',
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'span',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])('Tags')
        )
      ),
      group.tags.map(function (data) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_app_components_group_tagDistributionMeter__["a" /* default */], {
          key: data.key,
          'data-test-id': 'group-tag',
          orgId: orgId,
          projectId: projectId,
          group: group,
          name: data.name,
          tag: data.key
        });
      }),
      group.tags.length === 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'p',
        { 'data-test-id': 'no-tags' },
        this.props.environment ? Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["tct"])('No tags found in the [env] environment', {
          env: this.props.environment.displayName
        }) : Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])('No tags found')
      ),
      this.renderParticipantData(),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'h6',
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'span',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])('Notifications')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'p',
        { className: 'help-block' },
        this.getNotificationText()
      ),
      this.canChangeSubscriptionState() && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'a',
        { className: subscribeBtnClass, onClick: this.toggleSubscription },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon-signal' }),
        group.isSubscribed ? Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])('Unsubscribe') : Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])('Subscribe')
      )
    );
  }
});


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_16_app_utils_withEnvironment__["a" /* default */])(GroupSidebar));

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom_server__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom_server___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom_server__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_avatar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_actorAvatar__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_mixins_groupState__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_actionCreators_group__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_actionCreators_modal__ = __webpack_require__(104);















var SuggestedOwners = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'SuggestedOwners',

  propTypes: {
    event: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_9_app_mixins_groupState__["a" /* default */]],

  getInitialState: function getInitialState() {
    return {
      rule: null,
      owners: [],
      committers: []
    };
  },
  componentDidMount: function componentDidMount() {
    this.fetchData(this.props.event);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this.props.event && nextProps.event) {
      if (this.props.event.id !== nextProps.event.id) {
        //two events, with different IDs
        this.fetchData(nextProps.event);
      }
    } else if (nextProps.event) {
      //going from having no event to having an event
      this.fetchData(nextProps.event);
    }
  },
  fetchData: function fetchData(event) {
    var _this = this;

    if (!event) return;
    var org = this.getOrganization();
    var project = this.getProject();
    this.api.request('/projects/' + org.slug + '/' + project.slug + '/events/' + event.id + '/committers/', {
      success: function success(data, _, jqXHR) {
        _this.setState({
          committers: data.committers
        });
      },
      error: function error(_error) {
        _this.setState({
          committers: []
        });
      }
    });
    this.api.request('/projects/' + org.slug + '/' + project.slug + '/events/' + event.id + '/owners/', {
      success: function success(data, _, jqXHR) {
        _this.setState({
          owners: data.owners,
          rule: data.rule
        });
      },
      error: function error(_error2) {
        _this.setState({
          owners: []
        });
      }
    });
  },
  assignTo: function assignTo(user) {
    if (user.id !== undefined) {
      Object(__WEBPACK_IMPORTED_MODULE_10_app_actionCreators_group__["b" /* assignToUser */])({ id: this.props.event.groupID, user: user });
    }
  },
  assignToActor: function assignToActor(actor) {
    if (actor.id !== undefined) {
      Object(__WEBPACK_IMPORTED_MODULE_10_app_actionCreators_group__["a" /* assignToActor */])({
        actor: actor,
        id: this.props.event.groupID
      });
    }
  },
  renderCommitter: function renderCommitter(committer) {
    var _this2 = this;

    var author = committer.author,
        commits = committer.commits;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      {
        key: author.id || author.email,
        className: 'avatar-grid-item',
        style: { cursor: 'pointer' },
        onClick: function onClick() {
          return _this2.assignTo(author);
        }
      },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_app_components_tooltip__["default"],
        {
          tooltipOptions: {
            html: true,
            container: 'body',
            template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner tooltip-owners"></div></div>'
          },
          title: __WEBPACK_IMPORTED_MODULE_3_react_dom_server___default.a.renderToStaticMarkup(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            author.id ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'tooltip-owners-name' },
              author.name
            ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'tooltip-owners-unknown' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { className: 'tooltip-owners-unknown-email' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon icon-circle-cross' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'strong',
                  null,
                  author.email
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Sorry, we don\'t recognize this member. Make sure to link alternative\n                    emails in Account Settings.')
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr', null)
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'ul',
              { className: 'tooltip-owners-commits' },
              commits.slice(0, 6).map(function (c) {
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'li',
                  { key: c.id, className: 'tooltip-owners-commit' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { style: { whiteSpace: 'pre-line' } },
                    c.message.replace(/\n\s*\n/g, '\n') /*repress repeated newlines*/
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'tooltip-owners-date' },
                    ' ',
                    '- ',
                    __WEBPACK_IMPORTED_MODULE_4_moment___default()(c.dateCreated).fromNow()
                  )
                );
              })
            )
          ))
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_avatar__["a" /* default */], { user: author })
      )
    );
  },
  renderOwner: function renderOwner(owner) {
    var _this3 = this;

    var rule = this.state.rule;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      {
        key: owner.id + ':' + owner.type,
        className: 'avatar-grid-item',
        style: { cursor: 'pointer' },
        onClick: function onClick() {
          return _this3.assignToActor(owner);
        }
      },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_app_components_tooltip__["default"],
        {
          tooltipOptions: {
            html: true,
            container: 'body',
            template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner tooltip-owners"></div></div>'
          },
          title: __WEBPACK_IMPORTED_MODULE_3_react_dom_server___default.a.renderToStaticMarkup(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'tooltip-owners-name' },
              owner.name
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'ul',
              { className: 'tooltip-owners-commits' },
              Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])("Assigned based on your Project's Issue Ownership settings")
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'ul',
              { className: 'tooltip-owners-commits' },
              rule[0] + Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])(' matched: ') + rule[1]
            )
          ))
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_actorAvatar__["a" /* default */], { actor: owner, hasTooltip: false })
      )
    );
  },
  render: function render() {
    var _state = this.state,
        committers = _state.committers,
        owners = _state.owners;


    var group = this.getGroup();
    var project = this.getProject();
    var org = this.getOrganization();
    var access = new Set(org.access);

    var showCreateRule = access.has('project:write');

    var showSuggestedAssignees = committers.length > 0 || owners.length > 0;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
      null,
      showSuggestedAssignees && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'm-b-1' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h6',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Suggested Assignees')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'small',
            { style: { background: '#FFFFFF' } },
            Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Click to assign')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'avatar-grid' },
          committers.map(this.renderCommitter),
          owners.map(this.renderOwner)
        )
      ),
      showCreateRule && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'm-b-1' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h6',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Ownership Rules')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          {
            onClick: function onClick() {
              return Object(__WEBPACK_IMPORTED_MODULE_12_app_actionCreators_modal__["c" /* openCreateOwnershipRule */])({
                project: project,
                organization: org,
                issueId: group.id
              });
            },
            className: 'btn btn-default btn-sm btn-create-ownership-rule'
          },
          Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Create Ownership Rule')
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (SuggestedOwners);

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_avatar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_utils_formatters__ = __webpack_require__(320);









var GroupParticipants = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'GroupParticipants',

  propTypes: {
    participants: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired
  },

  render: function render() {
    var participants = this.props.participants;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'h6',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          participants.length,
          ' ',
          'Participant' + (participants.length === 1 ? '' : 's')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'ul',
        { className: 'faces' },
        participants.map(function (user, i) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'li',
            { key: user.username },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_app_components_tooltip__["default"],
              { title: Object(__WEBPACK_IMPORTED_MODULE_5_app_utils_formatters__["a" /* userDisplayName */])(user) },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_avatar__["a" /* default */], { size: 28, user: user })
            )
          );
        })
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (GroupParticipants);

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_dropdownLink__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_actionCreators_environments__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_stores_environmentStore__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_stores_latestContextStore__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_mixins_groupState__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_group_releaseChart__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_menuItem__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_group_seenInfo__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_locale__ = __webpack_require__(2);
















var GroupReleaseStats = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'GroupReleaseStats',

  propTypes: {
    group: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    allEnvironments: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
  },

  contextTypes: {
    organization: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_10_app_mixins_groupState__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_8_app_stores_latestContextStore__["a" /* default */], 'onLatestContextChange')],

  getInitialState: function getInitialState() {
    var envList = __WEBPACK_IMPORTED_MODULE_7_app_stores_environmentStore__["a" /* default */].getActive();

    return {
      envList: envList,
      environment: __WEBPACK_IMPORTED_MODULE_8_app_stores_latestContextStore__["a" /* default */].getInitialState().environment,
      hasEnvironmentsFeature: new Set(this.context.organization.features).has('environments')
    };
  },
  getEnvironment: function getEnvironment(envName) {
    var defaultEnv = __WEBPACK_IMPORTED_MODULE_7_app_stores_environmentStore__["a" /* default */].getDefault();
    var queriedEnvironment = __WEBPACK_IMPORTED_MODULE_7_app_stores_environmentStore__["a" /* default */].getByName(envName);

    return queriedEnvironment || defaultEnv;
  },
  onLatestContextChange: function onLatestContextChange(context) {
    this.setState({ environment: context.environment || null });
  },
  render: function render() {
    var _props = this.props,
        group = _props.group,
        allEnvironments = _props.allEnvironments;
    var _state = this.state,
        environment = _state.environment,
        hasEnvironmentsFeature = _state.hasEnvironmentsFeature;


    var envList = this.state.envList || [];

    var envName = environment ? environment.displayName : Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["t"])('All Environments');

    var projectId = this.getProject().slug;
    var orgId = this.getOrganization().slug;
    var hasRelease = this.getProjectFeatures().has('releases');
    var isLoading = !group || !allEnvironments;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'env-stats' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'h6',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          hasEnvironmentsFeature ? envName : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_app_components_dropdownLink__["default"],
            { title: envName },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12_app_components_menuItem__["default"],
              {
                isActive: environment === null,
                onClick: function onClick() {
                  return Object(__WEBPACK_IMPORTED_MODULE_6_app_actionCreators_environments__["e" /* setActiveEnvironment */])(null);
                }
              },
              Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["t"])('All Environments')
            ),
            envList.map(function (env) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_12_app_components_menuItem__["default"],
                {
                  key: env.name,
                  isActive: env.name === envName,
                  onClick: function onClick() {
                    return Object(__WEBPACK_IMPORTED_MODULE_6_app_actionCreators_environments__["e" /* setActiveEnvironment */])(env);
                  }
                },
                env.displayName
              );
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'env-content' },
        isLoading ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_loadingIndicator__["default"], null) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_group_releaseChart__["a" /* default */], {
            group: allEnvironments,
            environment: envName,
            environmentStats: group.stats,
            release: group.currentRelease ? group.currentRelease.release : null,
            releaseStats: group.currentRelease ? group.currentRelease.stats : null,
            statsPeriod: '24h',
            title: Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["t"])('Last 24 Hours'),
            firstSeen: group.firstSeen,
            lastSeen: group.lastSeen
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_group_releaseChart__["a" /* default */], {
            group: allEnvironments,
            environment: envName,
            environmentStats: group.stats,
            release: group.currentRelease ? group.currentRelease.release : null,
            releaseStats: group.currentRelease ? group.currentRelease.stats : null,
            statsPeriod: '30d',
            title: Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["t"])('Last 30 Days'),
            className: 'bar-chart-small',
            firstSeen: group.firstSeen,
            lastSeen: group.lastSeen
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h6',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["t"])('First seen')
            ),
            environment ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'small',
              null,
              '(',
              environment.displayName,
              ')'
            ) : null
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_app_components_group_seenInfo__["a" /* default */], {
            orgId: orgId,
            projectId: projectId,
            date: group.firstSeen,
            dateGlobal: allEnvironments.firstSeen,
            hasRelease: hasRelease,
            environment: environment ? environment.name : null,
            release: group.firstRelease || null,
            title: Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["t"])('First seen')
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h6',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["t"])('Last seen')
            ),
            environment ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'small',
              null,
              '(',
              environment.displayName,
              ')'
            ) : null
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_app_components_group_seenInfo__["a" /* default */], {
            orgId: orgId,
            projectId: projectId,
            date: group.lastSeen,
            dateGlobal: allEnvironments.lastSeen,
            hasRelease: hasRelease,
            environment: environment ? environment.name : null,
            release: group.lastRelease || null,
            title: Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["t"])('Last seen')
          })
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (GroupReleaseStats);

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_stackedBarChart__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_utils__ = __webpack_require__(10);









var GroupReleaseChart = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'GroupReleaseChart',

  propTypes: {
    group: __WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Group.isRequired,
    release: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
      version: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
    }),
    statsPeriod: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    environment: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    firstSeen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    lastSeen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
  },

  getInitialState: function getInitialState() {
    return this.getNextState(this.props);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    this.setState(this.getNextState(nextProps));
  },
  getNextState: function getNextState(props) {
    var releaseStats = props.releaseStats;
    var releasePoints = {};
    if (releaseStats) {
      releaseStats[props.statsPeriod].forEach(function (point) {
        releasePoints[point[0]] = point[1];
      });
    }

    var envStats = props.environmentStats;
    var envPoints = {};
    if (envStats) {
      envStats[props.statsPeriod].forEach(function (point) {
        envPoints[point[0]] = point[1];
      });
    }

    return {
      releasePoints: releasePoints,
      envPoints: envPoints
    };
  },
  renderTooltip: function renderTooltip(point, pointIdx, chart) {
    var timeLabel = chart.getTimeLabel(point);
    var totalY = 0;
    for (var i = 0; i < point.y.length; i++) {
      totalY += point.y[i];
    }

    var _props = this.props,
        environment = _props.environment,
        release = _props.release;
    var _state = this.state,
        releasePoints = _state.releasePoints,
        envPoints = _state.envPoints;


    return '<div style="width:150px">' + ('<div class="time-label">' + timeLabel + '</div>') + '<dl class="legend">' + '<dt class="inactive"><span></span></dt>' + ('<dd>' + Object(__WEBPACK_IMPORTED_MODULE_6_app_utils__["k" /* intcomma */])(totalY) + ' event' + (totalY !== 1 ? 's' : '') + '</dd>') + (environment ? '<dt class="environment"><span></span></dt>' + ('<dd>' + Object(__WEBPACK_IMPORTED_MODULE_6_app_utils__["k" /* intcomma */])(envPoints[point.x] || 0) + ' event' + (envPoints[point.x] !== 1 ? 's' : '')) + ('<small>in ' + Object(__WEBPACK_IMPORTED_MODULE_6_app_utils__["f" /* escape */])(environment) + '</small></dd>') : '') + (release ? '<dt class="active"><span></span></dt>' + ('<dd>' + Object(__WEBPACK_IMPORTED_MODULE_6_app_utils__["k" /* intcomma */])(releasePoints[point.x] || 0) + ' event' + (releasePoints[point.x] !== 1 ? 's' : '')) + ('<small>in ' + Object(__WEBPACK_IMPORTED_MODULE_6_app_utils__["f" /* escape */])(release.version.substr(0, 12)) + '</small></dd>') : '') + '</dl>' + '</div>';
  },
  render: function render() {
    var className = 'bar-chart group-chart ' + (this.props.className || '');

    var group = this.props.group;
    var stats = group.stats[this.props.statsPeriod];
    if (!stats || !stats.length) return null;

    var _state2 = this.state,
        releasePoints = _state2.releasePoints,
        envPoints = _state2.envPoints;


    var points = stats.map(function (point) {
      var rData = releasePoints[point[0]] || 0;
      var eData = (envPoints[point[0]] || 0) - rData;
      if (eData < 0) eData = 0;
      var remaining = point[1] - rData - eData;
      return {
        x: point[0],
        y: [rData, eData, remaining >= 0 ? remaining : 0]
      };
    });

    var markers = [];

    if (this.props.firstSeen) {
      var firstSeenX = new Date(this.props.firstSeen).getTime() / 1000;
      if (firstSeenX >= points[0].x) {
        markers.push({
          label: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('First seen'),
          x: firstSeenX,
          className: 'first-seen'
        });
      }
    }

    if (this.props.lastSeen) {
      var lastSeenX = new Date(this.props.lastSeen).getTime() / 1000;
      if (lastSeenX >= points[0].x) {
        markers.push({
          label: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Last seen'),
          x: lastSeenX,
          className: 'last-seen'
        });
      }
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: className },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'h6',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          this.props.title
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_stackedBarChart__["default"], {
        points: points,
        height: 40,
        label: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('events'),
        markers: markers,
        barClasses: ['release', 'environment', 'inactive'],
        tooltip: this.renderTooltip
      })
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (GroupReleaseChart);

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_dateTime__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_timeSince__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_version__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_versionHoverCard__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_utils_componentToString__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_locale__ = __webpack_require__(2);












var SeenInfo = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'SeenInfo',

  propTypes: {
    orgId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    date: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
    dateGlobal: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
    release: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
      version: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
    }),
    environment: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    hasRelease: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
    title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
  },

  contextTypes: {
    organization: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
  },

  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return (this.props.release || {}).version !== (nextProps.release || {}).version || this.props.date !== nextProps.date;
  },
  getReleaseTrackingUrl: function getReleaseTrackingUrl() {
    var _props = this.props,
        orgId = _props.orgId,
        projectId = _props.projectId;


    return '/' + orgId + '/' + projectId + '/settings/release-tracking/';
  },
  getTooltipTitle: function getTooltipTitle() {
    var _props2 = this.props,
        date = _props2.date,
        dateGlobal = _props2.dateGlobal,
        environment = _props2.environment,
        title = _props2.title;


    return Object(__WEBPACK_IMPORTED_MODULE_8_app_utils_componentToString__["a" /* componentToString */])(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { style: { width: 170 } },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'time-label' },
        title
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'dl',
        { className: 'flat' },
        environment && [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'dt',
          { key: '0' },
          Object(__WEBPACK_IMPORTED_MODULE_9_app_utils__["s" /* toTitleCase */])(environment)
        ), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'dd',
          { key: '0.1' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_timeSince__["default"], { date: date }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null)
        )],
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'dt',
          { key: '1' },
          Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Globally:')
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'dd',
          { key: '1.1' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_timeSince__["default"], { date: dateGlobal }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null)
        )
      )
    ));
  },
  render: function render() {
    var _props3 = this.props,
        date = _props3.date,
        dateGlobal = _props3.dateGlobal,
        environment = _props3.environment,
        release = _props3.release,
        orgId = _props3.orgId,
        projectId = _props3.projectId;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'dl',
      { className: 'seen-info' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'dt',
        { key: 0 },
        Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('When'),
        ':'
      ),
      date ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'dd',
        { key: 1 },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_app_components_tooltip__["default"],
          { title: this.getTooltipTitle(), tooltipOptions: { html: true } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_timeSince__["default"], { className: 'dotted-underline', date: date })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'small',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_dateTime__["default"], { date: date, seconds: true })
        )
      ) : dateGlobal && environment === '' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'dd',
        { key: 1 },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_app_components_tooltip__["default"],
          { title: this.getTooltipTitle(), tooltipOptions: { html: true } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_timeSince__["default"], { date: dateGlobal })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'small',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_dateTime__["default"], { date: dateGlobal, seconds: true })
        )
      ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'dd',
        { key: 1 },
        Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('n/a')
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'dt',
        { key: 4 },
        Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Release'),
        ':'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_9_app_utils__["d" /* defined */])(release) ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'dd',
        { key: 5 },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_app_components_versionHoverCard__["a" /* default */],
          {
            orgId: orgId,
            projectId: projectId,
            version: release.version
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_version__["a" /* default */], { orgId: orgId, projectId: projectId, version: release.version })
        )
      ) : !this.props.hasRelease ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'dd',
        { key: 5 },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'small',
          { style: { marginLeft: 5, fontStyle: 'italic' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            { href: this.getReleaseTrackingUrl() },
            Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('not configured')
          )
        )
      ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'dd',
        { key: 5 },
        Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('n/a')
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (SeenInfo);

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = componentToString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom_server__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom_server___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom_server__);


function componentToString(node) {
  return __WEBPACK_IMPORTED_MODULE_0_react_dom_server___default.a.renderToStaticMarkup(node);
}

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TagDistributionMeter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_utils_withEnvironment__ = __webpack_require__(158);











var TagDistributionMeter = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'TagDistributionMeter',

  propTypes: {
    group: __WEBPACK_IMPORTED_MODULE_5_app_proptypes__["e" /* default */].Group.isRequired,
    tag: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    orgId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    environment: __WEBPACK_IMPORTED_MODULE_5_app_proptypes__["e" /* default */].Environment
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    return {
      loading: true,
      error: false,
      data: null
    };
  },
  componentWillMount: function componentWillMount() {
    this.fetchData();
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return this.state.loading !== nextState.loading || this.state.error !== nextState.error || this.props.tag !== nextProps.tag || this.props.name !== nextProps.name || this.props.environment !== nextProps.environment;
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    if (prevProps.environment !== this.props.environment) {
      this.fetchData();
    }
  },
  fetchData: function fetchData() {
    var _this = this;

    var _props = this.props,
        group = _props.group,
        tag = _props.tag,
        environment = _props.environment;

    var url = '/issues/' + group.id + '/tags/' + encodeURIComponent(tag) + '/';
    var query = environment ? { environment: environment.name } : {};

    this.setState({
      loading: true,
      error: false
    });

    this.api.request(url, {
      query: query,
      success: function success(data) {
        _this.setState({
          data: data,
          error: false,
          loading: false
        });
      },
      error: function error() {
        _this.setState({
          error: true,
          loading: false
        });
      }
    });
  },


  /**
   * Render segments of tag distribution
   *
   * e.g.
   *
   * .--------.-----.----------------.
   * |  web-1 |web-2|     other      |
   * `--------'-----'----------------'
   */

  renderSegments: function renderSegments() {
    var _this2 = this;

    var data = this.state.data;
    var totalValues = data.totalValues;

    var totalVisible = data.topValues.reduce(function (sum, value) {
      return sum + value.count;
    }, 0);

    var hasOther = totalVisible < totalValues;
    var otherPct = Object(__WEBPACK_IMPORTED_MODULE_7_app_utils__["p" /* percent */])(totalValues - totalVisible, totalValues);
    var otherPctLabel = Math.floor(otherPct);

    var _props2 = this.props,
        orgId = _props2.orgId,
        projectId = _props2.projectId;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'segments' },
      data.topValues.map(function (value, index) {
        var pct = Object(__WEBPACK_IMPORTED_MODULE_7_app_utils__["p" /* percent */])(value.count, totalValues);
        var pctLabel = Math.floor(pct);
        var className = 'segment segment-' + index;

        var tooltipHtml = '<div class="truncate">' + Object(__WEBPACK_IMPORTED_MODULE_7_app_utils__["f" /* escape */])(Object(__WEBPACK_IMPORTED_MODULE_7_app_utils__["e" /* deviceNameMapper */])(value.name) || '') + '</div>' + pctLabel + '%';

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_app_components_tooltip__["default"],
          { key: value.key, title: tooltipHtml, tooltipOptions: { html: true } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_router__["Link"],
            {
              className: className,
              style: { width: pct + '%' },
              to: '/' + orgId + '/' + projectId + '/issues/' + _this2.props.group.id + '/tags/' + _this2.props.tag + '/'
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: 'tag-description' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'tag-percentage' },
                pctLabel,
                '%'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'tag-label' },
                Object(__WEBPACK_IMPORTED_MODULE_7_app_utils__["e" /* deviceNameMapper */])(value.name)
              )
            )
          )
        );
      }),
      hasOther && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router__["Link"],
        {
          key: 'other',
          className: 'segment segment-9',
          style: { width: otherPct + '%' },
          to: '/' + orgId + '/' + projectId + '/issues/' + this.props.group.id + '/tags/' + this.props.tag + '/',
          title: 'Other<br/>' + otherPctLabel + '%'
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'tag-description' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'tag-percentage' },
            otherPctLabel,
            '%'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'tag-label' },
            Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('Other')
          )
        )
      )
    );
  },
  renderBody: function renderBody() {
    if (this.state.loading || this.state.error) return null;

    if (!this.state.data.totalValues) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'p',
      null,
      Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('No recent data.')
    );

    return this.renderSegments();
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'distribution-graph' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'h6',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          this.props.tag
        )
      ),
      this.renderBody()
    );
  }
});


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_app_utils_withEnvironment__["a" /* default */])(TagDistributionMeter));

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MutedBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_dateTime__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_duration__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var MutedBox = (_temp2 = _class = function (_React$PureComponent) {
  _inherits(MutedBox, _React$PureComponent);

  function MutedBox() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MutedBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MutedBox.__proto__ || Object.getPrototypeOf(MutedBox)).call.apply(_ref, [this].concat(args))), _this), _this.renderReason = function () {
      var details = _this.props.statusDetails;
      if (details.ignoreUntil) {
        return Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('This issue has been ignored until %s', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'strong',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_dateTime__["default"], { date: details.ignoreUntil })
        ));
      } else if (details.ignoreCount && details.ignoreWindow) {
        return Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('This issue has been ignored until it occurs %s time(s) in %s', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'strong',
          null,
          details.ignoreCount.toLocaleString()
        ), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'strong',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_duration__["a" /* default */], { seconds: details.ignoreWindow * 60 })
        ));
      } else if (details.ignoreCount) {
        return Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('This issue has been ignored until it occurs %s more time(s)', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'strong',
          null,
          details.ignoreCount.toLocaleString()
        ));
      } else if (details.ignoreUserCount && details.ignoreUserWindow) {
        return Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('This issue has been ignored until it affects %s user(s) in %s', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'strong',
          null,
          details.ignoreUserCount.toLocaleString()
        ), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'strong',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_duration__["a" /* default */], { seconds: details.ignoreUserWindow * 60 })
        ));
      } else if (details.ignoreUserCount) {
        return Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('This issue has been ignored until it affects %s more user(s)', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'strong',
          null,
          details.ignoreUserCount.toLocaleString()
        ));
      }
      return Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('This issue has been ignored');
    }, _this.render = function () {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'box' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon icon-soundoff' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            _this.renderReason(),
            ' \u2014 '
          ),
          Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('You will not be notified of any changes and it will not show up by default in feeds.')
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return MutedBox;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent), _class.propTypes = {
  statusDetails: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp2);


/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_errors_detailedError__ = __webpack_require__(495);






var GroupEventDetailsLoadingError = function GroupEventDetailsLoadingError(_ref) {
  var onRetry = _ref.onRetry;

  var reasons = [Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('The events are still processing and are on their way'), Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('The events have been deleted'), Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('There is an internal systems error or active issue')];

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_errors_detailedError__["a" /* default */], {
    className: 'group-event-details-error',
    onRetry: onRetry,
    heading: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Sorry, the events for this issue could not be found.'),
    message: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'p',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('This could be due to a handful of reasons:')
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'ol',
        { className: 'detailed-error-list' },
        reasons.map(function (reason, i) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'li',
            { key: i },
            reason
          );
        })
      )
    )
  });
};

GroupEventDetailsLoadingError.propTypes = {
  onRetry: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (GroupEventDetailsLoadingError);

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResolutionBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_avatar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_version__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ResolutionBox = (_temp2 = _class = function (_React$Component) {
  _inherits(ResolutionBox, _React$Component);

  function ResolutionBox() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ResolutionBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ResolutionBox.__proto__ || Object.getPrototypeOf(ResolutionBox)).call.apply(_ref, [this].concat(args))), _this), _this.renderReason = function () {
      var _this$props = _this.props,
          params = _this$props.params,
          statusDetails = _this$props.statusDetails;

      var actor = statusDetails.actor ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'strong',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_avatar__["a" /* default */], { user: statusDetails.actor, size: 20, className: 'avatar' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { style: { marginLeft: 5 } },
          statusDetails.actor.name
        )
      ) : null;

      if (statusDetails.inNextRelease && statusDetails.actor) {
        return Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["tct"])('[actor] marked this issue as resolved in the upcoming release.', {
          actor: actor
        });
      } else if (statusDetails.inNextRelease) {
        return Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('This issue has been marked as resolved in the upcoming release.');
      } else if (statusDetails.inRelease && statusDetails.actor) {
        return Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["tct"])('[actor] marked this issue as resolved in version [version].', {
          actor: actor,
          version: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_version__["a" /* default */], {
            version: statusDetails.inRelease,
            orgId: params.orgId,
            projectId: params.projectId
          })
        });
      } else if (statusDetails.inRelease) {
        return Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["tct"])('This issue has been marked as resolved in version [version].', {
          version: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_version__["a" /* default */], {
            version: statusDetails.inRelease,
            orgId: params.orgId,
            projectId: params.projectId
          })
        });
      }
      return Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('This issue has been marked as resolved.');
    }, _this.render = function () {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'box' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon icon-checkmark' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { className: 'truncate break-all' },
          _this.renderReason()
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return ResolutionBox;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  statusDetails: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp2);


/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_views_groupMerged_mergedList__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_actions_groupingActions__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_stores_groupingStore__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_loadingIndicator__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













var GroupMergedView = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'GroupMergedView',
  mixins: [__WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_2_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_7_app_stores_groupingStore__["a" /* default */], 'onGroupingUpdate')],

  getInitialState: function getInitialState() {
    var queryParams = this.props.location.query;
    return {
      mergedItems: [],
      loading: true,
      error: false,
      query: queryParams.query || ''
    };
  },
  componentWillMount: function componentWillMount() {
    this.fetchData();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.params.groupId !== this.props.params.groupId || nextProps.location.search !== this.props.location.search) {
      var queryParams = nextProps.location.query;
      this.setState({
        query: queryParams.query
      }, this.fetchData);
    }
  },
  onGroupingUpdate: function onGroupingUpdate(_ref) {
    var mergedItems = _ref.mergedItems,
        mergedLinks = _ref.mergedLinks,
        loading = _ref.loading,
        error = _ref.error;

    if (mergedItems) {
      this.setState({
        mergedItems: mergedItems,
        mergedLinks: mergedLinks,
        loading: typeof loading !== 'undefined' ? loading : false,
        error: typeof error !== 'undefined' ? error : false
      });
    }
  },
  getEndpoint: function getEndpoint() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'hashes';

    var params = this.props.params;
    var queryParams = _extends({}, this.props.location.query, {
      limit: 50,
      query: this.state.query
    });

    return '/issues/' + params.groupId + '/' + type + '/?' + jQuery.param(queryParams);
  },
  fetchData: function fetchData() {
    __WEBPACK_IMPORTED_MODULE_6_app_actions_groupingActions__["a" /* default */].fetch([{
      endpoint: this.getEndpoint('hashes'),
      dataKey: 'merged',
      queryParams: this.props.location.query
    }]);
  },
  handleCollapse: function handleCollapse() {
    __WEBPACK_IMPORTED_MODULE_6_app_actions_groupingActions__["a" /* default */].collapseFingerprints();
  },
  handleUnmerge: function handleUnmerge() {
    __WEBPACK_IMPORTED_MODULE_6_app_actions_groupingActions__["a" /* default */].unmerge({
      groupId: this.props.params.groupId,
      loadingMessage: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Unmerging events') + '...',
      successMessage: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Events successfully queued for unmerging.'),
      errorMessage: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Unable to queue events for unmerging.')
    });
  },
  render: function render() {
    var _props$params = this.props.params,
        orgId = _props$params.orgId,
        projectId = _props$params.projectId,
        groupId = _props$params.groupId;

    var isLoading = this.state.loading;
    var isError = this.state.error && !isLoading;
    var isLoadedSuccessfully = !isError && !isLoading;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert alert-block alert-warning' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Warning'),
          ':'
        ),
        ' ',
        Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('This is an experimental feature. Data may not be immediately available while we process unmerges.')
      ),
      isLoading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_loadingIndicator__["default"], null),
      isError && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_loadingError__["default"], {
        message: 'Unable to load merged events, please try again later',
        onRetry: this.fetchData
      }),
      isLoadedSuccessfully && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_views_groupMerged_mergedList__["a" /* default */], {
        items: this.state.mergedItems,
        orgId: orgId,
        projectId: projectId,
        groupId: groupId,
        pageLinks: this.state.mergedLinks,
        busyMap: this.state.busy,
        hiddenMap: this.state.hidden,
        onUnmerge: this.handleUnmerge,
        onToggleCollapse: __WEBPACK_IMPORTED_MODULE_6_app_actions_groupingActions__["a" /* default */].toggleCollapseFingerprints
      })
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (GroupMergedView);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_views_groupMerged_mergedItem__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_views_groupMerged_mergedToolbar__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_pagination__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_queryCount__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_emptyStateWarning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_panels__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var MergedList = (_temp2 = _class = function (_React$Component) {
  _inherits(MergedList, _React$Component);

  function MergedList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MergedList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MergedList.__proto__ || Object.getPrototypeOf(MergedList)).call.apply(_ref, [this].concat(args))), _this), _this.renderEmpty = function () {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_app_components_emptyStateWarning__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])("There don't seem to be any hashes for this issue.")
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MergedList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          items = _props.items,
          pageLinks = _props.pageLinks,
          onToggleCollapse = _props.onToggleCollapse,
          onUnmerge = _props.onUnmerge,
          otherProps = _objectWithoutProperties(_props, ['items', 'pageLinks', 'onToggleCollapse', 'onUnmerge']);

      var itemsWithLatestEvent = items.filter(function (_ref2) {
        var latestEvent = _ref2.latestEvent;
        return !!latestEvent;
      });
      var hasResults = itemsWithLatestEvent.length > 0;

      if (!hasResults) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_app_components_panels__["a" /* Panel */],
          null,
          this.renderEmpty()
        );
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'merged-list-container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h2',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Merged fingerprints with latest event')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_queryCount__["a" /* default */], { count: itemsWithLatestEvent.length })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_views_groupMerged_mergedToolbar__["a" /* default */], _extends({}, otherProps, {
          onToggleCollapse: onToggleCollapse,
          onUnmerge: onUnmerge
        })),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'merged-list' },
          itemsWithLatestEvent.map(function (_ref3) {
            var id = _ref3.id,
                latestEvent = _ref3.latestEvent;
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_views_groupMerged_mergedItem__["a" /* default */], _extends({
              key: id
            }, otherProps, {
              disabled: items.length === 1,
              event: latestEvent,
              fingerprint: id,
              itemCount: items.length
            }));
          })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_pagination__["default"], { pageLinks: pageLinks })
      );
    }
  }]);

  return MergedList;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  onUnmerge: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  onToggleCollapse: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  items: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_app_proptypes__["b" /* Event */]),
  pageLinks: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (MergedList);

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_checkbox__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_eventOrGroupHeader__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_flowLayout__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_actions_groupingActions__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_stores_groupingStore__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_spreadLayout__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_less_components_mergedItem_less__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_less_components_mergedItem_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_app_less_components_mergedItem_less__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
















var MergedItem = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'MergedItem',

  propTypes: {
    orgId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    fingerprint: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    disabled: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    event: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
      groupID: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
      type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['error', 'csp', 'default']),
      dateCreated: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
      platform: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
    })
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_9_app_stores_groupingStore__["a" /* default */], 'onGroupingChange')],

  getInitialState: function getInitialState() {
    return {
      collapsed: false,
      checked: false,
      busy: false
    };
  },
  onGroupingChange: function onGroupingChange(_ref) {
    var _this = this;

    var unmergeState = _ref.unmergeState;

    if (!unmergeState) return;

    var fingerprint = this.props.fingerprint;

    var stateForId = unmergeState.has(fingerprint) && unmergeState.get(fingerprint);
    if (!stateForId) return;

    Object.keys(stateForId).forEach(function (key) {
      if (stateForId[key] === _this.state[key]) return;

      _this.setState(_defineProperty({}, key, stateForId[key]));
    });
  },
  handleToggleEvents: function handleToggleEvents() {
    var fingerprint = this.props.fingerprint;

    __WEBPACK_IMPORTED_MODULE_8_app_actions_groupingActions__["a" /* default */].toggleCollapseFingerprint(fingerprint);
  },


  // Disable default behavior of toggling checkbox
  handleLabelClick: function handleLabelClick(e) {
    e.preventDefault();
  },
  handleToggle: function handleToggle(e) {
    var _props = this.props,
        disabled = _props.disabled,
        fingerprint = _props.fingerprint,
        event = _props.event;


    if (disabled || this.state.busy) return;

    // clicking anywhere in the row will toggle the checkbox
    __WEBPACK_IMPORTED_MODULE_8_app_actions_groupingActions__["a" /* default */].toggleUnmerge([fingerprint, event.id]);
  },
  render: function render() {
    var _props2 = this.props,
        disabled = _props2.disabled,
        event = _props2.event,
        orgId = _props2.orgId,
        fingerprint = _props2.fingerprint,
        projectId = _props2.projectId;

    var checkboxDisabled = disabled || this.state.disabled;
    var cx = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('merged-group', {
      expanded: !this.state.collapsed,
      busy: this.state.busy
    });

    // `event` can be null if last event w/ fingerprint is not within retention period
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: cx },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_app_components_spreadLayout__["a" /* default */],
        { className: 'merged-controls', responsive: true },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_app_components_flowLayout__["a" /* default */],
          { onClick: this.handleToggle },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'action-column' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_checkbox__["a" /* default */], {
              id: fingerprint,
              value: fingerprint,
              checked: this.state.checked,
              disabled: checkboxDisabled
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'label',
            {
              onClick: this.handleLabelClick,
              htmlFor: fingerprint,
              className: 'truncate fingerprint'
            },
            fingerprint
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'merged-collapse', onClick: this.handleToggleEvents },
            this.state.collapsed ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'icon-arrow-down' }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'icon-arrow-up' })
          )
        )
      ),
      !this.state.collapsed && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'merged-events-list event-list' },
        event && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_app_components_spreadLayout__["a" /* default */],
          { className: 'event-details', responsive: true },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_app_components_flowLayout__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_eventOrGroupHeader__["a" /* default */], {
              orgId: orgId,
              projectId: projectId,
              data: event,
              hideIcons: true,
              hideLevel: true
            })
          )
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (MergedItem);

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(1120),
    hasIn = __webpack_require__(1123);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(1121),
    baseSet = __webpack_require__(1122),
    castPath = __webpack_require__(171);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(171),
    toKey = __webpack_require__(223);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(419),
    castPath = __webpack_require__(171),
    isIndex = __webpack_require__(423),
    isObject = __webpack_require__(121),
    toKey = __webpack_require__(223);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1124),
    hasPath = __webpack_require__(1125);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1124 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(171),
    isArguments = __webpack_require__(274),
    isArray = __webpack_require__(47),
    isIndex = __webpack_require__(423),
    isLength = __webpack_require__(487),
    toKey = __webpack_require__(223);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1127);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(94)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--4-1!../../../../../../node_modules/less-loader/dist/cjs.js!./mergedItem.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--4-1!../../../../../../node_modules/less-loader/dist/cjs.js!./mergedItem.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(93)(undefined);
// imports


// module
exports.push([module.i, ".merged-list{border:1px solid #e2dee6;border-top:none}.merged-group.busy{opacity:.2}.merged-group:first-child .merged-controls{border-top:none}.expanded .merged-controls,.merged-group:last-child .merged-controls{border-bottom:1px solid #e2dee6}.merged-controls{border-top:1px solid #e2dee6;background-color:#f3f1f6;padding:5px 0}.merged-controls .action-column{padding:0 10px;display:flex;align-items:center}.merged-controls .action-column input{margin:0}.merged-controls label{margin:0;font-weight:400}.merged-collapse{cursor:pointer;padding:0 10px}.merged-list .table{table-layout:fixed}.merged-list .table>tbody>tr>td,.merged-list .table>thead>tr>th{width:300px}.merged-events-list.event-list{overflow:hidden;border:none}.merged-events-list.event-list .event-details{padding:10px}.merged-events-list.event-list .event-details .event-message{margin-bottom:0}.merged-events-list .fingerprint{font-family:Monaco,monospace;font-size:11px;margin-left:5px;padding-left:5px}.fingerprint-header{font-weight:700;font-size:14px}.merged-toolbar{padding:5px 10px}", ""]);

// exports


/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_pick__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_stores_groupingStore__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_actionCreators_modal__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_linkWithConfirmation__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_toolbar__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_spreadLayout__ = __webpack_require__(127);


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();















var MergedToolbar = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'MergedToolbar',

  propTypes: {
    onUnmerge: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    groupId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    onToggleCollapse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_6_app_stores_groupingStore__["a" /* default */], 'onGroupingUpdate')],

  getInitialState: function getInitialState() {
    var unmergeList = __WEBPACK_IMPORTED_MODULE_6_app_stores_groupingStore__["a" /* default */].unmergeList,
        unmergeLastCollapsed = __WEBPACK_IMPORTED_MODULE_6_app_stores_groupingStore__["a" /* default */].unmergeLastCollapsed,
        unmergeDisabled = __WEBPACK_IMPORTED_MODULE_6_app_stores_groupingStore__["a" /* default */].unmergeDisabled,
        enableFingerprintCompare = __WEBPACK_IMPORTED_MODULE_6_app_stores_groupingStore__["a" /* default */].enableFingerprintCompare;


    return {
      enableFingerprintCompare: enableFingerprintCompare,
      unmergeList: unmergeList,
      unmergeLastCollapsed: unmergeLastCollapsed,
      unmergeDisabled: unmergeDisabled
    };
  },
  onGroupingUpdate: function onGroupingUpdate(updateObj) {
    var allowedKeys = ['unmergeLastCollapsed', 'unmergeDisabled', 'unmergeList', 'enableFingerprintCompare'];

    this.setState(__WEBPACK_IMPORTED_MODULE_0_lodash_pick___default()(updateObj, allowedKeys));
  },
  handleShowDiff: function handleShowDiff(e) {
    var groupId = this.props.groupId;

    var entries = this.state.unmergeList.entries();

    // `unmergeList` should only have 2 items in map
    if (this.state.unmergeList.size !== 2) return;

    // only need eventId, not fingerprint

    var _Array$from$map = Array.from(entries).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          eventId = _ref2[1];

      return eventId;
    }),
        _Array$from$map2 = _slicedToArray(_Array$from$map, 2),
        baseEventId = _Array$from$map2[0],
        targetEventId = _Array$from$map2[1];

    Object(__WEBPACK_IMPORTED_MODULE_7_app_actionCreators_modal__["e" /* openDiffModal */])({
      baseIssueId: groupId,
      targetIssueId: groupId,
      baseEventId: baseEventId,
      targetEventId: targetEventId
    });

    e.stopPropagation();
  },
  render: function render() {
    var _props = this.props,
        onUnmerge = _props.onUnmerge,
        onToggleCollapse = _props.onToggleCollapse;

    var unmergeCount = this.state.unmergeList && this.state.unmergeList.size || 0;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_app_components_toolbar__["a" /* default */],
      { className: 'merged-toolbar' },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_app_components_spreadLayout__["a" /* default */],
        { responsive: true },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_app_components_spreadLayout__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'merged-toolbar-actions' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_app_components_linkWithConfirmation__["a" /* default */],
              {
                disabled: this.state.unmergeDisabled,
                title: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Unmerging ' + unmergeCount + ' events'),
                message: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('These events will be unmerged and grouped into a new issue. Are you sure you want to unmerge these events?'),
                className: 'btn btn-sm btn-default',
                onConfirm: onUnmerge
              },
              Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Unmerge'),
              ' (',
              unmergeCount || 0,
              ')'
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_app_components_buttons_button__["default"],
              {
                style: { marginLeft: 10 },
                size: 'small',
                disabled: !this.state.enableFingerprintCompare,
                onClick: this.handleShowDiff
              },
              Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Compare')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_app_components_spreadLayout__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_app_components_buttons_button__["default"],
              {
                className: 'toggle-collapse-all',
                size: 'small',
                onClick: onToggleCollapse
              },
              this.state.unmergeLastCollapsed ? Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Expand All') : Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Collapse All')
            )
          )
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (MergedToolbar);

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1130);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(94)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--4-1!../../../../../../node_modules/less-loader/dist/cjs.js!./toolbar.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--4-1!../../../../../../node_modules/less-loader/dist/cjs.js!./toolbar.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(93)(undefined);
// imports


// module
exports.push([module.i, ".toolbar{background:#fbfbfc;border:1px solid #e2dee6;border-bottom:none;border-radius:3px 3px 0 0;box-shadow:0 1px 0 #e2dee6;margin:0}", ""]);

// exports


/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_actions_groupingActions__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_stores_groupingStore__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_mixins_projectState__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_views_groupSimilar_similarList__ = __webpack_require__(1132);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















var GroupGroupingView = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'GroupGroupingView',

  propTypes: {
    query: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_10_app_mixins_projectState__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_7_app_stores_groupingStore__["a" /* default */], 'onGroupingUpdate')],

  getInitialState: function getInitialState() {
    return {
      similarItems: [],
      filteredSimilarItems: [],
      similarLinks: [],
      loading: true,
      error: false
    };
  },
  componentWillMount: function componentWillMount() {
    this.fetchData();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.params.groupId !== this.props.params.groupId || nextProps.location.search !== this.props.location.search) {
      this.fetchData();
    }
  },
  onGroupingUpdate: function onGroupingUpdate(_ref) {
    var mergedParent = _ref.mergedParent,
        similarItems = _ref.similarItems,
        similarLinks = _ref.similarLinks,
        filteredSimilarItems = _ref.filteredSimilarItems,
        loading = _ref.loading,
        error = _ref.error;

    if (similarItems) {
      this.setState({
        similarItems: similarItems,
        similarLinks: similarLinks,
        filteredSimilarItems: filteredSimilarItems,
        loading: typeof loading !== 'undefined' ? loading : false,
        error: typeof error !== 'undefined' ? error : false
      });
    } else if (mergedParent && mergedParent !== this.props.params.groupId) {
      // Merge success, since we can't specify target, we need to redirect to new parent
      __WEBPACK_IMPORTED_MODULE_3_react_router__["browserHistory"].push('/issues/' + mergedParent + '/similar/');
    }
  },
  getEndpoint: function getEndpoint() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'similar';

    var params = this.props.params;
    var queryParams = _extends({}, this.props.location.query, {
      limit: 50
    });
    return '/issues/' + params.groupId + '/' + type + '/?' + jQuery.param(queryParams);
  },
  fetchData: function fetchData() {
    var projectFeatures = this.getProjectFeatures();

    this.setState({
      loading: true,
      error: false
    });

    var reqs = [];

    if (projectFeatures.has('similarity-view')) {
      reqs.push({
        endpoint: this.getEndpoint('similar'),
        dataKey: 'similar',
        queryParams: this.props.location.query
      });
    }

    __WEBPACK_IMPORTED_MODULE_6_app_actions_groupingActions__["a" /* default */].fetch(reqs);
  },
  handleMerge: function handleMerge() {
    var _props = this.props,
        query = _props.query,
        params = _props.params;


    if (params) {
      __WEBPACK_IMPORTED_MODULE_6_app_actions_groupingActions__["a" /* default */].merge({
        params: params,
        query: query
      });
    }
  },
  render: function render() {
    var _props$params = this.props.params,
        orgId = _props$params.orgId,
        projectId = _props$params.projectId,
        groupId = _props$params.groupId;

    var isLoading = this.state.loading;
    var isError = this.state.error && !isLoading;
    var isLoadedSuccessfully = !isError && !isLoading;
    var projectFeatures = this.getProjectFeatures();
    var hasSimilarItems = projectFeatures.has('similarity-view') && (this.state.similarItems.length >= 0 || this.state.filteredSimilarItems.length >= 0) && isLoadedSuccessfully;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'alert alert-block alert-warning' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'strong',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Warning'),
          ':'
        ),
        ' ',
        Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('This is an experimental feature. Data may not be immediately available while we process merges.')
      ),
      isLoading && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_loadingIndicator__["default"], null),
      isError && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_loadingError__["default"], {
        message: 'Unable to load similar issues, please try again later',
        onRetry: this.fetchData
      }),
      hasSimilarItems && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_views_groupSimilar_similarList__["a" /* default */], {
        items: this.state.similarItems,
        filteredItems: this.state.filteredSimilarItems,
        onMerge: this.handleMerge,
        orgId: orgId,
        projectId: projectId,
        groupId: groupId,
        pageLinks: this.state.similarLinks
      })
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (GroupGroupingView);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_pagination__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_queryCount__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_views_groupSimilar_similarItem__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_similarSpectrum__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_views_groupSimilar_similarToolbar__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_spreadLayout__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_emptyStateWarning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_panels__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var SimilarItemPropType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  issue: __WEBPACK_IMPORTED_MODULE_2_app_proptypes__["c" /* Group */],
  score: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  avgScore: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  isBelowThreshold: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
});

var SimilarList = (_temp = _class = function (_React$Component) {
  _inherits(SimilarList, _React$Component);

  function SimilarList() {
    var _ref;

    _classCallCheck(this, SimilarList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = SimilarList.__proto__ || Object.getPrototypeOf(SimilarList)).call.apply(_ref, [this].concat(args)));

    _this.renderEmpty = function () {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_app_components_panels__["a" /* Panel */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_app_components_emptyStateWarning__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('There are no similar issues.')
          )
        )
      );
    };

    _this.handleShowAll = function () {
      _this.setState({ showAllItems: true });
    };

    _this.state = {
      showAllItems: false
    };
    return _this;
  }

  _createClass(SimilarList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          orgId = _props.orgId,
          groupId = _props.groupId,
          projectId = _props.projectId,
          items = _props.items,
          filteredItems = _props.filteredItems,
          pageLinks = _props.pageLinks,
          onMerge = _props.onMerge;

      var hasHiddenItems = !!filteredItems.length;
      var hasResults = items.length > 0 || hasHiddenItems;
      var itemsWithFiltered = items.concat(this.state.showAllItems && filteredItems || []);

      if (!hasResults) {
        return this.renderEmpty();
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'similar-list-container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_app_components_spreadLayout__["a" /* default */],
          { className: 'similar-list-header' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h2',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Similar Issues')
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_queryCount__["a" /* default */], { count: items.length + filteredItems.length })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_similarSpectrum__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_views_groupSimilar_similarToolbar__["a" /* default */], { onMerge: onMerge }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'similar-list' },
          itemsWithFiltered.map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_views_groupSimilar_similarItem__["a" /* default */], _extends({
              key: item.issue.id,
              orgId: orgId,
              projectId: projectId,
              groupId: groupId
            }, item));
          }),
          hasHiddenItems && !this.state.showAllItems && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'similar-items-footer' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'button',
              { className: 'btn btn-default btn-xl', onClick: this.handleShowAll },
              'Show ',
              filteredItems.length,
              ' issues below threshold'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_pagination__["default"], { pageLinks: pageLinks })
      );
    }
  }]);

  return SimilarList;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  orgId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  groupId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  onMerge: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  pageLinks: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  items: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(SimilarItemPropType),
  filteredItems: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(SimilarItemPropType)
}, _class.defaultProps = {
  filteredItems: []
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (SimilarList);

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_actionCreators_modal__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_checkbox__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_count__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_eventOrGroupExtraDetails__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_eventOrGroupHeader__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_flowLayout__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_actions_groupingActions__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_stores_groupingStore__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_hovercard__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_scoreBar__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_components_similarScoreCard__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_components_spreadLayout__ = __webpack_require__(127);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




















var similarInterfaces = ['exception', 'message'];

var SimilarIssueItem = __WEBPACK_IMPORTED_MODULE_4_create_react_class___default()({
  displayName: 'SimilarIssueItem',

  propTypes: {
    orgId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    groupId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    score: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    scoresByInterface: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
      exception: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,
      message: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array
    }),
    aggregate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
      exception: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
      message: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
    }),
    issue: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
      id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
      level: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
      type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['error', 'csp', 'default']).isRequired,
      title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
      metadata: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
        value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        message: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        directive: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        uri: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
      }).isRequired,
      culprit: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
      hideLevel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
    })
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_12_app_stores_groupingStore__["a" /* default */], 'onGroupingUpdate')],

  getInitialState: function getInitialState() {
    return {
      visible: true,
      checked: false,
      busy: false
    };
  },
  onGroupingUpdate: function onGroupingUpdate(_ref) {
    var _this = this;

    var mergeState = _ref.mergeState;
    var issue = this.props.issue;

    if (mergeState) {
      var stateForId = mergeState.has(issue.id) && mergeState.get(issue.id);
      if (stateForId) {
        Object.keys(stateForId).forEach(function (key) {
          if (stateForId[key] !== _this.state[key]) {
            _this.setState(_defineProperty({}, key, stateForId[key]));
          }
        });
      }
    }
  },
  handleToggle: function handleToggle(e) {
    var issue = this.props.issue;

    // clicking anywhere in the row will toggle the checkbox

    if (!this.state.busy) {
      __WEBPACK_IMPORTED_MODULE_11_app_actions_groupingActions__["a" /* default */].toggleMerge(issue.id);
    }
  },
  handleShowDiff: function handleShowDiff(e) {
    var _props = this.props,
        groupId = _props.groupId,
        issue = _props.issue;

    Object(__WEBPACK_IMPORTED_MODULE_5_app_actionCreators_modal__["e" /* openDiffModal */])({
      baseIssueId: groupId,
      targetIssueId: issue.id
    });

    e.stopPropagation();
  },
  render: function render() {
    var _props2 = this.props,
        aggregate = _props2.aggregate,
        scoresByInterface = _props2.scoresByInterface,
        issue = _props2.issue,
        orgId = _props2.orgId,
        projectId = _props2.projectId;


    if (!this.state.visible) {
      return null;
    }

    var cx = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('group', 'similar-issue', {
      isResolved: issue.status === 'resolved',
      busy: this.state.busy
    });

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_16_app_components_spreadLayout__["a" /* default */],
      { className: cx, responsive: true, onClick: this.handleToggle },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_app_components_flowLayout__["a" /* default */],
        { truncate: true },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_app_components_flowLayout__["a" /* default */],
          { truncate: true },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'action-column' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_checkbox__["a" /* default */], { id: issue.id, value: issue.id, checked: this.state.checked })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'event-details level-error', style: { flex: 1 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_eventOrGroupHeader__["a" /* default */], { orgId: orgId, projectId: projectId, data: issue }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_eventOrGroupExtraDetails__["a" /* default */], _extends({}, issue, {
              groupId: issue.id,
              orgId: orgId,
              projectId: projectId,
              lastSeen: null,
              showAssignee: true,
              showStatus: true,
              group: true
            }))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'button',
          {
            style: { marginRight: 2 },
            className: 'btn btn-default btn-xs',
            onClick: this.handleShowDiff
          },
          'Diff'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'similar-score-columns' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_count__["default"], { className: 'similar-score-column', value: issue.count }),
        similarInterfaces.map(function (interfaceName) {
          var avgScore = aggregate[interfaceName];
          var scoreList = scoresByInterface[interfaceName] || [];
          // Check for valid number (and not NaN)
          var scoreValue = typeof avgScore === 'number' && !Number.isNaN(avgScore) ? avgScore : 0;

          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { key: interfaceName, className: 'similar-score-column' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_app_components_hovercard__["a" /* default */],
              {
                body: scoreList.length && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_app_components_similarScoreCard__["a" /* default */], { scoreList: scoreList })
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_app_components_scoreBar__["a" /* default */], { vertical: true, score: Math.round(scoreValue * 5) })
            )
          );
        })
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (SimilarIssueItem);

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_less_components_scoreBar_less__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_less_components_scoreBar_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_app_less_components_scoreBar_less__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ScoreBar = (_temp = _class = function (_React$Component) {
  _inherits(ScoreBar, _React$Component);

  function ScoreBar() {
    _classCallCheck(this, ScoreBar);

    return _possibleConstructorReturn(this, (ScoreBar.__proto__ || Object.getPrototypeOf(ScoreBar)).apply(this, arguments));
  }

  _createClass(ScoreBar, [{
    key: 'render',
    value: function render() {
      var _sizeStyle;

      var _props = this.props,
          className = _props.className,
          vertical = _props.vertical,
          palette = _props.palette,
          paletteClassNames = _props.paletteClassNames,
          score = _props.score,
          size = _props.size,
          thickness = _props.thickness;

      var useCss = !!paletteClassNames.length && !palette.length;
      var maxScore = useCss ? paletteClassNames.length : palette.length;
      var cx = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('score-bar', className, {
        vertical: vertical,
        horizontal: !vertical
      });

      // Make sure score is between 0 and maxScore
      var scoreInBounds = score >= maxScore ? maxScore : score <= 0 ? 0 : score;
      // Make sure paletteIndex is 0 based
      var paletteIndex = scoreInBounds - 1;

      // Size of bar, depends on orientation, although we could just apply a transformation via css
      var sizeStyle = (_sizeStyle = {}, _defineProperty(_sizeStyle, vertical ? 'width' : 'height', size), _defineProperty(_sizeStyle, vertical ? 'height' : 'width', thickness), _sizeStyle);

      var style = _extends({}, sizeStyle, !useCss ? {
        backgroundColor: palette[paletteIndex]
      } : {});

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: cx },
        [].concat(_toConsumableArray(Array(scoreInBounds))).map(function (j, i) {
          var paletteClassName = useCss && paletteClassNames[paletteIndex] || '';
          var barCx = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('score-bar-bar', _defineProperty({}, paletteClassName, !!paletteClassName));
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { key: i, style: style, className: barCx });
        }),
        [].concat(_toConsumableArray(Array(maxScore - scoreInBounds))).map(function (j, i) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', {
            style: _extends({}, sizeStyle),
            key: 'empty-' + i,
            className: 'score-bar-bar empty'
          });
        })
      );
    }
  }]);

  return ScoreBar;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  vertical: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  score: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  /** Array of strings */
  palette: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string),
  /** Array of classNames whose index maps to score */
  paletteClassNames: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string),
  /** Default controlled by CSS */
  size: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  thickness: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
}, _class.defaultProps = {
  palette: [],
  paletteClassNames: ['low', 'low-med', 'med', 'med-high', 'high']
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (ScoreBar);

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1136);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(94)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--4-1!../../../../../../node_modules/less-loader/dist/cjs.js!./scoreBar.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--4-1!../../../../../../node_modules/less-loader/dist/cjs.js!./scoreBar.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(93)(undefined);
// imports


// module
exports.push([module.i, ".similar-scores.empty{background-color:#e2dee6}.similar-scores.low{background-color:#ec5e44}.similar-scores.low-med{background-color:#f38259}.similar-scores.med{background-color:#f9a66d}.similar-scores.med-high{background-color:#98b480}.similar-scores.high{background-color:#57be8c}.score-bar{display:flex}.score-bar.vertical{flex-direction:column-reverse;justify-content:flex-end}.score-bar-bar{border-radius:3px;margin:2px}.score-bar-bar.low{background-color:#ec5e44}.score-bar-bar.low-med{background-color:#f38259}.score-bar-bar.med{background-color:#f9a66d}.score-bar-bar.med-high{background-color:#98b480}.score-bar-bar.high{background-color:#57be8c}.score-bar-bar.empty{background-color:#e2dee6}.horizontal .score-bar-bar{width:4px;height:40px}.vertical .score-bar-bar{height:4px;width:40px}", ""]);

// exports


/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_spreadLayout__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_less_components_similarScoreCard_less__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_less_components_similarScoreCard_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_app_less_components_similarScoreCard_less__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var scoreComponents = {
  'exception:message:character-shingles': Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Exception Message'),
  'exception:stacktrace:application-chunks': Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Application Code'),
  'exception:stacktrace:pairs': Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Stacktrace Frames'),
  'message:message:character-shingles': Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Log Message')
};

// classnames that map to colors to css
var scoreClassNames = ['low', 'low', 'low-med', 'med', 'med-high', 'high'];

var SimilarScoreCard = (_temp = _class = function (_React$Component) {
  _inherits(SimilarScoreCard, _React$Component);

  function SimilarScoreCard() {
    _classCallCheck(this, SimilarScoreCard);

    return _possibleConstructorReturn(this, (SimilarScoreCard.__proto__ || Object.getPrototypeOf(SimilarScoreCard)).apply(this, arguments));
  }

  _createClass(SimilarScoreCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          scoreList = _props.scoreList;

      var cx = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('similar-score-card', className);

      if (!scoreList.length) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: cx },
        scoreList.map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              score = _ref2[1];

          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_app_components_spreadLayout__["a" /* default */],
            { className: 'similar-score-card-row', key: key },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              scoreComponents[key]
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', {
              className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('similar-score-quantity', score === null ? 'empty' : scoreClassNames[Math.round(score * 5)])
            })
          );
        })
      );
    }
  }]);

  return SimilarScoreCard;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  scoreList: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array)
}, _class.defaultProps = {
  scoreList: []
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (SimilarScoreCard);

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1139);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(94)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--4-1!../../../../../../node_modules/less-loader/dist/cjs.js!./similarScoreCard.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--4-1!../../../../../../node_modules/less-loader/dist/cjs.js!./similarScoreCard.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(93)(undefined);
// imports


// module
exports.push([module.i, ".similar-score-card-row{margin:2px 0}", ""]);

// exports


/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_less_components_similarSpectrum_less__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_less_components_similarSpectrum_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_app_less_components_similarSpectrum_less__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var SimilarSpectrum = (_temp = _class = function (_React$Component) {
  _inherits(SimilarSpectrum, _React$Component);

  function SimilarSpectrum() {
    _classCallCheck(this, SimilarSpectrum);

    return _possibleConstructorReturn(this, (SimilarSpectrum.__proto__ || Object.getPrototypeOf(SimilarSpectrum)).apply(this, arguments));
  }

  _createClass(SimilarSpectrum, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;

      var cx = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('similar-spectrum', className);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Similar')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'similar-spectrum-box high' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'similar-spectrum-box med-high' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'similar-spectrum-box med' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'similar-spectrum-box low-med' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'similar-spectrum-box low' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Not Similar')
        )
      );
    }
  }]);

  return SimilarSpectrum;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {}, _class.defaultProps = {}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (SimilarSpectrum);

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1142);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(94)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--4-1!../../../../../../node_modules/less-loader/dist/cjs.js!./similarSpectrum.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--4-1!../../../../../../node_modules/less-loader/dist/cjs.js!./similarSpectrum.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(93)(undefined);
// imports


// module
exports.push([module.i, ".similar-scores.empty{background-color:#e2dee6}.similar-scores.low{background-color:#ec5e44}.similar-scores.low-med{background-color:#f38259}.similar-scores.med{background-color:#f9a66d}.similar-scores.med-high{background-color:#98b480}.similar-scores.high{background-color:#57be8c}.similar-spectrum{display:flex;font-size:12px}.similar-spectrum-box{border-radius:2px;margin:5px;width:14px}.similar-spectrum-box.empty{background-color:#e2dee6}.similar-spectrum-box.low{background-color:#ec5e44}.similar-spectrum-box.low-med{background-color:#f38259}.similar-spectrum-box.med{background-color:#f9a66d}.similar-spectrum-box.med-high{background-color:#98b480}.similar-spectrum-box.high{background-color:#57be8c}", ""]);

// exports


/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_stores_groupingStore__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_spreadLayout__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_flowLayout__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_linkWithConfirmation__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_toolbar__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_toolbarHeader__ = __webpack_require__(542);














var SimilarToolbar = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'SimilarToolbar',

  propTypes: {
    onMerge: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_5_app_stores_groupingStore__["a" /* default */], 'onGroupingUpdate')],

  getInitialState: function getInitialState() {
    return {
      mergeCount: 0
    };
  },
  onGroupingUpdate: function onGroupingUpdate(_ref) {
    var mergeList = _ref.mergeList;

    if (mergeList && mergeList.size !== this.state.mergedCount) {
      this.setState({
        mergeCount: mergeList.size
      });
    }
  },
  render: function render() {
    var onMerge = this.props.onMerge;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_app_components_toolbar__["a" /* default */],
      { className: 'similar-toolbar' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_app_components_spreadLayout__["a" /* default */],
        { responsive: true },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_app_components_flowLayout__["a" /* default */],
          { style: { flex: 1 } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_app_components_flowLayout__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'similar-toolbar-actions' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_app_components_linkWithConfirmation__["a" /* default */],
                {
                  disabled: this.state.mergeCount === 0,
                  title: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Merging ' + this.state.mergeCount + ' issues'),
                  message: Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Are you sure you want to merge these issues?'),
                  className: 'btn btn-sm btn-default',
                  onConfirm: onMerge
                },
                Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Merge'),
                ' (',
                this.state.mergeCount || 0,
                ')'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'similar-score-columns' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_app_components_toolbarHeader__["a" /* default */],
            { className: 'similar-score-column event-count-header' },
            Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Events')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_app_components_toolbarHeader__["a" /* default */],
            { className: 'similar-score-column event-similar-header' },
            Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Exception')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_app_components_toolbarHeader__["a" /* default */],
            { className: 'similar-score-column event-similar-header' },
            Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Message')
          )
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (SimilarToolbar);

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1145);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(94)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--4-1!../../../../../../node_modules/less-loader/dist/cjs.js!./toolbarHeader.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--4-1!../../../../../../node_modules/less-loader/dist/cjs.js!./toolbarHeader.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(93)(undefined);
// imports


// module
exports.push([module.i, ".toolbar-header{color:#7c6a8e;font-size:12px;text-transform:uppercase;font-weight:700}", ""]);

// exports


/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_avatar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_pagination__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_timeSince__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_utils_withEnvironment__ = __webpack_require__(158);
/*eslint react/jsx-key:0*/















var GroupTagValues = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'GroupTagValues',

  propTypes: {
    environment: __WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Environment
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    return {
      tagKey: null,
      tagValueList: null,
      loading: true,
      error: false,
      pageLinks: ''
    };
  },
  componentWillMount: function componentWillMount() {
    this.fetchData();
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search || prevProps.params.tagKey !== this.props.params.tagKey) {
      this.fetchData();
    }
  },
  fetchData: function fetchData() {
    var _this = this;

    var params = this.props.params;
    var queryParams = this.props.location.query;
    var querystring = __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.param(queryParams);

    this.setState({
      loading: true,
      error: false
    });

    var query = {};

    if (this.props.environment) {
      query.environment = this.props.environment.name;
    }

    this.api.request('/issues/' + params.groupId + '/tags/' + params.tagKey + '/', {
      query: query,
      success: function success(data) {
        _this.setState({
          tagKey: data,
          loading: _this.state.tagValueList === null
        });
      },
      error: function error(_error) {
        _this.setState({
          error: true,
          loading: false
        });
      }
    });

    this.api.request('/issues/' + params.groupId + '/tags/' + params.tagKey + '/values/?' + querystring, {
      success: function success(data, _, jqXHR) {
        _this.setState({
          tagValueList: data,
          loading: _this.state.tagKey === null,
          pageLinks: jqXHR.getResponseHeader('Link')
        });
      },
      error: function error(_error2) {
        _this.setState({
          error: true,
          loading: false
        });
      }
    });
  },
  getUserDisplayName: function getUserDisplayName(item) {
    return item.email || item.username || item.identifier || item.ipAddress || item.value;
  },
  render: function render() {
    var _this2 = this;

    if (this.state.loading) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_loadingIndicator__["default"], null);
    } else if (this.state.error) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_loadingError__["default"], { onRetry: this.fetchData });
    }

    var _props$params = this.props.params,
        orgId = _props$params.orgId,
        projectId = _props$params.projectId;

    var tagKey = this.state.tagKey;
    var children = this.state.tagValueList.map(function (tagValue, tagValueIdx) {
      var pct = Object(__WEBPACK_IMPORTED_MODULE_11_app_utils__["p" /* percent */])(tagValue.count, tagKey.totalValues).toFixed(2);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'tr',
        { key: tagValueIdx },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'bar-cell' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'bar', style: { width: pct + '%' } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'label' },
            pct,
            '%'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
            {
              to: {
                pathname: '/' + orgId + '/' + projectId + '/',
                query: { query: tagKey.key + ':"' + tagValue.value + '"' }
              }
            },
            tagKey.key === 'user' ? [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_avatar__["a" /* default */], { user: tagValue, size: 20, className: 'avatar' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { marginLeft: 10 } },
              _this2.getUserDisplayName(tagValue)
            )] : Object(__WEBPACK_IMPORTED_MODULE_11_app_utils__["e" /* deviceNameMapper */])(tagValue.name)
          ),
          tagValue.email && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            {
              href: 'mailto:' + tagValue.email,
              target: '_blank',
              className: 'external-icon'
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em', { className: 'icon-envelope' })
          ),
          Object(__WEBPACK_IMPORTED_MODULE_11_app_utils__["l" /* isUrl */])(tagValue.value) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: tagValue.value, className: 'external-icon' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em', { className: 'icon-open' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_timeSince__["default"], { date: tagValue.lastSeen })
        )
      );
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        null,
        tagKey.key == 'user' ? Object(__WEBPACK_IMPORTED_MODULE_12_app_locale__["t"])('Affected Users') : tagKey.name,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { href: 'export/', className: 'btn btn-default btn-sm', style: { marginLeft: 10 } },
          Object(__WEBPACK_IMPORTED_MODULE_12_app_locale__["t"])('Export to CSV')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'table',
        { className: 'table table-striped' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'thead',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'tr',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'th',
              { style: { width: 30 } },
              '%'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'th',
              { style: { width: 200 } },
              Object(__WEBPACK_IMPORTED_MODULE_12_app_locale__["t"])('Last Seen')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'tbody',
          null,
          children
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_pagination__["default"], { pageLinks: this.state.pageLinks }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'small',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_12_app_locale__["t"])('Note: Percentage of issue is based on events seen in the last 7 days.')
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_app_utils_withEnvironment__["a" /* default */])(GroupTagValues));

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_count__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_mixins_groupState__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_utils_withEnvironmentInQueryString__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_alert__ = __webpack_require__(212);

















var GroupTags = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'GroupTags',

  propTypes: {
    environment: __WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Environment
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_7_app_mixins_groupState__["a" /* default */]],

  getInitialState: function getInitialState() {
    return {
      tagList: null,
      loading: true,
      error: false,
      environment: this.props.environment
    };
  },
  componentWillMount: function componentWillMount() {
    this.fetchData();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.environment !== this.props.environment) {
      this.setState({ environment: nextProps.environment }, this.fetchData);
    }
  },
  fetchData: function fetchData() {
    var _this = this;

    this.setState({
      loading: true,
      error: false
    });

    var query = {};
    if (this.state.environment) {
      query.environment = this.state.environment.name;
    }

    // TODO(dcramer): each tag should be a separate query as the tags endpoint
    // is not performant
    this.api.request('/issues/' + this.getGroup().id + '/tags/', {
      query: query,
      success: function success(data) {
        _this.setState({
          tagList: data,
          error: false,
          loading: false
        });
      },
      error: function error(_error) {
        _this.setState({
          error: true,
          loading: false
        });
      }
    });
  },
  getTagsDocsUrl: function getTagsDocsUrl() {
    return 'https://docs.sentry.io/hosted/learn/context/';
  },
  render: function render() {
    if (this.state.loading) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_loadingIndicator__["default"], null);
    } else if (this.state.error) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_loadingError__["default"], { onRetry: this.fetchData });
    }

    var children = [];

    var orgId = this.getOrganization().slug;
    var projectId = this.getProject().slug;
    var groupId = this.getGroup().id;

    if (this.state.tagList) {
      children = this.state.tagList.map(function (tag, tagIdx) {
        var valueChildren = tag.topValues.map(function (tagValue, tagValueIdx) {
          var pct = Object(__WEBPACK_IMPORTED_MODULE_10_app_utils__["p" /* percent */])(tagValue.count, tag.totalValues);
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { key: tagValueIdx },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
              {
                className: 'tag-bar',
                to: {
                  pathname: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/events/',
                  query: { query: tag.key + ':' + '"' + tagValue.value + '"' }
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'tag-bar-background', style: { width: pct + '%' } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'tag-bar-label' },
                Object(__WEBPACK_IMPORTED_MODULE_10_app_utils__["e" /* deviceNameMapper */])(tagValue.name)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'tag-bar-count' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_count__["default"], { value: tagValue.count })
              )
            )
          );
        });

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_grid_emotion__["Box"],
          { key: tagIdx, px: 1, width: 0.5 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13_app_components_panels__["a" /* Panel */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_app_components_panels__["e" /* PanelHeader */],
              { hasButtons: true, style: { textTransform: 'none' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { fontSize: 16 } },
                tag.key
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_grid_emotion__["Flex"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                  {
                    className: 'btn btn-default btn-sm',
                    to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/tags/' + tag.key + '/'
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('More Details')
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_app_components_panels__["c" /* PanelBody */],
              { disablePadding: false },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'ul',
                { style: { listStyleType: 'none', padding: 0, margin: 0 } },
                valueChildren
              )
            )
          )
        );
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_grid_emotion__["Flex"],
        { wrap: 'wrap' },
        children
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_14_app_components_alert__["a" /* default */],
        { type: 'info' },
        Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["tct"])('Tags are automatically indexed for searching and breakdown charts. Learn how to [link: add custom tags to issues]', {
          link: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: this.getTagsDocsUrl() })
        })
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_app_utils_withEnvironmentInQueryString__["a" /* default */])(GroupTags));

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_mixins_groupState__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_events_userReport__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_utils_withEnvironmentInQueryString__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_emptyStateWarning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_components_panels__ = __webpack_require__(18);





var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


















var GroupUserReports = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'GroupUserReports',

  propTypes: {
    environment: __WEBPACK_IMPORTED_MODULE_6_app_proptypes__["e" /* default */].Environment
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_7_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_8_app_mixins_groupState__["a" /* default */]],

  getInitialState: function getInitialState() {
    return {
      loading: true,
      error: false,
      reportList: [],
      pageLinks: ''
    };
  },
  componentWillMount: function componentWillMount() {
    this.fetchData();
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    // Search term has changed (excluding environment)
    var searchHasChanged = !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_omit___default()(__WEBPACK_IMPORTED_MODULE_5_query_string___default.a.parse(prevProps.location.search), 'environment'), __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default()(__WEBPACK_IMPORTED_MODULE_5_query_string___default.a.parse(this.props.location.search), 'environment'));
    var environmentHasChanged = prevProps.environment !== this.props.environment;

    if (searchHasChanged || environmentHasChanged) {
      this.fetchData();
    }
  },
  fetchData: function fetchData() {
    var _this = this;

    var queryParams = _extends({}, this.props.params);

    if (this.props.environment) {
      queryParams.environment = this.props.environment.name;
    }

    this.setState({
      loading: true,
      error: false
    });

    this.api.request('/issues/' + this.getGroup().id + '/user-reports/', {
      query: queryParams,
      success: function success(data, _, jqXHR) {
        _this.setState({
          error: false,
          loading: false,
          reportList: data,
          pageLinks: jqXHR.getResponseHeader('Link')
        });
      },
      error: function error(_error) {
        _this.setState({
          error: true,
          loading: false
        });
      }
    });
  },
  getUserReportsUrl: function getUserReportsUrl() {
    var params = this.props.params;

    return '/' + params.orgId + '/' + params.projectId + '/settings/user-feedback/';
  },
  render: function render() {
    var reportList = this.state.reportList;
    var _props$params = this.props.params,
        projectId = _props$params.projectId,
        orgId = _props$params.orgId,
        groupId = _props$params.groupId;


    if (this.state.loading) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_loadingIndicator__["default"], null);
    } else if (this.state.error) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_loadingError__["default"], { onRetry: this.fetchData });
    }

    if (reportList.length) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'col-md-9' },
          reportList.map(function (item, idx) {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_events_userReport__["a" /* default */], {
              key: idx,
              report: item,
              projectId: projectId,
              orgId: orgId,
              issueId: groupId
            });
          })
        )
      );
    }

    var emptyStateMessage = this.props.environment ? Object(__WEBPACK_IMPORTED_MODULE_12_app_locale__["tct"])('No user reports have been collected from your [env] environment.', {
      env: this.props.environment.displayName
    }) : Object(__WEBPACK_IMPORTED_MODULE_12_app_locale__["t"])('No user reports have been collected.');

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_15_app_components_panels__["a" /* Panel */],
      null,
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_14_app_components_emptyStateWarning__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'p',
          null,
          emptyStateMessage
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_router__["Link"],
            { to: this.getUserReportsUrl() },
            Object(__WEBPACK_IMPORTED_MODULE_12_app_locale__["t"])('Learn how to integrate User Feedback')
          )
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_app_utils_withEnvironmentInQueryString__["a" /* default */])(GroupUserReports));

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var MAX_RETRIES = 2;

/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(fn) {
    var _this = this;

    var retries, tryLoad;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            retries = 0;

            tryLoad = function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var module;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return fn();

                      case 3:
                        module = _context.sent;
                        return _context.abrupt("return", module.default || module);

                      case 7:
                        _context.prev = 7;
                        _context.t0 = _context["catch"](0);

                        if (!(retries < MAX_RETRIES)) {
                          _context.next = 12;
                          break;
                        }

                        retries++;
                        return _context.abrupt("return", tryLoad());

                      case 12:
                        throw _context.t0;

                      case 13:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, _this, [[0, 7]]);
              }));

              return function tryLoad() {
                return _ref2.apply(this, arguments);
              };
            }();

            return _context2.abrupt("return", tryLoad());

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  function retryableImport(_x) {
    return _ref.apply(this, arguments);
  }

  return retryableImport;
})());

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_organizationIssueList__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var AssignedToMe = function (_React$Component) {
  _inherits(AssignedToMe, _React$Component);

  function AssignedToMe() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AssignedToMe);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AssignedToMe.__proto__ || Object.getPrototypeOf(AssignedToMe)).call.apply(_ref, [this].concat(args))), _this), _this.getEndpoint = function () {
      return '/organizations/' + _this.props.params.orgId + '/members/me/issues/assigned/';
    }, _this.getTitle = function () {
      return Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Assigned to me');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AssignedToMe, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_app_components_organizationIssueList__["a" /* default */], _extends({
        title: this.getTitle(),
        endpoint: this.getEndpoint(),
        emptyText: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('No issues currently assigned to you.')
      }, this.props));
    }
  }]);

  return AssignedToMe;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (AssignedToMe);

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_Modal__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Snooze = {
  // all values in minutes
  '30MINUTES': 30,
  '2HOURS': 60 * 2,
  '24HOURS': 60 * 24
};

var SnoozeAction = (_temp = _class = function (_React$Component) {
  _inherits(SnoozeAction, _React$Component);

  function SnoozeAction() {
    var _ref;

    _classCallCheck(this, SnoozeAction);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = SnoozeAction.__proto__ || Object.getPrototypeOf(SnoozeAction)).call.apply(_ref, [this].concat(args)));

    _this.toggleModal = function () {
      if (_this.props.disabled) {
        return;
      }
      _this.setState({
        isModalOpen: !_this.state.isModalOpen
      });
    };

    _this.closeModal = function () {
      _this.setState({ isModalOpen: false });
    };

    _this.onSnooze = function (duration) {
      _this.props.onSnooze(duration);
      _this.closeModal();
    };

    _this.state = {
      isModalOpen: false
    };
    return _this;
  }

  _createClass(SnoozeAction, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          {
            title: this.props.tooltip,
            className: this.props.className,
            disabled: this.props.disabled,
            onClick: this.toggleModal
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('zZz')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_Modal___default.a,
          {
            show: this.state.isModalOpen,
            title: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Please confirm'),
            animation: false,
            onHide: this.closeModal,
            bsSize: 'sm'
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'modal-body' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h5',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('How long should we ignore this issue?')
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'ul',
              { className: 'nav nav-stacked nav-pills' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'li',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  { onClick: this.onSnooze.bind(this, Snooze['30MINUTES']) },
                  Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('30 minutes')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'li',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  { onClick: this.onSnooze.bind(this, Snooze['2HOURS']) },
                  Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('2 hours')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'li',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  { onClick: this.onSnooze.bind(this, Snooze['24HOURS']) },
                  Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('24 hours')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'li',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  { onClick: this.onSnooze.bind(this, undefined) },
                  Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Forever')
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'modal-footer' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'button',
              { type: 'button', className: 'btn btn-default', onClick: this.closeModal },
              Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Cancel')
            )
          )
        )
      );
    }
  }]);

  return SnoozeAction;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  onSnooze: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tooltip: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (SnoozeAction);

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.on = on;
exports.off = off;
function on(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.addEventListener) {
    el.addEventListener(eventName, callback, opts);
  } else if (el.attachEvent) {
    el.attachEvent("on" + eventName, function (e) {
      callback.call(el, e || window.event);
    });
  }
}

function off(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.removeEventListener) {
    el.removeEventListener(eventName, callback, opts);
  } else if (el.detachEvent) {
    el.detachEvent("on" + eventName, callback);
  }
}

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @fileOverview Find scroll parent
 */

exports.default = function (node) {
  if (!node) {
    return document.documentElement;
  }

  var excludeStaticParent = node.style.position === 'absolute';
  var overflowRegex = /(scroll|auto)/;
  var parent = node;

  while (parent) {
    if (!parent.parentNode) {
      return node.ownerDocument || document.documentElement;
    }

    var style = window.getComputedStyle(parent);
    var position = style.position;
    var overflow = style.overflow;
    var overflowX = style['overflow-x'];
    var overflowY = style['overflow-y'];

    if (position === 'static' && excludeStaticParent) {
      parent = parent.parentNode;
      continue;
    }

    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return node.ownerDocument || node.documentElement || document.documentElement;
};

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = debounce;
function debounce(func, wait, immediate) {
  var timeout = void 0;
  var args = void 0;
  var context = void 0;
  var timestamp = void 0;
  var result = void 0;

  var later = function later() {
    var last = +new Date() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) {
          context = null;
          args = null;
        }
      }
    }
  };

  return function debounced() {
    context = this;
    args = arguments;
    timestamp = +new Date();

    var callNow = immediate && !timeout;
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }

    if (callNow) {
      result = func.apply(context, args);
      context = null;
      args = null;
    }

    return result;
  };
}

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = throttle;
/*eslint-disable */
function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last, deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date(),
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(276);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

exports.default = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function lazyload(WrappedComponent) {
    return function (_Component) {
      _inherits(LazyLoadDecorated, _Component);

      function LazyLoadDecorated() {
        _classCallCheck(this, LazyLoadDecorated);

        var _this = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));

        _this.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
        return _this;
      }

      _createClass(LazyLoadDecorated, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(
            _index2.default,
            options,
            _react2.default.createElement(WrappedComponent, this.props)
          );
        }
      }]);

      return LazyLoadDecorated;
    }(_react.Component);
  };
};

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_organizationIssueList__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Bookmarked = function (_React$Component) {
  _inherits(Bookmarked, _React$Component);

  function Bookmarked() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Bookmarked);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Bookmarked.__proto__ || Object.getPrototypeOf(Bookmarked)).call.apply(_ref, [this].concat(args))), _this), _this.getEndpoint = function () {
      return '/organizations/' + _this.props.params.orgId + '/members/me/issues/bookmarked/';
    }, _this.getTitle = function () {
      return Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Bookmarks');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Bookmarked, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_app_components_organizationIssueList__["a" /* default */], _extends({
        title: this.getTitle(),
        endpoint: this.getEndpoint(),
        emptyText: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('You have not bookmarked any issues.')
      }, this.props));
    }
  }]);

  return Bookmarked;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Bookmarked);

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_organizationIssueList__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Viewed = function (_React$Component) {
  _inherits(Viewed, _React$Component);

  function Viewed() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Viewed);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Viewed.__proto__ || Object.getPrototypeOf(Viewed)).call.apply(_ref, [this].concat(args))), _this), _this.getEndpoint = function () {
      return '/organizations/' + _this.props.params.orgId + '/members/me/issues/viewed/';
    }, _this.getTitle = function () {
      return Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('History');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Viewed, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_app_components_organizationIssueList__["a" /* default */], _extends({
        title: this.getTitle(),
        endpoint: this.getEndpoint(),
        emptyText: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('No recently viewed issues.')
      }, this.props));
    }
  }]);

  return Viewed;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Viewed);

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_document_title__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_mixins_organizationState__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_views_onboarding_createProject__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_projectHeader_projectSelector__ = __webpack_require__(210);









var NewProject = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'NewProject',
  mixins: [__WEBPACK_IMPORTED_MODULE_3_app_mixins_organizationState__["a" /* default */]],

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'getting-started' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'sub-header flex flex-container flex-vertically-centered' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'p-t-1 p-b-1' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_projectHeader_projectSelector__["default"], { organization: this.getOrganization() })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_document_title___default.a, { title: 'Sentry' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_views_onboarding_createProject__["a" /* default */], {
            getDocsUrl: function getDocsUrl(_ref) {
              var slug = _ref.slug,
                  projectSlug = _ref.projectSlug,
                  platform = _ref.platform;

              if (platform === 'other') platform = '';
              return '/' + slug + '/' + projectSlug + '/getting-started/' + platform;
            }
          })
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (NewProject);

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raven_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_utils_analytics__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_views_onboarding_configure_waiting__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_views_projects_projectContext__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_views_projectInstall_docsContext__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_views_projectInstall_platform__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_stores_hookStore__ = __webpack_require__(72);













var Configure = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Configure',
  mixins: [__WEBPACK_IMPORTED_MODULE_6_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    return {
      isFirstTimePolling: true,
      hasSentRealEvent: false
    };
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    var platform = this.props.params.platform;
    //redirect if platform is not known.

    if (!platform || platform === 'other') {
      this.redirectToNeutralDocs();
    }

    this.fetchEventData();
    this.timer = setInterval(function () {
      _this.fetchEventData();
    }, 2000);
  },
  componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
    if (!this.state.isFirstTimePolling && nextState.hasSentRealEvent == true && this.state.hasSentRealEvent == false) {
      this.redirectUrl();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    clearInterval(this.timer);
  },
  sentRealEvent: function sentRealEvent(data) {
    if (data.length == 1) {
      var firstError = data[0];
      return !firstError.message.includes('This is an example');
    } else {
      return data.length > 1;
    }
  },
  redirectUrl: function redirectUrl() {
    var _props$params = this.props.params,
        orgId = _props$params.orgId,
        projectId = _props$params.projectId;


    var url = '/' + orgId + '/' + projectId + '/#welcome';
    __WEBPACK_IMPORTED_MODULE_2_react_router__["browserHistory"].push(url);
  },
  fetchEventData: function fetchEventData() {
    var _this2 = this;

    var _props$params2 = this.props.params,
        orgId = _props$params2.orgId,
        projectId = _props$params2.projectId;


    this.api.request('/projects/' + orgId + '/' + projectId + '/events/', {
      method: 'GET',
      success: function success(data) {
        _this2.setState({
          isFirstTimePolling: false,
          hasSentRealEvent: _this2.sentRealEvent(data)
        });
      },

      error: function error(err) {
        __WEBPACK_IMPORTED_MODULE_3_raven_js___default.a.captureMessage('Polling for events in onboarding configure failed', {
          extra: err
        });
      }
    });
  },
  submit: function submit() {
    __WEBPACK_IMPORTED_MODULE_10_app_stores_hookStore__["default"].get('analytics:onboarding-complete').forEach(function (cb) {
      return cb();
    });
    Object(__WEBPACK_IMPORTED_MODULE_4_app_utils_analytics__["a" /* default */])('onboarding.complete', { project: this.props.params.projectId });
    this.redirectUrl();
  },
  redirectToNeutralDocs: function redirectToNeutralDocs() {
    var _props$params3 = this.props.params,
        orgId = _props$params3.orgId,
        projectId = _props$params3.projectId;

    var url = '/' + orgId + '/' + projectId + '/getting-started';

    __WEBPACK_IMPORTED_MODULE_2_react_router__["browserHistory"].push(url);
  },
  render: function render() {
    var _props$params4 = this.props.params,
        orgId = _props$params4.orgId,
        projectId = _props$params4.projectId;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'onboarding-Configure' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { style: { marginBottom: 30 } },
          'Configure your application'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_app_views_projects_projectContext__["a" /* default */],
          { projectId: projectId, orgId: orgId, style: { marginBottom: 30 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_app_views_projectInstall_docsContext__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_views_projectInstall_platform__["a" /* default */], {
              platformData: {
                hack: 'actually set by ProjectDocsContext, this object is here to avoid proptypes warnings'
              },
              params: this.props.params,
              linkPath: function linkPath(_orgId, _projectId, _platform) {
                return '/onboarding/' + _orgId + '/' + _projectId + '/configure/' + _platform + '/';
              }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_views_onboarding_configure_waiting__["a" /* default */], { skip: this.submit, hasEvent: this.state.hasSentRealEvent })
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Configure);

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Waiting = (_temp = _class = function (_React$Component) {
  _inherits(Waiting, _React$Component);

  function Waiting() {
    _classCallCheck(this, Waiting);

    return _possibleConstructorReturn(this, (Waiting.__proto__ || Object.getPrototypeOf(Waiting)).apply(this, arguments));
  }

  _createClass(Waiting, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'awaiting-event' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'pull-right' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'btn btn-primary', onClick: this.props.skip },
            Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('All done!')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'wrap waiting-text' },
          !this.props.hasEvent ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h3',
            { className: 'animated-ellipsis' },
            Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Waiting to receive an error')
          ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h3',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])("You've successfully sent an error")
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'robot' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'eye' })
          )
        )
      );
    }
  }]);

  return Waiting;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  skip: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  hasEvent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (Waiting);

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_views_settings_components_emptyMessage__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_stores_indicatorStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_actionCreators_teams__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_locale__ = __webpack_require__(2);











var MissingProjectMembership = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'MissingProjectMembership',

  propTypes: {
    organization: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
    projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    var _props = this.props,
        organization = _props.organization,
        projectId = _props.projectId;

    var project = organization.projects.find(function (p) {
      return p.slug === projectId;
    });

    return {
      loading: false,
      error: false,
      project: project
    };
  },
  joinTeam: function joinTeam(team) {
    var _this = this;

    this.setState({
      loading: true
    });

    Object(__WEBPACK_IMPORTED_MODULE_5_app_actionCreators_teams__["c" /* joinTeam */])(this.api, {
      orgId: this.props.organization.slug,
      teamId: team.slug
    }, {
      success: function success() {
        _this.setState({
          loading: false,
          error: false
        });
      },
      error: function error() {
        _this.setState({
          loading: false,
          error: true
        });
        __WEBPACK_IMPORTED_MODULE_4_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('There was an error while trying to leave the team.'), 'error');
      }
    });
  },
  renderJoinTeam: function renderJoinTeam(team, features) {
    if (!team) {
      return null;
    }
    if (this.state.loading) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        { className: 'btn btn-default btn-loading btn-disabled' },
        '...'
      );
    } else if (team.isPending) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        { className: 'btn btn-default btn-disabled' },
        Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('Request Pending')
      );
    } else if (features.has('open-membership')) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        { className: 'btn btn-default', onClick: this.joinTeam.bind(this, team) },
        Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('Join Team')
      );
    }
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'a',
      { className: 'btn btn-default', onClick: this.joinTeam.bind(this, team) },
      Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('Request Access')
    );
  },
  renderExplanation: function renderExplanation(features) {
    if (features.has('new-teams')) {
      if (features.has('open-membership')) {
        return Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('To view this data you must one of the following teams.');
      } else {
        return Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('To view this data you must first request access to one of the following teams:');
      }
    }

    var project = this.state.project;
    var team = project.team;


    if (team) {
      if (features.has('open-membership')) {
        return Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('To view this data you must first join the %s team.', team.name);
      }

      return Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('To view this data you must first request access to the %s team.', team.name);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('This project is not associated with any teams. To view this data, an administrator must grant access to a team you are on.');
  },
  renderJoinTeams: function renderJoinTeams(features) {
    var _this2 = this;

    var teams = this.state.project.teams;

    if (!teams.length) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_app_views_settings_components_emptyMessage__["a" /* default */],
        null,
        Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('No teams have access to this project yet. Ask an admin to add your team to this project.')
      );
    }

    return teams.map(function (team) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'p',
        { key: team.slug },
        '#',
        team.slug,
        ': ',
        _this2.renderJoinTeam(team, features)
      );
    });
  },
  render: function render() {
    var organization = this.props.organization;
    var team = this.state.project.team;

    var features = new Set(organization.features);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'container' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'box alert-box' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon icon-exclamation' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])("You're not a member of this project.")
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          this.renderExplanation(features)
        ),
        features.has('new-teams') ? this.renderJoinTeams(features) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          this.renderJoinTeam(team, features)
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (MissingProjectMembership);

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);







var InstallReactTest = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'InstallReactTest',

  propTypes: {
    dsn: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
  },

  getInitialState: function getInitialState(props) {
    return {
      loading: true,
      error: false
    };
  },
  render: function render() {
    var dsn = this.props.dsn;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'h3',
        null,
        ' Installation '
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'p',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Start by adding the'),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'pre' },
          ' raven.js '
        ),
        ' ',
        Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('script tag to your\n          page. It should be loaded as early as possible, before your main javascript\n          bundle.')
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'pre',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          '<'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          ScriptSpan,
          null,
          'script '
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          AttributeSpan,
          null,
          'src'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          '='
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          ValueSpan,
          null,
          Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('https://cdn.ravenjs.com/3.24.0/raven.min.js')
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          AttributeSpan,
          null,
          ' crossorigin'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          '='
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          ValueSpan,
          null,
          'anonymous'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          '></'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          ScriptSpan,
          null,
          'script'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          '>'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'h3',
        null,
        ' Basic Configuration '
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'p',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Next configure Raven.js to use your Sentry DSN. Sending release and environment data both provide valuable\n          context e.g. when an issue was first seen. Learn more about '),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          { href: 'https://docs.sentry.io/clients/javascript/config/' },
          ' ',
          'configuration options',
          ' '
        ),
        'here.'
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'pre',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          '<',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            ScriptSpan,
            null,
            'script'
          ),
          '>'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          ' Raven.config('
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          ValueSpan,
          null,
          '\'',
          dsn,
          '\''
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          ', {'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          '   release: '
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          ValueSpan,
          null,
          "'0-0-0'"
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          ','
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          '   environment: '
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          ValueSpan,
          null,
          "'development-test'"
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          ','
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          ' }).install()'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          '</',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            ScriptSpan,
            null,
            'script'
          ),
          '>'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null)
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'p',
        null,
        'Congrats! Raven is now ready to capture any uncaught exceptions'
      )
    );
  }
});

var ScriptSpan = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('span', {
  target: 'e1ngxzb00'
})('color:#2eb0f7;');
var AttributeSpan = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('span', {
  target: 'e1ngxzb01'
})('color:#a47ac6;');
var ValueSpan = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('span', {
  target: 'e1ngxzb02'
})('color:#e8535a;');

/* harmony default export */ __webpack_exports__["a"] = (InstallReactTest);

/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var LanguageNav = (_temp = _class = function (_React$Component) {
  _inherits(LanguageNav, _React$Component);

  function LanguageNav() {
    var _ref;

    _classCallCheck(this, LanguageNav);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = LanguageNav.__proto__ || Object.getPrototypeOf(LanguageNav)).call.apply(_ref, [this].concat(args)));

    _this.toggle = function () {
      _this.setState({ isVisible: !_this.state.isVisible });
    };

    _this.state = {
      isVisible: _this.props.active || false
    };
    return _this;
  }

  _createClass(LanguageNav, [{
    key: 'render',
    value: function render() {
      var isVisible = this.state.isVisible;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'install-language-nav' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'ul',
          { className: 'list-group' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'li',
            { className: 'list-group-item list-group-header' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { onClick: this.toggle, style: { display: 'block' } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'pull-right' },
                isVisible ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon-minus' }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon-plus' })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'strong',
                null,
                this.props.name
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            {
              style: {
                display: isVisible ? 'block' : 'none'
              }
            },
            this.props.children
          )
        )
      );
    }
  }]);

  return LanguageNav;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  active: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (LanguageNav);

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_document_title__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_views_onboarding_progress__ = __webpack_require__(1168);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var OnboardingWizard = (_temp = _class = function (_React$Component) {
  _inherits(OnboardingWizard, _React$Component);

  function OnboardingWizard() {
    _classCallCheck(this, OnboardingWizard);

    return _possibleConstructorReturn(this, (OnboardingWizard.__proto__ || Object.getPrototypeOf(OnboardingWizard)).apply(this, arguments));
  }

  _createClass(OnboardingWizard, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'onboarding-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_document_title___default.a, { title: 'Sentry' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'step-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_views_onboarding_progress__["a" /* default */], { params: this.props.params }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            this.props.children
          )
        )
      );
    }
  }]);

  return OnboardingWizard;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.contextTypes = {
  organization: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (OnboardingWizard);

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_views_onboarding_utils__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_stores_configStore__ = __webpack_require__(25);







var ProgressNodes = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'ProgressNodes',

  propTypes: {
    params: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
  },

  contextTypes: {
    organization: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
  },

  steps: Object.keys(__WEBPACK_IMPORTED_MODULE_4_app_views_onboarding_utils__["d" /* onboardingSteps */]),

  inferStep: function inferStep() {
    var projectId = this.props.params.projectId;

    if (!projectId) return __WEBPACK_IMPORTED_MODULE_4_app_views_onboarding_utils__["d" /* onboardingSteps */].project;
    return __WEBPACK_IMPORTED_MODULE_4_app_views_onboarding_utils__["d" /* onboardingSteps */].configure;
  },
  node: function node(stepKey, stepIndex) {
    var nodeClass = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('node', {
      done: stepIndex < this.inferStep(),
      active: stepIndex === this.inferStep()
    });

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: nodeClass, key: stepIndex },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: nodeClass }),
      __WEBPACK_IMPORTED_MODULE_4_app_views_onboarding_utils__["e" /* stepDescriptions */][stepKey]
    );
  },
  render: function render() {
    var config = __WEBPACK_IMPORTED_MODULE_5_app_stores_configStore__["default"].getConfig();
    var slug = this.context.organization.slug;


    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'onboarding-sidebar' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'sentry-flag' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { href: '/', className: 'icon-sentry-logo-full' })
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'progress-nodes' },
        this.steps.map(this.node)
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'stuck' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          {
            href: !config.isOnPremise ? '/organizations/' + slug + '/support/' : 'https://forum.sentry.io/'
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            ' Stuck?'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            ' Ask for help'
          )
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ProgressNodes);

/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrganizationActivity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_views_asyncView__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_activity_feed__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_organizations_homeContainer__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var OrganizationActivity = function (_AsyncView) {
  _inherits(OrganizationActivity, _AsyncView);

  function OrganizationActivity() {
    _classCallCheck(this, OrganizationActivity);

    return _possibleConstructorReturn(this, (OrganizationActivity.__proto__ || Object.getPrototypeOf(OrganizationActivity)).apply(this, arguments));
  }

  _createClass(OrganizationActivity, [{
    key: 'getEndpoint',
    value: function getEndpoint() {
      return '/organizations/' + this.props.params.orgId + '/activity/';
    }
  }, {
    key: 'getTitle',
    value: function getTitle() {
      return 'Activity';
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_app_components_organizations_homeContainer__["default"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Activity')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_activity_feed__["a" /* default */], _extends({
          endpoint: this.getEndpoint(),
          query: {
            per_page: 100
          },
          pagination: true
        }, this.props))
      );
    }
  }]);

  return OrganizationActivity;
}(__WEBPACK_IMPORTED_MODULE_1_app_views_asyncView__["default"]);



/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_utils_logging__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_activity_item__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_errorBoundary__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_pagination__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_styles_space__ = __webpack_require__(38);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















var ActivityFeed = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'ActivityFeed',

  propTypes: {
    endpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    renderEmpty: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    pagination: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_7_app_mixins_apiMixin__["default"]],

  getDefaultProps: function getDefaultProps() {
    return {
      pagination: true,
      query: {}
    };
  },
  getInitialState: function getInitialState() {
    return {
      itemList: [],
      loading: true,
      error: false,
      pageLinks: null
    };
  },
  componentWillMount: function componentWillMount() {
    this.fetchData();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var location = this.props.location;
    var nextLocation = nextProps.location;
    if (location.pathname != nextLocation.pathname || location.search != nextLocation.search) {
      this.remountComponent();
    }
  },
  remountComponent: function remountComponent() {
    this.setState(this.getInitialState(), this.fetchData);
  },
  fetchData: function fetchData() {
    var _this = this;

    var location = this.props.location;
    this.api.clear();
    this.api.request(this.props.endpoint, {
      method: 'GET',
      query: _extends({
        cursor: location.query.cursor || ''
      }, this.props.query),
      success: function success(data, _, jqXHR) {
        _this.setState({
          loading: false,
          error: false,
          itemList: data,
          pageLinks: jqXHR.getResponseHeader('Link')
        });
      },
      error: function error() {
        _this.setState({
          loading: false,
          error: true
        });
      }
    });
  },
  renderResults: function renderResults() {
    var body = void 0;
    var orgId = this.props.params.orgId;


    if (this.state.loading) body = this.renderLoading();else if (this.state.error) body = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_loadingError__["default"], { onRetry: this.fetchData });else if (this.state.itemList.length > 0) {
      body = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'activity-container' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'ul',
          { className: 'activity' },
          this.state.itemList.map(function (item) {
            try {
              return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_app_components_errorBoundary__["default"],
                {
                  mini: true,
                  className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])({ marginBottom: Object(__WEBPACK_IMPORTED_MODULE_12_app_styles_space__["a" /* default */])(1), borderRadius: 0 }),

                  key: item.id
                },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_activity_item__["a" /* default */], { orgId: orgId, item: item })
              );
            } catch (ex) {
              Object(__WEBPACK_IMPORTED_MODULE_4_app_utils_logging__["logException"])(ex, {
                itemId: item.id
              });
              return null;
            }
          })
        )
      );
    } else body = (this.props.renderEmpty || this.renderEmpty)();

    return body;
  },
  renderLoading: function renderLoading() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: 'box' },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_loadingIndicator__["default"], null)
    );
  },
  renderEmpty: function renderEmpty() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: 'box empty' },
      Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Nothing to show here, move along.')
    );
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      null,
      this.renderResults(),
      this.props.pagination && this.state.pageLinks && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_pagination__["default"], _extends({ pageLinks: this.state.pageLinks }, this.props))
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ActivityFeed);

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_marked__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_views_releases_pullRequestLink__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_commitLink__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_duration__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_avatar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_issueLink__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_versionHoverCard__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_stores_memberListStore__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_stores_teamStore__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_timeSince__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_version__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var ActivityItem = (_temp = _class = function (_React$Component) {
  _inherits(ActivityItem, _React$Component);

  function ActivityItem() {
    var _ref;

    _classCallCheck(this, ActivityItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = ActivityItem.__proto__ || Object.getPrototypeOf(ActivityItem)).call.apply(_ref, [this].concat(args)));

    _this.formatProjectActivity = function (author, item) {
      var data = item.data;
      var orgId = _this.props.orgId;
      var project = item.project;
      var issue = item.issue;

      var issueLink = issue ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_app_components_issueLink__["a" /* default */],
        { orgId: orgId, projectId: project.slug, issue: issue },
        issue.shortId
      ) : null;

      var versionLink = data.version ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_app_components_versionHoverCard__["a" /* default */],
        { orgId: orgId, projectId: project.slug, version: data.version },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_app_components_version__["a" /* default */], { version: data.version, orgId: orgId, projectId: project.slug })
      ) : null;

      switch (item.type) {
        case 'note':
          return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] commented on [issue]', {
            author: author,
            issue: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_app_components_issueLink__["a" /* default */],
              {
                orgId: orgId,
                projectId: project.slug,
                issue: issue,
                to: '/' + orgId + '/' + project.slug + '/issues/' + issue.id + '/activity/#event_' + item.id
              },
              issue.shortId
            )
          });
        case 'set_resolved':
          return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] marked [issue] as resolved', {
            author: author,
            issue: issueLink
          });
        case 'set_resolved_by_age':
          return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] marked [issue] as resolved due to age', {
            author: author,
            issue: issueLink
          });
        case 'set_resolved_in_release':
          if (data.version) {
            return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] marked [issue] as resolved in [version]', {
              author: author,
              version: versionLink,
              issue: issueLink
            });
          }
          return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] marked [issue] as resolved in the upcoming release', {
            author: author,
            issue: issueLink
          });
        case 'set_resolved_in_commit':
          return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] marked [issue] as fixed in [version]', {
            author: author,
            version: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_commitLink__["a" /* default */], {
              inline: true,
              commitId: data.commit && data.commit.id,
              repository: data.commit && data.commit.repository
            }),
            issue: issueLink
          });
        case 'set_resolved_in_pull_request':
          return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] marked [issue] as fixed in [version]', {
            author: author,
            version: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_views_releases_pullRequestLink__["a" /* default */], {
              inline: true,
              pullRequest: data.pullRequest,
              repository: data.pullRequest && data.pullRequest.repository
            }),
            issue: issueLink
          });
        case 'set_unresolved':
          return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] marked [issue] as unresolved', {
            author: author,
            issue: issueLink
          });
        case 'set_ignored':
          if (data.ignoreDuration) {
            return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] ignored [issue] for [duration]', {
              author: author,
              duration: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_duration__["a" /* default */], { seconds: data.ignoreDuration * 60 }),
              issue: issueLink
            });
          } else if (data.ignoreCount && data.ignoreWindow) {
            return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] ignored [issue] until it happens [count] time(s) in [duration]', {
              author: author,
              count: data.ignoreCount,
              duration: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_duration__["a" /* default */], { seconds: data.ignoreWindow * 60 }),
              issue: issueLink
            });
          } else if (data.ignoreCount) {
            return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] ignored [issue] until it happens [count] time(s)', {
              author: author,
              count: data.ignoreCount,
              issue: issueLink
            });
          } else if (data.ignoreUserCount && data.ignoreUserWindow) {
            return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] ignored [issue] until it affects [count] user(s) in [duration]', {
              author: author,
              count: data.ignoreUserCount,
              duration: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_duration__["a" /* default */], { seconds: data.ignoreUserWindow * 60 }),
              issue: issueLink
            });
          } else if (data.ignoreUserCount) {
            return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] ignored [issue] until it affects [count] user(s)', {
              author: author,
              count: data.ignoreUserCount,
              issue: issueLink
            });
          }
          return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] ignored [issue]', {
            author: author,
            issue: issueLink
          });
        case 'set_public':
          return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] made [issue] public', {
            author: author,
            issue: issueLink
          });
        case 'set_private':
          return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] made [issue] private', {
            author: author,
            issue: issueLink
          });
        case 'set_regression':
          if (data.version) {
            return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] marked [issue] as a regression in [version]', {
              author: author,
              version: versionLink,
              issue: issueLink
            });
          }
          return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] marked [issue] as a regression', {
            author: author,
            issue: issueLink
          });
        case 'create_issue':
          return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] linked [issue] on [provider]', {
            author: author,
            provider: data.provider,
            issue: issueLink
          });
        case 'unmerge_destination':
          return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tn"])('%2$s migrated %1$d fingerprint from %3$s to %4$s', '%2$s migrated %1$d fingerprints from %3$s to %4$s', data.fingerprints.length, author, data.source ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            { href: '/' + orgId + '/' + project.slug + '/issues/' + data.source.id },
            data.source.shortId
          ) : Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["t"])('a group'), issueLink);
        case 'first_seen':
          return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] saw [link:issue]', {
            author: author,
            issue: issueLink
          });
        case 'assigned':
          if (data.assigneeType == 'team') {
            return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] assigned [issue] to #[assignee]', {
              author: author,
              issue: issueLink,
              assignee: __WEBPACK_IMPORTED_MODULE_11_app_stores_teamStore__["a" /* default */].getById(data.assignee).slug
            });
          }
          var assignee = void 0;
          if (item.user && data.assignee === item.user.id) {
            return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] assigned [issue] to themselves', {
              author: author,
              issue: issueLink
            });
          }
          assignee = __WEBPACK_IMPORTED_MODULE_10_app_stores_memberListStore__["a" /* default */].getById(data.assignee);
          if (assignee && assignee.email) {
            return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] assigned [issue] to [assignee]', {
              author: author,
              assignee: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { title: assignee.email },
                assignee.name
              ),
              issue: issueLink
            });
          } else if (data.assigneeEmail) {
            return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] assigned [issue] to [assignee]', {
              author: author,
              assignee: data.assigneeEmail,
              issue: issueLink
            });
          }
          return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] assigned [issue] to an [help:unknown user]', {
            author: author,
            help: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { title: data.assignee }),
            issue: issueLink
          });
        case 'unassigned':
          return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] unassigned [issue]', {
            author: author,
            issue: issueLink
          });
        case 'merge':
          return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] merged [count] [link:issues]', {
            author: author,
            count: data.issues.length + 1,
            link: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Link"], { to: '/' + orgId + '/' + project.slug + '/issues/' + issue.id + '/' })
          });
        case 'release':
          return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] released version [version]', {
            author: author,
            version: versionLink
          });
        case 'deploy':
          return Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["tct"])('[author] deployed version [version] to [environment].', {
            author: author,
            version: versionLink,
            environment: data.environment || 'Default Environment'
          });
        default:
          return ''; // should never hit (?)
      }
    };

    _this.state = {
      clipped: _this.props.defaultClipped
    };
    return _this;
  }

  _createClass(ActivityItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.refs.activityBubble) {
        var bubbleHeight = this.refs.activityBubble.offsetHeight;

        if (bubbleHeight > this.props.clipHeight) {
          /*eslint react/no-did-mount-set-state:0*/
          // okay if this causes re-render; cannot determine until
          // rendered first anyways
          this.setState({
            clipped: true
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.item;
      var orgId = this.props.orgId;

      var bubbleClassName = 'activity-item-bubble';
      if (this.state.clipped) {
        bubbleClassName += ' clipped';
      }

      var avatar = item.user ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_avatar__["a" /* default */], { user: item.user, size: 36, className: 'activity-avatar' }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'activity-avatar avatar sentry' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon-sentry-logo' })
      );

      var author = {
        name: item.user ? item.user.name : 'Sentry',
        avatar: avatar
      };

      if (item.type === 'note') {
        var noteBody = __WEBPACK_IMPORTED_MODULE_3_marked___default()(item.data.text);
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'li',
          { className: 'activity-item activity-item-compact' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'activity-item-content' },
            this.formatProjectActivity(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              null,
              author.avatar,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'activity-author' },
                author.name
              )
            ), item),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', {
              className: bubbleClassName,
              ref: 'activityBubble',
              dangerouslySetInnerHTML: { __html: noteBody }
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'activity-meta' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                { className: 'project', to: '/' + orgId + '/' + item.project.slug + '/' },
                item.project.slug
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'bullet' }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_timeSince__["default"], { date: item.dateCreated })
            )
          )
        );
      } else if (item.type === 'create_issue') {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'li',
          { className: 'activity-item activity-item-compact' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'activity-item-content' },
            this.formatProjectActivity(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              null,
              author.avatar,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'activity-author' },
                author.name
              )
            ), item),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'activity-item-bubble' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { href: item.data.location },
                item.data.title
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'activity-meta' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                { className: 'project', to: '/' + orgId + '/' + item.project.slug + '/' },
                item.project.slug
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'bullet' }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_timeSince__["default"], { date: item.dateCreated })
            )
          )
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'li',
          { className: 'activity-item activity-item-compact' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'activity-item-content' },
            this.formatProjectActivity(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              null,
              author.avatar,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'activity-author' },
                author.name
              )
            ), item),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'activity-meta' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                { className: 'project', to: '/' + orgId + '/' + item.project.slug + '/' },
                item.project.slug
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'bullet' }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_timeSince__["default"], { date: item.dateCreated })
            )
          )
        );
      }
    }
  }]);

  return ActivityItem;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  clipHeight: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  defaultClipped: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  item: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  orgId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
}, _class.defaultProps = {
  defaultClipped: false,
  clipHeight: 68
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (ActivityItem);

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IssueLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_hovercard__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_count__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_eventOrGroupTitle__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_timeSince__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var IssueLink = (_temp = _class = function (_React$Component) {
  _inherits(IssueLink, _React$Component);

  function IssueLink() {
    _classCallCheck(this, IssueLink);

    return _possibleConstructorReturn(this, (IssueLink.__proto__ || Object.getPrototypeOf(IssueLink)).apply(this, arguments));
  }

  _createClass(IssueLink, [{
    key: 'getMessage',
    value: function getMessage(data) {
      var metadata = data.metadata;
      switch (data.type) {
        case 'error':
          return metadata.value;
        case 'csp':
          return metadata.message;
        default:
          return data.culprit || '';
      }
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _props = this.props,
          issue = _props.issue,
          orgId = _props.orgId,
          projectId = _props.projectId;

      var message = this.getMessage(issue);

      var className = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('type-' + issue.type, 'level-' + issue.level, {
        isBookmarked: issue.isBookmarked,
        hasSeen: issue.hasSeen,
        isResolved: issue.status === 'resolved'
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: className },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { marginBottom: 15 } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h3',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_eventOrGroupTitle__["a" /* default */], { data: issue })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'event-message' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: 'error-level' },
              issue.level
            ),
            message && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: 'message' },
              message
            ),
            issue.logger && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: 'event-annotation' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router__["Link"],
                {
                  to: {
                    pathname: '/' + orgId + '/' + projectId + '/',
                    query: { query: 'logger:' + issue.logger }
                  }
                },
                issue.logger
              )
            ),
            issue.annotations.map(function (annotation, i) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', {
                className: 'event-annotation',
                key: i,
                dangerouslySetInnerHTML: { __html: annotation }
              });
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'row row-flex', style: { marginBottom: 15 } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'col-xs-6' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h6',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('First Seen')
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_timeSince__["default"], { date: issue.firstSeen })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'col-xs-6' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h6',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('Last Seen')
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_timeSince__["default"], { date: issue.lastSeen })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'row row-flex' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'col-xs-6' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h6',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('Occurrences')
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_count__["default"], { value: issue.count })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'col-xs-6' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h6',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('Users Affected')
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_count__["default"], { value: issue.userCount })
          )
        )
      );
    }
  }, {
    key: 'getLinkTo',
    value: function getLinkTo() {
      var _props2 = this.props,
          issue = _props2.issue,
          orgId = _props2.orgId,
          projectId = _props2.projectId;


      return this.props.to || '/' + orgId + '/' + projectId + '/issues/' + issue.id + '/';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          card = _props3.card,
          issue = _props3.issue;

      if (!card) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router__["Link"],
        { to: this.getLinkTo() },
        this.props.children
      );

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_app_components_hovercard__["a" /* default */],
        { body: this.renderBody(), header: issue.shortId },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router__["Link"],
          { to: this.getLinkTo() },
          this.props.children
        )
      );
    }
  }]);

  return IssueLink;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  orgId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  issue: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  to: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  card: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _class.defaultProps = {
  card: true
}, _temp);


/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_inlineSvg__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_stores_configStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_utils_logging__ = __webpack_require__(191);









var ReleaseAnnouncement = function ReleaseAnnouncement(_ref) {
  var close = _ref.close;

  var mediaUrl = __WEBPACK_IMPORTED_MODULE_4_app_stores_configStore__["default"].get('mediaUrl');
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'h3',
      null,
      'Releases are better with commits',
      ' ',
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { className: 'badge badge-square badge-new' },
        'NEW'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'p',
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: mediaUrl + 'images/onboarding/release-commits-modal.gif' })
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'h5',
      { style: { lineHeight: '1.2' } },
      'By integrating commit data with Sentry, you\u2019ll unlock a number of helpful features:'
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'ul',
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'li',
        null,
        'Enhanced releases overview page that allows you to see new and resolved issues, files changed and authors all in the same place'
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'li',
        null,
        'Resolving Sentry issues via commit messages'
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'li',
        null,
        'Suggested assignees for issues'
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'li',
        null,
        'Detailed summary emails when a deploy goes out'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'p',
      { className: 'release-buttons' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        { className: 'btn btn-default btn-lg', href: '#', onClick: close },
        'Dismiss'
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        {
          className: 'btn btn-primary btn-lg',
          href: 'https://blog.sentry.io/2017/05/01/release-commits.html',
          onClick: close
        },
        'Read the full post'
      )
    )
  );
};

ReleaseAnnouncement.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
};

var BroadcastModal = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'BroadcastModal',

  propTypes: {
    closeBroadcast: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    return {
      alerts: [ReleaseAnnouncement],
      index: 0
    };
  },
  componentWillMount: function componentWillMount() {
    document.addEventListener('keydown', this.handleKeyDown);
  },
  componentWillUnmount: function componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  },
  close: function close() {
    var _this = this;

    //tell server to close
    var user = __WEBPACK_IMPORTED_MODULE_4_app_stores_configStore__["default"].get('user');
    var markedData = {
      options: {
        seenReleaseBroadcast: true
      }
    };
    this.api.request('/users/' + user.id + '/', {
      method: 'PUT',
      data: markedData,
      success: function success(data, _, jqXHR) {
        __WEBPACK_IMPORTED_MODULE_4_app_stores_configStore__["default"].set('user', data);
        _this.props.closeBroadcast();
      },
      error: function error(err) {
        Object(__WEBPACK_IMPORTED_MODULE_6_app_utils_logging__["logAjaxError"])(err);
        _this.props.closeBroadcast();
      }
    });
  },
  handleKeyDown: function handleKeyDown(evt) {
    if (evt.key === 'Escape' || evt.keyCode === 27) {
      this.close();
    }
  },
  handleClick: function handleClick(evt) {
    if ([].indexOf.call(evt.target.classList, 'modal') !== -1) {
      this.close();
    }
  },
  renderOneModal: function renderOneModal(message, i, a) {
    var _this2 = this;

    var nth = 'abcd'[a.length - 1 - i] + '-nth';
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      {
        className: 'modal ' + nth,
        style: { display: 'block' },
        key: i,
        onClick: this.handleClick
      },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'modal-dialog' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'modal-content', role: 'document' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'modal-body' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'pull-right' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                {
                  className: 'close-icon',
                  onClick: function onClick() {
                    if (_this2.state.index + 1 >= _this2.state.alerts.length) {
                      _this2.close();
                    }
                    _this2.setState({ index: _this2.state.index + 1 });
                  }
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_inlineSvg__["a" /* default */], { src: 'icon-close-lg' })
              )
            ),
            message({ close: this.close })
          )
        )
      )
    );
  },
  render: function render() {
    var _state = this.state,
        alerts = _state.alerts,
        index = _state.index;

    var modals = alerts.slice(index, index + 4).reverse().map(this.renderOneModal);
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'modal-broadcast' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'modal-backdrop in' }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'modals' },
        modals
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (BroadcastModal);

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrganizationCreate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_views_asyncView__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_stores_configStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_narrowLayout__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_forms__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var OrganizationCreate = function (_AsyncView) {
  _inherits(OrganizationCreate, _AsyncView);

  function OrganizationCreate() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrganizationCreate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrganizationCreate.__proto__ || Object.getPrototypeOf(OrganizationCreate)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmitSuccess = function (data) {
      // redirect to project creation *(BYPASS REACT ROUTER AND FORCE PAGE REFRESH TO GRAB CSRF TOKEN)*
      // browserHistory.pushState(null, `/organizations/${data.slug}/projects/new/`);
      window.location.href = '/organizations/' + data.slug + '/projects/new/';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OrganizationCreate, [{
    key: 'getEndpoints',
    value: function getEndpoints() {
      return [];
    }
  }, {
    key: 'getTitle',
    value: function getTitle() {
      return 'Create Organization';
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var termsUrl = __WEBPACK_IMPORTED_MODULE_2_app_stores_configStore__["default"].get('termsUrl');
      var privacyUrl = __WEBPACK_IMPORTED_MODULE_2_app_stores_configStore__["default"].get('privacyUrl');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_app_components_narrowLayout__["default"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Create a New Organization')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])("Organizations represent the top level in your hierarchy. You'll be able to bundle a collection of teams within an organization as well as give organization-wide permissions to users.")
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_app_components_forms__["ApiForm"],
          {
            initialData: { defaultTeam: true },
            submitLabel: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Create Organization'),
            apiEndpoint: '/organizations/',
            apiMethod: 'POST',
            onSubmitSuccess: this.onSubmitSuccess,
            requireChanges: true
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_forms__["TextField"], {
            name: 'name',
            label: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Organization Name'),
            placeholder: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('e.g. My Company'),
            required: true
          }),
          termsUrl && privacyUrl && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_forms__["BooleanField"], {
            name: 'agreeTerms',
            label: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["tct"])('I agree to the [termsLink:Terms of Service] and the [privacyLink:Privacy Policy]', {
              termsLink: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: termsUrl }),
              privacyLink: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: privacyUrl })
            }),
            placeholder: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('e.g. My Company'),
            required: true
          })
        )
      );
    }
  }]);

  return OrganizationCreate;
}(__WEBPACK_IMPORTED_MODULE_1_app_views_asyncView__["default"]);



/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* unused harmony export Dashboard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lazyload__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_idBadge__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_mixins_organizationState__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_stores_projectsStatsStore__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_utils_getProjectsByTeams__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_utils_withTeams__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_utils_withProjects__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__projectNav__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__teamSection__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__emptyState__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__resources__ = __webpack_require__(1220);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
























var Dashboard = (_temp = _class = function (_React$Component) {
  _inherits(Dashboard, _React$Component);

  function Dashboard() {
    _classCallCheck(this, Dashboard);

    return _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).apply(this, arguments));
  }

  _createClass(Dashboard, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      $(document.body).addClass('org-dashboard');
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      $(document.body).removeClass('org-dashboard');
      __WEBPACK_IMPORTED_MODULE_10_app_stores_projectsStatsStore__["a" /* default */].reset();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          teams = _props.teams,
          projects = _props.projects,
          params = _props.params,
          organization = _props.organization;

      var sortedProjects = Object(__WEBPACK_IMPORTED_MODULE_12_app_utils__["r" /* sortProjects */])(projects);

      var _getProjectsByTeams = Object(__WEBPACK_IMPORTED_MODULE_11_app_utils_getProjectsByTeams__["a" /* default */])(teams, sortedProjects),
          projectsByTeam = _getProjectsByTeams.projectsByTeam;

      var teamSlugs = Object.keys(projectsByTeam).sort();
      var favorites = projects.filter(function (project) {
        return project.isBookmarked;
      });
      var access = new Set(organization.access);
      var teamsMap = new Map(teams.map(function (teamObj) {
        return [teamObj.slug, teamObj];
      }));

      var hasTeamAdminAccess = access.has('team:admin');

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,
        null,
        favorites.length > 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__teamSection__["a" /* default */], {
          'data-test-id': 'favorites',
          orgId: params.orgId,
          showBorder: true,
          team: null,
          title: Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])('Bookmarked projects'),
          projects: favorites,
          access: access
        }),
        teamSlugs.map(function (slug, index) {
          var showBorder = index !== teamSlugs.length - 1;
          var team = teamsMap.get(slug);
          return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_lazyload___default.a,
            { key: slug, once: true, debounce: 50, height: 300, offset: 300 },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__teamSection__["a" /* default */], {
              orgId: params.orgId,
              team: team,
              showBorder: showBorder,
              title: hasTeamAdminAccess ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                TeamLink,
                { to: '/settings/' + organization.slug + '/teams/' + team.slug + '/' },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_idBadge__["a" /* default */], { team: team })
              ) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_idBadge__["a" /* default */], { team: team }),
              projects: projectsByTeam[slug],
              access: access
            })
          );
        }),
        teamSlugs.length === 0 && favorites.length === 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__emptyState__["a" /* default */], { projects: projects, teams: teams, organization: organization }),
        projects.length === 1 && !projects[0].firstEvent && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__resources__["a" /* default */], { org: organization, project: projects[0] })
      );
    }
  }]);

  return Dashboard;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  teams: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
  projects: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
  organization: __WEBPACK_IMPORTED_MODULE_7_app_proptypes__["e" /* default */].Organization
}, _temp);


var OrganizationDashboard = __WEBPACK_IMPORTED_MODULE_4_create_react_class___default()({
  displayName: 'OrganizationDashboard',
  mixins: [__WEBPACK_IMPORTED_MODULE_9_app_mixins_organizationState__["a" /* default */]],

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_grid_emotion__["Flex"],
      { flex: '1', direction: 'column' },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__projectNav__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Dashboard, _extends({ organization: this.context.organization }, this.props))
    );
  }
});

var TeamLink = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_6_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_0_react_router__["Link"], {
  target: 'e13kzy1z0'
})('display:flex;align-items:center;');


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_app_utils_withTeams__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_14_app_utils_withProjects__["a" /* default */])(OrganizationDashboard)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getProjectsByTeams;
function getProjectsByTeams(teams, projects) {
  var projectsByTeam = {};
  var teamlessProjects = [];
  var usersTeams = new Set(teams.filter(function (team) {
    return team.isMember;
  }).map(function (team) {
    return team.slug;
  }));

  projects.forEach(function (project) {
    if (!project.teams.length && project.isMember) {
      teamlessProjects.push(project);
    } else {
      project.teams.forEach(function (team) {
        if (!usersTeams.has(team.slug)) {
          return;
        }
        if (!projectsByTeam[team.slug]) {
          projectsByTeam[team.slug] = [];
        }
        projectsByTeam[team.slug].push(project);
      });
    }
  });

  return { projectsByTeam: projectsByTeam, teamlessProjects: teamlessProjects };
}

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_styles_space__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__teamMembers__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__projectCard__ = __webpack_require__(1179);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var TeamSection = (_temp = _class = function (_React$Component) {
  _inherits(TeamSection, _React$Component);

  function TeamSection() {
    _classCallCheck(this, TeamSection);

    return _possibleConstructorReturn(this, (TeamSection.__proto__ || Object.getPrototypeOf(TeamSection)).apply(this, arguments));
  }

  _createClass(TeamSection, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          team = _props.team,
          projects = _props.projects,
          title = _props.title,
          showBorder = _props.showBorder,
          orgId = _props.orgId,
          access = _props.access;


      var hasTeamAccess = access.has('team:read');
      var hasProjectAccess = access.has('project:read');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        TeamSectionWrapper,
        { 'data-test-id': 'team', showBorder: showBorder },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          TeamTitleBar,
          { justify: 'space-between', align: 'center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            TeamName,
            null,
            title
          ),
          hasTeamAccess && team && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__teamMembers__["a" /* default */], { teamId: team.slug, orgId: orgId })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          ProjectCards,
          null,
          projects.map(function (project) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__projectCard__["a" /* default */], {
              'data-test-id': project.slug,
              key: project.slug,
              project: project,
              hasProjectAccess: hasProjectAccess
            });
          })
        )
      );
    }
  }]);

  return TeamSection;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  team: __WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Team,
  orgId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  showBorder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  access: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  projects: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
}, _temp);


var ProjectCards = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Flex"], {
  target: 'e19r3sh20'
})('flex-wrap:wrap;padding:0 ', Object(__WEBPACK_IMPORTED_MODULE_5_app_styles_space__["a" /* default */])(3), ' ', Object(__WEBPACK_IMPORTED_MODULE_5_app_styles_space__["a" /* default */])(3), ';');

var TeamSectionWrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e19r3sh21'
})('border-bottom:', function (p) {
  return p.showBorder ? '1px solid ' + p.theme.borderLight : 0;
}, ';/* stylelint-disable no-duplicate-selectors */\n  &:last-child{', ProjectCards, '{padding-bottom:0;}}/* stylelint-enable */');

var TeamTitleBar = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Flex"], {
  target: 'e19r3sh22'
})('padding:', Object(__WEBPACK_IMPORTED_MODULE_5_app_styles_space__["a" /* default */])(3), ' ', Object(__WEBPACK_IMPORTED_MODULE_5_app_styles_space__["a" /* default */])(4), ' 10px;');

var TeamName = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('h4', {
  target: 'e19r3sh23'
})('margin:0;font-size:20px;line-height:24px;/* We need this so that header doesn\'t flicker when lazy loading because avatarList height > this */');

/* harmony default export */ __webpack_exports__["a"] = (TeamSection);

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TeamMembers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_asyncComponent__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_avatar_avatarList__ = __webpack_require__(253);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var TeamMembers = (_temp = _class = function (_AsyncComponent) {
  _inherits(TeamMembers, _AsyncComponent);

  function TeamMembers() {
    _classCallCheck(this, TeamMembers);

    return _possibleConstructorReturn(this, (TeamMembers.__proto__ || Object.getPrototypeOf(TeamMembers)).apply(this, arguments));
  }

  _createClass(TeamMembers, [{
    key: 'getEndpoints',
    value: function getEndpoints() {
      var _props = this.props,
          orgId = _props.orgId,
          teamId = _props.teamId;

      return [['members', '/teams/' + orgId + '/' + teamId + '/members/']];
    }
  }, {
    key: 'renderLoading',
    value: function renderLoading() {
      return null;
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      if (this.state.members) {
        var users = this.state.members.filter(function (_ref) {
          var user = _ref.user;
          return !!user;
        }).map(function (_ref2) {
          var user = _ref2.user;
          return user;
        });
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_avatar_avatarList__["a" /* default */], { users: users });
      }
      return null;
    }
  }]);

  return TeamMembers;
}(__WEBPACK_IMPORTED_MODULE_2_app_components_asyncComponent__["default"]), _class.propTypes = {
  teamId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  orgId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
}, _temp);


/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProjectCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_actionCreators_indicator__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_api__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_styles_space__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_actionCreators_projects__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_stores_projectsStatsStore__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_styles_overflowEllipsis__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_components_platformicon__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__chart__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__noEvents__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__deploys__ = __webpack_require__(1217);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























var ProjectCard = (_temp2 = _class = function (_React$Component) {
  _inherits(ProjectCard, _React$Component);

  function ProjectCard() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProjectCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProjectCard.__proto__ || Object.getPrototypeOf(ProjectCard)).call.apply(_ref, [this].concat(args))), _this), _this.toggleProjectBookmark = function () {
      var _this$props = _this.props,
          project = _this$props.project,
          params = _this$props.params;


      Object(__WEBPACK_IMPORTED_MODULE_14_app_actionCreators_projects__["i" /* update */])(_this.api, {
        orgId: params.orgId,
        projectId: project.slug,
        data: {
          isBookmarked: !project.isBookmarked
        }
      }).catch(function () {
        Object(__WEBPACK_IMPORTED_MODULE_7_app_actionCreators_indicator__["a" /* addErrorMessage */])(Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Unable to toggle bookmark for %s', project.slug));
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProjectCard, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          project = _props.project,
          params = _props.params;


      this.api = new __WEBPACK_IMPORTED_MODULE_9_app_api__["Client"]();

      // fetch project stats
      Object(__WEBPACK_IMPORTED_MODULE_14_app_actionCreators_projects__["d" /* loadStatsForProject */])(this.api, project.id, {
        orgId: params.orgId
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          project = _props2.project,
          hasProjectAccess = _props2.hasProjectAccess,
          params = _props2.params;
      var firstEvent = project.firstEvent,
          isBookmarked = project.isBookmarked,
          stats = project.stats,
          slug = project.slug;


      var bookmarkText = isBookmarked ? Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Remove from bookmarks') : Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Add to bookmarks');

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        ProjectCardWrapper,
        { 'data-test-id': slug, width: ['100%', '50%', '33%', '25%'] },
        stats ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          StyledProjectCard,
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_grid_emotion__["Flex"],
            { justify: 'space-between', align: 'center' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_grid_emotion__["Box"],
              { ml: 2 },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledPlatformicon, { size: '24', platform: project.platform || 'generic' })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              StyledTitle,
              null,
              hasProjectAccess ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_app_components_link__["a" /* default */],
                { to: '/' + params.orgId + '/' + slug + '/' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'strong',
                  null,
                  slug
                )
              ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                slug
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12_app_components_tooltip__["default"],
              { title: bookmarkText },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Star, {
                active: isBookmarked,
                className: 'project-select-bookmark icon icon-star-solid',
                onClick: this.toggleProjectBookmark
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            ChartContainer,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__chart__["a" /* default */], { stats: stats, noEvents: !firstEvent }),
            !firstEvent && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__noEvents__["a" /* default */], null)
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__deploys__["a" /* default */], { project: project, orgId: params.orgId })
        ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadingCard, null)
      );
    }
  }]);

  return ProjectCard;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  project: __WEBPACK_IMPORTED_MODULE_8_app_proptypes__["e" /* default */].Project.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  hasProjectAccess: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
}, _temp2);


var StyledPlatformicon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_17_app_components_platformicon__["a" /* default */], {
  target: 'efesc7i0'
})('display:block;color:white;border-radius:3px;max-width:24px;');

var ProjectCardContainer = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'ProjectCardContainer',

  propTypes: {
    project: __WEBPACK_IMPORTED_MODULE_8_app_proptypes__["e" /* default */].Project
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_15_app_stores_projectsStatsStore__["a" /* default */], 'onProjectStoreUpdate')],
  getInitialState: function getInitialState() {
    var project = this.props.project;

    var initialState = __WEBPACK_IMPORTED_MODULE_15_app_stores_projectsStatsStore__["a" /* default */].getInitialState() || {};
    return {
      projectDetails: initialState[project.slug] || null
    };
  },
  onProjectStoreUpdate: function onProjectStoreUpdate(itemsBySlug) {
    var project = this.props.project;

    // Don't update state if we already have stats

    if (!itemsBySlug[project.slug]) return;
    if (itemsBySlug[project.slug] === this.state.projectDetails) return;

    this.setState({
      projectDetails: itemsBySlug[project.slug]
    });
  },
  render: function render() {
    var _props3 = this.props,
        project = _props3.project,
        props = _objectWithoutProperties(_props3, ['project']);

    var projectDetails = this.state.projectDetails;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ProjectCard, _extends({}, props, {
      project: _extends({}, project, projectDetails || {})
    }));
  }
});

var ChartContainer = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('div', {
  target: 'efesc7i1'
})('position:relative;background:', function (p) {
  return p.theme.offWhite;
}, ';padding-top:', Object(__WEBPACK_IMPORTED_MODULE_11_app_styles_space__["a" /* default */])(1), ';');

var StyledTitle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('div', {
  target: 'efesc7i2'
})(__WEBPACK_IMPORTED_MODULE_16_app_styles_overflowEllipsis__["a" /* default */], ';padding:16px 8px;');

var ProjectCardWrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_6_grid_emotion__["Box"], {
  target: 'efesc7i3'
})('padding:10px;');

var StyledProjectCard = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('div', {
  target: 'efesc7i4'
})('background-color:white;border:1px solid ', function (p) {
  return p.theme.borderDark;
}, ';border-radius:', function (p) {
  return p.theme.borderRadius;
}, ';box-shadow:', function (p) {
  return p.theme.dropShadowLight;
}, ';');

var Star = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('a', {
  target: 'efesc7i5'
})('color:', function (p) {
  return p.active ? p.theme.yellowOrange : '#afa3bb';
}, ';margin-right:16px;&:hover{color:', function (p) {
  return p.theme.yellowOrange;
}, ';opacity:0.6;}');

var LoadingCard = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('div', {
  target: 'efesc7i6'
})('border:1px solid transparent;background-color:', function (p) {
  return p.theme.offWhite;
}, ';height:210px;');


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["withRouter"])(ProjectCardContainer));

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var PLATFORM_TO_ICON = {
  apple: 'apple',
  cocoa: 'apple',
  cordova: 'cordova',
  csharp: 'csharp',
  elixir: 'elixir',
  electron: 'electron',
  go: 'go',
  java: 'java',
  'java-android': 'java',
  'java-appengine': 'app-engine',
  'java-log4j': 'java',
  'java-log4j2': 'java',
  'java-logback': 'java',
  'java-logging': 'java',
  javascript: 'javascript',
  'javascript-angular': 'angularjs',
  'javascript-backbone': 'javascript',
  'javascript-ember': 'ember',
  'javascript-react': 'react',
  'javascript-vue': 'vue',
  node: 'nodejs',
  'node-connect': 'nodejs',
  'node-express': 'nodejs',
  'node-koa': 'nodejs',
  'objective-c': 'apple',
  perl: 'perl',
  php: 'php',
  'php-laravel': 'laravel',
  'php-monolog': 'php',
  'php-symfony2': 'php',
  python: 'python',
  'python-flask': 'flask',
  'python-bottle': 'bottle',
  'python-celery': 'python',
  'python-django': 'django',
  'python-pylons': 'python',
  'python-pyramid': 'python',
  'python-rq': 'python',
  'python-tornado': 'python',
  'react-native': 'apple',
  ruby: 'ruby',
  'ruby-rack': 'ruby',
  'ruby-rails': 'rails',
  rust: 'rust',
  swift: 'swift'
};

function getIcon(platform) {
  var icon = PLATFORM_TO_ICON[platform];

  if (!icon) {
    return 'generic';
  } else {
    return icon;
  }
}

var Platformicon = function Platformicon(_ref) {
  var platform = _ref.platform,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      props = _objectWithoutProperties(_ref, ['platform', 'size', 'width', 'height']);

  var icon = getIcon(platform);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', _extends({
    src: __webpack_require__(1181)("./" + icon + '.svg'),
    width: width || size || '1em',
    height: height || size || '1em'
  }, props));
};

Platformicon.propTypes = {
  platform: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  size: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Platformicon);

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./HTML5.svg": 1182,
	"./angularjs.svg": 1183,
	"./app-engine.svg": 1184,
	"./apple.svg": 1185,
	"./bootstrap.svg": 1186,
	"./bottle.svg": 1187,
	"./cordova.svg": 1188,
	"./csharp.svg": 1189,
	"./django.svg": 1190,
	"./dotnet.svg": 1191,
	"./electron.svg": 1192,
	"./elixir.svg": 1193,
	"./ember.svg": 1194,
	"./flask.svg": 1195,
	"./generic.svg": 1196,
	"./go.svg": 1197,
	"./ios.svg": 1198,
	"./java.svg": 1199,
	"./javascript.svg": 1200,
	"./laravel.svg": 1201,
	"./nodejs.svg": 1202,
	"./perl.svg": 1203,
	"./php.svg": 1204,
	"./python.svg": 1205,
	"./rails.svg": 1206,
	"./react.svg": 1207,
	"./redis.svg": 1208,
	"./redux.svg": 1209,
	"./ruby.svg": 1210,
	"./rust.svg": 1211,
	"./swift.svg": 1212,
	"./vue.svg": 1213,
	"./windows.svg": 1214
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1181;

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "HTML5.svg";

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "angularjs.svg";

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "app-engine.svg";

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "apple.svg";

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bootstrap.svg";

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bottle.svg";

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cordova.svg";

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "csharp.svg";

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "django.svg";

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dotnet.svg";

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "electron.svg";

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "elixir.svg";

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ember.svg";

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "flask.svg";

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "generic.svg";

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "go.svg";

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ios.svg";

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "java.svg";

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "javascript.svg";

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "laravel.svg";

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nodejs.svg";

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "perl.svg";

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "php.svg";

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "python.svg";

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "rails.svg";

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "react.svg";

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "redis.svg";

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "redux.svg";

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ruby.svg";

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "rust.svg";

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "swift.svg";

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "vue.svg";

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "windows.svg";

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Chart; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_barChart__ = __webpack_require__(215);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Chart = (_temp = _class = function (_React$Component) {
  _inherits(Chart, _React$Component);

  function Chart() {
    _classCallCheck(this, Chart);

    return _possibleConstructorReturn(this, (Chart.__proto__ || Object.getPrototypeOf(Chart)).apply(this, arguments));
  }

  _createClass(Chart, [{
    key: 'render',
    value: function render() {
      var data = this.props.stats.map(function (d) {
        return { x: d[0], y: d[1] };
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledBarChart, { points: data, label: 'events', height: 60 })
      );
    }
  }]);

  return Chart;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  stats: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
}, _class.defaultProps = {
  stats: []
}, _temp);



var StyledBarChart = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_3_app_components_barChart__["default"], {
  target: 'e1wib7610'
})('a{&:not(:first-child){border-left:2px solid transparent;}&:not(:last-child){border-right:2px solid transparent;}> span{left:0;right:0;}}');

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var NoEvents = function (_React$Component) {
  _inherits(NoEvents, _React$Component);

  function NoEvents() {
    _classCallCheck(this, NoEvents);

    return _possibleConstructorReturn(this, (NoEvents.__proto__ || Object.getPrototypeOf(NoEvents)).apply(this, arguments));
  }

  _createClass(NoEvents, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Container,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          EmptyText,
          { align: 'center', justify: 'center' },
          Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('No activity yet.')
        )
      );
    }
  }]);

  return NoEvents;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);




var Container = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])('div', {
  target: 'eks1zeg0'
})('position:absolute;top:0;left:0;right:0;');

var EmptyText = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Flex"], {
  target: 'eks1zeg1'
})('margin-left:4px;margin-right:4px;height:68px;color:', function (p) {
  return p.theme.gray2;
}, ';');

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Deploys; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_textOverflow__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_dynamicWrapper__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_utils__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _class2, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var DEPLOY_COUNT = 2;

var Deploys = (_temp = _class = function (_React$Component) {
  _inherits(Deploys, _React$Component);

  function Deploys() {
    _classCallCheck(this, Deploys);

    return _possibleConstructorReturn(this, (Deploys.__proto__ || Object.getPrototypeOf(Deploys)).apply(this, arguments));
  }

  _createClass(Deploys, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          project = _props.project,
          orgId = _props.orgId;


      var projectId = project.slug;

      var flattenedDeploys = Object.entries(project.latestDeploys || {}).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            environment = _ref2[0],
            value = _ref2[1];

        return _extends({ environment: environment }, value);
      });

      var deploys = (flattenedDeploys || []).sort(function (a, b) {
        return new Date(b.dateFinished) - new Date(a.dateFinished);
      }).slice(0, DEPLOY_COUNT);

      if (deploys.length) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          DeployBox,
          { p: 2, pt: 1 },
          deploys.map(function (deploy) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Deploy, {
              key: deploy.version,
              deploy: deploy,
              projectId: projectId,
              orgId: orgId
            });
          })
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NoDeploys, null);
      }
    }
  }]);

  return Deploys;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  project: __WEBPACK_IMPORTED_MODULE_5_app_proptypes__["e" /* default */].Project,
  orgId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _temp);

var Deploy = (_temp2 = _class2 = function (_React$Component2) {
  _inherits(Deploy, _React$Component2);

  function Deploy() {
    _classCallCheck(this, Deploy);

    return _possibleConstructorReturn(this, (Deploy.__proto__ || Object.getPrototypeOf(Deploy)).apply(this, arguments));
  }

  _createClass(Deploy, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          deploy = _props2.deploy,
          orgId = _props2.orgId,
          projectId = _props2.projectId;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        DeployRow,
        { justify: 'space-between' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Environment,
          null,
          deploy.environment
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Version,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            StyledLink,
            { to: '/' + orgId + '/' + projectId + '/releases/' + deploy.version + '/' },
            Object(__WEBPACK_IMPORTED_MODULE_11_app_utils__["j" /* getShortVersion */])(deploy.version)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_grid_emotion__["Flex"],
          { w: 90, justify: 'flex-end' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_dynamicWrapper__["default"], {
            value: __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(deploy.dateFinished).fromNow(),
            fixed: '3 hours ago'
          })
        )
      );
    }
  }]);

  return Deploy;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class2.propTypes = {
  deploy: __WEBPACK_IMPORTED_MODULE_5_app_proptypes__["e" /* default */].Deploy.isRequired,
  projectId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  orgId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
}, _temp2);


var DeployRow = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_3_grid_emotion__["Flex"], {
  target: 'eltxe6c0'
})('color:', function (p) {
  return p.theme.gray2;
}, ';font-size:12px;margin-top:8px;');

var Environment = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_9_app_components_textOverflow__["a" /* default */], {
  target: 'eltxe6c1'
})('font-size:11px;text-transform:uppercase;width:80px;border:1px solid ', function (p) {
  return p.theme.offWhite2;
}, ';margin-right:8px;background-color:', function (p) {
  return p.theme.offWhite;
}, ';text-align:center;border-radius:', function (p) {
  return p.theme.borderRadius;
}, ';');

var Version = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_9_app_components_textOverflow__["a" /* default */], {
  target: 'eltxe6c2'
})('display:flex;flex:1;margin-right:8px;');

var StyledLink = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_7_app_components_link__["a" /* default */], {
  target: 'eltxe6c3'
})('text-overflow:ellipsis;overflow:hidden;white-space:nowrap;');

var NoDeploys = function (_React$Component3) {
  _inherits(NoDeploys, _React$Component3);

  function NoDeploys() {
    _classCallCheck(this, NoDeploys);

    return _possibleConstructorReturn(this, (NoDeploys.__proto__ || Object.getPrototypeOf(NoDeploys)).apply(this, arguments));
  }

  _createClass(NoDeploys, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        DeployBox,
        { p: 2 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Background,
          { align: 'center', justify: 'center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_app_components_buttons_button__["default"],
            {
              size: 'xsmall',
              href: 'https://blog.sentry.io/2017/05/09/release-deploys',
              external: true
            },
            Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('Track deploys')
          )
        )
      );
    }
  }]);

  return NoDeploys;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var DeployBox = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_3_grid_emotion__["Box"], {
  target: 'eltxe6c4'
})('height:92px;');

var Background = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_3_grid_emotion__["Flex"], {
  target: 'eltxe6c5'
})('height:100%;background-color:', function (p) {
  return p.theme.offWhite;
}, ';');

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmptyState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_dashboard_hair_on_fire_svg__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_dashboard_hair_on_fire_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_dashboard_hair_on_fire_svg__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var EmptyState = (_temp = _class = function (_React$Component) {
  _inherits(EmptyState, _React$Component);

  function EmptyState() {
    _classCallCheck(this, EmptyState);

    return _possibleConstructorReturn(this, (EmptyState.__proto__ || Object.getPrototypeOf(EmptyState)).apply(this, arguments));
  }

  _createClass(EmptyState, [{
    key: 'render',
    value: function render() {
      var organization = this.props.organization;

      var orgId = organization.slug;
      var canCreateProject = organization.access.includes('project:write');
      var canJoinTeam = organization.access.includes('team:read');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Flex"],
        { flex: '1', align: 'center', justify: 'center' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Wrapper,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_7__images_dashboard_hair_on_fire_svg___default.a, height: 350, alt: 'Nothing to see' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Content,
            { direction: 'column', justify: 'center' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Remain calm.')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])("Sentry's got you covered. To get started:")
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Flex"],
              { align: 'center' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                CallToAction,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_app_components_tooltip__["default"],
                  {
                    disabled: canJoinTeam,
                    title: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('You do not have permission to join a team.')
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_app_components_buttons_button__["default"],
                    {
                      disabled: !canJoinTeam,
                      priority: 'primary',
                      to: '/settings/' + orgId + '/teams/'
                    },
                    Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Join a Team')
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                CallToAction,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_app_components_tooltip__["default"],
                  {
                    disabled: canCreateProject,
                    title: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('You do not have permission to create a project.')
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_app_components_buttons_button__["default"],
                    {
                      disabled: !canCreateProject,
                      to: '/organizations/' + orgId + '/projects/new/'
                    },
                    Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Create project')
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return EmptyState;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  organization: __WEBPACK_IMPORTED_MODULE_6_app_proptypes__["e" /* default */].Organization
}, _temp);



var CallToAction = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'eg5of2v0'
})('margin-right:8px;&:last-child{margin-right:0;}');

var Wrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Flex"], {
  target: 'eg5of2v1'
})('height:350px;');

var Content = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Flex"], {
  target: 'eg5of2v2'
})('margin-left:40px;');

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "hair-on-fire.svg";

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Resources; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_utils_analytics__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_resourceCard__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_errorRobot__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var Resources = (_temp = _class = function (_React$Component) {
  _inherits(Resources, _React$Component);

  function Resources() {
    _classCallCheck(this, Resources);

    return _possibleConstructorReturn(this, (Resources.__proto__ || Object.getPrototypeOf(Resources)).apply(this, arguments));
  }

  _createClass(Resources, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      Object(__WEBPACK_IMPORTED_MODULE_3_app_utils_analytics__["a" /* default */])('orgdash.resources_shown');
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        ResourcesWrapper,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          RobotPanel,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_errorRobot__["a" /* default */], { org: this.props.org, project: this.props.project })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          ResourcesSection,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('Resources')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Flex"],
            { justify: 'space-between' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Flex"],
              { width: 3 / 10 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_resourceCard__["a" /* default */], {
                link: 'https://blog.sentry.io/2018/03/06/the-sentry-workflow',
                imgUrl: 'images/releases.svg',
                title: 'The Sentry Workflow'
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Flex"],
              { width: 3 / 10 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_resourceCard__["a" /* default */], {
                link: 'https://sentry.io/vs/logging/',
                imgUrl: 'images/breadcrumbs-generic.svg',
                title: 'Sentry vs Logging'
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Flex"],
              { width: 3 / 10 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_resourceCard__["a" /* default */], {
                link: 'https://docs.sentry.io/',
                imgUrl: 'images/code-arguments-tags-mirrored.svg',
                title: 'Docs'
              })
            )
          )
        )
      );
    }
  }]);

  return Resources;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  org: __WEBPACK_IMPORTED_MODULE_5_app_proptypes__["e" /* default */].Organization,
  project: __WEBPACK_IMPORTED_MODULE_5_app_proptypes__["e" /* default */].Project
}, _temp);



var ResourcesWrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'ecl99l90'
})('border-top:1px solid ', function (p) {
  return p.theme.borderLight;
}, ';');

var RobotPanel = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_7_app_components_panels__["a" /* Panel */], {
  target: 'ecl99l91'
})('margin:30px 30px 20px 30px;');

var ResourcesSection = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'ecl99l92'
})('padding:0 30px 20px 30px;');

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResourceCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_utils_analytics__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_stores_configStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_externalLink__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_panels__ = __webpack_require__(18);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ResourceCard = (_temp2 = _class = function (_React$Component) {
  _inherits(ResourceCard, _React$Component);

  function ResourceCard() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ResourceCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ResourceCard.__proto__ || Object.getPrototypeOf(ResourceCard)).call.apply(_ref, [this].concat(args))), _this), _this.recordClick = function () {
      var _this$props = _this.props,
          link = _this$props.link,
          title = _this$props.title;

      Object(__WEBPACK_IMPORTED_MODULE_3_app_utils_analytics__["a" /* default */])('orgdash.resource_clicked', { link: link, title: title });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ResourceCard, [{
    key: 'render',
    value: function render() {
      var mediaUrl = __WEBPACK_IMPORTED_MODULE_4_app_stores_configStore__["default"].get('mediaUrl');
      var _props = this.props,
          title = _props.title,
          link = _props.link,
          imgUrl = _props.imgUrl;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        ResourceCardWrapper,
        { onClick: this.recordClick },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          StyledLink,
          { href: link },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'm-b-1' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: mediaUrl + imgUrl, alt: title })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            StyledTitle,
            null,
            title
          )
        )
      );
    }
  }]);

  return ResourceCard;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  imgUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
}, _temp2);



var StyledTitle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'ehxuq4s0'
})('color:#493e54;font-size:16px;text-align:center;font-weight:bold;');

var ResourceCardWrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_6_app_components_panels__["a" /* Panel */], {
  target: 'ehxuq4s1'
})('display:flex;flex:1;align-items:center;padding:20px;margin-bottom:0;');

var StyledLink = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_5_app_components_externalLink__["a" /* default */], {
  target: 'ehxuq4s2'
})('flex:1;');

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrganizationDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_actions_alertActions__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_errorBoundary__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_api__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_views_organizationContext__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_narrowLayout__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_footer__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_lazyLoad__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_locale__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _class2, _temp2, _class3, _temp3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var DeletionInProgress = (_temp = _class = function (_Component) {
  _inherits(DeletionInProgress, _Component);

  function DeletionInProgress() {
    _classCallCheck(this, DeletionInProgress);

    return _possibleConstructorReturn(this, (DeletionInProgress.__proto__ || Object.getPrototypeOf(DeletionInProgress)).apply(this, arguments));
  }

  _createClass(DeletionInProgress, [{
    key: 'render',
    value: function render() {
      var organization = this.props.organization;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_app_components_narrowLayout__["default"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["tct"])('The [organization] organization is currently in the process of being deleted from Sentry.', {
            organization: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              organization.slug
            )
          })
        )
      );
    }
  }]);

  return DeletionInProgress;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  organization: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
}, _temp);
var DeletionPending = (_temp2 = _class2 = function (_Component2) {
  _inherits(DeletionPending, _Component2);

  function DeletionPending() {
    var _ref;

    _classCallCheck(this, DeletionPending);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this2 = _possibleConstructorReturn(this, (_ref = DeletionPending.__proto__ || Object.getPrototypeOf(DeletionPending)).call.apply(_ref, [this].concat(args)));

    _this2.onRestore = function () {
      if (_this2.state.submitInProgress) return;
      _this2.setState({ submitInProgress: true });
      _this2.api.request('/organizations/' + _this2.props.organization.slug + '/', {
        method: 'PUT',
        data: { cancelDeletion: true },
        success: function success() {
          window.location.reload();
        },
        error: function error() {
          __WEBPACK_IMPORTED_MODULE_2_app_actions_alertActions__["default"].addAlert({
            message: 'We were unable to restore this organization. Please try again or contact support.',
            type: 'error'
          });
          _this2.setState({ submitInProgress: false });
        }
      });
    };

    _this2.state = { submitInProgress: false };
    return _this2;
  }

  _createClass(DeletionPending, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.api = new __WEBPACK_IMPORTED_MODULE_5_app_api__["Client"]();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.api.clear();
    }
  }, {
    key: 'render',
    value: function render() {
      var organization = this.props.organization;

      var access = new Set(organization.access);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_app_components_narrowLayout__["default"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Deletion Scheduled')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["tct"])('The [organization] organization is currently scheduled for deletion.', {
            organization: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              organization.slug
            )
          })
        ),
        access.has('org:admin') ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Would you like to cancel this process and restore the organization back to the original state?')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_app_components_buttons_button__["default"],
              {
                priority: 'primary',
                onClick: this.onRestore,
                disabled: this.state.submitInProgress
              },
              Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Restore Organization')
            )
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('If this is a mistake, contact an organization owner and ask them to restore this organization.')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])("Note: Restoration is available until the process begins. Once it does, there's no recovering the data that has been removed.")
          )
        )
      );
    }
  }]);

  return DeletionPending;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.propTypes = {
  organization: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
}, _temp2);
var OrganizationDetailsBody = (_temp3 = _class3 = function (_Component3) {
  _inherits(OrganizationDetailsBody, _Component3);

  function OrganizationDetailsBody() {
    _classCallCheck(this, OrganizationDetailsBody);

    return _possibleConstructorReturn(this, (OrganizationDetailsBody.__proto__ || Object.getPrototypeOf(OrganizationDetailsBody)).apply(this, arguments));
  }

  _createClass(OrganizationDetailsBody, [{
    key: 'render',
    value: function render() {
      var organization = this.context.organization;


      if (organization.status) if (organization.status.id === 'pending_deletion') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DeletionPending, { organization: organization });
      } else if (organization.status.id === 'deletion_in_progress') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DeletionInProgress, { organization: organization });
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_lazyLoad__["a" /* default */], _extends({
          component: function component() {
            return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 278)).then(function (mod) {
              return mod.default;
            });
          }
        }, this.props, {
          organization: organization
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_app_components_errorBoundary__["default"],
          null,
          this.props.children
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_footer__["a" /* default */], null)
      );
    }
  }]);

  return OrganizationDetailsBody;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class3.contextTypes = {
  organization: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
}, _temp3);

var OrganizationDetails = function (_Component4) {
  _inherits(OrganizationDetails, _Component4);

  function OrganizationDetails() {
    _classCallCheck(this, OrganizationDetails);

    return _possibleConstructorReturn(this, (OrganizationDetails.__proto__ || Object.getPrototypeOf(OrganizationDetails)).apply(this, arguments));
  }

  _createClass(OrganizationDetails, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_app_views_organizationContext__["a" /* default */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          OrganizationDetailsBody,
          null,
          this.props.children
        )
      );
    }
  }]);

  return OrganizationDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);



/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = load;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_stores_configStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_actions_incidentActions__ = __webpack_require__(553);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();






function getIncidentsFromIncidentResponse(incidents) {
  if (incidents === null || incidents.length == 0) {
    return [[], 'none'];
  }

  var isMajor = false;
  var log = [];
  incidents.forEach(function (item) {
    if (!isMajor && item.impact === 'major') {
      isMajor = true;
    }
    log.push({
      name: item.name,
      updates: item.incident_updates.map(function (update) {
        return update.body;
      }),
      url: item.shortlink,
      status: item.status
    });
  });

  return [log, isMajor ? 'major' : 'minor'];
}

function load() {
  var cfg = __WEBPACK_IMPORTED_MODULE_1_app_stores_configStore__["default"].get('statuspage');
  if (cfg && cfg.id) {
    __WEBPACK_IMPORTED_MODULE_2_app_actions_incidentActions__["a" /* default */].update();

    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      type: 'GET',
      url: 'https://' + cfg.id + '.' + cfg.api_host + '/api/v2/incidents/unresolved.json',
      crossDomain: true,
      cache: false,
      success: function success(data) {
        var _getIncidentsFromInci = getIncidentsFromIncidentResponse(data.incidents),
            _getIncidentsFromInci2 = _slicedToArray(_getIncidentsFromInci, 2),
            incidents = _getIncidentsFromInci2[0],
            indicator = _getIncidentsFromInci2[1];

        __WEBPACK_IMPORTED_MODULE_2_app_actions_incidentActions__["a" /* default */].updateSuccess({
          status: {
            incidents: incidents,
            indicator: indicator,
            url: data.page.url
          }
        });
      },
      error: function error() {
        __WEBPACK_IMPORTED_MODULE_2_app_actions_incidentActions__["a" /* default */].updateError({
          status: null
        });
      }
    });
  }
}

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_preferencesActions__ = __webpack_require__(552);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/**
 * This store is used to hold local user preferences
 * Side-effects (like reading/writing to cookies) are done in associated actionCreators
 */
var PreferencesStore = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({
  init: function init() {
    this.reset();

    this.listenTo(__WEBPACK_IMPORTED_MODULE_1__actions_preferencesActions__["a" /* default */].hideSidebar, this.onHideSidebar);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_1__actions_preferencesActions__["a" /* default */].showSidebar, this.onShowSidebar);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_1__actions_preferencesActions__["a" /* default */].loadInitialState, this.loadInitialState);
  },
  getInitialState: function getInitialState() {
    return this._state;
  },
  reset: function reset() {
    this._state = {
      collapsed: false
    };
  },
  loadInitialState: function loadInitialState(state) {
    this._state = _extends({}, state);
    this.trigger(this._state);
  },
  onHideSidebar: function onHideSidebar() {
    this._state.collapsed = true;
    this.trigger(this._state);
  },
  onShowSidebar: function onShowSidebar() {
    this._state.collapsed = false;
    this.trigger(this._state);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (PreferencesStore);

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_inlineSvg__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_sidebar_sidebarItem__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_sidebar_sidebarPanel__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_sidebar_sidebarPanelEmpty__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_sidebar_sidebarPanelItem__ = __webpack_require__(1226);













var MARK_SEEN_DELAY = 1000;
var POLLER_DELAY = 60000;

var Broadcasts = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'Broadcasts',

  propTypes: {
    orientation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['top', 'left']),
    collapsed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    showPanel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    currentPanel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    hidePanel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    onShowPanel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    return {
      broadcasts: [],
      loading: true,
      error: false
    };
  },
  componentWillMount: function componentWillMount() {
    this.fetchData();
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this.timer) {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
    if (this.poller) {
      window.clearTimeout(this.poller);
      this.poller = null;
    }
  },
  remountComponent: function remountComponent() {
    this.setState(this.getInitialState(), this.fetchData);
  },
  fetchData: function fetchData() {
    var _this = this;

    if (this.poller) {
      window.clearTimeout(this.poller);
    }
    this.api.request('/broadcasts/', {
      method: 'GET',
      success: function success(data) {
        _this.setState({
          broadcasts: data || [],
          loading: false
        });
        _this.poller = window.setTimeout(_this.fetchData, POLLER_DELAY);
      },
      error: function error() {
        _this.setState({
          loading: false,
          error: true
        });
        _this.poller = window.setTimeout(_this.fetchData, POLLER_DELAY);
      }
    });
  },
  handleShowPanel: function handleShowPanel() {
    this.timer = window.setTimeout(this.markSeen, MARK_SEEN_DELAY);
    this.props.onShowPanel();
  },
  getUnseenIds: function getUnseenIds() {
    if (!this.state.broadcasts) return [];

    return this.state.broadcasts.filter(function (item) {
      return !item.hasSeen;
    }).map(function (item) {
      return item.id;
    });
  },
  markSeen: function markSeen() {
    var _this2 = this;

    var unseenBroadcastIds = this.getUnseenIds();
    if (unseenBroadcastIds.length === 0) return;

    this.api.request('/broadcasts/', {
      method: 'PUT',
      query: { id: unseenBroadcastIds },
      data: {
        hasSeen: '1'
      },
      success: function success() {
        _this2.setState({
          broadcasts: _this2.state.broadcasts.map(function (item) {
            item.hasSeen = true;
            return item;
          })
        });
      }
    });
  },
  render: function render() {
    var _props = this.props,
        orientation = _props.orientation,
        collapsed = _props.collapsed,
        currentPanel = _props.currentPanel,
        showPanel = _props.showPanel,
        hidePanel = _props.hidePanel;
    var _state = this.state,
        broadcasts = _state.broadcasts,
        loading = _state.loading;


    var unseenPosts = this.getUnseenIds();

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_sidebar_sidebarItem__["a" /* default */], {
        'data-test-id': 'sidebar-broadcasts',
        orientation: orientation,
        collapsed: collapsed,
        active: currentPanel == 'broadcasts',
        badge: unseenPosts.length,
        icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_inlineSvg__["a" /* default */], { src: 'icon-broadcast', size: '22px' }),
        label: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])("What's new"),
        onClick: this.handleShowPanel
      }),
      showPanel && currentPanel == 'broadcasts' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_app_components_sidebar_sidebarPanel__["a" /* default */],
        {
          'data-test-id': 'sidebar-broadcasts-panel',
          orientation: orientation,
          collapsed: collapsed,
          title: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])("What's new in Sentry"),
          hidePanel: hidePanel
        },
        loading ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_loadingIndicator__["default"], null) : broadcasts.length === 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_app_components_sidebar_sidebarPanelEmpty__["a" /* default */],
          null,
          Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('No recent updates from the Sentry team.')
        ) : broadcasts.map(function (item) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_sidebar_sidebarPanelItem__["a" /* default */], {
            key: item.id,
            hasSeen: item.hasSeen,
            title: item.title,
            message: item.message,
            link: item.link
          });
        })
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Broadcasts);

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__externalLink__ = __webpack_require__(71);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SidebarPanelItem = (_temp = _class = function (_React$Component) {
  _inherits(SidebarPanelItem, _React$Component);

  function SidebarPanelItem() {
    _classCallCheck(this, SidebarPanelItem);

    return _possibleConstructorReturn(this, (SidebarPanelItem.__proto__ || Object.getPrototypeOf(SidebarPanelItem)).apply(this, arguments));
  }

  _createClass(SidebarPanelItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          hasSeen = _props.hasSeen,
          title = _props.title,
          image = _props.image,
          message = _props.message,
          link = _props.link;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        SidebarPanelItemRoot,
        null,
        title && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Title,
          { hasSeen: hasSeen },
          title
        ),
        image && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'image' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: image })
        ),
        message && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Message,
          null,
          message
        ),
        link && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Text,
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__externalLink__["a" /* default */],
            { href: link },
            Object(__WEBPACK_IMPORTED_MODULE_3__locale__["t"])('Read More')
          )
        )
      );
    }
  }]);

  return SidebarPanelItem;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  message: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
  link: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  hasSeen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (SidebarPanelItem);

var SidebarPanelItemRoot = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'er110870'
})('padding:15px 20px;line-height:1.2;border-bottom:1px solid ', function (p) {
  return p.theme.borderLight;
}, ';background:', function (p) {
  return p.theme.white;
}, ';box-shadow:0 1px 2px rgba(0,0,0,0.06);font-size:14px;');

var Title = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(function (_ref) {
  var hasSeen = _ref.hasSeen,
      props = _objectWithoutProperties(_ref, ['hasSeen']);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', props);
}, {
  target: 'er110871'
})('font-size:15px;margin-bottom:5px;color:', function (p) {
  return p.theme.gray5;
}, ';', function (p) {
  return !p.hasSeen && 'font-weight: 600;';
}, ';.culprit{font-weight:normal;}');

var Text = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])('div', {
  target: 'er110872'
})('margin-bottom:5px;&:last-child{margin-bottom:0;}');

var Message = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_emotion__["default"])(Text, {
  target: 'er110873'
})('color:', function (p) {
  return p.theme.gray3;
}, ';');

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_stores_incidentStore__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_inlineSvg__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sidebarItem__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sidebarPanel__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__sidebarPanelEmpty__ = __webpack_require__(554);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
















var Incidents = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'Incidents',

  propTypes: {
    orientation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['top', 'left']),
    collapsed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    showPanel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    currentPanel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    hidePanel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    onShowPanel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_7_app_stores_incidentStore__["a" /* default */], 'onIncidentChange')],

  getInitialState: function getInitialState() {
    return {
      status: null
    };
  },
  onIncidentChange: function onIncidentChange(status) {
    this.setState({
      status: _extends({}, status)
    });
  },
  render: function render() {
    var _props = this.props,
        orientation = _props.orientation,
        collapsed = _props.collapsed,
        currentPanel = _props.currentPanel,
        showPanel = _props.showPanel,
        hidePanel = _props.hidePanel,
        onShowPanel = _props.onShowPanel;
    var status = this.state.status;

    if (!status) return null;

    var active = currentPanel === 'statusupdate';
    var isEmpty = !status.incidents || status.incidents.length === 0;

    if (isEmpty) return null;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__sidebarItem__["a" /* default */], {
        id: 'statusupdate',
        orientation: orientation,
        collapsed: collapsed,
        active: active,
        icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_inlineSvg__["a" /* default */], {
          src: 'icon-circle-exclamation',
          className: 'animated pulse infinite'
        }),
        label: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Service status'),
        onClick: onShowPanel
      }),
      showPanel && active && status && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__sidebarPanel__["a" /* default */],
        {
          orientation: orientation,
          title: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Recent status updates'),
          hidePanel: hidePanel,
          collapsed: collapsed
        },
        isEmpty && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11__sidebarPanelEmpty__["a" /* default */],
          null,
          Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('There are no incidents to report')
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          IncidentList,
          { className: 'incident-list' },
          status.incidents.map(function (incident) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              IncidentItem,
              { key: incident.id },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                IncidentTitle,
                null,
                incident.title
              ),
              incident.updates ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  StatusHeader,
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Latest updates:')
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  StatusList,
                  null,
                  incident.updates.map(function (update, key) {
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      StatusItem,
                      { key: key },
                      update
                    );
                  })
                )
              ) : null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_app_components_buttons_button__["default"],
                  { href: incident.url, size: 'small', external: true },
                  Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Learn more')
                )
              )
            );
          })
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Incidents);

var IncidentList = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('ul', {
  target: 'e1teacth0'
})('list-style:none;padding:20px 20px 0;font-size:13px;');

var IncidentItem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('li', {
  target: 'e1teacth1'
})('border-bottom:1px solid ', function (p) {
  return p.theme.borderLight;
}, ';margin-bottom:20px;padding-bottom:5px;');

var IncidentTitle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('div', {
  target: 'e1teacth2'
})('font-size:18px;font-weight:600;line-height:1.2;margin-bottom:15px;');
var StatusHeader = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('div', {
  target: 'e1teacth3'
})('color:#7c6a8e;margin-bottom:15px;font-size:14px;font-weight:600;line-height:1;');
var StatusList = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('ul', {
  target: 'e1teacth4'
})('list-style:none;padding:0;');
var StatusItem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('li', {
  target: 'e1teacth5'
})('margin-bottom:15px;line-height:1.5;');

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_actions_incidentActions__ = __webpack_require__(553);




var IncidentStore = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({
  init: function init() {
    this.reset();

    this.listenTo(__WEBPACK_IMPORTED_MODULE_1_app_actions_incidentActions__["a" /* default */].updateSuccess, this.onUpdateSuccess);
  },
  reset: function reset() {
    this.status = {};
  },
  onUpdateSuccess: function onUpdateSuccess(data) {
    this.status = data.status;
    this.trigger(this.status);
  },
  getStatus: function getStatus() {
    return this.status;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IncidentStore);

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_avatar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_dropdownMenu__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_hook__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_inlineSvg__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_textOverflow__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_idBadge__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__switchOrganization__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__sidebarOrgSummary__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__sidebarMenuItem__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__divider_styled__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__sidebarDropdownMenu_styled__ = __webpack_require__(557);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var SidebarDropdown = (_temp = _class = function (_React$Component) {
  _inherits(SidebarDropdown, _React$Component);

  function SidebarDropdown() {
    _classCallCheck(this, SidebarDropdown);

    return _possibleConstructorReturn(this, (SidebarDropdown.__proto__ || Object.getPrototypeOf(SidebarDropdown)).apply(this, arguments));
  }

  _createClass(SidebarDropdown, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          org = _props.org,
          orientation = _props.orientation,
          collapsed = _props.collapsed,
          config = _props.config,
          user = _props.user,
          onClick = _props.onClick;

      var hasOrganization = !!org;
      var hasUser = !!user;

      // If there is no org in context, we use an org from `withLatestContext`
      // (which uses an org from organizations index endpoint versus details endpoint)
      // and does not have `access`
      var hasOrgRead = org && org.access && org.access.indexOf('org:read') > -1;
      var hasOrgWrite = org && org.access && org.access.indexOf('org:write') > -1;
      var hasMemberRead = org && org.access && org.access.indexOf('member:read') > -1;
      var hasTeamRead = org && org.access && org.access.indexOf('team:read') > -1;

      // Avatar to use: Organization --> user --> Sentry
      var avatar = hasOrganization || hasUser ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StyledAvatar, {
        onClick: onClick,
        collapsed: collapsed,
        organization: org,
        user: !org ? user : null,
        size: 32
      }) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        SentryLink,
        { to: '/' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_inlineSvg__["a" /* default */], {
          className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])({ fontSize: 32 }),
          src: 'icon-sentry' })
      );

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_app_components_dropdownMenu__["a" /* default */],
        null,
        function (_ref) {
          var isOpen = _ref.isOpen,
              getRootProps = _ref.getRootProps,
              getActorProps = _ref.getActorProps,
              getMenuProps = _ref.getMenuProps;

          return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            SidebarDropdownRoot,
            getRootProps({ isStyled: true }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              SidebarDropdownActor,
              _extends({
                'data-test-id': 'sidebar-dropdown'
              }, getActorProps({ isStyled: true })),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { style: { display: 'flex', alignItems: 'flex-start' } },
                avatar,
                hasOrganization && !collapsed && orientation !== 'top' && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  NameAndOrgWrapper,
                  null,
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    DropdownOrgName,
                    null,
                    org.name,
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i', { className: 'icon-arrow-down' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    DropdownUserName,
                    null,
                    user.name
                  )
                )
              )
            ),
            isOpen && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              OrgAndUserMenu,
              getMenuProps({ isStyled: true, org: org }),
              hasOrganization && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__sidebarOrgSummary__["b" /* default */], { organization: org }),
                hasOrgRead && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_15__sidebarMenuItem__["a" /* default */],
                  { to: '/settings/' + org.slug + '/' },
                  Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Organization settings')
                ),
                hasMemberRead && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_15__sidebarMenuItem__["a" /* default */],
                  { to: '/settings/' + org.slug + '/members/' },
                  Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Members')
                ),
                hasTeamRead && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_15__sidebarMenuItem__["a" /* default */],
                  { to: '/settings/' + org.slug + '/teams/' },
                  Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Teams')
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_hook__["a" /* default */], {
                  name: 'sidebar:organization-dropdown-menu',
                  organization: org,
                  Components: { SidebarMenuItem: __WEBPACK_IMPORTED_MODULE_15__sidebarMenuItem__["a" /* default */] }
                }),
                config.isOnPremise && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_15__sidebarMenuItem__["a" /* default */],
                  { href: 'https://forum.sentry.io/' },
                  Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Support forum')
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_15__sidebarMenuItem__["a" /* default */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__switchOrganization__["a" /* default */], { canCreateOrganization: hasOrgWrite })
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__divider_styled__["a" /* default */], null)
              ),
              !!user && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  UserSummary,
                  { to: '/settings/account/details/' },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(UserBadgeNoOverflow, { user: user, avatarSize: 32 })
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_15__sidebarMenuItem__["a" /* default */],
                    { to: '/settings/account/' },
                    Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('User settings')
                  ),
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_15__sidebarMenuItem__["a" /* default */],
                    { to: '/settings/account/api/' },
                    Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('API keys')
                  ),
                  user.isSuperuser && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_15__sidebarMenuItem__["a" /* default */],
                    { to: '/manage/' },
                    Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Admin')
                  ),
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_15__sidebarMenuItem__["a" /* default */],
                    { href: '/auth/logout/' },
                    Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Sign out')
                  )
                )
              )
            )
          );
        }
      );
    }
  }]);

  return SidebarDropdown;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['top', 'left']),
  collapsed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  org: __WEBPACK_IMPORTED_MODULE_10_app_proptypes__["e" /* default */].Organization,
  user: __WEBPACK_IMPORTED_MODULE_10_app_proptypes__["e" /* default */].User,
  config: __WEBPACK_IMPORTED_MODULE_10_app_proptypes__["e" /* default */].Config,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class.defaultProps = {
  onClick: function onClick() {}
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (SidebarDropdown);

var SentryLink = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_9_app_components_link__["a" /* default */], {
  target: 'e1fowdfw0'
})('color:', function (p) {
  return p.theme.white;
}, ';&:hover{color:', function (p) {
  return p.theme.white;
}, ';}');

var UserSummary = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_9_app_components_link__["a" /* default */], {
  target: 'e1fowdfw1'
})('display:flex;padding:10px 15px;');

var UserBadgeNoOverflow = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_12_app_components_idBadge__["a" /* default */], {
  target: 'e1fowdfw2'
})('overflow:hidden;');

var SidebarDropdownRoot = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e1fowdfw3'
})('position:relative;');

// So that long org names and user names do not overflow
var NameAndOrgWrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e1fowdfw4'
})('overflow:hidden;');
var DropdownOrgName = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_11_app_components_textOverflow__["a" /* default */], {
  target: 'e1fowdfw5'
})('font-size:16px;line-height:1.2;font-weight:bold;color:', function (p) {
  return p.theme.white;
}, ';text-shadow:0 0 6px rgba(255,255,255,0);transition:0.15s text-shadow linear;');

var DropdownUserName = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_11_app_components_textOverflow__["a" /* default */], {
  target: 'e1fowdfw6'
})('font-size:14px;line-height:16px;transition:0.15s color linear;');

var SidebarDropdownActor = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e1fowdfw7'
})('cursor:pointer;&:hover{/* stylelint-disable-next-line no-duplicate-selectors */\n    ', DropdownOrgName, '{text-shadow:0 0 6px rgba(255,255,255,0.1);}/* stylelint-disable-next-line no-duplicate-selectors */\n    ', DropdownUserName, '{color:', function (p) {
  return p.theme.gray1;
}, ';}}');

var StyledAvatar = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_5_app_components_avatar__["a" /* default */], {
  target: 'e1fowdfw8'
})('margin-top:2px;margin-bottom:2px;margin-right:', function (p) {
  return p.collapsed ? '0' : '12px';
}, ';box-shadow:0 2px 0 rgba(0,0,0,0.08);border-radius:4px;');

var OrgAndUserMenu = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e1fowdfw9'
})(__WEBPACK_IMPORTED_MODULE_17__sidebarDropdownMenu_styled__["a" /* default */], ';top:42px;min-width:180px;');

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_stores_hookStore__ = __webpack_require__(72);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







/**
 * Instead of accessing the HookStore directly, use this.
 *
 * If the hook slot needs to perform anything w/ the hooks, you can pass a function as a child and you will receive an object with a `hooks` key
 *
 * example:
 *
 * <Hook name="my-hook">
 * {({hooks}) => hooks.map(hook => (
 *  <Wrapper>
 *    {hook}
 * </Wrapper>
 * ))}
 * </Hook>
 *
 */
var Hook = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'Hook',
  propTypes: {
    name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_3_app_stores_hookStore__["default"], 'handleHooks')],

  getInitialState: function getInitialState() {
    var _props = this.props,
        name = _props.name,
        props = _objectWithoutProperties(_props, ['name']);

    return {
      hooks: __WEBPACK_IMPORTED_MODULE_3_app_stores_hookStore__["default"].get(name).map(function (cb) {
        return cb(props);
      })
    };
  },
  handleHooks: function handleHooks(hookName, hooks) {
    var _props2 = this.props,
        name = _props2.name,
        props = _objectWithoutProperties(_props2, ['name']);

    // Make sure that the incoming hook update matches this component's hook name


    if (hookName !== name) return;

    this.setState(function (state) {
      return {
        hooks: hooks.map(function (cb) {
          return cb(props);
        })
      };
    });
  },
  render: function render() {
    var children = this.props.children;


    if (!this.state.hooks || !this.state.hooks.length) return null;

    if (typeof children === 'function') {
      return children({ hooks: this.state.hooks });
    }

    return this.state.hooks;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Hook);

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SwitchOrganization */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_dropdownMenu__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_inlineSvg__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_utils_withOrganizations__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sidebarOrgSummary__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sidebarMenuItem__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__divider_styled__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sidebarDropdownMenu_styled__ = __webpack_require__(557);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















/**
 * Switch Organization Menu Label + Sub Menu
 */
var SwitchOrganization = (_temp = _class = function (_React$Component) {
  _inherits(SwitchOrganization, _React$Component);

  function SwitchOrganization() {
    _classCallCheck(this, SwitchOrganization);

    return _possibleConstructorReturn(this, (SwitchOrganization.__proto__ || Object.getPrototypeOf(SwitchOrganization)).apply(this, arguments));
  }

  _createClass(SwitchOrganization, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          organizations = _props.organizations,
          canCreateOrganization = _props.canCreateOrganization;

      var hasOrganizations = organizations && !!organizations.length;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_app_components_dropdownMenu__["a" /* default */],
        { isNestedDropdown: true },
        function (_ref) {
          var isOpen = _ref.isOpen,
              getMenuProps = _ref.getMenuProps,
              getActorProps = _ref.getActorProps;

          return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              SwitchOrganizationMenuActor,
              _extends({
                'data-test-id': 'sidebar-switch-org'
              }, getActorProps({
                isStyled: true
              }), {
                onClick: function onClick(e) {
                  // This overwrites `DropdownMenu.getActorProps.onClick` which normally handles clicks on actor
                  // to toggle visibility of menu. Instead, do nothing because it is nested and we only want it
                  // to appear when hovered on. Will also stop menu from closing when clicked on (which seems to be common
                  // behavior);

                  // Stop propagation so that dropdown menu doesn't close here
                  e.stopPropagation();
                }
              }),
              Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Switch organization'),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                SubMenuCaret,
                null,
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i', { className: 'icon-arrow-right' })
              )
            ),
            isOpen && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              SwitchOrganizationMenu,
              _extends({
                'data-test-id': 'sidebar-switch-org-menu'
              }, getMenuProps({ isStyled: true })),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                OrganizationList,
                null,
                organizations.map(function (organization) {
                  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10__sidebarMenuItem__["a" /* default */],
                    {
                      key: organization.slug,
                      to: '/' + organization.slug + '/'
                    },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__sidebarOrgSummary__["b" /* default */], { organization: organization })
                  );
                })
              ),
              hasOrganizations && canCreateOrganization && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__divider_styled__["a" /* default */], {
                className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])({ marginTop: 0 })
              }),
              canCreateOrganization && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10__sidebarMenuItem__["a" /* default */],
                {
                  'data-test-id': 'sidebar-create-org',
                  to: '/organizations/new/',
                  style: { alignItems: 'center' }
                },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  MenuItemLabelWithIcon,
                  null,
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(AddIcon, { src: 'icon-circle-add' }),
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'span',
                    null,
                    Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Create a new organization')
                  )
                )
              )
            )
          );
        }
      );
    }
  }]);

  return SwitchOrganization;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  organizations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_app_proptypes__["e" /* default */].Organization),
  canCreateOrganization: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _temp);

var SwitchOrganizationContainer = Object(__WEBPACK_IMPORTED_MODULE_8_app_utils_withOrganizations__["a" /* default */])(SwitchOrganization);


/* harmony default export */ __webpack_exports__["a"] = (SwitchOrganizationContainer);

var AddIcon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_6_app_components_inlineSvg__["a" /* default */], {
  target: 'ejspo4a0'
})('width:15px;height:15px;margin-right:8px;color:', function (p) {
  return p.theme.gray2;
}, ';');

var MenuItemLabelWithIcon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('span', {
  target: 'ejspo4a1'
})('line-height:1;display:flex;align-items:center;padding:8px 0;');

var SubMenuCaret = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('span', {
  target: 'ejspo4a2'
})('color:', function (p) {
  return p.theme.gray2;
}, ';transition:0.1s color linear;&:hover,&:active{color:', function (p) {
  return p.theme.gray3;
}, ';}');

// Menu Item in dropdown to "Switch organization"
var SwitchOrganizationMenuActor = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('span', {
  target: 'ejspo4a3'
})('display:flex;justify-content:space-between;align-items:center;margin:0 -', function (p) {
  return p.theme.sidebar.menuSpacing;
}, ';padding:0 ', function (p) {
  return p.theme.sidebar.menuSpacing;
}, ';');

var SwitchOrganizationMenu = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'ejspo4a4'
})(__WEBPACK_IMPORTED_MODULE_12__sidebarDropdownMenu_styled__["a" /* default */], ';top:0;left:256px;');

var OrganizationList = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'ejspo4a5'
})('max-height:350px;overflow-y:auto;');

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils_analytics__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sidebarPanel__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__onboardingWizard_todos__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tooltip__ = __webpack_require__(21);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var OnboardingStatus = (_temp = _class = function (_React$Component) {
  _inherits(OnboardingStatus, _React$Component);

  function OnboardingStatus() {
    _classCallCheck(this, OnboardingStatus);

    return _possibleConstructorReturn(this, (OnboardingStatus.__proto__ || Object.getPrototypeOf(OnboardingStatus)).apply(this, arguments));
  }

  _createClass(OnboardingStatus, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          currentPanel = _props.currentPanel,
          org = _props.org;

      if (currentPanel !== prevProps.currentPanel && (currentPanel || prevProps.currentPanel == 'todos')) {
        this.recordAnalytics(currentPanel, org.id);
      }
    }
  }, {
    key: 'recordAnalytics',
    value: function recordAnalytics(currentPanel, orgId) {
      currentPanel === 'todos' ? Object(__WEBPACK_IMPORTED_MODULE_2_app_utils_analytics__["a" /* default */])('onboarding.wizard_opened', { org_id: orgId }) : Object(__WEBPACK_IMPORTED_MODULE_2_app_utils_analytics__["a" /* default */])('onboarding.wizard_closed', { org_id: orgId });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          collapsed = _props2.collapsed,
          org = _props2.org,
          currentPanel = _props2.currentPanel,
          hidePanel = _props2.hidePanel,
          showPanel = _props2.showPanel,
          onShowPanel = _props2.onShowPanel;

      if (org.features && org.features.indexOf('onboarding') === -1) return null;

      var doneTasks = (org.onboardingTasks || []).filter(function (task) {
        return task.status === 'complete' || task.status === 'skipped';
      });
      var allDisplayedTasks = __WEBPACK_IMPORTED_MODULE_5__onboardingWizard_todos__["default"].TASKS.filter(function (task) {
        return task.display;
      });

      var percentage = Math.round(doneTasks.length / allDisplayedTasks.length * 100).toString();

      var style = {
        height: collapsed ? percentage + '%' : undefined,
        width: collapsed ? undefined : percentage + '%'
      };

      if (doneTasks.length >= allDisplayedTasks.length) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: currentPanel === 'todos' ? 'onboarding active' : 'onboarding' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__tooltip__["default"],
          {
            title: Object(__WEBPACK_IMPORTED_MODULE_3__locale__["t"])('Getting started with Sentry: <br />' + doneTasks.length + ' / ' + allDisplayedTasks.length + ' tasks completed'),
            tooltipOptions: { html: true }
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            {
              'data-test-id': 'onboarding-progress-bar',
              className: 'onboarding-progress-bar',
              onClick: onShowPanel
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'slider', style: style })
          )
        ),
        showPanel && currentPanel === 'todos' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__sidebarPanel__["a" /* default */],
          {
            collapsed: collapsed,
            title: 'Getting Started with Sentry',
            hidePanel: hidePanel
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__onboardingWizard_todos__["default"], null)
        )
      );
    }
  }]);

  return OnboardingStatus;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  org: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  currentPanel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  onShowPanel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  showPanel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  hidePanel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  collapsed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (OnboardingStatus);

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Raven) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_utils_analytics__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_mixins_organizationState__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_onboardingWizard_confirmation__ = __webpack_require__(1234);











var TodoItem = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'TodoItem',

  propTypes: {
    task: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    onSkip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_7_app_mixins_organizationState__["a" /* default */]],

  getInitialState: function getInitialState() {
    return {
      showConfirmation: false,
      isExpanded: false
    };
  },
  toggleDescription: function toggleDescription() {
    this.setState({ isExpanded: !this.state.isExpanded });
  },
  toggleConfirmation: function toggleConfirmation() {
    this.setState({ showConfirmation: !this.state.showConfirmation });
  },
  formatDescription: function formatDescription() {
    var task = this.props.task;
    var isExpanded = this.state.isExpanded;


    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'p',
      null,
      task.description,
      ' ',
      isExpanded && '. ' + task.detailedDescription
    );
  },
  learnMoreUrlCreator: function learnMoreUrlCreator() {
    var org = this.getOrganization();
    var task = this.props.task;

    var learnMoreUrl = void 0;
    if (task.featureLocation === 'project') {
      learnMoreUrl = '/organizations/' + org.slug + '/projects/choose/?onboarding=1&task=' + task.task;
    } else if (task.featureLocation === 'organization') {
      learnMoreUrl = '/organizations/' + org.slug + '/' + task.location;
    } else if (task.featureLocation === 'absolute') {
      learnMoreUrl = task.location;
    } else {
      Raven.captureMessage('No learnMoreUrl created for this featureLocation ', {
        extra: { props: this.props, state: this.state }
      });
    }
    return learnMoreUrl;
  },
  recordAnalytics: function recordAnalytics(action) {
    var org = this.getOrganization();
    var task = this.props.task;

    Object(__WEBPACK_IMPORTED_MODULE_6_app_utils_analytics__["a" /* default */])('onboarding.wizard_clicked', {
      org_id: parseInt(org.id, 10),
      todo_id: parseInt(task.task, 10),
      todo_title: task.title,
      action: action
    });
  },
  onSkip: function onSkip(task) {
    this.recordAnalytics('skipped');
    this.props.onSkip(task);
    this.setState({ showConfirmation: false });
  },
  handleClick: function handleClick(e) {
    this.recordAnalytics('clickthrough');
    e.stopPropagation();
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        task = _props.task,
        className = _props.className;
    var showConfirmation = this.state.showConfirmation;

    var learnMoreUrl = this.learnMoreUrlCreator();
    var description = void 0;

    switch (task.status) {
      case 'complete':
        description = Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["tct"])('[user] completed [dateCompleted]', {
          user: task.user,
          dateCompleted: __WEBPACK_IMPORTED_MODULE_0_moment___default()(task.dateCompleted).fromNow()
        });
        break;
      case 'pending':
        description = Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["tct"])('[user] kicked off [dateCompleted]', {
          user: task.user,
          dateCompleted: __WEBPACK_IMPORTED_MODULE_0_moment___default()(task.dateCompleted).fromNow()
        });
        break;
      case 'skipped':
        description = Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["tct"])('[user] skipped [dateCompleted]', {
          user: task.user,
          dateCompleted: __WEBPACK_IMPORTED_MODULE_0_moment___default()(task.dateCompleted).fromNow()
        });
        break;
      default:
        description = this.formatDescription();
    }

    var classes = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, task.status, {
      blur: showConfirmation
    });

    var showSkipButton = task.skippable && task.status !== 'skipped' && task.status !== 'complete' && !showConfirmation;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'li',
      {
        className: classes,
        onMouseOver: this.toggleDescription,
        onMouseOut: this.toggleDescription
      },
      task.status === 'pending' && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'pending-bar' }),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'todo-content' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'ob-checkbox' },
          task.status === 'complete' && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon-checkmark' }),
          task.status === 'skipped' && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon-x' }),
          task.status === 'pending' && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon-ellipsis' })
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'a',
          { href: learnMoreUrl, onClick: this.handleClick },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h4',
            null,
            task.title
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          null,
          description
        ),
        showSkipButton && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'a',
          { className: 'skip-btn btn btn-default', onClick: this.toggleConfirmation },
          Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Skip')
        )
      ),
      showConfirmation && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_onboardingWizard_confirmation__["a" /* default */], {
        task: task.task,
        onSkip: function onSkip() {
          return _this.onSkip(task.task);
        },
        dismiss: this.toggleConfirmation
      })
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (TodoItem);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(40)))

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Confirmation = (_temp2 = _class = function (_React$Component) {
  _inherits(Confirmation, _React$Component);

  function Confirmation() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Confirmation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Confirmation.__proto__ || Object.getPrototypeOf(Confirmation)).call.apply(_ref, [this].concat(args))), _this), _this.skip = function (e) {
      e.preventDefault();
      _this.props.onSkip();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Confirmation, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'ob-confirmation', onClick: this.props.dismiss },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Need help?')
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            { href: 'mailto:support@sentry.io?subject=Help with onboarding' },
            Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Ask us!')
          ),
          ' ',
          '\xB7 ',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            { onClick: this.skip },
            Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Skip')
          )
        )
      );
    }
  }]);

  return Confirmation;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  onSkip: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dismiss: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (Confirmation);

/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_proptypes__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var OrganizationAccessRequests = (_temp2 = _class = function (_React$Component) {
  _inherits(OrganizationAccessRequests, _React$Component);

  function OrganizationAccessRequests() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrganizationAccessRequests);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrganizationAccessRequests.__proto__ || Object.getPrototypeOf(OrganizationAccessRequests)).call.apply(_ref, [this].concat(args))), _this), _this.handleApprove = function (id, e) {
      e.stopPropagation();
      _this.props.onApprove(id);
    }, _this.handleDeny = function (id, e) {
      e.stopPropagation();
      _this.props.onDeny(id);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OrganizationAccessRequests, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          accessRequestBusy = _props.accessRequestBusy,
          requestList = _props.requestList;


      if (!requestList || !requestList.length) return null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_app_components_panels__["a" /* Panel */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_app_components_panels__["e" /* PanelHeader */],
          { disablePadding: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Flex"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Box"],
              { px: 2, flex: '1' },
              Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Pending Access Requests')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_app_components_panels__["c" /* PanelBody */],
          null,
          requestList.map(function (_ref2, i) {
            var id = _ref2.id,
                member = _ref2.member,
                team = _ref2.team;

            var displayName = member.user && (member.user.name || member.user.email || member.user.username);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_app_components_panels__["f" /* PanelItem */],
              { p: 0, key: id, align: 'center' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Box"],
                { p: 2, flex: '1' },
                Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["tct"])('[name] requests access to the [team] team.', {
                  name: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'strong',
                    null,
                    displayName
                  ),
                  team: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'strong',
                    null,
                    '#',
                    team.slug
                  )
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Box"],
                { p: 2 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_app_components_buttons_button__["default"],
                  {
                    onClick: function onClick(e) {
                      return _this2.handleApprove(id, e);
                    },
                    busy: accessRequestBusy.get(id),
                    priority: 'primary',
                    style: { marginRight: 4 },
                    size: 'small'
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Approve')
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_app_components_buttons_button__["default"],
                  {
                    busy: accessRequestBusy.get(id),
                    onClick: function onClick(e) {
                      return _this2.handleDeny(id, e);
                    },
                    size: 'small'
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Deny')
                )
              )
            );
          })
        )
      );
    }
  }]);

  return OrganizationAccessRequests;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  requestList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    member: __WEBPACK_IMPORTED_MODULE_6_app_proptypes__["e" /* default */].Member,
    team: __WEBPACK_IMPORTED_MODULE_6_app_proptypes__["e" /* default */].Team
  })),
  accessRequestBusy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onApprove: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onDeny: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, _class.defaultProps = {
  requestList: []
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (OrganizationAccessRequests);

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrganizationMemberRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_avatar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_confirm__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_inlineSvg__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_utils_recreateRoute__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_components_assistant_guideAnchor__ = __webpack_require__(65);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var UserName = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_10_app_components_link__["a" /* default */], {
  target: 'e10yeuzg0'
})('font-size:16px;');

var Email = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e10yeuzg1'
})('color:', function (p) {
  return p.theme.gray3;
}, ';font-size:14px;');

var OrganizationMemberRow = (_temp = _class = function (_React$PureComponent) {
  _inherits(OrganizationMemberRow, _React$PureComponent);

  function OrganizationMemberRow() {
    var _ref;

    _classCallCheck(this, OrganizationMemberRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = OrganizationMemberRow.__proto__ || Object.getPrototypeOf(OrganizationMemberRow)).call.apply(_ref, [this].concat(args)));

    _this.handleRemove = function (e) {
      var onRemove = _this.props.onRemove;


      if (typeof onRemove !== 'function') return;

      _this.setState({ busy: true });
      onRemove(_this.props.member, e);
    };

    _this.handleLeave = function (e) {
      var onLeave = _this.props.onLeave;


      if (typeof onLeave !== 'function') return;

      _this.setState({ busy: true });
      onLeave(_this.props.member, e);
    };

    _this.handleSendInvite = function (e) {
      var onSendInvite = _this.props.onSendInvite;


      if (typeof onSendInvite !== 'function') return;

      onSendInvite(_this.props.member, e);
    };

    _this.state = { busy: false };
    return _this;
  }

  _createClass(OrganizationMemberRow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          params = _props.params,
          routes = _props.routes,
          member = _props.member,
          orgName = _props.orgName,
          status = _props.status,
          requireLink = _props.requireLink,
          memberCanLeave = _props.memberCanLeave,
          currentUser = _props.currentUser,
          canRemoveMembers = _props.canRemoveMembers,
          canAddMembers = _props.canAddMembers;
      var id = member.id,
          flags = member.flags,
          email = member.email,
          name = member.name,
          roleName = member.roleName,
          pending = member.pending,
          user = member.user;

      // if member is not the only owner, they can leave

      var needsSso = !flags['sso:linked'] && requireLink;
      var isCurrentUser = currentUser.email === email;
      var showRemoveButton = !isCurrentUser;
      var showLeaveButton = isCurrentUser;
      var canRemoveMember = canRemoveMembers && !isCurrentUser;
      // member has a `user` property if they are registered with sentry
      // i.e. has accepted an invite to join org
      var has2fa = user && user.has2fa;
      var detailsUrl = Object(__WEBPACK_IMPORTED_MODULE_14_app_utils_recreateRoute__["a" /* default */])(id, { routes: routes, params: params });
      var isInviteSuccessful = status === 'success';
      var isInviting = status === 'loading';

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_app_components_panels__["f" /* PanelItem */],
        { align: 'center', p: 0, py: 2 },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Box"],
          { pl: 2 },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_avatar__["a" /* default */], { size: 32, user: user ? user : { id: email, email: email } })
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Box"],
          { pl: 1, pr: 2, flex: '1' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h5',
            { style: { margin: '0 0 3px' } },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              UserName,
              { to: detailsUrl },
              name
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            Email,
            null,
            email
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Box"],
          { px: 2, w: 180 },
          Object(__WEBPACK_IMPORTED_MODULE_15_app_components_assistant_guideAnchor__["conditionalGuideAnchor"])(this.props.firstRow, 'member_status', 'text', needsSso || pending ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              null,
              pending ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'strong',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Invited')
              ) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'strong',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Missing SSO Link')
              )
            ),
            isInviting && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { style: { padding: '4px 0 3px' } },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_loadingIndicator__["default"], { mini: true })
            ),
            isInviteSuccessful && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'span',
              null,
              'Sent!'
            ),
            !isInviting && !isInviteSuccessful && canAddMembers && (pending || needsSso) && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              ResendInviteButton,
              {
                priority: 'primary',
                size: 'xsmall',
                onClick: this.handleSendInvite
              },
              Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Resend invite')
            )
          ) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            null,
            !has2fa ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_app_components_tooltip__["default"],
              { title: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Two-factor auth not enabled') },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(NoTwoFactorIcon, null)
            ) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(HasTwoFactorIcon, null)
          ))
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Box"],
          { px: 2, w: 140 },
          Object(__WEBPACK_IMPORTED_MODULE_15_app_components_assistant_guideAnchor__["conditionalGuideAnchor"])(this.props.firstRow, 'member_role', 'text', roleName)
        ),
        showRemoveButton || showLeaveButton ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Box"],
          { px: 2, w: 140 },
          showRemoveButton && canRemoveMember && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_app_components_confirm__["a" /* default */],
            {
              message: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["tct"])('Are you sure you want to remove [name] from [orgName]?', {
                name: name,
                orgName: orgName
              }),
              onConfirm: this.handleRemove,
              onSuccess: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["tct"])('Removed [name] from [orgName]', {
                name: name,
                orgName: orgName
              }),
              onError: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["tct"])('Error removing [name] from [orgName]', {
                name: name,
                orgName: orgName
              })
            },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_app_components_buttons_button__["default"],
              { icon: 'icon-circle-subtract', size: 'small', busy: this.state.busy },
              Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Remove')
            )
          ),
          showRemoveButton && !canRemoveMember && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_app_components_buttons_button__["default"],
            {
              disabled: true,
              size: 'small',
              title: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('You do not have access to remove member'),
              icon: 'icon-circle-subtract'
            },
            Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Remove')
          ),
          showLeaveButton && memberCanLeave && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_app_components_confirm__["a" /* default */],
            {
              message: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["tct"])('Are you sure you want to leave [orgName]?', {
                orgName: orgName
              }),
              onConfirm: this.handleLeave,
              onSuccess: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["tct"])('Left [orgName]', {
                orgName: orgName
              }),
              onError: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["tct"])('Error leaving [orgName]', {
                orgName: orgName
              })
            },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_app_components_buttons_button__["default"],
              { priority: 'danger', size: 'small', busy: this.state.busy },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon icon-exit' }),
              ' ',
              Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Leave')
            )
          ),
          showLeaveButton && !memberCanLeave && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_app_components_buttons_button__["default"],
            {
              size: 'small',
              disabled: true,
              title: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('You cannot leave the organization as you are the only owner.')
            },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon icon-exit' }),
            ' ',
            Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Leave')
          )
        ) : null
      );
    }
  }]);

  return OrganizationMemberRow;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.PureComponent), _class.propTypes = {
  routes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // XXX: Spreading this does not work :(
  member: __WEBPACK_IMPORTED_MODULE_12_app_proptypes__["e" /* default */].Member,
  onRemove: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onSendInvite: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  orgName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  memberCanLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  requireLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  canRemoveMembers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  canAddMembers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  currentUser: __WEBPACK_IMPORTED_MODULE_12_app_proptypes__["e" /* default */].User,
  status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['', 'loading', 'success', 'error']),
  firstRow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _temp);



var NoTwoFactorIcon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(function (props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_inlineSvg__["a" /* default */], _extends({}, props, { src: 'icon-circle-exclamation' }));
}, {
  target: 'e10yeuzg2'
})('color:', function (p) {
  return p.theme.error;
}, ';font-size:18px;');
var HasTwoFactorIcon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(function (props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_inlineSvg__["a" /* default */], _extends({}, props, { src: 'icon-circle-check' }));
}, {
  target: 'e10yeuzg3'
})('color:', function (p) {
  return p.theme.success;
}, ';font-size:18px;');

var ResendInviteButton = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_7_app_components_buttons_button__["default"], {
  target: 'e10yeuzg4'
})('padding:0 4px;margin-top:2px;');

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OrganizationRoot */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_actionCreators_projects__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_actionCreators_navigation__ = __webpack_require__(394);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * This is the parent container for organization-level views such
 * as the Dashboard, Stats, Activity, etc...
 *
 * Currently is just used to unset active project
 */

var OrganizationRoot = function (_React$Component) {
  _inherits(OrganizationRoot, _React$Component);

  function OrganizationRoot() {
    _classCallCheck(this, OrganizationRoot);

    return _possibleConstructorReturn(this, (OrganizationRoot.__proto__ || Object.getPrototypeOf(OrganizationRoot)).apply(this, arguments));
  }

  _createClass(OrganizationRoot, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      Object(__WEBPACK_IMPORTED_MODULE_2_app_actionCreators_projects__["g" /* setActiveProject */])(null);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Save last route so that we can jump back to view from settings
      Object(__WEBPACK_IMPORTED_MODULE_3_app_actionCreators_navigation__["b" /* setLastRoute */])(this.props.location.pathname);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return OrganizationRoot;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["withRouter"])(OrganizationRoot));

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_mixins_organizationState__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_lazyLoad__ = __webpack_require__(355);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










var OrganizationStatsContainer = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'OrganizationStatsContainer ',
  propTypes: {
    routes: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_5_app_mixins_organizationState__["a" /* default */]],

  getInitialState: function getInitialState() {
    var until = Math.floor(new Date().getTime() / 1000);
    var since = until - 3600 * 24 * 7;

    return {
      projectsError: false,
      projectsLoading: false,
      projectsRequestsPending: 0,
      statsError: false,
      statsLoading: false,
      statsRequestsPending: 0,
      projectMap: null,
      rawProjectData: { received: null, rejected: null, blacklisted: null },
      rawOrgData: { received: null, rejected: null, blacklisted: null },
      orgStats: null,
      orgTotal: null,
      projectTotals: null,
      querySince: since,
      queryUntil: until
    };
  },
  componentWillMount: function componentWillMount() {
    this.fetchData();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    // If query string changes, it will be due to pagination.
    // Intentionally only fetch projects since stats are fetched for a fixed period during
    // the initial payload
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        projectsError: false,
        projectsRequestsPending: 1,
        projectsLoading: true
      });
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var prevParams = prevProps.params,
        currentParams = this.props.params;

    if (prevParams.orgId !== currentParams.orgId) {
      this.fetchData();
    }

    // Query string is changed, probably due to pagination, re-fetch only project data
    if (prevProps.location.search !== this.props.location.search) {
      // Not sure why, but when we use pagination and the new results load and re-render,
      // the scroll position does not reset to top like in Audit Log
      if (window.scrollTo) {
        window.scrollTo(0, 0);
      }
      this.fetchProjectData();
    }
    var state = this.state;
    if (state.statsLoading && !state.statsRequestsPending) {
      this.processOrgData();
    }
    if (state.projectsLoading && !state.projectsRequestsPending) {
      this.processProjectData();
    }
  },
  fetchProjectData: function fetchProjectData() {
    var _this = this;

    this.api.request(this.getOrganizationProjectsEndpoint(), {
      query: this.props.location.query,
      success: function success(data, textStatus, jqxhr) {
        var projectMap = {};
        data.forEach(function (project) {
          projectMap[project.id] = project;
        });

        _this.setState(function (prevState) {
          return {
            pageLinks: jqxhr.getResponseHeader('Link'),
            projectMap: projectMap,
            projectsRequestsPending: prevState.projectsRequestsPending - 1
          };
        });
      },
      error: function error() {
        _this.setState({
          projectsError: true
        });
      }
    });
  },
  fetchData: function fetchData() {
    var _this2 = this;

    this.setState({
      statsError: false,
      statsLoading: true,
      statsRequestsPending: 3,
      projectsError: false,
      projectsLoading: true,
      projectsRequestsPending: 4
    });

    var statEndpoint = this.getOrganizationStatsEndpoint();

    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(this.state.rawOrgData, function (statName) {
      _this2.api.request(statEndpoint, {
        query: {
          since: _this2.state.querySince,
          until: _this2.state.queryUntil,
          resolution: '1h',
          stat: statName
        },
        success: function success(data) {
          _this2.setState(function (prevState) {
            var rawOrgData = prevState.rawOrgData;
            rawOrgData[statName] = data;

            return {
              rawOrgData: rawOrgData,
              statsRequestsPending: prevState.statsRequestsPending - 1
            };
          });
        },
        error: function error() {
          _this2.setState({
            statsError: true
          });
        }
      });
    });

    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(this.state.rawProjectData, function (statName) {
      _this2.api.request(statEndpoint, {
        query: {
          since: _this2.state.querySince,
          until: _this2.state.queryUntil,
          stat: statName,
          group: 'project'
        },
        success: function success(data) {
          _this2.setState(function (prevState) {
            var rawProjectData = prevState.rawProjectData;
            rawProjectData[statName] = data;

            return {
              rawProjectData: rawProjectData,
              projectsRequestsPending: prevState.projectsRequestsPending - 1
            };
          });
        },
        error: function error() {
          _this2.setState({
            projectsError: true
          });
        }
      });
    });

    this.fetchProjectData();
  },
  getOrganizationStatsEndpoint: function getOrganizationStatsEndpoint() {
    var params = this.props.params;
    return '/organizations/' + params.orgId + '/stats/';
  },
  getOrganizationProjectsEndpoint: function getOrganizationProjectsEndpoint() {
    var params = this.props.params;
    return '/organizations/' + params.orgId + '/projects/';
  },
  processOrgData: function processOrgData() {
    var oReceived = 0;
    var oRejected = 0;
    var oBlacklisted = 0;
    var orgPoints = []; // accepted, rejected, blacklisted
    var aReceived = [0, 0]; // received, points
    var rawOrgData = this.state.rawOrgData;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(rawOrgData.received, function (idx, point) {
      var dReceived = point[1];
      var dRejected = rawOrgData.rejected[idx][1];
      var dBlacklisted = rawOrgData.blacklisted[idx][1];
      var dAccepted = Math.max(0, dReceived - dRejected - dBlacklisted);
      orgPoints.push({
        x: point[0],
        y: [dAccepted, dRejected, dBlacklisted]
      });
      oReceived += dReceived;
      oRejected += dRejected;
      oBlacklisted += dBlacklisted;
      if (dReceived > 0) {
        aReceived[0] += dReceived;
        aReceived[1] += 1;
      }
    });
    this.setState({
      orgStats: orgPoints,
      orgTotal: {
        received: oReceived,
        rejected: oRejected,
        blacklisted: oBlacklisted,
        accepted: Math.max(0, oReceived - oRejected - oBlacklisted),
        avgRate: aReceived[1] ? parseInt(aReceived[0] / aReceived[1] / 60, 10) : 0
      },
      statsLoading: false
    });
  },
  processProjectData: function processProjectData() {
    var rawProjectData = this.state.rawProjectData;
    var projectTotals = [];
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(rawProjectData.received, function (projectId, data) {
      var pReceived = 0;
      var pRejected = 0;
      var pBlacklisted = 0;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(data, function (idx, point) {
        pReceived += point[1];
        pRejected += rawProjectData.rejected[projectId][idx][1];
        pBlacklisted += rawProjectData.blacklisted[projectId][idx][1];
      });
      projectTotals.push({
        id: projectId,
        received: pReceived,
        rejected: pRejected,
        blacklisted: pBlacklisted,
        accepted: Math.max(0, pReceived - pRejected - pBlacklisted)
      });
    });
    this.setState({
      projectTotals: projectTotals,
      projectsLoading: false
    });
  },
  render: function render() {
    var organization = this.getOrganization();

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_lazyLoad__["a" /* default */], _extends({
      component: function component() {
        return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1570)).then(function (mod) {
          return mod.default;
        });
      },
      organization: organization
    }, this.state));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (OrganizationStatsContainer);

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_constants__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_actionCreators_indicator__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_actionCreators_environments__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_actionCreators_projects__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_views_settings_components_emptyMessage__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_stores_environmentStore__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_components_inlineSvg__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_components_listLink__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_app_views_settings_components_settingsPageHeader__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_app_views_settings_components_tag__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_app_utils_recreateRoute__ = __webpack_require__(148);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



























var ProjectEnvironments = __WEBPACK_IMPORTED_MODULE_5_create_react_class___default()({
  displayName: 'ProjectEnvironments',

  propTypes: {
    route: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    routes: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
    params: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_13_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_4_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_16_app_stores_environmentStore__["a" /* default */], 'onEnvironmentsChange')],

  getInitialState: function getInitialState() {
    var isHidden = this.props.route.path === 'environments/hidden/';
    var environments = isHidden ? __WEBPACK_IMPORTED_MODULE_16_app_stores_environmentStore__["a" /* default */].getHidden() : __WEBPACK_IMPORTED_MODULE_16_app_stores_environmentStore__["a" /* default */].getActive();

    return {
      project: null,
      environments: environments,
      isHidden: isHidden
    };
  },
  componentDidMount: function componentDidMount() {
    if (this.state.environments === null) {
      this.fetchData(this.state.isHidden);
    }

    // Fetch project details instead of using project context to guarantee we have latest project details
    this.fetchProjectDetails();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var _this = this;

    var isHidden = nextProps.route.path === 'environments/hidden/';
    var environments = isHidden ? __WEBPACK_IMPORTED_MODULE_16_app_stores_environmentStore__["a" /* default */].getHidden() : __WEBPACK_IMPORTED_MODULE_16_app_stores_environmentStore__["a" /* default */].getActive();

    this.setState({
      isHidden: isHidden,
      environments: environments
    }, function () {
      if (environments === null) {
        _this.fetchData(isHidden);
      }
    });
  },
  refetchAll: function refetchAll() {
    this.fetchData(true);
    this.fetchData(false);
    this.fetchProjectDetails();
  },
  fetchData: function fetchData(hidden) {
    var _props$params = this.props.params,
        orgId = _props$params.orgId,
        projectId = _props$params.projectId;

    this.api.request('/projects/' + orgId + '/' + projectId + '/environments/', {
      query: {
        visibility: hidden ? 'hidden' : 'visible'
      },
      success: function success(env) {
        var load = hidden ? __WEBPACK_IMPORTED_MODULE_9_app_actionCreators_environments__["d" /* loadHiddenEnvironments */] : __WEBPACK_IMPORTED_MODULE_9_app_actionCreators_environments__["b" /* loadActiveEnvironments */];
        load(env);
      }
    });
  },
  fetchProjectDetails: function fetchProjectDetails() {
    var _this2 = this;

    var _props$params2 = this.props.params,
        orgId = _props$params2.orgId,
        projectId = _props$params2.projectId;

    this.api.request('/projects/' + orgId + '/' + projectId + '/', {
      success: function success(project) {
        _this2.setState({ project: project });
      }
    });
  },
  onEnvironmentsChange: function onEnvironmentsChange() {
    var isHidden = this.state.isHidden;


    this.setState({
      environments: isHidden ? __WEBPACK_IMPORTED_MODULE_16_app_stores_environmentStore__["a" /* default */].getHidden() : __WEBPACK_IMPORTED_MODULE_16_app_stores_environmentStore__["a" /* default */].getActive()
    });
  },


  // Toggle visibility of environment
  toggleEnv: function toggleEnv(env, shouldHide) {
    var _props$params3 = this.props.params,
        orgId = _props$params3.orgId,
        projectId = _props$params3.projectId;


    this.api.request('/projects/' + orgId + '/' + projectId + '/environments/' + env.urlRoutingName + '/', {
      method: 'PUT',
      data: {
        name: env.name,
        isHidden: shouldHide
      },
      success: function success(e) {
        Object(__WEBPACK_IMPORTED_MODULE_8_app_actionCreators_indicator__["d" /* addSuccessMessage */])(Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["tct"])('Updated [environment]', {
          environment: env.displayName
        }));
      },
      error: function error(err) {
        Object(__WEBPACK_IMPORTED_MODULE_8_app_actionCreators_indicator__["d" /* addSuccessMessage */])(Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["tct"])('Unable to update [environment]', {
          environment: env.displayName
        }));
      },
      complete: this.refetchAll
    });
  },


  // Change "Default Environment"
  handleSetAsDefault: function handleSetAsDefault(env) {
    var _this3 = this;

    var defaultEnvironment = env.name === __WEBPACK_IMPORTED_MODULE_7_app_constants__["a" /* ALL_ENVIRONMENTS_KEY */] ? null : env.name;

    var data = { defaultEnvironment: defaultEnvironment };

    var oldProject = this.state.project;

    // Optimistically update state
    this.setState(function (state) {
      return _extends({}, state, {
        project: _extends({}, state.project, data)
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_8_app_actionCreators_indicator__["b" /* addLoadingMessage */])();

    // Update project details
    Object(__WEBPACK_IMPORTED_MODULE_11_app_actionCreators_projects__["i" /* update */])(this.api, _extends({}, this.props.params, {
      data: data
    })).then(function () {
      Object(__WEBPACK_IMPORTED_MODULE_8_app_actionCreators_indicator__["d" /* addSuccessMessage */])(Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["tct"])('Changed default environment to [environment]', {
        environment: env.displayName
      }));
    }, function (err) {
      // Error occurred, revert project state
      _this3.setState(function (state) {
        return _extends({}, state, {
          project: oldProject
        });
      });
      Object(__WEBPACK_IMPORTED_MODULE_8_app_actionCreators_indicator__["a" /* addErrorMessage */])(Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["tct"])('Unable to change default environment to [environment]', {
        environment: env.displayName
      }));
    });
  },
  renderEmpty: function renderEmpty() {
    var isHidden = this.state.isHidden;

    var message = isHidden ? Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])("You don't have any hidden environments.") : Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])("You don't have any environments yet.");
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_15_app_views_settings_components_emptyMessage__["a" /* default */],
      null,
      message
    );
  },


  /**
   * Renders rows for "system" environments:
   * - "All Environments"
   * - "No Environment"
   *
   */
  renderSystemRows: function renderSystemRows() {
    // Not available in "Hidden" tab
    if (this.state.isHidden) return null;
    var project = this.state.project;


    var isAllEnvironmentsDefault = project && project.defaultEnvironment === null;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(EnvironmentRow, {
      name: __WEBPACK_IMPORTED_MODULE_7_app_constants__["a" /* ALL_ENVIRONMENTS_KEY */],
      environment: {
        id: __WEBPACK_IMPORTED_MODULE_7_app_constants__["a" /* ALL_ENVIRONMENTS_KEY */],
        displayName: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('All Environments'),
        name: __WEBPACK_IMPORTED_MODULE_7_app_constants__["a" /* ALL_ENVIRONMENTS_KEY */]
      },
      isSystemRow: true,
      isDefault: isAllEnvironmentsDefault,
      shouldShowSetDefault: !isAllEnvironmentsDefault && !!project,
      onSetAsDefault: this.handleSetAsDefault
    });
  },


  // Renders current default environment IF it is not a valid environment
  renderInvalidDefaultEnvironment: function renderInvalidDefaultEnvironment() {
    // Not available in "Hidden" tab
    if (this.state.isHidden) return null;
    var _state = this.state,
        environments = _state.environments,
        project = _state.project;
    // Default environment that is not a valid environment

    var isAllEnvironmentsDefault = project && project.defaultEnvironment === null;

    var hasOtherDefaultEnvironment = project && environments && !isAllEnvironmentsDefault && !environments.find(function (_ref) {
      var name = _ref.name;
      return name === project.defaultEnvironment;
    });

    if (!hasOtherDefaultEnvironment) return null;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(EnvironmentRow, {
      name: project.defaultEnvironment,
      environment: {
        id: project.defaultEnvironment,
        displayName: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment,
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_23_app_components_tooltip__["default"],
            {
              title: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('This is not an active environment'),
              tooltipOptions: { container: 'body' }
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'span',
              {
                className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])({ marginRight: 8 })
              },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(InvalidDefaultEnvironmentIcon, null)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'code',
            null,
            project.defaultEnvironment
          )
        ),
        name: project.defaultEnvironment
      },
      isSystemRow: true,
      isDefault: true,
      shouldShowSetDefault: false,
      onSetAsDefault: this.handleSetAsDefault
    });
  },
  renderEnvironmentList: function renderEnvironmentList(envs) {
    var _this4 = this;

    var _state2 = this.state,
        project = _state2.project,
        isHidden = _state2.isHidden;

    var buttonText = isHidden ? Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Show') : Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Hide');

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment,
      null,
      this.renderSystemRows(),
      envs.map(function (env) {
        var isDefault = project && env.name === project.defaultEnvironment;
        // Don't show "Set as default" button until project details are loaded
        var shouldShowSetDefault = !isHidden && !isDefault && !!project;
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(EnvironmentRow, {
          key: env.id,
          name: env.name,
          environment: env,
          isDefault: isDefault,
          isHidden: isHidden,
          shouldShowSetDefault: shouldShowSetDefault,
          onSetAsDefault: _this4.handleSetAsDefault,
          onHide: _this4.toggleEnv,
          actionText: buttonText,
          shouldShowAction: true
        });
      }),
      this.renderInvalidDefaultEnvironment()
    );
  },
  render: function render() {
    var _this5 = this;

    var environments = this.state.environments;
    var _props = this.props,
        routes = _props.routes,
        params = _props.params;


    if (environments === null) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_app_components_loadingIndicator__["default"], null);
    }

    var baseUrl = Object(__WEBPACK_IMPORTED_MODULE_24_app_utils_recreateRoute__["a" /* default */])('', { routes: routes, params: params, stepBack: -1 });
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_app_views_settings_components_settingsPageHeader__["default"], {
        title: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Manage Environments'),
        tabs: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'ul',
          { className: 'nav nav-tabs', style: { borderBottom: '1px solid #ddd' } },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_18_app_components_listLink__["default"],
            {
              to: baseUrl + 'environments/',
              index: true,
              isActive: function isActive() {
                return !_this5.state.isHidden;
              }
            },
            Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Environments')
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_18_app_components_listLink__["default"],
            {
              to: baseUrl + 'environments/hidden/',
              index: true,
              isActive: function isActive() {
                return _this5.state.isHidden;
              }
            },
            Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Hidden')
          )
        )
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_app_components_panels__["a" /* Panel */],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12_app_components_panels__["e" /* PanelHeader */],
          null,
          this.state.isHidden ? Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Hidden') : Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Active Environments')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12_app_components_panels__["c" /* PanelBody */],
          null,
          environments.length ? this.renderEnvironmentList(environments) : this.renderEmpty()
        )
      )
    );
  }
});

var EnvironmentRow = (_temp = _class = function (_React$Component) {
  _inherits(EnvironmentRow, _React$Component);

  function EnvironmentRow() {
    _classCallCheck(this, EnvironmentRow);

    return _possibleConstructorReturn(this, (EnvironmentRow.__proto__ || Object.getPrototypeOf(EnvironmentRow)).apply(this, arguments));
  }

  _createClass(EnvironmentRow, [{
    key: 'render',
    value: function render() {
      var _this7 = this;

      var _props2 = this.props,
          environment = _props2.environment,
          shouldShowSetDefault = _props2.shouldShowSetDefault,
          shouldShowAction = _props2.shouldShowAction,
          isSystemRow = _props2.isSystemRow,
          isDefault = _props2.isDefault,
          isHidden = _props2.isHidden,
          actionText = _props2.actionText;


      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_app_components_panels__["f" /* PanelItem */],
        { align: 'center', justify: 'space-between' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Flex"],
          { align: 'center' },
          isSystemRow ? environment.displayName : environment.name,
          isDefault && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_22_app_views_settings_components_tag__["a" /* default */],
            { priority: 'success' },
            Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Default')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          null,
          shouldShowSetDefault && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            EnvironmentButton,
            {
              size: 'xsmall',
              onClick: function onClick() {
                return _this7.props.onSetAsDefault(environment);
              }
            },
            Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Set as default')
          ),
          shouldShowAction && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            EnvironmentButton,
            {
              size: 'xsmall',
              onClick: function onClick() {
                return _this7.props.onHide(environment, !isHidden);
              }
            },
            actionText
          )
        )
      );
    }
  }]);

  return EnvironmentRow;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component), _class.propTypes = {
  environment: __WEBPACK_IMPORTED_MODULE_20_app_proptypes__["e" /* default */].Environment,
  isDefault: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  isHidden: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  isSystemRow: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  shouldShowSetDefault: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  shouldShowAction: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  actionText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  onSetAsDefault: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onHide: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
}, _temp);

var EnvironmentButton = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_6_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_14_app_components_buttons_button__["default"], {
  target: 'ezuela50'
})('margin-left:4px;');

var InvalidDefaultEnvironmentIcon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_6_react_emotion__["default"])(function (props) {
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_app_components_inlineSvg__["a" /* default */], _extends({ src: 'icon-circle-exclamation' }, props));
}, {
  target: 'ezuela51'
})('color:', function (p) {
  return p.theme.error;
}, ';');
/* harmony default export */ __webpack_exports__["a"] = (ProjectEnvironments);

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProjectTags; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_views_asyncView__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_views_settings_components_emptyMessage__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_externalLink__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_linkWithConfirmation__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_views_settings_components_settingsPageHeader__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_views_settings_components_text_textBlock__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_tooltip__ = __webpack_require__(21);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var ProjectTags = function (_AsyncView) {
  _inherits(ProjectTags, _AsyncView);

  function ProjectTags() {
    _classCallCheck(this, ProjectTags);

    return _possibleConstructorReturn(this, (ProjectTags.__proto__ || Object.getPrototypeOf(ProjectTags)).apply(this, arguments));
  }

  _createClass(ProjectTags, [{
    key: 'getEndpoints',
    value: function getEndpoints() {
      var _props$params = this.props.params,
          projectId = _props$params.projectId,
          orgId = _props$params.orgId;

      return [['tags', '/projects/' + orgId + '/' + projectId + '/tags/']];
    }
  }, {
    key: 'onDelete',
    value: function onDelete(key, idx) {
      var _this2 = this;

      var _props$params2 = this.props.params,
          projectId = _props$params2.projectId,
          orgId = _props$params2.orgId;


      this.api.request('/projects/' + orgId + '/' + projectId + '/tags/' + key + '/', {
        method: 'DELETE',
        success: function success() {
          var tags = _this2.state.tags.slice();
          tags.splice(idx, 1);
          _this2.setState({ tags: tags });
        },
        error: function error() {
          _this2.setState({
            error: true,
            loading: false
          });
        }
      });
    }
  }, {
    key: 'renderLink',
    value: function renderLink(key, canDelete, idx) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_app_components_linkWithConfirmation__["a" /* default */],
        {
          className: 'btn btn-sm btn-default',
          title: 'Remove tag?',
          message: 'Are you sure you want to remove this tag?',
          onConfirm: function onConfirm() {
            return _this3.onDelete(key, idx);
          },
          disabled: !canDelete
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon icon-trash' })
      );
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _this4 = this;

      var tags = this.state.tags;

      var isEmpty = !tags || tags.length === 0;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_views_settings_components_settingsPageHeader__["default"], { title: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Tags') }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_app_views_settings_components_text_textBlock__["default"],
          null,
          Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["tct"])('Each event in Sentry may be annotated with various tags (key and value pairs).\n          Learn how to [link:add custom tags].', {
            link: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_externalLink__["a" /* default */], { href: 'https://docs.sentry.io/hosted/learn/context/' })
          })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_app_components_panels__["a" /* Panel */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_app_components_panels__["e" /* PanelHeader */],
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Flex"],
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Box"],
                { flex: '1' },
                Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Tags')
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_app_components_panels__["c" /* PanelBody */],
            null,
            isEmpty && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_app_views_settings_components_emptyMessage__["a" /* default */],
              null,
              Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["tct"])('There are no tags, [link:learn to add tags]', {
                link: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_externalLink__["a" /* default */], { href: 'https://docs.sentry.io/hosted/learn/context/' })
              })
            ),
            !isEmpty && tags.map(function (_ref, idx) {
              var key = _ref.key,
                  canDelete = _ref.canDelete;

              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_app_components_panels__["f" /* PanelItem */],
                { p: 0, align: 'center', key: key, className: 'ref-tag-row' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Box"],
                  { align: 'flex-end', flex: '1', p: 2 },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    null,
                    key
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Flex"],
                  { align: 'center', p: 2 },
                  canDelete ? _this4.renderLink(key, canDelete, idx) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_app_components_tooltip__["default"],
                    { title: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('This tag cannot be deleted.') },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'span',
                      null,
                      _this4.renderLink(key, canDelete, idx)
                    )
                  )
                )
              );
            })
          )
        )
      );
    }
  }]);

  return ProjectTags;
}(__WEBPACK_IMPORTED_MODULE_3_app_views_asyncView__["default"]);



/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_mixins_organizationState__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_utils_theme__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_onboardingWizard_todos__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_views_settings_components_settingsPageHeader__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_components_projectLabel__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_proptypes__ = __webpack_require__(6);





















var ProjectChooser = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'ProjectChooser',

  propTypes: {
    organization: __WEBPACK_IMPORTED_MODULE_16_app_proptypes__["e" /* default */].Organization
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_9_app_mixins_organizationState__["a" /* default */]],

  componentWillMount: function componentWillMount() {
    this.redirectNoMultipleProjects();
  },
  componentWillUnmount: function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_4_jquery___default()(document.body).removeClass('narrow');
  },
  redirectNoMultipleProjects: function redirectNoMultipleProjects() {
    var _this = this;

    var org = this.getOrganization();
    var projects = org.projects;
    var tasks = __WEBPACK_IMPORTED_MODULE_12_app_components_onboardingWizard_todos__["default"].TASKS.filter(function (task_inst) {
      return task_inst.task == _this.props.location.query.task;
    });

    if (projects.length === 0) {
      __WEBPACK_IMPORTED_MODULE_3_react_router__["browserHistory"].push('/organizations/' + org.slug + '/projects/new/');
    } else if (projects.length === 1 && tasks.length === 1) {
      var project = projects[0];
      __WEBPACK_IMPORTED_MODULE_3_react_router__["browserHistory"].push('/' + org.slug + '/' + project.slug + '/' + tasks[0].location);
    }
  },
  render: function render() {
    var _this2 = this;

    var org = this.getOrganization();
    var task = __WEBPACK_IMPORTED_MODULE_12_app_components_onboardingWizard_todos__["default"].TASKS.filter(function (task_inst) {
      return task_inst.task == _this2.props.location.query.task;
    })[0];

    // Expect onboarding=1 and task=<task id> parameters and task.featureLocation == 'project'
    // TODO throw up report dialog if not true
    if (task.featureLocation != 'project') {
      throw new Error('User arrived on project chooser without a valid task id.');
    }
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      {
        className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])({ 'padding-left': '90px', 'padding-top': '30px' }) + ' container'
      },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_app_views_settings_components_settingsPageHeader__["default"], { title: 'Projects' }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13_app_components_panels__["a" /* Panel */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13_app_components_panels__["e" /* PanelHeader */],
          { hasButtons: true },
          Object(__WEBPACK_IMPORTED_MODULE_7_app_locale__["t"])('Projects')
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13_app_components_panels__["c" /* PanelBody */],
          {
            className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])({ width: '100%' })
          },
          Object(__WEBPACK_IMPORTED_MODULE_10_app_utils__["r" /* sortProjects */])(org.projects).map(function (project, i) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_app_components_panels__["f" /* PanelItem */],
              { p: 0, key: project.slug, align: 'center' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_grid_emotion__["Box"],
                { p: 2, flex: '1' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_app_components_link__["a" /* default */],
                  {
                    to: '/' + org.slug + '/' + project.slug + '/' + task.location,
                    className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])({ color: __WEBPACK_IMPORTED_MODULE_11_app_utils_theme__["default"].gray3 })
                  },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledProjectLabel, {
                    project: project,
                    organization: _this2.props.organization
                  })
                )
              )
            );
          })
        )
      )
    );
  }
});

var StyledProjectLabel = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_6_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_15_app_components_projectLabel__["a" /* default */], {
  target: 'e1ebxjux0'
})('color:', function (p) {
  return p.theme.blue;
}, ';');

/* harmony default export */ __webpack_exports__["a"] = (ProjectChooser);

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_views_projectDashboard_eventList__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_mixins_projectState__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_views_projectDashboard_chart__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_utils_withEnvironmentInQueryString__ = __webpack_require__(69);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













var PERIOD_HOUR = '1h';
var PERIOD_DAY = '1d';
var PERIOD_WEEK = '1w';
var PERIODS = new Set([PERIOD_HOUR, PERIOD_DAY, PERIOD_WEEK]);

var ProjectDashboard = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'ProjectDashboard',

  propTypes: {
    defaultStatsPeriod: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    setProjectNavSection: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    environment: __WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Environment
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6_app_mixins_projectState__["a" /* default */]],

  getDefaultProps: function getDefaultProps() {
    return {
      defaultStatsPeriod: PERIOD_DAY
    };
  },
  getInitialState: function getInitialState() {
    return _extends({
      statsPeriod: this.props.defaultStatsPeriod
    }, this.getQueryStringState());
  },
  componentWillMount: function componentWillMount() {
    this.props.setProjectNavSection('dashboard');
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    this.setState(this.getQueryStringState(nextProps));
  },
  getQueryStringState: function getQueryStringState(props) {
    props = props || this.props;
    var currentQuery = props.location.query;
    var statsPeriod = currentQuery.statsPeriod;

    if (!PERIODS.has(statsPeriod)) {
      statsPeriod = props.defaultStatsPeriod;
    }

    return {
      statsPeriod: statsPeriod
    };
  },
  getStatsPeriodBeginTimestamp: function getStatsPeriodBeginTimestamp(statsPeriod) {
    var now = new Date().getTime() / 1000;
    switch (statsPeriod) {
      case PERIOD_WEEK:
        return now - 3600 * 24 * 7;
      case PERIOD_HOUR:
        return now - 3600;
      case PERIOD_DAY:
      default:
        return now - 3600 * 24;
    }
  },
  getStatsPeriodResolution: function getStatsPeriodResolution(statsPeriod) {
    switch (statsPeriod) {
      case PERIOD_WEEK:
        return '1h';
      case PERIOD_HOUR:
        return '10s';
      case PERIOD_DAY:
      default:
        return '1h';
    }
  },
  render: function render() {
    var statsPeriod = this.state.statsPeriod;

    var dateSince = this.getStatsPeriodBeginTimestamp(statsPeriod);
    var resolution = this.getStatsPeriodResolution(statsPeriod);
    var _props$params = this.props.params,
        orgId = _props$params.orgId,
        projectId = _props$params.projectId;

    var url = '/' + orgId + '/' + projectId + '/dashboard/';
    var routeQuery = this.props.location.query;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'pull-right' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'btn-group' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router__["Link"],
              {
                to: {
                  pathname: url,
                  query: _extends({}, routeQuery, { statsPeriod: PERIOD_HOUR })
                },
                className: 'btn btn-sm btn-default' + (statsPeriod === PERIOD_HOUR ? ' active' : '')
              },
              Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('1 hour')
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router__["Link"],
              {
                to: {
                  pathname: url,
                  query: _extends({}, routeQuery, { statsPeriod: PERIOD_DAY })
                },
                className: 'btn btn-sm btn-default' + (statsPeriod === PERIOD_DAY ? ' active' : '')
              },
              Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('1 day')
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router__["Link"],
              {
                to: {
                  pathname: url,
                  query: _extends({}, routeQuery, { statsPeriod: PERIOD_WEEK })
                },
                className: 'btn btn-sm btn-default' + (statsPeriod === PERIOD_WEEK ? ' active' : '')
              },
              Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('1 week')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('Overview')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_views_projectDashboard_chart__["a" /* default */], {
        dateSince: dateSince,
        resolution: resolution,
        environment: this.props.environment
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'col-md-6' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_views_projectDashboard_eventList__["a" /* default */], {
            type: 'priority',
            environment: this.props.environment,
            dateSince: dateSince,
            params: this.props.params
          })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'col-md-6' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_views_projectDashboard_eventList__["a" /* default */], {
            type: 'new',
            environment: this.props.environment,
            dateSince: dateSince,
            params: this.props.params
          })
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_app_utils_withEnvironmentInQueryString__["a" /* default */])(ProjectDashboard));

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_views_projectDashboard_eventNode__ = __webpack_require__(1244);













var EventList = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'EventList',

  propTypes: {
    type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['new', 'priority']).isRequired,
    environment: __WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Environment,
    dateSince: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    return {
      groupList: [],
      loading: true,
      error: false,
      statsPeriod: '24h'
    };
  },
  componentWillMount: function componentWillMount() {
    this.fetchData();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.environment !== this.props.environment) {
      this.setState({
        loading: true,
        error: false
      }, this.fetchData);
    }
  },
  getEndpoint: function getEndpoint() {
    var _props = this.props,
        params = _props.params,
        type = _props.type,
        environment = _props.environment;


    var qs = {
      sort: type,
      query: 'is:unresolved',
      since: this.props.dateSince
    };

    if (environment) {
      qs.environment = environment.name;
      qs.query = qs.query + ' environment:' + environment.name;
    }

    return '/projects/' + params.orgId + '/' + params.projectId + '/issues/?' + __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.param(qs);
  },
  getMinutes: function getMinutes() {
    switch (this.state.statsPeriod) {
      case '15m':
        return '15';
      case '60m':
        return '60';
      case '24h':
      default:
        return '1440';
    }
  },
  fetchData: function fetchData() {
    var _this = this;

    var endpoint = this.getEndpoint();
    var minutes = this.getMinutes();

    this.api.request(endpoint, {
      query: {
        limit: 5,
        minutes: minutes
      },
      success: function success(data) {
        _this.setState({
          groupList: data,
          loading: false,
          error: false
        });
      },
      error: function error() {
        _this.setState({
          loading: false,
          error: true
        });
      }
    });
  },
  onSelectStatsPeriod: function onSelectStatsPeriod(period) {
    this.setState({
      statsPeriod: period
    });
  },
  render: function render() {
    var eventNodes = this.state.groupList.map(function (item) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_views_projectDashboard_eventNode__["a" /* default */], { group: item, key: item.id });
    });

    var environment = this.props.environment;


    var emptyStateMessage = environment ? Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["tct"])('No data available in the [env] environment.', {
      env: environment.displayName
    }) : Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('No data available.');

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_app_components_panels__["a" /* Panel */],
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_app_components_panels__["e" /* PanelHeader */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'row', style: { flex: 1 } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'col-xs-8' },
            this.props.type === 'new' ? Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('New issues') : Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('Trending issues')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'col-xs-2 align-right' },
            Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('Events')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'col-xs-2 align-right' },
            Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('Users')
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_app_components_panels__["c" /* PanelBody */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'tab-pane active' },
          this.state.loading ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_loadingIndicator__["default"], null) : this.state.error ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_loadingError__["default"], { onRetry: this.fetchData }) : eventNodes.length ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'ul',
            { className: 'group-list group-list-small' },
            eventNodes
          ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'group-list-empty' },
            emptyStateMessage
          )
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (EventList);

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_count__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_eventOrGroupExtraDetails__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_eventOrGroupHeader__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_mixins_projectState__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_proptypes__ = __webpack_require__(6);










var EventNode = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'EventNode',

  propTypes: {
    group: __WEBPACK_IMPORTED_MODULE_6_app_proptypes__["e" /* default */].Group.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5_app_mixins_projectState__["a" /* default */]],

  render: function render() {
    var group = this.props.group;
    var userCount = group.userCount;
    var org = this.getOrganization();

    var orgId = org.slug;
    var projectId = group.project.slug;
    var groupId = group.id;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'li',
      { className: 'group row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-xs-8 event-details' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_eventOrGroupHeader__["a" /* default */], {
          orgId: orgId,
          projectId: projectId,
          data: group,
          hideIcons: true,
          hideLevel: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_eventOrGroupExtraDetails__["a" /* default */], {
          orgId: orgId,
          projectId: projectId,
          groupId: groupId,
          lastSeen: group.lastSeen,
          firstSeen: group.firstSeen
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-xs-2 event-count align-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_count__["default"], { value: group.count })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-xs-2 event-users align-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_count__["default"], { value: userCount })
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (EventNode);

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_barChart__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_dynamicWrapper__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_mixins_projectState__ = __webpack_require__(41);












var ProjectChart = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'ProjectChart',

  propTypes: {
    dateSince: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
    resolution: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    environment: __WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Environment
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_10_app_mixins_projectState__["a" /* default */]],

  getInitialState: function getInitialState() {
    return {
      loading: true,
      error: false,
      stats: [],
      releaseList: [],
      environment: this.props.environment
    };
  },
  componentWillMount: function componentWillMount() {
    this.fetchData();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.environment !== this.props.environment || nextProps.resolution !== this.props.resolution || nextProps.dateSince !== this.props.dateSince) {
      this.setState({
        environment: nextProps.environment,
        loading: true,
        error: false
      }, this.fetchData);
    }
  },
  getStatsEndpoint: function getStatsEndpoint() {
    var org = this.getOrganization();
    var project = this.getProject();
    return '/projects/' + org.slug + '/' + project.slug + '/stats/';
  },
  getProjectReleasesEndpoint: function getProjectReleasesEndpoint() {
    var org = this.getOrganization();
    var project = this.getProject();
    return '/projects/' + org.slug + '/' + project.slug + '/releases/';
  },
  fetchData: function fetchData() {
    var _this = this;

    var statsQuery = {
      since: this.props.dateSince,
      resolution: this.props.resolution,
      stat: 'generated'
    };

    var releasesQuery = {};

    if (this.state.environment) {
      statsQuery.environment = this.state.environment.name;
      releasesQuery.environment = this.state.environment.name;
    }
    this.api.request(this.getStatsEndpoint(), {
      query: statsQuery,
      success: function success(data) {
        _this.setState({
          stats: data,
          error: false,
          loading: false
        });
      },
      error: function error() {
        _this.setState({
          error: true,
          loading: false
        });
      }
    });

    this.api.request(this.getProjectReleasesEndpoint(), {
      query: releasesQuery,
      success: function success(data, _, jqXHR) {
        _this.setState({
          releaseList: data
        });
      }
    });
  },
  renderChart: function renderChart() {
    var points = this.state.stats.map(function (point) {
      return { x: point[0], y: point[1] };
    });
    var startX = this.props.dateSince;
    var markers = this.state.releaseList.filter(function (release) {
      var date = new Date(release.dateCreated).getTime() / 1000;
      return date >= startX;
    }).map(function (release) {
      return {
        label: 'Version ' + release.shortVersion,
        x: new Date(release.dateCreated).getTime() / 1000
      };
    });

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'chart-wrapper' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_barChart__["default"], {
        points: points,
        markers: markers,
        label: 'events',
        height: 150,
        className: 'standard-barchart'
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'small',
        { className: 'date-legend' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_dynamicWrapper__["default"], {
          fixed: 'Test Date 1, 2000',
          value: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.props.dateSince * 1000).format('LL')
        })
      )
    );
  },
  render: function render() {
    return this.state.loading ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_loadingIndicator__["default"], null) : this.state.error ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_loadingError__["default"], { onRetry: this.fetchData }) : this.renderChart();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ProjectChart);

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_externalLink__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_stores_hookStore__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_pluginList__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_mixins_projectState__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_views_settings_components_settingsPageHeader__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_stackedBarChart__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_views_settings_components_text_textBlock__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_emptyStateWarning__ = __webpack_require__(57);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


















var DataForwardingStats = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'DataForwardingStats',
  mixins: [__WEBPACK_IMPORTED_MODULE_3_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    var until = Math.floor(new Date().getTime() / 1000);
    var since = until - 3600 * 24 * 30;

    return {
      since: since,
      until: until,
      loading: true,
      error: false,
      stats: null,
      emptyStats: false
    };
  },
  componentWillMount: function componentWillMount() {
    this.fetchData();
  },
  fetchData: function fetchData() {
    var _this = this;

    var _props$params = this.props.params,
        orgId = _props$params.orgId,
        projectId = _props$params.projectId;

    this.api.request('/projects/' + orgId + '/' + projectId + '/stats/', {
      query: {
        since: this.state.since,
        until: this.state.until,
        resolution: '1d',
        stat: 'forwarded'
      },
      success: function success(data) {
        var emptyStats = true;
        var stats = data.map(function (p) {
          if (p[0]) emptyStats = false;
          return { x: p[0], y: [p[1]] };
        });
        _this.setState({
          stats: stats,
          emptyStats: emptyStats,
          error: false,
          loading: false
        });
      },
      error: function error() {
        _this.setState({ error: true, loading: false });
      }
    });
  },
  render: function render() {
    if (this.state.loading) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'box' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_loadingIndicator__["default"], null)
    );else if (this.state.error) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_loadingError__["default"], { onRetry: this.fetchData });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_app_components_panels__["a" /* Panel */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_app_components_panels__["e" /* PanelHeader */],
        null,
        Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Forwarded events in the last 30 days (by day)')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_app_components_panels__["c" /* PanelBody */],
        null,
        !this.state.emptyStats ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_stackedBarChart__["default"], {
          style: {
            border: 'none'
          },
          points: this.state.stats,
          height: 150,
          label: 'events',
          barClasses: ['accepted'],
          className: 'standard-barchart'
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'blankslate p-y-2' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h5',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Nothing forwarded in the last 30 days.')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'm-b-0' },
            Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Total events forwarded to third party integrations.')
          )
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'projectDataForwarding',
  mixins: [__WEBPACK_IMPORTED_MODULE_3_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_10_app_mixins_projectState__["a" /* default */]],

  getInitialState: function getInitialState() {
    return {
      loading: true,
      error: false,
      pluginList: [],
      hooksDisabled: __WEBPACK_IMPORTED_MODULE_5_app_stores_hookStore__["default"].get('project:data-forwarding:disabled')
    };
  },
  componentDidMount: function componentDidMount() {
    this.fetchData();
  },
  fetchData: function fetchData() {
    var _this2 = this;

    var _props$params2 = this.props.params,
        orgId = _props$params2.orgId,
        projectId = _props$params2.projectId;

    this.api.request('/projects/' + orgId + '/' + projectId + '/plugins/', {
      success: function success(data, _, jqXHR) {
        _this2.setState({
          error: false,
          loading: false,
          pluginList: data.filter(function (p) {
            return p.type === 'data-forwarding' && p.hasConfiguration;
          })
        });
      },
      error: function error() {
        _this2.setState({
          error: true,
          loading: false
        });
      }
    });
  },
  onEnablePlugin: function onEnablePlugin(plugin) {
    this.setState({
      pluginList: this.state.pluginList.map(function (p) {
        if (p.id !== plugin.id) return p;
        return _extends({}, plugin, {
          enabled: true
        });
      })
    });
  },
  onDisablePlugin: function onDisablePlugin(plugin) {
    this.setState({
      pluginList: this.state.pluginList.map(function (p) {
        if (p.id !== plugin.id) return p;
        return _extends({}, plugin, {
          enabled: false
        });
      })
    });
  },
  renderBody: function renderBody() {
    if (this.state.loading) return this.renderLoading();else if (this.state.error) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_loadingError__["default"], { onRetry: this.fetchData });

    var organization = this.getOrganization();
    var project = this.getProject();
    var pluginList = this.state.pluginList;

    var features = this.getProjectFeatures();

    if (!features.has('data-forwarding')) {
      return this.state.hooksDisabled.map(function (hook) {
        return hook(organization, project);
      }).shift() || this.renderEmpty();
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_pluginList__["a" /* default */], {
      organization: organization,
      project: project,
      pluginList: pluginList,
      onEnablePlugin: this.onEnablePlugin,
      onDisablePlugin: this.onDisablePlugin
    });
  },
  renderLoading: function renderLoading() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'box' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_loadingIndicator__["default"], null)
    );
  },
  renderEmpty: function renderEmpty() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_app_components_panels__["a" /* Panel */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_14_app_components_emptyStateWarning__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('There are no integrations available for data forwarding.')
        )
      )
    );
  },
  render: function render() {
    var params = this.props.params;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'ref-data-forwarding-settings' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_views_settings_components_settingsPageHeader__["default"], { title: Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Data Forwarding') }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13_app_views_settings_components_text_textBlock__["default"],
        null,
        Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])("Enable Data Forwarding to send processed events to your favorite business intelligence tools. The exact payload and types of data depend on the integration you're using.")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13_app_views_settings_components_text_textBlock__["default"],
        null,
        Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["tct"])('Learn more about this functionality in our [link:documentation].', {
          link: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_externalLink__["a" /* default */], { href: 'https://docs.sentry.io/learn/data-forwarding/' })
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13_app_views_settings_components_text_textBlock__["default"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'small',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["tct"])('Note: Sentry will forward [em:all applicable events] to the\n              given provider, which in some situations may be a much more significant\n              volume of data.', {
            em: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null)
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DataForwardingStats, { params: params }),
      this.renderBody()
    );
  }
}));

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_plugins_components_pluginIcon__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_textOverflow__ = __webpack_require__(124);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var IntegrationButton = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('button', {
  target: 'e1vi82zr0'
})('width:175px;text-align:center;font-size:12px;color:#889ab0;letter-spacing:0.1px;font-weight:600;text-transform:uppercase;border:1px solid #eee;background:inherit;border-radius:4px;padding:10px;&:hover{border-color:#ccc;}');

var InactivePlugins = (_temp2 = _class = function (_React$Component) {
  _inherits(InactivePlugins, _React$Component);

  function InactivePlugins() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InactivePlugins);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InactivePlugins.__proto__ || Object.getPrototypeOf(InactivePlugins)).call.apply(_ref, [this].concat(args))), _this), _this.enablePlugin = function (plugin) {
      return _this.props.onEnablePlugin(plugin, true);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InactivePlugins, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var plugins = this.props.plugins;
      if (plugins.length === 0) return null;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_app_components_panels__["a" /* Panel */],
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_app_components_panels__["e" /* PanelHeader */],
          null,
          Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Inactive Integrations')
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_app_components_panels__["c" /* PanelBody */],
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Flex"],
            { p: 1, flex: '1', wrap: 'wrap' },
            plugins.map(function (plugin) {
              return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Box"],
                { m: 1, key: plugin.id },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  IntegrationButton,
                  {
                    onClick: _this2.enablePlugin.bind(_this2, plugin),
                    className: 'ref-plugin-enable-' + plugin.id
                  },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Flex"],
                    { justify: 'center', align: 'center' },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Flex"],
                      { align: 'center', mr: 1 },
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_plugins_components_pluginIcon__["a" /* default */], { pluginId: plugin.id })
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_7_app_components_textOverflow__["a" /* default */],
                      null,
                      plugin.shortName || plugin.name
                    )
                  )
                )
              );
            })
          )
        )
      );
    }
  }]);

  return InactivePlugins;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  plugins: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  onEnablePlugin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (InactivePlugins);

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "integration-default.png";

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "integration-sentry.png";

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asana-logo.png";

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bitbucket-logo.png";

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "campfire-logo.png";

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "clubhouse-logo.png";

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "flowdock-logo.png";

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "github-logo.png";

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gitlab-logo.png";

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "heroku-logo.png";

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "hipchat-logo.png";

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "jira-logo.png";

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lighthouse-logo.png";

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "opsgenie-logo.png";

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pagerduty-logo.png";

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "phabricator-logo.png";

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pivotaltracker-logo.png";

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pushover-logo.png";

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "redmine-logo.png";

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "slack-logo.png";

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "taiga-logo.png";

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "teamwork-logo.png";

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "trello-logo.png";

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "twilio-logo.png";

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "vsts-logo.svg";

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "youtrack-logo.png";

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_lib_Modal__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_dateTime__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_emptyStateWarning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_fileSize__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_mixins_organizationState__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_views_settings_components_settingsPageHeader__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_views_settings_components_text_textBlock__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_components_timeSince__ = __webpack_require__(45);



















var marginBottomStyle = { marginBottom: 40 };

var LastSeen = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Flex"], {
  target: 'emphg7t0'
})('font-size:12px;color:', function (p) {
  return p.theme.purple2;
}, ';');

var TimeIcon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('span', {
  target: 'emphg7t1'
})('margin-right:4px;');

var HoverablePanelItem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_5_app_components_panels__["f" /* PanelItem */], {
  target: 'emphg7t2'
})('cursor:pointer;transition:all 0s ease-in-out;&:hover{background-color:', function (p) {
  return p.theme.whiteDark;
}, ';}');

var ProjectDebugSymbols = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'ProjectDebugSymbols',
  mixins: [__WEBPACK_IMPORTED_MODULE_7_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_13_app_mixins_organizationState__["a" /* default */]],

  getInitialState: function getInitialState() {
    return {
      loading: true,
      error: false,
      showModal: false,
      debugSymbols: [],
      unreferencedDebugSymbols: [],
      apps: [],
      activeAppID: null,
      activeVersion: null,
      activeBuilds: null,
      activeBuild: null,
      activeDsyms: null
    };
  },
  componentDidMount: function componentDidMount() {
    this.fetchData();
  },
  fetchData: function fetchData() {
    var _this = this;

    var _props$params = this.props.params,
        orgId = _props$params.orgId,
        projectId = _props$params.projectId;

    this.api.request('/projects/' + orgId + '/' + projectId + '/files/dsyms/', {
      success: function success(data, _, jqXHR) {
        _this.setState({
          error: false,
          loading: false,
          debugSymbols: data.debugSymbols,
          unreferencedDebugSymbols: data.unreferencedDebugSymbols,
          apps: data.apps,
          pageLinks: jqXHR.getResponseHeader('Link')
        });
      },
      error: function error() {
        _this.setState({
          error: true,
          loading: false
        });
      }
    });
  },
  setActive: function setActive(appID, version, builds) {
    this.setState({
      activeAppID: appID,
      activeVersion: version,
      activeBuilds: builds
    });
  },
  openModal: function openModal(build, dsyms) {
    this.setState({
      showModal: true,
      activeBuild: build,
      activeDsyms: dsyms
    });
  },
  closeModal: function closeModal() {
    this.setState({
      showModal: false
    });
  },
  renderDebugTable: function renderDebugTable() {
    var body = void 0;

    if (this.state.loading) {
      body = this.renderLoading();
    } else if (this.state.error) {
      body = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_loadingError__["default"], { onRetry: this.fetchData });
    } else if (this.state.debugSymbols.length > 0) {
      body = this.renderResults();
    } else {
      body = this.renderEmpty();
    }

    return body;
  },
  renderLoading: function renderLoading() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_app_components_panels__["a" /* Panel */],
      null,
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_loadingIndicator__["default"], null)
    );
  },
  renderEmpty: function renderEmpty() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_app_components_panels__["a" /* Panel */],
      null,
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_app_components_emptyStateWarning__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'p',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('There are no debug symbols for this project.')
        )
      )
    );
  },
  mapObject: function mapObject(object, callback) {
    if (object === undefined) {
      return [];
    }
    return Object.keys(object).map(function (key) {
      return callback(object[key], key);
    });
  },
  renderResults: function renderResults() {
    var _this2 = this;

    var groupedDsyms = [];
    this.state.debugSymbols.map(function (dsym, idx) {
      if (groupedDsyms[dsym.dsymAppId] === undefined) {
        groupedDsyms[dsym.dsymAppId] = [];
      }
      if (groupedDsyms[dsym.dsymAppId][dsym.version] === undefined) {
        groupedDsyms[dsym.dsymAppId][dsym.version] = [];
      }
      if (groupedDsyms[dsym.dsymAppId][dsym.version][dsym.build] === undefined) {
        groupedDsyms[dsym.dsymAppId][dsym.version][dsym.build] = [];
      }
      groupedDsyms[dsym.dsymAppId][dsym.version][dsym.build].push(dsym);
    });

    var indexedApps = [];
    if (this.state.apps) {
      this.state.apps.map(function (app, idx) {
        indexedApps[app.id] = app;
      });
    }

    return indexedApps.map(function (app) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_app_components_panels__["a" /* Panel */],
        { style: marginBottomStyle, key: app.id },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_app_components_panels__["e" /* PanelHeader */],
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', {
              className: 'app-icon',
              style: app.iconUrl && { backgroundImage: 'url(' + app.iconUrl + ')' }
            }),
            app.name
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'small',
            null,
            '(',
            app.appId,
            ')'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_app_components_panels__["c" /* PanelBody */],
          null,
          _this2.mapObject(groupedDsyms[app.id], function (builds, version) {
            var symbolsInVersion = 0;
            var lastSeen = null;
            _this2.mapObject(groupedDsyms[app.id][version], function (dsyms, build) {
              symbolsInVersion += Object.keys(dsyms).length;
              if (lastSeen === null || lastSeen && new Date(dsyms[0].dateAdded).getTime() > new Date(lastSeen).getTime()) {
                lastSeen = dsyms[0].dateAdded;
              }
            });
            var row = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              HoverablePanelItem,
              {
                className: 'hoverable',
                onClick: function onClick() {
                  return _this2.setActive(app.id, version, builds);
                }
              },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Flex"],
                { flex: '1', direction: 'column' },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'h3',
                  { className: 'truncate' },
                  version
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  BuildLabel,
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Builds'),
                  ': ',
                  Object.keys(builds).length
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  LastSeen,
                  { align: 'center' },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TimeIcon, { className: 'icon icon-clock' }),
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_app_components_timeSince__["default"], { date: lastSeen })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Box"],
                null,
                Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Debug Information Files'),
                ': ',
                symbolsInVersion
              )
            );

            var buildPanelItems = '';
            if (_this2.state.activeVersion && _this2.state.activeBuilds && _this2.state.activeVersion == version && _this2.state.activeAppID == app.id) {
              buildPanelItems = _this2.renderBuilds(version, _this2.state.activeBuilds);
            }
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_app_components_panels__["f" /* PanelItem */],
              { direction: 'column', key: version },
              row,
              buildPanelItems
            );
          })
        )
      );
    });
  },
  renderBuilds: function renderBuilds(version, builds) {
    var _this3 = this;

    var buildPanelItems = [];
    var dateAdded = null;
    this.mapObject(builds, function (dsyms, build) {
      if (dateAdded === null || dateAdded && new Date(dsyms[0].dateAdded).getTime() > new Date(dateAdded).getTime()) {
        dateAdded = dsyms[0].dateAdded;
      }
    });
    this.mapObject(builds, function (dsyms, build) {
      buildPanelItems.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        HoverablePanelItem,
        { key: build, onClick: function onClick() {
            return _this3.openModal(build, dsyms);
          } },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Flex"],
          { flex: '1', direction: 'column' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            BuildLabel,
            null,
            build
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            LastSeen,
            { align: 'center' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TimeIcon, { className: 'icon icon-clock' }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_app_components_timeSince__["default"], { date: dateAdded })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Box"],
          null,
          Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Debug Information Files'),
          ': ',
          dsyms.length
        )
      ));
    });
    return buildPanelItems;
  },
  renderDsyms: function renderDsyms(dsyms, raw) {
    var _this4 = this;

    if (dsyms === null) {
      return null;
    }

    var moreSymbolsHidden = null;
    if (raw && dsyms.length >= 100) {
      moreSymbolsHidden = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'tr',
        { className: 'text-center', key: 'empty-row' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'td',
          { colSpan: '6' },
          Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('There are more symbols than are shown here.')
        )
      );
    }

    var _props$params2 = this.props.params,
        orgId = _props$params2.orgId,
        projectId = _props$params2.projectId;

    var access = this.getAccess();

    var rows = dsyms.map(function (dsymFile, key) {
      var dsym = raw ? dsymFile : dsymFile.dsym;
      if (dsym === undefined || dsym === null) {
        return null;
      }
      var url = _this4.api.baseUrl + '/projects/' + orgId + '/' + projectId + '/files/dsyms/?download_id=' + dsym.id;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'tr',
        { key: key },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'code',
            { className: 'small' },
            dsym.debugId || dsym.uuid
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'td',
          null,
          dsym.symbolType === 'proguard' && dsym.objectName === 'proguard-mapping' ? '-' : dsym.objectName
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'td',
          null,
          dsym.symbolType === 'proguard' && dsym.cpuName === 'any' ? 'proguard' : dsym.cpuName + ' (' + dsym.symbolType + ')'
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_dateTime__["default"], { date: dsym.dateCreated })
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_fileSize__["a" /* default */], { bytes: dsym.size })
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'td',
          null,
          access.has('project:write') ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'a',
            { href: url, className: 'btn btn-sm btn-default' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon icon-open' })
          ) : null
        )
      );
    });

    rows.push(moreSymbolsHidden);
    return rows;
  },
  renderUnreferencedDebugSymbols: function renderUnreferencedDebugSymbols() {
    if (this.state.loading) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_app_views_settings_components_settingsPageHeader__["default"], { title: Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Unreferenced Debug Information Files') }),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_15_app_views_settings_components_text_textBlock__["default"],
        null,
        Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('\n          This list represents all Debug Information Files which are not assigned to an\n          app version. We will still find these debug symbols for symbolication\n          but we can\'t tell you which versions they belong to.  This happens\n          if you upload them with an old verison of sentry-cli or if sentry-cli\n          can\'t locate the Info.plist file at the time of upload.\n        ')
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'table',
        { className: 'table' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'thead',
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'tr',
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'th',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Debug ID')
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'th',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Object')
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'th',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Type')
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'th',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Uploaded')
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'th',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Size')
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'tbody',
          null,
          this.renderDsyms(this.state.unreferencedDebugSymbols, true)
        )
      )
    );
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_app_views_settings_components_settingsPageHeader__["default"], { title: Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Debug Information Files') }),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_15_app_views_settings_components_text_textBlock__["default"],
        null,
        Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('\n          Here you can find uploaded debug information (for instance debug\n          symbol files or proguard mappings).  This is used to convert\n          addresses and minified function names from crash dumps\n          into function names and locations.  For JavaScript debug support\n          look at releases instead.\n        ')
      ),
      this.renderDebugTable(),
      this.renderUnreferencedDebugSymbols(),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_lib_Modal___default.a,
        {
          show: this.state.showModal,
          onHide: this.closeModal,
          animation: false,
          backdrop: 'static',
          enforceFocus: false,
          bsSize: 'lg'
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_lib_Modal___default.a.Header,
          { closeButton: true },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_lib_Modal___default.a.Title,
            null,
            this.state.activeVersion,
            ' (',
            this.state.activeBuild,
            ')'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_lib_Modal___default.a.Body,
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'table',
            { className: 'table' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'th',
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Debug ID')
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'th',
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Object')
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'th',
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Type')
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'th',
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Uploaded')
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'th',
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Size')
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'tbody',
              null,
              this.renderDsyms(this.state.activeDsyms)
            )
          )
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ProjectDebugSymbols);

var BuildLabel = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('div', {
  target: 'emphg7t3'
})('margin-bottom:4px;');

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_views_projects_projectContext__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_views_projectDetailsLayout__ = __webpack_require__(1276);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ProjectDetails = function (_React$Component) {
  _inherits(ProjectDetails, _React$Component);

  function ProjectDetails() {
    _classCallCheck(this, ProjectDetails);

    return _possibleConstructorReturn(this, (ProjectDetails.__proto__ || Object.getPrototypeOf(ProjectDetails)).apply(this, arguments));
  }

  _createClass(ProjectDetails, [{
    key: 'render',
    value: function render() {
      var _props$params = this.props.params,
          projectId = _props$params.projectId,
          orgId = _props$params.orgId;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_app_views_projects_projectContext__["a" /* default */],
        { orgId: orgId, projectId: projectId },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_app_views_projectDetailsLayout__["a" /* default */],
          null,
          this.props.children
        )
      );
    }
  }]);

  return ProjectDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ProjectDetails);

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProjectDetailsLayout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_actionCreators_navigation__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_stores_environmentStore__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_projectHeader__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_mixins_projectState__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_utils_withEnvironment__ = __webpack_require__(158);












var ProjectDetailsLayout = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'ProjectDetailsLayout',

  propTypes: {
    environment: __WEBPACK_IMPORTED_MODULE_5_app_proptypes__["e" /* default */].Environment
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8_app_mixins_projectState__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_reflux___default.a.connect(__WEBPACK_IMPORTED_MODULE_6_app_stores_environmentStore__["a" /* default */], 'environments')],

  getInitialState: function getInitialState() {
    return {
      environments: __WEBPACK_IMPORTED_MODULE_6_app_stores_environmentStore__["a" /* default */].getActive() || [],
      projectNavSection: null
    };
  },
  componentWillUnmount: function componentWillUnmount() {
    // Save last route so that we can jump back to view from settings
    Object(__WEBPACK_IMPORTED_MODULE_4_app_actionCreators_navigation__["b" /* setLastRoute */])(this.props.location.pathname);
  },


  /**
   * This callback can be invoked by the child component
   * to update the active nav section (which is then passed
   * to the ProjectHeader
   */
  setProjectNavSection: function setProjectNavSection(section) {
    this.setState({
      projectNavSection: section
    });
  },
  render: function render() {
    if (!this.context.project) return null;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_projectHeader__["a" /* default */], {
        activeSection: this.state.projectNavSection,
        project: this.context.project,
        organization: this.getOrganization(),
        environments: this.state.environments,
        activeEnvironment: this.props.environment
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(this.props.children, {
            setProjectNavSection: this.setProjectNavSection,
            memberList: this.state.memberList
          })
        )
      )
    );
  }
});


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["withRouter"])(Object(__WEBPACK_IMPORTED_MODULE_9_app_utils_withEnvironment__["a" /* default */])(ProjectDetailsLayout)));

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_projectLink__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_projectHeader_projectSelector__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_projects_bookmarkToggle__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_dropdownLink__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_menuItem__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_actionCreators_environments__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__backfillNotice__ = __webpack_require__(1279);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var ProjectHeader = (_temp = _class = function (_React$Component) {
  _inherits(ProjectHeader, _React$Component);

  function ProjectHeader() {
    _classCallCheck(this, ProjectHeader);

    return _possibleConstructorReturn(this, (ProjectHeader.__proto__ || Object.getPrototypeOf(ProjectHeader)).apply(this, arguments));
  }

  _createClass(ProjectHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          project = _props.project,
          environments = _props.environments,
          activeEnvironment = _props.activeEnvironment;

      var navSection = this.props.activeSection;
      var org = this.props.organization;
      var features = new Set(project.features);
      var access = new Set(org.access);
      var orgFeatures = new Set(org.features);
      var allEnvironmentsLabel = Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('All environments');

      // TODO: remove when feature is released
      var hasEnvironmentsFeature = orgFeatures.has('environments');
      var pagesWithEnvironments = new Set(['stream', 'releases', 'dashboard', 'events', 'user-feedback']);
      var pageHasEnvironments = pagesWithEnvironments.has(navSection);
      var showEnvironmentsToggle = hasEnvironmentsFeature && pageHasEnvironments;

      var activeEnvironmentTitle = activeEnvironment ? activeEnvironment.displayName : allEnvironmentsLabel;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'sub-header flex flex-container flex-vertically-centered' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'project-header' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'project-header-main' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'project-select-wrapper' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_projectHeader_projectSelector__["default"], { organization: org, projectId: project.slug }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_projects_bookmarkToggle__["a" /* default */], null)
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'ul',
              { className: 'nav nav-tabs' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'li',
                { className: navSection == 'stream' ? 'active' : '' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_app_components_projectLink__["a" /* default */],
                  { to: '/' + org.slug + '/' + project.slug + '/' },
                  Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Issues')
                )
              ),
              features.has('global-events') && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'li',
                { className: navSection == 'events' ? 'active' : '' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_app_components_projectLink__["a" /* default */],
                  { to: '/' + org.slug + '/' + project.slug + '/events/' },
                  Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Events')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'li',
                { className: navSection == 'dashboard' ? 'active' : '' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_app_components_projectLink__["a" /* default */],
                  { to: '/' + org.slug + '/' + project.slug + '/dashboard/' },
                  Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Overview')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'li',
                { className: navSection == 'user-feedback' ? 'active' : '' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_app_components_projectLink__["a" /* default */],
                  { to: '/' + org.slug + '/' + project.slug + '/user-feedback/' },
                  Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('User Feedback')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'li',
                { className: navSection == 'releases' ? 'active' : '' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_app_components_projectLink__["a" /* default */],
                  { to: '/' + org.slug + '/' + project.slug + '/releases/' },
                  Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Releases')
                )
              ),
              access.has('project:write') && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'li',
                { className: navSection == 'settings' ? 'active' : '' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                  {
                    to: orgFeatures.has('new-settings') ? '/settings/' + org.slug + '/' + project.slug + '/' : '/' + org.slug + '/' + project.slug + '/settings/'
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Settings')
                )
              )
            )
          ),
          showEnvironmentsToggle && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            EnvironmentsToggle,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__backfillNotice__["a" /* default */], { project: project }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'project-header-toggle' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'label',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Environment')
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_app_components_dropdownLink__["default"],
                {
                  anchorRight: true,
                  title: activeEnvironmentTitle,
                  className: 'environment-selector-toggle'
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9_app_components_menuItem__["default"],
                  {
                    onClick: __WEBPACK_IMPORTED_MODULE_12_app_actionCreators_environments__["a" /* clearActiveEnvironment */],
                    className: activeEnvironment === null && 'active',
                    linkClassName: 'truncate'
                  },
                  allEnvironmentsLabel
                ),
                environments.map(function (env) {
                  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_9_app_components_menuItem__["default"],
                    {
                      key: env.id,
                      onClick: function onClick() {
                        return Object(__WEBPACK_IMPORTED_MODULE_12_app_actionCreators_environments__["e" /* setActiveEnvironment */])(env);
                      },
                      className: activeEnvironment && activeEnvironment.name === env.name && 'active',
                      linkClassName: 'truncate'
                    },
                    env.displayName
                  );
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_menuItem__["default"], { divider: true }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { textAlign: 'center', padding: '5px 0px' } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_app_components_buttons_button__["default"],
                    {
                      to: orgFeatures.has('new-settings') ? '/settings/' + org.slug + '/' + project.slug + '/environments/' : '/' + org.slug + '/' + project.slug + '/settings/',
                      size: 'small'
                    },
                    Object(__WEBPACK_IMPORTED_MODULE_11_app_locale__["t"])('Manage environments')
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ProjectHeader;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  project: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  organization: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  environments: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,
  activeSection: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  activeEnvironment: __WEBPACK_IMPORTED_MODULE_4_app_proptypes__["e" /* default */].Environment
}, _class.defaultProps = {
  environments: []
}, _temp);


var EnvironmentsToggle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e19fb2i90'
})('display:flex;position:relative;');

/* harmony default export */ __webpack_exports__["a"] = (ProjectHeader);

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_actionCreators_projects__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_stores_latestContextStore__ = __webpack_require__(169);








var BookmarkToggle = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'BookmarkToggle',

  mixins: [__WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_1_reflux___default.a.connect(__WEBPACK_IMPORTED_MODULE_6_app_stores_latestContextStore__["a" /* default */], 'latestContext')],

  handleBookmarkClick: function handleBookmarkClick() {
    var _state$latestContext = this.state.latestContext,
        project = _state$latestContext.project,
        organization = _state$latestContext.organization;

    if (project && organization) {
      Object(__WEBPACK_IMPORTED_MODULE_5_app_actionCreators_projects__["i" /* update */])(this.api, {
        orgId: organization.slug,
        projectId: project.slug,
        data: {
          isBookmarked: !project.isBookmarked
        }
      });
    }
  },
  render: function render() {
    // TODO: can't guarantee that a <span> is appropriate here 100% of the time
    //       if this is to be truly re-usable
    var project = this.state.latestContext.project;
    var isActive = project ? project.isBookmarked : false;

    var projectIconClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('project-select-bookmark icon icon-star-solid', {
      active: isActive
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { onClick: this.handleBookmarkClick },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: projectIconClass })
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (BookmarkToggle);

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BackfillNotice; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_space__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__inlineSvg__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_animations__ = __webpack_require__(236);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var BACKFILL_DATE = '2018-05-11';

var BackfillNotice = (_temp = _class = function (_React$Component) {
  _inherits(BackfillNotice, _React$Component);

  function BackfillNotice() {
    var _ref;

    _classCallCheck(this, BackfillNotice);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = BackfillNotice.__proto__ || Object.getPrototypeOf(BackfillNotice)).call.apply(_ref, [this].concat(args)));

    _this.onClose = function () {
      __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.set('backfill_notification_closed', 'true');
      _this.setState({ isDismissed: true });
    };

    _this.state = {
      isDismissed: false
    };
    return _this;
  }

  _createClass(BackfillNotice, [{
    key: 'render',
    value: function render() {
      var shouldDisplayWarning = __WEBPACK_IMPORTED_MODULE_2_moment___default()(BACKFILL_DATE).isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.props.project.dateCreated)) && __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.get('backfill_notification_closed') !== 'true' && this.state.isDismissed == false;

      return shouldDisplayWarning ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledCallout,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoIcon, { src: 'icon-circle-info' }),
        Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["tct"])('You can now filter by environment!\n          Environment-specific data may not be available for issues created before [backfillDate].', {
          backfillDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()(BACKFILL_DATE).format('MMM D')
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseButton, { src: 'icon-close-lg', onClick: this.onClose })
      ) : null;
    }
  }]);

  return BackfillNotice;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  project: __WEBPACK_IMPORTED_MODULE_5_app_proptypes__["e" /* default */].Project
}, _temp);



var StyledCallout = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])('div', {
  target: 'ejlwo9i0'
})('font-size:', function (p) {
  return p.theme.fontSizeSmall;
}, ';color:', function (p) {
  return p.theme.textColor;
}, ';background-color:', function (p) {
  return p.theme.offWhite2;
}, ';border-radius:', function (p) {
  return p.theme.borderRadius;
}, ';animation:0.5s ', __WEBPACK_IMPORTED_MODULE_8__styles_animations__["e" /* slideInRight */], ';width:400px;padding:', Object(__WEBPACK_IMPORTED_MODULE_6__styles_space__["a" /* default */])(1), ';position:absolute;right:calc(100% + ', Object(__WEBPACK_IMPORTED_MODULE_6__styles_space__["a" /* default */])(2), ');top:', Object(__WEBPACK_IMPORTED_MODULE_6__styles_space__["a" /* default */])(2), ';display:flex;align-items:center;z-index:', function (p) {
  return p.theme.zIndex.dropdown;
}, ';&:before{content:\'\';border-style:solid;border-width:', Object(__WEBPACK_IMPORTED_MODULE_6__styles_space__["a" /* default */])(1), ' 0 ', Object(__WEBPACK_IMPORTED_MODULE_6__styles_space__["a" /* default */])(1), ' ', Object(__WEBPACK_IMPORTED_MODULE_6__styles_space__["a" /* default */])(1), ';border-color:transparent transparent transparent ', function (p) {
  return p.theme.offWhite2;
}, ';position:absolute;left:100%;top:50%;transform:translateY(-50%);}');

var InfoIcon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_7__inlineSvg__["a" /* default */], {
  target: 'ejlwo9i1'
})('fill:', function (p) {
  return p.theme.textColor;
}, ';width:20px;height:20px;margin-right:', Object(__WEBPACK_IMPORTED_MODULE_6__styles_space__["a" /* default */])(1), ';flex-shrink:0;');

var CloseButton = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_7__inlineSvg__["a" /* default */], {
  target: 'ejlwo9i2'
})('stroke:', function (p) {
  return p.theme.gray4;
}, ';width:16px;height:16px;margin:0 ', Object(__WEBPACK_IMPORTED_MODULE_6__styles_space__["a" /* default */])(0.5), ' 0 ', Object(__WEBPACK_IMPORTED_MODULE_6__styles_space__["a" /* default */])(1), ';cursor:pointer;');

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_projectLink__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_dateTime__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_avatar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_pagination__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_components_searchBar__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_utils_withEnvironmentInQueryString__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_components_emptyStateWarning__ = __webpack_require__(57);





var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





















var ProjectEvents = __WEBPACK_IMPORTED_MODULE_4_create_react_class___default()({
  displayName: 'ProjectEvents',

  propTypes: {
    defaultQuery: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    setProjectNavSection: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    environment: __WEBPACK_IMPORTED_MODULE_7_app_proptypes__["e" /* default */].Environment
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_9_app_mixins_apiMixin__["default"]],

  getDefaultProps: function getDefaultProps() {
    return {
      defaultQuery: ''
    };
  },
  getInitialState: function getInitialState() {
    var queryParams = this.props.location.query;

    return {
      eventList: [],
      loading: true,
      error: false,
      query: queryParams.query || this.props.defaultQuery,
      pageLinks: '',
      environment: this.props.environment
    };
  },
  componentWillMount: function componentWillMount() {
    this.props.setProjectNavSection('events');
    this.fetchData();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    // omit when environment changes in query string since we handle that separately
    var searchHasChanged = !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_omit___default()(__WEBPACK_IMPORTED_MODULE_6_query_string___default.a.parse(nextProps.location.search), 'environment'), __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default()(__WEBPACK_IMPORTED_MODULE_6_query_string___default.a.parse(this.props.location.search), 'environment'));

    if (searchHasChanged) {
      var queryParams = nextProps.location.query;
      this.setState({
        query: queryParams.query
      }, this.fetchData);
    }

    if (nextProps.environment !== this.props.environment) {
      this.setState({ environment: nextProps.environment }, this.fetchData);
    }
  },
  onSearch: function onSearch(query) {
    var targetQueryParams = {};
    if (query !== '') targetQueryParams.query = query;

    var _props$params = this.props.params,
        orgId = _props$params.orgId,
        projectId = _props$params.projectId;

    __WEBPACK_IMPORTED_MODULE_5_react_router__["browserHistory"].push({
      pathname: '/' + orgId + '/' + projectId + '/events/',
      query: targetQueryParams
    });
  },
  fetchData: function fetchData() {
    var _this = this;

    this.setState({
      loading: true,
      error: false
    });

    var params = this.props.params;


    var query = _extends({}, this.props.location.query, {
      limit: 50,
      query: this.state.query
    });

    if (this.state.environment) {
      query.environment = this.state.environment.name;
    } else {
      delete query.environment;
    }

    this.api.request('/projects/' + params.orgId + '/' + params.projectId + '/events/', {
      query: query,
      success: function success(data, _, jqXHR) {
        _this.setState({
          error: false,
          loading: false,
          eventList: data,
          pageLinks: jqXHR.getResponseHeader('Link')
        });
      },
      error: function error() {
        _this.setState({
          error: true,
          loading: false
        });
      }
    });
  },
  getEventTitle: function getEventTitle(event) {
    return event.message.split('\n')[0].substr(0, 100);
  },
  renderStreamBody: function renderStreamBody() {
    var body = void 0;

    if (this.state.loading) body = this.renderLoading();else if (this.state.error) body = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_loadingError__["default"], { onRetry: this.fetchData });else if (this.state.eventList.length > 0) body = this.renderResults();else if (this.state.query && this.state.query !== this.props.defaultQuery) body = this.renderNoQueryResults();else body = this.renderEmpty();

    return body;
  },
  renderLoading: function renderLoading() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_app_components_loadingIndicator__["default"], null);
  },
  renderNoQueryResults: function renderNoQueryResults() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_18_app_components_emptyStateWarning__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'p',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_16_app_locale__["t"])('Sorry, no events match your filters.')
      )
    );
  },
  renderEmpty: function renderEmpty() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_18_app_components_emptyStateWarning__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'p',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_16_app_locale__["t"])("There don't seem to be any events.")
      )
    );
  },
  renderResults: function renderResults() {
    var _this2 = this;

    var _props$params2 = this.props.params,
        orgId = _props$params2.orgId,
        projectId = _props$params2.projectId;


    var children = this.state.eventList.map(function (event, eventIdx) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tr',
        { key: event.id },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'td',
          { style: { width: 240 } },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_dateTime__["default"], { date: event.dateCreated })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'h5',
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_app_components_projectLink__["a" /* default */],
              {
                to: '/' + orgId + '/' + projectId + '/issues/' + event.groupID + '/events/' + event.id + '/'
              },
              _this2.getEventTitle(event)
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'td',
          { className: 'event-user table-user-info', style: { textAlign: 'right' } },
          event.user ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_avatar__["a" /* default */], { user: event.user }),
            event.user.email
          ) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'span',
            null,
            '\u2014'
          )
        )
      );
    });

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'table',
      { className: 'table' },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tbody',
        null,
        children
      )
    );
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: 'row release-list-header' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: 'col-sm-7' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'h3',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_16_app_locale__["t"])('Events')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: 'col-sm-5 release-search' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_app_components_searchBar__["a" /* default */], {
            defaultQuery: '',
            placeholder: Object(__WEBPACK_IMPORTED_MODULE_16_app_locale__["t"])('Search event message'),
            query: this.state.query,
            onSearch: this.onSearch
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: 'alert alert-block alert-info' },
        Object(__WEBPACK_IMPORTED_MODULE_16_app_locale__["t"])('Psst! This feature is still a work-in-progress. Thanks for being an early\n          adopter!')
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: 'event-list' },
        this.renderStreamBody()
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_app_components_pagination__["default"], { pageLinks: this.state.pageLinks })
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_17_app_utils_withEnvironmentInQueryString__["a" /* default */])(ProjectEvents));

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_views_projects_projectContext__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_views_projectInstall_docsContext__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_projectHeader_projectSelector__ = __webpack_require__(210);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var GettingStartedBody = (_temp = _class = function (_React$Component) {
  _inherits(GettingStartedBody, _React$Component);

  function GettingStartedBody() {
    _classCallCheck(this, GettingStartedBody);

    return _possibleConstructorReturn(this, (GettingStartedBody.__proto__ || Object.getPrototypeOf(GettingStartedBody)).apply(this, arguments));
  }

  _createClass(GettingStartedBody, [{
    key: 'render',
    value: function render() {
      var _context = this.context,
          project = _context.project,
          organization = _context.organization;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'getting-started' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'sub-header flex flex-container flex-vertically-centered' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'p-t-1 p-b-1' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_projectHeader_projectSelector__["default"], { organization: organization, projectId: project.slug })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'container' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'content' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_app_views_projectInstall_docsContext__["a" /* default */],
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(this.props.children, {
                linkPath: function linkPath(orgId, projectId, platform) {
                  return '/' + orgId + '/' + projectId + '/getting-started/' + platform + '/';
                }
              })
            )
          )
        )
      );
    }
  }]);

  return GettingStartedBody;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.contextTypes = {
  project: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  organization: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
}, _temp);

var GettingStarted = function (_React$Component2) {
  _inherits(GettingStarted, _React$Component2);

  function GettingStarted() {
    _classCallCheck(this, GettingStarted);

    return _possibleConstructorReturn(this, (GettingStarted.__proto__ || Object.getPrototypeOf(GettingStarted)).apply(this, arguments));
  }

  _createClass(GettingStarted, [{
    key: 'render',
    value: function render() {
      var _props$params = this.props.params,
          projectId = _props$params.projectId,
          orgId = _props$params.orgId;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_app_views_projects_projectContext__["a" /* default */],
        { orgId: orgId, projectId: projectId },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          GettingStartedBody,
          null,
          this.props.children
        )
      );
    }
  }]);

  return GettingStarted;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (GettingStarted);

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_autoSelectText__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_views_onboarding_project_platformpicker__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_views_settings_components_settingsPageHeader__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_views_settings_components_text_textBlock__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_utils_recreateRoute__ = __webpack_require__(148);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var ProjectInstallOverview = (_temp = _class = function (_React$Component) {
  _inherits(ProjectInstallOverview, _React$Component);

  function ProjectInstallOverview() {
    var _ref;

    _classCallCheck(this, ProjectInstallOverview);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = ProjectInstallOverview.__proto__ || Object.getPrototypeOf(ProjectInstallOverview)).call.apply(_ref, [this].concat(args)));

    _this.isGettingStarted = function () {
      return location.href.indexOf('getting-started') > 0;
    };

    _this.redirectToDocs = function (platform) {
      var _this$props$params = _this.props.params,
          orgId = _this$props$params.orgId,
          projectId = _this$props$params.projectId;

      var prefix = Object(__WEBPACK_IMPORTED_MODULE_8_app_utils_recreateRoute__["a" /* default */])('', _extends({}, _this.props, { stepBack: -3 }));
      var rootUrl = prefix + 'install';

      if (_this.isGettingStarted()) {
        rootUrl = '/' + orgId + '/' + projectId + '/getting-started';
      }

      __WEBPACK_IMPORTED_MODULE_0_react_router__["browserHistory"].push(rootUrl + '/' + platform + '/');
    };

    _this.toggleDsn = function () {
      _this.setState({ showDsn: !_this.state.showDsn });
    };

    _this.state = {
      data: _this.props.platformData
    };
    return _this;
  }

  _createClass(ProjectInstallOverview, [{
    key: 'render',
    value: function render() {
      var data = this.state.data;
      var _props$params = this.props.params,
          orgId = _props$params.orgId,
          projectId = _props$params.projectId;


      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_views_settings_components_settingsPageHeader__["default"], { title: Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Configure your application') }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_app_views_settings_components_text_textBlock__["default"],
          null,
          Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Get started by selecting the platform or language that powers your application.')
        ),
        this.state.showDsn ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'control-group' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'label',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('DSN')
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_app_components_autoSelectText__["a" /* default */],
              { className: 'form-control disabled' },
              data.dsn
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'control-group' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'label',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Public DSN')
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_app_components_autoSelectText__["a" /* default */],
              { className: 'form-control disabled' },
              data.dsnPublic
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'help-block m-b-1' },
              Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('The public DSN should be used with JavaScript.')
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_0_react_router__["Link"],
              {
                to: '/' + orgId + '/' + projectId + '/#welcome',
                className: 'btn btn-primary m-b-1'
              },
              Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Got it! Take me to the Issue Stream.')
            )
          )
        ) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'small',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["tct"])('Already have things setup? [link:Get your DSN]', {
              link: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { className: 'btn-xsmall', onClick: this.toggleDsn })
            }),
            '.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_views_onboarding_project_platformpicker__["a" /* default */], { setPlatform: this.redirectToDocs, showOther: false }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'p',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["tct"])('\n             For a complete list of\n             client integrations, please see [docLink:our in-depth documentation].\n          ', {
            docLink: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { href: 'https://docs.sentry.io' })
          })
        )
      );
    }
  }]);

  return ProjectInstallOverview;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  platformData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (ProjectInstallOverview);

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_actions_pluginActions__ = __webpack_require__(559);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var PluginsStore = __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({
  getInitialState: function getInitialState() {
    return this.getState();
  },
  getState: function getState() {
    var _state = this.state,
        plugins = _state.plugins,
        state = _objectWithoutProperties(_state, ['plugins']);

    return _extends({}, state, {
      plugins: this.plugins ? Array.from(this.plugins.values()) : []
    });
  },
  init: function init() {
    this.reset();
    this.listenTo(__WEBPACK_IMPORTED_MODULE_1_app_actions_pluginActions__["a" /* default */].fetchAll, this.onFetchAll);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_1_app_actions_pluginActions__["a" /* default */].fetchAllSuccess, this.onFetchAllSuccess);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_1_app_actions_pluginActions__["a" /* default */].fetchAllError, this.onFetchAllError);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_1_app_actions_pluginActions__["a" /* default */].update, this.onUpdate);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_1_app_actions_pluginActions__["a" /* default */].updateSuccess, this.onUpdateSuccess);
    this.listenTo(__WEBPACK_IMPORTED_MODULE_1_app_actions_pluginActions__["a" /* default */].updateError, this.onUpdateError);
  },
  reset: function reset() {
    this.plugins = null;
    this.state = {
      loading: true,
      plugins: [],
      error: null,
      pageLinks: null
    };
    this.updating = new Map();
    return this.state;
  },
  triggerState: function triggerState() {
    this.trigger(this.getState());
  },
  onFetchAll: function onFetchAll() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        resetLoading = _ref.resetLoading;

    if (resetLoading) {
      this.state.loading = true;
      this.state.error = null;
      this.plugins = null;
    }

    this.triggerState();
  },
  onFetchAllSuccess: function onFetchAllSuccess(data, _ref2) {
    var pageLinks = _ref2.pageLinks;

    this.plugins = new Map(data.map(function (plugin) {
      return [plugin.id, plugin];
    }));
    this.state.pageLinks = pageLinks;
    this.state.loading = false;
    this.triggerState();
  },
  onFetchAllError: function onFetchAllError(err) {
    this.plugins = null;
    this.state.loading = false;
    this.state.error = err;
    this.triggerState();
  },
  onUpdate: function onUpdate(id, updateObj) {
    if (!this.plugins) return;

    var plugin = this.plugins.get(id);
    var newPlugin = _extends({}, plugin, updateObj);

    this.plugins.set(id, newPlugin);
    this.updating.set(id, plugin);
    this.triggerState();
  },
  onUpdateSuccess: function onUpdateSuccess(id, updateObj) {
    this.updating.delete(id);
  },
  onUpdateError: function onUpdateError(id, updateObj, err) {
    var origPlugin = this.updating.get(id);
    if (!origPlugin) return;

    this.plugins.set(id, origPlugin);
    this.updating.delete(id);
    this.state.error = err;
    this.triggerState();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (PluginsStore);

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProjectReleases */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_pagination__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_assistant_guideAnchor__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_searchBar__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_components_emptyStateWarning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_views_projectReleases_releaseList__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_utils_withEnvironmentInQueryString__ = __webpack_require__(69);





var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
























var DEFAULT_QUERY = '';

var ProjectReleases = __WEBPACK_IMPORTED_MODULE_4_create_react_class___default()({
  displayName: 'ProjectReleases',

  propTypes: {
    setProjectNavSection: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    environment: __WEBPACK_IMPORTED_MODULE_8_app_proptypes__["e" /* default */].Environment
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_9_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    var queryParams = this.props.location.query;

    return {
      releaseList: [],
      loading: true,
      error: false,
      query: queryParams.query || DEFAULT_QUERY,
      pageLinks: '',
      environment: this.props.environment
    };
  },
  componentWillMount: function componentWillMount() {
    this.props.setProjectNavSection('releases');
    this.fetchData();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var searchHasChanged = !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_omit___default()(__WEBPACK_IMPORTED_MODULE_7_query_string___default.a.parse(nextProps.location.search), 'environment'), __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default()(__WEBPACK_IMPORTED_MODULE_7_query_string___default.a.parse(this.props.location.search), 'environment'));

    if (searchHasChanged) {
      var queryParams = nextProps.location.query;
      this.setState({
        query: queryParams.query
      }, this.fetchData);
    }

    if (nextProps.environment !== this.props.environment) {
      this.setState({ environment: nextProps.environment }, this.fetchData);
    }
  },
  onSearch: function onSearch(query) {
    var targetQueryParams = {};
    if (query !== '') targetQueryParams.query = query;

    var _props$params = this.props.params,
        orgId = _props$params.orgId,
        projectId = _props$params.projectId;

    __WEBPACK_IMPORTED_MODULE_5_react_router__["browserHistory"].push({
      pathname: '/' + orgId + '/' + projectId + '/releases/',
      query: targetQueryParams
    });
  },
  fetchData: function fetchData() {
    var _this = this;

    this.setState({
      loading: true,
      error: false
    });

    var _props$params2 = this.props.params,
        orgId = _props$params2.orgId,
        projectId = _props$params2.projectId;


    var url = '/projects/' + orgId + '/' + projectId + '/releases/';

    var query = _extends({}, this.props.location.query, {
      per_page: 20,
      query: this.state.query
    });

    if (this.state.environment) {
      query.environment = this.state.environment.name;
    } else {
      delete query.environment;
    }

    this.api.request(url, {
      query: query,
      success: function success(data, _, jqXHR) {
        _this.setState({
          error: false,
          loading: false,
          releaseList: data,
          pageLinks: jqXHR.getResponseHeader('Link')
        });
      },
      error: function error() {
        _this.setState({
          error: true,
          loading: false
        });
      }
    });
  },
  getReleaseTrackingUrl: function getReleaseTrackingUrl() {
    var params = this.props.params;

    return '/' + params.orgId + '/' + params.projectId + '/settings/release-tracking/';
  },
  renderStreamBody: function renderStreamBody() {
    var body = void 0;

    var params = this.props.params;

    if (this.state.loading) body = this.renderLoading();else if (this.state.error) body = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_loadingError__["default"], { onRetry: this.fetchData });else if (this.state.releaseList.length > 0) body = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_app_views_projectReleases_releaseList__["a" /* default */], {
      orgId: params.orgId,
      projectId: params.projectId,
      releaseList: this.state.releaseList
    });else if (this.state.query && this.state.query !== DEFAULT_QUERY) body = this.renderNoQueryResults();else body = this.renderEmpty();

    return body;
  },
  renderLoading: function renderLoading() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_loadingIndicator__["default"], null);
  },
  renderNoQueryResults: function renderNoQueryResults() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_17_app_components_emptyStateWarning__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'p',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])('Sorry, no releases match your filters.')
      )
    );
  },
  renderEmpty: function renderEmpty() {
    var environment = this.state.environment;

    var message = environment ? Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["tct"])("There don't seem to be any releases in your [env] environment yet", {
      env: environment.displayName
    }) : Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])("There don't seem to be any releases yet.");

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_17_app_components_emptyStateWarning__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'p',
        null,
        message
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'p',
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'a',
          { href: this.getReleaseTrackingUrl() },
          Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])('Learn how to integrate Release Tracking')
        )
      )
    );
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: 'ref-project-releases' },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_app_components_assistant_guideAnchor__["default"], { target: 'releases', type: 'invisible' }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: 'row release-list-header' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: 'col-sm-7' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'h3',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])('Releases')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: 'col-sm-5 release-search' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_app_components_searchBar__["a" /* default */], {
            defaultQuery: '',
            placeholder: Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])('Search for a release'),
            query: this.state.query,
            onSearch: this.onSearch
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_16_app_components_panels__["a" /* Panel */],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_16_app_components_panels__["e" /* PanelHeader */],
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_grid_emotion__["Box"],
            { flex: '1' },
            Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])('Version')
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grid_emotion__["Box"], { w: 4 / 12, pl: 2, className: 'hidden-xs' }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_grid_emotion__["Box"],
            { w: 2 / 12, pl: 2 },
            Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])('New Issues')
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_grid_emotion__["Box"],
            { w: 2 / 12, pl: 2 },
            Object(__WEBPACK_IMPORTED_MODULE_15_app_locale__["t"])('Last Event')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_16_app_components_panels__["c" /* PanelBody */],
          null,
          this.renderStreamBody()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_pagination__["default"], { pageLinks: this.state.pageLinks })
    );
  }
});

 // For tests
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_19_app_utils_withEnvironmentInQueryString__["a" /* default */])(ProjectReleases));

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_releaseStats__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_count__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_timeSince__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_version__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_latestDeployOrReleaseTime__ = __webpack_require__(1286);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var ReleaseList = (_temp = _class = function (_React$Component) {
  _inherits(ReleaseList, _React$Component);

  function ReleaseList() {
    _classCallCheck(this, ReleaseList);

    return _possibleConstructorReturn(this, (ReleaseList.__proto__ || Object.getPrototypeOf(ReleaseList)).apply(this, arguments));
  }

  _createClass(ReleaseList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          orgId = _props.orgId,
          projectId = _props.projectId;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        this.props.releaseList.map(function (release) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_app_components_panels__["f" /* PanelItem */],
            { key: release.version, align: 'center', px: 2, py: 1 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Box"],
              { flex: '1' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { fontWeight: 'bold', marginBottom: 2 } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_version__["a" /* default */], {
                    orgId: orgId,
                    projectId: projectId,
                    version: release.version
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_latestDeployOrReleaseTime__["a" /* default */], { orgId: orgId, release: release })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Box"],
              { w: 4 / 12, pl: 2, className: 'hidden-xs' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_releaseStats__["a" /* default */], { release: release })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Box"],
              { w: 2 / 12, pl: 2 },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_count__["default"], { className: 'release-count', value: release.newGroups })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Box"],
              { w: 2 / 12, pl: 2 },
              release.lastEvent ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_timeSince__["default"], { date: release.lastEvent, style: { fontSize: 13 } }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                null,
                '\u2014'
              )
            )
          );
        })
      );
    }
  }]);

  return ReleaseList;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  orgId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  releaseList: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (ReleaseList);

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_timeSince__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);








var LatestDeployOrReleaseTime = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'LatestDeployOrReleaseTime',

  propTypes: {
    release: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_app_mixins_apiMixin__["default"]],

  render: function render() {
    var release = this.props.release;

    var earlierDeploysNum = release.totalDeploys - 1;
    var latestDeploy = release.lastDeploy;
    // if there are deploys associated with the release
    // render the most recent deploy (API will return data ordered by dateFinished)
    // otherwise, render the dateCreated associated with release
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      null,
      latestDeploy && latestDeploy.dateFinished ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'deploy' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { className: 'm-b-0 text-light' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            {
              className: 'repo-label',
              style: {
                padding: 3,
                display: 'inline-block',
                width: 70,
                maxWidth: 86,
                textAlign: 'center',
                fontSize: 12
              }
            },
            latestDeploy.environment + ' '
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon icon-clock' }),
          ' ',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_timeSince__["default"], { date: latestDeploy.dateFinished }),
          earlierDeploysNum > 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_app_components_tooltip__["default"],
            { title: earlierDeploysNum + Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])(' earlier deploys') },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: 'badge' },
              earlierDeploysNum
            )
          )
        )
      ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'p',
        { className: 'm-b-0 text-light' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon icon-clock' }),
        ' ',
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_timeSince__["default"], { date: release.dateCreated })
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (LatestDeployOrReleaseTime);

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SavedSearchRow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_confirm__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_stores_indicatorStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_views_settings_components_settingsPageHeader__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_components_emptyStateWarning__ = __webpack_require__(57);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var InputColumn = function InputColumn(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Flex"], _extends({ flex: '1', justify: 'center' }, props));
};

var SearchTitle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('div', {
  target: 'e1e9fsi50'
})('font-size:18px;margin-bottom:5px;');

var SavedSearchRow = (_temp2 = _class = function (_React$Component) {
  _inherits(SavedSearchRow, _React$Component);

  function SavedSearchRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SavedSearchRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SavedSearchRow.__proto__ || Object.getPrototypeOf(SavedSearchRow)).call.apply(_ref, [this].concat(args))), _this), _this.handleRemove = function () {
      var _this$props = _this.props,
          data = _this$props.data,
          onRemove = _this$props.onRemove;

      onRemove({ data: data });
    }, _this.handleDefault = function () {
      var _this$props2 = _this.props,
          data = _this$props2.data,
          onDefault = _this$props2.onDefault;

      onDefault({
        data: data,
        isDefault: true
      });
    }, _this.handleUserDefault = function () {
      var _this$props3 = _this.props,
          data = _this$props3.data,
          onUserDefault = _this$props3.onUserDefault;

      onUserDefault({
        data: data,
        isUserDefault: true
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SavedSearchRow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          canModify = _props.canModify;


      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13_app_components_panels__["f" /* PanelItem */],
        { p: 0, py: 2, align: 'center' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Flex"],
          { flex: '1', px: 2, direction: 'column' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            SearchTitle,
            null,
            data.name
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'code',
            null,
            data.query
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Flex"],
          { flex: '1' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            InputColumn,
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', {
              type: 'radio',
              name: 'userDefault',
              checked: data.isUserDefault,
              onChange: this.handleUserDefault
            })
          ),
          canModify && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            InputColumn,
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', {
              type: 'radio',
              name: 'default',
              checked: data.isDefault,
              onChange: this.handleDefault
            })
          ),
          canModify && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            InputColumn,
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_app_components_confirm__["a" /* default */],
              {
                message: Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Are you sure you want to remove this?'),
                onConfirm: this.handleRemove
              },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_app_components_buttons_button__["default"],
                { size: 'small' },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon icon-trash' })
              )
            )
          )
        )
      );
    }
  }]);

  return SavedSearchRow;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  canModify: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  onDefault: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onUserDefault: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onRemove: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, _temp2);


var ProjectSavedSearches = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'ProjectSavedSearches',
  contextTypes: {
    organization: __WEBPACK_IMPORTED_MODULE_5_app_proptypes__["e" /* default */].Organization
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_7_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    return {
      loading: true,
      error: false,
      savedSearchList: []
    };
  },
  componentDidMount: function componentDidMount() {
    this.fetchData();
  },
  fetchData: function fetchData() {
    var _this2 = this;

    var _props$params = this.props.params,
        orgId = _props$params.orgId,
        projectId = _props$params.projectId;

    this.api.request('/projects/' + orgId + '/' + projectId + '/searches/', {
      success: function success(data, _, jqXHR) {
        _this2.setState({
          error: false,
          loading: false,
          savedSearchList: data,
          pageLinks: jqXHR.getResponseHeader('Link')
        });
      },
      error: function error() {
        _this2.setState({
          error: true,
          loading: false
        });
      }
    });
  },
  handleUpdate: function handleUpdate(params) {
    var _this3 = this;

    var _props$params2 = this.props.params,
        orgId = _props$params2.orgId,
        projectId = _props$params2.projectId;

    var loadingIndicator = __WEBPACK_IMPORTED_MODULE_10_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Saving changes..'));
    var data = params.data,
        isDefault = params.isDefault,
        isUserDefault = params.isUserDefault;

    var key = typeof isDefault !== 'undefined' ? 'isDefault' : 'isUserDefault';
    var savedSearchList = this.state.savedSearchList;

    var newSearchList = savedSearchList.map(function (search) {
      return _extends({}, search, _defineProperty({}, key, data.id === search.id));
    });

    this.setState({
      savedSearchList: newSearchList
    }, function () {
      _this3.api.request('/projects/' + orgId + '/' + projectId + '/searches/' + data.id + '/', {
        method: 'PUT',
        data: {
          isDefault: isDefault,
          isUserDefault: isUserDefault
        },
        error: function error() {
          _this3.setState({
            savedSearchList: savedSearchList
          });
          __WEBPACK_IMPORTED_MODULE_10_app_stores_indicatorStore__["default"].addError(Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Error updating search'));
        },
        complete: function complete() {
          __WEBPACK_IMPORTED_MODULE_10_app_stores_indicatorStore__["default"].remove(loadingIndicator);
        }
      });
    });
  },
  handleRemovedSearch: function handleRemovedSearch(params) {
    var _this4 = this;

    var _props$params3 = this.props.params,
        orgId = _props$params3.orgId,
        projectId = _props$params3.projectId;

    var loadingIndicator = __WEBPACK_IMPORTED_MODULE_10_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Saving changes..'));
    var data = params.data;
    var savedSearchList = this.state.savedSearchList;

    var newSearchList = savedSearchList.filter(function (search) {
      return search.id !== data.id;
    });

    this.setState({
      savedSearchList: newSearchList
    }, function () {
      _this4.api.request('/projects/' + orgId + '/' + projectId + '/searches/' + data.id + '/', {
        method: 'DELETE',
        error: function error() {
          _this4.setState({
            savedSearchList: savedSearchList
          });
          __WEBPACK_IMPORTED_MODULE_10_app_stores_indicatorStore__["default"].addError(Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Error removing search'));
        },
        complete: function complete() {
          return __WEBPACK_IMPORTED_MODULE_10_app_stores_indicatorStore__["default"].remove(loadingIndicator);
        }
      });
    });
  },
  renderBody: function renderBody() {
    var body = void 0;

    if (this.state.loading) body = this.renderLoading();else if (this.state.error) body = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_loadingError__["default"], { onRetry: this.fetchData });else if (this.state.savedSearchList.length > 0) body = this.renderResults();else body = this.renderEmpty();

    return body;
  },
  renderLoading: function renderLoading() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_loadingIndicator__["default"], null);
  },
  renderEmpty: function renderEmpty() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_15_app_components_emptyStateWarning__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'p',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('There are no saved searches for this project.')
      )
    );
  },
  renderResults: function renderResults() {
    var _this5 = this;

    var _props$params4 = this.props.params,
        orgId = _props$params4.orgId,
        projectId = _props$params4.projectId;
    var organization = this.context.organization;

    var access = organization && new Set(organization.access);
    var canModify = organization && access.has('project:write') || false;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,
      null,
      this.state.savedSearchList.map(function (search) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(SavedSearchRow, {
          access: access,
          key: search.id,
          canModify: canModify,
          orgId: orgId,
          projectId: projectId,
          data: search,
          onUserDefault: _this5.handleUpdate,
          onDefault: _this5.handleUpdate,
          onRemove: _this5.handleRemovedSearch
        });
      })
    );
  },
  render: function render() {
    var organization = this.context.organization;

    var access = organization && new Set(organization.access);
    var canModify = organization && access.has('project:write') || false;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_app_views_settings_components_settingsPageHeader__["default"], { title: Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Saved Searches') }),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13_app_components_panels__["a" /* Panel */],
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13_app_components_panels__["e" /* PanelHeader */],
          { disablePadding: true },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Flex"],
            { flex: '1' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Flex"],
              { flex: '1', px: 2 },
              Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Search')
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_0_grid_emotion__["Flex"],
              { flex: '1' },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                InputColumn,
                null,
                Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('My Default')
              ),
              canModify && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                InputColumn,
                null,
                Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Team Default')
              ),
              canModify && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                InputColumn,
                null,
                Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Remove')
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13_app_components_panels__["c" /* PanelBody */],
          null,
          this.renderBody()
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ProjectSavedSearches);


/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_badge__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_listLink__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_mixins_organizationState__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_views_projectSettings_pluginNavigation__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_externalLink__ = __webpack_require__(71);














var ProjectSettings = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'ProjectSettings',

  propTypes: {
    setProjectNavSection: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
  },

  contextTypes: {
    location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    organization: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_9_app_mixins_organizationState__["a" /* default */]],

  getInitialState: function getInitialState() {
    return {
      loading: true,
      error: false,
      project: null
    };
  },
  componentWillMount: function componentWillMount() {
    var setProjectNavSection = this.props.setProjectNavSection;


    setProjectNavSection('settings');
    this.fetchData();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var params = this.props.params;
    if (nextProps.params.projectId !== params.projectId || nextProps.params.orgId !== params.orgId) {
      this.setState({
        loading: true,
        error: false
      }, this.fetchData);
    }
  },
  fetchData: function fetchData() {
    var _this = this;

    var params = this.props.params;

    this.api.request('/projects/' + params.orgId + '/' + params.projectId + '/', {
      success: function success(data) {
        _this.setState({
          project: data,
          loading: false,
          error: false
        });
      },
      error: function error() {
        _this.setState({
          loading: false,
          error: true
        });
      }
    });
  },
  render: function render() {
    // TODO(dcramer): move sidebar into component
    if (this.state.loading) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_loadingIndicator__["default"], null);else if (this.state.error) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_loadingError__["default"], { onRetry: this.fetchData });

    var access = this.getAccess();
    var features = this.getFeatures();
    var _props$params = this.props.params,
        orgId = _props$params.orgId,
        projectId = _props$params.projectId;

    var hasNewSettings = features.has('new-settings');
    var pathPrefix = hasNewSettings ? '/settings/' + orgId + '/' + projectId : '/' + orgId + '/' + projectId + '/settings';
    var settingsUrlRoot = pathPrefix;
    var project = this.state.project;
    var rootInstallPath = pathPrefix + '/install/';
    var path = this.props.location.pathname;
    var processingIssues = this.state.project.processingIssues;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'col-md-2' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h6',
          { className: 'nav-header' },
          Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Configuration')
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'ul',
          { className: 'nav nav-stacked' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_app_components_listLink__["default"],
            { to: pathPrefix + '/', index: true },
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('General')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_app_components_listLink__["default"],
            {
              to: pathPrefix + '/alerts/',
              isActive: function isActive(loc) {
                return path.indexOf(loc.pathname) === 0;
              }
            },
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Alerts')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_app_components_listLink__["default"],
            {
              to: pathPrefix + '/environments/',
              isActive: function isActive(loc) {
                return path.indexOf(loc.pathname) === 0;
              }
            },
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Environments')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_app_components_listLink__["default"],
            { to: pathPrefix + '/tags/' },
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Tags')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_app_components_listLink__["default"],
            { to: pathPrefix + '/issue-tracking/' },
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Issue Tracking')
          ),
          access.has('project:write') && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_app_components_listLink__["default"],
            {
              to: pathPrefix + '/release-tracking/',
              isActive: function isActive(loc) {
                return path.indexOf(loc.pathname) === 0;
              }
            },
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Release Tracking')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_app_components_listLink__["default"],
            { to: pathPrefix + '/data-forwarding/' },
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Data Forwarding')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_app_components_listLink__["default"],
            { to: pathPrefix + '/saved-searches/' },
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Saved Searches')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_app_components_listLink__["default"],
            { to: pathPrefix + '/debug-symbols/' },
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Debug Information Files')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_app_components_listLink__["default"],
            { className: 'badged', to: pathPrefix + '/processing-issues/' },
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Processing Issues'),
            processingIssues > 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_badge__["default"], {
              text: processingIssues > 99 ? '99+' : processingIssues + '',
              isNew: true
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h6',
          { className: 'nav-header' },
          Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Data')
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'ul',
          { className: 'nav nav-stacked' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_app_components_listLink__["default"],
            {
              to: rootInstallPath,
              isActive: function isActive(loc) {
                // Because react-router 1.0 removes router.isActive(route)
                return path === rootInstallPath || /install\/[\w\-]+\/$/.test(path);
              }
            },
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Error Tracking')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_app_components_listLink__["default"],
            { to: pathPrefix + '/security-headers/' },
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Security Headers')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_app_components_listLink__["default"],
            { to: pathPrefix + '/user-feedback/' },
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('User Feedback')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_app_components_listLink__["default"],
            { to: pathPrefix + '/filters/' },
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Inbound Filters')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_app_components_listLink__["default"],
            { to: pathPrefix + '/keys/' },
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Client Keys'),
            ' (DSN)'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h6',
          { className: 'nav-header' },
          Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Integrations')
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'ul',
          { className: 'nav nav-stacked' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_app_components_listLink__["default"],
            { to: pathPrefix + '/plugins/' },
            Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('All Integrations')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_views_projectSettings_pluginNavigation__["a" /* default */], { urlRoot: settingsUrlRoot })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'col-md-10' },
        access.has('project:write') ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(this.props.children, {
          setProjectNavSection: this.props.setProjectNavSection,
          project: project,
          organization: this.context.organization
        }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'alert alert-block' },
          Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('You’re restricted from accessing this page based on your organization role. Read more here: '),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_app_components_externalLink__["a" /* default */],
            { href: 'https://docs.sentry.io/learn/membership/' },
            'https://docs.sentry.io/learn/membership/'
          )
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ProjectSettings);

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_utils_withPlugins__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_proptypes__ = __webpack_require__(6);









var PluginNavigation = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'PluginNavigation',
  propTypes: {
    urlRoot: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    plugins: __WEBPACK_IMPORTED_MODULE_5_app_proptypes__["e" /* default */].PluginsStore
  },

  render: function render() {
    var _props = this.props,
        urlRoot = _props.urlRoot,
        plugins = _props.plugins;


    if (!plugins || !plugins.plugins) return null;
    var enabledPlugins = plugins.plugins.filter(function (p) {
      return p.enabled && p.hasConfiguration;
    });

    if (!enabledPlugins.length) return null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      enabledPlugins.map(function (_ref) {
        var id = _ref.id,
            name = _ref.name;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { key: id },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
            { to: urlRoot + '/plugins/' + id + '/' },
            name
          )
        );
      })
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_app_utils_withPlugins__["a" /* default */])(PluginNavigation));

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProjectUserReports */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_stores_groupStore__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_pagination__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_compactIssue__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_events_userReport__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_components_emptyStateWarning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_utils_withEnvironmentInQueryString__ = __webpack_require__(69);





var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




















var ProjectUserReports = __WEBPACK_IMPORTED_MODULE_4_create_react_class___default()({
  displayName: 'ProjectUserReports',

  propTypes: {
    defaultQuery: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    defaultStatus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    setProjectNavSection: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    environment: __WEBPACK_IMPORTED_MODULE_7_app_proptypes__["e" /* default */].Environment
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8_app_mixins_apiMixin__["default"]],

  getDefaultProps: function getDefaultProps() {
    return {
      defaultQuery: '',
      defaultStatus: 'unresolved'
    };
  },
  getInitialState: function getInitialState() {
    return _extends({
      reportList: [],
      loading: true,
      error: false,
      pageLinks: '',
      query: this.props.defaultQuery,
      status: this.props.defaultStatus,
      environment: this.props.environment
    }, this.getQueryStringState(this.props));
  },
  componentWillMount: function componentWillMount() {
    this.props.setProjectNavSection('user-feedback');
    this.fetchData();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    // Ignore changes to environment term since this is handled separately
    var nextSearchTerm = __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default()(__WEBPACK_IMPORTED_MODULE_6_query_string___default.a.parse(nextProps.location.search), 'environment');
    var thisSearchTerm = __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default()(__WEBPACK_IMPORTED_MODULE_6_query_string___default.a.parse(this.props.location.search), 'environment');

    if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(nextSearchTerm, thisSearchTerm)) {
      this.setState(this.getQueryStringState(nextProps), this.fetchData);
    }

    if (nextProps.environment !== this.props.environment) {
      this.setState({
        environment: nextProps.environment
      }, this.fetchData);
    }
  },
  getQueryStringState: function getQueryStringState(props) {
    var q = props.location.query;
    var status = 'status' in q ? q.status : this.props.defaultStatus;
    var query = 'query' in q ? q.query : this.props.defaultQuery;

    return {
      query: query,
      status: status
    };
  },
  onSearch: function onSearch(query) {
    var targetQueryParams = {};
    if (query !== '') targetQueryParams.query = query;
    if (this.state.status !== this.props.defaultStatus) targetQueryParams.status = this.state.status;

    var _props$params = this.props.params,
        orgId = _props$params.orgId,
        projectId = _props$params.projectId;

    __WEBPACK_IMPORTED_MODULE_5_react_router__["browserHistory"].push({
      pathname: '/' + orgId + '/' + projectId + '/user-feedback/',
      query: targetQueryParams
    });
  },
  fetchData: function fetchData() {
    var _this = this;

    this.setState({
      loading: true,
      error: false
    });

    var params = this.props.params;

    var query = _extends({}, this.props.location.query, {
      limit: 50,
      query: this.state.query,
      status: this.state.status
    });

    if (this.state.environment) {
      query.environment = this.state.environment.name;
    } else {
      delete query.environment;
    }

    this.api.request('/projects/' + params.orgId + '/' + params.projectId + '/user-reports/', {
      query: query,
      success: function success(data, _, jqXHR) {
        var issues = data.map(function (r) {
          return r.issue;
        });
        __WEBPACK_IMPORTED_MODULE_9_app_stores_groupStore__["a" /* default */].add(issues);
        _this.setState({
          error: false,
          loading: false,
          reportList: data,
          pageLinks: jqXHR.getResponseHeader('Link')
        });
      },
      error: function error() {
        _this.setState({
          error: true,
          loading: false
        });
      }
    });
  },
  getUserReportsUrl: function getUserReportsUrl() {
    var params = this.props.params;

    return '/' + params.orgId + '/' + params.projectId + '/settings/user-feedback/';
  },
  renderStreamBody: function renderStreamBody() {
    if (this.state.loading) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_loadingIndicator__["default"], null);
    } else if (this.state.error) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_loadingError__["default"], { onRetry: this.fetchData });
    } else if (this.state.reportList.length > 0) {
      return this.renderResults();
    } else if (this.state.query && this.state.query !== this.props.defaultQuery) {
      return this.renderNoQueryResults();
    } else {
      return this.renderEmpty();
    }
  },
  renderNoQueryResults: function renderNoQueryResults() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_16_app_components_emptyStateWarning__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'p',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_17_app_locale__["t"])('Sorry, no results match your search query.')
      )
    );
  },
  renderEmpty: function renderEmpty() {
    var environment = this.state.environment;

    var message = environment ? Object(__WEBPACK_IMPORTED_MODULE_17_app_locale__["tct"])('No user reports have been collected from your [env] environment.', {
      env: environment.displayName
    }) : Object(__WEBPACK_IMPORTED_MODULE_17_app_locale__["t"])('No user reports have been collected.');
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_16_app_components_emptyStateWarning__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'p',
        null,
        message
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'p',
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_router__["Link"],
          { to: this.getUserReportsUrl() },
          Object(__WEBPACK_IMPORTED_MODULE_17_app_locale__["t"])('Learn how to integrate User Feedback')
        )
      )
    );
  },
  renderResults: function renderResults() {
    var _props$params2 = this.props.params,
        orgId = _props$params2.orgId,
        projectId = _props$params2.projectId;


    var children = this.state.reportList.map(function (item) {
      var issue = item.issue;

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13_app_components_compactIssue__["a" /* default */],
        {
          key: item.id,
          id: issue.id,
          data: issue,
          orgId: orgId,
          projectId: projectId
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_app_components_events_userReport__["a" /* default */], {
          report: item,
          orgId: orgId,
          projectId: projectId,
          issueId: issue.id
        })
      );
    });

    return children;
  },
  render: function render() {
    var path = this.props.location.pathname;
    var status = this.state.status;
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: 'row release-list-header' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: 'col-sm-9' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'h3',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_17_app_locale__["t"])('User Feedback')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: 'col-sm-3', style: { textAlign: 'right' } },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'div',
            { className: 'btn-group' },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_router__["Link"],
              {
                to: path,
                className: 'btn btn-sm btn-default' + (status === 'unresolved' ? ' active' : '')
              },
              Object(__WEBPACK_IMPORTED_MODULE_17_app_locale__["t"])('Unresolved')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_router__["Link"],
              {
                to: { pathname: path, query: { status: '' } },
                className: 'btn btn-sm btn-default' + (status === '' ? ' active' : '')
              },
              Object(__WEBPACK_IMPORTED_MODULE_17_app_locale__["t"])('All Issues')
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_15_app_components_panels__["a" /* Panel */],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_15_app_components_panels__["c" /* PanelBody */],
          { className: 'issue-list' },
          this.renderStreamBody()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_pagination__["default"], { pageLinks: this.state.pageLinks })
    );
  }
});


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_18_app_utils_withEnvironmentInQueryString__["a" /* default */])(ProjectUserReports));

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_actionCreators_plugins__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_utils_withPlugins__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_views_projectPlugins_projectPlugins__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_views_projectPlugins_organizationIntegrations__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_views_settings_components_settingsPageHeader__ = __webpack_require__(52);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ProjectPluginsContainer = (_temp2 = _class = function (_React$Component) {
  _inherits(ProjectPluginsContainer, _React$Component);

  function ProjectPluginsContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProjectPluginsContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProjectPluginsContainer.__proto__ || Object.getPrototypeOf(ProjectPluginsContainer)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (pluginId, shouldEnable) {
      var _this$props$params = _this.props.params,
          projectId = _this$props$params.projectId,
          orgId = _this$props$params.orgId;

      var actionCreator = shouldEnable ? __WEBPACK_IMPORTED_MODULE_2_app_actionCreators_plugins__["b" /* enablePlugin */] : __WEBPACK_IMPORTED_MODULE_2_app_actionCreators_plugins__["a" /* disablePlugin */];
      actionCreator({ projectId: projectId, orgId: orgId, pluginId: pluginId });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProjectPluginsContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchData();
    }
  }, {
    key: 'fetchData',
    value: function fetchData() {
      Object(__WEBPACK_IMPORTED_MODULE_2_app_actionCreators_plugins__["c" /* fetchPlugins */])(this.props.params);
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref2 = this.props.plugins || {},
          loading = _ref2.loading,
          error = _ref2.error,
          plugins = _ref2.plugins;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_views_settings_components_settingsPageHeader__["default"], { title: Object(__WEBPACK_IMPORTED_MODULE_1_app_locale__["t"])('Integrations') }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_views_projectPlugins_organizationIntegrations__["a" /* default */], {
          orgId: this.props.params.orgId,
          projectId: this.props.params.projectId
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_views_projectPlugins_projectPlugins__["a" /* default */], _extends({}, this.props, {
          onError: this.fetchData,
          onChange: this.handleChange,
          loading: loading,
          error: error,
          plugins: plugins
        }))
      );
    }
  }]);

  return ProjectPluginsContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  plugins: __WEBPACK_IMPORTED_MODULE_6_app_proptypes__["e" /* default */].PluginsStore
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_app_utils_withPlugins__["a" /* default */])(ProjectPluginsContainer));

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_views_projectPlugins_projectPluginRow__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_views_routeError__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_proptypes__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ProjectPlugins = (_temp = _class = function (_Component) {
  _inherits(ProjectPlugins, _Component);

  function ProjectPlugins() {
    _classCallCheck(this, ProjectPlugins);

    return _possibleConstructorReturn(this, (ProjectPlugins.__proto__ || Object.getPrototypeOf(ProjectPlugins)).apply(this, arguments));
  }

  _createClass(ProjectPlugins, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          plugins = _props.plugins,
          loading = _props.loading,
          error = _props.error,
          onError = _props.onError,
          onChange = _props.onChange,
          routes = _props.routes,
          params = _props.params;

      var hasError = error;
      var isLoading = !hasError && loading;

      if (hasError) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_views_routeError__["a" /* default */], { error: error, component: this, onRetry: onError });
      }

      if (isLoading) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_loadingIndicator__["default"], null);
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_panels__["a" /* Panel */], {
        title: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Legacy Integration')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Enabled')
          )
        ),
        body: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],
          null,
          plugins.map(function (plugin) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_app_components_panels__["f" /* PanelItem */],
              { key: plugin.id },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_views_projectPlugins_projectPluginRow__["a" /* default */], _extends({
                params: params,
                routes: routes
              }, plugin, {
                onChange: onChange
              }))
            );
          })
        )
      });
    }
  }]);

  return ProjectPlugins;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.propTypes = {
  plugins: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_app_proptypes__["e" /* default */].PluginShape),
  loading: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  error: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onError: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  routes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (ProjectPlugins);

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_dynamicWrapper__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_externalLink__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_plugins_components_pluginIcon__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_switch__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_utils_recreateRoute__ = __webpack_require__(148);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var grayText = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["css"])('color:#979ba0;');

var ProjectPluginRow = (_temp2 = _class = function (_React$PureComponent) {
  _inherits(ProjectPluginRow, _React$PureComponent);

  function ProjectPluginRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProjectPluginRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProjectPluginRow.__proto__ || Object.getPrototypeOf(ProjectPluginRow)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function () {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          id = _this$props.id,
          enabled = _this$props.enabled;

      onChange(id, !enabled);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProjectPluginRow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          name = _props.name,
          slug = _props.slug,
          version = _props.version,
          author = _props.author,
          hasConfiguration = _props.hasConfiguration,
          enabled = _props.enabled;


      var configureUrl = Object(__WEBPACK_IMPORTED_MODULE_12_app_utils_recreateRoute__["a" /* default */])(id, this.props);
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Flex"],
        { key: id, className: slug, flex: '1', align: 'center' },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          PluginInfo,
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(StyledPluginIcon, { size: 48, pluginId: id }),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Flex"],
            { justify: 'center', direction: 'column' },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              PluginName,
              null,
              name + ' ',
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_dynamicWrapper__["default"], {
                value: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  Version,
                  null,
                  version ? 'v' + version : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    'em',
                    null,
                    Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('n/a')
                  )
                ),
                fixed: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  Version,
                  null,
                  'v10'
                )
              })
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              'div',
              null,
              author && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_app_components_externalLink__["a" /* default */],
                {
                  className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(grayText),
                  href: author.url },
                author.name
              ),
              hasConfiguration && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'span',
                null,
                ' ',
                '\xB7',
                ' ',
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                  {
                    className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(grayText),
                    to: configureUrl },
                  Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('Configure plugin')
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_switch__["default"], { size: 'lg', isActive: enabled, toggle: this.handleChange })
      );
    }
  }]);

  return ProjectPluginRow;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent), _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_10_app_proptypes__["e" /* default */].Plugin, {
  onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
}), _temp2);


/* harmony default export */ __webpack_exports__["a"] = (ProjectPluginRow);

// Includes icon, name, version, configure link
var PluginInfo = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])('div', {
  target: 'ectqpp0'
})('display:flex;flex:1;line-height:24px;');

var PluginName = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])('div', {
  target: 'ectqpp1'
})('font-size:16px;');

var StyledPluginIcon = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_9_app_plugins_components_pluginIcon__["a" /* default */], {
  target: 'ectqpp2'
})('margin-right:16px;');

// Keeping these colors the same from old integrations page
var Version = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])('span', {
  target: 'ectqpp3'
})('color:#babec2;');

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrganizationIntegrations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_asyncComponent__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_plugins_components_pluginIcon__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_utils_theme__ = __webpack_require__(126);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var ProviderName = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('div', {
  target: 'e5libwy0'
})('font-size:16px;font-weight:bold;margin-bottom:3px;');

var TeamName = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_4_react_emotion__["default"])('div', {
  target: 'e5libwy1'
})('color:', function (p) {
  return p.theme.gray2;
}, ';font-size:14px;');

var OrganizationIntegrations = (_temp = _class = function (_AsyncComponent) {
  _inherits(OrganizationIntegrations, _AsyncComponent);

  function OrganizationIntegrations() {
    _classCallCheck(this, OrganizationIntegrations);

    return _possibleConstructorReturn(this, (OrganizationIntegrations.__proto__ || Object.getPrototypeOf(OrganizationIntegrations)).apply(this, arguments));
  }

  _createClass(OrganizationIntegrations, [{
    key: 'getEndpoints',
    value: function getEndpoints() {
      var orgId = this.props.orgId;

      return [['config', '/organizations/' + orgId + '/config/integrations/'], ['organization', '/organizations/' + orgId + '/']];
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _props = this.props,
          orgId = _props.orgId,
          projectId = _props.projectId;

      var orgFeatures = new Set(this.state.organization.features);
      var internalIntegrations = new Set(['jira']);

      var integrations = this.state.config.providers.filter(function (provider) {
        return orgFeatures.has('internal-catchall') || !internalIntegrations.has(provider.key);
      }).map(function (provider) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_app_components_panels__["f" /* PanelItem */],
          { key: provider.key, align: 'center' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Box"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_plugins_components_pluginIcon__["a" /* default */], { size: 32, pluginId: provider.key })
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Box"],
            { px: 2, flex: 1 },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              ProviderName,
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_app_components_link__["a" /* default */],
                {
                  to: '/settings/' + orgId + '/' + projectId + '/integrations/' + provider.key + '/',
                  className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])({ color: __WEBPACK_IMPORTED_MODULE_11_app_utils_theme__["default"].gray5 })
                },
                provider.name
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              TeamName,
              null,
              provider.metadata.author
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Box"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_app_components_buttons_button__["default"],
              {
                size: 'small',
                to: '/settings/' + orgId + '/' + projectId + '/integrations/' + provider.key + '/'
              },
              Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Configure')
            )
          )
        );
      });

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_app_components_panels__["a" /* Panel */],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_app_components_panels__["e" /* PanelHeader */],
          { disablePadding: true },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Box"],
            { px: 2, flex: '1' },
            Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Global Integrations')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_app_components_panels__["c" /* PanelBody */],
          null,
          integrations
        )
      );
    }
  }]);

  return OrganizationIntegrations;
}(__WEBPACK_IMPORTED_MODULE_6_app_components_asyncComponent__["default"]), _class.propTypes = {
  orgId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  projectId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
}, _temp);


/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProjectPluginDetails */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_actionCreators_plugins__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_views_asyncView__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_buttons_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_externalLink__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_stores_indicatorStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_pluginConfig__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_views_settings_components_settingsPageHeader__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_utils_withPlugins__ = __webpack_require__(226);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













/**
 * There are currently two sources of truths for plugin details:
 *
 * 1) PluginsStore has a list of plugins, and this is where ENABLED state lives
 * 2) We fetch "plugin details" via API and save it to local state as `pluginDetails`.
 *    This is because "details" call contains form `config` and the "list" endpoint does not.
 *    The more correct way would be to pass `config` to PluginConfig and use plugin from
 *    PluginsStore
 */

var ProjectPluginDetails = function (_AsyncView) {
  _inherits(ProjectPluginDetails, _AsyncView);

  function ProjectPluginDetails() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProjectPluginDetails);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProjectPluginDetails.__proto__ || Object.getPrototypeOf(ProjectPluginDetails)).call.apply(_ref, [this].concat(args))), _this), _this.handleReset = function () {
      var _this$props$params = _this.props.params,
          projectId = _this$props$params.projectId,
          orgId = _this$props$params.orgId,
          pluginId = _this$props$params.pluginId;

      var loadingIndicator = __WEBPACK_IMPORTED_MODULE_6_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Saving changes..'));
      _this.api.request('/projects/' + orgId + '/' + projectId + '/plugins/' + pluginId + '/', {
        method: 'POST',
        data: { reset: true },
        success: function success(pluginDetails) {
          _this.setState({ pluginDetails: pluginDetails });
          __WEBPACK_IMPORTED_MODULE_6_app_stores_indicatorStore__["default"].addSuccess(Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Plugin was reset'));
        },
        error: function error() {
          __WEBPACK_IMPORTED_MODULE_6_app_stores_indicatorStore__["default"].addError(Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('An error occurred'));
        },
        complete: function complete() {
          return __WEBPACK_IMPORTED_MODULE_6_app_stores_indicatorStore__["default"].remove(loadingIndicator);
        }
      });
    }, _this.handleEnable = function () {
      Object(__WEBPACK_IMPORTED_MODULE_1_app_actionCreators_plugins__["b" /* enablePlugin */])(_this.props.params);
    }, _this.handleDisable = function () {
      Object(__WEBPACK_IMPORTED_MODULE_1_app_actionCreators_plugins__["a" /* disablePlugin */])(_this.props.params);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProjectPluginDetails, [{
    key: 'getTitle',
    value: function getTitle() {
      var plugin = this.state.plugin;

      if (plugin && plugin.name) {
        return plugin.name;
      } else {
        return 'Sentry';
      }
    }
  }, {
    key: 'getEndpoints',
    value: function getEndpoints() {
      var _props$params = this.props.params,
          projectId = _props$params.projectId,
          orgId = _props$params.orgId,
          pluginId = _props$params.pluginId;

      return [['pluginDetails', '/projects/' + orgId + '/' + projectId + '/plugins/' + pluginId + '/']];
    }
  }, {
    key: 'trimSchema',
    value: function trimSchema(value) {
      return value.split('//')[1];
    }
  }, {
    key: 'getEnabled',


    // Enabled state is handled via PluginsStore and not via plugins detail
    value: function getEnabled() {
      var _this2 = this;

      var pluginDetails = this.state.pluginDetails;
      var plugins = this.props.plugins;


      var plugin = plugins && plugins.plugins && plugins.plugins.find(function (_ref2) {
        var slug = _ref2.slug;
        return slug === _this2.props.params.pluginId;
      });

      return plugin ? plugin.enabled : pluginDetails && pluginDetails.enabled;
    }
  }, {
    key: 'renderActions',
    value: function renderActions() {
      var pluginDetails = this.state.pluginDetails;

      var enabled = this.getEnabled();

      var enable = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_app_components_buttons_button__["default"],
        { onClick: this.handleEnable, style: { marginRight: '6px' } },
        Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Enable Plugin')
      );

      var disable = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_app_components_buttons_button__["default"],
        { priority: 'danger', onClick: this.handleDisable, style: { marginRight: '6px' } },
        Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Disable Plugin')
      );

      var toggleEnable = enabled ? disable : enable;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'pull-right' },
        pluginDetails.canDisable && toggleEnable,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_app_components_buttons_button__["default"],
          { onClick: this.handleReset },
          Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Reset Configuration')
        )
      );
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _props = this.props,
          organization = _props.organization,
          project = _props.project;
      var pluginDetails = this.state.pluginDetails;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_views_settings_components_settingsPageHeader__["default"], { title: pluginDetails.name, action: this.renderActions() }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-7' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_pluginConfig__["default"], {
              organization: organization,
              project: project,
              data: pluginDetails,
              enabled: this.getEnabled(),
              onDisablePlugin: this.handleDisable
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-4 col-md-offset-1' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'pluginDetails-meta' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Plugin Information')
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'dl',
                { className: 'flat' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'dt',
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Name')
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'dd',
                  null,
                  pluginDetails.name
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'dt',
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Author')
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'dd',
                  null,
                  pluginDetails.author.name
                ),
                pluginDetails.author.url && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'dt',
                    null,
                    Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('URL')
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'dd',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_5_app_components_externalLink__["a" /* default */],
                      { href: pluginDetails.author.url },
                      this.trimSchema(pluginDetails.author.url)
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'dt',
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Version')
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'dd',
                  null,
                  pluginDetails.version
                )
              ),
              pluginDetails.description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h4',
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Description')
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: 'description' },
                  pluginDetails.description
                )
              ),
              pluginDetails.resourceLinks && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h4',
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Resources')
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'dl',
                  { className: 'flat' },
                  pluginDetails.resourceLinks.map(function (_ref3) {
                    var title = _ref3.title,
                        url = _ref3.url;
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'dd',
                      { key: url },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_app_components_externalLink__["a" /* default */],
                        { href: url },
                        title
                      )
                    );
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ProjectPluginDetails;
}(__WEBPACK_IMPORTED_MODULE_3_app_views_asyncView__["default"]);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_app_utils_withPlugins__["a" /* default */])(ProjectPluginDetails));

/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_utils_withEnvironmentInQueryString__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_groupList__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ReleaseAllEvents = (_temp = _class = function (_React$Component) {
  _inherits(ReleaseAllEvents, _React$Component);

  function ReleaseAllEvents() {
    _classCallCheck(this, ReleaseAllEvents);

    return _possibleConstructorReturn(this, (ReleaseAllEvents.__proto__ || Object.getPrototypeOf(ReleaseAllEvents)).apply(this, arguments));
  }

  _createClass(ReleaseAllEvents, [{
    key: 'render',
    value: function render() {
      var _props$params = this.props.params,
          orgId = _props$params.orgId,
          projectId = _props$params.projectId;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'alert alert-block' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
            {
              to: {
                pathname: '/' + orgId + '/' + projectId + '/',
                query: { query: 'release:' + this.context.release.version }
              }
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon icon-open' }),
            Object(__WEBPACK_IMPORTED_MODULE_6_app_locale__["t"])('View all events seen in this release in the stream')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_groupList__["a" /* default */], {
          orgId: orgId,
          projectId: projectId,
          query: 'release:"' + this.context.release.version + '"',
          canSelectGroups: false,
          environment: this.props.environment
        })
      );
    }
  }]);

  return ReleaseAllEvents;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  environment: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Environment
}, _class.contextTypes = {
  release: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_app_utils_withEnvironmentInQueryString__["a" /* default */])(ReleaseAllEvents));

/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_panels__ = __webpack_require__(18);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var GroupListHeader = function (_React$Component) {
  _inherits(GroupListHeader, _React$Component);

  function GroupListHeader() {
    _classCallCheck(this, GroupListHeader);

    return _possibleConstructorReturn(this, (GroupListHeader.__proto__ || Object.getPrototypeOf(GroupListHeader)).apply(this, arguments));
  }

  _createClass(GroupListHeader, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_app_components_panels__["e" /* PanelHeader */],
        { disablePadding: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Box"],
          { w: [8 / 12, 8 / 12, 6 / 12], mx: 2, flex: '1', className: 'toolbar-header' },
          Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Event')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Box"],
          { w: 160, mx: 2, className: 'toolbar-header hidden-xs hidden-sm' },
          Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Last 24 hours')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Flex"],
          { w: 80, mx: 2, justify: 'flex-end', className: 'toolbar-header' },
          Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('events')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Flex"],
          { w: 80, mx: 2, justify: 'flex-end', className: 'toolbar-header' },
          Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('users')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_grid_emotion__["Flex"],
          {
            w: 80,
            mx: 2,
            justify: 'flex-end',
            className: 'hidden-xs hidden-sm toolbar-header'
          },
          Object(__WEBPACK_IMPORTED_MODULE_2_app_locale__["t"])('Assignee')
        )
      );
    }
  }]);

  return GroupListHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (GroupListHeader);

/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_stores_selectedGroupStore__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_checkbox__ = __webpack_require__(208);








var GroupCheckBox = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'GroupCheckBox',

  propTypes: {
    id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_4_app_stores_selectedGroupStore__["a" /* default */], 'onSelectedGroupChange')],

  getInitialState: function getInitialState() {
    return {
      isSelected: __WEBPACK_IMPORTED_MODULE_4_app_stores_selectedGroupStore__["a" /* default */].isSelected(this.props.id)
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.id != this.props.id) {
      this.setState({
        isSelected: __WEBPACK_IMPORTED_MODULE_4_app_stores_selectedGroupStore__["a" /* default */].isSelected(nextProps.id)
      });
    }
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return nextState.isSelected !== this.state.isSelected;
  },
  onSelectedGroupChange: function onSelectedGroupChange() {
    var isSelected = __WEBPACK_IMPORTED_MODULE_4_app_stores_selectedGroupStore__["a" /* default */].isSelected(this.props.id);
    if (isSelected !== this.state.isSelected) {
      this.setState({
        isSelected: isSelected
      });
    }
  },
  onSelect: function onSelect() {
    var id = this.props.id;
    __WEBPACK_IMPORTED_MODULE_4_app_stores_selectedGroupStore__["a" /* default */].toggleSelect(id);
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_checkbox__["a" /* default */], {
      value: this.props.id,
      checked: this.state.isSelected,
      onChange: this.onSelect
    });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (GroupCheckBox);

/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_mixins_organizationState__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_fileSize__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_stores_indicatorStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_pagination__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_linkWithConfirmation__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_components_emptyStateWarning__ = __webpack_require__(57);



















var ReleaseArtifacts = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'ReleaseArtifacts',

  contextTypes: {
    release: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_5_app_mixins_organizationState__["a" /* default */]],

  getInitialState: function getInitialState() {
    return {
      loading: true,
      error: false,
      fileList: [],
      pageLinks: null
    };
  },
  componentDidMount: function componentDidMount() {
    this.fetchData();
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      this.fetchData();
    }
  },
  getFilesEndpoint: function getFilesEndpoint() {
    var params = this.props.params;
    return '/projects/' + params.orgId + '/' + params.projectId + '/releases/' + encodeURIComponent(params.version) + '/files/';
  },
  fetchData: function fetchData() {
    var _this = this;

    this.setState({
      loading: true,
      error: false
    });

    this.api.request(this.getFilesEndpoint(), {
      method: 'GET',
      data: this.props.location.query,
      success: function success(data, _, jqXHR) {
        _this.setState({
          error: false,
          loading: false,
          fileList: data,
          pageLinks: jqXHR.getResponseHeader('Link')
        });
      },
      error: function error() {
        _this.setState({
          error: true,
          loading: false
        });
      }
    });
  },
  handleRemove: function handleRemove(id) {
    var _this2 = this;

    var loadingIndicator = __WEBPACK_IMPORTED_MODULE_10_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Removing artifact..'));

    this.api.request(this.getFilesEndpoint() + (id + '/'), {
      method: 'DELETE',
      success: function success() {
        var fileList = _this2.state.fileList.filter(function (file) {
          return file.id !== id;
        });

        _this2.setState({
          fileList: fileList
        });

        __WEBPACK_IMPORTED_MODULE_10_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Artifact removed.'), 'success', {
          duration: 4000
        });
      },
      error: function error() {
        __WEBPACK_IMPORTED_MODULE_10_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Unable to remove artifact. Please try again.'), 'error', {
          duration: 4000
        });
      },
      complete: function complete() {
        __WEBPACK_IMPORTED_MODULE_10_app_stores_indicatorStore__["default"].remove(loadingIndicator);
      }
    });
  },
  render: function render() {
    var _this3 = this;

    if (this.state.loading) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_loadingIndicator__["default"], null);else if (this.state.error) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_loadingError__["default"], { onRetry: this.fetchData });else if (this.state.fileList.length === 0) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_14_app_components_panels__["a" /* Panel */],
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_15_app_components_emptyStateWarning__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('There are no artifacts uploaded for this release.')
        )
      )
    );

    var access = this.getAccess();

    // TODO(dcramer): files should allow you to download them
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_14_app_components_panels__["a" /* Panel */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_app_components_panels__["e" /* PanelHeader */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Flex"],
            { flex: '7', pr: 2 },
            Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Name')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Flex"],
            { flex: '2' },
            Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Distribution')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Flex"],
            { flex: '3' },
            Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Size')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_app_components_panels__["c" /* PanelBody */],
          null,
          this.state.fileList.map(function (file) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_14_app_components_panels__["f" /* PanelItem */],
              { key: file.id },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Flex"],
                {
                  flex: '7',
                  pr: 2,
                  style: { wordWrap: 'break-word', wordBreak: 'break-all' }
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'strong',
                  null,
                  file.name || '(empty)'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Flex"],
                { flex: '2' },
                file.dist || __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  { className: 'text-light' },
                  Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('None')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Flex"],
                { flex: '3', justify: 'space-between' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_fileSize__["a" /* default */], { bytes: file.size }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Flex"],
                  { align: 'center' },
                  access.has('project:write') ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'a',
                    {
                      href: _this3.api.baseUrl + _this3.getFilesEndpoint() + (file.id + '/?download=1'),
                      className: 'btn btn-sm btn-default'
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon icon-open' })
                  ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_app_components_tooltip__["default"],
                    {
                      title: Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('You do not have the required permission to download this artifact.')
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { className: 'btn btn-sm btn-default disabled' },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon icon-open' })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { style: { marginLeft: 5 } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_12_app_components_linkWithConfirmation__["a" /* default */],
                      {
                        className: 'btn btn-sm btn-default',
                        title: Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Delete artifact'),
                        message: Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Are you sure you want to remove this artifact?'),
                        onConfirm: _this3.handleRemove.bind(_this3, file.id)
                      },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon icon-trash' })
                    )
                  )
                )
              )
            );
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_pagination__["default"], { pageLinks: this.state.pageLinks })
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ReleaseArtifacts);

/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_dropdownLink__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_menuItem__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_commitRow__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_panels__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_emptyStateWarning__ = __webpack_require__(57);














var ReleaseCommits = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'ReleaseCommits',
  mixins: [__WEBPACK_IMPORTED_MODULE_6_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    return {
      loading: true,
      error: false,
      commitList: [],
      activeRepo: null
    };
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    var _props$params = this.props.params,
        orgId = _props$params.orgId,
        projectId = _props$params.projectId,
        version = _props$params.version;


    var path = '/projects/' + orgId + '/' + projectId + '/releases/' + encodeURIComponent(version) + '/commits/';
    this.api.request(path, {
      method: 'GET',
      data: this.props.location.query,
      success: function success(data, _, jqXHR) {
        _this.setState({
          error: false,
          loading: false,
          commitList: data,
          pageLinks: jqXHR.getResponseHeader('Link')
        });
      },
      error: function error() {
        _this.setState({
          error: true,
          loading: false
        });
      }
    });
  },
  emptyState: function emptyState() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_app_components_panels__["a" /* Panel */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_app_components_emptyStateWarning__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('There are no commits associated with this release.')
        )
      )
    );
  },
  setActiveRepo: function setActiveRepo(repo) {
    this.setState({
      activeRepo: repo
    });
  },
  getCommitsByRepository: function getCommitsByRepository() {
    var commitList = this.state.commitList;

    var commitsByRepository = commitList.reduce(function (cbr, commit) {
      var repository = commit.repository;

      if (!cbr.hasOwnProperty(repository.name)) {
        cbr[repository.name] = [];
      }

      cbr[repository.name].push(commit);
      return cbr;
    }, {});
    return commitsByRepository;
  },
  renderCommitsForRepo: function renderCommitsForRepo(repo) {
    var commitsByRepository = this.getCommitsByRepository();
    var activeCommits = commitsByRepository[repo];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_app_components_panels__["a" /* Panel */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_app_components_panels__["e" /* PanelHeader */],
        null,
        repo
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_app_components_panels__["c" /* PanelBody */],
        null,
        activeCommits.map(function (commit) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_commitRow__["a" /* default */], { key: commit.id, commit: commit });
        })
      )
    );
  },
  render: function render() {
    var _this2 = this;

    if (this.state.loading) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_loadingIndicator__["default"], null);

    if (this.state.error) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_loadingError__["default"], null);

    var _state = this.state,
        commitList = _state.commitList,
        activeRepo = _state.activeRepo;


    if (!commitList.length) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.emptyState, null);
    var commitsByRepository = this.getCommitsByRepository();
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'heading' },
        Object.keys(commitsByRepository).length > 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'commits-dropdown align-left' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'commits-dropdowng' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_app_components_dropdownLink__["default"],
              {
                caret: true,
                title: this.state.activeRepo || 'All Repositories'
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_app_components_menuItem__["default"],
                {
                  key: 'all',
                  noAnchor: true,
                  onClick: function onClick() {
                    _this2.setActiveRepo(null);
                  },
                  isActive: this.state.activeRepo === null
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('All Repositories')
                )
              ),
              Object.keys(commitsByRepository).map(function (repository) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_app_components_menuItem__["default"],
                  {
                    key: commitsByRepository[repository].id,
                    noAnchor: true,
                    onClick: function onClick() {
                      _this2.setActiveRepo(repository);
                    },
                    isActive: _this2.state.activeRepo === repository
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    null,
                    repository
                  )
                );
              })
            )
          )
        ) : null
      ),
      activeRepo ? this.renderCommitsForRepo(activeRepo) : Object.keys(commitsByRepository).map(function (repository) {
        return _this2.renderCommitsForRepo(repository);
      })
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ReleaseCommits);

/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_document_title__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_count__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_externalLink__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_listLink__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_mixins_projectState__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_releaseStats__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_textOverflow__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_components_timeSince__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_components_version__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_utils_withEnvironmentInQueryString__ = __webpack_require__(69);




















var ReleaseDetails = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'ReleaseDetails',

  propTypes: {
    setProjectNavSection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    environment: __WEBPACK_IMPORTED_MODULE_13_app_proptypes__["e" /* default */].Environment
  },

  contextTypes: {
    location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  },

  childContextTypes: {
    release: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_11_app_mixins_projectState__["a" /* default */]],

  getInitialState: function getInitialState() {
    return {
      release: null,
      loading: true,
      error: false
    };
  },
  getChildContext: function getChildContext() {
    return {
      release: this.state.release
    };
  },
  componentWillMount: function componentWillMount() {
    this.props.setProjectNavSection('releases');
    this.fetchData();
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    if (this.props.environment !== prevProps.environment) {
      this.fetchData();
    }
  },
  getTitle: function getTitle() {
    var project = this.getProject();
    var params = this.props.params;
    return 'Release ' + params.version + ' | ' + project.slug;
  },
  fetchData: function fetchData() {
    var _this = this;

    this.setState({
      loading: true,
      error: false
    });

    var environment = this.props.environment;

    var query = environment ? { environment: environment.name } : {};

    this.api.request(this.getReleaseDetailsEndpoint(), {
      query: query,
      success: function success(data) {
        _this.setState({
          loading: false,
          release: data
        });
      },
      error: function error() {
        _this.setState({
          loading: false,
          error: true
        });
      }
    });
  },
  getReleaseDetailsEndpoint: function getReleaseDetailsEndpoint() {
    var params = this.props.params;
    var orgId = params.orgId;
    var projectId = params.projectId;
    var version = params.version;

    return '/projects/' + orgId + '/' + projectId + '/releases/' + encodeURIComponent(version) + '/';
  },
  render: function render() {
    var _this2 = this;

    if (this.state.loading) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_loadingIndicator__["default"], null);else if (this.state.error) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_loadingError__["default"], { onRetry: this.fetchData });

    var release = this.state.release;
    var _props$params = this.props.params,
        orgId = _props$params.orgId,
        projectId = _props$params.projectId;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_document_title___default.a,
      { title: this.getTitle() },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'ref-release-details' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'release-details' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'col-sm-4 col-xs-12' },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'h3',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Release'),
                ' ',
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'strong',
                  null,
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_app_components_version__["a" /* default */], {
                    orgId: orgId,
                    projectId: projectId,
                    version: release.version,
                    anchor: false
                  })
                )
              ),
              !!release.url && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_app_components_externalLink__["a" /* default */],
                  { href: release.url },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_14_app_components_textOverflow__["a" /* default */],
                    null,
                    release.url
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: 'release-meta' },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon icon-clock' }),
                ' ',
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_app_components_timeSince__["default"], { date: release.dateCreated })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'col-sm-2 hidden-xs' },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_releaseStats__["a" /* default */], { release: release })
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'col-sm-2 hidden-xs' },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: 'release-stats' },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'h6',
                  { className: 'nav-header' },
                  Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('New Issues')
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'span',
                  { className: 'stream-count' },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_count__["default"], { value: release.newGroups })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'col-sm-2 hidden-xs' },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: 'release-stats' },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'h6',
                  { className: 'nav-header' },
                  Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('First Event')
                ),
                release.firstEvent ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'span',
                  { className: 'stream-count' },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_app_components_timeSince__["default"], { date: release.firstEvent })
                ) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'span',
                  null,
                  '\u2014'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'col-sm-2 hidden-xs' },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: 'release-stats' },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'h6',
                  { className: 'nav-header' },
                  Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Last Event')
                ),
                release.lastEvent ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'span',
                  { className: 'stream-count' },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_app_components_timeSince__["default"], { date: release.lastEvent })
                ) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'span',
                  null,
                  '\u2014'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'ul',
            { className: 'nav nav-tabs' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_app_components_listLink__["default"],
              {
                to: '/' + orgId + '/' + projectId + '/releases/' + encodeURIComponent(release.version) + '/',
                isActive: function isActive(loc) {
                  // react-router isActive will return true for any route that is part of the active route
                  // e.g. parent routes. To avoid matching on sub-routes, insist on strict path equality.
                  return loc.pathname === _this2.props.location.pathname;
                }
              },
              Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Overview')
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_app_components_listLink__["default"],
              {
                to: '/' + orgId + '/' + projectId + '/releases/' + encodeURIComponent(release.version) + '/new-events/'
              },
              Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('New Issues')
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_app_components_listLink__["default"],
              {
                to: '/' + orgId + '/' + projectId + '/releases/' + encodeURIComponent(release.version) + '/all-events/'
              },
              Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('All Issues')
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_app_components_listLink__["default"],
              {
                to: '/' + orgId + '/' + projectId + '/releases/' + encodeURIComponent(release.version) + '/artifacts/'
              },
              Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Artifacts')
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_app_components_listLink__["default"],
              {
                to: '/' + orgId + '/' + projectId + '/releases/' + encodeURIComponent(release.version) + '/commits/'
              },
              Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Commits')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(this.props.children, {
          release: release,
          environment: this.props.environment
        })
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_17_app_utils_withEnvironmentInQueryString__["a" /* default */])(ReleaseDetails));

/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_groupList__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_utils_withEnvironmentInQueryString__ = __webpack_require__(69);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ReleaseNewEvents = (_temp = _class = function (_React$Component) {
  _inherits(ReleaseNewEvents, _React$Component);

  function ReleaseNewEvents() {
    _classCallCheck(this, ReleaseNewEvents);

    return _possibleConstructorReturn(this, (ReleaseNewEvents.__proto__ || Object.getPrototypeOf(ReleaseNewEvents)).apply(this, arguments));
  }

  _createClass(ReleaseNewEvents, [{
    key: 'render',
    value: function render() {
      var _props$params = this.props.params,
          orgId = _props$params.orgId,
          projectId = _props$params.projectId;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'alert alert-block' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
            {
              to: {
                pathname: '/' + orgId + '/' + projectId + '/',
                query: { query: 'first-release:' + this.context.release.version }
              }
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon icon-open' }),
            Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('View new events seen in this release in the stream')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_groupList__["a" /* default */], {
          orgId: orgId,
          projectId: projectId,
          query: 'first-release:"' + this.context.release.version + '"',
          canSelectGroups: false,
          environment: this.props.environment
        })
      );
    }
  }]);

  return ReleaseNewEvents;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  environment: __WEBPACK_IMPORTED_MODULE_3_app_proptypes__["e" /* default */].Environment
}, _class.contextTypes = {
  release: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_app_utils_withEnvironmentInQueryString__["a" /* default */])(ReleaseNewEvents));

/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_utils_withEnvironmentInQueryString__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_icons_icon_open__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_lastCommit__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_issueList__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_commitAuthorStats__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_releaseProjectStatSparkline__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_repositoryFileSummary__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_timeSince__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_mixins_organizationState__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_components_panels__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
























var ReleaseOverview = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'ReleaseOverview',

  propTypes: {
    environment: __WEBPACK_IMPORTED_MODULE_15_app_proptypes__["e" /* default */].Environment
  },

  contextTypes: {
    release: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_13_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_16_app_mixins_organizationState__["a" /* default */]],

  getInitialState: function getInitialState() {
    return {
      loading: true,
      error: false,
      projects: [],
      fileList: [],
      deploys: [],
      hasRepos: false
    };
  },
  componentDidMount: function componentDidMount() {
    this.fetchAll();
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    if (prevProps.environment !== this.props.environment) {
      this.fetchAll();
    }
  },
  fetchAll: function fetchAll() {
    var _this = this;

    var _props$params = this.props.params,
        orgId = _props$params.orgId,
        version = _props$params.version;

    var query = _extends({}, this.props.location.query);

    if (this.props.environment) {
      query.environment = this.props.environment.name;
    } else {
      delete query.environment;
    }

    var path = '/organizations/' + orgId + '/releases/' + encodeURIComponent(version) + '/commitfiles/';
    this.api.request(path, {
      method: 'GET',
      data: query,
      success: function success(data, _, jqXHR) {
        _this.setState({
          fileList: data
        });
      },
      error: function error() {
        _this.setState({
          error: true
        });
      }
    });
    this.getReleaseProjects();
    this.getDeploys();
    this.getRepos();
  },
  getReleaseProjects: function getReleaseProjects() {
    var _this2 = this;

    var _props$params2 = this.props.params,
        orgId = _props$params2.orgId,
        version = _props$params2.version;

    var query = this.props.environment ? { environment: this.props.environment.name } : {};

    var path = '/organizations/' + orgId + '/releases/' + encodeURIComponent(version) + '/';
    this.api.request(path, {
      query: query,
      method: 'GET',
      success: function success(data, _, jqXHR) {
        _this2.setState({
          projects: data.projects
        });
      },
      error: function error() {
        _this2.setState({
          error: true
        });
      }
    });
  },
  getDeploys: function getDeploys() {
    var _this3 = this;

    var _props$params3 = this.props.params,
        orgId = _props$params3.orgId,
        version = _props$params3.version;


    var path = '/organizations/' + orgId + '/releases/' + encodeURIComponent(version) + '/deploys/';
    this.api.request(path, {
      method: 'GET',
      success: function success(data, _, jqXHR) {
        _this3.setState({
          deploys: data,
          loading: false
        });
      },
      error: function error() {
        _this3.setState({
          error: true
        });
      }
    });
  },
  getRepos: function getRepos() {
    var _this4 = this;

    var orgId = this.props.params.orgId;

    var query = this.props.environment ? { environment: this.props.environment.name } : {};

    var path = '/organizations/' + orgId + '/repos/';
    this.api.request(path, {
      method: 'GET',
      query: query,
      success: function success(data, _, jqXHR) {
        _this4.setState({
          hasRepos: data.length > 0
        });
      },
      error: function error() {
        _this4.setState({
          error: true
        });
      }
    });
  },
  renderEmpty: function renderEmpty() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'box empty' },
      Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["t"])('None')
    );
  },
  render: function render() {
    var _this5 = this;

    var _props$params4 = this.props.params,
        orgId = _props$params4.orgId,
        projectId = _props$params4.projectId,
        version = _props$params4.version;
    var release = this.context.release;

    var lastCommit = release.lastCommit;

    if (this.state.loading) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_loadingIndicator__["default"], null);

    if (this.state.error) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_loadingError__["default"], null);

    var _state = this.state,
        fileList = _state.fileList,
        projects = _state.projects,
        hasRepos = _state.hasRepos;

    // convert list of individual file changes (can be
    // multiple changes to a single file) into a per-file
    // summary grouped by repository

    var filesByRepository = fileList.reduce(function (fbr, file) {
      var filename = file.filename,
          repoName = file.repoName,
          author = file.author,
          type = file.type;

      if (!fbr.hasOwnProperty(repoName)) {
        fbr[repoName] = {};
      }
      if (!fbr[repoName].hasOwnProperty(filename)) {
        fbr[repoName][filename] = {
          authors: {},
          types: new Set(),
          repos: new Set()
        };
      }

      fbr[repoName][filename].authors[author.email] = author;
      fbr[repoName][filename].types.add(type);

      return fbr;
    }, {});

    var deploys = this.state.deploys;

    var query = this.props.environment ? { environment: this.props.environment.name } : {};

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'row', style: { paddingTop: 10 } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'col-sm-8' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h5',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["t"])('Issues Resolved in this Release')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_issueList__["a" /* default */], {
            endpoint: '/projects/' + orgId + '/' + projectId + '/releases/' + encodeURIComponent(version) + '/resolved/',
            query: query,
            pagination: false,
            renderEmpty: function renderEmpty() {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17_app_components_panels__["a" /* Panel */],
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_17_app_components_panels__["c" /* PanelBody */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17_app_components_panels__["f" /* PanelItem */],
                    { key: 'none', justify: 'center' },
                    Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["t"])('No issues resolved')
                  )
                )
              );
            },
            ref: 'issueList',
            showActions: false,
            params: { orgId: orgId },
            className: 'm-b-2'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h5',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["t"])('New Issues in this Release')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_issueList__["a" /* default */], {
            endpoint: '/projects/' + orgId + '/' + projectId + '/issues/',
            query: _extends({}, query, {
              query: 'first-release:"' + version + '"',
              limit: 5
            }),
            statsPeriod: '0',
            pagination: false,
            renderEmpty: function renderEmpty() {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17_app_components_panels__["a" /* Panel */],
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_17_app_components_panels__["c" /* PanelBody */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17_app_components_panels__["f" /* PanelItem */],
                    { justify: 'center' },
                    Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["t"])('No new issues')
                  )
                )
              );
            },
            ref: 'issueList',
            showActions: false,
            params: { orgId: orgId },
            className: 'm-b-2'
          }),
          hasRepos && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            Object.keys(filesByRepository).map(function (repository, i) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_repositoryFileSummary__["a" /* default */], {
                key: i,
                repository: repository,
                fileChangeSummary: filesByRepository[repository]
              });
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'col-sm-4' },
          hasRepos ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            lastCommit && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_lastCommit__["a" /* default */], { commit: lastCommit, headerClass: 'nav-header' }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_commitAuthorStats__["a" /* default */], {
              orgId: orgId,
              projectId: projectId,
              version: version
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h6',
              { className: 'nav-header m-b-1' },
              Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["t"])('Other Projects Affected')
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'ul',
              { className: 'nav nav-stacked' },
              projects.length === 1 ? this.renderEmpty() : projects.map(function (project) {
                if (project.slug === projectId) {
                  return null;
                }
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_releaseProjectStatSparkline__["a" /* default */], {
                  key: project.id,
                  orgId: orgId,
                  project: project,
                  version: version
                });
              })
            )
          ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'well blankslate m-t-2 m-b-2 p-x-2 p-t-1 p-b-2 align-center' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon icon-git-commit' }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h5',
              null,
              'Releases are better with commit data!'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              'Connect a repository to see commit info, files changed, and authors involved in future releases.'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { className: 'btn btn-primary', href: '/organizations/' + orgId + '/repos/' },
              'Connect a repository'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h6',
            { className: 'nav-header m-b-1' },
            Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["t"])('Deploys')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'ul',
            { className: 'nav nav-stacked' },
            !deploys.length ? this.renderEmpty() : deploys.map(function (deploy) {
              var href = '/' + orgId + '/' + projectId + '/?query=release:' + version + '&environment=' + encodeURIComponent(deploy.environment);

              // TODO(lyn): Remove when environment feature switched on
              if (!_this5.getFeatures().has('environments')) {
                var q = encodeURIComponent('environment:' + deploy.environment + ' release:' + version);
                href = '/' + orgId + '/' + projectId + '/?query=' + q;
              }
              // End remove block

              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'li',
                { key: deploy.id },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  { href: href, title: Object(__WEBPACK_IMPORTED_MODULE_14_app_locale__["t"])('View in stream') },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row row-flex row-center-vertically' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { className: 'col-xs-6' },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'span',
                        {
                          className: 'repo-label',
                          style: { verticalAlign: 'bottom' }
                        },
                        deploy.environment,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_icons_icon_open__["a" /* default */], {
                          className: 'icon-open',
                          size: 11,
                          style: { marginLeft: 6 }
                        })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { className: 'col-xs-6 align-right' },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'small',
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_timeSince__["default"], { date: deploy.dateFinished })
                      )
                    )
                  )
                )
              );
            })
          )
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_app_utils_withEnvironmentInQueryString__["a" /* default */])(ReleaseOverview));

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function IconOpen(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 15 15' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      { stroke: 'currentColor', fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
        d: 'M14.5,8.5 L14.5,13.1823525 C14.5,13.9100691 13.9162615,14.5 13.182914,14.5 L1.81708601,14.5 C1.08967949,14.5 0.5,13.9162615 0.5,13.182914 L0.5,1.81708601 C0.5,1.08967949 1.09439142,0.5 1.80585884,0.5 L6.5,0.5',
        id: 'outer-path'
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M7.5,7.5 L14.5,0.5', id: 'line' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline', { id: 'arrow', points: '9.5 0.5 14.5 0.5 14.5 5.5' })
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (IconOpen);

/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_avatar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_panels__ = __webpack_require__(18);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var CommitBar = (_temp = _class = function (_React$Component) {
  _inherits(CommitBar, _React$Component);

  function CommitBar() {
    _classCallCheck(this, CommitBar);

    return _possibleConstructorReturn(this, (CommitBar.__proto__ || Object.getPrototypeOf(CommitBar)).apply(this, arguments));
  }

  _createClass(CommitBar, [{
    key: 'render',
    value: function render() {
      var barStyle = {};
      barStyle.width = this.props.authorCommits / this.props.totalCommits * 100 + '%';

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'commit-bar', style: barStyle });
    }
  }]);

  return CommitBar;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  totalCommits: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  authorCommits: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
}, _temp);


var CommitAuthorStats = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'CommitAuthorStats',

  propTypes: {
    orgId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    version: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    return {
      loading: true,
      error: false
    };
  },
  componentDidMount: function componentDidMount() {
    var _this2 = this;

    var _props = this.props,
        orgId = _props.orgId,
        projectId = _props.projectId,
        version = _props.version;

    var path = '/projects/' + orgId + '/' + projectId + '/releases/' + encodeURIComponent(version) + '/commits/';
    this.api.request(path, {
      method: 'GET',
      success: function success(data, _, jqXHR) {
        _this2.setState({
          error: false,
          loading: false,
          commitList: data,
          pageLinks: jqXHR.getResponseHeader('Link')
        });
      },
      error: function error() {
        _this2.setState({
          error: true,
          loading: false
        });
      }
    });
  },
  renderEmpty: function renderEmpty() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'box empty' },
      Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('No authors in this release')
    );
  },
  render: function render() {
    if (this.state.loading) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_loadingIndicator__["default"], null);

    if (this.state.error) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_loadingError__["default"], null);

    var commitList = this.state.commitList;


    var commitAuthors = commitList.reduce(function (_commitAuthors, commit) {
      var author = commit.author;

      if (!_commitAuthors.hasOwnProperty(author.email)) {
        _commitAuthors[author.email] = {
          commitCount: 1,
          author: author
        };
      } else {
        _commitAuthors[author.email].commitCount += 1;
      }
      return _commitAuthors;
    }, {});

    var commitAuthorValues = Object.values(commitAuthors);

    // sort commitAuthors by highest commitCount to lowest commitCount
    commitAuthorValues.sort(function (a, b) {
      return b.commitCount - a.commitCount;
    });

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { style: { marginTop: 5 } },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'h6',
        { className: 'nav-header m-b-1' },
        Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Commits by Author')
      ),
      !commitAuthorValues.length && this.renderEmpty(),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_app_components_panels__["a" /* Panel */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_app_components_panels__["c" /* PanelBody */],
          null,
          commitAuthorValues.map(function (commitAuthor, i) {
            var author = commitAuthor.author,
                commitCount = commitAuthor.commitCount;

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_app_components_panels__["f" /* PanelItem */],
              { key: i, p: 1, align: 'center' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Flex"],
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_app_components_tooltip__["default"],
                  { title: author.name + ' ' + author.email },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_avatar__["a" /* default */], { user: author, size: 20 })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_grid_emotion__["Flex"],
                { flex: '1', px: 1 },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CommitBar, {
                  style: { marginLeft: 5 },
                  totalCommits: commitList.length,
                  authorCommits: commitCount
                })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                commitCount
              )
            );
          })
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (CommitAuthorStats);

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_sparklines__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_sparklines___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_sparklines__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_locale__ = __webpack_require__(2);













var ReleaseProjectStatSparkline = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'ReleaseProjectStatSparkline',

  propTypes: {
    orgId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    project: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    version: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_7_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    return {
      loading: true,
      error: false,
      stats: [],
      newIssueCount: null
    };
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    var orgId = this.props.orgId;

    var projectId = this.props.project.slug;
    var path = '/projects/' + orgId + '/' + projectId + '/stats/';
    this.api.request(path, {
      method: 'GET',
      data: 'stat=received',
      success: function success(data, _, jqXHR) {
        _this.setState({
          stats: data
        });
        _this.getNewIssuesCount();
      },
      error: function error() {
        _this.setState({
          error: true
        });
      }
    });
  },
  getNewIssuesCount: function getNewIssuesCount() {
    var _this2 = this;

    var _props = this.props,
        orgId = _props.orgId,
        version = _props.version;

    var projectId = this.props.project.slug;
    var issuesPath = '/projects/' + orgId + '/' + projectId + '/releases/' + encodeURIComponent(version) + '/';
    this.api.request(issuesPath, {
      method: 'GET',
      success: function success(data, _, jqXHR) {
        _this2.setState({
          newIssueCount: data.newGroups,
          loading: false
        });
      },
      error: function error() {
        _this2.setState({
          error: true
        });
      }
    });
  },
  render: function render() {
    var _props2 = this.props,
        orgId = _props2.orgId,
        project = _props2.project,
        version = _props2.version;

    var newIssueCount = this.state.newIssueCount;
    var values = this.state.stats.map(function (tuple) {
      return tuple[1];
    });
    if (this.state.loading) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_loadingIndicator__["default"], null);

    if (this.state.error) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_loadingError__["default"], null);
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'li',
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'sparkline pull-right', style: { width: 96 } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_sparklines__["Sparklines"],
          { data: values, width: 100, height: 32 },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_sparklines__["SparklinesLine"], { style: { stroke: '#8f85d4', fill: 'none', strokeWidth: 3 } })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router__["Link"],
        { to: '/' + orgId + '/' + project.slug + '/releases/' + encodeURIComponent(version) + '/' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h6',
          { className: 'm-b-0' },
          project.slug
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { className: 'm-b-0 text-muted' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'small',
            null,
            newIssueCount > 0 ? Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["tn"])('%d new issue', '%d new issues', newIssueCount) : Object(__WEBPACK_IMPORTED_MODULE_8_app_locale__["t"])('No new issues')
          )
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ReleaseProjectStatSparkline);

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_fileChange__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






function Collapsed(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'li',
    { className: 'list-group-item list-group-item-sm align-center' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon-container' }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'a',
      { onClick: props.onClick },
      Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["tn"])('Show %d collapsed file', 'Show %d collapsed files', props.count)
    )
  );
}

Collapsed.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  count: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
};

var RepositoryFileSummary = (_temp = _class = function (_React$Component) {
  _inherits(RepositoryFileSummary, _React$Component);

  function RepositoryFileSummary() {
    var _ref;

    _classCallCheck(this, RepositoryFileSummary);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = RepositoryFileSummary.__proto__ || Object.getPrototypeOf(RepositoryFileSummary)).call.apply(_ref, [this].concat(args)));

    _this.onCollapseToggle = function () {
      _this.setState({
        collapsed: !_this.state.collapsed
      });
    };

    _this.state = {
      loading: true,
      collapsed: true
    };
    return _this;
  }

  _createClass(RepositoryFileSummary, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          repository = _props.repository,
          fileChangeSummary = _props.fileChangeSummary;

      var MAX = RepositoryFileSummary.MAX_WHEN_COLLAPSED;
      var files = Object.keys(fileChangeSummary);
      var fileCount = files.length;
      files.sort();
      if (this.state.collapsed && fileCount > MAX) {
        files = files.slice(0, MAX);
      }
      var numCollapsed = fileCount - files.length;
      var canCollapse = fileCount > MAX;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h5',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["tn"])('%d file changed in ' + repository, '%d files changed in ' + repository, fileCount)
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'ul',
          { className: 'list-group list-group-striped m-b-2' },
          files.map(function (filename) {
            var _fileChangeSummary$fi = fileChangeSummary[filename],
                id = _fileChangeSummary$fi.id,
                authors = _fileChangeSummary$fi.authors,
                types = _fileChangeSummary$fi.types;

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_fileChange__["a" /* default */], {
              key: id,
              filename: filename,
              authors: Object.values(authors),
              types: types
            });
          }),
          numCollapsed > 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Collapsed, { onClick: this.onCollapseToggle, count: numCollapsed }),
          numCollapsed === 0 && canCollapse && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'li',
            { className: 'list-group-item list-group-item-sm align-center' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon-container' }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { onClick: this.onCollapseToggle },
              Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Collapse')
            )
          )
        )
      );
    }
  }]);

  return RepositoryFileSummary;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  fileChangeSummary: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  repository: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, _class.MAX_WHEN_COLLAPSED = 5, _temp);


/* harmony default export */ __webpack_exports__["a"] = (RepositoryFileSummary);

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_avatar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_icons_icon_file_generic__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_mixins_apiMixin__ = __webpack_require__(8);








var FileChange = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'FileChange',

  propTypes: {
    filename: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    authors: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    return {
      loading: true
    };
  },
  render: function render() {
    var _props = this.props,
        filename = _props.filename,
        authors = _props.authors;
    // types = Array.from(types);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'li',
      { className: 'list-group-item list-group-item-sm release-file-change' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'row row-flex row-center-vertically' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'col-sm-9 truncate' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_icons_icon_file_generic__["a" /* default */], { className: 'icon-file-generic', size: 15 }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'file-name' },
            filename
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'col-sm-3 avatar-grid align-right' },
          authors.map(function (author, i) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_app_components_tooltip__["default"],
              { key: i, title: author.name + ' ' + author.email },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'avatar-grid-item m-b-0' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_avatar__["a" /* default */], { user: author })
              )
            );
          })
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (FileChange);

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function IconFileGeneric(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 15 15' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      { stroke: 'currentColor', fill: 'none' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
        d: 'M13.5,3.5 L13.5,12.9968907 C13.5,13.827035 12.8204455,14.5 12.0044548,14.5 L2.99554521,14.5 C2.1695784,14.5 1.5,13.8247509 1.5,13.0017548 L1.5,1.99824524 C1.5,1.17078724 2.17667683,0.5 3.00687434,0.5 L10.502848,0.5 L13.5,3.5 Z',
        id: 'file',
        strokeLinejoin: 'round'
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M10.5,0.5 L10.5,3.5', id: 'line-1' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M13.5,3.5 L10.5,3.5', id: 'line-2' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M4.5,4.5 L7.5,4.5', id: 'line-3', strokeLinejoin: 'round' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M4.5,7.5 L10.5,7.5', id: 'line-4', strokeLinejoin: 'round' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M4.5,10.5 L10.5,10.5', id: 'line-5', strokeLinejoin: 'round' })
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (IconFileGeneric);

/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_document_title__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_footer__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_sidebar__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_errors_notFound__ = __webpack_require__(404);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var RouteNotFound = function (_React$Component) {
  _inherits(RouteNotFound, _React$Component);

  function RouteNotFound() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RouteNotFound);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RouteNotFound.__proto__ || Object.getPrototypeOf(RouteNotFound)).call.apply(_ref, [this].concat(args))), _this), _this.getTitle = function () {
      return 'Page Not Found';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RouteNotFound, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_1_raven_js___default.a.captureException(new Error('Route not found'), {
        fingerprint: ['RouteNotFound']
      });
    }
  }, {
    key: 'render',
    value: function render() {
      // TODO(dcramer): show additional resource links
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_document_title___default.a,
        { title: this.getTitle() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'app' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_sidebar__["default"], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'content' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'section',
                { className: 'body' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_errors_notFound__["a" /* default */], null)
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_footer__["a" /* default */], null)
        )
      );
    }
  }]);

  return RouteNotFound;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (RouteNotFound);

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_proptypes__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * Simple Component that takes project from context and passes it as props to children
 *
 * Don't do anything additional (e.g. loader) because not all children require project
 *
 * This is made because some components (e.g. ProjectPluginDetail) takes project as prop
 */
var SettingsProjectProvider = (_temp = _class = function (_React$Component) {
  _inherits(SettingsProjectProvider, _React$Component);

  function SettingsProjectProvider() {
    _classCallCheck(this, SettingsProjectProvider);

    return _possibleConstructorReturn(this, (SettingsProjectProvider.__proto__ || Object.getPrototypeOf(SettingsProjectProvider)).apply(this, arguments));
  }

  _createClass(SettingsProjectProvider, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var project = this.context.project;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(children, _extends({}, this.props, children.props, {
        project: project
      }));
    }
  }]);

  return SettingsProjectProvider;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.contextTypes = {
  project: __WEBPACK_IMPORTED_MODULE_1_app_proptypes__["e" /* default */].Project
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (SettingsProjectProvider);

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_views_settings_components_scrollToTop__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_utils_withLatestContext__ = __webpack_require__(387);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var StyledSettingsWrapper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_emotion__["default"])('div', {
  target: 'e1krdl7w0'
})('font-family:\'Rubik\',sans-serif;font-size:16px;color:', function (p) {
  return p.theme.gray5;
}, ';margin:0 auto;line-height:1;footer > .container{max-width:', function (p) {
  return p.theme.settings.containerWidth;
}, ';padding:', function (p) {
  return p.theme.grid * 2;
}, 'px;}');

var SettingsWrapper = (_temp = _class = function (_React$Component) {
  _inherits(SettingsWrapper, _React$Component);

  function SettingsWrapper(props) {
    _classCallCheck(this, SettingsWrapper);

    // save current context
    var _this = _possibleConstructorReturn(this, (SettingsWrapper.__proto__ || Object.getPrototypeOf(SettingsWrapper)).call(this, props));

    _this.state = {
      lastAppContext: !!props.project ? 'project' : !!props.organization ? 'organization' : null
    };
    return _this;
  }

  _createClass(SettingsWrapper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        lastAppContext: this.state.lastAppContext
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.body).addClass('new-settings');
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.body).removeClass('new-settings');
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        StyledSettingsWrapper,
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_app_views_settings_components_scrollToTop__["a" /* default */],
          null,
          this.props.children
        )
      );
    }
  }]);

  return SettingsWrapper;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  project: __WEBPACK_IMPORTED_MODULE_5_app_proptypes__["e" /* default */].Project,
  organization: __WEBPACK_IMPORTED_MODULE_5_app_proptypes__["e" /* default */].Organization
}, _class.childContextTypes = {
  lastAppContext: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['project', 'organization'])
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_app_utils_withLatestContext__["a" /* default */])(SettingsWrapper));

/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ScrollToTop = (_temp = _class = function (_React$Component) {
  _inherits(ScrollToTop, _React$Component);

  function ScrollToTop() {
    _classCallCheck(this, ScrollToTop);

    return _possibleConstructorReturn(this, (ScrollToTop.__proto__ || Object.getPrototypeOf(ScrollToTop)).apply(this, arguments));
  }

  _createClass(ScrollToTop, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.location !== prevProps.location) {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return ScrollToTop;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["withRouter"])(ScrollToTop));

/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_omit__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_mixins_projectState__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_stores_tagStore__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_utils_withEnvironmentInQueryString__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_views_stream_stream__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_actionCreators_tags__ = __webpack_require__(1326);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };














var StreamContainer = __WEBPACK_IMPORTED_MODULE_4_create_react_class___default()({
  displayName: 'StreamContainer',
  propTypes: {
    environment: __WEBPACK_IMPORTED_MODULE_5_app_proptypes__["e" /* default */].Environment,
    setProjectNavSection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6_app_mixins_projectState__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_7_app_stores_tagStore__["a" /* default */], 'onTagsChange')],

  getInitialState: function getInitialState() {
    var hasEnvironmentsFeature = new Set(this.getOrganization().features).has('environments');

    return {
      tags: __WEBPACK_IMPORTED_MODULE_7_app_stores_tagStore__["a" /* default */].getAllTags(),
      tagsLoading: true,
      hasEnvironmentsFeature: hasEnvironmentsFeature
    };
  },
  componentWillMount: function componentWillMount() {
    var _props$params = this.props.params,
        orgId = _props$params.orgId,
        projectId = _props$params.projectId;

    this.props.setProjectNavSection('stream');
    Object(__WEBPACK_IMPORTED_MODULE_10_app_actionCreators_tags__["a" /* fetchTags */])(orgId, projectId);
  },
  onTagsChange: function onTagsChange(tags) {
    this.setState({
      tags: tags,
      tagsLoading: false
    });
  },


  // We don't want the environment tag to be visible to the user
  filterTags: function filterTags(tags) {
    return __WEBPACK_IMPORTED_MODULE_0_lodash_omit___default()(tags, 'environment');
  },
  render: function render() {
    var _state = this.state,
        hasEnvironmentsFeature = _state.hasEnvironmentsFeature,
        tagsLoading = _state.tagsLoading,
        tags = _state.tags;

    var filteredTags = hasEnvironmentsFeature ? this.filterTags(this.state.tags) : tags;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_views_stream_stream__["a" /* default */], _extends({
      hasEnvironmentsFeature: hasEnvironmentsFeature,
      tags: filteredTags,
      tagsLoading: tagsLoading
    }, this.props));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_app_utils_withEnvironmentInQueryString__["a" /* default */])(StreamContainer));

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_cookie__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_query_string__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_utils_analytics__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_proptypes__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_stores_configStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_stores_groupStore__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_stores_environmentStore__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_components_errorRobot__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_mixins_projectState__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_app_components_pagination__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_app_components_stream_group__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_app_views_stream_actions__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_app_views_stream_filters__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_app_views_stream_sidebar__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_app_components_timeSince__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_app_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_app_utils_queryString__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_app_utils_logging__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_app_utils_parseLinkHeader__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_app_actionCreators_environments__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_app_components_panels__ = __webpack_require__(18);






































var MAX_ITEMS = 25;
var DEFAULT_SORT = 'date';
var DEFAULT_STATS_PERIOD = '24h';
var STATS_PERIODS = new Set(['14d', '24h']);

var Stream = __WEBPACK_IMPORTED_MODULE_4_create_react_class___default()({
  displayName: 'Stream',

  propTypes: {
    environment: __WEBPACK_IMPORTED_MODULE_11_app_proptypes__["e" /* default */].Environment,
    hasEnvironmentsFeature: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    tags: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    tagsLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_14_app_stores_groupStore__["a" /* default */], 'onGroupChange'), __WEBPACK_IMPORTED_MODULE_12_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_19_app_mixins_projectState__["a" /* default */]],

  getInitialState: function getInitialState() {
    var searchId = this.props.params.searchId || null;
    var project = this.getProject();
    var realtimeActiveCookie = __WEBPACK_IMPORTED_MODULE_7_js_cookie___default.a.get('realtimeActive');
    var realtimeActive = typeof realtimeActiveCookie === 'undefined' ? project && !project.firstEvent : realtimeActiveCookie === 'true';

    var currentQuery = this.props.location.query || {};
    var sort = 'sort' in currentQuery ? currentQuery.sort : DEFAULT_SORT;

    var hasQuery = 'query' in currentQuery;
    var statsPeriod = STATS_PERIODS.has(currentQuery.statsPeriod) ? currentQuery.statsPeriod : DEFAULT_STATS_PERIOD;

    return {
      groupIds: [],
      isDefaultSearch: false,
      searchId: hasQuery ? null : searchId,
      // if we have no query then we can go ahead and fetch data
      loading: searchId || !hasQuery,
      savedSearchLoading: true,
      savedSearchList: [],
      selectAllActive: false,
      multiSelected: false,
      anySelected: false,
      statsPeriod: statsPeriod,
      realtimeActive: realtimeActive,
      pageLinks: '',
      queryCount: null,
      dataLoading: true,
      error: false,
      query: hasQuery ? currentQuery.query : '',
      sort: sort,
      isSidebarVisible: false,
      processingIssues: null,
      environment: this.props.environment
    };
  },
  componentWillMount: function componentWillMount() {
    this._streamManager = new __WEBPACK_IMPORTED_MODULE_26_app_utils__["c" /* default */].StreamManager(__WEBPACK_IMPORTED_MODULE_14_app_stores_groupStore__["a" /* default */]);
    this._poller = new __WEBPACK_IMPORTED_MODULE_26_app_utils__["c" /* default */].CursorPoller({
      success: this.onRealtimePoll
    });

    this.fetchSavedSearches();
    this.fetchProcessingIssues();
    if (!this.state.loading) {
      this.fetchData();
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.environment !== this.props.environment) {
      this.setState({
        environment: nextProps.environment
      }, this.fetchData);
    }

    // you cannot apply both a query and a saved search (our routes do not
    // support it), so the searchId takes priority
    var nextSearchId = nextProps.params.searchId || null;

    var searchIdChanged = this.state.isDefaultSearch ? nextSearchId !== null : nextSearchId !== this.state.searchId;

    // We are using qs.parse with location.search since this.props.location.query
    // returns the same value as nextProps.location.query
    var currentSearchTerm = __WEBPACK_IMPORTED_MODULE_9_query_string___default.a.parse(this.props.location.search);
    var nextSearchTerm = __WEBPACK_IMPORTED_MODULE_9_query_string___default.a.parse(nextProps.location.search);

    var searchTermChanged = !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_omit___default()(currentSearchTerm, 'environment'), __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default()(nextSearchTerm, 'environment'));

    if (searchIdChanged || searchTermChanged) {
      this.setState(this.getQueryState(nextProps), this.fetchData);
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    if (prevState.realtimeActive !== this.state.realtimeActive) {
      // User toggled realtime button
      if (this.state.realtimeActive) {
        this.resumePolling();
      } else {
        this._poller.disable();
      }
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this._poller.disable();
    __WEBPACK_IMPORTED_MODULE_14_app_stores_groupStore__["a" /* default */].reset();
  },
  fetchSavedSearches: function fetchSavedSearches() {
    var _this = this;

    this.setState({
      savedSearchLoading: true
    });

    var _props$params = this.props.params,
        orgId = _props$params.orgId,
        projectId = _props$params.projectId;
    var searchId = this.state.searchId;


    this.api.request('/projects/' + orgId + '/' + projectId + '/searches/', {
      success: function success(data) {
        var newState = {
          isDefaultSearch: false,
          savedSearchLoading: false,
          savedSearchList: data,
          loading: false
        };
        var needsData = _this.state.loading;
        if (searchId) {
          var match = data.find(function (search) {
            return search.id === searchId;
          });

          if (match) {
            newState.query = match.query;
          } else {
            _this.setState({
              savedSearchLoading: false,
              savedSearchList: data,
              searchId: null,
              isDefaultSearch: true
            }, _this.transitionTo);
          }
        } else if (!_this.hasQuery()) {
          var defaultResult = data.find(function (search) {
            return search.isUserDefault;
          }) || data.find(function (search) {
            return search.isDefault;
          });

          if (defaultResult) {
            // Check if there is an environment specified in the default search
            var envName = __WEBPACK_IMPORTED_MODULE_27_app_utils_queryString__["a" /* default */].getQueryEnvironment(defaultResult.query);
            var env = __WEBPACK_IMPORTED_MODULE_15_app_stores_environmentStore__["a" /* default */].getByName(envName);
            if (env) {
              Object(__WEBPACK_IMPORTED_MODULE_31_app_actionCreators_environments__["e" /* setActiveEnvironment */])(env);
            }

            newState.searchId = defaultResult.id;
            newState.query = __WEBPACK_IMPORTED_MODULE_27_app_utils_queryString__["a" /* default */].getQueryStringWithoutEnvironment(defaultResult.query);
            newState.isDefaultSearch = true;
          }
        }

        _this.setState(newState, needsData ? _this.fetchData : null);
      },
      error: function error(_error) {
        // XXX(dcramer): fail gracefully by still loading the stream
        Object(__WEBPACK_IMPORTED_MODULE_28_app_utils_logging__["logAjaxError"])(_error);
        _this.setState({
          loading: false,
          isDefaultSearch: null,
          searchId: null,
          savedSearchList: [],
          savedSearchLoading: false,
          query: ''
        });
      }
    });
  },
  fetchProcessingIssues: function fetchProcessingIssues() {
    var _this2 = this;

    var _props$params2 = this.props.params,
        orgId = _props$params2.orgId,
        projectId = _props$params2.projectId;

    this.api.request('/projects/' + orgId + '/' + projectId + '/processingissues/', {
      success: function success(data) {
        if (data.hasIssues || data.resolveableIssues > 0 || data.issuesProcessing > 0) {
          _this2.setState({
            processingIssues: data
          });
        }
      },
      error: function error(_error2) {
        Object(__WEBPACK_IMPORTED_MODULE_28_app_utils_logging__["logAjaxError"])(_error2);
        // this is okay. it's just a ui hint
      }
    });
  },
  showingProcessingIssues: function showingProcessingIssues() {
    return this.state.query && this.state.query.trim() == 'is:unprocessed';
  },
  onSavedSearchCreate: function onSavedSearchCreate(data) {
    var _props$params3 = this.props.params,
        orgId = _props$params3.orgId,
        projectId = _props$params3.projectId;

    var savedSearchList = this.state.savedSearchList;
    savedSearchList.push(data);
    // TODO(dcramer): sort
    this.setState({
      savedSearchList: savedSearchList
    });
    __WEBPACK_IMPORTED_MODULE_6_react_router__["browserHistory"].push('/' + orgId + '/' + projectId + '/searches/' + data.id + '/');
  },
  getQueryState: function getQueryState(props) {
    var currentQuery = props.location.query || {};

    var hasQuery = 'query' in currentQuery;

    var searchId = hasQuery ? null : props.params.searchId || this.state.searchId || null;

    var sort = 'sort' in currentQuery ? currentQuery.sort : DEFAULT_SORT;

    var statsPeriod = STATS_PERIODS.has(currentQuery.statsPeriod) ? currentQuery.statsPeriod : DEFAULT_STATS_PERIOD;

    var newState = {
      sort: sort,
      statsPeriod: statsPeriod,
      query: hasQuery ? currentQuery.query : '',
      searchId: searchId,
      isDefaultSearch: false
    };

    if (searchId) {
      var searchResult = this.state.savedSearchList.find(function (search) {
        return search.id === searchId;
      });
      if (searchResult) {
        // New behavior is that we'll no longer want to support environment in saved search
        // We check if the query contains a valid environment and update the global setting if so
        // We'll always strip environment from the querystring whether valid or not
        if (this.props.hasEnvironmentsFeature) {
          var queryEnv = __WEBPACK_IMPORTED_MODULE_27_app_utils_queryString__["a" /* default */].getQueryEnvironment(searchResult.query);
          if (queryEnv) {
            var env = __WEBPACK_IMPORTED_MODULE_15_app_stores_environmentStore__["a" /* default */].getByName(queryEnv);
            Object(__WEBPACK_IMPORTED_MODULE_31_app_actionCreators_environments__["e" /* setActiveEnvironment */])(env);
          }
          newState.query = __WEBPACK_IMPORTED_MODULE_27_app_utils_queryString__["a" /* default */].getQueryStringWithoutEnvironment(searchResult.query);
        } else {
          // Old behavior, keep the environment in the querystring
          newState.query = searchResult.query;
        }

        if (this.state.searchId && !props.params.searchId) {
          newState.isDefaultSearch = true;
        }
      } else {
        newState.searchId = null;
      }
    } else if (!hasQuery) {
      var defaultResult = this.state.savedSearchList.find(function (search) {
        return search.isDefault;
      });
      if (defaultResult) {
        newState.isDefaultSearch = true;
        newState.searchId = defaultResult.id;
        newState.query = defaultResult.query;
      } else {
        newState.searchId = null;
      }
    }
    newState.loading = false;
    return newState;
  },
  hasQuery: function hasQuery(props) {
    props = props || this.props;
    var currentQuery = props.location.query || {};
    return 'query' in currentQuery;
  },
  fetchData: function fetchData() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_14_app_stores_groupStore__["a" /* default */].loadInitialData([]);

    this.setState({
      dataLoading: true,
      queryCount: null,
      error: false
    });

    var url = this.getGroupListEndpoint();

    // Remove leading and trailing whitespace
    var query = __WEBPACK_IMPORTED_MODULE_27_app_utils_queryString__["a" /* default */].formatQueryString(this.state.query);

    var environment = this.state.environment;


    var requestParams = {
      query: query,
      limit: MAX_ITEMS,
      sort: this.state.sort,
      statsPeriod: this.state.statsPeriod,
      shortIdLookup: '1'
    };

    // Always keep the global active environment in sync with the queried environment
    // The global environment wins unless there one is specified by the saved search
    var queryEnvironment = __WEBPACK_IMPORTED_MODULE_27_app_utils_queryString__["a" /* default */].getQueryEnvironment(query);

    if (queryEnvironment !== null) {
      requestParams.environment = queryEnvironment;
    } else if (environment) {
      requestParams.environment = environment.name;
    }

    var currentQuery = this.props.location.query || {};
    if ('cursor' in currentQuery) {
      requestParams.cursor = currentQuery.cursor;
    }

    if (this.lastRequest) {
      this.lastRequest.cancel();
    }

    this._poller.disable();

    this.lastRequest = this.api.request(url, {
      method: 'GET',
      data: requestParams,
      success: function success(data, ignore, jqXHR) {
        // if this is a direct hit, we redirect to the intended result directly.
        // we have to use the project slug from the result data instead of the
        // the current props one as the shortIdLookup can return results for
        // different projects.
        if (jqXHR.getResponseHeader('X-Sentry-Direct-Hit') === '1') {
          if (data[0].matchingEventId) {
            return void __WEBPACK_IMPORTED_MODULE_6_react_router__["browserHistory"].push('/' + _this3.props.params.orgId + '/' + data[0].project.slug + '/issues/' + data[0].id + '/events/' + data[0].matchingEventId + '/');
          }
          return void __WEBPACK_IMPORTED_MODULE_6_react_router__["browserHistory"].push('/' + _this3.props.params.orgId + '/' + data[0].project.slug + '/issues/' + data[0].id + '/');
        }

        _this3._streamManager.push(data);

        var queryCount = jqXHR.getResponseHeader('X-Hits');
        var queryMaxCount = jqXHR.getResponseHeader('X-Max-Hits');

        return void _this3.setState({
          error: false,
          dataLoading: false,
          query: query,
          queryCount: typeof queryCount !== 'undefined' ? parseInt(queryCount, 10) || 0 : 0,
          queryMaxCount: typeof queryMaxCount !== 'undefined' ? parseInt(queryMaxCount, 10) || 0 : 0,
          pageLinks: jqXHR.getResponseHeader('Link')
        });
      },
      error: function error(err) {
        var error = err.responseJSON || true;
        error = error.detail || true;
        _this3.setState({
          error: error,
          dataLoading: false
        });
      },
      complete: function complete(jqXHR) {
        _this3.lastRequest = null;

        _this3.resumePolling();
      }
    });
  },
  resumePolling: function resumePolling() {
    if (!this.state.pageLinks) return;

    // Only resume polling if we're on the first page of results
    var links = Object(__WEBPACK_IMPORTED_MODULE_29_app_utils_parseLinkHeader__["a" /* default */])(this.state.pageLinks);
    if (links && !links.previous.results && this.state.realtimeActive) {
      this._poller.setEndpoint(links.previous.href);
      this._poller.enable();
    }
  },
  getGroupListEndpoint: function getGroupListEndpoint() {
    var params = this.props.params;

    return '/projects/' + params.orgId + '/' + params.projectId + '/issues/';
  },
  onRealtimeChange: function onRealtimeChange(realtime) {
    __WEBPACK_IMPORTED_MODULE_7_js_cookie___default.a.set('realtimeActive', realtime.toString());
    this.setState({
      realtimeActive: realtime
    });
  },
  onSelectStatsPeriod: function onSelectStatsPeriod(period) {
    if (period != this.state.statsPeriod) {
      // TODO(dcramer): all charts should now suggest "loading"
      this.setState({
        statsPeriod: period
      }, function () {
        this.transitionTo();
      });
    }
  },
  onRealtimePoll: function onRealtimePoll(data, links) {
    this._streamManager.unshift(data);
    if (!__WEBPACK_IMPORTED_MODULE_26_app_utils__["c" /* default */].valueIsEqual(this.state.pageLinks, links, true)) {
      this.setState({
        pageLinks: links
      });
    }
  },
  onGroupChange: function onGroupChange() {
    var groupIds = this._streamManager.getAllItems().map(function (item) {
      return item.id;
    });
    if (!__WEBPACK_IMPORTED_MODULE_26_app_utils__["c" /* default */].valueIsEqual(groupIds, this.state.groupIds)) {
      this.setState({
        groupIds: groupIds
      });
    }
  },
  onSearch: function onSearch(query) {
    var _this4 = this;

    if (query === this.state.query) {
      // if query is the same, just re-fetch data
      this.fetchData();
    } else {
      // We no longer want to support environments specified in the querystring
      // To keep this aligned with old behavior though we'll update the global environment
      // and remove it from the query if someone does provide it this way
      if (this.props.hasEnvironmentsFeature) {
        var queryEnvironment = __WEBPACK_IMPORTED_MODULE_27_app_utils_queryString__["a" /* default */].getQueryEnvironment(query);
        if (queryEnvironment !== null) {
          var env = __WEBPACK_IMPORTED_MODULE_15_app_stores_environmentStore__["a" /* default */].getByName(queryEnvironment);
          Object(__WEBPACK_IMPORTED_MODULE_31_app_actionCreators_environments__["e" /* setActiveEnvironment */])(env);
        }

        query = __WEBPACK_IMPORTED_MODULE_27_app_utils_queryString__["a" /* default */].getQueryStringWithoutEnvironment(query);
      }

      this.setState({
        query: query,
        searchId: null
      }, this.transitionTo);
    }

    // Ignore saved searches
    if (this.state.savedSearchList.map(function (s) {
      return s.query == _this4.state.query;
    }).length > 0) {
      var _props$params4 = this.props.params,
          orgId = _props$params4.orgId,
          projectId = _props$params4.projectId;

      Object(__WEBPACK_IMPORTED_MODULE_10_app_utils_analytics__["a" /* default */])('issue.search', {
        query: this.state.query,
        organization_id: orgId,
        project_id: projectId
      });
    }
  },
  onSortChange: function onSortChange(sort) {
    this.setState({
      sort: sort
    }, this.transitionTo);
  },
  onSidebarToggle: function onSidebarToggle() {
    this.setState({
      isSidebarVisible: !this.state.isSidebarVisible
    });
  },


  /**
   * Returns true if all results in the current query are visible/on this page
   */
  allResultsVisible: function allResultsVisible() {
    if (!this.state.pageLinks) return false;

    var links = Object(__WEBPACK_IMPORTED_MODULE_29_app_utils_parseLinkHeader__["a" /* default */])(this.state.pageLinks);
    return links && !links.previous.results && !links.next.results;
  },
  transitionTo: function transitionTo() {
    var queryParams = {};

    if (this.props.location.query.environment) {
      queryParams.environment = this.props.location.query.environment;
    }

    if (!this.state.searchId) {
      queryParams.query = this.state.query;
    }

    if (this.state.sort !== DEFAULT_SORT) {
      queryParams.sort = this.state.sort;
    }

    if (this.state.statsPeriod !== DEFAULT_STATS_PERIOD) {
      queryParams.statsPeriod = this.state.statsPeriod;
    }

    var params = this.props.params;

    var path = this.state.searchId ? '/' + params.orgId + '/' + params.projectId + '/searches/' + this.state.searchId + '/' : '/' + params.orgId + '/' + params.projectId + '/';
    __WEBPACK_IMPORTED_MODULE_6_react_router__["browserHistory"].push({
      pathname: path,
      query: queryParams
    });
  },
  renderProcessingIssuesHint: function renderProcessingIssuesHint() {
    var pi = this.state.processingIssues;
    if (!pi || this.showingProcessingIssues()) {
      return null;
    }

    var _props$params5 = this.props.params,
        orgId = _props$params5.orgId,
        projectId = _props$params5.projectId;

    var link = '/' + orgId + '/' + projectId + '/settings/processing-issues/';
    var showButton = false;
    var className = {
      'processing-issues': true,
      alert: true
    };
    var issues = null;
    var lastEvent = null;
    var icon = null;

    if (pi.numIssues > 0) {
      icon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'icon icon-alert' });
      issues = Object(__WEBPACK_IMPORTED_MODULE_30_app_locale__["tn"])('There is %d issue blocking event processing', 'There are %d issues blocking event processing', pi.numIssues);
      lastEvent = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'span',
        { className: 'last-seen' },
        '(',
        Object(__WEBPACK_IMPORTED_MODULE_30_app_locale__["tct"])('last event from [ago]', {
          ago: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_app_components_timeSince__["default"], { date: pi.lastSeen })
        }),
        ')'
      );
      className['alert-error'] = true;
      showButton = true;
    } else if (pi.issuesProcessing > 0) {
      icon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'icon icon-processing play' });
      className['alert-info'] = true;
      issues = Object(__WEBPACK_IMPORTED_MODULE_30_app_locale__["tn"])('Reprocessing %d event …', 'Reprocessing %d events …', pi.issuesProcessing);
    } else if (pi.resolveableIssues > 0) {
      icon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'icon icon-processing' });
      className['alert-warning'] = true;
      issues = Object(__WEBPACK_IMPORTED_MODULE_30_app_locale__["tn"])('There is %d event pending reprocessing.', 'There are %d events pending reprocessing.', pi.resolveableIssues);
      showButton = true;
    } else {
      /* we should not go here but what do we know */return null;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(className),
        style: { margin: '-1px -1px 0', padding: '10px 16px' }
      },
      showButton && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_router__["Link"],
        { to: link, className: 'btn btn-default btn-sm pull-right' },
        Object(__WEBPACK_IMPORTED_MODULE_30_app_locale__["t"])('Show details')
      ),
      icon,
      ' ',
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'strong',
        null,
        issues
      ),
      ' ',
      lastEvent,
      ' '
    );
  },
  renderGroupNodes: function renderGroupNodes(ids, statsPeriod) {
    var _this5 = this;

    // Restrict this guide to only show for new users (joined<30 days) and add guide anhor only to the first issue
    var userDateJoined = new Date(__WEBPACK_IMPORTED_MODULE_13_app_stores_configStore__["default"].get('user').dateJoined);
    var dateCutoff = new Date();
    dateCutoff.setDate(dateCutoff.getDate() - 30);

    var topIssue = ids[0];

    var _props$params6 = this.props.params,
        orgId = _props$params6.orgId,
        projectId = _props$params6.projectId;

    var groupNodes = ids.map(function (id) {
      var hasGuideAnchor = userDateJoined > dateCutoff && id === topIssue;
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_app_components_stream_group__["a" /* default */], {
        key: id,
        id: id,
        orgId: orgId,
        projectId: projectId,
        statsPeriod: statsPeriod,
        query: _this5.state.query,
        hasGuideAnchor: hasGuideAnchor
      });
    });
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_32_app_components_panels__["c" /* PanelBody */],
      { className: 'ref-group-list' },
      groupNodes
    );
  },
  renderAwaitingEvents: function renderAwaitingEvents() {
    var org = this.getOrganization();
    var project = this.getProject();
    var sampleIssueId = this.state.groupIds.length > 0 ? this.state.groupIds[0] : '';
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_app_components_errorRobot__["a" /* default */], {
      org: org,
      project: project,
      sampleIssueId: sampleIssueId,
      gradient: true
    });
  },
  renderEmpty: function renderEmpty() {
    var environment = this.state.environment;

    var message = environment ? Object(__WEBPACK_IMPORTED_MODULE_30_app_locale__["tct"])('Sorry no events match your filters in the [env] environment.', {
      env: environment.displayName
    }) : Object(__WEBPACK_IMPORTED_MODULE_30_app_locale__["t"])('Sorry, no events match your filters.');

    // TODO(lyn): Extract empty state to a separate component
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: 'empty-stream', style: { border: 0 } },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'icon icon-exclamation' }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'p',
        null,
        message
      )
    );
  },
  renderLoading: function renderLoading() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_app_components_loadingIndicator__["default"], null);
  },
  renderStreamBody: function renderStreamBody() {
    var body = void 0;
    var project = this.getProject();
    if (this.state.dataLoading) {
      body = this.renderLoading();
    } else if (this.state.error) {
      body = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_app_components_loadingError__["default"], { message: this.state.error, onRetry: this.fetchData });
    } else if (!project.firstEvent) {
      body = this.renderAwaitingEvents();
    } else if (this.state.groupIds.length > 0) {
      body = this.renderGroupNodes(this.state.groupIds, this.state.statsPeriod);
    } else {
      body = this.renderEmpty();
    }
    return body;
  },
  render: function render() {
    // global loading
    if (this.state.loading) {
      return this.renderLoading();
    }
    var params = this.props.params;
    var classes = ['stream-row'];
    if (this.state.isSidebarVisible) classes.push('show-sidebar');
    var _props$params7 = this.props.params,
        orgId = _props$params7.orgId,
        projectId = _props$params7.projectId;

    var searchId = this.state.searchId;
    var access = this.getAccess();
    var projectFeatures = this.getProjectFeatures();
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(classes) },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: 'stream-content' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_app_views_stream_filters__["a" /* default */], {
          access: access,
          orgId: orgId,
          projectId: projectId,
          query: this.state.query,
          sort: this.state.sort,
          searchId: searchId,
          queryCount: this.state.queryCount,
          queryMaxCount: this.state.queryMaxCount,
          onSortChange: this.onSortChange,
          onSearch: this.onSearch,
          onSavedSearchCreate: this.onSavedSearchCreate,
          onSidebarToggle: this.onSidebarToggle,
          isSearchDisabled: this.state.isSidebarVisible,
          savedSearchList: this.state.savedSearchList
        }),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_32_app_components_panels__["a" /* Panel */],
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_app_views_stream_actions__["a" /* default */], {
            orgId: params.orgId,
            projectId: params.projectId,
            hasReleases: projectFeatures.has('releases'),
            latestRelease: this.context.project.latestRelease,
            query: this.state.query,
            queryCount: this.state.queryCount,
            onSelectStatsPeriod: this.onSelectStatsPeriod,
            onRealtimeChange: this.onRealtimeChange,
            realtimeActive: this.state.realtimeActive,
            statsPeriod: this.state.statsPeriod,
            groupIds: this.state.groupIds,
            allResultsVisible: this.allResultsVisible()
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_32_app_components_panels__["c" /* PanelBody */],
            null,
            this.renderProcessingIssuesHint(),
            this.renderStreamBody()
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_app_components_pagination__["default"], { pageLinks: this.state.pageLinks })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_app_views_stream_sidebar__["a" /* default */], {
        loading: this.props.tagsLoading,
        tags: this.props.tags,
        query: this.state.query,
        onQueryChange: this.onSearch,
        orgId: params.orgId,
        projectId: params.projectId
      })
    );
  }
});
/* harmony default export */ __webpack_exports__["a"] = (Stream);

/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_capitalize__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_capitalize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_capitalize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_emotion__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grid_emotion__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_dropdownLink__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_stores_indicatorStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_menuItem__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_stores_selectedGroupStore__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_checkbox__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_components_toolbarHeader__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_components_actions_resolve__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_components_actions_ignore__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_components_actions_actionLink__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_components_tooltip__ = __webpack_require__(21);

























var BULK_LIMIT = 1000;
var BULK_LIMIT_STR = BULK_LIMIT.toLocaleString();

var getBulkConfirmMessage = function getBulkConfirmMessage(action, queryCount) {
  if (queryCount > BULK_LIMIT) {
    return Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["tct"])('Are you sure you want to [action] the first [bulkNumber] issues that match the search?', {
      action: action,
      bulkNumber: BULK_LIMIT_STR
    });
  }

  return Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["tct"])('Are you sure you want to [action] all [bulkNumber] issues that match the search?', {
    action: action,
    bulkNumber: queryCount
  });
};

var getConfirm = function getConfirm(numIssues, allInQuerySelected, query, queryCount) {
  return function (action, canBeUndone) {
    var append = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    var question = allInQuerySelected ? getBulkConfirmMessage('' + action + append, queryCount) : Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["tn"])('Are you sure you want to ' + action + ' this %d issue' + append + '?', 'Are you sure you want to ' + action + ' these %d issues' + append + '?', numIssues);

    var message = action == 'delete' ? Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["tct"])('Bulk deletion is only recommended for junk data. To clear your stream, consider resolving or ignoring. [link:When should I delete events?]', {
      link: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router__["Link"], { to: 'https://help.sentry.io/hc/en-us/articles/360003443113-When-should-I-delete-events-' })
    }) : Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('This action cannot be undone.');

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'p',
        { style: { marginBottom: '20px' } },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'strong',
          null,
          question
        )
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ExtraDescription, {
        all: allInQuerySelected,
        query: query,
        queryCount: queryCount
      }),
      !canBeUndone && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'p',
        null,
        message
      )
    );
  };
};

var getLabel = function getLabel(numIssues, allInQuerySelected) {
  return function (action) {
    var append = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var capitalized = __WEBPACK_IMPORTED_MODULE_0_lodash_capitalize___default()(action);
    var text = allInQuerySelected ? Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Bulk ' + action + ' issues') : Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["tn"])(capitalized + ' %d selected issue', capitalized + ' %d selected issues', numIssues);

    return text + append;
  };
};

var ExtraDescription = function ExtraDescription(_ref) {
  var all = _ref.all,
      query = _ref.query,
      queryCount = _ref.queryCount;

  if (!all) return null;

  if (query) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'p',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('This will apply to the current search query') + ':'
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'pre',
        null,
        query
      )
    );
  }
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'p',
    { className: 'error' },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'strong',
      null,
      queryCount > BULK_LIMIT ? Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["tct"])('This will apply to the first [bulkNumber] issues matched in this project!', {
        bulkNumber: BULK_LIMIT_STR
      }) : Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["tct"])('This will apply to all [bulkNumber] issues matched in this project!', {
        bulkNumber: queryCount
      })
    )
  );
};

ExtraDescription.propTypes = {
  all: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  queryCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var StreamActions = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'StreamActions',

  propTypes: {
    allResultsVisible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    orgId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    projectId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    groupIds: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Array).isRequired,
    onRealtimeChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onSelectStatsPeriod: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    realtimeActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    statsPeriod: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    queryCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    hasReleases: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    latestRelease: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_4_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_12_app_stores_selectedGroupStore__["a" /* default */], 'onSelectedGroupChange')],

  getDefaultProps: function getDefaultProps() {
    return { hasReleases: false, latestRelease: null };
  },
  getInitialState: function getInitialState() {
    return {
      datePickerActive: false,
      anySelected: false,
      multiSelected: false, // more than one selected
      pageSelected: false, // all on current page selected (e.g. 25)
      allInQuerySelected: false, // all in current search query selected (e.g. 1000+)
      selectedIds: new Set()
    };
  },
  selectAll: function selectAll() {
    this.setState({
      allInQuerySelected: true
    });
  },
  selectStatsPeriod: function selectStatsPeriod(period) {
    return this.props.onSelectStatsPeriod(period);
  },
  actionSelectedGroups: function actionSelectedGroups(callback) {
    var selectedIds = void 0;

    if (this.state.allInQuerySelected) {
      selectedIds = undefined; // undefined means "all"
    } else {
      var itemIdSet = __WEBPACK_IMPORTED_MODULE_12_app_stores_selectedGroupStore__["a" /* default */].getSelectedIds();
      selectedIds = this.props.groupIds.filter(function (itemId) {
        return itemIdSet.has(itemId);
      });
    }

    callback(selectedIds);

    this.deselectAll();
  },
  deselectAll: function deselectAll() {
    __WEBPACK_IMPORTED_MODULE_12_app_stores_selectedGroupStore__["a" /* default */].deselectAll();
    this.setState({ allInQuerySelected: false });
  },
  onUpdate: function onUpdate(data) {
    var _this = this;

    this.actionSelectedGroups(function (itemIds) {
      var loadingIndicator = __WEBPACK_IMPORTED_MODULE_10_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Saving changes..'));

      _this.api.bulkUpdate({
        orgId: _this.props.orgId,
        projectId: _this.props.projectId,
        itemIds: itemIds,
        data: data,
        query: _this.props.query
      }, {
        complete: function complete() {
          __WEBPACK_IMPORTED_MODULE_10_app_stores_indicatorStore__["default"].remove(loadingIndicator);
        }
      });
    });
  },
  onDelete: function onDelete(event) {
    var _this2 = this;

    var loadingIndicator = __WEBPACK_IMPORTED_MODULE_10_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Removing events..'));

    this.actionSelectedGroups(function (itemIds) {
      _this2.api.bulkDelete({
        orgId: _this2.props.orgId,
        projectId: _this2.props.projectId,
        itemIds: itemIds,
        query: _this2.props.query
      }, {
        complete: function complete() {
          __WEBPACK_IMPORTED_MODULE_10_app_stores_indicatorStore__["default"].remove(loadingIndicator);
        }
      });
    });
  },
  onMerge: function onMerge(event) {
    var _this3 = this;

    var loadingIndicator = __WEBPACK_IMPORTED_MODULE_10_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Merging events..'));

    this.actionSelectedGroups(function (itemIds) {
      _this3.api.merge({
        orgId: _this3.props.orgId,
        projectId: _this3.props.projectId,
        itemIds: itemIds,
        query: _this3.props.query
      }, {
        complete: function complete() {
          __WEBPACK_IMPORTED_MODULE_10_app_stores_indicatorStore__["default"].remove(loadingIndicator);
        }
      });
    });
  },
  onSelectedGroupChange: function onSelectedGroupChange() {
    this.setState({
      pageSelected: __WEBPACK_IMPORTED_MODULE_12_app_stores_selectedGroupStore__["a" /* default */].allSelected(),
      multiSelected: __WEBPACK_IMPORTED_MODULE_12_app_stores_selectedGroupStore__["a" /* default */].multiSelected(),
      anySelected: __WEBPACK_IMPORTED_MODULE_12_app_stores_selectedGroupStore__["a" /* default */].anySelected(),
      allInQuerySelected: false, // any change resets
      selectedIds: __WEBPACK_IMPORTED_MODULE_12_app_stores_selectedGroupStore__["a" /* default */].getSelectedIds()
    });
  },
  onSelectAll: function onSelectAll() {
    __WEBPACK_IMPORTED_MODULE_12_app_stores_selectedGroupStore__["a" /* default */].toggleSelectAll();
  },
  onRealtimeChange: function onRealtimeChange(evt) {
    this.props.onRealtimeChange(!this.props.realtimeActive);
  },
  shouldConfirm: function shouldConfirm(action) {
    var selectedItems = __WEBPACK_IMPORTED_MODULE_12_app_stores_selectedGroupStore__["a" /* default */].getSelectedIds();
    switch (action) {
      case 'resolve':
      case 'unresolve':
      case 'ignore':
      case 'unbookmark':
        return this.state.pageSelected && selectedItems.size > 1;
      case 'bookmark':
        return selectedItems.size > 1;
      case 'merge':
      case 'delete':
      default:
        return true; // By default, should confirm ...
    }
  },
  render: function render() {
    var _this4 = this;

    // TODO(mitsuhiko): very unclear how to translate this
    var _props = this.props,
        allResultsVisible = _props.allResultsVisible,
        hasReleases = _props.hasReleases,
        latestRelease = _props.latestRelease,
        orgId = _props.orgId,
        projectId = _props.projectId,
        queryCount = _props.queryCount,
        query = _props.query,
        realtimeActive = _props.realtimeActive,
        statsPeriod = _props.statsPeriod;

    var issues = this.state.selectedIds;
    var numIssues = issues.size;
    var _state = this.state,
        allInQuerySelected = _state.allInQuerySelected,
        anySelected = _state.anySelected,
        multiSelected = _state.multiSelected,
        pageSelected = _state.pageSelected;

    var confirm = getConfirm(numIssues, allInQuerySelected, query, queryCount);
    var label = getLabel(numIssues, allInQuerySelected);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      Sticky,
      null,
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        StyledFlex,
        { py: 1 },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          ActionsCheckbox,
          { pl: 2 },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_app_components_checkbox__["a" /* default */], { onChange: this.onSelectAll, checked: pageSelected })
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          ActionSet,
          { w: [8 / 12, 8 / 12, 6 / 12], mx: 1, flex: '1' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_app_components_actions_resolve__["a" /* default */], {
            hasRelease: hasReleases,
            latestRelease: latestRelease,
            orgId: orgId,
            projectId: projectId,
            onUpdate: this.onUpdate,
            shouldConfirm: this.shouldConfirm('resolve'),
            confirmMessage: confirm('resolve', true),
            confirmLabel: label('resolve'),
            disabled: !anySelected
          }),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_app_components_actions_ignore__["a" /* default */], {
            onUpdate: this.onUpdate,
            shouldConfirm: this.shouldConfirm('ignore'),
            confirmMessage: confirm('ignore', true),
            confirmLabel: label('ignore'),
            disabled: !anySelected
          }),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'btn-group hidden-sm hidden-xs' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_18_app_components_actions_actionLink__["a" /* default */],
              {
                className: 'btn btn-default btn-sm action-merge',
                disabled: !multiSelected,
                onAction: this.onMerge,
                shouldConfirm: this.shouldConfirm('merge'),
                message: confirm('merge', false),
                confirmLabel: label('merge'),
                title: Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Merge Selected Issues')
              },
              Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Merge')
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'btn-group hidden-xs' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_18_app_components_actions_actionLink__["a" /* default */],
              {
                className: 'btn btn-default btn-sm action-bookmark hidden-sm hidden-xs',
                onAction: function onAction() {
                  return _this4.onUpdate({ isBookmarked: true });
                },
                shouldConfirm: this.shouldConfirm('bookmark'),
                message: confirm('bookmark', false),
                confirmLabel: label('bookmark'),
                title: Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Add to Bookmarks'),
                disabled: !anySelected
              },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i', { 'aria-hidden': 'true', className: 'icon-star-solid' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'btn-group' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_app_components_dropdownLink__["default"],
              {
                key: 'actions',
                btnGroup: true,
                caret: false,
                className: 'btn btn-sm btn-default action-more',
                title: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon-ellipsis' })
              },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_app_components_menuItem__["default"],
                { noAnchor: true },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_18_app_components_actions_actionLink__["a" /* default */],
                  {
                    className: 'action-merge hidden-md hidden-lg hidden-xl',
                    disabled: !multiSelected,
                    onAction: this.onMerge,
                    shouldConfirm: this.shouldConfirm('merge'),
                    message: confirm('merge', false),
                    confirmLabel: label('merge'),
                    title: Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Merge Selected Issues')
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Merge')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_menuItem__["default"], { divider: true, className: 'hidden-md hidden-lg hidden-xl' }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_app_components_menuItem__["default"],
                { noAnchor: true },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_18_app_components_actions_actionLink__["a" /* default */],
                  {
                    className: 'action-bookmark hidden-md hidden-lg hidden-xl',
                    disabled: !anySelected,
                    onAction: function onAction() {
                      return _this4.onUpdate({ isBookmarked: true });
                    },
                    shouldConfirm: this.shouldConfirm('bookmark'),
                    message: confirm('bookmark', false),
                    confirmLabel: label('bookmark'),
                    title: Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Add to Bookmarks')
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Add to Bookmarks')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_menuItem__["default"], { divider: true, className: 'hidden-md hidden-lg hidden-xl' }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_app_components_menuItem__["default"],
                { noAnchor: true },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_18_app_components_actions_actionLink__["a" /* default */],
                  {
                    className: 'action-remove-bookmark',
                    disabled: !anySelected,
                    onAction: function onAction() {
                      return _this4.onUpdate({ isBookmarked: false });
                    },
                    shouldConfirm: this.shouldConfirm('unbookmark'),
                    message: confirm('remove', false, ' from your bookmarks'),
                    confirmLabel: label('remove', ' from your bookmarks')
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Remove from Bookmarks')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_menuItem__["default"], { divider: true }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_app_components_menuItem__["default"],
                { noAnchor: true },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_18_app_components_actions_actionLink__["a" /* default */],
                  {
                    className: 'action-unresolve',
                    disabled: !anySelected,
                    onAction: function onAction() {
                      return _this4.onUpdate({ status: 'unresolved' });
                    },
                    shouldConfirm: this.shouldConfirm('unresolve'),
                    message: confirm('unresolve', true),
                    confirmLabel: label('unresolve')
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Set status to: Unresolved')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_menuItem__["default"], { divider: true }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_app_components_menuItem__["default"],
                { noAnchor: true },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_18_app_components_actions_actionLink__["a" /* default */],
                  {
                    className: 'action-delete',
                    disabled: !anySelected,
                    onAction: this.onDelete,
                    shouldConfirm: this.shouldConfirm('delete'),
                    message: confirm('delete', false),
                    confirmLabel: label('delete'),
                    selectAllActive: pageSelected
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Delete Issues')
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'btn-group' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_19_app_components_tooltip__["default"],
              {
                title: Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('%s real-time updates', realtimeActive ? Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Pause') : Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Enable')),
                tooltipOptions: { container: 'body' }
              },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'a',
                {
                  className: 'btn btn-default btn-sm hidden-xs realtime-control',
                  onClick: this.onRealtimeChange
                },
                realtimeActive ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon icon-pause' }) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon icon-play' })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_grid_emotion__["Box"],
          { w: 160, mx: 2, className: 'hidden-xs hidden-sm' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_grid_emotion__["Flex"],
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              StyledToolbarHeader,
              null,
              Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Graph:')
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              GraphToggle,
              {
                active: statsPeriod === '24h',
                onClick: this.selectStatsPeriod.bind(this, '24h')
              },
              Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('24h')
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              GraphToggle,
              {
                active: statsPeriod === '14d',
                onClick: this.selectStatsPeriod.bind(this, '14d')
              },
              Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('14d')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_grid_emotion__["Box"],
          { w: [40, 60, 80, 80], mx: 2, className: 'align-right' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_15_app_components_toolbarHeader__["a" /* default */],
            null,
            Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Events')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_grid_emotion__["Box"],
          { w: [40, 60, 80, 80], mx: 2, className: 'align-right' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_15_app_components_toolbarHeader__["a" /* default */],
            null,
            Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Users')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_grid_emotion__["Box"],
          { w: 80, mx: 2, className: 'align-right hidden-xs hidden-sm' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_15_app_components_toolbarHeader__["a" /* default */],
            null,
            Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["t"])('Assignee')
          )
        )
      ),
      !allResultsVisible && pageSelected && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'row stream-select-all-notice' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'col-md-12' },
          allInQuerySelected ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'strong',
            null,
            queryCount >= BULK_LIMIT ? Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["tct"])('Selected up to the first [count] issues that match this search query.', {
              count: BULK_LIMIT_STR
            }) : Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["tct"])('Selected all [count] issues that match this search query.', {
              count: queryCount
            })
          ) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'span',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["tn"])('%d issue on this page selected.', '%d issues on this page selected.', numIssues),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'a',
              { onClick: this.selectAll },
              queryCount >= BULK_LIMIT ? Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["tct"])('Select the first [count] issues that match this search query.', {
                count: BULK_LIMIT_STR
              }) : Object(__WEBPACK_IMPORTED_MODULE_13_app_locale__["tct"])('Select all [count] issues that match this search query.', {
                count: queryCount
              })
            )
          )
        )
      )
    );
  }
});

var Sticky = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])('div', {
  target: 'e1vbh80t0'
})('position:sticky;z-index:', function (p) {
  return p.theme.zIndex.header;
}, ';top:-1px;');

var StyledFlex = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_6_grid_emotion__["Flex"], {
  target: 'e1vbh80t1'
})('align-items:center;background:', function (p) {
  return p.theme.offWhite;
}, ';border-bottom:1px solid ', function (p) {
  return p.theme.borderDark;
}, ';border-radius:', function (p) {
  return p.theme.borderRadius;
}, ' ', function (p) {
  return p.theme.borderRadius;
}, ' 0 0;margin-bottom:-1px;');

var ActionsCheckbox = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_6_grid_emotion__["Box"], {
  target: 'e1vbh80t2'
})('& input[type=\'checkbox\']{margin:0;display:block;}');

var ActionSet = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_6_grid_emotion__["Box"], {
  target: 'e1vbh80t3'
})('display:flex;.btn-group{margin-right:6px;}');

var StyledToolbarHeader = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])(__WEBPACK_IMPORTED_MODULE_15_app_components_toolbarHeader__["a" /* default */], {
  target: 'e1vbh80t4'
})('flex:1;');

var GraphToggle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react_emotion__["default"])('a', {
  target: 'e1vbh80t5'
})('font-size:13px;padding-left:8px;&,&:hover,&:focus,&:active{color:', function (p) {
  return p.active ? p.theme.gray4 : p.theme.gray1;
}, ';}');

/* harmony default export */ __webpack_exports__["a"] = (StreamActions);

/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_views_stream_savedSearchSelector__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_views_stream_searchBar__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_views_stream_sortOptions__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var StreamFilters = (_temp = _class = function (_React$Component) {
  _inherits(StreamFilters, _React$Component);

  function StreamFilters() {
    _classCallCheck(this, StreamFilters);

    return _possibleConstructorReturn(this, (StreamFilters.__proto__ || Object.getPrototypeOf(StreamFilters)).apply(this, arguments));
  }

  _createClass(StreamFilters, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          access = _props.access,
          orgId = _props.orgId,
          projectId = _props.projectId,
          searchId = _props.searchId,
          queryCount = _props.queryCount,
          queryMaxCount = _props.queryMaxCount,
          query = _props.query,
          savedSearchList = _props.savedSearchList,
          isSearchDisabled = _props.isSearchDisabled,
          sort = _props.sort,
          onSidebarToggle = _props.onSidebarToggle,
          onSearch = _props.onSearch,
          onSavedSearchCreate = _props.onSavedSearchCreate,
          onSortChange = _props.onSortChange;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'stream-header' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'col-sm-5' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_views_stream_savedSearchSelector__["a" /* default */], {
              access: access,
              orgId: orgId,
              projectId: projectId,
              searchId: searchId,
              queryCount: queryCount,
              queryMaxCount: queryMaxCount,
              query: query,
              onSavedSearchCreate: onSavedSearchCreate,
              savedSearchList: savedSearchList
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'col-sm-7' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'search-container' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'stream-sort' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_views_stream_sortOptions__["a" /* default */], { sort: sort, onSelect: onSortChange })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_views_stream_searchBar__["a" /* default */], {
                orgId: orgId,
                projectId: projectId,
                placeholder: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Search for events, users, tags, and everything else.'),
                query: query || '',
                onSearch: onSearch,
                disabled: isSearchDisabled,
                excludeEnvironment: true
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                {
                  className: 'btn btn-default toggle-stream-sidebar',
                  onClick: onSidebarToggle
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon-filter' })
              )
            )
          )
        )
      );
    }
  }]);

  return StreamFilters;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  orgId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  access: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,

  searchId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  savedSearchList: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,

  sort: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  query: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  isSearchDisabled: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  queryCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  queryMaxCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,

  onSortChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onSearch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onSidebarToggle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onSavedSearchCreate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
}, _class.contextTypes = {
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
}, _class.defaultProps = {
  sort: '',
  query: null,
  onSortChange: function onSortChange() {},
  onSearch: function onSearch() {},
  onSidebarToggle: function onSidebarToggle() {}
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (StreamFilters);

/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Modal__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_stores_indicatorStore__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_dropdownLink__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_queryCount__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_menuItem__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_forms__ = __webpack_require__(55);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















var SaveSearchButton = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'SaveSearchButton',

  propTypes: {
    orgId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    access: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
    query: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    disabled: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    tooltip: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    buttonTitle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

    onSave: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    return {
      isModalOpen: false,
      formData: {
        query: this.props.query
      },
      errors: {}
    };
  },
  onToggle: function onToggle() {
    if (this.props.disabled) {
      return;
    }
    this.setState({
      isModalOpen: !this.state.isModalOpen,
      state: __WEBPACK_IMPORTED_MODULE_11_app_components_forms__["FormState"].READY,
      formData: {
        query: this.props.query
      }
    });
  },
  onFieldChange: function onFieldChange(name, value) {
    var formData = this.state.formData;
    formData[name] = value;
    this.setState({
      formData: formData
    });
  },
  onDefaultChange: function onDefaultChange(e) {
    this.onFieldChange('isDefault', e.target.checked);
  },
  onUserDefaultChange: function onUserDefaultChange(e) {
    this.onFieldChange('isUserDefault', e.target.checked);
  },
  onSubmit: function onSubmit(e) {
    var _this = this;

    e.preventDefault();

    if (this.state.state == __WEBPACK_IMPORTED_MODULE_11_app_components_forms__["FormState"].SAVING) {
      return;
    }
    this.setState({
      state: __WEBPACK_IMPORTED_MODULE_11_app_components_forms__["FormState"].SAVING
    }, function () {
      var loadingIndicator = __WEBPACK_IMPORTED_MODULE_7_app_stores_indicatorStore__["default"].add(Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Saving changes..'));
      var _props = _this.props,
          orgId = _props.orgId,
          projectId = _props.projectId;

      _this.api.request('/projects/' + orgId + '/' + projectId + '/searches/', {
        method: 'POST',
        data: _this.state.formData,
        success: function success(data) {
          _this.onToggle();
          _this.props.onSave(data);
          _this.setState({
            state: __WEBPACK_IMPORTED_MODULE_11_app_components_forms__["FormState"].READY,
            errors: {}
          });
        },
        error: function error(err) {
          var errors = err.responseJSON || true;
          errors = errors.detail || true;
          _this.setState({
            state: __WEBPACK_IMPORTED_MODULE_11_app_components_forms__["FormState"].ERROR,
            errors: errors
          });
        },
        complete: function complete() {
          __WEBPACK_IMPORTED_MODULE_7_app_stores_indicatorStore__["default"].remove(loadingIndicator);
        }
      });
    });
  },
  render: function render() {
    var isSaving = this.state.state === __WEBPACK_IMPORTED_MODULE_11_app_components_forms__["FormState"].SAVING;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        {
          title: this.props.tooltip || this.props.buttonTitle,
          className: this.props.className,
          disabled: this.props.disabled,
          onClick: this.onToggle,
          style: this.props.style
        },
        this.props.children
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_Modal___default.a,
        { show: this.state.isModalOpen, animation: false, onHide: this.onToggle },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'form',
          { onSubmit: this.onSubmit },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'modal-header' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h4',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Save Current Search')
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'modal-body' },
            this.state.state === __WEBPACK_IMPORTED_MODULE_11_app_components_forms__["FormState"].ERROR && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'alert alert-error alert-block' },
              Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Unable to save your changes. ' + this.state.errors)
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Saving this search will give you and your team quick access to it in the future.')
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_forms__["TextField"], {
              key: 'name',
              name: 'name',
              label: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Name'),
              placeholder: 'e.g. My Search Results',
              required: true,
              onChange: this.onFieldChange.bind(this, 'name')
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_forms__["TextField"], {
              key: 'query',
              name: 'query',
              label: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Query'),
              value: this.state.formData.query,
              required: true,
              onChange: this.onFieldChange.bind(this, 'query')
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_forms__["BooleanField"], {
              key: 'isUserDefault',
              name: 'is-user-default',
              label: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Make this the default view for myself.'),
              onChange: this.onFieldChange.bind(this, 'isUserDefault')
            }),
            this.props.access.has('project:write') && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_forms__["BooleanField"], {
              key: 'isDefault',
              name: 'is-default',
              label: Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Make this the default view for my team.'),
              onChange: this.onFieldChange.bind(this, 'isDefault')
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'modal-footer' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-default',
                disabled: isSaving,
                onClick: this.onToggle
              },
              Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Cancel')
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'button',
              { type: 'submit', className: 'btn btn-primary', disabled: isSaving },
              Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Save')
            )
          )
        )
      )
    );
  }
});

var SavedSearchSelector = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'SavedSearchSelector',

  propTypes: {
    orgId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    searchId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    access: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
    savedSearchList: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,
    queryCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    queryMaxCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    onSavedSearchCreate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6_app_mixins_apiMixin__["default"]],

  getTitle: function getTitle() {
    var searchId = this.props.searchId || null;
    if (!searchId) return Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Custom Search');
    var results = this.props.savedSearchList.filter(function (search) {
      return searchId === search.id;
    });
    return results.length ? results[0].name : Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Custom Search');
  },
  render: function render() {
    var _props2 = this.props,
        access = _props2.access,
        orgId = _props2.orgId,
        projectId = _props2.projectId,
        queryCount = _props2.queryCount,
        queryMaxCount = _props2.queryMaxCount;

    var children = this.props.savedSearchList.map(function (search) {
      // TODO(dcramer): we want these to link directly to the saved
      // search ID, and pass that into the backend (probably)
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_app_components_menuItem__["default"],
        { to: '/' + orgId + '/' + projectId + '/searches/' + search.id + '/', key: search.id },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'strong',
          null,
          search.name
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'code',
          null,
          search.query
        )
      );
    });
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'saved-search-selector' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_app_components_dropdownLink__["default"],
        {
          title: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              null,
              this.getTitle()
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_queryCount__["a" /* default */], { count: queryCount, max: queryMaxCount })
          )
        },
        children.length ? children : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'li',
          { className: 'empty' },
          Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])("There don't seem to be any saved searches yet.")
        ),
        access.has('project:write') && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_menuItem__["default"], { divider: true }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'li',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'col-md-7' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                SaveSearchButton,
                _extends({
                  className: 'btn btn-sm btn-default',
                  onSave: this.props.onSavedSearchCreate
                }, this.props),
                Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Save Current Search')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'col-md-5' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_router__["Link"],
                {
                  to: '/' + orgId + '/' + projectId + '/settings/saved-searches/',
                  className: 'btn btn-sm btn-default'
                },
                Object(__WEBPACK_IMPORTED_MODULE_5_app_locale__["t"])('Manage')
              )
            )
          )
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (SavedSearchSelector);

/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reflux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_stores_tagStore__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_stores_memberListStore__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_views_stream_searchDropdown__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_mixins_organizationState__ = __webpack_require__(39);


















var SearchBar = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'SearchBar',

  propTypes: {
    defaultQuery: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    defaultSearchItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
    disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    onSearch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    // If true, excludes the environment tag from the autocompletion list
    // This is because we don't want to treat environment as a tag in some places
    // such as the stream view where it is a top level concept
    excludeEnvironment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_9_app_mixins_apiMixin__["default"], __WEBPACK_IMPORTED_MODULE_12_app_mixins_organizationState__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5_reflux___default.a.listenTo(__WEBPACK_IMPORTED_MODULE_8_app_stores_memberListStore__["a" /* default */], 'onMemberListStoreChange')],

  statics: {
    /**
     * Given a query, and the current cursor position, return the string-delimiting
     * index of the search term designated by the cursor.
     */
    getLastTermIndex: function getLastTermIndex(query, cursor) {
      // TODO: work with quoted-terms
      var cursorOffset = query.slice(cursor).search(/\s|$/);
      return cursor + (cursorOffset === -1 ? 0 : cursorOffset);
    },


    /**
     * Returns an array of query terms, including incomplete terms
     *
     * e.g. ["is:unassigned", "browser:\"Chrome 33.0\"", "assigned"]
     */
    getQueryTerms: function getQueryTerms(query, cursor) {
      return query.slice(0, cursor).match(/\S+:"[^"]*"?|\S+/g);
    }
  },

  getDefaultProps: function getDefaultProps() {
    return {
      defaultQuery: '',
      query: null,
      onSearch: function onSearch() {},
      excludeEnvironment: false,
      defaultSearchItems: [{
        title: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Tag'),
        desc: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('key/value pair associated to an issue'),
        example: 'browser:"Chrome 34", has:browser',
        className: 'icon-tag',
        value: 'browser:'
      }, {
        title: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Status'),
        desc: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('State of an issue'),
        example: 'is:resolved, unresolved, ignored, assigned, unassigned',
        className: 'icon-toggle',
        value: 'is:'
      }, {
        title: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Time or Count'),
        desc: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Time or Count related search'),
        example: 'firstSeen, lastSeen, event.timestamp, timesSeen',
        className: 'icon-clock',
        value: ''
      }, {
        title: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Assigned'),
        desc: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('team member assigned to an issue'),
        example: 'assigned:[me|user@example.com]',
        className: 'icon-user',
        value: 'assigned:'
      }, {
        title: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('Bookmarked By'),
        desc: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('team member who bookmarked an issue'),
        example: 'bookmarks:[me|user@example.com]',
        className: 'icon-user',
        value: 'bookmarks:'
      }, {
        desc: Object(__WEBPACK_IMPORTED_MODULE_10_app_locale__["t"])('or paste an event id to jump straight to it'),
        className: 'icon-hash',
        value: ''
      }]
    };
  },
  getInitialState: function getInitialState() {
    var hasEnvironmentsFeature = this.getFeatures().has('environments');

    return {
      query: this.props.query !== null ? this.props.query : this.props.defaultQuery,

      searchTerm: '',
      searchItems: [],
      activeSearchItem: 0,

      tags: {},
      members: __WEBPACK_IMPORTED_MODULE_8_app_stores_memberListStore__["a" /* default */].getAll(),

      dropdownVisible: false,
      loading: false,
      hasEnvironmentsFeature: hasEnvironmentsFeature
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    // query was updated by another source (e.g. sidebar filters)
    if (nextProps.query !== this.state.query) {
      this.setState({
        query: nextProps.query
      });
    }
  },


  DROPDOWN_BLUR_DURATION: 200,

  blur: function blur() {
    __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this.refs.searchInput).blur();
  },
  onSubmit: function onSubmit(evt) {
    evt.preventDefault();
    this.blur();
    this.props.onSearch(this.state.query);
  },
  clearSearch: function clearSearch() {
    var _this = this;

    this.setState({ query: '' }, function () {
      return _this.props.onSearch(_this.state.query);
    });
  },
  onQueryFocus: function onQueryFocus() {
    this.setState({
      dropdownVisible: true
    });
  },
  onQueryBlur: function onQueryBlur() {
    var _this2 = this;

    // wait 200ms before closing dropdown in case blur was a result of
    // clicking a menu option
    this.blurTimeout = setTimeout(function () {
      _this2.blurTimeout = null;
      _this2.setState({ dropdownVisible: false });
    }, this.DROPDOWN_BLUR_DURATION);
  },
  onQueryChange: function onQueryChange(evt) {
    var _this3 = this;

    this.setState({ query: evt.target.value }, function () {
      return _this3.updateAutoCompleteItems();
    });
  },
  onKeyUp: function onKeyUp(evt) {
    if (evt.key === 'Escape' || evt.keyCode === 27) {
      // blur handler should additionally hide dropdown
      this.blur();
    }
  },
  getCursorPosition: function getCursorPosition() {
    return __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this.refs.searchInput).selectionStart;
  },


  /**
   * Returns array of possible key values that substring match `query`
   *
   * e.g. ['is:', 'assigned:', 'url:', 'release:']
   */
  getTagKeys: function getTagKeys(query) {
    var allKeys = __WEBPACK_IMPORTED_MODULE_7_app_stores_tagStore__["a" /* default */].getTagKeys().map(function (key) {
      return key + ':';
    }).filter(function (key) {
      return key.indexOf(query) > -1;
    });

    // If the environment feature is active and excludeEnvironment = true
    // then remove the environment key
    if (this.state.hasEnvironmentsFeature && this.props.excludeEnvironment) {
      return allKeys.filter(function (key) {
        return key !== 'environment:';
      });
    } else {
      return allKeys;
    }
  },

  /**
   * Returns array of tag values that substring match `query`; invokes `callback`
   * with data when ready
   */
  getTagValues: __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function (tag, query, callback) {
    var _this4 = this;

    // Strip double quotes if there are any
    query = query.replace('"', '').trim();

    this.setState({
      loading: true
    });

    var _props = this.props,
        orgId = _props.orgId,
        projectId = _props.projectId;


    this.api.request('/projects/' + orgId + '/' + projectId + '/tags/' + tag.key + '/values/', {
      data: {
        query: query
      },
      method: 'GET',
      success: function success(values) {
        _this4.setState({ loading: false });
        callback(values.map(function (v) {
          // Wrap in quotes if there is a space
          return v.value.indexOf(' ') > -1 ? '"' + v.value + '"' : v.value;
        }), tag.key, query);
      }
    });
  }, 300),

  /**
   * Returns array of tag values that substring match `query`; invokes `callback`
   * with results
   */
  getPredefinedTagValues: function getPredefinedTagValues(tag, query, callback) {
    var values = tag.values.filter(function (value) {
      return value.indexOf(query) > -1;
    });

    callback(values, tag.key);
  },

  onInputClick: function onInputClick() {
    var _this5 = this;

    var cursor = this.getCursorPosition();

    if (cursor === this.state.query.length && this.state.query.charAt(cursor - 1) !== ' ') {
      // If the cursor lands at the end of the input value, and the preceding character
      // is not whitespace, then add a space and move the cursor beyond that space.
      this.setState({ query: this.state.query + ' ' }, function () {
        __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(_this5.refs.searchInput).setSelectionRange(cursor + 1, cursor + 1);
        _this5.updateAutoCompleteItems();
      });
    } else {
      this.updateAutoCompleteItems();
    }
  },
  updateAutoCompleteItems: function updateAutoCompleteItems() {
    if (this.blurTimeout) {
      clearTimeout(this.blurTimeout);
      this.blurTimeout = null;
    }

    var cursor = this.getCursorPosition();
    var query = this.state.query;

    var lastTermIndex = SearchBar.getLastTermIndex(query, cursor);
    var terms = SearchBar.getQueryTerms(query.slice(0, lastTermIndex));

    if (!terms || // no terms
    terms.length === 0 || // no terms
    terms.length === 1 && terms[0] === this.props.defaultQuery || // default term
    /^\s+$/.test(query.slice(cursor - 1, cursor + 1))) {
      // cursor on whitespace
      // show default "help" search terms
      return void this.setState({
        searchTerm: '',
        searchItems: this.props.defaultSearchItems,
        activeSearchItem: 0
      });
    }

    var last = terms.pop();
    var autoCompleteItems = void 0;
    var matchValue = void 0;
    var tagName = void 0;
    var index = last.indexOf(':');

    if (index === -1) {
      // No colon present; must still be deciding key
      matchValue = last;
      autoCompleteItems = this.getTagKeys(matchValue);

      this.setState({ searchTerm: matchValue });
      this.updateAutoCompleteState(autoCompleteItems, matchValue);
    } else {
      tagName = last.slice(0, index);
      query = last.slice(index + 1);

      // filter existing items immediately, until API can return
      // with actual tag value results
      var filteredSearchItems = this.state.searchItems.filter(function (item) {
        return query && item.value.indexOf(query) !== -1;
      });

      this.setState({
        searchTerm: query,
        searchItems: filteredSearchItems
      });

      var tag = __WEBPACK_IMPORTED_MODULE_7_app_stores_tagStore__["a" /* default */].getTag(tagName);

      if (!tag) return undefined;

      // Ignore the environment tag if the feature is active and excludeEnvironment = true
      if (this.state.hasEnvironmentsFeature && this.props.excludeEnvironment && tagName === 'environment') {
        return undefined;
      }

      return void (tag.predefined ? this.getPredefinedTagValues : this.getTagValues)(tag, query, this.updateAutoCompleteState);
    }
    return undefined;
  },
  isDefaultDropdown: function isDefaultDropdown() {
    return this.state.searchItems === this.props.defaultSearchItems;
  },
  updateAutoCompleteState: function updateAutoCompleteState(autoCompleteItems, tagName) {
    autoCompleteItems = autoCompleteItems.map(function (item) {
      var out = {
        desc: item,
        value: item
      };

      // Specify icons according to tag value
      switch (tagName || item.replace(':', '')) {
        case 'is':
          out.className = 'icon-toggle';
          break;
        case 'assigned':
        case 'bookmarks':
          out.className = 'icon-user';
          break;
        case 'firstSeen':
        case 'lastSeen':
        case 'event.timestamp':
          out.className = 'icon-clock';
          break;
        default:
          out.className = 'icon-tag';
      }
      return out;
    });

    if (autoCompleteItems.length > 0 && !this.isDefaultDropdown()) {
      autoCompleteItems[0].active = true;
    }

    this.setState({
      searchItems: autoCompleteItems.slice(0, 5), // only show 5
      activeSearchItem: 0
    });
  },
  onKeyDown: function onKeyDown(evt) {
    var state = this.state;
    var searchItems = state.searchItems;

    if (!searchItems.length) return;

    if (evt.key === 'ArrowDown' || evt.key === 'ArrowUp') {
      evt.preventDefault();

      // Move active selection up/down
      delete searchItems[state.activeSearchItem].active;

      state.activeSearchItem = evt.key === 'ArrowDown' ? Math.min(state.activeSearchItem + 1, searchItems.length - 1) : Math.max(state.activeSearchItem - 1, 0);

      searchItems[state.activeSearchItem].active = true;
      this.setState({ searchItems: searchItems.slice(0) });
    } else if (evt.key === 'Tab' && !this.isDefaultDropdown()) {
      evt.preventDefault();

      this.onAutoComplete(searchItems[state.activeSearchItem].value);
    }
  },
  onAutoComplete: function onAutoComplete(replaceText) {
    var _this6 = this;

    var cursor = this.getCursorPosition();
    var query = this.state.query;

    var lastTermIndex = SearchBar.getLastTermIndex(query, cursor);
    var terms = SearchBar.getQueryTerms(query.slice(0, lastTermIndex));
    var newQuery = void 0;

    // If not postfixed with : (tag value), add trailing space
    replaceText += replaceText.charAt(replaceText.length - 1) === ':' ? '' : ' ';

    if (!terms) {
      newQuery = replaceText;
    } else {
      var last = terms.pop();

      newQuery = query.slice(0, lastTermIndex); // get text preceding last term

      newQuery = last.indexOf(':') > -1 ? // tag key present: replace everything after colon with replaceText
      newQuery.replace(/\:"[^"]*"?$|\:\S*$/, ':' + replaceText) : // no tag key present: replace last token with replaceText
      newQuery.replace(/\S+$/, replaceText);

      newQuery = newQuery.concat(query.slice(lastTermIndex));
    }

    this.setState({
      query: newQuery
    }, function () {
      // setting a new input value will lose focus; restore it
      var node = __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(_this6.refs.searchInput);
      node.focus();

      // then update the autocomplete box with new contextTypes
      _this6.updateAutoCompleteItems();
    });
  },
  onMemberListStoreChange: function onMemberListStoreChange(members) {
    this.setState({
      members: members
    }, this.updateAutoCompleteItems);
  },
  render: function render() {
    var dropdownStyle = {
      display: this.state.dropdownVisible ? 'block' : 'none'
    };

    var rootClassNames = ['search'];
    if (this.props.disabled) rootClassNames.push('disabled');

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(rootClassNames) },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'form',
        { className: 'form-horizontal', ref: 'searchForm', onSubmit: this.onSubmit },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', {
            type: 'text',
            className: 'search-input form-control',
            placeholder: this.props.placeholder,
            name: 'query',
            ref: 'searchInput',
            autoComplete: 'off',
            value: this.state.query,
            onFocus: this.onQueryFocus,
            onBlur: this.onQueryBlur,
            onKeyUp: this.onKeyUp,
            onKeyDown: this.onKeyDown,
            onChange: this.onQueryChange,
            onClick: this.onInputClick,
            disabled: this.props.disabled
          }),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon-search' }),
          this.state.query !== '' && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'a',
              { className: 'search-clear-form', onClick: this.clearSearch },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'icon-circle-cross' })
            )
          )
        ),
        (this.state.loading || this.state.searchItems.length > 0) && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { style: dropdownStyle },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_views_stream_searchDropdown__["a" /* default */], {
            style: dropdownStyle,
            items: this.state.searchItems,
            onClick: this.onAutoComplete,
            loading: this.state.loading,
            searchSubstring: this.state.searchTerm
          })
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (SearchBar);

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_loadingIndicator__ = __webpack_require__(11);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var SearchDropdown = (_temp2 = _class = function (_React$PureComponent) {
  _inherits(SearchDropdown, _React$PureComponent);

  function SearchDropdown() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchDropdown.__proto__ || Object.getPrototypeOf(SearchDropdown)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (itemValue) {
      _this.props.onClick(itemValue);
    }, _this.renderDescription = function (item) {
      var searchSubstring = _this.props.searchSubstring;
      if (!searchSubstring) return item.desc;

      var text = item.desc;
      var idx = text.toLowerCase().indexOf(searchSubstring.toLowerCase());

      if (idx === -1) return item.desc;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        null,
        text.substr(0, idx),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'strong',
          null,
          text.substr(idx, searchSubstring.length)
        ),
        text.substr(idx + searchSubstring.length)
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SearchDropdown, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'search-dropdown' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'ul',
          { className: 'search-helper search-autocomplete-list' },
          this.props.loading ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'li',
            { key: 'loading', className: 'search-autocomplete-item' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_loadingIndicator__["default"], { mini: true })
          ) : this.props.items.map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'li',
              {
                key: item.value || item.desc,
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('search-autocomplete-item', item.active && 'active'),
                onClick: _this2.onClick.bind(_this2, item.value)
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('icon', item.className) }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h4',
                null,
                item.title && item.title + ' - ',
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  { className: 'search-description' },
                  _this2.renderDescription(item)
                )
              ),
              item.example ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { className: 'search-example' },
                item.example
              ) : ''
            );
          })
        )
      );
    }
  }]);

  return SearchDropdown;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent), _class.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,
  searchSubstring: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  loading: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _class.defaultProps = {
  searchSubstring: '',
  onClick: function onClick() {}
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (SearchDropdown);

/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_dropdownLink__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_menuItem__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var SortOptions = (_temp = _class = function (_React$PureComponent) {
  _inherits(SortOptions, _React$PureComponent);

  function SortOptions() {
    var _ref;

    _classCallCheck(this, SortOptions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = SortOptions.__proto__ || Object.getPrototypeOf(SortOptions)).call.apply(_ref, [this].concat(args)));

    _this.getMenuItem = function (key) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_app_components_menuItem__["default"],
        {
          onSelect: _this.onSelect,
          eventKey: key,
          isActive: _this.state.sortKey === key
        },
        _this.getSortLabel(key)
      );
    };

    _this.onSelect = function (sort) {
      _this.setState({ sortKey: sort });
      if (_this.props.onSelect) {
        _this.props.onSelect(sort);
      }
    };

    _this.getSortLabel = function (key) {
      switch (key) {
        case 'new':
          return Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('First Seen');
        case 'priority':
          return Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Priority');
        case 'freq':
          return Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Frequency');
        case 'date':
        default:
          return Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Last Seen');
      }
    };

    _this.state = {
      sortKey: _this.props.sort || 'date'
    };
    return _this;
  }

  _createClass(SortOptions, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        sortKey: nextProps.sort || 'date'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var dropdownTitle = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'strong',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_4_app_locale__["t"])('Sort by'),
          ':'
        ),
        '\xA0 ',
        this.getSortLabel(this.state.sortKey)
      );

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_app_components_dropdownLink__["default"],
        { btnGroup: true, title: dropdownTitle },
        this.getMenuItem('priority'),
        this.getMenuItem('date'),
        this.getMenuItem('new'),
        this.getMenuItem('freq')
      );
    }
  }]);

  return SortOptions;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent), _class.propTypes = {
  sort: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  onSelect: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (SortOptions);

/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEqual__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_views_stream_tagFilter__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_utils_stream__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_locale__ = __webpack_require__(2);




var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










var TEXT_FILTER_DEBOUNCE_IN_MS = 300;

var StreamSidebar = __WEBPACK_IMPORTED_MODULE_5_create_react_class___default()({
  displayName: 'StreamSidebar',

  propTypes: {
    orgId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
    projectId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,

    tags: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    query: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    onQueryChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    loading: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      tags: {},
      query: '',
      onQueryChange: function onQueryChange() {}
    };
  },
  getInitialState: function getInitialState() {
    var queryObj = Object(__WEBPACK_IMPORTED_MODULE_8_app_utils_stream__["b" /* queryToObj */])(this.props.query);
    return {
      queryObj: queryObj,
      textFilter: queryObj.__text
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    // If query was updated by another source (e.g. SearchBar),
    // clobber state of sidebar with new query.
    var query = Object(__WEBPACK_IMPORTED_MODULE_8_app_utils_stream__["a" /* objToQuery */])(this.state.queryObj);

    if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isEqual___default()(nextProps.query, query)) {
      var queryObj = Object(__WEBPACK_IMPORTED_MODULE_8_app_utils_stream__["b" /* queryToObj */])(nextProps.query);
      this.setState({
        queryObj: queryObj,
        textFilter: queryObj.__text
      });
    }
  },
  onSelectTag: function onSelectTag(tag, value) {
    var newQuery = _extends({}, this.state.queryObj);
    if (value) newQuery[tag.key] = value;else delete newQuery[tag.key];

    this.setState({
      queryObj: newQuery
    }, this.onQueryChange);
  },


  onTextChange: function onTextChange(evt) {
    this.setState({ textFilter: evt.target.value });
  },

  debouncedTextChange: __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function (text) {
    this.setState({
      queryObj: _extends({}, this.state.queryObj, { __text: text })
    }, this.onQueryChange);
  }, TEXT_FILTER_DEBOUNCE_IN_MS),

  onTextFilterSubmit: function onTextFilterSubmit(evt) {
    evt && evt.preventDefault();

    var newQueryObj = _extends({}, this.state.queryObj, {
      __text: this.state.textFilter
    });

    this.setState({
      queryObj: newQueryObj
    }, this.onQueryChange);
  },
  onQueryChange: function onQueryChange() {
    var query = Object(__WEBPACK_IMPORTED_MODULE_8_app_utils_stream__["a" /* objToQuery */])(this.state.queryObj);
    this.props.onQueryChange && this.props.onQueryChange(query);
  },
  onClearSearch: function onClearSearch() {
    this.setState({
      textFilter: ''
    }, this.onTextFilterSubmit);
  },
  render: function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      { className: 'stream-sidebar' },
      this.props.loading ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_loadingIndicator__["default"], null) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'div',
          { className: 'stream-tag-filter' },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'h6',
            { className: 'nav-header' },
            Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Text')
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'form',
            { onSubmit: this.onTextFilterSubmit },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input', {
              className: 'form-control',
              placeholder: Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Search title and culprit text body'),
              onChange: this.onTextChange,
              value: this.state.textFilter
            }),
            this.state.textFilter && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              'a',
              { className: 'search-clear-form', onClick: this.onClearSearch },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'icon-circle-cross' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('hr', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(this.props.tags, function (tag) {
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_views_stream_tagFilter__["a" /* default */], {
            value: _this.state.queryObj[tag.key],
            key: tag.key,
            tag: tag,
            onSelect: _this.onSelectTag,
            orgId: _this.props.orgId,
            projectId: _this.props.projectId
          });
        })
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (StreamSidebar);

/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var StreamTagFilter = (_temp = _class = function (_React$Component) {
  _inherits(StreamTagFilter, _React$Component);

  function StreamTagFilter() {
    var _ref;

    _classCallCheck(this, StreamTagFilter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = StreamTagFilter.__proto__ || Object.getPrototypeOf(StreamTagFilter)).call.apply(_ref, [this].concat(args)));

    _this.getTagValuesAPIEndpoint = function () {
      return '/api/0/projects/' + _this.props.orgId + '/' + _this.props.projectId + '/tags/' + _this.props.tag.key + '/values/';
    };

    _this.onSelectValue = function (evt) {
      var val = evt.target.value;
      _this.setState({
        value: val
      });

      _this.props.onSelect && _this.props.onSelect(_this.props.tag, val);
    };

    _this.state = {
      query: '',
      loading: false,
      value: _this.props.value
    };
    return _this;
  }

  _createClass(StreamTagFilter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var select = this.refs.select;

      var selectOpts = {
        placeholder: '--',
        allowClear: true
      };

      if (!this.props.tag.predefined) {
        Object.assign(selectOpts, {
          initSelection: function initSelection(element, callback) {
            callback(StreamTagFilter.tagValueToSelect2Format(_this2.props.value));
          },
          ajax: {
            url: this.getTagValuesAPIEndpoint(),
            dataType: 'json',
            delay: 250,
            data: function data(term, page) {
              return {
                query: term
              };
            },
            results: function results(data, page) {
              // parse the results into the format expected by Select2
              return {
                results: __WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(data, function (val) {
                  return StreamTagFilter.tagValueToSelect2Format(val.value);
                })
              };
            },
            cache: true
          }
        });
      }

      $(select).select2(selectOpts).select2('val', this.state.value).on('change', this.onSelectValue);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      if (nextProps.value !== this.state.value) {
        this.setState({
          value: nextProps.value
        }, function () {
          var select = _this3.refs.select;
          $(select).select2('val', _this3.state.value);
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var select = __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(this.refs.select);
      $(select).select2('destroy');
    }
  }, {
    key: 'render',
    value: function render() {
      // NOTE: need to specify empty onChange handler on <select> - even though this
      //       will get overridden by select2 - because React will complain with
      //       a warning
      var tag = this.props.tag;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'stream-tag-filter' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'h6',
          { className: 'nav-header' },
          tag.key
        ),
        this.props.tag.predefined ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'select',
          { ref: 'select', onChange: function onChange() {} },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option', { key: 'empty' }),
          this.props.tag.values.map(function (val) {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'option',
              { key: val },
              val
            );
          })
        ) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', { type: 'hidden', ref: 'select', value: this.props.value })
      );
    }
  }]);

  return StreamTagFilter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  orgId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  projectId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class.tagValueToSelect2Format = function (key) {
  return {
    id: key,
    text: key
  };
}, _class.defaultProps = {
  tag: {},
  value: ''
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (StreamTagFilter);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = queryToObj;
/* harmony export (immutable) */ __webpack_exports__["a"] = objToQuery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_reduce__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_reduce__);





/**
 * Converts a stream query to an object representation, with
 * keys representing tag names, and the magic __text key
 * representing the text component of the search.
 *
 * Example:
 *
 * "python is:unresolved assigned:foo@bar.com"
 * => {
 *      __text: "python",
 *      is: "unresolved",
 *      assigned: "foo@bar.com"
 *    }
 */

function queryToObj(queryStr) {
  var text = [];

  var queryItems = queryStr.match(/\S+:"[^"]*"?|\S+/g);
  var queryObj = __WEBPACK_IMPORTED_MODULE_2_lodash_reduce___default()(queryItems, function (obj, item) {
    var index = item.indexOf(':');
    if (index === -1) {
      text.push(item);
    } else {
      var tagKey = item.slice(0, index);
      var value = item.slice(index + 1).replace(/^"|"$/g, '');
      obj[tagKey] = value;
    }
    return obj;
  }, {});

  if (text.length) queryObj.__text = text.join(' ');

  return queryObj;
}

/**
 * Converts an object representation of a stream query to a string
 * (consumable by the Sentry stream HTTP API).
 */
function objToQuery(queryObj) {
  var tags = __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default()(queryObj, '__text');

  var parts = __WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(tags, function (value, tagKey) {
    if (value.indexOf(' ') > -1) value = '"' + value + '"';

    return tagKey + ':' + value;
  });

  if (queryObj.__text) parts.push(queryObj.__text);

  return parts.join(' ');
}

/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchTags;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_locale__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_stores_tagStore__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_actions_tagActions__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_actions_alertActions__ = __webpack_require__(142);






var api = new __WEBPACK_IMPORTED_MODULE_0_app_api__["Client"]();

var MAX_TAGS = 500;

function fetchTags(orgId, projectId) {
  __WEBPACK_IMPORTED_MODULE_2_app_stores_tagStore__["a" /* default */].reset();
  __WEBPACK_IMPORTED_MODULE_3_app_actions_tagActions__["a" /* default */].loadTags();

  api.request('/projects/' + orgId + '/' + projectId + '/tags/', {
    success: function success(tags) {
      var trimmedTags = tags.slice(0, MAX_TAGS);

      if (tags.length > MAX_TAGS) {
        __WEBPACK_IMPORTED_MODULE_4_app_actions_alertActions__["default"].addAlert({
          message: Object(__WEBPACK_IMPORTED_MODULE_1_app_locale__["t"])('You have too many unique tags and some have been truncated'),
          type: 'warn'
        });
      }
      __WEBPACK_IMPORTED_MODULE_3_app_actions_tagActions__["a" /* default */].loadTagsSuccess(trimmedTags);
    },
    error: __WEBPACK_IMPORTED_MODULE_3_app_actions_tagActions__["a" /* default */].loadTagsError
  });
}

/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Radio = (_temp = _class = function (_React$Component) {
  _inherits(Radio, _React$Component);

  function Radio() {
    _classCallCheck(this, Radio);

    return _possibleConstructorReturn(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).apply(this, arguments));
  }

  _createClass(Radio, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          otherProps = _objectWithoutProperties(_props, ['className']);

      var cx = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('radio-select', className);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({ type: 'radio', className: cx }, otherProps));
    }
  }]);

  return Radio;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.defaultProps = {
  checked: false
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (Radio);

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_actions_alertActions__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_avatarCropper__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_avatarRadio__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_loadingError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_loadingIndicator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_locale__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













var AvatarSettings = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'AvatarSettings',
  propTypes: {
    userId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_app_mixins_apiMixin__["default"]],

  getInitialState: function getInitialState() {
    return {
      user: null,
      savedDataUrl: null,
      dataUrl: null,
      hasError: false
    };
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    this.api.request(this.getEndpoint(), {
      method: 'GET',
      success: this.updateUserState,
      error: function error() {
        _this.setState({ hasError: true });
      }
    });
  },
  getEndpoint: function getEndpoint() {
    return '/users/me/avatar/';
  },
  updateUserState: function updateUserState(user) {
    this.setState({ user: user });
  },
  updateDataUrlState: function updateDataUrlState(dataUrlState) {
    this.setState(dataUrlState);
  },
  handleError: function handleError(msg) {
    __WEBPACK_IMPORTED_MODULE_3_app_actions_alertActions__["default"].addAlert({
      message: Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])(msg),
      type: 'error'
    });
  },
  handleSuccess: function handleSuccess(user) {
    this.setState({ user: user });
    __WEBPACK_IMPORTED_MODULE_3_app_actions_alertActions__["default"].addAlert({
      message: Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Successfully saved avatar preferences'),
      type: 'success',
      expireAfrer: 3000
    });
  },
  saveSettings: function saveSettings(ev) {
    var _this2 = this;

    ev.preventDefault();
    var avatarPhoto = null;
    if (this.state.dataUrl) {
      avatarPhoto = this.state.dataUrl.split(',')[1];
    }
    this.api.request(this.getEndpoint(), {
      method: 'PUT',
      data: {
        avatar_photo: avatarPhoto,
        avatar_type: this.state.user.avatar.avatarType
      },
      success: function success(user) {
        _this2.setState({ savedDataUrl: _this2.state.dataUrl });
        _this2.handleSuccess(user);
      },
      error: this.handleError.bind(this, 'There was an error saving your preferences.')
    });
  },
  render: function render() {
    if (this.state.hasError) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_loadingError__["default"], null);
    }
    if (!this.state.user) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_loadingIndicator__["default"], null);
    }

    var gravatarMessage = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'well' },
      Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Gravatars are managed through '),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        { href: 'http://gravatar.com', target: '_blank', rel: 'noreferrer noopener' },
        'Gravatar.com'
      )
    );

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { style: { lineHeight: '1.5em' } },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'form',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_avatarRadio__["a" /* default */], { user: this.state.user, updateUser: this.updateUserState }),
        this.state.user.avatar.avatarType === 'gravatar' && gravatarMessage,
        this.state.user.avatar.avatarType === 'upload' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_avatarCropper__["a" /* default */], _extends({}, this.props, {
          model: this.state.user,
          savedDataUrl: this.state.savedDataUrl,
          updateDataUrlState: this.updateDataUrlState
        })),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'fieldset',
          { className: 'form-actions' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'button',
            { className: 'btn btn-primary', onClick: this.saveSettings },
            Object(__WEBPACK_IMPORTED_MODULE_9_app_locale__["t"])('Done')
          )
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["default"] = (AvatarSettings);

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);







var AvatarRadio = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'AvatarRadio',

  propTypes: {
    user: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
    updateUser: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
  },

  OPTIONS: {
    upload: 'Upload a Photo',
    gravatar: 'Use Gravatar',
    letter_avatar: 'Use my initials'
  },

  onChange: function onChange(ev) {
    var avatar = Object.assign({}, this.props.user.avatar, { avatarType: ev.target.value });
    this.props.user.avatar = avatar;
    this.props.updateUser(this.props.user);
  },
  render: function render() {
    var radios = [];
    for (var opt in this.OPTIONS) {
      radios.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'li',
        { className: 'radio', key: opt },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'label',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
            type: 'radio',
            name: 'avatar-type',
            value: opt,
            onChange: this.onChange,
            checked: this.props.user.avatar.avatarType === opt
          }),
          this.OPTIONS[opt]
        )
      ));
    }
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'legend',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('Avatar Type')
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'ul',
        { className: 'radio-inputs' },
        radios
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (AvatarRadio);

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_js_tooltip__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_js_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_js_tooltip__);




/* harmony default export */ __webpack_exports__["default"] = (function (options) {
  options = options || {};
  return {
    componentDidMount: function componentDidMount() {
      this.attachTooltips();
    },
    componentWillUnmount: function componentWillUnmount() {
      this.removeTooltips();
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(__WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.findDOMNode(this)).unbind();
    },
    attachTooltips: function attachTooltips() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(__WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.findDOMNode(this)).tooltip(Object.prototype.toString.call(options) === '[object Function]' ? options.call(this) : options);
    },
    removeTooltips: function removeTooltips() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(__WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.findDOMNode(this)).tooltip('destroy') // destroy tooltips on parent ...
      .find(options.selector).tooltip('destroy'); // ... and descendents
    }
  };
});

/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_mixins_apiMixin__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_stores_organizationsStore__ = __webpack_require__(168);







var OrganizationsLoader = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'OrganizationsLoader',
  mixins: [__WEBPACK_IMPORTED_MODULE_2_app_mixins_apiMixin__["default"]],

  componentWillMount: function componentWillMount() {
    var _this = this;

    this.api.request('/organizations/', {
      query: {
        member: '1'
      },
      success: function success(data) {
        __WEBPACK_IMPORTED_MODULE_3_app_stores_organizationsStore__["a" /* default */].load(data);
        _this.setState({
          loading: false
        });
      },
      error: function error() {
        _this.setState({
          loading: false,
          error: true
        });
      }
    });
  },
  componentWillUnmount: function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_3_app_stores_organizationsStore__["a" /* default */].load([]);
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      this.props.children
    );
  }
});

/* harmony default export */ __webpack_exports__["default"] = (OrganizationsLoader);

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_u2finterface__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_locale__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var U2fEnrollment = (_temp = _class = function (_React$Component) {
  _inherits(U2fEnrollment, _React$Component);

  function U2fEnrollment() {
    _classCallCheck(this, U2fEnrollment);

    return _possibleConstructorReturn(this, (U2fEnrollment.__proto__ || Object.getPrototypeOf(U2fEnrollment)).apply(this, arguments));
  }

  _createClass(U2fEnrollment, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_app_components_u2finterface__["a" /* default */],
        { challengeData: this.props.enrollmentData, flowMode: 'enroll' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_3_app_locale__["t"])('\n            To enroll your U2F device insert it now or tap the button on it\n            to activate it.\n          ')
        )
      );
    }
  }]);

  return U2fEnrollment;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  enrollmentData: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
}, _temp);


/* harmony default export */ __webpack_exports__["default"] = (U2fEnrollment);

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_api__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_loadingIndicator__ = __webpack_require__(11);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var SetupWizard = (_temp = _class = function (_React$Component) {
  _inherits(SetupWizard, _React$Component);

  function SetupWizard(props, context) {
    _classCallCheck(this, SetupWizard);

    var _this = _possibleConstructorReturn(this, (SetupWizard.__proto__ || Object.getPrototypeOf(SetupWizard)).call(this, props, context));

    _this.state = _this.getDefaultState();
    return _this;
  }

  _createClass(SetupWizard, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.api = new __WEBPACK_IMPORTED_MODULE_2_app_api__["Client"]();
      this.pollFinished();
    }
  }, {
    key: 'getDefaultState',
    value: function getDefaultState() {
      return {
        log: [],
        finished: false
      };
    }
  }, {
    key: 'pollFinished',
    value: function pollFinished() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.api.request('/wizard/' + _this2.props.hash + '/', {
          method: 'GET',
          success: function success(data) {
            setTimeout(function () {
              return _this2.pollFinished();
            }, 1000);
          },
          error: function error(err) {
            resolve();
            _this2.setState({
              finished: true
            });
            setTimeout(function () {
              return window.close();
            }, 10000);
          }
        });
      });
    }
  }, {
    key: 'renderSuccess',
    value: function renderSuccess() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h5',
          null,
          'Return to your terminal to complete your setup'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h5',
          null,
          '(This window will close in 10 sec)'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'button',
          { className: 'btn btn-default', onClick: function onClick() {
              return window.close();
            } },
          'Close browser tab'
        )
      );
    }
  }, {
    key: 'renderLoading',
    value: function renderLoading() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h5',
          null,
          'Waiting for wizard to connect'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_app_components_loadingIndicator__["default"],
          { style: { margin: '2em auto' }, finished: this.state.finished },
          this.state.finished ? this.renderSuccess() : this.renderLoading()
        )
      );
    }
  }]);

  return SetupWizard;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  hash: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
}, _class.defaultProps = {
  hash: false
}, _temp);


/* harmony default export */ __webpack_exports__["default"] = (SetupWizard);

/***/ })
],[649]);


// WEBPACK FOOTER //
// app.js